
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec5f8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec5f8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7B2bR", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $587db01302e19550$export$ffb0004e005737fa, (v) => $587db01302e19550$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $587db01302e19550$export$34b9dba7ce09269b, (v) => $587db01302e19550$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $587db01302e19550$export$25062201e9e25d76, (v) => $587db01302e19550$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $587db01302e19550$export$ffb0004e005737fa;
var $587db01302e19550$export$34b9dba7ce09269b;
var $587db01302e19550$export$25062201e9e25d76;
"use strict";

(function() {
    "use strict";
    var React = (parcelRequire("acw62"));
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown;
    var specialPropRefWarningShown;
    var didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function warnIfStringRefCannotBeAutoConverted(config, self) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */ function jsxDEV(type, config, maybeKey, source, self) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
        // but as an intermediary step, we will use jsxDEV for everything except
        // <div {...props} key="Hi" />, because we aren't currently able to tell if
        // key is explicitly declared to be undefined or not.
        if (maybeKey !== undefined) {
            checkKeyStringCoercion(maybeKey);
            key = "" + maybeKey;
        }
        if (hasValidKey(config)) {
            checkKeyStringCoercion(config.key);
            key = "" + config.key;
        }
        if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
        } // Remaining properties are added to a new props object
        for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
         // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) {
            var children = props.children;
            if (children !== undefined) {
                if (isStaticChildren) {
                    if (isArray(children)) {
                        for(var i = 0; i < children.length; i++)validateChildKeys(children[i], type);
                        if (Object.freeze) Object.freeze(children);
                    } else error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                } else validateChildKeys(children, type);
            }
        }
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    } // These two functions exist to still get child warnings in dev
    // even with the prod transform. This means that jsxDEV is purely
    // opt-in behavior for better messages but that we won't stop
    // giving you warnings if you use production apis.
    function jsxWithValidationStatic(type, props, key) {
        return jsxWithValidation(type, props, key, true);
    }
    function jsxWithValidationDynamic(type, props, key) {
        return jsxWithValidation(type, props, key, false);
    }
    var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
    // for now we can ship identical prod functions
    var jsxs = jsxWithValidationStatic;
    $587db01302e19550$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $587db01302e19550$export$34b9dba7ce09269b = jsx;
    $587db01302e19550$export$25062201e9e25d76 = jsxs;
})();

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jWQW9"));

});
parcelRegister("jWQW9", function(module, exports) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var ReactVersion = "18.2.0";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        transition: null
    };
    var ReactCurrentActQueue = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: false,
        didScheduleLegacyUpdate: false
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var ReactDebugCurrentFrame = {};
    var currentExtraStackFrame = null;
    function setExtraStackFrame(stack) {
        currentExtraStackFrame = stack;
    }
    ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
        currentExtraStackFrame = stack;
    }; // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ""; // Add an extra top frame while an element is being validated
        if (currentExtraStackFrame) stack += currentExtraStackFrame;
         // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || "";
        return stack;
    };
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner
    };
    ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
    ReactSharedInternals.ReactCurrentActQueue = ReactCurrentActQueue;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning("warn", format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || "ReactClass";
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, "forceUpdate");
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, "replaceState");
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, "setState");
        }
    };
    var assign = Object.assign;
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (typeof partialState !== "object" && typeof partialState !== "function" && partialState != null) throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    var deprecatedAPIs = {
        isMounted: [
            "isMounted",
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            "replaceState",
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            }
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (element === null || element === undefined) throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            } // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = ".";
    var SUBSEPARATOR = ":";
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            "=": "=0",
            ":": "=2"
        };
        var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return "$" + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return text.replace(userProvidedKeyEscapeRegex, "$&/");
    }
    /**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getElementKey(element, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof element === "object" && element !== null && element.key != null) {
            checkKeyStringCoercion(element.key);
            return escape("" + element.key);
        } // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if (type === "undefined" || type === "boolean") // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case "string":
            case "number":
                invokeCallback = true;
                break;
            case "object":
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:
            var childKey = nameSoFar === "" ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (isArray(mappedChild)) {
                var escapedChildKey = "";
                if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + "/";
                mapIntoArray(mappedChild, array, escapedChildKey, "", function(c) {
                    return c;
                });
            } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) {
                    // The `if` statement here prevents auto-disabling of the safe
                    // coercion ESLint rule, so we must manually disable it below.
                    // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
                    if (mappedChild.key && (!_child || _child.key !== mappedChild.key)) checkKeyStringCoercion(mappedChild.key);
                    mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
                    escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // eslint-disable-next-line react-internal/safe-string-coercion
                    escapeUserProvidedKey("" + mappedChild.key) + "/" : "") + childKey);
                }
                array.push(mappedChild);
            }
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getElementKey(child, i);
            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === "function") {
                var iterableChildren = children;
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(iterableChildren);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getElementKey(child, ii++);
                    subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
                }
            } else if (type === "object") {
                // eslint-disable-next-line react-internal/safe-string-coercion
                var childrenString = String(children);
                throw new Error("Objects are not valid as a React child (found: " + (childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
            }
        }
        return subtreeCount;
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        var count = 0;
        mapIntoArray(children, result, "", "", function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        var n = 0;
        mapChildren(children, function() {
            n++; // Don't return anything
        });
        return n;
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments); // Don't return anything.
        }, forEachContext);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw new Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
    function createContext(defaultValue) {
        // TODO: Second argument used to be an optional `calculateChangedBits`
        // function. Warn to reserve for future use?
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null,
            // Add these to use same hidden class in VM as ServerContext
            _defaultValue: null,
            _globalName: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        var hasWarnedAboutDisplayNameOnConsumer = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            },
            displayName: {
                get: function() {
                    return context.displayName;
                },
                set: function(displayName) {
                    if (!hasWarnedAboutDisplayNameOnConsumer) {
                        warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                        hasWarnedAboutDisplayNameOnConsumer = true;
                    }
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function lazyInitializer(payload) {
        if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.
            // This might throw either because it's missing or throws. If so, we treat it
            // as still uninitialized and try again next time. Which is the same as what
            // happens if the ctor or any wrappers processing the ctor throws. This might
            // end up fixing it if the resolution was a concurrency bug.
            thenable.then(function(moduleObject) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var resolved = payload;
                    resolved._status = Resolved;
                    resolved._result = moduleObject;
                }
            }, function(error) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var rejected = payload;
                    rejected._status = Rejected;
                    rejected._result = error;
                }
            });
            if (payload._status === Uninitialized) {
                // In case, we're still uninitialized, then we're waiting for the thenable
                // to resolve. Set it as pending in the meantime.
                var pending = payload;
                pending._status = Pending;
                pending._result = thenable;
            }
        }
        if (payload._status === Resolved) {
            var moduleObject = payload._result;
            if (moduleObject === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", moduleObject);
            if (!("default" in moduleObject)) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
            return moduleObject.default;
        } else throw payload._result;
    }
    function lazy(ctor) {
        var payload = {
            // We use these fields to store the result.
            _status: Uninitialized,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes; // $FlowFixMe
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "defaultProps", {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "propTypes", {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== "function") error("forwardRef requires a render function but was given %s.", render === null ? "null" : typeof render);
        else if (render.length !== 0 && render.length !== 2) error("forwardRef render functions accept exactly two parameters: props and ref. %s", render.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.forwardRef((props, ref) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!render.name && !render.displayName) render.displayName = name;
            }
        });
        return elementType;
    }
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? "null" : typeof type);
        var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.memo((props) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!type.name && !type.displayName) type.displayName = name;
            }
        });
        return elementType;
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (dispatcher === null) error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        // intentionally don't throw our own error because this is in a hot path.
        // Also helps ensure this is inlined.
        return dispatcher;
    }
    function useContext(Context) {
        var dispatcher = resolveDispatcher();
        // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useInsertionEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useInsertionEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    function useTransition() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useTransition();
    }
    function useDeferredValue(value) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDeferredValue(value);
    }
    function useId() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useId();
    }
    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher$1.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher$1.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            setExtraStackFrame(stack);
        } else setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, "type", {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, "type", {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    function startTransition(scope, options) {
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = {};
        var currentTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition._updatedFibers = new Set();
        try {
            scope();
        } finally{
            ReactCurrentBatchConfig.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    var didWarnAboutMessageChannel = false;
    var enqueueTaskImpl = null;
    function enqueueTask(task) {
        if (enqueueTaskImpl === null) try {
            // read require off the module object to get around the bundlers.
            // we don't want them to detect a require and bundle a Node polyfill.
            var requireString = ("require" + Math.random()).slice(0, 7);
            var nodeRequire = module && module[requireString]; // assuming we're in node, let's try to get node's
            // version of setImmediate, bypassing fake timers if any.
            enqueueTaskImpl = nodeRequire.call(module, "timers").setImmediate;
        } catch (_err) {
            // we're in a browser
            // we can't use regular timers because they may still be faked
            // so we try MessageChannel+postMessage instead
            enqueueTaskImpl = function(callback) {
                if (didWarnAboutMessageChannel === false) {
                    didWarnAboutMessageChannel = true;
                    if (typeof MessageChannel === "undefined") error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.");
                }
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(undefined);
            };
        }
        return enqueueTaskImpl(task);
    }
    var actScopeDepth = 0;
    var didWarnNoAwaitAct = false;
    function act(callback) {
        // `act` calls can be nested, so we track the depth. This represents the
        // number of `act` scopes on the stack.
        var prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        if (ReactCurrentActQueue.current === null) // This is the outermost `act` scope. Initialize the queue. The reconciler
        // will detect the queue and use it instead of Scheduler.
        ReactCurrentActQueue.current = [];
        var prevIsBatchingLegacy = ReactCurrentActQueue.isBatchingLegacy;
        var result;
        try {
            // Used to reproduce behavior of `batchedUpdates` in legacy mode. Only
            // set to `true` while the given callback is executed, not for updates
            // triggered during an async event, because this is how the legacy
            // implementation of `act` behaved.
            ReactCurrentActQueue.isBatchingLegacy = true;
            result = callback(); // Replicate behavior of original `act` implementation in legacy mode,
            // which flushed updates immediately after the scope function exits, even
            // if it's an async function.
            if (!prevIsBatchingLegacy && ReactCurrentActQueue.didScheduleLegacyUpdate) {
                var queue = ReactCurrentActQueue.current;
                if (queue !== null) {
                    ReactCurrentActQueue.didScheduleLegacyUpdate = false;
                    flushActQueue(queue);
                }
            }
        } catch (error) {
            popActScope(prevActScopeDepth);
            throw error;
        } finally{
            ReactCurrentActQueue.isBatchingLegacy = prevIsBatchingLegacy;
        }
        if (result !== null && typeof result === "object" && typeof result.then === "function") {
            var thenableResult = result; // The callback is an async function (i.e. returned a promise). Wait
            // for it to resolve before exiting the current scope.
            var wasAwaited = false;
            var thenable = {
                then: function(resolve, reject) {
                    wasAwaited = true;
                    thenableResult.then(function(returnValue) {
                        popActScope(prevActScopeDepth);
                        if (actScopeDepth === 0) // We've exited the outermost act scope. Recursively flush the
                        // queue until there's no remaining work.
                        recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        else resolve(returnValue);
                    }, function(error) {
                        // The callback threw an error.
                        popActScope(prevActScopeDepth);
                        reject(error);
                    });
                }
            };
            if (!didWarnNoAwaitAct && typeof Promise !== "undefined") // eslint-disable-next-line no-undef
            Promise.resolve().then(function() {}).then(function() {
                if (!wasAwaited) {
                    didWarnNoAwaitAct = true;
                    error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);");
                }
            });
            return thenable;
        } else {
            var returnValue = result; // The callback is not an async function. Exit the current scope
            // immediately, without awaiting.
            popActScope(prevActScopeDepth);
            if (actScopeDepth === 0) {
                // Exiting the outermost act scope. Flush the queue.
                var _queue = ReactCurrentActQueue.current;
                if (_queue !== null) {
                    flushActQueue(_queue);
                    ReactCurrentActQueue.current = null;
                } // Return a thenable. If the user awaits it, we'll flush again in
                // case additional work was scheduled by a microtask.
                var _thenable = {
                    then: function(resolve, reject) {
                        // Confirm we haven't re-entered another `act` scope, in case
                        // the user does something weird like await the thenable
                        // multiple times.
                        if (ReactCurrentActQueue.current === null) {
                            // Recursively flush the queue until there's no remaining work.
                            ReactCurrentActQueue.current = [];
                            recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        } else resolve(returnValue);
                    }
                };
                return _thenable;
            } else {
                // Since we're inside a nested `act` scope, the returned thenable
                // immediately resolves. The outer scope will flush the queue.
                var _thenable2 = {
                    then: function(resolve, reject) {
                        resolve(returnValue);
                    }
                };
                return _thenable2;
            }
        }
    }
    function popActScope(prevActScopeDepth) {
        if (prevActScopeDepth !== actScopeDepth - 1) error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactCurrentActQueue.current;
        if (queue !== null) try {
            flushActQueue(queue);
            enqueueTask(function() {
                if (queue.length === 0) {
                    // No additional work was scheduled. Finish.
                    ReactCurrentActQueue.current = null;
                    resolve(returnValue);
                } else // Keep flushing work until there's none left.
                recursivelyFlushAsyncActWork(returnValue, resolve, reject);
            });
        } catch (error) {
            reject(error);
        }
        else resolve(returnValue);
    }
    var isFlushing = false;
    function flushActQueue(queue) {
        if (!isFlushing) {
            // Prevent re-entrance.
            isFlushing = true;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(true);
                    while (callback !== null);
                }
                queue.length = 0;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                queue = queue.slice(i + 1);
                throw error;
            } finally{
                isFlushing = false;
            }
        }
    }
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    exports.Children = Children;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
    exports.cloneElement = cloneElement$1;
    exports.createContext = createContext;
    exports.createElement = createElement$1;
    exports.createFactory = createFactory;
    exports.createRef = createRef;
    exports.forwardRef = forwardRef;
    exports.isValidElement = isValidElement;
    exports.lazy = lazy;
    exports.memo = memo;
    exports.startTransition = startTransition;
    exports.unstable_act = act;
    exports.useCallback = useCallback;
    exports.useContext = useContext;
    exports.useDebugValue = useDebugValue;
    exports.useDeferredValue = useDeferredValue;
    exports.useEffect = useEffect;
    exports.useId = useId;
    exports.useImperativeHandle = useImperativeHandle;
    exports.useInsertionEffect = useInsertionEffect;
    exports.useLayoutEffect = useLayoutEffect;
    exports.useMemo = useMemo;
    exports.useReducer = useReducer;
    exports.useRef = useRef;
    exports.useState = useState;
    exports.useSyncExternalStore = useSyncExternalStore;
    exports.useTransition = useTransition;
    exports.version = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("3y30c", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $2956e04298bc31b1$export$ae55be85d98224ed, (v) => $2956e04298bc31b1$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $2956e04298bc31b1$export$d39a5bbd09211389, (v) => $2956e04298bc31b1$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $2956e04298bc31b1$export$882461b6382ed46c, (v) => $2956e04298bc31b1$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $2956e04298bc31b1$export$466bfc07425424d5, (v) => $2956e04298bc31b1$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $2956e04298bc31b1$export$cd75ccfd720a3cd4, (v) => $2956e04298bc31b1$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $2956e04298bc31b1$export$fa8d919ba61d84db, (v) => $2956e04298bc31b1$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $2956e04298bc31b1$export$757ceba2d55c277e, (v) => $2956e04298bc31b1$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $2956e04298bc31b1$export$b3890eb0ae9dca99, (v) => $2956e04298bc31b1$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $2956e04298bc31b1$export$502457920280e6be, (v) => $2956e04298bc31b1$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $2956e04298bc31b1$export$c78a37762a8d58e1, (v) => $2956e04298bc31b1$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $2956e04298bc31b1$export$dc54d992c10e8a18, (v) => $2956e04298bc31b1$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $2956e04298bc31b1$export$83d89fbfd8236492, (v) => $2956e04298bc31b1$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2956e04298bc31b1$export$ae55be85d98224ed;
var $2956e04298bc31b1$export$d39a5bbd09211389;
var $2956e04298bc31b1$export$882461b6382ed46c;
var $2956e04298bc31b1$export$466bfc07425424d5;
var $2956e04298bc31b1$export$cd75ccfd720a3cd4;
var $2956e04298bc31b1$export$fa8d919ba61d84db;
var $2956e04298bc31b1$export$757ceba2d55c277e;
var $2956e04298bc31b1$export$b3890eb0ae9dca99;
var $2956e04298bc31b1$export$502457920280e6be;
var $2956e04298bc31b1$export$c78a37762a8d58e1;
var $2956e04298bc31b1$export$dc54d992c10e8a18;
var $2956e04298bc31b1$export$83d89fbfd8236492;
"use strict";


(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("acw62"));
    var Scheduler = (parcelRequire("fO90s"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    var suppressWarning = false;
    function setSuppressWarning(newSuppressWarning) {
        suppressWarning = newSuppressWarning;
    } // In DEV, calls to console.warn and console.error get replaced
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        if (!suppressWarning) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            printWarning("warn", format, args);
        }
    }
    function error(format) {
        if (!suppressWarning) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            printWarning("error", format, args);
        }
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var ScopeComponent = 21;
    var OffscreenComponent = 22;
    var LegacyHiddenComponent = 23;
    var CacheComponent = 24;
    var TracingMarkerComponent = 25;
    // -----------------------------------------------------------------------------
    var enableClientRenderFallbackOnTextMismatch = true; // TODO: Need to review this code one more time before landing
    // the react-reconciler package.
    var enableNewReconciler = false; // Support legacy Primer support on internal FB www
    var enableLazyContextPropagation = false; // FB-only usage. The new API has different semantics.
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    var enableSuspenseAvoidThisFallback = false; // Enables unstable_avoidThisFallback feature in Fizz
    // React DOM Chopping Block
    //
    // Similar to main Chopping Block but only flags related to React DOM. These are
    // grouped because we will likely batch all of them into a single major release.
    // -----------------------------------------------------------------------------
    // Disable support for comment nodes as React DOM containers. Already disabled
    // in open source, but www codebase still relies on it. Need to remove.
    var disableCommentsAsDOMContainers = true; // Disable javascript: URL strings in href for XSS protection.
    // and client rendering, mostly to allow JSX attributes to apply to the custom
    // element's object properties instead of only HTML attributes.
    // https://github.com/facebook/react/issues/11347
    var enableCustomElementPropertySupport = false; // Disables children for <textarea> elements
    var warnAboutStringRefs = false; // -----------------------------------------------------------------------------
    // Debugging and DevTools
    // -----------------------------------------------------------------------------
    // Adds user timing marks for e.g. state updates, suspense, and work loop stuff,
    // for an experimental timeline tool.
    var enableSchedulingProfiler = true; // Helps identify side effects in render-phase lifecycle hooks and setState
    var enableProfilerTimer = true; // Record durations for commit and passive effects phases.
    var enableProfilerCommitHooks = true; // Phase param passed to onRender callback differentiates between an "update" and a "cascading-update".
    var allNativeEvents = new Set();
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + "Capture", dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        if (registrationNameDependencies[registrationName]) error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === "onDoubleClick") possibleRegistrationNames.ondblclick = registrationName;
        for(var i = 0; i < dependencies.length; i++)allNativeEvents.add(dependencies[i]);
    }
    var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkPropStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkHtmlStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error("Invalid attribute name: `%s`", attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case "function":
            case "symbol":
                // eslint-disable-line
                return true;
            case "boolean":
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== "data-" && prefix !== "aria-";
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === "undefined") return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        "children",
        "dangerouslySetInnerHTML",
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        "defaultValue",
        "defaultChecked",
        "innerHTML",
        "suppressContentEditableWarning",
        "suppressHydrationWarning",
        "style"
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "className",
            "class"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        "contentEditable",
        "draggable",
        "spellCheck",
        "value"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        "allowFullScreen",
        "async",
        // on the client side because the browsers are inconsistent. Instead we call focus().
        "autoFocus",
        "autoPlay",
        "controls",
        "default",
        "defer",
        "disabled",
        "disablePictureInPicture",
        "disableRemotePlayback",
        "formNoValidate",
        "hidden",
        "loop",
        "noModule",
        "noValidate",
        "open",
        "playsInline",
        "readOnly",
        "required",
        "reversed",
        "scoped",
        "seamless",
        "itemScope"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        "checked",
        // disabled with `removeAttribute`. We have special logic for handling this.
        "multiple",
        "muted",
        "selected" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        "capture",
        "download" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        "cols",
        "rows",
        "size",
        "span" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        "rowSpan",
        "start"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        "accent-height",
        "alignment-baseline",
        "arabic-form",
        "baseline-shift",
        "cap-height",
        "clip-path",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "dominant-baseline",
        "enable-background",
        "fill-opacity",
        "fill-rule",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "horiz-adv-x",
        "horiz-origin-x",
        "image-rendering",
        "letter-spacing",
        "lighting-color",
        "marker-end",
        "marker-mid",
        "marker-start",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "pointer-events",
        "rendering-intent",
        "shape-rendering",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "underline-position",
        "underline-thickness",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "v-hanging",
        "v-ideographic",
        "v-mathematical",
        "vector-effect",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "word-spacing",
        "writing-mode",
        "xmlns:xlink",
        "x-height" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
    }); // String SVG attributes with the xml namespace.
    [
        "xml:base",
        "xml:lang",
        "xml:space" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        "tabIndex",
        "crossOrigin"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = "xlinkHref";
    properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
    [
        "src",
        "href",
        "action",
        "formAction"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            checkAttributeStringCoercion(expected, name);
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            // eslint-disable-next-line react-internal/safe-string-coercion
            sanitizeURL("" + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === "") return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                     // eslint-disable-next-line react-internal/safe-string-coercion
                    if (value === "" + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue; // eslint-disable-next-line react-internal/safe-string-coercion
            else if (stringValue === "" + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected, isCustomComponentTag) {
        if (!isAttributeNameSafe(name)) return;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        checkAttributeStringCoercion(expected, name);
        if (value === "" + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else {
                    checkAttributeStringCoercion(value, name);
                    node.setAttribute(_attributeName, "" + value);
                }
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : "";
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = "";
            else {
                checkAttributeStringCoercion(value, attributeName);
                attributeValue = "" + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_SCOPE_TYPE = Symbol.for("react.scope");
    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for("react.debug_trace_mode");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
    var REACT_CACHE_TYPE = Symbol.for("react.cache");
    var REACT_TRACING_MARKER_TYPE = Symbol.for("react.tracing_marker");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    function describeFiber(fiber) {
        var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
        var source = fiber._debugSource;
        switch(fiber.tag){
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame("Lazy");
            case SuspenseComponent:
                return describeBuiltInComponentFrame("Suspense");
            case SuspenseListComponent:
                return describeBuiltInComponentFrame("SuspenseList");
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "";
            var node = workInProgress;
            do {
                info += describeFiber(node);
                node = node.return;
            }while (node);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    function getWrappedName$1(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || "";
        return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
    } // Keep in sync with shared/getComponentNameFromType
    function getContextName$1(type) {
        return type.displayName || "Context";
    }
    function getComponentNameFromFiber(fiber) {
        var tag = fiber.tag, type = fiber.type;
        switch(tag){
            case CacheComponent:
                return "Cache";
            case ContextConsumer:
                var context = type;
                return getContextName$1(context) + ".Consumer";
            case ContextProvider:
                var provider = type;
                return getContextName$1(provider._context) + ".Provider";
            case DehydratedFragment:
                return "DehydratedFragment";
            case ForwardRef:
                return getWrappedName$1(type, type.render, "ForwardRef");
            case Fragment:
                return "Fragment";
            case HostComponent:
                // Host component type is the display name (e.g. "div", "View")
                return type;
            case HostPortal:
                return "Portal";
            case HostRoot:
                return "Root";
            case HostText:
                return "Text";
            case LazyComponent:
                // Name comes from the type in this case; we don't have a tag.
                return getComponentNameFromType(type);
            case Mode:
                if (type === REACT_STRICT_MODE_TYPE) // Don't be less specific than shared/getComponentNameFromType
                return "StrictMode";
                return "Mode";
            case OffscreenComponent:
                return "Offscreen";
            case Profiler:
                return "Profiler";
            case ScopeComponent:
                return "Scope";
            case SuspenseComponent:
                return "Suspense";
            case SuspenseListComponent:
                return "SuspenseList";
            case TracingMarkerComponent:
                return "TracingMarker";
            // The display name for this tags come from the user-provided type:
            case ClassComponent:
            case FunctionComponent:
            case IncompleteClassComponent:
            case IndeterminateComponent:
            case MemoComponent:
            case SimpleMemoComponent:
                if (typeof type === "function") return type.displayName || type.name || null;
                if (typeof type === "string") return type;
                break;
        }
        return null;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== "undefined") return getComponentNameFromFiber(owner);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return "";
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = fiber === null ? null : getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function getCurrentFiber() {
        return current;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        // The coercion safety check is performed in getToStringValue().
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case "boolean":
            case "number":
            case "string":
            case "undefined":
                return value;
            case "object":
                checkFormFieldValueStringCoercion(value);
                return value;
            default:
                // function, symbol are assigned as empty strings
                return "";
        }
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (type === "checkbox" || type === "radio");
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = "";
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? "true" : "false";
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? "checked" : "value";
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        checkFormFieldValueStringCoercion(node[valueField]);
        var currentValue = "" + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === "undefined" || typeof descriptor.get !== "function" || typeof descriptor.set !== "function") return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== "undefined" ? document : undefined);
        if (typeof doc === "undefined") return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === "checkbox" || props.type === "radio";
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        checkControlledValueProps("input", props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? "" : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, "checked", checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === "number") {
                if (value === 0 && node.value === "" || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === "submit" || type === "reset") {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute("value");
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty("value")) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty("defaultValue")) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty("value") || props.hasOwnProperty("defaultValue")) {
            var type = props.type;
            var isButton = type === "submit" || type === "reset"; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== "") node.name = "";
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== "") node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === "radio" && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            checkAttributeStringCoercion(name, "name");
            var group = queryRoot.querySelectorAll("input[name=" + JSON.stringify("" + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode(otherNode);
                if (!otherProps) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== "number" || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    var didWarnInvalidInnerHTML = false;
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // If a value is not provided, then the children must be simple.
        if (props.value == null) {
            if (typeof props.children === "object" && props.children !== null) React.Children.forEach(props.children, function(child) {
                if (child == null) return;
                if (typeof child === "string" || typeof child === "number") return;
                if (!didWarnInvalidChild) {
                    didWarnInvalidChild = true;
                    error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
                }
            });
            else if (props.dangerouslySetInnerHTML != null) {
                if (!didWarnInvalidInnerHTML) {
                    didWarnInvalidInnerHTML = true;
                    error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
                }
            }
        } // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute("value", toString(getToStringValue(props.value)));
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return "\n\nCheck the render method of `" + ownerName + "`.";
        return "";
    }
    var valuePropNames = [
        "value",
        "defaultValue"
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        checkControlledValueProps("select", props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var propNameIsArray = isArray(props[propName]);
            if (props.multiple && !propNameIsArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && propNameIsArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue["$" + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty("$" + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$1(element, props) {
        return assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : "", false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$2(element, props) {
        var node = element;
        if (props.dangerouslySetInnerHTML != null) throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        checkControlledValueProps("textarea", props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component");
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (defaultValue != null) throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (isArray(children)) {
                    if (children.length > 1) throw new Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = "";
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== "" && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
    var MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
    var SVG_NAMESPACE = "http://www.w3.org/2000/svg"; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case "svg":
                return SVG_NAMESPACE;
            case "math":
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === "foreignObject") // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== "undefined" && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === SVG_NAMESPACE) {
            if (!("innerHTML" in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement("div");
                reusableSVGContainer.innerHTML = "<svg>" + html.valueOf().toString() + "</svg>";
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            "animationDelay",
            "animationDirection",
            "animationDuration",
            "animationFillMode",
            "animationIterationCount",
            "animationName",
            "animationPlayState",
            "animationTimingFunction"
        ],
        background: [
            "backgroundAttachment",
            "backgroundClip",
            "backgroundColor",
            "backgroundImage",
            "backgroundOrigin",
            "backgroundPositionX",
            "backgroundPositionY",
            "backgroundRepeat",
            "backgroundSize"
        ],
        backgroundPosition: [
            "backgroundPositionX",
            "backgroundPositionY"
        ],
        border: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth",
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth",
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth",
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth",
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderBlockEnd: [
            "borderBlockEndColor",
            "borderBlockEndStyle",
            "borderBlockEndWidth"
        ],
        borderBlockStart: [
            "borderBlockStartColor",
            "borderBlockStartStyle",
            "borderBlockStartWidth"
        ],
        borderBottom: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth"
        ],
        borderColor: [
            "borderBottomColor",
            "borderLeftColor",
            "borderRightColor",
            "borderTopColor"
        ],
        borderImage: [
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth"
        ],
        borderInlineEnd: [
            "borderInlineEndColor",
            "borderInlineEndStyle",
            "borderInlineEndWidth"
        ],
        borderInlineStart: [
            "borderInlineStartColor",
            "borderInlineStartStyle",
            "borderInlineStartWidth"
        ],
        borderLeft: [
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth"
        ],
        borderRadius: [
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius"
        ],
        borderRight: [
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth"
        ],
        borderStyle: [
            "borderBottomStyle",
            "borderLeftStyle",
            "borderRightStyle",
            "borderTopStyle"
        ],
        borderTop: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderWidth: [
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth"
        ],
        columnRule: [
            "columnRuleColor",
            "columnRuleStyle",
            "columnRuleWidth"
        ],
        columns: [
            "columnCount",
            "columnWidth"
        ],
        flex: [
            "flexBasis",
            "flexGrow",
            "flexShrink"
        ],
        flexFlow: [
            "flexDirection",
            "flexWrap"
        ],
        font: [
            "fontFamily",
            "fontFeatureSettings",
            "fontKerning",
            "fontLanguageOverride",
            "fontSize",
            "fontSizeAdjust",
            "fontStretch",
            "fontStyle",
            "fontVariant",
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition",
            "fontWeight",
            "lineHeight"
        ],
        fontVariant: [
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition"
        ],
        gap: [
            "columnGap",
            "rowGap"
        ],
        grid: [
            "gridAutoColumns",
            "gridAutoFlow",
            "gridAutoRows",
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        gridArea: [
            "gridColumnEnd",
            "gridColumnStart",
            "gridRowEnd",
            "gridRowStart"
        ],
        gridColumn: [
            "gridColumnEnd",
            "gridColumnStart"
        ],
        gridColumnGap: [
            "columnGap"
        ],
        gridGap: [
            "columnGap",
            "rowGap"
        ],
        gridRow: [
            "gridRowEnd",
            "gridRowStart"
        ],
        gridRowGap: [
            "rowGap"
        ],
        gridTemplate: [
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        listStyle: [
            "listStyleImage",
            "listStylePosition",
            "listStyleType"
        ],
        margin: [
            "marginBottom",
            "marginLeft",
            "marginRight",
            "marginTop"
        ],
        marker: [
            "markerEnd",
            "markerMid",
            "markerStart"
        ],
        mask: [
            "maskClip",
            "maskComposite",
            "maskImage",
            "maskMode",
            "maskOrigin",
            "maskPositionX",
            "maskPositionY",
            "maskRepeat",
            "maskSize"
        ],
        maskPosition: [
            "maskPositionX",
            "maskPositionY"
        ],
        outline: [
            "outlineColor",
            "outlineStyle",
            "outlineWidth"
        ],
        overflow: [
            "overflowX",
            "overflowY"
        ],
        padding: [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ],
        placeContent: [
            "alignContent",
            "justifyContent"
        ],
        placeItems: [
            "alignItems",
            "justifyItems"
        ],
        placeSelf: [
            "alignSelf",
            "justifySelf"
        ],
        textDecoration: [
            "textDecorationColor",
            "textDecorationLine",
            "textDecorationStyle"
        ],
        textEmphasis: [
            "textEmphasisColor",
            "textEmphasisStyle"
        ],
        transition: [
            "transitionDelay",
            "transitionDuration",
            "transitionProperty",
            "transitionTimingFunction"
        ],
        wordWrap: [
            "overflowWrap"
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        "Webkit",
        "ms",
        "Moz",
        "O"
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === "boolean" || value === "";
        if (isEmpty) return "";
        if (!isCustomProperty && typeof value === "number" && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
        checkCSSPropertyStringCoercion(value, name);
        return ("" + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-");
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported style property %s. Did you mean %s?", name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, "ms-")));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ""));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error("`NaN` is an invalid value for the `%s` css style property.", name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error("`Infinity` is an invalid value for the `%s` css style property.", name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf("-") > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === "number") {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = "";
        var delimiter = "";
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf("--") === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ":";
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ";";
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf("--") === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === "float") styleName = "cssFloat";
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === "boolean" || value === "";
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + "," + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? "Removing" : "Updating", originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = "__html";
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (props.children != null || props.dangerouslySetInnerHTML != null) throw new Error(tag + " is a void element tag and must neither have `children` nor " + "use `dangerouslySetInnerHTML`.");
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (props.children != null) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (typeof props.dangerouslySetInnerHTML !== "object" || !(HTML in props.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (props.style != null && typeof props.style !== "object") throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf("-") === -1) return typeof props.is === "string";
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    };
    var ariaProperties = {
        "aria-current": 0,
        // state
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    function validateProperty(tagName, name) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = "aria-" + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== "input" && type !== "textarea" && type !== "select") return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === "select" && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error("Unknown event handler property `%s`. It will be ignored.", name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === "innerhtml") {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "aria") {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "is" && value !== null && value !== undefined && typeof value !== "string") {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "number" && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
    var IS_NON_DELEGATED = 2;
    var IS_CAPTURE_PHASE = 4;
    // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
    // we call willDeferLaterForLegacyFBSupport, thus not bailing out
    // will result in endless cycles like an infinite loop.
    // We also don't want to defer during event replaying.
    var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
    // This exists to avoid circular dependency between ReactDOMEventReplaying
    // and DOMPluginEventSystem.
    var currentReplayingEvent = null;
    function setReplayingEvent(event) {
        if (currentReplayingEvent !== null) error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = event;
    }
    function resetReplayingEvent() {
        if (currentReplayingEvent === null) error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = null;
    }
    function isReplayingEvent(event) {
        return event === currentReplayingEvent;
    }
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (typeof restoreImpl !== "function") throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var flushSyncImpl = function() {};
    var isInsideEventHandler = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            // TODO: Restore state in the microtask, after the discrete updates flush,
            // instead of early flushing them here.
            flushSyncImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, a, b) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, a, b);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    } // TODO: Replace with flushSync
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushSyncImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        flushSyncImpl = _flushSyncImpl;
    }
    function isInteractive(tag) {
        return tag === "button" || tag === "input" || tag === "select" || tag === "textarea";
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (stateNode === null) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (props === null) // Work in progress.
        return null;
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (listener && typeof listener !== "function") throw new Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    if (canUseDOM) try {
        var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value
        Object.defineProperty(options, "passive", {
            get: function() {
                passiveBrowserEventsSupported = true;
            }
        });
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
    } catch (e) {
        passiveBrowserEventsSupported = false;
    }
    function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    }
    var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof document !== "undefined" && typeof document.createEvent === "function") {
        var fakeNode = document.createElement("react");
        invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebook/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (typeof document === "undefined" || document === null) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent("Event");
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, "event");
            function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== "undefined" && window.hasOwnProperty("event")) window.event = windowEvent;
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === "object") try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : "invokeguardedcallback"); // Attach our event handlers
            window.addEventListener("error", handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, "event", windowEventDescriptor);
            if (didCall && didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener("error", handleWindowError);
            if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
            }
        };
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function has(key) {
        return key._reactInternals !== undefined;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoFlags = /*                      */ 0;
    var PerformedWork = /*                */ 1; // You can change the rest (and add more).
    var Placement = /*                    */ 2;
    var Update = /*                       */ 4;
    var ChildDeletion = /*                */ 16;
    var ContentReset = /*                 */ 32;
    var Callback = /*                     */ 64;
    var DidCapture = /*                   */ 128;
    var ForceClientRender = /*            */ 256;
    var Ref = /*                          */ 512;
    var Snapshot = /*                     */ 1024;
    var Passive = /*                      */ 2048;
    var Hydrating = /*                    */ 4096;
    var Visibility = /*                   */ 8192;
    var StoreConsistency = /*             */ 16384;
    var LifecycleEffectMask = Passive | Update | Callback | Ref | Snapshot | StoreConsistency; // Union of all commit flags (flags with the lifetime of a particular commit)
    var HostEffectMask = /*               */ 32767; // These are not really side effects, but we still reuse this field.
    var Incomplete = /*                   */ 32768;
    var ShouldCapture = /*                */ 65536;
    var ForceUpdateForLegacySuspense = /* */ 131072;
    var Forked = /*                       */ 1048576; // Static tags describe aspects of a fiber that are not specific to a render,
    // e.g. a fiber uses a passive effect (even if there are no updates on this particular render).
    // This enables us to defer more work in the unmount case,
    // since we can defer traversing the tree during layout to look for Passive effects,
    // and instead rely on the static flag as a signal that there may be cleanup work.
    var RefStatic = /*                    */ 2097152;
    var LayoutStatic = /*                 */ 4194304;
    var PassiveStatic = /*                */ 8388608; // These flags allow us to traverse to fibers that have effects on mount
    // without traversing the entire tree after every commit for
    // double invoking
    var MountLayoutDev = /*               */ 16777216;
    var MountPassiveDev = /*              */ 33554432; // Groups of flags that are used in the commit phase to skip over trees that
    // don't contain effects, by checking subtreeFlags.
    var BeforeMutationMask = // flag logic (see #20043)
    Update | Snapshot | 0;
    var MutationMask = Placement | Update | ChildDeletion | ContentReset | Ref | Hydrating | Visibility;
    var LayoutMask = Update | Callback | Ref | Visibility; // TODO: Split into PassiveMountMask and PassiveUnmountMask
    var PassiveMask = Passive | ChildDeletion; // Union of tags that don't get reset on clones.
    // This allows certain concepts to persist without recalculating them,
    // e.g. whether a subtree contains passive effects or portals.
    var StaticMask = LayoutStatic | PassiveStatic | RefStatic;
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.flags & (Placement | Hydrating)) !== NoFlags) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromFiber(ownerFiber) || "A component");
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw new Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (nearestMounted === null) throw new Error("Unable to find node on an unmounted component.");
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                // way this could possibly happen is if this was unmounted, if at all.
                throw new Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (a.tag !== HostRoot) throw new Error("Unable to find node on an unmounted component.");
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberImpl(currentParent) : null;
    }
    function findCurrentHostFiberImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            var match = findCurrentHostFiberImpl(child);
            if (match !== null) return match;
            child = child.sibling;
        }
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberWithNoPortalsImpl(currentParent) : null;
    }
    function findCurrentHostFiberWithNoPortalsImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            if (child.tag !== HostPortal) {
                var match = findCurrentHostFiberWithNoPortalsImpl(child);
                if (match !== null) return match;
            }
            child = child.sibling;
        }
        return null;
    }
    // This module only exists as an ESM wrapper around the external CommonJS
    var scheduleCallback = Scheduler.unstable_scheduleCallback;
    var cancelCallback = Scheduler.unstable_cancelCallback;
    var shouldYield = Scheduler.unstable_shouldYield;
    var requestPaint = Scheduler.unstable_requestPaint;
    var now = Scheduler.unstable_now;
    var getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel;
    var ImmediatePriority = Scheduler.unstable_ImmediatePriority;
    var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority;
    var NormalPriority = Scheduler.unstable_NormalPriority;
    var LowPriority = Scheduler.unstable_LowPriority;
    var IdlePriority = Scheduler.unstable_IdlePriority;
    // this doesn't actually exist on the scheduler, but it *does*
    // on scheduler/unstable_mock, which we'll need for internal testing
    var unstable_yieldValue = Scheduler.unstable_yieldValue;
    var unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue;
    var rendererID = null;
    var injectedHook = null;
    var injectedProfilingHooks = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined";
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined") // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            return true;
        }
        try {
            if (enableSchedulingProfiler) // Conditionally inject these hooks only if Timeline profiler is supported by this build.
            // This gives DevTools a way to feature detect that isn't tied to version number
            // (since profiling and timeline are controlled by different feature flags).
            internals = assign({}, internals, {
                getLaneLabelMap: getLaneLabelMap,
                injectProfilingHooks: injectProfilingHooks
            });
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            injectedHook = hook;
        } catch (err) {
            error("React instrumentation encountered an error: %s.", err);
        }
        if (hook.checkDCE) // This is the real DevTools.
        return true;
        else // This is likely a hook installed by Fast Refresh runtime.
        return false;
    }
    function onScheduleRoot(root, children) {
        if (injectedHook && typeof injectedHook.onScheduleFiberRoot === "function") try {
            injectedHook.onScheduleFiberRoot(rendererID, root, children);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitRoot(root, eventPriority) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === "function") try {
            var didError = (root.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) {
                var schedulerPriority;
                switch(eventPriority){
                    case DiscreteEventPriority:
                        schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority;
                        break;
                }
                injectedHook.onCommitFiberRoot(rendererID, root, schedulerPriority, didError);
            } else injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onPostCommitRoot(root) {
        if (injectedHook && typeof injectedHook.onPostCommitFiberRoot === "function") try {
            injectedHook.onPostCommitFiberRoot(rendererID, root);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === "function") try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        if (typeof unstable_yieldValue === "function") {
            // We're in a test because Scheduler.unstable_yieldValue only exists
            // in SchedulerMock. To reduce the noise in strict mode tests,
            // suppress warnings and disable scheduler yielding during the double render
            unstable_setDisableYieldValue(newIsStrictMode);
            setSuppressWarning(newIsStrictMode);
        }
        if (injectedHook && typeof injectedHook.setStrictMode === "function") try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    } // Profiler API hooks
    function injectProfilingHooks(profilingHooks) {
        injectedProfilingHooks = profilingHooks;
    }
    function getLaneLabelMap() {
        var map = new Map();
        var lane = 1;
        for(var index = 0; index < TotalLanes; index++){
            var label = getLabelForLane(lane);
            map.set(lane, label);
            lane *= 2;
        }
        return map;
    }
    function markCommitStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStarted === "function") injectedProfilingHooks.markCommitStarted(lanes);
    }
    function markCommitStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStopped === "function") injectedProfilingHooks.markCommitStopped();
    }
    function markComponentRenderStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStarted === "function") injectedProfilingHooks.markComponentRenderStarted(fiber);
    }
    function markComponentRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStopped === "function") injectedProfilingHooks.markComponentRenderStopped();
    }
    function markComponentPassiveEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectMountStarted(fiber);
    }
    function markComponentPassiveEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectMountStopped();
    }
    function markComponentPassiveEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStarted(fiber);
    }
    function markComponentPassiveEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStopped();
    }
    function markComponentLayoutEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectMountStarted(fiber);
    }
    function markComponentLayoutEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectMountStopped();
    }
    function markComponentLayoutEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStarted(fiber);
    }
    function markComponentLayoutEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStopped();
    }
    function markComponentErrored(fiber, thrownValue, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentErrored === "function") injectedProfilingHooks.markComponentErrored(fiber, thrownValue, lanes);
    }
    function markComponentSuspended(fiber, wakeable, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentSuspended === "function") injectedProfilingHooks.markComponentSuspended(fiber, wakeable, lanes);
    }
    function markLayoutEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStarted === "function") injectedProfilingHooks.markLayoutEffectsStarted(lanes);
    }
    function markLayoutEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStopped === "function") injectedProfilingHooks.markLayoutEffectsStopped();
    }
    function markPassiveEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStarted === "function") injectedProfilingHooks.markPassiveEffectsStarted(lanes);
    }
    function markPassiveEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStopped === "function") injectedProfilingHooks.markPassiveEffectsStopped();
    }
    function markRenderStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStarted === "function") injectedProfilingHooks.markRenderStarted(lanes);
    }
    function markRenderYielded() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderYielded === "function") injectedProfilingHooks.markRenderYielded();
    }
    function markRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStopped === "function") injectedProfilingHooks.markRenderStopped();
    }
    function markRenderScheduled(lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderScheduled === "function") injectedProfilingHooks.markRenderScheduled(lane);
    }
    function markForceUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markForceUpdateScheduled === "function") injectedProfilingHooks.markForceUpdateScheduled(fiber, lane);
    }
    function markStateUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markStateUpdateScheduled === "function") injectedProfilingHooks.markStateUpdateScheduled(fiber, lane);
    }
    var NoMode = /*                         */ 0; // TODO: Remove ConcurrentMode by reading from the root tag instead
    var ConcurrentMode = /*                 */ 1;
    var ProfileMode = /*                    */ 2;
    var StrictLegacyMode = /*               */ 8;
    var StrictEffectsMode = /*              */ 16;
    // TODO: This is pretty well supported by browsers. Maybe we can drop it.
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(x) {
        var asUint = x >>> 0;
        if (asUint === 0) return 32;
        return 31 - (log(asUint) / LN2 | 0) | 0;
    }
    // If those values are changed that package should be rebuilt and redeployed.
    var TotalLanes = 31;
    var NoLanes = /*                        */ 0;
    var NoLane = /*                          */ 0;
    var SyncLane = /*                        */ 1;
    var InputContinuousHydrationLane = /*    */ 2;
    var InputContinuousLane = /*             */ 4;
    var DefaultHydrationLane = /*            */ 8;
    var DefaultLane = /*                     */ 16;
    var TransitionHydrationLane = /*                */ 32;
    var TransitionLanes = /*                       */ 4194240;
    var TransitionLane1 = /*                        */ 64;
    var TransitionLane2 = /*                        */ 128;
    var TransitionLane3 = /*                        */ 256;
    var TransitionLane4 = /*                        */ 512;
    var TransitionLane5 = /*                        */ 1024;
    var TransitionLane6 = /*                        */ 2048;
    var TransitionLane7 = /*                        */ 4096;
    var TransitionLane8 = /*                        */ 8192;
    var TransitionLane9 = /*                        */ 16384;
    var TransitionLane10 = /*                       */ 32768;
    var TransitionLane11 = /*                       */ 65536;
    var TransitionLane12 = /*                       */ 131072;
    var TransitionLane13 = /*                       */ 262144;
    var TransitionLane14 = /*                       */ 524288;
    var TransitionLane15 = /*                       */ 1048576;
    var TransitionLane16 = /*                       */ 2097152;
    var RetryLanes = /*                            */ 130023424;
    var RetryLane1 = /*                             */ 4194304;
    var RetryLane2 = /*                             */ 8388608;
    var RetryLane3 = /*                             */ 16777216;
    var RetryLane4 = /*                             */ 33554432;
    var RetryLane5 = /*                             */ 67108864;
    var SomeRetryLane = RetryLane1;
    var SelectiveHydrationLane = /*          */ 134217728;
    var NonIdleLanes = /*                          */ 268435455;
    var IdleHydrationLane = /*               */ 268435456;
    var IdleLane = /*                        */ 536870912;
    var OffscreenLane = /*                   */ 1073741824; // This function is used for the experimental timeline (react-devtools-timeline)
    // It should be kept in sync with the Lanes values above.
    function getLabelForLane(lane) {
        if (lane & SyncLane) return "Sync";
        if (lane & InputContinuousHydrationLane) return "InputContinuousHydration";
        if (lane & InputContinuousLane) return "InputContinuous";
        if (lane & DefaultHydrationLane) return "DefaultHydration";
        if (lane & DefaultLane) return "Default";
        if (lane & TransitionHydrationLane) return "TransitionHydration";
        if (lane & TransitionLanes) return "Transition";
        if (lane & RetryLanes) return "Retry";
        if (lane & SelectiveHydrationLane) return "SelectiveHydration";
        if (lane & IdleHydrationLane) return "IdleHydration";
        if (lane & IdleLane) return "Idle";
        if (lane & OffscreenLane) return "Offscreen";
    }
    var NoTimestamp = -1;
    var nextTransitionLane = TransitionLane1;
    var nextRetryLane = RetryLane1;
    function getHighestPriorityLanes(lanes) {
        switch(getHighestPriorityLane(lanes)){
            case SyncLane:
                return SyncLane;
            case InputContinuousHydrationLane:
                return InputContinuousHydrationLane;
            case InputContinuousLane:
                return InputContinuousLane;
            case DefaultHydrationLane:
                return DefaultHydrationLane;
            case DefaultLane:
                return DefaultLane;
            case TransitionHydrationLane:
                return TransitionHydrationLane;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return lanes & TransitionLanes;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                return lanes & RetryLanes;
            case SelectiveHydrationLane:
                return SelectiveHydrationLane;
            case IdleHydrationLane:
                return IdleHydrationLane;
            case IdleLane:
                return IdleLane;
            case OffscreenLane:
                return OffscreenLane;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return lanes;
        }
    }
    function getNextLanes(root, wipLanes) {
        // Early bailout if there's no pending work left.
        var pendingLanes = root.pendingLanes;
        if (pendingLanes === NoLanes) return NoLanes;
        var nextLanes = NoLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes; // Do not work on any idle work until all the non-idle work has finished,
        // even if the work is suspended.
        var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
        if (nonIdlePendingLanes !== NoLanes) {
            var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
            if (nonIdleUnblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
            else {
                var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                if (nonIdlePingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
            }
        } else {
            // The only remaining work is Idle.
            var unblockedLanes = pendingLanes & ~suspendedLanes;
            if (unblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(unblockedLanes);
            else if (pingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(pingedLanes);
        }
        if (nextLanes === NoLanes) // This should only be reachable if we're suspended
        // TODO: Consider warning in this path if a fallback timer is not scheduled.
        return NoLanes;
         // If we're already in the middle of a render, switching lanes will interrupt
        // it and we'll lose our progress. We should only do this if the new lanes are
        // higher priority.
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
            var nextLane = getHighestPriorityLane(nextLanes);
            var wipLane = getHighestPriorityLane(wipLanes);
            if (// one. This works because the bits decrease in priority as you go left.
            nextLane >= wipLane || // Default priority updates should not interrupt transition updates. The
            // only difference between default updates and transition updates is that
            // default updates do not support refresh transitions.
            nextLane === DefaultLane && (wipLane & TransitionLanes) !== NoLanes) // Keep working on the existing in-progress tree. Do not interrupt.
            return wipLanes;
        }
        if ((nextLanes & InputContinuousLane) !== NoLanes) // When updates are sync by default, we entangle continuous priority updates
        // and default updates, so they render in the same batch. The only reason
        // they use separate lanes is because continuous updates should interrupt
        // transitions, but default updates should not.
        nextLanes |= pendingLanes & DefaultLane;
         // Check for entangled lanes and add them to the batch.
        //
        // A lane is said to be entangled with another when it's not allowed to render
        // in a batch that does not also include the other lane. Typically we do this
        // when multiple updates have the same source, and we only want to respond to
        // the most recent event from that source.
        //
        // Note that we apply entanglements *after* checking for partial work above.
        // This means that if a lane is entangled during an interleaved event while
        // it's already rendering, we won't interrupt it. This is intentional, since
        // entanglement is usually "best effort": we'll try our best to render the
        // lanes in the same batch, but it's not worth throwing out partially
        // completed work in order to do it.
        // TODO: Reconsider this. The counter-argument is that the partial work
        // represents an intermediate state, which we don't want to show to the user.
        // And by spending extra time finishing it, we're increasing the amount of
        // time it takes to show the final state, which is what they are actually
        // waiting for.
        //
        // For those exceptions where entanglement is semantically important, like
        // useMutableSource, we should ensure that there is no partial work at the
        // time we apply the entanglement.
        var entangledLanes = root.entangledLanes;
        if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;
            while(lanes > 0){
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                nextLanes |= entanglements[index];
                lanes &= ~lane;
            }
        }
        return nextLanes;
    }
    function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];
            if (eventTime > mostRecentEventTime) mostRecentEventTime = eventTime;
            lanes &= ~lane;
        }
        return mostRecentEventTime;
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case SyncLane:
            case InputContinuousHydrationLane:
            case InputContinuousLane:
                // User interactions should expire slightly more quickly.
                //
                // NOTE: This is set to the corresponding constant as in Scheduler.js.
                // When we made it larger, a product metric in www regressed, suggesting
                // there's a user interaction that's being starved by a series of
                // synchronous updates. If that theory is correct, the proper solution is
                // to fix the starvation. However, this scenario supports the idea that
                // expiration times are an important safeguard when starvation
                // does happen.
                return currentTime + 250;
            case DefaultHydrationLane:
            case DefaultLane:
            case TransitionHydrationLane:
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return currentTime + 5000;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                // TODO: Retries should be allowed to expire if they are CPU bound for
                // too long, but when I made this change it caused a spike in browser
                // crashes. There must be some other underlying bug; not super urgent but
                // ideally should figure out why and fix it. Unfortunately we don't have
                // a repro for the crashes, only detected via production metrics.
                return NoTimestamp;
            case SelectiveHydrationLane:
            case IdleHydrationLane:
            case IdleLane:
            case OffscreenLane:
                // Anything idle priority or lower should never expire.
                return NoTimestamp;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return NoTimestamp;
        }
    }
    function markStarvedLanesAsExpired(root, currentTime) {
        // TODO: This gets called every time we yield. We can optimize by storing
        // the earliest expiration time on the root. Then use that to quickly bail out
        // of this function.
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
        // expiration time. If so, we'll assume the update is being starved and mark
        // it as expired to force it to finish.
        var lanes = pendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];
            if (expirationTime === NoTimestamp) // Found a pending lane with no expiration time. If it's not suspended, or
            // if it's pinged, assume it's CPU-bound. Compute a new expiration time
            // using the current time.
            {
                if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else if (expirationTime <= currentTime) // This lane expired
            root.expiredLanes |= lane;
            lanes &= ~lane;
        }
    } // This returns the highest priority pending lanes regardless of whether they
    // are suspended.
    function getHighestPriorityPendingLanes(root) {
        return getHighestPriorityLanes(root.pendingLanes);
    }
    function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) return everythingButOffscreen;
        if (everythingButOffscreen & OffscreenLane) return OffscreenLane;
        return NoLanes;
    }
    function includesSyncLane(lanes) {
        return (lanes & SyncLane) !== NoLanes;
    }
    function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
    }
    function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
    }
    function includesOnlyNonUrgentLanes(lanes) {
        var UrgentLanes = SyncLane | InputContinuousLane | DefaultLane;
        return (lanes & UrgentLanes) === NoLanes;
    }
    function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
    }
    function includesBlockingLane(root, lanes) {
        var SyncDefaultLanes = InputContinuousHydrationLane | InputContinuousLane | DefaultHydrationLane | DefaultLane;
        return (lanes & SyncDefaultLanes) !== NoLanes;
    }
    function includesExpiredLane(root, lanes) {
        // This is a separate check from includesBlockingLane because a lane can
        // expire after a render has already started.
        return (lanes & root.expiredLanes) !== NoLanes;
    }
    function isTransitionLane(lane) {
        return (lane & TransitionLanes) !== NoLanes;
    }
    function claimNextTransitionLane() {
        // Cycle through the lanes, assigning each new transition to the next lane.
        // In most cases, this means every transition gets its own lane, until we
        // run out of lanes and cycle back to the beginning.
        var lane = nextTransitionLane;
        nextTransitionLane <<= 1;
        if ((nextTransitionLane & TransitionLanes) === NoLanes) nextTransitionLane = TransitionLane1;
        return lane;
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        if ((nextRetryLane & RetryLanes) === NoLanes) nextRetryLane = RetryLane1;
        return lane;
    }
    function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
    }
    function pickArbitraryLane(lanes) {
        // This wrapper function gets inlined. Only exists so to communicate that it
        // doesn't matter which bit is selected; you can pick any bit without
        // affecting the algorithms where its used. Here I'm using
        // getHighestPriorityLane because it requires the fewest operations.
        return getHighestPriorityLane(lanes);
    }
    function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
    }
    function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
    }
    function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
    }
    function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
    }
    function mergeLanes(a, b) {
        return a | b;
    }
    function removeLanes(set, subset) {
        return set & ~subset;
    }
    function intersectLanes(a, b) {
        return a & b;
    } // Seems redundant, but it changes the type from a single lane (used for
    // updates) to a group of lanes (used for flushing work).
    function laneToLanes(lane) {
        return lane;
    }
    function higherPriorityLane(a, b) {
        // This works because the bit ranges decrease in priority as you go left.
        return a !== NoLane && a < b ? a : b;
    }
    function createLaneMap(initial) {
        // Intentionally pushing one by one.
        // https://v8.dev/blog/elements-kinds#avoid-creating-holes
        var laneMap = [];
        for(var i = 0; i < TotalLanes; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane; // If there are any suspended transitions, it's possible this new update
        // could unblock them. Clear the suspended lanes so that we can try rendering
        // them again.
        //
        // TODO: We really only need to unsuspend only lanes that are in the
        // `subtreeLanes` of the updated fiber, or the update lanes of the return
        // path. This would exclude suspended updates in an unrelated sibling tree,
        // since there's no way for this update to unblock it.
        //
        // We don't do this if the incoming update is idle, because we never process
        // idle updates until after all the regular updates have finished; there's no
        // way it could unblock a transition.
        if (updateLane !== IdleLane) {
            root.suspendedLanes = NoLanes;
            root.pingedLanes = NoLanes;
        }
        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
        // recent event, and we assume time is monotonically increasing.
        eventTimes[index] = eventTime;
    }
    function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
    }
    function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes; // Let's try everything again
        root.suspendedLanes = NoLanes;
        root.pingedLanes = NoLanes;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work
        var lanes = noLongerPendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootEntangled(root, entangledLanes) {
        // In addition to entangling each of the given lanes with each other, we also
        // have to consider _transitive_ entanglements. For each lane that is already
        // entangled with *any* of the given lanes, that lane is now transitively
        // entangled with *all* the given lanes.
        //
        // Translated: If C is entangled with A, then entangling A with B also
        // entangles C with B.
        //
        // If this is hard to grasp, it might help to intentionally break this
        // function and look at the tests that fail in ReactTransition-test.js. Try
        // commenting out one of the conditions below.
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = rootEntangledLanes;
        while(lanes){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            if (lane & entangledLanes | // Is this lane transitively entangled with the newly entangled lanes?
            entanglements[index] & entangledLanes) entanglements[index] |= entangledLanes;
            lanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = getHighestPriorityLane(renderLanes);
        var lane;
        switch(renderLane){
            case InputContinuousLane:
                lane = InputContinuousHydrationLane;
                break;
            case DefaultLane:
                lane = DefaultHydrationLane;
                break;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                lane = TransitionHydrationLane;
                break;
            case IdleLane:
                lane = IdleHydrationLane;
                break;
            default:
                // Everything else is already either a hydration lane, or shouldn't
                // be retried at a hydration lane.
                lane = NoLane;
                break;
        } // Check if the lane we chose is suspended. If so, that indicates that we
        // already attempted and failed to hydrate at that level. Also check if we're
        // already rendering that lane, which is rare but could happen.
        if ((lane & (root.suspendedLanes | renderLanes)) !== NoLane) // Give up trying to hydrate and fall back to client render.
        return NoLane;
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            updaters.add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        var memoizedUpdaters = root.memoizedUpdaters;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            if (updaters.size > 0) {
                updaters.forEach(function(fiber) {
                    var alternate = fiber.alternate;
                    if (alternate === null || !memoizedUpdaters.has(alternate)) memoizedUpdaters.add(fiber);
                });
                updaters.clear();
            }
            lanes &= ~lane;
        }
    }
    function getTransitionsForLanes(root, lanes) {
        return null;
    }
    var DiscreteEventPriority = SyncLane;
    var ContinuousEventPriority = InputContinuousLane;
    var DefaultEventPriority = DefaultLane;
    var IdleEventPriority = IdleLane;
    var currentUpdatePriority = NoLane;
    function getCurrentUpdatePriority() {
        return currentUpdatePriority;
    }
    function setCurrentUpdatePriority(newPriority) {
        currentUpdatePriority = newPriority;
    }
    function runWithPriority(priority, fn) {
        var previousPriority = currentUpdatePriority;
        try {
            currentUpdatePriority = priority;
            return fn();
        } finally{
            currentUpdatePriority = previousPriority;
        }
    }
    function higherEventPriority(a, b) {
        return a !== 0 && a < b ? a : b;
    }
    function lowerEventPriority(a, b) {
        return a === 0 || a > b ? a : b;
    }
    function isHigherEventPriority(a, b) {
        return a !== 0 && a < b;
    }
    function lanesToEventPriority(lanes) {
        var lane = getHighestPriorityLane(lanes);
        if (!isHigherEventPriority(DiscreteEventPriority, lane)) return DiscreteEventPriority;
        if (!isHigherEventPriority(ContinuousEventPriority, lane)) return ContinuousEventPriority;
        if (includesNonIdleWork(lane)) return DefaultEventPriority;
        return IdleEventPriority;
    }
    // This is imported by the event replaying implementation in React DOM. It's
    // in a separate file to break a circular dependency between the renderer and
    // the reconciler.
    function isRootDehydrated(root) {
        var currentState = root.current.memoizedState;
        return currentState.isDehydrated;
    }
    var _attemptSynchronousHydration;
    function setAttemptSynchronousHydration(fn) {
        _attemptSynchronousHydration = fn;
    }
    function attemptSynchronousHydration(fiber) {
        _attemptSynchronousHydration(fiber);
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    }
    var getCurrentUpdatePriority$1;
    function setGetCurrentUpdatePriority(fn) {
        getCurrentUpdatePriority$1 = fn;
    }
    var attemptHydrationAtPriority;
    function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    // has this definition built-in.
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    var discreteReplayableEvents = [
        "mousedown",
        "mouseup",
        "touchcancel",
        "touchend",
        "touchstart",
        "auxclick",
        "dblclick",
        "pointercancel",
        "pointerdown",
        "pointerup",
        "dragend",
        "dragstart",
        "drop",
        "compositionend",
        "compositionstart",
        "keydown",
        "keypress",
        "keyup",
        "input",
        "textInput",
        "copy",
        "cut",
        "paste",
        "click",
        "change",
        "contextmenu",
        "reset",
        "submit"
    ];
    function isDiscreteEventThatRequiresHydration(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        };
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case "focusin":
            case "focusout":
                queuedFocus = null;
                break;
            case "dragenter":
            case "dragleave":
                queuedDrag = null;
                break;
            case "mouseover":
            case "mouseout":
                queuedMouse = null;
                break;
            case "pointerover":
            case "pointerout":
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags, and the targetContainers, and
        // store a single event to be replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;
        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) targetContainers.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(domEventName){
            case "focusin":
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
            case "dragenter":
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
            case "mouseover":
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
            case "pointerover":
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
            case "gotpointercapture":
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with findInstanceBlockingEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        attemptHydrationAtPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function queueExplicitHydrationTarget(target) {
        // TODO: This will read the priority if it's dispatched by the React
        // event system but not native events. Should read window.event.type, like
        // we do for updates (getCurrentEventPriority).
        var updatePriority = getCurrentUpdatePriority$1();
        var queuedTarget = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        var i = 0;
        for(; i < queuedExplicitHydrationTargets.length; i++){
            // Stop once we hit the first target with lower priority than
            if (!isHigherEventPriority(updatePriority, queuedExplicitHydrationTargets[i].priority)) break;
        }
        queuedExplicitHydrationTargets.splice(i, 0, queuedTarget);
        if (i === 0) attemptExplicitHydrationTarget(queuedTarget);
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var targetContainers = queuedEvent.targetContainers;
        while(targetContainers.length > 0){
            var targetContainer = targetContainers[0];
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn === null) {
                var nativeEvent = queuedEvent.nativeEvent;
                var nativeEventClone = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                setReplayingEvent(nativeEventClone);
                nativeEvent.target.dispatchEvent(nativeEventClone);
                resetReplayingEvent();
            } else {
                // We're still blocked. Try again later.
                var _fiber3 = getInstanceFromNode(nextBlockedOn);
                if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
                queuedEvent.blockedOn = nextBlockedOn;
                return false;
            } // This target container was successfully dispatched. Try the next.
            targetContainers.shift();
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false;
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig; // TODO: can we stop exporting these?
    var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
    // We'd like to remove this but it's not clear if this is safe.
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriority(domEventName);
        var listenerWrapper;
        switch(eventPriority){
            case DiscreteEventPriority:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            case DefaultEventPriority:
            default:
                listenerWrapper = dispatchEvent;
                break;
        }
        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(DiscreteEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(ContinuousEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) return;
        dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent);
    }
    function dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var blockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        if (blockedOn === null) {
            dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
            clearIfContinuousEvent(domEventName, nativeEvent);
            return;
        }
        if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
            nativeEvent.stopPropagation();
            return;
        } // We need to clear only if we didn't queue because
        // queueing is accumulative.
        clearIfContinuousEvent(domEventName, nativeEvent);
        if (eventSystemFlags & IS_CAPTURE_PHASE && isDiscreteEventThatRequiresHydration(domEventName)) {
            while(blockedOn !== null){
                var fiber = getInstanceFromNode(blockedOn);
                if (fiber !== null) attemptSynchronousHydration(fiber);
                var nextBlockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
                if (nextBlockedOn === null) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (nextBlockedOn === blockedOn) break;
                blockedOn = nextBlockedOn;
            }
            if (blockedOn !== null) nativeEvent.stopPropagation();
            return;
        } // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
    var return_targetInst = null; // Returns a SuspenseInstance or Container if it's blocked.
    // The return_targetInst field above is conceptually part of the return value.
    function findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // TODO: Warn if _enabled is false.
        return_targetInst = null;
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        return_targetInst = targetInst; // We're not blocked on anything.
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            // Used by SimpleEventPlugin:
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            // eslint-disable-next-line no-fallthrough
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            // eslint-disable-next-line no-fallthrough
            case "beforeblur":
            case "afterblur":
            // eslint-disable-next-line no-fallthrough
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
                return DiscreteEventPriority;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "toggle":
            case "touchmove":
            case "wheel":
            // eslint-disable-next-line no-fallthrough
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
                return ContinuousEventPriority;
            case "message":
                // We might be in the Scheduler callback.
                // Eventually this mechanism will be replaced by a check
                // of the current priority on the native scheduler.
                var schedulerPriority = getCurrentPriorityLevel();
                switch(schedulerPriority){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority:
                    case LowPriority:
                        // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
    }
    function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
    }
    function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
        });
        return listener;
    }
    function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            passive: passive
        });
        return listener;
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ("value" in root) return root.value;
        return root.textContent;
    }
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ("charCode" in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    } // This is intentionally a factory so that we have different returned constructors.
    // If we had a single constructor, it would be megamorphic and engines would deopt.
    function createSyntheticEvent(Interface) {
        /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */ function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var _propName in Interface){
                if (!Interface.hasOwnProperty(_propName)) continue;
                var normalize = Interface[_propName];
                if (normalize) this[_propName] = normalize(nativeEvent);
                else this[_propName] = nativeEvent[_propName];
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
            else this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = true;
                var event = this.nativeEvent;
                if (!event) return;
                if (event.preventDefault) event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.returnValue !== "unknown") event.returnValue = false;
                this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                if (!event) return;
                if (event.stopPropagation) event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.cancelBubble !== "unknown") // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
                this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */ persist: function() {},
            /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */ isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    };
    var SyntheticEvent = createSyntheticEvent(EventInterface);
    var UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    });
    var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
    var lastMovementX;
    var lastMovementY;
    var lastMouseEvent;
    function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === "mousemove") {
                lastMovementX = event.screenX - lastMouseEvent.screenX;
                lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
                lastMovementX = 0;
                lastMovementY = 0;
            }
            lastMouseEvent = event;
        }
    }
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
        },
        movementX: function(event) {
            if ("movementX" in event) return event.movementX;
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
        },
        movementY: function(event) {
            if ("movementY" in event) return event.movementY;
             // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.
            return lastMovementY;
        }
    });
    var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    });
    var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    });
    var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
        }
    });
    var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    });
    var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ // Happens to share the same list for now.
    var SyntheticInputEvent = SyntheticCompositionEvent;
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        "8": "Backspace",
        "9": "Tab",
        "12": "Clear",
        "13": "Enter",
        "16": "Shift",
        "17": "Control",
        "18": "Alt",
        "19": "Pause",
        "20": "CapsLock",
        "27": "Escape",
        "32": " ",
        "33": "PageUp",
        "34": "PageDown",
        "35": "End",
        "36": "Home",
        "37": "ArrowLeft",
        "38": "ArrowUp",
        "39": "ArrowRight",
        "40": "ArrowDown",
        "45": "Insert",
        "46": "Delete",
        "112": "F1",
        "113": "F2",
        "114": "F3",
        "115": "F4",
        "116": "F5",
        "117": "F6",
        "118": "F7",
        "119": "F8",
        "120": "F9",
        "121": "F10",
        "122": "F11",
        "123": "F12",
        "144": "NumLock",
        "145": "ScrollLock",
        "224": "Meta"
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== "Unidentified") return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === "keypress") {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? "Enter" : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === "keydown" || nativeEvent.type === "keyup") // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || "Unidentified";
        return "";
    }
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var KeyboardEventInterface = assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === "keypress") return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === "keypress") return getEventCharCode(event);
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        }
    });
    var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    });
    var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    });
    var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
    });
    var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && "CompositionEvent" in window;
    var documentMode = null;
    if (canUseDOM && "documentMode" in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
    function registerEvents() {
        registerTwoPhaseEvent("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]);
        registerTwoPhaseEvent("onCompositionEnd", [
            "compositionend",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionStart", [
            "compositionstart",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionUpdate", [
            "compositionupdate",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
    } // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 */ function getCompositionEventType(domEventName) {
        switch(domEventName){
            case "compositionstart":
                return "onCompositionStart";
            case "compositionend":
                return "onCompositionEnd";
            case "compositionupdate":
                return "onCompositionUpdate";
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */ function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === "keydown" && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 */ function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case "keyup":
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case "keydown":
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case "keypress":
            case "mousedown":
            case "focusout":
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === "object" && "data" in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === "ko";
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(domEventName);
        else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) eventType = "onCompositionStart";
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) eventType = "onCompositionEnd";
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === "onCompositionStart") isComposing = initialize(nativeEventTarget);
            else if (eventType === "onCompositionEnd") {
                if (isComposing) fallbackData = getData();
            }
        }
        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
        if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            if (fallbackData) // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
            else {
                var customData = getDataFromCustomEvent(nativeEvent);
                if (customData !== null) event.data = customData;
            }
        }
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case "compositionend":
                return getDataFromCustomEvent(nativeEvent);
            case "keypress":
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case "textInput":
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */ function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (domEventName === "compositionend" || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(domEventName){
            case "paste":
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case "keypress":
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case "compositionend":
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        else chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var listeners = accumulateTwoPhaseListeners(targetInst, "onBeforeInput");
        if (listeners.length > 0) {
            var event = new SyntheticInputEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            event.data = chars;
        }
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    }
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === "input") return !!supportedInputTypes[elem.type];
        if (nodeName === "textarea") return true;
        return false;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = "on" + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement("div");
            element.setAttribute(eventName, "return;");
            isSupported = typeof element[eventName] === "function";
        }
        return isSupported;
    }
    function registerEvents$1() {
        registerTwoPhaseEvent("onChange", [
            "change",
            "click",
            "focusin",
            "focusout",
            "input",
            "keydown",
            "keyup",
            "selectionchange"
        ]);
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, "onChange");
        if (listeners.length > 0) {
            var event = new SyntheticEvent("onChange", "change", null, nativeEvent, target);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
        }
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === "select" || nodeName === "input" && elem.type === "file";
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, dispatchQueue);
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === "change") return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported("input") && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent("onpropertychange", handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent("onpropertychange", handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== "value") return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === "focusin") {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (domEventName === "focusout") stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === "selectionchange" || domEventName === "keyup" || domEventName === "keydown") // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (elem.type === "checkbox" || elem.type === "radio");
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === "click") return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === "input" || domEventName === "change") return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== "number") return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, "number", node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
            }
        } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
                createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                return;
            }
        }
        if (handleEventFunc) handleEventFunc(domEventName, targetNode, targetInst);
         // When blurring, set the value attribute for number inputs
        if (domEventName === "focusout") handleControlledInputBlur(targetNode);
    }
    function registerEvents$2() {
        registerDirectEvent("onMouseEnter", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onMouseLeave", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onPointerEnter", [
            "pointerout",
            "pointerover"
        ]);
        registerDirectEvent("onPointerLeave", [
            "pointerout",
            "pointerover"
        ]);
    }
    /**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */ function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === "mouseover" || domEventName === "pointerover";
        var isOutEvent = domEventName === "mouseout" || domEventName === "pointerout";
        if (isOverEvent && !isReplayingEvent(nativeEvent)) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
                // If the related node is managed by React, we can assume that we have
                // already dispatched the corresponding events during its mouseout.
                if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) return;
            }
        }
        if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
        return;
        var win; // TODO: why is this nullable in the types but we read from it?
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
            }
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return;
        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = "onMouseLeave";
        var enterEventType = "onMouseEnter";
        var eventTypePrefix = "mouse";
        if (domEventName === "pointerout" || domEventName === "pointerover") {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = "onPointerLeave";
            enterEventType = "onPointerEnter";
            eventTypePrefix = "pointer";
        }
        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + "leave", from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null; // We should only process this nativeEvent if we are processing
        // the first ancestor. Next time, we will ignore the event.
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + "enter", to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
        }
        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            var currentKey = keysA[i];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return false;
        }
        return true;
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ("contains" in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === "string";
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === "input" && (elem.type === "text" || elem.type === "search" || elem.type === "tel" || elem.type === "url" || elem.type === "password") || nodeName === "textarea" || elem.contentEditable === "true");
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === "function") priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ("selectionStart" in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ("selectionStart" in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && document.documentMode <= 11;
    function registerEvents$3() {
        registerTwoPhaseEvent("onSelect", [
            "focusout",
            "contextmenu",
            "dragend",
            "focusin",
            "keydown",
            "keyup",
            "mousedown",
            "mouseup",
            "selectionchange"
        ]);
    }
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */ function getSelection$1(node) {
        if ("selectionStart" in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, "onSelect");
            if (listeners.length > 0) {
                var event = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.target = activeElement$1;
            }
        }
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        switch(domEventName){
            // Track the input node that has focus.
            case "focusin":
                if (isTextInputElement(targetNode) || targetNode.contentEditable === "true") {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case "focusout":
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case "mousedown":
                mouseDown = true;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case "selectionchange":
                if (skipSelectionChangeEvent) break;
            // falls through
            case "keydown":
            case "keyup":
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
    }
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes["Webkit" + styleProp] = "webkit" + eventName;
        prefixes["Moz" + styleProp] = "moz" + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap("Animation", "AnimationEnd"),
        animationiteration: makePrefixMap("Animation", "AnimationIteration"),
        animationstart: makePrefixMap("Animation", "AnimationStart"),
        transitionend: makePrefixMap("Transition", "TransitionEnd")
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement("div").style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!("AnimationEvent" in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!("TransitionEvent" in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    var ANIMATION_END = getVendorPrefixedEventName("animationend");
    var ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration");
    var ANIMATION_START = getVendorPrefixedEventName("animationstart");
    var TRANSITION_END = getVendorPrefixedEventName("transitionend");
    var topLevelEventsToReactNames = new Map(); // NOTE: Capitalization is important in this list!
    //
    // E.g. it needs "pointerDown", not "pointerdown".
    // This is because we derive both React name ("onPointerDown")
    // and DOM name ("pointerdown") from the same list.
    //
    // Exceptions that don't match this convention are listed separately.
    //
    // prettier-ignore
    var simpleEventPluginEvents = [
        "abort",
        "auxClick",
        "cancel",
        "canPlay",
        "canPlayThrough",
        "click",
        "close",
        "contextMenu",
        "copy",
        "cut",
        "drag",
        "dragEnd",
        "dragEnter",
        "dragExit",
        "dragLeave",
        "dragOver",
        "dragStart",
        "drop",
        "durationChange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "gotPointerCapture",
        "input",
        "invalid",
        "keyDown",
        "keyPress",
        "keyUp",
        "load",
        "loadedData",
        "loadedMetadata",
        "loadStart",
        "lostPointerCapture",
        "mouseDown",
        "mouseMove",
        "mouseOut",
        "mouseOver",
        "mouseUp",
        "paste",
        "pause",
        "play",
        "playing",
        "pointerCancel",
        "pointerDown",
        "pointerMove",
        "pointerOut",
        "pointerOver",
        "pointerUp",
        "progress",
        "rateChange",
        "reset",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "submit",
        "suspend",
        "timeUpdate",
        "touchCancel",
        "touchEnd",
        "touchStart",
        "volumeChange",
        "scroll",
        "toggle",
        "touchMove",
        "waiting",
        "wheel"
    ];
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function registerSimpleEvents() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i];
            var domEventName = eventName.toLowerCase();
            var capitalizedEvent = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, "on" + capitalizedEvent);
        } // Special cases where event names don't match.
        registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
        registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
        registerSimpleEvent(ANIMATION_START, "onAnimationStart");
        registerSimpleEvent("dblclick", "onDoubleClick");
        registerSimpleEvent("focusin", "onFocus");
        registerSimpleEvent("focusout", "onBlur");
        registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
    }
    function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (reactName === undefined) return;
        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;
        switch(domEventName){
            case "keypress":
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) return;
            /* falls through */ case "keydown":
            case "keyup":
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case "focusin":
                reactEventType = "focus";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "focusout":
                reactEventType = "blur";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "beforeblur":
            case "afterblur":
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "click":
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return;
            /* falls through */ case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            /* falls through */ case "mouseout":
            case "mouseover":
            case "contextmenu":
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case "scroll":
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case "wheel":
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case "copy":
            case "cut":
            case "paste":
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
        }
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        // Some events don't bubble in the browser.
        // In the past, React has always bubbled them, but this can be surprising.
        // We're going to try aligning closer to the browser behavior by not bubbling
        // them in React either. We'll start by not bubbling onScroll, and then expand.
        var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        domEventName === "scroll";
        var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
        if (_listeners.length > 0) {
            // Intentionally create event lazily.
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: _event,
                listeners: _listeners
            });
        }
    }
    // TODO: remove top-level side effect.
    registerSimpleEvents();
    registerEvents$2();
    registerEvents$1();
    registerEvents$3();
    registerEvents();
    function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        // TODO: we should remove the concept of a "SimpleEventPlugin".
        // This is the basic functionality of the event system. All
        // the other plugins are essentially polyfills. So the plugin
        // should probably be inlined somewhere and have its logic
        // be core the to event system. This would potentially allow
        // us to ship builds of React without the polyfilled plugins below.
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
        // event's native "bubble" phase, which means that we're
        // not in the capture phase. That's because we emulate
        // the capture phase here still. This is a trade-off,
        // because in an ideal world we would not emulate and use
        // the phases properly, like we do with the SimpleEvent
        // plugin. However, the plugins below either expect
        // emulation (EnterLeave) or use state localized to that
        // plugin (BeforeInput, Change, Select). The state in
        // these modules complicates things, as you'll essentially
        // get the case where the capture phase event might change
        // state, only for the following bubble event to come in
        // later and not trigger anything as the state now
        // invalidates the heuristics of the event plugin. We
        // could alter all these plugins to work in such ways, but
        // that might cause other unknown side-effects that we
        // can't foresee right now.
        if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
    } // List of events that need to be individually attached to media elements.
    var mediaEventTypes = [
        "abort",
        "canplay",
        "canplaythrough",
        "durationchange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "loadeddata",
        "loadedmetadata",
        "loadstart",
        "pause",
        "play",
        "playing",
        "progress",
        "ratechange",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "suspend",
        "timeupdate",
        "volumechange",
        "waiting"
    ]; // We should not delegate these events to the container, but rather
    // set them on the actual target element itself. This is primarily
    // because these events do not consistently bubble in the DOM.
    var nonDelegatedEvents = new Set([
        "cancel",
        "close",
        "invalid",
        "load",
        "scroll",
        "toggle"
    ].concat(mediaEventTypes));
    function executeDispatch(event, listener, currentTarget) {
        var type = event.type || "unknown-event";
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;
        if (inCapturePhase) for(var i = dispatchListeners.length - 1; i >= 0; i--){
            var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
        }
        else for(var _i = 0; _i < dispatchListeners.length; _i++){
            var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
            if (_instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
        }
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
        } // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        if (!nonDelegatedEvents.has(domEventName)) error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
        if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        if (nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener) error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        if (isCapturePhaseListener) eventSystemFlags |= IS_CAPTURE_PHASE;
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    } // This is only used by createEventHandle when the
    var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = true;
            allNativeEvents.forEach(function(domEventName) {
                // We handle selectionchange separately because it
                // doesn't bubble and needs to be on the document.
                if (domEventName !== "selectionchange") {
                    if (!nonDelegatedEvents.has(domEventName)) listenToNativeEvent(domEventName, false, rootContainerElement);
                    listenToNativeEvent(domEventName, true, rootContainerElement);
                }
            });
            var ownerDocument = rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
            if (ownerDocument !== null) // The selectionchange event also needs deduplication
            // but it is attached to the document.
            {
                if (!ownerDocument[listeningMarker]) {
                    ownerDocument[listeningMarker] = true;
                    listenToNativeEvent("selectionchange", false, ownerDocument);
                }
            }
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
        // active and not passive.
        var isPassiveListener = undefined;
        if (passiveBrowserEventsSupported) // Browsers introduced an intervention, making these events
        // passive by default on document. React doesn't bind them
        // to document anymore, but changing this now would undo
        // the performance wins from the change. So we emulate
        // the existing behavior manually on the roots now.
        // https://github.com/facebook/react/issues/19651
        {
            if (domEventName === "touchstart" || domEventName === "touchmove" || domEventName === "wheel") isPassiveListener = true;
        }
        targetContainer;
        var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we
        if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            else unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
        } else if (isPassiveListener !== undefined) unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
        else unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
    function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;
        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we
            if (targetInst !== null) {
                // The below logic attempts to work out if we need to change
                // the target fiber to a different ancestor. We had similar logic
                // in the legacy event system, except the big difference between
                // systems is that the modern event system now has an event listener
                // attached to each React Root and React Portal Root. Together,
                // the DOM nodes representing these roots are the "rootContainer".
                // To figure out which ancestor instance we should use, we traverse
                // up the fiber tree from the target instance and attempt to find
                // root boundaries that match that of our current "rootContainer".
                // If we find that "rootContainer", we find the parent fiber
                // sub-tree for that root and make that our ancestor instance.
                var node = targetInst;
                mainLoop: while(true){
                    if (node === null) return;
                    var nodeTag = node.tag;
                    if (nodeTag === HostRoot || nodeTag === HostPortal) {
                        var container = node.stateNode.containerInfo;
                        if (isMatchingRootContainer(container, targetContainerNode)) break;
                        if (nodeTag === HostPortal) {
                            // The target is a portal, but it's not the rootContainer we're looking for.
                            // Normally portals handle their own events all the way down to the root.
                            // So we should be able to stop now. However, we don't know if this portal
                            // was part of *our* root.
                            var grandNode = node.return;
                            while(grandNode !== null){
                                var grandTag = grandNode.tag;
                                if (grandTag === HostRoot || grandTag === HostPortal) {
                                    var grandContainer = grandNode.stateNode.containerInfo;
                                    if (isMatchingRootContainer(grandContainer, targetContainerNode)) // This is the rootContainer we're looking for and we found it as
                                    // a parent of the Portal. That means we can ignore it because the
                                    // Portal will bubble through to us.
                                    return;
                                }
                                grandNode = grandNode.return;
                            }
                        } // Now we need to find it's corresponding host fiber in the other
                        // tree. To do this we can use getClosestInstanceFromNode, but we
                        // need to validate that the fiber is a host instance, otherwise
                        // we need to traverse up through the DOM till we find the correct
                        // node that is from the other tree.
                        while(container !== null){
                            var parentNode = getClosestInstanceFromNode(container);
                            if (parentNode === null) return;
                            var parentTag = parentNode.tag;
                            if (parentTag === HostComponent || parentTag === HostText) {
                                node = ancestorInst = parentNode;
                                continue mainLoop;
                            }
                            container = container.parentNode;
                        }
                    }
                    node = node.return;
                }
            }
        }
        batchedUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly, nativeEvent) {
        var captureName = reactName !== null ? reactName + "Capture" : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                lastHostComponent = stateNode; // createEventHandle listeners
                if (reactEventName !== null) {
                    var listener = getListener(instance, reactEventName);
                    if (listener != null) listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.
            if (accumulateTargetOnly) break;
             // If we are processing the onBeforeBlur event, then we need to take
            instance = instance.return;
        }
        return listeners;
    } // We should only use this function for:
    // - BeforeInputEventPlugin
    // - ChangeEventPlugin
    // - SelectEventPlugin
    // This is because we only process these plugins
    // in the bubble phase, so we need to accumulate two
    // phase event listeners (via emulation).
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + "Capture";
        var listeners = [];
        var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                var captureListener = getListener(instance, captureName);
                if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                var bubbleListener = getListener(instance, reactName);
                if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
            instance = instance.return;
        }
        return listeners;
    }
    function getParent(inst) {
        if (inst === null) return null;
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;
        for(var tempA = nodeA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = nodeB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            nodeA = getParent(nodeA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            nodeB = getParent(nodeB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) return nodeA;
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
        }
        return null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;
        while(instance !== null){
            if (instance === common) break;
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) break;
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                if (inCapturePhase) {
                    var captureListener = getListener(instance, registrationName);
                    if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                } else if (!inCapturePhase) {
                    var bubbleListener = getListener(instance, registrationName);
                    if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
            }
            instance = instance.return;
        }
        if (listeners.length !== 0) dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    } // We should only use this function for:
    // - EnterLeaveEventPlugin
    // This is because we only process this plugin
    // in the bubble phase, so we need to accumulate two
    // phase event listeners.
    function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        if (from !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        if (to !== null && enterEvent !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
    }
    function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? "capture" : "bubble");
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = "dangerouslySetInnerHTML";
    var SUPPRESS_CONTENT_EDITABLE_WARNING = "suppressContentEditableWarning";
    var SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning";
    var AUTOFOCUS = "autoFocus";
    var CHILDREN = "children";
    var STYLE = "style";
    var HTML$1 = "__html";
    var warnedUnknownTags;
    var validatePropertiesInDevelopment;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeHTML;
    warnedUnknownTags = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        });
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode;
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error("Prop `%s` did not match. Server: %s Client: %s", propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error("Extra attributes from the server: %s", names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    function normalizeMarkupForTextOrAttribute(markup) {
        checkHtmlStringCoercion(markup);
        var markupString = typeof markup === "string" ? markup : "" + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    }
    function checkForUnmatchedText(serverText, clientText, isConcurrentMode, shouldWarnDev) {
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        if (shouldWarnDev) {
            if (!didWarnInvalidHydration) {
                didWarnInvalidHydration = true;
                error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
            }
        }
        if (isConcurrentMode && enableClientRenderFallbackOnTextMismatch) // In concurrent roots, we throw when there's a text mismatch and revert to
        // client rendering, up to the nearest Suspense boundary.
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string") {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== "textarea" || nextProp !== "";
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === "number") setTextContent(domElement, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === "script") {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement("div");
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === "string") // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === "select") {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === "[object HTMLUnknownElement]" && !hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                props = rawProps;
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                props = rawProps;
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                props = rawProps;
                break;
            case "input":
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                props = rawProps;
                break;
            case "select":
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "option":
                postMountWrapper$1(domElement, rawProps);
                break;
            case "select":
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case "input":
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "select":
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "textarea":
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== "function" && typeof nextProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = "";
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the allowed property list in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = "";
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string" || typeof nextProp === "number") (updatePayload = updatePayload || []).push(propKey, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else // For any other property we always add it to the queue and then we
            // filter it out using the allowed property list during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === "input" && nextRawProps.type === "radio" && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case "input":
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case "textarea":
                updateWrapper$1(domElement, nextRawProps);
                break;
            case "select":
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement, isConcurrentMode, shouldWarnDev) {
        var isCustomComponentTag;
        var extraAttributeNames;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                break;
            case "input":
                initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                break;
            case "select":
                initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case "value":
                    break;
                case "checked":
                    break;
                case "selected":
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === "string") {
                    if (domElement.textContent !== nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === "number") {
                    if (domElement.textContent !== "" + nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            "" + nextProp
                        ];
                    }
                }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (shouldWarnDev && true && // Convince Flow we've calculated it (it's DEV-only in this method.)
            typeof isCustomComponentTag === "boolean") {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = isCustomComponentTag && enableCustomElementPropertySupport ? null : getPropertyInfo(propKey);
                if (rawProps[SUPPRESS_HYDRATION_WARNING] === true) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === "value" || propKey === "checked" || propKey === "selected") ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        var expectedHTML = normalizeHTML(domElement, nextHtml);
                        if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                    }
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute("style");
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag && !enableCustomElementPropertySupport) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    var dontWarnCustomElement = enableCustomElementPropertySupport;
                    if (!dontWarnCustomElement && nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        if (shouldWarnDev) {
            if (extraAttributeNames.size > 0 && rawProps[SUPPRESS_HYDRATION_WARNING] !== true) // $FlowFixMe - Should be inferred as not undefined.
            warnForExtraAttributes(extraAttributeNames);
        }
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "select":
            case "option":
                break;
            default:
                if (typeof rawProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text, isConcurrentMode) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Did not expect server HTML to contain a <%s> in <%s>.", child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Expected server HTML to contain a matching <%s> in <%s>.", tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === "") // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case "input":
                restoreControlledState(domElement, props);
                return;
            case "textarea":
                restoreControlledState$2(domElement, props);
                return;
            case "select":
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "base",
        "basefont",
        "bgsound",
        "blockquote",
        "body",
        "br",
        "button",
        "caption",
        "center",
        "col",
        "colgroup",
        "dd",
        "details",
        "dir",
        "div",
        "dl",
        "dt",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "iframe",
        "img",
        "input",
        "isindex",
        "li",
        "link",
        "listing",
        "main",
        "marquee",
        "menu",
        "menuitem",
        "meta",
        "nav",
        "noembed",
        "noframes",
        "noscript",
        "object",
        "ol",
        "p",
        "param",
        "plaintext",
        "pre",
        "script",
        "section",
        "select",
        "source",
        "style",
        "summary",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "title",
        "tr",
        "track",
        "ul",
        "wbr",
        "xmp"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        "button"
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        "dd",
        "dt",
        "li",
        "option",
        "optgroup",
        "p",
        "rp",
        "rt"
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== "address" && tag !== "div" && tag !== "p") {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === "form") ancestorInfo.formTag = info;
        if (tag === "a") ancestorInfo.aTagInScope = info;
        if (tag === "button") ancestorInfo.buttonTagInScope = info;
        if (tag === "nobr") ancestorInfo.nobrTagInScope = info;
        if (tag === "p") ancestorInfo.pTagInButtonScope = info;
        if (tag === "li") ancestorInfo.listItemTagAutoclosing = info;
        if (tag === "dd" || tag === "dt") ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
                return tag === "option" || tag === "optgroup" || tag === "#text";
            case "optgroup":
                return tag === "option" || tag === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
                return tag === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
                return tag === "th" || tag === "td" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
                return tag === "tr" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
                return tag === "col" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
                return tag === "caption" || tag === "colgroup" || tag === "tbody" || tag === "tfoot" || tag === "thead" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
                return tag === "base" || tag === "basefont" || tag === "bgsound" || tag === "link" || tag === "meta" || tag === "title" || tag === "noscript" || tag === "noframes" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
                return tag === "head" || tag === "body" || tag === "frameset";
            case "frameset":
                return tag === "frame";
            case "#document":
                return tag === "html";
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return parentTag !== "h1" && parentTag !== "h2" && parentTag !== "h3" && parentTag !== "h4" && parentTag !== "h5" && parentTag !== "h6";
            case "rp":
            case "rt":
                return impliedEndTags.indexOf(parentTag) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return ancestorInfo.pTagInButtonScope;
            case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case "li":
                return ancestorInfo.listItemTagAutoclosing;
            case "dd":
            case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
            case "button":
                return ancestorInfo.buttonTagInScope;
            case "a":
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case "nobr":
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error("validateDOMNesting: when childText is passed, childTag should be null");
            childTag = "#text";
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var warnKey = !!invalidParent + "|" + childTag + "|" + ancestorTag;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = "";
        if (childTag === "#text") {
            if (/\S/.test(childText)) tagDisplayName = "Text nodes";
            else {
                tagDisplayName = "Whitespace text nodes";
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = "<" + childTag + ">";
        if (invalidParent) {
            var info = "";
            if (ancestorTag === "table" && childTag === "tr") info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1 = "suppressHydrationWarning";
    var SUSPENSE_START_DATA = "$";
    var SUSPENSE_END_DATA = "/$";
    var SUSPENSE_PENDING_START_DATA = "$?";
    var SUSPENSE_FALLBACK_START_DATA = "$!";
    var STYLE$1 = "style";
    var eventsEnabled = null;
    var selectionInformation = null;
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? "#document" : "#fragment";
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, "");
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === "string" || typeof props.children === "number") {
            var string = "" + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                return !!props.autoFocus;
            case "img":
                return true;
            default:
                return false;
        }
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === "string" || typeof newProps.children === "number")) {
            var string = "" + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps);
    }
    function shouldSetTextContent(type, props) {
        return type === "textarea" || type === "noscript" || typeof props.children === "string" || typeof props.children === "number" || typeof props.dangerouslySetInnerHTML === "object" && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    function getCurrentEventPriority() {
        var currentEvent = window.event;
        if (currentEvent === undefined) return DefaultEventPriority;
        return getEventPriority(currentEvent.type);
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === "function" ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === "function" ? clearTimeout : undefined;
    var noTimeout = -1;
    var localPromise = typeof Promise === "function" ? Promise : undefined; // -------------------
    var scheduleMicrotask = typeof queueMicrotask === "function" ? queueMicrotask : typeof localPromise !== "undefined" ? function(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout; // TODO: Determine the best fallback here.
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    } // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                if (newProps.autoFocus) domElement.focus();
                return;
            case "img":
                if (newProps.src) domElement.src = newProps.src;
                return;
        }
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps); // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function clearSuspenseBoundary(parentInstance, suspenseInstance) {
        var node = suspenseInstance; // Delete all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && nextNode.nodeType === COMMENT_NODE) {
                var data = nextNode.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) {
                        parentInstance.removeChild(nextNode); // Retry if any event replaying was blocked on this.
                        retryIfBlockedOn(suspenseInstance);
                        return;
                    } else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_FALLBACK_START_DATA) depth++;
            }
            node = nextNode;
        }while (node); // TODO: Warn, we didn't find the end comment boundary.
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function clearSuspenseBoundaryFromContainer(container, suspenseInstance) {
        if (container.nodeType === COMMENT_NODE) clearSuspenseBoundary(container.parentNode, suspenseInstance);
        else if (container.nodeType === ELEMENT_NODE) clearSuspenseBoundary(container, suspenseInstance);
         // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function hideInstance(instance) {
        // TODO: Does this work for all element types? What about MathML? Should we
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === "function") style.setProperty("display", "none", "important");
        else style.display = "none";
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = "";
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty("display") ? styleProp.display : null;
        instance.style.display = dangerousStyleValue("display", display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) container.textContent = "";
        else if (container.nodeType === DOCUMENT_NODE) {
            if (container.documentElement) container.removeChild(container.documentElement);
        }
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === "" || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function canHydrateSuspenseInstance(instance) {
        if (instance.nodeType !== COMMENT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a suspense node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getSuspenseInstanceFallbackErrorDetails(instance) {
        var dataset = instance.nextSibling && instance.nextSibling.dataset;
        var digest, message, stack;
        if (dataset) {
            digest = dataset.dgst;
            message = dataset.msg;
            stack = dataset.stck;
        }
        return {
            message: message,
            digest: digest,
            stack: stack
        };
    // const nextSibling = instance.nextSibling;
    // if (nextSibling) {
    //   const dataset = ((nextSibling: any): HTMLTemplateElement).dataset;
    //   value.message = dataset.msg;
    //   value.hash = dataset.hash;
    //   if (true) {
    //     value.stack = dataset.stack;
    //   }
    // }
    // return value;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        instance._reactRetry = callback;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
            if (nodeType === COMMENT_NODE) {
                var nodeData = node.data;
                if (nodeData === SUSPENSE_START_DATA || nodeData === SUSPENSE_FALLBACK_START_DATA || nodeData === SUSPENSE_PENDING_START_DATA) break;
                if (nodeData === SUSPENSE_END_DATA) return null;
            }
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function getFirstHydratableChildWithinContainer(parentContainer) {
        return getNextHydratable(parentContainer.firstChild);
    }
    function getFirstHydratableChildWithinSuspenseInstance(parentInstance) {
        return getNextHydratable(parentInstance.nextSibling);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance, isConcurrentMode, shouldWarnDev);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, textInstance); // TODO: Temporary hack to check if we're in a concurrent root. We can delete
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedText(textInstance, text);
    }
    function hydrateSuspenseInstance(suspenseInstance, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, suspenseInstance);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function shouldDeleteUnhydratedTailInstances(parentType) {
        return parentType !== "head" && parentType !== "body";
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text, isConcurrentMode) {
        var shouldWarnDev = true;
        checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text, isConcurrentMode) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            var shouldWarnDev = true;
            checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
        }
    }
    function didNotHydrateInstanceWithinContainer(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstanceWithinSuspenseInstance(parentInstance, instance) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentNode, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentNode, instance);
        }
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableInstanceWithinContainer(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableTextInstanceWithinContainer(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstanceWithinSuspenseInstance(parentInstance, type, props) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedElement(parentNode, type);
    }
    function didNotFindHydratableTextInstanceWithinSuspenseInstance(parentInstance, text) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedText(parentNode, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function errorHydratingContainer(parentContainer) {
        // TODO: This gets logged by onRecoverableError, too, so we should be
        // able to remove it.
        error("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", parentContainer.nodeName.toLowerCase());
    }
    function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = "__reactFiber$" + randomKey;
    var internalPropsKey = "__reactProps$" + randomKey;
    var internalContainerInstanceKey = "__reactContainer$" + randomKey;
    var internalEventHandlersKey = "__reactEvents$" + randomKey;
    var internalEventHandlerListenersKey = "__reactListeners$" + randomKey;
    var internalEventHandlesSetKey = "__reactHandles$" + randomKey;
    function detachDeletedInstance(node) {
        // TODO: This function is only called on host components. I don't think all of
        // these fields are relevant.
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        // invariant for a missing parent, which is super confusing.
        throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
    }
    function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];
        if (elementListenerSet === undefined) elementListenerSet = node[internalEventHandlersKey] = new Set();
        return elementListenerSet;
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error("Unexpected pop.");
            return;
        }
        if (fiber !== fiberStack[index]) error("Unexpected Fiber popped.");
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentNameFromFiber(workInProgress) || "Unknown";
        checkPropTypes(contextTypes, context, "context", name);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (contextStackCursor.current !== emptyContextObject) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== "function") {
            var componentName = getComponentNameFromFiber(fiber) || "Unknown";
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw new Error((getComponentNameFromFiber(fiber) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
        }
        var name = getComponentNameFromFiber(fiber) || "Unknown";
        checkPropTypes(childContextTypes, childContext, "child context", name);
        return assign({}, parentContext, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!isFiberMounted(fiber) || fiber.tag !== ClassComponent) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var ConcurrentRoot = 1;
    var syncQueue = null;
    var includesLegacySyncCallbacks = false;
    var isFlushingSyncQueue = false;
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) syncQueue = [
            callback
        ];
        else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
    }
    function scheduleLegacySyncCallback(callback) {
        includesLegacySyncCallbacks = true;
        scheduleSyncCallback(callback);
    }
    function flushSyncCallbacksOnlyInLegacyMode() {
        // Only flushes the queue if there's a legacy sync callback scheduled.
        // TODO: There's only a single type of callback: performSyncOnWorkOnRoot. So
        // it might make more sense for the queue to be a list of roots instead of a
        // list of generic callbacks. Then we can have two: one for legacy roots, one
        // for concurrent roots. And this method would only flush the legacy ones.
        if (includesLegacySyncCallbacks) flushSyncCallbacks();
    }
    function flushSyncCallbacks() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrance.
            isFlushingSyncQueue = true;
            var i = 0;
            var previousUpdatePriority = getCurrentUpdatePriority();
            try {
                var isSync = true;
                var queue = syncQueue; // TODO: Is this necessary anymore? The only user code that runs in this
                // queue is in the render or commit phases.
                setCurrentUpdatePriority(DiscreteEventPriority);
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(isSync);
                    while (callback !== null);
                }
                syncQueue = null;
                includesLegacySyncCallbacks = false;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                scheduleCallback(ImmediatePriority, flushSyncCallbacks);
                throw error;
            } finally{
                setCurrentUpdatePriority(previousUpdatePriority);
                isFlushingSyncQueue = false;
            }
        }
        return null;
    }
    // TODO: Use the unified fiber stack module instead of this local one?
    // Intentionally not using it yet to derisk the initial implementation, because
    // the way we push/pop these values is a bit unusual. If there's a mistake, I'd
    // rather the ids be wrong than crash the whole reconciler.
    var forkStack = [];
    var forkStackIndex = 0;
    var treeForkProvider = null;
    var treeForkCount = 0;
    var idStack = [];
    var idStackIndex = 0;
    var treeContextProvider = null;
    var treeContextId = 1;
    var treeContextOverflow = "";
    function isForkedChild(workInProgress) {
        warnIfNotHydrating();
        return (workInProgress.flags & Forked) !== NoFlags;
    }
    function getForksAtLevel(workInProgress) {
        warnIfNotHydrating();
        return treeForkCount;
    }
    function getTreeId() {
        var overflow = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
    }
    function pushTreeFork(workInProgress, totalChildren) {
        // This is called right after we reconcile an array (or iterator) of child
        // fibers, because that's the only place where we know how many children in
        // the whole set without doing extra work later, or storing addtional
        // information on the fiber.
        //
        // That's why this function is separate from pushTreeId — it's called during
        // the render phase of the fork parent, not the child, which is where we push
        // the other context values.
        //
        // In the Fizz implementation this is much simpler because the child is
        // rendered in the same callstack as the parent.
        //
        // It might be better to just add a `forks` field to the Fiber type. It would
        // make this module simpler.
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        var baseOverflow = treeContextOverflow; // The leftmost 1 marks the end of the sequence, non-inclusive. It's not part
        // of the id; we use it to account for leading 0s.
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength; // 30 is the max length we can store without overflowing, taking into
        // consideration the leading 1 we use to mark the end of the sequence.
        if (length > 30) {
            // We overflowed the bitwise-safe range. Fall back to slower algorithm.
            // This branch assumes the length of the base id is greater than 5; it won't
            // work for smaller ids, because you need 5 bits per character.
            //
            // We encode the id in multiple steps: first the base id, then the
            // remaining digits.
            //
            // Each 5 bit sequence corresponds to a single base 32 character. So for
            // example, if the current id is 23 bits long, we can convert 20 of those
            // bits into a string of 4 characters, with 3 bits left over.
            //
            // First calculate how many bits in the base id represent a complete
            // sequence of characters.
            var numberOfOverflowBits = baseLength - baseLength % 5; // Then create a bitmask that selects only those bits.
            var newOverflowBits = (1 << numberOfOverflowBits) - 1; // Select the bits, and convert them to a base 32 string.
            var newOverflow = (baseId & newOverflowBits).toString(32); // Now we can remove those bits from the base id.
            var restOfBaseId = baseId >> numberOfOverflowBits;
            var restOfBaseLength = baseLength - numberOfOverflowBits; // Finally, encode the rest of the bits using the normal algorithm. Because
            // we made more room, this time it won't overflow.
            var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
            var restOfNewBits = slot << restOfBaseLength;
            var id = restOfNewBits | restOfBaseId;
            var overflow = newOverflow + baseOverflow;
            treeContextId = 1 << restOfLength | id;
            treeContextOverflow = overflow;
        } else {
            // Normal path
            var newBits = slot << baseLength;
            var _id = newBits | baseId;
            var _overflow = baseOverflow;
            treeContextId = 1 << length | _id;
            treeContextOverflow = _overflow;
        }
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating(); // This component materialized an id. This will affect any ids that appear
        // in its children.
        var returnFiber = workInProgress.return;
        if (returnFiber !== null) {
            var numberOfForks = 1;
            var slotIndex = 0;
            pushTreeFork(workInProgress, numberOfForks);
            pushTreeId(workInProgress, numberOfForks, slotIndex);
        }
    }
    function getBitLength(number) {
        return 32 - clz32(number);
    }
    function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
    }
    function popTreeContext(workInProgress) {
        // Restore the previous values.
        // This is a bit more complicated than other context-like modules in Fiber
        // because the same Fiber may appear on the stack multiple times and for
        // different reasons. We have to keep popping until the work-in-progress is
        // no longer at the top of the stack.
        while(workInProgress === treeForkProvider){
            treeForkProvider = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
            treeForkCount = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
        }
        while(workInProgress === treeContextProvider){
            treeContextProvider = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextOverflow = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextId = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
        }
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        if (treeContextProvider !== null) return {
            id: treeContextId,
            overflow: treeContextOverflow
        };
        else return null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        if (!getIsHydrating()) error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false; // This flag allows for warning supression when we expect there to be mismatches
    // due to earlier mismatches or a suspended fiber.
    var didSuspendOrErrorDEV = false; // Hydration errors that were thrown inside this boundary
    var hydrationErrors = null;
    function warnIfHydrating() {
        if (isHydrating) error("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function markDidThrowWhileHydratingDEV() {
        didSuspendOrErrorDEV = true;
    }
    function didSuspendOrErrorWhileHydratingDEV() {
        return didSuspendOrErrorDEV;
    }
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChildWithinContainer(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        return true;
    }
    function reenterHydrationStateFromDehydratedSuspenseInstance(fiber, suspenseInstance, treeContext) {
        nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(suspenseInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        if (treeContext !== null) restoreSuspendedTreeContext(fiber, treeContext);
        return true;
    }
    function warnUnhydratedInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateInstanceWithinContainer(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance, isConcurrentMode);
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                if (suspenseState.dehydrated !== null) didNotHydrateInstanceWithinSuspenseInstance(suspenseState.dehydrated, instance);
                break;
        }
    }
    function deleteHydratableInstance(returnFiber, instance) {
        warnUnhydratedInstance(returnFiber, instance);
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                childToDelete
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(childToDelete);
    }
    function warnNonhydratedInstance(returnFiber, fiber) {
        if (didSuspendOrErrorDEV) // Inside a boundary that already suspended. We're currently rendering the
        // siblings of a suspended node. The mismatch may be due to the missing
        // data, so it's probably a false positive.
        return;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinContainer(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinContainer(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props, isConcurrentMode);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        var _isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text, _isConcurrentMode);
                        break;
                }
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                var _parentInstance = suspenseState.dehydrated;
                if (_parentInstance !== null) switch(fiber.tag){
                    case HostComponent:
                        var _type2 = fiber.type;
                        var _props2 = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinSuspenseInstance(_parentInstance, _type2);
                        break;
                    case HostText:
                        var _text2 = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinSuspenseInstance(_parentInstance, _text2);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        warnNonhydratedInstance(returnFiber, fiber);
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    hydrationParentFiber = fiber;
                    nextHydratableInstance = getFirstHydratableChild(instance);
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    hydrationParentFiber = fiber; // Text Instances don't have children so there's nothing to hydrate.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            case SuspenseComponent:
                var suspenseInstance = canHydrateSuspenseInstance(nextInstance);
                if (suspenseInstance !== null) {
                    var suspenseState = {
                        dehydrated: suspenseInstance,
                        treeContext: getSuspendedTreeContext(),
                        retryLane: OffscreenLane
                    };
                    fiber.memoizedState = suspenseState; // Store the dehydrated fragment as a child fiber.
                    // This simplifies the code for getHostSibling and deleting nodes,
                    // since it doesn't have to consider all Suspense boundaries and
                    // check if they're dehydrated ones or not.
                    var dehydratedFragment = createFiberFromDehydratedFragment(suspenseInstance);
                    dehydratedFragment.return = fiber;
                    fiber.child = dehydratedFragment;
                    hydrationParentFiber = fiber; // While a Suspense Instance does have children, we won't step into
                    // it during the first pass. Instead, we'll reenter it later.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            default:
                return false;
        }
    }
    function shouldClientRenderOnMismatch(fiber) {
        return (fiber.mode & ConcurrentMode) !== NoMode && (fiber.flags & DidCapture) === NoFlags;
    }
    function throwOnHydrationMismatch(fiber) {
        throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            var prevHydrationParentFiber = hydrationParentFiber;
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(prevHydrationParentFiber, firstAttemptedInstance);
        }
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var shouldWarnIfMismatchDev = !didSuspendOrErrorDEV;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber, shouldWarnIfMismatchDev); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent, isConcurrentMode);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    var _isConcurrentMode2 = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent, _isConcurrentMode2);
                    break;
            }
        }
        return shouldUpdate;
    }
    function prepareToHydrateHostSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        hydrateSuspenseInstance(suspenseInstance, fiber);
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        } // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them. We also don't delete anything inside the root container.
        if (fiber.tag !== HostRoot && (fiber.tag !== HostComponent || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps))) {
            var nextInstance = nextHydratableInstance;
            if (nextInstance) {
                if (shouldClientRenderOnMismatch(fiber)) {
                    warnIfUnhydratedTailNodes(fiber);
                    throwOnHydrationMismatch();
                } else while(nextInstance){
                    deleteHydratableInstance(fiber, nextInstance);
                    nextInstance = getNextHydratableSibling(nextInstance);
                }
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function hasUnhydratedTailNodes() {
        return isHydrating && nextHydratableInstance !== null;
    }
    function warnIfUnhydratedTailNodes(fiber) {
        var nextInstance = nextHydratableInstance;
        while(nextInstance){
            warnUnhydratedInstance(fiber, nextInstance);
            nextInstance = getNextHydratableSibling(nextInstance);
        }
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
        didSuspendOrErrorDEV = false;
    }
    function upgradeHydrationErrorsToRecoverable() {
        if (hydrationErrors !== null) {
            // Successfully completed a forced client render. The errors that occurred
            // during the hydration attempt are now recovered. We will log them in
            // commit phase, once the entire tree has finished.
            queueRecoverableErrors(hydrationErrors);
            hydrationErrors = null;
        }
    }
    function getIsHydrating() {
        return isHydrating;
    }
    function queueHydrationError(error) {
        if (hydrationErrors === null) hydrationErrors = [
            error
        ];
        else hydrationErrors.push(error);
    }
    var ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var NoTransition = null;
    function requestCurrentTransition() {
        return ReactCurrentBatchConfig$1.transition;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictLegacyMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(", ");
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedupe strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillMount === "function") pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillReceiveProps === "function") pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillUpdate === "function") pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === "function") {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally{
                resetCurrentFiber();
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastFullyObservedContext = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        context._currentValue = currentValue;
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        // Update the child lanes of all the ancestors, including the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                node.childLanes = mergeLanes(node.childLanes, renderLanes);
                if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            if (node === propagationRoot) break;
            node = node.return;
        }
        if (node !== propagationRoot) error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChange(workInProgress, context, renderLanes) {
        propagateContextChange_eager(workInProgress, context, renderLanes);
    }
    function propagateContextChange_eager(workInProgress, context, renderLanes) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var lane = pickArbitraryLane(renderLanes);
                            var update = createUpdate(NoTimestamp, lane);
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            // Inlined `enqueueUpdate` to remove interleaved update check
                            var updateQueue = fiber.updateQueue;
                            if (updateQueue === null) ;
                            else {
                                var sharedQueue = updateQueue.shared;
                                var pending = sharedQueue.pending;
                                if (pending === null) // This is the first update. Create a circular list.
                                update.next = update;
                                else {
                                    update.next = pending.next;
                                    pending.next = update;
                                }
                                sharedQueue.pending = update;
                            }
                        }
                        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                        var alternate = fiber.alternate;
                        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                        scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress); // Mark the updated lanes on the list, too.
                        list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else if (fiber.tag === DehydratedFragment) {
                // If a dehydrated suspense boundary is in this subtree, we don't know
                // if it will have any context consumers in it. The best we can do is
                // mark it as having updates.
                var parentSuspense = fiber.return;
                if (parentSuspense === null) throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
                parentSuspense.lanes = mergeLanes(parentSuspense.lanes, renderLanes);
                var _alternate = parentSuspense.alternate;
                if (_alternate !== null) _alternate.lanes = mergeLanes(_alternate.lanes, renderLanes);
                 // This is intentionally passing this fiber as the parent
                // because we want to schedule this fiber as having work
                // on its children. We'll use the childLanes on
                // this fiber to indicate that a context has changed.
                scheduleContextWorkOnParentPath(parentSuspense, renderLanes, workInProgress);
                nextFiber = fiber.sibling;
            } else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (includesSomeLane(dependencies.lanes, renderLanes)) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        var value = context._currentValue;
        if (lastFullyObservedContext === context) ;
        else {
            var contextItem = {
                context: context,
                memoizedValue: value,
                next: null
            };
            if (lastContextDependency === null) {
                if (currentlyRenderingFiber === null) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    lanes: NoLanes,
                    firstContext: contextItem
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return value;
    }
    // render. When this render exits, either because it finishes or because it is
    // interrupted, the interleaved updates will be transferred onto the main part
    // of the queue.
    var concurrentQueues = null;
    function pushConcurrentUpdateQueue(queue) {
        if (concurrentQueues === null) concurrentQueues = [
            queue
        ];
        else concurrentQueues.push(queue);
    }
    function finishQueueingConcurrentUpdates() {
        // Transfer the interleaved updates onto the main queue. Each queue has a
        // `pending` field and an `interleaved` field. When they are not null, they
        // point to the last node in a circular linked list. We need to append the
        // interleaved list to the end of the pending list by joining them into a
        // single, circular list.
        if (concurrentQueues !== null) {
            for(var i = 0; i < concurrentQueues.length; i++){
                var queue = concurrentQueues[i];
                var lastInterleavedUpdate = queue.interleaved;
                if (lastInterleavedUpdate !== null) {
                    queue.interleaved = null;
                    var firstInterleavedUpdate = lastInterleavedUpdate.next;
                    var lastPendingUpdate = queue.pending;
                    if (lastPendingUpdate !== null) {
                        var firstPendingUpdate = lastPendingUpdate.next;
                        lastPendingUpdate.next = firstInterleavedUpdate;
                        lastInterleavedUpdate.next = firstPendingUpdate;
                    }
                    queue.pending = lastInterleavedUpdate;
                }
            }
            concurrentQueues = null;
        }
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
    }
    function enqueueConcurrentClassUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    } // Calling this function outside this module should only be done for backwards
    // compatibility and should always be accompanied by a warning.
    var unsafe_markUpdateLaneFromFiberToRoot = markUpdateLaneFromFiberToRoot;
    function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        // Update the source fiber's lanes
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, lane);
        if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while(parent !== null){
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            else if ((parent.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            node = parent;
            parent = parent.return;
        }
        if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
        } else return null;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: NoLanes
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: currentQueue.firstBaseUpdate,
                lastBaseUpdate: currentQueue.lastBaseUpdate,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(eventTime, lane) {
        var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        return update;
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return null;
        var sharedQueue = updateQueue.shared;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
        if (isUnsafeClassRenderPhaseUpdate()) {
            // This is an unsafe render phase update. Add directly to the update
            // queue so we can process it immediately during the current render.
            var pending = sharedQueue.pending;
            if (pending === null) // This is the first update. Create a circular list.
            update.next = update;
            else {
                update.next = pending.next;
                pending.next = update;
            }
            sharedQueue.pending = update; // Update the childLanes even though we're most likely already rendering
            // this fiber. This is for backwards compatibility in the case where you
            // update a different component during render phase than the one that is
            // currently renderings (a pattern that is accompanied by a warning).
            return unsafe_markUpdateLaneFromFiberToRoot(fiber, lane);
        } else return enqueueConcurrentClassUpdate(fiber, sharedQueue, update, lane);
    }
    function entangleTransitions(root, fiber, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        if (isTransitionLane(lane)) {
            var queueLanes = sharedQueue.lanes; // If any entangled lanes are no longer pending on the root, then they must
            // have finished. We can remove them from the shared queue, which represents
            // a superset of the actually pending lanes. In some cases we may entangle
            // more than we need to, but that's OK. In fact it's worse if we *don't*
            // entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            sharedQueue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        // Captured updates are updates that are thrown by a child during the render
        // phase. They should be discarded if the render is aborted. Therefore,
        // we should only put them on the work-in-progress queue, not the current one.
        var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.
        var current = workInProgress.alternate;
        if (current !== null) {
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                // The work-in-progress queue is the same as current. This happens when
                // we bail out on a parent fiber that then captures an error thrown by
                // a child. Since we want to append the update only to the work-in
                // -progress queue, we need to clone the updates. We usually clone during
                // processUpdateQueue, but that didn't happen in this case because we
                // skipped over the parent when we bailed out.
                var newFirst = null;
                var newLast = null;
                var firstBaseUpdate = queue.firstBaseUpdate;
                if (firstBaseUpdate !== null) {
                    // Loop through the updates and clone them.
                    var update = firstBaseUpdate;
                    do {
                        var clone = {
                            eventTime: update.eventTime,
                            lane: update.lane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLast === null) newFirst = newLast = clone;
                        else {
                            newLast.next = clone;
                            newLast = clone;
                        }
                        update = update.next;
                    }while (update !== null); // Append the captured update the end of the cloned list.
                    if (newLast === null) newFirst = newLast = capturedUpdate;
                    else {
                        newLast.next = capturedUpdate;
                        newLast = capturedUpdate;
                    }
                } else // There are no base updates.
                newFirst = newLast = capturedUpdate;
                queue = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: newFirst,
                    lastBaseUpdate: newLast,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = queue;
                return;
            }
        } // Append the update to the end of the list.
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) queue.firstBaseUpdate = capturedUpdate;
        else lastBaseUpdate.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === "function") {
                    enterDisallowedContextReadInDEV();
                    var nextState = payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === "function") {
                    enterDisallowedContextReadInDEV();
                    partialState = _payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            _payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue
            if (lastBaseUpdate === null) firstBaseUpdate = firstPendingUpdate;
            else lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                // This is always non-null on a ClassComponent or HostRoot
                var currentQueue = current.updateQueue;
                var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                if (currentLastBaseUpdate !== lastBaseUpdate) {
                    if (currentLastBaseUpdate === null) currentQueue.firstBaseUpdate = firstPendingUpdate;
                    else currentLastBaseUpdate.next = firstPendingUpdate;
                    currentQueue.lastBaseUpdate = lastPendingUpdate;
                }
            }
        } // These values may change as we process the queue.
        if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
                var updateLane = update.lane;
                var updateEventTime = update.eventTime;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        eventTime: updateEventTime,
                        lane: updateLane,
                        tag: update.tag,
                        payload: update.payload,
                        callback: update.callback,
                        next: null
                    };
                    if (newLastBaseUpdate === null) {
                        newFirstBaseUpdate = newLastBaseUpdate = clone;
                        newBaseState = newState;
                    } else newLastBaseUpdate = newLastBaseUpdate.next = clone;
                     // Update the remaining priority in the queue.
                    newLanes = mergeLanes(newLanes, updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newLastBaseUpdate !== null) {
                        var _clone = {
                            eventTime: updateEventTime,
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                    } // Process this update.
                    newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                    var callback = update.callback;
                    if (callback !== null && // If the update was already committed, we should not queue its
                    // callback again.
                    update.lane !== NoLane) {
                        workInProgress.flags |= Callback;
                        var effects = queue.effects;
                        if (effects === null) queue.effects = [
                            update
                        ];
                        else effects.push(update);
                    }
                }
                update = update.next;
                if (update === null) {
                    pendingQueue = queue.shared.pending;
                    if (pendingQueue === null) break;
                    else {
                        // An update was scheduled from inside a reducer. Add the new
                        // pending updates to the end of the list and keep processing.
                        var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                        // unravel them when transferring them to the base queue.
                        var _firstPendingUpdate = _lastPendingUpdate.next;
                        _lastPendingUpdate.next = null;
                        update = _firstPendingUpdate;
                        queue.lastBaseUpdate = _lastPendingUpdate;
                        queue.shared.pending = null;
                    }
                }
            }while (true);
            if (newLastBaseUpdate === null) newBaseState = newState;
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Interleaved updates are stored on a separate queue. We aren't going to
            // process them during this render, but we do need to track which lanes
            // are remaining.
            var lastInterleaved = queue.shared.interleaved;
            if (lastInterleaved !== null) {
                var interleaved = lastInterleaved;
                do {
                    newLanes = mergeLanes(newLanes, interleaved.lane);
                    interleaved = interleaved.next;
                }while (interleaved !== lastInterleaved);
            } else if (firstBaseUpdate === null) // `queue.lanes` is used for entangling transitions. We can set it back to
            // zero once the queue is empty.
            queue.shared.lanes = NoLanes;
             // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (typeof callback !== "function") throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + callback));
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var fakeInternalInstance = {}; // React.Component uses a shared frozen object by default.
    // We'll use it to determine whether we need to initialize legacy refs.
    var emptyRefsObject = new React.Component().refs;
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === "function") return;
        var key = callerName + "_" + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentNameFromType(type) || "Component";
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, "_processChildContext", {
        enumerable: false,
        value: function() {
            throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                // Invoke the function an extra time to help detect side-effects.
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "setState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "replaceState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "forceUpdate");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markForceUpdateScheduled(fiber, lane);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === "function") {
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    // Invoke the function an extra time to help detect side-effects.
                    shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || "Component");
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentNameFromType(ctor) || "Component";
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === "function") error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === "function") error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || "A pure component");
        if (typeof instance.componentDidUnmount === "function") error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === "function") error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === "function") error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === "function") error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === "function") error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === "function") error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === "function") error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== "object" || isArray(_state))) error("%s.state: must be set to an object or null", name);
        if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ("contextType" in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = "";
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== "object") addendum = " However, it is set to a " + typeof contextType + ".";
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = " Did you accidentally pass the Context.Provider instead?";
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = " Did you accidentally pass the Context.Consumer instead?";
                else addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || "Component", addendum);
            }
        }
        if (typeof contextType === "object" && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        }
        var instance = new ctor(props, context); // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                instance = new ctor(props, context); // eslint-disable-line no-new
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === "function" && state === null) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = "componentWillMount";
            else if (typeof instance.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = "componentWillReceiveProps";
            else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = "componentWillUpdate";
            else if (typeof instance.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentNameFromType(ctor) || "Component";
                var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === "function") instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || "Component");
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        if (typeof instance.componentWillReceiveProps === "function") instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === "function") instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        if (instance.state !== oldState) {
            var componentName = getComponentNameFromFiber(workInProgress) || "Component";
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === "object" && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === "function") {
            var fiberFlags = Update;
            fiberFlags |= LayoutStatic;
            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
            workInProgress.flags |= fiberFlags;
        }
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var fiberFlags = Update;
                fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
                workInProgress.flags |= fiberFlags;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
                if (typeof instance.componentWillMount === "function") instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
            }
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags = Update;
                _fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags;
            }
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags2 = Update;
                _fiberFlags2 |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags2 |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags2;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing() && !enableLazyContextPropagation) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) || // TODO: In some cases, we'll end up checking if context has changed twice,
        // both before and after `shouldComponentUpdate` has been called. Not ideal,
        // but I'm loath to refactor this function. This only happens for memoized
        // components so it's not that common.
        enableLazyContextPropagation;
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === "function" || typeof instance.componentWillUpdate === "function")) {
                if (typeof instance.componentWillUpdate === "function") instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === "function") instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.componentDidUpdate === "function") workInProgress.flags |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === "function") workInProgress.flags |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child, returnFiber) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child, returnFiber) {
        if (child === null || typeof child !== "object") return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (typeof child._store !== "object") throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasKeyUseWarning[componentName]) return;
        ownerHasKeyUseWarning[componentName] = true;
        error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
    };
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== "function" && typeof mixedRef !== "object") {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictLegacyMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self)) {
                var componentName = getComponentNameFromFiber(returnFiber) || "Component";
                if (!didWarnAboutStringRefs[componentName]) {
                    error('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', mixedRef);
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (ownerFiber.tag !== ClassComponent) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw new Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a " + "bug in React. Please file an issue.");
                 // Assigning this to a const so Flow knows it won't change in the closure
                var resolvedInst = inst;
                checkPropStringCoercion(mixedRef, "ref");
                var stringRef = "" + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === "function" && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = resolvedInst.refs;
                    if (refs === emptyRefsObject) // This is a lazy pooled frozen object, so we need to initialize.
                    refs = resolvedInst.refs = {};
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (typeof mixedRef !== "string") throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                if (!element._owner) throw new Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of" + " the following reasons:\n" + "1. You may be adding a ref to a function component\n" + "2. You may be adding a ref to a component that was not created inside a component's render method\n" + "3. You have multiple copies of React loaded\n" + "See https://reactjs.org/link/refs-must-have-owner for more information.");
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var childString = Object.prototype.toString.call(newChild);
        throw new Error("Objects are not valid as a React child (found: " + (childString === "[object Object]" ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : childString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
    }
    function warnOnFunctionType(returnFiber) {
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasFunctionTypeWarning[componentName]) return;
        ownerHasFunctionTypeWarning[componentName] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function resolveLazy(lazyType) {
        var payload = lazyType._payload;
        var init = lazyType._init;
        return init(payload);
    } // This wrapper function exists because I expect to clone the code in each path
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
            var deletions = returnFiber.deletions;
            if (deletions === null) {
                returnFiber.deletions = [
                    childToDelete
                ];
                returnFiber.flags |= ChildDeletion;
            } else deletions.push(childToDelete);
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) {
                // During hydration, the useId algorithm needs to know which fibers are
                // part of a list of children (arrays, iterators).
                newFiber.flags |= Forked;
                return lastPlacedIndex;
            }
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.flags |= Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.flags |= Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.flags |= Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
            if (current !== null) {
                if (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || // Lazy types should reconcile their resolved type.
                // We need to do this after the Hot Reloading check above,
                // because hot reloading has different semantics than prod because
                // it doesn't resuspend. So we can't let the call below suspend.
                typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText("" + newChild, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        _created2.return = returnFiber;
                        return _created2;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return createChild(returnFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) return updateElement(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateSlot(returnFiber, oldFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateFromMap(existingChildren, returnFiber, newIdx, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys, returnFiber) {
            if (typeof child !== "object" || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child, returnFiber);
                    var key = child.key;
                    if (typeof key !== "string") break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
                case REACT_LAZY_TYPE:
                    var payload = child._payload;
                    var init = child._init;
                    warnOnInvalidKey(init(payload), knownKeys, returnFiber);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                if (getIsHydrating()) {
                    var _numberOfForks = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks2 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks2);
            }
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (typeof iteratorFn !== "function") throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === "Generator") {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (newChildren == null) throw new Error("An iterable object provided no iterator.");
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, lanes);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                if (getIsHydrating()) {
                    var _numberOfForks3 = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks3);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks4 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks4);
            }
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    var elementType = element.type;
                    if (elementType === REACT_FRAGMENT_TYPE) {
                        if (child.tag === Fragment) {
                            deleteRemainingChildren(returnFiber, child.sibling);
                            var existing = useFiber(child, element.props.children);
                            existing.return = returnFiber;
                            existing._debugSource = element._source;
                            existing._debugOwner = element._owner;
                            return existing;
                        }
                    } else if (child.elementType === elementType || isCompatibleFamilyForHotReloading(child, element) || // Lazy types should reconcile their resolved type.
                    // We need to do this after the Hot Reloading check above,
                    // because hot reloading has different semantics than prod because
                    // it doesn't resuspend. So we can't let the call below suspend.
                    typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === child.type) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var _existing = useFiber(child, element.props);
                        _existing.ref = coerceRef(returnFiber, child, element);
                        _existing.return = returnFiber;
                        _existing._debugSource = element._source;
                        _existing._debugOwner = element._owner;
                        return _existing;
                    }
                     // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === "object" && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_PORTAL_TYPE:
                        return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init; // TODO: This function is supposed to be non-recursive.
                        return reconcileChildFibers(returnFiber, currentFirstChild, init(payload), lanes);
                }
                if (isArray(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, "" + newChild, lanes));
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (current !== null && workInProgress.child !== current.child) throw new Error("Resuming work not yet implemented.");
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, lanes);
            child = child.sibling;
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (c === NO_CONTEXT) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // Regular boundaries always capture.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.flags & DidCapture) !== NoFlags;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var NoFlags$1 = /*   */ 0; // Represents whether effect should fire.
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Insertion = /*  */ 2;
    var Layout = /*    */ 4;
    var Passive$1 = /*   */ 8;
    // and should be reset before starting a new render.
    // This tracks which mutable sources need to be reset after a render.
    var workInProgressSources = [];
    function resetWorkInProgressVersions() {
        for(var i = 0; i < workInProgressSources.length; i++){
            var mutableSource = workInProgressSources[i];
            mutableSource._workInProgressVersionPrimary = null;
        }
        workInProgressSources.length = 0;
    }
    // This ensures that the version used for server rendering matches the one
    // that is eventually read during hydration.
    // If they don't match there's a potential tear and a full deopt render is required.
    function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
        // Retaining it forever may interfere with GC.
        if (root.mutableSourceEagerHydrationData == null) root.mutableSourceEagerHydrationData = [
            mutableSource,
            version
        ];
        else root.mutableSourceEagerHydrationData.push(mutableSource, version);
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$2 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    var didWarnUncachedGetSnapshot;
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
    // gets reset after each attempt.
    // TODO: Maybe there's some way to consolidate this with
    // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.
    var didScheduleRenderPhaseUpdateDuringThisPass = false; // Counts the number of useId hooks in this component.
    var localIdCounter = 0; // Used for ids that are generated completely client-side (i.e. not during
    // hydration). This counter is global, so client ids are not stable across
    // render attempts.
    var globalClientIdCounter = 0;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber$1);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = "";
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += " ";
                    row += newHookName + "\n";
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                didScheduleRenderPhaseUpdateDuringThisPass = false;
                localIdCounter = 0;
                if (numberOfReRenders >= RE_RENDER_LIMIT) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (didScheduleRenderPhaseUpdateDuringThisPass);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1; // Confirm that a static flag was not added or removed since the last
        // render. If this fires, it suggests that we incorrectly reset the static
        // flags in some other part of the codebase. This has happened before, for
        // example, in the SuspenseList implementation.
        if (current !== null && (current.flags & StaticMask) !== (workInProgress.flags & StaticMask) && // Disable this warning in legacy mode, because legacy Suspense is weird
        // and creates false positives. To make this work in legacy mode, we'd
        // need to mark fibers that commit in an incomplete state, somehow. For
        // now I'll disable the warning that most of the bugs that would trigger
        // it are either exclusive to concurrent mode or exist in both.
        (current.mode & ConcurrentMode) !== NoMode) error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = false; // This is reset by checkDidRenderIdHook
        // localIdCounter = 0;
        if (didRenderTooFewHooks) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function checkDidRenderIdHook() {
        // This should be called immediately after every renderWithHooks call.
        // Conceptually, it's part of the return value of renderWithHooks; it's only a
        // separate function to avoid using an array tuple.
        var didRenderIdHook = localIdCounter !== 0;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue; // TODO: Don't need to reset the flags here, because they're reset in the
        // complete phase (bubbleProperties).
        if ((workInProgress.mode & StrictEffectsMode) !== NoMode) workInProgress.flags &= ~(MountPassiveDev | MountLayoutDev | Passive | Update);
        else workInProgress.flags &= ~(Passive | Update);
        current.lanes = removeLanes(current.lanes, lanes);
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        isUpdatingOpaqueValueInRenderPhase = false;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        localIdCounter = 0;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (nextCurrentHook === null) throw new Error("Rendered more hooks than during the previous render.");
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            stores: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === "function" ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            if (current.baseQueue !== baseQueue) // Internal invariant that should never happen, but feasibly could in
            // the future if we implement resuming, or some form of that.
            error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateLane = update.lane;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        lane: updateLane,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    // TODO: Don't need to accumulate this. Instead, we can remove
                    // renderLanes from the original lanes.
                    currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                    markSkippedUpdateLanes(updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            action: update.action,
                            hasEagerState: update.hasEagerState,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Process this update.
                    if (update.hasEagerState) // If this update is a state update (not a reducer) and was processed eagerly,
                    // we can use the eagerly computed state
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        } // Interleaved updates are stored on a separate queue. We aren't going to
        // process them during this render, but we do need to track which lanes
        // are remaining.
        var lastInterleaved = queue.interleaved;
        if (lastInterleaved !== null) {
            var interleaved = lastInterleaved;
            do {
                var interleavedLane = interleaved.lane;
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, interleavedLane);
                markSkippedUpdateLanes(interleavedLane);
                interleaved = interleaved.next;
            }while (interleaved !== lastInterleaved);
        } else if (baseQueue === null) // `queue.lanes` is used for entangling transitions. We can set it back to
        // zero once the queue is empty.
        queue.lanes = NoLanes;
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function updateMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = mountWorkInProgressHook();
        var nextSnapshot;
        var isHydrating = getIsHydrating();
        if (isHydrating) {
            if (getServerSnapshot === undefined) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            nextSnapshot = getServerSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                if (nextSnapshot !== getServerSnapshot()) {
                    error("The result of getServerSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
        } else {
            nextSnapshot = getSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                var cachedSnapshot = getSnapshot();
                if (!objectIs(nextSnapshot, cachedSnapshot)) {
                    error("The result of getSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            //
            // We won't do this if we're hydrating server-rendered content, because if
            // the content is stale, it's already visible anyway. Instead we'll patch
            // it up in a passive effect.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        } // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        hook.memoizedState = nextSnapshot;
        var inst = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst; // Schedule an effect to subscribe to the store.
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Schedule an effect to update the mutable instance fields. We will update
        // this whenever subscribe, getSnapshot, or value changes. Because there's no
        // clean-up function, and we track the deps correctly, we can call pushEffect
        // directly, without storing any additional state. For the same reason, we
        // don't need to set a static flag, either.
        // TODO: We can move this to the passive phase once we add a pre-commit
        // consistency check. See the next comment.
        fiber.flags |= Passive;
        pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = updateWorkInProgressHook(); // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        var nextSnapshot = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            if (!objectIs(nextSnapshot, cachedSnapshot)) {
                error("The result of getSnapshot should be cached to avoid an infinite loop");
                didWarnUncachedGetSnapshot = true;
            }
        }
        var prevSnapshot = hook.memoizedState;
        var snapshotChanged = !objectIs(prevSnapshot, nextSnapshot);
        if (snapshotChanged) {
            hook.memoizedState = nextSnapshot;
            markWorkInProgressReceivedUpdate();
        }
        var inst = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if (inst.getSnapshot !== getSnapshot || snapshotChanged || // Check if the susbcribe function changed. We can save some memory by
        // checking whether we scheduled a subscription effect above.
        workInProgressHook !== null && workInProgressHook.memoizedState.tag & HasEffect) {
            fiber.flags |= Passive;
            pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null); // Unless we're rendering a blocking lane, schedule a consistency check.
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        return nextSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= StoreConsistency;
        var check = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.stores = [
                check
            ];
        } else {
            var stores = componentUpdateQueue.stores;
            if (stores === null) componentUpdateQueue.stores = [
                check
            ];
            else stores.push(check);
        }
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        // These are updated in the passive phase
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot; // Something may have been mutated in between render and commit. This could
        // have been in an event that fired before the passive effects, or it could
        // have been in a layout effect. In that case, we would have used the old
        // snapsho and getSnapshot values to bail out. We need to check one more time.
        if (checkIfSnapshotChanged(inst)) // Force a re-render.
        forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        var handleStoreChange = function() {
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceStoreRerender(fiber);
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange);
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(prevValue, nextValue);
        } catch (error) {
            return true;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === "function") // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var _ref2 = {
            current: initialValue
        };
        hook.memoizedState = _ref2;
        return _ref2;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    hook.memoizedState = pushEffect(hookFlags, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) return mountEffectImpl(MountPassiveDev | Passive | PassiveStatic, Passive$1, create, deps);
        else return mountEffectImpl(Passive | PassiveStatic, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        return updateEffectImpl(Passive, Passive$1, create, deps);
    }
    function mountInsertionEffect(create, deps) {
        return mountEffectImpl(Update, Insertion, create, deps);
    }
    function updateInsertionEffect(create, deps) {
        return updateEffectImpl(Update, Insertion, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === "function") {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty("current")) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(refObject).join(", ") + "}");
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = value;
        return value;
    }
    function updateDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        var resolvedCurrentHook = currentHook;
        var prevValue = resolvedCurrentHook.memoizedState;
        return updateDeferredValueImpl(hook, prevValue, value);
    }
    function rerenderDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        if (currentHook === null) {
            // This is a rerender during a mount.
            hook.memoizedState = value;
            return value;
        } else {
            // This is a rerender during an update.
            var prevValue = currentHook.memoizedState;
            return updateDeferredValueImpl(hook, prevValue, value);
        }
    }
    function updateDeferredValueImpl(hook, prevValue, value) {
        var shouldDeferValue = !includesOnlyNonUrgentLanes(renderLanes);
        if (shouldDeferValue) {
            // This is an urgent update. If the value has changed, keep using the
            // previous value and spawn a deferred render to update it later.
            if (!objectIs(value, prevValue)) {
                // Schedule a deferred render
                var deferredLane = claimNextTransitionLane();
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, deferredLane);
                markSkippedUpdateLanes(deferredLane); // Set this to true to indicate that the rendered value is inconsistent
                // from the latest value. The name "baseState" doesn't really match how we
                // use it because we're reusing a state hook field instead of creating a
                // new one.
                hook.baseState = true;
            } // Reuse the previous value
            return prevValue;
        } else {
            // This is not an urgent update, so we can use the latest value regardless
            // of what it is. No need to defer it.
            // However, if we're currently inside a spawned render, then we need to mark
            // this as an update to prevent the fiber from bailing out.
            //
            // `baseState` is true when the current value is different from the rendered
            // value. The name doesn't really match how we use it because we're reusing
            // a state hook field instead of creating a new one.
            if (hook.baseState) {
                // Flip this back to false.
                hook.baseState = false;
                markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = value;
            return value;
        }
    }
    function startTransition(setPending, callback, options) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(higherEventPriority(previousPriority, ContinuousEventPriority));
        setPending(true);
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition = {};
        var currentTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition._updatedFibers = new Set();
        try {
            setPending(false);
            callback();
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$2.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    function mountTransition() {
        var _mountState = mountState(false), isPending = _mountState[0], setPending = _mountState[1]; // The `start` method never changes.
        var start = startTransition.bind(null, setPending);
        var hook = mountWorkInProgressHook();
        hook.memoizedState = start;
        return [
            isPending,
            start
        ];
    }
    function updateTransition() {
        var _updateState = updateState(), isPending = _updateState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    function rerenderTransition() {
        var _rerenderState = rerenderState(), isPending = _rerenderState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    var isUpdatingOpaqueValueInRenderPhase = false;
    function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        return isUpdatingOpaqueValueInRenderPhase;
    }
    function mountId() {
        var hook = mountWorkInProgressHook();
        var root = getWorkInProgressRoot(); // TODO: In Fizz, id generation is specific to each server config. Maybe we
        // should do this in Fiber, too? Deferring this decision for now because
        // there's no other place to store the prefix except for an internal field on
        // the public createRoot object, which the fiber tree does not currently have
        // a reference to.
        var identifierPrefix = root.identifierPrefix;
        var id;
        if (getIsHydrating()) {
            var treeId = getTreeId(); // Use a captial R prefix for server-generated ids.
            id = ":" + identifierPrefix + "R" + treeId; // Unless this is the first id at this level, append a number at the end
            // that represents the position of this useId hook among all the useId
            // hooks for this fiber.
            var localId = localIdCounter++;
            if (localId > 0) id += "H" + localId.toString(32);
            id += ":";
        } else {
            // Use a lowercase r prefix for client-generated ids.
            var globalClientId = globalClientIdCounter++;
            id = ":" + identifierPrefix + "r" + globalClientId.toString(32) + ":";
        }
        hook.memoizedState = id;
        return id;
    }
    function updateId() {
        var hook = updateWorkInProgressHook();
        var id = hook.memoizedState;
        return id;
    }
    function dispatchReducerAction(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function dispatchSetState(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.hasEagerState = true;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) {
                            // Fast path. We can bail out without scheduling React to re-render.
                            // It's still possible that we'll need to rebase this update later,
                            // if the component re-renders for a different reason and by that
                            // time the reducer has changed.
                            // TODO: Do we still need to entangle transitions in this case?
                            enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane);
                            return;
                        }
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        // This is a render phase update. Stash it in a lazily-created map of
        // queue -> linked list of updates. After this render pass, we'll restart
        // and apply the stashed updates on top of the work-in-progress hook.
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
    } // TODO: Move to ReactFiberConcurrentUpdates?
    function entangleTransitionUpdate(root, queue, lane) {
        if (isTransitionLane(lane)) {
            var queueLanes = queue.lanes; // If any entangled lanes are no longer pending on the root, then they
            // must have finished. We can remove them from the shared queue, which
            // represents a superset of the actually pending lanes. In some cases we
            // may entangle more than we need to, but that's OK. In fact it's worse if
            // we *don't* entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            queue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function markUpdateInDevTools(fiber, lane, action) {
        markStateUpdateScheduled(fiber, lane);
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var layoutEffectStartTime = -1;
    var profilerStartTime = -1;
    var passiveEffectStartTime = -1;
    /**
 * Tracks whether the current update was a nested/cascading update (scheduled from a layout effect).
 *
 * The overall sequence is:
 *   1. render
 *   2. commit (and call `onRender`, `onCommit`)
 *   3. check for nested updates
 *   4. flush passive effects (and call `onPostCommit`)
 *
 * Nested updates are identified in step 3 above,
 * but step 4 still applies to the work that was just committed.
 * We use two flags to track nested updates then:
 * one tracks whether the upcoming update is a nested update,
 * and the other tracks whether the current update was a nested update.
 * The first value gets synced to the second at the start of the render phase.
 */ var currentUpdateIsNested = false;
    var nestedUpdateScheduled = false;
    function isCurrentUpdateNested() {
        return currentUpdateIsNested;
    }
    function markNestedUpdateScheduled() {
        nestedUpdateScheduled = true;
    }
    function resetNestedUpdateFlag() {
        currentUpdateIsNested = false;
        nestedUpdateScheduled = false;
    }
    function syncNestedUpdateFlag() {
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = false;
    }
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordLayoutEffectDuration(fiber) {
        if (layoutEffectStartTime >= 0) {
            var elapsedTime = now$1() - layoutEffectStartTime;
            layoutEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        root.effectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        parentStateNode.effectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function recordPassiveEffectDuration(fiber) {
        if (passiveEffectStartTime >= 0) {
            var elapsedTime = now$1() - passiveEffectStartTime;
            passiveEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        if (root !== null) root.passiveEffectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        if (parentStateNode !== null) // Detached fibers have their state node cleared out.
                        // In this case, the return pointer is also cleared out,
                        // so we won't be able to report the time spent in this Profiler's subtree.
                        parentStateNode.passiveEffectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function startLayoutEffectTimer() {
        layoutEffectStartTime = now$1();
    }
    function startPassiveEffectTimer() {
        passiveEffectStartTime = now$1();
    }
    function transferActualDuration(fiber) {
        // Transfer time spent rendering these children so we don't lose it
        // after we rerender. This is used as a helper in special cases
        // where we should count the work of multiple passes.
        var child = fiber.child;
        while(child){
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
        }
    }
    function createCapturedValueAtFiber(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source),
            digest: null
        };
    }
    function createCapturedValue(value, digest, stack) {
        return {
            value: value,
            source: null,
            stack: stack != null ? stack : null,
            digest: digest != null ? digest : null
        };
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(boundary, errorInfo) {
        return true;
    }
    function logCapturedError(boundary, errorInfo) {
        try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.
            if (logError === false) return;
            var error = errorInfo.value;
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : ""; // Browsers support silencing uncaught errors by calling
            // `preventDefault()` in window `error` handler.
            // We record this information as an expando on the error.
            if (error != null && error._suppressLogging) {
                if (boundary.tag === ClassComponent) // The error is recoverable and was silenced.
                // Ignore it and don't print the stack addendum.
                // This is handy for testing error boundaries without noise.
                return;
                 // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.
                console["error"](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
            }
            var componentName = source ? getComponentNameFromFiber(source) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : "The above error occurred in one of your React components:";
            var errorBoundaryMessage;
            if (boundary.tag === HostRoot) errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            else {
                var errorBoundaryName = getComponentNameFromFiber(boundary) || "Anonymous";
                errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            }
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
            console["error"](combinedMessage); // Don't transform to our wrapper
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var PossiblyWeakMap$1 = typeof WeakMap === "function" ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logCapturedError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === "function") {
            var error$1 = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error$1);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                logCapturedError(fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === "function") update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            logCapturedError(fiber, errorInfo);
            if (typeof getDerivedStateFromError !== "function") // To preserve the preexisting retry behavior of error boundaries,
            // we keep track of which ones already failed during this batch.
            // This gets reset before we yield back to the browser.
            // TODO: Warn in strict mode if getDerivedStateFromError is
            // not defined.
            markLegacyErrorBoundaryAsFailed(this);
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ""
            });
            if (typeof getDerivedStateFromError !== "function") // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (!includesSomeLane(fiber.lanes, SyncLane)) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || "Unknown");
            }
        };
        return update;
    }
    function attachPingListener(root, wakeable, lanes) {
        // Attach a ping listener
        //
        // The data might resolve before we have a chance to commit the fallback. Or,
        // in the case of a refresh, we'll never commit a fallback. So we need to
        // attach a listener now. When it resolves ("pings"), we can decide whether to
        // try rendering the tree again.
        //
        // Only attach a listener if one does not already exist for the lanes
        // we're currently rendering (which acts like a "thread ID" here).
        //
        // We only need to do this in concurrent mode. Legacy Suspense always
        // commits fallbacks synchronously, so there are no pings.
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            }
        }
        if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            if (isDevToolsPresent) // If we have pending work still, restore the original updaters
            restorePendingUpdaters(root, lanes);
            wakeable.then(ping, ping);
        }
    }
    function attachRetryListener(suspenseBoundary, root, wakeable, lanes) {
        // Retry listener
        //
        // If the fallback does commit, we need to attach a different type of
        // listener. This one schedules an update on the Suspense boundary to turn
        // the fallback state off.
        //
        // Stash the wakeable on the boundary fiber so we can access it in the
        // commit phase.
        //
        // When the wakeable resolves, we'll attempt to render the boundary
        // again ("retry").
        var wakeables = suspenseBoundary.updateQueue;
        if (wakeables === null) {
            var updateQueue = new Set();
            updateQueue.add(wakeable);
            suspenseBoundary.updateQueue = updateQueue;
        } else wakeables.add(wakeable);
    }
    function resetSuspendedComponent(sourceFiber, rootRenderLanes) {
        // A legacy mode Suspense quirk, only relevant to hook components.
        var tag = sourceFiber.tag;
        if ((sourceFiber.mode & ConcurrentMode) === NoMode && (tag === FunctionComponent || tag === ForwardRef || tag === SimpleMemoComponent)) {
            var currentSource = sourceFiber.alternate;
            if (currentSource) {
                sourceFiber.updateQueue = currentSource.updateQueue;
                sourceFiber.memoizedState = currentSource.memoizedState;
                sourceFiber.lanes = currentSource.lanes;
            } else {
                sourceFiber.updateQueue = null;
                sourceFiber.memoizedState = null;
            }
        }
    }
    function getNearestSuspenseBoundaryToCapture(returnFiber) {
        var node = returnFiber;
        do {
            if (node.tag === SuspenseComponent && shouldCaptureSuspense(node)) return node;
             // This boundary already captured during this render. Continue to the next
            // boundary.
            node = node.return;
        }while (node !== null);
        return null;
    }
    function markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes) {
        // This marks a Suspense boundary so that when we're unwinding the stack,
        // it captures the suspended "exception" and does a second (fallback) pass.
        if ((suspenseBoundary.mode & ConcurrentMode) === NoMode) {
            // Legacy Mode Suspense
            //
            // If the boundary is in legacy mode, we should *not*
            // suspend the commit. Pretend as if the suspended component rendered
            // null and keep rendering. When the Suspense boundary completes,
            // we'll do a second pass to render the fallback.
            if (suspenseBoundary === returnFiber) // Special case where we suspended while reconciling the children of
            // a Suspense boundary's inner Offscreen wrapper fiber. This happens
            // when a React.lazy component is a direct child of a
            // Suspense boundary.
            //
            // Suspense boundaries are implemented as multiple fibers, but they
            // are a single conceptual unit. The legacy mode behavior where we
            // pretend the suspended fiber committed as `null` won't work,
            // because in this case the "suspended" fiber is the inner
            // Offscreen wrapper.
            //
            // Because the contents of the boundary haven't started rendering
            // yet (i.e. nothing in the tree has partially rendered) we can
            // switch to the regular, concurrent mode behavior: mark the
            // boundary with ShouldCapture and enter the unwind phase.
            suspenseBoundary.flags |= ShouldCapture;
            else {
                suspenseBoundary.flags |= DidCapture;
                sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                // But we shouldn't call any lifecycle methods or callbacks. Remove
                // all lifecycle effect tags.
                sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                if (sourceFiber.tag === ClassComponent) {
                    var currentSourceFiber = sourceFiber.alternate;
                    if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                    // completed class component. For example, we should not call
                    // componentWillUnmount if it is deleted.
                    sourceFiber.tag = IncompleteClassComponent;
                    else {
                        // When we try rendering again, we should not reuse the current fiber,
                        // since it's known to be in an inconsistent state. Use a force update to
                        // prevent a bail out.
                        var update = createUpdate(NoTimestamp, SyncLane);
                        update.tag = ForceUpdate;
                        enqueueUpdate(sourceFiber, update, SyncLane);
                    }
                } // The source fiber did not complete. Mark it with Sync priority to
                // indicate that it still has pending work.
                sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
            }
            return suspenseBoundary;
        } // Confirmed that the boundary is in a concurrent mode tree. Continue
        // with the normal suspend path.
        //
        // After this we'll use a set of heuristics to determine whether this
        // render pass will run to completion or restart or "suspend" the commit.
        // The actual logic for this is spread out in different places.
        //
        // This first principle is that if we're going to suspend when we complete
        // a root, then we should also restart if we get an update or ping that
        // might unsuspend it, and vice versa. The only reason to suspend is
        // because you think you might want to restart before committing. However,
        // it doesn't make sense to restart only while in the period we're suspended.
        //
        // Restarting too aggressively is also not good because it starves out any
        // intermediate loading state. So we use heuristics to determine when.
        // Suspense Heuristics
        //
        // If nothing threw a Promise or all the same fallbacks are already showing,
        // then don't suspend/restart.
        //
        // If this is an initial render of a new tree of Suspense boundaries and
        // those trigger a fallback, then don't suspend/restart. We want to ensure
        // that we can show the initial loading state as quickly as possible.
        //
        // If we hit a "Delayed" case, such as when we'd switch from content back into
        // a fallback, then we should always suspend/restart. Transitions apply
        // to this case. If none is defined, JND is used instead.
        //
        // If we're already showing a fallback and it gets "retried", allowing us to show
        // another level, but there's still an inner boundary that would show a fallback,
        // then we suspend/restart for 500ms since the last time we showed a fallback
        // anywhere in the tree. This effectively throttles progressive loading into a
        // consistent train of commits. This also gives us an opportunity to restart to
        // get to the completed state slightly earlier.
        //
        // If there's ambiguity due to batching it's resolved in preference of:
        // 1) "delayed", 2) "initial render", 3) "retry".
        //
        // We want to ensure that a "busy" state doesn't get force committed. We want to
        // ensure that new initial loading states can commit as soon as possible.
        suspenseBoundary.flags |= ShouldCapture; // TODO: I think we can remove this, since we now use `DidCapture` in
        // the begin phase to prevent an early bailout.
        suspenseBoundary.lanes = rootRenderLanes;
        return suspenseBoundary;
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        // The source fiber did not complete.
        sourceFiber.flags |= Incomplete;
        if (isDevToolsPresent) // If we have pending work still, restore the original updaters
        restorePendingUpdaters(root, rootRenderLanes);
        if (value !== null && typeof value === "object" && typeof value.then === "function") {
            // This is a wakeable. The component suspended.
            var wakeable = value;
            resetSuspendedComponent(sourceFiber);
            if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) markDidThrowWhileHydratingDEV();
            var suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);
            if (suspenseBoundary !== null) {
                suspenseBoundary.flags &= ~ForceClientRender;
                markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // We only attach ping listeners in concurrent mode. Legacy Suspense always
                // commits fallbacks synchronously, so there are no pings.
                if (suspenseBoundary.mode & ConcurrentMode) attachPingListener(root, wakeable, rootRenderLanes);
                attachRetryListener(suspenseBoundary, root, wakeable);
                return;
            } else {
                // No boundary was found. Unless this is a sync update, this is OK.
                // We can suspend and wait for more data to arrive.
                if (!includesSyncLane(rootRenderLanes)) {
                    // This is not a sync update. Suspend. Since we're not activating a
                    // Suspense boundary, this will unwind all the way to the root without
                    // performing a second pass to render a fallback. (This is arguably how
                    // refresh transitions should work, too, since we're not going to commit
                    // the fallbacks anyway.)
                    //
                    // This case also applies to initial hydration.
                    attachPingListener(root, wakeable, rootRenderLanes);
                    renderDidSuspendDelayIfPossible();
                    return;
                } // This is a sync/discrete update. We treat this case like an error
                // because discrete renders are expected to produce a complete tree
                // synchronously to maintain consistency with external state.
                var uncaughtSuspenseError = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition."); // If we're outside a transition, fall through to the regular error path.
                // The error will be caught by the nearest suspense boundary.
                value = uncaughtSuspenseError;
            }
        } else // This is a regular error, not a Suspense wakeable.
        if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
            markDidThrowWhileHydratingDEV();
            var _suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber); // If the error was thrown during hydration, we may be able to recover by
            // discarding the dehydrated content and switching to a client render.
            // Instead of surfacing the error, find the nearest Suspense boundary
            // and render it again without hydration.
            if (_suspenseBoundary !== null) {
                if ((_suspenseBoundary.flags & ShouldCapture) === NoFlags) // Set a flag to indicate that we should try rendering the normal
                // children again, not the fallback.
                _suspenseBoundary.flags |= ForceClientRender;
                markSuspenseBoundaryShouldCapture(_suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // Even though the user may not be affected by this error, we should
                // still log it so it can be fixed.
                queueHydrationError(createCapturedValueAtFiber(value, sourceFiber));
                return;
            }
        }
        value = createCapturedValueAtFiber(value, sourceFiber);
        renderDidError(value); // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.flags |= ShouldCapture;
                    var lane = pickArbitraryLane(rootRenderLanes);
                    workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                    var update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                    enqueueCapturedUpdate(workInProgress, update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === "function" || instance !== null && typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state
                        var _update = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    function getSuspendedCache() {
        return null;
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, renderLanes);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(type));
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, "prop", getComponentNameFromType(_type));
        var currentChild = current.child; // This is always exactly one child
        var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
        if (!hasScheduledUpdateOrContext) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    outerMemoType = init(payload);
                } catch (x) {
                    outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, "prop", getComponentNameFromType(outerMemoType));
            }
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false; // The props are shallowly equal. Reuse the previous props object, like we
                // would during a normal fiber bailout.
                //
                // We don't have strong guarantees that the props object is referentially
                // equal during updates where we can't bail out anyway — like if the props
                // are shallowly equal, but there's a local state or context update in the
                // same batch.
                //
                // However, as a principle, we should aim to make the behavior consistent
                // across different ways of memoizing a component. For example, React.memo
                // has a different internal Fiber layout if you pass a normal function
                // component (SimpleMemoComponent) versus if you pass a different type
                // like forwardRef (MemoComponent). But this is an implementation detail.
                // Wrapping a component in forwardRef (or React.lazy, etc) shouldn't
                // affect whether the props object is reused during a bailout.
                workInProgress.pendingProps = nextProps = prevProps;
                if (!checkScheduledUpdateOrContext(current, renderLanes)) {
                    // The pending lanes were cleared at the beginning of beginWork. We're
                    // about to bail out, but there might be other lanes that weren't
                    // included in the current render. Usually, the priority level of the
                    // remaining updates is accumulated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.lanes = current.lanes;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;
        if (nextProps.mode === "hidden" || enableLegacyHidden) {
            // Rendering a hidden tree.
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                // In legacy sync mode, don't defer the subtree. Render it now.
                // TODO: Consider how Offscreen should work with transitions in the future
                var nextState = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = nextState;
                pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                var spawnedCachePool = null; // We're hidden, and we're not rendering at Offscreen. We will bail out
                // and resume this tree later.
                var nextBaseLanes;
                if (prevState !== null) {
                    var prevBaseLanes = prevState.baseLanes;
                    nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                } else nextBaseLanes = renderLanes;
                 // Schedule this fiber to re-render at offscreen priority. Then bailout.
                workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                var _nextState = {
                    baseLanes: nextBaseLanes,
                    cachePool: spawnedCachePool,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState;
                workInProgress.updateQueue = null;
                // to avoid a push/pop misalignment.
                pushRenderLanes(workInProgress, nextBaseLanes);
                return null;
            } else {
                // This is the second render. The surrounding visible content has already
                // committed. Now we resume rendering the hidden tree.
                // Rendering at offscreen, so we can clear the base lanes.
                var _nextState2 = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.
                var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
        } else {
            // Rendering a visible tree.
            var _subtreeRenderLanes;
            if (prevState !== null) {
                // We're going from hidden -> visible.
                _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes);
                workInProgress.memoizedState = null;
            } else // We weren't previously hidden, and we still aren't, so there's nothing
            // special to do. Need to push to the stack regardless, though, to avoid
            // a push/pop misalignment.
            _subtreeRenderLanes = renderLanes;
            pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    } // Note: These happen to have identical begin phases, for now. We shouldn't hold
    function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderLanes) {
        workInProgress.flags |= Update;
        // Reset effect durations for the next eventual effect phase.
        // These are reset during render to allow the DevTools commit hook a chance to read them,
        var stateNode = workInProgress.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) {
            // Schedule a Ref effect
            workInProgress.flags |= Ref;
            workInProgress.flags |= RefStatic;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        // This is used by DevTools to force a boundary to error.
        switch(shouldError(workInProgress)){
            case false:
                var _instance = workInProgress.stateNode;
                var ctor = workInProgress.type; // TODO This way of resetting the error boundary state is a hack.
                // Is there a better way to do this?
                var tempInstance = new ctor(workInProgress.memoizedProps, _instance.context);
                var state = tempInstance.state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case true:
                workInProgress.flags |= DidCapture;
                workInProgress.flags |= ShouldCapture; // eslint-disable-next-line react-internal/prod-error-codes
                var error$1 = new Error("Simulated error coming from DevTools");
                var lane = pickArbitraryLane(renderLanes);
                workInProgress.lanes = mergeLanes(workInProgress.lanes, lane); // Schedule the error boundary to re-render using updated state
                var update = createClassErrorUpdate(workInProgress, createCapturedValueAtFiber(error$1, workInProgress), lane);
                enqueueCapturedUpdate(workInProgress, update);
                break;
        }
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress); // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        var inst = workInProgress.stateNode;
        if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || "a component");
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== "function") {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            markComponentRenderStarted(workInProgress);
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    instance.render();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            setIsRendering(false);
            markComponentRenderStopped();
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);
        if (current === null) throw new Error("Should have a current fiber. This is a bug in React.");
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState.element;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState;
        var root = workInProgress.stateNode;
        // being called "element".
        var nextChildren = nextState.element;
        if (prevState.isDehydrated) {
            // This is a hydration root whose shell has not yet hydrated. We should
            // attempt to hydrate.
            // Flip isDehydrated to false to indicate that when this render
            // finishes, the root will no longer be dehydrated.
            var overrideState = {
                element: nextChildren,
                isDehydrated: false,
                cache: nextState.cache,
                pendingSuspenseBoundaries: nextState.pendingSuspenseBoundaries,
                transitions: nextState.transitions
            };
            var updateQueue = workInProgress.updateQueue; // `baseState` can always be the last state because the root doesn't
            // have reducer functions so it doesn't need rebasing.
            updateQueue.baseState = overrideState;
            workInProgress.memoizedState = overrideState;
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during a previous attempt to hydrate the shell, so we
                // forced a client render.
                var recoverableError = createCapturedValueAtFiber(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError);
            } else if (nextChildren !== prevChildren) {
                var _recoverableError = createCapturedValueAtFiber(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, _recoverableError);
            } else {
                // The outermost shell has not hydrated yet. Start hydrating.
                enterHydrationState(workInProgress);
                var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
                workInProgress.child = child;
                var node = child;
                while(node){
                    // Mark each child as hydrating. This is a fast path to know whether this
                    // tree is part of a hydrating tree. This is used to determine if a child
                    // node has fully mounted yet, and for scheduling event replaying.
                    // Conceptually this is similar to Placement in that a new subtree is
                    // inserted into the React tree here. It just happens to not need DOM
                    // mutations because it already exists.
                    node.flags = node.flags & ~Placement | Hydrating;
                    node = node.sibling;
                }
            }
        } else {
            // Root is not dehydrated. Either this is a client-only root, or it
            // already hydrated.
            resetHydrationState();
            if (nextChildren === prevChildren) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }
        return workInProgress.child;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError) {
        // Revert to client rendering.
        resetHydrationState();
        queueHydrationError(recoverableError);
        workInProgress.flags |= ForceClientRender;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.flags |= ContentReset;
        markRef(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, "prop", getComponentNameFromType(Component));
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), renderLanes);
                return child;
        }
        var hint = "";
        if (Component !== null && typeof Component === "object" && Component.$$typeof === REACT_LAZY_TYPE) hint = " Did you wrap a component in React.lazy() more than once?";
        // because the fact that it's a separate type of work is an
        // implementation detail.
        throw new Error("Element type is invalid. Received a promise that resolves to: " + Component + ". " + ("Lazy element type must resolve to a class or function." + hint));
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress); // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        var hasId;
        markComponentRenderStarted(workInProgress);
        if (Component.prototype && typeof Component.prototype.render === "function") {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        hasId = checkDidRenderIdHook();
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName2 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                    hasId = checkDidRenderIdHook();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
            reconcileChildren(null, workInProgress, value, renderLanes);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error("%s(...): childContextTypes cannot be defined on a function component.", Component.displayName || Component.name || "Component");
        }
        if (workInProgress.ref !== null) {
            var info = "";
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
            var warningKey = ownerName || "";
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ":" + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (typeof Component.getDerivedStateFromProps === "function") {
            var _componentName3 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === "object" && Component.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error("%s: Function components do not support contextType.", _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: NoLane
    };
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache(),
            transitions: null
        };
    }
    function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        var cachePool = null;
        return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes),
            cachePool: cachePool,
            transitions: prevOffscreenState.transitions
        };
    } // TODO: Probably should inline this back
    function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        // If we're already showing a fallback, there are cases where we need to
        // remain on that fallback regardless of whether the content has resolved.
        // For example, SuspenseList coordinates when nested content appears.
        if (current !== null) {
            var suspenseState = current.memoizedState;
            if (suspenseState === null) // Currently showing content. Don't hide it, even if ForceSuspenseFallback
            // is true. More precise name might be "ForceRemainSuspenseFallback".
            // Note: This is a factoring smell. Can't remain on a fallback if there's
            // no fallback to remain on.
            return false;
        } // Not currently showing content. Consult the Suspense context.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
    }
    function getRemainingWorkInPrimaryTree(current, renderLanes) {
        // TODO: Should not remove render lanes that were pinged during this render
        return removeLanes(current.childLanes, renderLanes);
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.flags |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
        } else // Attempting the main content
        if (current === null || current.memoizedState !== null) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
        // boundary's children. This involves some custom reconciliation logic. Two
        // main reasons this is so complicated.
        //
        // First, Legacy Mode has different semantics for backwards compatibility. The
        // primary tree will commit in an inconsistent state, so when we do the
        // second pass to render the fallback, we do some exceedingly, uh, clever
        // hacks to make that not totally break. Like transferring effects and
        // deletions from hidden tree. In Concurrent Mode, it's much simpler,
        // because we bailout on the primary tree completely and leave it in its old
        // state, no effects. Same as what we do for Offscreen (except that
        // Offscreen doesn't have the first render pass).
        //
        // Second is hydration. During hydration, the Suspense fiber has a slightly
        // different layout, where the child points to a dehydrated fragment, which
        // contains the DOM rendered by the server.
        //
        // Third, even if you set all that aside, Suspense is like error boundaries in
        // that we first we try to render one tree, and if that fails, we render again
        // and switch to a different tree. Like a try/catch block. So we have to track
        // which branch we're currently rendering. Ideally we would model this using
        // a stack.
        if (current === null) {
            // Initial mount
            // Special path for hydration
            // If we're currently hydrating, try to hydrate this boundary.
            tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            var suspenseState = workInProgress.memoizedState;
            if (suspenseState !== null) {
                var dehydrated = suspenseState.dehydrated;
                if (dehydrated !== null) return mountDehydratedSuspenseComponent(workInProgress, dehydrated);
            }
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
                var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var primaryChildFragment = workInProgress.child;
                primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackFragment;
            } else return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
        } else {
            // This is an update.
            // Special path for hydration
            var prevState = current.memoizedState;
            if (prevState !== null) {
                var _dehydrated = prevState.dehydrated;
                if (_dehydrated !== null) return updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, _dehydrated, prevState, renderLanes);
            }
            if (showFallback) {
                var _nextFallbackChildren = nextProps.fallback;
                var _nextPrimaryChildren = nextProps.children;
                var fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren, _nextFallbackChildren, renderLanes);
                var _primaryChildFragment2 = workInProgress.child;
                var prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment2.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                _primaryChildFragment2.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            } else {
                var _nextPrimaryChildren2 = nextProps.children;
                var _primaryChildFragment3 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren2, renderLanes);
                workInProgress.memoizedState = null;
                return _primaryChildFragment3;
            }
        }
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
        primaryChildFragment.return = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode & ConcurrentMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = 0;
                primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
            primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode, renderLanes) {
        // The props argument to `createFiberFromOffscreen` is `any` typed, so we use
        // this wrapper function to constrain it.
        return createFiberFromOffscreen(offscreenProps, mode, NoLanes, null);
    }
    function updateWorkInProgressOffscreenFiber(current, offscreenProps) {
        // The props argument to `createWorkInProgress` is `any` typed, so we use this
        // wrapper function to constrain it.
        return createWorkInProgress(current, offscreenProps);
    }
    function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: "visible",
            children: primaryChildren
        });
        if ((workInProgress.mode & ConcurrentMode) === NoMode) primaryChildFragment.lanes = renderLanes;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            var deletions = workInProgress.deletions;
            if (deletions === null) {
                workInProgress.deletions = [
                    currentFallbackChildFragment
                ];
                workInProgress.flags |= ChildDeletion;
            } else deletions.push(currentFallbackChildFragment);
        }
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        if (// completed, even though it's in an inconsistent state.
        (mode & ConcurrentMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it.
            workInProgress.deletions = null;
        } else {
            primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps); // Since we're reusing a current tree, we need to reuse the flags, too.
            // (We don't do this in legacy mode, because in legacy mode we don't re-use
            // the current tree; see previous branch.)
            primaryChildFragment.subtreeFlags = currentPrimaryChildFragment.subtreeFlags & StaticMask;
        }
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.
            fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, recoverableError) {
        // Falling back to client rendering. Because this has performance
        // implications, it's considered a recoverable error, even though the user
        // likely won't observe anything wrong with the UI.
        //
        // The error is passed in as an argument to enforce that every caller provide
        // a custom message, or explicitly opt out (currently the only path that opts
        // out is legacy mode; every concurrent path provides an error).
        if (recoverableError !== null) queueHydrationError(recoverableError);
         // This will add the old fiber to the deletion list
        reconcileChildFibers(workInProgress, current.child, null, renderLanes); // We're now not suspended nor dehydrated.
        var nextProps = workInProgress.pendingProps;
        var primaryChildren = nextProps.children;
        var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Needs a placement effect because the parent (the Suspense boundary) already
        // mounted but this is a new fiber.
        primaryChildFragment.flags |= Placement;
        workInProgress.memoizedState = null;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var fiberMode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, fiberMode);
        var fallbackChildFragment = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes, null); // Needs a placement effect because the parent (the Suspense
        // boundary) already mounted but this is a new fiber.
        fallbackChildFragment.flags |= Placement;
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        if ((workInProgress.mode & ConcurrentMode) !== NoMode) // We will have dropped the effect list which contains the
        // deletion. We need to reconcile to delete the current child.
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        return fallbackChildFragment;
    }
    function mountDehydratedSuspenseComponent(workInProgress, suspenseInstance, renderLanes) {
        // During the first pass, we'll bail out and not drill into the children.
        // Instead, we'll leave the content in place and try to hydrate it later.
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            error("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components.");
            workInProgress.lanes = laneToLanes(SyncLane);
        } else if (isSuspenseInstanceFallback(suspenseInstance)) // This is a client-only boundary. Since we won't get any content from the server
        // for this, we need to schedule that at a higher priority based on when it would
        // have timed out. In theory we could render it in this pass but it would have the
        // wrong priority associated with it and will prevent hydration of parent path.
        // Instead, we'll leave work left on it to render it in a separate commit.
        // TODO This time should be the time at which the server rendered response that is
        // a parent to this boundary was displayed. However, since we currently don't have
        // a protocol to transfer that time, we'll just estimate it by using the current
        // time. This will mean that Suspense timeouts are slightly shifted to later than
        // they should be.
        // Schedule a normal pri update to render this content.
        workInProgress.lanes = laneToLanes(DefaultHydrationLane);
        else // We'll continue hydrating the rest at offscreen priority since we'll already
        // be showing the right content coming from the server, it is no rush.
        workInProgress.lanes = laneToLanes(OffscreenLane);
        return null;
    }
    function updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, suspenseInstance, suspenseState, renderLanes) {
        if (!didSuspend) {
            // This is the first render pass. Attempt to hydrate.
            // We should never be hydrating at this point because it is the first pass,
            // but after we've already committed once.
            warnIfHydrating();
            if ((workInProgress.mode & ConcurrentMode) === NoMode) return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null);
            if (isSuspenseInstanceFallback(suspenseInstance)) {
                // This boundary is in a permanent fallback state. In this case, we'll never
                // get an update and we'll never be able to hydrate the final content. Let's just try the
                // client side render instead.
                var digest, message, stack;
                var _getSuspenseInstanceF = getSuspenseInstanceFallbackErrorDetails(suspenseInstance);
                digest = _getSuspenseInstanceF.digest;
                message = _getSuspenseInstanceF.message;
                stack = _getSuspenseInstanceF.stack;
                var error;
                if (message) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error(message);
                else error = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
                var capturedValue = createCapturedValue(error, digest, stack);
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, capturedValue);
            }
            // any context has changed, we need to treat is as if the input might have changed.
            var hasContextChanged = includesSomeLane(renderLanes, current.childLanes);
            if (didReceiveUpdate || hasContextChanged) {
                // This boundary has changed since the first render. This means that we are now unable to
                // hydrate it. We might still be able to hydrate it using a higher priority lane.
                var root = getWorkInProgressRoot();
                if (root !== null) {
                    var attemptHydrationAtLane = getBumpedLaneForHydration(root, renderLanes);
                    if (attemptHydrationAtLane !== NoLane && attemptHydrationAtLane !== suspenseState.retryLane) {
                        // Intentionally mutating since this render will get interrupted. This
                        // is one of the very rare times where we mutate the current tree
                        // during the render phase.
                        suspenseState.retryLane = attemptHydrationAtLane; // TODO: Ideally this would inherit the event time of the current render
                        var eventTime = NoTimestamp;
                        enqueueConcurrentRenderForLane(current, attemptHydrationAtLane);
                        scheduleUpdateOnFiber(root, current, attemptHydrationAtLane, eventTime);
                    }
                } // If we have scheduled higher pri work above, this will probably just abort the render
                // since we now have higher priority work, but in case it doesn't, we need to prepare to
                // render something, if we time out. Even if that requires us to delete everything and
                // skip hydration.
                // Delay having to do this as long as the suspense timeout allows us.
                renderDidSuspendDelayIfPossible();
                var _capturedValue = createCapturedValue(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue);
            } else if (isSuspenseInstancePending(suspenseInstance)) {
                // This component is still pending more data from the server, so we can't hydrate its
                // content. We treat it as if this component suspended itself. It might seem as if
                // we could just try to render it client-side instead. However, this will perform a
                // lot of unnecessary work and is unlikely to complete since it often will suspend
                // on missing data anyway. Additionally, the server might be able to render more
                // than we can on the client yet. In that case we'd end up with more fallback states
                // on the client than if we just leave it alone. If the server times out or errors
                // these should update this boundary to the permanent Fallback state instead.
                // Mark it as having captured (i.e. suspended).
                workInProgress.flags |= DidCapture; // Leave the child in place. I.e. the dehydrated fragment.
                workInProgress.child = current.child; // Register a callback to retry this boundary once the server has sent the result.
                var retry = retryDehydratedSuspenseBoundary.bind(null, current);
                registerSuspenseInstanceRetry(suspenseInstance, retry);
                return null;
            } else {
                // This is the first attempt.
                reenterHydrationStateFromDehydratedSuspenseInstance(workInProgress, suspenseInstance, suspenseState.treeContext);
                var primaryChildren = nextProps.children;
                var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Mark the children as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                primaryChildFragment.flags |= Hydrating;
                return primaryChildFragment;
            }
        } else {
            // This is the second render pass. We already attempted to hydrated, but
            // something either suspended or errored.
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during hydration. Try again without hydrating.
                workInProgress.flags &= ~ForceClientRender;
                var _capturedValue2 = createCapturedValue(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue2);
            } else if (workInProgress.memoizedState !== null) {
                // Something suspended and we should still be in dehydrated mode.
                // Leave the existing child in place.
                workInProgress.child = current.child; // The dehydrated completion pass expects this flag to be there
                // but the normal suspense pass doesn't.
                workInProgress.flags |= DidCapture;
                return null;
            } else {
                // Suspended but we should no longer be in dehydrated mode.
                // Therefore we now have to render the fallback.
                var nextPrimaryChildren = nextProps.children;
                var nextFallbackChildren = nextProps.fallback;
                var fallbackChildFragment = mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var _primaryChildFragment4 = workInProgress.child;
                _primaryChildFragment4.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            }
        }
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== "forwards" && revealOrder !== "backwards" && revealOrder !== "together" && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === "string") switch(revealOrder.toLowerCase()){
                case "together":
                case "forwards":
                case "backwards":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case "forward":
                case "backward":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== "collapsed" && tailMode !== "hidden") {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== "forwards" && revealOrder !== "backwards") {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArray(childSlot);
        var isIterable = !isAnArray && typeof getIteratorFn(childSlot) === "function";
        if (isAnArray || isIterable) {
            var type = isAnArray ? "array" : "iterable";
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === "forwards" || revealOrder === "backwards") && children !== undefined && children !== null && children !== false) {
            if (isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === "function") {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & ConcurrentMode) === NoMode) // In legacy mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case "forwards":
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode);
                break;
            case "backwards":
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, false, null, null, undefined);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
    function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        if (!("value" in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?");
            }
        }
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, "prop", "Context.Provider");
        pushProvider(workInProgress, context, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            if (objectIs(oldValue, newValue)) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, renderLanes);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== "function") error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderLanes);
        var newValue = readContext(context);
        markComponentRenderStarted(workInProgress);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress) {
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            if (current !== null) {
                // A lazy component only mounts if it suspended inside a non-
                // concurrent tree, in an inconsistent state. We want to treat it like
                // a new mount, even though an empty version of it already committed.
                // Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.flags |= Placement;
            }
        }
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.
        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) return null;
         // This fiber doesn't have work, but its subtree does. Clone the child
        // fibers and continue.
        cloneChildFibers(current, workInProgress);
        return workInProgress.child;
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) // eslint-disable-next-line react-internal/prod-error-codes
        throw new Error("Cannot swap the root fiber.");
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
            throw new Error("Expected parent to have a child.");
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
                throw new Error("Expected to find the previous sibling.");
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                current
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(current);
        newWorkInProgress.flags |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        // Before performing an early bailout, we must check if there are pending
        // updates or context.
        var updateLanes = current.lanes;
        if (includesSomeLane(updateLanes, renderLanes)) return true;
         // No pending update, but because context is propagated lazily, we need
        return false;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        // This fiber does not have any pending work. Bailout without entering
        // the begin phase. There's still some bookkeeping we that needs to be done
        // in this optimized path, mostly pushing stuff onto the stack.
        switch(workInProgress.tag){
            case HostRoot:
                pushHostRootContext(workInProgress);
                var root = workInProgress.stateNode;
                resetHydrationState();
                break;
            case HostComponent:
                pushHostContext(workInProgress);
                break;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) pushContextProvider(workInProgress);
                break;
            case HostPortal:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case ContextProvider:
                var newValue = workInProgress.memoizedProps.value;
                var context = workInProgress.type._context;
                pushProvider(workInProgress, context, newValue);
                break;
            case Profiler:
                // Profiler should only call onRender when one of its descendants actually rendered.
                var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (hasChildWork) workInProgress.flags |= Update;
                // Reset effect durations for the next eventual effect phase.
                // These are reset during render to allow the DevTools commit hook a chance to read them,
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = 0;
                stateNode.passiveEffectDuration = 0;
                break;
            case SuspenseComponent:
                var state = workInProgress.memoizedState;
                if (state !== null) {
                    if (state.dehydrated !== null) {
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // We know that this component will suspend again because if it has
                        // been unsuspended it has committed as a resolved Suspense component.
                        // If it needs to be retried, it should have work scheduled on it.
                        workInProgress.flags |= DidCapture; // We should never render the children of a dehydrated boundary until we
                        // upgrade it. We return null instead of bailoutOnAlreadyFinishedWork.
                        return null;
                    } // If this boundary is currently timed out, we need to decide
                    // whether to retry the primary children, or to skip over it and
                    // go straight to the fallback. Check the priority of the primary
                    // child fragment.
                    var primaryChildFragment = workInProgress.child;
                    var primaryChildLanes = primaryChildFragment.childLanes;
                    if (includesSomeLane(renderLanes, primaryChildLanes)) // The primary children have pending work. Use the normal path
                    // to attempt to render the primary children again.
                    return updateSuspenseComponent(current, workInProgress, renderLanes);
                    else {
                        // The primary child fragment does not have pending work marked
                        // on it
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                        // priority. Bailout.
                        var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        if (child !== null) // The fallback children have pending work. Skip over the
                        // primary children and work on the fallback.
                        return child.sibling;
                        else // Note: We can return `null` here because we already checked
                        // whether there were nested context consumers, via the call to
                        // `bailoutOnAlreadyFinishedWork` above.
                        return null;
                    }
                } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                break;
            case SuspenseListComponent:
                var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (didSuspendBefore) {
                    if (_hasChildWork) // If something was in fallback state last time, and we have all the
                    // same children then we're still in progressive loading state.
                    // Something might get unblocked by state updates or retries in the
                    // tree which will affect the tail. So we need to use the normal
                    // path to compute the correct tail.
                    return updateSuspenseListComponent(current, workInProgress, renderLanes);
                     // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.
                    workInProgress.flags |= DidCapture;
                } // If nothing suspended before and we're rendering the same children,
                // then the tail doesn't matter. Anything new that suspends will work
                // in the "together" mode, so we can continue from the state we had.
                var renderState = workInProgress.memoizedState;
                if (renderState !== null) {
                    // Reset to the "together" mode in case we've started a different
                    // update in the past but didn't complete it.
                    renderState.rendering = null;
                    renderState.tail = null;
                    renderState.lastEffect = null;
                }
                pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                if (_hasChildWork) break;
                else // If none of the children had any work, that means that none of
                // them got retried so they'll still be blocked in the same way
                // as before. We can fast bail out.
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                // Need to check if the tree still needs to be deferred. This is
                // almost identical to the logic used in the normal update path,
                // so we'll just enter that. The only difference is we'll bail out
                // at the next level instead of this one, because the child props
                // have not changed. Which is fine.
                // TODO: Probably should refactor `beginWork` to split the bailout
                // path from the normal path. I'm tempted to do a labeled break here
                // but I won't :)
                workInProgress.lanes = NoLanes;
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else {
                // Neither props nor legacy context changes. Check if there's a pending
                // update or context change.
                var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
                if (!hasScheduledUpdateOrContext && // If this is the second pass of an error or suspense boundary, there
                // may not be work scheduled on `current`, so we check for this flag.
                (workInProgress.flags & DidCapture) === NoFlags) {
                    // No pending updates or context. Bail out now.
                    didReceiveUpdate = false;
                    return attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                }
                if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
                else // An update was scheduled on this fiber, but there are no new props
                // nor legacy context. Set this to false. If an update queue or context
                // consumer produces a changed value, it will set this to true. Otherwise,
                // the component will assume the children have not changed and bail out.
                didReceiveUpdate = false;
            }
        } else {
            didReceiveUpdate = false;
            if (getIsHydrating() && isForkedChild(workInProgress)) {
                // Check if this child belongs to a list of muliple children in
                // its parent.
                //
                // In a true multi-threaded implementation, we would render children on
                // parallel threads. This would represent the beginning of a new render
                // thread for this subtree.
                //
                // We only use this for id generation during hydration, which is why the
                // logic is located in this special branch.
                var slotIndex = workInProgress.index;
                var numberOfForks = getForksAtLevel();
                pushTreeId(workInProgress, numberOfForks, slotIndex);
            }
        } // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.lanes = NoLanes;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, renderLanes);
            case FunctionComponent:
                var Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === Component ? unresolvedProps : resolveDefaultProps(Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, Component, resolvedProps, renderLanes);
            case ClassComponent:
                var _Component = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component ? _unresolvedProps : resolveDefaultProps(_Component, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component, _resolvedProps, renderLanes);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, "prop", getComponentNameFromType(_type2));
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, renderLanes);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case IncompleteClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component2 ? _unresolvedProps4 : resolveDefaultProps(_Component2, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component2, _resolvedProps4, renderLanes);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case ScopeComponent:
                break;
            case OffscreenComponent:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.flags |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.flags |= Ref;
        workInProgress.flags |= RefStatic;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(current, workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) // If we're hydrating, we should consume as many items as we can
        // so we don't leave any behind.
        return;
        switch(renderState.tailMode){
            case "hidden":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case "collapsed":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = completedWork.alternate !== null && completedWork.alternate.child === completedWork.child;
        var newChildLanes = NoLanes;
        var subtreeFlags = NoFlags;
        if (!didBailout) {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var actualDuration = completedWork.actualDuration;
                var treeBaseDuration = completedWork.selfBaseDuration;
                var child = completedWork.child;
                while(child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                    subtreeFlags |= child.subtreeFlags;
                    subtreeFlags |= child.flags; // When a fiber is cloned, its actualDuration is reset to 0. This value will
                    // only be updated if work is done on the fiber (i.e. it doesn't bailout).
                    // When work is done, it should bubble to the parent's actualDuration. If
                    // the fiber has not been cloned though, (meaning no work was done), then
                    // this value will reflect the amount of time spent working on a previous
                    // render. In that case it should not bubble. We determine whether it was
                    // cloned by comparing the child pointer.
                    actualDuration += child.actualDuration;
                    treeBaseDuration += child.treeBaseDuration;
                    child = child.sibling;
                }
                completedWork.actualDuration = actualDuration;
                completedWork.treeBaseDuration = treeBaseDuration;
            } else {
                var _child = completedWork.child;
                while(_child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                    subtreeFlags |= _child.subtreeFlags;
                    subtreeFlags |= _child.flags; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child.return = completedWork;
                    _child = _child.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        } else {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var _treeBaseDuration = completedWork.selfBaseDuration;
                var _child2 = completedWork.child;
                while(_child2 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child2.lanes, _child2.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child2.subtreeFlags & StaticMask;
                    subtreeFlags |= _child2.flags & StaticMask;
                    _treeBaseDuration += _child2.treeBaseDuration;
                    _child2 = _child2.sibling;
                }
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else {
                var _child3 = completedWork.child;
                while(_child3 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child3.lanes, _child3.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child3.subtreeFlags & StaticMask;
                    subtreeFlags |= _child3.flags & StaticMask; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child3.return = completedWork;
                    _child3 = _child3.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        }
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeDehydratedSuspenseBoundary(current, workInProgress, nextState) {
        if (hasUnhydratedTailNodes() && (workInProgress.mode & ConcurrentMode) !== NoMode && (workInProgress.flags & DidCapture) === NoFlags) {
            warnIfUnhydratedTailNodes(workInProgress);
            resetHydrationState();
            workInProgress.flags |= ForceClientRender | Incomplete | ShouldCapture;
            return false;
        }
        var wasHydrated = popHydrationState(workInProgress);
        if (nextState !== null && nextState.dehydrated !== null) {
            // We might be inside a hydration state the first time we're picking up this
            // Suspense boundary, and also after we've reentered it for further hydration.
            if (current === null) {
                if (!wasHydrated) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                prepareToHydrateHostSuspenseInstance(workInProgress);
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var isTimedOutSuspense = nextState !== null;
                    if (isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            } else {
                // We might have reentered this boundary to hydrate it. If so, we need to reset the hydration
                // state since we're now exiting out of it. popHydrationState doesn't do that for us.
                resetHydrationState();
                if ((workInProgress.flags & DidCapture) === NoFlags) // This boundary did not suspend so it's now hydrated and unsuspended.
                workInProgress.memoizedState = null;
                 // If nothing suspended, we need to schedule an effect to mark this boundary
                // as having hydrated so events know that they're free to be invoked.
                // It's also a signal to replay events and the suspense callback.
                // If something suspended, schedule an effect to attach retry listeners.
                // So we might as well always mark this.
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var _isTimedOutSuspense = nextState !== null;
                    if (_isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var _primaryChildFragment = workInProgress.child;
                        if (_primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= _primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            }
        } else {
            // Successfully completed this tree. If this was a forced client render,
            // there may have been recoverable errors during first hydration
            // attempt. If so, add them to a queue so we can log them in the
            // commit phase.
            upgradeHydrationErrorsToRecoverable(); // Fall through to normal Suspense path
            return true;
        }
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps; // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                bubbleProperties(workInProgress);
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostRoot:
                var fiberRoot = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                    else if (current !== null) {
                        var prevState = current.memoizedState;
                        if (!prevState.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                        (workInProgress.flags & ForceClientRender) !== NoFlags) {
                            // Schedule an effect to clear this container at the start of the
                            // next commit. This handles the case of React rendering into a
                            // container with previous children. It's also safe to do for
                            // updates too, because current.child would only be null if the
                            // previous render was null (so the container would already
                            // be empty).
                            workInProgress.flags |= Snapshot; // If this was a forced client render, there may have been
                            // recoverable errors during first hydration attempt. If so, add
                            // them to a queue so we can log them in the commit phase.
                            upgradeHydrationErrorsToRecoverable();
                        }
                    }
                }
                updateHostContainer(current, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false);
                        workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== "string") {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState; // Special path for dehydrated boundaries. We may eventually move this
                // to its own fiber type so that we can add other kinds of hydration
                // boundaries that aren't associated with a Suspense tree. In anticipation
                // of such a refactor, all the hydration logic is contained in
                // this branch.
                if (current === null || current.memoizedState !== null && current.memoizedState.dehydrated !== null) {
                    var fallthroughToNormalSuspensePath = completeDehydratedSuspenseBoundary(current, workInProgress, nextState);
                    if (!fallthroughToNormalSuspensePath) {
                        if (workInProgress.flags & ShouldCapture) // Special case. There were remaining unhydrated nodes. We treat
                        // this as a mismatch. Revert to client rendering.
                        return workInProgress;
                        else // Did not finish hydrating, either because this is the initial
                        // render or because something suspended.
                        return null;
                    } // Continue with the normal Suspense path.
                }
                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.lanes = renderLanes; // Do not reset the effect list.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                     // Don't bubble properties in this case.
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = current !== null && current.memoizedState !== null;
                // a passive effect, which is when we process the transitions
                if (nextDidTimeout !== prevDidTimeout) // an effect to toggle the subtree's visibility. When we switch from
                // fallback -> primary, the inner Offscreen fiber schedules this effect
                // as part of its normal complete phase. But when we switch from
                // primary -> fallback, the inner Offscreen fiber does not have a complete
                // phase. So we need to schedule its effect here.
                //
                // We also use this flag to connect/disconnect the effects, but the same
                // logic applies: when re-connecting, the Offscreen fiber's complete
                // phase will handle scheduling the effect. It's only when the fallback
                // is active that we have to do anything special.
                {
                    if (nextDidTimeout) {
                        var _offscreenFiber2 = workInProgress.child;
                        _offscreenFiber2.flags |= Visibility; // TODO: This will still suspend a synchronous tree if anything
                        // in the concurrent tree already suspended during this render.
                        // This is a known bug.
                        if ((workInProgress.mode & ConcurrentMode) !== NoMode) {
                            // TODO: Move this back to throwException because this is too late
                            // if this is a large tree which is common for initial loads. We
                            // don't know if we should restart a render or not until we get
                            // this marker, and this is too late.
                            // If this render already had a ping or lower pri updates,
                            // and this is the first time we know we're going to suspend we
                            // should be able to immediately restart from within throwException.
                            var hasInvisibleChildContext = current === null && (workInProgress.memoizedProps.unstable_avoidThisFallback !== true || !enableSuspenseAvoidThisFallback);
                            if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                            // this boundary is ok.
                            renderDidSuspend();
                            else // Otherwise, we're going to have to hide content so we should
                            // suspend for longer if possible.
                            renderDidSuspendDelayIfPossible();
                        }
                    }
                }
                var wakeables = workInProgress.updateQueue;
                if (wakeables !== null) // Schedule an effect to attach a retry listener to the promise.
                // TODO: Move to passive phase
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    if (nextDidTimeout) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(current, workInProgress);
                if (current === null) preparePortalMount(workInProgress.stateNode.containerInfo);
                bubbleProperties(workInProgress);
                return null;
            case ContextProvider:
                // Pop provider fiber
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) {
                    // We're running in the default, "independent" mode.
                    // We don't do anything in this mode.
                    bubbleProperties(workInProgress);
                    return null;
                }
                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.flags |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thenables. Instead, we'll transfer its thenables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThenables = suspended.updateQueue;
                                    if (newThenables !== null) {
                                        workInProgress.updateQueue = newThenables;
                                        workInProgress.flags |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect flags before doing the second pass since that's now invalid.
                                    // Reset the child fibers to their original state.
                                    workInProgress.subtreeFlags = NoFlags;
                                    resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback)); // Don't bubble properties in this case.
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                        if (renderState.tail !== null && now() > getRenderTargetTime()) {
                            // We have already passed our CPU deadline but we still have rows
                            // left in the tail. We'll just give up further attempts to render
                            // the main content and only render fallbacks.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThenables = _suspended.updateQueue;
                            if (_newThenables !== null) {
                                workInProgress.updateQueue = _newThenables;
                                workInProgress.flags |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === "hidden" && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                            ) {
                                // We're done.
                                bubbleProperties(workInProgress);
                                return null;
                            }
                        } else if (// time we have to render. So rendering one more row would likely
                        // exceed it.
                        now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    // Don't bubble properties in this case.
                    return next;
                }
                bubbleProperties(workInProgress);
                return null;
            case ScopeComponent:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                var _nextState = workInProgress.memoizedState;
                var nextIsHidden = _nextState !== null;
                if (current !== null) {
                    var _prevState = current.memoizedState;
                    var prevIsHidden = _prevState !== null;
                    if (prevIsHidden !== nextIsHidden && !enableLegacyHidden) workInProgress.flags |= Visibility;
                }
                if (!nextIsHidden || (workInProgress.mode & ConcurrentMode) === NoMode) bubbleProperties(workInProgress);
                else // Don't bubble properties for hidden children unless we're rendering
                // at offscreen priority.
                if (includesSomeLane(subtreeRenderLanes, OffscreenLane)) {
                    bubbleProperties(workInProgress);
                    // Check if there was an insertion or update in the hidden subtree.
                    // If so, we need to hide those nodes in the commit phase, so
                    // schedule a visibility effect.
                    if (workInProgress.subtreeFlags & (Placement | Update)) workInProgress.flags |= Visibility;
                }
                return null;
            case CacheComponent:
                return null;
            case TracingMarkerComponent:
                return null;
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function unwindWork(current, workInProgress, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var flags = workInProgress.flags;
                if (flags & ShouldCapture) {
                    workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case HostRoot:
                var root = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;
                if ((_flags & ShouldCapture) !== NoFlags && (_flags & DidCapture) === NoFlags) {
                    // There was an error during render that wasn't captured by a suspense
                    // boundary. Do a second pass on the root to unmount the children.
                    workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                    return workInProgress;
                } // We unwound to the root without completing it. Exit.
                return null;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var suspenseState = workInProgress.memoizedState;
                if (suspenseState !== null && suspenseState.dehydrated !== null) {
                    if (workInProgress.alternate === null) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                var _flags2 = workInProgress.flags;
                if (_flags2 & ShouldCapture) {
                    workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            case CacheComponent:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                var root = interruptedWork.stateNode;
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                var context = interruptedWork.type._context;
                popProvider(context, interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
        }
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    // Allows us to avoid traversing the return path to find the nearest Offscreen ancestor.
    // Only used when enableSuspenseLayoutEffectSemantics is enabled.
    var offscreenSubtreeIsHidden = false;
    var offscreenSubtreeWasHidden = false;
    var PossiblyWeakSet = typeof WeakSet === "function" ? WeakSet : Set;
    var nextEffect = null; // Used for Profiling builds to track updaters.
    var inProgressLanes = null;
    var inProgressRoot = null;
    function reportUncaughtErrorInDEV(error) {
        invokeGuardedCallback(null, function() {
            throw error;
        });
        clearCaughtError();
    }
    var callComponentWillUnmountWithTimer = function(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        if (current.mode & ProfileMode) try {
            startLayoutEffectTimer();
            instance.componentWillUnmount();
        } finally{
            recordLayoutEffectDuration(current);
        }
        else instance.componentWillUnmount();
    }; // Capture errors so they don't interrupt mounting.
    function safelyCallCommitHookLayoutEffectListMount(current, nearestMountedAncestor) {
        try {
            commitHookEffectListMount(Layout, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        try {
            callComponentWillUnmountWithTimer(current, instance);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyCallComponentDidMount(current, nearestMountedAncestor, instance) {
        try {
            instance.componentDidMount();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            commitAttachRef(current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === "function") {
                var retVal;
                try {
                    if (enableProfilerTimer && enableProfilerCommitHooks && current.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        retVal = ref(null);
                    } finally{
                        recordLayoutEffectDuration(current);
                    }
                    else retVal = ref(null);
                } catch (error) {
                    captureCommitPhaseError(current, nearestMountedAncestor, error);
                }
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(current));
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, nearestMountedAncestor, destroy) {
        try {
            destroy();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    var focusedInstanceHandle = null;
    var shouldFireAfterActiveInstanceBlur = false;
    function commitBeforeMutationEffects(root, firstChild) {
        focusedInstanceHandle = prepareForCommit(root.containerInfo);
        nextEffect = firstChild;
        commitBeforeMutationEffects_begin(); // We no longer need to track the active instance fiber
        var shouldFire = shouldFireAfterActiveInstanceBlur;
        shouldFireAfterActiveInstanceBlur = false;
        focusedInstanceHandle = null;
        return shouldFire;
    }
    function commitBeforeMutationEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect; // This phase is only used for beforeActiveInstanceBlur.
            var child = fiber.child;
            if ((fiber.subtreeFlags & BeforeMutationMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitBeforeMutationEffects_complete();
        }
    }
    function commitBeforeMutationEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            setCurrentFiber(fiber);
            try {
                commitBeforeMutationEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitBeforeMutationEffectsOnFiber(finishedWork) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags;
        if ((flags & Snapshot) !== NoFlags) {
            setCurrentFiber(finishedWork);
            switch(finishedWork.tag){
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                    break;
                case ClassComponent:
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    }
                    break;
                case HostRoot:
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                    break;
                case HostComponent:
                case HostText:
                case HostPortal:
                case IncompleteClassComponent:
                    break;
                default:
                    throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            resetCurrentFiber();
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) {
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStarted(finishedWork);
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStarted(finishedWork);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                        safelyCallDestroy(finishedWork, nearestMountedAncestor, destroy);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStopped();
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStopped();
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(flags, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStarted(finishedWork);
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStarted(finishedWork);
                    var create = effect.create;
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                    effect.destroy = create();
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStopped();
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStopped();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== "function") {
                        var hookName = void 0;
                        if ((effect.tag & Layout) !== NoFlags) hookName = "useLayoutEffect";
                        else if ((effect.tag & Insertion) !== NoFlags) hookName = "useInsertionEffect";
                        else hookName = "useEffect";
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === "function") addendum = "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. " + "Instead, write the async function inside your effect " + "and call it immediately:\n\n" + hookName + "(() => {\n" + "  async function fetchData() {\n" + "    // You can await here\n" + "    const response = await MyAPI.getData(someId);\n" + "    // ...\n" + "  }\n" + "  fetchData();\n" + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + "Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching";
                        else addendum = " You returned: " + destroy;
                        error("%s must not return anything besides a function, which is used for clean-up.%s", hookName, addendum);
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitPassiveEffectDurations(finishedRoot, finishedWork) {
        // Only Profilers with work in their subtree will have an Update effect scheduled.
        if ((finishedWork.flags & Update) !== NoFlags) switch(finishedWork.tag){
            case Profiler:
                var passiveEffectDuration = finishedWork.stateNode.passiveEffectDuration;
                var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onPostCommit = _finishedWork$memoize.onPostCommit; // This value will still reflect the previous commit phase.
                // It does not get reset until the start of the next commit phase.
                var commitTime = getCommitTime();
                var phase = finishedWork.alternate === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onPostCommit === "function") onPostCommit(id, phase, passiveEffectDuration, commitTime);
                 // Bubble times to the next nearest ancestor Profiler.
                // After we process that Profiler, we'll bubble further up.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork, committedLanes) {
        if ((finishedWork.flags & LayoutMask) !== NoFlags) switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    // At this point layout effects have already been destroyed (during mutation phase).
                    // This is done to prevent sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListMount(Layout | HasEffect, finishedWork);
                    } finally{
                        recordLayoutEffectDuration(finishedWork);
                    }
                    else commitHookEffectListMount(Layout | HasEffect, finishedWork);
                }
                break;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.flags & Update) {
                    if (!offscreenSubtreeWasHidden) {
                        if (current === null) {
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidMount();
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidMount();
                        } else {
                            var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                            var prevState = current.memoizedState; // We could update instance props and state here,
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        }
                    }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                break;
            case HostRoot:
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                break;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.flags & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                break;
            case HostText:
                break;
            case HostPortal:
                break;
            case Profiler:
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime = getCommitTime();
                var phase = current === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onRender === "function") onRender(finishedWork.memoizedProps.id, phase, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime);
                if (typeof onCommit === "function") onCommit(finishedWork.memoizedProps.id, phase, effectDuration, commitTime);
                 // Schedule a passive effect for this Profiler to call onPostCommit hooks.
                // This effect should be scheduled even if there is no onPostCommit callback for this Profiler,
                // because the effect is also where times bubble to parent Profilers.
                enqueuePendingPassiveProfilerEffect(finishedWork); // Propagate layout effect durations to the next nearest Profiler ancestor.
                // Do not reset these values until the next render so DevTools has a chance to read them first.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.effectDuration += effectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.effectDuration += effectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
            case TracingMarkerComponent:
                break;
            default:
                throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (!offscreenSubtreeWasHidden) {
            if (finishedWork.flags & Ref) commitAttachRef(finishedWork);
        }
    }
    function reappearLayoutEffectsOnFiber(node) {
        // Turn on layout effects in a tree that previously disappeared.
        // TODO (Offscreen) Check: flags & LayoutStatic
        switch(node.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (node.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    safelyCallCommitHookLayoutEffectListMount(node, node.return);
                } finally{
                    recordLayoutEffectDuration(node);
                }
                else safelyCallCommitHookLayoutEffectListMount(node, node.return);
                break;
            case ClassComponent:
                var instance = node.stateNode;
                if (typeof instance.componentDidMount === "function") safelyCallComponentDidMount(node, node.return, instance);
                safelyAttachRef(node, node.return);
                break;
            case HostComponent:
                safelyAttachRef(node, node.return);
                break;
        }
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // Only hide or unhide the top-most host nodes.
        var hostSubtreeRoot = null;
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                if (hostSubtreeRoot === null) {
                    hostSubtreeRoot = node;
                    try {
                        var instance = node.stateNode;
                        if (isHidden) hideInstance(instance);
                        else unhideInstance(node.stateNode, node.memoizedProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
            } else if (node.tag === HostText) {
                if (hostSubtreeRoot === null) try {
                    var _instance3 = node.stateNode;
                    if (isHidden) hideTextInstance(_instance3);
                    else unhideTextInstance(_instance3, node.memoizedProps);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                if (hostSubtreeRoot === node) hostSubtreeRoot = null;
                node = node.return;
            }
            if (hostSubtreeRoot === node) hostSubtreeRoot = null;
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === "function") {
                var retVal;
                if (finishedWork.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    retVal = ref(instanceToUse);
                } finally{
                    recordLayoutEffectDuration(finishedWork);
                }
                else retVal = ref(instanceToUse);
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(finishedWork));
            } else {
                if (!ref.hasOwnProperty("current")) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork));
                ref.current = instanceToUse;
            }
        }
    }
    function detachFiberMutation(fiber) {
        // Cut off the return pointer to disconnect it from the tree.
        // This enables us to detect and warn against state updates on an unmounted component.
        // It also prevents events from bubbling from within disconnected components.
        //
        // Ideally, we should also clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child.
        // This child itself will be GC:ed when the parent updates the next time.
        //
        // Note that we can't clear child or sibling pointers yet.
        // They're needed for passive effects and for findDOMNode.
        // We defer those fields, and all other cleanup, to the passive phase (see detachFiberAfterEffects).
        //
        // Don't reset the alternate yet, either. We need that so we can detach the
        // alternate's fields in the passive phase. Clearing the return pointer is
        // sufficient for findDOMNode semantics.
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.return = null;
        fiber.return = null;
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        if (alternate !== null) {
            fiber.alternate = null;
            detachFiberAfterEffects(alternate);
        } // Note: Defensively using negation instead of < in case
        // Clear cyclical Fiber fields. This level alone is designed to roughly
        // approximate the planned Fiber refactor. In that world, `setState` will be
        // bound to a special "instance" object instead of a Fiber. The Instance
        // object will not have any of these fields. It will only be connected to
        // the fiber tree via a single link at the root. So if this level alone is
        // sufficient to fix memory issues, that bodes well for our plans.
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null; // The `stateNode` is cyclical because on host nodes it points to the host
        // tree, which has its own pointers to children, parents, and siblings.
        // The other host nodes also point back to fibers, so we should detach that
        // one, too.
        if (fiber.tag === HostComponent) {
            var hostInstance = fiber.stateNode;
            if (hostInstance !== null) detachDeletedInstance(hostInstance);
        }
        fiber.stateNode = null; // I'm intentionally not clearing the `return` field in this level. We
        fiber._debugOwner = null;
        // Theoretically, nothing in here should be necessary, because we already
        // disconnected the fiber from the tree. So even if something leaks this
        // particular fiber, it won't leak anything else
        //
        // The purpose of this branch is to be super aggressive so we can measure
        // if there's any difference in memory impact. If there is, that could
        // indicate a React leak we don't know about.
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null; // TODO: Move to `commitPassiveUnmountInsideDeletedTreeOnFiber` instead.
        fiber.updateQueue = null;
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.flags & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.flags & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        switch(parentFiber.tag){
            case HostComponent:
                var parent = parentFiber.stateNode;
                if (parentFiber.flags & ContentReset) {
                    // Reset the text content of the parent before doing any insertions
                    resetTextContent(parent); // Clear ContentReset from the effect tag
                    parentFiber.flags &= ~ContentReset;
                }
                var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
                // children to find all the terminal nodes.
                insertOrAppendPlacementNode(finishedWork, before, parent);
                break;
            case HostRoot:
            case HostPortal:
                var _parent = parentFiber.stateNode.containerInfo;
                var _before = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, _before, _parent);
                break;
            // eslint-disable-next-line-no-fallthrough
            default:
                throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    } // These are tracked on the stack as we recursively traverse a
    // deleted subtree.
    // TODO: Update these during the whole mutation phase, not just during
    // a deletion.
    var hostParent = null;
    var hostParentIsContainer = false;
    function commitDeletionEffects(root, returnFiber, deletedFiber) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        // Recursively delete all host nodes from the parent, detach refs, clean
        // up mounted layout effects, and call componentWillUnmount.
        // We only need to remove the topmost host child in each branch. But then we
        // still need to keep traversing to unmount effects, refs, and cWU. TODO: We
        // could split this into two separate traversals functions, where the second
        // one doesn't include any removeChild logic. This is maybe the same
        // function as "disappearLayoutEffects" (or whatever that turns into after
        // the layout phase is refactored to use recursion).
        // Before starting, find the nearest host parent on the stack so we know
        // which instance/container to remove the children from.
        // TODO: Instead of searching up the fiber return path on every deletion, we
        // can track the nearest host component on the JS stack as we traverse the
        // tree during the commit phase. This would make insertions faster, too.
        var parent = returnFiber;
        findParent: while(parent !== null){
            switch(parent.tag){
                case HostComponent:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = false;
                    break findParent;
                case HostRoot:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
                case HostPortal:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
            }
            parent = parent.return;
        }
        if (hostParent === null) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
        hostParent = null;
        hostParentIsContainer = false;
        detachFiberMutation(deletedFiber);
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        // TODO: Use a static flag to skip trees that don't have unmount effects
        var child = parent.child;
        while(child !== null){
            commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, child);
            child = child.sibling;
        }
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        onCommitUnmount(deletedFiber); // The cases in this outer switch modify the stack before they traverse
        // into their subtree. There are simpler cases in the inner switch
        // that don't modify the stack.
        switch(deletedFiber.tag){
            case HostComponent:
                if (!offscreenSubtreeWasHidden) safelyDetachRef(deletedFiber, nearestMountedAncestor);
                 // Intentional fallthrough to next branch
            // eslint-disable-next-line-no-fallthrough
            case HostText:
                var prevHostParent = hostParent;
                var prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (hostParent !== null) {
                    // Now that all the child effects have unmounted, we can remove the
                    // node from the tree.
                    if (hostParentIsContainer) removeChildFromContainer(hostParent, deletedFiber.stateNode);
                    else removeChild(hostParent, deletedFiber.stateNode);
                }
                return;
            case DehydratedFragment:
                if (hostParent !== null) {
                    if (hostParentIsContainer) clearSuspenseBoundaryFromContainer(hostParent, deletedFiber.stateNode);
                    else clearSuspenseBoundary(hostParent, deletedFiber.stateNode);
                }
                return;
            case HostPortal:
                // When we go into a portal, it becomes the parent to remove from.
                var _prevHostParent = hostParent;
                var _prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = true;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = _prevHostParent;
                hostParentIsContainer = _prevHostParentIsContainer;
                return;
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    var updateQueue = deletedFiber.updateQueue;
                    if (updateQueue !== null) {
                        var lastEffect = updateQueue.lastEffect;
                        if (lastEffect !== null) {
                            var firstEffect = lastEffect.next;
                            var effect = firstEffect;
                            do {
                                var _effect = effect, destroy = _effect.destroy, tag = _effect.tag;
                                if (destroy !== undefined) {
                                    if ((tag & Insertion) !== NoFlags$1) safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                    else if ((tag & Layout) !== NoFlags$1) {
                                        markComponentLayoutEffectUnmountStarted(deletedFiber);
                                        if (deletedFiber.mode & ProfileMode) {
                                            startLayoutEffectTimer();
                                            safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                            recordLayoutEffectDuration(deletedFiber);
                                        } else safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                        markComponentLayoutEffectUnmountStopped();
                                    }
                                }
                                effect = effect.next;
                            }while (effect !== firstEffect);
                        }
                    }
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ClassComponent:
                if (!offscreenSubtreeWasHidden) {
                    safelyDetachRef(deletedFiber, nearestMountedAncestor);
                    var instance = deletedFiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, instance);
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ScopeComponent:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case OffscreenComponent:
                if (deletedFiber.mode & ConcurrentMode) {
                    // If this offscreen component is hidden, we already unmounted it. Before
                    // deleting the children, track that it's already unmounted so that we
                    // don't attempt to unmount the effects again.
                    // TODO: If the tree is hidden, in most cases we should be able to skip
                    // over the nested children entirely. An exception is we haven't yet found
                    // the topmost host node to delete, which we already track on the stack.
                    // But the other case is portals, which need to be detached no matter how
                    // deeply they are nested. We should use a subtree flag to track whether a
                    // subtree includes a nested portal.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || deletedFiber.memoizedState !== null;
                    recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
        }
    }
    function commitSuspenseCallback(finishedWork) {
        // TODO: Move this to passive phase
        var newState = finishedWork.memoizedState;
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of wakeables.
        // For each wakeable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            wakeables.forEach(function(wakeable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                if (!retryCache.has(wakeable)) {
                    retryCache.add(wakeable);
                    if (isDevToolsPresent) {
                        if (inProgressLanes !== null && inProgressRoot !== null) // If we have pending work still, associate the original updaters with it.
                        restorePendingUpdaters(inProgressRoot, inProgressLanes);
                        else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
                    }
                    wakeable.then(retry, retry);
                }
            });
        }
    } // This function detects when a Suspense boundary goes from visible to hidden.
    function commitMutationEffects(root, finishedWork, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        setCurrentFiber(finishedWork);
        commitMutationEffectsOnFiber(finishedWork, root);
        setCurrentFiber(finishedWork);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function recursivelyTraverseMutationEffects(root, parentFiber, lanes) {
        // Deletions effects can be scheduled on any fiber type. They need to happen
        // before the children effects hae fired.
        var deletions = parentFiber.deletions;
        if (deletions !== null) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            try {
                commitDeletionEffects(root, parentFiber, childToDelete);
            } catch (error) {
                captureCommitPhaseError(childToDelete, parentFiber, error);
            }
        }
        var prevDebugFiber = getCurrentFiber();
        if (parentFiber.subtreeFlags & MutationMask) {
            var child = parentFiber.child;
            while(child !== null){
                setCurrentFiber(child);
                commitMutationEffectsOnFiber(child, root);
                child = child.sibling;
            }
        }
        setCurrentFiber(prevDebugFiber);
    }
    function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags; // The effect flag should be checked *after* we refine the type of fiber,
        // because the fiber tag is more specific. An exception is any flag related
        // to reconcilation, because those can be set on all fiber types.
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    try {
                        commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return);
                        commitHookEffectListMount(Insertion | HasEffect, finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    } // Layout effects are destroyed during the mutation phase so that all
                    // destroy functions for all fibers are called before any create functions.
                    // This prevents sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) {
                        try {
                            startLayoutEffectTimer();
                            commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                        recordLayoutEffectDuration(finishedWork);
                    } else try {
                        commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case ClassComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                return;
            case HostComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                // TODO: ContentReset gets cleared by the children during the commit
                // phase. This is a refactor hazard because it means we must read
                // flags the flags after `commitReconciliationEffects` has already run;
                // the order matters. We should refactor so that ContentReset does not
                // rely on mutating the flag during commit. Like by setting a flag
                // during the render phase instead.
                if (finishedWork.flags & ContentReset) {
                    var instance = finishedWork.stateNode;
                    try {
                        resetTextContent(instance);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                if (flags & Update) {
                    var _instance4 = finishedWork.stateNode;
                    if (_instance4 != null) {
                        // Commit the work prepared earlier.
                        var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                        // as the newProps. The updatePayload will contain the real change in
                        // this case.
                        var oldProps = current !== null ? current.memoizedProps : newProps;
                        var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                        var updatePayload = finishedWork.updateQueue;
                        finishedWork.updateQueue = null;
                        if (updatePayload !== null) try {
                            commitUpdate(_instance4, updatePayload, type, oldProps, newProps, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostText:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (finishedWork.stateNode === null) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    var textInstance = finishedWork.stateNode;
                    var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldText = current !== null ? current.memoizedProps : newText;
                    try {
                        commitTextUpdate(textInstance, oldText, newText);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case HostRoot:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (current !== null) {
                        var prevRootState = current.memoizedState;
                        if (prevRootState.isDehydrated) try {
                            commitHydratedContainer(root.containerInfo);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostPortal:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
            case SuspenseComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                var offscreenFiber = finishedWork.child;
                if (offscreenFiber.flags & Visibility) {
                    var offscreenInstance = offscreenFiber.stateNode;
                    var newState = offscreenFiber.memoizedState;
                    var isHidden = newState !== null; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    offscreenInstance.isHidden = isHidden;
                    if (isHidden) {
                        var wasHidden = offscreenFiber.alternate !== null && offscreenFiber.alternate.memoizedState !== null;
                        if (!wasHidden) // TODO: Move to passive phase
                        markCommitTimeOfFallback();
                    }
                }
                if (flags & Update) {
                    try {
                        commitSuspenseCallback(finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                    attachSuspenseRetryListeners(finishedWork);
                }
                return;
            case OffscreenComponent:
                var _wasHidden = current !== null && current.memoizedState !== null;
                if (finishedWork.mode & ConcurrentMode) {
                    // Before committing the children, track on the stack whether this
                    // offscreen subtree was already hidden, so that we don't unmount the
                    // effects again.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _wasHidden;
                    recursivelyTraverseMutationEffects(root, finishedWork);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Visibility) {
                    var _offscreenInstance = finishedWork.stateNode;
                    var _newState = finishedWork.memoizedState;
                    var _isHidden = _newState !== null;
                    var offscreenBoundary = finishedWork; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    _offscreenInstance.isHidden = _isHidden;
                    if (_isHidden) {
                        if (!_wasHidden) {
                            if ((offscreenBoundary.mode & ConcurrentMode) !== NoMode) {
                                nextEffect = offscreenBoundary;
                                var offscreenChild = offscreenBoundary.child;
                                while(offscreenChild !== null){
                                    nextEffect = offscreenChild;
                                    disappearLayoutEffects_begin(offscreenChild);
                                    offscreenChild = offscreenChild.sibling;
                                }
                            }
                        }
                    }
                    // TODO: This needs to run whenever there's an insertion or update
                    // inside a hidden Offscreen tree.
                    hideOrUnhideAllChildren(offscreenBoundary, _isHidden);
                }
                return;
            case SuspenseListComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) attachSuspenseRetryListeners(finishedWork);
                return;
            case ScopeComponent:
                return;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
        }
    }
    function commitReconciliationEffects(finishedWork) {
        // Placement effects (insertions, reorders) can be scheduled on any fiber
        // type. They needs to happen after the children effects have fired, but
        // before the effects on this fiber have fired.
        var flags = finishedWork.flags;
        if (flags & Placement) {
            try {
                commitPlacement(finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            } // Clear the "placement" from effect tag so that we know that this is
            // inserted, before any life-cycles like componentDidMount gets called.
            // TODO: findDOMNode doesn't rely on this any more but isMounted does
            // and isMounted is deprecated anyway so we should be able to kill this.
            finishedWork.flags &= ~Placement;
        }
        if (flags & Hydrating) finishedWork.flags &= ~Hydrating;
    }
    function commitLayoutEffects(finishedWork, root, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        nextEffect = finishedWork;
        commitLayoutEffects_begin(finishedWork, root, committedLanes);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function commitLayoutEffects_begin(subtreeRoot, root, committedLanes) {
        // Suspense layout effects semantics don't change for legacy roots.
        var isModernRoot = (subtreeRoot.mode & ConcurrentMode) !== NoMode;
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent && isModernRoot) {
                // Keep track of the current Offscreen stack's state.
                var isHidden = fiber.memoizedState !== null;
                var newOffscreenSubtreeIsHidden = isHidden || offscreenSubtreeIsHidden;
                if (newOffscreenSubtreeIsHidden) {
                    // The Offscreen tree is hidden. Skip over its layout effects.
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                } else {
                    // TODO (Offscreen) Also check: subtreeFlags & LayoutMask
                    var current = fiber.alternate;
                    var wasHidden = current !== null && current.memoizedState !== null;
                    var newOffscreenSubtreeWasHidden = wasHidden || offscreenSubtreeWasHidden;
                    var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden;
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden; // Traverse the Offscreen subtree with the current Offscreen as the root.
                    offscreenSubtreeIsHidden = newOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden;
                    if (offscreenSubtreeWasHidden && !prevOffscreenSubtreeWasHidden) {
                        // This is the root of a reappearing boundary. Turn its layout effects
                        // back on.
                        nextEffect = fiber;
                        reappearLayoutEffects_begin(fiber);
                    }
                    var child = firstChild;
                    while(child !== null){
                        nextEffect = child;
                        commitLayoutEffects_begin(child, root, committedLanes);
                        child = child.sibling;
                    } // Restore Offscreen state and resume in our-progress traversal.
                    nextEffect = fiber;
                    offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                }
            }
            if ((fiber.subtreeFlags & LayoutMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
        }
    }
    function commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & LayoutMask) !== NoFlags) {
                var current = fiber.alternate;
                setCurrentFiber(fiber);
                try {
                    commitLayoutEffectOnFiber(root, current, fiber, committedLanes);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function disappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child; // TODO (Offscreen) Check: flags & (RefStatic | LayoutStatic)
            switch(fiber.tag){
                case FunctionComponent:
                case ForwardRef:
                case MemoComponent:
                case SimpleMemoComponent:
                    if (fiber.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    } finally{
                        recordLayoutEffectDuration(fiber);
                    }
                    else commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    break;
                case ClassComponent:
                    // TODO (Offscreen) Check: flags & RefStatic
                    safelyDetachRef(fiber, fiber.return);
                    var instance = fiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                    break;
                case HostComponent:
                    safelyDetachRef(fiber, fiber.return);
                    break;
                case OffscreenComponent:
                    // Check if this is a
                    var isHidden = fiber.memoizedState !== null;
                    if (isHidden) {
                        // Nested Offscreen tree is already hidden. Don't disappear
                        // its effects.
                        disappearLayoutEffects_complete(subtreeRoot);
                        continue;
                    }
                    break;
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else disappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function disappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function reappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent) {
                var isHidden = fiber.memoizedState !== null;
                if (isHidden) {
                    // Nested Offscreen tree is still hidden. Don't re-appear its effects.
                    reappearLayoutEffects_complete(subtreeRoot);
                    continue;
                }
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else reappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function reappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect; // TODO (Offscreen) Check: flags & LayoutStatic
            setCurrentFiber(fiber);
            try {
                reappearLayoutEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountEffects(root, finishedWork, committedLanes, committedTransitions) {
        nextEffect = finishedWork;
        commitPassiveMountEffects_begin(finishedWork, root, committedLanes, committedTransitions);
    }
    function commitPassiveMountEffects_begin(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions);
        }
    }
    function commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                try {
                    commitPassiveMountOnFiber(root, fiber, committedLanes, committedTransitions);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    try {
                        commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                    } finally{
                        recordPassiveEffectDuration(finishedWork);
                    }
                } else commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
        }
    }
    function commitPassiveUnmountEffects(firstChild) {
        nextEffect = firstChild;
        commitPassiveUnmountEffects_begin();
    }
    function commitPassiveUnmountEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var child = fiber.child;
            if ((nextEffect.flags & ChildDeletion) !== NoFlags) {
                var deletions = fiber.deletions;
                if (deletions !== null) {
                    for(var i = 0; i < deletions.length; i++){
                        var fiberToDelete = deletions[i];
                        nextEffect = fiberToDelete;
                        commitPassiveUnmountEffectsInsideOfDeletedTree_begin(fiberToDelete, fiber);
                    }
                    // A fiber was deleted from this parent fiber, but it's still part of
                    // the previous (alternate) parent fiber's list of children. Because
                    // children are a linked list, an earlier sibling that's still alive
                    // will be connected to the deleted fiber via its `alternate`:
                    //
                    //   live fiber
                    //   --alternate--> previous live fiber
                    //   --sibling--> deleted fiber
                    //
                    // We can't disconnect `alternate` on nodes that haven't been deleted
                    // yet, but we can disconnect the `sibling` and `child` pointers.
                    var previousFiber = fiber.alternate;
                    if (previousFiber !== null) {
                        var detachedChild = previousFiber.child;
                        if (detachedChild !== null) {
                            previousFiber.child = null;
                            do {
                                var detachedSibling = detachedChild.sibling;
                                detachedChild.sibling = null;
                                detachedChild = detachedSibling;
                            }while (detachedChild !== null);
                        }
                    }
                    nextEffect = fiber;
                }
            }
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffects_complete();
        }
    }
    function commitPassiveUnmountEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                commitPassiveUnmountOnFiber(fiber);
                resetCurrentFiber();
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                    recordPassiveEffectDuration(finishedWork);
                } else commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                break;
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        while(nextEffect !== null){
            var fiber = nextEffect; // Deletion effects fire in parent -> child order
            // TODO: Check if fiber has a PassiveStatic flag
            setCurrentFiber(fiber);
            commitPassiveUnmountInsideDeletedTreeOnFiber(fiber, nearestMountedAncestor);
            resetCurrentFiber();
            var child = fiber.child; // TODO: Only traverse subtree if it has a PassiveStatic flag. (But, if we
            // do this, still need to handle `deletedTreeCleanUpLevel` correctly.)
            if (child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot);
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var sibling = fiber.sibling;
            var returnFiber = fiber.return;
            // Recursively traverse the entire deleted tree and clean up fiber fields.
            // This is more aggressive than ideal, and the long term goal is to only
            // have to detach the deleted tree at the root.
            detachFiberAfterEffects(fiber);
            if (fiber === deletedSubtreeRoot) {
                nextEffect = null;
                return;
            }
            if (sibling !== null) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                return;
            }
            nextEffect = returnFiber;
        }
    }
    function commitPassiveUnmountInsideDeletedTreeOnFiber(current, nearestMountedAncestor) {
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (current.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                    recordPassiveEffectDuration(current);
                } else commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                break;
        }
    } // TODO: Reuse reappearLayoutEffects traversal here?
    function invokeLayoutEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Layout | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                try {
                    instance.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokePassiveEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Passive$1 | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokeLayoutEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Layout | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                break;
        }
    }
    function invokePassiveEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Passive$1 | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
        }
    }
    var COMPONENT_TYPE = 0;
    var HAS_PSEUDO_CLASS_TYPE = 1;
    var ROLE_TYPE = 2;
    var TEST_NAME_TYPE = 3;
    var TEXT_TYPE = 4;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        COMPONENT_TYPE = symbolFor("selector.component");
        HAS_PSEUDO_CLASS_TYPE = symbolFor("selector.has_pseudo_class");
        ROLE_TYPE = symbolFor("selector.role");
        TEST_NAME_TYPE = symbolFor("selector.test_id");
        TEXT_TYPE = symbolFor("selector.text");
    }
    var commitHooks = [];
    function onCommitRoot$1() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    var ReactCurrentActQueue = ReactSharedInternals.ReactCurrentActQueue;
    function isLegacyActEnvironment(fiber) {
        // Legacy mode. We preserve the behavior of React 17's act. It assumes an
        // act environment whenever `jest` is defined, but you can still turn off
        // spurious warnings by setting IS_REACT_ACT_ENVIRONMENT explicitly
        // to false.
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined; // $FlowExpectedError - Flow doesn't know about jest
        var jestIsDefined = typeof jest !== "undefined";
        return jestIsDefined && isReactActEnvironmentGlobal !== false;
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined;
        if (!isReactActEnvironmentGlobal && ReactCurrentActQueue.current !== null) // TODO: Include link to relevant documentation page.
        error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, ReactCurrentBatchConfig$3 = ReactSharedInternals.ReactCurrentBatchConfig, ReactCurrentActQueue$1 = ReactSharedInternals.ReactCurrentActQueue;
    var NoContext = /*             */ 0;
    var BatchedContext = /*               */ 1;
    var RenderContext = /*                */ 2;
    var CommitContext = /*                */ 4;
    var RootInProgress = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5;
    var RootDidNotComplete = 6; // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The lanes we're rendering
    var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
    // This is a superset of the lanes we started working on at the root. The only
    // case where it's different from `workInProgressRootRenderLanes` is when we
    // enter a subtree that is hidden and needs to be unhidden: Suspense and
    // Offscreen component.
    //
    // Most things in the work loop should deal with workInProgressRootRenderLanes.
    // Most things in begin/complete phases should deal with subtreeRenderLanes.
    var subtreeRenderLanes = NoLanes;
    var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootInProgress; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
    // slightly different than `renderLanes` because `renderLanes` can change as you
    // enter and exit an Offscreen tree. This value is the combination of all render
    // lanes for the entire render phase.
    var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.
    var workInProgressRootInterleavedUpdatedLanes = NoLanes; // Lanes that were updated during the render phase (*not* an interleaved event).
    var workInProgressRootPingedLanes = NoLanes; // Errors that are thrown during the render phase.
    var workInProgressRootConcurrentErrors = null; // These are errors that we recovered from without surfacing them to the UI.
    // We will log them once the tree commits.
    var workInProgressRootRecoverableErrors = null; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
    // more and prefer CPU suspense heuristics instead.
    var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
    // suspense heuristics and opt out of rendering more content.
    var RENDER_TIMEOUT_MS = 500;
    var workInProgressTransitions = null;
    function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
    }
    function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
    }
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null; // Only used when enableProfilerNestedUpdateScheduledHook is true;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsLanes = NoLanes;
    var pendingPassiveProfilerEffects = [];
    var pendingPassiveTransitions = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var isFlushingPassiveEffects = false;
    var didScheduleUpdateDuringPassiveEffects = false;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0;
    var rootWithPassiveNestedUpdates = null; // If two updates are scheduled within the same event, we should treat their
    // event times as simultaneous, even if the actual clock time has advanced
    // between the first and second call.
    var currentEventTime = NoTimestamp;
    var currentEventTransitionLane = NoLanes;
    var isRunningInsertionEffect = false;
    function getWorkInProgressRoot() {
        return workInProgressRoot;
    }
    function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return now();
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoTimestamp) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = now();
        return currentEventTime;
    }
    function requestUpdateLane(fiber) {
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        else if ((executionContext & RenderContext) !== NoContext && workInProgressRootRenderLanes !== NoLanes) // This is a render phase update. These are not officially supported. The
        // old behavior is to give this the same "thread" (lanes) as
        // whatever is currently rendering. So if you call `setState` on a component
        // that happens later in the same render, it will flush. Ideally, we want to
        // remove the special case and treat them as if they came from an
        // interleaved event. Regardless, this pattern is not officially supported.
        // This behavior is only a fallback. The flag only exists until we can roll
        // out the setState warning, since existing code might accidentally rely on
        // the current behavior.
        return pickArbitraryLane(workInProgressRootRenderLanes);
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
            if (ReactCurrentBatchConfig$3.transition !== null) {
                var transition = ReactCurrentBatchConfig$3.transition;
                if (!transition._updatedFibers) transition._updatedFibers = new Set();
                transition._updatedFibers.add(fiber);
            } // The algorithm for assigning an update to a lane should be stable for all
            // updates at the same priority within the same event. To do this, the
            // inputs to the algorithm must be the same.
            //
            // The trick we use is to cache the first of each of these inputs within an
            // event. Then reset the cached values once we can be sure the event is
            // over. Our heuristic for that is whenever we enter a concurrent work loop.
            if (currentEventTransitionLane === NoLane) // All transitions within the same event are assigned the same lane.
            currentEventTransitionLane = claimNextTransitionLane();
            return currentEventTransitionLane;
        } // Updates originating inside certain React methods, like flushSync, have
        // their priority set by tracking it with a context variable.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var updateLane = getCurrentUpdatePriority();
        if (updateLane !== NoLane) return updateLane;
         // This update originated outside React. Ask the host environment for an
        // appropriate priority, based on the type of event.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var eventLane = getCurrentEventPriority();
        return eventLane;
    }
    function requestRetryLane(fiber) {
        // This is a fork of `requestUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        return claimNextRetryLane();
    }
    function scheduleUpdateOnFiber(root, fiber, lane, eventTime) {
        checkForNestedUpdates();
        if (isRunningInsertionEffect) error("useInsertionEffect must not schedule updates.");
        if (isFlushingPassiveEffects) didScheduleUpdateDuringPassiveEffects = true;
        markRootUpdated(root, lane, eventTime);
        if ((executionContext & RenderContext) !== NoLanes && root === workInProgressRoot) // This update was dispatched during the render phase. This is a mistake
        // if the update originates from user space (with the exception of local
        // hook updates, which are handled differently and don't reach this
        // function), but there are some internal React features that use this as
        // an implementation detail, like selective hydration.
        warnAboutRenderPhaseUpdatesInDEV(fiber); // Track lanes that were updated during the render phase
        else {
            if (isDevToolsPresent) addFiberToLanesMap(root, fiber, lane);
            warnIfUpdatesNotWrappedWithActDEV(fiber);
            if (root === workInProgressRoot) {
                // Received an update to a tree that's in the middle of rendering. Mark
                // that there was an interleaved update work on this root. Unless the
                // `deferRenderPhaseUpdateToNextBatch` flag is off and this is a render
                // phase update. In that case, we don't treat render phase updates as if
                // they were interleaved, for backwards compat reasons.
                if ((executionContext & RenderContext) === NoContext) workInProgressRootInterleavedUpdatedLanes = mergeLanes(workInProgressRootInterleavedUpdatedLanes, lane);
                if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
                // definitely won't finish. Since we have a new update, let's mark it as
                // suspended now, right before marking the incoming update. This has the
                // effect of interrupting the current render and switching to the update.
                // TODO: Make sure this doesn't override pings that happen while we've
                // already started rendering.
                markRootSuspended$1(root, workInProgressRootRenderLanes);
            }
            ensureRootIsScheduled(root, eventTime);
            if (lane === SyncLane && executionContext === NoContext && (fiber.mode & ConcurrentMode) === NoMode && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                // Flush the synchronous work now, unless we're already working or inside
                // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                // scheduleCallbackForFiber to preserve the ability to schedule a callback
                // without immediately flushing it. We only do this for user-initiated
                // updates, to preserve historical behavior of legacy mode.
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function scheduleInitialHydrationOnRoot(root, lane, eventTime) {
        // This is a special fork of scheduleUpdateOnFiber that is only used to
        // schedule the initial hydration of a root that has just been created. Most
        // of the stuff in scheduleUpdateOnFiber can be skipped.
        //
        // The main reason for this separate path, though, is to distinguish the
        // initial children from subsequent updates. In fully client-rendered roots
        // (createRoot instead of hydrateRoot), all top-level renders are modeled as
        // updates, but hydration roots are special because the initial render must
        // match what was rendered on the server.
        var current = root.current;
        current.lanes = lane;
        markRootUpdated(root, lane, eventTime);
        ensureRootIsScheduled(root, eventTime);
    }
    function isUnsafeClassRenderPhaseUpdate(fiber) {
        // Check if this is a render phase update. Only called by class components,
        // which special (deprecated) behavior for UNSAFE_componentWillReceive props.
        return(// decided not to enable it.
        (executionContext & RenderContext) !== NoContext);
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the priority
    // of the existing task is the same as the priority of the next level that the
    // root has work on. This function is called on every update, and right before
    // exiting a task.
    function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
        // expired so we know to work on those next.
        markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) cancelCallback$1(existingCallbackNode);
            root.callbackNode = null;
            root.callbackPriority = NoLane;
            return;
        } // We use the highest priority lane to represent the priority of the callback.
        var newCallbackPriority = getHighestPriorityLane(nextLanes); // Check if there's an existing task. We may be able to reuse it.
        var existingCallbackPriority = root.callbackPriority;
        if (existingCallbackPriority === newCallbackPriority && // Special case related to `act`. If the currently scheduled task is a
        // Scheduler task, rather than an `act` task, cancel it and re-scheduled
        // on the `act` queue.
        !(ReactCurrentActQueue$1.current !== null && existingCallbackNode !== fakeActCallbackNode)) {
            // If we're going to re-use an existing task, it needs to exist.
            // Assume that discrete update microtasks are non-cancellable and null.
            // TODO: Temporary until we confirm this warning is not fired.
            if (existingCallbackNode == null && existingCallbackPriority !== SyncLane) error("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
            return;
        }
        if (existingCallbackNode != null) // Cancel the existing callback. We'll schedule a new one below.
        cancelCallback$1(existingCallbackNode);
         // Schedule a new callback.
        var newCallbackNode;
        if (newCallbackPriority === SyncLane) {
            // Special case: Sync React callbacks are scheduled on a special
            // internal queue
            if (root.tag === LegacyRoot) {
                if (ReactCurrentActQueue$1.isBatchingLegacy !== null) ReactCurrentActQueue$1.didScheduleLegacyUpdate = true;
                scheduleLegacySyncCallback(performSyncWorkOnRoot.bind(null, root));
            } else scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
            // Flush the queue in a microtask.
            if (ReactCurrentActQueue$1.current !== null) // Inside `act`, use our internal `act` queue so that these get flushed
            // at the end of the current scope even when using the sync version
            // of `act`.
            ReactCurrentActQueue$1.current.push(flushSyncCallbacks);
            else scheduleMicrotask(function() {
                // In Safari, appending an iframe forces microtasks to run.
                // https://github.com/facebook/react/issues/22459
                // We don't support running callbacks in the middle of render
                // or commit so we need to check against that.
                if ((executionContext & (RenderContext | CommitContext)) === NoContext) // Note that this would still prematurely flush the callbacks
                // if this happens outside render or commit phase (e.g. in an event).
                flushSyncCallbacks();
            });
            newCallbackNode = null;
        } else {
            var schedulerPriorityLevel;
            switch(lanesToEventPriority(nextLanes)){
                case DiscreteEventPriority:
                    schedulerPriorityLevel = ImmediatePriority;
                    break;
                case ContinuousEventPriority:
                    schedulerPriorityLevel = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    schedulerPriorityLevel = NormalPriority;
                    break;
                case IdleEventPriority:
                    schedulerPriorityLevel = IdlePriority;
                    break;
                default:
                    schedulerPriorityLevel = NormalPriority;
                    break;
            }
            newCallbackNode = scheduleCallback$1(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }
        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root, didTimeout) {
        resetNestedUpdateFlag();
        // event time. The next update will compute a new event time.
        currentEventTime = NoTimestamp;
        currentEventTransitionLane = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
         // Flush any pending passive effects before deciding which lanes to work on,
        // in case they schedule additional work.
        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) // The current task was canceled. Exit. We don't need to call
            // `ensureRootIsScheduled` because the check above implies either that
            // there's a new task, or that there's no remaining work on this root.
            return null;
        } // Determine the next lanes to work on, using the fields stored
        // on the root.
        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) // Defensive coding. This is never expected to happen.
        return null;
         // We disable time-slicing in some cases: if the work has been CPU-bound
        // for too long ("expired" work, to prevent starvation), or we're in
        // sync-updates-by-default mode.
        // TODO: We only check `didTimeout` defensively, to account for a Scheduler
        // bug we're still investigating. Once the bug in Scheduler is fixed,
        // we can remove this, since we track expiration ourselves.
        var shouldTimeSlice = !includesBlockingLane(root, lanes) && !includesExpiredLane(root, lanes) && !didTimeout;
        var exitStatus = shouldTimeSlice ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes);
        if (exitStatus !== RootInProgress) {
            if (exitStatus === RootErrored) {
                // If something threw an error, try rendering one more time. We'll
                // render synchronously to block concurrent data mutations, and we'll
                // includes all pending updates are included. If it still fails after
                // the second attempt, we'll give up and commit the resulting tree.
                var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                if (errorRetryLanes !== NoLanes) {
                    lanes = errorRetryLanes;
                    exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
                }
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            }
            if (exitStatus === RootDidNotComplete) // The render unwound without completing the tree. This happens in special
            // cases where need to exit the current render without producing a
            // consistent tree or committing.
            //
            // This should only happen during a concurrent render, not a discrete or
            // synchronous update. We should have already checked for this when we
            // unwound the stack.
            markRootSuspended$1(root, lanes);
            else {
                // The render completed.
                // Check if this render may have yielded to a concurrent event, and if so,
                // confirm that any newly rendered stores are consistent.
                // TODO: It's possible that even a concurrent render may never have yielded
                // to the main thread, if it was fast enough, or if it expired. We could
                // skip the consistency check in that case, too.
                var renderWasConcurrent = !includesBlockingLane(root, lanes);
                var finishedWork = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(finishedWork)) {
                    // A store was mutated in an interleaved event. Render again,
                    // synchronously, to block further mutations.
                    exitStatus = renderRootSync(root, lanes); // We need to check again if something threw
                    if (exitStatus === RootErrored) {
                        var _errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                        if (_errorRetryLanes !== NoLanes) {
                            lanes = _errorRetryLanes;
                            exitStatus = recoverFromConcurrentError(root, _errorRetryLanes); // We assume the tree is now consistent because we didn't yield to any
                        // concurrent events.
                        }
                    }
                    if (exitStatus === RootFatalErrored) {
                        var _fatalError = workInProgressRootFatalError;
                        prepareFreshStack(root, NoLanes);
                        markRootSuspended$1(root, lanes);
                        ensureRootIsScheduled(root, now());
                        throw _fatalError;
                    }
                } // We now have a consistent tree. The next step is either to commit it,
                // or, if something suspended, wait to commit it after a timeout.
                root.finishedWork = finishedWork;
                root.finishedLanes = lanes;
                finishConcurrentRender(root, exitStatus, lanes);
            }
        }
        ensureRootIsScheduled(root, now());
        if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
        // currently executed. Need to return a continuation.
        return performConcurrentWorkOnRoot.bind(null, root);
        return null;
    }
    function recoverFromConcurrentError(root, errorRetryLanes) {
        // If an error occurred during hydration, discard server response and fall
        // back to client side render.
        // Before rendering again, save the errors from the previous attempt.
        var errorsFromFirstAttempt = workInProgressRootConcurrentErrors;
        if (isRootDehydrated(root)) {
            // The shell failed to hydrate. Set a flag to force a client rendering
            // during the next attempt. To do this, we call prepareFreshStack now
            // to create the root work-in-progress fiber. This is a bit weird in terms
            // of factoring, because it relies on renderRootSync not calling
            // prepareFreshStack again in the call below, which happens because the
            // root and lanes haven't changed.
            //
            // TODO: I think what we should do is set ForceClientRender inside
            // throwException, like we do for nested Suspense boundaries. The reason
            // it's here instead is so we can switch to the synchronous work loop, too.
            // Something to consider for a future refactor.
            var rootWorkInProgress = prepareFreshStack(root, errorRetryLanes);
            rootWorkInProgress.flags |= ForceClientRender;
            errorHydratingContainer(root.containerInfo);
        }
        var exitStatus = renderRootSync(root, errorRetryLanes);
        if (exitStatus !== RootErrored) {
            // Successfully finished rendering on retry
            // The errors from the failed first attempt have been recovered. Add
            // them to the collection of recoverable errors. We'll log them in the
            // commit phase.
            var errorsFromSecondAttempt = workInProgressRootRecoverableErrors;
            workInProgressRootRecoverableErrors = errorsFromFirstAttempt; // The errors from the second attempt should be queued after the errors
            // from the first attempt, to preserve the causal sequence.
            if (errorsFromSecondAttempt !== null) queueRecoverableErrors(errorsFromSecondAttempt);
        }
        return exitStatus;
    }
    function queueRecoverableErrors(errors) {
        if (workInProgressRootRecoverableErrors === null) workInProgressRootRecoverableErrors = errors;
        else workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
    }
    function finishConcurrentRender(root, exitStatus, lanes) {
        switch(exitStatus){
            case RootInProgress:
            case RootFatalErrored:
                throw new Error("Root did not complete. This is a bug in React.");
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspended:
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                    // This render only included retries, no updates. Throttle committing
                    // retries so that we don't show too many loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        var nextLanes = getNextLanes(root, NoLanes);
                        if (nextLanes !== NoLanes) break;
                        var suspendedLanes = root.suspendedLanes;
                        if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            // FIXME: What if the suspended lanes are Idle? Should not restart.
                            var eventTime = requestEventTime();
                            markRootPinged(root, suspendedLanes);
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspendedWithDelay:
                markRootSuspended$1(root, lanes);
                if (includesOnlyTransitions(lanes)) break;
                if (!shouldForceFlushFallbacksInDEV()) {
                    // This is not a transition, but we did trigger an avoided state.
                    // Schedule a placeholder to display after a short delay, using the Just
                    // Noticeable Difference.
                    // TODO: Is the JND optimization worth the added complexity? If this is
                    // the only reason we track the event time, then probably not.
                    // Consider removing.
                    var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                    var eventTimeMs = mostRecentEventTime;
                    var timeElapsedMs = now() - eventTimeMs;
                    var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // Instead of committing the fallback immediately, wait for more data
                        // to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), _msUntilTimeout);
                        break;
                    }
                } // Commit the placeholder.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            default:
                throw new Error("Unknown root exit status.");
        }
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        // Search the rendered tree for external store reads, and check whether the
        // stores were mutated in a concurrent event. Intentionally using an iterative
        // loop instead of recursion so we can exit early.
        var node = finishedWork;
        while(true){
            if (node.flags & StoreConsistency) {
                var updateQueue = node.updateQueue;
                if (updateQueue !== null) {
                    var checks = updateQueue.stores;
                    if (checks !== null) for(var i = 0; i < checks.length; i++){
                        var check = checks[i];
                        var getSnapshot = check.getSnapshot;
                        var renderedValue = check.value;
                        try {
                            if (!objectIs(getSnapshot(), renderedValue)) // Found an inconsistent store.
                            return false;
                        } catch (error) {
                            // If `getSnapshot` throws, return `false`. This will schedule
                            // a re-render, and the error will be rethrown during render.
                            return false;
                        }
                    }
                }
            }
            var child = node.child;
            if (node.subtreeFlags & StoreConsistency && child !== null) {
                child.return = node;
                node = child;
                continue;
            }
            if (node === finishedWork) return true;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return true;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow doesn't know this is unreachable, but eslint does
        // eslint-disable-next-line no-unreachable
        return true;
    }
    function markRootSuspended$1(root, suspendedLanes) {
        // When suspending, we should always exclude lanes that were pinged or (more
        // rarely, since we try to avoid it) updated during the render phase.
        // TODO: Lol maybe there's a better way to factor this besides this
        // obnoxiously named function :)
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootInterleavedUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        syncNestedUpdateFlag();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        flushPassiveEffects();
        var lanes = getNextLanes(root, NoLanes);
        if (!includesSomeLane(lanes, SyncLane)) {
            // There's no remaining sync work left.
            ensureRootIsScheduled(root, now());
            return null;
        }
        var exitStatus = renderRootSync(root, lanes);
        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.
            var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
            if (errorRetryLanes !== NoLanes) {
                lanes = errorRetryLanes;
                exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
            }
        }
        if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
        }
        if (exitStatus === RootDidNotComplete) throw new Error("Root did not complete. This is a bug in React.");
         // We now have a consistent tree. Because this is a sync render, we
        // will commit it even if something suspended.
        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions); // Before exiting, make sure there's a callback scheduled for the next
        // pending level.
        ensureRootIsScheduled(root, now());
        return null;
    }
    function flushRoot(root, lanes) {
        if (lanes !== NoLanes) {
            markRootEntangled(root, mergeLanes(lanes, SyncLane));
            ensureRootIsScheduled(root, now());
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
                resetRenderTimer();
                flushSyncCallbacks();
            }
        }
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext; // If there were legacy sync updates, flush them at the end of the outer
            // most batchedUpdates-like method.
            if (executionContext === NoContext && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function discreteUpdates(fn, a, b, c, d) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            return fn(a, b, c, d);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            if (executionContext === NoContext) resetRenderTimer();
        }
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync(fn) {
        // In legacy mode, we flush pending passive effects at the beginning of the
        // next event, not at the end of the previous one.
        if (rootWithPendingPassiveEffects !== null && rootWithPendingPassiveEffects.tag === LegacyRoot && (executionContext & (RenderContext | CommitContext)) === NoContext) flushPassiveEffects();
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        var previousPriority = getCurrentUpdatePriority();
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            if (fn) return fn();
            else return undefined;
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) flushSyncCallbacks();
        }
    }
    function isAlreadyRendering() {
        // Used by the renderer to print a warning if certain APIs are called from
        // the wrong context.
        return (executionContext & (RenderContext | CommitContext)) !== NoContext;
    }
    function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
    }
    function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                var current = interruptedWork.alternate;
                unwindInterruptedWork(current, interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        var rootWorkInProgress = createWorkInProgress(root.current, null);
        workInProgress = rootWorkInProgress;
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootInterleavedUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        workInProgressRootConcurrentErrors = null;
        workInProgressRootRecoverableErrors = null;
        finishQueueingConcurrentUpdates();
        ReactStrictModeWarnings.discardPendingWarnings();
        return rootWorkInProgress;
    }
    function handleError(root, thrownValue) {
        do {
            var erroredWork = workInProgress;
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
                // separate issue. Write a regression test using string refs.
                ReactCurrentOwner$2.current = null;
                if (erroredWork === null || erroredWork.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // intentionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return;
                }
                if (enableProfilerTimer && erroredWork.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                if (enableSchedulingProfiler) {
                    markComponentRenderStopped();
                    if (thrownValue !== null && typeof thrownValue === "object" && typeof thrownValue.then === "function") {
                        var wakeable = thrownValue;
                        markComponentSuspended(erroredWork, wakeable, workInProgressRootRenderLanes);
                    } else markComponentErrored(erroredWork, thrownValue, workInProgressRootRenderLanes);
                }
                throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                if (workInProgress === erroredWork && erroredWork !== null) {
                    // If this boundary has already errored, then we had trouble processing
                    // the error. Bubble it to the next boundary.
                    erroredWork = erroredWork.return;
                    workInProgress = erroredWork;
                } else erroredWork = workInProgress;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootInProgress || workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootErrored) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there are updates that we skipped tree that might have unblocked
        // this render.
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootInterleavedUpdatedLanes))) // Mark the current render as suspended so that we switch to working on
        // the updates that were skipped. Usually we only suspend at the end of
        // the render phase.
        // TODO: We should probably always mark the root as suspended immediately
        // (inside this function), since by suspending at the end of the render
        // phase introduces a potential mistake where we suspend lanes that were
        // pinged or updated while we were rendering.
        markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
    }
    function renderDidError(error) {
        if (workInProgressRootExitStatus !== RootSuspendedWithDelay) workInProgressRootExitStatus = RootErrored;
        if (workInProgressRootConcurrentErrors === null) workInProgressRootConcurrentErrors = [
            error
        ];
        else workInProgressRootConcurrentErrors.push(error);
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootInProgress;
    }
    function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopSync();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) // This is a sync render, so we should have finished the whole tree.
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        markRenderStopped();
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            resetRenderTimer();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopConcurrent();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) {
            markRenderYielded();
            return RootInProgress;
        } else {
            markRenderStopped();
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.
            return workInProgressRootExitStatus;
        }
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        completeUnitOfWork(unitOfWork);
        else workInProgress = next;
        ReactCurrentOwner$2.current = null;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        var completedWork = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.
            if ((completedWork.flags & Incomplete) === NoFlags) {
                setCurrentFiber(completedWork);
                var next = void 0;
                if ((completedWork.mode & ProfileMode) === NoMode) next = completeWork(current, completedWork, subtreeRenderLanes);
                else {
                    startProfilerTimer(completedWork);
                    next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                }
                resetCurrentFiber();
                if (next !== null) {
                    // Completing this fiber spawned new work. Work on that next.
                    workInProgress = next;
                    return;
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(current, completedWork); // Because this fiber did not complete, don't reset its lanes.
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    _next.flags &= HostEffectMask;
                    workInProgress = _next;
                    return;
                }
                if ((completedWork.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = completedWork.actualDuration;
                    var child = completedWork.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    completedWork.actualDuration = actualDuration;
                }
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its subtree flags.
                    returnFiber.flags |= Incomplete;
                    returnFiber.subtreeFlags = NoFlags;
                    returnFiber.deletions = null;
                } else {
                    // We've unwound all the way to the root.
                    workInProgressRootExitStatus = RootDidNotComplete;
                    workInProgress = null;
                    return;
                }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                workInProgress = siblingFiber;
                return;
            } // Otherwise, return to the parent
            completedWork = returnFiber; // Update the next thing we're working on in case something throws.
            workInProgress = completedWork;
        }while (completedWork !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootCompleted;
    }
    function commitRoot(root, recoverableErrors, transitions) {
        // TODO: This no longer makes any sense. We already wrap the mutation and
        // layout phases. Should be able to remove.
        var previousUpdateLanePriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            commitRootImpl(root, recoverableErrors, transitions, previousUpdateLanePriority);
        } finally{
            ReactCurrentBatchConfig$3.transition = prevTransition;
            setCurrentUpdatePriority(previousUpdateLanePriority);
        }
        return null;
    }
    function commitRootImpl(root, recoverableErrors, transitions, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        markCommitStarted(lanes);
        if (finishedWork === null) {
            markCommitStopped();
            return null;
        } else if (lanes === NoLanes) error("root.finishedLanes should not be empty during a commit. This is a bug in React.");
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        if (finishedWork === root.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null;
        root.callbackPriority = NoLane; // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes);
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
        } // If there are pending passive effects, schedule a callback to process them.
        // Do this as early as possible, so it is queued before anything else that
        // might get scheduled in the commit phase. (See #16714.)
        // TODO: Delete all other places that schedule the passive effect callback
        // They're redundant.
        if ((finishedWork.subtreeFlags & PassiveMask) !== NoFlags || (finishedWork.flags & PassiveMask) !== NoFlags) {
            if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                // to store it in pendingPassiveTransitions until they get processed
                // We need to pass this through as an argument to commitRoot
                // because workInProgressTransitions might have changed between
                // the previous render and commit if we throttle the commit
                // with setTimeout
                pendingPassiveTransitions = transitions;
                scheduleCallback$1(NormalPriority, function() {
                    flushPassiveEffects(); // This render triggered passive effects: release the root cache pool
                    // *after* passive effects fire to avoid freeing a cache pool that may
                    // be referenced by a node in the tree (HostRoot, Cache boundary etc)
                    return null;
                });
            }
        } // Check if there are any effects in the whole tree.
        // TODO: This is left over from the effect list implementation, where we had
        // to check for the existence of `firstEffect` to satisfy Flow. I think the
        // only other reason this optimization exists is because it affects profiling.
        // Reconsider whether this is necessary.
        var subtreeHasEffects = (finishedWork.subtreeFlags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        var rootHasEffect = (finishedWork.flags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        if (subtreeHasEffects || rootHasEffect) {
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            ReactCurrentBatchConfig$3.transition = null;
            var previousPriority = getCurrentUpdatePriority();
            setCurrentUpdatePriority(DiscreteEventPriority);
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext; // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            var shouldFireAfterActiveInstanceBlur = commitBeforeMutationEffects(root, finishedWork);
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            commitMutationEffects(root, finishedWork, lanes);
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            markLayoutEffectsStarted(lanes);
            commitLayoutEffects(finishedWork, root, lanes);
            markLayoutEffectsStopped();
            // opportunity to paint.
            requestPaint();
            executionContext = prevExecutionContext; // Reset the priority to the previous non-sync value.
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            recordCommitTime();
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
        } else {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
        } // Read this again, since an effect might have updated it
        remainingLanes = root.pendingLanes; // Check if there's remaining work on this root
        // TODO: This is part of the `componentDidCatch` implementation. Its purpose
        // is to detect whether something might have called setState inside
        // `componentDidCatch`. The mechanism is known to be flawed because `setState`
        // inside `componentDidCatch` is itself flawed — that's why we recommend
        // `getDerivedStateFromError` instead. However, it could be improved by
        // checking if remainingLanes includes Sync work, instead of whether there's
        // any work remaining at all (which would also include stuff like Suspense
        // retries or transitions). It's been like this for a while, though, so fixing
        // it probably isn't that urgent.
        if (remainingLanes === NoLanes) // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) commitDoubleInvokeEffectsInDEV(root.current, false);
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        if (isDevToolsPresent) root.memoizedUpdaters.clear();
        onCommitRoot$1();
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root, now());
        if (recoverableErrors !== null) {
            // There were errors during this render, but recovered from them without
            // needing to surface it to the UI. We log them here.
            var onRecoverableError = root.onRecoverableError;
            for(var i = 0; i < recoverableErrors.length; i++){
                var recoverableError = recoverableErrors[i];
                var componentStack = recoverableError.stack;
                var digest = recoverableError.digest;
                onRecoverableError(recoverableError.value, {
                    componentStack: componentStack,
                    digest: digest
                });
            }
        }
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var error$1 = firstUncaughtError;
            firstUncaughtError = null;
            throw error$1;
        } // If the passive effects are the result of a discrete render, flush them
        // synchronously at the end of the current task so that the result is
        // immediately observable. Otherwise, we assume that they are not
        // order-dependent and do not need to be observed by external systems, so we
        // can wait until after paint.
        // TODO: We can optimize this by not scheduling the callback earlier. Since we
        // currently schedule the callback in multiple places, will wait until those
        // are consolidated.
        if (includesSomeLane(pendingPassiveEffectsLanes, SyncLane) && root.tag !== LegacyRoot) flushPassiveEffects();
         // Read this again, since a passive effect might have updated it
        remainingLanes = root.pendingLanes;
        if (includesSomeLane(remainingLanes, SyncLane)) {
            markNestedUpdateScheduled();
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
         // If layout work was scheduled, flush it now.
        flushSyncCallbacks();
        markCommitStopped();
        return null;
    }
    function flushPassiveEffects() {
        // Returns whether passive effects were flushed.
        // TODO: Combine this check with the one in flushPassiveEFfectsImpl. We should
        // probably just combine the two functions. I believe they were only separate
        // in the first place because we used to wrap it with
        // `Scheduler.runWithPriority`, which accepts a function. But now we track the
        // priority within React itself, so we can mutate the variable directly.
        if (rootWithPendingPassiveEffects !== null) {
            var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes);
            var priority = lowerEventPriority(DefaultEventPriority, renderPriority);
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            var previousPriority = getCurrentUpdatePriority();
            try {
                ReactCurrentBatchConfig$3.transition = null;
                setCurrentUpdatePriority(priority);
                return flushPassiveEffectsImpl();
            } finally{
                setCurrentUpdatePriority(previousPriority);
                ReactCurrentBatchConfig$3.transition = prevTransition; // Once passive effects have run for the tree - giving components a
            }
        }
        return false;
    }
    function enqueuePendingPassiveProfilerEffect(fiber) {
        pendingPassiveProfilerEffects.push(fiber);
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback$1(NormalPriority, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
         // Cache and clear the transitions flag
        var transitions = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null; // TODO: This is sometimes out of sync with rootWithPendingPassiveEffects.
        // Figure out why and fix it. It's not causing any known issues (probably
        // because it's only used for profiling), but it's a refactor hazard.
        pendingPassiveEffectsLanes = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Cannot flush passive effects while already rendering.");
        isFlushingPassiveEffects = true;
        didScheduleUpdateDuringPassiveEffects = false;
        markPassiveEffectsStarted(lanes);
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        commitPassiveUnmountEffects(root.current);
        commitPassiveMountEffects(root, root.current, lanes, transitions); // TODO: Move to commitPassiveMountEffects
        var profilerEffects = pendingPassiveProfilerEffects;
        pendingPassiveProfilerEffects = [];
        for(var i = 0; i < profilerEffects.length; i++){
            var _fiber = profilerEffects[i];
            commitPassiveEffectDurations(root, _fiber);
        }
        markPassiveEffectsStopped();
        commitDoubleInvokeEffectsInDEV(root.current, true);
        executionContext = prevExecutionContext;
        flushSyncCallbacks();
        // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        if (didScheduleUpdateDuringPassiveEffects) {
            if (root === rootWithPassiveNestedUpdates) nestedPassiveUpdateCount++;
            else {
                nestedPassiveUpdateCount = 0;
                rootWithPassiveNestedUpdates = root;
            }
        } else nestedPassiveUpdateCount = 0;
        isFlushingPassiveEffects = false;
        didScheduleUpdateDuringPassiveEffects = false;
        onPostCommitRoot(root);
        var stateNode = root.current.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValueAtFiber(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        var root = enqueueUpdate(rootFiber, update, SyncLane);
        var eventTime = requestEventTime();
        if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error$1) {
        reportUncaughtErrorInDEV(error$1);
        setIsRunningInsertionEffect(false);
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error$1);
            return;
        }
        var fiber = null;
        fiber = nearestMountedAncestor;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error$1);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === "function" || typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValueAtFiber(error$1, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                    var root = enqueueUpdate(fiber, update, SyncLane);
                    var eventTime = requestEventTime();
                    if (root !== null) {
                        markRootUpdated(root, SyncLane, eventTime);
                        ensureRootIsScheduled(root, eventTime);
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
        // TODO: Until we re-land skipUnmountedBoundaries (see #20147), this warning
        // will fire for errors that are thrown by destroy functions inside deleted
        // trees. What it should instead do is propagate the error to the parent of
        // the deleted tree. In the meantime, do not add this warning to the
        // allowlist; this is only for our internal use.
        error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error$1);
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(wakeable);
        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        warnIfSuspenseResolutionNotWrappedWithActDEV(root);
        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root.
            prepareFreshStack(root, NoLanes);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
        }
        ensureRootIsScheduled(root, eventTime);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new lanes.
        if (retryLane === NoLane) // TODO: Assign this to `suspenseState.retryLane`? to avoid
        // unnecessary entanglement?
        retryLane = requestRetryLane(boundaryFiber);
         // TODO: Special case idle priority?
        var eventTime = requestEventTime();
        var root = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState;
        var retryLane = NoLane;
        if (suspenseState !== null) retryLane = suspenseState.retryLane;
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane; // Default
        var retryCache;
        switch(boundaryFiber.tag){
            case SuspenseComponent:
                retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                if (suspenseState !== null) retryLane = suspenseState.retryLane;
                break;
            case SuspenseListComponent:
                retryCache = boundaryFiber.stateNode;
                break;
            default:
                throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        if (retryCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    function commitDoubleInvokeEffectsInDEV(fiber, hasPassiveEffects) {
        // TODO (StrictEffects) Should we set a marker on the root if it contains strict effects
        // so we don't traverse unnecessarily? similar to subtreeFlags but just at the root level.
        // Maybe not a big deal since this is DEV only behavior.
        setCurrentFiber(fiber);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectUnmountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectUnmountInDEV);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectMountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectMountInDEV);
        resetCurrentFiber();
    }
    function invokeEffectsInDev(firstChild, fiberFlags, invokeEffectFn) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        var current = firstChild;
        var subtreeRoot = null;
        while(current !== null){
            var primarySubtreeFlag = current.subtreeFlags & fiberFlags;
            if (current !== subtreeRoot && current.child !== null && primarySubtreeFlag !== NoFlags) current = current.child;
            else {
                if ((current.flags & fiberFlags) !== NoFlags) invokeEffectFn(current);
                if (current.sibling !== null) current = current.sibling;
                else current = subtreeRoot = current.return;
            }
        }
    }
    var didWarnStateUpdateForNotYetMountedComponent = null;
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) !== NoContext) // We let the other warning about render phase updates deal with this one.
        return;
        if (!(fiber.mode & ConcurrentMode)) return;
        var tag = fiber.tag;
        if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentNameFromFiber(fiber) || "ReactComponent";
        if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
        } else didWarnStateUpdateForNotYetMountedComponent = new Set([
            componentName
        ]);
        var previousFiber = current;
        try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally{
            if (previousFiber) setCurrentFiber(fiber);
            else resetCurrentFiber();
        }
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, lanes) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, lanes);
        } catch (originalError) {
            if (didSuspendOrErrorWhileHydratingDEV() || originalError !== null && typeof originalError === "object" && typeof originalError.then === "function") // Don't replay promises.
            // Don't replay errors if we are hydrating and have already suspended or handled an error
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(current, unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
            if (hasCaughtError()) {
                var replayError = clearCaughtError();
                if (typeof replayError === "object" && replayError !== null && replayError._suppressLogging && typeof originalError === "object" && originalError !== null && !originalError._suppressLogging) // If suppressed, let the flag carry over to the original error which is the one we'll rethrow.
                originalError._suppressLogging = true;
            } // We always throw the original error in case the second render pass is not idempotent.
            // This can happen if a memoized function or CommonJS module doesn't throw after first invocation.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown"; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentNameFromFiber(fiber) || "Unknown";
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    }
    function restorePendingUpdaters(root, lanes) {
        if (isDevToolsPresent) {
            var memoizedUpdaters = root.memoizedUpdaters;
            memoizedUpdaters.forEach(function(schedulingFiber) {
                addFiberToLanesMap(root, schedulingFiber, lanes);
            }); // This function intentionally does not clear memoized updaters.
        // Those may still be relevant to the current commit
        // and a future one (e.g. Suspense).
        }
    }
    var fakeActCallbackNode = {};
    function scheduleCallback$1(priorityLevel, callback) {
        // If we're currently inside an `act` scope, bypass Scheduler and push to
        // the `act` queue instead.
        var actQueue = ReactCurrentActQueue$1.current;
        if (actQueue !== null) {
            actQueue.push(callback);
            return fakeActCallbackNode;
        } else return scheduleCallback(priorityLevel, callback);
    }
    function cancelCallback$1(callbackNode) {
        if (callbackNode === fakeActCallbackNode) return;
         // In production, always call Scheduler. This function will be stripped out.
        return cancelCallback(callbackNode);
    }
    function shouldForceFlushFallbacksInDEV() {
        // Never force flush in production. This function should get stripped out.
        return ReactCurrentActQueue$1.current !== null;
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        if (fiber.mode & ConcurrentMode) {
            if (!isConcurrentActEnvironment()) // Not in an act environment. No need to warn.
            return;
        } else {
            // Legacy mode has additional cases where we suppress a warning.
            if (!isLegacyActEnvironment()) // Not in an act environment. No need to warn.
            return;
            if (executionContext !== NoContext) // Legacy mode doesn't warn if the update is batched, i.e.
            // batchedUpdates or flushSync.
            return;
            if (fiber.tag !== FunctionComponent && fiber.tag !== ForwardRef && fiber.tag !== SimpleMemoComponent) // For backwards compatibility with pre-hooks code, legacy mode only
            // warns for updates that originate from a hook.
            return;
        }
        if (ReactCurrentActQueue$1.current === null) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    function warnIfSuspenseResolutionNotWrappedWithActDEV(root) {
        if (root.tag !== LegacyRoot && isConcurrentActEnvironment() && ReactCurrentActQueue$1.current === null) error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act");
    }
    function setIsRunningInsertionEffect(isRunning) {
        isRunningInsertionEffect = isRunning;
    }
    /* eslint-disable react-internal/prod-error-codes */ var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === "function") {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === "object" && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== "function") return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        flushSync(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error("Expected resolveFamily to be set during hot reload.");
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) {
            var _root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (_root !== null) scheduleUpdateOnFiber(_root, fiber, SyncLane, NoTimestamp);
        }
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error("Expected to reach root first.");
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        /* eslint-disable no-new */ new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    /* eslint-enable no-new */ } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.flags = NoFlags;
        this.subtreeFlags = NoFlags;
        this.deletions = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        // This isn't directly used but is handy for debugging internals:
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === "function") Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === "function" && !shouldConstruct$1(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === "function") return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.flags = NoFlags; // The effects are no longer valid.
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        } // Reset all effects except static ones.
        // Static effects are not specific to a render.
        workInProgress.flags = current.flags & StaticMask;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderLanes) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect flags but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.flags &= StaticMask | Placement; // The effects are no longer valid.
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag, isStrictMode, concurrentUpdatesByDefaultOverride) {
        var mode;
        if (tag === ConcurrentRoot) {
            mode = ConcurrentMode;
            if (isStrictMode === true) {
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
            }
        } else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === "function") {
            if (shouldConstruct$1(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === "string") fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictLegacyMode;
                if ((mode & ConcurrentMode) !== NoMode) // Strict effects should never run on legacy roots
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            case REACT_LEGACY_HIDDEN_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_SCOPE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_CACHE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_TRACING_MARKER_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_DEBUG_TRACING_MODE_TYPE:
            // eslint-disable-next-line no-fallthrough
            default:
                if (typeof type === "object" && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                }
                var info = "";
                if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentNameFromFiber(owner) : null;
                if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
                throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        fiber._debugOwner = owner;
        return fiber;
    }
    function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        if (typeof pendingProps.id !== "string") error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof pendingProps.id);
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
        };
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        var primaryChildInstance = {
            isHidden: false
        };
        fiber.stateNode = primaryChildInstance;
        return fiber;
    }
    function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode);
        fiber.elementType = "DELETED";
        return fiber;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(DehydratedFragment, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.subtreeFlags = source.subtreeFlags;
        target.deletions = source.deletions;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.callbackNode = null;
        this.callbackPriority = NoLane;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.identifierPrefix = identifierPrefix;
        this.onRecoverableError = onRecoverableError;
        this.mutableSourceEagerHydrationData = null;
        this.effectDuration = 0;
        this.passiveEffectDuration = 0;
        this.memoizedUpdaters = new Set();
        var pendingUpdatersLaneMap = this.pendingUpdatersLaneMap = [];
        for(var _i = 0; _i < TotalLanes; _i++)pendingUpdatersLaneMap.push(new Set());
        switch(tag){
            case ConcurrentRoot:
                this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
                break;
            case LegacyRoot:
                this._debugRootType = hydrate ? "hydrate()" : "render()";
                break;
        }
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, // host config, but because they are passed in at runtime, we have to thread
    // them through the root constructor. Perhaps we should put them all into a
    // single type, like a DynamicHostConfig that is defined by the renderer.
    identifierPrefix, onRecoverableError, transitionCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag, isStrictMode);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        var _initialState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: null,
            // not enabled yet
            transitions: null,
            pendingSuspenseBoundaries: null
        };
        uninitializedFiber.memoizedState = _initialState;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    var ReactVersion = "18.2.0";
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        checkKeyStringCoercion(key);
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : "" + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === "function") throw new Error("Unable to find node on an unmounted component.");
            else {
                var keys = Object.keys(component).join(",");
                throw new Error("Argument appears to not be a ReactComponent. Keys: " + keys);
            }
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictLegacyMode) {
            var componentName = getComponentNameFromFiber(fiber) || "Component";
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                    setCurrentFiber(hostFiber);
                    if (fiber.mode & StrictLegacyMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                    else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } finally{
                    // Ideally this should reset to previous but this shouldn't be called in
                    // render and there's another warning for that anyway.
                    if (previousFiber) setCurrentFiber(previousFiber);
                    else resetCurrentFiber();
                }
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = false;
        var initialChildren = null;
        return createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
    }
    function createHydrationContainer(initialChildren, callback, containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = true;
        var root = createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError); // TODO: Move this to FiberRoot constructor
        root.context = getContextForSubtree(null); // Schedule the initial render. In a hydration root, this is different from
        // a regular update because the initial render must match was was rendered
        // on the server.
        // NOTE: This update intentionally doesn't have a payload. We're only using
        // the update to schedule work on the root fiber (and, for legacy roots, to
        // enqueue the callback if one is provided).
        var current = root.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current);
        var update = createUpdate(eventTime, lane);
        update.callback = callback !== undefined && callback !== null ? callback : null;
        enqueueUpdate(current, update, lane);
        scheduleInitialHydrationOnRoot(root, lane, eventTime);
        return root;
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current$1);
        markRenderScheduled(lane);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || "Unknown");
        }
        var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== "function") error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        var root = enqueueUpdate(current$1, update, lane);
        if (root !== null) {
            scheduleUpdateOnFiber(root, current$1, lane, eventTime);
            entangleTransitions(root, current$1, lane);
        }
        return lane;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function attemptSynchronousHydration$1(fiber) {
        switch(fiber.tag){
            case HostRoot:
                var root = fiber.stateNode;
                if (isRootDehydrated(root)) {
                    // Flush the first scheduled "update".
                    var lanes = getHighestPriorityPendingLanes(root);
                    flushRoot(root, lanes);
                }
                break;
            case SuspenseComponent:
                flushSync(function() {
                    var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
                    if (root !== null) {
                        var eventTime = requestEventTime();
                        scheduleUpdateOnFiber(root, fiber, SyncLane, eventTime);
                    }
                }); // If we're still blocked after this, we need to increase
                // the priority of any promises resolving within this
                // boundary so that they next attempt also has higher pri.
                var retryLane = SyncLane;
                markRetryLaneIfNotHydrated(fiber, retryLane);
                break;
        }
    }
    function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
    } // Increases the priority of thenables when they resolve within this boundary.
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) markRetryLaneImpl(alternate, retryLane);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var lane = SelectiveHydrationLane;
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var lane = requestUpdateLane(fiber);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    var shouldErrorImpl = function(fiber) {
        return null;
    };
    function shouldError(fiber) {
        return shouldErrorImpl(fiber);
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideHookStateDeletePath = null;
    var overrideHookStateRenamePath = null;
    var overrideProps = null;
    var overridePropsDeletePath = null;
    var overridePropsRenamePath = null;
    var scheduleUpdate = null;
    var setErrorHandler = null;
    var setSuspenseHandler = null;
    var copyWithDeleteImpl = function(obj, path, index) {
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) {
            if (isArray(updated)) updated.splice(key, 1);
            else delete updated[key];
            return updated;
        } // $FlowFixMe number or string is fine here
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    };
    var copyWithDelete = function(obj, path) {
        return copyWithDeleteImpl(obj, path, 0);
    };
    var copyWithRenameImpl = function(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === oldPath.length) {
            var newKey = newPath[index]; // $FlowFixMe number or string is fine here
            updated[newKey] = updated[oldKey];
            if (isArray(updated)) updated.splice(oldKey, 1);
            else delete updated[oldKey];
        } else // $FlowFixMe number or string is fine here
        updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    };
    var copyWithRename = function(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) {
            warn("copyWithRename() expects paths of the same length");
            return;
        } else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                warn("copyWithRename() expects paths to be the same except for the deepest key");
                return;
            }
        }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
    };
    var copyWithSetImpl = function(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    };
    var findHook = function(fiber, id) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        return currentHook;
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    scheduleUpdate = function(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    setErrorHandler = function(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function emptyFindFiberByHostInstance(instance) {
        return null;
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setErrorHandler: setErrorHandler,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools,
            // Enables DevTools to detect reconciler version rather than renderer version
            // which may not match for third party renderers.
            reconcilerVersion: ReactVersion
        });
    }
    /* global reportError */ var defaultOnRecoverableError = typeof reportError === "function" ? // emulating an uncaught JavaScript error.
    reportError : function(error) {
        // In older browsers and test environments, fallback to console.error.
        // eslint-disable-next-line react-internal/no-production-logging
        console["error"](error);
    };
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (root === null) throw new Error("Cannot update an unmounted root.");
        if (typeof arguments[1] === "function") error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        else if (isValidContainer(arguments[1])) error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.");
        else if (typeof arguments[1] !== "undefined") error("You passed a second argument to root.render(...) but it only accepts one argument.");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        if (typeof arguments[0] === "function") error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        if (root !== null) {
            this._internalRoot = null;
            var container = root.containerInfo;
            if (isAlreadyRendering()) error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            flushSync(function() {
                updateContainer(null, root, null, null);
            });
            unmarkContainerAsRoot(container);
        }
    };
    function createRoot(container, options) {
        if (!isValidContainer(container)) throw new Error("createRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        var transitionCallbacks = null;
        if (options !== null && options !== undefined) {
            if (options.hydrate) warn("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.");
            else if (typeof options === "object" && options !== null && options.$$typeof === REACT_ELEMENT_TYPE) error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);");
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
            if (options.transitionCallbacks !== undefined) transitionCallbacks = options.transitionCallbacks;
        }
        var root = createContainer(container, ConcurrentRoot, null, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container);
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        return new ReactDOMRoot(root);
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function scheduleHydration(target) {
        if (target) queueExplicitHydrationTarget(target);
    }
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = scheduleHydration;
    function hydrateRoot(container, initialChildren, options) {
        if (!isValidContainer(container)) throw new Error("hydrateRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        if (initialChildren === undefined) error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        // the hydration callbacks.
        var hydrationCallbacks = options != null ? options : null; // TODO: Delete this option
        var mutableSources = options != null && options.hydratedSources || null;
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        if (options !== null && options !== undefined) {
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
        }
        var root = createHydrationContainer(initialChildren, null, container, ConcurrentRoot, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container); // This can't be a comment node since hydration doesn't work on comment nodes anyway.
        listenToAllSupportedEvents(container);
        if (mutableSources) for(var i = 0; i < mutableSources.length; i++){
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
        }
        return new ReactDOMHydrationRoot(root);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || !disableCommentsAsDOMContainers));
    } // TODO: Remove this function which also includes comment nodes.
    // We only use it in places that are currently more relaxed.
    function isValidContainerLegacy(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === " react-mount-point-unstable "));
    }
    function warnIfReactDOMContainerInDEV(container) {
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app.");
        if (isContainerMarkedAsRoot(container)) {
            if (container._reactRootContainer) error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.");
            else error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.");
        }
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function noopOnRecoverableError() {
    // legacy API.
    }
    function legacyCreateRootFromDOMContainer(container, initialChildren, parentComponent, callback, isHydrationContainer) {
        if (isHydrationContainer) {
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            }
            var root = createHydrationContainer(initialChildren, callback, container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = root;
            markContainerAsRoot(root.current, container);
            var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(rootContainerElement);
            flushSync();
            return root;
        } else {
            // First clear any existing content.
            var rootSibling;
            while(rootSibling = container.lastChild)container.removeChild(rootSibling);
            if (typeof callback === "function") {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(_root);
                    _originalCallback.call(instance);
                };
            }
            var _root = createContainer(container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = _root;
            markContainerAsRoot(_root.current, container);
            var _rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(_rootContainerElement); // Initial mount should not be batched.
            flushSync(function() {
                updateContainer(initialChildren, _root, parentComponent, callback);
            });
            return _root;
        }
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== "function") error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, "render");
        var maybeRoot = container._reactRootContainer;
        var root;
        if (!maybeRoot) // Initial mount
        root = legacyCreateRootFromDOMContainer(container, children, parentComponent, callback, forceHydrate);
        else {
            root = maybeRoot;
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, root, parentComponent, callback);
        }
        return getPublicRootInstance(root);
    }
    function findDOMNode(componentOrElement) {
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromType(owner.type) || "A component");
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, "findDOMNode");
    }
    function hydrate(element, container, callback) {
        error("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        error("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        error("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(containerNode)) throw new Error("Target container is not a DOM element.");
        if (parentComponent == null || !has(parentComponent)) throw new Error("parentComponent must be a valid React Component");
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    function unmountComponentAtNode(container) {
        if (!isValidContainerLegacy(container)) throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            flushSync(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainerLegacy(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    setAttemptSynchronousHydration(attemptSynchronousHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    setGetCurrentUpdatePriority(getCurrentUpdatePriority);
    setAttemptHydrationAtPriority(runWithPriority);
    if (typeof Map !== "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== "function" || typeof Set !== "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== "function" || typeof Set.prototype.forEach !== "function") error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates, flushSync);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw new Error("Target container is not a DOM element.");
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    var Internals = {
        usingClientEntryPoint: false,
        // Keep in sync with ReactTestUtils.js.
        // This is an array for better minification.
        Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            batchedUpdates$1
        ]
    };
    function createRoot$1(container, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return createRoot(container, options);
    }
    function hydrateRoot$1(container, initialChildren, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return hydrateRoot(container, initialChildren, options);
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync$1(fn) {
        if (isAlreadyRendering()) error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        return flushSync(fn);
    }
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: "react-dom"
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol === "file:" ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ""), "font-weight:bold");
        }
    }
    $2956e04298bc31b1$export$ae55be85d98224ed = Internals;
    $2956e04298bc31b1$export$d39a5bbd09211389 = createPortal$1;
    $2956e04298bc31b1$export$882461b6382ed46c = createRoot$1;
    $2956e04298bc31b1$export$466bfc07425424d5 = findDOMNode;
    $2956e04298bc31b1$export$cd75ccfd720a3cd4 = flushSync$1;
    $2956e04298bc31b1$export$fa8d919ba61d84db = hydrate;
    $2956e04298bc31b1$export$757ceba2d55c277e = hydrateRoot$1;
    $2956e04298bc31b1$export$b3890eb0ae9dca99 = render;
    $2956e04298bc31b1$export$502457920280e6be = unmountComponentAtNode;
    $2956e04298bc31b1$export$c78a37762a8d58e1 = batchedUpdates$1;
    $2956e04298bc31b1$export$dc54d992c10e8a18 = renderSubtreeIntoContainer;
    $2956e04298bc31b1$export$83d89fbfd8236492 = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7jGsX"));

});
parcelRegister("7jGsX", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $553b3f9a1c62156e$export$c4744153514ff05d, (v) => $553b3f9a1c62156e$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7, (v) => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $553b3f9a1c62156e$export$e26fe2ed2fa76875, (v) => $553b3f9a1c62156e$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $553b3f9a1c62156e$export$502329bbf4b505b1, (v) => $553b3f9a1c62156e$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $553b3f9a1c62156e$export$6e3807111c4874c4, (v) => $553b3f9a1c62156e$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $553b3f9a1c62156e$export$c27134553091fb3a, (v) => $553b3f9a1c62156e$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $553b3f9a1c62156e$export$33ee1acdc04fd2a2, (v) => $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $553b3f9a1c62156e$export$b00a404bbd5edef2, (v) => $553b3f9a1c62156e$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $553b3f9a1c62156e$export$8352ce38b91d0c62, (v) => $553b3f9a1c62156e$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $553b3f9a1c62156e$export$d66a1c1c77bd778b, (v) => $553b3f9a1c62156e$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $553b3f9a1c62156e$export$d3dfb8e4810cb555, (v) => $553b3f9a1c62156e$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $553b3f9a1c62156e$export$839f9183b0465a69, (v) => $553b3f9a1c62156e$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $553b3f9a1c62156e$export$72fdf0e06517287b, (v) => $553b3f9a1c62156e$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $553b3f9a1c62156e$export$4b844e58a3e414b4, (v) => $553b3f9a1c62156e$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $553b3f9a1c62156e$export$816d2913ae6b83b1, (v) => $553b3f9a1c62156e$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $553b3f9a1c62156e$export$61bcfe829111a1d0, (v) => $553b3f9a1c62156e$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $553b3f9a1c62156e$export$7ee8c9beb337bc3f, (v) => $553b3f9a1c62156e$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $553b3f9a1c62156e$export$b5836b71941fa3ed, (v) => $553b3f9a1c62156e$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $553b3f9a1c62156e$export$cf845f2c119da08a, (v) => $553b3f9a1c62156e$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $553b3f9a1c62156e$export$c4744153514ff05d;
var $553b3f9a1c62156e$export$3e506c1ccc9cc1a7;
var $553b3f9a1c62156e$export$e26fe2ed2fa76875;
var $553b3f9a1c62156e$export$502329bbf4b505b1;
var $553b3f9a1c62156e$export$6e3807111c4874c4;
var $553b3f9a1c62156e$export$c27134553091fb3a;
var $553b3f9a1c62156e$export$33ee1acdc04fd2a2;
var $553b3f9a1c62156e$export$b00a404bbd5edef2;
var $553b3f9a1c62156e$export$8352ce38b91d0c62;
var $553b3f9a1c62156e$export$d66a1c1c77bd778b;
var $553b3f9a1c62156e$export$d3dfb8e4810cb555;
var $553b3f9a1c62156e$export$839f9183b0465a69;
var $553b3f9a1c62156e$export$72fdf0e06517287b;
var $553b3f9a1c62156e$export$4b844e58a3e414b4;
var $553b3f9a1c62156e$export$816d2913ae6b83b1;
var $553b3f9a1c62156e$export$61bcfe829111a1d0;
var $553b3f9a1c62156e$export$7ee8c9beb337bc3f;
var $553b3f9a1c62156e$export$b5836b71941fa3ed;
var $553b3f9a1c62156e$export$cf845f2c119da08a;
"use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var enableSchedulerDebugging = false;
    var enableProfiling = false;
    var frameYieldMs = 5;
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        return heap.length === 0 ? null : heap[0];
    }
    function pop(heap) {
        if (heap.length === 0) return null;
        var first = heap[0];
        var last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            siftDown(heap, last, 0);
        }
        return first;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(index > 0){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        var halfLength = length >>> 1;
        while(index < halfLength){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (compare(left, node) < 0) {
                if (rightIndex < length && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (rightIndex < length && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    function markTaskErrored(task, ms) {}
    /* eslint-disable no-var */ var hasPerformanceNow = typeof performance === "object" && typeof performance.now === "function";
    if (hasPerformanceNow) {
        var localPerformance = performance;
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        var initialTime = localDate.now();
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    } // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrance.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false; // Capture local references to native APIs, in case a polyfill overrides them.
    var localSetTimeout = typeof setTimeout === "function" ? setTimeout : null;
    var localClearTimeout = typeof clearTimeout === "function" ? clearTimeout : null;
    var localSetImmediate = typeof setImmediate !== "undefined" ? setImmediate : null; // IE and Node.js + jsdom
    var isInputPending = typeof navigator !== "undefined" && navigator.scheduling !== undefined && navigator.scheduling.isInputPending !== undefined ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod code path.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) break;
            var callback = currentTask.callback;
            if (typeof callback === "function") {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                if (typeof continuationCallback === "function") currentTask.callback = continuationCallback;
                else if (currentTask === peek(taskQueue)) pop(taskQueue);
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
        var startTime;
        if (typeof options === "object" && options !== null) {
            var delay = options.delay;
            if (typeof delay === "number" && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
        } else startTime = currentTime;
        var timeout;
        switch(priorityLevel){
            case ImmediatePriority:
                timeout = IMMEDIATE_PRIORITY_TIMEOUT;
                break;
            case UserBlockingPriority:
                timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
                break;
            case IdlePriority:
                timeout = IDLE_PRIORITY_TIMEOUT;
                break;
            case LowPriority:
                timeout = LOW_PRIORITY_TIMEOUT;
                break;
            case NormalPriority:
            default:
                timeout = NORMAL_PRIORITY_TIMEOUT;
                break;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    var isMessageLoopRunning = false;
    var scheduledHostCallback = null;
    var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
    // thread, like user events. By default, it yields multiple times per frame.
    // It does not attempt to align with frame boundaries, since most tasks don't
    // need to be frame aligned; for those that do, use requestAnimationFrame.
    var frameInterval = frameYieldMs;
    var startTime = -1;
    function shouldYieldToHost() {
        var timeElapsed = $553b3f9a1c62156e$export$c4744153514ff05d() - startTime;
        if (timeElapsed < frameInterval) // The main thread has only been blocked for a really short amount of time;
        // smaller than a single frame. Don't yield yet.
        return false;
         // The main thread has been blocked for a non-negligible amount of time. We
        return true;
    }
    function requestPaint() {}
    function forceFrameRate(fps) {
        if (fps < 0 || fps > 125) {
            // Using console['error'] to evade Babel and ESLint
            console["error"]("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
        }
        if (fps > 0) frameInterval = Math.floor(1000 / fps);
        else // reset the framerate
        frameInterval = frameYieldMs;
    }
    var performWorkUntilDeadline = function() {
        if (scheduledHostCallback !== null) {
            var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d(); // Keep track of the start time so we can measure how long the main thread
            // has been blocked.
            startTime = currentTime;
            var hasTimeRemaining = true; // If a scheduler task throws, exit the current browser task so the
            // error can be observed.
            //
            // Intentionally not using a try-catch, since that makes some debugging
            // techniques harder. Instead, if `scheduledHostCallback` errors, then
            // `hasMoreWork` will remain true, and we'll continue the work loop.
            var hasMoreWork = true;
            try {
                hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
            } finally{
                if (hasMoreWork) // If there's more work, schedule the next message event at the end
                // of the preceding one.
                schedulePerformWorkUntilDeadline();
                else {
                    isMessageLoopRunning = false;
                    scheduledHostCallback = null;
                }
            }
        } else isMessageLoopRunning = false;
         // Yielding to the browser will give it a chance to paint, so we can
    };
    var schedulePerformWorkUntilDeadline;
    if (typeof localSetImmediate === "function") // Node.js and old IE.
    // There's a few reasons for why we prefer setImmediate.
    //
    // Unlike MessageChannel, it doesn't prevent a Node.js process from exiting.
    // (Even though this is a DOM fork of the Scheduler, you could get here
    // with a mix of Node.js 15+, which has a MessageChannel, and jsdom.)
    // https://github.com/facebook/react/issues/20756
    //
    // But also, it runs earlier which is the semantic we want.
    // If other browsers ever implement it, it's better to use it.
    // Although both of these would be inferior to native scheduling.
    schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if (typeof MessageChannel !== "undefined") {
        // DOM and Worker environments.
        // We prefer MessageChannel because of the 4ms setTimeout clamping.
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
        };
    } else // We should only fallback here in non-browser environments.
    schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    function requestHostCallback(callback) {
        scheduledHostCallback = callback;
        if (!isMessageLoopRunning) {
            isMessageLoopRunning = true;
            schedulePerformWorkUntilDeadline();
        }
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback($553b3f9a1c62156e$export$c4744153514ff05d());
        }, ms);
    }
    function cancelHostTimeout() {
        localClearTimeout(taskTimeoutID);
        taskTimeoutID = -1;
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = null;
    $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = IdlePriority;
    $553b3f9a1c62156e$export$e26fe2ed2fa76875 = ImmediatePriority;
    $553b3f9a1c62156e$export$502329bbf4b505b1 = LowPriority;
    $553b3f9a1c62156e$export$6e3807111c4874c4 = NormalPriority;
    $553b3f9a1c62156e$export$c27134553091fb3a = unstable_Profiling;
    $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = UserBlockingPriority;
    $553b3f9a1c62156e$export$b00a404bbd5edef2 = unstable_cancelCallback;
    $553b3f9a1c62156e$export$8352ce38b91d0c62 = unstable_continueExecution;
    $553b3f9a1c62156e$export$d66a1c1c77bd778b = forceFrameRate;
    $553b3f9a1c62156e$export$d3dfb8e4810cb555 = unstable_getCurrentPriorityLevel;
    $553b3f9a1c62156e$export$839f9183b0465a69 = unstable_getFirstCallbackNode;
    $553b3f9a1c62156e$export$72fdf0e06517287b = unstable_next;
    $553b3f9a1c62156e$export$4b844e58a3e414b4 = unstable_pauseExecution;
    $553b3f9a1c62156e$export$816d2913ae6b83b1 = unstable_requestPaint;
    $553b3f9a1c62156e$export$61bcfe829111a1d0 = unstable_runWithPriority;
    $553b3f9a1c62156e$export$7ee8c9beb337bc3f = unstable_scheduleCallback;
    $553b3f9a1c62156e$export$b5836b71941fa3ed = shouldYieldToHost;
    $553b3f9a1c62156e$export$cf845f2c119da08a = unstable_wrapCallback;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("dwO3n", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $9d95171a353491b6$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $9d95171a353491b6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Driver = void 0;

var $5lryg = parcelRequire("5lryg");

var $92UFn = parcelRequire("92UFn");
var $azdaC = parcelRequire("azdaC");
var $3osda = parcelRequire("3osda");

var $5UUfm = parcelRequire("5UUfm");
/** class fully implements DriverInterface */ class $9d95171a353491b6$var$Driver extends $5lryg.DriverNoVendor {
    constructor(net, genesis, initialHead, wallet){
        super(net, genesis, initialHead);
        this.wallet = wallet;
        /** params for tx construction */ this.txParams = {
            expiration: 18,
            gasPriceCoef: 0
        };
    }
    /**
     * create driver instance
     * it will fetch config(genesis, head) via net as construction params
     * @param net
     * @param wallet
     */ static connect(net, wallet) {
        return $9d95171a353491b6$var$__awaiter(this, void 0, void 0, function*() {
            const genesis = yield net.http("GET", "blocks/0");
            const best = yield net.http("GET", "blocks/best", {
                validateResponseHeader: (headers)=>{
                    const xgid = headers["x-genesis-id"];
                    if (xgid && xgid !== genesis.id) throw new Error(`responded 'x-genesis-id' not matched`);
                }
            });
            return new $9d95171a353491b6$var$Driver(net, genesis, {
                id: best.id,
                number: best.number,
                timestamp: best.timestamp,
                parentID: best.parentID,
                txsFeatures: best.txsFeatures,
                gasLimit: best.gasLimit
            }, wallet);
        });
    }
    signTx(msg, options) {
        return $9d95171a353491b6$var$__awaiter(this, void 0, void 0, function*() {
            options.onAccepted && options.onAccepted();
            const key = this.findKey(options.signer);
            const clauses = msg.map((c)=>({
                    to: c.to ? c.to.toLowerCase() : null,
                    value: c.value.toString().toLowerCase(),
                    data: (c.data || "0x").toLowerCase()
                }));
            const gas = options.gas || (yield this.estimateGas(clauses, key.address));
            const txBody = {
                chainTag: Number.parseInt(this.genesis.id.slice(-2), 16),
                blockRef: this.head.id.slice(0, 18),
                expiration: this.txParams.expiration,
                clauses: clauses,
                gasPriceCoef: this.txParams.gasPriceCoef,
                gas: gas,
                dependsOn: options.dependsOn || null,
                nonce: "0x" + $5UUfm.randomBytes(8).toString("hex")
            };
            let tx;
            if (options.delegator) {
                const delegatedTx = new $3osda.Transaction(Object.assign(Object.assign({}, txBody), {
                    reserved: {
                        features: 1 /* vip191 */ 
                    }
                }));
                const originSig = yield key.sign(delegatedTx.signingHash());
                const unsigned = {
                    raw: "0x" + delegatedTx.encode().toString("hex"),
                    origin: key.address
                };
                try {
                    const result = yield this.net.http("POST", options.delegator.url, {
                        body: unsigned
                    });
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                    delegatedTx.signature = $9d95171a353491b6$require$Buffer.concat([
                        originSig,
                        $9d95171a353491b6$require$Buffer.from(result.signature.slice(2), "hex")
                    ]);
                    tx = delegatedTx;
                } catch (err) {
                    // tslint:disable-next-line: no-console
                    console.warn("tx delegation error: ", err);
                // fallback to non-vip191 tx
                }
            }
            if (!tx) {
                tx = new $3osda.Transaction(txBody);
                tx.signature = yield key.sign(tx.signingHash());
            }
            const raw = "0x" + tx.encode().toString("hex");
            if (this.onTxCommit) this.onTxCommit({
                id: tx.id,
                raw: raw,
                resend: ()=>$9d95171a353491b6$var$__awaiter(this, void 0, void 0, function*() {
                        yield this.sendTx(raw);
                    })
            });
            yield this.sendTx(raw);
            return {
                txid: tx.id,
                signer: key.address
            };
        });
    }
    signCert(msg, options) {
        return $9d95171a353491b6$var$__awaiter(this, void 0, void 0, function*() {
            options.onAccepted && options.onAccepted();
            const key = this.findKey(options.signer);
            const annex = {
                domain: "localhost",
                timestamp: this.head.timestamp,
                signer: key.address
            };
            const unsigned = $azdaC.Certificate.encode(Object.assign(Object.assign({}, msg), annex));
            const signature = yield key.sign($92UFn.blake2b256(unsigned));
            return {
                annex: annex,
                signature: "0x" + signature.toString("hex")
            };
        });
    }
    findKey(addr) {
        if (this.wallet) {
            const keys = this.wallet.list;
            const key = addr ? keys.find((k)=>k.address === addr) : keys[0];
            if (key) return key;
        }
        throw new Error("empty wallet");
    }
    sendTx(raw) {
        return this.httpPost("transactions", {
            raw: raw
        });
    }
    estimateGas(clauses, caller) {
        return $9d95171a353491b6$var$__awaiter(this, void 0, void 0, function*() {
            const outputs = yield this.explain({
                clauses: clauses,
                caller: caller
            }, this.head.id);
            const execGas = outputs.reduce((sum, out)=>sum + out.gasUsed, 0);
            const intrinsicGas = $3osda.Transaction.intrinsicGas(clauses);
            return intrinsicGas + (execGas ? execGas + 15000 : 0);
        });
    }
}
module.exports.Driver = $9d95171a353491b6$var$Driver;

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("5lryg", function(module, exports) {
"use strict";
var $3e4449194a134bb0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DriverNoVendor = void 0;

var $1Ermq = parcelRequire("1Ermq");

var $e32i7 = parcelRequire("e32i7");

var $92UFn = parcelRequire("92UFn");

var $5ZiX2 = parcelRequire("5ZiX2");
/** class implements Connex.Driver leaves out Vendor related methods */ class $3e4449194a134bb0$var$DriverNoVendor {
    constructor(net, genesis, initialHead){
        this.net = net;
        this.genesis = genesis;
        this.headResolvers = [];
        this.int = new $1Ermq.PromInt();
        this.cache = new $e32i7.Cache();
        // to merge concurrent identical remote requests
        this.pendingRequests = {};
        if (initialHead) this.head = initialHead;
        else this.head = {
            id: genesis.id,
            number: genesis.number,
            timestamp: genesis.timestamp,
            parentID: genesis.parentID,
            txsFeatures: genesis.txsFeatures,
            gasLimit: genesis.gasLimit
        };
        this.headTrackerLoop();
    }
    // close the driver to prevent mem leak
    close() {
        this.int.interrupt();
    }
    // implementations
    pollHead() {
        return this.int.wrap(new Promise((resolve)=>{
            this.headResolvers.push(()=>resolve(this.head));
        }));
    }
    getBlock(revision) {
        return this.cache.getBlock(revision, ()=>this.httpGet(`blocks/${revision}`));
    }
    getTransaction(id, allowPending) {
        return this.cache.getTx(id, ()=>{
            const query = {
                head: this.head.id
            };
            if (allowPending) query.pending = "true";
            return this.httpGet(`transactions/${id}`, query);
        });
    }
    getReceipt(id) {
        return this.cache.getReceipt(id, ()=>this.httpGet(`transactions/${id}/receipt`, {
                head: this.head.id
            }));
    }
    getAccount(addr, revision) {
        return this.cache.getAccount(addr, revision, ()=>this.httpGet(`accounts/${addr}`, {
                revision: revision
            }));
    }
    getCode(addr, revision) {
        return this.cache.getTied(`code-${addr}`, revision, ()=>this.httpGet(`accounts/${addr}/code`, {
                revision: revision
            }));
    }
    getStorage(addr, key, revision) {
        return this.cache.getTied(`storage-${addr}-${key}`, revision, ()=>this.httpGet(`accounts/${addr}/storage/${key}`, {
                revision: revision
            }));
    }
    explain(arg, revision, cacheHints) {
        const cacheKey = `explain-${$92UFn.blake2b256(JSON.stringify(arg)).toString("hex")}`;
        return this.cache.getTied(cacheKey, revision, ()=>this.httpPost("accounts/*", arg, {
                revision: revision
            }), cacheHints);
    }
    filterEventLogs(arg, cacheHints) {
        const cacheKey = `event-${$92UFn.blake2b256(JSON.stringify(arg)).toString("hex")}`;
        return this.cache.getTied(cacheKey, this.head.id, ()=>this.httpPost("logs/event", arg), cacheHints);
    }
    filterTransferLogs(arg, cacheHints) {
        const cacheKey = `transfer-${$92UFn.blake2b256(JSON.stringify(arg)).toString("hex")}`;
        return this.cache.getTied(cacheKey, this.head.id, ()=>this.httpPost("logs/transfer", arg), cacheHints);
    }
    signTx(msg, options) {
        throw new Error("signer not implemented");
    }
    signCert(msg, options) {
        throw new Error("signer not implemented");
    }
    //////
    mergeRequest(req, ...keyParts) {
        const key = JSON.stringify(keyParts);
        const pending = this.pendingRequests[key];
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        if (pending) return pending;
        return this.pendingRequests[key] = (()=>$3e4449194a134bb0$var$__awaiter(this, void 0, void 0, function*() {
                try {
                    return yield req();
                } finally{
                    delete this.pendingRequests[key];
                }
            }))();
    }
    httpGet(path, query) {
        return this.mergeRequest(()=>{
            return this.net.http("GET", path, {
                query: query,
                validateResponseHeader: this.headerValidator
            });
        }, path, query || "");
    }
    httpPost(path, body, query) {
        return this.mergeRequest(()=>{
            return this.net.http("POST", path, {
                query: query,
                body: body,
                validateResponseHeader: this.headerValidator
            });
        }, path, query || "", body || "");
    }
    get headerValidator() {
        return (headers)=>{
            const xgid = headers["x-genesis-id"];
            if (xgid && xgid !== this.genesis.id) throw new Error(`responded 'x-genesis-id' not matched`);
        };
    }
    emitNewHead() {
        const resolvers = this.headResolvers;
        this.headResolvers = [];
        resolvers.forEach((r)=>r());
    }
    headTrackerLoop() {
        return $3e4449194a134bb0$var$__awaiter(this, void 0, void 0, function*() {
            for(;;){
                let attemptWs = false;
                try {
                    const best = yield this.int.wrap(this.httpGet("blocks/best"));
                    if (best.id !== this.head.id && best.number >= this.head.number) {
                        this.head = {
                            id: best.id,
                            number: best.number,
                            timestamp: best.timestamp,
                            parentID: best.parentID,
                            txsFeatures: best.txsFeatures,
                            gasLimit: best.gasLimit
                        };
                        this.cache.handleNewBlock(this.head, undefined, best);
                        this.emitNewHead();
                        if (Date.now() - this.head.timestamp * 1000 < 60000) // nearly synced
                        attemptWs = true;
                    }
                } catch (err) {
                    if (err instanceof $1Ermq.InterruptedError) break;
                }
                if (attemptWs) try {
                    yield this.trackWs();
                } catch (err) {
                    if (err instanceof $1Ermq.InterruptedError) break;
                }
                try {
                    yield this.int.wrap($5ZiX2.sleep(8000));
                } catch (_a) {
                    break;
                }
            }
        });
    }
    trackWs() {
        return $3e4449194a134bb0$var$__awaiter(this, void 0, void 0, function*() {
            const wsPath = `subscriptions/beat2?pos=${this.head.parentID}`;
            const wsr = this.net.openWebSocketReader(wsPath);
            try {
                for(;;){
                    const data = yield this.int.wrap(wsr.read());
                    const beat = JSON.parse(data);
                    if (!beat.obsolete && beat.id !== this.head.id && beat.number >= this.head.number) {
                        this.head = {
                            id: beat.id,
                            number: beat.number,
                            timestamp: beat.timestamp,
                            parentID: beat.parentID,
                            txsFeatures: beat.txsFeatures,
                            gasLimit: beat.gasLimit
                        };
                        this.cache.handleNewBlock(this.head, {
                            k: beat.k,
                            bits: beat.bloom
                        });
                        this.emitNewHead();
                    }
                }
            } finally{
                wsr.close();
            }
        });
    }
}
module.exports.DriverNoVendor = $3e4449194a134bb0$var$DriverNoVendor;

});
parcelRegister("1Ermq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InterruptedError = module.exports.PromInt = void 0;
/** class to make promise interruptable */ class $133ec01cb1f2f1d9$var$PromInt {
    constructor(){
        this.rejectors = new Set();
    }
    /**
     * interrupt all wrapped promises
     */ interrupt() {
        const rejectors = this.rejectors;
        this.rejectors = new Set();
        rejectors.forEach((r)=>r(new $133ec01cb1f2f1d9$var$InterruptedError()));
    }
    /**
     * wrap the promise
     * @param p the given promise
     * @returns the wrapped promise which will raise InterruptedError on interruption
     */ wrap(p) {
        return new Promise((resolve, reject)=>{
            const rejectors = this.rejectors;
            rejectors.add(reject);
            p.then(resolve).catch(reject).then(()=>rejectors.delete(reject));
        });
    }
}
module.exports.PromInt = $133ec01cb1f2f1d9$var$PromInt;
class $133ec01cb1f2f1d9$var$InterruptedError extends Error {
    constructor(){
        super("promise interrupted");
    }
}
module.exports.InterruptedError = $133ec01cb1f2f1d9$var$InterruptedError;
$133ec01cb1f2f1d9$var$InterruptedError.prototype.name = "InterruptedError";

});

parcelRegister("e32i7", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a3a31f7c24fef244$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $a3a31f7c24fef244$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cache = void 0;

var $fCGCe = parcelRequire("fCGCe");

var $5Kq8F = parcelRequire("5Kq8F");

var $4wvEg = parcelRequire("4wvEg");
const $a3a31f7c24fef244$var$WINDOW_LEN = 12;
class $a3a31f7c24fef244$var$Cache {
    constructor(){
        this.irreversible = {
            blocks: new $fCGCe(256),
            txs: new $fCGCe(512),
            receipts: new $fCGCe(512)
        };
        this.window = [];
    }
    handleNewBlock(head, bloom, block) {
        while(this.window.length > 0){
            const top = this.window[this.window.length - 1];
            if (top.id === head.id) return;
            if (top.id === head.parentID) break;
            this.window.pop();
        }
        this.window.push(Object.assign(Object.assign({}, head), {
            bloom: bloom ? $4wvEg.newFilter($a3a31f7c24fef244$require$Buffer.from(bloom.bits.slice(2), "hex"), bloom.k) : undefined,
            block: block,
            accounts: new Map(),
            txs: new Map(),
            receipts: new Map(),
            tied: new Map()
        }));
        // shift out old slots and move cached items into frozen cache
        while(this.window.length > $a3a31f7c24fef244$var$WINDOW_LEN){
            const bottom = this.window.shift();
            bottom.txs.forEach((v, k)=>this.irreversible.txs.set(k, v));
            bottom.receipts.forEach((v, k)=>this.irreversible.receipts.set(k, v));
            if (bottom.block) {
                this.irreversible.blocks.set(bottom.block.id, bottom.block);
                this.irreversible.blocks.set(bottom.block.number, bottom.block);
            }
        }
    }
    getBlock(revision, fetch) {
        return $a3a31f7c24fef244$var$__awaiter(this, void 0, void 0, function*() {
            let block = this.irreversible.blocks.get(revision) || null;
            if (block) return block;
            const { slot: slot } = this.findSlot(revision);
            if (slot && slot.block) return slot.block;
            block = yield fetch();
            if (block) {
                if (slot && slot.id === block.id) slot.block = block;
                if (this.isIrreversible(block.number)) {
                    this.irreversible.blocks.set(block.id, block);
                    if (block.isTrunk) this.irreversible.blocks.set(block.number, block);
                }
            }
            return block;
        });
    }
    getTx(txid, fetch) {
        return $a3a31f7c24fef244$var$__awaiter(this, void 0, void 0, function*() {
            let tx = this.irreversible.txs.get(txid) || null;
            if (tx) return tx;
            for (const slot of this.window){
                tx = slot.txs.get(txid) || null;
                if (tx) return tx;
            }
            tx = yield fetch();
            if (tx && tx.meta) {
                const { slot: slot } = this.findSlot(tx.meta.blockID);
                if (slot) slot.txs.set(txid, tx);
                if (this.isIrreversible(tx.meta.blockNumber)) this.irreversible.txs.set(txid, tx);
            }
            return tx;
        });
    }
    getReceipt(txid, fetch) {
        return $a3a31f7c24fef244$var$__awaiter(this, void 0, void 0, function*() {
            let receipt = this.irreversible.receipts.get(txid) || null;
            if (receipt) return receipt;
            for (const slot of this.window){
                receipt = slot.receipts.get(txid) || null;
                if (receipt) return receipt;
            }
            receipt = yield fetch();
            if (receipt) {
                const { slot: slot } = this.findSlot(receipt.meta.blockID);
                if (slot) slot.receipts.set(txid, receipt);
                if (this.isIrreversible(receipt.meta.blockNumber)) this.irreversible.receipts.set(txid, receipt);
            }
            return receipt;
        });
    }
    getAccount(addr, revision, fetch) {
        return $a3a31f7c24fef244$var$__awaiter(this, void 0, void 0, function*() {
            const found = this.findSlot(revision);
            for(let i = found.index; i >= 0; i--){
                const slot = this.window[i];
                const acc = slot.accounts.get(addr);
                if (acc) {
                    if (i !== found.index) found.slot.accounts.set(addr, acc);
                    return acc.snapshot(found.slot.timestamp);
                }
                if (!slot.bloom || $a3a31f7c24fef244$var$testBytesHex(slot.bloom, addr)) break;
            }
            const accObj = yield fetch();
            if (found.slot) found.slot.accounts.set(addr, new $a3a31f7c24fef244$var$Account(accObj, found.slot.timestamp));
            return accObj;
        });
    }
    /**
     * get cached entry which is tied to a batch of addresses
     * @param key the cache key
     * @param revision block id where cache bound to
     * @param fetch to fetch value when cache missing
     * @param hints array of tied addresses, as the gist to invalidate cache key. undefined means the key is always
     * invalidated on different revision.
     */ getTied(key, revision, fetch, hints) {
        return $a3a31f7c24fef244$var$__awaiter(this, void 0, void 0, function*() {
            const found = this.findSlot(revision);
            for(let i = found.index; i >= 0; i--){
                const slot = this.window[i];
                const v = slot.tied.get(key);
                if (v) {
                    if (i !== found.index) found.slot.tied.set(key, v);
                    return v;
                }
                if (!slot.bloom || !hints) break;
                // if hints.length === 0, never invalidate cache
                if (hints.some((t)=>$a3a31f7c24fef244$var$testBytesHex(slot.bloom, t))) break;
            }
            const value = yield fetch();
            if (found.slot) found.slot.tied.set(key, value);
            return value;
        });
    }
    findSlot(revision) {
        const index = this.window.findIndex((s)=>s.id === revision || s.number === revision);
        if (index >= 0) return {
            slot: this.window[index],
            index: index
        };
        return {
            index: index
        };
    }
    isIrreversible(n) {
        if (this.window.length > 0) return n < this.window[this.window.length - 1].number - $a3a31f7c24fef244$var$WINDOW_LEN;
        return false;
    }
}
module.exports.Cache = $a3a31f7c24fef244$var$Cache;
function $a3a31f7c24fef244$var$testBytesHex(filter, hex) {
    let buf = $a3a31f7c24fef244$require$Buffer.from(hex.slice(2), "hex");
    const nzIndex = buf.findIndex((v)=>v !== 0);
    if (nzIndex < 0) buf = $a3a31f7c24fef244$require$Buffer.alloc(0);
    else buf = buf.slice(nzIndex);
    return filter.contains(buf);
}
const $a3a31f7c24fef244$var$ENERGY_GROWTH_RATE = 5000000000;
class $a3a31f7c24fef244$var$Account {
    constructor(obj, initTimestamp){
        this.obj = obj;
        this.initTimestamp = initTimestamp;
    }
    snapshot(timestamp) {
        return Object.assign(Object.assign({}, this.obj), {
            energy: this.energyAt(timestamp)
        });
    }
    energyAt(timestamp) {
        if (timestamp < this.initTimestamp) return this.obj.energy;
        return "0x" + new $5Kq8F.default(this.obj.balance).times(timestamp - this.initTimestamp).times($a3a31f7c24fef244$var$ENERGY_GROWTH_RATE).dividedToIntegerBy(1e18).plus(this.obj.energy).toString(16);
    }
}

});
parcelRegister("fCGCe", function(module, exports) {
"use strict";

var $aCuYy = parcelRequire("aCuYy");
const $b5fb762dbcfe3962$var$MAX = Symbol("max");
const $b5fb762dbcfe3962$var$LENGTH = Symbol("length");
const $b5fb762dbcfe3962$var$LENGTH_CALCULATOR = Symbol("lengthCalculator");
const $b5fb762dbcfe3962$var$ALLOW_STALE = Symbol("allowStale");
const $b5fb762dbcfe3962$var$MAX_AGE = Symbol("maxAge");
const $b5fb762dbcfe3962$var$DISPOSE = Symbol("dispose");
const $b5fb762dbcfe3962$var$NO_DISPOSE_ON_SET = Symbol("noDisposeOnSet");
const $b5fb762dbcfe3962$var$LRU_LIST = Symbol("lruList");
const $b5fb762dbcfe3962$var$CACHE = Symbol("cache");
const $b5fb762dbcfe3962$var$UPDATE_AGE_ON_GET = Symbol("updateAgeOnGet");
const $b5fb762dbcfe3962$var$naiveLength = ()=>1;
// lruList is a yallist where the head is the youngest
// item, and the tail is the oldest.  the list contains the Hit
// objects as the entries.
// Each Hit object has a reference to its Yallist.Node.  This
// never changes.
//
// cache is a Map (or PseudoMap) that matches the keys to
// the Yallist.Node object.
class $b5fb762dbcfe3962$var$LRUCache {
    constructor(options){
        if (typeof options === "number") options = {
            max: options
        };
        if (!options) options = {};
        if (options.max && (typeof options.max !== "number" || options.max < 0)) throw new TypeError("max must be a non-negative number");
        // Kind of weird to have a default max of Infinity, but oh well.
        const max = this[$b5fb762dbcfe3962$var$MAX] = options.max || Infinity;
        const lc = options.length || $b5fb762dbcfe3962$var$naiveLength;
        this[$b5fb762dbcfe3962$var$LENGTH_CALCULATOR] = typeof lc !== "function" ? $b5fb762dbcfe3962$var$naiveLength : lc;
        this[$b5fb762dbcfe3962$var$ALLOW_STALE] = options.stale || false;
        if (options.maxAge && typeof options.maxAge !== "number") throw new TypeError("maxAge must be a number");
        this[$b5fb762dbcfe3962$var$MAX_AGE] = options.maxAge || 0;
        this[$b5fb762dbcfe3962$var$DISPOSE] = options.dispose;
        this[$b5fb762dbcfe3962$var$NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false;
        this[$b5fb762dbcfe3962$var$UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false;
        this.reset();
    }
    // resize the cache when the max changes.
    set max(mL) {
        if (typeof mL !== "number" || mL < 0) throw new TypeError("max must be a non-negative number");
        this[$b5fb762dbcfe3962$var$MAX] = mL || Infinity;
        $b5fb762dbcfe3962$var$trim(this);
    }
    get max() {
        return this[$b5fb762dbcfe3962$var$MAX];
    }
    set allowStale(allowStale) {
        this[$b5fb762dbcfe3962$var$ALLOW_STALE] = !!allowStale;
    }
    get allowStale() {
        return this[$b5fb762dbcfe3962$var$ALLOW_STALE];
    }
    set maxAge(mA) {
        if (typeof mA !== "number") throw new TypeError("maxAge must be a non-negative number");
        this[$b5fb762dbcfe3962$var$MAX_AGE] = mA;
        $b5fb762dbcfe3962$var$trim(this);
    }
    get maxAge() {
        return this[$b5fb762dbcfe3962$var$MAX_AGE];
    }
    // resize the cache when the lengthCalculator changes.
    set lengthCalculator(lC) {
        if (typeof lC !== "function") lC = $b5fb762dbcfe3962$var$naiveLength;
        if (lC !== this[$b5fb762dbcfe3962$var$LENGTH_CALCULATOR]) {
            this[$b5fb762dbcfe3962$var$LENGTH_CALCULATOR] = lC;
            this[$b5fb762dbcfe3962$var$LENGTH] = 0;
            this[$b5fb762dbcfe3962$var$LRU_LIST].forEach((hit)=>{
                hit.length = this[$b5fb762dbcfe3962$var$LENGTH_CALCULATOR](hit.value, hit.key);
                this[$b5fb762dbcfe3962$var$LENGTH] += hit.length;
            });
        }
        $b5fb762dbcfe3962$var$trim(this);
    }
    get lengthCalculator() {
        return this[$b5fb762dbcfe3962$var$LENGTH_CALCULATOR];
    }
    get length() {
        return this[$b5fb762dbcfe3962$var$LENGTH];
    }
    get itemCount() {
        return this[$b5fb762dbcfe3962$var$LRU_LIST].length;
    }
    rforEach(fn, thisp) {
        thisp = thisp || this;
        for(let walker = this[$b5fb762dbcfe3962$var$LRU_LIST].tail; walker !== null;){
            const prev = walker.prev;
            $b5fb762dbcfe3962$var$forEachStep(this, fn, walker, thisp);
            walker = prev;
        }
    }
    forEach(fn, thisp) {
        thisp = thisp || this;
        for(let walker = this[$b5fb762dbcfe3962$var$LRU_LIST].head; walker !== null;){
            const next = walker.next;
            $b5fb762dbcfe3962$var$forEachStep(this, fn, walker, thisp);
            walker = next;
        }
    }
    keys() {
        return this[$b5fb762dbcfe3962$var$LRU_LIST].toArray().map((k)=>k.key);
    }
    values() {
        return this[$b5fb762dbcfe3962$var$LRU_LIST].toArray().map((k)=>k.value);
    }
    reset() {
        if (this[$b5fb762dbcfe3962$var$DISPOSE] && this[$b5fb762dbcfe3962$var$LRU_LIST] && this[$b5fb762dbcfe3962$var$LRU_LIST].length) this[$b5fb762dbcfe3962$var$LRU_LIST].forEach((hit)=>this[$b5fb762dbcfe3962$var$DISPOSE](hit.key, hit.value));
        this[$b5fb762dbcfe3962$var$CACHE] = new Map() // hash of items by key
        ;
        this[$b5fb762dbcfe3962$var$LRU_LIST] = new $aCuYy() // list of items in order of use recency
        ;
        this[$b5fb762dbcfe3962$var$LENGTH] = 0 // length of items in the list
        ;
    }
    dump() {
        return this[$b5fb762dbcfe3962$var$LRU_LIST].map((hit)=>$b5fb762dbcfe3962$var$isStale(this, hit) ? false : {
                k: hit.key,
                v: hit.value,
                e: hit.now + (hit.maxAge || 0)
            }).toArray().filter((h)=>h);
    }
    dumpLru() {
        return this[$b5fb762dbcfe3962$var$LRU_LIST];
    }
    set(key, value, maxAge) {
        maxAge = maxAge || this[$b5fb762dbcfe3962$var$MAX_AGE];
        if (maxAge && typeof maxAge !== "number") throw new TypeError("maxAge must be a number");
        const now = maxAge ? Date.now() : 0;
        const len = this[$b5fb762dbcfe3962$var$LENGTH_CALCULATOR](value, key);
        if (this[$b5fb762dbcfe3962$var$CACHE].has(key)) {
            if (len > this[$b5fb762dbcfe3962$var$MAX]) {
                $b5fb762dbcfe3962$var$del(this, this[$b5fb762dbcfe3962$var$CACHE].get(key));
                return false;
            }
            const node = this[$b5fb762dbcfe3962$var$CACHE].get(key);
            const item = node.value;
            // dispose of the old one before overwriting
            // split out into 2 ifs for better coverage tracking
            if (this[$b5fb762dbcfe3962$var$DISPOSE]) {
                if (!this[$b5fb762dbcfe3962$var$NO_DISPOSE_ON_SET]) this[$b5fb762dbcfe3962$var$DISPOSE](key, item.value);
            }
            item.now = now;
            item.maxAge = maxAge;
            item.value = value;
            this[$b5fb762dbcfe3962$var$LENGTH] += len - item.length;
            item.length = len;
            this.get(key);
            $b5fb762dbcfe3962$var$trim(this);
            return true;
        }
        const hit = new $b5fb762dbcfe3962$var$Entry(key, value, len, now, maxAge);
        // oversized objects fall out of cache automatically.
        if (hit.length > this[$b5fb762dbcfe3962$var$MAX]) {
            if (this[$b5fb762dbcfe3962$var$DISPOSE]) this[$b5fb762dbcfe3962$var$DISPOSE](key, value);
            return false;
        }
        this[$b5fb762dbcfe3962$var$LENGTH] += hit.length;
        this[$b5fb762dbcfe3962$var$LRU_LIST].unshift(hit);
        this[$b5fb762dbcfe3962$var$CACHE].set(key, this[$b5fb762dbcfe3962$var$LRU_LIST].head);
        $b5fb762dbcfe3962$var$trim(this);
        return true;
    }
    has(key) {
        if (!this[$b5fb762dbcfe3962$var$CACHE].has(key)) return false;
        const hit = this[$b5fb762dbcfe3962$var$CACHE].get(key).value;
        return !$b5fb762dbcfe3962$var$isStale(this, hit);
    }
    get(key) {
        return $b5fb762dbcfe3962$var$get(this, key, true);
    }
    peek(key) {
        return $b5fb762dbcfe3962$var$get(this, key, false);
    }
    pop() {
        const node = this[$b5fb762dbcfe3962$var$LRU_LIST].tail;
        if (!node) return null;
        $b5fb762dbcfe3962$var$del(this, node);
        return node.value;
    }
    del(key) {
        $b5fb762dbcfe3962$var$del(this, this[$b5fb762dbcfe3962$var$CACHE].get(key));
    }
    load(arr) {
        // reset the cache
        this.reset();
        const now = Date.now();
        // A previous serialized cache has the most recent items first
        for(let l = arr.length - 1; l >= 0; l--){
            const hit = arr[l];
            const expiresAt = hit.e || 0;
            if (expiresAt === 0) // the item was created without expiration in a non aged cache
            this.set(hit.k, hit.v);
            else {
                const maxAge = expiresAt - now;
                // dont add already expired items
                if (maxAge > 0) this.set(hit.k, hit.v, maxAge);
            }
        }
    }
    prune() {
        this[$b5fb762dbcfe3962$var$CACHE].forEach((value, key)=>$b5fb762dbcfe3962$var$get(this, key, false));
    }
}
const $b5fb762dbcfe3962$var$get = (self, key, doUse)=>{
    const node = self[$b5fb762dbcfe3962$var$CACHE].get(key);
    if (node) {
        const hit = node.value;
        if ($b5fb762dbcfe3962$var$isStale(self, hit)) {
            $b5fb762dbcfe3962$var$del(self, node);
            if (!self[$b5fb762dbcfe3962$var$ALLOW_STALE]) return undefined;
        } else if (doUse) {
            if (self[$b5fb762dbcfe3962$var$UPDATE_AGE_ON_GET]) node.value.now = Date.now();
            self[$b5fb762dbcfe3962$var$LRU_LIST].unshiftNode(node);
        }
        return hit.value;
    }
};
const $b5fb762dbcfe3962$var$isStale = (self, hit)=>{
    if (!hit || !hit.maxAge && !self[$b5fb762dbcfe3962$var$MAX_AGE]) return false;
    const diff = Date.now() - hit.now;
    return hit.maxAge ? diff > hit.maxAge : self[$b5fb762dbcfe3962$var$MAX_AGE] && diff > self[$b5fb762dbcfe3962$var$MAX_AGE];
};
const $b5fb762dbcfe3962$var$trim = (self)=>{
    if (self[$b5fb762dbcfe3962$var$LENGTH] > self[$b5fb762dbcfe3962$var$MAX]) for(let walker = self[$b5fb762dbcfe3962$var$LRU_LIST].tail; self[$b5fb762dbcfe3962$var$LENGTH] > self[$b5fb762dbcfe3962$var$MAX] && walker !== null;){
        // We know that we're about to delete this one, and also
        // what the next least recently used key will be, so just
        // go ahead and set it now.
        const prev = walker.prev;
        $b5fb762dbcfe3962$var$del(self, walker);
        walker = prev;
    }
};
const $b5fb762dbcfe3962$var$del = (self, node)=>{
    if (node) {
        const hit = node.value;
        if (self[$b5fb762dbcfe3962$var$DISPOSE]) self[$b5fb762dbcfe3962$var$DISPOSE](hit.key, hit.value);
        self[$b5fb762dbcfe3962$var$LENGTH] -= hit.length;
        self[$b5fb762dbcfe3962$var$CACHE].delete(hit.key);
        self[$b5fb762dbcfe3962$var$LRU_LIST].removeNode(node);
    }
};
class $b5fb762dbcfe3962$var$Entry {
    constructor(key, value, length, now, maxAge){
        this.key = key;
        this.value = value;
        this.length = length;
        this.now = now;
        this.maxAge = maxAge || 0;
    }
}
const $b5fb762dbcfe3962$var$forEachStep = (self, fn, node, thisp)=>{
    let hit = node.value;
    if ($b5fb762dbcfe3962$var$isStale(self, hit)) {
        $b5fb762dbcfe3962$var$del(self, node);
        if (!self[$b5fb762dbcfe3962$var$ALLOW_STALE]) hit = undefined;
    }
    if (hit) fn.call(thisp, hit.value, hit.key, self);
};
module.exports = $b5fb762dbcfe3962$var$LRUCache;

});
parcelRegister("aCuYy", function(module, exports) {
"use strict";
module.exports = $7bb57b1d30306317$var$Yallist;
$7bb57b1d30306317$var$Yallist.Node = $7bb57b1d30306317$var$Node;
$7bb57b1d30306317$var$Yallist.create = $7bb57b1d30306317$var$Yallist;
function $7bb57b1d30306317$var$Yallist(list) {
    var self = this;
    if (!(self instanceof $7bb57b1d30306317$var$Yallist)) self = new $7bb57b1d30306317$var$Yallist();
    self.tail = null;
    self.head = null;
    self.length = 0;
    if (list && typeof list.forEach === "function") list.forEach(function(item) {
        self.push(item);
    });
    else if (arguments.length > 0) for(var i = 0, l = arguments.length; i < l; i++)self.push(arguments[i]);
    return self;
}
$7bb57b1d30306317$var$Yallist.prototype.removeNode = function(node) {
    if (node.list !== this) throw new Error("removing node which does not belong to this list");
    var next = node.next;
    var prev = node.prev;
    if (next) next.prev = prev;
    if (prev) prev.next = next;
    if (node === this.head) this.head = next;
    if (node === this.tail) this.tail = prev;
    node.list.length--;
    node.next = null;
    node.prev = null;
    node.list = null;
    return next;
};
$7bb57b1d30306317$var$Yallist.prototype.unshiftNode = function(node) {
    if (node === this.head) return;
    if (node.list) node.list.removeNode(node);
    var head = this.head;
    node.list = this;
    node.next = head;
    if (head) head.prev = node;
    this.head = node;
    if (!this.tail) this.tail = node;
    this.length++;
};
$7bb57b1d30306317$var$Yallist.prototype.pushNode = function(node) {
    if (node === this.tail) return;
    if (node.list) node.list.removeNode(node);
    var tail = this.tail;
    node.list = this;
    node.prev = tail;
    if (tail) tail.next = node;
    this.tail = node;
    if (!this.head) this.head = node;
    this.length++;
};
$7bb57b1d30306317$var$Yallist.prototype.push = function() {
    for(var i = 0, l = arguments.length; i < l; i++)$7bb57b1d30306317$var$push(this, arguments[i]);
    return this.length;
};
$7bb57b1d30306317$var$Yallist.prototype.unshift = function() {
    for(var i = 0, l = arguments.length; i < l; i++)$7bb57b1d30306317$var$unshift(this, arguments[i]);
    return this.length;
};
$7bb57b1d30306317$var$Yallist.prototype.pop = function() {
    if (!this.tail) return undefined;
    var res = this.tail.value;
    this.tail = this.tail.prev;
    if (this.tail) this.tail.next = null;
    else this.head = null;
    this.length--;
    return res;
};
$7bb57b1d30306317$var$Yallist.prototype.shift = function() {
    if (!this.head) return undefined;
    var res = this.head.value;
    this.head = this.head.next;
    if (this.head) this.head.prev = null;
    else this.tail = null;
    this.length--;
    return res;
};
$7bb57b1d30306317$var$Yallist.prototype.forEach = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.head, i = 0; walker !== null; i++){
        fn.call(thisp, walker.value, i, this);
        walker = walker.next;
    }
};
$7bb57b1d30306317$var$Yallist.prototype.forEachReverse = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.tail, i = this.length - 1; walker !== null; i--){
        fn.call(thisp, walker.value, i, this);
        walker = walker.prev;
    }
};
$7bb57b1d30306317$var$Yallist.prototype.get = function(n) {
    for(var i = 0, walker = this.head; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.next;
    if (i === n && walker !== null) return walker.value;
};
$7bb57b1d30306317$var$Yallist.prototype.getReverse = function(n) {
    for(var i = 0, walker = this.tail; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.prev;
    if (i === n && walker !== null) return walker.value;
};
$7bb57b1d30306317$var$Yallist.prototype.map = function(fn, thisp) {
    thisp = thisp || this;
    var res = new $7bb57b1d30306317$var$Yallist();
    for(var walker = this.head; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.next;
    }
    return res;
};
$7bb57b1d30306317$var$Yallist.prototype.mapReverse = function(fn, thisp) {
    thisp = thisp || this;
    var res = new $7bb57b1d30306317$var$Yallist();
    for(var walker = this.tail; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.prev;
    }
    return res;
};
$7bb57b1d30306317$var$Yallist.prototype.reduce = function(fn, initial) {
    var acc;
    var walker = this.head;
    if (arguments.length > 1) acc = initial;
    else if (this.head) {
        walker = this.head.next;
        acc = this.head.value;
    } else throw new TypeError("Reduce of empty list with no initial value");
    for(var i = 0; walker !== null; i++){
        acc = fn(acc, walker.value, i);
        walker = walker.next;
    }
    return acc;
};
$7bb57b1d30306317$var$Yallist.prototype.reduceReverse = function(fn, initial) {
    var acc;
    var walker = this.tail;
    if (arguments.length > 1) acc = initial;
    else if (this.tail) {
        walker = this.tail.prev;
        acc = this.tail.value;
    } else throw new TypeError("Reduce of empty list with no initial value");
    for(var i = this.length - 1; walker !== null; i--){
        acc = fn(acc, walker.value, i);
        walker = walker.prev;
    }
    return acc;
};
$7bb57b1d30306317$var$Yallist.prototype.toArray = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.head; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.next;
    }
    return arr;
};
$7bb57b1d30306317$var$Yallist.prototype.toArrayReverse = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.tail; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.prev;
    }
    return arr;
};
$7bb57b1d30306317$var$Yallist.prototype.slice = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new $7bb57b1d30306317$var$Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = 0, walker = this.head; walker !== null && i < from; i++)walker = walker.next;
    for(; walker !== null && i < to; i++, walker = walker.next)ret.push(walker.value);
    return ret;
};
$7bb57b1d30306317$var$Yallist.prototype.sliceReverse = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new $7bb57b1d30306317$var$Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = this.length, walker = this.tail; walker !== null && i > to; i--)walker = walker.prev;
    for(; walker !== null && i > from; i--, walker = walker.prev)ret.push(walker.value);
    return ret;
};
$7bb57b1d30306317$var$Yallist.prototype.splice = function(start, deleteCount /*, ...nodes */ ) {
    if (start > this.length) start = this.length - 1;
    if (start < 0) start = this.length + start;
    for(var i = 0, walker = this.head; walker !== null && i < start; i++)walker = walker.next;
    var ret = [];
    for(var i = 0; walker && i < deleteCount; i++){
        ret.push(walker.value);
        walker = this.removeNode(walker);
    }
    if (walker === null) walker = this.tail;
    if (walker !== this.head && walker !== this.tail) walker = walker.prev;
    for(var i = 2; i < arguments.length; i++)walker = $7bb57b1d30306317$var$insert(this, walker, arguments[i]);
    return ret;
};
$7bb57b1d30306317$var$Yallist.prototype.reverse = function() {
    var head = this.head;
    var tail = this.tail;
    for(var walker = head; walker !== null; walker = walker.prev){
        var p = walker.prev;
        walker.prev = walker.next;
        walker.next = p;
    }
    this.head = tail;
    this.tail = head;
    return this;
};
function $7bb57b1d30306317$var$insert(self, node, value) {
    var inserted = node === self.head ? new $7bb57b1d30306317$var$Node(value, null, node, self) : new $7bb57b1d30306317$var$Node(value, node, node.next, self);
    if (inserted.next === null) self.tail = inserted;
    if (inserted.prev === null) self.head = inserted;
    self.length++;
    return inserted;
}
function $7bb57b1d30306317$var$push(self, item) {
    self.tail = new $7bb57b1d30306317$var$Node(item, self.tail, null, self);
    if (!self.head) self.head = self.tail;
    self.length++;
}
function $7bb57b1d30306317$var$unshift(self, item) {
    self.head = new $7bb57b1d30306317$var$Node(item, null, self.head, self);
    if (!self.tail) self.tail = self.head;
    self.length++;
}
function $7bb57b1d30306317$var$Node(value, prev, next, list) {
    if (!(this instanceof $7bb57b1d30306317$var$Node)) return new $7bb57b1d30306317$var$Node(value, prev, next, list);
    this.list = list;
    this.value = value;
    if (prev) {
        prev.next = this;
        this.prev = prev;
    } else this.prev = null;
    if (next) {
        next.prev = this;
        this.next = next;
    } else this.next = null;
}

try {
    // add if support for Symbol.iterator is present
    (parcelRequire("2yyuc"))($7bb57b1d30306317$var$Yallist);
} catch (er) {}

});
parcelRegister("2yyuc", function(module, exports) {
"use strict";
module.exports = function(Yallist) {
    Yallist.prototype[Symbol.iterator] = function*() {
        for(let walker = this.head; walker; walker = walker.next)yield walker.value;
    };
};

});



parcelRegister("5Kq8F", function(module, exports) {
(function(globalObject) {
    "use strict";
    /*
 *      bignumber.js v7.2.1
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2018 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            decimalSeparator: ".",
            groupSeparator: ",",
            groupSize: 3,
            secondaryGroupSize: 0,
            fractionGroupSeparator: "\xa0",
            fractionGroupSize: 0
        }, // The alphabet used for base conversion.
        // It must be at least 2 characters long, with no '.' or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * n {number|string|BigNumber} A numeric value.
     * [b] {number} The base of n. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(n, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor usage without new.
            if (!(x instanceof BigNumber)) // Don't throw on constructor call without new (#81).
            // '[BigNumber Error] Constructor call without new: {n}'
            //throw Error(bignumberError + ' Constructor call without new: ' + n);
            return new BigNumber(n, b);
            if (b == null) {
                // Duplicate.
                if (n instanceof BigNumber) {
                    x.s = n.s;
                    x.e = n.e;
                    x.c = (n = n.c) ? n.slice() : n;
                    return;
                }
                isNum = typeof n == "number";
                if (isNum && n * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / n < 0 ? (n = -n, -1) : 1;
                    // Faster path for integers.
                    if (n === ~~n) {
                        for(e = 0, i = n; i >= 10; i /= 10, e++);
                        x.e = e;
                        x.c = [
                            n
                        ];
                        return;
                    }
                    str = n + "";
                } else {
                    if (!isNumeric.test(str = n + "")) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, "Base");
                str = n + "";
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10) {
                    x = new BigNumber(n instanceof BigNumber ? n : str);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                isNum = typeof n == "number";
                if (isNum) {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (n * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / n < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + n);
                    // Prevent later check for length on converted number.
                    isNum = false;
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == ".") // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, n + "", isNum, b);
                }
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            str = str.slice(i, ++len);
            if (str) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (n > MAX_SAFE_INTEGER || n !== mathfloor(n))) throw Error(tooManyDigits + x.s * n);
                e = e - i - 1;
                // Overflow?
                if (e > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE;
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        str = str.slice(i);
                        i = LOG_BASE - str.length;
                    } else i -= len;
                    for(; i--; str += "0");
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *      decimalSeparator       {string}
     *      groupSeparator         {string}
     *      groupSize              {number}
     *      secondaryGroupSize     {number}
     *      fractionGroupSeparator {string}
     *      fractionGroupSize      {number}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == "object") {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                        v = obj[p];
                        if (isArray(v)) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = "RANGE")) {
                        v = obj[p];
                        if (isArray(v)) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + "crypto unavailable");
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + " not true or false: " + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = "FORMAT")) {
                        v = obj[p];
                        if (typeof v == "object") FORMAT = v;
                        else throw Error(bignumberError + p + " not an object: " + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                        v = obj[p];
                        // Disallow if only one character, or contains '.' or a repeated character.
                        if (typeof v == "string" && !/^.$|\.|(.).*\1/.test(v)) ALPHABET = v;
                        else throw Error(bignumberError + p + " invalid: " + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + "Object expected: " + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * v {any}
     */ BigNumber.isBigNumber = function(v) {
            return v instanceof BigNumber || v && v._isBigNumber === true || false;
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, P.lt);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, P.gt);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + "crypto unavailable");
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = "0123456789";
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace(".", "");
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // THe index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && ne <= TO_EXP_NEG ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += "0", len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e, "0");
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += "."; i--; str += "0");
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += ".";
                            for(; i--; str += "0");
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? "-" + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        function maxOrMin(args, method) {
            var m, n, i = 0;
            if (isArray(args[0])) args = args[0];
            m = new BigNumber(args[0]);
            for(; ++i < args.length;){
                n = new BigNumber(args[i]);
                // If any number is NaN, return NaN.
                if (!n.s) {
                    m = n;
                    break;
                } else if (method.call(m, n)) m = n;
            }
            return m;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) {
                    x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                    x.c = x.e = null;
                } else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                    // NaN
                    x.c = x.e = x.s = null;
                }
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = n / pows10[d - j - 1] % 10 | 0;
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : n / pows10[d - j - 1] % 10 | 0;
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + n);
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+x.valueOf(), nIsBig ? 2 - isOdd(n) : +n));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                nIsOdd = isOdd(n);
            } else nIsOdd = n % 2;
            if (nIsNeg) n.s = 1;
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (nIsBig) {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (!n.c[0]) break;
                    nIsBig = n.e > 14;
                    nIsOdd = isOdd(n);
                } else {
                    n = mathfloor(n / 2);
                    if (!n) break;
                    nIsOdd = n % 2;
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) t = xc, xc = yc, yc = t, y.s = -y.s;
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) zc = xc, xc = yc, yc = zc, i = xcL, xcL = ycL, ycL = i;
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) t = yc, yc = xc, xc = t, b = a;
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times("1e" + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+x);
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += "0";
                s = Math.sqrt(n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = "1e" + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf("e") + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + "");
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == "9999" || !rep && n == "4999") {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the FORMAT object (see BigNumber.set).
     *
     * FORMAT = {
     *      decimalSeparator : '.',
     *      groupSeparator : ',',
     *      groupSize : 3,
     *      secondaryGroupSize : 0,
     *      fractionGroupSeparator : '\xA0',    // non-breaking space
     *      fractionGroupSize : 0
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFormat = function(dp, rm) {
            var str = this.toFixed(dp, rm);
            if (this.c) {
                var i, arr = str.split("."), g1 = +FORMAT.groupSize, g2 = +FORMAT.secondaryGroupSize, groupSeparator = FORMAT.groupSeparator, intPart = arr[0], fractionPart = arr[1], isNeg = this.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) i = g1, g1 = g2, g2 = i, len -= i;
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = "-" + intPart;
                }
                str = fractionPart ? intPart + FORMAT.decimalSeparator + ((g2 = +FORMAT.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + FORMAT.fractionGroupSeparator) : fractionPart) : intPart;
            }
            return str;
        };
        /*
     * Return a string array representing the value of this BigNumber as a simple fraction with
     * an integer numerator and an integer denominator. The denominator will be a positive
     * non-zero value less than or equal to the specified maximum denominator. If a maximum
     * denominator is not specified, the denominator will be the lowest value necessary to
     * represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var arr, d, d0, d1, d2, e, exp, n, n0, n1, q, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + md);
            }
            if (!xc) return x.toString();
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e *= 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            arr = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1.toString(),
                d1.toString()
            ] : [
                n0.toString(),
                d0.toString()
            ];
            MAX_EXP = exp;
            return arr;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +this;
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = "Infinity";
                    if (s < 0) str = "-" + str;
                } else str = "NaN";
            } else {
                str = coeffToString(n.c);
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
                else {
                    intCheck(b, 2, ALPHABET.length, "Base");
                    str = convertBase(toFixedPoint(str, e, "0"), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = "-" + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            var str, n = this, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
            return n.s < 0 ? "-" + str : str;
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + "";
        for(; i < j;){
            s = a[i++] + "";
            z = LOG_BASE - s.length;
            for(; z--; s = "0" + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== (n < 0 ? mathceil(n) : mathfloor(n))) throw Error(bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + n);
    }
    function isArray(obj) {
        return Object.prototype.toString.call(obj) == "[object Array]";
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + "."; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return BigNumber;
    });
    else if (0, module.exports) module.exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != "undefined" && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})(module.exports);

});

parcelRegister("4wvEg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.newFilter = void 0;

var $92UFn = parcelRequire("92UFn");
function $34b2b34dc027e322$var$newFilter(bits, k) {
    const nBits = bits.length * 8;
    return {
        contains (key) {
            let hash = $92UFn.blake2b256(key).readUInt32BE(0);
            const delta = hash >>> 17 | hash << 15 >>> 0;
            for(let i = 0; i < k; i++){
                const bitPos = hash % nBits;
                const index = bitPos >>> 3;
                const bit = 1 << bitPos % 8;
                if (!(bits[index] & bit)) return false;
                hash = hash + delta >>> 0;
            }
            return true;
        }
    };
}
module.exports.newFilter = $34b2b34dc027e322$var$newFilter; // // test vector
 // const bits = Buffer.from('63b2a4758c74e246c818e080b870437f5327a15cf81172512d98e61c54361a851ba8f108420e6b2b74a4196fb8e7bfe2b96c985e49abddb21c0600063997c93edb7c54921551600bcfc80fb62bfcd045c030b328eb8b5498e06dce610d22e901201226226441b8da094141526e0e58f5baf53064d63d598a4024bf68e0', 'hex')
 // const f = newFilter(bits, 6)
 // for (let i = 0; i < 100; i++) {
 //     if (!f.contains(Buffer.from(i + ''))) {
 //         throw new Error('should return true')
 //     }
 // }

});
parcelRegister("92UFn", function(module, exports) {

$parcel$export(module.exports, "blake2b256", () => $696041b52f52cede$export$a00142b13614340a);

var $hf3Gt = parcelRequire("hf3Gt");

var $6ZWSX = parcelRequire("6ZWSX");
function $696041b52f52cede$export$a00142b13614340a(...data) {
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($hf3Gt))).blake2bInit(32);
    data.forEach((d)=>{
        if ((0, $6ZWSX.Buffer).isBuffer(d)) (0, (/*@__PURE__*/$parcel$interopDefault($hf3Gt))).blake2bUpdate(ctx, d);
        else (0, (/*@__PURE__*/$parcel$interopDefault($hf3Gt))).blake2bUpdate(ctx, (0, $6ZWSX.Buffer).from(d, "utf8"));
    });
    return (0, $6ZWSX.Buffer).from((0, (/*@__PURE__*/$parcel$interopDefault($hf3Gt))).blake2bFinal(ctx));
}

});
parcelRegister("hf3Gt", function(module, exports) {

var $kRp7n = parcelRequire("kRp7n");

var $i5ZMu = parcelRequire("i5ZMu");
module.exports = {
    blake2b: $kRp7n.blake2b,
    blake2bHex: $kRp7n.blake2bHex,
    blake2bInit: $kRp7n.blake2bInit,
    blake2bUpdate: $kRp7n.blake2bUpdate,
    blake2bFinal: $kRp7n.blake2bFinal,
    blake2s: $i5ZMu.blake2s,
    blake2sHex: $i5ZMu.blake2sHex,
    blake2sInit: $i5ZMu.blake2sInit,
    blake2sUpdate: $i5ZMu.blake2sUpdate,
    blake2sFinal: $i5ZMu.blake2sFinal
};

});
parcelRegister("kRp7n", function(module, exports) {
// Blake2B in pure Javascript
// Adapted from the reference implementation in RFC7693
// Ported to Javascript by DC - https://github.com/dcposch

var $h8Cd4 = parcelRequire("h8Cd4");
// 64-bit unsigned addition
// Sets v[a,a+1] += v[b,b+1]
// v should be a Uint32Array
function $f2fc3dd0f2723bed$var$ADD64AA(v, a, b) {
    const o0 = v[a] + v[b];
    let o1 = v[a + 1] + v[b + 1];
    if (o0 >= 0x100000000) o1++;
    v[a] = o0;
    v[a + 1] = o1;
}
// 64-bit unsigned addition
// Sets v[a,a+1] += b
// b0 is the low 32 bits of b, b1 represents the high 32 bits
function $f2fc3dd0f2723bed$var$ADD64AC(v, a, b0, b1) {
    let o0 = v[a] + b0;
    if (b0 < 0) o0 += 0x100000000;
    let o1 = v[a + 1] + b1;
    if (o0 >= 0x100000000) o1++;
    v[a] = o0;
    v[a + 1] = o1;
}
// Little-endian byte access
function $f2fc3dd0f2723bed$var$B2B_GET32(arr, i) {
    return arr[i] ^ arr[i + 1] << 8 ^ arr[i + 2] << 16 ^ arr[i + 3] << 24;
}
// G Mixing function
// The ROTRs are inlined for speed
function $f2fc3dd0f2723bed$var$B2B_G(a, b, c, d, ix, iy) {
    const x0 = $f2fc3dd0f2723bed$var$m[ix];
    const x1 = $f2fc3dd0f2723bed$var$m[ix + 1];
    const y0 = $f2fc3dd0f2723bed$var$m[iy];
    const y1 = $f2fc3dd0f2723bed$var$m[iy + 1];
    $f2fc3dd0f2723bed$var$ADD64AA($f2fc3dd0f2723bed$var$v, a, b) // v[a,a+1] += v[b,b+1] ... in JS we must store a uint64 as two uint32s
    ;
    $f2fc3dd0f2723bed$var$ADD64AC($f2fc3dd0f2723bed$var$v, a, x0, x1) // v[a, a+1] += x ... x0 is the low 32 bits of x, x1 is the high 32 bits
    ;
    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated to the right by 32 bits
    let xor0 = $f2fc3dd0f2723bed$var$v[d] ^ $f2fc3dd0f2723bed$var$v[a];
    let xor1 = $f2fc3dd0f2723bed$var$v[d + 1] ^ $f2fc3dd0f2723bed$var$v[a + 1];
    $f2fc3dd0f2723bed$var$v[d] = xor1;
    $f2fc3dd0f2723bed$var$v[d + 1] = xor0;
    $f2fc3dd0f2723bed$var$ADD64AA($f2fc3dd0f2723bed$var$v, c, d);
    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 24 bits
    xor0 = $f2fc3dd0f2723bed$var$v[b] ^ $f2fc3dd0f2723bed$var$v[c];
    xor1 = $f2fc3dd0f2723bed$var$v[b + 1] ^ $f2fc3dd0f2723bed$var$v[c + 1];
    $f2fc3dd0f2723bed$var$v[b] = xor0 >>> 24 ^ xor1 << 8;
    $f2fc3dd0f2723bed$var$v[b + 1] = xor1 >>> 24 ^ xor0 << 8;
    $f2fc3dd0f2723bed$var$ADD64AA($f2fc3dd0f2723bed$var$v, a, b);
    $f2fc3dd0f2723bed$var$ADD64AC($f2fc3dd0f2723bed$var$v, a, y0, y1);
    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated right by 16 bits
    xor0 = $f2fc3dd0f2723bed$var$v[d] ^ $f2fc3dd0f2723bed$var$v[a];
    xor1 = $f2fc3dd0f2723bed$var$v[d + 1] ^ $f2fc3dd0f2723bed$var$v[a + 1];
    $f2fc3dd0f2723bed$var$v[d] = xor0 >>> 16 ^ xor1 << 16;
    $f2fc3dd0f2723bed$var$v[d + 1] = xor1 >>> 16 ^ xor0 << 16;
    $f2fc3dd0f2723bed$var$ADD64AA($f2fc3dd0f2723bed$var$v, c, d);
    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 63 bits
    xor0 = $f2fc3dd0f2723bed$var$v[b] ^ $f2fc3dd0f2723bed$var$v[c];
    xor1 = $f2fc3dd0f2723bed$var$v[b + 1] ^ $f2fc3dd0f2723bed$var$v[c + 1];
    $f2fc3dd0f2723bed$var$v[b] = xor1 >>> 31 ^ xor0 << 1;
    $f2fc3dd0f2723bed$var$v[b + 1] = xor0 >>> 31 ^ xor1 << 1;
}
// Initialization Vector
const $f2fc3dd0f2723bed$var$BLAKE2B_IV32 = new Uint32Array([
    0xf3bcc908,
    0x6a09e667,
    0x84caa73b,
    0xbb67ae85,
    0xfe94f82b,
    0x3c6ef372,
    0x5f1d36f1,
    0xa54ff53a,
    0xade682d1,
    0x510e527f,
    0x2b3e6c1f,
    0x9b05688c,
    0xfb41bd6b,
    0x1f83d9ab,
    0x137e2179,
    0x5be0cd19
]);
const $f2fc3dd0f2723bed$var$SIGMA8 = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9,
    12,
    5,
    1,
    15,
    14,
    13,
    4,
    10,
    0,
    7,
    6,
    3,
    9,
    2,
    8,
    11,
    13,
    11,
    7,
    14,
    12,
    1,
    3,
    9,
    5,
    0,
    15,
    4,
    8,
    6,
    2,
    10,
    6,
    15,
    14,
    9,
    11,
    3,
    0,
    8,
    12,
    2,
    13,
    7,
    1,
    4,
    10,
    5,
    10,
    2,
    8,
    4,
    7,
    6,
    1,
    5,
    15,
    11,
    9,
    14,
    3,
    12,
    13,
    0,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3
];
// These are offsets into a uint64 buffer.
// Multiply them all by 2 to make them offsets into a uint32 buffer,
// because this is Javascript and we don't have uint64s
const $f2fc3dd0f2723bed$var$SIGMA82 = new Uint8Array($f2fc3dd0f2723bed$var$SIGMA8.map(function(x) {
    return x * 2;
}));
// Compression function. 'last' flag indicates last block.
// Note we're representing 16 uint64s as 32 uint32s
const $f2fc3dd0f2723bed$var$v = new Uint32Array(32);
const $f2fc3dd0f2723bed$var$m = new Uint32Array(32);
function $f2fc3dd0f2723bed$var$blake2bCompress(ctx, last) {
    let i = 0;
    // init work variables
    for(i = 0; i < 16; i++){
        $f2fc3dd0f2723bed$var$v[i] = ctx.h[i];
        $f2fc3dd0f2723bed$var$v[i + 16] = $f2fc3dd0f2723bed$var$BLAKE2B_IV32[i];
    }
    // low 64 bits of offset
    $f2fc3dd0f2723bed$var$v[24] = $f2fc3dd0f2723bed$var$v[24] ^ ctx.t;
    $f2fc3dd0f2723bed$var$v[25] = $f2fc3dd0f2723bed$var$v[25] ^ ctx.t / 0x100000000;
    // high 64 bits not supported, offset may not be higher than 2**53-1
    // last block flag set ?
    if (last) {
        $f2fc3dd0f2723bed$var$v[28] = ~$f2fc3dd0f2723bed$var$v[28];
        $f2fc3dd0f2723bed$var$v[29] = ~$f2fc3dd0f2723bed$var$v[29];
    }
    // get little-endian words
    for(i = 0; i < 32; i++)$f2fc3dd0f2723bed$var$m[i] = $f2fc3dd0f2723bed$var$B2B_GET32(ctx.b, 4 * i);
    // twelve rounds of mixing
    // uncomment the DebugPrint calls to log the computation
    // and match the RFC sample documentation
    // util.debugPrint('          m[16]', m, 64)
    for(i = 0; i < 12; i++){
        // util.debugPrint('   (i=' + (i < 10 ? ' ' : '') + i + ') v[16]', v, 64)
        $f2fc3dd0f2723bed$var$B2B_G(0, 8, 16, 24, $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 0], $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 1]);
        $f2fc3dd0f2723bed$var$B2B_G(2, 10, 18, 26, $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 2], $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 3]);
        $f2fc3dd0f2723bed$var$B2B_G(4, 12, 20, 28, $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 4], $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 5]);
        $f2fc3dd0f2723bed$var$B2B_G(6, 14, 22, 30, $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 6], $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 7]);
        $f2fc3dd0f2723bed$var$B2B_G(0, 10, 20, 30, $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 8], $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 9]);
        $f2fc3dd0f2723bed$var$B2B_G(2, 12, 22, 24, $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 10], $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 11]);
        $f2fc3dd0f2723bed$var$B2B_G(4, 14, 16, 26, $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 12], $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 13]);
        $f2fc3dd0f2723bed$var$B2B_G(6, 8, 18, 28, $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 14], $f2fc3dd0f2723bed$var$SIGMA82[i * 16 + 15]);
    }
    // util.debugPrint('   (i=12) v[16]', v, 64)
    for(i = 0; i < 16; i++)ctx.h[i] = ctx.h[i] ^ $f2fc3dd0f2723bed$var$v[i] ^ $f2fc3dd0f2723bed$var$v[i + 16];
// util.debugPrint('h[8]', ctx.h, 64)
}
// reusable parameterBlock
const $f2fc3dd0f2723bed$var$parameterBlock = new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0 // 60: personal
]);
// Creates a BLAKE2b hashing context
// Requires an output length between 1 and 64 bytes
// Takes an optional Uint8Array key
// Takes an optinal Uint8Array salt
// Takes an optinal Uint8Array personal
function $f2fc3dd0f2723bed$var$blake2bInit(outlen, key, salt, personal) {
    if (outlen === 0 || outlen > 64) throw new Error("Illegal output length, expected 0 < length <= 64");
    if (key && key.length > 64) throw new Error("Illegal key, expected Uint8Array with 0 < length <= 64");
    if (salt && salt.length !== 16) throw new Error("Illegal salt, expected Uint8Array with length is 16");
    if (personal && personal.length !== 16) throw new Error("Illegal personal, expected Uint8Array with length is 16");
    // state, 'param block'
    const ctx = {
        b: new Uint8Array(128),
        h: new Uint32Array(16),
        t: 0,
        c: 0,
        outlen: outlen // output length in bytes
    };
    // initialize parameterBlock before usage
    $f2fc3dd0f2723bed$var$parameterBlock.fill(0);
    $f2fc3dd0f2723bed$var$parameterBlock[0] = outlen;
    if (key) $f2fc3dd0f2723bed$var$parameterBlock[1] = key.length;
    $f2fc3dd0f2723bed$var$parameterBlock[2] = 1 // fanout
    ;
    $f2fc3dd0f2723bed$var$parameterBlock[3] = 1 // depth
    ;
    if (salt) $f2fc3dd0f2723bed$var$parameterBlock.set(salt, 32);
    if (personal) $f2fc3dd0f2723bed$var$parameterBlock.set(personal, 48);
    // initialize hash state
    for(let i = 0; i < 16; i++)ctx.h[i] = $f2fc3dd0f2723bed$var$BLAKE2B_IV32[i] ^ $f2fc3dd0f2723bed$var$B2B_GET32($f2fc3dd0f2723bed$var$parameterBlock, i * 4);
    // key the hash, if applicable
    if (key) {
        $f2fc3dd0f2723bed$var$blake2bUpdate(ctx, key);
        // at the end
        ctx.c = 128;
    }
    return ctx;
}
// Updates a BLAKE2b streaming hash
// Requires hash context and Uint8Array (byte array)
function $f2fc3dd0f2723bed$var$blake2bUpdate(ctx, input) {
    for(let i = 0; i < input.length; i++){
        if (ctx.c === 128) {
            // buffer full ?
            ctx.t += ctx.c // add counters
            ;
            $f2fc3dd0f2723bed$var$blake2bCompress(ctx, false) // compress (not last)
            ;
            ctx.c = 0 // counter to zero
            ;
        }
        ctx.b[ctx.c++] = input[i];
    }
}
// Completes a BLAKE2b streaming hash
// Returns a Uint8Array containing the message digest
function $f2fc3dd0f2723bed$var$blake2bFinal(ctx) {
    ctx.t += ctx.c // mark last block offset
    ;
    while(ctx.c < 128)// fill up with zeros
    ctx.b[ctx.c++] = 0;
    $f2fc3dd0f2723bed$var$blake2bCompress(ctx, true) // final block flag = 1
    ;
    // little endian convert and store
    const out = new Uint8Array(ctx.outlen);
    for(let i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3);
    return out;
}
// Computes the BLAKE2B hash of a string or byte array, and returns a Uint8Array
//
// Returns a n-byte Uint8Array
//
// Parameters:
// - input - the input bytes, as a string, Buffer or Uint8Array
// - key - optional key Uint8Array, up to 64 bytes
// - outlen - optional output length in bytes, default 64
// - salt - optional salt bytes, string, Buffer or Uint8Array
// - personal - optional personal bytes, string, Buffer or Uint8Array
function $f2fc3dd0f2723bed$var$blake2b(input, key, outlen, salt, personal) {
    // preprocess inputs
    outlen = outlen || 64;
    input = $h8Cd4.normalizeInput(input);
    if (salt) salt = $h8Cd4.normalizeInput(salt);
    if (personal) personal = $h8Cd4.normalizeInput(personal);
    // do the math
    const ctx = $f2fc3dd0f2723bed$var$blake2bInit(outlen, key, salt, personal);
    $f2fc3dd0f2723bed$var$blake2bUpdate(ctx, input);
    return $f2fc3dd0f2723bed$var$blake2bFinal(ctx);
}
// Computes the BLAKE2B hash of a string or byte array
//
// Returns an n-byte hash in hex, all lowercase
//
// Parameters:
// - input - the input bytes, as a string, Buffer, or Uint8Array
// - key - optional key Uint8Array, up to 64 bytes
// - outlen - optional output length in bytes, default 64
// - salt - optional salt bytes, string, Buffer or Uint8Array
// - personal - optional personal bytes, string, Buffer or Uint8Array
function $f2fc3dd0f2723bed$var$blake2bHex(input, key, outlen, salt, personal) {
    const output = $f2fc3dd0f2723bed$var$blake2b(input, key, outlen, salt, personal);
    return $h8Cd4.toHex(output);
}
module.exports = {
    blake2b: $f2fc3dd0f2723bed$var$blake2b,
    blake2bHex: $f2fc3dd0f2723bed$var$blake2bHex,
    blake2bInit: $f2fc3dd0f2723bed$var$blake2bInit,
    blake2bUpdate: $f2fc3dd0f2723bed$var$blake2bUpdate,
    blake2bFinal: $f2fc3dd0f2723bed$var$blake2bFinal
};

});
parcelRegister("h8Cd4", function(module, exports) {
const $c7a0d2b49b511ad5$var$ERROR_MSG_INPUT = "Input must be an string, Buffer or Uint8Array";
// For convenience, let people hash a string, not just a Uint8Array
function $c7a0d2b49b511ad5$var$normalizeInput(input) {
    let ret;
    if (input instanceof Uint8Array) ret = input;
    else if (typeof input === "string") {
        const encoder = new TextEncoder();
        ret = encoder.encode(input);
    } else throw new Error($c7a0d2b49b511ad5$var$ERROR_MSG_INPUT);
    return ret;
}
// Converts a Uint8Array to a hexadecimal string
// For example, toHex([255, 0, 255]) returns "ff00ff"
function $c7a0d2b49b511ad5$var$toHex(bytes) {
    return Array.prototype.map.call(bytes, function(n) {
        return (n < 16 ? "0" : "") + n.toString(16);
    }).join("");
}
// Converts any value in [0...2^32-1] to an 8-character hex string
function $c7a0d2b49b511ad5$var$uint32ToHex(val) {
    return (0x100000000 + val).toString(16).substring(1);
}
// For debugging: prints out hash state in the same format as the RFC
// sample computation exactly, so that you can diff
function $c7a0d2b49b511ad5$var$debugPrint(label, arr, size) {
    let msg = "\n" + label + " = ";
    for(let i = 0; i < arr.length; i += 2){
        if (size === 32) {
            msg += $c7a0d2b49b511ad5$var$uint32ToHex(arr[i]).toUpperCase();
            msg += " ";
            msg += $c7a0d2b49b511ad5$var$uint32ToHex(arr[i + 1]).toUpperCase();
        } else if (size === 64) {
            msg += $c7a0d2b49b511ad5$var$uint32ToHex(arr[i + 1]).toUpperCase();
            msg += $c7a0d2b49b511ad5$var$uint32ToHex(arr[i]).toUpperCase();
        } else throw new Error("Invalid size " + size);
        if (i % 6 === 4) msg += "\n" + new Array(label.length + 4).join(" ");
        else if (i < arr.length - 2) msg += " ";
    }
    console.log(msg);
}
// For performance testing: generates N bytes of input, hashes M times
// Measures and prints MB/second hash performance each time
function $c7a0d2b49b511ad5$var$testSpeed(hashFn, N, M) {
    let startMs = new Date().getTime();
    const input = new Uint8Array(N);
    for(let i = 0; i < N; i++)input[i] = i % 256;
    const genMs = new Date().getTime();
    console.log("Generated random input in " + (genMs - startMs) + "ms");
    startMs = genMs;
    for(let i = 0; i < M; i++){
        const hashHex = hashFn(input);
        const hashMs = new Date().getTime();
        const ms = hashMs - startMs;
        startMs = hashMs;
        console.log("Hashed in " + ms + "ms: " + hashHex.substring(0, 20) + "...");
        console.log(Math.round(N / 1048576 / (ms / 1000) * 100) / 100 + " MB PER SECOND");
    }
}
module.exports = {
    normalizeInput: $c7a0d2b49b511ad5$var$normalizeInput,
    toHex: $c7a0d2b49b511ad5$var$toHex,
    debugPrint: $c7a0d2b49b511ad5$var$debugPrint,
    testSpeed: $c7a0d2b49b511ad5$var$testSpeed
};

});


parcelRegister("i5ZMu", function(module, exports) {
// BLAKE2s hash function in pure Javascript
// Adapted from the reference implementation in RFC7693
// Ported to Javascript by DC - https://github.com/dcposch

var $h8Cd4 = parcelRequire("h8Cd4");
// Little-endian byte access.
// Expects a Uint8Array and an index
// Returns the little-endian uint32 at v[i..i+3]
function $d2c89e155cff8bdb$var$B2S_GET32(v, i) {
    return v[i] ^ v[i + 1] << 8 ^ v[i + 2] << 16 ^ v[i + 3] << 24;
}
// Mixing function G.
function $d2c89e155cff8bdb$var$B2S_G(a, b, c, d, x, y) {
    $d2c89e155cff8bdb$var$v[a] = $d2c89e155cff8bdb$var$v[a] + $d2c89e155cff8bdb$var$v[b] + x;
    $d2c89e155cff8bdb$var$v[d] = $d2c89e155cff8bdb$var$ROTR32($d2c89e155cff8bdb$var$v[d] ^ $d2c89e155cff8bdb$var$v[a], 16);
    $d2c89e155cff8bdb$var$v[c] = $d2c89e155cff8bdb$var$v[c] + $d2c89e155cff8bdb$var$v[d];
    $d2c89e155cff8bdb$var$v[b] = $d2c89e155cff8bdb$var$ROTR32($d2c89e155cff8bdb$var$v[b] ^ $d2c89e155cff8bdb$var$v[c], 12);
    $d2c89e155cff8bdb$var$v[a] = $d2c89e155cff8bdb$var$v[a] + $d2c89e155cff8bdb$var$v[b] + y;
    $d2c89e155cff8bdb$var$v[d] = $d2c89e155cff8bdb$var$ROTR32($d2c89e155cff8bdb$var$v[d] ^ $d2c89e155cff8bdb$var$v[a], 8);
    $d2c89e155cff8bdb$var$v[c] = $d2c89e155cff8bdb$var$v[c] + $d2c89e155cff8bdb$var$v[d];
    $d2c89e155cff8bdb$var$v[b] = $d2c89e155cff8bdb$var$ROTR32($d2c89e155cff8bdb$var$v[b] ^ $d2c89e155cff8bdb$var$v[c], 7);
}
// 32-bit right rotation
// x should be a uint32
// y must be between 1 and 31, inclusive
function $d2c89e155cff8bdb$var$ROTR32(x, y) {
    return x >>> y ^ x << 32 - y;
}
// Initialization Vector.
const $d2c89e155cff8bdb$var$BLAKE2S_IV = new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
const $d2c89e155cff8bdb$var$SIGMA = new Uint8Array([
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9,
    12,
    5,
    1,
    15,
    14,
    13,
    4,
    10,
    0,
    7,
    6,
    3,
    9,
    2,
    8,
    11,
    13,
    11,
    7,
    14,
    12,
    1,
    3,
    9,
    5,
    0,
    15,
    4,
    8,
    6,
    2,
    10,
    6,
    15,
    14,
    9,
    11,
    3,
    0,
    8,
    12,
    2,
    13,
    7,
    1,
    4,
    10,
    5,
    10,
    2,
    8,
    4,
    7,
    6,
    1,
    5,
    15,
    11,
    9,
    14,
    3,
    12,
    13,
    0
]);
// Compression function. "last" flag indicates last block
const $d2c89e155cff8bdb$var$v = new Uint32Array(16);
const $d2c89e155cff8bdb$var$m = new Uint32Array(16);
function $d2c89e155cff8bdb$var$blake2sCompress(ctx, last) {
    let i = 0;
    for(i = 0; i < 8; i++){
        // init work variables
        $d2c89e155cff8bdb$var$v[i] = ctx.h[i];
        $d2c89e155cff8bdb$var$v[i + 8] = $d2c89e155cff8bdb$var$BLAKE2S_IV[i];
    }
    $d2c89e155cff8bdb$var$v[12] ^= ctx.t // low 32 bits of offset
    ;
    $d2c89e155cff8bdb$var$v[13] ^= ctx.t / 0x100000000 // high 32 bits
    ;
    if (last) // last block flag set ?
    $d2c89e155cff8bdb$var$v[14] = ~$d2c89e155cff8bdb$var$v[14];
    for(i = 0; i < 16; i++)// get little-endian words
    $d2c89e155cff8bdb$var$m[i] = $d2c89e155cff8bdb$var$B2S_GET32(ctx.b, 4 * i);
    // ten rounds of mixing
    // uncomment the DebugPrint calls to log the computation
    // and match the RFC sample documentation
    // util.debugPrint('          m[16]', m, 32)
    for(i = 0; i < 10; i++){
        // util.debugPrint('   (i=' + i + ')  v[16]', v, 32)
        $d2c89e155cff8bdb$var$B2S_G(0, 4, 8, 12, $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 0]], $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 1]]);
        $d2c89e155cff8bdb$var$B2S_G(1, 5, 9, 13, $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 2]], $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 3]]);
        $d2c89e155cff8bdb$var$B2S_G(2, 6, 10, 14, $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 4]], $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 5]]);
        $d2c89e155cff8bdb$var$B2S_G(3, 7, 11, 15, $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 6]], $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 7]]);
        $d2c89e155cff8bdb$var$B2S_G(0, 5, 10, 15, $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 8]], $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 9]]);
        $d2c89e155cff8bdb$var$B2S_G(1, 6, 11, 12, $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 10]], $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 11]]);
        $d2c89e155cff8bdb$var$B2S_G(2, 7, 8, 13, $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 12]], $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 13]]);
        $d2c89e155cff8bdb$var$B2S_G(3, 4, 9, 14, $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 14]], $d2c89e155cff8bdb$var$m[$d2c89e155cff8bdb$var$SIGMA[i * 16 + 15]]);
    }
    // util.debugPrint('   (i=10) v[16]', v, 32)
    for(i = 0; i < 8; i++)ctx.h[i] ^= $d2c89e155cff8bdb$var$v[i] ^ $d2c89e155cff8bdb$var$v[i + 8];
// util.debugPrint('h[8]', ctx.h, 32)
}
// Creates a BLAKE2s hashing context
// Requires an output length between 1 and 32 bytes
// Takes an optional Uint8Array key
function $d2c89e155cff8bdb$var$blake2sInit(outlen, key) {
    if (!(outlen > 0 && outlen <= 32)) throw new Error("Incorrect output length, should be in [1, 32]");
    const keylen = key ? key.length : 0;
    if (key && !(keylen > 0 && keylen <= 32)) throw new Error("Incorrect key length, should be in [1, 32]");
    const ctx = {
        h: new Uint32Array($d2c89e155cff8bdb$var$BLAKE2S_IV),
        b: new Uint8Array(64),
        c: 0,
        t: 0,
        outlen: outlen // output length in bytes
    };
    ctx.h[0] ^= 0x01010000 ^ keylen << 8 ^ outlen;
    if (keylen > 0) {
        $d2c89e155cff8bdb$var$blake2sUpdate(ctx, key);
        ctx.c = 64 // at the end
        ;
    }
    return ctx;
}
// Updates a BLAKE2s streaming hash
// Requires hash context and Uint8Array (byte array)
function $d2c89e155cff8bdb$var$blake2sUpdate(ctx, input) {
    for(let i = 0; i < input.length; i++){
        if (ctx.c === 64) {
            // buffer full ?
            ctx.t += ctx.c // add counters
            ;
            $d2c89e155cff8bdb$var$blake2sCompress(ctx, false) // compress (not last)
            ;
            ctx.c = 0 // counter to zero
            ;
        }
        ctx.b[ctx.c++] = input[i];
    }
}
// Completes a BLAKE2s streaming hash
// Returns a Uint8Array containing the message digest
function $d2c89e155cff8bdb$var$blake2sFinal(ctx) {
    ctx.t += ctx.c // mark last block offset
    ;
    while(ctx.c < 64)// fill up with zeros
    ctx.b[ctx.c++] = 0;
    $d2c89e155cff8bdb$var$blake2sCompress(ctx, true) // final block flag = 1
    ;
    // little endian convert and store
    const out = new Uint8Array(ctx.outlen);
    for(let i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3) & 0xff;
    return out;
}
// Computes the BLAKE2S hash of a string or byte array, and returns a Uint8Array
//
// Returns a n-byte Uint8Array
//
// Parameters:
// - input - the input bytes, as a string, Buffer, or Uint8Array
// - key - optional key Uint8Array, up to 32 bytes
// - outlen - optional output length in bytes, default 64
function $d2c89e155cff8bdb$var$blake2s(input, key, outlen) {
    // preprocess inputs
    outlen = outlen || 32;
    input = $h8Cd4.normalizeInput(input);
    // do the math
    const ctx = $d2c89e155cff8bdb$var$blake2sInit(outlen, key);
    $d2c89e155cff8bdb$var$blake2sUpdate(ctx, input);
    return $d2c89e155cff8bdb$var$blake2sFinal(ctx);
}
// Computes the BLAKE2S hash of a string or byte array
//
// Returns an n-byte hash in hex, all lowercase
//
// Parameters:
// - input - the input bytes, as a string, Buffer, or Uint8Array
// - key - optional key Uint8Array, up to 32 bytes
// - outlen - optional output length in bytes, default 64
function $d2c89e155cff8bdb$var$blake2sHex(input, key, outlen) {
    const output = $d2c89e155cff8bdb$var$blake2s(input, key, outlen);
    return $h8Cd4.toHex(output);
}
module.exports = {
    blake2s: $d2c89e155cff8bdb$var$blake2s,
    blake2sHex: $d2c89e155cff8bdb$var$blake2sHex,
    blake2sInit: $d2c89e155cff8bdb$var$blake2sInit,
    blake2sUpdate: $d2c89e155cff8bdb$var$blake2sUpdate,
    blake2sFinal: $d2c89e155cff8bdb$var$blake2sFinal
};

});





parcelRegister("5ZiX2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sleep = void 0;
function $45c15990488d3124$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
module.exports.sleep = $45c15990488d3124$var$sleep;

});


parcelRegister("azdaC", function(module, exports) {

$parcel$export(module.exports, "Certificate", () => $7b17639d56959fd4$export$ca20b3ed1788c40a);

var $eHb7V = parcelRequire("eHb7V");

var $92UFn = parcelRequire("92UFn");

var $bZmTT = parcelRequire("bZmTT");

var $1FoUm = parcelRequire("1FoUm");

var $6ZWSX = parcelRequire("6ZWSX");
var $7b17639d56959fd4$export$ca20b3ed1788c40a;
(function(Certificate) {
    function safeToLowerCase(str) {
        return typeof str === "string" ? str.toLowerCase() : str;
    }
    /**
     * deterministically encode cert into JSON
     * @param cert cert object
     */ function encode(cert) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1FoUm)))(Object.assign(Object.assign({}, cert), {
            signer: safeToLowerCase(cert.signer),
            signature: cert.signature ? safeToLowerCase(cert.signature) : cert.signature
        }));
    }
    Certificate.encode = encode;
    /**
     * verify the cert
     * @param cert cert object with signature
     */ function verify(cert) {
        if (!cert.signature) throw new Error("signature missing");
        const signature = cert.signature;
        if (!/^0x[0-9a-f]+$/i.test(signature) || signature.length % 2 !== 0) throw new Error("invalid signature");
        const encoded = encode(Object.assign(Object.assign({}, cert), {
            signature: undefined
        }));
        const signingHash = (0, $92UFn.blake2b256)(encoded);
        const pubKey = (0, $bZmTT.secp256k1).recover(signingHash, (0, $6ZWSX.Buffer).from(signature.slice(2), "hex"));
        if ((0, $eHb7V.address).fromPublicKey(pubKey) !== safeToLowerCase(cert.signer)) throw new Error("signature does not match with signer");
    }
    Certificate.verify = verify;
})($7b17639d56959fd4$export$ca20b3ed1788c40a || ($7b17639d56959fd4$export$ca20b3ed1788c40a = {}));

});
parcelRegister("eHb7V", function(module, exports) {

$parcel$export(module.exports, "address", () => $ab2db660dfba525e$export$f7d3c097ceca6c15);

var $aCcJY = parcelRequire("aCcJY");
var $ab2db660dfba525e$export$f7d3c097ceca6c15;
(function(address) {
    /**
     * derive Address from public key, note that the public key is uncompressed
     * @param pub the public key
     */ function fromPublicKey(pub) {
        return "0x" + (0, $aCcJY.keccak256)(pub.slice(1)).slice(12).toString("hex");
    }
    address.fromPublicKey = fromPublicKey;
    /**
     * to check if a value presents an address
     * @param v the value to be checked
     */ function test(v) {
        return typeof v === "string" && /^0x[0-9a-f]{40}$/i.test(v);
    }
    address.test = test;
    /**
     * encode the address to checksumed address that is compatible with eip-55
     * @param address input address
     */ function toChecksumed(addr) {
        if (!test(addr)) throw new Error("invalid address");
        addr = addr.slice(2).toLowerCase();
        const hash = (0, $aCcJY.keccak256)(addr);
        let checksumed = "0x";
        for(let i = 0; i < addr.length; i++){
            // tslint:disable-next-line:no-bitwise
            let byte = hash[i >> 1];
            if (i % 2 === 0) // tslint:disable-next-line:no-bitwise
            byte >>= 4;
            if (byte % 16 >= 8) checksumed += addr[i].toUpperCase();
            else checksumed += addr[i];
        }
        return checksumed;
    }
    address.toChecksumed = toChecksumed;
})($ab2db660dfba525e$export$f7d3c097ceca6c15 || ($ab2db660dfba525e$export$f7d3c097ceca6c15 = {}));

});
parcelRegister("aCcJY", function(module, exports) {

$parcel$export(module.exports, "keccak256", () => $7ba755fc74a4d4d1$export$f8151fce47ad1c35);

var $1IGmO = parcelRequire("1IGmO");

var $6ZWSX = parcelRequire("6ZWSX");
function $7ba755fc74a4d4d1$export$f8151fce47ad1c35(...data) {
    const h = (0, $1IGmO.keccak_256).create();
    data.forEach((d)=>{
        if ((0, $6ZWSX.Buffer).isBuffer(d)) h.update(d);
        else h.update((0, $6ZWSX.Buffer).from(d, "utf8"));
    });
    return (0, $6ZWSX.Buffer).from(h.digest());
}

});
parcelRegister("1IGmO", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.5.7
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2016
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var root = typeof window === "object" ? window : {};
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $hPtJY === "object" && $hPtJY.versions && $hPtJY.versions.node;
    if (NODE_JS) root = $parcel$global;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array"
    ];
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(bits, padding, type);
        }
        return method;
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createShakeOutputMethod(bits, padding, type);
        }
        return method;
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        var notString = typeof message !== "string";
        if (notString && message.constructor === ArrayBuffer) message = new Uint8Array(message);
        var length = message.length, blocks = this.blocks, byteCount = this.byteCount, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.finalize = function() {
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            if (extraBytes > 0) hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            if (extraBytes > 0) array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else for(var i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
})();

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});




parcelRegister("bZmTT", function(module, exports) {

$parcel$export(module.exports, "secp256k1", () => $8ba727c812e615e2$export$529e6123e9353a90);

var $5UUfm = parcelRequire("5UUfm");

var $1zUcV = parcelRequire("1zUcV");

var $6ZWSX = parcelRequire("6ZWSX");
const $8ba727c812e615e2$var$curve = new (0, $1zUcV.ec)("secp256k1");
const $8ba727c812e615e2$var$N = (0, $6ZWSX.Buffer).from("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", "hex");
const $8ba727c812e615e2$var$ZERO = (0, $6ZWSX.Buffer).alloc(32, 0);
function $8ba727c812e615e2$var$isValidPrivateKey(key) {
    return (0, $6ZWSX.Buffer).isBuffer(key) && key.length === 32 && !key.equals($8ba727c812e615e2$var$ZERO) && key.compare($8ba727c812e615e2$var$N) < 0;
}
function $8ba727c812e615e2$var$isValidMessageHash(hash) {
    return (0, $6ZWSX.Buffer).isBuffer(hash) && hash.length === 32;
}
var $8ba727c812e615e2$export$529e6123e9353a90;
(function(secp256k1) {
    /**
     * generate private key
     * @param rng the optional random number generator, which exactly generates 32 random bytes
     */ function generatePrivateKey(rng) {
        rng = rng !== null && rng !== void 0 ? rng : ()=>(0, $5UUfm.randomBytes)(32);
        for(;;){
            const privKey = rng();
            if ($8ba727c812e615e2$var$isValidPrivateKey(privKey)) return privKey;
        }
    }
    secp256k1.generatePrivateKey = generatePrivateKey;
    /**
     * derive public key(uncompressed) from private key
     * @param privKey the private key
     */ function derivePublicKey(privKey) {
        if (!$8ba727c812e615e2$var$isValidPrivateKey(privKey)) throw new Error("invalid private key");
        const keyPair = $8ba727c812e615e2$var$curve.keyFromPrivate(privKey);
        return (0, $6ZWSX.Buffer).from(keyPair.getPublic().encode("array", false));
    }
    secp256k1.derivePublicKey = derivePublicKey;
    /**
     * sign a message using elliptic curve algorithm on the curve secp256k1
     * @param msgHash hash of message
     * @param privKey serialized private key
     */ function sign(msgHash, privKey) {
        if (!$8ba727c812e615e2$var$isValidMessageHash(msgHash)) throw new Error("invalid message hash");
        if (!$8ba727c812e615e2$var$isValidPrivateKey(privKey)) throw new Error("invalid private key");
        const keyPair = $8ba727c812e615e2$var$curve.keyFromPrivate(privKey);
        const sig = keyPair.sign(msgHash, {
            canonical: true
        });
        const r = (0, $6ZWSX.Buffer).from(sig.r.toArray("be", 32));
        const s = (0, $6ZWSX.Buffer).from(sig.s.toArray("be", 32));
        return (0, $6ZWSX.Buffer).concat([
            r,
            s,
            (0, $6ZWSX.Buffer).from([
                sig.recoveryParam
            ])
        ]);
    }
    secp256k1.sign = sign;
    /**
     * recovery signature to public key
     * @param msgHash hash of message
     * @param sig signature
     */ function recover(msgHash, sig) {
        if (!$8ba727c812e615e2$var$isValidMessageHash(msgHash)) throw new Error("invalid message hash");
        if (!(0, $6ZWSX.Buffer).isBuffer(sig) || sig.length !== 65) throw new Error("invalid signature");
        const recovery = sig[64];
        if (recovery !== 0 && recovery !== 1) throw new Error("invalid signature recovery");
        const r = sig.slice(0, 32);
        const s = sig.slice(32, 64);
        return (0, $6ZWSX.Buffer).from($8ba727c812e615e2$var$curve.recoverPubKey(msgHash, {
            r: r,
            s: s
        }, recovery).encode("array", false));
    }
    secp256k1.recover = recover;
})($8ba727c812e615e2$export$529e6123e9353a90 || ($8ba727c812e615e2$export$529e6123e9353a90 = {}));

});
parcelRegister("5UUfm", function(module, exports) {

$parcel$export(module.exports, "randomBytes", () => $44edd02a6be448cd$export$5f828d93ff035aa8, (v) => $44edd02a6be448cd$export$5f828d93ff035aa8 = v);
var $44edd02a6be448cd$export$5f828d93ff035aa8;
var $44edd02a6be448cd$export$cd94982b18c6332c;
var $44edd02a6be448cd$export$1d518568e4f529b0;
var $44edd02a6be448cd$export$5285b6d41c912b41;
var $44edd02a6be448cd$export$2fb37efbf6ae0c0e;
var $44edd02a6be448cd$export$ab85ecd77ce6a5cd;
var $44edd02a6be448cd$export$da39cf97e1eb7c91;
var $44edd02a6be448cd$export$52a9039d7177394f;
var $44edd02a6be448cd$export$f7201db400317331;
var $44edd02a6be448cd$export$448fa22aedc9dbca;
var $44edd02a6be448cd$export$b80c7ba289c8fa56;
var $44edd02a6be448cd$export$26e5786e8ac8e530;
var $44edd02a6be448cd$export$bdd223f16383713e;
var $44edd02a6be448cd$export$20533d26f07f1ee0;
var $44edd02a6be448cd$export$2f64596b8cbf08b4;
var $44edd02a6be448cd$export$2ce6d8d0e8b04e1a;
var $44edd02a6be448cd$export$12ada9414fbc594c;
var $44edd02a6be448cd$export$f5e7e39d57cd9700;
var $44edd02a6be448cd$export$36b6d6ef312eab39;
var $44edd02a6be448cd$export$58a258485f1e49f6;
var $44edd02a6be448cd$export$dedd8dc3dc62b370;
var $44edd02a6be448cd$export$971862a2fcb1bb40;
var $44edd02a6be448cd$export$c6ff6a88acbeaf40;
var $44edd02a6be448cd$export$fdc27893e98845cc;
var $44edd02a6be448cd$export$6671fb9a1323bed;
var $44edd02a6be448cd$export$d74daf141a551db;
var $44edd02a6be448cd$export$45df7cae684751af;
var $44edd02a6be448cd$export$1db683ad541682f6;
var $44edd02a6be448cd$export$6f65485f87568e37;
var $44edd02a6be448cd$export$91a8e56769aeb334;
var $44edd02a6be448cd$export$2d4117e99c2179e4;
var $44edd02a6be448cd$export$512823e338ddb1b7;
var $44edd02a6be448cd$export$9d0e0c0c4a8d30f3;
var $44edd02a6be448cd$export$b9d55ff329113abd;
var $44edd02a6be448cd$export$7efb24e2fddf99b9;
var $44edd02a6be448cd$export$bb1abf2ce84fc7e8;
var $44edd02a6be448cd$export$2f7171e78e524d5e;
var $44edd02a6be448cd$export$e1d879b482f37d98;
var $44edd02a6be448cd$export$1a988e7317c65621;
"use strict";

$44edd02a6be448cd$export$5f828d93ff035aa8 = $44edd02a6be448cd$export$cd94982b18c6332c = $44edd02a6be448cd$export$1d518568e4f529b0 = $44edd02a6be448cd$export$5285b6d41c912b41 = (parcelRequire("hkN9y"));

$44edd02a6be448cd$export$2fb37efbf6ae0c0e = $44edd02a6be448cd$export$ab85ecd77ce6a5cd = (parcelRequire("1R2J7"));

$44edd02a6be448cd$export$da39cf97e1eb7c91 = $44edd02a6be448cd$export$52a9039d7177394f = (parcelRequire("1iL1D"));

var $eFSIF = parcelRequire("eFSIF");
var $44edd02a6be448cd$var$algoKeys = Object.keys($eFSIF);
var $44edd02a6be448cd$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($44edd02a6be448cd$var$algoKeys);
$44edd02a6be448cd$export$f7201db400317331 = function() {
    return $44edd02a6be448cd$var$hashes;
};

var $lORrZ = parcelRequire("lORrZ");
$44edd02a6be448cd$export$448fa22aedc9dbca = $lORrZ.pbkdf2;
$44edd02a6be448cd$export$b80c7ba289c8fa56 = $lORrZ.pbkdf2Sync;

var $eyeBm = parcelRequire("eyeBm");
$44edd02a6be448cd$export$26e5786e8ac8e530 = $eyeBm.Cipher;
$44edd02a6be448cd$export$bdd223f16383713e = $eyeBm.createCipher;
$44edd02a6be448cd$export$20533d26f07f1ee0 = $eyeBm.Cipheriv;
$44edd02a6be448cd$export$2f64596b8cbf08b4 = $eyeBm.createCipheriv;
$44edd02a6be448cd$export$2ce6d8d0e8b04e1a = $eyeBm.Decipher;
$44edd02a6be448cd$export$12ada9414fbc594c = $eyeBm.createDecipher;
$44edd02a6be448cd$export$f5e7e39d57cd9700 = $eyeBm.Decipheriv;
$44edd02a6be448cd$export$36b6d6ef312eab39 = $eyeBm.createDecipheriv;
$44edd02a6be448cd$export$58a258485f1e49f6 = $eyeBm.getCiphers;
$44edd02a6be448cd$export$dedd8dc3dc62b370 = $eyeBm.listCiphers;

var $5NszM = parcelRequire("5NszM");
$44edd02a6be448cd$export$971862a2fcb1bb40 = $5NszM.DiffieHellmanGroup;
$44edd02a6be448cd$export$c6ff6a88acbeaf40 = $5NszM.createDiffieHellmanGroup;
$44edd02a6be448cd$export$fdc27893e98845cc = $5NszM.getDiffieHellman;
$44edd02a6be448cd$export$6671fb9a1323bed = $5NszM.createDiffieHellman;
$44edd02a6be448cd$export$d74daf141a551db = $5NszM.DiffieHellman;

var $4zMFU = parcelRequire("4zMFU");
$44edd02a6be448cd$export$45df7cae684751af = $4zMFU.createSign;
$44edd02a6be448cd$export$1db683ad541682f6 = $4zMFU.Sign;
$44edd02a6be448cd$export$6f65485f87568e37 = $4zMFU.createVerify;
$44edd02a6be448cd$export$91a8e56769aeb334 = $4zMFU.Verify;

$44edd02a6be448cd$export$2d4117e99c2179e4 = (parcelRequire("fd3gh"));

var $fMM6j = parcelRequire("fMM6j");
$44edd02a6be448cd$export$512823e338ddb1b7 = $fMM6j.publicEncrypt;
$44edd02a6be448cd$export$9d0e0c0c4a8d30f3 = $fMM6j.privateEncrypt;
$44edd02a6be448cd$export$b9d55ff329113abd = $fMM6j.publicDecrypt;
$44edd02a6be448cd$export$7efb24e2fddf99b9 = $fMM6j.privateDecrypt;

var $c34vB = parcelRequire("c34vB");
$44edd02a6be448cd$export$bb1abf2ce84fc7e8 = $c34vB.randomFill;
$44edd02a6be448cd$export$2f7171e78e524d5e = $c34vB.randomFillSync;
$44edd02a6be448cd$export$e1d879b482f37d98 = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
$44edd02a6be448cd$export$1a988e7317c65621 = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};

});
parcelRegister("hkN9y", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $c9ea6eb6e1b0be83$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $c9ea6eb6e1b0be83$var$MAX_UINT32 = 4294967295;
function $c9ea6eb6e1b0be83$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $1U9GM = parcelRequire("1U9GM");
var $c9ea6eb6e1b0be83$require$Buffer = $1U9GM.Buffer;
var $c9ea6eb6e1b0be83$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($c9ea6eb6e1b0be83$var$crypto && $c9ea6eb6e1b0be83$var$crypto.getRandomValues) module.exports = $c9ea6eb6e1b0be83$var$randomBytes;
else module.exports = $c9ea6eb6e1b0be83$var$oldBrowser;
function $c9ea6eb6e1b0be83$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $c9ea6eb6e1b0be83$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $c9ea6eb6e1b0be83$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $c9ea6eb6e1b0be83$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $c9ea6eb6e1b0be83$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes.slice(generated, generated + $c9ea6eb6e1b0be83$var$MAX_BYTES));
        else $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $hPtJY.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});


parcelRegister("1R2J7", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $loYLU = parcelRequire("loYLU");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $26nOC = parcelRequire("26nOC");
function $159cdb2c74f453a8$var$Hash(hash) {
    $26nOC.call(this, "digest");
    this._hash = hash;
}
$dlqwk($159cdb2c74f453a8$var$Hash, $26nOC);
$159cdb2c74f453a8$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$159cdb2c74f453a8$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $loYLU();
    if (alg === "rmd160" || alg === "ripemd160") return new $a8qBR();
    return new $159cdb2c74f453a8$var$Hash($5Z1sR(alg));
};

});
parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("loYLU", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");

var $1U9GM = parcelRequire("1U9GM");
var $f94afad95abc0930$require$Buffer = $1U9GM.Buffer;
var $f94afad95abc0930$var$ARRAY16 = new Array(16);
function $f94afad95abc0930$var$MD5() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$dlqwk($f94afad95abc0930$var$MD5, $eLdEM);
$f94afad95abc0930$var$MD5.prototype._update = function() {
    var M = $f94afad95abc0930$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$f94afad95abc0930$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $f94afad95abc0930$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $f94afad95abc0930$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $f94afad95abc0930$var$fnF(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnG(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnH(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnI(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $f94afad95abc0930$var$MD5;

});
parcelRegister("eLdEM", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $abf00c68ae11d39d$require$Buffer = $1U9GM.Buffer;

var $b6RFW = parcelRequire("b6RFW");
var $abf00c68ae11d39d$require$Transform = $b6RFW.Transform;

var $dlqwk = parcelRequire("dlqwk");
function $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $abf00c68ae11d39d$var$HashBase(blockSize) {
    $abf00c68ae11d39d$require$Transform.call(this);
    this._block = $abf00c68ae11d39d$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dlqwk($abf00c68ae11d39d$var$HashBase, $abf00c68ae11d39d$require$Transform);
$abf00c68ae11d39d$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype.update = function(data, encoding) {
    $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(data)) data = $abf00c68ae11d39d$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$abf00c68ae11d39d$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$abf00c68ae11d39d$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$abf00c68ae11d39d$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $abf00c68ae11d39d$var$HashBase;

});
parcelRegister("b6RFW", function(module, exports) {

exports = module.exports = (parcelRequire("d4xg3"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("3LwY7"));

exports.Duplex = (parcelRequire("DwJuQ"));

exports.Transform = (parcelRequire("b7kl8"));

exports.PassThrough = (parcelRequire("4wWcs"));

exports.finished = (parcelRequire("fiCvv"));

exports.pipeline = (parcelRequire("aGSwO"));

});
parcelRegister("d4xg3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $9845726cca5dc7eb$var$Readable;
/*<replacement>*/ var $9845726cca5dc7eb$var$Duplex;
/*</replacement>*/ $9845726cca5dc7eb$var$Readable.ReadableState = $9845726cca5dc7eb$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $9845726cca5dc7eb$require$EE = $7etJZ.EventEmitter;
var $9845726cca5dc7eb$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $9845726cca5dc7eb$require$Buffer = $6ZWSX.Buffer;
var $9845726cca5dc7eb$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk) {
    return $9845726cca5dc7eb$require$Buffer.from(chunk);
}
function $9845726cca5dc7eb$var$_isUint8Array(obj) {
    return $9845726cca5dc7eb$require$Buffer.isBuffer(obj) || obj instanceof $9845726cca5dc7eb$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $9845726cca5dc7eb$var$debug;
if ($kjyEk && $kjyEk.debuglog) $9845726cca5dc7eb$var$debug = $kjyEk.debuglog("stream");
else $9845726cca5dc7eb$var$debug = function debug() {};

var $bF5dL = parcelRequire("bF5dL");

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $9845726cca5dc7eb$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $9845726cca5dc7eb$require$_require$codes = $6JySE.codes;
var $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE = $9845726cca5dc7eb$require$_require$codes.ERR_INVALID_ARG_TYPE, $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED = $9845726cca5dc7eb$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $9845726cca5dc7eb$var$StringDecoder;
var $9845726cca5dc7eb$var$createReadableStreamAsyncIterator;
var $9845726cca5dc7eb$var$from;

(parcelRequire("dlqwk"))($9845726cca5dc7eb$var$Readable, $jfAlf);
var $9845726cca5dc7eb$var$errorOrDestroy = $fMCbt.errorOrDestroy;
var $9845726cca5dc7eb$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $9845726cca5dc7eb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9845726cca5dc7eb$var$ReadableState(options, stream, isDuplex) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $9845726cca5dc7eb$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $9845726cca5dc7eb$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $bF5dL();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $9845726cca5dc7eb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9845726cca5dc7eb$var$Readable(options) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    if (!(this instanceof $9845726cca5dc7eb$var$Readable)) return new $9845726cca5dc7eb$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $9845726cca5dc7eb$var$Duplex;
    this._readableState = new $9845726cca5dc7eb$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jfAlf.call(this);
}
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9845726cca5dc7eb$var$Readable.prototype.destroy = $fMCbt.destroy;
$9845726cca5dc7eb$var$Readable.prototype._undestroy = $fMCbt.undestroy;
$9845726cca5dc7eb$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9845726cca5dc7eb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9845726cca5dc7eb$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$9845726cca5dc7eb$var$Readable.prototype.unshift = function(chunk) {
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, null, true, false);
};
function $9845726cca5dc7eb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $9845726cca5dc7eb$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9845726cca5dc7eb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9845726cca5dc7eb$var$chunkInvalid(state, chunk);
        if (er) $9845726cca5dc7eb$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $9845726cca5dc7eb$require$Buffer.prototype) chunk = $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
                    else $9845726cca5dc7eb$var$maybeReadMore(stream, state);
                } else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $9845726cca5dc7eb$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $9845726cca5dc7eb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9845726cca5dc7eb$var$emitReadable(stream);
    }
    $9845726cca5dc7eb$var$maybeReadMore(stream, state);
}
function $9845726cca5dc7eb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9845726cca5dc7eb$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$9845726cca5dc7eb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$9845726cca5dc7eb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $9845726cca5dc7eb$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $9845726cca5dc7eb$var$MAX_HWM = 0x40000000;
function $9845726cca5dc7eb$var$computeNewHighWaterMark(n) {
    if (n >= $9845726cca5dc7eb$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $9845726cca5dc7eb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9845726cca5dc7eb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$9845726cca5dc7eb$var$Readable.prototype.read = function(n) {
    $9845726cca5dc7eb$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $9845726cca5dc7eb$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $9845726cca5dc7eb$var$endReadable(this);
        else $9845726cca5dc7eb$var$emitReadable(this);
        return null;
    }
    n = $9845726cca5dc7eb$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9845726cca5dc7eb$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9845726cca5dc7eb$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9845726cca5dc7eb$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9845726cca5dc7eb$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $9845726cca5dc7eb$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9845726cca5dc7eb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9845726cca5dc7eb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9845726cca5dc7eb$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $9845726cca5dc7eb$var$onEofChunk(stream, state) {
    $9845726cca5dc7eb$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $9845726cca5dc7eb$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $9845726cca5dc7eb$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9845726cca5dc7eb$var$emitReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9845726cca5dc7eb$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$emitReadable_, stream);
    }
}
function $9845726cca5dc7eb$var$emitReadable_(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $9845726cca5dc7eb$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9845726cca5dc7eb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$maybeReadMore_, stream, state);
    }
}
function $9845726cca5dc7eb$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $9845726cca5dc7eb$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9845726cca5dc7eb$var$Readable.prototype._read = function(n) {
    $9845726cca5dc7eb$var$errorOrDestroy(this, new $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$9845726cca5dc7eb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9845726cca5dc7eb$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9845726cca5dc7eb$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9845726cca5dc7eb$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9845726cca5dc7eb$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9845726cca5dc7eb$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $9845726cca5dc7eb$var$debug("ondata");
        var ret = dest.write(chunk);
        $9845726cca5dc7eb$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9845726cca5dc7eb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9845726cca5dc7eb$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9845726cca5dc7eb$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($9845726cca5dc7eb$var$EElistenerCount(dest, "error") === 0) $9845726cca5dc7eb$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $9845726cca5dc7eb$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $9845726cca5dc7eb$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $9845726cca5dc7eb$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $9845726cca5dc7eb$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $9845726cca5dc7eb$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9845726cca5dc7eb$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $9845726cca5dc7eb$var$flow(src);
        }
    };
}
$9845726cca5dc7eb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $9845726cca5dc7eb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$9845726cca5dc7eb$var$Readable.prototype.on = function(ev, fn) {
    var res = $jfAlf.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $9845726cca5dc7eb$var$debug("on readable", state.length, state.reading);
            if (state.length) $9845726cca5dc7eb$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($9845726cca5dc7eb$var$nReadingNextTick, this);
        }
    }
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.addListener = $9845726cca5dc7eb$var$Readable.prototype.on;
$9845726cca5dc7eb$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jfAlf.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jfAlf.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
function $9845726cca5dc7eb$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $9845726cca5dc7eb$var$nReadingNextTick(self1) {
    $9845726cca5dc7eb$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9845726cca5dc7eb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $9845726cca5dc7eb$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $9845726cca5dc7eb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$resume_, stream, state);
    }
}
function $9845726cca5dc7eb$var$resume_(stream, state) {
    $9845726cca5dc7eb$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $9845726cca5dc7eb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9845726cca5dc7eb$var$Readable.prototype.pause = function() {
    $9845726cca5dc7eb$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $9845726cca5dc7eb$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $9845726cca5dc7eb$var$flow(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9845726cca5dc7eb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $9845726cca5dc7eb$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $9845726cca5dc7eb$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $9845726cca5dc7eb$var$kProxyEvents.length; n++)stream.on($9845726cca5dc7eb$var$kProxyEvents[n], this.emit.bind(this, $9845726cca5dc7eb$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9845726cca5dc7eb$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($9845726cca5dc7eb$var$createReadableStreamAsyncIterator === undefined) $9845726cca5dc7eb$var$createReadableStreamAsyncIterator = (parcelRequire("2UdT6"));
    return $9845726cca5dc7eb$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$9845726cca5dc7eb$var$Readable._fromList = $9845726cca5dc7eb$var$fromList;
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $9845726cca5dc7eb$var$endReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$endReadableNT, state, stream);
    }
}
function $9845726cca5dc7eb$var$endReadableNT(state, stream) {
    $9845726cca5dc7eb$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.from = function(iterable, opts) {
    if ($9845726cca5dc7eb$var$from === undefined) $9845726cca5dc7eb$var$from = (parcelRequire("e6P81"));
    return $9845726cca5dc7eb$var$from($9845726cca5dc7eb$var$Readable, iterable, opts);
};
function $9845726cca5dc7eb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("jfAlf", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("bF5dL", function(module, exports) {
"use strict";
function $87d792cd1b95f90e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $87d792cd1b95f90e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $87d792cd1b95f90e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $87d792cd1b95f90e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $87d792cd1b95f90e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $87d792cd1b95f90e$var$_defineProperty(obj, key, value) {
    key = $87d792cd1b95f90e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $87d792cd1b95f90e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $87d792cd1b95f90e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $87d792cd1b95f90e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $87d792cd1b95f90e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $87d792cd1b95f90e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $87d792cd1b95f90e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $87d792cd1b95f90e$var$_toPropertyKey(arg) {
    var key = $87d792cd1b95f90e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $87d792cd1b95f90e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $87d792cd1b95f90e$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $87d792cd1b95f90e$var$inspect = $kjyEk.inspect;
var $87d792cd1b95f90e$var$custom = $87d792cd1b95f90e$var$inspect && $87d792cd1b95f90e$var$inspect.custom || "inspect";
function $87d792cd1b95f90e$var$copyBuffer(src, target, offset) {
    $87d792cd1b95f90e$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $87d792cd1b95f90e$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $87d792cd1b95f90e$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $87d792cd1b95f90e$var$Buffer.alloc(0);
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $87d792cd1b95f90e$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $87d792cd1b95f90e$var$custom,
            value: function value(_, options) {
                return $87d792cd1b95f90e$var$inspect(this, $87d792cd1b95f90e$var$_objectSpread($87d792cd1b95f90e$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("fMCbt", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $b7d8f541ca4a3ff5$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
    });
    return this;
}
function $b7d8f541ca4a3ff5$var$emitErrorAndCloseNT(self, err) {
    $b7d8f541ca4a3ff5$var$emitErrorNT(self, err);
    $b7d8f541ca4a3ff5$var$emitCloseNT(self);
}
function $b7d8f541ca4a3ff5$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $b7d8f541ca4a3ff5$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b7d8f541ca4a3ff5$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $b7d8f541ca4a3ff5$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $b7d8f541ca4a3ff5$var$destroy,
    undestroy: $b7d8f541ca4a3ff5$var$undestroy,
    errorOrDestroy: $b7d8f541ca4a3ff5$var$errorOrDestroy
};

});

parcelRegister("04a3B", function(module, exports) {
"use strict";

var $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE = (parcelRequire("6JySE")).codes.ERR_INVALID_OPT_VALUE;
function $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $00c82cf8dac417cf$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $00c82cf8dac417cf$var$getHighWaterMark
};

});
parcelRegister("6JySE", function(module, exports) {

$parcel$export(module.exports, "codes", () => $4e720097bc0bc9d8$export$e45cb6485273080e, (v) => $4e720097bc0bc9d8$export$e45cb6485273080e = v);
var $4e720097bc0bc9d8$export$e45cb6485273080e;
"use strict";
function $4e720097bc0bc9d8$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4e720097bc0bc9d8$var$codes = {};
function $4e720097bc0bc9d8$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $4e720097bc0bc9d8$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $4e720097bc0bc9d8$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $4e720097bc0bc9d8$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $4e720097bc0bc9d8$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $4e720097bc0bc9d8$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $4e720097bc0bc9d8$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $4e720097bc0bc9d8$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($4e720097bc0bc9d8$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    else {
        var type = $4e720097bc0bc9d8$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$4e720097bc0bc9d8$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$4e720097bc0bc9d8$export$e45cb6485273080e = $4e720097bc0bc9d8$var$codes;

});


parcelRegister("DwJuQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $076d08b0309449dc$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $076d08b0309449dc$var$Duplex;

var $d4xg3 = parcelRequire("d4xg3");

var $3LwY7 = parcelRequire("3LwY7");

(parcelRequire("dlqwk"))($076d08b0309449dc$var$Duplex, $d4xg3);
// Allow the keys array to be GC'ed.
var $076d08b0309449dc$var$keys = $076d08b0309449dc$var$objectKeys($3LwY7.prototype);
for(var $076d08b0309449dc$var$v = 0; $076d08b0309449dc$var$v < $076d08b0309449dc$var$keys.length; $076d08b0309449dc$var$v++){
    var $076d08b0309449dc$var$method = $076d08b0309449dc$var$keys[$076d08b0309449dc$var$v];
    if (!$076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method]) $076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method] = $3LwY7.prototype[$076d08b0309449dc$var$method];
}
function $076d08b0309449dc$var$Duplex(options) {
    if (!(this instanceof $076d08b0309449dc$var$Duplex)) return new $076d08b0309449dc$var$Duplex(options);
    $d4xg3.call(this, options);
    $3LwY7.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $076d08b0309449dc$var$onend);
        }
    }
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $076d08b0309449dc$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($076d08b0309449dc$var$onEndNT, this);
}
function $076d08b0309449dc$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("3LwY7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $2bdf55c2c4f390d3$var$Writable;
/* <replacement> */ function $2bdf55c2c4f390d3$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2bdf55c2c4f390d3$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2bdf55c2c4f390d3$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2bdf55c2c4f390d3$var$Duplex;
/*</replacement>*/ $2bdf55c2c4f390d3$var$Writable.WritableState = $2bdf55c2c4f390d3$var$WritableState;

/*<replacement>*/ var $2bdf55c2c4f390d3$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $2bdf55c2c4f390d3$require$Buffer = $6ZWSX.Buffer;
var $2bdf55c2c4f390d3$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk) {
    return $2bdf55c2c4f390d3$require$Buffer.from(chunk);
}
function $2bdf55c2c4f390d3$var$_isUint8Array(obj) {
    return $2bdf55c2c4f390d3$require$Buffer.isBuffer(obj) || obj instanceof $2bdf55c2c4f390d3$var$OurUint8Array;
}

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $2bdf55c2c4f390d3$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $2bdf55c2c4f390d3$require$_require$codes = $6JySE.codes;
var $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_INVALID_ARG_TYPE, $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED = $2bdf55c2c4f390d3$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK = $2bdf55c2c4f390d3$require$_require$codes.ERR_MULTIPLE_CALLBACK, $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_DESTROYED, $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_NULL_VALUES, $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING = $2bdf55c2c4f390d3$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $2bdf55c2c4f390d3$var$errorOrDestroy = $fMCbt.errorOrDestroy;

(parcelRequire("dlqwk"))($2bdf55c2c4f390d3$var$Writable, $jfAlf);
function $2bdf55c2c4f390d3$var$nop() {}

function $2bdf55c2c4f390d3$var$WritableState(options, stream, isDuplex) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $2bdf55c2c4f390d3$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $2bdf55c2c4f390d3$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2bdf55c2c4f390d3$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(this);
}
$2bdf55c2c4f390d3$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2bdf55c2c4f390d3$var$WritableState.prototype, "buffer", {
            get: $2bdf55c2c4f390d3$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2bdf55c2c4f390d3$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $2bdf55c2c4f390d3$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2bdf55c2c4f390d3$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($2bdf55c2c4f390d3$var$realHasInstance.call(this, object)) return true;
            if (this !== $2bdf55c2c4f390d3$var$Writable) return false;
            return object && object._writableState instanceof $2bdf55c2c4f390d3$var$WritableState;
        }
    });
} else $2bdf55c2c4f390d3$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $2bdf55c2c4f390d3$var$Writable(options) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $2bdf55c2c4f390d3$var$Duplex;
    if (!isDuplex && !$2bdf55c2c4f390d3$var$realHasInstance.call($2bdf55c2c4f390d3$var$Writable, this)) return new $2bdf55c2c4f390d3$var$Writable(options);
    this._writableState = new $2bdf55c2c4f390d3$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jfAlf.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$2bdf55c2c4f390d3$var$Writable.prototype.pipe = function() {
    $2bdf55c2c4f390d3$var$errorOrDestroy(this, new $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE());
};
function $2bdf55c2c4f390d3$var$writeAfterEnd(stream, cb) {
    var er = new $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2bdf55c2c4f390d3$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$2bdf55c2c4f390d3$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2bdf55c2c4f390d3$var$_isUint8Array(chunk);
    if (isBuf && !$2bdf55c2c4f390d3$require$Buffer.isBuffer(chunk)) chunk = $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $2bdf55c2c4f390d3$var$nop;
    if (state.ending) $2bdf55c2c4f390d3$var$writeAfterEnd(this, cb);
    else if (isBuf || $2bdf55c2c4f390d3$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2bdf55c2c4f390d3$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2bdf55c2c4f390d3$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$2bdf55c2c4f390d3$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(this, state);
    }
};
$2bdf55c2c4f390d3$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $2bdf55c2c4f390d3$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2bdf55c2c4f390d3$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2bdf55c2c4f390d3$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($2bdf55c2c4f390d3$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    }
}
function $2bdf55c2c4f390d3$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2bdf55c2c4f390d3$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK();
    $2bdf55c2c4f390d3$var$onwriteStateUpdate(state);
    if (er) $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2bdf55c2c4f390d3$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($2bdf55c2c4f390d3$var$afterWrite, stream, state, finished, cb);
        else $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb);
    }
}
function $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2bdf55c2c4f390d3$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2bdf55c2c4f390d3$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $2bdf55c2c4f390d3$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2bdf55c2c4f390d3$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2bdf55c2c4f390d3$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$2bdf55c2c4f390d3$var$Writable.prototype._writev = null;
$2bdf55c2c4f390d3$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $2bdf55c2c4f390d3$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $2bdf55c2c4f390d3$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2bdf55c2c4f390d3$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $2bdf55c2c4f390d3$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    });
}
function $2bdf55c2c4f390d3$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($2bdf55c2c4f390d3$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $2bdf55c2c4f390d3$var$finishMaybe(stream, state) {
    var need = $2bdf55c2c4f390d3$var$needFinish(state);
    if (need) {
        $2bdf55c2c4f390d3$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $2bdf55c2c4f390d3$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2bdf55c2c4f390d3$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2bdf55c2c4f390d3$var$Writable.prototype.destroy = $fMCbt.destroy;
$2bdf55c2c4f390d3$var$Writable.prototype._undestroy = $fMCbt.undestroy;
$2bdf55c2c4f390d3$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config("throwDeprecation")) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});

parcelRegister("2UdT6", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $21db958e3a099d7d$var$_Object$setPrototypeO;
function $21db958e3a099d7d$var$_defineProperty(obj, key, value) {
    key = $21db958e3a099d7d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $21db958e3a099d7d$var$_toPropertyKey(arg) {
    var key = $21db958e3a099d7d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $21db958e3a099d7d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $fiCvv = parcelRequire("fiCvv");
var $21db958e3a099d7d$var$kLastResolve = Symbol("lastResolve");
var $21db958e3a099d7d$var$kLastReject = Symbol("lastReject");
var $21db958e3a099d7d$var$kError = Symbol("error");
var $21db958e3a099d7d$var$kEnded = Symbol("ended");
var $21db958e3a099d7d$var$kLastPromise = Symbol("lastPromise");
var $21db958e3a099d7d$var$kHandlePromise = Symbol("handlePromise");
var $21db958e3a099d7d$var$kStream = Symbol("stream");
function $21db958e3a099d7d$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $21db958e3a099d7d$var$readAndResolve(iter) {
    var resolve = iter[$21db958e3a099d7d$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$21db958e3a099d7d$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$21db958e3a099d7d$var$kLastPromise] = null;
            iter[$21db958e3a099d7d$var$kLastResolve] = null;
            iter[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(data, false));
        }
    }
}
function $21db958e3a099d7d$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($21db958e3a099d7d$var$readAndResolve, iter);
}
function $21db958e3a099d7d$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$21db958e3a099d7d$var$kEnded]) {
                resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
                return;
            }
            iter[$21db958e3a099d7d$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $21db958e3a099d7d$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($21db958e3a099d7d$var$_Object$setPrototypeO = {
    get stream () {
        return this[$21db958e3a099d7d$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$21db958e3a099d7d$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$21db958e3a099d7d$var$kEnded]) return Promise.resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        if (this[$21db958e3a099d7d$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$21db958e3a099d7d$var$kError]) reject(_this[$21db958e3a099d7d$var$kError]);
                else resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$21db958e3a099d7d$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($21db958e3a099d7d$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$21db958e3a099d7d$var$kStream].read();
            if (data !== null) return Promise.resolve($21db958e3a099d7d$var$createIterResult(data, false));
            promise = new Promise(this[$21db958e3a099d7d$var$kHandlePromise]);
        }
        this[$21db958e3a099d7d$var$kLastPromise] = promise;
        return promise;
    }
}, $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$21db958e3a099d7d$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        });
    });
}), $21db958e3a099d7d$var$_Object$setPrototypeO), $21db958e3a099d7d$var$AsyncIteratorPrototype);
var $21db958e3a099d7d$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kStream, {
        value: stream,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastResolve, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastReject, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kError, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$21db958e3a099d7d$var$kStream].read();
            if (data) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                resolve($21db958e3a099d7d$var$createIterResult(data, false));
            } else {
                iterator[$21db958e3a099d7d$var$kLastResolve] = resolve;
                iterator[$21db958e3a099d7d$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$21db958e3a099d7d$var$kLastPromise] = null;
    $fiCvv(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$21db958e3a099d7d$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                reject(err);
            }
            iterator[$21db958e3a099d7d$var$kError] = err;
            return;
        }
        var resolve = iterator[$21db958e3a099d7d$var$kLastResolve];
        if (resolve !== null) {
            iterator[$21db958e3a099d7d$var$kLastPromise] = null;
            iterator[$21db958e3a099d7d$var$kLastResolve] = null;
            iterator[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        }
        iterator[$21db958e3a099d7d$var$kEnded] = true;
    });
    stream.on("readable", $21db958e3a099d7d$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $21db958e3a099d7d$var$createReadableStreamAsyncIterator;

});
parcelRegister("fiCvv", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("6JySE")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $b236683171fcb6ee$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $b236683171fcb6ee$var$noop() {}
function $b236683171fcb6ee$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $b236683171fcb6ee$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $b236683171fcb6ee$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $b236683171fcb6ee$var$once(callback || $b236683171fcb6ee$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($b236683171fcb6ee$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $b236683171fcb6ee$var$eos;

});


parcelRegister("e6P81", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("b7kl8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $8180203f7f0d3074$var$Transform;

var $6JySE = parcelRequire("6JySE");
var $8180203f7f0d3074$require$_require$codes = $6JySE.codes;
var $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED = $8180203f7f0d3074$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK = $8180203f7f0d3074$require$_require$codes.ERR_MULTIPLE_CALLBACK, $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0 = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $DwJuQ = parcelRequire("DwJuQ");

(parcelRequire("dlqwk"))($8180203f7f0d3074$var$Transform, $DwJuQ);
function $8180203f7f0d3074$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $8180203f7f0d3074$var$Transform(options) {
    if (!(this instanceof $8180203f7f0d3074$var$Transform)) return new $8180203f7f0d3074$var$Transform(options);
    $DwJuQ.call(this, options);
    this._transformState = {
        afterTransform: $8180203f7f0d3074$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $8180203f7f0d3074$var$prefinish);
}
function $8180203f7f0d3074$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $8180203f7f0d3074$var$done(_this, er, data);
    });
    else $8180203f7f0d3074$var$done(this, null, null);
}
$8180203f7f0d3074$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $DwJuQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$8180203f7f0d3074$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$8180203f7f0d3074$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$8180203f7f0d3074$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$8180203f7f0d3074$var$Transform.prototype._destroy = function(err, cb) {
    $DwJuQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $8180203f7f0d3074$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("4wWcs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $34c74be520d619f2$var$PassThrough;

var $b7kl8 = parcelRequire("b7kl8");

(parcelRequire("dlqwk"))($34c74be520d619f2$var$PassThrough, $b7kl8);
function $34c74be520d619f2$var$PassThrough(options) {
    if (!(this instanceof $34c74be520d619f2$var$PassThrough)) return new $34c74be520d619f2$var$PassThrough(options);
    $b7kl8.call(this, options);
}
$34c74be520d619f2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("aGSwO", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $7c881fce7a4fadf1$var$eos;
function $7c881fce7a4fadf1$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $6JySE = parcelRequire("6JySE");
var $7c881fce7a4fadf1$require$_require$codes = $6JySE.codes;
var $7c881fce7a4fadf1$var$ERR_MISSING_ARGS = $7c881fce7a4fadf1$require$_require$codes.ERR_MISSING_ARGS, $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED = $7c881fce7a4fadf1$require$_require$codes.ERR_STREAM_DESTROYED;
function $7c881fce7a4fadf1$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $7c881fce7a4fadf1$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, callback) {
    callback = $7c881fce7a4fadf1$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($7c881fce7a4fadf1$var$eos === undefined) $7c881fce7a4fadf1$var$eos = (parcelRequire("fiCvv"));
    $7c881fce7a4fadf1$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($7c881fce7a4fadf1$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $7c881fce7a4fadf1$var$call(fn) {
    fn();
}
function $7c881fce7a4fadf1$var$pipe(from, to) {
    return from.pipe(to);
}
function $7c881fce7a4fadf1$var$popCallback(streams) {
    if (!streams.length) return $7c881fce7a4fadf1$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $7c881fce7a4fadf1$var$noop;
    return streams.pop();
}
function $7c881fce7a4fadf1$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $7c881fce7a4fadf1$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $7c881fce7a4fadf1$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($7c881fce7a4fadf1$var$call);
            if (reading) return;
            destroys.forEach($7c881fce7a4fadf1$var$call);
            callback(error);
        });
    });
    return streams.reduce($7c881fce7a4fadf1$var$pipe);
}
module.exports = $7c881fce7a4fadf1$var$pipeline;

});




parcelRegister("a8qBR", function(module, exports) {
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");
var $760f4ae3157f7f0b$require$Buffer = $6ZWSX.Buffer;

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");
var $760f4ae3157f7f0b$var$ARRAY16 = new Array(16);
var $760f4ae3157f7f0b$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $760f4ae3157f7f0b$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $760f4ae3157f7f0b$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $760f4ae3157f7f0b$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $760f4ae3157f7f0b$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $760f4ae3157f7f0b$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $760f4ae3157f7f0b$var$RIPEMD160() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dlqwk($760f4ae3157f7f0b$var$RIPEMD160, $eLdEM);
$760f4ae3157f7f0b$var$RIPEMD160.prototype._update = function() {
    var words = $760f4ae3157f7f0b$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $760f4ae3157f7f0b$var$fn1(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[0], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn5(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[0], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 32) {
            tl = $760f4ae3157f7f0b$var$fn2(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[1], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn4(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[1], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 48) {
            tl = $760f4ae3157f7f0b$var$fn3(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[2], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn3(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[2], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 64) {
            tl = $760f4ae3157f7f0b$var$fn4(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[3], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn2(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[3], $760f4ae3157f7f0b$var$sr[i]);
        } else {
            tl = $760f4ae3157f7f0b$var$fn5(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[4], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn1(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[4], $760f4ae3157f7f0b$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $760f4ae3157f7f0b$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $760f4ae3157f7f0b$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$760f4ae3157f7f0b$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $760f4ae3157f7f0b$require$Buffer.alloc ? $760f4ae3157f7f0b$require$Buffer.alloc(20) : new $760f4ae3157f7f0b$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $760f4ae3157f7f0b$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $760f4ae3157f7f0b$var$fn1(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn2(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn3(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn4(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn5(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $760f4ae3157f7f0b$var$RIPEMD160;

});

parcelRegister("5Z1sR", function(module, exports) {
var $45b3c90d57600982$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $45b3c90d57600982$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$45b3c90d57600982$var$exports.sha = (parcelRequire("dECyV"));

$45b3c90d57600982$var$exports.sha1 = (parcelRequire("dVcFO"));

$45b3c90d57600982$var$exports.sha224 = (parcelRequire("3wNjm"));

$45b3c90d57600982$var$exports.sha256 = (parcelRequire("3BFQx"));

$45b3c90d57600982$var$exports.sha384 = (parcelRequire("5qHaZ"));

$45b3c90d57600982$var$exports.sha512 = (parcelRequire("bZI17"));

});
parcelRegister("dECyV", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $9f0cec708e1f2103$require$Buffer = $1U9GM.Buffer;
var $9f0cec708e1f2103$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $9f0cec708e1f2103$var$W = new Array(80);
function $9f0cec708e1f2103$var$Sha() {
    this.init();
    this._w = $9f0cec708e1f2103$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($9f0cec708e1f2103$var$Sha, $O5ywn);
$9f0cec708e1f2103$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $9f0cec708e1f2103$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $9f0cec708e1f2103$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $9f0cec708e1f2103$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$9f0cec708e1f2103$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $9f0cec708e1f2103$var$rotl5(a) + $9f0cec708e1f2103$var$ft(s, b, c, d) + e + W[j] + $9f0cec708e1f2103$var$K[s] | 0;
        e = d;
        d = c;
        c = $9f0cec708e1f2103$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$9f0cec708e1f2103$var$Sha.prototype._hash = function() {
    var H = $9f0cec708e1f2103$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $9f0cec708e1f2103$var$Sha;

});
parcelRegister("O5ywn", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $0968fae43eb53960$require$Buffer = $1U9GM.Buffer;
// prototype class for hash functions
function $0968fae43eb53960$var$Hash(blockSize, finalSize) {
    this._block = $0968fae43eb53960$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$0968fae43eb53960$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $0968fae43eb53960$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$0968fae43eb53960$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$0968fae43eb53960$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $0968fae43eb53960$var$Hash;

});


parcelRegister("dVcFO", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $a22a6de6a357c37a$require$Buffer = $1U9GM.Buffer;
var $a22a6de6a357c37a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $a22a6de6a357c37a$var$W = new Array(80);
function $a22a6de6a357c37a$var$Sha1() {
    this.init();
    this._w = $a22a6de6a357c37a$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($a22a6de6a357c37a$var$Sha1, $O5ywn);
$a22a6de6a357c37a$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $a22a6de6a357c37a$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $a22a6de6a357c37a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $a22a6de6a357c37a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $a22a6de6a357c37a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$a22a6de6a357c37a$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $a22a6de6a357c37a$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $a22a6de6a357c37a$var$rotl5(a) + $a22a6de6a357c37a$var$ft(s, b, c, d) + e + W[j] + $a22a6de6a357c37a$var$K[s] | 0;
        e = d;
        d = c;
        c = $a22a6de6a357c37a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$a22a6de6a357c37a$var$Sha1.prototype._hash = function() {
    var H = $a22a6de6a357c37a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $a22a6de6a357c37a$var$Sha1;

});

parcelRegister("3wNjm", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $3BFQx = parcelRequire("3BFQx");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $291a9c6c5654a48d$require$Buffer = $1U9GM.Buffer;
var $291a9c6c5654a48d$var$W = new Array(64);
function $291a9c6c5654a48d$var$Sha224() {
    this.init();
    this._w = $291a9c6c5654a48d$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($291a9c6c5654a48d$var$Sha224, $3BFQx);
$291a9c6c5654a48d$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$291a9c6c5654a48d$var$Sha224.prototype._hash = function() {
    var H = $291a9c6c5654a48d$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $291a9c6c5654a48d$var$Sha224;

});
parcelRegister("3BFQx", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $2a05499bef58a0cf$require$Buffer = $1U9GM.Buffer;
var $2a05499bef58a0cf$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $2a05499bef58a0cf$var$W = new Array(64);
function $2a05499bef58a0cf$var$Sha256() {
    this.init();
    this._w = $2a05499bef58a0cf$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($2a05499bef58a0cf$var$Sha256, $O5ywn);
$2a05499bef58a0cf$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $2a05499bef58a0cf$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $2a05499bef58a0cf$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $2a05499bef58a0cf$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $2a05499bef58a0cf$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $2a05499bef58a0cf$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $2a05499bef58a0cf$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$2a05499bef58a0cf$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $2a05499bef58a0cf$var$gamma1(W[i - 2]) + W[i - 7] + $2a05499bef58a0cf$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $2a05499bef58a0cf$var$sigma1(e) + $2a05499bef58a0cf$var$ch(e, f, g) + $2a05499bef58a0cf$var$K[j] + W[j] | 0;
        var T2 = $2a05499bef58a0cf$var$sigma0(a) + $2a05499bef58a0cf$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$2a05499bef58a0cf$var$Sha256.prototype._hash = function() {
    var H = $2a05499bef58a0cf$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $2a05499bef58a0cf$var$Sha256;

});


parcelRegister("5qHaZ", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $bZI17 = parcelRequire("bZI17");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $01052ce47f94a5df$require$Buffer = $1U9GM.Buffer;
var $01052ce47f94a5df$var$W = new Array(160);
function $01052ce47f94a5df$var$Sha384() {
    this.init();
    this._w = $01052ce47f94a5df$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($01052ce47f94a5df$var$Sha384, $bZI17);
$01052ce47f94a5df$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$01052ce47f94a5df$var$Sha384.prototype._hash = function() {
    var H = $01052ce47f94a5df$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $01052ce47f94a5df$var$Sha384;

});
parcelRegister("bZI17", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $8bb7891960962038$require$Buffer = $1U9GM.Buffer;
var $8bb7891960962038$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8bb7891960962038$var$W = new Array(160);
function $8bb7891960962038$var$Sha512() {
    this.init();
    this._w = $8bb7891960962038$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($8bb7891960962038$var$Sha512, $O5ywn);
$8bb7891960962038$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8bb7891960962038$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8bb7891960962038$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8bb7891960962038$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8bb7891960962038$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8bb7891960962038$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8bb7891960962038$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8bb7891960962038$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8bb7891960962038$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8bb7891960962038$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8bb7891960962038$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $8bb7891960962038$var$Gamma0(xh, xl);
        var gamma0l = $8bb7891960962038$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $8bb7891960962038$var$Gamma1(xh, xl);
        var gamma1l = $8bb7891960962038$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8bb7891960962038$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8bb7891960962038$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8bb7891960962038$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $8bb7891960962038$var$maj(ah, bh, ch);
        var majl = $8bb7891960962038$var$maj(al, bl, cl);
        var sigma0h = $8bb7891960962038$var$sigma0(ah, al);
        var sigma0l = $8bb7891960962038$var$sigma0(al, ah);
        var sigma1h = $8bb7891960962038$var$sigma1(eh, el);
        var sigma1l = $8bb7891960962038$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $8bb7891960962038$var$K[j];
        var Kil = $8bb7891960962038$var$K[j + 1];
        var chh = $8bb7891960962038$var$Ch(eh, fh, gh);
        var chl = $8bb7891960962038$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8bb7891960962038$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8bb7891960962038$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8bb7891960962038$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8bb7891960962038$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8bb7891960962038$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8bb7891960962038$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8bb7891960962038$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8bb7891960962038$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8bb7891960962038$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8bb7891960962038$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8bb7891960962038$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8bb7891960962038$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8bb7891960962038$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8bb7891960962038$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8bb7891960962038$var$getCarry(this._hl, hl) | 0;
};
$8bb7891960962038$var$Sha512.prototype._hash = function() {
    var H = $8bb7891960962038$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8bb7891960962038$var$Sha512;

});



parcelRegister("26nOC", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $187e9d8dfda3dbba$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $187e9d8dfda3dbba$require$Transform = $ioRHp.Transform;

var $eNRCS = parcelRequire("eNRCS");
var $187e9d8dfda3dbba$require$StringDecoder = $eNRCS.StringDecoder;

var $dlqwk = parcelRequire("dlqwk");
function $187e9d8dfda3dbba$var$CipherBase(hashMode) {
    $187e9d8dfda3dbba$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$dlqwk($187e9d8dfda3dbba$var$CipherBase, $187e9d8dfda3dbba$require$Transform);
$187e9d8dfda3dbba$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $187e9d8dfda3dbba$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAutoPadding = function() {};
$187e9d8dfda3dbba$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$187e9d8dfda3dbba$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$187e9d8dfda3dbba$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $187e9d8dfda3dbba$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $187e9d8dfda3dbba$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $187e9d8dfda3dbba$var$CipherBase;

});
parcelRegister("ioRHp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $d6541f691ffb0af6$var$Stream;

var $7etJZ = parcelRequire("7etJZ");
var $d6541f691ffb0af6$require$EE = $7etJZ.EventEmitter;

var $dlqwk = parcelRequire("dlqwk");
$dlqwk($d6541f691ffb0af6$var$Stream, $d6541f691ffb0af6$require$EE);

$d6541f691ffb0af6$var$Stream.Readable = (parcelRequire("d4xg3"));

$d6541f691ffb0af6$var$Stream.Writable = (parcelRequire("3LwY7"));

$d6541f691ffb0af6$var$Stream.Duplex = (parcelRequire("DwJuQ"));

$d6541f691ffb0af6$var$Stream.Transform = (parcelRequire("b7kl8"));

$d6541f691ffb0af6$var$Stream.PassThrough = (parcelRequire("4wWcs"));

$d6541f691ffb0af6$var$Stream.finished = (parcelRequire("fiCvv"));

$d6541f691ffb0af6$var$Stream.pipeline = (parcelRequire("aGSwO"));
// Backwards-compat with node 0.4.x
$d6541f691ffb0af6$var$Stream.Stream = $d6541f691ffb0af6$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6541f691ffb0af6$var$Stream() {
    $d6541f691ffb0af6$require$EE.call(this);
}
$d6541f691ffb0af6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6541f691ffb0af6$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});



parcelRegister("1iL1D", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $77ZZs = parcelRequire("77ZZs");

var $26nOC = parcelRequire("26nOC");

var $1U9GM = parcelRequire("1U9GM");
var $0f2bf322914b61b2$require$Buffer = $1U9GM.Buffer;

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");
var $0f2bf322914b61b2$var$ZEROS = $0f2bf322914b61b2$require$Buffer.alloc(128);
function $0f2bf322914b61b2$var$Hmac(alg, key) {
    $26nOC.call(this, "digest");
    if (typeof key === "string") key = $0f2bf322914b61b2$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $a8qBR() : $5Z1sR(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $0f2bf322914b61b2$require$Buffer.concat([
        key,
        $0f2bf322914b61b2$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $a8qBR() : $5Z1sR(alg);
    this._hash.update(ipad);
}
$dlqwk($0f2bf322914b61b2$var$Hmac, $26nOC);
$0f2bf322914b61b2$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$0f2bf322914b61b2$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $a8qBR() : $5Z1sR(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $0f2bf322914b61b2$var$Hmac("rmd160", key);
    if (alg === "md5") return new $77ZZs($8nM4g, key);
    return new $0f2bf322914b61b2$var$Hmac(alg, key);
};

});
parcelRegister("77ZZs", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $530945d1f5e7b9b5$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");
var $530945d1f5e7b9b5$var$ZEROS = $530945d1f5e7b9b5$require$Buffer.alloc(128);
var $530945d1f5e7b9b5$var$blocksize = 64;
function $530945d1f5e7b9b5$var$Hmac(alg, key) {
    $26nOC.call(this, "digest");
    if (typeof key === "string") key = $530945d1f5e7b9b5$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $530945d1f5e7b9b5$var$blocksize) key = alg(key);
    else if (key.length < $530945d1f5e7b9b5$var$blocksize) key = $530945d1f5e7b9b5$require$Buffer.concat([
        key,
        $530945d1f5e7b9b5$var$ZEROS
    ], $530945d1f5e7b9b5$var$blocksize);
    var ipad = this._ipad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    var opad = this._opad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    for(var i = 0; i < $530945d1f5e7b9b5$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$dlqwk($530945d1f5e7b9b5$var$Hmac, $26nOC);
$530945d1f5e7b9b5$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$530945d1f5e7b9b5$var$Hmac.prototype._final = function() {
    var h = this._alg($530945d1f5e7b9b5$require$Buffer.concat(this._hash));
    return this._alg($530945d1f5e7b9b5$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $530945d1f5e7b9b5$var$Hmac;

});

parcelRegister("8nM4g", function(module, exports) {

var $loYLU = parcelRequire("loYLU");
module.exports = function(buffer) {
    return new $loYLU().update(buffer).digest();
};

});


parcelRegister("eFSIF", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6swAi"));

});
parcelRegister("6swAi", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});


parcelRegister("lORrZ", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $fe27baa2ca96071e$export$448fa22aedc9dbca, (v) => $fe27baa2ca96071e$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $fe27baa2ca96071e$export$b80c7ba289c8fa56, (v) => $fe27baa2ca96071e$export$b80c7ba289c8fa56 = v);
var $fe27baa2ca96071e$export$448fa22aedc9dbca;
var $fe27baa2ca96071e$export$b80c7ba289c8fa56;

$fe27baa2ca96071e$export$448fa22aedc9dbca = (parcelRequire("5dQ72"));

$fe27baa2ca96071e$export$b80c7ba289c8fa56 = (parcelRequire("1VtKc"));

});
parcelRegister("5dQ72", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $3cd697166017b735$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $1VtKc = parcelRequire("1VtKc");

var $kiaDM = parcelRequire("kiaDM");
var $3cd697166017b735$var$ZERO_BUF;
var $3cd697166017b735$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $3cd697166017b735$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $3cd697166017b735$var$checks = [];
function $3cd697166017b735$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$3cd697166017b735$var$subtle || !$3cd697166017b735$var$subtle.importKey || !$3cd697166017b735$var$subtle.deriveBits) return Promise.resolve(false);
    if ($3cd697166017b735$var$checks[algo] !== undefined) return $3cd697166017b735$var$checks[algo];
    $3cd697166017b735$var$ZERO_BUF = $3cd697166017b735$var$ZERO_BUF || $3cd697166017b735$require$Buffer.alloc(8);
    var prom = $3cd697166017b735$var$browserPbkdf2($3cd697166017b735$var$ZERO_BUF, $3cd697166017b735$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $3cd697166017b735$var$checks[algo] = prom;
    return prom;
}
var $3cd697166017b735$var$nextTick;
function $3cd697166017b735$var$getNextTick() {
    if ($3cd697166017b735$var$nextTick) return $3cd697166017b735$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $3cd697166017b735$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $3cd697166017b735$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $3cd697166017b735$var$nextTick = $parcel$global.setImmediate;
    else $3cd697166017b735$var$nextTick = $parcel$global.setTimeout;
    return $3cd697166017b735$var$nextTick;
}
function $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $3cd697166017b735$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $3cd697166017b735$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $3cd697166017b735$require$Buffer.from(res);
    });
}
function $3cd697166017b735$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $3cd697166017b735$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $3cd697166017b735$var$getNextTick()(function() {
            var out;
            try {
                out = $1VtKc(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, "Password");
    salt = $kiaDM(salt, $6YaY3, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $3cd697166017b735$var$resolvePromise($3cd697166017b735$var$checkNative(algo).then(function(resp) {
        if (resp) return $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $1VtKc(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("7dtUH", function(module, exports) {
var $5410f37dea3a95ee$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $5410f37dea3a95ee$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRegister("6YaY3", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
var $5130da986dd86f24$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $5130da986dd86f24$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $5130da986dd86f24$var$pVersionMajor = parseInt($hPtJY.version.split(".")[0].slice(1), 10);
    $5130da986dd86f24$var$defaultEncoding = $5130da986dd86f24$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $5130da986dd86f24$var$defaultEncoding = "utf-8";
module.exports = $5130da986dd86f24$var$defaultEncoding;

});

parcelRegister("1VtKc", function(module, exports) {

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $1U9GM = parcelRequire("1U9GM");
var $16722fe28cdbf3c2$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $kiaDM = parcelRequire("kiaDM");
var $16722fe28cdbf3c2$var$ZEROS = $16722fe28cdbf3c2$require$Buffer.alloc(128);
var $16722fe28cdbf3c2$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $16722fe28cdbf3c2$var$Hmac(alg, key, saltLen) {
    var hash = $16722fe28cdbf3c2$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $16722fe28cdbf3c2$require$Buffer.concat([
        key,
        $16722fe28cdbf3c2$var$ZEROS
    ], blocksize);
    var ipad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    var opad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $16722fe28cdbf3c2$var$sizes[alg];
}
$16722fe28cdbf3c2$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $16722fe28cdbf3c2$var$getDigest(alg) {
    function shaFunc(data) {
        return $5Z1sR(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $a8qBR().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $8nM4g;
    return shaFunc;
}
function $16722fe28cdbf3c2$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, "Password");
    salt = $kiaDM(salt, $6YaY3, "Salt");
    digest = digest || "sha1";
    var hmac = new $16722fe28cdbf3c2$var$Hmac(digest, password, salt.length);
    var DK = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(keylen);
    var block1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $16722fe28cdbf3c2$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $16722fe28cdbf3c2$var$pbkdf2;

});
parcelRegister("kiaDM", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $ec5dbe1d2de061b3$require$Buffer = $1U9GM.Buffer;
module.exports = function(thing, encoding, name) {
    if ($ec5dbe1d2de061b3$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $ec5dbe1d2de061b3$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $ec5dbe1d2de061b3$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});




parcelRegister("eyeBm", function(module, exports) {

$parcel$export(module.exports, "createCipher", () => $a97f913e2ff95e3b$export$bdd223f16383713e, (v) => $a97f913e2ff95e3b$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipher", () => $a97f913e2ff95e3b$export$26e5786e8ac8e530, (v) => $a97f913e2ff95e3b$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipheriv", () => $a97f913e2ff95e3b$export$2f64596b8cbf08b4, (v) => $a97f913e2ff95e3b$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Cipheriv", () => $a97f913e2ff95e3b$export$20533d26f07f1ee0, (v) => $a97f913e2ff95e3b$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createDecipher", () => $a97f913e2ff95e3b$export$12ada9414fbc594c, (v) => $a97f913e2ff95e3b$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipher", () => $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a, (v) => $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipheriv", () => $a97f913e2ff95e3b$export$36b6d6ef312eab39, (v) => $a97f913e2ff95e3b$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "Decipheriv", () => $a97f913e2ff95e3b$export$f5e7e39d57cd9700, (v) => $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "listCiphers", () => $a97f913e2ff95e3b$export$dedd8dc3dc62b370, (v) => $a97f913e2ff95e3b$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "getCiphers", () => $a97f913e2ff95e3b$export$58a258485f1e49f6, (v) => $a97f913e2ff95e3b$export$58a258485f1e49f6 = v);
var $a97f913e2ff95e3b$export$bdd223f16383713e;
var $a97f913e2ff95e3b$export$26e5786e8ac8e530;
var $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
var $a97f913e2ff95e3b$export$20533d26f07f1ee0;
var $a97f913e2ff95e3b$export$12ada9414fbc594c;
var $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
var $a97f913e2ff95e3b$export$36b6d6ef312eab39;
var $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
var $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $a97f913e2ff95e3b$export$58a258485f1e49f6;

var $ljOtR = parcelRequire("ljOtR");

var $7Zu82 = parcelRequire("7Zu82");

var $5Su5u = parcelRequire("5Su5u");

var $xsYYh = parcelRequire("xsYYh");

var $bSYjd = parcelRequire("bSYjd");
function $a97f913e2ff95e3b$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($xsYYh[suite]) {
        keyLen = $xsYYh[suite].key * 8;
        ivLen = $xsYYh[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createCipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($xsYYh[suite]) {
        keyLen = $xsYYh[suite].key * 8;
        ivLen = $xsYYh[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createCipheriv(suite, key, iv);
    if ($xsYYh[suite]) return new $ljOtR({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $a97f913e2ff95e3b$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createDecipheriv(suite, key, iv);
    if ($xsYYh[suite]) return new $ljOtR({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $a97f913e2ff95e3b$var$getCiphers() {
    return Object.keys($xsYYh).concat($7Zu82.getCiphers());
}
$a97f913e2ff95e3b$export$bdd223f16383713e = $a97f913e2ff95e3b$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$var$createCipher;
$a97f913e2ff95e3b$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$var$createCipheriv;
$a97f913e2ff95e3b$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$var$createDecipher;
$a97f913e2ff95e3b$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$var$createDecipheriv;
$a97f913e2ff95e3b$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$58a258485f1e49f6 = $a97f913e2ff95e3b$var$getCiphers;

});
parcelRegister("ljOtR", function(module, exports) {

var $26nOC = parcelRequire("26nOC");

var $8SeDJ = parcelRequire("8SeDJ");

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $f85287bc79724838$require$Buffer = $1U9GM.Buffer;
var $f85287bc79724838$var$modes = {
    "des-ede3-cbc": $8SeDJ.CBC.instantiate($8SeDJ.EDE),
    "des-ede3": $8SeDJ.EDE,
    "des-ede-cbc": $8SeDJ.CBC.instantiate($8SeDJ.EDE),
    "des-ede": $8SeDJ.EDE,
    "des-cbc": $8SeDJ.CBC.instantiate($8SeDJ.DES),
    "des-ecb": $8SeDJ.DES
};
$f85287bc79724838$var$modes.des = $f85287bc79724838$var$modes["des-cbc"];
$f85287bc79724838$var$modes.des3 = $f85287bc79724838$var$modes["des-ede3-cbc"];
module.exports = $f85287bc79724838$var$DES;
$dlqwk($f85287bc79724838$var$DES, $26nOC);
function $f85287bc79724838$var$DES(opts) {
    $26nOC.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $f85287bc79724838$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$f85287bc79724838$require$Buffer.isBuffer(key)) key = $f85287bc79724838$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $f85287bc79724838$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$f85287bc79724838$require$Buffer.isBuffer(iv)) iv = $f85287bc79724838$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$f85287bc79724838$var$DES.prototype._update = function(data) {
    return $f85287bc79724838$require$Buffer.from(this._des.update(data));
};
$f85287bc79724838$var$DES.prototype._final = function() {
    return $f85287bc79724838$require$Buffer.from(this._des.final());
};

});
parcelRegister("8SeDJ", function(module, exports) {

$parcel$export(module.exports, "DES", () => $675eb908dbde2e68$export$cc8859615686b300, (v) => $675eb908dbde2e68$export$cc8859615686b300 = v);
$parcel$export(module.exports, "CBC", () => $675eb908dbde2e68$export$8ad3f227af08fcc5, (v) => $675eb908dbde2e68$export$8ad3f227af08fcc5 = v);
$parcel$export(module.exports, "EDE", () => $675eb908dbde2e68$export$947646e34766044f, (v) => $675eb908dbde2e68$export$947646e34766044f = v);
var $675eb908dbde2e68$export$eab97d15b1788b8d;
var $675eb908dbde2e68$export$26e5786e8ac8e530;
var $675eb908dbde2e68$export$cc8859615686b300;
var $675eb908dbde2e68$export$8ad3f227af08fcc5;
var $675eb908dbde2e68$export$947646e34766044f;
"use strict";

$675eb908dbde2e68$export$eab97d15b1788b8d = (parcelRequire("dyok1"));

$675eb908dbde2e68$export$26e5786e8ac8e530 = (parcelRequire("enfpo"));

$675eb908dbde2e68$export$cc8859615686b300 = (parcelRequire("dB8Kv"));

$675eb908dbde2e68$export$8ad3f227af08fcc5 = (parcelRequire("eiYbc"));

$675eb908dbde2e68$export$947646e34766044f = (parcelRequire("5ye6K"));

});
parcelRegister("dyok1", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $9de15128f81796e0$export$cfaef8ed399428b0, (v) => $9de15128f81796e0$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $9de15128f81796e0$export$a80c7deaea7cbd80, (v) => $9de15128f81796e0$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $9de15128f81796e0$export$ed7577ae6e1cd0ef, (v) => $9de15128f81796e0$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $9de15128f81796e0$export$5dcbef3aa594f567, (v) => $9de15128f81796e0$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $9de15128f81796e0$export$5bc8001ca71ed9c5, (v) => $9de15128f81796e0$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $9de15128f81796e0$export$3e714e2c5d5d8cb2, (v) => $9de15128f81796e0$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $9de15128f81796e0$export$94c3e544fd062b7f, (v) => $9de15128f81796e0$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $9de15128f81796e0$export$9f77e0932fb78f72, (v) => $9de15128f81796e0$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $9de15128f81796e0$export$d865ce2836f5927f, (v) => $9de15128f81796e0$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $9de15128f81796e0$export$95e62ad65da8b7d2, (v) => $9de15128f81796e0$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $9de15128f81796e0$export$209139ff098c441a, (v) => $9de15128f81796e0$export$209139ff098c441a = v);
var $9de15128f81796e0$export$cfaef8ed399428b0;
var $9de15128f81796e0$export$a80c7deaea7cbd80;
var $9de15128f81796e0$export$ed7577ae6e1cd0ef;
var $9de15128f81796e0$export$5dcbef3aa594f567;
var $9de15128f81796e0$export$5bc8001ca71ed9c5;
var $9de15128f81796e0$export$3e714e2c5d5d8cb2;
var $9de15128f81796e0$export$94c3e544fd062b7f;
var $9de15128f81796e0$export$9f77e0932fb78f72;
var $9de15128f81796e0$export$d865ce2836f5927f;
var $9de15128f81796e0$export$95e62ad65da8b7d2;
var $9de15128f81796e0$export$209139ff098c441a;
"use strict";
$9de15128f81796e0$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$9de15128f81796e0$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$9de15128f81796e0$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $9de15128f81796e0$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$9de15128f81796e0$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $9de15128f81796e0$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $9de15128f81796e0$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $9de15128f81796e0$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$9de15128f81796e0$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $9de15128f81796e0$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$9de15128f81796e0$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $9de15128f81796e0$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $9de15128f81796e0$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$9de15128f81796e0$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRegister("enfpo", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");
function $a76f2a83ec677410$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $a76f2a83ec677410$var$Cipher;
$a76f2a83ec677410$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$a76f2a83ec677410$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$a76f2a83ec677410$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$a76f2a83ec677410$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$a76f2a83ec677410$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$a76f2a83ec677410$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$a76f2a83ec677410$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$a76f2a83ec677410$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $koC21.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("koC21", function(module, exports) {
module.exports = $ed938ccf59a32f03$var$assert;
function $ed938ccf59a32f03$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$ed938ccf59a32f03$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});


parcelRegister("dB8Kv", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $dyok1 = parcelRequire("dyok1");

var $enfpo = parcelRequire("enfpo");
function $9e6584766ef755d8$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $9e6584766ef755d8$var$DES(options) {
    $enfpo.call(this, options);
    var state = new $9e6584766ef755d8$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$dlqwk($9e6584766ef755d8$var$DES, $enfpo);
module.exports = $9e6584766ef755d8$var$DES;
$9e6584766ef755d8$var$DES.create = function create(options) {
    return new $9e6584766ef755d8$var$DES(options);
};
var $9e6584766ef755d8$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$9e6584766ef755d8$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $koC21.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $dyok1.readUInt32BE(key, 0);
    var kR = $dyok1.readUInt32BE(key, 4);
    $dyok1.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $9e6584766ef755d8$var$shiftTable[i >>> 1];
        kL = $dyok1.r28shl(kL, shift);
        kR = $dyok1.r28shl(kR, shift);
        $dyok1.pc2(kL, kR, state.keys, i);
    }
};
$9e6584766ef755d8$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $dyok1.readUInt32BE(inp, inOff);
    var r = $dyok1.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $dyok1.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $dyok1.writeUInt32BE(out, l, outOff);
    $dyok1.writeUInt32BE(out, r, outOff + 4);
};
$9e6584766ef755d8$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$9e6584766ef755d8$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$koC21.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$9e6584766ef755d8$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(r, l, out, off);
};
$9e6584766ef755d8$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(l, r, out, off);
};

});

parcelRegister("eiYbc", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $a6a16d933acb8abd$export$f9bb8d20ccc7477a, (v) => $a6a16d933acb8abd$export$f9bb8d20ccc7477a = v);
var $a6a16d933acb8abd$export$f9bb8d20ccc7477a;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
var $a6a16d933acb8abd$var$proto = {};
function $a6a16d933acb8abd$var$CBCState(iv) {
    $koC21.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $a6a16d933acb8abd$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $dlqwk(CBC, Base);
    var keys = Object.keys($a6a16d933acb8abd$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $a6a16d933acb8abd$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$a6a16d933acb8abd$export$f9bb8d20ccc7477a = $a6a16d933acb8abd$var$instantiate;
$a6a16d933acb8abd$var$proto._cbcInit = function _cbcInit() {
    var state = new $a6a16d933acb8abd$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$a6a16d933acb8abd$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("5ye6K", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $enfpo = parcelRequire("enfpo");

var $dB8Kv = parcelRequire("dB8Kv");
function $40ab123e2a8964f5$var$EDEState(type, key) {
    $koC21.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $dB8Kv.create({
            type: "encrypt",
            key: k1
        }),
        $dB8Kv.create({
            type: "decrypt",
            key: k2
        }),
        $dB8Kv.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $dB8Kv.create({
            type: "decrypt",
            key: k3
        }),
        $dB8Kv.create({
            type: "encrypt",
            key: k2
        }),
        $dB8Kv.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $40ab123e2a8964f5$var$EDE(options) {
    $enfpo.call(this, options);
    var state = new $40ab123e2a8964f5$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$dlqwk($40ab123e2a8964f5$var$EDE, $enfpo);
module.exports = $40ab123e2a8964f5$var$EDE;
$40ab123e2a8964f5$var$EDE.create = function create(options) {
    return new $40ab123e2a8964f5$var$EDE(options);
};
$40ab123e2a8964f5$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$40ab123e2a8964f5$var$EDE.prototype._pad = $dB8Kv.prototype._pad;
$40ab123e2a8964f5$var$EDE.prototype._unpad = $dB8Kv.prototype._unpad;

});



parcelRegister("7Zu82", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $5d1599d560efe1c2$export$2f64596b8cbf08b4, (v) => $5d1599d560efe1c2$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $5d1599d560efe1c2$export$36b6d6ef312eab39, (v) => $5d1599d560efe1c2$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $5d1599d560efe1c2$export$58a258485f1e49f6, (v) => $5d1599d560efe1c2$export$58a258485f1e49f6 = v);
var $5d1599d560efe1c2$export$bdd223f16383713e;
var $5d1599d560efe1c2$export$26e5786e8ac8e530;
var $5d1599d560efe1c2$export$2f64596b8cbf08b4;
var $5d1599d560efe1c2$export$20533d26f07f1ee0;
var $5d1599d560efe1c2$export$12ada9414fbc594c;
var $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a;
var $5d1599d560efe1c2$export$36b6d6ef312eab39;
var $5d1599d560efe1c2$export$f5e7e39d57cd9700;
var $5d1599d560efe1c2$export$dedd8dc3dc62b370;
var $5d1599d560efe1c2$export$58a258485f1e49f6;

var $8Zgnw = parcelRequire("8Zgnw");

var $aSTOs = parcelRequire("aSTOs");

var $2lZ3i = parcelRequire("2lZ3i");
function $5d1599d560efe1c2$var$getCiphers() {
    return Object.keys($2lZ3i);
}
$5d1599d560efe1c2$export$bdd223f16383713e = $5d1599d560efe1c2$export$26e5786e8ac8e530 = $8Zgnw.createCipher;
$5d1599d560efe1c2$export$2f64596b8cbf08b4 = $5d1599d560efe1c2$export$20533d26f07f1ee0 = $8Zgnw.createCipheriv;
$5d1599d560efe1c2$export$12ada9414fbc594c = $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a = $aSTOs.createDecipher;
$5d1599d560efe1c2$export$36b6d6ef312eab39 = $5d1599d560efe1c2$export$f5e7e39d57cd9700 = $aSTOs.createDecipheriv;
$5d1599d560efe1c2$export$dedd8dc3dc62b370 = $5d1599d560efe1c2$export$58a258485f1e49f6 = $5d1599d560efe1c2$var$getCiphers;

});
parcelRegister("8Zgnw", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $68b0b9a01ec378ac$export$2f64596b8cbf08b4, (v) => $68b0b9a01ec378ac$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $68b0b9a01ec378ac$export$bdd223f16383713e, (v) => $68b0b9a01ec378ac$export$bdd223f16383713e = v);
var $68b0b9a01ec378ac$export$2f64596b8cbf08b4;
var $68b0b9a01ec378ac$export$bdd223f16383713e;

var $5Su5u = parcelRequire("5Su5u");

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $68b0b9a01ec378ac$require$Buffer = $1U9GM.Buffer;

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $68b0b9a01ec378ac$var$Cipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $68b0b9a01ec378ac$var$Splitter();
    this._cipher = new $j0hdX.AES(key);
    this._prev = $68b0b9a01ec378ac$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($68b0b9a01ec378ac$var$Cipher, $26nOC);
$68b0b9a01ec378ac$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $68b0b9a01ec378ac$require$Buffer.concat(out);
};
var $68b0b9a01ec378ac$var$PADDING = $68b0b9a01ec378ac$require$Buffer.alloc(16, 0x10);
$68b0b9a01ec378ac$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($68b0b9a01ec378ac$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$68b0b9a01ec378ac$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $68b0b9a01ec378ac$var$Splitter() {
    this.cache = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(0);
}
$68b0b9a01ec378ac$var$Splitter.prototype.add = function(data) {
    this.cache = $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$68b0b9a01ec378ac$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$68b0b9a01ec378ac$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $68b0b9a01ec378ac$var$createCipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $68b0b9a01ec378ac$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $68b0b9a01ec378ac$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $hzsAp(config.module, password, iv);
    else if (config.type === "auth") return new $lyZ5N(config.module, password, iv);
    return new $68b0b9a01ec378ac$var$Cipher(config.module, password, iv);
}
function $68b0b9a01ec378ac$var$createCipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $68b0b9a01ec378ac$var$createCipheriv(suite, keys.key, keys.iv);
}
$68b0b9a01ec378ac$export$2f64596b8cbf08b4 = $68b0b9a01ec378ac$var$createCipheriv;
$68b0b9a01ec378ac$export$bdd223f16383713e = $68b0b9a01ec378ac$var$createCipher;

});
parcelRegister("5Su5u", function(module, exports) {








var $447955a9e06650da$var$modeModules = {
    ECB: (parcelRequire("f6p9h")),
    CBC: (parcelRequire("3QymJ")),
    CFB: (parcelRequire("2cuuO")),
    CFB8: (parcelRequire("03mhO")),
    CFB1: (parcelRequire("fK9OU")),
    OFB: (parcelRequire("fFe8N")),
    CTR: (parcelRequire("fJbMg")),
    GCM: (parcelRequire("fJbMg"))
};

var $2lZ3i = parcelRequire("2lZ3i");
for(var $447955a9e06650da$var$key in $2lZ3i)$2lZ3i[$447955a9e06650da$var$key].module = $447955a9e06650da$var$modeModules[$2lZ3i[$447955a9e06650da$var$key].mode];
module.exports = $2lZ3i;

});
parcelRegister("f6p9h", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $afeaec8849bcc81c$export$5b0f6292f11d1d18, (v) => $afeaec8849bcc81c$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $afeaec8849bcc81c$export$e85a0c9a1067c5d3, (v) => $afeaec8849bcc81c$export$e85a0c9a1067c5d3 = v);
var $afeaec8849bcc81c$export$5b0f6292f11d1d18;
var $afeaec8849bcc81c$export$e85a0c9a1067c5d3;
$afeaec8849bcc81c$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$afeaec8849bcc81c$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("3QymJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18, (v) => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3, (v) => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = v);
var $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18;
var $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3;

var $dUX5c = parcelRequire("dUX5c");
$2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $dUX5c(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $dUX5c(out, pad);
};

});
parcelRegister("dUX5c", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a21e55eeffd2595b$require$Buffer = $6ZWSX.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $a21e55eeffd2595b$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("2cuuO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $19a45ba19082fc97$export$5b0f6292f11d1d18, (v) => $19a45ba19082fc97$export$5b0f6292f11d1d18 = v);
var $19a45ba19082fc97$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $19a45ba19082fc97$require$Buffer = $1U9GM.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $19a45ba19082fc97$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $dUX5c(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $19a45ba19082fc97$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$19a45ba19082fc97$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("03mhO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $00a19188a96aa70f$export$5b0f6292f11d1d18, (v) => $00a19188a96aa70f$export$5b0f6292f11d1d18 = v);
var $00a19188a96aa70f$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $00a19188a96aa70f$require$Buffer = $1U9GM.Buffer;
function $00a19188a96aa70f$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $00a19188a96aa70f$require$Buffer.concat([
        self._prev.slice(1),
        $00a19188a96aa70f$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$00a19188a96aa70f$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $00a19188a96aa70f$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $00a19188a96aa70f$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fK9OU", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b762c4f45662bf18$export$5b0f6292f11d1d18, (v) => $b762c4f45662bf18$export$5b0f6292f11d1d18 = v);
var $b762c4f45662bf18$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $b762c4f45662bf18$require$Buffer = $1U9GM.Buffer;
function $b762c4f45662bf18$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $b762c4f45662bf18$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $b762c4f45662bf18$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(buffer.length);
    buffer = $b762c4f45662bf18$require$Buffer.concat([
        buffer,
        $b762c4f45662bf18$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$b762c4f45662bf18$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $b762c4f45662bf18$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fFe8N", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b675a769a603e0fc$export$5b0f6292f11d1d18, (v) => $b675a769a603e0fc$export$5b0f6292f11d1d18 = v);
var $b675a769a603e0fc$export$5b0f6292f11d1d18;

var $6ZWSX = parcelRequire("6ZWSX");
var $b675a769a603e0fc$require$Buffer = $6ZWSX.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $b675a769a603e0fc$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$b675a769a603e0fc$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $b675a769a603e0fc$require$Buffer.concat([
        self._cache,
        $b675a769a603e0fc$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});

parcelRegister("fJbMg", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b73431c24e9fa039$export$5b0f6292f11d1d18, (v) => $b73431c24e9fa039$export$5b0f6292f11d1d18 = v);
var $b73431c24e9fa039$export$5b0f6292f11d1d18;

var $dUX5c = parcelRequire("dUX5c");

var $1U9GM = parcelRequire("1U9GM");
var $b73431c24e9fa039$require$Buffer = $1U9GM.Buffer;

var $3VKgl = parcelRequire("3VKgl");
function $b73431c24e9fa039$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $3VKgl(self._prev);
    return out;
}
var $b73431c24e9fa039$var$blockSize = 16;
$b73431c24e9fa039$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $b73431c24e9fa039$var$blockSize);
    var start = self._cache.length;
    self._cache = $b73431c24e9fa039$require$Buffer.concat([
        self._cache,
        $b73431c24e9fa039$require$Buffer.allocUnsafe(chunkNum * $b73431c24e9fa039$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $b73431c24e9fa039$var$getBlock(self);
        var offset = start + i * $b73431c24e9fa039$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});
parcelRegister("3VKgl", function(module, exports) {
function $2dca94c326c7eb9a$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $2dca94c326c7eb9a$var$incr32;

});


parcelRegister("2lZ3i", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRegister("lyZ5N", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $fb2c299f1eae7447$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");

var $5Z5i8 = parcelRequire("5Z5i8");

var $dUX5c = parcelRequire("dUX5c");

var $3VKgl = parcelRequire("3VKgl");
function $fb2c299f1eae7447$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $fb2c299f1eae7447$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $5Z5i8(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($fb2c299f1eae7447$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($fb2c299f1eae7447$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $fb2c299f1eae7447$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $fb2c299f1eae7447$require$Buffer.from(self._finID);
    $3VKgl(out);
    return out;
}
function $fb2c299f1eae7447$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    var h = $fb2c299f1eae7447$require$Buffer.alloc(4, 0);
    this._cipher = new $j0hdX.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $5Z5i8(ck);
    iv = $fb2c299f1eae7447$var$calcIv(this, iv, ck);
    this._prev = $fb2c299f1eae7447$require$Buffer.from(iv);
    this._cache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._secCache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$dlqwk($fb2c299f1eae7447$var$StreamCipher, $26nOC);
$fb2c299f1eae7447$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $fb2c299f1eae7447$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$fb2c299f1eae7447$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $dUX5c(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $fb2c299f1eae7447$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$fb2c299f1eae7447$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$fb2c299f1eae7447$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $fb2c299f1eae7447$var$StreamCipher;

});
parcelRegister("j0hdX", function(module, exports) {

$parcel$export(module.exports, "AES", () => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5, (v) => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5;

var $1U9GM = parcelRequire("1U9GM");
var $dd5b60bed61b3c64$require$Buffer = $1U9GM.Buffer;
function $dd5b60bed61b3c64$var$asUInt32Array(buf) {
    if (!$dd5b60bed61b3c64$require$Buffer.isBuffer(buf)) buf = $dd5b60bed61b3c64$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $dd5b60bed61b3c64$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $dd5b60bed61b3c64$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $dd5b60bed61b3c64$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $dd5b60bed61b3c64$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $dd5b60bed61b3c64$var$AES(key) {
    this._key = $dd5b60bed61b3c64$var$asUInt32Array(key);
    this._reset();
}
$dd5b60bed61b3c64$var$AES.blockSize = 16;
$dd5b60bed61b3c64$var$AES.keySize = 32;
$dd5b60bed61b3c64$var$AES.prototype.blockSize = $dd5b60bed61b3c64$var$AES.blockSize;
$dd5b60bed61b3c64$var$AES.prototype.keySize = $dd5b60bed61b3c64$var$AES.keySize;
$dd5b60bed61b3c64$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
            t ^= $dd5b60bed61b3c64$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $dd5b60bed61b3c64$var$G.INV_SUB_MIX[0][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 24]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[1][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 16 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[2][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 8 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[3][$dd5b60bed61b3c64$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    return $dd5b60bed61b3c64$var$cryptBlock(M, this._keySchedule, $dd5b60bed61b3c64$var$G.SUB_MIX, $dd5b60bed61b3c64$var$G.SBOX, this._nRounds);
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.decryptBlock = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $dd5b60bed61b3c64$var$cryptBlock(M, this._invKeySchedule, $dd5b60bed61b3c64$var$G.INV_SUB_MIX, $dd5b60bed61b3c64$var$G.INV_SBOX, this._nRounds);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.scrub = function() {
    $dd5b60bed61b3c64$var$scrubVec(this._keySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._invKeySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._key);
};
$dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = $dd5b60bed61b3c64$var$AES;

});

parcelRegister("5Z5i8", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $45b6c10c8dc18438$require$Buffer = $1U9GM.Buffer;
var $45b6c10c8dc18438$var$ZEROES = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
function $45b6c10c8dc18438$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $45b6c10c8dc18438$var$fromArray(out) {
    var buf = $45b6c10c8dc18438$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $45b6c10c8dc18438$var$GHASH(key) {
    this.h = key;
    this.state = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
    this.cache = $45b6c10c8dc18438$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$45b6c10c8dc18438$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$45b6c10c8dc18438$var$GHASH.prototype._multiply = function() {
    var Vi = $45b6c10c8dc18438$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $45b6c10c8dc18438$var$fromArray(Zi);
};
$45b6c10c8dc18438$var$GHASH.prototype.update = function(buf) {
    this.cache = $45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$45b6c10c8dc18438$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        $45b6c10c8dc18438$var$ZEROES
    ], 16));
    this.ghash($45b6c10c8dc18438$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $45b6c10c8dc18438$var$GHASH;

});


parcelRegister("hzsAp", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $ccabe1300e92c82b$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");
function $ccabe1300e92c82b$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    this._cipher = new $j0hdX.AES(key);
    this._prev = $ccabe1300e92c82b$require$Buffer.from(iv);
    this._cache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._secCache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$dlqwk($ccabe1300e92c82b$var$StreamCipher, $26nOC);
$ccabe1300e92c82b$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$ccabe1300e92c82b$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $ccabe1300e92c82b$var$StreamCipher;

});

parcelRegister("bSYjd", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $8a7384f85993cf90$require$Buffer = $1U9GM.Buffer;

var $loYLU = parcelRequire("loYLU");
/* eslint-disable camelcase */ function $8a7384f85993cf90$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$8a7384f85993cf90$require$Buffer.isBuffer(password)) password = $8a7384f85993cf90$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$8a7384f85993cf90$require$Buffer.isBuffer(salt)) salt = $8a7384f85993cf90$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $8a7384f85993cf90$require$Buffer.alloc(keyLen);
    var iv = $8a7384f85993cf90$require$Buffer.alloc(ivLen || 0);
    var tmp = $8a7384f85993cf90$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $loYLU();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $8a7384f85993cf90$var$EVP_BytesToKey;

});


parcelRegister("aSTOs", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $7eca3dd1d6757703$export$12ada9414fbc594c, (v) => $7eca3dd1d6757703$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $7eca3dd1d6757703$export$36b6d6ef312eab39, (v) => $7eca3dd1d6757703$export$36b6d6ef312eab39 = v);
var $7eca3dd1d6757703$export$12ada9414fbc594c;
var $7eca3dd1d6757703$export$36b6d6ef312eab39;

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $7eca3dd1d6757703$require$Buffer = $1U9GM.Buffer;

var $5Su5u = parcelRequire("5Su5u");

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $7eca3dd1d6757703$var$Decipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $7eca3dd1d6757703$var$Splitter();
    this._last = void 0;
    this._cipher = new $j0hdX.AES(key);
    this._prev = $7eca3dd1d6757703$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($7eca3dd1d6757703$var$Decipher, $26nOC);
$7eca3dd1d6757703$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $7eca3dd1d6757703$require$Buffer.concat(out);
};
$7eca3dd1d6757703$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $7eca3dd1d6757703$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$7eca3dd1d6757703$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $7eca3dd1d6757703$var$Splitter() {
    this.cache = $7eca3dd1d6757703$require$Buffer.allocUnsafe(0);
}
$7eca3dd1d6757703$var$Splitter.prototype.add = function(data) {
    this.cache = $7eca3dd1d6757703$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$7eca3dd1d6757703$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$7eca3dd1d6757703$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $7eca3dd1d6757703$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $7eca3dd1d6757703$var$createDecipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $7eca3dd1d6757703$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $7eca3dd1d6757703$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $hzsAp(config.module, password, iv, true);
    else if (config.type === "auth") return new $lyZ5N(config.module, password, iv, true);
    return new $7eca3dd1d6757703$var$Decipher(config.module, password, iv);
}
function $7eca3dd1d6757703$var$createDecipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $7eca3dd1d6757703$var$createDecipheriv(suite, keys.key, keys.iv);
}
$7eca3dd1d6757703$export$12ada9414fbc594c = $7eca3dd1d6757703$var$createDecipher;
$7eca3dd1d6757703$export$36b6d6ef312eab39 = $7eca3dd1d6757703$var$createDecipheriv;

});


parcelRegister("xsYYh", function(module, exports) {

$parcel$export(module.exports, "des-ecb", () => $0649907c0434f982$export$116f8a5cee447347, (v) => $0649907c0434f982$export$116f8a5cee447347 = v);
$parcel$export(module.exports, "des-cbc", () => $0649907c0434f982$export$7483c4066bfb7ae9, (v) => $0649907c0434f982$export$7483c4066bfb7ae9 = v);
$parcel$export(module.exports, "des", () => $0649907c0434f982$export$e7a565d2e588bb06, (v) => $0649907c0434f982$export$e7a565d2e588bb06 = v);
$parcel$export(module.exports, "des-ede3-cbc", () => $0649907c0434f982$export$aaa2f54a426f3eb8, (v) => $0649907c0434f982$export$aaa2f54a426f3eb8 = v);
$parcel$export(module.exports, "des3", () => $0649907c0434f982$export$eba20568dde4ada, (v) => $0649907c0434f982$export$eba20568dde4ada = v);
$parcel$export(module.exports, "des-ede3", () => $0649907c0434f982$export$d3b5e5996938f5ae, (v) => $0649907c0434f982$export$d3b5e5996938f5ae = v);
$parcel$export(module.exports, "des-ede-cbc", () => $0649907c0434f982$export$57c08356130bc99b, (v) => $0649907c0434f982$export$57c08356130bc99b = v);
$parcel$export(module.exports, "des-ede", () => $0649907c0434f982$export$c7169791d5c1e65d, (v) => $0649907c0434f982$export$c7169791d5c1e65d = v);
var $0649907c0434f982$export$116f8a5cee447347;
var $0649907c0434f982$export$7483c4066bfb7ae9;
var $0649907c0434f982$export$e7a565d2e588bb06;
var $0649907c0434f982$export$aaa2f54a426f3eb8;
var $0649907c0434f982$export$eba20568dde4ada;
var $0649907c0434f982$export$d3b5e5996938f5ae;
var $0649907c0434f982$export$57c08356130bc99b;
var $0649907c0434f982$export$c7169791d5c1e65d;
$0649907c0434f982$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$0649907c0434f982$export$7483c4066bfb7ae9 = $0649907c0434f982$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$0649907c0434f982$export$aaa2f54a426f3eb8 = $0649907c0434f982$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$0649907c0434f982$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$0649907c0434f982$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$0649907c0434f982$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("5NszM", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", () => $4387b1fafb8a1868$export$971862a2fcb1bb40, (v) => $4387b1fafb8a1868$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $4387b1fafb8a1868$export$c6ff6a88acbeaf40, (v) => $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $4387b1fafb8a1868$export$fdc27893e98845cc, (v) => $4387b1fafb8a1868$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $4387b1fafb8a1868$export$6671fb9a1323bed, (v) => $4387b1fafb8a1868$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $4387b1fafb8a1868$export$d74daf141a551db, (v) => $4387b1fafb8a1868$export$d74daf141a551db = v);
var $4387b1fafb8a1868$export$971862a2fcb1bb40;
var $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
var $4387b1fafb8a1868$export$fdc27893e98845cc;
var $4387b1fafb8a1868$export$6671fb9a1323bed;
var $4387b1fafb8a1868$export$d74daf141a551db;

var $6ZWSX = parcelRequire("6ZWSX");
var $4387b1fafb8a1868$require$Buffer = $6ZWSX.Buffer;

var $aV75E = parcelRequire("aV75E");

var $kGErQ = parcelRequire("kGErQ");

var $bLCm8 = parcelRequire("bLCm8");
function $4387b1fafb8a1868$var$getDiffieHellman(mod) {
    var prime = new $4387b1fafb8a1868$require$Buffer($kGErQ[mod].prime, "hex");
    var gen = new $4387b1fafb8a1868$require$Buffer($kGErQ[mod].gen, "hex");
    return new $bLCm8(prime, gen);
}
var $4387b1fafb8a1868$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $4387b1fafb8a1868$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($4387b1fafb8a1868$require$Buffer.isBuffer(enc) || $4387b1fafb8a1868$var$ENCODINGS[enc] === undefined) return $4387b1fafb8a1868$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $4387b1fafb8a1868$require$Buffer([
        2
    ]);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(generator)) generator = new $4387b1fafb8a1868$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $bLCm8($aV75E(prime, generator), generator, true);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(prime)) prime = new $4387b1fafb8a1868$require$Buffer(prime, enc);
    return new $bLCm8(prime, generator, true);
}
$4387b1fafb8a1868$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$fdc27893e98845cc = $4387b1fafb8a1868$var$getDiffieHellman;
$4387b1fafb8a1868$export$6671fb9a1323bed = $4387b1fafb8a1868$export$d74daf141a551db = $4387b1fafb8a1868$var$createDiffieHellman;

});
parcelRegister("aV75E", function(module, exports) {

var $hkN9y = parcelRequire("hkN9y");
module.exports = $7f34ba2fa9025258$var$findPrime;
$7f34ba2fa9025258$var$findPrime.simpleSieve = $7f34ba2fa9025258$var$simpleSieve;
$7f34ba2fa9025258$var$findPrime.fermatTest = $7f34ba2fa9025258$var$fermatTest;

var $dEXSZ = parcelRequire("dEXSZ");
var $7f34ba2fa9025258$var$TWENTYFOUR = new $dEXSZ(24);

var $g2bJL = parcelRequire("g2bJL");
var $7f34ba2fa9025258$var$millerRabin = new $g2bJL();
var $7f34ba2fa9025258$var$ONE = new $dEXSZ(1);
var $7f34ba2fa9025258$var$TWO = new $dEXSZ(2);
var $7f34ba2fa9025258$var$FIVE = new $dEXSZ(5);
var $7f34ba2fa9025258$var$SIXTEEN = new $dEXSZ(16);
var $7f34ba2fa9025258$var$EIGHT = new $dEXSZ(8);
var $7f34ba2fa9025258$var$TEN = new $dEXSZ(10);
var $7f34ba2fa9025258$var$THREE = new $dEXSZ(3);
var $7f34ba2fa9025258$var$SEVEN = new $dEXSZ(7);
var $7f34ba2fa9025258$var$ELEVEN = new $dEXSZ(11);
var $7f34ba2fa9025258$var$FOUR = new $dEXSZ(4);
var $7f34ba2fa9025258$var$TWELVE = new $dEXSZ(12);
var $7f34ba2fa9025258$var$primes = null;
function $7f34ba2fa9025258$var$_getPrimes() {
    if ($7f34ba2fa9025258$var$primes !== null) return $7f34ba2fa9025258$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $7f34ba2fa9025258$var$primes = res;
    return res;
}
function $7f34ba2fa9025258$var$simpleSieve(p) {
    var primes = $7f34ba2fa9025258$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $7f34ba2fa9025258$var$fermatTest(p) {
    var red = $dEXSZ.mont(p);
    return $7f34ba2fa9025258$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $7f34ba2fa9025258$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $dEXSZ([
            0x8c,
            0x7b
        ]);
        else return new $dEXSZ([
            0x8c,
            0x27
        ]);
    }
    gen = new $dEXSZ(gen);
    var num, n2;
    while(true){
        num = new $dEXSZ($hkN9y(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($7f34ba2fa9025258$var$ONE);
        if (!num.testn(1)) num.iadd($7f34ba2fa9025258$var$TWO);
        if (!gen.cmp($7f34ba2fa9025258$var$TWO)) while(num.mod($7f34ba2fa9025258$var$TWENTYFOUR).cmp($7f34ba2fa9025258$var$ELEVEN))num.iadd($7f34ba2fa9025258$var$FOUR);
        else if (!gen.cmp($7f34ba2fa9025258$var$FIVE)) while(num.mod($7f34ba2fa9025258$var$TEN).cmp($7f34ba2fa9025258$var$THREE))num.iadd($7f34ba2fa9025258$var$FOUR);
        n2 = num.shrn(1);
        if ($7f34ba2fa9025258$var$simpleSieve(n2) && $7f34ba2fa9025258$var$simpleSieve(num) && $7f34ba2fa9025258$var$fermatTest(n2) && $7f34ba2fa9025258$var$fermatTest(num) && $7f34ba2fa9025258$var$millerRabin.test(n2) && $7f34ba2fa9025258$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("dEXSZ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("g2bJL", function(module, exports) {

var $dEXSZ = parcelRequire("dEXSZ");

var $7JHF0 = parcelRequire("7JHF0");
function $bac5f004a90de4c6$var$MillerRabin(rand) {
    this.rand = rand || new $7JHF0.Rand();
}
module.exports = $bac5f004a90de4c6$var$MillerRabin;
$bac5f004a90de4c6$var$MillerRabin.create = function create(rand) {
    return new $bac5f004a90de4c6$var$MillerRabin(rand);
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $dEXSZ(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$bac5f004a90de4c6$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $dEXSZ.mont(n);
    var rone = new $dEXSZ(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $dEXSZ(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$bac5f004a90de4c6$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $dEXSZ.mont(n);
    var rone = new $dEXSZ(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $dEXSZ(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("7JHF0", function(module, exports) {
var $5a1e9a6ed4e8de8a$var$r;
module.exports = function rand(len) {
    if (!$5a1e9a6ed4e8de8a$var$r) $5a1e9a6ed4e8de8a$var$r = new $5a1e9a6ed4e8de8a$var$Rand(null);
    return $5a1e9a6ed4e8de8a$var$r.generate(len);
};
function $5a1e9a6ed4e8de8a$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $5a1e9a6ed4e8de8a$var$Rand;
$5a1e9a6ed4e8de8a$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $5a1e9a6ed4e8de8a$var$crypto = (parcelRequire("kjyEk"));
    if (typeof $5a1e9a6ed4e8de8a$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        return $5a1e9a6ed4e8de8a$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("kGErQ", function(module, exports) {
module.exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');

});

parcelRegister("bLCm8", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $8911d62d5514749e$require$Buffer = $6ZWSX.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $g2bJL = parcelRequire("g2bJL");
var $8911d62d5514749e$var$millerRabin = new $g2bJL();
var $8911d62d5514749e$var$TWENTYFOUR = new $dEXSZ(24);
var $8911d62d5514749e$var$ELEVEN = new $dEXSZ(11);
var $8911d62d5514749e$var$TEN = new $dEXSZ(10);
var $8911d62d5514749e$var$THREE = new $dEXSZ(3);
var $8911d62d5514749e$var$SEVEN = new $dEXSZ(7);

var $aV75E = parcelRequire("aV75E");

var $hkN9y = parcelRequire("hkN9y");
module.exports = $8911d62d5514749e$var$DH;
function $8911d62d5514749e$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(pub)) pub = new $8911d62d5514749e$require$Buffer(pub, enc);
    this._pub = new $dEXSZ(pub);
    return this;
}
function $8911d62d5514749e$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(priv)) priv = new $8911d62d5514749e$require$Buffer(priv, enc);
    this._priv = new $dEXSZ(priv);
    return this;
}
var $8911d62d5514749e$var$primeCache = {};
function $8911d62d5514749e$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $8911d62d5514749e$var$primeCache) return $8911d62d5514749e$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$aV75E.simpleSieve || !$aV75E.fermatTest(prime) || !$8911d62d5514749e$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $8911d62d5514749e$var$primeCache[hex] = error;
        return error;
    }
    if (!$8911d62d5514749e$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($8911d62d5514749e$var$TWENTYFOUR).cmp($8911d62d5514749e$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($8911d62d5514749e$var$TEN);
            if (rem.cmp($8911d62d5514749e$var$THREE) && rem.cmp($8911d62d5514749e$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $8911d62d5514749e$var$primeCache[hex] = error;
    return error;
}
function $8911d62d5514749e$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $dEXSZ(prime);
    this._prime = $dEXSZ.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $8911d62d5514749e$var$setPublicKey;
        this.setPrivateKey = $8911d62d5514749e$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($8911d62d5514749e$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = $8911d62d5514749e$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$8911d62d5514749e$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $dEXSZ($hkN9y(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$8911d62d5514749e$var$DH.prototype.computeSecret = function(other) {
    other = new $dEXSZ(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $8911d62d5514749e$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $8911d62d5514749e$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $8911d62d5514749e$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$8911d62d5514749e$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._pub, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._priv, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrime = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this.__prime, enc);
};
$8911d62d5514749e$var$DH.prototype.getGenerator = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._gen, enc);
};
$8911d62d5514749e$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(gen)) gen = new $8911d62d5514749e$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $dEXSZ(gen);
    return this;
};
function $8911d62d5514749e$var$formatReturnValue(bn, enc) {
    var buf = new $8911d62d5514749e$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("4zMFU", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $3550302076d9e62e$require$Buffer = $1U9GM.Buffer;

var $1R2J7 = parcelRequire("1R2J7");

var $b6RFW = parcelRequire("b6RFW");

var $dlqwk = parcelRequire("dlqwk");

var $6E9kG = parcelRequire("6E9kG");

var $fQdau = parcelRequire("fQdau");

var $6swAi = parcelRequire("6swAi");
Object.keys($6swAi).forEach(function(key) {
    $6swAi[key].id = $3550302076d9e62e$require$Buffer.from($6swAi[key].id, "hex");
    $6swAi[key.toLowerCase()] = $6swAi[key];
});
function $3550302076d9e62e$var$Sign(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Sign, $b6RFW.Writable);
$3550302076d9e62e$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $6E9kG(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $3550302076d9e62e$var$Verify(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Verify, $b6RFW.Writable);
$3550302076d9e62e$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === "string" ? $3550302076d9e62e$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $fQdau(sigBuffer, hash, key, this._signType, this._tag);
};
function $3550302076d9e62e$var$createSign(algorithm) {
    return new $3550302076d9e62e$var$Sign(algorithm);
}
function $3550302076d9e62e$var$createVerify(algorithm) {
    return new $3550302076d9e62e$var$Verify(algorithm);
}
module.exports = {
    Sign: $3550302076d9e62e$var$createSign,
    Verify: $3550302076d9e62e$var$createVerify,
    createSign: $3550302076d9e62e$var$createSign,
    createVerify: $3550302076d9e62e$var$createVerify
};

});
parcelRegister("6E9kG", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $4d6db7c28d99f640$require$Buffer = $1U9GM.Buffer;

var $1iL1D = parcelRequire("1iL1D");

var $3Sg1O = parcelRequire("3Sg1O");

var $1zUcV = parcelRequire("1zUcV");
var $4d6db7c28d99f640$require$EC = $1zUcV.ec;

var $jVUXf = parcelRequire("jVUXf");

var $aNeDF = parcelRequire("aNeDF");

var $aYksR = parcelRequire("aYksR");
var $4d6db7c28d99f640$var$RSA_PKCS1_PADDING = 1;
function $4d6db7c28d99f640$var$sign(hash, key, hashType, signType, tag) {
    var priv = $aNeDF(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $4d6db7c28d99f640$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $4d6db7c28d99f640$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    if (key.padding !== undefined && key.padding !== $4d6db7c28d99f640$var$RSA_PKCS1_PADDING) throw new Error("illegal or unsupported padding mode");
    hash = $4d6db7c28d99f640$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $3Sg1O(pad, priv);
    return out;
}
function $4d6db7c28d99f640$var$ecSign(hash, priv) {
    var curveId = $aYksR[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $4d6db7c28d99f640$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $4d6db7c28d99f640$require$Buffer.from(out.toDER());
}
function $4d6db7c28d99f640$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $jVUXf(0);
    var k;
    var H = $4d6db7c28d99f640$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $4d6db7c28d99f640$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $4d6db7c28d99f640$var$makeKey(q, kv, algo);
        r = $4d6db7c28d99f640$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $jVUXf(0);
        }
    }
    return $4d6db7c28d99f640$var$toDER(r, s);
}
function $4d6db7c28d99f640$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $4d6db7c28d99f640$require$Buffer.from(res);
}
function $4d6db7c28d99f640$var$getKey(x, q, hash, algo) {
    x = $4d6db7c28d99f640$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - x.length);
        x = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $4d6db7c28d99f640$var$bits2octets(hash, q);
    var v = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $4d6db7c28d99f640$var$bits2int(obits, q) {
    var bits = new $jVUXf(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $4d6db7c28d99f640$var$bits2octets(bits, q) {
    bits = $4d6db7c28d99f640$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $4d6db7c28d99f640$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - out.length);
        out = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $4d6db7c28d99f640$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $4d6db7c28d99f640$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
            t = $4d6db7c28d99f640$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $4d6db7c28d99f640$var$bits2int(t, q);
        kv.k = $1iL1D(algo, kv.k).update(kv.v).update($4d6db7c28d99f640$require$Buffer.from([
            0
        ])).digest();
        kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $4d6db7c28d99f640$var$makeR(g, k, p, q) {
    return g.toRed($jVUXf.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $4d6db7c28d99f640$var$sign;
module.exports.getKey = $4d6db7c28d99f640$var$getKey;
module.exports.makeKey = $4d6db7c28d99f640$var$makeKey;

});
parcelRegister("3Sg1O", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $2d22d91c93a13ae5$require$Buffer = $6ZWSX.Buffer;

var $5KK3w = parcelRequire("5KK3w");

var $hkN9y = parcelRequire("hkN9y");
function $2d22d91c93a13ae5$var$blind(priv) {
    var r = $2d22d91c93a13ae5$var$getr(priv);
    var blinder = r.toRed($5KK3w.mont(priv.modulus)).redPow(new $5KK3w(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $2d22d91c93a13ae5$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $5KK3w($hkN9y(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $2d22d91c93a13ae5$var$crt(msg, priv) {
    var blinds = $2d22d91c93a13ae5$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $5KK3w(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($5KK3w.mont(priv.prime1));
    var c2 = blinded.toRed($5KK3w.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($2d22d91c93a13ae5$require$Buffer, "be", len);
}
$2d22d91c93a13ae5$var$crt.getr = $2d22d91c93a13ae5$var$getr;
module.exports = $2d22d91c93a13ae5$var$crt;

});
parcelRegister("5KK3w", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("1zUcV", function(module, exports) {
"use strict";
var $1264a8f63e75be39$var$elliptic = module.exports;

$1264a8f63e75be39$var$elliptic.version = (parcelRequire("fuV4H")).version;

$1264a8f63e75be39$var$elliptic.utils = (parcelRequire("gEVtY"));

$1264a8f63e75be39$var$elliptic.rand = (parcelRequire("7JHF0"));

$1264a8f63e75be39$var$elliptic.curve = (parcelRequire("cP1GP"));

$1264a8f63e75be39$var$elliptic.curves = (parcelRequire("fbTbW"));

// Protocols
$1264a8f63e75be39$var$elliptic.ec = (parcelRequire("220Zx"));

$1264a8f63e75be39$var$elliptic.eddsa = (parcelRequire("esmmS"));

});
parcelRegister("fuV4H", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRegister("gEVtY", function(module, exports) {
"use strict";
var $c20cf89948514165$var$utils = module.exports;

var $dEXSZ = parcelRequire("dEXSZ");

var $koC21 = parcelRequire("koC21");

var $lC4vN = parcelRequire("lC4vN");
$c20cf89948514165$var$utils.assert = $koC21;
$c20cf89948514165$var$utils.toArray = $lC4vN.toArray;
$c20cf89948514165$var$utils.zero2 = $lC4vN.zero2;
$c20cf89948514165$var$utils.toHex = $lC4vN.toHex;
$c20cf89948514165$var$utils.encode = $lC4vN.encode;
// Represent num in a w-NAF form
function $c20cf89948514165$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$c20cf89948514165$var$utils.getNAF = $c20cf89948514165$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $c20cf89948514165$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$c20cf89948514165$var$utils.getJSF = $c20cf89948514165$var$getJSF;
function $c20cf89948514165$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$c20cf89948514165$var$utils.cachedProperty = $c20cf89948514165$var$cachedProperty;
function $c20cf89948514165$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $c20cf89948514165$var$utils.toArray(bytes, "hex") : bytes;
}
$c20cf89948514165$var$utils.parseBytes = $c20cf89948514165$var$parseBytes;
function $c20cf89948514165$var$intFromLE(bytes) {
    return new $dEXSZ(bytes, "hex", "le");
}
$c20cf89948514165$var$utils.intFromLE = $c20cf89948514165$var$intFromLE;

});
parcelRegister("lC4vN", function(module, exports) {
"use strict";
var $fbc0a58a3f4350d8$var$utils = module.exports;
function $fbc0a58a3f4350d8$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$fbc0a58a3f4350d8$var$utils.toArray = $fbc0a58a3f4350d8$var$toArray;
function $fbc0a58a3f4350d8$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$fbc0a58a3f4350d8$var$utils.zero2 = $fbc0a58a3f4350d8$var$zero2;
function $fbc0a58a3f4350d8$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $fbc0a58a3f4350d8$var$zero2(msg[i].toString(16));
    return res;
}
$fbc0a58a3f4350d8$var$utils.toHex = $fbc0a58a3f4350d8$var$toHex;
$fbc0a58a3f4350d8$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $fbc0a58a3f4350d8$var$toHex(arr);
    else return arr;
};

});


parcelRegister("cP1GP", function(module, exports) {
"use strict";
var $955b8f041d2341cf$var$curve = module.exports;

$955b8f041d2341cf$var$curve.base = (parcelRequire("hSu7V"));

$955b8f041d2341cf$var$curve.short = (parcelRequire("eYNyQ"));

$955b8f041d2341cf$var$curve.mont = (parcelRequire("av2Yx"));

$955b8f041d2341cf$var$curve.edwards = (parcelRequire("dqmX9"));

});
parcelRegister("hSu7V", function(module, exports) {
"use strict";

var $dEXSZ = parcelRequire("dEXSZ");

var $gEVtY = parcelRequire("gEVtY");
var $d03ed95a59c9b218$var$getNAF = $gEVtY.getNAF;
var $d03ed95a59c9b218$var$getJSF = $gEVtY.getJSF;
var $d03ed95a59c9b218$var$assert = $gEVtY.assert;
function $d03ed95a59c9b218$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $dEXSZ(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $dEXSZ.red(conf.prime) : $dEXSZ.mont(this.p);
    // Useful for many curves
    this.zero = new $dEXSZ(0).toRed(this.red);
    this.one = new $dEXSZ(1).toRed(this.red);
    this.two = new $dEXSZ(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $dEXSZ(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $d03ed95a59c9b218$var$BaseCurve;
$d03ed95a59c9b218$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $d03ed95a59c9b218$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $d03ed95a59c9b218$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $d03ed95a59c9b218$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $d03ed95a59c9b218$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $d03ed95a59c9b218$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $d03ed95a59c9b218$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $d03ed95a59c9b218$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $d03ed95a59c9b218$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$d03ed95a59c9b218$var$BaseCurve.BasePoint = $d03ed95a59c9b218$var$BasePoint;
$d03ed95a59c9b218$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$d03ed95a59c9b218$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $gEVtY.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$d03ed95a59c9b218$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$d03ed95a59c9b218$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$d03ed95a59c9b218$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $gEVtY.encode(this._encode(compact), enc);
};
$d03ed95a59c9b218$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$d03ed95a59c9b218$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$d03ed95a59c9b218$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$d03ed95a59c9b218$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("eYNyQ", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $dEXSZ = parcelRequire("dEXSZ");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $ae7d1d0c45b43ec6$var$assert = $gEVtY.assert;
function $ae7d1d0c45b43ec6$var$ShortCurve(conf) {
    $hSu7V.call(this, "short", conf);
    this.a = new $dEXSZ(conf.a, 16).toRed(this.red);
    this.b = new $dEXSZ(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$dlqwk($ae7d1d0c45b43ec6$var$ShortCurve, $hSu7V);
module.exports = $ae7d1d0c45b43ec6$var$ShortCurve;
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $dEXSZ(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $dEXSZ(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $ae7d1d0c45b43ec6$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $dEXSZ(vec.a, 16),
            b: new $dEXSZ(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $dEXSZ.mont(num);
    var tinv = new $dEXSZ(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $dEXSZ(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $dEXSZ(1);
    var y1 = new $dEXSZ(0);
    var x2 = new $dEXSZ(0);
    var y2 = new $dEXSZ(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $dEXSZ(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $ae7d1d0c45b43ec6$var$Point(curve, x, y, isRed) {
    $hSu7V.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $dEXSZ(x, 16);
        this.y = new $dEXSZ(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$dlqwk($ae7d1d0c45b43ec6$var$Point, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $ae7d1d0c45b43ec6$var$Point(this, x, y, isRed);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $ae7d1d0c45b43ec6$var$Point.fromJSON(this, obj, red);
};
$ae7d1d0c45b43ec6$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$ae7d1d0c45b43ec6$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$ae7d1d0c45b43ec6$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.mul = function mul(k) {
    k = new $dEXSZ(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$ae7d1d0c45b43ec6$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$ae7d1d0c45b43ec6$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$ae7d1d0c45b43ec6$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $ae7d1d0c45b43ec6$var$JPoint(curve, x, y, z) {
    $hSu7V.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $dEXSZ(0);
    } else {
        this.x = new $dEXSZ(x, 16);
        this.y = new $dEXSZ(y, 16);
        this.z = new $dEXSZ(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$dlqwk($ae7d1d0c45b43ec6$var$JPoint, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $ae7d1d0c45b43ec6$var$JPoint(this, x, y, z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $dEXSZ(k, kbase);
    return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("av2Yx", function(module, exports) {
"use strict";

var $dEXSZ = parcelRequire("dEXSZ");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");

var $gEVtY = parcelRequire("gEVtY");
function $7a4f1b7c0dc1f992$var$MontCurve(conf) {
    $hSu7V.call(this, "mont", conf);
    this.a = new $dEXSZ(conf.a, 16).toRed(this.red);
    this.b = new $dEXSZ(conf.b, 16).toRed(this.red);
    this.i4 = new $dEXSZ(4).toRed(this.red).redInvm();
    this.two = new $dEXSZ(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$dlqwk($7a4f1b7c0dc1f992$var$MontCurve, $hSu7V);
module.exports = $7a4f1b7c0dc1f992$var$MontCurve;
$7a4f1b7c0dc1f992$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $7a4f1b7c0dc1f992$var$Point(curve, x, z) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $dEXSZ(x, 16);
        this.z = new $dEXSZ(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$dlqwk($7a4f1b7c0dc1f992$var$Point, $hSu7V.BasePoint);
$7a4f1b7c0dc1f992$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($gEVtY.toArray(bytes, enc), 1);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.point = function point(x, z) {
    return new $7a4f1b7c0dc1f992$var$Point(this, x, z);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $7a4f1b7c0dc1f992$var$Point.fromJSON(this, obj);
};
$7a4f1b7c0dc1f992$var$Point.prototype.precompute = function precompute() {
// No-op
};
$7a4f1b7c0dc1f992$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$7a4f1b7c0dc1f992$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $7a4f1b7c0dc1f992$var$Point(curve, obj[0], obj[1] || curve.one);
};
$7a4f1b7c0dc1f992$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$7a4f1b7c0dc1f992$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$7a4f1b7c0dc1f992$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$7a4f1b7c0dc1f992$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("dqmX9", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $dEXSZ = parcelRequire("dEXSZ");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $9c5f8216d530af0e$var$assert = $gEVtY.assert;
function $9c5f8216d530af0e$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $hSu7V.call(this, "edwards", conf);
    this.a = new $dEXSZ(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $dEXSZ(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $dEXSZ(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $9c5f8216d530af0e$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$dlqwk($9c5f8216d530af0e$var$EdwardsCurve, $hSu7V);
module.exports = $9c5f8216d530af0e$var$EdwardsCurve;
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$9c5f8216d530af0e$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $dEXSZ(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $dEXSZ(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $9c5f8216d530af0e$var$Point(curve, x, y, z, t) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $dEXSZ(x, 16);
        this.y = new $dEXSZ(y, 16);
        this.z = z ? new $dEXSZ(z, 16) : this.curve.one;
        this.t = t && new $dEXSZ(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$dlqwk($9c5f8216d530af0e$var$Point, $hSu7V.BasePoint);
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $9c5f8216d530af0e$var$Point.fromJSON(this, obj);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $9c5f8216d530af0e$var$Point(this, x, y, z, t);
};
$9c5f8216d530af0e$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $9c5f8216d530af0e$var$Point(curve, obj[0], obj[1], obj[2]);
};
$9c5f8216d530af0e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$9c5f8216d530af0e$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$9c5f8216d530af0e$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$9c5f8216d530af0e$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$9c5f8216d530af0e$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$9c5f8216d530af0e$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$9c5f8216d530af0e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$9c5f8216d530af0e$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$9c5f8216d530af0e$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$9c5f8216d530af0e$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$9c5f8216d530af0e$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$9c5f8216d530af0e$var$Point.prototype.toP = $9c5f8216d530af0e$var$Point.prototype.normalize;
$9c5f8216d530af0e$var$Point.prototype.mixedAdd = $9c5f8216d530af0e$var$Point.prototype.add;

});


parcelRegister("fbTbW", function(module, exports) {
"use strict";
var $b0f2b206068f1378$var$curves = module.exports;

var $kiSKt = parcelRequire("kiSKt");

var $cP1GP = parcelRequire("cP1GP");

var $gEVtY = parcelRequire("gEVtY");
var $b0f2b206068f1378$var$assert = $gEVtY.assert;
function $b0f2b206068f1378$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $cP1GP.short(options);
    else if (options.type === "edwards") this.curve = new $cP1GP.edwards(options);
    else this.curve = new $cP1GP.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $b0f2b206068f1378$var$assert(this.g.validate(), "Invalid curve");
    $b0f2b206068f1378$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$b0f2b206068f1378$var$curves.PresetCurve = $b0f2b206068f1378$var$PresetCurve;
function $b0f2b206068f1378$var$defineCurve(name, options) {
    Object.defineProperty($b0f2b206068f1378$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $b0f2b206068f1378$var$PresetCurve(options);
            Object.defineProperty($b0f2b206068f1378$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$b0f2b206068f1378$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$b0f2b206068f1378$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$b0f2b206068f1378$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$b0f2b206068f1378$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $kiSKt.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$b0f2b206068f1378$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $kiSKt.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$b0f2b206068f1378$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$b0f2b206068f1378$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $b0f2b206068f1378$var$pre;

try {
    $b0f2b206068f1378$var$pre = (parcelRequire("lNVWe"));
} catch (e) {
    $b0f2b206068f1378$var$pre = undefined;
}
$b0f2b206068f1378$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $kiSKt.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $b0f2b206068f1378$var$pre
    ]
});

});
parcelRegister("kiSKt", function(module, exports) {
var $ec7ff5071b027891$var$hash = module.exports;

$ec7ff5071b027891$var$hash.utils = (parcelRequire("btcbI"));

$ec7ff5071b027891$var$hash.common = (parcelRequire("aAb7n"));

$ec7ff5071b027891$var$hash.sha = (parcelRequire("2wnQk"));

$ec7ff5071b027891$var$hash.ripemd = (parcelRequire("05eZB"));

$ec7ff5071b027891$var$hash.hmac = (parcelRequire("ap2lu"));
// Proxy hash functions to the main object
$ec7ff5071b027891$var$hash.sha1 = $ec7ff5071b027891$var$hash.sha.sha1;
$ec7ff5071b027891$var$hash.sha256 = $ec7ff5071b027891$var$hash.sha.sha256;
$ec7ff5071b027891$var$hash.sha224 = $ec7ff5071b027891$var$hash.sha.sha224;
$ec7ff5071b027891$var$hash.sha384 = $ec7ff5071b027891$var$hash.sha.sha384;
$ec7ff5071b027891$var$hash.sha512 = $ec7ff5071b027891$var$hash.sha.sha512;
$ec7ff5071b027891$var$hash.ripemd160 = $ec7ff5071b027891$var$hash.ripemd.ripemd160;

});
parcelRegister("btcbI", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $859bdb699f0f4e15$export$69f1b2dcda23c5f8, (v) => $859bdb699f0f4e15$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $859bdb699f0f4e15$export$45b10814cc054894, (v) => $859bdb699f0f4e15$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $859bdb699f0f4e15$export$7ea66e3774a60b67, (v) => $859bdb699f0f4e15$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $859bdb699f0f4e15$export$34a52f00f601f6f1, (v) => $859bdb699f0f4e15$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $859bdb699f0f4e15$export$812b0cbd5e8a72ab, (v) => $859bdb699f0f4e15$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $859bdb699f0f4e15$export$f24f9e11d63bb314, (v) => $859bdb699f0f4e15$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $859bdb699f0f4e15$export$b71357c7e07ca1f1, (v) => $859bdb699f0f4e15$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $859bdb699f0f4e15$export$2e58a4b541fdcbe8, (v) => $859bdb699f0f4e15$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $859bdb699f0f4e15$export$183b950bde9faab8, (v) => $859bdb699f0f4e15$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $859bdb699f0f4e15$export$4785c77169fea59e, (v) => $859bdb699f0f4e15$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $859bdb699f0f4e15$export$242a185dfcffac5b, (v) => $859bdb699f0f4e15$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $859bdb699f0f4e15$export$58c04ae0ae31877d, (v) => $859bdb699f0f4e15$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $859bdb699f0f4e15$export$d058ca695f8c6f11, (v) => $859bdb699f0f4e15$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $859bdb699f0f4e15$export$a1efd7fc3e986367, (v) => $859bdb699f0f4e15$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $859bdb699f0f4e15$export$bbfea4a2b5abaab4, (v) => $859bdb699f0f4e15$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $859bdb699f0f4e15$export$97ad4afc7de86152, (v) => $859bdb699f0f4e15$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $859bdb699f0f4e15$export$ce4673d9a79f6a4b, (v) => $859bdb699f0f4e15$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $859bdb699f0f4e15$export$786cc99fc6eedc0b, (v) => $859bdb699f0f4e15$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $859bdb699f0f4e15$export$45c59b9a1848dd0, (v) => $859bdb699f0f4e15$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $859bdb699f0f4e15$export$50d8f613e76d3034, (v) => $859bdb699f0f4e15$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $859bdb699f0f4e15$export$b8e83683c60ee162, (v) => $859bdb699f0f4e15$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $859bdb699f0f4e15$export$aeeb51790d1bcc4a, (v) => $859bdb699f0f4e15$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $859bdb699f0f4e15$export$bb7c616f719ad9c, (v) => $859bdb699f0f4e15$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $859bdb699f0f4e15$export$4d63290824f9d7df, (v) => $859bdb699f0f4e15$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $859bdb699f0f4e15$export$2f64ceb90ef28ea1, (v) => $859bdb699f0f4e15$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $859bdb699f0f4e15$export$8d2089d465f6d10d, (v) => $859bdb699f0f4e15$export$8d2089d465f6d10d = v);
var $859bdb699f0f4e15$export$69f1b2dcda23c5f8;
var $859bdb699f0f4e15$export$45b10814cc054894;
var $859bdb699f0f4e15$export$7ea66e3774a60b67;
var $859bdb699f0f4e15$export$34a52f00f601f6f1;
var $859bdb699f0f4e15$export$812b0cbd5e8a72ab;
var $859bdb699f0f4e15$export$f24f9e11d63bb314;
var $859bdb699f0f4e15$export$b71357c7e07ca1f1;
var $859bdb699f0f4e15$export$2e58a4b541fdcbe8;
var $859bdb699f0f4e15$export$183b950bde9faab8;
var $859bdb699f0f4e15$export$4785c77169fea59e;
var $859bdb699f0f4e15$export$242a185dfcffac5b;
var $859bdb699f0f4e15$export$58c04ae0ae31877d;
var $859bdb699f0f4e15$export$d058ca695f8c6f11;
var $859bdb699f0f4e15$export$a1efd7fc3e986367;
var $859bdb699f0f4e15$export$bbfea4a2b5abaab4;
var $859bdb699f0f4e15$export$97ad4afc7de86152;
var $859bdb699f0f4e15$export$ce4673d9a79f6a4b;
var $859bdb699f0f4e15$export$786cc99fc6eedc0b;
var $859bdb699f0f4e15$export$45c59b9a1848dd0;
var $859bdb699f0f4e15$export$50d8f613e76d3034;
var $859bdb699f0f4e15$export$b8e83683c60ee162;
var $859bdb699f0f4e15$export$aeeb51790d1bcc4a;
var $859bdb699f0f4e15$export$bb7c616f719ad9c;
var $859bdb699f0f4e15$export$4d63290824f9d7df;
var $859bdb699f0f4e15$export$2f64ceb90ef28ea1;
var $859bdb699f0f4e15$export$8d2089d465f6d10d;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
$859bdb699f0f4e15$export$69f1b2dcda23c5f8 = $dlqwk;
function $859bdb699f0f4e15$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $859bdb699f0f4e15$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($859bdb699f0f4e15$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$859bdb699f0f4e15$export$45b10814cc054894 = $859bdb699f0f4e15$var$toArray;
function $859bdb699f0f4e15$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $859bdb699f0f4e15$var$zero2(msg[i].toString(16));
    return res;
}
$859bdb699f0f4e15$export$7ea66e3774a60b67 = $859bdb699f0f4e15$var$toHex;
function $859bdb699f0f4e15$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$859bdb699f0f4e15$export$34a52f00f601f6f1 = $859bdb699f0f4e15$var$htonl;
function $859bdb699f0f4e15$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $859bdb699f0f4e15$var$htonl(w);
        res += $859bdb699f0f4e15$var$zero8(w.toString(16));
    }
    return res;
}
$859bdb699f0f4e15$export$812b0cbd5e8a72ab = $859bdb699f0f4e15$var$toHex32;
function $859bdb699f0f4e15$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$859bdb699f0f4e15$export$f24f9e11d63bb314 = $859bdb699f0f4e15$var$zero2;
function $859bdb699f0f4e15$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$859bdb699f0f4e15$export$b71357c7e07ca1f1 = $859bdb699f0f4e15$var$zero8;
function $859bdb699f0f4e15$var$join32(msg, start, end, endian) {
    var len = end - start;
    $koC21(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$859bdb699f0f4e15$export$2e58a4b541fdcbe8 = $859bdb699f0f4e15$var$join32;
function $859bdb699f0f4e15$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$859bdb699f0f4e15$export$183b950bde9faab8 = $859bdb699f0f4e15$var$split32;
function $859bdb699f0f4e15$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$859bdb699f0f4e15$export$4785c77169fea59e = $859bdb699f0f4e15$var$rotr32;
function $859bdb699f0f4e15$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$859bdb699f0f4e15$export$242a185dfcffac5b = $859bdb699f0f4e15$var$rotl32;
function $859bdb699f0f4e15$var$sum32(a, b) {
    return a + b >>> 0;
}
$859bdb699f0f4e15$export$58c04ae0ae31877d = $859bdb699f0f4e15$var$sum32;
function $859bdb699f0f4e15$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$859bdb699f0f4e15$export$d058ca695f8c6f11 = $859bdb699f0f4e15$var$sum32_3;
function $859bdb699f0f4e15$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$859bdb699f0f4e15$export$a1efd7fc3e986367 = $859bdb699f0f4e15$var$sum32_4;
function $859bdb699f0f4e15$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$859bdb699f0f4e15$export$bbfea4a2b5abaab4 = $859bdb699f0f4e15$var$sum32_5;
function $859bdb699f0f4e15$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$859bdb699f0f4e15$export$97ad4afc7de86152 = $859bdb699f0f4e15$var$sum64;
function $859bdb699f0f4e15$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$ce4673d9a79f6a4b = $859bdb699f0f4e15$var$sum64_hi;
function $859bdb699f0f4e15$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$786cc99fc6eedc0b = $859bdb699f0f4e15$var$sum64_lo;
function $859bdb699f0f4e15$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$45c59b9a1848dd0 = $859bdb699f0f4e15$var$sum64_4_hi;
function $859bdb699f0f4e15$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$50d8f613e76d3034 = $859bdb699f0f4e15$var$sum64_4_lo;
function $859bdb699f0f4e15$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$b8e83683c60ee162 = $859bdb699f0f4e15$var$sum64_5_hi;
function $859bdb699f0f4e15$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$aeeb51790d1bcc4a = $859bdb699f0f4e15$var$sum64_5_lo;
function $859bdb699f0f4e15$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$bb7c616f719ad9c = $859bdb699f0f4e15$var$rotr64_hi;
function $859bdb699f0f4e15$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$4d63290824f9d7df = $859bdb699f0f4e15$var$rotr64_lo;
function $859bdb699f0f4e15$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$859bdb699f0f4e15$export$2f64ceb90ef28ea1 = $859bdb699f0f4e15$var$shr64_hi;
function $859bdb699f0f4e15$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$8d2089d465f6d10d = $859bdb699f0f4e15$var$shr64_lo;

});

parcelRegister("aAb7n", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7b45e3fb23ceb2f4$export$8687658379b577e6, (v) => $7b45e3fb23ceb2f4$export$8687658379b577e6 = v);
var $7b45e3fb23ceb2f4$export$8687658379b577e6;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $7b45e3fb23ceb2f4$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7b45e3fb23ceb2f4$export$8687658379b577e6 = $7b45e3fb23ceb2f4$var$BlockHash;
$7b45e3fb23ceb2f4$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $btcbI.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $btcbI.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $koC21(this.pending === null);
    return this._digest(enc);
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("2wnQk", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $1d6110a725745f5a$export$5091bdda49ba90f5, (v) => $1d6110a725745f5a$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $1d6110a725745f5a$export$97b70509d4e397ea, (v) => $1d6110a725745f5a$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $1d6110a725745f5a$export$bced8d2aada2d1c9, (v) => $1d6110a725745f5a$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $1d6110a725745f5a$export$612d47d55dedde45, (v) => $1d6110a725745f5a$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $1d6110a725745f5a$export$a888d2532e6dc7bb, (v) => $1d6110a725745f5a$export$a888d2532e6dc7bb = v);
var $1d6110a725745f5a$export$5091bdda49ba90f5;
var $1d6110a725745f5a$export$97b70509d4e397ea;
var $1d6110a725745f5a$export$bced8d2aada2d1c9;
var $1d6110a725745f5a$export$612d47d55dedde45;
var $1d6110a725745f5a$export$a888d2532e6dc7bb;
"use strict";

$1d6110a725745f5a$export$5091bdda49ba90f5 = (parcelRequire("IUW6G"));

$1d6110a725745f5a$export$97b70509d4e397ea = (parcelRequire("gBE2w"));

$1d6110a725745f5a$export$bced8d2aada2d1c9 = (parcelRequire("a9EzX"));

$1d6110a725745f5a$export$612d47d55dedde45 = (parcelRequire("7j4cV"));

$1d6110a725745f5a$export$a888d2532e6dc7bb = (parcelRequire("lMBCM"));

});
parcelRegister("IUW6G", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");
var $0870468534428d45$var$rotl32 = $btcbI.rotl32;
var $0870468534428d45$var$sum32 = $btcbI.sum32;
var $0870468534428d45$var$sum32_5 = $btcbI.sum32_5;
var $0870468534428d45$var$ft_1 = $dV8oa.ft_1;
var $0870468534428d45$var$BlockHash = $aAb7n.BlockHash;
var $0870468534428d45$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $0870468534428d45$var$SHA1() {
    if (!(this instanceof $0870468534428d45$var$SHA1)) return new $0870468534428d45$var$SHA1();
    $0870468534428d45$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$btcbI.inherits($0870468534428d45$var$SHA1, $0870468534428d45$var$BlockHash);
module.exports = $0870468534428d45$var$SHA1;
$0870468534428d45$var$SHA1.blockSize = 512;
$0870468534428d45$var$SHA1.outSize = 160;
$0870468534428d45$var$SHA1.hmacStrength = 80;
$0870468534428d45$var$SHA1.padLength = 64;
$0870468534428d45$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $0870468534428d45$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $0870468534428d45$var$sum32_5($0870468534428d45$var$rotl32(a, 5), $0870468534428d45$var$ft_1(s, b, c, d), e, W[i], $0870468534428d45$var$sha1_K[s]);
        e = d;
        d = c;
        c = $0870468534428d45$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $0870468534428d45$var$sum32(this.h[0], a);
    this.h[1] = $0870468534428d45$var$sum32(this.h[1], b);
    this.h[2] = $0870468534428d45$var$sum32(this.h[2], c);
    this.h[3] = $0870468534428d45$var$sum32(this.h[3], d);
    this.h[4] = $0870468534428d45$var$sum32(this.h[4], e);
};
$0870468534428d45$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});
parcelRegister("dV8oa", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $a2271b1744b4602b$export$5a92649d7ddb9f63, (v) => $a2271b1744b4602b$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $a2271b1744b4602b$export$c6d0d020c3a6269, (v) => $a2271b1744b4602b$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $a2271b1744b4602b$export$eb90c27fca05f956, (v) => $a2271b1744b4602b$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $a2271b1744b4602b$export$14a4a98e063b1999, (v) => $a2271b1744b4602b$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $a2271b1744b4602b$export$d20cecfa1564c686, (v) => $a2271b1744b4602b$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $a2271b1744b4602b$export$44fd472a12fc6db, (v) => $a2271b1744b4602b$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $a2271b1744b4602b$export$1ed238bb6ea1dd47, (v) => $a2271b1744b4602b$export$1ed238bb6ea1dd47 = v);
var $a2271b1744b4602b$export$5a92649d7ddb9f63;
var $a2271b1744b4602b$export$c6d0d020c3a6269;
var $a2271b1744b4602b$export$eb90c27fca05f956;
var $a2271b1744b4602b$export$cc992891a14496a1;
var $a2271b1744b4602b$export$14a4a98e063b1999;
var $a2271b1744b4602b$export$d20cecfa1564c686;
var $a2271b1744b4602b$export$44fd472a12fc6db;
var $a2271b1744b4602b$export$1ed238bb6ea1dd47;
"use strict";

var $btcbI = parcelRequire("btcbI");
var $a2271b1744b4602b$var$rotr32 = $btcbI.rotr32;
function $a2271b1744b4602b$var$ft_1(s, x, y, z) {
    if (s === 0) return $a2271b1744b4602b$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $a2271b1744b4602b$var$p32(x, y, z);
    if (s === 2) return $a2271b1744b4602b$var$maj32(x, y, z);
}
$a2271b1744b4602b$export$5a92649d7ddb9f63 = $a2271b1744b4602b$var$ft_1;
function $a2271b1744b4602b$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$a2271b1744b4602b$export$c6d0d020c3a6269 = $a2271b1744b4602b$var$ch32;
function $a2271b1744b4602b$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$a2271b1744b4602b$export$eb90c27fca05f956 = $a2271b1744b4602b$var$maj32;
function $a2271b1744b4602b$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$a2271b1744b4602b$export$cc992891a14496a1 = $a2271b1744b4602b$var$p32;
function $a2271b1744b4602b$var$s0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 2) ^ $a2271b1744b4602b$var$rotr32(x, 13) ^ $a2271b1744b4602b$var$rotr32(x, 22);
}
$a2271b1744b4602b$export$14a4a98e063b1999 = $a2271b1744b4602b$var$s0_256;
function $a2271b1744b4602b$var$s1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 6) ^ $a2271b1744b4602b$var$rotr32(x, 11) ^ $a2271b1744b4602b$var$rotr32(x, 25);
}
$a2271b1744b4602b$export$d20cecfa1564c686 = $a2271b1744b4602b$var$s1_256;
function $a2271b1744b4602b$var$g0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 7) ^ $a2271b1744b4602b$var$rotr32(x, 18) ^ x >>> 3;
}
$a2271b1744b4602b$export$44fd472a12fc6db = $a2271b1744b4602b$var$g0_256;
function $a2271b1744b4602b$var$g1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 17) ^ $a2271b1744b4602b$var$rotr32(x, 19) ^ x >>> 10;
}
$a2271b1744b4602b$export$1ed238bb6ea1dd47 = $a2271b1744b4602b$var$g1_256;

});


parcelRegister("gBE2w", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $a9EzX = parcelRequire("a9EzX");
function $c16f2915997a3b04$var$SHA224() {
    if (!(this instanceof $c16f2915997a3b04$var$SHA224)) return new $c16f2915997a3b04$var$SHA224();
    $a9EzX.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$btcbI.inherits($c16f2915997a3b04$var$SHA224, $a9EzX);
module.exports = $c16f2915997a3b04$var$SHA224;
$c16f2915997a3b04$var$SHA224.blockSize = 512;
$c16f2915997a3b04$var$SHA224.outSize = 224;
$c16f2915997a3b04$var$SHA224.hmacStrength = 192;
$c16f2915997a3b04$var$SHA224.padLength = 64;
$c16f2915997a3b04$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 7), "big");
    else return $btcbI.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("a9EzX", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");

var $koC21 = parcelRequire("koC21");
var $764a38c4cb12cffe$var$sum32 = $btcbI.sum32;
var $764a38c4cb12cffe$var$sum32_4 = $btcbI.sum32_4;
var $764a38c4cb12cffe$var$sum32_5 = $btcbI.sum32_5;
var $764a38c4cb12cffe$var$ch32 = $dV8oa.ch32;
var $764a38c4cb12cffe$var$maj32 = $dV8oa.maj32;
var $764a38c4cb12cffe$var$s0_256 = $dV8oa.s0_256;
var $764a38c4cb12cffe$var$s1_256 = $dV8oa.s1_256;
var $764a38c4cb12cffe$var$g0_256 = $dV8oa.g0_256;
var $764a38c4cb12cffe$var$g1_256 = $dV8oa.g1_256;
var $764a38c4cb12cffe$var$BlockHash = $aAb7n.BlockHash;
var $764a38c4cb12cffe$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $764a38c4cb12cffe$var$SHA256() {
    if (!(this instanceof $764a38c4cb12cffe$var$SHA256)) return new $764a38c4cb12cffe$var$SHA256();
    $764a38c4cb12cffe$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $764a38c4cb12cffe$var$sha256_K;
    this.W = new Array(64);
}
$btcbI.inherits($764a38c4cb12cffe$var$SHA256, $764a38c4cb12cffe$var$BlockHash);
module.exports = $764a38c4cb12cffe$var$SHA256;
$764a38c4cb12cffe$var$SHA256.blockSize = 512;
$764a38c4cb12cffe$var$SHA256.outSize = 256;
$764a38c4cb12cffe$var$SHA256.hmacStrength = 192;
$764a38c4cb12cffe$var$SHA256.padLength = 64;
$764a38c4cb12cffe$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $764a38c4cb12cffe$var$sum32_4($764a38c4cb12cffe$var$g1_256(W[i - 2]), W[i - 7], $764a38c4cb12cffe$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $koC21(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $764a38c4cb12cffe$var$sum32_5(h, $764a38c4cb12cffe$var$s1_256(e), $764a38c4cb12cffe$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $764a38c4cb12cffe$var$sum32($764a38c4cb12cffe$var$s0_256(a), $764a38c4cb12cffe$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $764a38c4cb12cffe$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $764a38c4cb12cffe$var$sum32(T1, T2);
    }
    this.h[0] = $764a38c4cb12cffe$var$sum32(this.h[0], a);
    this.h[1] = $764a38c4cb12cffe$var$sum32(this.h[1], b);
    this.h[2] = $764a38c4cb12cffe$var$sum32(this.h[2], c);
    this.h[3] = $764a38c4cb12cffe$var$sum32(this.h[3], d);
    this.h[4] = $764a38c4cb12cffe$var$sum32(this.h[4], e);
    this.h[5] = $764a38c4cb12cffe$var$sum32(this.h[5], f);
    this.h[6] = $764a38c4cb12cffe$var$sum32(this.h[6], g);
    this.h[7] = $764a38c4cb12cffe$var$sum32(this.h[7], h);
};
$764a38c4cb12cffe$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});


parcelRegister("7j4cV", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $lMBCM = parcelRequire("lMBCM");
function $551d923eb49b8fc5$var$SHA384() {
    if (!(this instanceof $551d923eb49b8fc5$var$SHA384)) return new $551d923eb49b8fc5$var$SHA384();
    $lMBCM.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$btcbI.inherits($551d923eb49b8fc5$var$SHA384, $lMBCM);
module.exports = $551d923eb49b8fc5$var$SHA384;
$551d923eb49b8fc5$var$SHA384.blockSize = 1024;
$551d923eb49b8fc5$var$SHA384.outSize = 384;
$551d923eb49b8fc5$var$SHA384.hmacStrength = 192;
$551d923eb49b8fc5$var$SHA384.padLength = 128;
$551d923eb49b8fc5$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 12), "big");
    else return $btcbI.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("lMBCM", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $koC21 = parcelRequire("koC21");
var $fdbb441c0566fb85$var$rotr64_hi = $btcbI.rotr64_hi;
var $fdbb441c0566fb85$var$rotr64_lo = $btcbI.rotr64_lo;
var $fdbb441c0566fb85$var$shr64_hi = $btcbI.shr64_hi;
var $fdbb441c0566fb85$var$shr64_lo = $btcbI.shr64_lo;
var $fdbb441c0566fb85$var$sum64 = $btcbI.sum64;
var $fdbb441c0566fb85$var$sum64_hi = $btcbI.sum64_hi;
var $fdbb441c0566fb85$var$sum64_lo = $btcbI.sum64_lo;
var $fdbb441c0566fb85$var$sum64_4_hi = $btcbI.sum64_4_hi;
var $fdbb441c0566fb85$var$sum64_4_lo = $btcbI.sum64_4_lo;
var $fdbb441c0566fb85$var$sum64_5_hi = $btcbI.sum64_5_hi;
var $fdbb441c0566fb85$var$sum64_5_lo = $btcbI.sum64_5_lo;
var $fdbb441c0566fb85$var$BlockHash = $aAb7n.BlockHash;
var $fdbb441c0566fb85$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $fdbb441c0566fb85$var$SHA512() {
    if (!(this instanceof $fdbb441c0566fb85$var$SHA512)) return new $fdbb441c0566fb85$var$SHA512();
    $fdbb441c0566fb85$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $fdbb441c0566fb85$var$sha512_K;
    this.W = new Array(160);
}
$btcbI.inherits($fdbb441c0566fb85$var$SHA512, $fdbb441c0566fb85$var$BlockHash);
module.exports = $fdbb441c0566fb85$var$SHA512;
$fdbb441c0566fb85$var$SHA512.blockSize = 1024;
$fdbb441c0566fb85$var$SHA512.outSize = 512;
$fdbb441c0566fb85$var$SHA512.hmacStrength = 192;
$fdbb441c0566fb85$var$SHA512.padLength = 128;
$fdbb441c0566fb85$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $fdbb441c0566fb85$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $fdbb441c0566fb85$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $fdbb441c0566fb85$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $fdbb441c0566fb85$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $fdbb441c0566fb85$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $fdbb441c0566fb85$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$fdbb441c0566fb85$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $koC21(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $fdbb441c0566fb85$var$s1_512_hi(eh, el);
        var c1_lo = $fdbb441c0566fb85$var$s1_512_lo(eh, el);
        var c2_hi = $fdbb441c0566fb85$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $fdbb441c0566fb85$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $fdbb441c0566fb85$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $fdbb441c0566fb85$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $fdbb441c0566fb85$var$s0_512_hi(ah, al);
        c0_lo = $fdbb441c0566fb85$var$s0_512_lo(ah, al);
        c1_hi = $fdbb441c0566fb85$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $fdbb441c0566fb85$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $fdbb441c0566fb85$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $fdbb441c0566fb85$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $fdbb441c0566fb85$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $fdbb441c0566fb85$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $fdbb441c0566fb85$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $fdbb441c0566fb85$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $fdbb441c0566fb85$var$sum64(this.h, 0, ah, al);
    $fdbb441c0566fb85$var$sum64(this.h, 2, bh, bl);
    $fdbb441c0566fb85$var$sum64(this.h, 4, ch, cl);
    $fdbb441c0566fb85$var$sum64(this.h, 6, dh, dl);
    $fdbb441c0566fb85$var$sum64(this.h, 8, eh, el);
    $fdbb441c0566fb85$var$sum64(this.h, 10, fh, fl);
    $fdbb441c0566fb85$var$sum64(this.h, 12, gh, gl);
    $fdbb441c0566fb85$var$sum64(this.h, 14, hh, hl);
};
$fdbb441c0566fb85$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};
function $fdbb441c0566fb85$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("05eZB", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e, (v) => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e = v);
var $00fc18f316764a3b$export$d1cea0ee4e3f0d3e;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");
var $00fc18f316764a3b$var$rotl32 = $btcbI.rotl32;
var $00fc18f316764a3b$var$sum32 = $btcbI.sum32;
var $00fc18f316764a3b$var$sum32_3 = $btcbI.sum32_3;
var $00fc18f316764a3b$var$sum32_4 = $btcbI.sum32_4;
var $00fc18f316764a3b$var$BlockHash = $aAb7n.BlockHash;
function $00fc18f316764a3b$var$RIPEMD160() {
    if (!(this instanceof $00fc18f316764a3b$var$RIPEMD160)) return new $00fc18f316764a3b$var$RIPEMD160();
    $00fc18f316764a3b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$btcbI.inherits($00fc18f316764a3b$var$RIPEMD160, $00fc18f316764a3b$var$BlockHash);
$00fc18f316764a3b$export$d1cea0ee4e3f0d3e = $00fc18f316764a3b$var$RIPEMD160;
$00fc18f316764a3b$var$RIPEMD160.blockSize = 512;
$00fc18f316764a3b$var$RIPEMD160.outSize = 160;
$00fc18f316764a3b$var$RIPEMD160.hmacStrength = 192;
$00fc18f316764a3b$var$RIPEMD160.padLength = 64;
$00fc18f316764a3b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(A, $00fc18f316764a3b$var$f(j, B, C, D), msg[$00fc18f316764a3b$var$r[j] + start], $00fc18f316764a3b$var$K(j)), $00fc18f316764a3b$var$s[j]), E);
        A = E;
        E = D;
        D = $00fc18f316764a3b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(Ah, $00fc18f316764a3b$var$f(79 - j, Bh, Ch, Dh), msg[$00fc18f316764a3b$var$rh[j] + start], $00fc18f316764a3b$var$Kh(j)), $00fc18f316764a3b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $00fc18f316764a3b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $00fc18f316764a3b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $00fc18f316764a3b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $00fc18f316764a3b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $00fc18f316764a3b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $00fc18f316764a3b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$00fc18f316764a3b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "little");
    else return $btcbI.split32(this.h, "little");
};
function $00fc18f316764a3b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $00fc18f316764a3b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $00fc18f316764a3b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $00fc18f316764a3b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $00fc18f316764a3b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $00fc18f316764a3b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $00fc18f316764a3b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("ap2lu", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $792e0ef6fa035d02$var$Hmac(hash, key, enc) {
    if (!(this instanceof $792e0ef6fa035d02$var$Hmac)) return new $792e0ef6fa035d02$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($btcbI.toArray(key, enc));
}
module.exports = $792e0ef6fa035d02$var$Hmac;
$792e0ef6fa035d02$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $koC21(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$792e0ef6fa035d02$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$792e0ef6fa035d02$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("lNVWe", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRegister("220Zx", function(module, exports) {
"use strict";

var $dEXSZ = parcelRequire("dEXSZ");

var $kKonu = parcelRequire("kKonu");

var $gEVtY = parcelRequire("gEVtY");

var $fbTbW = parcelRequire("fbTbW");

var $7JHF0 = parcelRequire("7JHF0");
var $17ac898fe5b06379$var$assert = $gEVtY.assert;

var $lPqzs = parcelRequire("lPqzs");

var $i46nc = parcelRequire("i46nc");
function $17ac898fe5b06379$var$EC(options) {
    if (!(this instanceof $17ac898fe5b06379$var$EC)) return new $17ac898fe5b06379$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $17ac898fe5b06379$var$assert(Object.prototype.hasOwnProperty.call($fbTbW, options), "Unknown curve " + options);
        options = $fbTbW[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $fbTbW.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $17ac898fe5b06379$var$EC;
$17ac898fe5b06379$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lPqzs(this, options);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lPqzs.fromPrivate(this, priv, enc);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lPqzs.fromPublic(this, pub, enc);
};
$17ac898fe5b06379$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $7JHF0(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $dEXSZ(2));
    for(;;){
        var priv = new $dEXSZ(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$17ac898fe5b06379$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$17ac898fe5b06379$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $dEXSZ(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $dEXSZ(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $dEXSZ(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $i46nc({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$17ac898fe5b06379$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $dEXSZ(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $i46nc(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$17ac898fe5b06379$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $17ac898fe5b06379$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $i46nc(signature, enc);
    var n = this.n;
    var e = new $dEXSZ(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$17ac898fe5b06379$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $i46nc(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRegister("kKonu", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $lC4vN = parcelRequire("lC4vN");

var $koC21 = parcelRequire("koC21");
function $f1ab03780ebd0ab4$var$HmacDRBG(options) {
    if (!(this instanceof $f1ab03780ebd0ab4$var$HmacDRBG)) return new $f1ab03780ebd0ab4$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $lC4vN.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $lC4vN.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $lC4vN.toArray(options.pers, options.persEnc || "hex");
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $f1ab03780ebd0ab4$var$HmacDRBG;
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $kiSKt.hmac(this.hash, this.K);
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $lC4vN.toArray(entropy, entropyEnc);
    add = $lC4vN.toArray(add, addEnc);
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $lC4vN.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $lC4vN.encode(res, enc);
};

});

parcelRegister("lPqzs", function(module, exports) {
"use strict";

var $dEXSZ = parcelRequire("dEXSZ");

var $gEVtY = parcelRequire("gEVtY");
var $fe42f8d68750188b$var$assert = $gEVtY.assert;
function $fe42f8d68750188b$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fe42f8d68750188b$var$KeyPair;
$fe42f8d68750188b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fe42f8d68750188b$var$KeyPair) return pub;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fe42f8d68750188b$var$KeyPair) return priv;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$fe42f8d68750188b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fe42f8d68750188b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$fe42f8d68750188b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $dEXSZ(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fe42f8d68750188b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $fe42f8d68750188b$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $fe42f8d68750188b$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fe42f8d68750188b$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fe42f8d68750188b$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$fe42f8d68750188b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$fe42f8d68750188b$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRegister("i46nc", function(module, exports) {
"use strict";

var $dEXSZ = parcelRequire("dEXSZ");

var $gEVtY = parcelRequire("gEVtY");
var $d26d8b510bde7292$var$assert = $gEVtY.assert;
function $d26d8b510bde7292$var$Signature(options, enc) {
    if (options instanceof $d26d8b510bde7292$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $d26d8b510bde7292$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $dEXSZ(options.r, 16);
    this.s = new $dEXSZ(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $d26d8b510bde7292$var$Signature;
function $d26d8b510bde7292$var$Position() {
    this.place = 0;
}
function $d26d8b510bde7292$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $d26d8b510bde7292$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$d26d8b510bde7292$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $gEVtY.toArray(data, enc);
    var p = new $d26d8b510bde7292$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $d26d8b510bde7292$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $d26d8b510bde7292$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $d26d8b510bde7292$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $dEXSZ(r);
    this.s = new $dEXSZ(s);
    this.recoveryParam = null;
    return true;
};
function $d26d8b510bde7292$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$d26d8b510bde7292$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $d26d8b510bde7292$var$rmPadding(r);
    s = $d26d8b510bde7292$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $d26d8b510bde7292$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $d26d8b510bde7292$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $d26d8b510bde7292$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $gEVtY.encode(res, enc);
};

});


parcelRegister("esmmS", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $fbTbW = parcelRequire("fbTbW");

var $gEVtY = parcelRequire("gEVtY");
var $a865080dcef76248$var$assert = $gEVtY.assert;
var $a865080dcef76248$var$parseBytes = $gEVtY.parseBytes;

var $1D85n = parcelRequire("1D85n");

var $7XcGE = parcelRequire("7XcGE");
function $a865080dcef76248$var$EDDSA(curve) {
    $a865080dcef76248$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $a865080dcef76248$var$EDDSA)) return new $a865080dcef76248$var$EDDSA(curve);
    curve = $fbTbW[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $kiSKt.sha512;
}
module.exports = $a865080dcef76248$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $a865080dcef76248$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $a865080dcef76248$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $a865080dcef76248$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $a865080dcef76248$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$a865080dcef76248$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $gEVtY.intFromLE(hash.digest()).umod(this.curve.n);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $1D85n.fromPublic(this, pub);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $1D85n.fromSecret(this, secret);
};
$a865080dcef76248$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $7XcGE) return sig;
    return new $7XcGE(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $a865080dcef76248$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$a865080dcef76248$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $gEVtY.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $gEVtY.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$a865080dcef76248$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$a865080dcef76248$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $gEVtY.intFromLE(bytes);
};
$a865080dcef76248$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("1D85n", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");
var $12ffb49ca423a34b$var$assert = $gEVtY.assert;
var $12ffb49ca423a34b$var$parseBytes = $gEVtY.parseBytes;
var $12ffb49ca423a34b$var$cachedProperty = $gEVtY.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $12ffb49ca423a34b$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $12ffb49ca423a34b$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $12ffb49ca423a34b$var$parseBytes(params.pub);
}
$12ffb49ca423a34b$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $12ffb49ca423a34b$var$KeyPair) return pub;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        pub: pub
    });
};
$12ffb49ca423a34b$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $12ffb49ca423a34b$var$KeyPair) return secret;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        secret: secret
    });
};
$12ffb49ca423a34b$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$12ffb49ca423a34b$var$KeyPair.prototype.sign = function sign(message) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair is public only");
    return $gEVtY.encode(this.secret(), enc);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $gEVtY.encode(this.pubBytes(), enc);
};
module.exports = $12ffb49ca423a34b$var$KeyPair;

});

parcelRegister("7XcGE", function(module, exports) {
"use strict";

var $dEXSZ = parcelRequire("dEXSZ");

var $gEVtY = parcelRequire("gEVtY");
var $5ca7e26f93e1a560$var$assert = $gEVtY.assert;
var $5ca7e26f93e1a560$var$cachedProperty = $gEVtY.cachedProperty;
var $5ca7e26f93e1a560$var$parseBytes = $gEVtY.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $5ca7e26f93e1a560$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $5ca7e26f93e1a560$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $5ca7e26f93e1a560$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $dEXSZ) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$5ca7e26f93e1a560$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$5ca7e26f93e1a560$var$Signature.prototype.toHex = function toHex() {
    return $gEVtY.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $5ca7e26f93e1a560$var$Signature;

});



parcelRegister("jVUXf", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("aNeDF", function(module, exports) {

var $fC6a8 = parcelRequire("fC6a8");

var $5v6nH = parcelRequire("5v6nH");

var $3ILSx = parcelRequire("3ILSx");

var $7Zu82 = parcelRequire("7Zu82");

var $lORrZ = parcelRequire("lORrZ");

var $1U9GM = parcelRequire("1U9GM");
var $7db9d5f82e4113aa$require$Buffer = $1U9GM.Buffer;
module.exports = $7db9d5f82e4113aa$var$parseKeys;
function $7db9d5f82e4113aa$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$7db9d5f82e4113aa$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $7db9d5f82e4113aa$require$Buffer.from(buffer);
    var stripped = $3ILSx(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $fC6a8.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $fC6a8.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fC6a8.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $fC6a8.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $fC6a8.EncryptedPrivateKey.decode(data, "der");
            data = $7db9d5f82e4113aa$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $fC6a8.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fC6a8.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $fC6a8.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $fC6a8.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $fC6a8.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $fC6a8.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $fC6a8.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $fC6a8.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$7db9d5f82e4113aa$var$parseKeys.signature = $fC6a8.signature;
function $7db9d5f82e4113aa$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $5v6nH[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $lORrZ.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $7Zu82.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $7db9d5f82e4113aa$require$Buffer.concat(out);
}

});
parcelRegister("fC6a8", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $b5df2f5887fb7e8d$export$c98397a6eb8d0678, (v) => $b5df2f5887fb7e8d$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b, (v) => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $b5df2f5887fb7e8d$export$4471f5c65d097c11, (v) => $b5df2f5887fb7e8d$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de, (v) => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $b5df2f5887fb7e8d$export$8f54525b330fd87b, (v) => $b5df2f5887fb7e8d$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7, (v) => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce, (v) => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $b5df2f5887fb7e8d$export$8ad762e3e6399afe, (v) => $b5df2f5887fb7e8d$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0, (v) => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $b5df2f5887fb7e8d$export$c9cd164b539ebb63, (v) => $b5df2f5887fb7e8d$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $b5df2f5887fb7e8d$export$c98397a6eb8d0678;
var $b5df2f5887fb7e8d$export$f4aab6816f64fa6b;
var $b5df2f5887fb7e8d$export$4471f5c65d097c11;
var $b5df2f5887fb7e8d$export$ca8b6604d6ce14de;
var $b5df2f5887fb7e8d$export$8f54525b330fd87b;
var $b5df2f5887fb7e8d$export$23cd2842b44ca3e7;
var $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce;
var $b5df2f5887fb7e8d$export$8ad762e3e6399afe;
var $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0;
var $b5df2f5887fb7e8d$export$c9cd164b539ebb63;
"use strict";

var $10gXo = parcelRequire("10gXo");

$b5df2f5887fb7e8d$export$c98397a6eb8d0678 = (parcelRequire("bDaUv"));
var $b5df2f5887fb7e8d$var$RSAPrivateKey = $10gXo.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
});
$b5df2f5887fb7e8d$export$f4aab6816f64fa6b = $b5df2f5887fb7e8d$var$RSAPrivateKey;
var $b5df2f5887fb7e8d$var$RSAPublicKey = $10gXo.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
});
$b5df2f5887fb7e8d$export$4471f5c65d097c11 = $b5df2f5887fb7e8d$var$RSAPublicKey;
var $b5df2f5887fb7e8d$var$PublicKey = $10gXo.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$b5df2f5887fb7e8d$export$ca8b6604d6ce14de = $b5df2f5887fb7e8d$var$PublicKey;
var $b5df2f5887fb7e8d$var$AlgorithmIdentifier = $10gXo.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
});
var $b5df2f5887fb7e8d$var$PrivateKeyInfo = $10gXo.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version").int(), this.key("algorithm").use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$b5df2f5887fb7e8d$export$8f54525b330fd87b = $b5df2f5887fb7e8d$var$PrivateKeyInfo;
var $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo = $10gXo.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo;
var $b5df2f5887fb7e8d$var$DSAPrivateKey = $10gXo.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
});
$b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = $b5df2f5887fb7e8d$var$DSAPrivateKey;
$b5df2f5887fb7e8d$export$8ad762e3e6399afe = $10gXo.define("DSAparam", function() {
    this.int();
});
var $b5df2f5887fb7e8d$var$ECPrivateKey = $10gXo.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($b5df2f5887fb7e8d$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = $b5df2f5887fb7e8d$var$ECPrivateKey;
var $b5df2f5887fb7e8d$var$ECParameters = $10gXo.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$b5df2f5887fb7e8d$export$c9cd164b539ebb63 = $10gXo.define("signature", function() {
    this.seq().obj(this.key("r").int(), this.key("s").int());
});

});
parcelRegister("10gXo", function(module, exports) {
"use strict";
const $0bb2f1d33a97833b$var$asn1 = module.exports;

$0bb2f1d33a97833b$var$asn1.bignum = (parcelRequire("dEXSZ"));

$0bb2f1d33a97833b$var$asn1.define = (parcelRequire("8fBln")).define;

$0bb2f1d33a97833b$var$asn1.base = (parcelRequire("5JhaY"));

$0bb2f1d33a97833b$var$asn1.constants = (parcelRequire("3TcQc"));

$0bb2f1d33a97833b$var$asn1.decoders = (parcelRequire("89TTw"));

$0bb2f1d33a97833b$var$asn1.encoders = (parcelRequire("ljw8S"));

});
parcelRegister("8fBln", function(module, exports) {
"use strict";

var $ljw8S = parcelRequire("ljw8S");

var $89TTw = parcelRequire("89TTw");

var $dlqwk = parcelRequire("dlqwk");
const $601cb1289d0f28d5$var$api = module.exports;
$601cb1289d0f28d5$var$api.define = function define(name, body) {
    return new $601cb1289d0f28d5$var$Entity(name, body);
};
function $601cb1289d0f28d5$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
$601cb1289d0f28d5$var$Entity.prototype._createNamed = function createNamed(Base) {
    const name = this.name;
    function Generated(entity) {
        this._initNamed(entity, name);
    }
    $dlqwk(Generated, Base);
    Generated.prototype._initNamed = function _initNamed(entity, name) {
        Base.call(this, entity, name);
    };
    return new Generated(this);
};
$601cb1289d0f28d5$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($89TTw[enc]);
    return this.decoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$601cb1289d0f28d5$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($ljw8S[enc]);
    return this.encoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("ljw8S", function(module, exports) {
"use strict";
const $f8444e153c0591ac$var$encoders = module.exports;

$f8444e153c0591ac$var$encoders.der = (parcelRequire("2j6ve"));

$f8444e153c0591ac$var$encoders.pem = (parcelRequire("bPffB"));

});
parcelRegister("2j6ve", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $5ZrzL = parcelRequire("5ZrzL");
var $1ae2666fc718ae87$require$Buffer = $5ZrzL.Buffer;

var $h4y6g = parcelRequire("h4y6g");

var $1G1m0 = parcelRequire("1G1m0");
function $1ae2666fc718ae87$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $1ae2666fc718ae87$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $1ae2666fc718ae87$var$DEREncoder;
$1ae2666fc718ae87$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $1ae2666fc718ae87$var$DERNode(parent) {
    $h4y6g.call(this, "der", parent);
}
$dlqwk($1ae2666fc718ae87$var$DERNode, $h4y6g);
$1ae2666fc718ae87$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    const encodedTag = $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        const header = $1ae2666fc718ae87$require$Buffer.alloc(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    let lenOctets = 1;
    for(let i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    const header = $1ae2666fc718ae87$require$Buffer.alloc(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        const buf = $1ae2666fc718ae87$require$Buffer.alloc(str.length * 2);
        for(let i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s.]+/g);
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    let size = 0;
    for(let i = 0; i < id.length; i++){
        let ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    const objid = $1ae2666fc718ae87$require$Buffer.alloc(size);
    let offset = objid.length - 1;
    for(let i = id.length - 1; i >= 0; i--){
        let ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $1ae2666fc718ae87$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$1ae2666fc718ae87$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    let str;
    const date = new Date(time);
    if (tag === "gentime") str = [
        $1ae2666fc718ae87$var$two(date.getUTCFullYear()),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $1ae2666fc718ae87$var$two(date.getUTCFullYear() % 100),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        const numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = $1ae2666fc718ae87$require$Buffer.from(numArray);
    }
    if ($1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        let size = num.length;
        if (num.length === 0) size++;
        const out = $1ae2666fc718ae87$require$Buffer.alloc(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    let size = 1;
    for(let i = num; i >= 0x100; i >>= 8)size++;
    const out = new Array(size);
    for(let i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer($1ae2666fc718ae87$require$Buffer.from(out));
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$1ae2666fc718ae87$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$1ae2666fc718ae87$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    const state = this._baseState;
    let i;
    if (state["default"] === null) return false;
    const data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, reporter) {
    let res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($1G1m0.tagByName.hasOwnProperty(tag)) res = $1G1m0.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $1G1m0.tagClassByName[cls || "universal"] << 6;
    return res;
}

});
parcelRegister("5ZrzL", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");
var $45c80a3e8b7e5b65$var$Buffer = $6ZWSX.Buffer;
var $45c80a3e8b7e5b65$var$safer = {};
var $45c80a3e8b7e5b65$var$key;
for($45c80a3e8b7e5b65$var$key in $6ZWSX){
    if (!$6ZWSX.hasOwnProperty($45c80a3e8b7e5b65$var$key)) continue;
    if ($45c80a3e8b7e5b65$var$key === "SlowBuffer" || $45c80a3e8b7e5b65$var$key === "Buffer") continue;
    $45c80a3e8b7e5b65$var$safer[$45c80a3e8b7e5b65$var$key] = $6ZWSX[$45c80a3e8b7e5b65$var$key];
}
var $45c80a3e8b7e5b65$var$Safer = $45c80a3e8b7e5b65$var$safer.Buffer = {};
for($45c80a3e8b7e5b65$var$key in $45c80a3e8b7e5b65$var$Buffer){
    if (!$45c80a3e8b7e5b65$var$Buffer.hasOwnProperty($45c80a3e8b7e5b65$var$key)) continue;
    if ($45c80a3e8b7e5b65$var$key === "allocUnsafe" || $45c80a3e8b7e5b65$var$key === "allocUnsafeSlow") continue;
    $45c80a3e8b7e5b65$var$Safer[$45c80a3e8b7e5b65$var$key] = $45c80a3e8b7e5b65$var$Buffer[$45c80a3e8b7e5b65$var$key];
}
$45c80a3e8b7e5b65$var$safer.Buffer.prototype = $45c80a3e8b7e5b65$var$Buffer.prototype;
if (!$45c80a3e8b7e5b65$var$Safer.from || $45c80a3e8b7e5b65$var$Safer.from === Uint8Array.from) $45c80a3e8b7e5b65$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === "undefined") throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    return $45c80a3e8b7e5b65$var$Buffer(value, encodingOrOffset, length);
};
if (!$45c80a3e8b7e5b65$var$Safer.alloc) $45c80a3e8b7e5b65$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $45c80a3e8b7e5b65$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === "string") buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$45c80a3e8b7e5b65$var$safer.kStringMaxLength) try {
    $45c80a3e8b7e5b65$var$safer.kStringMaxLength = $hPtJY.binding("buffer").kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$45c80a3e8b7e5b65$var$safer.constants) {
    $45c80a3e8b7e5b65$var$safer.constants = {
        MAX_LENGTH: $45c80a3e8b7e5b65$var$safer.kMaxLength
    };
    if ($45c80a3e8b7e5b65$var$safer.kStringMaxLength) $45c80a3e8b7e5b65$var$safer.constants.MAX_STRING_LENGTH = $45c80a3e8b7e5b65$var$safer.kStringMaxLength;
}
module.exports = $45c80a3e8b7e5b65$var$safer;

});

parcelRegister("h4y6g", function(module, exports) {
"use strict";

var $k2jVB = parcelRequire("k2jVB");
var $c6dd42f3395d566f$require$Reporter = $k2jVB.Reporter;

var $33sbF = parcelRequire("33sbF");
var $c6dd42f3395d566f$require$EncoderBuffer = $33sbF.EncoderBuffer;

var $33sbF = parcelRequire("33sbF");
var $c6dd42f3395d566f$require$DecoderBuffer = $33sbF.DecoderBuffer;

var $koC21 = parcelRequire("koC21");
// Supported tags
const $c6dd42f3395d566f$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
const $c6dd42f3395d566f$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($c6dd42f3395d566f$var$tags);
// Overrided methods list
const $c6dd42f3395d566f$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $c6dd42f3395d566f$var$Node(enc, parent, name) {
    const state = {};
    this._baseState = state;
    state.name = name;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $c6dd42f3395d566f$var$Node;
const $c6dd42f3395d566f$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$c6dd42f3395d566f$var$Node.prototype.clone = function clone() {
    const state = this._baseState;
    const cstate = {};
    $c6dd42f3395d566f$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    const res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$c6dd42f3395d566f$var$Node.prototype._wrap = function wrap() {
    const state = this._baseState;
    $c6dd42f3395d566f$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            const clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$c6dd42f3395d566f$var$Node.prototype._init = function init(body) {
    const state = this._baseState;
    $koC21(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $koC21.equal(state.children.length, 1, "Root node can have only one child");
};
$c6dd42f3395d566f$var$Node.prototype._useArgs = function useArgs(args) {
    const state = this._baseState;
    // Filter children and args
    const children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $koC21(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $koC21(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            const res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                const value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$c6dd42f3395d566f$var$overrided.forEach(function(method) {
    $c6dd42f3395d566f$var$Node.prototype[method] = function _overrided() {
        const state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$c6dd42f3395d566f$var$tags.forEach(function(tag) {
    $c6dd42f3395d566f$var$Node.prototype[tag] = function _tagMethod() {
        const state = this._baseState;
        const args = Array.prototype.slice.call(arguments);
        $koC21(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$c6dd42f3395d566f$var$Node.prototype.use = function use(item) {
    $koC21(item);
    const state = this._baseState;
    $koC21(state.use === null);
    state.use = item;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.optional = function optional() {
    const state = this._baseState;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.def = function def(val) {
    const state = this._baseState;
    $koC21(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.explicit = function explicit(num) {
    const state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.implicit = function implicit(num) {
    const state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.obj = function obj() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.key = function key(newKey) {
    const state = this._baseState;
    $koC21(state.key === null);
    state.key = newKey;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.any = function any() {
    const state = this._baseState;
    state.any = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.choice = function choice(obj) {
    const state = this._baseState;
    $koC21(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.contains = function contains(item) {
    const state = this._baseState;
    $koC21(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$c6dd42f3395d566f$var$Node.prototype._decode = function decode(input, options) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    let result = state["default"];
    let present = true;
    let prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        let tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            const save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    let prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            const explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        const start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            let save;
            if (state.any) save = input.save();
            const body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) ;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            const data = new $c6dd42f3395d566f$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    const state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$c6dd42f3395d566f$var$Node.prototype._getUse = function _getUse(entity, obj) {
    const state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $koC21(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$c6dd42f3395d566f$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    const state = this._baseState;
    let result = null;
    let match = false;
    Object.keys(state.choice).some(function(key) {
        const save = input.save();
        const node = state.choice[key];
        try {
            const value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$c6dd42f3395d566f$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $c6dd42f3395d566f$require$EncoderBuffer(data, this.reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encode = function encode(data, reporter, parent) {
    const state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    const result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $c6dd42f3395d566f$require$Reporter());
    let result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    let content = null;
    let primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            const prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            const res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            const child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                const state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    if (!state.any && state.choice === null) {
        const tag = state.implicit !== null ? state.implicit : state.tag;
        const cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    const state = this._baseState;
    const node = state.choice[data.type];
    if (!node) $koC21(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    const state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$c6dd42f3395d566f$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$c6dd42f3395d566f$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};

});
parcelRegister("k2jVB", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $e96373d85f7a5083$export$957313a2f485e5ed, (v) => $e96373d85f7a5083$export$957313a2f485e5ed = v);
var $e96373d85f7a5083$export$957313a2f485e5ed;
"use strict";

var $dlqwk = parcelRequire("dlqwk");
function $e96373d85f7a5083$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$e96373d85f7a5083$export$957313a2f485e5ed = $e96373d85f7a5083$var$Reporter;
$e96373d85f7a5083$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $e96373d85f7a5083$var$ReporterError;
};
$e96373d85f7a5083$var$Reporter.prototype.save = function save() {
    const state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$e96373d85f7a5083$var$Reporter.prototype.restore = function restore(data) {
    const state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$e96373d85f7a5083$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$e96373d85f7a5083$var$Reporter.prototype.exitKey = function exitKey(index) {
    const state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$e96373d85f7a5083$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    const state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$e96373d85f7a5083$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$e96373d85f7a5083$var$Reporter.prototype.enterObject = function enterObject() {
    const state = this._reporterState;
    const prev = state.obj;
    state.obj = {};
    return prev;
};
$e96373d85f7a5083$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    const state = this._reporterState;
    const now = state.obj;
    state.obj = prev;
    return now;
};
$e96373d85f7a5083$var$Reporter.prototype.error = function error(msg) {
    let err;
    const state = this._reporterState;
    const inherited = msg instanceof $e96373d85f7a5083$var$ReporterError;
    if (inherited) err = msg;
    else err = new $e96373d85f7a5083$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$e96373d85f7a5083$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    const state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $e96373d85f7a5083$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$dlqwk($e96373d85f7a5083$var$ReporterError, Error);
$e96373d85f7a5083$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $e96373d85f7a5083$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("33sbF", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $2397844df508f52e$export$bf9f79cdc4a49163, (v) => $2397844df508f52e$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $2397844df508f52e$export$8ff24f7760c7a78e, (v) => $2397844df508f52e$export$8ff24f7760c7a78e = v);
var $2397844df508f52e$export$bf9f79cdc4a49163;
var $2397844df508f52e$export$8ff24f7760c7a78e;
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $k2jVB = parcelRequire("k2jVB");
var $2397844df508f52e$require$Reporter = $k2jVB.Reporter;

var $5ZrzL = parcelRequire("5ZrzL");
var $2397844df508f52e$require$Buffer = $5ZrzL.Buffer;
function $2397844df508f52e$var$DecoderBuffer(base, options) {
    $2397844df508f52e$require$Reporter.call(this, options);
    if (!$2397844df508f52e$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$dlqwk($2397844df508f52e$var$DecoderBuffer, $2397844df508f52e$require$Reporter);
$2397844df508f52e$export$bf9f79cdc4a49163 = $2397844df508f52e$var$DecoderBuffer;
$2397844df508f52e$var$DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
    if (data instanceof $2397844df508f52e$var$DecoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && $2397844df508f52e$require$Buffer.isBuffer(data.base) && data.constructor.name === "DecoderBuffer" && typeof data.offset === "number" && typeof data.length === "number" && typeof data.save === "function" && typeof data.restore === "function" && typeof data.isEmpty === "function" && typeof data.readUInt8 === "function" && typeof data.skip === "function" && typeof data.raw === "function";
    return isCompatible;
};
$2397844df508f52e$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $2397844df508f52e$require$Reporter.prototype.save.call(this)
    };
};
$2397844df508f52e$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    const res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $2397844df508f52e$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$2397844df508f52e$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$2397844df508f52e$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    const res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $2397844df508f52e$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!$2397844df508f52e$var$EncoderBuffer.isEncoderBuffer(item)) item = new $2397844df508f52e$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $2397844df508f52e$require$Buffer.byteLength(value);
    } else if ($2397844df508f52e$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
$2397844df508f52e$export$8ff24f7760c7a78e = $2397844df508f52e$var$EncoderBuffer;
$2397844df508f52e$var$EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
    if (data instanceof $2397844df508f52e$var$EncoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && data.constructor.name === "EncoderBuffer" && typeof data.length === "number" && typeof data.join === "function";
    return isCompatible;
};
$2397844df508f52e$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = $2397844df508f52e$require$Buffer.alloc(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($2397844df508f52e$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});


parcelRegister("1G1m0", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $138ac3909863432c$export$3584c46ed60baee8, (v) => $138ac3909863432c$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $138ac3909863432c$export$f18596ef8d632e49, (v) => $138ac3909863432c$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $138ac3909863432c$export$2b067c6666111485, (v) => $138ac3909863432c$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $138ac3909863432c$export$f17df38a421ab9e3, (v) => $138ac3909863432c$export$f17df38a421ab9e3 = v);
var $138ac3909863432c$export$3584c46ed60baee8;
var $138ac3909863432c$export$f18596ef8d632e49;
var $138ac3909863432c$export$2b067c6666111485;
var $138ac3909863432c$export$f17df38a421ab9e3;
"use strict";
// Helper
function $138ac3909863432c$var$reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
}
$138ac3909863432c$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$138ac3909863432c$export$f18596ef8d632e49 = $138ac3909863432c$var$reverse($138ac3909863432c$export$3584c46ed60baee8);
$138ac3909863432c$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$138ac3909863432c$export$f17df38a421ab9e3 = $138ac3909863432c$var$reverse($138ac3909863432c$export$2b067c6666111485);

});


parcelRegister("bPffB", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $2j6ve = parcelRequire("2j6ve");
function $89c04996afa84ca7$var$PEMEncoder(entity) {
    $2j6ve.call(this, entity);
    this.enc = "pem";
}
$dlqwk($89c04996afa84ca7$var$PEMEncoder, $2j6ve);
module.exports = $89c04996afa84ca7$var$PEMEncoder;
$89c04996afa84ca7$var$PEMEncoder.prototype.encode = function encode(data, options) {
    const buf = $2j6ve.prototype.encode.call(this, data);
    const p = buf.toString("base64");
    const out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(let i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});


parcelRegister("89TTw", function(module, exports) {
"use strict";
const $5f0a857a78ce037a$var$decoders = module.exports;

$5f0a857a78ce037a$var$decoders.der = (parcelRequire("fkoHA"));

$5f0a857a78ce037a$var$decoders.pem = (parcelRequire("9wGrq"));

});
parcelRegister("fkoHA", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $dEXSZ = parcelRequire("dEXSZ");

var $33sbF = parcelRequire("33sbF");
var $b28be291c8d179e1$require$DecoderBuffer = $33sbF.DecoderBuffer;

var $h4y6g = parcelRequire("h4y6g");

var $1G1m0 = parcelRequire("1G1m0");
function $b28be291c8d179e1$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $b28be291c8d179e1$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $b28be291c8d179e1$var$DERDecoder;
$b28be291c8d179e1$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!$b28be291c8d179e1$require$DecoderBuffer.isDecoderBuffer(data)) data = new $b28be291c8d179e1$require$DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $b28be291c8d179e1$var$DERNode(parent) {
    $h4y6g.call(this, "der", parent);
}
$dlqwk($b28be291c8d179e1$var$DERNode, $h4y6g);
$b28be291c8d179e1$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    const state = buffer.save();
    const decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    const decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    let len = $b28be291c8d179e1$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    const state = buffer.save();
    const res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$b28be291c8d179e1$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    for(;;){
        const tag = $b28be291c8d179e1$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        const len = $b28be291c8d179e1$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        let res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$b28be291c8d179e1$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    const result = [];
    while(!buffer.isEmpty()){
        const possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        const res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        const unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        const raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        let str = "";
        for(let i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        const numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        const printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$b28be291c8d179e1$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    let result;
    const identifiers = [];
    let ident = 0;
    let subident = 0;
    while(!buffer.isEmpty()){
        subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    const first = identifiers[0] / 40 | 0;
    const second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        let tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    const str = buffer.raw().toString();
    let year;
    let mon;
    let day;
    let hour;
    let min;
    let sec;
    if (tag === "gentime") {
        year = str.slice(0, 4) | 0;
        mon = str.slice(4, 6) | 0;
        day = str.slice(6, 8) | 0;
        hour = str.slice(8, 10) | 0;
        min = str.slice(10, 12) | 0;
        sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        year = str.slice(0, 2) | 0;
        mon = str.slice(2, 4) | 0;
        day = str.slice(4, 6) | 0;
        hour = str.slice(6, 8) | 0;
        min = str.slice(8, 10) | 0;
        sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$b28be291c8d179e1$var$DERNode.prototype._decodeNull = function decodeNull() {
    return null;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    const res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    const raw = buffer.raw();
    let res = new $dEXSZ(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$b28be291c8d179e1$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $b28be291c8d179e1$var$derDecodeTag(buf, fail) {
    let tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    const cls = $1G1m0.tagClass[tag >> 6];
    const primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        let oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    const tagStr = $1G1m0.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $b28be291c8d179e1$var$derDecodeLen(buf, primitive, fail) {
    let len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    const num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(let i = 0; i < num; i++){
        len <<= 8;
        const j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("9wGrq", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $5ZrzL = parcelRequire("5ZrzL");
var $6ef8062b6cdbe0f4$require$Buffer = $5ZrzL.Buffer;

var $fkoHA = parcelRequire("fkoHA");
function $6ef8062b6cdbe0f4$var$PEMDecoder(entity) {
    $fkoHA.call(this, entity);
    this.enc = "pem";
}
$dlqwk($6ef8062b6cdbe0f4$var$PEMDecoder, $fkoHA);
module.exports = $6ef8062b6cdbe0f4$var$PEMDecoder;
$6ef8062b6cdbe0f4$var$PEMDecoder.prototype.decode = function decode(data, options) {
    const lines = data.toString().split(/[\r\n]+/g);
    const label = options.label.toUpperCase();
    const re = /^-----(BEGIN|END) ([^-]+)-----$/;
    let start = -1;
    let end = -1;
    for(let i = 0; i < lines.length; i++){
        const match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    const base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9+/=]+/gi, "");
    const input = $6ef8062b6cdbe0f4$require$Buffer.from(base64, "base64");
    return $fkoHA.prototype.decode.call(this, input, options);
};

});



parcelRegister("5JhaY", function(module, exports) {
"use strict";
const $42be7a86790be210$var$base = module.exports;

$42be7a86790be210$var$base.Reporter = (parcelRequire("k2jVB")).Reporter;

$42be7a86790be210$var$base.DecoderBuffer = (parcelRequire("33sbF")).DecoderBuffer;

$42be7a86790be210$var$base.EncoderBuffer = (parcelRequire("33sbF")).EncoderBuffer;

$42be7a86790be210$var$base.Node = (parcelRequire("h4y6g"));

});

parcelRegister("3TcQc", function(module, exports) {
"use strict";
const $2d507811e368678d$var$constants = module.exports;
// Helper
$2d507811e368678d$var$constants._reverse = function reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
};

$2d507811e368678d$var$constants.der = (parcelRequire("1G1m0"));

});


parcelRegister("bDaUv", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $10gXo = parcelRequire("10gXo");
var $877bcccea3fc6be5$var$Time = $10gXo.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $877bcccea3fc6be5$var$AttributeTypeValue = $10gXo.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $877bcccea3fc6be5$var$AlgorithmIdentifier = $10gXo.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $877bcccea3fc6be5$var$SubjectPublicKeyInfo = $10gXo.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $877bcccea3fc6be5$var$RelativeDistinguishedName = $10gXo.define("RelativeDistinguishedName", function() {
    this.setof($877bcccea3fc6be5$var$AttributeTypeValue);
});
var $877bcccea3fc6be5$var$RDNSequence = $10gXo.define("RDNSequence", function() {
    this.seqof($877bcccea3fc6be5$var$RelativeDistinguishedName);
});
var $877bcccea3fc6be5$var$Name = $10gXo.define("Name", function() {
    this.choice({
        rdnSequence: this.use($877bcccea3fc6be5$var$RDNSequence)
    });
});
var $877bcccea3fc6be5$var$Validity = $10gXo.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($877bcccea3fc6be5$var$Time), this.key("notAfter").use($877bcccea3fc6be5$var$Time));
});
var $877bcccea3fc6be5$var$Extension = $10gXo.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $877bcccea3fc6be5$var$TBSCertificate = $10gXo.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("issuer").use($877bcccea3fc6be5$var$Name), this.key("validity").use($877bcccea3fc6be5$var$Validity), this.key("subject").use($877bcccea3fc6be5$var$Name), this.key("subjectPublicKeyInfo").use($877bcccea3fc6be5$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($877bcccea3fc6be5$var$Extension).optional());
});
var $877bcccea3fc6be5$var$X509Certificate = $10gXo.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($877bcccea3fc6be5$var$TBSCertificate), this.key("signatureAlgorithm").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $877bcccea3fc6be5$var$X509Certificate;

});


parcelRegister("5v6nH", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRegister("3ILSx", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip
var $2b5a9edea8bfc145$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $2b5a9edea8bfc145$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $2b5a9edea8bfc145$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $bSYjd = parcelRequire("bSYjd");

var $7Zu82 = parcelRequire("7Zu82");

var $1U9GM = parcelRequire("1U9GM");
var $2b5a9edea8bfc145$require$Buffer = $1U9GM.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($2b5a9edea8bfc145$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($2b5a9edea8bfc145$var$fullRegex);
        decrypted = $2b5a9edea8bfc145$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $2b5a9edea8bfc145$require$Buffer.from(match[2], "hex");
        var cipherText = $2b5a9edea8bfc145$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $bSYjd(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $7Zu82.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $2b5a9edea8bfc145$require$Buffer.concat(out);
    }
    var tag = key.match($2b5a9edea8bfc145$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("aYksR", function(module, exports) {
module.exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');

});


parcelRegister("fQdau", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $b885ed4272d45f84$require$Buffer = $1U9GM.Buffer;

var $jVUXf = parcelRequire("jVUXf");

var $1zUcV = parcelRequire("1zUcV");
var $b885ed4272d45f84$require$EC = $1zUcV.ec;

var $aNeDF = parcelRequire("aNeDF");

var $aYksR = parcelRequire("aYksR");
function $b885ed4272d45f84$var$verify(sig, hash, key, signType, tag) {
    var pub = $aNeDF(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $b885ed4272d45f84$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $b885ed4272d45f84$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    hash = $b885ed4272d45f84$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $b885ed4272d45f84$require$Buffer.from(pad);
    var red = $jVUXf.mont(pub.modulus);
    sig = new $jVUXf(sig).toRed(red);
    sig = sig.redPow(new $jVUXf(pub.publicExponent));
    sig = $b885ed4272d45f84$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $b885ed4272d45f84$var$ecVerify(sig, hash, pub) {
    var curveId = $aYksR[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $b885ed4272d45f84$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $b885ed4272d45f84$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $aNeDF.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $b885ed4272d45f84$var$checkValue(s, q);
    $b885ed4272d45f84$var$checkValue(r, q);
    var montp = $jVUXf.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $jVUXf(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $b885ed4272d45f84$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= 0) throw new Error("invalid sig");
}
module.exports = $b885ed4272d45f84$var$verify;

});


parcelRegister("fd3gh", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b12a999e54d2bf45$require$Buffer = $6ZWSX.Buffer;

var $1zUcV = parcelRequire("1zUcV");

var $dEXSZ = parcelRequire("dEXSZ");
module.exports = function createECDH(curve) {
    return new $b12a999e54d2bf45$var$ECDH(curve);
};
var $b12a999e54d2bf45$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$b12a999e54d2bf45$var$aliases.p224 = $b12a999e54d2bf45$var$aliases.secp224r1;
$b12a999e54d2bf45$var$aliases.p256 = $b12a999e54d2bf45$var$aliases.secp256r1 = $b12a999e54d2bf45$var$aliases.prime256v1;
$b12a999e54d2bf45$var$aliases.p192 = $b12a999e54d2bf45$var$aliases.secp192r1 = $b12a999e54d2bf45$var$aliases.prime192v1;
$b12a999e54d2bf45$var$aliases.p384 = $b12a999e54d2bf45$var$aliases.secp384r1;
$b12a999e54d2bf45$var$aliases.p521 = $b12a999e54d2bf45$var$aliases.secp521r1;
function $b12a999e54d2bf45$var$ECDH(curve) {
    this.curveType = $b12a999e54d2bf45$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $1zUcV.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$b12a999e54d2bf45$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$b12a999e54d2bf45$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(other)) other = new $b12a999e54d2bf45$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $b12a999e54d2bf45$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $b12a999e54d2bf45$var$formatReturnValue(key, enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $b12a999e54d2bf45$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(pub)) pub = new $b12a999e54d2bf45$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$b12a999e54d2bf45$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(priv)) priv = new $b12a999e54d2bf45$require$Buffer(priv, enc);
    var _priv = new $dEXSZ(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $b12a999e54d2bf45$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $b12a999e54d2bf45$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $b12a999e54d2bf45$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $b12a999e54d2bf45$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});

parcelRegister("fMM6j", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", () => $b7e0a6843ffae451$export$512823e338ddb1b7, (v) => $b7e0a6843ffae451$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateDecrypt", () => $b7e0a6843ffae451$export$7efb24e2fddf99b9, (v) => $b7e0a6843ffae451$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "privateEncrypt", () => $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3, (v) => $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $b7e0a6843ffae451$export$b9d55ff329113abd, (v) => $b7e0a6843ffae451$export$b9d55ff329113abd = v);
var $b7e0a6843ffae451$export$512823e338ddb1b7;
var $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
var $b7e0a6843ffae451$export$b9d55ff329113abd;

$b7e0a6843ffae451$export$512823e338ddb1b7 = (parcelRequire("98aLY"));

$b7e0a6843ffae451$export$7efb24e2fddf99b9 = (parcelRequire("jU8t7"));
$b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $b7e0a6843ffae451$export$512823e338ddb1b7(key, buf, true);
};
$b7e0a6843ffae451$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $b7e0a6843ffae451$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("98aLY", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $hkN9y = parcelRequire("hkN9y");

var $1R2J7 = parcelRequire("1R2J7");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $dEXSZ = parcelRequire("dEXSZ");

var $3pDg3 = parcelRequire("3pDg3");

var $3Sg1O = parcelRequire("3Sg1O");

var $1U9GM = parcelRequire("1U9GM");
var $6a5d37a95541eeab$require$Buffer = $1U9GM.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $6a5d37a95541eeab$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $6a5d37a95541eeab$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $dEXSZ(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $3Sg1O(paddedMsg, key);
    else return $3pDg3(paddedMsg, key);
};
function $6a5d37a95541eeab$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $1R2J7("sha1").update($6a5d37a95541eeab$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $hkN9y(hLen);
    var maskedDb = $6nrMP($6a5d37a95541eeab$require$Buffer.concat([
        iHash,
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $5BMkJ(seed, dblen));
    var maskedSeed = $6nrMP(seed, $5BMkJ(maskedDb, hLen));
    return new $dEXSZ($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $6a5d37a95541eeab$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $6a5d37a95541eeab$var$nonZero(k - mLen - 3);
    return new $dEXSZ($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        msg
    ], k));
}
function $6a5d37a95541eeab$var$nonZero(len) {
    var out = $6a5d37a95541eeab$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $hkN9y(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $hkN9y(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("5BMkJ", function(module, exports) {

var $1R2J7 = parcelRequire("1R2J7");

var $1U9GM = parcelRequire("1U9GM");
var $4155e6705a7c8e0e$require$Buffer = $1U9GM.Buffer;
module.exports = function(seed, len) {
    var t = $4155e6705a7c8e0e$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $4155e6705a7c8e0e$var$i2ops(i++);
        t = $4155e6705a7c8e0e$require$Buffer.concat([
            t,
            $1R2J7("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $4155e6705a7c8e0e$var$i2ops(c) {
    var out = $4155e6705a7c8e0e$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("6nrMP", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("3pDg3", function(module, exports) {

var $dEXSZ = parcelRequire("dEXSZ");

var $1U9GM = parcelRequire("1U9GM");
var $27c228af35759e80$require$Buffer = $1U9GM.Buffer;
function $27c228af35759e80$var$withPublic(paddedMsg, key) {
    return $27c228af35759e80$require$Buffer.from(paddedMsg.toRed($dEXSZ.mont(key.modulus)).redPow(new $dEXSZ(key.publicExponent)).fromRed().toArray());
}
module.exports = $27c228af35759e80$var$withPublic;

});


parcelRegister("jU8t7", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $dEXSZ = parcelRequire("dEXSZ");

var $3Sg1O = parcelRequire("3Sg1O");

var $1R2J7 = parcelRequire("1R2J7");

var $3pDg3 = parcelRequire("3pDg3");

var $1U9GM = parcelRequire("1U9GM");
var $e7d9d10092031842$require$Buffer = $1U9GM.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $dEXSZ(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $3pDg3(new $dEXSZ(enc), key);
    else msg = $3Sg1O(enc, key);
    var zBuffer = $e7d9d10092031842$require$Buffer.alloc(k - msg.length);
    msg = $e7d9d10092031842$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $e7d9d10092031842$var$oaep(key, msg);
    else if (padding === 1) return $e7d9d10092031842$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $e7d9d10092031842$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $1R2J7("sha1").update($e7d9d10092031842$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $6nrMP(maskedSeed, $5BMkJ(maskedDb, hLen));
    var db = $6nrMP(maskedDb, $5BMkJ(seed, k - hLen - 1));
    if ($e7d9d10092031842$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $e7d9d10092031842$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $e7d9d10092031842$var$compare(a, b) {
    a = $e7d9d10092031842$require$Buffer.from(a);
    b = $e7d9d10092031842$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("c34vB", function(module, exports) {

$parcel$export(module.exports, "randomFill", () => $8c5943302864e9a5$export$bb1abf2ce84fc7e8, (v) => $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $8c5943302864e9a5$export$2f7171e78e524d5e, (v) => $8c5943302864e9a5$export$2f7171e78e524d5e = v);
var $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
var $8c5943302864e9a5$export$2f7171e78e524d5e;

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $8c5943302864e9a5$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $1U9GM = parcelRequire("1U9GM");

var $hkN9y = parcelRequire("hkN9y");
var $8c5943302864e9a5$var$Buffer = $1U9GM.Buffer;
var $8c5943302864e9a5$var$kBufferMaxLength = $1U9GM.kMaxLength;
var $8c5943302864e9a5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $8c5943302864e9a5$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $8c5943302864e9a5$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $8c5943302864e9a5$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $8c5943302864e9a5$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $8c5943302864e9a5$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $8c5943302864e9a5$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $8c5943302864e9a5$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($8c5943302864e9a5$var$crypto && $8c5943302864e9a5$var$crypto.getRandomValues || false) {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$randomFill;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$randomFillSync;
} else {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$oldBrowser;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$oldBrowser;
}
function $8c5943302864e9a5$var$randomFill(buf, offset, size, cb) {
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size, cb);
}
function $8c5943302864e9a5$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $8c5943302864e9a5$var$crypto.getRandomValues(uint);
    if (cb) {
        $hPtJY.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $hkN9y(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $hkN9y(size);
    bytes.copy(buf, offset);
    return buf;
}
function $8c5943302864e9a5$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size);
}

});



parcelRegister("1FoUm", function(module, exports) {
"use strict";
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === "function") opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === "boolean" ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === "function") node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == "number") return isFinite(node) ? "" + node : "null";
        if (typeof node !== "object") return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = "[";
            for(i = 0; i < node.length; i++){
                if (i) out += ",";
                out += stringify(node[i]) || "null";
            }
            return out + "]";
        }
        if (node === null) return "null";
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify("__cycle__");
            throw new TypeError("Converting circular structure to JSON");
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = "";
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ",";
            out += JSON.stringify(key) + ":" + value;
        }
        seen.splice(seenIndex, 1);
        return "{" + out + "}";
    }(data);
};

});


parcelRegister("3osda", function(module, exports) {

$parcel$export(module.exports, "Transaction", () => $27897f3134847f3a$export$febc5573c75cefb0);

var $eHb7V = parcelRequire("eHb7V");

var $92UFn = parcelRequire("92UFn");

var $4KwWn = parcelRequire("4KwWn");

var $bZmTT = parcelRequire("bZmTT");

var $6ZWSX = parcelRequire("6ZWSX");
class $27897f3134847f3a$export$febc5573c75cefb0 {
    /**
     * construct a transaction object with given body
     * @param body body of tx
     */ constructor(body){
        this.body = Object.assign({}, body);
    }
    /** decode from Buffer to transaction
     * @param raw encoded buffer
     * @param unsigned to indicator if the encoded buffer contains signature
     */ static decode(raw, unsigned) {
        let body;
        let signature;
        if (unsigned) body = $27897f3134847f3a$var$unsignedTxRLP.decode(raw);
        else {
            const decoded = $27897f3134847f3a$var$txRLP.decode(raw);
            signature = decoded.signature;
            delete decoded.signature;
            body = decoded;
        }
        const reserved = body.reserved;
        if (reserved.length > 0) {
            if (reserved[reserved.length - 1].length === 0) throw new Error("invalid reserved fields: not trimmed");
            const features = $27897f3134847f3a$var$featuresKind.buffer(reserved[0], "reserved.features").decode();
            body.reserved = {
                features: features
            };
            if (reserved.length > 1) body.reserved.unused = reserved.slice(1);
        } else delete body.reserved;
        const tx = new $27897f3134847f3a$export$febc5573c75cefb0(body);
        if (signature) tx.signature = signature;
        return tx;
    }
    /**
     * returns transaction ID
     * null returned if something wrong (e.g. invalid signature)
     */ get id() {
        if (!this._signatureValid) return null;
        try {
            const signingHash = this.signingHash();
            const pubKey = (0, $bZmTT.secp256k1).recover(signingHash, this.signature.slice(0, 65));
            const origin = (0, $eHb7V.address).fromPublicKey(pubKey);
            return "0x" + (0, $92UFn.blake2b256)(signingHash, (0, $6ZWSX.Buffer).from(origin.slice(2), "hex")).toString("hex");
        } catch (_a) {
            return null;
        }
    }
    /**
     * compute signing hashes.
     * It returns tx hash for origin or delegator depends on param `delegateFor`.
     * @param delegateFor address of intended tx origin. If set, the returned hash is for delegator to sign.
     */ signingHash(delegateFor) {
        const reserved = this._encodeReserved();
        const buf = $27897f3134847f3a$var$unsignedTxRLP.encode(Object.assign(Object.assign({}, this.body), {
            reserved: reserved
        }));
        const hash = (0, $92UFn.blake2b256)(buf);
        if (delegateFor) {
            if (!/^0x[0-9a-f]{40}$/i.test(delegateFor)) throw new Error("delegateFor expected address");
            return (0, $92UFn.blake2b256)(hash, (0, $6ZWSX.Buffer).from(delegateFor.slice(2), "hex"));
        }
        return hash;
    }
    /** returns tx origin. null returned if no signature or not incorrectly signed */ get origin() {
        if (!this._signatureValid) return null;
        try {
            const signingHash = this.signingHash();
            const pubKey = (0, $bZmTT.secp256k1).recover(signingHash, this.signature.slice(0, 65));
            return (0, $eHb7V.address).fromPublicKey(pubKey);
        } catch (_a) {
            return null;
        }
    }
    /** returns tx delegator. null returned if no signature or not incorrectly signed */ get delegator() {
        if (!this.delegated) return null;
        if (!this._signatureValid) return null;
        const origin = this.origin;
        if (!origin) return null;
        try {
            const signingHash = this.signingHash(origin);
            const pubKey = (0, $bZmTT.secp256k1).recover(signingHash, this.signature.slice(65));
            return (0, $eHb7V.address).fromPublicKey(pubKey);
        } catch (_a) {
            return null;
        }
    }
    /** returns whether delegated. see https://github.com/vechain/VIPs/blob/master/vips/VIP-191.md */ get delegated() {
        var _a, _b;
        // tslint:disable-next-line:no-bitwise
        return (((_b = ((_a = this.body.reserved) !== null && _a !== void 0 ? _a : {}).features) !== null && _b !== void 0 ? _b : 0) & $27897f3134847f3a$export$febc5573c75cefb0.DELEGATED_MASK) === $27897f3134847f3a$export$febc5573c75cefb0.DELEGATED_MASK;
    }
    /** returns intrinsic gas it takes */ get intrinsicGas() {
        return $27897f3134847f3a$export$febc5573c75cefb0.intrinsicGas(this.body.clauses);
    }
    /** encode into Buffer */ encode() {
        const reserved = this._encodeReserved();
        if (this.signature) return $27897f3134847f3a$var$txRLP.encode(Object.assign(Object.assign({}, this.body), {
            reserved: reserved,
            signature: this.signature
        }));
        return $27897f3134847f3a$var$unsignedTxRLP.encode(Object.assign(Object.assign({}, this.body), {
            reserved: reserved
        }));
    }
    _encodeReserved() {
        var _a, _b, _c;
        const reserved = (_a = this.body.reserved) !== null && _a !== void 0 ? _a : {};
        const list = [
            $27897f3134847f3a$var$featuresKind.data((_b = reserved.features) !== null && _b !== void 0 ? _b : 0, "reserved.features").encode(),
            ...(_c = reserved.unused) !== null && _c !== void 0 ? _c : []
        ];
        // trim
        while(list.length > 0){
            if (list[list.length - 1].length === 0) list.pop();
            else break;
        }
        return list;
    }
    get _signatureValid() {
        const expectedSigLen = this.delegated ? 130 : 65;
        return this.signature ? this.signature.length === expectedSigLen : false;
    }
}
$27897f3134847f3a$export$febc5573c75cefb0.DELEGATED_MASK = 1;
(function(Transaction) {
    /**
     * calculates intrinsic gas that a tx costs with the given clauses.
     * @param clauses
     */ function intrinsicGas(clauses) {
        const txGas = 5000;
        const clauseGas = 16000;
        const clauseGasContractCreation = 48000;
        if (clauses.length === 0) return txGas + clauseGas;
        return clauses.reduce((sum, c)=>{
            if (c.to) sum += clauseGas;
            else sum += clauseGasContractCreation;
            sum += dataGas(c.data);
            return sum;
        }, txGas);
    }
    Transaction.intrinsicGas = intrinsicGas;
    function dataGas(data) {
        const zgas = 4;
        const nzgas = 68;
        let sum = 0;
        for(let i = 2; i < data.length; i += 2)if (data.substring(i, i + 2) === "00") sum += zgas;
        else sum += nzgas;
        return sum;
    }
})($27897f3134847f3a$export$febc5573c75cefb0 || ($27897f3134847f3a$export$febc5573c75cefb0 = {}));
const $27897f3134847f3a$var$unsignedTxRLP = new (0, $4KwWn.RLP)({
    name: "tx",
    kind: [
        {
            name: "chainTag",
            kind: new (0, $4KwWn.RLP).NumericKind(1)
        },
        {
            name: "blockRef",
            kind: new (0, $4KwWn.RLP).CompactFixedBlobKind(8)
        },
        {
            name: "expiration",
            kind: new (0, $4KwWn.RLP).NumericKind(4)
        },
        {
            name: "clauses",
            kind: {
                item: [
                    {
                        name: "to",
                        kind: new (0, $4KwWn.RLP).NullableFixedBlobKind(20)
                    },
                    {
                        name: "value",
                        kind: new (0, $4KwWn.RLP).NumericKind(32)
                    },
                    {
                        name: "data",
                        kind: new (0, $4KwWn.RLP).BlobKind()
                    }
                ]
            }
        },
        {
            name: "gasPriceCoef",
            kind: new (0, $4KwWn.RLP).NumericKind(1)
        },
        {
            name: "gas",
            kind: new (0, $4KwWn.RLP).NumericKind(8)
        },
        {
            name: "dependsOn",
            kind: new (0, $4KwWn.RLP).NullableFixedBlobKind(32)
        },
        {
            name: "nonce",
            kind: new (0, $4KwWn.RLP).NumericKind(8)
        },
        {
            name: "reserved",
            kind: {
                item: new (0, $4KwWn.RLP).BufferKind()
            }
        }
    ]
});
const $27897f3134847f3a$var$txRLP = new (0, $4KwWn.RLP)({
    name: "tx",
    kind: [
        ...$27897f3134847f3a$var$unsignedTxRLP.profile.kind,
        {
            name: "signature",
            kind: new (0, $4KwWn.RLP).BufferKind()
        }
    ]
});
const $27897f3134847f3a$var$featuresKind = new (0, $4KwWn.RLP).NumericKind(4);

});
parcelRegister("4KwWn", function(module, exports) {

$parcel$export(module.exports, "RLP", () => $3755029ccd43e0fd$export$4859e6f62c4b9b84);

var $5Kq8F = parcelRequire("5Kq8F");

var $15efp = parcelRequire("15efp");

var $6ZWSX = parcelRequire("6ZWSX");
class $3755029ccd43e0fd$export$4859e6f62c4b9b84 {
    constructor(profile){
        this.profile = profile;
    }
    /**
     * encode data according to profile
     * @param data the structured data to be encoded
     */ encode(data) {
        const packed = $3755029ccd43e0fd$var$pack(data, this.profile, "");
        return $15efp.encode(packed);
    }
    /**
     * decode buffer according to profile
     * @param buf rlp encoded data
     */ decode(buf) {
        const packed = $15efp.decode(buf);
        return $3755029ccd43e0fd$var$unpack(packed, this.profile, "");
    }
}
(function(RLP) {
    /** base class of scalar kind */ class ScalarKind {
    }
    RLP.ScalarKind = ScalarKind;
    /** a buffer kind to keep buffer type */ class BufferKind extends ScalarKind {
        data(data, ctx) {
            $3755029ccd43e0fd$var$assert((0, $6ZWSX.Buffer).isBuffer(data), ctx, "expected buffer");
            return {
                encode () {
                    return data;
                }
            };
        }
        buffer(buf, ctx) {
            return {
                decode () {
                    return buf;
                }
            };
        }
    }
    RLP.BufferKind = BufferKind;
    /** a scalar kind to presents number */ class NumericKind extends ScalarKind {
        /**
         * create a numeric kind
         * @param maxBytes up limit of data in bytes
         */ constructor(maxBytes){
            super();
            this.maxBytes = maxBytes;
        }
        data(data, ctx) {
            $3755029ccd43e0fd$var$assert(typeof data === "string" || typeof data === "number", ctx, "expected string or number");
            if (typeof data === "string") {
                const isHex = $3755029ccd43e0fd$var$isHexString(data);
                const isDec = $3755029ccd43e0fd$var$isDecString(data);
                $3755029ccd43e0fd$var$assert(isHex || isDec, ctx, "expected non-negative integer in hex or dec string");
                if (isHex) $3755029ccd43e0fd$var$assert(data.length > 2, ctx, "expected valid hex string");
            } else $3755029ccd43e0fd$var$assert(Number.isSafeInteger(data) && data >= 0, ctx, "expected non-negative safe integer");
            const bn = new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(data);
            if (bn.isZero()) return {
                encode () {
                    return (0, $6ZWSX.Buffer).alloc(0);
                }
            };
            let hex = bn.toString(16);
            if (hex.length % 2 !== 0) hex = "0" + hex;
            $3755029ccd43e0fd$var$assert(this.maxBytes ? hex.length <= this.maxBytes * 2 : true, ctx, `expected number in ${this.maxBytes} bytes`);
            return {
                encode () {
                    return (0, $6ZWSX.Buffer).from(hex, "hex");
                }
            };
        }
        buffer(buf, ctx) {
            $3755029ccd43e0fd$var$assert(this.maxBytes ? buf.length <= this.maxBytes : true, ctx, `expected less than ${this.maxBytes} bytes`);
            $3755029ccd43e0fd$var$assert(buf.length === 0 || buf[0] !== 0, ctx, `expected canonical integer (no leading zero bytes)`);
            return {
                decode () {
                    if (buf.length === 0) return 0;
                    const bn = new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(buf.toString("hex"), 16);
                    const num = bn.toNumber();
                    return Number.isSafeInteger(num) ? num : "0x" + bn.toString(16);
                }
            };
        }
    }
    RLP.NumericKind = NumericKind;
    /** a scalar kind to present blob */ class BlobKind extends ScalarKind {
        data(data, ctx) {
            $3755029ccd43e0fd$var$assert($3755029ccd43e0fd$var$isHexString(data), ctx, "expected hex string");
            $3755029ccd43e0fd$var$assert(data.length % 2 === 0, ctx, "expected even length hex");
            return {
                encode () {
                    return (0, $6ZWSX.Buffer).from(data.slice(2), "hex");
                }
            };
        }
        buffer(buf, ctx) {
            return {
                decode () {
                    return "0x" + buf.toString("hex");
                }
            };
        }
    }
    RLP.BlobKind = BlobKind;
    /** fixed length blob */ class FixedBlobKind extends BlobKind {
        constructor(bytes){
            super();
            this.bytes = bytes;
        }
        data(data, ctx) {
            const encoder = super.data(data, ctx);
            $3755029ccd43e0fd$var$assert(data.length === this.bytes * 2 + 2, ctx, `expected hex string presents ${this.bytes} bytes`);
            return encoder;
        }
        buffer(buf, ctx) {
            const decoder = super.buffer(buf, ctx);
            $3755029ccd43e0fd$var$assert(buf.length === this.bytes, ctx, `expected ${this.bytes} bytes`);
            return decoder;
        }
    }
    RLP.FixedBlobKind = FixedBlobKind;
    /** fixed length blob allowing null */ class NullableFixedBlobKind extends FixedBlobKind {
        data(data, ctx) {
            if (!data) return {
                encode () {
                    return (0, $6ZWSX.Buffer).alloc(0);
                }
            };
            return super.data(data, ctx);
        }
        buffer(buf, ctx) {
            if (buf.length === 0) return {
                decode () {
                    return null;
                }
            };
            return super.buffer(buf, ctx);
        }
    }
    RLP.NullableFixedBlobKind = NullableFixedBlobKind;
    /** fixed length blob kind that will remove leading zero on encoding and pad zero on decoding */ class CompactFixedBlobKind extends FixedBlobKind {
        data(data, ctx) {
            const buf = super.data(data, ctx).encode();
            return {
                encode () {
                    const nzIndex = buf.findIndex((v)=>v !== 0);
                    if (nzIndex >= 0) return buf.slice(nzIndex);
                    return (0, $6ZWSX.Buffer).alloc(0);
                }
            };
        }
        buffer(buf, ctx) {
            $3755029ccd43e0fd$var$assert(buf.length <= this.bytes, ctx, `expected less than ${this.bytes} bytes`);
            $3755029ccd43e0fd$var$assert(buf.length === 0 || buf[0] !== 0, ctx, `expected no leading zero bytes`);
            const bytes = this.bytes;
            return {
                decode () {
                    const zeros = "0".repeat((bytes - buf.length) * 2);
                    return "0x" + zeros + buf.toString("hex");
                }
            };
        }
    }
    RLP.CompactFixedBlobKind = CompactFixedBlobKind;
})($3755029ccd43e0fd$export$4859e6f62c4b9b84 || ($3755029ccd43e0fd$export$4859e6f62c4b9b84 = {}));
function $3755029ccd43e0fd$var$pack(obj, profile, ctx) {
    ctx = ctx ? ctx + "." + profile.name : profile.name;
    const kind = profile.kind;
    if (kind instanceof $3755029ccd43e0fd$export$4859e6f62c4b9b84.ScalarKind) return kind.data(obj, ctx).encode();
    if (Array.isArray(kind)) return kind.map((k)=>$3755029ccd43e0fd$var$pack(obj[k.name], k, ctx));
    $3755029ccd43e0fd$var$assert(Array.isArray(obj), ctx, "expected array");
    const item = kind.item;
    return obj.map((part, i)=>$3755029ccd43e0fd$var$pack(part, {
            name: "#" + i,
            kind: item
        }, ctx));
}
function $3755029ccd43e0fd$var$unpack(packed, profile, ctx) {
    ctx = ctx ? ctx + "." + profile.name : profile.name;
    const kind = profile.kind;
    if (kind instanceof $3755029ccd43e0fd$export$4859e6f62c4b9b84.ScalarKind) {
        $3755029ccd43e0fd$var$assert((0, $6ZWSX.Buffer).isBuffer(packed), ctx, "expected Buffer");
        return kind.buffer(packed, ctx).decode();
    }
    if (Array.isArray(kind)) {
        $3755029ccd43e0fd$var$assert(Array.isArray(packed), ctx, "expected array");
        const parts = packed;
        $3755029ccd43e0fd$var$assert(parts.length === kind.length, ctx, `expected ${kind.length} items, but got ${parts.length}`);
        return kind.reduce((o, p, i)=>{
            o[p.name] = $3755029ccd43e0fd$var$unpack(parts[i], p, ctx);
            return o;
        }, {});
    }
    $3755029ccd43e0fd$var$assert(Array.isArray(packed), ctx, "expected array");
    const item = kind.item;
    return packed.map((part, i)=>$3755029ccd43e0fd$var$unpack(part, {
            name: "#" + i,
            kind: item
        }, ctx));
}
function $3755029ccd43e0fd$var$assert(cond, ctx, msg) {
    if (!cond) throw new $3755029ccd43e0fd$var$RLPError(`${ctx}: ${msg}`);
}
function $3755029ccd43e0fd$var$isHexString(str) {
    return /^0x[0-9a-f]*$/i.test(str);
}
function $3755029ccd43e0fd$var$isDecString(str) {
    return /^\d+$/.test(str);
}
class $3755029ccd43e0fd$var$RLPError extends Error {
    constructor(msg){
        super(msg);
        this.name = $3755029ccd43e0fd$var$RLPError.name;
    }
}

});
parcelRegister("15efp", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $0ca14f51a53c43ef$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $0ca14f51a53c43ef$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLength = module.exports.decode = module.exports.encode = void 0;

var $0ca14f51a53c43ef$var$bn_js_1 = $0ca14f51a53c43ef$var$__importDefault((parcelRequire("3DJLR")));
/**
 * RLP Encoding based on: https://github.com/ethereum/wiki/wiki/%5BEnglish%5D-RLP
 * This function takes in a data, convert it to buffer if not, and a length for recursion
 * @param input - will be converted to buffer
 * @returns returns buffer of encoded data
 **/ function $0ca14f51a53c43ef$var$encode(input) {
    if (Array.isArray(input)) {
        var output = [];
        for(var i = 0; i < input.length; i++)output.push($0ca14f51a53c43ef$var$encode(input[i]));
        var buf = $0ca14f51a53c43ef$require$Buffer.concat(output);
        return $0ca14f51a53c43ef$require$Buffer.concat([
            $0ca14f51a53c43ef$var$encodeLength(buf.length, 192),
            buf
        ]);
    } else {
        var inputBuf = $0ca14f51a53c43ef$var$toBuffer(input);
        return inputBuf.length === 1 && inputBuf[0] < 128 ? inputBuf : $0ca14f51a53c43ef$require$Buffer.concat([
            $0ca14f51a53c43ef$var$encodeLength(inputBuf.length, 128),
            inputBuf
        ]);
    }
}
module.exports.encode = $0ca14f51a53c43ef$var$encode;
/**
 * Parse integers. Check if there is no leading zeros
 * @param v The value to parse
 * @param base The base to parse the integer into
 */ function $0ca14f51a53c43ef$var$safeParseInt(v, base) {
    if (v[0] === "0" && v[1] === "0") throw new Error("invalid RLP: extra zeros");
    return parseInt(v, base);
}
function $0ca14f51a53c43ef$var$encodeLength(len, offset) {
    if (len < 56) return $0ca14f51a53c43ef$require$Buffer.from([
        len + offset
    ]);
    else {
        var hexLength = $0ca14f51a53c43ef$var$intToHex(len);
        var lLength = hexLength.length / 2;
        var firstByte = $0ca14f51a53c43ef$var$intToHex(offset + 55 + lLength);
        return $0ca14f51a53c43ef$require$Buffer.from(firstByte + hexLength, "hex");
    }
}
function $0ca14f51a53c43ef$var$decode(input, stream) {
    if (stream === void 0) stream = false;
    if (!input || input.length === 0) return $0ca14f51a53c43ef$require$Buffer.from([]);
    var inputBuffer = $0ca14f51a53c43ef$var$toBuffer(input);
    var decoded = $0ca14f51a53c43ef$var$_decode(inputBuffer);
    if (stream) return decoded;
    if (decoded.remainder.length !== 0) throw new Error("invalid remainder");
    return decoded.data;
}
module.exports.decode = $0ca14f51a53c43ef$var$decode;
/**
 * Get the length of the RLP input
 * @param input
 * @returns The length of the input or an empty Buffer if no input
 */ function $0ca14f51a53c43ef$var$getLength(input) {
    if (!input || input.length === 0) return $0ca14f51a53c43ef$require$Buffer.from([]);
    var inputBuffer = $0ca14f51a53c43ef$var$toBuffer(input);
    var firstByte = inputBuffer[0];
    if (firstByte <= 0x7f) return inputBuffer.length;
    else if (firstByte <= 0xb7) return firstByte - 0x7f;
    else if (firstByte <= 0xbf) return firstByte - 0xb6;
    else if (firstByte <= 0xf7) // a list between  0-55 bytes long
    return firstByte - 0xbf;
    else {
        // a list  over 55 bytes long
        var llength = firstByte - 0xf6;
        var length_1 = $0ca14f51a53c43ef$var$safeParseInt(inputBuffer.slice(1, llength).toString("hex"), 16);
        return llength + length_1;
    }
}
module.exports.getLength = $0ca14f51a53c43ef$var$getLength;
/** Decode an input with RLP */ function $0ca14f51a53c43ef$var$_decode(input) {
    var length, llength, data, innerRemainder, d;
    var decoded = [];
    var firstByte = input[0];
    if (firstByte <= 0x7f) // a single byte whose value is in the [0x00, 0x7f] range, that byte is its own RLP encoding.
    return {
        data: input.slice(0, 1),
        remainder: input.slice(1)
    };
    else if (firstByte <= 0xb7) {
        // string is 0-55 bytes long. A single byte with value 0x80 plus the length of the string followed by the string
        // The range of the first byte is [0x80, 0xb7]
        length = firstByte - 0x7f;
        // set 0x80 null to 0
        if (firstByte === 0x80) data = $0ca14f51a53c43ef$require$Buffer.from([]);
        else data = input.slice(1, length);
        if (length === 2 && data[0] < 0x80) throw new Error("invalid rlp encoding: byte must be less 0x80");
        return {
            data: data,
            remainder: input.slice(length)
        };
    } else if (firstByte <= 0xbf) {
        // string is greater than 55 bytes long. A single byte with the value (0xb7 plus the length of the length),
        // followed by the length, followed by the string
        llength = firstByte - 0xb6;
        if (input.length - 1 < llength) throw new Error("invalid RLP: not enough bytes for string length");
        length = $0ca14f51a53c43ef$var$safeParseInt(input.slice(1, llength).toString("hex"), 16);
        if (length <= 55) throw new Error("invalid RLP: expected string length to be greater than 55");
        data = input.slice(llength, length + llength);
        if (data.length < length) throw new Error("invalid RLP: not enough bytes for string");
        return {
            data: data,
            remainder: input.slice(length + llength)
        };
    } else if (firstByte <= 0xf7) {
        // a list between  0-55 bytes long
        length = firstByte - 0xbf;
        innerRemainder = input.slice(1, length);
        while(innerRemainder.length){
            d = $0ca14f51a53c43ef$var$_decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(length)
        };
    } else {
        // a list  over 55 bytes long
        llength = firstByte - 0xf6;
        length = $0ca14f51a53c43ef$var$safeParseInt(input.slice(1, llength).toString("hex"), 16);
        var totalLength = llength + length;
        if (totalLength > input.length) throw new Error("invalid rlp: total length is larger than the data");
        innerRemainder = input.slice(llength, totalLength);
        if (innerRemainder.length === 0) throw new Error("invalid rlp, List has a invalid length");
        while(innerRemainder.length){
            d = $0ca14f51a53c43ef$var$_decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(totalLength)
        };
    }
}
/** Check if a string is prefixed by 0x */ function $0ca14f51a53c43ef$var$isHexPrefixed(str) {
    return str.slice(0, 2) === "0x";
}
/** Removes 0x from a given String */ function $0ca14f51a53c43ef$var$stripHexPrefix(str) {
    if (typeof str !== "string") return str;
    return $0ca14f51a53c43ef$var$isHexPrefixed(str) ? str.slice(2) : str;
}
/** Transform an integer into its hexadecimal value */ function $0ca14f51a53c43ef$var$intToHex(integer) {
    if (integer < 0) throw new Error("Invalid integer as argument, must be unsigned!");
    var hex = integer.toString(16);
    return hex.length % 2 ? "0" + hex : hex;
}
/** Pad a string to be even */ function $0ca14f51a53c43ef$var$padToEven(a) {
    return a.length % 2 ? "0" + a : a;
}
/** Transform an integer into a Buffer */ function $0ca14f51a53c43ef$var$intToBuffer(integer) {
    var hex = $0ca14f51a53c43ef$var$intToHex(integer);
    return $0ca14f51a53c43ef$require$Buffer.from(hex, "hex");
}
/** Transform anything into a Buffer */ function $0ca14f51a53c43ef$var$toBuffer(v) {
    if (!$0ca14f51a53c43ef$require$Buffer.isBuffer(v)) {
        if (typeof v === "string") {
            if ($0ca14f51a53c43ef$var$isHexPrefixed(v)) return $0ca14f51a53c43ef$require$Buffer.from($0ca14f51a53c43ef$var$padToEven($0ca14f51a53c43ef$var$stripHexPrefix(v)), "hex");
            else return $0ca14f51a53c43ef$require$Buffer.from(v);
        } else if (typeof v === "number" || typeof v === "bigint") {
            if (!v) return $0ca14f51a53c43ef$require$Buffer.from([]);
            else return $0ca14f51a53c43ef$var$intToBuffer(v);
        } else if (v === null || v === undefined) return $0ca14f51a53c43ef$require$Buffer.from([]);
        else if (v instanceof Uint8Array) return $0ca14f51a53c43ef$require$Buffer.from(v);
        else if ($0ca14f51a53c43ef$var$bn_js_1.default.isBN(v)) // converts a BN to a Buffer
        return $0ca14f51a53c43ef$require$Buffer.from(v.toArray());
        else throw new Error("invalid type");
    }
    return v;
}

});
parcelRegister("3DJLR", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});





parcelRegister("beQa5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7lRdT", function(module, exports) {
"use strict";
var $55a3c78d976a1c96$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimpleNet = void 0;

var $fmRoT = parcelRequire("fmRoT");

var $cVSZM = parcelRequire("cVSZM");

var $biuEp = parcelRequire("biuEp");

var $k6Qs9 = parcelRequire("k6Qs9");

var $cgLmW = parcelRequire("cgLmW");
/** class simply implements Net interface */ class $55a3c78d976a1c96$var$SimpleNet {
    constructor(baseURL, timeout = 30000, wsTimeout = 30000){
        this.baseURL = baseURL;
        this.wsTimeout = wsTimeout;
        this.axios = $fmRoT.default.create({
            httpAgent: new $k6Qs9.Agent({
                keepAlive: true
            }),
            httpsAgent: new $cgLmW.Agent({
                keepAlive: true
            }),
            baseURL: baseURL,
            timeout: timeout
        });
    }
    http(method, path, params) {
        return $55a3c78d976a1c96$var$__awaiter(this, void 0, void 0, function*() {
            params = params || {};
            try {
                const resp = yield this.axios.request({
                    method: method,
                    url: path,
                    data: params.body,
                    headers: params.headers,
                    params: params.query
                });
                if (params.validateResponseHeader) params.validateResponseHeader(resp.headers);
                return resp.data;
            } catch (err) {
                if (err.isAxiosError) throw $55a3c78d976a1c96$var$convertError(err);
                throw new Error(`${method} ${$biuEp.resolve(this.baseURL, path)}: ${err.message}`);
            }
        });
    }
    openWebSocketReader(path) {
        const url = $biuEp.resolve(this.baseURL, path).replace(/^http:/i, "ws:").replace(/^https:/i, "wss:");
        return new $cVSZM.SimpleWebSocketReader(url, this.wsTimeout);
    }
}
module.exports.SimpleNet = $55a3c78d976a1c96$var$SimpleNet;
function $55a3c78d976a1c96$var$convertError(err) {
    if (err.response) {
        const resp = err.response;
        if (typeof resp.data === "string") {
            let text = resp.data.trim();
            if (text.length > 50) text = text.slice(0, 50) + "...";
            return new Error(`${resp.status} ${err.config.method} ${err.config.url}: ${text}`);
        } else return new Error(`${resp.status} ${err.config.method} ${err.config.url}`);
    } else return new Error(`${err.config.method} ${err.config.url}: ${err.message}`);
}

});
parcelRegister("fmRoT", function(module, exports) {

module.exports = (parcelRequire("7we3r"));

});
parcelRegister("7we3r", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    var context = new $ewFRw(defaultConfig);
    var instance = $jJbMR($ewFRw.prototype.request, context);
    // Copy axios.prototype to instance
    $gKvUL.extend(instance, $ewFRw.prototype, context);
    // Copy context to instance
    $gKvUL.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance($lJY4v);
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = $ewFRw;
// Factory for creating new instances
$57966c7e0affc4cb$var$axios.create = function create(instanceConfig) {
    return $57966c7e0affc4cb$var$createInstance($lk5EI($57966c7e0affc4cb$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.Cancel = (parcelRequire("4Tkeq"));

$57966c7e0affc4cb$var$axios.CancelToken = (parcelRequire("lAKPy"));

$57966c7e0affc4cb$var$axios.isCancel = (parcelRequire("7L4QX"));
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$57966c7e0affc4cb$var$axios.spread = (parcelRequire("JEeti"));

// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (parcelRequire("dxy9O"));
module.exports = $57966c7e0affc4cb$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {
"use strict";

var $jJbMR = parcelRequire("jJbMR");
// utils is a library of generic helper functions non-specific to axios
var $c319b2c832c2914a$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $c319b2c832c2914a$var$isArray(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $c319b2c832c2914a$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBuffer(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $c319b2c832c2914a$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $c319b2c832c2914a$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $c319b2c832c2914a$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $c319b2c832c2914a$var$isPlainObject(val) {
    if ($c319b2c832c2914a$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $c319b2c832c2914a$var$isDate(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $c319b2c832c2914a$var$isFile(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $c319b2c832c2914a$var$isBlob(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $c319b2c832c2914a$var$isFunction(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $c319b2c832c2914a$var$isStream(val) {
    return $c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $c319b2c832c2914a$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $c319b2c832c2914a$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $c319b2c832c2914a$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $c319b2c832c2914a$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($c319b2c832c2914a$var$isPlainObject(result[key]) && $c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge(result[key], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $c319b2c832c2914a$var$extend(a, b, thisArg) {
    $c319b2c832c2914a$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $jJbMR(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $c319b2c832c2914a$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isStandardBrowserEnv: $c319b2c832c2914a$var$isStandardBrowserEnv,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM
};

});
parcelRegister("jJbMR", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("ewFRw", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");

var $bv3QM = parcelRequire("bv3QM");
var $a93486d2307f31c3$var$validators = $bv3QM.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $a93486d2307f31c3$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $83RYu(),
        response: new $83RYu()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $a93486d2307f31c3$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $lk5EI(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $bv3QM.assertOptions(transitional, {
        silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean, "1.0.0"),
        forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean, "1.0.0"),
        clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean, "1.0.0")
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $dlZEJ,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $dlZEJ(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$a93486d2307f31c3$var$Axios.prototype.getUri = function getUri(config) {
    config = $lk5EI(this.defaults, config);
    return $cbIsf(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$gKvUL.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($gKvUL.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $gKvUL.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($gKvUL.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $gKvUL.forEach(val, function parseValue(v) {
                if ($gKvUL.isDate(v)) v = v.toISOString();
                else if ($gKvUL.isObject(v)) v = JSON.stringify(v);
                parts.push($8df8fedf1c1e4428$var$encode(key) + "=" + $8df8fedf1c1e4428$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("83RYu", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $5de878cd737ef277$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $5de878cd737ef277$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $5de878cd737ef277$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $5de878cd737ef277$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $gKvUL.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $7YJ0v.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $gKvUL.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $gKvUL.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $lJY4v.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $7YJ0v.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$7L4QX(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $7YJ0v.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("7YJ0v", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $lJY4v;
    /*eslint no-param-reassign:0*/ $gKvUL.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("lJY4v", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kiL6T = parcelRequire("kiL6T");

var $8v8A7 = parcelRequire("8v8A7");
var $fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, value) {
    if (!$gKvUL.isUndefined(headers) && $gKvUL.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $fd3c65eeb28abd71$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("at5cb"));
    else if (typeof $hPtJY !== "undefined" && Object.prototype.toString.call($hPtJY) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("at5cb"));
    return adapter;
}
function $fd3c65eeb28abd71$var$stringifySafely(rawValue, parser, encoder) {
    if ($gKvUL.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $gKvUL.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $fd3c65eeb28abd71$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $fd3c65eeb28abd71$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $kiL6T(headers, "Accept");
            $kiL6T(headers, "Content-Type");
            if ($gKvUL.isFormData(data) || $gKvUL.isArrayBuffer(data) || $gKvUL.isBuffer(data) || $gKvUL.isStream(data) || $gKvUL.isFile(data) || $gKvUL.isBlob(data)) return data;
            if ($gKvUL.isArrayBufferView(data)) return data.buffer;
            if ($gKvUL.isURLSearchParams(data)) {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($gKvUL.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, "application/json");
                return $fd3c65eeb28abd71$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $gKvUL.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $8v8A7(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$fd3c65eeb28abd71$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$gKvUL.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = {};
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = $gKvUL.merge($fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $fd3c65eeb28abd71$var$defaults;

});
parcelRegister("kiL6T", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $gKvUL.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("8v8A7", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRegister("at5cb", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $8JRzs = parcelRequire("8JRzs");

var $cbIsf = parcelRequire("cbIsf");

var $7GD7a = parcelRequire("7GD7a");

var $lDriZ = parcelRequire("lDriZ");

var $889er = parcelRequire("889er");

var $kjF3e = parcelRequire("kjF3e");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($gKvUL.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $7GD7a(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $cbIsf(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $lDriZ(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $kk0E9(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($kjF3e("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($kjF3e("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($kjF3e(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($gKvUL.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $889er(fullPath)) && config.xsrfCookieName ? $8JRzs.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $gKvUL.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$gKvUL.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {
"use strict";

var $kjF3e = parcelRequire("kjF3e");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($kjF3e("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("kjF3e", function(module, exports) {
"use strict";

var $8v8A7 = parcelRequire("8v8A7");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $8v8A7(error, config, code, request, response);
};

});


parcelRegister("8JRzs", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($gKvUL.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($gKvUL.isString(path)) cookie.push("path=" + path);
            if ($gKvUL.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("7GD7a", function(module, exports) {
"use strict";

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$ckHwb(requestedURL)) return $fE4ul(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("ckHwb", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("fE4ul", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("lDriZ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $fc026bbf9ee156f1$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $gKvUL.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $gKvUL.trim(line.substr(0, i)).toLowerCase();
        val = $gKvUL.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("889er", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $gKvUL.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("7L4QX", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("lk5EI", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy",
        "params"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding"
    ];
    var directMergeKeys = [
        "validateStatus"
    ];
    function getMergedValue(target, source) {
        if ($gKvUL.isPlainObject(target) && $gKvUL.isPlainObject(source)) return $gKvUL.merge(target, source);
        else if ($gKvUL.isPlainObject(source)) return $gKvUL.merge({}, source);
        else if ($gKvUL.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $gKvUL.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $gKvUL.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $gKvUL.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $gKvUL.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $gKvUL.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRegister("bv3QM", function(module, exports) {
"use strict";

var $bgdCC = parcelRequire("bgdCC");
var $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $85f59389941e7907$var$deprecatedWarnings = {};
var $85f59389941e7907$var$currentVerArr = $bgdCC.version.split(".");
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $85f59389941e7907$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split(".") : $85f59389941e7907$var$currentVerArr;
    var destVer = version.split(".");
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && $85f59389941e7907$var$isOlderVersion(version);
    function formatMessage(opt, desc) {
        return "[Axios v" + $bgdCC.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed in " + version));
        if (isDeprecated && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    isOlderVersion: $85f59389941e7907$var$isOlderVersion,
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};

});
parcelRegister("bgdCC", function(module, exports) {
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

});



parcelRegister("4Tkeq", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $38fbfe0afbd5bf1e$var$Cancel(message) {
    this.message = message;
}
$38fbfe0afbd5bf1e$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$38fbfe0afbd5bf1e$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $38fbfe0afbd5bf1e$var$Cancel;

});

parcelRegister("lAKPy", function(module, exports) {
"use strict";

var $4Tkeq = parcelRequire("4Tkeq");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $fb81495929d8a282$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $4Tkeq(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $fb81495929d8a282$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $fb81495929d8a282$var$CancelToken.source = function source() {
    var cancel;
    var token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("dxy9O", function(module, exports) {
"use strict";
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
};

});



parcelRegister("cVSZM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimpleWebSocketReader = void 0;

var $8f8QB = parcelRequire("8f8QB");
class $96a577dfa77ecd33$var$SimpleWebSocketReader {
    constructor(url, timeout = 30000){
        this.timeout = timeout;
        this.callbacks = [];
        this.ws = new $8f8QB(url);
        this.ws.onmessage = (ev)=>{
            try {
                const cbs = this.callbacks;
                this.callbacks = [];
                cbs.forEach((cb)=>cb(ev.data));
            } catch (err) {
                this.setError(err);
                this.ws.close();
            }
        };
        this.ws.onerror = (ev)=>{
            this.setError(ev.error);
            this.ws.close();
        };
        this.ws.onclose = ()=>{
            this.setError(new Error("closed"));
        };
    }
    read() {
        return new Promise((resolve, reject)=>{
            if (this.error) return reject(this.error);
            const timer = setTimeout(()=>{
                reject(new Error("ws read timeout"));
            }, this.timeout);
            this.callbacks.push((data, err)=>{
                clearTimeout(timer);
                if (err) return reject(err);
                resolve(data);
            });
        });
    }
    close() {
        this.ws.close();
    }
    setError(err) {
        if (!this.error) {
            this.error = err;
            const cbs = this.callbacks;
            this.callbacks = [];
            cbs.forEach((cb)=>cb(null, err));
        }
    }
}
module.exports.SimpleWebSocketReader = $96a577dfa77ecd33$var$SimpleWebSocketReader;

});
parcelRegister("8f8QB", function(module, exports) {
// https://github.com/maxogden/websocket-stream/blob/48dc3ddf943e5ada668c31ccd94e9186f02fafbd/ws-fallback.js
var $600696615019689e$var$ws = null;
if (typeof WebSocket !== "undefined") $600696615019689e$var$ws = WebSocket;
else if (typeof MozWebSocket !== "undefined") $600696615019689e$var$ws = MozWebSocket;
else if (typeof $parcel$global !== "undefined") $600696615019689e$var$ws = $parcel$global.WebSocket || $parcel$global.MozWebSocket;
else if (typeof window !== "undefined") $600696615019689e$var$ws = window.WebSocket || window.MozWebSocket;
else if (typeof self !== "undefined") $600696615019689e$var$ws = self.WebSocket || self.MozWebSocket;
module.exports = $600696615019689e$var$ws;

});


parcelRegister("biuEp", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ "use strict";

var $dBHwk = parcelRequire("dBHwk");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};

var $2rasJ = parcelRequire("2rasJ");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === "object" && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== "string") throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $2rasJ.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf("@", hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || "";
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $dBHwk.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $2rasJ.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === "string") obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && typeof this.query === "object" && Object.keys(this.query).length) query = $2rasJ.stringify(this.query, {
        arrayFormat: "repeat",
        addQueryPrefix: false
    });
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === "string") {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = "/";
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (srcPath.length > 0) result.pathname = srcPath.join("/");
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("dBHwk", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("2rasJ", function(module, exports) {
"use strict";

var $jJyEy = parcelRequire("jJyEy");

var $cfYIz = parcelRequire("cfYIz");

var $i1Gbt = parcelRequire("i1Gbt");
module.exports = {
    formats: $i1Gbt,
    parse: $cfYIz,
    stringify: $jJyEy
};

});
parcelRegister("jJyEy", function(module, exports) {
"use strict";

var $LlIML = parcelRequire("LlIML");

var $iBfJ5 = parcelRequire("iBfJ5");

var $i1Gbt = parcelRequire("i1Gbt");
var $e5dd19a945a45bbb$var$has = Object.prototype.hasOwnProperty;
var $e5dd19a945a45bbb$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $e5dd19a945a45bbb$var$isArray = Array.isArray;
var $e5dd19a945a45bbb$var$push = Array.prototype.push;
var $e5dd19a945a45bbb$var$pushToArray = function(arr, valueOrArray) {
    $e5dd19a945a45bbb$var$push.apply(arr, $e5dd19a945a45bbb$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $e5dd19a945a45bbb$var$toISO = Date.prototype.toISOString;
var $e5dd19a945a45bbb$var$defaultFormat = $i1Gbt.default;
var $e5dd19a945a45bbb$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: $iBfJ5.encode,
    encodeValuesOnly: false,
    format: $e5dd19a945a45bbb$var$defaultFormat,
    formatter: $i1Gbt.formatters[$e5dd19a945a45bbb$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $e5dd19a945a45bbb$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $e5dd19a945a45bbb$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $e5dd19a945a45bbb$var$sentinel = {};
var $e5dd19a945a45bbb$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($e5dd19a945a45bbb$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($e5dd19a945a45bbb$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) obj = $iBfJ5.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($e5dd19a945a45bbb$var$isNonNullishPrimitive(obj) || $iBfJ5.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $e5dd19a945a45bbb$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $iBfJ5.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($e5dd19a945a45bbb$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var adjustedPrefix = commaRoundTrip && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 1 ? prefix + "[]" : prefix;
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $e5dd19a945a45bbb$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + key : "[" + key + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $LlIML();
        valueSideChannel.set($e5dd19a945a45bbb$var$sentinel, sideChannel);
        $e5dd19a945a45bbb$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, generateArrayPrefix === "comma" && encodeValuesOnly && $e5dd19a945a45bbb$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $e5dd19a945a45bbb$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $e5dd19a945a45bbb$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $e5dd19a945a45bbb$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $i1Gbt.default;
    if (typeof opts.format !== "undefined") {
        if (!$e5dd19a945a45bbb$var$has.call($i1Gbt.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $i1Gbt.formatters[format];
    var filter = $e5dd19a945a45bbb$var$defaults.filter;
    if (typeof opts.filter === "function" || $e5dd19a945a45bbb$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $e5dd19a945a45bbb$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? $e5dd19a945a45bbb$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $e5dd19a945a45bbb$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? $e5dd19a945a45bbb$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $e5dd19a945a45bbb$var$defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $e5dd19a945a45bbb$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $e5dd19a945a45bbb$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $e5dd19a945a45bbb$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $e5dd19a945a45bbb$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $e5dd19a945a45bbb$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $e5dd19a945a45bbb$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($e5dd19a945a45bbb$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in $e5dd19a945a45bbb$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = $e5dd19a945a45bbb$var$arrayPrefixGenerators[arrayFormat];
    if (opts && "commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var commaRoundTrip = generateArrayPrefix === "comma" && opts && opts.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $LlIML();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $e5dd19a945a45bbb$var$pushToArray(keys, $e5dd19a945a45bbb$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("LlIML", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $hXu6F = parcelRequire("hXu6F");

var $e7DLx = parcelRequire("e7DLx");
var $08e53d4ef2e1f8ef$var$$TypeError = $1zENl("%TypeError%");
var $08e53d4ef2e1f8ef$var$$WeakMap = $1zENl("%WeakMap%", true);
var $08e53d4ef2e1f8ef$var$$Map = $1zENl("%Map%", true);
var $08e53d4ef2e1f8ef$var$$weakMapGet = $hXu6F("WeakMap.prototype.get", true);
var $08e53d4ef2e1f8ef$var$$weakMapSet = $hXu6F("WeakMap.prototype.set", true);
var $08e53d4ef2e1f8ef$var$$weakMapHas = $hXu6F("WeakMap.prototype.has", true);
var $08e53d4ef2e1f8ef$var$$mapGet = $hXu6F("Map.prototype.get", true);
var $08e53d4ef2e1f8ef$var$$mapSet = $hXu6F("Map.prototype.set", true);
var $08e53d4ef2e1f8ef$var$$mapHas = $hXu6F("Map.prototype.has", true);
/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */ var $08e53d4ef2e1f8ef$var$listGetNode = function(list, key) {
    for(var prev = list, curr; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        curr.next = list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
var $08e53d4ef2e1f8ef$var$listGet = function(objects, key) {
    var node = $08e53d4ef2e1f8ef$var$listGetNode(objects, key);
    return node && node.value;
};
var $08e53d4ef2e1f8ef$var$listSet = function(objects, key, value) {
    var node = $08e53d4ef2e1f8ef$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = {
        key: key,
        next: objects.next,
        value: value
    };
};
var $08e53d4ef2e1f8ef$var$listHas = function(objects, key) {
    return !!$08e53d4ef2e1f8ef$var$listGetNode(objects, key);
};
module.exports = function getSideChannel() {
    var $wm;
    var $m;
    var $o;
    var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $08e53d4ef2e1f8ef$var$$TypeError("Side channel does not contain " + $e7DLx(key));
        },
        get: function(key) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $08e53d4ef2e1f8ef$var$$weakMapGet($wm, key);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if ($m) return $08e53d4ef2e1f8ef$var$$mapGet($m, key);
            } else {
                if ($o) return $08e53d4ef2e1f8ef$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $08e53d4ef2e1f8ef$var$$weakMapHas($wm, key);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if ($m) return $08e53d4ef2e1f8ef$var$$mapHas($m, key);
            } else {
                if ($o) return $08e53d4ef2e1f8ef$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $08e53d4ef2e1f8ef$var$$WeakMap();
                $08e53d4ef2e1f8ef$var$$weakMapSet($wm, key, value);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if (!$m) $m = new $08e53d4ef2e1f8ef$var$$Map();
                $08e53d4ef2e1f8ef$var$$mapSet($m, key, value);
            } else {
                if (!$o) /*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */ $o = {
                    key: {},
                    next: null
                };
                $08e53d4ef2e1f8ef$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("1zENl", function(module, exports) {
"use strict";
var $1258b452ecf218a1$var$undefined1;
var $1258b452ecf218a1$var$$SyntaxError = SyntaxError;
var $1258b452ecf218a1$var$$Function = Function;
var $1258b452ecf218a1$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1258b452ecf218a1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1258b452ecf218a1$var$$gOPD) try {
    $1258b452ecf218a1$var$$gOPD({}, "");
} catch (e) {
    $1258b452ecf218a1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $1258b452ecf218a1$var$$TypeError();
};
var $1258b452ecf218a1$var$ThrowTypeError = $1258b452ecf218a1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1258b452ecf218a1$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $1258b452ecf218a1$var$hasProto = (parcelRequire("dSRh6"))();
var $1258b452ecf218a1$var$getProto = Object.getPrototypeOf || ($1258b452ecf218a1$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === "undefined" || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGenerator%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncIteratorPrototype%": $1258b452ecf218a1$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $1258b452ecf218a1$var$$Function,
    "%GeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $1258b452ecf218a1$var$$SyntaxError,
    "%ThrowTypeError%": $1258b452ecf218a1$var$ThrowTypeError,
    "%TypedArray%": $1258b452ecf218a1$var$TypedArray,
    "%TypeError%": $1258b452ecf218a1$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($1258b452ecf218a1$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto(e));
    $1258b452ecf218a1$var$INTRINSICS["%Error.prototype%"] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $1258b452ecf218a1$var$getProto) value = $1258b452ecf218a1$var$getProto(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call(Function.call, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call(Function.apply, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call(Function.call, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call(Function.call, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $1258b452ecf218a1$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $1258b452ecf218a1$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $1258b452ecf218a1$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $1258b452ecf218a1$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $1258b452ecf218a1$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $1258b452ecf218a1$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $1258b452ecf218a1$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $1258b452ecf218a1$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $1258b452ecf218a1$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1258b452ecf218a1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1258b452ecf218a1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("24qIq", function(module, exports) {
"use strict";
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $1820ada193f67aeb$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $7YWkK();
};

});
parcelRegister("7YWkK", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("dSRh6", function(module, exports) {
"use strict";
var $a1b9a4c94d7d9147$var$test = {
    foo: {}
};
var $a1b9a4c94d7d9147$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $a1b9a4c94d7d9147$var$test
    }).foo === $a1b9a4c94d7d9147$var$test.foo && !(({
        __proto__: null
    }) instanceof $a1b9a4c94d7d9147$var$$Object);
};

});

parcelRegister("gvair", function(module, exports) {
"use strict";

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = "[object Function]";
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $efd80b1d7fbb2850$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("4c4Ky", function(module, exports) {
"use strict";
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {(o: {}, p: PropertyKey) => p is keyof o} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});


parcelRegister("hXu6F", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $cOB0F = parcelRequire("cOB0F");
var $d12f4cdcd6b10506$var$$indexOf = $cOB0F($1zENl("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d12f4cdcd6b10506$var$$indexOf(name, ".prototype.") > -1) return $cOB0F(intrinsic);
    return intrinsic;
};

});
parcelRegister("cOB0F", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");

var $1zENl = parcelRequire("1zENl");

var $BPe9e = parcelRequire("BPe9e");
var $9546dce5bd4976bd$var$$TypeError = $1zENl("%TypeError%");
var $9546dce5bd4976bd$var$$apply = $1zENl("%Function.prototype.apply%");
var $9546dce5bd4976bd$var$$call = $1zENl("%Function.prototype.call%");
var $9546dce5bd4976bd$var$$reflectApply = $1zENl("%Reflect.apply%", true) || $gvair.call($9546dce5bd4976bd$var$$call, $9546dce5bd4976bd$var$$apply);
var $9546dce5bd4976bd$var$$defineProperty = $1zENl("%Object.defineProperty%", true);
var $9546dce5bd4976bd$var$$max = $1zENl("%Math.max%");
if ($9546dce5bd4976bd$var$$defineProperty) try {
    $9546dce5bd4976bd$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $9546dce5bd4976bd$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $9546dce5bd4976bd$var$$TypeError("a function is required");
    var func = $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$call, arguments);
    return $BPe9e(func, 1 + $9546dce5bd4976bd$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $9546dce5bd4976bd$var$applyBind = function applyBind() {
    return $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$apply, arguments);
};
if ($9546dce5bd4976bd$var$$defineProperty) $9546dce5bd4976bd$var$$defineProperty(module.exports, "apply", {
    value: $9546dce5bd4976bd$var$applyBind
});
else module.exports.apply = $9546dce5bd4976bd$var$applyBind;

});
parcelRegister("BPe9e", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $5FEEt = parcelRequire("5FEEt");

var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();

var $dYOee = parcelRequire("dYOee");
var $071b317808876eb5$var$$TypeError = $1zENl("%TypeError%");
var $071b317808876eb5$var$$floor = $1zENl("%Math.floor%");
module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $071b317808876eb5$var$$TypeError("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $071b317808876eb5$var$$TypeError("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $dYOee) {
        var desc = $dYOee(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $5FEEt(fn, "length", length, true, true);
        else $5FEEt(fn, "length", length);
    }
    return fn;
};

});
parcelRegister("5FEEt", function(module, exports) {
"use strict";

var $421050b39f25e605$var$hasPropertyDescriptors = (parcelRequire("i16wS"))();

var $1zENl = parcelRequire("1zENl");
var $421050b39f25e605$var$$defineProperty = $421050b39f25e605$var$hasPropertyDescriptors && $1zENl("%Object.defineProperty%", true);
if ($421050b39f25e605$var$$defineProperty) try {
    $421050b39f25e605$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $421050b39f25e605$var$$defineProperty = false;
}
var $421050b39f25e605$var$$SyntaxError = $1zENl("%SyntaxError%");
var $421050b39f25e605$var$$TypeError = $1zENl("%TypeError%");

var $dYOee = parcelRequire("dYOee");
/** @type {(obj: Record<PropertyKey, unknown>, property: PropertyKey, value: unknown, nonEnumerable?: boolean | null, nonWritable?: boolean | null, nonConfigurable?: boolean | null, loose?: boolean) => void} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $421050b39f25e605$var$$TypeError("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $421050b39f25e605$var$$TypeError("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $421050b39f25e605$var$$TypeError("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $421050b39f25e605$var$$TypeError("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $421050b39f25e605$var$$TypeError("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $421050b39f25e605$var$$TypeError("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$dYOee && $dYOee(obj, property);
    if ($421050b39f25e605$var$$defineProperty) $421050b39f25e605$var$$defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $421050b39f25e605$var$$SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("i16wS", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $d1dd62937e17e68d$var$$defineProperty = $1zENl("%Object.defineProperty%", true);
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($d1dd62937e17e68d$var$$defineProperty) try {
        $d1dd62937e17e68d$var$$defineProperty({}, "a", {
            value: 1
        });
        return true;
    } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
    }
    return false;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$d1dd62937e17e68d$var$hasPropertyDescriptors()) return null;
    try {
        return $d1dd62937e17e68d$var$$defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});

parcelRegister("dYOee", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $a2d7d74e83f6c3ed$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
if ($a2d7d74e83f6c3ed$var$$gOPD) try {
    $a2d7d74e83f6c3ed$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$var$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$var$$gOPD;

});





parcelRegister("e7DLx", function(module, exports) {
var $a48090c7c3dfd2b6$var$hasMap = typeof Map === "function" && Map.prototype;
var $a48090c7c3dfd2b6$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $a48090c7c3dfd2b6$var$mapSize = $a48090c7c3dfd2b6$var$hasMap && $a48090c7c3dfd2b6$var$mapSizeDescriptor && typeof $a48090c7c3dfd2b6$var$mapSizeDescriptor.get === "function" ? $a48090c7c3dfd2b6$var$mapSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$mapForEach = $a48090c7c3dfd2b6$var$hasMap && Map.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasSet = typeof Set === "function" && Set.prototype;
var $a48090c7c3dfd2b6$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $a48090c7c3dfd2b6$var$setSize = $a48090c7c3dfd2b6$var$hasSet && $a48090c7c3dfd2b6$var$setSizeDescriptor && typeof $a48090c7c3dfd2b6$var$setSizeDescriptor.get === "function" ? $a48090c7c3dfd2b6$var$setSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$setForEach = $a48090c7c3dfd2b6$var$hasSet && Set.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $a48090c7c3dfd2b6$var$weakMapHas = $a48090c7c3dfd2b6$var$hasWeakMap ? WeakMap.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $a48090c7c3dfd2b6$var$weakSetHas = $a48090c7c3dfd2b6$var$hasWeakSet ? WeakSet.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $a48090c7c3dfd2b6$var$weakRefDeref = $a48090c7c3dfd2b6$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $a48090c7c3dfd2b6$var$booleanValueOf = Boolean.prototype.valueOf;
var $a48090c7c3dfd2b6$var$objectToString = Object.prototype.toString;
var $a48090c7c3dfd2b6$var$functionToString = Function.prototype.toString;
var $a48090c7c3dfd2b6$var$$match = String.prototype.match;
var $a48090c7c3dfd2b6$var$$slice = String.prototype.slice;
var $a48090c7c3dfd2b6$var$$replace = String.prototype.replace;
var $a48090c7c3dfd2b6$var$$toUpperCase = String.prototype.toUpperCase;
var $a48090c7c3dfd2b6$var$$toLowerCase = String.prototype.toLowerCase;
var $a48090c7c3dfd2b6$var$$test = RegExp.prototype.test;
var $a48090c7c3dfd2b6$var$$concat = Array.prototype.concat;
var $a48090c7c3dfd2b6$var$$join = Array.prototype.join;
var $a48090c7c3dfd2b6$var$$arrSlice = Array.prototype.slice;
var $a48090c7c3dfd2b6$var$$floor = Math.floor;
var $a48090c7c3dfd2b6$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $a48090c7c3dfd2b6$var$gOPS = Object.getOwnPropertySymbols;
var $a48090c7c3dfd2b6$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $a48090c7c3dfd2b6$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $a48090c7c3dfd2b6$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $a48090c7c3dfd2b6$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $a48090c7c3dfd2b6$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $a48090c7c3dfd2b6$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $a48090c7c3dfd2b6$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $a48090c7c3dfd2b6$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$a48090c7c3dfd2b6$var$$floor(-num) : $a48090c7c3dfd2b6$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $a48090c7c3dfd2b6$var$$slice.call(str, intStr.length + 1);
            return $a48090c7c3dfd2b6$var$$replace.call(intStr, sepRegex, "$&_") + "." + $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $a48090c7c3dfd2b6$var$$replace.call(str, sepRegex, "$&_");
}

var $kjyEk = parcelRequire("kjyEk");
var $a48090c7c3dfd2b6$var$inspectCustom = $kjyEk.custom;
var $a48090c7c3dfd2b6$var$inspectSymbol = $a48090c7c3dfd2b6$var$isSymbol($a48090c7c3dfd2b6$var$inspectCustom) ? $a48090c7c3dfd2b6$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($a48090c7c3dfd2b6$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($a48090c7c3dfd2b6$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $a48090c7c3dfd2b6$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($a48090c7c3dfd2b6$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($a48090c7c3dfd2b6$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $a48090c7c3dfd2b6$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $a48090c7c3dfd2b6$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $a48090c7c3dfd2b6$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($a48090c7c3dfd2b6$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $a48090c7c3dfd2b6$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($a48090c7c3dfd2b6$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var name = $a48090c7c3dfd2b6$var$nameOf(obj);
        var keys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $a48090c7c3dfd2b6$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($a48090c7c3dfd2b6$var$isSymbol(obj)) {
        var symString = $a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $a48090c7c3dfd2b6$var$symToString.call(obj);
        return typeof obj === "object" && !$a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$markBoxed(symString) : symString;
    }
    if ($a48090c7c3dfd2b6$var$isElement(obj)) {
        var s = "<" + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $a48090c7c3dfd2b6$var$wrapQuotes($a48090c7c3dfd2b6$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($a48090c7c3dfd2b6$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (indent && !$a48090c7c3dfd2b6$var$singleLineValues(xs)) return "[" + $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) + "]";
        return "[ " + $a48090c7c3dfd2b6$var$$join.call(xs, ", ") + " ]";
    }
    if ($a48090c7c3dfd2b6$var$isError(obj)) {
        var parts = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$a48090c7c3dfd2b6$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $a48090c7c3dfd2b6$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($a48090c7c3dfd2b6$var$inspectSymbol && typeof obj[$a48090c7c3dfd2b6$var$inspectSymbol] === "function" && $kjyEk) return $kjyEk(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($a48090c7c3dfd2b6$var$isMap(obj)) {
        var mapParts = [];
        if ($a48090c7c3dfd2b6$var$mapForEach) $a48090c7c3dfd2b6$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf("Map", $a48090c7c3dfd2b6$var$mapSize.call(obj), mapParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isSet(obj)) {
        var setParts = [];
        if ($a48090c7c3dfd2b6$var$setForEach) $a48090c7c3dfd2b6$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf("Set", $a48090c7c3dfd2b6$var$setSize.call(obj), setParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isWeakMap(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakMap");
    if ($a48090c7c3dfd2b6$var$isWeakSet(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakSet");
    if ($a48090c7c3dfd2b6$var$isWeakRef(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakRef");
    if ($a48090c7c3dfd2b6$var$isNumber(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(Number(obj)));
    if ($a48090c7c3dfd2b6$var$isBigInt(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect($a48090c7c3dfd2b6$var$bigIntValueOf.call(obj)));
    if ($a48090c7c3dfd2b6$var$isBoolean(obj)) return $a48090c7c3dfd2b6$var$markBoxed($a48090c7c3dfd2b6$var$booleanValueOf.call(obj));
    if ($a48090c7c3dfd2b6$var$isString(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (obj === $parcel$global) return "{ [object globalThis] }";
    if (!$a48090c7c3dfd2b6$var$isDate(obj) && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var ys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        var isPlainObject = $a48090c7c3dfd2b6$var$gPO ? $a48090c7c3dfd2b6$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $a48090c7c3dfd2b6$var$toStringTag && Object(obj) === obj && $a48090c7c3dfd2b6$var$toStringTag in obj ? $a48090c7c3dfd2b6$var$$slice.call($a48090c7c3dfd2b6$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $a48090c7c3dfd2b6$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $a48090c7c3dfd2b6$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $a48090c7c3dfd2b6$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $a48090c7c3dfd2b6$var$quote(s) {
    return $a48090c7c3dfd2b6$var$$replace.call(String(s), /"/g, "&quot;");
}
function $a48090c7c3dfd2b6$var$isArray(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Array]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isDate(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Date]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isRegExp(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object RegExp]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isError(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Error]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isString(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object String]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isNumber(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Number]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isBoolean(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Boolean]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $a48090c7c3dfd2b6$var$isSymbol(obj) {
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$a48090c7c3dfd2b6$var$symToString) return false;
    try {
        $a48090c7c3dfd2b6$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$a48090c7c3dfd2b6$var$bigIntValueOf) return false;
    try {
        $a48090c7c3dfd2b6$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $a48090c7c3dfd2b6$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $a48090c7c3dfd2b6$var$has(obj, key) {
    return $a48090c7c3dfd2b6$var$hasOwn.call(obj, key);
}
function $a48090c7c3dfd2b6$var$toStr(obj) {
    return $a48090c7c3dfd2b6$var$objectToString.call(obj);
}
function $a48090c7c3dfd2b6$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $a48090c7c3dfd2b6$var$$match.call($a48090c7c3dfd2b6$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $a48090c7c3dfd2b6$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $a48090c7c3dfd2b6$var$isMap(x) {
    if (!$a48090c7c3dfd2b6$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$mapSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakMap(x) {
    if (!$a48090c7c3dfd2b6$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        try {
            $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakRef(x) {
    if (!$a48090c7c3dfd2b6$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isSet(x) {
    if (!$a48090c7c3dfd2b6$var$setSize || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$setSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakSet(x) {
    if (!$a48090c7c3dfd2b6$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        try {
            $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $a48090c7c3dfd2b6$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $a48090c7c3dfd2b6$var$inspectString($a48090c7c3dfd2b6$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $a48090c7c3dfd2b6$var$lowbyte);
    return $a48090c7c3dfd2b6$var$wrapQuotes(s, "single", opts);
}
function $a48090c7c3dfd2b6$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $a48090c7c3dfd2b6$var$$toUpperCase.call(n.toString(16));
}
function $a48090c7c3dfd2b6$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $a48090c7c3dfd2b6$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $a48090c7c3dfd2b6$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $a48090c7c3dfd2b6$var$indentedJoin(entries, indent) : $a48090c7c3dfd2b6$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $a48090c7c3dfd2b6$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($a48090c7c3dfd2b6$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $a48090c7c3dfd2b6$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $a48090c7c3dfd2b6$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $a48090c7c3dfd2b6$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $a48090c7c3dfd2b6$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect) {
    var isArr = $a48090c7c3dfd2b6$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $a48090c7c3dfd2b6$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $a48090c7c3dfd2b6$var$gOPS === "function" ? $a48090c7c3dfd2b6$var$gOPS(obj) : [];
    var symMap;
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$a48090c7c3dfd2b6$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($a48090c7c3dfd2b6$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($a48090c7c3dfd2b6$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $a48090c7c3dfd2b6$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($a48090c7c3dfd2b6$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});


parcelRegister("iBfJ5", function(module, exports) {
"use strict";

var $i1Gbt = parcelRequire("i1Gbt");
var $d8a7e190fdc9c6e7$var$has = Object.prototype.hasOwnProperty;
var $d8a7e190fdc9c6e7$var$isArray = Array.isArray;
var $d8a7e190fdc9c6e7$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $d8a7e190fdc9c6e7$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($d8a7e190fdc9c6e7$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $d8a7e190fdc9c6e7$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $d8a7e190fdc9c6e7$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($d8a7e190fdc9c6e7$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$d8a7e190fdc9c6e7$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($d8a7e190fdc9c6e7$var$isArray(target) && !$d8a7e190fdc9c6e7$var$isArray(source)) mergeTarget = $d8a7e190fdc9c6e7$var$arrayToObject(target, options);
    if ($d8a7e190fdc9c6e7$var$isArray(target) && $d8a7e190fdc9c6e7$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($d8a7e190fdc9c6e7$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($d8a7e190fdc9c6e7$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $d8a7e190fdc9c6e7$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $d8a7e190fdc9c6e7$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $d8a7e190fdc9c6e7$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $i1Gbt.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $d8a7e190fdc9c6e7$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($d8a7e190fdc9c6e7$var$hexTable[0xC0 | c >> 6] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($d8a7e190fdc9c6e7$var$hexTable[0xE0 | c >> 12] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $d8a7e190fdc9c6e7$var$hexTable[0xF0 | c >> 18] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 12 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $d8a7e190fdc9c6e7$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $d8a7e190fdc9c6e7$var$compactQueue(queue);
    return value;
};
var $d8a7e190fdc9c6e7$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $d8a7e190fdc9c6e7$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $d8a7e190fdc9c6e7$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $d8a7e190fdc9c6e7$var$maybeMap = function maybeMap(val, fn) {
    if ($d8a7e190fdc9c6e7$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $d8a7e190fdc9c6e7$var$arrayToObject,
    assign: $d8a7e190fdc9c6e7$var$assign,
    combine: $d8a7e190fdc9c6e7$var$combine,
    compact: $d8a7e190fdc9c6e7$var$compact,
    decode: $d8a7e190fdc9c6e7$var$decode,
    encode: $d8a7e190fdc9c6e7$var$encode,
    isBuffer: $d8a7e190fdc9c6e7$var$isBuffer,
    isRegExp: $d8a7e190fdc9c6e7$var$isRegExp,
    maybeMap: $d8a7e190fdc9c6e7$var$maybeMap,
    merge: $d8a7e190fdc9c6e7$var$merge
};

});
parcelRegister("i1Gbt", function(module, exports) {
"use strict";
var $d1f90adf4e1eece6$var$replace = String.prototype.replace;
var $d1f90adf4e1eece6$var$percentTwenties = /%20/g;
var $d1f90adf4e1eece6$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $d1f90adf4e1eece6$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $d1f90adf4e1eece6$var$replace.call(value, $d1f90adf4e1eece6$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $d1f90adf4e1eece6$var$Format.RFC1738,
    RFC3986: $d1f90adf4e1eece6$var$Format.RFC3986
};

});



parcelRegister("cfYIz", function(module, exports) {
"use strict";

var $iBfJ5 = parcelRequire("iBfJ5");
var $8ec5fc0fdc198ba4$var$has = Object.prototype.hasOwnProperty;
var $8ec5fc0fdc198ba4$var$isArray = Array.isArray;
var $8ec5fc0fdc198ba4$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: $iBfJ5.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $8ec5fc0fdc198ba4$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $8ec5fc0fdc198ba4$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $8ec5fc0fdc198ba4$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $8ec5fc0fdc198ba4$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $8ec5fc0fdc198ba4$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $8ec5fc0fdc198ba4$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $8ec5fc0fdc198ba4$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = $iBfJ5.maybeMap($8ec5fc0fdc198ba4$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $8ec5fc0fdc198ba4$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $8ec5fc0fdc198ba4$var$isArray(val) ? [
            val
        ] : val;
        if ($8ec5fc0fdc198ba4$var$has.call(obj, key)) obj[key] = $iBfJ5.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $8ec5fc0fdc198ba4$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $8ec5fc0fdc198ba4$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $8ec5fc0fdc198ba4$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $8ec5fc0fdc198ba4$var$parseObject(keys, val, options, valuesParsed);
};
var $8ec5fc0fdc198ba4$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $8ec5fc0fdc198ba4$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $8ec5fc0fdc198ba4$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $8ec5fc0fdc198ba4$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $8ec5fc0fdc198ba4$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $8ec5fc0fdc198ba4$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $8ec5fc0fdc198ba4$var$defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $8ec5fc0fdc198ba4$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $iBfJ5.isRegExp(opts.delimiter) ? opts.delimiter : $8ec5fc0fdc198ba4$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $8ec5fc0fdc198ba4$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $8ec5fc0fdc198ba4$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $8ec5fc0fdc198ba4$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $8ec5fc0fdc198ba4$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $8ec5fc0fdc198ba4$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $8ec5fc0fdc198ba4$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $8ec5fc0fdc198ba4$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $8ec5fc0fdc198ba4$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $iBfJ5.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $iBfJ5.compact(obj);
};

});



parcelRegister("k6Qs9", function(module, exports) {

var $1r5QY = parcelRequire("1r5QY");

var $6dXuF = parcelRequire("6dXuF");

var $h0kNM = parcelRequire("h0kNM");

var $4rffA = parcelRequire("4rffA");

var $biuEp = parcelRequire("biuEp");
var $ea3d0e42a2be418c$var$http = module.exports;
$ea3d0e42a2be418c$var$http.request = function(opts, cb) {
    if (typeof opts === "string") opts = $biuEp.parse(opts);
    else opts = $h0kNM(opts);
    // Normally, the page is loaded from http or https, so not specifying a protocol
    // will result in a (valid) protocol-relative url. However, this won't work if
    // the protocol is something else, like 'file:'
    var defaultProtocol = $parcel$global.location.protocol.search(/^https?:$/) === -1 ? "http:" : "";
    var protocol = opts.protocol || defaultProtocol;
    var host = opts.hostname || opts.host;
    var port = opts.port;
    var path = opts.path || "/";
    // Necessary for IPv6 addresses
    if (host && host.indexOf(":") !== -1) host = "[" + host + "]";
    // This may be a relative url. The browser should always be able to interpret it correctly.
    opts.url = (host ? protocol + "//" + host : "") + (port ? ":" + port : "") + path;
    opts.method = (opts.method || "GET").toUpperCase();
    opts.headers = opts.headers || {};
    // Also valid opts.auth, opts.mode
    var req = new $1r5QY(opts);
    if (cb) req.on("response", cb);
    return req;
};
$ea3d0e42a2be418c$var$http.get = function get(opts, cb) {
    var req = $ea3d0e42a2be418c$var$http.request(opts, cb);
    req.end();
    return req;
};
$ea3d0e42a2be418c$var$http.ClientRequest = $1r5QY;
$ea3d0e42a2be418c$var$http.IncomingMessage = $6dXuF.IncomingMessage;
$ea3d0e42a2be418c$var$http.Agent = function() {};
$ea3d0e42a2be418c$var$http.Agent.defaultMaxSockets = 4;
$ea3d0e42a2be418c$var$http.globalAgent = new $ea3d0e42a2be418c$var$http.Agent();
$ea3d0e42a2be418c$var$http.STATUS_CODES = $4rffA;
$ea3d0e42a2be418c$var$http.METHODS = [
    "CHECKOUT",
    "CONNECT",
    "COPY",
    "DELETE",
    "GET",
    "HEAD",
    "LOCK",
    "M-SEARCH",
    "MERGE",
    "MKACTIVITY",
    "MKCOL",
    "MOVE",
    "NOTIFY",
    "OPTIONS",
    "PATCH",
    "POST",
    "PROPFIND",
    "PROPPATCH",
    "PURGE",
    "PUT",
    "REPORT",
    "SEARCH",
    "SUBSCRIBE",
    "TRACE",
    "UNLOCK",
    "UNSUBSCRIBE"
];

});
parcelRegister("1r5QY", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $10bcda68fa6d9d94$require$Buffer = $6ZWSX.Buffer;

var $hPtJY = parcelRequire("hPtJY");

var $jjD4m = parcelRequire("jjD4m");

var $dlqwk = parcelRequire("dlqwk");

var $6dXuF = parcelRequire("6dXuF");

var $b6RFW = parcelRequire("b6RFW");
var $10bcda68fa6d9d94$var$IncomingMessage = $6dXuF.IncomingMessage;
var $10bcda68fa6d9d94$var$rStates = $6dXuF.readyStates;
function $10bcda68fa6d9d94$var$decideMode(preferBinary, useFetch) {
    if ($jjD4m.fetch && useFetch) return "fetch";
    else if ($jjD4m.mozchunkedarraybuffer) return "moz-chunked-arraybuffer";
    else if ($jjD4m.msstream) return "ms-stream";
    else if ($jjD4m.arraybuffer && preferBinary) return "arraybuffer";
    else return "text";
}
var $10bcda68fa6d9d94$var$ClientRequest = module.exports = function(opts) {
    var self = this;
    $b6RFW.Writable.call(self);
    self._opts = opts;
    self._body = [];
    self._headers = {};
    if (opts.auth) self.setHeader("Authorization", "Basic " + $10bcda68fa6d9d94$require$Buffer.from(opts.auth).toString("base64"));
    Object.keys(opts.headers).forEach(function(name) {
        self.setHeader(name, opts.headers[name]);
    });
    var preferBinary;
    var useFetch = true;
    if (opts.mode === "disable-fetch" || "requestTimeout" in opts && !$jjD4m.abortController) {
        // If the use of XHR should be preferred. Not typically needed.
        useFetch = false;
        preferBinary = true;
    } else if (opts.mode === "prefer-streaming") // If streaming is a high priority but binary compatibility and
    // the accuracy of the 'content-type' header aren't
    preferBinary = false;
    else if (opts.mode === "allow-wrong-content-type") // If streaming is more important than preserving the 'content-type' header
    preferBinary = !$jjD4m.overrideMimeType;
    else if (!opts.mode || opts.mode === "default" || opts.mode === "prefer-fast") // Use binary if text streaming may corrupt data or the content-type header, or for speed
    preferBinary = true;
    else throw new Error("Invalid value for opts.mode");
    self._mode = $10bcda68fa6d9d94$var$decideMode(preferBinary, useFetch);
    self._fetchTimer = null;
    self._socketTimeout = null;
    self._socketTimer = null;
    self.on("finish", function() {
        self._onFinish();
    });
};
$dlqwk($10bcda68fa6d9d94$var$ClientRequest, $b6RFW.Writable);
$10bcda68fa6d9d94$var$ClientRequest.prototype.setHeader = function(name, value) {
    var self = this;
    var lowerName = name.toLowerCase();
    // This check is not necessary, but it prevents warnings from browsers about setting unsafe
    // headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
    // http-browserify did it, so I will too.
    if ($10bcda68fa6d9d94$var$unsafeHeaders.indexOf(lowerName) !== -1) return;
    self._headers[lowerName] = {
        name: name,
        value: value
    };
};
$10bcda68fa6d9d94$var$ClientRequest.prototype.getHeader = function(name) {
    var header = this._headers[name.toLowerCase()];
    if (header) return header.value;
    return null;
};
$10bcda68fa6d9d94$var$ClientRequest.prototype.removeHeader = function(name) {
    var self = this;
    delete self._headers[name.toLowerCase()];
};
$10bcda68fa6d9d94$var$ClientRequest.prototype._onFinish = function() {
    var self = this;
    if (self._destroyed) return;
    var opts = self._opts;
    if ("timeout" in opts && opts.timeout !== 0) self.setTimeout(opts.timeout);
    var headersObj = self._headers;
    var body = null;
    if (opts.method !== "GET" && opts.method !== "HEAD") body = new Blob(self._body, {
        type: (headersObj["content-type"] || {}).value || ""
    });
    // create flattened list of headers
    var headersList = [];
    Object.keys(headersObj).forEach(function(keyName) {
        var name = headersObj[keyName].name;
        var value = headersObj[keyName].value;
        if (Array.isArray(value)) value.forEach(function(v) {
            headersList.push([
                name,
                v
            ]);
        });
        else headersList.push([
            name,
            value
        ]);
    });
    if (self._mode === "fetch") {
        var signal = null;
        if ($jjD4m.abortController) {
            var controller = new AbortController();
            signal = controller.signal;
            self._fetchAbortController = controller;
            if ("requestTimeout" in opts && opts.requestTimeout !== 0) self._fetchTimer = $parcel$global.setTimeout(function() {
                self.emit("requestTimeout");
                if (self._fetchAbortController) self._fetchAbortController.abort();
            }, opts.requestTimeout);
        }
        $parcel$global.fetch(self._opts.url, {
            method: self._opts.method,
            headers: headersList,
            body: body || undefined,
            mode: "cors",
            credentials: opts.withCredentials ? "include" : "same-origin",
            signal: signal
        }).then(function(response) {
            self._fetchResponse = response;
            self._resetTimers(false);
            self._connect();
        }, function(reason) {
            self._resetTimers(true);
            if (!self._destroyed) self.emit("error", reason);
        });
    } else {
        var xhr = self._xhr = new $parcel$global.XMLHttpRequest();
        try {
            xhr.open(self._opts.method, self._opts.url, true);
        } catch (err) {
            $hPtJY.nextTick(function() {
                self.emit("error", err);
            });
            return;
        }
        // Can't set responseType on really old browsers
        if ("responseType" in xhr) xhr.responseType = self._mode;
        if ("withCredentials" in xhr) xhr.withCredentials = !!opts.withCredentials;
        if (self._mode === "text" && "overrideMimeType" in xhr) xhr.overrideMimeType("text/plain; charset=x-user-defined");
        if ("requestTimeout" in opts) {
            xhr.timeout = opts.requestTimeout;
            xhr.ontimeout = function() {
                self.emit("requestTimeout");
            };
        }
        headersList.forEach(function(header) {
            xhr.setRequestHeader(header[0], header[1]);
        });
        self._response = null;
        xhr.onreadystatechange = function() {
            switch(xhr.readyState){
                case $10bcda68fa6d9d94$var$rStates.LOADING:
                case $10bcda68fa6d9d94$var$rStates.DONE:
                    self._onXHRProgress();
                    break;
            }
        };
        // Necessary for streaming in Firefox, since xhr.response is ONLY defined
        // in onprogress, not in onreadystatechange with xhr.readyState = 3
        if (self._mode === "moz-chunked-arraybuffer") xhr.onprogress = function() {
            self._onXHRProgress();
        };
        xhr.onerror = function() {
            if (self._destroyed) return;
            self._resetTimers(true);
            self.emit("error", new Error("XHR error"));
        };
        try {
            xhr.send(body);
        } catch (err) {
            $hPtJY.nextTick(function() {
                self.emit("error", err);
            });
            return;
        }
    }
};
/**
 * Checks if xhr.status is readable and non-zero, indicating no error.
 * Even though the spec says it should be available in readyState 3,
 * accessing it throws an exception in IE8
 */ function $10bcda68fa6d9d94$var$statusValid(xhr) {
    try {
        var status = xhr.status;
        return status !== null && status !== 0;
    } catch (e) {
        return false;
    }
}
$10bcda68fa6d9d94$var$ClientRequest.prototype._onXHRProgress = function() {
    var self = this;
    self._resetTimers(false);
    if (!$10bcda68fa6d9d94$var$statusValid(self._xhr) || self._destroyed) return;
    if (!self._response) self._connect();
    self._response._onXHRProgress(self._resetTimers.bind(self));
};
$10bcda68fa6d9d94$var$ClientRequest.prototype._connect = function() {
    var self = this;
    if (self._destroyed) return;
    self._response = new $10bcda68fa6d9d94$var$IncomingMessage(self._xhr, self._fetchResponse, self._mode, self._resetTimers.bind(self));
    self._response.on("error", function(err) {
        self.emit("error", err);
    });
    self.emit("response", self._response);
};
$10bcda68fa6d9d94$var$ClientRequest.prototype._write = function(chunk, encoding, cb) {
    var self = this;
    self._body.push(chunk);
    cb();
};
$10bcda68fa6d9d94$var$ClientRequest.prototype._resetTimers = function(done) {
    var self = this;
    $parcel$global.clearTimeout(self._socketTimer);
    self._socketTimer = null;
    if (done) {
        $parcel$global.clearTimeout(self._fetchTimer);
        self._fetchTimer = null;
    } else if (self._socketTimeout) self._socketTimer = $parcel$global.setTimeout(function() {
        self.emit("timeout");
    }, self._socketTimeout);
};
$10bcda68fa6d9d94$var$ClientRequest.prototype.abort = $10bcda68fa6d9d94$var$ClientRequest.prototype.destroy = function(err) {
    var self = this;
    self._destroyed = true;
    self._resetTimers(true);
    if (self._response) self._response._destroyed = true;
    if (self._xhr) self._xhr.abort();
    else if (self._fetchAbortController) self._fetchAbortController.abort();
    if (err) self.emit("error", err);
};
$10bcda68fa6d9d94$var$ClientRequest.prototype.end = function(data, encoding, cb) {
    var self = this;
    if (typeof data === "function") {
        cb = data;
        data = undefined;
    }
    $b6RFW.Writable.prototype.end.call(self, data, encoding, cb);
};
$10bcda68fa6d9d94$var$ClientRequest.prototype.setTimeout = function(timeout, cb) {
    var self = this;
    if (cb) self.once("timeout", cb);
    self._socketTimeout = timeout;
    self._resetTimers(false);
};
$10bcda68fa6d9d94$var$ClientRequest.prototype.flushHeaders = function() {};
$10bcda68fa6d9d94$var$ClientRequest.prototype.setNoDelay = function() {};
$10bcda68fa6d9d94$var$ClientRequest.prototype.setSocketKeepAlive = function() {};
// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
var $10bcda68fa6d9d94$var$unsafeHeaders = [
    "accept-charset",
    "accept-encoding",
    "access-control-request-headers",
    "access-control-request-method",
    "connection",
    "content-length",
    "cookie",
    "cookie2",
    "date",
    "dnt",
    "expect",
    "host",
    "keep-alive",
    "origin",
    "referer",
    "te",
    "trailer",
    "transfer-encoding",
    "upgrade",
    "via"
];

});
parcelRegister("jjD4m", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $e0fe19014972c28c$export$e7aa7bc5c1b3cfb3, (v) => $e0fe19014972c28c$export$e7aa7bc5c1b3cfb3 = v);
$parcel$export(module.exports, "writableStream", () => $e0fe19014972c28c$export$37489d82087dc5d1, (v) => $e0fe19014972c28c$export$37489d82087dc5d1 = v);
$parcel$export(module.exports, "abortController", () => $e0fe19014972c28c$export$f137bf8a46425a6f, (v) => $e0fe19014972c28c$export$f137bf8a46425a6f = v);
$parcel$export(module.exports, "arraybuffer", () => $e0fe19014972c28c$export$724c4efdc2b90612, (v) => $e0fe19014972c28c$export$724c4efdc2b90612 = v);
$parcel$export(module.exports, "msstream", () => $e0fe19014972c28c$export$a9aa1e45c4448986, (v) => $e0fe19014972c28c$export$a9aa1e45c4448986 = v);
$parcel$export(module.exports, "mozchunkedarraybuffer", () => $e0fe19014972c28c$export$4c3c163e941f6ba3, (v) => $e0fe19014972c28c$export$4c3c163e941f6ba3 = v);
$parcel$export(module.exports, "overrideMimeType", () => $e0fe19014972c28c$export$8f1269d6d73f87ef, (v) => $e0fe19014972c28c$export$8f1269d6d73f87ef = v);
var $e0fe19014972c28c$export$e7aa7bc5c1b3cfb3;
var $e0fe19014972c28c$export$37489d82087dc5d1;
var $e0fe19014972c28c$export$f137bf8a46425a6f;
// If fetch is supported, then arraybuffer will be supported too. Skip calling
// checkTypeSupport(), since that calls getXHR().
var $e0fe19014972c28c$export$724c4efdc2b90612;
// These next two tests unavoidably show warnings in Chrome. Since fetch will always
// be used if it's available, just return false for these to avoid the warnings.
var $e0fe19014972c28c$export$a9aa1e45c4448986;
var $e0fe19014972c28c$export$4c3c163e941f6ba3;
// If fetch is supported, then overrideMimeType will be supported too. Skip calling
// getXHR().
var $e0fe19014972c28c$export$8f1269d6d73f87ef;
$e0fe19014972c28c$export$e7aa7bc5c1b3cfb3 = $e0fe19014972c28c$var$isFunction($parcel$global.fetch) && $e0fe19014972c28c$var$isFunction($parcel$global.ReadableStream);
$e0fe19014972c28c$export$37489d82087dc5d1 = $e0fe19014972c28c$var$isFunction($parcel$global.WritableStream);
$e0fe19014972c28c$export$f137bf8a46425a6f = $e0fe19014972c28c$var$isFunction($parcel$global.AbortController);
// The xhr request to example.com may violate some restrictive CSP configurations,
// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
// and assume support for certain features below.
var $e0fe19014972c28c$var$xhr;
function $e0fe19014972c28c$var$getXHR() {
    // Cache the xhr value
    if ($e0fe19014972c28c$var$xhr !== undefined) return $e0fe19014972c28c$var$xhr;
    if ($parcel$global.XMLHttpRequest) {
        $e0fe19014972c28c$var$xhr = new $parcel$global.XMLHttpRequest();
        // If XDomainRequest is available (ie only, where xhr might not work
        // cross domain), use the page location. Otherwise use example.com
        // Note: this doesn't actually make an http request.
        try {
            $e0fe19014972c28c$var$xhr.open("GET", $parcel$global.XDomainRequest ? "/" : "https://example.com");
        } catch (e) {
            $e0fe19014972c28c$var$xhr = null;
        }
    } else // Service workers don't have XHR
    $e0fe19014972c28c$var$xhr = null;
    return $e0fe19014972c28c$var$xhr;
}
function $e0fe19014972c28c$var$checkTypeSupport(type) {
    var xhr = $e0fe19014972c28c$var$getXHR();
    if (!xhr) return false;
    try {
        xhr.responseType = type;
        return xhr.responseType === type;
    } catch (e) {}
    return false;
}
$e0fe19014972c28c$export$724c4efdc2b90612 = $e0fe19014972c28c$export$e7aa7bc5c1b3cfb3 || $e0fe19014972c28c$var$checkTypeSupport("arraybuffer");
$e0fe19014972c28c$export$a9aa1e45c4448986 = !$e0fe19014972c28c$export$e7aa7bc5c1b3cfb3 && $e0fe19014972c28c$var$checkTypeSupport("ms-stream");
$e0fe19014972c28c$export$4c3c163e941f6ba3 = !$e0fe19014972c28c$export$e7aa7bc5c1b3cfb3 && $e0fe19014972c28c$var$checkTypeSupport("moz-chunked-arraybuffer");
$e0fe19014972c28c$export$8f1269d6d73f87ef = $e0fe19014972c28c$export$e7aa7bc5c1b3cfb3 || ($e0fe19014972c28c$var$getXHR() ? $e0fe19014972c28c$var$isFunction($e0fe19014972c28c$var$getXHR().overrideMimeType) : false);
function $e0fe19014972c28c$var$isFunction(value) {
    return typeof value === "function";
}
$e0fe19014972c28c$var$xhr = null // Help gc
;

});

parcelRegister("6dXuF", function(module, exports) {

$parcel$export(module.exports, "readyStates", () => $48821b31b3e528df$export$8e4da25483e314e6, (v) => $48821b31b3e528df$export$8e4da25483e314e6 = v);
$parcel$export(module.exports, "IncomingMessage", () => $48821b31b3e528df$export$9d4333345ffa4fd6, (v) => $48821b31b3e528df$export$9d4333345ffa4fd6 = v);
var $48821b31b3e528df$export$8e4da25483e314e6;
var $48821b31b3e528df$export$9d4333345ffa4fd6;

var $hPtJY = parcelRequire("hPtJY");

var $6ZWSX = parcelRequire("6ZWSX");
var $48821b31b3e528df$require$Buffer = $6ZWSX.Buffer;

var $jjD4m = parcelRequire("jjD4m");

var $dlqwk = parcelRequire("dlqwk");

var $b6RFW = parcelRequire("b6RFW");
var $48821b31b3e528df$var$rStates = $48821b31b3e528df$export$8e4da25483e314e6 = {
    UNSENT: 0,
    OPENED: 1,
    HEADERS_RECEIVED: 2,
    LOADING: 3,
    DONE: 4
};
var $48821b31b3e528df$var$IncomingMessage = $48821b31b3e528df$export$9d4333345ffa4fd6 = function(xhr, response, mode, resetTimers) {
    var self = this;
    $b6RFW.Readable.call(self);
    self._mode = mode;
    self.headers = {};
    self.rawHeaders = [];
    self.trailers = {};
    self.rawTrailers = [];
    // Fake the 'close' event, but only once 'end' fires
    self.on("end", function() {
        // The nextTick is necessary to prevent the 'request' module from causing an infinite loop
        $hPtJY.nextTick(function() {
            self.emit("close");
        });
    });
    if (mode === "fetch") {
        self._fetchResponse = response;
        self.url = response.url;
        self.statusCode = response.status;
        self.statusMessage = response.statusText;
        response.headers.forEach(function(header, key) {
            self.headers[key.toLowerCase()] = header;
            self.rawHeaders.push(key, header);
        });
        if ($jjD4m.writableStream) {
            var writable = new WritableStream({
                write: function(chunk) {
                    resetTimers(false);
                    return new Promise(function(resolve, reject) {
                        if (self._destroyed) reject();
                        else if (self.push($48821b31b3e528df$require$Buffer.from(chunk))) resolve();
                        else self._resumeFetch = resolve;
                    });
                },
                close: function() {
                    resetTimers(true);
                    if (!self._destroyed) self.push(null);
                },
                abort: function(err) {
                    resetTimers(true);
                    if (!self._destroyed) self.emit("error", err);
                }
            });
            try {
                response.body.pipeTo(writable).catch(function(err) {
                    resetTimers(true);
                    if (!self._destroyed) self.emit("error", err);
                });
                return;
            } catch (e) {} // pipeTo method isn't defined. Can't find a better way to feature test this
        }
        // fallback for when writableStream or pipeTo aren't available
        var reader = response.body.getReader();
        function read() {
            reader.read().then(function(result) {
                if (self._destroyed) return;
                resetTimers(result.done);
                if (result.done) {
                    self.push(null);
                    return;
                }
                self.push($48821b31b3e528df$require$Buffer.from(result.value));
                read();
            }).catch(function(err) {
                resetTimers(true);
                if (!self._destroyed) self.emit("error", err);
            });
        }
        read();
    } else {
        self._xhr = xhr;
        self._pos = 0;
        self.url = xhr.responseURL;
        self.statusCode = xhr.status;
        self.statusMessage = xhr.statusText;
        var headers = xhr.getAllResponseHeaders().split(/\r?\n/);
        headers.forEach(function(header) {
            var matches = header.match(/^([^:]+):\s*(.*)/);
            if (matches) {
                var key = matches[1].toLowerCase();
                if (key === "set-cookie") {
                    if (self.headers[key] === undefined) self.headers[key] = [];
                    self.headers[key].push(matches[2]);
                } else if (self.headers[key] !== undefined) self.headers[key] += ", " + matches[2];
                else self.headers[key] = matches[2];
                self.rawHeaders.push(matches[1], matches[2]);
            }
        });
        self._charset = "x-user-defined";
        if (!$jjD4m.overrideMimeType) {
            var mimeType = self.rawHeaders["mime-type"];
            if (mimeType) {
                var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/);
                if (charsetMatch) self._charset = charsetMatch[1].toLowerCase();
            }
            if (!self._charset) self._charset = "utf-8" // best guess
            ;
        }
    }
};
$dlqwk($48821b31b3e528df$var$IncomingMessage, $b6RFW.Readable);
$48821b31b3e528df$var$IncomingMessage.prototype._read = function() {
    var self = this;
    var resolve = self._resumeFetch;
    if (resolve) {
        self._resumeFetch = null;
        resolve();
    }
};
$48821b31b3e528df$var$IncomingMessage.prototype._onXHRProgress = function(resetTimers) {
    var self = this;
    var xhr = self._xhr;
    var response = null;
    switch(self._mode){
        case "text":
            response = xhr.responseText;
            if (response.length > self._pos) {
                var newData = response.substr(self._pos);
                if (self._charset === "x-user-defined") {
                    var buffer = $48821b31b3e528df$require$Buffer.alloc(newData.length);
                    for(var i = 0; i < newData.length; i++)buffer[i] = newData.charCodeAt(i) & 0xff;
                    self.push(buffer);
                } else self.push(newData, self._charset);
                self._pos = response.length;
            }
            break;
        case "arraybuffer":
            if (xhr.readyState !== $48821b31b3e528df$var$rStates.DONE || !xhr.response) break;
            response = xhr.response;
            self.push($48821b31b3e528df$require$Buffer.from(new Uint8Array(response)));
            break;
        case "moz-chunked-arraybuffer":
            response = xhr.response;
            if (xhr.readyState !== $48821b31b3e528df$var$rStates.LOADING || !response) break;
            self.push($48821b31b3e528df$require$Buffer.from(new Uint8Array(response)));
            break;
        case "ms-stream":
            response = xhr.response;
            if (xhr.readyState !== $48821b31b3e528df$var$rStates.LOADING) break;
            var reader = new $parcel$global.MSStreamReader();
            reader.onprogress = function() {
                if (reader.result.byteLength > self._pos) {
                    self.push($48821b31b3e528df$require$Buffer.from(new Uint8Array(reader.result.slice(self._pos))));
                    self._pos = reader.result.byteLength;
                }
            };
            reader.onload = function() {
                resetTimers(true);
                self.push(null);
            };
            // reader.onerror = ??? // TODO: this
            reader.readAsArrayBuffer(response);
            break;
    }
    // The ms-stream case handles end separately in reader.onload()
    if (self._xhr.readyState === $48821b31b3e528df$var$rStates.DONE && self._mode !== "ms-stream") {
        resetTimers(true);
        self.push(null);
    }
};

});


parcelRegister("h0kNM", function(module, exports) {
module.exports = $c61292941889f8f2$var$extend;
var $c61292941889f8f2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $c61292941889f8f2$var$extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if ($c61292941889f8f2$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

});

parcelRegister("4rffA", function(module, exports) {
module.exports = {
    "100": "Continue",
    "101": "Switching Protocols",
    "102": "Processing",
    "200": "OK",
    "201": "Created",
    "202": "Accepted",
    "203": "Non-Authoritative Information",
    "204": "No Content",
    "205": "Reset Content",
    "206": "Partial Content",
    "207": "Multi-Status",
    "208": "Already Reported",
    "226": "IM Used",
    "300": "Multiple Choices",
    "301": "Moved Permanently",
    "302": "Found",
    "303": "See Other",
    "304": "Not Modified",
    "305": "Use Proxy",
    "307": "Temporary Redirect",
    "308": "Permanent Redirect",
    "400": "Bad Request",
    "401": "Unauthorized",
    "402": "Payment Required",
    "403": "Forbidden",
    "404": "Not Found",
    "405": "Method Not Allowed",
    "406": "Not Acceptable",
    "407": "Proxy Authentication Required",
    "408": "Request Timeout",
    "409": "Conflict",
    "410": "Gone",
    "411": "Length Required",
    "412": "Precondition Failed",
    "413": "Payload Too Large",
    "414": "URI Too Long",
    "415": "Unsupported Media Type",
    "416": "Range Not Satisfiable",
    "417": "Expectation Failed",
    "418": "I'm a teapot",
    "421": "Misdirected Request",
    "422": "Unprocessable Entity",
    "423": "Locked",
    "424": "Failed Dependency",
    "425": "Unordered Collection",
    "426": "Upgrade Required",
    "428": "Precondition Required",
    "429": "Too Many Requests",
    "431": "Request Header Fields Too Large",
    "451": "Unavailable For Legal Reasons",
    "500": "Internal Server Error",
    "501": "Not Implemented",
    "502": "Bad Gateway",
    "503": "Service Unavailable",
    "504": "Gateway Timeout",
    "505": "HTTP Version Not Supported",
    "506": "Variant Also Negotiates",
    "507": "Insufficient Storage",
    "508": "Loop Detected",
    "509": "Bandwidth Limit Exceeded",
    "510": "Not Extended",
    "511": "Network Authentication Required"
};

});


parcelRegister("cgLmW", function(module, exports) {

var $k6Qs9 = parcelRequire("k6Qs9");

var $biuEp = parcelRequire("biuEp");
var $8eebb92ac53798d1$var$https = module.exports;
for(var $8eebb92ac53798d1$var$key in $k6Qs9)if ($k6Qs9.hasOwnProperty($8eebb92ac53798d1$var$key)) $8eebb92ac53798d1$var$https[$8eebb92ac53798d1$var$key] = $k6Qs9[$8eebb92ac53798d1$var$key];
$8eebb92ac53798d1$var$https.request = function(params, cb) {
    params = $8eebb92ac53798d1$var$validateParams(params);
    return $k6Qs9.request.call(this, params, cb);
};
$8eebb92ac53798d1$var$https.get = function(params, cb) {
    params = $8eebb92ac53798d1$var$validateParams(params);
    return $k6Qs9.get.call(this, params, cb);
};
function $8eebb92ac53798d1$var$validateParams(params) {
    if (typeof params === "string") params = $biuEp.parse(params);
    if (!params.protocol) params.protocol = "https:";
    if (params.protocol !== "https:") throw new Error('Protocol "' + params.protocol + '" not supported. Expected "https:"');
    return params;
}

});


parcelRegister("6RLWI", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $4ffce261be62d3db$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimpleWallet = void 0;

var $eHb7V = parcelRequire("eHb7V");
var $bZmTT = parcelRequire("bZmTT");
/** class simply implements Wallet interface */ class $4ffce261be62d3db$var$SimpleWallet {
    constructor(){
        this.keys = [];
    }
    get list() {
        return this.keys.map((k)=>{
            return {
                address: k.address,
                sign (msgHash) {
                    return Promise.resolve($bZmTT.secp256k1.sign(msgHash, k.privateKey));
                }
            };
        });
    }
    /**
     * import private key
     * @param privateKey hex string presented private key
     * @returns address derived from the private key
     */ import(privateKey) {
        if (privateKey.startsWith("0x")) privateKey = privateKey.slice(2);
        if (!/^[0-9a-f]{64}$/i.test(privateKey)) throw new Error("invalid private key");
        const buf = $4ffce261be62d3db$require$Buffer.from(privateKey, "hex");
        const addr = $eHb7V.address.fromPublicKey($bZmTT.secp256k1.derivePublicKey(buf));
        this.keys.push({
            address: addr,
            privateKey: buf
        });
        return addr;
    }
    /**
     * remove corresponding key by given address
     * @param addr address
     * @returns true if found and removed, false otherwise
     */ remove(addr) {
        const i = this.keys.findIndex((k)=>k.address === addr.toLowerCase());
        if (i >= 0) {
            this.keys.splice(i, 1);
            return true;
        }
        return false;
    }
}
module.exports.SimpleWallet = $4ffce261be62d3db$var$SimpleWallet;

});

parcelRegister("9OCA8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $21QB3 = parcelRequire("21QB3");
// Unknown Error
module.exports.UNKNOWN_ERROR = "UNKNOWN_ERROR";
// Not implemented
module.exports.NOT_IMPLEMENTED = "NOT_IMPLEMENTED";
// Missing new operator to an object
//  - name: The name of the class
module.exports.MISSING_NEW = "MISSING_NEW";
// Call exception
//  - transaction: the transaction
//  - address?: the contract address
//  - args?: The arguments passed into the function
//  - method?: The Solidity method signature
//  - errorSignature?: The EIP848 error signature
//  - errorArgs?: The EIP848 error parameters
//  - reason: The reason (only for EIP848 "Error(string)")
module.exports.CALL_EXCEPTION = "CALL_EXCEPTION";
// Invalid argument (e.g. value is incompatible with type) to a function:
//   - argument: The argument name that was invalid
//   - value: The value of the argument
module.exports.INVALID_ARGUMENT = "INVALID_ARGUMENT";
// Missing argument to a function:
//   - count: The number of arguments received
//   - expectedCount: The number of arguments expected
module.exports.MISSING_ARGUMENT = "MISSING_ARGUMENT";
// Too many arguments
//   - count: The number of arguments received
//   - expectedCount: The number of arguments expected
module.exports.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT";
// Numeric Fault
//   - operation: the operation being executed
//   - fault: the reason this faulted
module.exports.NUMERIC_FAULT = "NUMERIC_FAULT";
// Insufficien funds (< value + gasLimit * gasPrice)
//   - transaction: the transaction attempted
module.exports.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS";
// Nonce has already been used
//   - transaction: the transaction attempted
module.exports.NONCE_EXPIRED = "NONCE_EXPIRED";
// The replacement fee for the transaction is too low
//   - transaction: the transaction attempted
module.exports.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED";
// Unsupported operation
//   - operation
module.exports.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION";
var $7256b61b9c690644$var$_permanentCensorErrors = false;
var $7256b61b9c690644$var$_censorErrors = false;
// @TODO: Enum
function $7256b61b9c690644$var$throwError(message, code, params) {
    if ($7256b61b9c690644$var$_censorErrors) throw new Error("unknown error");
    if (!code) code = module.exports.UNKNOWN_ERROR;
    if (!params) params = {};
    var messageDetails = [];
    Object.keys(params).forEach(function(key) {
        try {
            messageDetails.push(key + "=" + JSON.stringify(params[key]));
        } catch (error) {
            messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
        }
    });
    messageDetails.push("version=" + $21QB3.version);
    var reason = message;
    if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
    // @TODO: Any??
    var error = new Error(message);
    error.reason = reason;
    error.code = code;
    Object.keys(params).forEach(function(key) {
        error[key] = params[key];
    });
    throw error;
}
module.exports.throwError = $7256b61b9c690644$var$throwError;
function $7256b61b9c690644$var$checkNew(self, kind) {
    if (!(self instanceof kind)) $7256b61b9c690644$var$throwError("missing new", module.exports.MISSING_NEW, {
        name: kind.name
    });
}
module.exports.checkNew = $7256b61b9c690644$var$checkNew;
function $7256b61b9c690644$var$checkArgumentCount(count, expectedCount, suffix) {
    if (!suffix) suffix = "";
    if (count < expectedCount) $7256b61b9c690644$var$throwError("missing argument" + suffix, module.exports.MISSING_ARGUMENT, {
        count: count,
        expectedCount: expectedCount
    });
    if (count > expectedCount) $7256b61b9c690644$var$throwError("too many arguments" + suffix, module.exports.UNEXPECTED_ARGUMENT, {
        count: count,
        expectedCount: expectedCount
    });
}
module.exports.checkArgumentCount = $7256b61b9c690644$var$checkArgumentCount;
function $7256b61b9c690644$var$setCensorship(censorship, permanent) {
    if ($7256b61b9c690644$var$_permanentCensorErrors) $7256b61b9c690644$var$throwError("error censorship permanent", module.exports.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
    });
    $7256b61b9c690644$var$_censorErrors = !!censorship;
    $7256b61b9c690644$var$_permanentCensorErrors = !!permanent;
}
module.exports.setCensorship = $7256b61b9c690644$var$setCensorship;
function $7256b61b9c690644$var$checkNormalize() {
    try {
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach(function(form) {
            try {
                "test".normalize(form);
            } catch (error) {
                throw new Error("missing " + form);
            }
        });
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        $7256b61b9c690644$var$throwError("platform missing String.prototype.normalize", module.exports.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: error.message
        });
    }
}
module.exports.checkNormalize = $7256b61b9c690644$var$checkNormalize;
var $7256b61b9c690644$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warn: 3,
    error: 4,
    off: 5
};
var $7256b61b9c690644$var$LogLevel = $7256b61b9c690644$var$LogLevels["default"];
function $7256b61b9c690644$var$setLogLevel(logLevel) {
    var level = $7256b61b9c690644$var$LogLevels[logLevel];
    if (level == null) {
        $7256b61b9c690644$var$warn("invliad log level - " + logLevel);
        return;
    }
    $7256b61b9c690644$var$LogLevel = level;
}
module.exports.setLogLevel = $7256b61b9c690644$var$setLogLevel;
function $7256b61b9c690644$var$log(logLevel, args) {
    if ($7256b61b9c690644$var$LogLevel > $7256b61b9c690644$var$LogLevels[logLevel]) return;
    console.log.apply(console, args);
}
function $7256b61b9c690644$var$warn() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    $7256b61b9c690644$var$log("warn", args);
}
module.exports.warn = $7256b61b9c690644$var$warn;
function $7256b61b9c690644$var$info() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    $7256b61b9c690644$var$log("info", args);
}
module.exports.info = $7256b61b9c690644$var$info;

});
parcelRegister("21QB3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = "4.0.27-5";

});


parcelRegister("lkFCe", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wNAF = wNAF;
exports.pippenger = pippenger;
exports.precomputeMSMUnsafe = precomputeMSMUnsafe;
exports.validateBasic = validateBasic;

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");
const _0n = BigInt(0);
const _1n = BigInt(1);
function constTimeNegate(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
function validateW(W, bits) {
    if (!Number.isSafeInteger(W) || W <= 0 || W > bits) throw new Error("invalid window size, expected [1.." + bits + "], got W=" + W);
}
function calcWOpts(W, bits) {
    validateW(W, bits);
    const windows = Math.ceil(bits / W) + 1; // +1, because
    const windowSize = 2 ** (W - 1); // -1 because we skip zero
    return {
        windows: windows,
        windowSize: windowSize
    };
}
function validateMSMPoints(points, c) {
    if (!Array.isArray(points)) throw new Error("array expected");
    points.forEach((p, i)=>{
        if (!(p instanceof c)) throw new Error("invalid point at index " + i);
    });
}
function validateMSMScalars(scalars, field) {
    if (!Array.isArray(scalars)) throw new Error("array of scalars expected");
    scalars.forEach((s, i)=>{
        if (!field.isValid(s)) throw new Error("invalid scalar at index " + i);
    });
}
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes
const pointPrecomputes = new WeakMap();
const pointWindowSizes = new WeakMap(); // This allows use make points immutable (nothing changes inside)
function getW(P) {
    return pointWindowSizes.get(P) || 1;
}
/**
 * Elliptic curve multiplication of Point by scalar. Fragile.
 * Scalars should always be less than curve order: this should be checked inside of a curve itself.
 * Creates precomputation tables for fast multiplication:
 * - private scalar is split by fixed size windows of W bits
 * - every window point is collected from window's table & added to accumulator
 * - since windows are different, same point inside tables won't be accessed more than once per calc
 * - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
 * - +1 window is neccessary for wNAF
 * - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
 *
 * @todo Research returning 2d JS array of windows, instead of a single window.
 * This would allow windows to be in different memory locations
 */ function wNAF(c, bits) {
    return {
        constTimeNegate: constTimeNegate,
        hasPrecomputes (elm) {
            return getW(elm) !== 1;
        },
        // non-const time multiplication ladder
        unsafeLadder (elm, n, p = c.ZERO) {
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @param elm Point instance
         * @param W window size
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = calcWOpts(W, bits);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = calcWOpts(W, bits);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        /**
         * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @param acc accumulator point to add result of multiplication
         * @returns point
         */ wNAFUnsafe (W, precomputes, n, acc = c.ZERO) {
            const { windows, windowSize } = calcWOpts(W, bits);
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                if (n === _0n) break; // No need to go over empty scalar
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                if (wbits === 0) continue;
                let curr = precomputes[offset + Math.abs(wbits) - 1]; // -1 because we skip zero
                if (wbits < 0) curr = curr.negate();
                // NOTE: by re-using acc, we can save a lot of additions in case of MSM
                acc = acc.add(curr);
            }
            return acc;
        },
        getPrecomputes (W, P, transform) {
            // Calculate precomputes on a first run, reuse them after
            let comp = pointPrecomputes.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) pointPrecomputes.set(P, transform(comp));
            }
            return comp;
        },
        wNAFCached (P, n, transform) {
            const W = getW(P);
            return this.wNAF(W, this.getPrecomputes(W, P, transform), n);
        },
        wNAFCachedUnsafe (P, n, transform, prev) {
            const W = getW(P);
            if (W === 1) return this.unsafeLadder(P, n, prev); // For W=1 ladder is ~x2 faster
            return this.wNAFUnsafe(W, this.getPrecomputes(W, P, transform), n, prev);
        },
        // We calculate precomputes for elliptic curve point multiplication
        // using windowed method. This specifies window size and
        // stores precomputed values. Usually only base point would be precomputed.
        setWindowSize (P, W) {
            validateW(W, bits);
            pointWindowSizes.set(P, W);
            pointPrecomputes.delete(P);
        }
    };
}
/**
 * Pippenger algorithm for multi-scalar multiplication (MSM, Pa + Qb + Rc + ...).
 * 30x faster vs naive addition on L=4096, 10x faster with precomputes.
 * For N=254bit, L=1, it does: 1024 ADD + 254 DBL. For L=5: 1536 ADD + 254 DBL.
 * Algorithmically constant-time (for same L), even when 1 point + scalar, or when scalar = 0.
 * @param c Curve Point constructor
 * @param fieldN field over CURVE.N - important that it's not over CURVE.P
 * @param points array of L curve points
 * @param scalars array of L scalars (aka private keys / bigints)
 */ function pippenger(c, fieldN, points, scalars) {
    // If we split scalars by some window (let's say 8 bits), every chunk will only
    // take 256 buckets even if there are 4096 scalars, also re-uses double.
    // TODO:
    // - https://eprint.iacr.org/2024/750.pdf
    // - https://tches.iacr.org/index.php/TCHES/article/view/10287
    // 0 is accepted in scalars
    validateMSMPoints(points, c);
    validateMSMScalars(scalars, fieldN);
    if (points.length !== scalars.length) throw new Error("arrays of points and scalars must have equal length");
    const zero = c.ZERO;
    const wbits = (0, $esaJO.bitLen)(BigInt(points.length));
    const windowSize = wbits > 12 ? wbits - 3 : wbits > 4 ? wbits - 2 : wbits ? 2 : 1; // in bits
    const MASK = (1 << windowSize) - 1;
    const buckets = new Array(MASK + 1).fill(zero); // +1 for zero array
    const lastBits = Math.floor((fieldN.BITS - 1) / windowSize) * windowSize;
    let sum = zero;
    for(let i = lastBits; i >= 0; i -= windowSize){
        buckets.fill(zero);
        for(let j = 0; j < scalars.length; j++){
            const scalar = scalars[j];
            const wbits = Number(scalar >> BigInt(i) & BigInt(MASK));
            buckets[wbits] = buckets[wbits].add(points[j]);
        }
        let resI = zero; // not using this will do small speed-up, but will lose ct
        // Skip first bucket, because it is zero
        for(let j = buckets.length - 1, sumI = zero; j > 0; j--){
            sumI = sumI.add(buckets[j]);
            resI = resI.add(sumI);
        }
        sum = sum.add(resI);
        if (i !== 0) for(let j = 0; j < windowSize; j++)sum = sum.double();
    }
    return sum;
}
/**
 * Precomputed multi-scalar multiplication (MSM, Pa + Qb + Rc + ...).
 * @param c Curve Point constructor
 * @param fieldN field over CURVE.N - important that it's not over CURVE.P
 * @param points array of L curve points
 * @returns function which multiplies points with scaars
 */ function precomputeMSMUnsafe(c, fieldN, points, windowSize) {
    /**
     * Performance Analysis of Window-based Precomputation
     *
     * Base Case (256-bit scalar, 8-bit window):
     * - Standard precomputation requires:
     *   - 31 additions per scalar × 256 scalars = 7,936 ops
     *   - Plus 255 summary additions = 8,191 total ops
     *   Note: Summary additions can be optimized via accumulator
     *
     * Chunked Precomputation Analysis:
     * - Using 32 chunks requires:
     *   - 255 additions per chunk
     *   - 256 doublings
     *   - Total: (255 × 32) + 256 = 8,416 ops
     *
     * Memory Usage Comparison:
     * Window Size | Standard Points | Chunked Points
     * ------------|-----------------|---------------
     *     4-bit   |     520         |      15
     *     8-bit   |    4,224        |     255
     *    10-bit   |   13,824        |   1,023
     *    16-bit   |  557,056        |  65,535
     *
     * Key Advantages:
     * 1. Enables larger window sizes due to reduced memory overhead
     * 2. More efficient for smaller scalar counts:
     *    - 16 chunks: (16 × 255) + 256 = 4,336 ops
     *    - ~2x faster than standard 8,191 ops
     *
     * Limitations:
     * - Not suitable for plain precomputes (requires 256 constant doublings)
     * - Performance degrades with larger scalar counts:
     *   - Optimal for ~256 scalars
     *   - Less efficient for 4096+ scalars (Pippenger preferred)
     */ validateW(windowSize, fieldN.BITS);
    validateMSMPoints(points, c);
    const zero = c.ZERO;
    const tableSize = 2 ** windowSize - 1; // table size (without zero)
    const chunks = Math.ceil(fieldN.BITS / windowSize); // chunks of item
    const MASK = BigInt((1 << windowSize) - 1);
    const tables = points.map((p)=>{
        const res = [];
        for(let i = 0, acc = p; i < tableSize; i++){
            res.push(acc);
            acc = acc.add(p);
        }
        return res;
    });
    return (scalars)=>{
        validateMSMScalars(scalars, fieldN);
        if (scalars.length > points.length) throw new Error("array of scalars must be smaller than array of points");
        let res = zero;
        for(let i = 0; i < chunks; i++){
            // No need to double if accumulator is still zero.
            if (res !== zero) for(let j = 0; j < windowSize; j++)res = res.double();
            const shiftBy = BigInt(chunks * windowSize - (i + 1) * windowSize);
            for(let j = 0; j < scalars.length; j++){
                const n = scalars[j];
                const curr = Number(n >> shiftBy & MASK);
                if (!curr) continue; // skip zero scalars chunks
                res = res.add(tables[j][curr - 1]);
            }
        }
        return res;
    };
}
function validateBasic(curve) {
    (0, $2D9sF.validateField)(curve.Fp);
    (0, $esaJO.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $2D9sF.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

});
parcelRegister("2D9sF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isNegativeLE = void 0;
module.exports.mod = $1ea6901afdde618b$var$mod;
module.exports.pow = $1ea6901afdde618b$var$pow;
module.exports.pow2 = $1ea6901afdde618b$var$pow2;
module.exports.invert = $1ea6901afdde618b$var$invert;
module.exports.tonelliShanks = $1ea6901afdde618b$var$tonelliShanks;
module.exports.FpSqrt = $1ea6901afdde618b$var$FpSqrt;
module.exports.validateField = $1ea6901afdde618b$var$validateField;
module.exports.FpPow = $1ea6901afdde618b$var$FpPow;
module.exports.FpInvertBatch = $1ea6901afdde618b$var$FpInvertBatch;
module.exports.FpDiv = $1ea6901afdde618b$var$FpDiv;
module.exports.FpLegendre = $1ea6901afdde618b$var$FpLegendre;
module.exports.FpIsSquare = $1ea6901afdde618b$var$FpIsSquare;
module.exports.nLength = $1ea6901afdde618b$var$nLength;
module.exports.Field = $1ea6901afdde618b$var$Field;
module.exports.FpSqrtOdd = $1ea6901afdde618b$var$FpSqrtOdd;
module.exports.FpSqrtEven = $1ea6901afdde618b$var$FpSqrtEven;
module.exports.hashToPrivateScalar = $1ea6901afdde618b$var$hashToPrivateScalar;
module.exports.getFieldBytesLength = $1ea6901afdde618b$var$getFieldBytesLength;
module.exports.getMinHashLength = $1ea6901afdde618b$var$getMinHashLength;
module.exports.mapHashToField = $1ea6901afdde618b$var$mapHashToField;

var $esaJO = parcelRequire("esaJO");
// prettier-ignore
const $1ea6901afdde618b$var$_0n = BigInt(0), $1ea6901afdde618b$var$_1n = BigInt(1), $1ea6901afdde618b$var$_2n = /* @__PURE__ */ BigInt(2), $1ea6901afdde618b$var$_3n = /* @__PURE__ */ BigInt(3);
// prettier-ignore
const $1ea6901afdde618b$var$_4n = /* @__PURE__ */ BigInt(4), $1ea6901afdde618b$var$_5n = /* @__PURE__ */ BigInt(5), $1ea6901afdde618b$var$_8n = /* @__PURE__ */ BigInt(8);
// prettier-ignore
const $1ea6901afdde618b$var$_9n = /* @__PURE__ */ BigInt(9), $1ea6901afdde618b$var$_16n = /* @__PURE__ */ BigInt(16);
// Calculates a modulo b
function $1ea6901afdde618b$var$mod(a, b) {
    const result = a % b;
    return result >= $1ea6901afdde618b$var$_0n ? result : b + result;
}
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @todo use field version && remove
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ function $1ea6901afdde618b$var$pow(num, power, modulo) {
    if (power < $1ea6901afdde618b$var$_0n) throw new Error("invalid exponent, negatives unsupported");
    if (modulo <= $1ea6901afdde618b$var$_0n) throw new Error("invalid modulus");
    if (modulo === $1ea6901afdde618b$var$_1n) return $1ea6901afdde618b$var$_0n;
    let res = $1ea6901afdde618b$var$_1n;
    while(power > $1ea6901afdde618b$var$_0n){
        if (power & $1ea6901afdde618b$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $1ea6901afdde618b$var$_1n;
    }
    return res;
}
/** Does `x^(2^power)` mod p. `pow2(30, 4)` == `30^(2^4)` */ function $1ea6901afdde618b$var$pow2(x, power, modulo) {
    let res = x;
    while(power-- > $1ea6901afdde618b$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
/**
 * Inverses number over modulo.
 * Implemented using [Euclidean GCD](https://brilliant.org/wiki/extended-euclidean-algorithm/).
 */ function $1ea6901afdde618b$var$invert(number, modulo) {
    if (number === $1ea6901afdde618b$var$_0n) throw new Error("invert: expected non-zero number");
    if (modulo <= $1ea6901afdde618b$var$_0n) throw new Error("invert: expected positive modulus, got " + modulo);
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $1ea6901afdde618b$var$mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $1ea6901afdde618b$var$_0n, y = $1ea6901afdde618b$var$_1n, u = $1ea6901afdde618b$var$_1n, v = $1ea6901afdde618b$var$_0n;
    while(a !== $1ea6901afdde618b$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $1ea6901afdde618b$var$_1n) throw new Error("invert: does not exist");
    return $1ea6901afdde618b$var$mod(x, modulo);
}
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function $1ea6901afdde618b$var$tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $1ea6901afdde618b$var$_1n, S = 0; Q % $1ea6901afdde618b$var$_2n === $1ea6901afdde618b$var$_0n; Q /= $1ea6901afdde618b$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $1ea6901afdde618b$var$_2n; Z < P && $1ea6901afdde618b$var$pow(Z, legendreC, P) !== P - $1ea6901afdde618b$var$_1n; Z++){
        // Crash instead of infinity loop, we cannot reasonable count until P.
        if (Z > 1000) throw new Error("Cannot find square root: likely non-prime P");
    }
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $1ea6901afdde618b$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
/**
 * Square root for a finite field. It will try to check if optimizations are applicable and fall back to 4:
 *
 * 1. P ≡ 3 (mod 4)
 * 2. P ≡ 5 (mod 8)
 * 3. P ≡ 9 (mod 16)
 * 4. Tonelli-Shanks algorithm
 *
 * Different algorithms can give different roots, it is up to user to decide which one they want.
 * For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
 */ function $1ea6901afdde618b$var$FpSqrt(P) {
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $1ea6901afdde618b$var$_4n === $1ea6901afdde618b$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $1ea6901afdde618b$var$_8n === $1ea6901afdde618b$var$_5n) {
        const c1 = (P - $1ea6901afdde618b$var$_5n) / $1ea6901afdde618b$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $1ea6901afdde618b$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $1ea6901afdde618b$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $1ea6901afdde618b$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $1ea6901afdde618b$var$tonelliShanks(P);
}
// Little-endian check for first LE bit (last BE bit);
const $1ea6901afdde618b$var$isNegativeLE = (num, modulo)=>($1ea6901afdde618b$var$mod(num, modulo) & $1ea6901afdde618b$var$_1n) === $1ea6901afdde618b$var$_1n;
module.exports.isNegativeLE = $1ea6901afdde618b$var$isNegativeLE;
// prettier-ignore
const $1ea6901afdde618b$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $1ea6901afdde618b$var$validateField(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $1ea6901afdde618b$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $esaJO.validateObject)(field, opts);
}
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function $1ea6901afdde618b$var$FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $1ea6901afdde618b$var$_0n) throw new Error("invalid exponent, negatives unsupported");
    if (power === $1ea6901afdde618b$var$_0n) return f.ONE;
    if (power === $1ea6901afdde618b$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $1ea6901afdde618b$var$_0n){
        if (power & $1ea6901afdde618b$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $1ea6901afdde618b$var$_1n;
    }
    return p;
}
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */ function $1ea6901afdde618b$var$FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $1ea6901afdde618b$var$FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $1ea6901afdde618b$var$invert(rhs, f.ORDER) : f.inv(rhs));
}
/**
 * Legendre symbol.
 * * (a | p) ≡ 1    if a is a square (mod p), quadratic residue
 * * (a | p) ≡ -1   if a is not a square (mod p), quadratic non residue
 * * (a | p) ≡ 0    if a ≡ 0 (mod p)
 */ function $1ea6901afdde618b$var$FpLegendre(order) {
    const legendreConst = (order - $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n; // Integer arithmetic
    return (f, x)=>f.pow(x, legendreConst);
}
// This function returns True whenever the value x is a square in the field F.
function $1ea6901afdde618b$var$FpIsSquare(f) {
    const legendre = $1ea6901afdde618b$var$FpLegendre(f.ORDER);
    return (x)=>{
        const p = legendre(f, x);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
// CURVE.n lengths
function $1ea6901afdde618b$var$nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
/**
 * Initializes a finite field over prime.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * Fragile: always run a benchmark on a change.
 * Security note: operations don't check 'isValid' for all elements for performance reasons,
 * it is caller responsibility to check this.
 * This is low-level code, please make sure you know what you're doing.
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function $1ea6901afdde618b$var$Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $1ea6901afdde618b$var$_0n) throw new Error("invalid field: expected ORDER > 0, got " + ORDER);
    const { nBitLength: BITS, nByteLength: BYTES } = $1ea6901afdde618b$var$nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("invalid field: expected ORDER of <= 2048 bytes");
    let sqrtP; // cached sqrtP
    const f = Object.freeze({
        ORDER: ORDER,
        isLE: isLE,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $esaJO.bitMask)(BITS),
        ZERO: $1ea6901afdde618b$var$_0n,
        ONE: $1ea6901afdde618b$var$_1n,
        create: (num)=>$1ea6901afdde618b$var$mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error("invalid field element: expected bigint, got " + typeof num);
            return $1ea6901afdde618b$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $1ea6901afdde618b$var$_0n,
        isOdd: (num)=>(num & $1ea6901afdde618b$var$_1n) === $1ea6901afdde618b$var$_1n,
        neg: (num)=>$1ea6901afdde618b$var$mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$1ea6901afdde618b$var$mod(num * num, ORDER),
        add: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs * rhs, ORDER),
        pow: (num, power)=>$1ea6901afdde618b$var$FpPow(f, num, power),
        div: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs * $1ea6901afdde618b$var$invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$1ea6901afdde618b$var$invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>{
            if (!sqrtP) sqrtP = $1ea6901afdde618b$var$FpSqrt(ORDER);
            return sqrtP(f, n);
        }),
        invertBatch: (lst)=>$1ea6901afdde618b$var$FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $esaJO.numberToBytesLE)(num, BYTES) : (0, $esaJO.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error("Field.fromBytes: expected " + BYTES + " bytes, got " + bytes.length);
            return isLE ? (0, $esaJO.bytesToNumberLE)(bytes) : (0, $esaJO.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $1ea6901afdde618b$var$FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $1ea6901afdde618b$var$FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use `mapKeyToField` instead
 */ function $1ea6901afdde618b$var$hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, $esaJO.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $1ea6901afdde618b$var$nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error("hashToPrivateScalar: expected " + minLen + "-1024 bytes of input, got " + hashLen);
    const num = isLE ? (0, $esaJO.bytesToNumberLE)(hash) : (0, $esaJO.bytesToNumberBE)(hash);
    return $1ea6901afdde618b$var$mod(num, groupOrder - $1ea6901afdde618b$var$_1n) + $1ea6901afdde618b$var$_1n;
}
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function $1ea6901afdde618b$var$getMinHashLength(fieldOrder) {
    const length = $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function $1ea6901afdde618b$var$mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder);
    const minLen = $1ea6901afdde618b$var$getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error("expected " + minLen + "-1024 bytes of input, got " + len);
    const num = isLE ? (0, $esaJO.bytesToNumberLE)(key) : (0, $esaJO.bytesToNumberBE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $1ea6901afdde618b$var$mod(num, fieldOrder - $1ea6901afdde618b$var$_1n) + $1ea6901afdde618b$var$_1n;
    return isLE ? (0, $esaJO.numberToBytesLE)(reduced, fieldLen) : (0, $esaJO.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("esaJO", function(module, exports) {
"use strict";
/**
 * Hex, bytes and number utilities.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.notImplemented = module.exports.bitMask = void 0;
module.exports.isBytes = $a85c028f110aa8ce$var$isBytes;
module.exports.abytes = $a85c028f110aa8ce$var$abytes;
module.exports.abool = $a85c028f110aa8ce$var$abool;
module.exports.bytesToHex = $a85c028f110aa8ce$var$bytesToHex;
module.exports.numberToHexUnpadded = $a85c028f110aa8ce$var$numberToHexUnpadded;
module.exports.hexToNumber = $a85c028f110aa8ce$var$hexToNumber;
module.exports.hexToBytes = $a85c028f110aa8ce$var$hexToBytes;
module.exports.bytesToNumberBE = $a85c028f110aa8ce$var$bytesToNumberBE;
module.exports.bytesToNumberLE = $a85c028f110aa8ce$var$bytesToNumberLE;
module.exports.numberToBytesBE = $a85c028f110aa8ce$var$numberToBytesBE;
module.exports.numberToBytesLE = $a85c028f110aa8ce$var$numberToBytesLE;
module.exports.numberToVarBytesBE = $a85c028f110aa8ce$var$numberToVarBytesBE;
module.exports.ensureBytes = $a85c028f110aa8ce$var$ensureBytes;
module.exports.concatBytes = $a85c028f110aa8ce$var$concatBytes;
module.exports.equalBytes = $a85c028f110aa8ce$var$equalBytes;
module.exports.utf8ToBytes = $a85c028f110aa8ce$var$utf8ToBytes;
module.exports.inRange = $a85c028f110aa8ce$var$inRange;
module.exports.aInRange = $a85c028f110aa8ce$var$aInRange;
module.exports.bitLen = $a85c028f110aa8ce$var$bitLen;
module.exports.bitGet = $a85c028f110aa8ce$var$bitGet;
module.exports.bitSet = $a85c028f110aa8ce$var$bitSet;
module.exports.createHmacDrbg = $a85c028f110aa8ce$var$createHmacDrbg;
module.exports.validateObject = $a85c028f110aa8ce$var$validateObject;
module.exports.memoized = $a85c028f110aa8ce$var$memoized;
// 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $a85c028f110aa8ce$var$_0n = /* @__PURE__ */ BigInt(0);
const $a85c028f110aa8ce$var$_1n = /* @__PURE__ */ BigInt(1);
const $a85c028f110aa8ce$var$_2n = /* @__PURE__ */ BigInt(2);
function $a85c028f110aa8ce$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
function $a85c028f110aa8ce$var$abytes(item) {
    if (!$a85c028f110aa8ce$var$isBytes(item)) throw new Error("Uint8Array expected");
}
function $a85c028f110aa8ce$var$abool(title, value) {
    if (typeof value !== "boolean") throw new Error(title + " boolean expected, got " + value);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $a85c028f110aa8ce$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $a85c028f110aa8ce$var$bytesToHex(bytes) {
    $a85c028f110aa8ce$var$abytes(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $a85c028f110aa8ce$var$hexes[bytes[i]];
    return hex;
}
function $a85c028f110aa8ce$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? "0" + hex : hex;
}
function $a85c028f110aa8ce$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    return hex === "" ? $a85c028f110aa8ce$var$_0n : BigInt("0x" + hex); // Big Endian
}
// We use optimized technique to convert hex string to byte array
const $a85c028f110aa8ce$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $a85c028f110aa8ce$var$asciiToBase16(ch) {
    if (ch >= $a85c028f110aa8ce$var$asciis._0 && ch <= $a85c028f110aa8ce$var$asciis._9) return ch - $a85c028f110aa8ce$var$asciis._0; // '2' => 50-48
    if (ch >= $a85c028f110aa8ce$var$asciis.A && ch <= $a85c028f110aa8ce$var$asciis.F) return ch - ($a85c028f110aa8ce$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $a85c028f110aa8ce$var$asciis.a && ch <= $a85c028f110aa8ce$var$asciis.f) return ch - ($a85c028f110aa8ce$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $a85c028f110aa8ce$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $a85c028f110aa8ce$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $a85c028f110aa8ce$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
// BE: Big Endian, LE: Little Endian
function $a85c028f110aa8ce$var$bytesToNumberBE(bytes) {
    return $a85c028f110aa8ce$var$hexToNumber($a85c028f110aa8ce$var$bytesToHex(bytes));
}
function $a85c028f110aa8ce$var$bytesToNumberLE(bytes) {
    $a85c028f110aa8ce$var$abytes(bytes);
    return $a85c028f110aa8ce$var$hexToNumber($a85c028f110aa8ce$var$bytesToHex(Uint8Array.from(bytes).reverse()));
}
function $a85c028f110aa8ce$var$numberToBytesBE(n, len) {
    return $a85c028f110aa8ce$var$hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
function $a85c028f110aa8ce$var$numberToBytesLE(n, len) {
    return $a85c028f110aa8ce$var$numberToBytesBE(n, len).reverse();
}
// Unpadded, rarely used
function $a85c028f110aa8ce$var$numberToVarBytesBE(n) {
    return $a85c028f110aa8ce$var$hexToBytes($a85c028f110aa8ce$var$numberToHexUnpadded(n));
}
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $a85c028f110aa8ce$var$ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $a85c028f110aa8ce$var$hexToBytes(hex);
    } catch (e) {
        throw new Error(title + " must be hex string or Uint8Array, cause: " + e);
    }
    else if ($a85c028f110aa8ce$var$isBytes(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(title + " must be hex string or Uint8Array");
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(title + " of length " + expectedLength + " expected, got " + len);
    return res;
}
/**
 * Copies several Uint8Arrays into one.
 */ function $a85c028f110aa8ce$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $a85c028f110aa8ce$var$abytes(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
// Compares 2 u8a-s in kinda constant time
function $a85c028f110aa8ce$var$equalBytes(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $a85c028f110aa8ce$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error("string expected");
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
// Is positive bigint
const $a85c028f110aa8ce$var$isPosBig = (n)=>typeof n === "bigint" && $a85c028f110aa8ce$var$_0n <= n;
function $a85c028f110aa8ce$var$inRange(n, min, max) {
    return $a85c028f110aa8ce$var$isPosBig(n) && $a85c028f110aa8ce$var$isPosBig(min) && $a85c028f110aa8ce$var$isPosBig(max) && min <= n && n < max;
}
/**
 * Asserts min <= n < max. NOTE: It's < max and not <= max.
 * @example
 * aInRange('x', x, 1n, 256n); // would assume x is in (1n..255n)
 */ function $a85c028f110aa8ce$var$aInRange(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!$a85c028f110aa8ce$var$inRange(n, min, max)) throw new Error("expected valid " + title + ": " + min + " <= n < " + max + ", got " + n);
}
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function $a85c028f110aa8ce$var$bitLen(n) {
    let len;
    for(len = 0; n > $a85c028f110aa8ce$var$_0n; n >>= $a85c028f110aa8ce$var$_1n, len += 1);
    return len;
}
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $a85c028f110aa8ce$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $a85c028f110aa8ce$var$_1n;
}
/**
 * Sets single bit at position.
 */ function $a85c028f110aa8ce$var$bitSet(n, pos, value) {
    return n | (value ? $a85c028f110aa8ce$var$_1n : $a85c028f110aa8ce$var$_0n) << BigInt(pos);
}
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const $a85c028f110aa8ce$var$bitMask = (n)=>($a85c028f110aa8ce$var$_2n << BigInt(n - 1)) - $a85c028f110aa8ce$var$_1n;
module.exports.bitMask = $a85c028f110aa8ce$var$bitMask;
// DRBG
const $a85c028f110aa8ce$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $a85c028f110aa8ce$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $a85c028f110aa8ce$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $a85c028f110aa8ce$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $a85c028f110aa8ce$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $a85c028f110aa8ce$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($a85c028f110aa8ce$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($a85c028f110aa8ce$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $a85c028f110aa8ce$var$concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $a85c028f110aa8ce$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || $a85c028f110aa8ce$var$isBytes(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $a85c028f110aa8ce$var$validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $a85c028f110aa8ce$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error("invalid validator function");
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error("param " + String(fieldName) + " is invalid. Expected " + type + ", got " + val);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
// validate type tests
// const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
// const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
// // Should fail type-check
// const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
// const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
// const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
// const z4 = validateObject(o, { a: 'boolean', z: 'bug' });
/**
 * throws not implemented error
 */ const $a85c028f110aa8ce$var$notImplemented = ()=>{
    throw new Error("not implemented");
};
module.exports.notImplemented = $a85c028f110aa8ce$var$notImplemented;
/**
 * Memoizes (caches) computation result.
 * Uses WeakMap: the value is going auto-cleaned by GC after last reference is removed.
 */ function $a85c028f110aa8ce$var$memoized(fn) {
    const map = new WeakMap();
    return (arg, ...args)=>{
        const val = map.get(arg);
        if (val !== undefined) return val;
        const computed = fn(arg, ...args);
        map.set(arg, computed);
        return computed;
    };
}

});



parcelRegister("48YDT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HeartBeat = void 0;

var $7WQrb = parcelRequire("7WQrb");

var $7etJZ = parcelRequire("7etJZ");

var $aG48A = parcelRequire("aG48A");

var $5nu18 = parcelRequire("5nu18");

var $1nGZv = parcelRequire("1nGZv");
class $3046f31a17013644$var$HeartBeat extends $5nu18.IHeartBeat {
    constructor(opts){
        super(opts);
        this.events = new $7etJZ.EventEmitter();
        this.interval = $1nGZv.HEARTBEAT_INTERVAL;
        this.interval = (opts === null || opts === void 0 ? void 0 : opts.interval) || $1nGZv.HEARTBEAT_INTERVAL;
    }
    static init(opts) {
        return $7WQrb.__awaiter(this, void 0, void 0, function*() {
            const heartbeat = new $3046f31a17013644$var$HeartBeat(opts);
            yield heartbeat.init();
            return heartbeat;
        });
    }
    init() {
        return $7WQrb.__awaiter(this, void 0, void 0, function*() {
            yield this.initialize();
        });
    }
    stop() {
        clearInterval(this.intervalRef);
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    initialize() {
        return $7WQrb.__awaiter(this, void 0, void 0, function*() {
            this.intervalRef = setInterval(()=>this.pulse(), $aG48A.toMiliseconds(this.interval));
        });
    }
    pulse() {
        this.events.emit($1nGZv.HEARTBEAT_EVENTS.pulse);
    }
}
module.exports.HeartBeat = $3046f31a17013644$var$HeartBeat;

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
$parcel$export(module.exports, "__exportStar", () => $5c96a02c592fcff1$export$f33643c0debef087);
$parcel$export(module.exports, "__importDefault", () => $5c96a02c592fcff1$export$da59b14a69baef04);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $5c96a02c592fcff1$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("aG48A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("9EePZ")), module.exports);

$7WQrb.__exportStar((parcelRequire("iD73S")), module.exports);

$7WQrb.__exportStar((parcelRequire("dTXLC")), module.exports);

$7WQrb.__exportStar((parcelRequire("2MWZl")), module.exports);

});
parcelRegister("9EePZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("fUPCt")), module.exports);

$7WQrb.__exportStar((parcelRequire("3NXE9")), module.exports);

});
parcelRegister("fUPCt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.delay = void 0;
function $b964208cf0e7f449$var$delay(timeout) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(true);
        }, timeout);
    });
}
module.exports.delay = $b964208cf0e7f449$var$delay;

});

parcelRegister("3NXE9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromMiliseconds = module.exports.toMiliseconds = void 0;

var $2MWZl = parcelRequire("2MWZl");
function $2c543746c4e25c3a$var$toMiliseconds(seconds) {
    return seconds * $2MWZl.ONE_THOUSAND;
}
module.exports.toMiliseconds = $2c543746c4e25c3a$var$toMiliseconds;
function $2c543746c4e25c3a$var$fromMiliseconds(miliseconds) {
    return Math.floor(miliseconds / $2MWZl.ONE_THOUSAND);
}
module.exports.fromMiliseconds = $2c543746c4e25c3a$var$fromMiliseconds;

});
parcelRegister("2MWZl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("lfr75")), module.exports);

$7WQrb.__exportStar((parcelRequire("1qmVT")), module.exports);

});
parcelRegister("lfr75", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_THOUSAND = module.exports.ONE_HUNDRED = void 0;
module.exports.ONE_HUNDRED = 100;
module.exports.ONE_THOUSAND = 1000;

});

parcelRegister("1qmVT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_YEAR = module.exports.FOUR_WEEKS = module.exports.THREE_WEEKS = module.exports.TWO_WEEKS = module.exports.ONE_WEEK = module.exports.THIRTY_DAYS = module.exports.SEVEN_DAYS = module.exports.FIVE_DAYS = module.exports.THREE_DAYS = module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS = module.exports.TWELVE_HOURS = module.exports.SIX_HOURS = module.exports.THREE_HOURS = module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES = module.exports.THIRTY_MINUTES = module.exports.TEN_MINUTES = module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS = module.exports.THIRTY_SECONDS = module.exports.TEN_SECONDS = module.exports.FIVE_SECONDS = module.exports.ONE_SECOND = void 0;
module.exports.ONE_SECOND = 1;
module.exports.FIVE_SECONDS = 5;
module.exports.TEN_SECONDS = 10;
module.exports.THIRTY_SECONDS = 30;
module.exports.SIXTY_SECONDS = 60;
module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS;
module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE * 5;
module.exports.TEN_MINUTES = module.exports.ONE_MINUTE * 10;
module.exports.THIRTY_MINUTES = module.exports.ONE_MINUTE * 30;
module.exports.SIXTY_MINUTES = module.exports.ONE_MINUTE * 60;
module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES;
module.exports.THREE_HOURS = module.exports.ONE_HOUR * 3;
module.exports.SIX_HOURS = module.exports.ONE_HOUR * 6;
module.exports.TWELVE_HOURS = module.exports.ONE_HOUR * 12;
module.exports.TWENTY_FOUR_HOURS = module.exports.ONE_HOUR * 24;
module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS;
module.exports.THREE_DAYS = module.exports.ONE_DAY * 3;
module.exports.FIVE_DAYS = module.exports.ONE_DAY * 5;
module.exports.SEVEN_DAYS = module.exports.ONE_DAY * 7;
module.exports.THIRTY_DAYS = module.exports.ONE_DAY * 30;
module.exports.ONE_WEEK = module.exports.SEVEN_DAYS;
module.exports.TWO_WEEKS = module.exports.ONE_WEEK * 2;
module.exports.THREE_WEEKS = module.exports.ONE_WEEK * 3;
module.exports.FOUR_WEEKS = module.exports.ONE_WEEK * 4;
module.exports.ONE_YEAR = module.exports.ONE_DAY * 365;

});




parcelRegister("iD73S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Watch = void 0;
class $d90158c308dd266b$var$Watch {
    constructor(){
        this.timestamps = new Map();
    }
    start(label) {
        if (this.timestamps.has(label)) throw new Error(`Watch already started for label: ${label}`);
        this.timestamps.set(label, {
            started: Date.now()
        });
    }
    stop(label) {
        const timestamp = this.get(label);
        if (typeof timestamp.elapsed !== "undefined") throw new Error(`Watch already stopped for label: ${label}`);
        const elapsed = Date.now() - timestamp.started;
        this.timestamps.set(label, {
            started: timestamp.started,
            elapsed: elapsed
        });
    }
    get(label) {
        const timestamp = this.timestamps.get(label);
        if (typeof timestamp === "undefined") throw new Error(`No timestamp found for label: ${label}`);
        return timestamp;
    }
    elapsed(label) {
        const timestamp = this.get(label);
        const elapsed = timestamp.elapsed || Date.now() - timestamp.started;
        return elapsed;
    }
}
module.exports.Watch = $d90158c308dd266b$var$Watch;
module.exports.default = $d90158c308dd266b$var$Watch;

});

parcelRegister("dTXLC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("b5rRE")), module.exports);

});
parcelRegister("b5rRE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IWatch = void 0;
class $8125c6986ecca435$var$IWatch {
}
module.exports.IWatch = $8125c6986ecca435$var$IWatch;

});



parcelRegister("5nu18", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("bVfbs")), module.exports);

});
parcelRegister("bVfbs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IHeartBeat = void 0;
parcelRequire("37EVq");
var $3VSyk = parcelRequire("3VSyk");
class $8ae0cbc8ca291b66$var$IHeartBeat extends $3VSyk.IEvents {
    constructor(opts){
        super();
    }
}
module.exports.IHeartBeat = $8ae0cbc8ca291b66$var$IHeartBeat;

});
parcelRegister("37EVq", function(module, exports) {
$parcel$export(module.exports, "IEvents", () => (parcelRequire("3VSyk")).IEvents);
parcelRequire("3VSyk");

});
parcelRegister("3VSyk", function(module, exports) {

$parcel$export(module.exports, "IEvents", () => $2dd102fe42a3c147$export$ab429ec7e240e546);
class $2dd102fe42a3c147$export$ab429ec7e240e546 {
}

});




parcelRegister("1nGZv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("18uwn")), module.exports);

});
parcelRegister("18uwn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HEARTBEAT_EVENTS = module.exports.HEARTBEAT_INTERVAL = void 0;

var $aG48A = parcelRequire("aG48A");
module.exports.HEARTBEAT_INTERVAL = $aG48A.FIVE_SECONDS;
module.exports.HEARTBEAT_EVENTS = {
    pulse: "heartbeat_pulse"
};

});



parcelRegister("kgxrf", function(module, exports) {
"use strict";

var $7h4xj = parcelRequire("7h4xj");
module.exports = $03ceb28a240053b3$var$pino;
const $03ceb28a240053b3$var$_console = $03ceb28a240053b3$var$pfGlobalThisOrFallback().console || {};
const $03ceb28a240053b3$var$stdSerializers = {
    mapHttpRequest: $03ceb28a240053b3$var$mock,
    mapHttpResponse: $03ceb28a240053b3$var$mock,
    wrapRequestSerializer: $03ceb28a240053b3$var$passthrough,
    wrapResponseSerializer: $03ceb28a240053b3$var$passthrough,
    wrapErrorSerializer: $03ceb28a240053b3$var$passthrough,
    req: $03ceb28a240053b3$var$mock,
    res: $03ceb28a240053b3$var$mock,
    err: $03ceb28a240053b3$var$asErrValue
};
function $03ceb28a240053b3$var$shouldSerialize(serialize, serializers) {
    if (Array.isArray(serialize)) {
        const hasToFilter = serialize.filter(function(k) {
            return k !== "!stdSerializers.err";
        });
        return hasToFilter;
    } else if (serialize === true) return Object.keys(serializers);
    return false;
}
function $03ceb28a240053b3$var$pino(opts) {
    opts = opts || {};
    opts.browser = opts.browser || {};
    const transmit = opts.browser.transmit;
    if (transmit && typeof transmit.send !== "function") throw Error("pino: transmit option must have a send function");
    const proto = opts.browser.write || $03ceb28a240053b3$var$_console;
    if (opts.browser.write) opts.browser.asObject = true;
    const serializers = opts.serializers || {};
    const serialize = $03ceb28a240053b3$var$shouldSerialize(opts.browser.serialize, serializers);
    let stdErrSerialize = opts.browser.serialize;
    if (Array.isArray(opts.browser.serialize) && opts.browser.serialize.indexOf("!stdSerializers.err") > -1) stdErrSerialize = false;
    const levels = [
        "error",
        "fatal",
        "warn",
        "info",
        "debug",
        "trace"
    ];
    if (typeof proto === "function") proto.error = proto.fatal = proto.warn = proto.info = proto.debug = proto.trace = proto;
    if (opts.enabled === false) opts.level = "silent";
    const level = opts.level || "info";
    const logger = Object.create(proto);
    if (!logger.log) logger.log = $03ceb28a240053b3$var$noop;
    Object.defineProperty(logger, "levelVal", {
        get: getLevelVal
    });
    Object.defineProperty(logger, "level", {
        get: getLevel,
        set: setLevel
    });
    const setOpts = {
        transmit: transmit,
        serialize: serialize,
        asObject: opts.browser.asObject,
        levels: levels,
        timestamp: $03ceb28a240053b3$var$getTimeFunction(opts)
    };
    logger.levels = $03ceb28a240053b3$var$pino.levels;
    logger.level = level;
    logger.setMaxListeners = logger.getMaxListeners = logger.emit = logger.addListener = logger.on = logger.prependListener = logger.once = logger.prependOnceListener = logger.removeListener = logger.removeAllListeners = logger.listeners = logger.listenerCount = logger.eventNames = logger.write = logger.flush = $03ceb28a240053b3$var$noop;
    logger.serializers = serializers;
    logger._serialize = serialize;
    logger._stdErrSerialize = stdErrSerialize;
    logger.child = child;
    if (transmit) logger._logEvent = $03ceb28a240053b3$var$createLogEventShape();
    function getLevelVal() {
        return this.level === "silent" ? Infinity : this.levels.values[this.level];
    }
    function getLevel() {
        return this._level;
    }
    function setLevel(level) {
        if (level !== "silent" && !this.levels.values[level]) throw Error("unknown level " + level);
        this._level = level;
        $03ceb28a240053b3$var$set(setOpts, logger, "error", "log") // <-- must stay first
        ;
        $03ceb28a240053b3$var$set(setOpts, logger, "fatal", "error");
        $03ceb28a240053b3$var$set(setOpts, logger, "warn", "error");
        $03ceb28a240053b3$var$set(setOpts, logger, "info", "log");
        $03ceb28a240053b3$var$set(setOpts, logger, "debug", "log");
        $03ceb28a240053b3$var$set(setOpts, logger, "trace", "log");
    }
    function child(bindings, childOptions) {
        if (!bindings) throw new Error("missing bindings for child Pino");
        childOptions = childOptions || {};
        if (serialize && bindings.serializers) childOptions.serializers = bindings.serializers;
        const childOptionsSerializers = childOptions.serializers;
        if (serialize && childOptionsSerializers) {
            var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
            var childSerialize = opts.browser.serialize === true ? Object.keys(childSerializers) : serialize;
            delete bindings.serializers;
            $03ceb28a240053b3$var$applySerializers([
                bindings
            ], childSerialize, childSerializers, this._stdErrSerialize);
        }
        function Child(parent) {
            this._childLevel = (parent._childLevel | 0) + 1;
            this.error = $03ceb28a240053b3$var$bind(parent, bindings, "error");
            this.fatal = $03ceb28a240053b3$var$bind(parent, bindings, "fatal");
            this.warn = $03ceb28a240053b3$var$bind(parent, bindings, "warn");
            this.info = $03ceb28a240053b3$var$bind(parent, bindings, "info");
            this.debug = $03ceb28a240053b3$var$bind(parent, bindings, "debug");
            this.trace = $03ceb28a240053b3$var$bind(parent, bindings, "trace");
            if (childSerializers) {
                this.serializers = childSerializers;
                this._serialize = childSerialize;
            }
            if (transmit) this._logEvent = $03ceb28a240053b3$var$createLogEventShape([].concat(parent._logEvent.bindings, bindings));
        }
        Child.prototype = this;
        return new Child(this);
    }
    return logger;
}
$03ceb28a240053b3$var$pino.levels = {
    values: {
        fatal: 60,
        error: 50,
        warn: 40,
        info: 30,
        debug: 20,
        trace: 10
    },
    labels: {
        10: "trace",
        20: "debug",
        30: "info",
        40: "warn",
        50: "error",
        60: "fatal"
    }
};
$03ceb28a240053b3$var$pino.stdSerializers = $03ceb28a240053b3$var$stdSerializers;
$03ceb28a240053b3$var$pino.stdTimeFunctions = Object.assign({}, {
    nullTime: $03ceb28a240053b3$var$nullTime,
    epochTime: $03ceb28a240053b3$var$epochTime,
    unixTime: $03ceb28a240053b3$var$unixTime,
    isoTime: $03ceb28a240053b3$var$isoTime
});
function $03ceb28a240053b3$var$set(opts, logger, level, fallback) {
    const proto = Object.getPrototypeOf(logger);
    logger[level] = logger.levelVal > logger.levels.values[level] ? $03ceb28a240053b3$var$noop : proto[level] ? proto[level] : $03ceb28a240053b3$var$_console[level] || $03ceb28a240053b3$var$_console[fallback] || $03ceb28a240053b3$var$noop;
    $03ceb28a240053b3$var$wrap(opts, logger, level);
}
function $03ceb28a240053b3$var$wrap(opts, logger, level) {
    if (!opts.transmit && logger[level] === $03ceb28a240053b3$var$noop) return;
    logger[level] = function(write) {
        return function LOG() {
            const ts = opts.timestamp();
            const args = new Array(arguments.length);
            const proto = Object.getPrototypeOf && Object.getPrototypeOf(this) === $03ceb28a240053b3$var$_console ? $03ceb28a240053b3$var$_console : this;
            for(var i = 0; i < args.length; i++)args[i] = arguments[i];
            if (opts.serialize && !opts.asObject) $03ceb28a240053b3$var$applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
            if (opts.asObject) write.call(proto, $03ceb28a240053b3$var$asObject(this, level, args, ts));
            else write.apply(proto, args);
            if (opts.transmit) {
                const transmitLevel = opts.transmit.level || logger.level;
                const transmitValue = $03ceb28a240053b3$var$pino.levels.values[transmitLevel];
                const methodValue = $03ceb28a240053b3$var$pino.levels.values[level];
                if (methodValue < transmitValue) return;
                $03ceb28a240053b3$var$transmit(this, {
                    ts: ts,
                    methodLevel: level,
                    methodValue: methodValue,
                    transmitLevel: transmitLevel,
                    transmitValue: $03ceb28a240053b3$var$pino.levels.values[opts.transmit.level || logger.level],
                    send: opts.transmit.send,
                    val: logger.levelVal
                }, args);
            }
        };
    }(logger[level]);
}
function $03ceb28a240053b3$var$asObject(logger, level, args, ts) {
    if (logger._serialize) $03ceb28a240053b3$var$applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize);
    const argsCloned = args.slice();
    let msg = argsCloned[0];
    const o = {};
    if (ts) o.time = ts;
    o.level = $03ceb28a240053b3$var$pino.levels.values[level];
    let lvl = (logger._childLevel | 0) + 1;
    if (lvl < 1) lvl = 1;
    // deliberate, catching objects, arrays
    if (msg !== null && typeof msg === "object") {
        while(lvl-- && typeof argsCloned[0] === "object")Object.assign(o, argsCloned.shift());
        msg = argsCloned.length ? $7h4xj(argsCloned.shift(), argsCloned) : undefined;
    } else if (typeof msg === "string") msg = $7h4xj(argsCloned.shift(), argsCloned);
    if (msg !== undefined) o.msg = msg;
    return o;
}
function $03ceb28a240053b3$var$applySerializers(args, serialize, serializers, stdErrSerialize) {
    for(const i in args){
        if (stdErrSerialize && args[i] instanceof Error) args[i] = $03ceb28a240053b3$var$pino.stdSerializers.err(args[i]);
        else if (typeof args[i] === "object" && !Array.isArray(args[i])) {
            for(const k in args[i])if (serialize && serialize.indexOf(k) > -1 && k in serializers) args[i][k] = serializers[k](args[i][k]);
        }
    }
}
function $03ceb28a240053b3$var$bind(parent, bindings, level) {
    return function() {
        const args = new Array(1 + arguments.length);
        args[0] = bindings;
        for(var i = 1; i < args.length; i++)args[i] = arguments[i - 1];
        return parent[level].apply(this, args);
    };
}
function $03ceb28a240053b3$var$transmit(logger, opts, args) {
    const send = opts.send;
    const ts = opts.ts;
    const methodLevel = opts.methodLevel;
    const methodValue = opts.methodValue;
    const val = opts.val;
    const bindings = logger._logEvent.bindings;
    $03ceb28a240053b3$var$applySerializers(args, logger._serialize || Object.keys(logger.serializers), logger.serializers, logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize);
    logger._logEvent.ts = ts;
    logger._logEvent.messages = args.filter(function(arg) {
        // bindings can only be objects, so reference equality check via indexOf is fine
        return bindings.indexOf(arg) === -1;
    });
    logger._logEvent.level.label = methodLevel;
    logger._logEvent.level.value = methodValue;
    send(methodLevel, logger._logEvent, val);
    logger._logEvent = $03ceb28a240053b3$var$createLogEventShape(bindings);
}
function $03ceb28a240053b3$var$createLogEventShape(bindings) {
    return {
        ts: 0,
        messages: [],
        bindings: bindings || [],
        level: {
            label: "",
            value: 0
        }
    };
}
function $03ceb28a240053b3$var$asErrValue(err) {
    const obj = {
        type: err.constructor.name,
        msg: err.message,
        stack: err.stack
    };
    for(const key in err)if (obj[key] === undefined) obj[key] = err[key];
    return obj;
}
function $03ceb28a240053b3$var$getTimeFunction(opts) {
    if (typeof opts.timestamp === "function") return opts.timestamp;
    if (opts.timestamp === false) return $03ceb28a240053b3$var$nullTime;
    return $03ceb28a240053b3$var$epochTime;
}
function $03ceb28a240053b3$var$mock() {
    return {};
}
function $03ceb28a240053b3$var$passthrough(a) {
    return a;
}
function $03ceb28a240053b3$var$noop() {}
function $03ceb28a240053b3$var$nullTime() {
    return false;
}
function $03ceb28a240053b3$var$epochTime() {
    return Date.now();
}
function $03ceb28a240053b3$var$unixTime() {
    return Math.round(Date.now() / 1000.0);
}
function $03ceb28a240053b3$var$isoTime() {
    return new Date(Date.now()).toISOString();
} // using Date.now() for testability
/* eslint-disable */ /* istanbul ignore next */ function $03ceb28a240053b3$var$pfGlobalThisOrFallback() {
    function defd(o) {
        return typeof o !== "undefined" && o;
    }
    try {
        if (typeof globalThis !== "undefined") return globalThis;
        Object.defineProperty(Object.prototype, "globalThis", {
            get: function() {
                delete Object.prototype.globalThis;
                return this.globalThis = this;
            },
            configurable: true
        });
        return globalThis;
    } catch (e) {
        return defd(self) || defd(window) || defd(this) || {};
    }
} /* eslint-enable */ 

});
parcelRegister("7h4xj", function(module, exports) {
"use strict";
function $54bda3badc858a5e$var$tryStringify(o) {
    try {
        return JSON.stringify(o);
    } catch (e) {
        return '"[Circular]"';
    }
}
module.exports = $54bda3badc858a5e$var$format;
function $54bda3badc858a5e$var$format(f, args, opts) {
    var ss = opts && opts.stringify || $54bda3badc858a5e$var$tryStringify;
    var offset = 1;
    if (typeof f === "object" && f !== null) {
        var len = args.length + offset;
        if (len === 1) return f;
        var objects = new Array(len);
        objects[0] = ss(f);
        for(var index = 1; index < len; index++)objects[index] = ss(args[index]);
        return objects.join(" ");
    }
    if (typeof f !== "string") return f;
    var argLen = args.length;
    if (argLen === 0) return f;
    var str = "";
    var a = 1 - offset;
    var lastPos = -1;
    var flen = f && f.length || 0;
    for(var i = 0; i < flen;){
        if (f.charCodeAt(i) === 37 && i + 1 < flen) {
            lastPos = lastPos > -1 ? lastPos : 0;
            switch(f.charCodeAt(i + 1)){
                case 100:
                case 102:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Number(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 105:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Math.floor(Number(args[a]));
                    lastPos = i + 2;
                    i++;
                    break;
                case 79:
                case 111:
                case 106:
                    if (a >= argLen) break;
                    if (args[a] === undefined) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    var type = typeof args[a];
                    if (type === "string") {
                        str += "'" + args[a] + "'";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    if (type === "function") {
                        str += args[a].name || "<anonymous>";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    str += ss(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 115:
                    if (a >= argLen) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += String(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 37:
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += "%";
                    lastPos = i + 2;
                    i++;
                    a--;
                    break;
            }
            ++a;
        }
        ++i;
    }
    if (lastPos === -1) return f;
    else if (lastPos < flen) str += f.slice(lastPos);
    return str;
}

});


parcelRegister("glyO2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PINO_CUSTOM_CONTEXT_KEY = module.exports.PINO_LOGGER_DEFAULTS = void 0;
module.exports.PINO_LOGGER_DEFAULTS = {
    level: "info"
};
module.exports.PINO_CUSTOM_CONTEXT_KEY = "custom_context";

});

parcelRegister("cyyD4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateChildLogger = module.exports.formatChildLoggerContext = module.exports.getLoggerContext = module.exports.setBrowserLoggerContext = module.exports.getBrowserLoggerContext = module.exports.getDefaultLoggerOptions = void 0;

var $glyO2 = parcelRequire("glyO2");
function $924385a22f0d1fa4$var$getDefaultLoggerOptions(opts) {
    return Object.assign(Object.assign({}, opts), {
        level: (opts === null || opts === void 0 ? void 0 : opts.level) || $glyO2.PINO_LOGGER_DEFAULTS.level
    });
}
module.exports.getDefaultLoggerOptions = $924385a22f0d1fa4$var$getDefaultLoggerOptions;
function $924385a22f0d1fa4$var$getBrowserLoggerContext(logger, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    return logger[customContextKey] || "";
}
module.exports.getBrowserLoggerContext = $924385a22f0d1fa4$var$getBrowserLoggerContext;
function $924385a22f0d1fa4$var$setBrowserLoggerContext(logger, context, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    logger[customContextKey] = context;
    return logger;
}
module.exports.setBrowserLoggerContext = $924385a22f0d1fa4$var$setBrowserLoggerContext;
function $924385a22f0d1fa4$var$getLoggerContext(logger, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    let context = "";
    if (typeof logger.bindings === "undefined") context = $924385a22f0d1fa4$var$getBrowserLoggerContext(logger, customContextKey);
    else context = logger.bindings().context || "";
    return context;
}
module.exports.getLoggerContext = $924385a22f0d1fa4$var$getLoggerContext;
function $924385a22f0d1fa4$var$formatChildLoggerContext(logger, childContext, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    const parentContext = $924385a22f0d1fa4$var$getLoggerContext(logger, customContextKey);
    const context = parentContext.trim() ? `${parentContext}/${childContext}` : childContext;
    return context;
}
module.exports.formatChildLoggerContext = $924385a22f0d1fa4$var$formatChildLoggerContext;
function $924385a22f0d1fa4$var$generateChildLogger(logger, childContext, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    const context = $924385a22f0d1fa4$var$formatChildLoggerContext(logger, childContext, customContextKey);
    const child = logger.child({
        context: context
    });
    return $924385a22f0d1fa4$var$setBrowserLoggerContext(child, context, customContextKey);
}
module.exports.generateChildLogger = $924385a22f0d1fa4$var$generateChildLogger;

});

parcelRegister("ljFVp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowserCryptoAvailable = module.exports.getSubtleCrypto = module.exports.getBrowerCrypto = void 0;
function $f84be4b966947ef2$var$getBrowerCrypto() {
    return ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.crypto) || ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.msCrypto) || {};
}
module.exports.getBrowerCrypto = $f84be4b966947ef2$var$getBrowerCrypto;
function $f84be4b966947ef2$var$getSubtleCrypto() {
    const browserCrypto = $f84be4b966947ef2$var$getBrowerCrypto();
    return browserCrypto.subtle || browserCrypto.webkitSubtle;
}
module.exports.getSubtleCrypto = $f84be4b966947ef2$var$getSubtleCrypto;
function $f84be4b966947ef2$var$isBrowserCryptoAvailable() {
    return !!$f84be4b966947ef2$var$getBrowerCrypto() && !!$f84be4b966947ef2$var$getSubtleCrypto();
}
module.exports.isBrowserCryptoAvailable = $f84be4b966947ef2$var$isBrowserCryptoAvailable;

});

parcelRegister("5vmD7", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowser = module.exports.isNode = module.exports.isReactNative = void 0;
function $402166cfd1e26574$var$isReactNative() {
    return typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative";
}
module.exports.isReactNative = $402166cfd1e26574$var$isReactNative;
function $402166cfd1e26574$var$isNode() {
    return typeof $hPtJY !== "undefined" && typeof $hPtJY.versions !== "undefined" && typeof $hPtJY.versions.node !== "undefined";
}
module.exports.isNode = $402166cfd1e26574$var$isNode;
function $402166cfd1e26574$var$isBrowser() {
    return !$402166cfd1e26574$var$isReactNative() && !$402166cfd1e26574$var$isNode();
}
module.exports.isBrowser = $402166cfd1e26574$var$isBrowser;

});

parcelRegister("fvaAM", function(module, exports) {
"use strict";
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

});

parcelRegister("6cqMT", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("laOt8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f6a1ae3267718cab$export$2e2bcd8739ae039);
function $f6a1ae3267718cab$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});

parcelRegister("hohVq", function(module, exports) {

$parcel$export(module.exports, "RouterCtrl", () => $ca92951fe17fd102$export$2dd8023fb2cd44c);
$parcel$export(module.exports, "CoreUtil", () => $ca92951fe17fd102$export$2ff3ceb398d6f444);
$parcel$export(module.exports, "EventsCtrl", () => $ca92951fe17fd102$export$59a837b99037295);
$parcel$export(module.exports, "OptionsCtrl", () => $ca92951fe17fd102$export$5f7b08e38aeeee56);
$parcel$export(module.exports, "ConfigCtrl", () => $ca92951fe17fd102$export$5239b2e4de4e2646);
$parcel$export(module.exports, "ExplorerCtrl", () => $ca92951fe17fd102$export$8a0e3ad54b37ee57);
$parcel$export(module.exports, "ModalCtrl", () => $ca92951fe17fd102$export$f6ef1648e6110c37);
$parcel$export(module.exports, "ThemeCtrl", () => $ca92951fe17fd102$export$fed0363cf09933ba);
$parcel$export(module.exports, "ToastCtrl", () => $ca92951fe17fd102$export$49bec3d5b199c07);

var $lDt57 = parcelRequire("lDt57");
const $ca92951fe17fd102$var$o = (0, $lDt57.proxy)({
    history: [
        "ConnectWallet"
    ],
    view: "ConnectWallet",
    data: void 0
}), $ca92951fe17fd102$export$2dd8023fb2cd44c = {
    state: $ca92951fe17fd102$var$o,
    subscribe (e) {
        return (0, $lDt57.subscribe)($ca92951fe17fd102$var$o, ()=>e($ca92951fe17fd102$var$o));
    },
    push (e, t) {
        e !== $ca92951fe17fd102$var$o.view && ($ca92951fe17fd102$var$o.view = e, t && ($ca92951fe17fd102$var$o.data = t), $ca92951fe17fd102$var$o.history.push(e));
    },
    reset (e) {
        $ca92951fe17fd102$var$o.view = e, $ca92951fe17fd102$var$o.history = [
            e
        ];
    },
    replace (e) {
        $ca92951fe17fd102$var$o.history.length > 1 && ($ca92951fe17fd102$var$o.history[$ca92951fe17fd102$var$o.history.length - 1] = e, $ca92951fe17fd102$var$o.view = e);
    },
    goBack () {
        if ($ca92951fe17fd102$var$o.history.length > 1) {
            $ca92951fe17fd102$var$o.history.pop();
            const [e] = $ca92951fe17fd102$var$o.history.slice(-1);
            $ca92951fe17fd102$var$o.view = e;
        }
    },
    setData (e) {
        $ca92951fe17fd102$var$o.data = e;
    }
}, $ca92951fe17fd102$export$2ff3ceb398d6f444 = {
    WALLETCONNECT_DEEPLINK_CHOICE: "WALLETCONNECT_DEEPLINK_CHOICE",
    WCM_VERSION: "WCM_VERSION",
    RECOMMENDED_WALLET_AMOUNT: 9,
    isMobile () {
        return typeof window < "u" ? Boolean(window.matchMedia("(pointer:coarse)").matches || /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/u.test(navigator.userAgent)) : !1;
    },
    isAndroid () {
        return $ca92951fe17fd102$export$2ff3ceb398d6f444.isMobile() && navigator.userAgent.toLowerCase().includes("android");
    },
    isIos () {
        const e = navigator.userAgent.toLowerCase();
        return $ca92951fe17fd102$export$2ff3ceb398d6f444.isMobile() && (e.includes("iphone") || e.includes("ipad"));
    },
    isHttpUrl (e) {
        return e.startsWith("http://") || e.startsWith("https://");
    },
    isArray (e) {
        return Array.isArray(e) && e.length > 0;
    },
    formatNativeUrl (e, t, s) {
        if ($ca92951fe17fd102$export$2ff3ceb398d6f444.isHttpUrl(e)) return this.formatUniversalUrl(e, t, s);
        let n = e;
        n.includes("://") || (n = e.replaceAll("/", "").replaceAll(":", ""), n = `${n}://`), n.endsWith("/") || (n = `${n}/`), this.setWalletConnectDeepLink(n, s);
        const i = encodeURIComponent(t);
        return `${n}wc?uri=${i}`;
    },
    formatUniversalUrl (e, t, s) {
        if (!$ca92951fe17fd102$export$2ff3ceb398d6f444.isHttpUrl(e)) return this.formatNativeUrl(e, t, s);
        let n = e;
        n.endsWith("/") || (n = `${n}/`), this.setWalletConnectDeepLink(n, s);
        const i = encodeURIComponent(t);
        return `${n}wc?uri=${i}`;
    },
    async wait (e) {
        return new Promise((t)=>{
            setTimeout(t, e);
        });
    },
    openHref (e, t) {
        window.open(e, t, "noreferrer noopener");
    },
    setWalletConnectDeepLink (e, t) {
        try {
            localStorage.setItem($ca92951fe17fd102$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
                href: e,
                name: t
            }));
        } catch  {
            console.info("Unable to set WalletConnect deep link");
        }
    },
    setWalletConnectAndroidDeepLink (e) {
        try {
            const [t] = e.split("?");
            localStorage.setItem($ca92951fe17fd102$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
                href: t,
                name: "Android"
            }));
        } catch  {
            console.info("Unable to set WalletConnect android deep link");
        }
    },
    removeWalletConnectDeepLink () {
        try {
            localStorage.removeItem($ca92951fe17fd102$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE);
        } catch  {
            console.info("Unable to remove WalletConnect deep link");
        }
    },
    setModalVersionInStorage () {
        try {
            typeof localStorage < "u" && localStorage.setItem($ca92951fe17fd102$export$2ff3ceb398d6f444.WCM_VERSION, "2.6.2");
        } catch  {
            console.info("Unable to set Web3Modal version in storage");
        }
    },
    getWalletRouterData () {
        var e;
        const t = (e = $ca92951fe17fd102$export$2dd8023fb2cd44c.state.data) == null ? void 0 : e.Wallet;
        if (!t) throw new Error('Missing "Wallet" view data');
        return t;
    }
}, $ca92951fe17fd102$var$_ = typeof location < "u" && (location.hostname.includes("localhost") || location.protocol.includes("https")), $ca92951fe17fd102$var$r = (0, $lDt57.proxy)({
    enabled: $ca92951fe17fd102$var$_,
    userSessionId: "",
    events: [],
    connectedWalletId: void 0
}), $ca92951fe17fd102$export$59a837b99037295 = {
    state: $ca92951fe17fd102$var$r,
    subscribe (e) {
        return (0, $lDt57.subscribe)($ca92951fe17fd102$var$r.events, ()=>e((0, $lDt57.snapshot)($ca92951fe17fd102$var$r.events[$ca92951fe17fd102$var$r.events.length - 1])));
    },
    initialize () {
        $ca92951fe17fd102$var$r.enabled && typeof (crypto == null ? void 0 : crypto.randomUUID) < "u" && ($ca92951fe17fd102$var$r.userSessionId = crypto.randomUUID());
    },
    setConnectedWalletId (e) {
        $ca92951fe17fd102$var$r.connectedWalletId = e;
    },
    click (e) {
        if ($ca92951fe17fd102$var$r.enabled) {
            const t = {
                type: "CLICK",
                name: e.name,
                userSessionId: $ca92951fe17fd102$var$r.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $ca92951fe17fd102$var$r.events.push(t);
        }
    },
    track (e) {
        if ($ca92951fe17fd102$var$r.enabled) {
            const t = {
                type: "TRACK",
                name: e.name,
                userSessionId: $ca92951fe17fd102$var$r.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $ca92951fe17fd102$var$r.events.push(t);
        }
    },
    view (e) {
        if ($ca92951fe17fd102$var$r.enabled) {
            const t = {
                type: "VIEW",
                name: e.name,
                userSessionId: $ca92951fe17fd102$var$r.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $ca92951fe17fd102$var$r.events.push(t);
        }
    }
}, $ca92951fe17fd102$var$c = (0, $lDt57.proxy)({
    chains: void 0,
    walletConnectUri: void 0,
    isAuth: !1,
    isCustomDesktop: !1,
    isCustomMobile: !1,
    isDataLoaded: !1,
    isUiLoaded: !1
}), $ca92951fe17fd102$export$5f7b08e38aeeee56 = {
    state: $ca92951fe17fd102$var$c,
    subscribe (e) {
        return (0, $lDt57.subscribe)($ca92951fe17fd102$var$c, ()=>e($ca92951fe17fd102$var$c));
    },
    setChains (e) {
        $ca92951fe17fd102$var$c.chains = e;
    },
    setWalletConnectUri (e) {
        $ca92951fe17fd102$var$c.walletConnectUri = e;
    },
    setIsCustomDesktop (e) {
        $ca92951fe17fd102$var$c.isCustomDesktop = e;
    },
    setIsCustomMobile (e) {
        $ca92951fe17fd102$var$c.isCustomMobile = e;
    },
    setIsDataLoaded (e) {
        $ca92951fe17fd102$var$c.isDataLoaded = e;
    },
    setIsUiLoaded (e) {
        $ca92951fe17fd102$var$c.isUiLoaded = e;
    },
    setIsAuth (e) {
        $ca92951fe17fd102$var$c.isAuth = e;
    }
}, $ca92951fe17fd102$var$W = (0, $lDt57.proxy)({
    projectId: "",
    mobileWallets: void 0,
    desktopWallets: void 0,
    walletImages: void 0,
    chains: void 0,
    enableAuthMode: !1,
    enableExplorer: !0,
    explorerExcludedWalletIds: void 0,
    explorerRecommendedWalletIds: void 0,
    termsOfServiceUrl: void 0,
    privacyPolicyUrl: void 0
}), $ca92951fe17fd102$export$5239b2e4de4e2646 = {
    state: $ca92951fe17fd102$var$W,
    subscribe (e) {
        return (0, $lDt57.subscribe)($ca92951fe17fd102$var$W, ()=>e($ca92951fe17fd102$var$W));
    },
    setConfig (e) {
        var t, s;
        $ca92951fe17fd102$export$59a837b99037295.initialize(), $ca92951fe17fd102$export$5f7b08e38aeeee56.setChains(e.chains), $ca92951fe17fd102$export$5f7b08e38aeeee56.setIsAuth(Boolean(e.enableAuthMode)), $ca92951fe17fd102$export$5f7b08e38aeeee56.setIsCustomMobile(Boolean((t = e.mobileWallets) == null ? void 0 : t.length)), $ca92951fe17fd102$export$5f7b08e38aeeee56.setIsCustomDesktop(Boolean((s = e.desktopWallets) == null ? void 0 : s.length)), $ca92951fe17fd102$export$2ff3ceb398d6f444.setModalVersionInStorage(), Object.assign($ca92951fe17fd102$var$W, e);
    }
};
var $ca92951fe17fd102$var$V = Object.defineProperty, $ca92951fe17fd102$var$D = Object.getOwnPropertySymbols, $ca92951fe17fd102$var$H = Object.prototype.hasOwnProperty, $ca92951fe17fd102$var$B = Object.prototype.propertyIsEnumerable, $ca92951fe17fd102$var$M = (e, t, s)=>t in e ? $ca92951fe17fd102$var$V(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : e[t] = s, $ca92951fe17fd102$var$K = (e, t)=>{
    for(var s in t || (t = {}))$ca92951fe17fd102$var$H.call(t, s) && $ca92951fe17fd102$var$M(e, s, t[s]);
    if ($ca92951fe17fd102$var$D) for (var s of $ca92951fe17fd102$var$D(t))$ca92951fe17fd102$var$B.call(t, s) && $ca92951fe17fd102$var$M(e, s, t[s]);
    return e;
};
const $ca92951fe17fd102$var$L = "https://explorer-api.walletconnect.com", $ca92951fe17fd102$var$E = "wcm", $ca92951fe17fd102$var$O = "js-2.6.2";
async function $ca92951fe17fd102$var$w(e, t) {
    const s = $ca92951fe17fd102$var$K({
        sdkType: $ca92951fe17fd102$var$E,
        sdkVersion: $ca92951fe17fd102$var$O
    }, t), n = new URL(e, $ca92951fe17fd102$var$L);
    return n.searchParams.append("projectId", $ca92951fe17fd102$export$5239b2e4de4e2646.state.projectId), Object.entries(s).forEach(([i, l])=>{
        l && n.searchParams.append(i, String(l));
    }), (await fetch(n)).json();
}
const $ca92951fe17fd102$var$m = {
    async getDesktopListings (e) {
        return $ca92951fe17fd102$var$w("/w3m/v1/getDesktopListings", e);
    },
    async getMobileListings (e) {
        return $ca92951fe17fd102$var$w("/w3m/v1/getMobileListings", e);
    },
    async getInjectedListings (e) {
        return $ca92951fe17fd102$var$w("/w3m/v1/getInjectedListings", e);
    },
    async getAllListings (e) {
        return $ca92951fe17fd102$var$w("/w3m/v1/getAllListings", e);
    },
    getWalletImageUrl (e) {
        return `${$ca92951fe17fd102$var$L}/w3m/v1/getWalletImage/${e}?projectId=${$ca92951fe17fd102$export$5239b2e4de4e2646.state.projectId}&sdkType=${$ca92951fe17fd102$var$E}&sdkVersion=${$ca92951fe17fd102$var$O}`;
    },
    getAssetImageUrl (e) {
        return `${$ca92951fe17fd102$var$L}/w3m/v1/getAssetImage/${e}?projectId=${$ca92951fe17fd102$export$5239b2e4de4e2646.state.projectId}&sdkType=${$ca92951fe17fd102$var$E}&sdkVersion=${$ca92951fe17fd102$var$O}`;
    }
};
var $ca92951fe17fd102$var$z = Object.defineProperty, $ca92951fe17fd102$var$j = Object.getOwnPropertySymbols, $ca92951fe17fd102$var$J = Object.prototype.hasOwnProperty, $ca92951fe17fd102$var$q = Object.prototype.propertyIsEnumerable, $ca92951fe17fd102$var$k = (e, t, s)=>t in e ? $ca92951fe17fd102$var$z(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : e[t] = s, $ca92951fe17fd102$var$F = (e, t)=>{
    for(var s in t || (t = {}))$ca92951fe17fd102$var$J.call(t, s) && $ca92951fe17fd102$var$k(e, s, t[s]);
    if ($ca92951fe17fd102$var$j) for (var s of $ca92951fe17fd102$var$j(t))$ca92951fe17fd102$var$q.call(t, s) && $ca92951fe17fd102$var$k(e, s, t[s]);
    return e;
};
const $ca92951fe17fd102$var$N = $ca92951fe17fd102$export$2ff3ceb398d6f444.isMobile(), $ca92951fe17fd102$var$d = (0, $lDt57.proxy)({
    wallets: {
        listings: [],
        total: 0,
        page: 1
    },
    search: {
        listings: [],
        total: 0,
        page: 1
    },
    recomendedWallets: []
}), $ca92951fe17fd102$export$8a0e3ad54b37ee57 = {
    state: $ca92951fe17fd102$var$d,
    async getRecomendedWallets () {
        const { explorerRecommendedWalletIds: e, explorerExcludedWalletIds: t } = $ca92951fe17fd102$export$5239b2e4de4e2646.state;
        if (e === "NONE" || t === "ALL" && !e) return $ca92951fe17fd102$var$d.recomendedWallets;
        if ($ca92951fe17fd102$export$2ff3ceb398d6f444.isArray(e)) {
            const s = {
                recommendedIds: e.join(",")
            }, { listings: n } = await $ca92951fe17fd102$var$m.getAllListings(s), i = Object.values(n);
            i.sort((l, v)=>{
                const b = e.indexOf(l.id), f = e.indexOf(v.id);
                return b - f;
            }), $ca92951fe17fd102$var$d.recomendedWallets = i;
        } else {
            const { chains: s, isAuth: n } = $ca92951fe17fd102$export$5f7b08e38aeeee56.state, i = s?.join(","), l = $ca92951fe17fd102$export$2ff3ceb398d6f444.isArray(t), v = {
                page: 1,
                sdks: n ? "auth_v1" : void 0,
                entries: $ca92951fe17fd102$export$2ff3ceb398d6f444.RECOMMENDED_WALLET_AMOUNT,
                chains: i,
                version: 2,
                excludedIds: l ? t.join(",") : void 0
            }, { listings: b } = $ca92951fe17fd102$var$N ? await $ca92951fe17fd102$var$m.getMobileListings(v) : await $ca92951fe17fd102$var$m.getDesktopListings(v);
            $ca92951fe17fd102$var$d.recomendedWallets = Object.values(b);
        }
        return $ca92951fe17fd102$var$d.recomendedWallets;
    },
    async getWallets (e) {
        const t = $ca92951fe17fd102$var$F({}, e), { explorerRecommendedWalletIds: s, explorerExcludedWalletIds: n } = $ca92951fe17fd102$export$5239b2e4de4e2646.state, { recomendedWallets: i } = $ca92951fe17fd102$var$d;
        if (n === "ALL") return $ca92951fe17fd102$var$d.wallets;
        i.length ? t.excludedIds = i.map((x)=>x.id).join(",") : $ca92951fe17fd102$export$2ff3ceb398d6f444.isArray(s) && (t.excludedIds = s.join(",")), $ca92951fe17fd102$export$2ff3ceb398d6f444.isArray(n) && (t.excludedIds = [
            t.excludedIds,
            n
        ].filter(Boolean).join(",")), $ca92951fe17fd102$export$5f7b08e38aeeee56.state.isAuth && (t.sdks = "auth_v1");
        const { page: l, search: v } = e, { listings: b, total: f } = $ca92951fe17fd102$var$N ? await $ca92951fe17fd102$var$m.getMobileListings(t) : await $ca92951fe17fd102$var$m.getDesktopListings(t), A = Object.values(b), U = v ? "search" : "wallets";
        return $ca92951fe17fd102$var$d[U] = {
            listings: [
                ...$ca92951fe17fd102$var$d[U].listings,
                ...A
            ],
            total: f,
            page: l ?? 1
        }, {
            listings: A,
            total: f
        };
    },
    getWalletImageUrl (e) {
        return $ca92951fe17fd102$var$m.getWalletImageUrl(e);
    },
    getAssetImageUrl (e) {
        return $ca92951fe17fd102$var$m.getAssetImageUrl(e);
    },
    resetSearch () {
        $ca92951fe17fd102$var$d.search = {
            listings: [],
            total: 0,
            page: 1
        };
    }
}, $ca92951fe17fd102$var$I = (0, $lDt57.proxy)({
    open: !1
}), $ca92951fe17fd102$export$f6ef1648e6110c37 = {
    state: $ca92951fe17fd102$var$I,
    subscribe (e) {
        return (0, $lDt57.subscribe)($ca92951fe17fd102$var$I, ()=>e($ca92951fe17fd102$var$I));
    },
    async open (e) {
        return new Promise((t)=>{
            const { isUiLoaded: s, isDataLoaded: n } = $ca92951fe17fd102$export$5f7b08e38aeeee56.state;
            if ($ca92951fe17fd102$export$2ff3ceb398d6f444.removeWalletConnectDeepLink(), $ca92951fe17fd102$export$5f7b08e38aeeee56.setWalletConnectUri(e?.uri), $ca92951fe17fd102$export$5f7b08e38aeeee56.setChains(e?.chains), $ca92951fe17fd102$export$2dd8023fb2cd44c.reset("ConnectWallet"), s && n) $ca92951fe17fd102$var$I.open = !0, t();
            else {
                const i = setInterval(()=>{
                    const l = $ca92951fe17fd102$export$5f7b08e38aeeee56.state;
                    l.isUiLoaded && l.isDataLoaded && (clearInterval(i), $ca92951fe17fd102$var$I.open = !0, t());
                }, 200);
            }
        });
    },
    close () {
        $ca92951fe17fd102$var$I.open = !1;
    }
};
var $ca92951fe17fd102$var$G = Object.defineProperty, $ca92951fe17fd102$var$$ = Object.getOwnPropertySymbols, $ca92951fe17fd102$var$Q = Object.prototype.hasOwnProperty, $ca92951fe17fd102$var$X = Object.prototype.propertyIsEnumerable, $ca92951fe17fd102$var$S = (e, t, s)=>t in e ? $ca92951fe17fd102$var$G(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : e[t] = s, $ca92951fe17fd102$var$Y = (e, t)=>{
    for(var s in t || (t = {}))$ca92951fe17fd102$var$Q.call(t, s) && $ca92951fe17fd102$var$S(e, s, t[s]);
    if ($ca92951fe17fd102$var$$) for (var s of $ca92951fe17fd102$var$$(t))$ca92951fe17fd102$var$X.call(t, s) && $ca92951fe17fd102$var$S(e, s, t[s]);
    return e;
};
function $ca92951fe17fd102$var$Z() {
    return typeof matchMedia < "u" && matchMedia("(prefers-color-scheme: dark)").matches;
}
const $ca92951fe17fd102$var$C = (0, $lDt57.proxy)({
    themeMode: $ca92951fe17fd102$var$Z() ? "dark" : "light"
}), $ca92951fe17fd102$export$fed0363cf09933ba = {
    state: $ca92951fe17fd102$var$C,
    subscribe (e) {
        return (0, $lDt57.subscribe)($ca92951fe17fd102$var$C, ()=>e($ca92951fe17fd102$var$C));
    },
    setThemeConfig (e) {
        const { themeMode: t, themeVariables: s } = e;
        t && ($ca92951fe17fd102$var$C.themeMode = t), s && ($ca92951fe17fd102$var$C.themeVariables = $ca92951fe17fd102$var$Y({}, s));
    }
}, $ca92951fe17fd102$var$g = (0, $lDt57.proxy)({
    open: !1,
    message: "",
    variant: "success"
}), $ca92951fe17fd102$export$49bec3d5b199c07 = {
    state: $ca92951fe17fd102$var$g,
    subscribe (e) {
        return (0, $lDt57.subscribe)($ca92951fe17fd102$var$g, ()=>e($ca92951fe17fd102$var$g));
    },
    openToast (e, t) {
        $ca92951fe17fd102$var$g.open = !0, $ca92951fe17fd102$var$g.message = e, $ca92951fe17fd102$var$g.variant = t;
    },
    closeToast () {
        $ca92951fe17fd102$var$g.open = !1;
    }
};

});
parcelRegister("lDt57", function(module, exports) {

$parcel$export(module.exports, "getVersion", () => $fc03cc7843f50881$export$c506eb22e615ba4a, (v) => $fc03cc7843f50881$export$c506eb22e615ba4a = v);
$parcel$export(module.exports, "proxy", () => $fc03cc7843f50881$export$923f96dd5afa9ce6, (v) => $fc03cc7843f50881$export$923f96dd5afa9ce6 = v);
$parcel$export(module.exports, "ref", () => $fc03cc7843f50881$export$eff4d24c3ff7876e, (v) => $fc03cc7843f50881$export$eff4d24c3ff7876e = v);
$parcel$export(module.exports, "snapshot", () => $fc03cc7843f50881$export$b8801ea43165ed7d, (v) => $fc03cc7843f50881$export$b8801ea43165ed7d = v);
$parcel$export(module.exports, "subscribe", () => $fc03cc7843f50881$export$ec068583843480e7, (v) => $fc03cc7843f50881$export$ec068583843480e7 = v);
$parcel$export(module.exports, "unstable_buildProxyFunction", () => $fc03cc7843f50881$export$e7b04d37d9502758, (v) => $fc03cc7843f50881$export$e7b04d37d9502758 = v);
var $fc03cc7843f50881$export$c506eb22e615ba4a;
var $fc03cc7843f50881$export$923f96dd5afa9ce6;
var $fc03cc7843f50881$export$eff4d24c3ff7876e;
var $fc03cc7843f50881$export$b8801ea43165ed7d;
var $fc03cc7843f50881$export$ec068583843480e7;
var $fc03cc7843f50881$export$e7b04d37d9502758;
"use strict";

var $fkrbD = parcelRequire("fkrbD");
var $fc03cc7843f50881$var$isObject = function isObject(x) {
    return typeof x === "object" && x !== null;
};
var $fc03cc7843f50881$var$proxyStateMap = new WeakMap();
var $fc03cc7843f50881$var$refSet = new WeakSet();
var $fc03cc7843f50881$var$buildProxyFunction = function buildProxyFunction(objectIs, newProxy, canProxy, defaultHandlePromise, snapCache, createSnapshot, proxyCache, versionHolder, _proxyFunction) {
    if (objectIs === void 0) objectIs = Object.is;
    if (newProxy === void 0) newProxy = function newProxy(target, handler) {
        return new Proxy(target, handler);
    };
    if (canProxy === void 0) canProxy = function canProxy(x) {
        return $fc03cc7843f50881$var$isObject(x) && !$fc03cc7843f50881$var$refSet.has(x) && (Array.isArray(x) || !(Symbol.iterator in x)) && !(x instanceof WeakMap) && !(x instanceof WeakSet) && !(x instanceof Error) && !(x instanceof Number) && !(x instanceof Date) && !(x instanceof String) && !(x instanceof RegExp) && !(x instanceof ArrayBuffer);
    };
    if (defaultHandlePromise === void 0) defaultHandlePromise = function defaultHandlePromise(promise) {
        switch(promise.status){
            case "fulfilled":
                return promise.value;
            case "rejected":
                throw promise.reason;
            default:
                throw promise;
        }
    };
    if (snapCache === void 0) snapCache = new WeakMap();
    if (createSnapshot === void 0) createSnapshot = function(_createSnapshot) {
        function createSnapshot(_x, _x2, _x3) {
            return _createSnapshot.apply(this, arguments);
        }
        createSnapshot.toString = function() {
            return _createSnapshot.toString();
        };
        return createSnapshot;
    }(function(target, version, handlePromise) {
        if (handlePromise === void 0) handlePromise = defaultHandlePromise;
        var cache = snapCache.get(target);
        if ((cache == null ? void 0 : cache[0]) === version) return cache[1];
        var snap = Array.isArray(target) ? [] : Object.create(Object.getPrototypeOf(target));
        $fkrbD.markToTrack(snap, true);
        snapCache.set(target, [
            version,
            snap
        ]);
        Reflect.ownKeys(target).forEach(function(key) {
            if (Object.getOwnPropertyDescriptor(snap, key)) return;
            var value = Reflect.get(target, key);
            var desc = {
                value: value,
                enumerable: true,
                configurable: true
            };
            if ($fc03cc7843f50881$var$refSet.has(value)) $fkrbD.markToTrack(value, false);
            else if (value instanceof Promise) {
                delete desc.value;
                desc.get = function() {
                    return handlePromise(value);
                };
            } else if ($fc03cc7843f50881$var$proxyStateMap.has(value)) {
                var _ref = $fc03cc7843f50881$var$proxyStateMap.get(value), _target = _ref[0], _ensureVersion = _ref[1];
                desc.value = createSnapshot(_target, _ensureVersion(), handlePromise);
            }
            Object.defineProperty(snap, key, desc);
        });
        return Object.preventExtensions(snap);
    });
    if (proxyCache === void 0) proxyCache = new WeakMap();
    if (versionHolder === void 0) versionHolder = [
        1,
        1
    ];
    if (_proxyFunction === void 0) _proxyFunction = function proxyFunction(initialObject) {
        if (!$fc03cc7843f50881$var$isObject(initialObject)) throw new Error("object required");
        var found = proxyCache.get(initialObject);
        if (found) return found;
        var version = versionHolder[0];
        var listeners = new Set();
        var notifyUpdate = function notifyUpdate(op, nextVersion) {
            if (nextVersion === void 0) nextVersion = ++versionHolder[0];
            if (version !== nextVersion) {
                version = nextVersion;
                listeners.forEach(function(listener) {
                    return listener(op, nextVersion);
                });
            }
        };
        var checkVersion = versionHolder[1];
        var ensureVersion = function ensureVersion(nextCheckVersion) {
            if (nextCheckVersion === void 0) nextCheckVersion = ++versionHolder[1];
            if (checkVersion !== nextCheckVersion && !listeners.size) {
                checkVersion = nextCheckVersion;
                propProxyStates.forEach(function(_ref2) {
                    var propProxyState = _ref2[0];
                    var propVersion = propProxyState[1](nextCheckVersion);
                    if (propVersion > version) version = propVersion;
                });
            }
            return version;
        };
        var createPropListener = function createPropListener(prop) {
            return function(op, nextVersion) {
                var newOp = [].concat(op);
                newOp[1] = [
                    prop
                ].concat(newOp[1]);
                notifyUpdate(newOp, nextVersion);
            };
        };
        var propProxyStates = new Map();
        var addPropListener = function addPropListener(prop, propProxyState) {
            if (propProxyStates.has(prop)) throw new Error("prop listener already exists");
            if (listeners.size) {
                var remove = propProxyState[3](createPropListener(prop));
                propProxyStates.set(prop, [
                    propProxyState,
                    remove
                ]);
            } else propProxyStates.set(prop, [
                propProxyState
            ]);
        };
        var removePropListener = function removePropListener(prop) {
            var entry = propProxyStates.get(prop);
            if (entry) {
                var _entry$;
                propProxyStates.delete(prop);
                (_entry$ = entry[1]) == null || _entry$.call(entry);
            }
        };
        var addListener = function addListener(listener) {
            listeners.add(listener);
            if (listeners.size === 1) propProxyStates.forEach(function(_ref3, prop) {
                var propProxyState = _ref3[0], prevRemove = _ref3[1];
                if (prevRemove) throw new Error("remove already exists");
                var remove = propProxyState[3](createPropListener(prop));
                propProxyStates.set(prop, [
                    propProxyState,
                    remove
                ]);
            });
            var removeListener = function removeListener() {
                listeners.delete(listener);
                if (listeners.size === 0) propProxyStates.forEach(function(_ref4, prop) {
                    var propProxyState = _ref4[0], remove = _ref4[1];
                    if (remove) {
                        remove();
                        propProxyStates.set(prop, [
                            propProxyState
                        ]);
                    }
                });
            };
            return removeListener;
        };
        var baseObject = Array.isArray(initialObject) ? [] : Object.create(Object.getPrototypeOf(initialObject));
        var handler = {
            deleteProperty: function deleteProperty(target, prop) {
                var prevValue = Reflect.get(target, prop);
                removePropListener(prop);
                var deleted = Reflect.deleteProperty(target, prop);
                if (deleted) notifyUpdate([
                    "delete",
                    [
                        prop
                    ],
                    prevValue
                ]);
                return deleted;
            },
            set: function set(target, prop, value, receiver) {
                var hasPrevValue = Reflect.has(target, prop);
                var prevValue = Reflect.get(target, prop, receiver);
                if (hasPrevValue && (objectIs(prevValue, value) || proxyCache.has(value) && objectIs(prevValue, proxyCache.get(value)))) return true;
                removePropListener(prop);
                if ($fc03cc7843f50881$var$isObject(value)) value = $fkrbD.getUntracked(value) || value;
                var nextValue = value;
                if (value instanceof Promise) value.then(function(v) {
                    value.status = "fulfilled";
                    value.value = v;
                    notifyUpdate([
                        "resolve",
                        [
                            prop
                        ],
                        v
                    ]);
                }).catch(function(e) {
                    value.status = "rejected";
                    value.reason = e;
                    notifyUpdate([
                        "reject",
                        [
                            prop
                        ],
                        e
                    ]);
                });
                else {
                    if (!$fc03cc7843f50881$var$proxyStateMap.has(value) && canProxy(value)) nextValue = _proxyFunction(value);
                    var childProxyState = !$fc03cc7843f50881$var$refSet.has(nextValue) && $fc03cc7843f50881$var$proxyStateMap.get(nextValue);
                    if (childProxyState) addPropListener(prop, childProxyState);
                }
                Reflect.set(target, prop, nextValue, receiver);
                notifyUpdate([
                    "set",
                    [
                        prop
                    ],
                    value,
                    prevValue
                ]);
                return true;
            }
        };
        var proxyObject = newProxy(baseObject, handler);
        proxyCache.set(initialObject, proxyObject);
        var proxyState = [
            baseObject,
            ensureVersion,
            createSnapshot,
            addListener
        ];
        $fc03cc7843f50881$var$proxyStateMap.set(proxyObject, proxyState);
        Reflect.ownKeys(initialObject).forEach(function(key) {
            var desc = Object.getOwnPropertyDescriptor(initialObject, key);
            if ("value" in desc) {
                proxyObject[key] = initialObject[key];
                delete desc.value;
                delete desc.writable;
            }
            Object.defineProperty(baseObject, key, desc);
        });
        return proxyObject;
    };
    return [
        _proxyFunction,
        $fc03cc7843f50881$var$proxyStateMap,
        $fc03cc7843f50881$var$refSet,
        objectIs,
        newProxy,
        canProxy,
        defaultHandlePromise,
        snapCache,
        createSnapshot,
        proxyCache,
        versionHolder
    ];
};
var $fc03cc7843f50881$var$_buildProxyFunction = $fc03cc7843f50881$var$buildProxyFunction(), $fc03cc7843f50881$var$defaultProxyFunction = $fc03cc7843f50881$var$_buildProxyFunction[0];
function $fc03cc7843f50881$var$proxy(initialObject) {
    if (initialObject === void 0) initialObject = {};
    return $fc03cc7843f50881$var$defaultProxyFunction(initialObject);
}
function $fc03cc7843f50881$var$getVersion(proxyObject) {
    var proxyState = $fc03cc7843f50881$var$proxyStateMap.get(proxyObject);
    return proxyState == null ? void 0 : proxyState[1]();
}
function $fc03cc7843f50881$var$subscribe(proxyObject, callback, notifyInSync) {
    var proxyState = $fc03cc7843f50881$var$proxyStateMap.get(proxyObject);
    if (!proxyState) console.warn("Please use proxy object");
    var promise;
    var ops = [];
    var addListener = proxyState[3];
    var isListenerActive = false;
    var listener = function listener(op) {
        ops.push(op);
        if (notifyInSync) {
            callback(ops.splice(0));
            return;
        }
        if (!promise) promise = Promise.resolve().then(function() {
            promise = undefined;
            if (isListenerActive) callback(ops.splice(0));
        });
    };
    var removeListener = addListener(listener);
    isListenerActive = true;
    return function() {
        isListenerActive = false;
        removeListener();
    };
}
function $fc03cc7843f50881$var$snapshot(proxyObject, handlePromise) {
    var proxyState = $fc03cc7843f50881$var$proxyStateMap.get(proxyObject);
    if (!proxyState) console.warn("Please use proxy object");
    var _ref5 = proxyState, target = _ref5[0], ensureVersion = _ref5[1], createSnapshot = _ref5[2];
    return createSnapshot(target, ensureVersion(), handlePromise);
}
function $fc03cc7843f50881$var$ref(obj) {
    $fc03cc7843f50881$var$refSet.add(obj);
    return obj;
}
var $fc03cc7843f50881$var$unstable_buildProxyFunction = $fc03cc7843f50881$var$buildProxyFunction;
$fc03cc7843f50881$export$c506eb22e615ba4a = $fc03cc7843f50881$var$getVersion;
$fc03cc7843f50881$export$923f96dd5afa9ce6 = $fc03cc7843f50881$var$proxy;
$fc03cc7843f50881$export$eff4d24c3ff7876e = $fc03cc7843f50881$var$ref;
$fc03cc7843f50881$export$b8801ea43165ed7d = $fc03cc7843f50881$var$snapshot;
$fc03cc7843f50881$export$ec068583843480e7 = $fc03cc7843f50881$var$subscribe;
$fc03cc7843f50881$export$e7b04d37d9502758 = $fc03cc7843f50881$var$unstable_buildProxyFunction;

});
parcelRegister("fkrbD", function(module, exports) {

$parcel$export(module.exports, "getUntracked", () => $b28dcff9705b9efe$export$80d2cee7ee556e99);
$parcel$export(module.exports, "markToTrack", () => $b28dcff9705b9efe$export$2c8383c890e26a1c);
const $b28dcff9705b9efe$var$e = Symbol(), $b28dcff9705b9efe$var$t = Symbol(), $b28dcff9705b9efe$var$r = "a", $b28dcff9705b9efe$var$n = "w";
let $b28dcff9705b9efe$var$o = (e, t)=>new Proxy(e, t);
const $b28dcff9705b9efe$var$s = Object.getPrototypeOf, $b28dcff9705b9efe$var$c = new WeakMap, $b28dcff9705b9efe$var$l = (e)=>e && ($b28dcff9705b9efe$var$c.has(e) ? $b28dcff9705b9efe$var$c.get(e) : $b28dcff9705b9efe$var$s(e) === Object.prototype || $b28dcff9705b9efe$var$s(e) === Array.prototype), $b28dcff9705b9efe$var$f = (e)=>"object" == typeof e && null !== e, $b28dcff9705b9efe$var$i = (e)=>{
    if (Array.isArray(e)) return Array.from(e);
    const t = Object.getOwnPropertyDescriptors(e);
    return Object.values(t).forEach((e)=>{
        e.configurable = !0;
    }), Object.create($b28dcff9705b9efe$var$s(e), t);
}, $b28dcff9705b9efe$var$u = (e)=>e[$b28dcff9705b9efe$var$t] || e, $b28dcff9705b9efe$export$7865d0c7f908de6b = (s, c, f, p)=>{
    if (!$b28dcff9705b9efe$var$l(s)) return s;
    let g = p && p.get(s);
    if (!g) {
        const e = $b28dcff9705b9efe$var$u(s);
        g = ((e)=>Object.values(Object.getOwnPropertyDescriptors(e)).some((e)=>!e.configurable && !e.writable))(e) ? [
            e,
            $b28dcff9705b9efe$var$i(e)
        ] : [
            e
        ], null == p || p.set(s, g);
    }
    const [y, h] = g;
    let w = f && f.get(y);
    return w && w[1].f === !!h || (w = ((o, s)=>{
        const c = {
            f: s
        };
        let l = !1;
        const f = (e, t)=>{
            if (!l) {
                let s = c[$b28dcff9705b9efe$var$r].get(o);
                if (s || (s = {}, c[$b28dcff9705b9efe$var$r].set(o, s)), e === $b28dcff9705b9efe$var$n) s[$b28dcff9705b9efe$var$n] = !0;
                else {
                    let r = s[e];
                    r || (r = new Set, s[e] = r), r.add(t);
                }
            }
        }, i = {
            get: (e, n)=>n === $b28dcff9705b9efe$var$t ? o : (f("k", n), $b28dcff9705b9efe$export$7865d0c7f908de6b(Reflect.get(e, n), c[$b28dcff9705b9efe$var$r], c.c, c.t)),
            has: (t, n)=>n === $b28dcff9705b9efe$var$e ? (l = !0, c[$b28dcff9705b9efe$var$r].delete(o), !0) : (f("h", n), Reflect.has(t, n)),
            getOwnPropertyDescriptor: (e, t)=>(f("o", t), Reflect.getOwnPropertyDescriptor(e, t)),
            ownKeys: (e)=>(f($b28dcff9705b9efe$var$n), Reflect.ownKeys(e))
        };
        return s && (i.set = i.deleteProperty = ()=>!1), [
            i,
            c
        ];
    })(y, !!h), w[1].p = $b28dcff9705b9efe$var$o(h || y, w[0]), f && f.set(y, w)), w[1][$b28dcff9705b9efe$var$r] = c, w[1].c = f, w[1].t = p, w[1].p;
}, $b28dcff9705b9efe$export$3a85b3f4caf02b6f = (e, t, r, o)=>{
    if (Object.is(e, t)) return !1;
    if (!$b28dcff9705b9efe$var$f(e) || !$b28dcff9705b9efe$var$f(t)) return !0;
    const s = r.get($b28dcff9705b9efe$var$u(e));
    if (!s) return !0;
    if (o) {
        const r = o.get(e);
        if (r && r.n === t) return r.g;
        o.set(e, {
            n: t,
            g: !1
        });
    }
    let c = null;
    try {
        for (const r of s.h || [])if (c = Reflect.has(e, r) !== Reflect.has(t, r), c) return c;
        if (!0 === s[$b28dcff9705b9efe$var$n]) {
            if (c = ((e, t)=>{
                const r = Reflect.ownKeys(e), n = Reflect.ownKeys(t);
                return r.length !== n.length || r.some((e, t)=>e !== n[t]);
            })(e, t), c) return c;
        } else for (const r of s.o || [])if (c = !!Reflect.getOwnPropertyDescriptor(e, r) != !!Reflect.getOwnPropertyDescriptor(t, r), c) return c;
        for (const n of s.k || [])if (c = $b28dcff9705b9efe$export$3a85b3f4caf02b6f(e[n], t[n], r, o), c) return c;
        return null === c && (c = !0), c;
    } finally{
        o && o.set(e, {
            n: t,
            g: c
        });
    }
}, $b28dcff9705b9efe$export$badc26589cf7bb38 = (t)=>!!$b28dcff9705b9efe$var$l(t) && $b28dcff9705b9efe$var$e in t, $b28dcff9705b9efe$export$80d2cee7ee556e99 = (e)=>$b28dcff9705b9efe$var$l(e) && e[$b28dcff9705b9efe$var$t] || null, $b28dcff9705b9efe$export$2c8383c890e26a1c = (e, t = !0)=>{
    $b28dcff9705b9efe$var$c.set(e, t);
}, $b28dcff9705b9efe$export$10e85fc10e680a16 = (e, t, r)=>{
    const o = [], s = new WeakSet, c = (e, l)=>{
        if (s.has(e)) return;
        $b28dcff9705b9efe$var$f(e) && s.add(e);
        const i = $b28dcff9705b9efe$var$f(e) && t.get($b28dcff9705b9efe$var$u(e));
        if (i) {
            var a, p;
            if (null == (a = i.h) || a.forEach((e)=>{
                const t = `:has(${String(e)})`;
                o.push(l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            }), !0 === i[$b28dcff9705b9efe$var$n]) {
                const e = ":ownKeys";
                o.push(l ? [
                    ...l,
                    e
                ] : [
                    e
                ]);
            } else {
                var g;
                null == (g = i.o) || g.forEach((e)=>{
                    const t = `:hasOwn(${String(e)})`;
                    o.push(l ? [
                        ...l,
                        t
                    ] : [
                        t
                    ]);
                });
            }
            null == (p = i.k) || p.forEach((t)=>{
                r && !("value" in (Object.getOwnPropertyDescriptor(e, t) || {})) || c(e[t], l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            });
        } else l && o.push(l);
    };
    return c(e), o;
}, $b28dcff9705b9efe$export$9b4d5450dbd8e67e = (e)=>{
    $b28dcff9705b9efe$var$o = e;
};

});



parcelRegister("jiqUU", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cGIh0").then(()=>parcelRequire("k9DFq"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("MPA2U", function(module, exports) {

$parcel$export(module.exports, "create", () => $092c7e998bebe629$export$185802fd694ee1f5, (v) => $092c7e998bebe629$export$185802fd694ee1f5 = v);
$parcel$export(module.exports, "toCanvas", () => $092c7e998bebe629$export$f87f6982d1fd4f81, (v) => $092c7e998bebe629$export$f87f6982d1fd4f81 = v);
$parcel$export(module.exports, "toDataURL", () => $092c7e998bebe629$export$723e4939e5a27c8, (v) => $092c7e998bebe629$export$723e4939e5a27c8 = v);
$parcel$export(module.exports, "toString", () => $092c7e998bebe629$export$f84e8e69fd4488a5, (v) => $092c7e998bebe629$export$f84e8e69fd4488a5 = v);
var $092c7e998bebe629$export$185802fd694ee1f5;
var $092c7e998bebe629$export$f87f6982d1fd4f81;
var $092c7e998bebe629$export$723e4939e5a27c8;
// only svg for now.
var $092c7e998bebe629$export$f84e8e69fd4488a5;

var $jLEcc = parcelRequire("jLEcc");

var $8an4w = parcelRequire("8an4w");

var $7bRLF = parcelRequire("7bRLF");

var $4dczE = parcelRequire("4dczE");
function $092c7e998bebe629$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$jLEcc()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $8an4w.create(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $8an4w.create(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$092c7e998bebe629$export$185802fd694ee1f5 = $8an4w.create;
$092c7e998bebe629$export$f87f6982d1fd4f81 = $092c7e998bebe629$var$renderCanvas.bind(null, $7bRLF.render);
$092c7e998bebe629$export$723e4939e5a27c8 = $092c7e998bebe629$var$renderCanvas.bind(null, $7bRLF.renderToDataURL);
$092c7e998bebe629$export$f84e8e69fd4488a5 = $092c7e998bebe629$var$renderCanvas.bind(null, function(data, _, opts) {
    return $4dczE.render(data, opts);
});

});
parcelRegister("jLEcc", function(module, exports) {
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
module.exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};

});

parcelRegister("8an4w", function(module, exports) {

$parcel$export(module.exports, "create", () => $5f2127839fe01a16$export$185802fd694ee1f5, (v) => $5f2127839fe01a16$export$185802fd694ee1f5 = v);
/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $5f2127839fe01a16$export$185802fd694ee1f5;

var $gAPR2 = parcelRequire("gAPR2");

var $i2Grt = parcelRequire("i2Grt");

var $2Yr7q = parcelRequire("2Yr7q");

var $59qyF = parcelRequire("59qyF");

var $gEXbH = parcelRequire("gEXbH");

var $fuRP0 = parcelRequire("fuRP0");

var $2EgxG = parcelRequire("2EgxG");

var $aWGUA = parcelRequire("aWGUA");

var $ziz9l = parcelRequire("ziz9l");

var $1ILJK = parcelRequire("1ILJK");

var $2HRKe = parcelRequire("2HRKe");

var $2UpRK = parcelRequire("2UpRK");

var $zJRcv = parcelRequire("zJRcv");
/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $fuRP0.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $5f2127839fe01a16$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupAlignmentPattern(matrix, version) {
    const pos = $gEXbH.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $1ILJK.getEncodedBits(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $5f2127839fe01a16$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $2HRKe.getEncodedBits(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $5f2127839fe01a16$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $2Yr7q();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $2UpRK.getCharCountIndicator(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $gAPR2.getSymbolTotalCodewords(version);
    const ecTotalCodewords = $aWGUA.getTotalCodewordsCount(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $5f2127839fe01a16$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $gAPR2.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $aWGUA.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $aWGUA.getBlocksCount(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $ziz9l(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $zJRcv.fromArray(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $zJRcv.rawSplit(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $1ILJK.getBestVersionForData(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $zJRcv.fromString(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = $1ILJK.getBestVersionForData(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $gAPR2.getSymbolSize(version);
    const modules = new $59qyF(moduleCount);
    // Add function modules
    $5f2127839fe01a16$var$setupFinderPattern(modules, version);
    $5f2127839fe01a16$var$setupTimingPattern(modules);
    $5f2127839fe01a16$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $5f2127839fe01a16$var$setupVersionInfo(modules, version);
    // Add data codewords
    $5f2127839fe01a16$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $2EgxG.getBestMask(modules, $5f2127839fe01a16$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $2EgxG.applyMask(maskPattern, modules);
    // Replace format info bits with correct values
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$5f2127839fe01a16$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = $i2Grt.M;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $i2Grt.from(options.errorCorrectionLevel, $i2Grt.M);
        version = $1ILJK.from(options.version);
        mask = $2EgxG.from(options.maskPattern);
        if (options.toSJISFunc) $gAPR2.setToSJISFunction(options.toSJISFunc);
    }
    return $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, mask);
};

});
parcelRegister("gAPR2", function(module, exports) {

$parcel$export(module.exports, "getSymbolSize", () => $c1483b5b1305278f$export$8d4a06d3facd414b, (v) => $c1483b5b1305278f$export$8d4a06d3facd414b = v);
$parcel$export(module.exports, "getSymbolTotalCodewords", () => $c1483b5b1305278f$export$b05dac13c7a35c32, (v) => $c1483b5b1305278f$export$b05dac13c7a35c32 = v);
$parcel$export(module.exports, "getBCHDigit", () => $c1483b5b1305278f$export$ed1d66da50968976, (v) => $c1483b5b1305278f$export$ed1d66da50968976 = v);
$parcel$export(module.exports, "setToSJISFunction", () => $c1483b5b1305278f$export$6733b14783f975c2, (v) => $c1483b5b1305278f$export$6733b14783f975c2 = v);
$parcel$export(module.exports, "isKanjiModeEnabled", () => $c1483b5b1305278f$export$ce5b1274f8597fa0, (v) => $c1483b5b1305278f$export$ce5b1274f8597fa0 = v);
$parcel$export(module.exports, "toSJIS", () => $c1483b5b1305278f$export$43dd553ecded716d, (v) => $c1483b5b1305278f$export$43dd553ecded716d = v);
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $c1483b5b1305278f$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $c1483b5b1305278f$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $c1483b5b1305278f$export$ed1d66da50968976;
var $c1483b5b1305278f$export$6733b14783f975c2;
var $c1483b5b1305278f$export$ce5b1274f8597fa0;
var $c1483b5b1305278f$export$43dd553ecded716d;
let $c1483b5b1305278f$var$toSJISFunction;
const $c1483b5b1305278f$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$c1483b5b1305278f$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$c1483b5b1305278f$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $c1483b5b1305278f$var$CODEWORDS_COUNT[version];
};
$c1483b5b1305278f$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$c1483b5b1305278f$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $c1483b5b1305278f$var$toSJISFunction = f;
};
$c1483b5b1305278f$export$ce5b1274f8597fa0 = function() {
    return typeof $c1483b5b1305278f$var$toSJISFunction !== "undefined";
};
$c1483b5b1305278f$export$43dd553ecded716d = function toSJIS(kanji) {
    return $c1483b5b1305278f$var$toSJISFunction(kanji);
};

});

parcelRegister("i2Grt", function(module, exports) {

$parcel$export(module.exports, "L", () => $d22956012916b666$export$61196ced6d74a310, (v) => $d22956012916b666$export$61196ced6d74a310 = v);
$parcel$export(module.exports, "M", () => $d22956012916b666$export$3a1a48c8f6ef640e, (v) => $d22956012916b666$export$3a1a48c8f6ef640e = v);
$parcel$export(module.exports, "Q", () => $d22956012916b666$export$3722cfe417b6ed86, (v) => $d22956012916b666$export$3722cfe417b6ed86 = v);
$parcel$export(module.exports, "H", () => $d22956012916b666$export$7f8ddf7c7c20b3cd, (v) => $d22956012916b666$export$7f8ddf7c7c20b3cd = v);
$parcel$export(module.exports, "isValid", () => $d22956012916b666$export$1ea939691cdc45b8, (v) => $d22956012916b666$export$1ea939691cdc45b8 = v);
$parcel$export(module.exports, "from", () => $d22956012916b666$export$6788812c4e6611e6, (v) => $d22956012916b666$export$6788812c4e6611e6 = v);
var $d22956012916b666$export$61196ced6d74a310;
var $d22956012916b666$export$3a1a48c8f6ef640e;
var $d22956012916b666$export$3722cfe417b6ed86;
var $d22956012916b666$export$7f8ddf7c7c20b3cd;
var $d22956012916b666$export$1ea939691cdc45b8;
var $d22956012916b666$export$6788812c4e6611e6;
$d22956012916b666$export$61196ced6d74a310 = {
    bit: 1
};
$d22956012916b666$export$3a1a48c8f6ef640e = {
    bit: 0
};
$d22956012916b666$export$3722cfe417b6ed86 = {
    bit: 3
};
$d22956012916b666$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $d22956012916b666$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $d22956012916b666$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $d22956012916b666$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $d22956012916b666$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $d22956012916b666$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$d22956012916b666$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$d22956012916b666$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($d22956012916b666$export$1ea939691cdc45b8(value)) return value;
    try {
        return $d22956012916b666$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});

parcelRegister("2Yr7q", function(module, exports) {
function $22a6389bcfc83921$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$22a6389bcfc83921$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
module.exports = $22a6389bcfc83921$var$BitBuffer;

});

parcelRegister("59qyF", function(module, exports) {
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $3c0264e2c9c64d36$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
module.exports = $3c0264e2c9c64d36$var$BitMatrix;

});

parcelRegister("gEXbH", function(module, exports) {

$parcel$export(module.exports, "getRowColCoords", () => $c20e4b3185223698$export$cb05537eb8e57a83, (v) => $c20e4b3185223698$export$cb05537eb8e57a83 = v);
$parcel$export(module.exports, "getPositions", () => $c20e4b3185223698$export$c39457c570f2b189, (v) => $c20e4b3185223698$export$c39457c570f2b189 = v);
/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $c20e4b3185223698$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $c20e4b3185223698$export$c39457c570f2b189;

var $gAPR2 = parcelRequire("gAPR2");
var $c20e4b3185223698$require$getSymbolSize = $gAPR2.getSymbolSize;
$c20e4b3185223698$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $c20e4b3185223698$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$c20e4b3185223698$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $c20e4b3185223698$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};

});

parcelRegister("fuRP0", function(module, exports) {

$parcel$export(module.exports, "getPositions", () => $b4836838cc492349$export$c39457c570f2b189, (v) => $b4836838cc492349$export$c39457c570f2b189 = v);
/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $b4836838cc492349$export$c39457c570f2b189;

var $gAPR2 = parcelRequire("gAPR2");
var $b4836838cc492349$require$getSymbolSize = $gAPR2.getSymbolSize;
const $b4836838cc492349$var$FINDER_PATTERN_SIZE = 7;
$b4836838cc492349$export$c39457c570f2b189 = function getPositions(version) {
    const size = $b4836838cc492349$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE
        ]
    ];
};

});

parcelRegister("2EgxG", function(module, exports) {

$parcel$export(module.exports, "Patterns", () => $1edc2624fba191d0$export$7ed115685df827af, (v) => $1edc2624fba191d0$export$7ed115685df827af = v);
$parcel$export(module.exports, "isValid", () => $1edc2624fba191d0$export$1ea939691cdc45b8, (v) => $1edc2624fba191d0$export$1ea939691cdc45b8 = v);
$parcel$export(module.exports, "from", () => $1edc2624fba191d0$export$6788812c4e6611e6, (v) => $1edc2624fba191d0$export$6788812c4e6611e6 = v);
$parcel$export(module.exports, "getPenaltyN1", () => $1edc2624fba191d0$export$a5fd3a02c14d0b3e, (v) => $1edc2624fba191d0$export$a5fd3a02c14d0b3e = v);
$parcel$export(module.exports, "getPenaltyN2", () => $1edc2624fba191d0$export$9a9385107a518e46, (v) => $1edc2624fba191d0$export$9a9385107a518e46 = v);
$parcel$export(module.exports, "getPenaltyN3", () => $1edc2624fba191d0$export$ade754353f0dc75e, (v) => $1edc2624fba191d0$export$ade754353f0dc75e = v);
$parcel$export(module.exports, "getPenaltyN4", () => $1edc2624fba191d0$export$3ff6f04d40d9962b, (v) => $1edc2624fba191d0$export$3ff6f04d40d9962b = v);
$parcel$export(module.exports, "applyMask", () => $1edc2624fba191d0$export$a1c9aa9c0e8ba394, (v) => $1edc2624fba191d0$export$a1c9aa9c0e8ba394 = v);
$parcel$export(module.exports, "getBestMask", () => $1edc2624fba191d0$export$fe9625aaceb0e563, (v) => $1edc2624fba191d0$export$fe9625aaceb0e563 = v);
/**
 * Data mask pattern reference
 * @type {Object}
 */ var $1edc2624fba191d0$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $1edc2624fba191d0$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $1edc2624fba191d0$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $1edc2624fba191d0$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $1edc2624fba191d0$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $1edc2624fba191d0$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $1edc2624fba191d0$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $1edc2624fba191d0$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $1edc2624fba191d0$export$fe9625aaceb0e563;
$1edc2624fba191d0$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $1edc2624fba191d0$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$1edc2624fba191d0$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$1edc2624fba191d0$export$6788812c4e6611e6 = function from(value) {
    return $1edc2624fba191d0$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$1edc2624fba191d0$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$1edc2624fba191d0$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N2;
};
$1edc2624fba191d0$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N3;
};
$1edc2624fba191d0$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $1edc2624fba191d0$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $1edc2624fba191d0$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$1edc2624fba191d0$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $1edc2624fba191d0$var$getMaskAt(pattern, row, col));
    }
};
$1edc2624fba191d0$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($1edc2624fba191d0$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $1edc2624fba191d0$export$a5fd3a02c14d0b3e(data) + $1edc2624fba191d0$export$9a9385107a518e46(data) + $1edc2624fba191d0$export$ade754353f0dc75e(data) + $1edc2624fba191d0$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};

});

parcelRegister("aWGUA", function(module, exports) {

$parcel$export(module.exports, "getBlocksCount", () => $7f809b8d8966b945$export$41a1fc627aca72b9, (v) => $7f809b8d8966b945$export$41a1fc627aca72b9 = v);
$parcel$export(module.exports, "getTotalCodewordsCount", () => $7f809b8d8966b945$export$683d1b3e8a1a8438, (v) => $7f809b8d8966b945$export$683d1b3e8a1a8438 = v);
/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $7f809b8d8966b945$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $7f809b8d8966b945$export$683d1b3e8a1a8438;

var $i2Grt = parcelRequire("i2Grt");
const $7f809b8d8966b945$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $7f809b8d8966b945$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$7f809b8d8966b945$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $i2Grt.L:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $i2Grt.M:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $i2Grt.Q:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $i2Grt.H:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$7f809b8d8966b945$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $i2Grt.L:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $i2Grt.M:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $i2Grt.Q:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $i2Grt.H:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};

});

parcelRegister("ziz9l", function(module, exports) {

var $cPckW = parcelRequire("cPckW");
function $06a1abce65162dc0$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $cPckW.generateECPolynomial(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $cPckW.mod(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
module.exports = $06a1abce65162dc0$var$ReedSolomonEncoder;

});
parcelRegister("cPckW", function(module, exports) {

$parcel$export(module.exports, "mul", () => $9563d144998a4c78$export$6e3a27864ab166fe, (v) => $9563d144998a4c78$export$6e3a27864ab166fe = v);
$parcel$export(module.exports, "mod", () => $9563d144998a4c78$export$842a2cf37af977e1, (v) => $9563d144998a4c78$export$842a2cf37af977e1 = v);
$parcel$export(module.exports, "generateECPolynomial", () => $9563d144998a4c78$export$7b8be06a973a9d05, (v) => $9563d144998a4c78$export$7b8be06a973a9d05 = v);
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $9563d144998a4c78$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $9563d144998a4c78$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $9563d144998a4c78$export$7b8be06a973a9d05;

var $a5KSf = parcelRequire("a5KSf");
$9563d144998a4c78$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $a5KSf.mul(p1[i], p2[j]);
    return coeff;
};
$9563d144998a4c78$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $a5KSf.mul(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$9563d144998a4c78$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $9563d144998a4c78$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $a5KSf.exp(i)
    ]));
    return poly;
};

});
parcelRegister("a5KSf", function(module, exports) {

$parcel$export(module.exports, "exp", () => $758ebb328fd03b3c$export$b310ec824aaee37f, (v) => $758ebb328fd03b3c$export$b310ec824aaee37f = v);
$parcel$export(module.exports, "mul", () => $758ebb328fd03b3c$export$6e3a27864ab166fe, (v) => $758ebb328fd03b3c$export$6e3a27864ab166fe = v);
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $758ebb328fd03b3c$export$6e3a27864ab166fe;
const $758ebb328fd03b3c$var$EXP_TABLE = new Uint8Array(512);
const $758ebb328fd03b3c$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $758ebb328fd03b3c$var$EXP_TABLE[i] = x;
        $758ebb328fd03b3c$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$758ebb328fd03b3c$var$EXP_TABLE[i] = $758ebb328fd03b3c$var$EXP_TABLE[i - 255];
})();
$758ebb328fd03b3c$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $758ebb328fd03b3c$var$LOG_TABLE[n];
};
$758ebb328fd03b3c$export$b310ec824aaee37f = function exp(n) {
    return $758ebb328fd03b3c$var$EXP_TABLE[n];
};
$758ebb328fd03b3c$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $758ebb328fd03b3c$var$EXP_TABLE[$758ebb328fd03b3c$var$LOG_TABLE[x] + $758ebb328fd03b3c$var$LOG_TABLE[y]];
};

});



parcelRegister("1ILJK", function(module, exports) {

$parcel$export(module.exports, "getCapacity", () => $140eee110ea3b5f9$export$55b283886ec2d3fb, (v) => $140eee110ea3b5f9$export$55b283886ec2d3fb = v);
$parcel$export(module.exports, "from", () => $140eee110ea3b5f9$export$6788812c4e6611e6, (v) => $140eee110ea3b5f9$export$6788812c4e6611e6 = v);
$parcel$export(module.exports, "getBestVersionForData", () => $140eee110ea3b5f9$export$264e969aa7a8ff7e, (v) => $140eee110ea3b5f9$export$264e969aa7a8ff7e = v);
$parcel$export(module.exports, "getEncodedBits", () => $140eee110ea3b5f9$export$eee5438974ef6f0e, (v) => $140eee110ea3b5f9$export$eee5438974ef6f0e = v);
/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $140eee110ea3b5f9$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $140eee110ea3b5f9$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $140eee110ea3b5f9$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $140eee110ea3b5f9$export$eee5438974ef6f0e;

var $gAPR2 = parcelRequire("gAPR2");

var $aWGUA = parcelRequire("aWGUA");

var $i2Grt = parcelRequire("i2Grt");

var $2UpRK = parcelRequire("2UpRK");

var $aUgu3 = parcelRequire("aUgu3");
// Generator polynomial used to encode version information
const $140eee110ea3b5f9$var$G18 = 7973;
const $140eee110ea3b5f9$var$G18_BCH = $gAPR2.getBCHDigit($140eee110ea3b5f9$var$G18);
function $140eee110ea3b5f9$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $140eee110ea3b5f9$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $2UpRK.getCharCountIndicator(mode, version) + 4;
}
function $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $140eee110ea3b5f9$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $140eee110ea3b5f9$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $2UpRK.MIXED)) return currentVersion;
    }
    return undefined;
}
$140eee110ea3b5f9$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($aUgu3.isValid(value)) return parseInt(value, 10);
    return defaultValue;
};
$140eee110ea3b5f9$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$aUgu3.isValid(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $2UpRK.BYTE;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $gAPR2.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $aWGUA.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $2UpRK.MIXED) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $140eee110ea3b5f9$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $2UpRK.NUMERIC:
            return Math.floor(usableBits / 10 * 3);
        case $2UpRK.ALPHANUMERIC:
            return Math.floor(usableBits / 11 * 2);
        case $2UpRK.KANJI:
            return Math.floor(usableBits / 13);
        case $2UpRK.BYTE:
        default:
            return Math.floor(usableBits / 8);
    }
};
$140eee110ea3b5f9$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $i2Grt.from(errorCorrectionLevel, $i2Grt.M);
    if (Array.isArray(data)) {
        if (data.length > 1) return $140eee110ea3b5f9$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $140eee110ea3b5f9$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$140eee110ea3b5f9$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$aUgu3.isValid(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while($gAPR2.getBCHDigit(d) - $140eee110ea3b5f9$var$G18_BCH >= 0)d ^= $140eee110ea3b5f9$var$G18 << $gAPR2.getBCHDigit(d) - $140eee110ea3b5f9$var$G18_BCH;
    return version << 12 | d;
};

});
parcelRegister("2UpRK", function(module, exports) {

$parcel$export(module.exports, "NUMERIC", () => $21e4e023abb588c2$export$4d318981b5a83836, (v) => $21e4e023abb588c2$export$4d318981b5a83836 = v);
$parcel$export(module.exports, "ALPHANUMERIC", () => $21e4e023abb588c2$export$376a9ed239d6c1c8, (v) => $21e4e023abb588c2$export$376a9ed239d6c1c8 = v);
$parcel$export(module.exports, "BYTE", () => $21e4e023abb588c2$export$8f4bf8f7eb581284, (v) => $21e4e023abb588c2$export$8f4bf8f7eb581284 = v);
$parcel$export(module.exports, "KANJI", () => $21e4e023abb588c2$export$a4d452c2363c8e12, (v) => $21e4e023abb588c2$export$a4d452c2363c8e12 = v);
$parcel$export(module.exports, "MIXED", () => $21e4e023abb588c2$export$bb410559a65d3418, (v) => $21e4e023abb588c2$export$bb410559a65d3418 = v);
$parcel$export(module.exports, "getCharCountIndicator", () => $21e4e023abb588c2$export$e79764af6ffaeb8d, (v) => $21e4e023abb588c2$export$e79764af6ffaeb8d = v);
$parcel$export(module.exports, "getBestModeForData", () => $21e4e023abb588c2$export$1bd4c93ffb42e55e, (v) => $21e4e023abb588c2$export$1bd4c93ffb42e55e = v);
$parcel$export(module.exports, "toString", () => $21e4e023abb588c2$export$f84e8e69fd4488a5, (v) => $21e4e023abb588c2$export$f84e8e69fd4488a5 = v);
$parcel$export(module.exports, "isValid", () => $21e4e023abb588c2$export$1ea939691cdc45b8, (v) => $21e4e023abb588c2$export$1ea939691cdc45b8 = v);
$parcel$export(module.exports, "from", () => $21e4e023abb588c2$export$6788812c4e6611e6, (v) => $21e4e023abb588c2$export$6788812c4e6611e6 = v);
/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $21e4e023abb588c2$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $21e4e023abb588c2$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $21e4e023abb588c2$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $21e4e023abb588c2$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $21e4e023abb588c2$export$6788812c4e6611e6;

var $aUgu3 = parcelRequire("aUgu3");

var $if0aV = parcelRequire("if0aV");
$21e4e023abb588c2$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$21e4e023abb588c2$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$21e4e023abb588c2$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$21e4e023abb588c2$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$21e4e023abb588c2$export$bb410559a65d3418 = {
    bit: -1
};
$21e4e023abb588c2$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$aUgu3.isValid(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$21e4e023abb588c2$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($if0aV.testNumeric(dataStr)) return $21e4e023abb588c2$export$4d318981b5a83836;
    else if ($if0aV.testAlphanumeric(dataStr)) return $21e4e023abb588c2$export$376a9ed239d6c1c8;
    else if ($if0aV.testKanji(dataStr)) return $21e4e023abb588c2$export$a4d452c2363c8e12;
    else return $21e4e023abb588c2$export$8f4bf8f7eb581284;
};
$21e4e023abb588c2$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$21e4e023abb588c2$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $21e4e023abb588c2$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $21e4e023abb588c2$export$4d318981b5a83836;
        case "alphanumeric":
            return $21e4e023abb588c2$export$376a9ed239d6c1c8;
        case "kanji":
            return $21e4e023abb588c2$export$a4d452c2363c8e12;
        case "byte":
            return $21e4e023abb588c2$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$21e4e023abb588c2$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($21e4e023abb588c2$export$1ea939691cdc45b8(value)) return value;
    try {
        return $21e4e023abb588c2$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});
parcelRegister("aUgu3", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $7f0bebb05133540b$export$1ea939691cdc45b8, (v) => $7f0bebb05133540b$export$1ea939691cdc45b8 = v);
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $7f0bebb05133540b$export$1ea939691cdc45b8;
$7f0bebb05133540b$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};

});

parcelRegister("if0aV", function(module, exports) {

$parcel$export(module.exports, "KANJI", () => $d479c387334094fb$export$a4d452c2363c8e12, (v) => $d479c387334094fb$export$a4d452c2363c8e12 = v);
$parcel$export(module.exports, "BYTE_KANJI", () => $d479c387334094fb$export$9df7c29d562bab83, (v) => $d479c387334094fb$export$9df7c29d562bab83 = v);
$parcel$export(module.exports, "BYTE", () => $d479c387334094fb$export$8f4bf8f7eb581284, (v) => $d479c387334094fb$export$8f4bf8f7eb581284 = v);
$parcel$export(module.exports, "NUMERIC", () => $d479c387334094fb$export$4d318981b5a83836, (v) => $d479c387334094fb$export$4d318981b5a83836 = v);
$parcel$export(module.exports, "ALPHANUMERIC", () => $d479c387334094fb$export$376a9ed239d6c1c8, (v) => $d479c387334094fb$export$376a9ed239d6c1c8 = v);
$parcel$export(module.exports, "testKanji", () => $d479c387334094fb$export$175f16aef75a4569, (v) => $d479c387334094fb$export$175f16aef75a4569 = v);
$parcel$export(module.exports, "testNumeric", () => $d479c387334094fb$export$50b7f9bf92c74274, (v) => $d479c387334094fb$export$50b7f9bf92c74274 = v);
$parcel$export(module.exports, "testAlphanumeric", () => $d479c387334094fb$export$4ba5f52893b4ac97, (v) => $d479c387334094fb$export$4ba5f52893b4ac97 = v);
var $d479c387334094fb$export$a4d452c2363c8e12;
var $d479c387334094fb$export$9df7c29d562bab83;
var $d479c387334094fb$export$8f4bf8f7eb581284;
var $d479c387334094fb$export$4d318981b5a83836;
var $d479c387334094fb$export$376a9ed239d6c1c8;
var $d479c387334094fb$export$175f16aef75a4569;
var $d479c387334094fb$export$50b7f9bf92c74274;
var $d479c387334094fb$export$4ba5f52893b4ac97;
const $d479c387334094fb$var$numeric = "[0-9]+";
const $d479c387334094fb$var$alphanumeric = "[A-Z $%*+\\-./:]+";
let $d479c387334094fb$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$d479c387334094fb$var$kanji = $d479c387334094fb$var$kanji.replace(/u/g, "\\u");
const $d479c387334094fb$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $d479c387334094fb$var$kanji + ")(?:.|[\r\n]))+";
$d479c387334094fb$export$a4d452c2363c8e12 = new RegExp($d479c387334094fb$var$kanji, "g");
$d479c387334094fb$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$d479c387334094fb$export$8f4bf8f7eb581284 = new RegExp($d479c387334094fb$var$byte, "g");
$d479c387334094fb$export$4d318981b5a83836 = new RegExp($d479c387334094fb$var$numeric, "g");
$d479c387334094fb$export$376a9ed239d6c1c8 = new RegExp($d479c387334094fb$var$alphanumeric, "g");
const $d479c387334094fb$var$TEST_KANJI = new RegExp("^" + $d479c387334094fb$var$kanji + "$");
const $d479c387334094fb$var$TEST_NUMERIC = new RegExp("^" + $d479c387334094fb$var$numeric + "$");
const $d479c387334094fb$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$d479c387334094fb$export$175f16aef75a4569 = function testKanji(str) {
    return $d479c387334094fb$var$TEST_KANJI.test(str);
};
$d479c387334094fb$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $d479c387334094fb$var$TEST_NUMERIC.test(str);
};
$d479c387334094fb$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $d479c387334094fb$var$TEST_ALPHANUMERIC.test(str);
};

});



parcelRegister("2HRKe", function(module, exports) {

$parcel$export(module.exports, "getEncodedBits", () => $1f894980312e7d2a$export$eee5438974ef6f0e, (v) => $1f894980312e7d2a$export$eee5438974ef6f0e = v);
/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $1f894980312e7d2a$export$eee5438974ef6f0e;

var $gAPR2 = parcelRequire("gAPR2");
const $1f894980312e7d2a$var$G15 = 1335;
const $1f894980312e7d2a$var$G15_MASK = 21522;
const $1f894980312e7d2a$var$G15_BCH = $gAPR2.getBCHDigit($1f894980312e7d2a$var$G15);
$1f894980312e7d2a$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($gAPR2.getBCHDigit(d) - $1f894980312e7d2a$var$G15_BCH >= 0)d ^= $1f894980312e7d2a$var$G15 << $gAPR2.getBCHDigit(d) - $1f894980312e7d2a$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $1f894980312e7d2a$var$G15_MASK;
};

});

parcelRegister("zJRcv", function(module, exports) {

$parcel$export(module.exports, "fromArray", () => $06b6d7424b9df2df$export$571d59b505e6bb4e, (v) => $06b6d7424b9df2df$export$571d59b505e6bb4e = v);
$parcel$export(module.exports, "fromString", () => $06b6d7424b9df2df$export$3004f64547af360e, (v) => $06b6d7424b9df2df$export$3004f64547af360e = v);
$parcel$export(module.exports, "rawSplit", () => $06b6d7424b9df2df$export$89ab1afb9839589b, (v) => $06b6d7424b9df2df$export$89ab1afb9839589b = v);
/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $06b6d7424b9df2df$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $06b6d7424b9df2df$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $06b6d7424b9df2df$export$89ab1afb9839589b;

var $2UpRK = parcelRequire("2UpRK");

var $avjb5 = parcelRequire("avjb5");

var $l9d7a = parcelRequire("l9d7a");

var $6aVeG = parcelRequire("6aVeG");

var $8NLQr = parcelRequire("8NLQr");

var $if0aV = parcelRequire("if0aV");

var $gAPR2 = parcelRequire("gAPR2");

var $9hr6W = parcelRequire("9hr6W");
/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $06b6d7424b9df2df$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegmentsFromString(dataStr) {
    const numSegs = $06b6d7424b9df2df$var$getSegments($if0aV.NUMERIC, $2UpRK.NUMERIC, dataStr);
    const alphaNumSegs = $06b6d7424b9df2df$var$getSegments($if0aV.ALPHANUMERIC, $2UpRK.ALPHANUMERIC, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($gAPR2.isKanjiModeEnabled()) {
        byteSegs = $06b6d7424b9df2df$var$getSegments($if0aV.BYTE, $2UpRK.BYTE, dataStr);
        kanjiSegs = $06b6d7424b9df2df$var$getSegments($if0aV.KANJI, $2UpRK.KANJI, dataStr);
    } else {
        byteSegs = $06b6d7424b9df2df$var$getSegments($if0aV.BYTE_KANJI, $2UpRK.BYTE, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $06b6d7424b9df2df$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $2UpRK.NUMERIC:
            return $avjb5.getBitsLength(length);
        case $2UpRK.ALPHANUMERIC:
            return $l9d7a.getBitsLength(length);
        case $2UpRK.KANJI:
            return $8NLQr.getBitsLength(length);
        case $2UpRK.BYTE:
            return $6aVeG.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $2UpRK.NUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $2UpRK.ALPHANUMERIC,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $2UpRK.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $2UpRK.ALPHANUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $2UpRK.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $2UpRK.KANJI:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $2UpRK.BYTE,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $2UpRK.BYTE:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $2UpRK.BYTE,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $06b6d7424b9df2df$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(node.length, node.mode) + 4 + $2UpRK.getCharCountIndicator(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $06b6d7424b9df2df$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $2UpRK.getBestModeForData(data);
    mode = $2UpRK.from(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $2UpRK.BYTE && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $2UpRK.toString(mode) + ".\n Suggested mode is: " + $2UpRK.toString(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $2UpRK.KANJI && !$gAPR2.isKanjiModeEnabled()) mode = $2UpRK.BYTE;
    switch(mode){
        case $2UpRK.NUMERIC:
            return new $avjb5(data);
        case $2UpRK.ALPHANUMERIC:
            return new $l9d7a(data);
        case $2UpRK.KANJI:
            return new $8NLQr(data);
        case $2UpRK.BYTE:
            return new $6aVeG(data);
    }
}
$06b6d7424b9df2df$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$06b6d7424b9df2df$export$3004f64547af360e = function fromString(data, version) {
    const segs = $06b6d7424b9df2df$var$getSegmentsFromString(data, $gAPR2.isKanjiModeEnabled());
    const nodes = $06b6d7424b9df2df$var$buildNodes(segs);
    const graph = $06b6d7424b9df2df$var$buildGraph(nodes, version);
    const path = $9hr6W.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$mergeSegments(optimizedSegs));
};
$06b6d7424b9df2df$export$89ab1afb9839589b = function rawSplit(data) {
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$getSegmentsFromString(data, $gAPR2.isKanjiModeEnabled()));
};

});
parcelRegister("avjb5", function(module, exports) {

var $2UpRK = parcelRequire("2UpRK");
function $7a5bacf4a539441d$var$NumericData(data) {
    this.mode = $2UpRK.NUMERIC;
    this.data = data.toString();
}
$7a5bacf4a539441d$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$7a5bacf4a539441d$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$7a5bacf4a539441d$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $7a5bacf4a539441d$var$NumericData.getBitsLength(this.data.length);
};
$7a5bacf4a539441d$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
module.exports = $7a5bacf4a539441d$var$NumericData;

});

parcelRegister("l9d7a", function(module, exports) {

var $2UpRK = parcelRequire("2UpRK");
/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $f6549c884fd9ace3$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $f6549c884fd9ace3$var$AlphanumericData(data) {
    this.mode = $2UpRK.ALPHANUMERIC;
    this.data = data;
}
$f6549c884fd9ace3$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $f6549c884fd9ace3$var$AlphanumericData.getBitsLength(this.data.length);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
module.exports = $f6549c884fd9ace3$var$AlphanumericData;

});

parcelRegister("6aVeG", function(module, exports) {

var $fB3iO = parcelRequire("fB3iO");

var $2UpRK = parcelRequire("2UpRK");
function $47f01312d66828cb$var$ByteData(data) {
    this.mode = $2UpRK.BYTE;
    if (typeof data === "string") data = $fB3iO(data);
    this.data = new Uint8Array(data);
}
$47f01312d66828cb$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$47f01312d66828cb$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$47f01312d66828cb$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $47f01312d66828cb$var$ByteData.getBitsLength(this.data.length);
};
$47f01312d66828cb$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
module.exports = $47f01312d66828cb$var$ByteData;

});
parcelRegister("fB3iO", function(module, exports) {
"use strict";
module.exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};

});


parcelRegister("8NLQr", function(module, exports) {

var $2UpRK = parcelRequire("2UpRK");

var $gAPR2 = parcelRequire("gAPR2");
function $668803520f2d7445$var$KanjiData(data) {
    this.mode = $2UpRK.KANJI;
    this.data = data;
}
$668803520f2d7445$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$668803520f2d7445$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$668803520f2d7445$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $668803520f2d7445$var$KanjiData.getBitsLength(this.data.length);
};
$668803520f2d7445$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $gAPR2.toSJIS(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
module.exports = $668803520f2d7445$var$KanjiData;

});

parcelRegister("9hr6W", function(module, exports) {
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $6c1abb425b529163$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $6c1abb425b529163$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $6c1abb425b529163$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $6c1abb425b529163$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $6c1abb425b529163$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
module.exports = $6c1abb425b529163$var$dijkstra;

});



parcelRegister("7bRLF", function(module, exports) {

$parcel$export(module.exports, "render", () => $53c344a5283c422c$export$b3890eb0ae9dca99, (v) => $53c344a5283c422c$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "renderToDataURL", () => $53c344a5283c422c$export$c3e5526bbaf70a25, (v) => $53c344a5283c422c$export$c3e5526bbaf70a25 = v);
var $53c344a5283c422c$export$b3890eb0ae9dca99;
var $53c344a5283c422c$export$c3e5526bbaf70a25;

var $hdBDw = parcelRequire("hdBDw");
function $53c344a5283c422c$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $53c344a5283c422c$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$53c344a5283c422c$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $53c344a5283c422c$var$getCanvasElement();
    opts = $hdBDw.getOptions(opts);
    const size = $hdBDw.getImageWidth(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    $hdBDw.qrToImageData(image.data, qrData, opts);
    $53c344a5283c422c$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$53c344a5283c422c$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $53c344a5283c422c$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};

});
parcelRegister("hdBDw", function(module, exports) {

$parcel$export(module.exports, "getOptions", () => $c890d85f31194258$export$d2312e68e1f5ad00, (v) => $c890d85f31194258$export$d2312e68e1f5ad00 = v);
$parcel$export(module.exports, "getScale", () => $c890d85f31194258$export$5cdac61cf538712e, (v) => $c890d85f31194258$export$5cdac61cf538712e = v);
$parcel$export(module.exports, "getImageWidth", () => $c890d85f31194258$export$c3a1a1f268a8142b, (v) => $c890d85f31194258$export$c3a1a1f268a8142b = v);
$parcel$export(module.exports, "qrToImageData", () => $c890d85f31194258$export$83136f57c739c5f3, (v) => $c890d85f31194258$export$83136f57c739c5f3 = v);
var $c890d85f31194258$export$d2312e68e1f5ad00;
var $c890d85f31194258$export$5cdac61cf538712e;
var $c890d85f31194258$export$c3a1a1f268a8142b;
var $c890d85f31194258$export$83136f57c739c5f3;
function $c890d85f31194258$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$c890d85f31194258$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $c890d85f31194258$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $c890d85f31194258$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$c890d85f31194258$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$c890d85f31194258$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $c890d85f31194258$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$c890d85f31194258$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $c890d85f31194258$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};

});


parcelRegister("4dczE", function(module, exports) {

$parcel$export(module.exports, "render", () => $3112213e4acbe245$export$b3890eb0ae9dca99, (v) => $3112213e4acbe245$export$b3890eb0ae9dca99 = v);
var $3112213e4acbe245$export$b3890eb0ae9dca99;

var $hdBDw = parcelRequire("hdBDw");
function $3112213e4acbe245$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $3112213e4acbe245$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $3112213e4acbe245$var$qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $3112213e4acbe245$var$svgCmd("M", col + margin, 0.5 + row + margin) : $3112213e4acbe245$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $3112213e4acbe245$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$3112213e4acbe245$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $hdBDw.getOptions(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + $3112213e4acbe245$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + $3112213e4acbe245$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $3112213e4acbe245$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};

});


var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("7B2bR"));


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error("^_^");
}

$11492dca620dcaa5$exports = (parcelRequire("3y30c"));


var $7e96a608cb33bf79$var$i = $11492dca620dcaa5$exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$7e96a608cb33bf79$export$882461b6382ed46c = function(c, o) {
    $7e96a608cb33bf79$var$i.usingClientEntryPoint = true;
    try {
        return $11492dca620dcaa5$exports.createRoot(c, o);
    } finally{
        $7e96a608cb33bf79$var$i.usingClientEntryPoint = false;
    }
};
$7e96a608cb33bf79$export$757ceba2d55c277e = function(c, h, o) {
    $7e96a608cb33bf79$var$i.usingClientEntryPoint = true;
    try {
        return $11492dca620dcaa5$exports.hydrateRoot(c, h, o);
    } finally{
        $7e96a608cb33bf79$var$i.usingClientEntryPoint = false;
    }
};



parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $396d828a707f29ff$exports = {};
"use strict";
var $396d828a707f29ff$var$__createBinding = $396d828a707f29ff$exports && $396d828a707f29ff$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $396d828a707f29ff$var$__exportStar = $396d828a707f29ff$exports && $396d828a707f29ff$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $396d828a707f29ff$var$__createBinding(exports1, m, p);
};
Object.defineProperty($396d828a707f29ff$exports, "__esModule", {
    value: true
});

$396d828a707f29ff$var$__exportStar((parcelRequire("dwO3n")), $396d828a707f29ff$exports);

$396d828a707f29ff$var$__exportStar((parcelRequire("5lryg")), $396d828a707f29ff$exports);

$396d828a707f29ff$var$__exportStar((parcelRequire("beQa5")), $396d828a707f29ff$exports);

$396d828a707f29ff$var$__exportStar((parcelRequire("7lRdT")), $396d828a707f29ff$exports);

$396d828a707f29ff$var$__exportStar((parcelRequire("6RLWI")), $396d828a707f29ff$exports);


var $aa2dfa8e6e1e6118$exports = {};
"use strict";
var $aa2dfa8e6e1e6118$var$__extends = $aa2dfa8e6e1e6118$exports && $aa2dfa8e6e1e6118$exports.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $aa2dfa8e6e1e6118$var$__importStar = $aa2dfa8e6e1e6118$exports && $aa2dfa8e6e1e6118$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty($aa2dfa8e6e1e6118$exports, "__esModule", {
    value: true
});
var $fa59cd666d8676fc$exports = {};
"use strict";
Object.defineProperty($fa59cd666d8676fc$exports, "__esModule", {
    value: true
});
var $fc46f7c7d8d74570$exports = {};
"use strict";
var $fc46f7c7d8d74570$var$__importDefault = $fc46f7c7d8d74570$exports && $fc46f7c7d8d74570$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $fc46f7c7d8d74570$var$__importStar = $fc46f7c7d8d74570$exports && $fc46f7c7d8d74570$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty($fc46f7c7d8d74570$exports, "__esModule", {
    value: true
});

/**
 *  BigNumber
 *
 *  A wrapper around the BN.js object. We use the BN.js library
 *  because it is used by elliptic, so it is required regardles.
 *
 */ var $fc46f7c7d8d74570$var$bn_js_1 = $fc46f7c7d8d74570$var$__importDefault((parcelRequire("dEXSZ")));
var $36f30ca1d30438a3$exports = {};
"use strict";
/**
 *  Conversion Utilities
 *
 */ var $36f30ca1d30438a3$var$__importStar = $36f30ca1d30438a3$exports && $36f30ca1d30438a3$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty($36f30ca1d30438a3$exports, "__esModule", {
    value: true
});

var $36f30ca1d30438a3$var$errors = $36f30ca1d30438a3$var$__importStar((parcelRequire("9OCA8")));
///////////////////////////////
function $36f30ca1d30438a3$var$isHexable(value) {
    return !!value.toHexString;
}
$36f30ca1d30438a3$exports.isHexable = $36f30ca1d30438a3$var$isHexable;
function $36f30ca1d30438a3$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        var args = Array.prototype.slice.call(arguments);
        return $36f30ca1d30438a3$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $36f30ca1d30438a3$var$isArrayish(value) {
    if (!value || parseInt(String(value.length)) != value.length || typeof value === "string") return false;
    for(var i = 0; i < value.length; i++){
        var v = value[i];
        if (v < 0 || v >= 256 || parseInt(String(v)) != v) return false;
    }
    return true;
}
$36f30ca1d30438a3$exports.isArrayish = $36f30ca1d30438a3$var$isArrayish;
function $36f30ca1d30438a3$var$arrayify(value) {
    if (value == null) $36f30ca1d30438a3$var$errors.throwError("cannot convert null value to array", $36f30ca1d30438a3$var$errors.INVALID_ARGUMENT, {
        arg: "value",
        value: value
    });
    if ($36f30ca1d30438a3$var$isHexable(value)) value = value.toHexString();
    if (typeof value === "string") {
        var match = value.match(/^(0x)?[0-9a-fA-F]*$/);
        if (!match) $36f30ca1d30438a3$var$errors.throwError("invalid hexidecimal string", $36f30ca1d30438a3$var$errors.INVALID_ARGUMENT, {
            arg: "value",
            value: value
        });
        if (match[1] !== "0x") $36f30ca1d30438a3$var$errors.throwError("hex string must have 0x prefix", $36f30ca1d30438a3$var$errors.INVALID_ARGUMENT, {
            arg: "value",
            value: value
        });
        value = value.substring(2);
        if (value.length % 2) value = "0" + value;
        var result = [];
        for(var i = 0; i < value.length; i += 2)result.push(parseInt(value.substr(i, 2), 16));
        return $36f30ca1d30438a3$var$addSlice(new Uint8Array(result));
    }
    if ($36f30ca1d30438a3$var$isArrayish(value)) return $36f30ca1d30438a3$var$addSlice(new Uint8Array(value));
    $36f30ca1d30438a3$var$errors.throwError("invalid arrayify value", null, {
        arg: "value",
        value: value,
        type: typeof value
    });
    return null;
}
$36f30ca1d30438a3$exports.arrayify = $36f30ca1d30438a3$var$arrayify;
function $36f30ca1d30438a3$var$concat(objects) {
    var arrays = [];
    var length = 0;
    for(var i = 0; i < objects.length; i++){
        var object = $36f30ca1d30438a3$var$arrayify(objects[i]);
        arrays.push(object);
        length += object.length;
    }
    var result = new Uint8Array(length);
    var offset = 0;
    for(var i = 0; i < arrays.length; i++){
        result.set(arrays[i], offset);
        offset += arrays[i].length;
    }
    return $36f30ca1d30438a3$var$addSlice(result);
}
$36f30ca1d30438a3$exports.concat = $36f30ca1d30438a3$var$concat;
function $36f30ca1d30438a3$var$stripZeros(value) {
    var result = $36f30ca1d30438a3$var$arrayify(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    var start = 0;
    while(result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
$36f30ca1d30438a3$exports.stripZeros = $36f30ca1d30438a3$var$stripZeros;
function $36f30ca1d30438a3$var$padZeros(value, length) {
    value = $36f30ca1d30438a3$var$arrayify(value);
    if (length < value.length) throw new Error("cannot pad");
    var result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $36f30ca1d30438a3$var$addSlice(result);
}
$36f30ca1d30438a3$exports.padZeros = $36f30ca1d30438a3$var$padZeros;
function $36f30ca1d30438a3$var$isHexString(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
$36f30ca1d30438a3$exports.isHexString = $36f30ca1d30438a3$var$isHexString;
var $36f30ca1d30438a3$var$HexCharacters = "0123456789abcdef";
function $36f30ca1d30438a3$var$hexlify(value) {
    if ($36f30ca1d30438a3$var$isHexable(value)) return value.toHexString();
    if (typeof value === "number") {
        if (value < 0) $36f30ca1d30438a3$var$errors.throwError("cannot hexlify negative value", $36f30ca1d30438a3$var$errors.INVALID_ARGUMENT, {
            arg: "value",
            value: value
        });
        // @TODO: Roll this into the above error as a numeric fault (overflow); next version, not backward compatible
        // We can about (value == MAX_INT) to as well, since that may indicate we underflowed already
        if (value >= 9007199254740991) $36f30ca1d30438a3$var$errors.throwError("out-of-range", $36f30ca1d30438a3$var$errors.NUMERIC_FAULT, {
            operartion: "hexlify",
            fault: "out-of-safe-range"
        });
        var hex = "";
        while(value){
            hex = $36f30ca1d30438a3$var$HexCharacters[value & 0x0f] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "string") {
        var match = value.match(/^(0x)?[0-9a-fA-F]*$/);
        if (!match) $36f30ca1d30438a3$var$errors.throwError("invalid hexidecimal string", $36f30ca1d30438a3$var$errors.INVALID_ARGUMENT, {
            arg: "value",
            value: value
        });
        if (match[1] !== "0x") $36f30ca1d30438a3$var$errors.throwError("hex string must have 0x prefix", $36f30ca1d30438a3$var$errors.INVALID_ARGUMENT, {
            arg: "value",
            value: value
        });
        if (value.length % 2) value = "0x0" + value.substring(2);
        return value;
    }
    if ($36f30ca1d30438a3$var$isArrayish(value)) {
        var result = [];
        for(var i = 0; i < value.length; i++){
            var v = value[i];
            result.push($36f30ca1d30438a3$var$HexCharacters[(v & 0xf0) >> 4] + $36f30ca1d30438a3$var$HexCharacters[v & 0x0f]);
        }
        return "0x" + result.join("");
    }
    $36f30ca1d30438a3$var$errors.throwError("invalid hexlify value", null, {
        arg: "value",
        value: value
    });
    return "never";
}
$36f30ca1d30438a3$exports.hexlify = $36f30ca1d30438a3$var$hexlify;
function $36f30ca1d30438a3$var$hexDataLength(data) {
    if (!$36f30ca1d30438a3$var$isHexString(data) || data.length % 2 !== 0) return null;
    return (data.length - 2) / 2;
}
$36f30ca1d30438a3$exports.hexDataLength = $36f30ca1d30438a3$var$hexDataLength;
function $36f30ca1d30438a3$var$hexDataSlice(data, offset, endOffset) {
    if (!$36f30ca1d30438a3$var$isHexString(data)) $36f30ca1d30438a3$var$errors.throwError("invalid hex data", $36f30ca1d30438a3$var$errors.INVALID_ARGUMENT, {
        arg: "value",
        value: data
    });
    if (data.length % 2 !== 0) $36f30ca1d30438a3$var$errors.throwError("hex data length must be even", $36f30ca1d30438a3$var$errors.INVALID_ARGUMENT, {
        arg: "value",
        value: data
    });
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
$36f30ca1d30438a3$exports.hexDataSlice = $36f30ca1d30438a3$var$hexDataSlice;
function $36f30ca1d30438a3$var$hexStripZeros(value) {
    if (!$36f30ca1d30438a3$var$isHexString(value)) $36f30ca1d30438a3$var$errors.throwError("invalid hex string", $36f30ca1d30438a3$var$errors.INVALID_ARGUMENT, {
        arg: "value",
        value: value
    });
    while(value.length > 3 && value.substring(0, 3) === "0x0")value = "0x" + value.substring(3);
    return value;
}
$36f30ca1d30438a3$exports.hexStripZeros = $36f30ca1d30438a3$var$hexStripZeros;
function $36f30ca1d30438a3$var$hexZeroPad(value, length) {
    if (!$36f30ca1d30438a3$var$isHexString(value)) $36f30ca1d30438a3$var$errors.throwError("invalid hex string", $36f30ca1d30438a3$var$errors.INVALID_ARGUMENT, {
        arg: "value",
        value: value
    });
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
$36f30ca1d30438a3$exports.hexZeroPad = $36f30ca1d30438a3$var$hexZeroPad;
function $36f30ca1d30438a3$var$isSignature(value) {
    return value && value.r != null && value.s != null;
}
function $36f30ca1d30438a3$var$splitSignature(signature) {
    var v = 0;
    var r = "0x", s = "0x";
    if ($36f30ca1d30438a3$var$isSignature(signature)) {
        if (signature.v == null && signature.recoveryParam == null) $36f30ca1d30438a3$var$errors.throwError("at least on of recoveryParam or v must be specified", $36f30ca1d30438a3$var$errors.INVALID_ARGUMENT, {
            argument: "signature",
            value: signature
        });
        r = $36f30ca1d30438a3$var$hexZeroPad(signature.r, 32);
        s = $36f30ca1d30438a3$var$hexZeroPad(signature.s, 32);
        v = signature.v;
        if (typeof v === "string") v = parseInt(v, 16);
        var recoveryParam = signature.recoveryParam;
        if (recoveryParam == null && signature.v != null) recoveryParam = 1 - v % 2;
        v = 27 + recoveryParam;
    } else {
        var bytes = $36f30ca1d30438a3$var$arrayify(signature);
        if (bytes.length !== 65) throw new Error("invalid signature");
        r = $36f30ca1d30438a3$var$hexlify(bytes.slice(0, 32));
        s = $36f30ca1d30438a3$var$hexlify(bytes.slice(32, 64));
        v = bytes[64];
        if (v !== 27 && v !== 28) v = 27 + v % 2;
    }
    return {
        r: r,
        s: s,
        recoveryParam: v - 27,
        v: v
    };
}
$36f30ca1d30438a3$exports.splitSignature = $36f30ca1d30438a3$var$splitSignature;
function $36f30ca1d30438a3$var$joinSignature(signature) {
    signature = $36f30ca1d30438a3$var$splitSignature(signature);
    return $36f30ca1d30438a3$var$hexlify($36f30ca1d30438a3$var$concat([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}
$36f30ca1d30438a3$exports.joinSignature = $36f30ca1d30438a3$var$joinSignature;


var $6dadc4810a2babb6$exports = {};
"use strict";
var $6dadc4810a2babb6$var$__importStar = $6dadc4810a2babb6$exports && $6dadc4810a2babb6$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty($6dadc4810a2babb6$exports, "__esModule", {
    value: true
});

var $6dadc4810a2babb6$var$errors = $6dadc4810a2babb6$var$__importStar((parcelRequire("9OCA8")));
function $6dadc4810a2babb6$var$defineReadOnly(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
$6dadc4810a2babb6$exports.defineReadOnly = $6dadc4810a2babb6$var$defineReadOnly;
// There are some issues with instanceof with npm link, so we use this
// to ensure types are what we expect.
function $6dadc4810a2babb6$var$setType(object, type) {
    Object.defineProperty(object, "_ethersType", {
        configurable: false,
        value: type,
        writable: false
    });
}
$6dadc4810a2babb6$exports.setType = $6dadc4810a2babb6$var$setType;
function $6dadc4810a2babb6$var$isType(object, type) {
    return object && object._ethersType === type;
}
$6dadc4810a2babb6$exports.isType = $6dadc4810a2babb6$var$isType;
function $6dadc4810a2babb6$var$resolveProperties(object) {
    var result = {};
    var promises = [];
    Object.keys(object).forEach(function(key) {
        var value = object[key];
        if (value instanceof Promise) promises.push(value.then(function(value) {
            result[key] = value;
            return null;
        }));
        else result[key] = value;
    });
    return Promise.all(promises).then(function() {
        return result;
    });
}
$6dadc4810a2babb6$exports.resolveProperties = $6dadc4810a2babb6$var$resolveProperties;
function $6dadc4810a2babb6$var$checkProperties(object, properties) {
    if (!object || typeof object !== "object") $6dadc4810a2babb6$var$errors.throwError("invalid object", $6dadc4810a2babb6$var$errors.INVALID_ARGUMENT, {
        argument: "object",
        value: object
    });
    Object.keys(object).forEach(function(key) {
        if (!properties[key]) $6dadc4810a2babb6$var$errors.throwError("invalid object key - " + key, $6dadc4810a2babb6$var$errors.INVALID_ARGUMENT, {
            argument: "transaction",
            value: object,
            key: key
        });
    });
}
$6dadc4810a2babb6$exports.checkProperties = $6dadc4810a2babb6$var$checkProperties;
function $6dadc4810a2babb6$var$shallowCopy(object) {
    var result = {};
    for(var key in object)result[key] = object[key];
    return result;
}
$6dadc4810a2babb6$exports.shallowCopy = $6dadc4810a2babb6$var$shallowCopy;
var $6dadc4810a2babb6$var$opaque = {
    boolean: true,
    number: true,
    string: true
};
function $6dadc4810a2babb6$var$deepCopy(object, frozen) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $6dadc4810a2babb6$var$opaque[typeof object]) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) {
        var result = object.map(function(item) {
            return $6dadc4810a2babb6$var$deepCopy(item, frozen);
        });
        if (frozen) Object.freeze(result);
        return result;
    }
    if (typeof object === "object") {
        // Some internal objects, which are already immutable
        if ($6dadc4810a2babb6$var$isType(object, "BigNumber")) return object;
        if ($6dadc4810a2babb6$var$isType(object, "Description")) return object;
        if ($6dadc4810a2babb6$var$isType(object, "Indexed")) return object;
        var result = {};
        for(var key in object){
            var value = object[key];
            if (value === undefined) continue;
            $6dadc4810a2babb6$var$defineReadOnly(result, key, $6dadc4810a2babb6$var$deepCopy(value, frozen));
        }
        if (frozen) Object.freeze(result);
        return result;
    }
    // The function type is also immutable, so safe to copy by assignment
    if (typeof object === "function") return object;
    throw new Error("Cannot deepCopy " + typeof object);
}
$6dadc4810a2babb6$exports.deepCopy = $6dadc4810a2babb6$var$deepCopy;
// See: https://github.com/isaacs/inherits/blob/master/inherits_browser.js
function $6dadc4810a2babb6$var$inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
}
function $6dadc4810a2babb6$var$inheritable(parent) {
    return function(child) {
        $6dadc4810a2babb6$var$inherits(child, parent);
        $6dadc4810a2babb6$var$defineReadOnly(child, "inherits", $6dadc4810a2babb6$var$inheritable(child));
    };
}
$6dadc4810a2babb6$exports.inheritable = $6dadc4810a2babb6$var$inheritable;



var $fc46f7c7d8d74570$var$errors = $fc46f7c7d8d74570$var$__importStar((parcelRequire("9OCA8")));
var $fc46f7c7d8d74570$var$BN_1 = new $fc46f7c7d8d74570$var$bn_js_1.default.BN(-1);
function $fc46f7c7d8d74570$var$toHex(bn) {
    var value = bn.toString(16);
    if (value[0] === "-") {
        if (value.length % 2 === 0) return "-0x0" + value.substring(1);
        return "-0x" + value.substring(1);
    }
    if (value.length % 2 === 1) return "0x0" + value;
    return "0x" + value;
}
function $fc46f7c7d8d74570$var$toBN(value) {
    return $fc46f7c7d8d74570$var$_bnify($fc46f7c7d8d74570$var$bigNumberify(value));
}
function $fc46f7c7d8d74570$var$toBigNumber(bn) {
    return new $fc46f7c7d8d74570$var$BigNumber($fc46f7c7d8d74570$var$toHex(bn));
}
function $fc46f7c7d8d74570$var$_bnify(value) {
    var hex = value._hex;
    if (hex[0] === "-") return new $fc46f7c7d8d74570$var$bn_js_1.default.BN(hex.substring(3), 16).mul($fc46f7c7d8d74570$var$BN_1);
    return new $fc46f7c7d8d74570$var$bn_js_1.default.BN(hex.substring(2), 16);
}
var $fc46f7c7d8d74570$var$BigNumber = /** @class */ function() {
    function BigNumber(value) {
        $fc46f7c7d8d74570$var$errors.checkNew(this, BigNumber);
        $6dadc4810a2babb6$exports.setType(this, "BigNumber");
        if (typeof value === "string") {
            if ($36f30ca1d30438a3$exports.isHexString(value)) {
                if (value == "0x") value = "0x0";
                $6dadc4810a2babb6$exports.defineReadOnly(this, "_hex", value);
            } else if (value[0] === "-" && $36f30ca1d30438a3$exports.isHexString(value.substring(1))) $6dadc4810a2babb6$exports.defineReadOnly(this, "_hex", value);
            else if (value.match(/^-?[0-9]*$/)) {
                if (value == "") value = "0";
                $6dadc4810a2babb6$exports.defineReadOnly(this, "_hex", $fc46f7c7d8d74570$var$toHex(new $fc46f7c7d8d74570$var$bn_js_1.default.BN(value)));
            } else $fc46f7c7d8d74570$var$errors.throwError("invalid BigNumber string value", $fc46f7c7d8d74570$var$errors.INVALID_ARGUMENT, {
                arg: "value",
                value: value
            });
        } else if (typeof value === "number") {
            if (parseInt(String(value)) !== value) $fc46f7c7d8d74570$var$errors.throwError("underflow", $fc46f7c7d8d74570$var$errors.NUMERIC_FAULT, {
                operation: "setValue",
                fault: "underflow",
                value: value,
                outputValue: parseInt(String(value))
            });
            try {
                $6dadc4810a2babb6$exports.defineReadOnly(this, "_hex", $fc46f7c7d8d74570$var$toHex(new $fc46f7c7d8d74570$var$bn_js_1.default.BN(value)));
            } catch (error) {
                $fc46f7c7d8d74570$var$errors.throwError("overflow", $fc46f7c7d8d74570$var$errors.NUMERIC_FAULT, {
                    operation: "setValue",
                    fault: "overflow",
                    details: error.message
                });
            }
        } else if (value instanceof BigNumber) $6dadc4810a2babb6$exports.defineReadOnly(this, "_hex", value._hex);
        else if (value.toHexString) $6dadc4810a2babb6$exports.defineReadOnly(this, "_hex", $fc46f7c7d8d74570$var$toHex($fc46f7c7d8d74570$var$toBN(value.toHexString())));
        else if (value._hex && $36f30ca1d30438a3$exports.isHexString(value._hex)) $6dadc4810a2babb6$exports.defineReadOnly(this, "_hex", value._hex);
        else if ($36f30ca1d30438a3$exports.isArrayish(value)) $6dadc4810a2babb6$exports.defineReadOnly(this, "_hex", $fc46f7c7d8d74570$var$toHex(new $fc46f7c7d8d74570$var$bn_js_1.default.BN($36f30ca1d30438a3$exports.hexlify(value).substring(2), 16)));
        else $fc46f7c7d8d74570$var$errors.throwError("invalid BigNumber value", $fc46f7c7d8d74570$var$errors.INVALID_ARGUMENT, {
            arg: "value",
            value: value
        });
    }
    BigNumber.prototype.fromTwos = function(value) {
        return $fc46f7c7d8d74570$var$toBigNumber($fc46f7c7d8d74570$var$_bnify(this).fromTwos(value));
    };
    BigNumber.prototype.toTwos = function(value) {
        return $fc46f7c7d8d74570$var$toBigNumber($fc46f7c7d8d74570$var$_bnify(this).toTwos(value));
    };
    BigNumber.prototype.abs = function() {
        if (this._hex[0] === "-") return $fc46f7c7d8d74570$var$toBigNumber($fc46f7c7d8d74570$var$_bnify(this).mul($fc46f7c7d8d74570$var$BN_1));
        return this;
    };
    BigNumber.prototype.add = function(other) {
        return $fc46f7c7d8d74570$var$toBigNumber($fc46f7c7d8d74570$var$_bnify(this).add($fc46f7c7d8d74570$var$toBN(other)));
    };
    BigNumber.prototype.sub = function(other) {
        return $fc46f7c7d8d74570$var$toBigNumber($fc46f7c7d8d74570$var$_bnify(this).sub($fc46f7c7d8d74570$var$toBN(other)));
    };
    BigNumber.prototype.div = function(other) {
        var o = $fc46f7c7d8d74570$var$bigNumberify(other);
        if (o.isZero()) $fc46f7c7d8d74570$var$errors.throwError("division by zero", $fc46f7c7d8d74570$var$errors.NUMERIC_FAULT, {
            operation: "divide",
            fault: "division by zero"
        });
        return $fc46f7c7d8d74570$var$toBigNumber($fc46f7c7d8d74570$var$_bnify(this).div($fc46f7c7d8d74570$var$toBN(other)));
    };
    BigNumber.prototype.mul = function(other) {
        return $fc46f7c7d8d74570$var$toBigNumber($fc46f7c7d8d74570$var$_bnify(this).mul($fc46f7c7d8d74570$var$toBN(other)));
    };
    BigNumber.prototype.mod = function(other) {
        return $fc46f7c7d8d74570$var$toBigNumber($fc46f7c7d8d74570$var$_bnify(this).mod($fc46f7c7d8d74570$var$toBN(other)));
    };
    BigNumber.prototype.pow = function(other) {
        return $fc46f7c7d8d74570$var$toBigNumber($fc46f7c7d8d74570$var$_bnify(this).pow($fc46f7c7d8d74570$var$toBN(other)));
    };
    BigNumber.prototype.maskn = function(value) {
        return $fc46f7c7d8d74570$var$toBigNumber($fc46f7c7d8d74570$var$_bnify(this).maskn(value));
    };
    BigNumber.prototype.eq = function(other) {
        return $fc46f7c7d8d74570$var$_bnify(this).eq($fc46f7c7d8d74570$var$toBN(other));
    };
    BigNumber.prototype.lt = function(other) {
        return $fc46f7c7d8d74570$var$_bnify(this).lt($fc46f7c7d8d74570$var$toBN(other));
    };
    BigNumber.prototype.lte = function(other) {
        return $fc46f7c7d8d74570$var$_bnify(this).lte($fc46f7c7d8d74570$var$toBN(other));
    };
    BigNumber.prototype.gt = function(other) {
        return $fc46f7c7d8d74570$var$_bnify(this).gt($fc46f7c7d8d74570$var$toBN(other));
    };
    BigNumber.prototype.gte = function(other) {
        return $fc46f7c7d8d74570$var$_bnify(this).gte($fc46f7c7d8d74570$var$toBN(other));
    };
    BigNumber.prototype.isZero = function() {
        return $fc46f7c7d8d74570$var$_bnify(this).isZero();
    };
    BigNumber.prototype.toNumber = function() {
        try {
            return $fc46f7c7d8d74570$var$_bnify(this).toNumber();
        } catch (error) {
            $fc46f7c7d8d74570$var$errors.throwError("overflow", $fc46f7c7d8d74570$var$errors.NUMERIC_FAULT, {
                operation: "setValue",
                fault: "overflow",
                details: error.message
            });
        }
        return null;
    };
    BigNumber.prototype.toString = function() {
        return $fc46f7c7d8d74570$var$_bnify(this).toString(10);
    };
    BigNumber.prototype.toHexString = function() {
        return this._hex;
    };
    BigNumber.isBigNumber = function(value) {
        return $6dadc4810a2babb6$exports.isType(value, "BigNumber");
    };
    return BigNumber;
}();
$fc46f7c7d8d74570$exports.BigNumber = $fc46f7c7d8d74570$var$BigNumber;
function $fc46f7c7d8d74570$var$bigNumberify(value) {
    if ($fc46f7c7d8d74570$var$BigNumber.isBigNumber(value)) return value;
    return new $fc46f7c7d8d74570$var$BigNumber(value);
}
$fc46f7c7d8d74570$exports.bigNumberify = $fc46f7c7d8d74570$var$bigNumberify;


var $fa59cd666d8676fc$var$AddressZero = "0x0000000000000000000000000000000000000000";
$fa59cd666d8676fc$exports.AddressZero = $fa59cd666d8676fc$var$AddressZero;
var $fa59cd666d8676fc$var$HashZero = "0x0000000000000000000000000000000000000000000000000000000000000000";
$fa59cd666d8676fc$exports.HashZero = $fa59cd666d8676fc$var$HashZero;
// NFKD (decomposed)
//const EtherSymbol = '\uD835\uDF63';
// NFKC (composed)
var $fa59cd666d8676fc$var$EtherSymbol = "\u039E";
$fa59cd666d8676fc$exports.EtherSymbol = $fa59cd666d8676fc$var$EtherSymbol;
var $fa59cd666d8676fc$var$NegativeOne = $fc46f7c7d8d74570$exports.bigNumberify(-1);
$fa59cd666d8676fc$exports.NegativeOne = $fa59cd666d8676fc$var$NegativeOne;
var $fa59cd666d8676fc$var$Zero = $fc46f7c7d8d74570$exports.bigNumberify(0);
$fa59cd666d8676fc$exports.Zero = $fa59cd666d8676fc$var$Zero;
var $fa59cd666d8676fc$var$One = $fc46f7c7d8d74570$exports.bigNumberify(1);
$fa59cd666d8676fc$exports.One = $fa59cd666d8676fc$var$One;
var $fa59cd666d8676fc$var$Two = $fc46f7c7d8d74570$exports.bigNumberify(2);
$fa59cd666d8676fc$exports.Two = $fa59cd666d8676fc$var$Two;
var $fa59cd666d8676fc$var$WeiPerEther = $fc46f7c7d8d74570$exports.bigNumberify("1000000000000000000");
$fa59cd666d8676fc$exports.WeiPerEther = $fa59cd666d8676fc$var$WeiPerEther;
var $fa59cd666d8676fc$var$MaxUint256 = $fc46f7c7d8d74570$exports.bigNumberify("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
$fa59cd666d8676fc$exports.MaxUint256 = $fa59cd666d8676fc$var$MaxUint256;



var $aa2dfa8e6e1e6118$var$errors = $aa2dfa8e6e1e6118$var$__importStar((parcelRequire("9OCA8")));
var $8f3acb2099d0eea3$exports = {};
"use strict";
var $8f3acb2099d0eea3$var$__importDefault = $8f3acb2099d0eea3$exports && $8f3acb2099d0eea3$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($8f3acb2099d0eea3$exports, "__esModule", {
    value: true
});

// We use this for base 36 maths
var $8f3acb2099d0eea3$var$bn_js_1 = $8f3acb2099d0eea3$var$__importDefault((parcelRequire("dEXSZ")));

var $f8739d1436b7e7b6$exports = {};
"use strict";
Object.defineProperty($f8739d1436b7e7b6$exports, "__esModule", {
    value: true
});

var $1IGmO = parcelRequire("1IGmO");

function $f8739d1436b7e7b6$var$keccak256(data) {
    return "0x" + $1IGmO.keccak_256($36f30ca1d30438a3$exports.arrayify(data));
}
$f8739d1436b7e7b6$exports.keccak256 = $f8739d1436b7e7b6$var$keccak256;


var $c7ee20aa45c51195$exports = {};
"use strict";
//See: https://github.com/ethereum/wiki/wiki/RLP
Object.defineProperty($c7ee20aa45c51195$exports, "__esModule", {
    value: true
});

function $c7ee20aa45c51195$var$arrayifyInteger(value) {
    var result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $c7ee20aa45c51195$var$unarrayifyInteger(data, offset, length) {
    var result = 0;
    for(var i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $c7ee20aa45c51195$var$_encode(object) {
    if (Array.isArray(object)) {
        var payload = [];
        object.forEach(function(child) {
            payload = payload.concat($c7ee20aa45c51195$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        var length = $c7ee20aa45c51195$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    var data = Array.prototype.slice.call($36f30ca1d30438a3$exports.arrayify(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    var length = $c7ee20aa45c51195$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $c7ee20aa45c51195$var$encode(object) {
    return $36f30ca1d30438a3$exports.hexlify($c7ee20aa45c51195$var$_encode(object));
}
$c7ee20aa45c51195$exports.encode = $c7ee20aa45c51195$var$encode;
function $c7ee20aa45c51195$var$_decodeChildren(data, offset, childOffset, length) {
    var result = [];
    while(childOffset < offset + 1 + length){
        var decoded = $c7ee20aa45c51195$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) throw new Error("invalid rlp");
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $c7ee20aa45c51195$var$_decode(data, offset) {
    if (data.length === 0) throw new Error("invalid rlp data");
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        var lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) throw new Error("too short");
        var length = $c7ee20aa45c51195$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) throw new Error("to short");
        return $c7ee20aa45c51195$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        var length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) throw new Error("invalid rlp data");
        return $c7ee20aa45c51195$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        var lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) throw new Error("invalid rlp data");
        var length = $c7ee20aa45c51195$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) throw new Error("invalid rlp data");
        var result = $36f30ca1d30438a3$exports.hexlify(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        var length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) throw new Error("invlaid rlp data");
        var result = $36f30ca1d30438a3$exports.hexlify(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: $36f30ca1d30438a3$exports.hexlify(data[offset])
    };
}
function $c7ee20aa45c51195$var$decode(data) {
    var bytes = $36f30ca1d30438a3$exports.arrayify(data);
    var decoded = $c7ee20aa45c51195$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) throw new Error("invalid rlp data");
    return decoded.result;
}
$c7ee20aa45c51195$exports.decode = $c7ee20aa45c51195$var$decode;



var $9OCA8 = parcelRequire("9OCA8");
///////////////////////////////
function $8f3acb2099d0eea3$var$getChecksumAddress(address) {
    if (typeof address !== "string" || !address.match(/^0x[0-9A-Fa-f]{40}$/)) $9OCA8.throwError("invalid address", $9OCA8.INVALID_ARGUMENT, {
        arg: "address",
        value: address
    });
    address = address.toLowerCase();
    var chars = address.substring(2).split("");
    var hashed = new Uint8Array(40);
    for(var i_1 = 0; i_1 < 40; i_1++)hashed[i_1] = chars[i_1].charCodeAt(0);
    hashed = $36f30ca1d30438a3$exports.arrayify($f8739d1436b7e7b6$exports.keccak256(hashed));
    for(var i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
var $8f3acb2099d0eea3$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $8f3acb2099d0eea3$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
var $8f3acb2099d0eea3$var$ibanLookup = {};
for(var $8f3acb2099d0eea3$var$i = 0; $8f3acb2099d0eea3$var$i < 10; $8f3acb2099d0eea3$var$i++)$8f3acb2099d0eea3$var$ibanLookup[String($8f3acb2099d0eea3$var$i)] = String($8f3acb2099d0eea3$var$i);
for(var $8f3acb2099d0eea3$var$i = 0; $8f3acb2099d0eea3$var$i < 26; $8f3acb2099d0eea3$var$i++)$8f3acb2099d0eea3$var$ibanLookup[String.fromCharCode(65 + $8f3acb2099d0eea3$var$i)] = String(10 + $8f3acb2099d0eea3$var$i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
var $8f3acb2099d0eea3$var$safeDigits = Math.floor($8f3acb2099d0eea3$var$log10($8f3acb2099d0eea3$var$MAX_SAFE_INTEGER));
function $8f3acb2099d0eea3$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    var expanded = "";
    address.split("").forEach(function(c) {
        expanded += $8f3acb2099d0eea3$var$ibanLookup[c];
    });
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $8f3acb2099d0eea3$var$safeDigits){
        var block = expanded.substring(0, $8f3acb2099d0eea3$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    var checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $8f3acb2099d0eea3$var$getAddress(address, checksum) {
    if (checksum === void 0) checksum = true;
    var result = null;
    if (typeof address !== "string") $9OCA8.throwError("invalid address", $9OCA8.INVALID_ARGUMENT, {
        arg: "address",
        value: address
    });
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        if (checksum) {
            result = $8f3acb2099d0eea3$var$getChecksumAddress(address);
            // It is a checksummed address with a bad checksum
            if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $9OCA8.throwError("bad address checksum", $9OCA8.INVALID_ARGUMENT, {
                arg: "address",
                value: address
            });
        } else result = address;
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $8f3acb2099d0eea3$var$ibanChecksum(address)) $9OCA8.throwError("bad icap checksum", $9OCA8.INVALID_ARGUMENT, {
            arg: "address",
            value: address
        });
        result = new $8f3acb2099d0eea3$var$bn_js_1.default.BN(address.substring(4), 36).toString(16);
        while(result.length < 40)result = "0" + result;
        result = checksum ? $8f3acb2099d0eea3$var$getChecksumAddress("0x" + result) : "0x" + result;
    } else $9OCA8.throwError("invalid address", $9OCA8.INVALID_ARGUMENT, {
        arg: "address",
        value: address
    });
    return result;
}
$8f3acb2099d0eea3$exports.getAddress = $8f3acb2099d0eea3$var$getAddress;
function $8f3acb2099d0eea3$var$getIcapAddress(address) {
    var base36 = new $8f3acb2099d0eea3$var$bn_js_1.default.BN($8f3acb2099d0eea3$var$getAddress(address).substring(2), 16).toString(36).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $8f3acb2099d0eea3$var$ibanChecksum("XE00" + base36) + base36;
}
$8f3acb2099d0eea3$exports.getIcapAddress = $8f3acb2099d0eea3$var$getIcapAddress;
// http://ethereum.stackexchange.com/questions/760/how-is-the-address-of-an-ethereum-contract-computed
function $8f3acb2099d0eea3$var$getContractAddress(transaction) {
    if (!transaction.from) throw new Error("missing from address");
    var nonce = transaction.nonce;
    return $8f3acb2099d0eea3$var$getAddress("0x" + $f8739d1436b7e7b6$exports.keccak256($c7ee20aa45c51195$exports.encode([
        $8f3acb2099d0eea3$var$getAddress(transaction.from),
        $36f30ca1d30438a3$exports.stripZeros($36f30ca1d30438a3$exports.hexlify(nonce))
    ])).substring(26));
}
$8f3acb2099d0eea3$exports.getContractAddress = $8f3acb2099d0eea3$var$getContractAddress;




var $1104b1e291445767$exports = {};
"use strict";
Object.defineProperty($1104b1e291445767$exports, "__esModule", {
    value: true
});


var $9OCA8 = parcelRequire("9OCA8");

///////////////////////////////
var $1104b1e291445767$var$UnicodeNormalizationForm;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($1104b1e291445767$var$UnicodeNormalizationForm = $1104b1e291445767$exports.UnicodeNormalizationForm || ($1104b1e291445767$exports.UnicodeNormalizationForm = {}));
// http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array
function $1104b1e291445767$var$toUtf8Bytes(str, form) {
    if (form === void 0) form = $1104b1e291445767$var$UnicodeNormalizationForm.current;
    if (form != $1104b1e291445767$var$UnicodeNormalizationForm.current) {
        $9OCA8.checkNormalize();
        str = str.normalize(form);
    }
    var result = [];
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            var c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(c >> 18 | 0xf0);
            result.push(c >> 12 & 0x3f | 0x80);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return $36f30ca1d30438a3$exports.arrayify(result);
}
$1104b1e291445767$exports.toUtf8Bytes = $1104b1e291445767$var$toUtf8Bytes;
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $1104b1e291445767$var$toUtf8String(bytes, ignoreErrors) {
    bytes = $36f30ca1d30438a3$exports.arrayify(bytes);
    var result = "";
    var i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        var c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result += String.fromCharCode(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        var extraLength = null;
        var overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if (!ignoreErrors) {
                if ((c & 0xc0) === 0x80) throw new Error("invalid utf8 byte sequence; unexpected continuation byte");
                throw new Error("invalid utf8 byte sequence; invalid prefix");
            }
            continue;
        }
        // Do we have enough bytes in our data?
        if (i + extraLength > bytes.length) {
            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; too short");
            // If there is an invalid unprocessed byte, skip continuation bytes
            for(; i < bytes.length; i++){
                if (bytes[i] >> 6 !== 0x02) break;
            }
            continue;
        }
        // Remove the length prefix from the char
        var res = c & (1 << 8 - extraLength - 1) - 1;
        for(var j = 0; j < extraLength; j++){
            var nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        if (res === null) {
            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; invalid continuation byte");
            continue;
        }
        // Check for overlong seuences (more bytes than needed)
        if (res <= overlongMask) {
            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; overlong");
            continue;
        }
        // Maximum code point
        if (res > 0x10ffff) {
            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; out-of-range");
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; utf-16 surrogate");
            continue;
        }
        if (res <= 0xffff) {
            result += String.fromCharCode(res);
            continue;
        }
        res -= 0x10000;
        result += String.fromCharCode((res >> 10 & 0x3ff) + 0xd800, (res & 0x3ff) + 0xdc00);
    }
    return result;
}
$1104b1e291445767$exports.toUtf8String = $1104b1e291445767$var$toUtf8String;
function $1104b1e291445767$var$formatBytes32String(text) {
    // Get the bytes
    var bytes = $1104b1e291445767$var$toUtf8Bytes(text);
    // Check we have room for null-termination
    if (bytes.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
    // Zero-pad (implicitly null-terminates)
    return $36f30ca1d30438a3$exports.hexlify($36f30ca1d30438a3$exports.concat([
        bytes,
        $fa59cd666d8676fc$exports.HashZero
    ]).slice(0, 32));
}
$1104b1e291445767$exports.formatBytes32String = $1104b1e291445767$var$formatBytes32String;
function $1104b1e291445767$var$parseBytes32String(bytes) {
    var data = $36f30ca1d30438a3$exports.arrayify(bytes);
    // Must be 32 bytes with a null-termination
    if (data.length !== 32) throw new Error("invalid bytes32 - not 32 bytes long");
    if (data[31] !== 0) throw new Error("invalid bytes32 sdtring - no null terminator");
    // Find the null termination
    var length = 31;
    while(data[length - 1] === 0)length--;
    // Determine the string value
    return $1104b1e291445767$var$toUtf8String(data.slice(0, length));
}
$1104b1e291445767$exports.parseBytes32String = $1104b1e291445767$var$parseBytes32String;



///////////////////////////////
var $aa2dfa8e6e1e6118$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
var $aa2dfa8e6e1e6118$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
var $aa2dfa8e6e1e6118$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
$aa2dfa8e6e1e6118$exports.defaultCoerceFunc = function(type, value) {
    var match = type.match($aa2dfa8e6e1e6118$var$paramTypeNumber);
    if (match && parseInt(match[2]) <= 48) return value.toNumber();
    return value;
};
///////////////////////////////////
// Parsing for Solidity Signatures
var $aa2dfa8e6e1e6118$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
var $aa2dfa8e6e1e6118$var$regexIdentifier = new RegExp("^[A-Za-z_][A-Za-z0-9_]*$");
function $aa2dfa8e6e1e6118$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    return type;
}
function $aa2dfa8e6e1e6118$var$parseParam(param, allowIndexed) {
    var originalParam = param;
    function throwError(i) {
        throw new Error('unexpected character "' + originalParam[i] + '" at position ' + i + ' in "' + originalParam + '"');
    }
    param = param.replace(/\s/g, " ");
    var parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    var node = parent;
    for(var i = 0; i < param.length; i++){
        var c = param[i];
        switch(c){
            case "(":
                if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $aa2dfa8e6e1e6118$var$verifyType(node.type);
                node.components = [
                    {
                        type: "",
                        name: "",
                        parent: node,
                        state: {
                            allowType: true
                        }
                    }
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (allowIndexed && node.name === "indexed") {
                    node.indexed = true;
                    node.name = "";
                }
                node.type = $aa2dfa8e6e1e6118$var$verifyType(node.type);
                var child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (allowIndexed && node.name === "indexed") {
                    node.indexed = true;
                    node.name = "";
                }
                node.type = $aa2dfa8e6e1e6118$var$verifyType(node.type);
                var sibling = {
                    type: "",
                    name: "",
                    parent: node.parent,
                    state: {
                        allowType: true
                    }
                };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $aa2dfa8e6e1e6118$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (allowIndexed && node.name === "indexed") {
                            node.indexed = true;
                            node.name = "";
                        } else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) throw new Error("unexpected eof");
    delete parent.state;
    if (allowIndexed && node.name === "indexed") {
        node.indexed = true;
        node.name = "";
    }
    parent.type = $aa2dfa8e6e1e6118$var$verifyType(parent.type);
    return parent;
}
// @TODO: Better return type
function $aa2dfa8e6e1e6118$var$parseSignatureEvent(fragment) {
    var abi = {
        anonymous: false,
        inputs: [],
        name: "",
        type: "event"
    };
    var match = fragment.match($aa2dfa8e6e1e6118$var$regexParen);
    if (!match) throw new Error("invalid event: " + fragment);
    abi.name = match[1].trim();
    $aa2dfa8e6e1e6118$var$splitNesting(match[2]).forEach(function(param) {
        param = $aa2dfa8e6e1e6118$var$parseParam(param, true);
        param.indexed = !!param.indexed;
        abi.inputs.push(param);
    });
    match[3].split(" ").forEach(function(modifier) {
        switch(modifier){
            case "anonymous":
                abi.anonymous = true;
                break;
            case "":
                break;
            default:
                $aa2dfa8e6e1e6118$var$errors.info("unknown modifier: " + modifier);
        }
    });
    if (abi.name && !abi.name.match($aa2dfa8e6e1e6118$var$regexIdentifier)) throw new Error('invalid identifier: "' + abi.name + '"');
    return abi;
}
function $aa2dfa8e6e1e6118$var$parseSignatureFunction(fragment) {
    var abi = {
        constant: false,
        gas: null,
        inputs: [],
        name: "",
        outputs: [],
        payable: false,
        stateMutability: null,
        type: "function"
    };
    var comps = fragment.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) throw new Error("invalid signature");
        if (!comps[1].match(/^[0-9]+$/)) throw new Error("invalid signature gas");
        abi.gas = $fc46f7c7d8d74570$exports.bigNumberify(comps[1]);
        fragment = comps[0];
    }
    comps = fragment.split(" returns ");
    var left = comps[0].match($aa2dfa8e6e1e6118$var$regexParen);
    if (!left) throw new Error("invalid signature");
    abi.name = left[1].trim();
    if (!abi.name.match($aa2dfa8e6e1e6118$var$regexIdentifier)) throw new Error('invalid identifier: "' + left[1] + '"');
    $aa2dfa8e6e1e6118$var$splitNesting(left[2]).forEach(function(param) {
        abi.inputs.push($aa2dfa8e6e1e6118$var$parseParam(param));
    });
    left[3].split(" ").forEach(function(modifier) {
        switch(modifier){
            case "constant":
                abi.constant = true;
                break;
            case "payable":
                abi.payable = true;
                abi.stateMutability = "payable";
                break;
            case "pure":
                abi.constant = true;
                abi.stateMutability = "pure";
                break;
            case "view":
                abi.constant = true;
                abi.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                $aa2dfa8e6e1e6118$var$errors.info("unknown modifier: " + modifier);
        }
    });
    // We have outputs
    if (comps.length > 1) {
        var right = comps[1].match($aa2dfa8e6e1e6118$var$regexParen);
        if (right[1].trim() != "" || right[3].trim() != "") throw new Error("unexpected tokens");
        $aa2dfa8e6e1e6118$var$splitNesting(right[2]).forEach(function(param) {
            abi.outputs.push($aa2dfa8e6e1e6118$var$parseParam(param));
        });
    }
    if (abi.name === "constructor") {
        abi.type = "constructor";
        if (abi.outputs.length) throw new Error("constructor may not have outputs");
        delete abi.name;
        delete abi.outputs;
    }
    return abi;
}
function $aa2dfa8e6e1e6118$var$parseParamType(type) {
    return $aa2dfa8e6e1e6118$var$parseParam(type, true);
}
$aa2dfa8e6e1e6118$exports.parseParamType = $aa2dfa8e6e1e6118$var$parseParamType;
// @TODO: Allow a second boolean to expose names
function $aa2dfa8e6e1e6118$var$formatParamType(paramType) {
    return $aa2dfa8e6e1e6118$var$getParamCoder($aa2dfa8e6e1e6118$exports.defaultCoerceFunc, paramType).type;
}
$aa2dfa8e6e1e6118$exports.formatParamType = $aa2dfa8e6e1e6118$var$formatParamType;
// @TODO: Allow a second boolean to expose names and modifiers
function $aa2dfa8e6e1e6118$var$formatSignature(fragment) {
    return fragment.name + "(" + fragment.inputs.map(function(i) {
        return $aa2dfa8e6e1e6118$var$formatParamType(i);
    }).join(",") + ")";
}
$aa2dfa8e6e1e6118$exports.formatSignature = $aa2dfa8e6e1e6118$var$formatSignature;
function $aa2dfa8e6e1e6118$var$parseSignature(fragment) {
    if (typeof fragment === "string") {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        fragment = fragment.replace(/\s/g, " ");
        fragment = fragment.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        fragment = fragment.trim();
        if (fragment.substring(0, 6) === "event ") return $aa2dfa8e6e1e6118$var$parseSignatureEvent(fragment.substring(6).trim());
        else {
            if (fragment.substring(0, 9) === "function ") fragment = fragment.substring(9);
            return $aa2dfa8e6e1e6118$var$parseSignatureFunction(fragment.trim());
        }
    }
    throw new Error("unknown signature");
}
$aa2dfa8e6e1e6118$exports.parseSignature = $aa2dfa8e6e1e6118$var$parseSignature;
var $aa2dfa8e6e1e6118$var$Coder = /** @class */ function() {
    function Coder(coerceFunc, name1, type, localName, dynamic) {
        this.coerceFunc = coerceFunc;
        this.name = name1;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    return Coder;
}();
// Clones the functionality of an existing Coder, but without a localName
var $aa2dfa8e6e1e6118$var$CoderAnonymous = /** @class */ function(_super) {
    $aa2dfa8e6e1e6118$var$__extends(CoderAnonymous, _super);
    function CoderAnonymous(coder) {
        var _this = _super.call(this, coder.coerceFunc, coder.name, coder.type, undefined, coder.dynamic) || this;
        $6dadc4810a2babb6$exports.defineReadOnly(_this, "coder", coder);
        return _this;
    }
    CoderAnonymous.prototype.encode = function(value) {
        return this.coder.encode(value);
    };
    CoderAnonymous.prototype.decode = function(data, offset) {
        return this.coder.decode(data, offset);
    };
    return CoderAnonymous;
}($aa2dfa8e6e1e6118$var$Coder);
var $aa2dfa8e6e1e6118$var$CoderNull = /** @class */ function(_super) {
    $aa2dfa8e6e1e6118$var$__extends(CoderNull, _super);
    function CoderNull(coerceFunc, localName) {
        return _super.call(this, coerceFunc, "null", "", localName, false) || this;
    }
    CoderNull.prototype.encode = function(value) {
        return $36f30ca1d30438a3$exports.arrayify([]);
    };
    CoderNull.prototype.decode = function(data, offset) {
        if (offset > data.length) throw new Error("invalid null");
        return {
            consumed: 0,
            value: this.coerceFunc("null", undefined)
        };
    };
    return CoderNull;
}($aa2dfa8e6e1e6118$var$Coder);
var $aa2dfa8e6e1e6118$var$CoderNumber = /** @class */ function(_super) {
    $aa2dfa8e6e1e6118$var$__extends(CoderNumber, _super);
    function CoderNumber(coerceFunc, size, signed, localName) {
        var _this = this;
        var name1 = (signed ? "int" : "uint") + size * 8;
        _this = _super.call(this, coerceFunc, name1, name1, localName, false) || this;
        _this.size = size;
        _this.signed = signed;
        return _this;
    }
    CoderNumber.prototype.encode = function(value) {
        try {
            var v = $fc46f7c7d8d74570$exports.bigNumberify(value);
            if (this.signed) {
                var bounds = $fa59cd666d8676fc$exports.MaxUint256.maskn(this.size * 8 - 1);
                if (v.gt(bounds)) throw new Error("out-of-bounds");
                bounds = bounds.add($fa59cd666d8676fc$exports.One).mul($fa59cd666d8676fc$exports.NegativeOne);
                if (v.lt(bounds)) throw new Error("out-of-bounds");
            } else if (v.lt($fa59cd666d8676fc$exports.Zero) || v.gt($fa59cd666d8676fc$exports.MaxUint256.maskn(this.size * 8))) throw new Error("out-of-bounds");
            v = v.toTwos(this.size * 8).maskn(this.size * 8);
            if (this.signed) v = v.fromTwos(this.size * 8).toTwos(256);
            return $36f30ca1d30438a3$exports.padZeros($36f30ca1d30438a3$exports.arrayify(v), 32);
        } catch (error) {
            $aa2dfa8e6e1e6118$var$errors.throwError("invalid number value", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
                arg: this.localName,
                coderType: this.name,
                value: value
            });
        }
        return null;
    };
    CoderNumber.prototype.decode = function(data, offset) {
        if (data.length < offset + 32) $aa2dfa8e6e1e6118$var$errors.throwError("insufficient data for " + this.name + " type", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: this.name,
            value: $36f30ca1d30438a3$exports.hexlify(data.slice(offset, offset + 32))
        });
        var junkLength = 32 - this.size;
        var value = $fc46f7c7d8d74570$exports.bigNumberify(data.slice(offset + junkLength, offset + 32));
        if (this.signed) value = value.fromTwos(this.size * 8);
        else value = value.maskn(this.size * 8);
        return {
            consumed: 32,
            value: this.coerceFunc(this.name, value)
        };
    };
    return CoderNumber;
}($aa2dfa8e6e1e6118$var$Coder);
var $aa2dfa8e6e1e6118$var$uint256Coder = new $aa2dfa8e6e1e6118$var$CoderNumber(function(type, value) {
    return value;
}, 32, false, "none");
var $aa2dfa8e6e1e6118$var$CoderBoolean = /** @class */ function(_super) {
    $aa2dfa8e6e1e6118$var$__extends(CoderBoolean, _super);
    function CoderBoolean(coerceFunc, localName) {
        return _super.call(this, coerceFunc, "bool", "bool", localName, false) || this;
    }
    CoderBoolean.prototype.encode = function(value) {
        return $aa2dfa8e6e1e6118$var$uint256Coder.encode(!!value ? 1 : 0);
    };
    CoderBoolean.prototype.decode = function(data, offset) {
        try {
            var result = $aa2dfa8e6e1e6118$var$uint256Coder.decode(data, offset);
        } catch (error) {
            if (error.reason === "insufficient data for uint256 type") $aa2dfa8e6e1e6118$var$errors.throwError("insufficient data for boolean type", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
                arg: this.localName,
                coderType: "boolean",
                value: error.value
            });
            throw error;
        }
        return {
            consumed: result.consumed,
            value: this.coerceFunc("bool", !result.value.isZero())
        };
    };
    return CoderBoolean;
}($aa2dfa8e6e1e6118$var$Coder);
var $aa2dfa8e6e1e6118$var$CoderFixedBytes = /** @class */ function(_super) {
    $aa2dfa8e6e1e6118$var$__extends(CoderFixedBytes, _super);
    function CoderFixedBytes(coerceFunc, length, localName) {
        var _this = this;
        var name1 = "bytes" + length;
        _this = _super.call(this, coerceFunc, name1, name1, localName, false) || this;
        _this.length = length;
        return _this;
    }
    CoderFixedBytes.prototype.encode = function(value) {
        var result = new Uint8Array(32);
        try {
            var data = $36f30ca1d30438a3$exports.arrayify(value);
            if (data.length !== this.length) throw new Error("incorrect data length");
            result.set(data);
        } catch (error) {
            $aa2dfa8e6e1e6118$var$errors.throwError("invalid " + this.name + " value", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
                arg: this.localName,
                coderType: this.name,
                value: error.value || value
            });
        }
        return result;
    };
    CoderFixedBytes.prototype.decode = function(data, offset) {
        if (data.length < offset + 32) $aa2dfa8e6e1e6118$var$errors.throwError("insufficient data for " + name + " type", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: this.name,
            value: $36f30ca1d30438a3$exports.hexlify(data.slice(offset, offset + 32))
        });
        return {
            consumed: 32,
            value: this.coerceFunc(this.name, $36f30ca1d30438a3$exports.hexlify(data.slice(offset, offset + this.length)))
        };
    };
    return CoderFixedBytes;
}($aa2dfa8e6e1e6118$var$Coder);
var $aa2dfa8e6e1e6118$var$CoderAddress = /** @class */ function(_super) {
    $aa2dfa8e6e1e6118$var$__extends(CoderAddress, _super);
    function CoderAddress(coerceFunc, localName) {
        return _super.call(this, coerceFunc, "address", "address", localName, false) || this;
    }
    CoderAddress.prototype.encode = function(value) {
        var result = new Uint8Array(32);
        try {
            result.set($36f30ca1d30438a3$exports.arrayify($8f3acb2099d0eea3$exports.getAddress(value, false)), 12);
        } catch (error) {
            $aa2dfa8e6e1e6118$var$errors.throwError("invalid address", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
                arg: this.localName,
                coderType: "address",
                value: value
            });
        }
        return result;
    };
    CoderAddress.prototype.decode = function(data, offset) {
        if (data.length < offset + 32) $aa2dfa8e6e1e6118$var$errors.throwError("insufficuent data for address type", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: "address",
            value: $36f30ca1d30438a3$exports.hexlify(data.slice(offset, offset + 32))
        });
        return {
            consumed: 32,
            value: this.coerceFunc("address", $8f3acb2099d0eea3$exports.getAddress($36f30ca1d30438a3$exports.hexlify(data.slice(offset + 12, offset + 32)), false))
        };
    };
    return CoderAddress;
}($aa2dfa8e6e1e6118$var$Coder);
function $aa2dfa8e6e1e6118$var$_encodeDynamicBytes(value) {
    var dataLength = 32 * Math.ceil(value.length / 32);
    var padding = new Uint8Array(dataLength - value.length);
    return $36f30ca1d30438a3$exports.concat([
        $aa2dfa8e6e1e6118$var$uint256Coder.encode(value.length),
        value,
        padding
    ]);
}
function $aa2dfa8e6e1e6118$var$_decodeDynamicBytes(data, offset, localName) {
    if (data.length < offset + 32) $aa2dfa8e6e1e6118$var$errors.throwError("insufficient data for dynamicBytes length", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
        arg: localName,
        coderType: "dynamicBytes",
        value: $36f30ca1d30438a3$exports.hexlify(data.slice(offset, offset + 32))
    });
    var length = $aa2dfa8e6e1e6118$var$uint256Coder.decode(data, offset).value;
    try {
        length = length.toNumber();
    } catch (error) {
        $aa2dfa8e6e1e6118$var$errors.throwError("dynamic bytes count too large", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
            arg: localName,
            coderType: "dynamicBytes",
            value: length.toString()
        });
    }
    if (data.length < offset + 32 + length) $aa2dfa8e6e1e6118$var$errors.throwError("insufficient data for dynamicBytes type", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
        arg: localName,
        coderType: "dynamicBytes",
        value: $36f30ca1d30438a3$exports.hexlify(data.slice(offset, offset + 32 + length))
    });
    return {
        consumed: 32 + 32 * Math.ceil(length / 32),
        value: data.slice(offset + 32, offset + 32 + length)
    };
}
var $aa2dfa8e6e1e6118$var$CoderDynamicBytes = /** @class */ function(_super) {
    $aa2dfa8e6e1e6118$var$__extends(CoderDynamicBytes, _super);
    function CoderDynamicBytes(coerceFunc, localName) {
        return _super.call(this, coerceFunc, "bytes", "bytes", localName, true) || this;
    }
    CoderDynamicBytes.prototype.encode = function(value) {
        try {
            return $aa2dfa8e6e1e6118$var$_encodeDynamicBytes($36f30ca1d30438a3$exports.arrayify(value));
        } catch (error) {
            $aa2dfa8e6e1e6118$var$errors.throwError("invalid bytes value", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
                arg: this.localName,
                coderType: "bytes",
                value: error.value
            });
        }
        return null;
    };
    CoderDynamicBytes.prototype.decode = function(data, offset) {
        var result = $aa2dfa8e6e1e6118$var$_decodeDynamicBytes(data, offset, this.localName);
        result.value = this.coerceFunc("bytes", $36f30ca1d30438a3$exports.hexlify(result.value));
        return result;
    };
    return CoderDynamicBytes;
}($aa2dfa8e6e1e6118$var$Coder);
var $aa2dfa8e6e1e6118$var$CoderString = /** @class */ function(_super) {
    $aa2dfa8e6e1e6118$var$__extends(CoderString, _super);
    function CoderString(coerceFunc, localName) {
        return _super.call(this, coerceFunc, "string", "string", localName, true) || this;
    }
    CoderString.prototype.encode = function(value) {
        if (typeof value !== "string") $aa2dfa8e6e1e6118$var$errors.throwError("invalid string value", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: "string",
            value: value
        });
        return $aa2dfa8e6e1e6118$var$_encodeDynamicBytes($1104b1e291445767$exports.toUtf8Bytes(value));
    };
    CoderString.prototype.decode = function(data, offset) {
        var result = $aa2dfa8e6e1e6118$var$_decodeDynamicBytes(data, offset, this.localName);
        result.value = this.coerceFunc("string", $1104b1e291445767$exports.toUtf8String(result.value));
        return result;
    };
    return CoderString;
}($aa2dfa8e6e1e6118$var$Coder);
function $aa2dfa8e6e1e6118$var$alignSize(size) {
    return 32 * Math.ceil(size / 32);
}
function $aa2dfa8e6e1e6118$var$pack(coders, values) {
    if (Array.isArray(values)) ;
    else if (values && typeof values === "object") {
        var arrayValues = [];
        coders.forEach(function(coder) {
            arrayValues.push(values[coder.localName]);
        });
        values = arrayValues;
    } else $aa2dfa8e6e1e6118$var$errors.throwError("invalid tuple value", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
        coderType: "tuple",
        value: values
    });
    if (coders.length !== values.length) $aa2dfa8e6e1e6118$var$errors.throwError("types/value length mismatch", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
        coderType: "tuple",
        value: values
    });
    var parts = [];
    coders.forEach(function(coder, index) {
        parts.push({
            dynamic: coder.dynamic,
            value: coder.encode(values[index])
        });
    });
    var staticSize = 0, dynamicSize = 0;
    parts.forEach(function(part) {
        if (part.dynamic) {
            staticSize += 32;
            dynamicSize += $aa2dfa8e6e1e6118$var$alignSize(part.value.length);
        } else staticSize += $aa2dfa8e6e1e6118$var$alignSize(part.value.length);
    });
    var offset = 0, dynamicOffset = staticSize;
    var data = new Uint8Array(staticSize + dynamicSize);
    parts.forEach(function(part) {
        if (part.dynamic) {
            //uint256Coder.encode(dynamicOffset).copy(data, offset);
            data.set($aa2dfa8e6e1e6118$var$uint256Coder.encode(dynamicOffset), offset);
            offset += 32;
            //part.value.copy(data, dynamicOffset);  @TODO
            data.set(part.value, dynamicOffset);
            dynamicOffset += $aa2dfa8e6e1e6118$var$alignSize(part.value.length);
        } else {
            //part.value.copy(data, offset);  @TODO
            data.set(part.value, offset);
            offset += $aa2dfa8e6e1e6118$var$alignSize(part.value.length);
        }
    });
    return data;
}
function $aa2dfa8e6e1e6118$var$unpack(coders, data, offset) {
    var baseOffset = offset;
    var consumed = 0;
    var value = [];
    coders.forEach(function(coder) {
        if (coder.dynamic) {
            var dynamicOffset = $aa2dfa8e6e1e6118$var$uint256Coder.decode(data, offset);
            var result = coder.decode(data, baseOffset + dynamicOffset.value.toNumber());
            // The dynamic part is leap-frogged somewhere else; doesn't count towards size
            result.consumed = dynamicOffset.consumed;
        } else var result = coder.decode(data, offset);
        if (result.value != undefined) value.push(result.value);
        offset += result.consumed;
        consumed += result.consumed;
    });
    coders.forEach(function(coder, index) {
        var name1 = coder.localName;
        if (!name1) return;
        if (name1 === "length") name1 = "_length";
        if (value[name1] != null) return;
        value[name1] = value[index];
    });
    return {
        value: value,
        consumed: consumed
    };
}
var $aa2dfa8e6e1e6118$var$CoderArray = /** @class */ function(_super) {
    $aa2dfa8e6e1e6118$var$__extends(CoderArray, _super);
    function CoderArray(coerceFunc, coder, length, localName) {
        var _this = this;
        var type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        var dynamic = length === -1 || coder.dynamic;
        _this = _super.call(this, coerceFunc, "array", type, localName, dynamic) || this;
        _this.coder = coder;
        _this.length = length;
        return _this;
    }
    CoderArray.prototype.encode = function(value) {
        if (!Array.isArray(value)) $aa2dfa8e6e1e6118$var$errors.throwError("expected array value", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: "array",
            value: value
        });
        var count = this.length;
        var result = new Uint8Array(0);
        if (count === -1) {
            count = value.length;
            result = $aa2dfa8e6e1e6118$var$uint256Coder.encode(count);
        }
        $aa2dfa8e6e1e6118$var$errors.checkArgumentCount(count, value.length, " in coder array" + (this.localName ? " " + this.localName : ""));
        var coders = [];
        for(var i = 0; i < value.length; i++)coders.push(this.coder);
        return $36f30ca1d30438a3$exports.concat([
            result,
            $aa2dfa8e6e1e6118$var$pack(coders, value)
        ]);
    };
    CoderArray.prototype.decode = function(data, offset) {
        // @TODO:
        //if (data.length < offset + length * 32) { throw new Error('invalid array'); }
        var consumed = 0;
        var count = this.length;
        if (count === -1) {
            try {
                var decodedLength = $aa2dfa8e6e1e6118$var$uint256Coder.decode(data, offset);
            } catch (error) {
                $aa2dfa8e6e1e6118$var$errors.throwError("insufficient data for dynamic array length", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
                    arg: this.localName,
                    coderType: "array",
                    value: error.value
                });
            }
            try {
                count = decodedLength.value.toNumber();
            } catch (error) {
                $aa2dfa8e6e1e6118$var$errors.throwError("array count too large", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
                    arg: this.localName,
                    coderType: "array",
                    value: decodedLength.value.toString()
                });
            }
            consumed += decodedLength.consumed;
            offset += decodedLength.consumed;
        }
        var coders = [];
        for(var i = 0; i < count; i++)coders.push(new $aa2dfa8e6e1e6118$var$CoderAnonymous(this.coder));
        var result = $aa2dfa8e6e1e6118$var$unpack(coders, data, offset);
        result.consumed += consumed;
        result.value = this.coerceFunc(this.type, result.value);
        return result;
    };
    return CoderArray;
}($aa2dfa8e6e1e6118$var$Coder);
var $aa2dfa8e6e1e6118$var$CoderTuple = /** @class */ function(_super) {
    $aa2dfa8e6e1e6118$var$__extends(CoderTuple, _super);
    function CoderTuple(coerceFunc, coders, localName) {
        var _this = this;
        var dynamic = false;
        var types = [];
        coders.forEach(function(coder) {
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        var type = "tuple(" + types.join(",") + ")";
        _this = _super.call(this, coerceFunc, "tuple", type, localName, dynamic) || this;
        _this.coders = coders;
        return _this;
    }
    CoderTuple.prototype.encode = function(value) {
        return $aa2dfa8e6e1e6118$var$pack(this.coders, value);
    };
    CoderTuple.prototype.decode = function(data, offset) {
        var result = $aa2dfa8e6e1e6118$var$unpack(this.coders, data, offset);
        result.value = this.coerceFunc(this.type, result.value);
        return result;
    };
    return CoderTuple;
}($aa2dfa8e6e1e6118$var$Coder);
/*
function getTypes(coders) {
    var type = coderTuple(coders).type;
    return type.substring(6, type.length - 1);
}
*/ function $aa2dfa8e6e1e6118$var$splitNesting(value) {
    value = value.trim();
    var result = [];
    var accum = "";
    var depth = 0;
    for(var offset = 0; offset < value.length; offset++){
        var c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) throw new Error("unbalanced parenthsis");
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}
// @TODO: Is there a way to return "class"?
var $aa2dfa8e6e1e6118$var$paramTypeSimple = {
    address: $aa2dfa8e6e1e6118$var$CoderAddress,
    bool: $aa2dfa8e6e1e6118$var$CoderBoolean,
    string: $aa2dfa8e6e1e6118$var$CoderString,
    bytes: $aa2dfa8e6e1e6118$var$CoderDynamicBytes
};
function $aa2dfa8e6e1e6118$var$getTupleParamCoder(coerceFunc, components, localName) {
    if (!components) components = [];
    var coders = [];
    components.forEach(function(component) {
        coders.push($aa2dfa8e6e1e6118$var$getParamCoder(coerceFunc, component));
    });
    return new $aa2dfa8e6e1e6118$var$CoderTuple(coerceFunc, coders, localName);
}
function $aa2dfa8e6e1e6118$var$getParamCoder(coerceFunc, param) {
    var coder = $aa2dfa8e6e1e6118$var$paramTypeSimple[param.type];
    if (coder) return new coder(coerceFunc, param.name);
    var match = param.type.match($aa2dfa8e6e1e6118$var$paramTypeNumber);
    if (match) {
        var size = parseInt(match[2] || "256");
        if (size === 0 || size > 256 || size % 8 !== 0) $aa2dfa8e6e1e6118$var$errors.throwError("invalid " + match[1] + " bit length", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
            arg: "param",
            value: param
        });
        return new $aa2dfa8e6e1e6118$var$CoderNumber(coerceFunc, size / 8, match[1] === "int", param.name);
    }
    var match = param.type.match($aa2dfa8e6e1e6118$var$paramTypeBytes);
    if (match) {
        var size = parseInt(match[1]);
        if (size === 0 || size > 32) $aa2dfa8e6e1e6118$var$errors.throwError("invalid bytes length", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
            arg: "param",
            value: param
        });
        return new $aa2dfa8e6e1e6118$var$CoderFixedBytes(coerceFunc, size, param.name);
    }
    var match = param.type.match($aa2dfa8e6e1e6118$var$paramTypeArray);
    if (match) {
        var size = parseInt(match[2] || "-1");
        param = $6dadc4810a2babb6$exports.shallowCopy(param);
        param.type = match[1];
        param = $6dadc4810a2babb6$exports.deepCopy(param);
        return new $aa2dfa8e6e1e6118$var$CoderArray(coerceFunc, $aa2dfa8e6e1e6118$var$getParamCoder(coerceFunc, param), size, param.name);
    }
    if (param.type.substring(0, 5) === "tuple") return $aa2dfa8e6e1e6118$var$getTupleParamCoder(coerceFunc, param.components, param.name);
    if (param.type === "") return new $aa2dfa8e6e1e6118$var$CoderNull(coerceFunc, param.name);
    $aa2dfa8e6e1e6118$var$errors.throwError("invalid type", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
        arg: "type",
        value: param.type
    });
    return null;
}
var $aa2dfa8e6e1e6118$var$AbiCoder = /** @class */ function() {
    function AbiCoder(coerceFunc) {
        $aa2dfa8e6e1e6118$var$errors.checkNew(this, AbiCoder);
        if (!coerceFunc) coerceFunc = $aa2dfa8e6e1e6118$exports.defaultCoerceFunc;
        $6dadc4810a2babb6$exports.defineReadOnly(this, "coerceFunc", coerceFunc);
    }
    AbiCoder.prototype.encode = function(types, values) {
        if (types.length !== values.length) $aa2dfa8e6e1e6118$var$errors.throwError("types/values length mismatch", $aa2dfa8e6e1e6118$var$errors.INVALID_ARGUMENT, {
            count: {
                types: types.length,
                values: values.length
            },
            value: {
                types: types,
                values: values
            }
        });
        var coders = [];
        types.forEach(function(type) {
            // Convert types to type objects
            //   - "uint foo" => { type: "uint", name: "foo" }
            //   - "tuple(uint, uint)" => { type: "tuple", components: [ { type: "uint" }, { type: "uint" }, ] }
            var typeObject = null;
            if (typeof type === "string") typeObject = $aa2dfa8e6e1e6118$var$parseParam(type);
            else typeObject = type;
            coders.push($aa2dfa8e6e1e6118$var$getParamCoder(this.coerceFunc, typeObject));
        }, this);
        return $36f30ca1d30438a3$exports.hexlify(new $aa2dfa8e6e1e6118$var$CoderTuple(this.coerceFunc, coders, "_").encode(values));
    };
    AbiCoder.prototype.decode = function(types, data) {
        var coders = [];
        types.forEach(function(type) {
            // See encode for details
            var typeObject = null;
            if (typeof type === "string") typeObject = $aa2dfa8e6e1e6118$var$parseParam(type);
            else typeObject = $6dadc4810a2babb6$exports.deepCopy(type);
            coders.push($aa2dfa8e6e1e6118$var$getParamCoder(this.coerceFunc, typeObject));
        }, this);
        return new $aa2dfa8e6e1e6118$var$CoderTuple(this.coerceFunc, coders, "_").decode($36f30ca1d30438a3$exports.arrayify(data), 0).value;
    };
    return AbiCoder;
}();
$aa2dfa8e6e1e6118$exports.AbiCoder = $aa2dfa8e6e1e6118$var$AbiCoder;
$aa2dfa8e6e1e6118$exports.defaultAbiCoder = new $aa2dfa8e6e1e6118$var$AbiCoder();



var $aCcJY = parcelRequire("aCcJY");

var $6ZWSX = parcelRequire("6ZWSX");
class $87d5bb11d6ef18e0$var$Coder extends (0, $aa2dfa8e6e1e6118$exports.AbiCoder) {
    constructor(){
        super((type, value)=>{
            if (type.match(/^u?int/) && !Array.isArray(value) && typeof value !== "object" || value._ethersType === "BigNumber") return value.toString();
            return value;
        });
    }
    encode(types, values) {
        try {
            return super.encode(types, values);
        } catch (err) {
            if (err.reason) throw new Error(err.reason);
            throw err;
        }
    }
    decode(types, data) {
        try {
            return super.decode(types, data);
        } catch (err) {
            if (err.reason) throw new Error(err.reason);
            throw err;
        }
    }
}
const $87d5bb11d6ef18e0$var$coder = new $87d5bb11d6ef18e0$var$Coder();
function $87d5bb11d6ef18e0$var$formatSignature(fragment) {
    try {
        return (0, $aa2dfa8e6e1e6118$exports.formatSignature)(fragment).replace(/\(tuple\(/g, "((").replace(/,tuple\(/g, ",(");
    } catch (err) {
        if (err.reason) throw new Error(err.reason);
        throw err;
    }
}
var $87d5bb11d6ef18e0$export$3de1df63de3dd8b4;
(function(abi) {
    /**
     * encode single parameter
     * @param type type of the parameter
     * @param value value of the parameter
     * @returns encoded value in hex string
     */ function encodeParameter(type, value) {
        return $87d5bb11d6ef18e0$var$coder.encode([
            type
        ], [
            value
        ]);
    }
    abi.encodeParameter = encodeParameter;
    /**
     * decode single parameter
     * @param type type of the parameter
     * @param data encoded parameter in hex string
     * @returns decoded value
     */ function decodeParameter(type, data) {
        return $87d5bb11d6ef18e0$var$coder.decode([
            type
        ], data)[0];
    }
    abi.decodeParameter = decodeParameter;
    /**
     * encode a group of parameters
     * @param types type array
     * @param values value array
     * @returns encoded values in hex string
     */ function encodeParameters(types, values) {
        return $87d5bb11d6ef18e0$var$coder.encode(types, values);
    }
    abi.encodeParameters = encodeParameters;
    /**
     * decode a group of parameters
     * @param types type array
     * @param data encoded values in hex string
     * @returns decoded object
     */ function decodeParameters(types, data) {
        const result = $87d5bb11d6ef18e0$var$coder.decode(types, data);
        const decoded = {};
        types.forEach((t, i)=>{
            decoded[i] = result[i];
            if (t.name) decoded[t.name] = result[i];
        });
        return decoded;
    }
    abi.decodeParameters = decodeParameters;
    /** for contract function */ class Function {
        /**
         * create a function object
         * @param definition abi definition of the function
         */ constructor(definition){
            this.definition = definition;
            this.canonicalName = $87d5bb11d6ef18e0$var$formatSignature(definition);
            this.signature = "0x" + (0, $aCcJY.keccak256)(this.canonicalName).slice(0, 4).toString("hex");
        }
        /**
         * encode input parameters into call data
         * @param args arguments for the function
         */ encode(...args) {
            return this.signature + encodeParameters(this.definition.inputs, args).slice(2);
        }
        /**
         * decode output data
         * @param outputData output data to decode
         */ decode(outputData) {
            return decodeParameters(this.definition.outputs, outputData);
        }
    }
    abi.Function = Function;
    /** for contract event */ class Event {
        /** for contract event */ constructor(definition){
            this.definition = definition;
            this.canonicalName = $87d5bb11d6ef18e0$var$formatSignature(definition);
            this.signature = "0x" + (0, $aCcJY.keccak256)(this.canonicalName).toString("hex");
        }
        /**
         * encode an object of indexed keys into topics.
         * @param indexed an object contains indexed keys
         */ encode(indexed) {
            const topics = [];
            if (!this.definition.anonymous) topics.push(this.signature);
            for (const input of this.definition.inputs){
                if (!input.indexed) continue;
                const value = indexed[input.name];
                if (value === undefined || value === null) topics.push(null);
                else {
                    let topic;
                    // https://docs.soliditylang.org/en/v0.8.11/abi-spec.html#encoding-of-indexed-event-parameters
                    if (isValueType(input.type)) topic = encodeParameter(input.type, value);
                    else {
                        if (input.type === "string") topic = "0x" + (0, $aCcJY.keccak256)(value).toString("hex");
                        else if (typeof value === "string" && /^0x[0-9a-f]+$/i.test(value) && value.length % 2 === 0) // value is encoded
                        topic = "0x" + (0, $aCcJY.keccak256)((0, $6ZWSX.Buffer).from(value.slice(2), "hex")).toString("hex");
                        else throw new Error(`event.encode: invalid ${input.type} value`);
                    }
                    topics.push(topic);
                }
            }
            return topics;
        }
        /**
         * decode event log
         * @param data data in event output
         * @param topics topics in event
         */ decode(data, topics) {
            if (!this.definition.anonymous) topics = topics.slice(1);
            if (this.definition.inputs.filter((t)=>t.indexed).length !== topics.length) throw new Error("invalid topics count");
            const decodedNonIndexed = $87d5bb11d6ef18e0$var$coder.decode(this.definition.inputs.filter((t)=>!t.indexed), data);
            const decoded = {};
            this.definition.inputs.forEach((t, i)=>{
                if (t.indexed) {
                    const topic = topics.shift();
                    decoded[i] = isValueType(t.type) ? decodeParameter(t.type, topic) : topic;
                } else decoded[i] = decodedNonIndexed.shift();
                if (t.name) decoded[t.name] = decoded[i];
            });
            return decoded;
        }
    }
    abi.Event = Event;
    function isValueType(type) {
        return type === "address" || type === "bool" || /^(u?int)(\d*)$/.test(type) || /^bytes(\d+)$/.test(type);
    }
})($87d5bb11d6ef18e0$export$3de1df63de3dd8b4 || ($87d5bb11d6ef18e0$export$3de1df63de3dd8b4 = {}));



var $aCcJY = parcelRequire("aCcJY");
// https://docs.soliditylang.org/en/v0.8.16/control-structures.html#error-handling-assert-require-revert-and-exceptions
// builtin errors in solidity, Error(string) and Panic(uint256)
const $7d619938cb6b8de1$var$errorSelector = "0x" + (0, $aCcJY.keccak256)("Error(string)").toString("hex").slice(0, 8);
const $7d619938cb6b8de1$var$panicSelector = "0x" + (0, $aCcJY.keccak256)("Panic(uint256)").toString("hex").slice(0, 8);
function $7d619938cb6b8de1$export$d8c990de1767b71f(data) {
    try {
        if (data.startsWith($7d619938cb6b8de1$var$errorSelector)) return (0, $87d5bb11d6ef18e0$export$3de1df63de3dd8b4).decodeParameter("string", "0x" + data.slice($7d619938cb6b8de1$var$errorSelector.length));
        else if (data.startsWith($7d619938cb6b8de1$var$panicSelector)) {
            const decoded = (0, $87d5bb11d6ef18e0$export$3de1df63de3dd8b4).decodeParameter("uint256", "0x" + data.slice($7d619938cb6b8de1$var$panicSelector.length));
            return `Panic(0x${parseInt(decoded).toString(16).padStart(2, "0")})`;
        }
        return "";
    } catch (_a) {
        return "";
    }
}


/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ var $34eec9ede8c6d9f9$exports = {};
"use strict";
Object.defineProperty($34eec9ede8c6d9f9$exports, "__esModule", {
    value: true
});
/**
 * convert the given Scheme into a Rule that allows undefined value
 * @param scheme the scheme
 */ function $34eec9ede8c6d9f9$var$optional(scheme) {
    return (value, context)=>{
        if (value !== undefined) $34eec9ede8c6d9f9$var$validate(value, scheme, context);
        return "";
    };
}
$34eec9ede8c6d9f9$exports.optional = $34eec9ede8c6d9f9$var$optional;
/**
 * convert the given Scheme into a Rule that allows null value
 * @param scheme the scheme
 */ function $34eec9ede8c6d9f9$var$nullable(scheme) {
    return (value, context)=>{
        if (value !== null) $34eec9ede8c6d9f9$var$validate(value, scheme, context);
        return "";
    };
}
$34eec9ede8c6d9f9$exports.nullable = $34eec9ede8c6d9f9$var$nullable;
/** Validator class */ class $34eec9ede8c6d9f9$var$Validator {
    constructor(scheme){
        this.scheme = scheme;
    }
    test(value, context) {
        return $34eec9ede8c6d9f9$var$validate(value, this.scheme, context);
    }
}
$34eec9ede8c6d9f9$exports.Validator = $34eec9ede8c6d9f9$var$Validator;
/** Error class describes validation error */ class $34eec9ede8c6d9f9$var$ValidationError extends Error {
    constructor(rawMessage, context){
        super(context ? `${context}: ${rawMessage}` : rawMessage);
        this.rawMessage = rawMessage;
        this.context = context;
    }
}
$34eec9ede8c6d9f9$exports.ValidationError = $34eec9ede8c6d9f9$var$ValidationError;
$34eec9ede8c6d9f9$var$ValidationError.prototype.name = "ValidationError";
/**
 * direct function to validate value without construct Validator object
 * @param value value to be validated
 * @param scheme scheme
 * @param context context string appears in error object
 */ function $34eec9ede8c6d9f9$var$validate(value, scheme, context) {
    if (Array.isArray(scheme)) {
        if (!Array.isArray(value)) throw new $34eec9ede8c6d9f9$var$ValidationError("expected array", context || "");
        value.forEach((el, i)=>$34eec9ede8c6d9f9$var$validate(el, scheme[0], context ? `${context}.#${i}` : `#${i}`));
    } else if (scheme instanceof Function) {
        const errMsg = scheme(value, context);
        if (errMsg) throw new $34eec9ede8c6d9f9$var$ValidationError(errMsg, context || "");
    } else {
        if (!(value instanceof Object)) throw new $34eec9ede8c6d9f9$var$ValidationError("expected object", context || "");
        for(const key in scheme)if (scheme.hasOwnProperty(key)) $34eec9ede8c6d9f9$var$validate(value[key], scheme[key], context ? `${context}.${key}` : key);
    }
    return value;
}
$34eec9ede8c6d9f9$exports.validate = $34eec9ede8c6d9f9$var$validate;


function $805873001930ba7e$export$9a301e927062062(val) {
    return typeof val === "string" && /^[0-9]+$/.test(val);
}
function $805873001930ba7e$export$b02a40aff8e4ad18(val) {
    return typeof val === "string" && /^0x[0-9a-f]+$/i.test(val);
}
function $805873001930ba7e$export$5f493709ce2232d6(val, n) {
    if (typeof val !== "string" || !/^0x[0-9a-f]*$/i.test(val)) return false;
    return n ? val.length === n * 2 + 2 : val.length % 2 === 0;
}
function $805873001930ba7e$export$718d406b7f640eef(val, bit) {
    if (val < 0 || !Number.isInteger(val)) return false;
    return bit ? val < Math.pow(2, bit) : true;
}
function $805873001930ba7e$export$c4c1bdb0d1c7cfc7(v) {
    return typeof v === "string" ? $805873001930ba7e$export$9a301e927062062(v) || $805873001930ba7e$export$b02a40aff8e4ad18(v) : $805873001930ba7e$export$718d406b7f640eef(v, 0);
}
class $805873001930ba7e$export$602e9f66b41a1160 extends Error {
    constructor(msg){
        super(msg);
    }
}
$805873001930ba7e$export$602e9f66b41a1160.prototype.name = "BadParameter";
function $805873001930ba7e$export$c291509e8e0abb43(b, msg) {
    if (!b) throw new $805873001930ba7e$export$602e9f66b41a1160(msg);
}
function $805873001930ba7e$export$e0969da9b8fb378d(value, scheme, context) {
    try {
        return $34eec9ede8c6d9f9$exports.validate(value, scheme, context);
    } catch (err) {
        if (err instanceof $34eec9ede8c6d9f9$exports.ValidationError) throw new $805873001930ba7e$export$602e9f66b41a1160(err.message);
        throw err;
    }
}
function $805873001930ba7e$export$b3317979f9250576(v) {
    return $805873001930ba7e$export$5f493709ce2232d6(v) ? "" : "expected bytes in hex string";
}
function $805873001930ba7e$export$ab581ee3ae9b8c92(v) {
    return $805873001930ba7e$export$5f493709ce2232d6(v, 8) ? "" : "expected bytes8";
}
function $805873001930ba7e$export$1a4f358fa435a50d(v) {
    return $805873001930ba7e$export$5f493709ce2232d6(v, 32) ? "" : "expected bytes32";
}
function $805873001930ba7e$export$52e103c63c4e68cf(v) {
    return $805873001930ba7e$export$718d406b7f640eef(v, 8) ? "" : "expected 8-bit unsigned integer";
}
function $805873001930ba7e$export$de9ffb9418dd7d0d(v) {
    return $805873001930ba7e$export$718d406b7f640eef(v, 32) ? "" : "expected 32-bit unsigned integer";
}
function $805873001930ba7e$export$870002f71f6ee2de(v) {
    return $805873001930ba7e$export$718d406b7f640eef(v, 64) ? "" : "expected 64-bit unsigned integer";
}
function $805873001930ba7e$export$87b259aa03e3d267(v) {
    return typeof v === "boolean" ? "" : "expected boolean";
}
function $805873001930ba7e$export$c97e695afb26d84(v) {
    return $805873001930ba7e$export$c4c1bdb0d1c7cfc7(v) ? "" : "expected unsigned integer in number or string";
}
function $805873001930ba7e$export$1b06654353ef9f67(v) {
    return $805873001930ba7e$export$b02a40aff8e4ad18(v) ? "" : "expected integer in hex string";
}
function $805873001930ba7e$export$f7d3c097ceca6c15(v) {
    return $805873001930ba7e$export$5f493709ce2232d6(v, 20) ? "" : "expected address";
}
function $805873001930ba7e$export$22b082955e083ec3(v) {
    return typeof v === "string" ? "" : "expected string";
}


const $92a336add588c8bf$var$MAX_LIMIT = 256;
function $92a336add588c8bf$export$e4dab2ca248f78f1(readyDriver, kind, criteria) {
    const filterBody = {
        range: {
            unit: "block",
            from: 0,
            to: Math.pow(2, 32) - 1
        },
        options: {
            offset: 0,
            limit: 10
        },
        criteriaSet: criteria,
        order: "asc"
    };
    let cacheHints;
    return {
        range (range) {
            $805873001930ba7e$export$e0969da9b8fb378d(range, {
                unit: (v)=>v === "block" || v === "time" ? "" : `expected 'block' or 'time'`,
                from: $805873001930ba7e$export$870002f71f6ee2de,
                to: $805873001930ba7e$export$870002f71f6ee2de
            }, "arg0");
            $805873001930ba7e$export$c291509e8e0abb43(range.from <= range.to, "arg0.from: expected <= arg0.to");
            filterBody.range = Object.assign({}, range);
            return this;
        },
        order (order) {
            $805873001930ba7e$export$c291509e8e0abb43(order === "asc" || order === "desc", `arg0: expected 'asc' or 'desc'`);
            filterBody.order = order;
            return this;
        },
        cache (hints) {
            cacheHints = $805873001930ba7e$export$e0969da9b8fb378d(hints, [
                $805873001930ba7e$export$f7d3c097ceca6c15
            ], "arg0").map((t)=>t.toLowerCase());
            return this;
        },
        apply (offset, limit) {
            $805873001930ba7e$export$e0969da9b8fb378d(offset, $805873001930ba7e$export$870002f71f6ee2de, "arg0");
            $805873001930ba7e$export$c291509e8e0abb43(limit >= 0 && limit <= $92a336add588c8bf$var$MAX_LIMIT && Number.isInteger(limit), `arg1: expected unsigned integer <= ${$92a336add588c8bf$var$MAX_LIMIT}`);
            filterBody.options.offset = offset;
            filterBody.options.limit = limit;
            if (kind === "transfer") return readyDriver.then((d)=>d.filterTransferLogs(filterBody, cacheHints));
            else return readyDriver.then((d)=>d.filterEventLogs(filterBody, cacheHints));
        }
    };
}






var $5Kq8F = parcelRequire("5Kq8F");
var $0ef68bc7dc0cae13$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $0ef68bc7dc0cae13$export$2a23acb45fe6803e(driver) {
    return {
        sign: (kind, msg)=>{
            if (kind === "tx") {
                $805873001930ba7e$export$e0969da9b8fb378d(msg, [
                    $0ef68bc7dc0cae13$var$clauseScheme
                ], "arg1");
                return $0ef68bc7dc0cae13$export$608f889fec86cea1(Promise.resolve(driver), msg);
            } else if (kind === "cert") {
                $805873001930ba7e$export$e0969da9b8fb378d(msg, {
                    purpose: (v)=>v === "agreement" || v === "identification" ? "" : `expected 'agreement' or 'identification'`,
                    payload: {
                        type: (v)=>v === "text" ? "" : `expected 'text'`,
                        content: $805873001930ba7e$export$22b082955e083ec3
                    }
                }, "arg1");
                return $0ef68bc7dc0cae13$var$newCertSigningService(Promise.resolve(driver), msg);
            } else throw new $805873001930ba7e$export$602e9f66b41a1160(`arg0: expected 'tx' or 'cert'`);
        }
    };
}
function $0ef68bc7dc0cae13$export$608f889fec86cea1(readyDriver, msg) {
    const opts = {};
    return {
        signer (addr) {
            opts.signer = $805873001930ba7e$export$e0969da9b8fb378d(addr, $805873001930ba7e$export$f7d3c097ceca6c15, "arg0").toLowerCase();
            return this;
        },
        gas (gas) {
            opts.gas = $805873001930ba7e$export$e0969da9b8fb378d(gas, $805873001930ba7e$export$870002f71f6ee2de, "arg0");
            return this;
        },
        dependsOn (txid) {
            opts.dependsOn = $805873001930ba7e$export$e0969da9b8fb378d(txid, $805873001930ba7e$export$1a4f358fa435a50d, "arg0").toLowerCase();
            return this;
        },
        link (url) {
            opts.link = $805873001930ba7e$export$e0969da9b8fb378d(url, $805873001930ba7e$export$22b082955e083ec3, "arg0");
            return this;
        },
        comment (text) {
            opts.comment = $805873001930ba7e$export$e0969da9b8fb378d(text, $805873001930ba7e$export$22b082955e083ec3, "arg0");
            return this;
        },
        delegate (url, signer) {
            $805873001930ba7e$export$c291509e8e0abb43(typeof url === "string", `arg0: expected url string`);
            $805873001930ba7e$export$e0969da9b8fb378d(signer, $34eec9ede8c6d9f9$exports.optional($805873001930ba7e$export$f7d3c097ceca6c15), "arg1");
            opts.delegator = {
                url: url,
                signer: signer && signer.toLowerCase()
            };
            return this;
        },
        accepted (cb) {
            $805873001930ba7e$export$c291509e8e0abb43(typeof cb === "function", "arg0: expected function");
            opts.onAccepted = cb;
            return this;
        },
        request () {
            const transformedMsg = msg.map((c)=>Object.assign(Object.assign({}, c), {
                    value: new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(c.value).toString(10)
                }));
            return (()=>$0ef68bc7dc0cae13$var$__awaiter(this, void 0, void 0, function*() {
                    try {
                        const driver = yield readyDriver;
                        return yield driver.signTx(transformedMsg, opts);
                    } catch (err) {
                        throw new $0ef68bc7dc0cae13$var$Rejected(err.message);
                    }
                }))();
        }
    };
}
function $0ef68bc7dc0cae13$var$newCertSigningService(readyDriver, msg) {
    const opts = {};
    return {
        signer (addr) {
            opts.signer = $805873001930ba7e$export$e0969da9b8fb378d(addr, $805873001930ba7e$export$f7d3c097ceca6c15, "arg0").toLowerCase();
            return this;
        },
        link (url) {
            opts.link = $805873001930ba7e$export$e0969da9b8fb378d(url, $805873001930ba7e$export$22b082955e083ec3, "arg0");
            return this;
        },
        accepted (cb) {
            $805873001930ba7e$export$c291509e8e0abb43(typeof cb === "function", "arg0: expected function");
            opts.onAccepted = cb;
            return this;
        },
        request () {
            return (()=>$0ef68bc7dc0cae13$var$__awaiter(this, void 0, void 0, function*() {
                    try {
                        const driver = yield readyDriver;
                        return yield driver.signCert(msg, opts);
                    } catch (err) {
                        throw new $0ef68bc7dc0cae13$var$Rejected(err.message);
                    }
                }))();
        }
    };
}
class $0ef68bc7dc0cae13$var$Rejected extends Error {
    constructor(msg){
        super(msg);
    }
}
$0ef68bc7dc0cae13$var$Rejected.prototype.name = "Rejected";
const $0ef68bc7dc0cae13$var$clauseScheme = {
    to: $34eec9ede8c6d9f9$exports.nullable($805873001930ba7e$export$f7d3c097ceca6c15),
    value: $805873001930ba7e$export$c97e695afb26d84,
    data: $34eec9ede8c6d9f9$exports.optional($805873001930ba7e$export$b3317979f9250576),
    comment: $34eec9ede8c6d9f9$exports.optional($805873001930ba7e$export$22b082955e083ec3),
    abi: $34eec9ede8c6d9f9$exports.optional((v)=>{
        if (!(v instanceof Object)) return "expected object";
        try {
            new (0, $87d5bb11d6ef18e0$export$3de1df63de3dd8b4).Function(v).signature;
            return "";
        } catch (err) {
            return `expected valid ABI (${err.message})`;
        }
    })
};



function $6770d46c314e5b0f$export$6543f75972bc0704(readyDriver, addr) {
    return {
        get address () {
            return addr;
        },
        get: ()=>{
            return readyDriver.then((d)=>d.getAccount(addr, d.head.id));
        },
        getCode: ()=>{
            return readyDriver.then((d)=>d.getCode(addr, d.head.id));
        },
        getStorage: (key)=>{
            key = $805873001930ba7e$export$e0969da9b8fb378d(key, $805873001930ba7e$export$1a4f358fa435a50d, "arg0").toLowerCase();
            return readyDriver.then((d)=>d.getStorage(addr, key, d.head.id));
        },
        method: (jsonABI)=>{
            let coder;
            try {
                coder = new (0, $87d5bb11d6ef18e0$export$3de1df63de3dd8b4).Function(JSON.parse(JSON.stringify(jsonABI)));
            } catch (err) {
                throw new $805873001930ba7e$export$602e9f66b41a1160(`arg0: expected valid ABI (${err.message})`);
            }
            return $6770d46c314e5b0f$var$newMethod(readyDriver, addr, coder);
        },
        event: (jsonABI)=>{
            let coder;
            try {
                coder = new (0, $87d5bb11d6ef18e0$export$3de1df63de3dd8b4).Event(JSON.parse(JSON.stringify(jsonABI)));
            } catch (err) {
                throw new $805873001930ba7e$export$602e9f66b41a1160(`arg0: expected valid ABI (${err.message})`);
            }
            return $6770d46c314e5b0f$var$newEvent(readyDriver, addr, coder);
        }
    };
}
function $6770d46c314e5b0f$var$newMethod(readyDriver, addr, coder) {
    let value = 0;
    const opts = {};
    let cacheHints;
    return {
        value (val) {
            value = $805873001930ba7e$export$e0969da9b8fb378d(val, $805873001930ba7e$export$c97e695afb26d84, "arg0");
            return this;
        },
        caller (addr) {
            opts.caller = $805873001930ba7e$export$e0969da9b8fb378d(addr, $805873001930ba7e$export$f7d3c097ceca6c15, "arg0").toLowerCase();
            return this;
        },
        gas (gas) {
            opts.gas = $805873001930ba7e$export$e0969da9b8fb378d(gas, $805873001930ba7e$export$870002f71f6ee2de, "arg0");
            return this;
        },
        gasPrice (gp) {
            opts.gasPrice = $805873001930ba7e$export$e0969da9b8fb378d(gp, $805873001930ba7e$export$c97e695afb26d84, "arg0").toString().toLowerCase();
            return this;
        },
        gasPayer (addr) {
            opts.gasPayer = $805873001930ba7e$export$e0969da9b8fb378d(addr, $805873001930ba7e$export$f7d3c097ceca6c15, "arg0").toLowerCase();
            return this;
        },
        cache (hints) {
            cacheHints = $805873001930ba7e$export$e0969da9b8fb378d(hints, [
                $805873001930ba7e$export$f7d3c097ceca6c15
            ], "arg0").map((t)=>t.toLowerCase());
            return this;
        },
        asClause: (...args)=>{
            const inputsLen = (coder.definition.inputs || []).length;
            $805873001930ba7e$export$c291509e8e0abb43(inputsLen === args.length, `args count expected ${inputsLen}`);
            try {
                const data = coder.encode(...args);
                return {
                    to: addr,
                    value: value.toString().toLowerCase(),
                    data: data
                };
            } catch (err) {
                throw new $805873001930ba7e$export$602e9f66b41a1160(`args can not be encoded (${err.message})`);
            }
        },
        call (...args) {
            const clause = this.asClause(...args);
            return readyDriver.then((d)=>d.explain(Object.assign({
                    clauses: [
                        clause
                    ]
                }, opts), d.head.id, cacheHints)).then((outputs)=>outputs[0]).then((output)=>{
                if (output.reverted) {
                    const revertReason = (0, $7d619938cb6b8de1$export$d8c990de1767b71f)(output.data);
                    return Object.assign(Object.assign({}, output), {
                        revertReason: revertReason,
                        decoded: {}
                    });
                } else {
                    const decoded = coder.decode(output.data);
                    return Object.assign(Object.assign({}, output), {
                        decoded: decoded
                    });
                }
            });
        },
        transact (...args) {
            const clause = this.asClause(...args);
            return (0, $0ef68bc7dc0cae13$export$608f889fec86cea1)(readyDriver, [
                Object.assign(Object.assign({}, clause), {
                    abi: coder.definition
                })
            ]);
        }
    };
}
function $6770d46c314e5b0f$var$newEvent(readyDriver, addr, coder) {
    const encode = (indexed)=>{
        const topics = coder.encode(indexed);
        return {
            address: addr,
            topic0: topics[0] || undefined,
            topic1: topics[1] || undefined,
            topic2: topics[2] || undefined,
            topic3: topics[3] || undefined,
            topic4: topics[4] || undefined
        };
    };
    return {
        asCriteria: (indexed)=>{
            try {
                return encode(indexed);
            } catch (err) {
                throw new $805873001930ba7e$export$602e9f66b41a1160(`arg0: can not be encoded (${err.message})`);
            }
        },
        filter: (indexed)=>{
            $805873001930ba7e$export$e0969da9b8fb378d(indexed, [
                {}
            ], "arg0");
            if (indexed.length === 0) indexed = [
                {}
            ];
            const criteria = indexed.map((o, i)=>{
                try {
                    return encode(o);
                } catch (err) {
                    throw new $805873001930ba7e$export$602e9f66b41a1160(`arg0.#${i}: can not be encoded (${err.message})`);
                }
            });
            const filter = (0, $92a336add588c8bf$export$e4dab2ca248f78f1)(readyDriver, "event", criteria);
            return {
                range (range) {
                    filter.range(range);
                    return this;
                },
                order (order) {
                    filter.order(order);
                    return this;
                },
                cache (hints) {
                    filter.cache(hints);
                    return this;
                },
                apply (offset, limit) {
                    return filter.apply(offset, limit).then((events)=>events.map((event)=>{
                            const decoded = coder.decode(event.data, event.topics);
                            return Object.assign(Object.assign({}, event), {
                                decoded: decoded
                            });
                        }));
                }
            };
        }
    };
}


function $66dd2857e6328dc5$export$f8c4645d39827a54(driver, revision) {
    return {
        get revision () {
            return revision;
        },
        get: ()=>driver.getBlock(revision)
    };
}


function $e053d46ceff5caeb$export$2776a1970d3a920c(readyDriver, id) {
    let allowPending = false;
    return {
        get id () {
            return id;
        },
        allowPending () {
            allowPending = true;
            return this;
        },
        get: ()=>readyDriver.then((d)=>d.getTransaction(id, allowPending)),
        getReceipt: ()=>readyDriver.then((d)=>d.getReceipt(id))
    };
}



var $377da49a7f1d287f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const $377da49a7f1d287f$var$checkpointInterval = 180;
function $377da49a7f1d287f$export$262e0fd9e55ca09b(driver) {
    let head = Object.assign({}, driver.head);
    let finalized = driver.genesis.id;
    let resolvers = [];
    (()=>$377da49a7f1d287f$var$__awaiter(this, void 0, void 0, function*() {
            for(;;)try {
                const newHead = yield driver.pollHead();
                if (newHead.id !== head.id && newHead.number >= head.number) {
                    if (head.number === 0 || (newHead.number + 1) % $377da49a7f1d287f$var$checkpointInterval === 0) try {
                        const finalizedBlk = yield driver.getBlock("finalized");
                        if (finalizedBlk && finalizedBlk.id != finalized) finalized = finalizedBlk.id;
                    } catch (_a) {}
                    head = Object.assign({}, newHead);
                    const resolversCopy = resolvers;
                    resolvers = [];
                    resolversCopy.forEach((r)=>r(newHead));
                } else yield new Promise((resolve)=>setTimeout(resolve, 1000));
            } catch (_b) {
                break;
            }
        }))();
    const genesisTs = driver.genesis.timestamp;
    return {
        get head () {
            return head;
        },
        get progress () {
            const nowTsMs = Date.now();
            const headTsMs = head.timestamp * 1000;
            if (nowTsMs - headTsMs < 30000) return 1;
            const genesisTsMs = genesisTs * 1000;
            const p = (headTsMs - genesisTsMs) / (nowTsMs - genesisTsMs);
            return p < 0 ? NaN : p;
        },
        get finalized () {
            return finalized;
        },
        ticker: ()=>{
            let lastHeadId = head.id;
            return {
                next: ()=>{
                    return new Promise((resolve)=>{
                        if (lastHeadId !== head.id) return resolve(Object.assign({}, head));
                        resolvers.push((newHead)=>{
                            resolve(Object.assign({}, newHead));
                        });
                    }).then((h)=>{
                        lastHeadId = h.id;
                        return h;
                    });
                }
            };
        }
    };
}





var $5Kq8F = parcelRequire("5Kq8F");
function $abd3f23bd13bf0bd$export$e626e96088803350(readyDriver, clauses) {
    const opts = {};
    let cacheHints;
    return {
        caller (addr) {
            opts.caller = $805873001930ba7e$export$e0969da9b8fb378d(addr, $805873001930ba7e$export$f7d3c097ceca6c15, "arg0").toLowerCase();
            return this;
        },
        gas (gas) {
            opts.gas = $805873001930ba7e$export$e0969da9b8fb378d(gas, $805873001930ba7e$export$870002f71f6ee2de, "arg0");
            return this;
        },
        gasPrice (gp) {
            opts.gasPrice = $805873001930ba7e$export$e0969da9b8fb378d(gp, $805873001930ba7e$export$c97e695afb26d84, "arg0").toString().toLowerCase();
            return this;
        },
        gasPayer (addr) {
            opts.gasPayer = $805873001930ba7e$export$e0969da9b8fb378d(addr, $805873001930ba7e$export$f7d3c097ceca6c15, "arg0").toLowerCase();
            return this;
        },
        cache (hints) {
            cacheHints = $805873001930ba7e$export$e0969da9b8fb378d(hints, [
                $805873001930ba7e$export$f7d3c097ceca6c15
            ], "arg0").map((t)=>t.toLowerCase());
            return this;
        },
        execute () {
            const transformedClauses = clauses.map((c)=>{
                return {
                    to: c.to ? c.to.toLowerCase() : null,
                    value: new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(c.value).toString(10),
                    data: (c.data || "0x").toLowerCase()
                };
            });
            return readyDriver.then((d)=>d.explain(Object.assign({
                    clauses: transformedClauses
                }, opts), d.head.id, cacheHints)).then((outputs)=>{
                return outputs.map((o)=>{
                    if (o.reverted) {
                        const revertReason = (0, $7d619938cb6b8de1$export$d8c990de1767b71f)(o.data);
                        return Object.assign(Object.assign({}, o), {
                            revertReason: revertReason
                        });
                    }
                    return o;
                });
            });
        }
    };
}




var $87026cc8be2c0eb7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $87026cc8be2c0eb7$export$ed0b62d232bf177(driver) {
    const headTracker = (0, $377da49a7f1d287f$export$262e0fd9e55ca09b)(driver);
    const readyDriver = (()=>$87026cc8be2c0eb7$var$__awaiter(this, void 0, void 0, function*() {
            if (headTracker.head.number > 0) return driver;
            yield headTracker.ticker().next();
            return driver;
        }))();
    const genesis = JSON.parse(JSON.stringify(driver.genesis));
    return {
        get genesis () {
            return genesis;
        },
        get status () {
            return {
                head: headTracker.head,
                progress: headTracker.progress,
                finalized: headTracker.finalized
            };
        },
        ticker: ()=>headTracker.ticker(),
        account: (addr)=>{
            addr = $805873001930ba7e$export$e0969da9b8fb378d(addr, $805873001930ba7e$export$f7d3c097ceca6c15, "arg0").toLowerCase();
            return (0, $6770d46c314e5b0f$export$6543f75972bc0704)(readyDriver, addr);
        },
        block: (revision)=>{
            if (typeof revision === "undefined") revision = driver.head.id;
            else $805873001930ba7e$export$c291509e8e0abb43(typeof revision === "string" ? $805873001930ba7e$export$5f493709ce2232d6(revision, 32) : $805873001930ba7e$export$718d406b7f640eef(revision, 32), "arg0: expected bytes32 or unsigned 32-bit integer");
            return (0, $66dd2857e6328dc5$export$f8c4645d39827a54)(driver, typeof revision === "string" ? revision.toLowerCase() : revision);
        },
        transaction: (id)=>{
            id = $805873001930ba7e$export$e0969da9b8fb378d(id, $805873001930ba7e$export$1a4f358fa435a50d, "arg0").toLowerCase();
            return (0, $e053d46ceff5caeb$export$2776a1970d3a920c)(readyDriver, id);
        },
        filter: (kind, criteria)=>{
            $805873001930ba7e$export$c291509e8e0abb43(kind === "event" || kind === "transfer", `arg0: expected 'event' or 'transfer'`);
            if (kind === "event") {
                $805873001930ba7e$export$e0969da9b8fb378d(criteria, [
                    $87026cc8be2c0eb7$var$eventCriteriaScheme
                ], "arg1");
                return (0, $92a336add588c8bf$export$e4dab2ca248f78f1)(readyDriver, "event", criteria.map((c)=>{
                    return {
                        address: c.address ? c.address.toLowerCase() : undefined,
                        topic0: c.topic0 ? c.topic0.toLowerCase() : undefined,
                        topic1: c.topic1 ? c.topic1.toLowerCase() : undefined,
                        topic2: c.topic2 ? c.topic2.toLowerCase() : undefined,
                        topic3: c.topic3 ? c.topic3.toLowerCase() : undefined,
                        topic4: c.topic4 ? c.topic4.toLowerCase() : undefined
                    };
                }));
            } else {
                $805873001930ba7e$export$e0969da9b8fb378d(criteria, [
                    $87026cc8be2c0eb7$var$transferCriteriaScheme
                ], "arg1");
                return (0, $92a336add588c8bf$export$e4dab2ca248f78f1)(readyDriver, "transfer", criteria.map((c)=>{
                    return {
                        txOrigin: c.txOrigin ? c.txOrigin.toLowerCase() : undefined,
                        sender: c.sender ? c.sender.toLowerCase() : undefined,
                        recipient: c.recipient ? c.recipient.toLowerCase() : undefined
                    };
                }));
            }
        },
        explain: (clauses)=>{
            $805873001930ba7e$export$e0969da9b8fb378d(clauses, [
                $87026cc8be2c0eb7$var$clauseScheme
            ], "arg0");
            return (0, $abd3f23bd13bf0bd$export$e626e96088803350)(readyDriver, clauses);
        }
    };
}
const $87026cc8be2c0eb7$var$clauseScheme = {
    to: $34eec9ede8c6d9f9$exports.nullable($805873001930ba7e$export$f7d3c097ceca6c15),
    value: $805873001930ba7e$export$c97e695afb26d84,
    data: $34eec9ede8c6d9f9$exports.optional($805873001930ba7e$export$b3317979f9250576)
};
const $87026cc8be2c0eb7$var$eventCriteriaScheme = {
    address: $34eec9ede8c6d9f9$exports.optional($805873001930ba7e$export$f7d3c097ceca6c15),
    topic0: $34eec9ede8c6d9f9$exports.optional($805873001930ba7e$export$1a4f358fa435a50d),
    topic1: $34eec9ede8c6d9f9$exports.optional($805873001930ba7e$export$1a4f358fa435a50d),
    topic2: $34eec9ede8c6d9f9$exports.optional($805873001930ba7e$export$1a4f358fa435a50d),
    topic3: $34eec9ede8c6d9f9$exports.optional($805873001930ba7e$export$1a4f358fa435a50d),
    topic4: $34eec9ede8c6d9f9$exports.optional($805873001930ba7e$export$1a4f358fa435a50d)
};
const $87026cc8be2c0eb7$var$transferCriteriaScheme = {
    sender: $34eec9ede8c6d9f9$exports.optional($805873001930ba7e$export$f7d3c097ceca6c15),
    recipient: $34eec9ede8c6d9f9$exports.optional($805873001930ba7e$export$f7d3c097ceca6c15),
    txOrigin: $34eec9ede8c6d9f9$exports.optional($805873001930ba7e$export$f7d3c097ceca6c15)
};





function $0ac9d28c51f328e4$export$98d3fdab2faa8d6e(driver, errHandler) {
    const test = (obj, scheme, path)=>{
        try {
            $34eec9ede8c6d9f9$exports.validate(obj, scheme, path);
        } catch (err) {
            if (errHandler) errHandler(err);
            else // tslint:disable-next-line:no-console
            console.warn(`Connex-Driver[MALFORMED RESPONSE]: ${err.message}`);
        }
        return obj;
    };
    const genesis = test(driver.genesis, $0ac9d28c51f328e4$var$blockScheme, "genesis");
    return {
        genesis: genesis,
        get head () {
            return test(driver.head, $0ac9d28c51f328e4$var$headScheme, "head");
        },
        pollHead () {
            return driver.pollHead().then((h)=>test(h, $0ac9d28c51f328e4$var$headScheme, "getHead()"));
        },
        getBlock (revision) {
            return driver.getBlock(revision).then((b)=>b ? test(b, $0ac9d28c51f328e4$var$blockScheme, "getBlock()") : b);
        },
        getTransaction (id, allowPending) {
            return driver.getTransaction(id, allowPending).then((tx)=>tx ? test(tx, $0ac9d28c51f328e4$var$txScheme, "getTransaction()") : tx);
        },
        getReceipt (id) {
            return driver.getReceipt(id).then((r)=>r ? test(r, $0ac9d28c51f328e4$var$receiptScheme, "getReceipt()") : r);
        },
        getAccount (addr, revision) {
            return driver.getAccount(addr, revision).then((a)=>test(a, {
                    balance: $805873001930ba7e$export$1b06654353ef9f67,
                    energy: $805873001930ba7e$export$1b06654353ef9f67,
                    hasCode: $805873001930ba7e$export$87b259aa03e3d267
                }, "getAccount()"));
        },
        getCode (addr, revision) {
            return driver.getCode(addr, revision).then((c)=>test(c, {
                    code: $805873001930ba7e$export$b3317979f9250576
                }, "getCode()"));
        },
        getStorage (addr, key, revision) {
            return driver.getStorage(addr, key, revision).then((s)=>test(s, {
                    value: $805873001930ba7e$export$1a4f358fa435a50d
                }, "getStorage()"));
        },
        explain (arg, revision) {
            return driver.explain(arg, revision).then((r)=>test(r, [
                    $0ac9d28c51f328e4$var$vmOutputScheme
                ], "explain()"));
        },
        filterEventLogs (arg) {
            return driver.filterEventLogs(arg).then((r)=>test(r, [
                    $0ac9d28c51f328e4$var$eventWithMetaScheme
                ], "filterEventLogs()"));
        },
        filterTransferLogs (arg) {
            return driver.filterTransferLogs(arg).then((r)=>test(r, [
                    $0ac9d28c51f328e4$var$transferWithMetaScheme
                ], "filterTransferLogs()"));
        },
        signTx (msg, options) {
            return driver.signTx(msg, options).then((r)=>test(r, {
                    txid: $805873001930ba7e$export$1a4f358fa435a50d,
                    signer: $805873001930ba7e$export$f7d3c097ceca6c15
                }, "signTx()"));
        },
        signCert (msg, options) {
            return driver.signCert(msg, options).then((r)=>test(r, {
                    annex: {
                        domain: $805873001930ba7e$export$22b082955e083ec3,
                        timestamp: $805873001930ba7e$export$870002f71f6ee2de,
                        signer: $805873001930ba7e$export$f7d3c097ceca6c15
                    },
                    signature: (v)=>$805873001930ba7e$export$5f493709ce2232d6(v, 65) ? "" : "expected 65 bytes"
                }, "signCert()"));
        }
    };
}
const $0ac9d28c51f328e4$var$headScheme = {
    id: $805873001930ba7e$export$1a4f358fa435a50d,
    number: $805873001930ba7e$export$de9ffb9418dd7d0d,
    timestamp: $805873001930ba7e$export$870002f71f6ee2de,
    parentID: $805873001930ba7e$export$1a4f358fa435a50d,
    txsFeatures: $34eec9ede8c6d9f9$exports.optional($805873001930ba7e$export$de9ffb9418dd7d0d),
    gasLimit: $805873001930ba7e$export$870002f71f6ee2de
};
const $0ac9d28c51f328e4$var$blockScheme = {
    id: $805873001930ba7e$export$1a4f358fa435a50d,
    number: $805873001930ba7e$export$de9ffb9418dd7d0d,
    size: $805873001930ba7e$export$de9ffb9418dd7d0d,
    parentID: $805873001930ba7e$export$1a4f358fa435a50d,
    timestamp: $805873001930ba7e$export$870002f71f6ee2de,
    gasLimit: $805873001930ba7e$export$870002f71f6ee2de,
    beneficiary: $805873001930ba7e$export$f7d3c097ceca6c15,
    gasUsed: $805873001930ba7e$export$870002f71f6ee2de,
    totalScore: $805873001930ba7e$export$870002f71f6ee2de,
    txsRoot: $805873001930ba7e$export$1a4f358fa435a50d,
    txsFeatures: $34eec9ede8c6d9f9$exports.optional($805873001930ba7e$export$de9ffb9418dd7d0d),
    stateRoot: $805873001930ba7e$export$1a4f358fa435a50d,
    receiptsRoot: $805873001930ba7e$export$1a4f358fa435a50d,
    signer: $805873001930ba7e$export$f7d3c097ceca6c15,
    com: $34eec9ede8c6d9f9$exports.optional($805873001930ba7e$export$87b259aa03e3d267),
    isFinalized: $34eec9ede8c6d9f9$exports.optional($805873001930ba7e$export$87b259aa03e3d267),
    isTrunk: $805873001930ba7e$export$87b259aa03e3d267,
    transactions: [
        $805873001930ba7e$export$1a4f358fa435a50d
    ]
};
const $0ac9d28c51f328e4$var$txScheme = {
    id: $805873001930ba7e$export$1a4f358fa435a50d,
    chainTag: $805873001930ba7e$export$52e103c63c4e68cf,
    blockRef: $805873001930ba7e$export$ab581ee3ae9b8c92,
    expiration: $805873001930ba7e$export$de9ffb9418dd7d0d,
    gasPriceCoef: $805873001930ba7e$export$52e103c63c4e68cf,
    gas: $805873001930ba7e$export$870002f71f6ee2de,
    origin: $805873001930ba7e$export$f7d3c097ceca6c15,
    delegator: $34eec9ede8c6d9f9$exports.nullable($34eec9ede8c6d9f9$exports.optional($805873001930ba7e$export$f7d3c097ceca6c15)),
    nonce: $805873001930ba7e$export$1b06654353ef9f67,
    dependsOn: $34eec9ede8c6d9f9$exports.nullable($805873001930ba7e$export$1a4f358fa435a50d),
    size: $805873001930ba7e$export$de9ffb9418dd7d0d,
    clauses: [
        {
            to: $34eec9ede8c6d9f9$exports.nullable($805873001930ba7e$export$f7d3c097ceca6c15),
            value: $805873001930ba7e$export$1b06654353ef9f67,
            data: $805873001930ba7e$export$b3317979f9250576
        }
    ],
    meta: $34eec9ede8c6d9f9$exports.nullable({
        blockID: $805873001930ba7e$export$1a4f358fa435a50d,
        blockNumber: $805873001930ba7e$export$de9ffb9418dd7d0d,
        blockTimestamp: $805873001930ba7e$export$870002f71f6ee2de
    })
};
const $0ac9d28c51f328e4$var$logMetaScheme = {
    blockID: $805873001930ba7e$export$1a4f358fa435a50d,
    blockNumber: $805873001930ba7e$export$de9ffb9418dd7d0d,
    blockTimestamp: $805873001930ba7e$export$870002f71f6ee2de,
    txID: $805873001930ba7e$export$1a4f358fa435a50d,
    txOrigin: $805873001930ba7e$export$f7d3c097ceca6c15,
    clauseIndex: $805873001930ba7e$export$de9ffb9418dd7d0d
};
const $0ac9d28c51f328e4$var$eventScheme = {
    address: $805873001930ba7e$export$f7d3c097ceca6c15,
    topics: [
        $805873001930ba7e$export$1a4f358fa435a50d
    ],
    data: $805873001930ba7e$export$b3317979f9250576
};
const $0ac9d28c51f328e4$var$eventWithMetaScheme = Object.assign(Object.assign({}, $0ac9d28c51f328e4$var$eventScheme), {
    meta: $0ac9d28c51f328e4$var$logMetaScheme
});
const $0ac9d28c51f328e4$var$transferScheme = {
    sender: $805873001930ba7e$export$f7d3c097ceca6c15,
    recipient: $805873001930ba7e$export$f7d3c097ceca6c15,
    amount: $805873001930ba7e$export$1b06654353ef9f67
};
const $0ac9d28c51f328e4$var$transferWithMetaScheme = Object.assign(Object.assign({}, $0ac9d28c51f328e4$var$transferScheme), {
    meta: $0ac9d28c51f328e4$var$logMetaScheme
});
const $0ac9d28c51f328e4$var$receiptScheme = {
    gasUsed: $805873001930ba7e$export$870002f71f6ee2de,
    gasPayer: $805873001930ba7e$export$f7d3c097ceca6c15,
    paid: $805873001930ba7e$export$1b06654353ef9f67,
    reward: $805873001930ba7e$export$1b06654353ef9f67,
    reverted: $805873001930ba7e$export$87b259aa03e3d267,
    outputs: [
        {
            contractAddress: $34eec9ede8c6d9f9$exports.nullable($805873001930ba7e$export$f7d3c097ceca6c15),
            events: [
                $0ac9d28c51f328e4$var$eventScheme
            ],
            transfers: [
                $0ac9d28c51f328e4$var$transferScheme
            ]
        }
    ],
    meta: {
        blockID: $805873001930ba7e$export$1a4f358fa435a50d,
        blockNumber: $805873001930ba7e$export$de9ffb9418dd7d0d,
        blockTimestamp: $805873001930ba7e$export$870002f71f6ee2de,
        txID: $805873001930ba7e$export$1a4f358fa435a50d,
        txOrigin: $805873001930ba7e$export$f7d3c097ceca6c15
    }
};
const $0ac9d28c51f328e4$var$vmOutputScheme = {
    data: $805873001930ba7e$export$b3317979f9250576,
    vmError: $805873001930ba7e$export$22b082955e083ec3,
    gasUsed: $805873001930ba7e$export$870002f71f6ee2de,
    reverted: $805873001930ba7e$export$87b259aa03e3d267,
    revertReason: ()=>"",
    events: [
        {
            address: $805873001930ba7e$export$f7d3c097ceca6c15,
            topics: [
                $805873001930ba7e$export$1a4f358fa435a50d
            ],
            data: $805873001930ba7e$export$b3317979f9250576
        }
    ],
    transfers: [
        {
            sender: $805873001930ba7e$export$f7d3c097ceca6c15,
            recipient: $805873001930ba7e$export$f7d3c097ceca6c15,
            amount: $805873001930ba7e$export$1b06654353ef9f67
        }
    ]
};


class $77618c5bc79fb5a3$export$638889172ebce0c4 {
    /**
     * constructor
     * @param driver the driver instance
     */ constructor(driver){
        this.thor = (0, $87026cc8be2c0eb7$export$ed0b62d232bf177)(driver);
        this.vendor = (0, $0ef68bc7dc0cae13$export$2a23acb45fe6803e)(driver);
    }
    /**
     * create a wrapper for driver, to validate responses. it should be helpful to make sure driver is properly
     * implemented in development stage.
     * @param driver the driver to be wrapped
     * @param errorHandler optional error handler. If omitted, error message will be printed via console.warn.
     */ static guardDriver(driver, errorHandler) {
        return (0, $0ac9d28c51f328e4$export$98d3fdab2faa8d6e)(driver, errorHandler);
    }
}


/**
 *  The Application Programming Interface (API) is the collection of
 *  functions, classes and types offered by the Ethers library.
 *
 *  @_section: api:Application Programming Interface  [about-api]
 *  @_navTitle: API
 */ /**
 *  A fragment is a single item from an ABI, which may represent any of:
 *
 *  - [Functions](FunctionFragment)
 *  - [Events](EventFragment)
 *  - [Constructors](ConstructorFragment)
 *  - Custom [Errors](ErrorFragment)
 *  - [Fallback or Receive](FallbackFragment) functions
 *
 *  @_subsection api/abi/abi-coder:Fragments  [about-fragments]
 */ /**
 *  All errors in ethers include properties to ensure they are both
 *  human-readable (i.e. ``.message``) and machine-readable (i.e. ``.code``).
 *
 *  The [[isError]] function can be used to check the error ``code`` and
 *  provide a type guard for the properties present on that error interface.
 *
 *  @_section: api/utils/errors:Errors  [about-errors]
 */ /* Do NOT modify this file; see /src.ts/_admin/update-version.ts */ /**
 *  The current version of Ethers.
 */ const $9f7bf65ddafc81a6$export$83d89fbfd8236492 = "6.13.2";


/**
 *  Property helper functions.
 *
 *  @_subsection api/utils:Properties  [about-properties]
 */ function $5ac0677dd70fe0c6$var$checkType(value, type, name) {
    const types = type.split("|").map((t)=>t.trim());
    for(let i = 0; i < types.length; i++)switch(type){
        case "any":
            return;
        case "bigint":
        case "boolean":
        case "number":
        case "string":
            if (typeof value === type) return;
    }
    const error = new Error(`invalid value for type ${type}`);
    error.code = "INVALID_ARGUMENT";
    error.argument = `value.${name}`;
    error.value = value;
    throw error;
}
async function $5ac0677dd70fe0c6$export$d503dd157d963b60(value) {
    const keys = Object.keys(value);
    const results = await Promise.all(keys.map((k)=>Promise.resolve(value[k])));
    return results.reduce((accum, v, index)=>{
        accum[keys[index]] = v;
        return accum;
    }, {});
}
function $5ac0677dd70fe0c6$export$b61bda4fbca264f2(target, values, types) {
    for(let key in values){
        let value = values[key];
        const type = types ? types[key] : null;
        if (type) $5ac0677dd70fe0c6$var$checkType(value, type, key);
        Object.defineProperty(target, key, {
            enumerable: true,
            value: value,
            writable: false
        });
    }
}


function $634aa51198273feb$var$stringify(value) {
    if (value == null) return "null";
    if (Array.isArray(value)) return "[ " + value.map($634aa51198273feb$var$stringify).join(", ") + " ]";
    if (value instanceof Uint8Array) {
        const HEX = "0123456789abcdef";
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            result += HEX[value[i] >> 4];
            result += HEX[value[i] & 0xf];
        }
        return result;
    }
    if (typeof value === "object" && typeof value.toJSON === "function") return $634aa51198273feb$var$stringify(value.toJSON());
    switch(typeof value){
        case "boolean":
        case "symbol":
            return value.toString();
        case "bigint":
            return BigInt(value).toString();
        case "number":
            return value.toString();
        case "string":
            return JSON.stringify(value);
        case "object":
            {
                const keys = Object.keys(value);
                keys.sort();
                return "{ " + keys.map((k)=>`${$634aa51198273feb$var$stringify(k)}: ${$634aa51198273feb$var$stringify(value[k])}`).join(", ") + " }";
            }
    }
    return `[ COULD NOT SERIALIZE ]`;
}
function $634aa51198273feb$export$e6127cc7fe7395c3(error, code) {
    return error && error.code === code;
}
function $634aa51198273feb$export$748c4fa78f31ff35(error) {
    return $634aa51198273feb$export$e6127cc7fe7395c3(error, "CALL_EXCEPTION");
}
function $634aa51198273feb$export$5a4bb2b1c89bdce7(message, code, info) {
    let shortMessage = message;
    {
        const details = [];
        if (info) {
            if ("message" in info || "code" in info || "name" in info) throw new Error(`value will overwrite populated values: ${$634aa51198273feb$var$stringify(info)}`);
            for(const key in info){
                if (key === "shortMessage") continue;
                const value = info[key];
                //                try {
                details.push(key + "=" + $634aa51198273feb$var$stringify(value));
            //                } catch (error: any) {
            //                console.log("MMM", error.message);
            //                    details.push(key + "=[could not serialize object]");
            //                }
            }
        }
        details.push(`code=${code}`);
        details.push(`version=${(0, $9f7bf65ddafc81a6$export$83d89fbfd8236492)}`);
        if (details.length) message += " (" + details.join(", ") + ")";
    }
    let error;
    switch(code){
        case "INVALID_ARGUMENT":
            error = new TypeError(message);
            break;
        case "NUMERIC_FAULT":
        case "BUFFER_OVERRUN":
            error = new RangeError(message);
            break;
        default:
            error = new Error(message);
    }
    (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(error, {
        code: code
    });
    if (info) Object.assign(error, info);
    if (error.shortMessage == null) (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(error, {
        shortMessage: shortMessage
    });
    return error;
}
function $634aa51198273feb$export$a7a9523472993e97(check, message, code, info) {
    if (!check) throw $634aa51198273feb$export$5a4bb2b1c89bdce7(message, code, info);
}
function $634aa51198273feb$export$c3d31707e5030f5e(check, message, name, value) {
    $634aa51198273feb$export$a7a9523472993e97(check, message, "INVALID_ARGUMENT", {
        argument: name,
        value: value
    });
}
function $634aa51198273feb$export$d228410a8a77e4fa(count, expectedCount, message) {
    if (message == null) message = "";
    if (message) message = ": " + message;
    $634aa51198273feb$export$a7a9523472993e97(count >= expectedCount, "missing arguemnt" + message, "MISSING_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
    $634aa51198273feb$export$a7a9523472993e97(count <= expectedCount, "too many arguments" + message, "UNEXPECTED_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
}
const $634aa51198273feb$var$_normalizeForms = [
    "NFD",
    "NFC",
    "NFKD",
    "NFKC"
].reduce((accum, form)=>{
    try {
        // General test for normalize
        /* c8 ignore start */ if ("test".normalize(form) !== "test") throw new Error("bad");
        /* c8 ignore stop */ if (form === "NFD") {
            const check = String.fromCharCode(0xe9).normalize("NFD");
            const expected = String.fromCharCode(0x65, 0x0301);
            /* c8 ignore start */ if (check !== expected) throw new Error("broken");
        /* c8 ignore stop */ }
        accum.push(form);
    } catch (error) {}
    return accum;
}, []);
function $634aa51198273feb$export$d993e67fefdfecda(form) {
    $634aa51198273feb$export$a7a9523472993e97($634aa51198273feb$var$_normalizeForms.indexOf(form) >= 0, "platform missing String.prototype.normalize", "UNSUPPORTED_OPERATION", {
        operation: "String.prototype.normalize",
        info: {
            form: form
        }
    });
}
function $634aa51198273feb$export$ac1a938d48ec8c7b(givenGuard, guard, className) {
    if (className == null) className = "";
    if (givenGuard !== guard) {
        let method = className, operation = "new";
        if (className) {
            method += ".";
            operation += " " + className;
        }
        $634aa51198273feb$export$a7a9523472993e97(false, `private constructor; use ${method}from* methods`, "UNSUPPORTED_OPERATION", {
            operation: operation
        });
    }
}

/**
 *  Some mathematic operations.
 *
 *  @_subsection: api/utils:Math Helpers  [about-maths]
 */ /**
 *  Some data helpers.
 *
 *
 *  @_subsection api/utils:Data Helpers  [about-data]
 */ 
function $fd3872da8feed9cb$var$_getBytes(value, name, copy) {
    if (value instanceof Uint8Array) {
        if (copy) return new Uint8Array(value);
        return value;
    }
    if (typeof value === "string" && value.match(/^0x(?:[0-9a-f][0-9a-f])*$/i)) {
        const result = new Uint8Array((value.length - 2) / 2);
        let offset = 2;
        for(let i = 0; i < result.length; i++){
            result[i] = parseInt(value.substring(offset, offset + 2), 16);
            offset += 2;
        }
        return result;
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid BytesLike value", name || "value", value);
}
function $fd3872da8feed9cb$export$a3521add2594f3c8(value, name) {
    return $fd3872da8feed9cb$var$_getBytes(value, name, false);
}
function $fd3872da8feed9cb$export$37110e7fee0af4ad(value, name) {
    return $fd3872da8feed9cb$var$_getBytes(value, name, true);
}
function $fd3872da8feed9cb$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (typeof length === "number" && value.length !== 2 + 2 * length) return false;
    if (length === true && value.length % 2 !== 0) return false;
    return true;
}
function $fd3872da8feed9cb$export$9a14abb1a440cd5e(value) {
    return $fd3872da8feed9cb$export$b02a40aff8e4ad18(value, true) || value instanceof Uint8Array;
}
const $fd3872da8feed9cb$var$HexCharacters = "0123456789abcdef";
function $fd3872da8feed9cb$export$2b0d6b5fbe698c70(data) {
    const bytes = $fd3872da8feed9cb$export$a3521add2594f3c8(data);
    let result = "0x";
    for(let i = 0; i < bytes.length; i++){
        const v = bytes[i];
        result += $fd3872da8feed9cb$var$HexCharacters[(v & 0xf0) >> 4] + $fd3872da8feed9cb$var$HexCharacters[v & 0x0f];
    }
    return result;
}
function $fd3872da8feed9cb$export$ee1b3e54f0441b22(datas) {
    return "0x" + datas.map((d)=>$fd3872da8feed9cb$export$2b0d6b5fbe698c70(d).substring(2)).join("");
}
function $fd3872da8feed9cb$export$2321cd91b99770ff(data) {
    if ($fd3872da8feed9cb$export$b02a40aff8e4ad18(data, true)) return (data.length - 2) / 2;
    return $fd3872da8feed9cb$export$a3521add2594f3c8(data).length;
}
function $fd3872da8feed9cb$export$f6d845ffb449edc9(data, start, end) {
    const bytes = $fd3872da8feed9cb$export$a3521add2594f3c8(data);
    if (end != null && end > bytes.length) (0, $634aa51198273feb$export$a7a9523472993e97)(false, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: bytes.length,
        offset: end
    });
    return $fd3872da8feed9cb$export$2b0d6b5fbe698c70(bytes.slice(start == null ? 0 : start, end == null ? bytes.length : end));
}
function $fd3872da8feed9cb$export$9c854001a22ebaa2(data) {
    let bytes = $fd3872da8feed9cb$export$2b0d6b5fbe698c70(data).substring(2);
    while(bytes.startsWith("00"))bytes = bytes.substring(2);
    return "0x" + bytes;
}
function $fd3872da8feed9cb$var$zeroPad(data, length, left) {
    const bytes = $fd3872da8feed9cb$export$a3521add2594f3c8(data);
    (0, $634aa51198273feb$export$a7a9523472993e97)(length >= bytes.length, "padding exceeds data length", "BUFFER_OVERRUN", {
        buffer: new Uint8Array(bytes),
        length: length,
        offset: length + 1
    });
    const result = new Uint8Array(length);
    result.fill(0);
    if (left) result.set(bytes, length - bytes.length);
    else result.set(bytes, 0);
    return $fd3872da8feed9cb$export$2b0d6b5fbe698c70(result);
}
function $fd3872da8feed9cb$export$4473860254365feb(data, length) {
    return $fd3872da8feed9cb$var$zeroPad(data, length, true);
}
function $fd3872da8feed9cb$export$1dc7fbe1b8738fe7(data, length) {
    return $fd3872da8feed9cb$var$zeroPad(data, length, false);
}



const $6fa405e57bb6371e$var$BN_0 = BigInt(0);
const $6fa405e57bb6371e$var$BN_1 = BigInt(1);
//const BN_Max256 = (BN_1 << BigInt(256)) - BN_1;
// IEEE 754 support 53-bits of mantissa
const $6fa405e57bb6371e$var$maxValue = 0x1fffffffffffff;
function $6fa405e57bb6371e$export$92182edcfa20e5bc(_value, _width) {
    const value = $6fa405e57bb6371e$export$8677d6ca9282a154(_value, "value");
    const width = BigInt($6fa405e57bb6371e$export$b14f2714108df84(_width, "width"));
    (0, $634aa51198273feb$export$a7a9523472993e97)(value >> width === $6fa405e57bb6371e$var$BN_0, "overflow", "NUMERIC_FAULT", {
        operation: "fromTwos",
        fault: "overflow",
        value: _value
    });
    // Top bit set; treat as a negative value
    if (value >> width - $6fa405e57bb6371e$var$BN_1) {
        const mask = ($6fa405e57bb6371e$var$BN_1 << width) - $6fa405e57bb6371e$var$BN_1;
        return -((~value & mask) + $6fa405e57bb6371e$var$BN_1);
    }
    return value;
}
function $6fa405e57bb6371e$export$7101cd4e6275351c(_value, _width) {
    let value = $6fa405e57bb6371e$export$61fe455e2b1e28a4(_value, "value");
    const width = BigInt($6fa405e57bb6371e$export$b14f2714108df84(_width, "width"));
    const limit = $6fa405e57bb6371e$var$BN_1 << width - $6fa405e57bb6371e$var$BN_1;
    if (value < $6fa405e57bb6371e$var$BN_0) {
        value = -value;
        (0, $634aa51198273feb$export$a7a9523472993e97)(value <= limit, "too low", "NUMERIC_FAULT", {
            operation: "toTwos",
            fault: "overflow",
            value: _value
        });
        const mask = ($6fa405e57bb6371e$var$BN_1 << width) - $6fa405e57bb6371e$var$BN_1;
        return (~value & mask) + $6fa405e57bb6371e$var$BN_1;
    } else (0, $634aa51198273feb$export$a7a9523472993e97)(value < limit, "too high", "NUMERIC_FAULT", {
        operation: "toTwos",
        fault: "overflow",
        value: _value
    });
    return value;
}
function $6fa405e57bb6371e$export$d99f0801a68bbcf1(_value, _bits) {
    const value = $6fa405e57bb6371e$export$8677d6ca9282a154(_value, "value");
    const bits = BigInt($6fa405e57bb6371e$export$b14f2714108df84(_bits, "bits"));
    return value & ($6fa405e57bb6371e$var$BN_1 << bits) - $6fa405e57bb6371e$var$BN_1;
}
function $6fa405e57bb6371e$export$61fe455e2b1e28a4(value, name) {
    switch(typeof value){
        case "bigint":
            return value;
        case "number":
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(value >= -$6fa405e57bb6371e$var$maxValue && value <= $6fa405e57bb6371e$var$maxValue, "overflow", name || "value", value);
            return BigInt(value);
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                if (value[0] === "-" && value[1] !== "-") return -BigInt(value.substring(1));
                return BigInt(value);
            } catch (e) {
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `invalid BigNumberish string: ${e.message}`, name || "value", value);
            }
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid BigNumberish value", name || "value", value);
}
function $6fa405e57bb6371e$export$8677d6ca9282a154(value, name) {
    const result = $6fa405e57bb6371e$export$61fe455e2b1e28a4(value, name);
    (0, $634aa51198273feb$export$a7a9523472993e97)(result >= $6fa405e57bb6371e$var$BN_0, "unsigned value cannot be negative", "NUMERIC_FAULT", {
        fault: "overflow",
        operation: "getUint",
        value: value
    });
    return result;
}
const $6fa405e57bb6371e$var$Nibbles = "0123456789abcdef";
function $6fa405e57bb6371e$export$c221a145703ab783(value) {
    if (value instanceof Uint8Array) {
        let result = "0x0";
        for (const v of value){
            result += $6fa405e57bb6371e$var$Nibbles[v >> 4];
            result += $6fa405e57bb6371e$var$Nibbles[v & 0x0f];
        }
        return BigInt(result);
    }
    return $6fa405e57bb6371e$export$61fe455e2b1e28a4(value);
}
function $6fa405e57bb6371e$export$b14f2714108df84(value, name) {
    switch(typeof value){
        case "bigint":
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(value >= -$6fa405e57bb6371e$var$maxValue && value <= $6fa405e57bb6371e$var$maxValue, "overflow", name || "value", value);
            return Number(value);
        case "number":
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(value >= -$6fa405e57bb6371e$var$maxValue && value <= $6fa405e57bb6371e$var$maxValue, "overflow", name || "value", value);
            return value;
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                return $6fa405e57bb6371e$export$b14f2714108df84(BigInt(value), name);
            } catch (e) {
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `invalid numeric string: ${e.message}`, name || "value", value);
            }
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid numeric value", name || "value", value);
}
function $6fa405e57bb6371e$export$a0a81dc3380ce7d3(value) {
    return $6fa405e57bb6371e$export$b14f2714108df84($6fa405e57bb6371e$export$c221a145703ab783(value));
}
function $6fa405e57bb6371e$export$c6ebe05badb16181(_value, _width) {
    const value = $6fa405e57bb6371e$export$8677d6ca9282a154(_value, "value");
    let result = value.toString(16);
    if (_width == null) // Ensure the value is of even length
    {
        if (result.length % 2) result = "0" + result;
    } else {
        const width = $6fa405e57bb6371e$export$b14f2714108df84(_width, "width");
        (0, $634aa51198273feb$export$a7a9523472993e97)(width * 2 >= result.length, `value exceeds width (${width} bytes)`, "NUMERIC_FAULT", {
            operation: "toBeHex",
            fault: "overflow",
            value: _value
        });
        // Pad the value to the required width
        while(result.length < width * 2)result = "0" + result;
    }
    return "0x" + result;
}
function $6fa405e57bb6371e$export$b627fcfb5ea68cb0(_value) {
    const value = $6fa405e57bb6371e$export$8677d6ca9282a154(_value, "value");
    if (value === $6fa405e57bb6371e$var$BN_0) return new Uint8Array([]);
    let hex = value.toString(16);
    if (hex.length % 2) hex = "0" + hex;
    const result = new Uint8Array(hex.length / 2);
    for(let i = 0; i < result.length; i++){
        const offset = i * 2;
        result[i] = parseInt(hex.substring(offset, offset + 2), 16);
    }
    return result;
}
function $6fa405e57bb6371e$export$d9c067986dbc68dd(value) {
    let result = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)((0, $fd3872da8feed9cb$export$9a14abb1a440cd5e)(value) ? value : $6fa405e57bb6371e$export$b627fcfb5ea68cb0(value)).substring(2);
    while(result.startsWith("0"))result = result.substring(1);
    if (result === "") result = "0";
    return "0x" + result;
}


/**
 *  A fundamental building block of Ethereum is the underlying
 *  cryptographic primitives.
 *
 *  @_section: api/crypto:Cryptographic Functions   [about-crypto]
 */ /**
 *  An **HMAC** enables verification that a given key was used
 *  to authenticate a payload.
 *
 *  See: [[link-wiki-hmac]]
 *
 *  @_subsection: api/crypto:HMAC  [about-hmac]
 */ /* Browser Crypto Shims */ var $2cf13bab2f682ab6$exports = {};
"use strict";
Object.defineProperty($2cf13bab2f682ab6$exports, "__esModule", {
    value: true
});
$2cf13bab2f682ab6$exports.hmac = $2cf13bab2f682ab6$exports.HMAC = void 0;
var $1cde114f57cd2105$exports = {};
"use strict";
Object.defineProperty($1cde114f57cd2105$exports, "__esModule", {
    value: true
});
$1cde114f57cd2105$exports.output = $1cde114f57cd2105$exports.exists = $1cde114f57cd2105$exports.hash = $1cde114f57cd2105$exports.bytes = $1cde114f57cd2105$exports.bool = $1cde114f57cd2105$exports.number = void 0;
function $1cde114f57cd2105$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
$1cde114f57cd2105$exports.number = $1cde114f57cd2105$var$number;
function $1cde114f57cd2105$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
$1cde114f57cd2105$exports.bool = $1cde114f57cd2105$var$bool;
function $1cde114f57cd2105$var$bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
$1cde114f57cd2105$exports.bytes = $1cde114f57cd2105$var$bytes;
function $1cde114f57cd2105$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $1cde114f57cd2105$var$number(hash.outputLen);
    $1cde114f57cd2105$var$number(hash.blockLen);
}
$1cde114f57cd2105$exports.hash = $1cde114f57cd2105$var$hash;
function $1cde114f57cd2105$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
$1cde114f57cd2105$exports.exists = $1cde114f57cd2105$var$exists;
function $1cde114f57cd2105$var$output(out, instance) {
    $1cde114f57cd2105$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
$1cde114f57cd2105$exports.output = $1cde114f57cd2105$var$output;
const $1cde114f57cd2105$var$assert = {
    number: $1cde114f57cd2105$var$number,
    bool: $1cde114f57cd2105$var$bool,
    bytes: $1cde114f57cd2105$var$bytes,
    hash: $1cde114f57cd2105$var$hash,
    exists: $1cde114f57cd2105$var$exists,
    output: $1cde114f57cd2105$var$output
};
$1cde114f57cd2105$exports.default = $1cde114f57cd2105$var$assert;


var $61b84c5a52451a70$exports = {};
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty($61b84c5a52451a70$exports, "__esModule", {
    value: true
});
$61b84c5a52451a70$exports.randomBytes = $61b84c5a52451a70$exports.wrapXOFConstructorWithOpts = $61b84c5a52451a70$exports.wrapConstructorWithOpts = $61b84c5a52451a70$exports.wrapConstructor = $61b84c5a52451a70$exports.checkOpts = $61b84c5a52451a70$exports.Hash = $61b84c5a52451a70$exports.concatBytes = $61b84c5a52451a70$exports.toBytes = $61b84c5a52451a70$exports.utf8ToBytes = $61b84c5a52451a70$exports.asyncLoop = $61b84c5a52451a70$exports.nextTick = $61b84c5a52451a70$exports.hexToBytes = $61b84c5a52451a70$exports.bytesToHex = $61b84c5a52451a70$exports.isLE = $61b84c5a52451a70$exports.rotr = $61b84c5a52451a70$exports.createView = $61b84c5a52451a70$exports.u32 = $61b84c5a52451a70$exports.u8 = void 0;
var $b25b79cbab9e4728$exports = {};
"use strict";
Object.defineProperty($b25b79cbab9e4728$exports, "__esModule", {
    value: true
});
$b25b79cbab9e4728$exports.crypto = void 0;
$b25b79cbab9e4728$exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;


const $61b84c5a52451a70$var$u8a = (a)=>a instanceof Uint8Array;
// Cast array to different type
const $61b84c5a52451a70$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
$61b84c5a52451a70$exports.u8 = $61b84c5a52451a70$var$u8;
const $61b84c5a52451a70$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
$61b84c5a52451a70$exports.u32 = $61b84c5a52451a70$var$u32;
// Cast array to view
const $61b84c5a52451a70$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
$61b84c5a52451a70$exports.createView = $61b84c5a52451a70$var$createView;
// The rotate right (circular right shift) operation for uint32
const $61b84c5a52451a70$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
$61b84c5a52451a70$exports.rotr = $61b84c5a52451a70$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
$61b84c5a52451a70$exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!$61b84c5a52451a70$exports.isLE) throw new Error("Non little-endian hardware is not supported");
const $61b84c5a52451a70$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $61b84c5a52451a70$var$bytesToHex(bytes) {
    if (!$61b84c5a52451a70$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $61b84c5a52451a70$var$hexes[bytes[i]];
    return hex;
}
$61b84c5a52451a70$exports.bytesToHex = $61b84c5a52451a70$var$bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $61b84c5a52451a70$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
$61b84c5a52451a70$exports.hexToBytes = $61b84c5a52451a70$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $61b84c5a52451a70$var$nextTick = async ()=>{};
$61b84c5a52451a70$exports.nextTick = $61b84c5a52451a70$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $61b84c5a52451a70$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, $61b84c5a52451a70$exports.nextTick)();
        ts += diff;
    }
}
$61b84c5a52451a70$exports.asyncLoop = $61b84c5a52451a70$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $61b84c5a52451a70$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
$61b84c5a52451a70$exports.utf8ToBytes = $61b84c5a52451a70$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $61b84c5a52451a70$var$toBytes(data) {
    if (typeof data === "string") data = $61b84c5a52451a70$var$utf8ToBytes(data);
    if (!$61b84c5a52451a70$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
$61b84c5a52451a70$exports.toBytes = $61b84c5a52451a70$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $61b84c5a52451a70$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$61b84c5a52451a70$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
$61b84c5a52451a70$exports.concatBytes = $61b84c5a52451a70$var$concatBytes;
// For runtime check if class implements interface
class $61b84c5a52451a70$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
$61b84c5a52451a70$exports.Hash = $61b84c5a52451a70$var$Hash;
const $61b84c5a52451a70$var$toStr = {}.toString;
function $61b84c5a52451a70$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $61b84c5a52451a70$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
$61b84c5a52451a70$exports.checkOpts = $61b84c5a52451a70$var$checkOpts;
function $61b84c5a52451a70$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($61b84c5a52451a70$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
$61b84c5a52451a70$exports.wrapConstructor = $61b84c5a52451a70$var$wrapConstructor;
function $61b84c5a52451a70$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($61b84c5a52451a70$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
$61b84c5a52451a70$exports.wrapConstructorWithOpts = $61b84c5a52451a70$var$wrapConstructorWithOpts;
function $61b84c5a52451a70$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($61b84c5a52451a70$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
$61b84c5a52451a70$exports.wrapXOFConstructorWithOpts = $61b84c5a52451a70$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $61b84c5a52451a70$var$randomBytes(bytesLength = 32) {
    if ($b25b79cbab9e4728$exports.crypto && typeof $b25b79cbab9e4728$exports.crypto.getRandomValues === "function") return $b25b79cbab9e4728$exports.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
$61b84c5a52451a70$exports.randomBytes = $61b84c5a52451a70$var$randomBytes;


// HMAC (RFC 2104)
class $2cf13bab2f682ab6$var$HMAC extends $61b84c5a52451a70$exports.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $1cde114f57cd2105$exports.hash)(hash);
        const key = (0, $61b84c5a52451a70$exports.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $1cde114f57cd2105$exports.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $1cde114f57cd2105$exports.exists)(this);
        (0, $1cde114f57cd2105$exports.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
$2cf13bab2f682ab6$exports.HMAC = $2cf13bab2f682ab6$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const $2cf13bab2f682ab6$var$hmac = (hash, key, message)=>new $2cf13bab2f682ab6$var$HMAC(hash, key).update(message).digest();
$2cf13bab2f682ab6$exports.hmac = $2cf13bab2f682ab6$var$hmac;
$2cf13bab2f682ab6$exports.hmac.create = (hash, key)=>new $2cf13bab2f682ab6$var$HMAC(hash, key);


var $ea6196dd1a9277ad$exports = {};
"use strict";
Object.defineProperty($ea6196dd1a9277ad$exports, "__esModule", {
    value: true
});
$ea6196dd1a9277ad$exports.pbkdf2Async = $ea6196dd1a9277ad$exports.pbkdf2 = void 0;



// Common prologue and epilogue for sync/async functions
function $ea6196dd1a9277ad$var$pbkdf2Init(hash, _password, _salt, _opts) {
    (0, $1cde114f57cd2105$exports.hash)(hash);
    const opts = (0, $61b84c5a52451a70$exports.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c: c, dkLen: dkLen, asyncTick: asyncTick } = opts;
    (0, $1cde114f57cd2105$exports.number)(c);
    (0, $1cde114f57cd2105$exports.number)(dkLen);
    (0, $1cde114f57cd2105$exports.number)(asyncTick);
    if (c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
    const password = (0, $61b84c5a52451a70$exports.toBytes)(_password);
    const salt = (0, $61b84c5a52451a70$exports.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = $2cf13bab2f682ab6$exports.hmac.create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $ea6196dd1a9277ad$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 */ function $ea6196dd1a9277ad$var$pbkdf2(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $ea6196dd1a9277ad$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $61b84c5a52451a70$exports.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $ea6196dd1a9277ad$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
$ea6196dd1a9277ad$exports.pbkdf2 = $ea6196dd1a9277ad$var$pbkdf2;
async function $ea6196dd1a9277ad$var$pbkdf2Async(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, asyncTick: asyncTick, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $ea6196dd1a9277ad$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $61b84c5a52451a70$exports.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, $61b84c5a52451a70$exports.asyncLoop)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return $ea6196dd1a9277ad$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
$ea6196dd1a9277ad$exports.pbkdf2Async = $ea6196dd1a9277ad$var$pbkdf2Async;


var $0dea00f7ce276413$exports = {};
"use strict";
Object.defineProperty($0dea00f7ce276413$exports, "__esModule", {
    value: true
});
$0dea00f7ce276413$exports.sha224 = $0dea00f7ce276413$exports.sha256 = void 0;
var $bcee57f9340bd28e$exports = {};
"use strict";
Object.defineProperty($bcee57f9340bd28e$exports, "__esModule", {
    value: true
});
$bcee57f9340bd28e$exports.SHA2 = void 0;


// Polyfill for Safari 14
function $bcee57f9340bd28e$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class $bcee57f9340bd28e$var$SHA2 extends $61b84c5a52451a70$exports.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $61b84c5a52451a70$exports.createView)(this.buffer);
    }
    update(data) {
        (0, $1cde114f57cd2105$exports.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $61b84c5a52451a70$exports.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $61b84c5a52451a70$exports.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $1cde114f57cd2105$exports.exists)(this);
        (0, $1cde114f57cd2105$exports.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $bcee57f9340bd28e$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $61b84c5a52451a70$exports.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
$bcee57f9340bd28e$exports.SHA2 = $bcee57f9340bd28e$var$SHA2;



// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $0dea00f7ce276413$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $0dea00f7ce276413$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $0dea00f7ce276413$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $0dea00f7ce276413$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $0dea00f7ce276413$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $0dea00f7ce276413$var$SHA256 extends $bcee57f9340bd28e$exports.SHA2 {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $0dea00f7ce276413$var$IV[0] | 0;
        this.B = $0dea00f7ce276413$var$IV[1] | 0;
        this.C = $0dea00f7ce276413$var$IV[2] | 0;
        this.D = $0dea00f7ce276413$var$IV[3] | 0;
        this.E = $0dea00f7ce276413$var$IV[4] | 0;
        this.F = $0dea00f7ce276413$var$IV[5] | 0;
        this.G = $0dea00f7ce276413$var$IV[6] | 0;
        this.H = $0dea00f7ce276413$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$0dea00f7ce276413$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $0dea00f7ce276413$var$SHA256_W[i - 15];
            const W2 = $0dea00f7ce276413$var$SHA256_W[i - 2];
            const s0 = (0, $61b84c5a52451a70$exports.rotr)(W15, 7) ^ (0, $61b84c5a52451a70$exports.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $61b84c5a52451a70$exports.rotr)(W2, 17) ^ (0, $61b84c5a52451a70$exports.rotr)(W2, 19) ^ W2 >>> 10;
            $0dea00f7ce276413$var$SHA256_W[i] = s1 + $0dea00f7ce276413$var$SHA256_W[i - 7] + s0 + $0dea00f7ce276413$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $61b84c5a52451a70$exports.rotr)(E, 6) ^ (0, $61b84c5a52451a70$exports.rotr)(E, 11) ^ (0, $61b84c5a52451a70$exports.rotr)(E, 25);
            const T1 = H + sigma1 + $0dea00f7ce276413$var$Chi(E, F, G) + $0dea00f7ce276413$var$SHA256_K[i] + $0dea00f7ce276413$var$SHA256_W[i] | 0;
            const sigma0 = (0, $61b84c5a52451a70$exports.rotr)(A, 2) ^ (0, $61b84c5a52451a70$exports.rotr)(A, 13) ^ (0, $61b84c5a52451a70$exports.rotr)(A, 22);
            const T2 = sigma0 + $0dea00f7ce276413$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $0dea00f7ce276413$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $0dea00f7ce276413$var$SHA224 extends $0dea00f7ce276413$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ $0dea00f7ce276413$exports.sha256 = (0, $61b84c5a52451a70$exports.wrapConstructor)(()=>new $0dea00f7ce276413$var$SHA256());
$0dea00f7ce276413$exports.sha224 = (0, $61b84c5a52451a70$exports.wrapConstructor)(()=>new $0dea00f7ce276413$var$SHA224());


var $8e7cc92c618cf71d$exports = {};
"use strict";
Object.defineProperty($8e7cc92c618cf71d$exports, "__esModule", {
    value: true
});
$8e7cc92c618cf71d$exports.sha384 = $8e7cc92c618cf71d$exports.sha512_256 = $8e7cc92c618cf71d$exports.sha512_224 = $8e7cc92c618cf71d$exports.sha512 = $8e7cc92c618cf71d$exports.SHA512 = void 0;

var $200a460cc5084673$exports = {};
"use strict";
Object.defineProperty($200a460cc5084673$exports, "__esModule", {
    value: true
});
$200a460cc5084673$exports.add5L = $200a460cc5084673$exports.add5H = $200a460cc5084673$exports.add4H = $200a460cc5084673$exports.add4L = $200a460cc5084673$exports.add3H = $200a460cc5084673$exports.add3L = $200a460cc5084673$exports.add = $200a460cc5084673$exports.rotlBL = $200a460cc5084673$exports.rotlBH = $200a460cc5084673$exports.rotlSL = $200a460cc5084673$exports.rotlSH = $200a460cc5084673$exports.rotr32L = $200a460cc5084673$exports.rotr32H = $200a460cc5084673$exports.rotrBL = $200a460cc5084673$exports.rotrBH = $200a460cc5084673$exports.rotrSL = $200a460cc5084673$exports.rotrSH = $200a460cc5084673$exports.shrSL = $200a460cc5084673$exports.shrSH = $200a460cc5084673$exports.toBig = $200a460cc5084673$exports.split = $200a460cc5084673$exports.fromBig = void 0;
const $200a460cc5084673$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $200a460cc5084673$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $200a460cc5084673$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $200a460cc5084673$var$U32_MASK64),
        l: Number(n >> $200a460cc5084673$var$_32n & $200a460cc5084673$var$U32_MASK64)
    };
    return {
        h: Number(n >> $200a460cc5084673$var$_32n & $200a460cc5084673$var$U32_MASK64) | 0,
        l: Number(n & $200a460cc5084673$var$U32_MASK64) | 0
    };
}
$200a460cc5084673$exports.fromBig = $200a460cc5084673$var$fromBig;
function $200a460cc5084673$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $200a460cc5084673$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
$200a460cc5084673$exports.split = $200a460cc5084673$var$split;
const $200a460cc5084673$var$toBig = (h, l)=>BigInt(h >>> 0) << $200a460cc5084673$var$_32n | BigInt(l >>> 0);
$200a460cc5084673$exports.toBig = $200a460cc5084673$var$toBig;
// for Shift in [0, 32)
const $200a460cc5084673$var$shrSH = (h, _l, s)=>h >>> s;
$200a460cc5084673$exports.shrSH = $200a460cc5084673$var$shrSH;
const $200a460cc5084673$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
$200a460cc5084673$exports.shrSL = $200a460cc5084673$var$shrSL;
// Right rotate for Shift in [1, 32)
const $200a460cc5084673$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
$200a460cc5084673$exports.rotrSH = $200a460cc5084673$var$rotrSH;
const $200a460cc5084673$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
$200a460cc5084673$exports.rotrSL = $200a460cc5084673$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $200a460cc5084673$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
$200a460cc5084673$exports.rotrBH = $200a460cc5084673$var$rotrBH;
const $200a460cc5084673$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
$200a460cc5084673$exports.rotrBL = $200a460cc5084673$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $200a460cc5084673$var$rotr32H = (_h, l)=>l;
$200a460cc5084673$exports.rotr32H = $200a460cc5084673$var$rotr32H;
const $200a460cc5084673$var$rotr32L = (h, _l)=>h;
$200a460cc5084673$exports.rotr32L = $200a460cc5084673$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $200a460cc5084673$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
$200a460cc5084673$exports.rotlSH = $200a460cc5084673$var$rotlSH;
const $200a460cc5084673$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
$200a460cc5084673$exports.rotlSL = $200a460cc5084673$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $200a460cc5084673$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
$200a460cc5084673$exports.rotlBH = $200a460cc5084673$var$rotlBH;
const $200a460cc5084673$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
$200a460cc5084673$exports.rotlBL = $200a460cc5084673$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $200a460cc5084673$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
$200a460cc5084673$exports.add = $200a460cc5084673$var$add;
// Addition with more than 2 elements
const $200a460cc5084673$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
$200a460cc5084673$exports.add3L = $200a460cc5084673$var$add3L;
const $200a460cc5084673$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
$200a460cc5084673$exports.add3H = $200a460cc5084673$var$add3H;
const $200a460cc5084673$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
$200a460cc5084673$exports.add4L = $200a460cc5084673$var$add4L;
const $200a460cc5084673$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
$200a460cc5084673$exports.add4H = $200a460cc5084673$var$add4H;
const $200a460cc5084673$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
$200a460cc5084673$exports.add5L = $200a460cc5084673$var$add5L;
const $200a460cc5084673$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
$200a460cc5084673$exports.add5H = $200a460cc5084673$var$add5H;
// prettier-ignore
const $200a460cc5084673$var$u64 = {
    fromBig: $200a460cc5084673$var$fromBig,
    split: $200a460cc5084673$var$split,
    toBig: $200a460cc5084673$var$toBig,
    shrSH: $200a460cc5084673$var$shrSH,
    shrSL: $200a460cc5084673$var$shrSL,
    rotrSH: $200a460cc5084673$var$rotrSH,
    rotrSL: $200a460cc5084673$var$rotrSL,
    rotrBH: $200a460cc5084673$var$rotrBH,
    rotrBL: $200a460cc5084673$var$rotrBL,
    rotr32H: $200a460cc5084673$var$rotr32H,
    rotr32L: $200a460cc5084673$var$rotr32L,
    rotlSH: $200a460cc5084673$var$rotlSH,
    rotlSL: $200a460cc5084673$var$rotlSL,
    rotlBH: $200a460cc5084673$var$rotlBH,
    rotlBL: $200a460cc5084673$var$rotlBL,
    add: $200a460cc5084673$var$add,
    add3L: $200a460cc5084673$var$add3L,
    add3H: $200a460cc5084673$var$add3H,
    add4L: $200a460cc5084673$var$add4L,
    add4H: $200a460cc5084673$var$add4H,
    add5H: $200a460cc5084673$var$add5H,
    add5L: $200a460cc5084673$var$add5L
};
$200a460cc5084673$exports.default = $200a460cc5084673$var$u64;



// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$8e7cc92c618cf71d$var$SHA512_Kh, $8e7cc92c618cf71d$var$SHA512_Kl] = /* @__PURE__ */ (()=>$200a460cc5084673$exports.default.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $8e7cc92c618cf71d$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $8e7cc92c618cf71d$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $8e7cc92c618cf71d$var$SHA512 extends $bcee57f9340bd28e$exports.SHA2 {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $8e7cc92c618cf71d$var$SHA512_W_H[i] = view.getUint32(offset);
            $8e7cc92c618cf71d$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $8e7cc92c618cf71d$var$SHA512_W_H[i - 15] | 0;
            const W15l = $8e7cc92c618cf71d$var$SHA512_W_L[i - 15] | 0;
            const s0h = $200a460cc5084673$exports.default.rotrSH(W15h, W15l, 1) ^ $200a460cc5084673$exports.default.rotrSH(W15h, W15l, 8) ^ $200a460cc5084673$exports.default.shrSH(W15h, W15l, 7);
            const s0l = $200a460cc5084673$exports.default.rotrSL(W15h, W15l, 1) ^ $200a460cc5084673$exports.default.rotrSL(W15h, W15l, 8) ^ $200a460cc5084673$exports.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $8e7cc92c618cf71d$var$SHA512_W_H[i - 2] | 0;
            const W2l = $8e7cc92c618cf71d$var$SHA512_W_L[i - 2] | 0;
            const s1h = $200a460cc5084673$exports.default.rotrSH(W2h, W2l, 19) ^ $200a460cc5084673$exports.default.rotrBH(W2h, W2l, 61) ^ $200a460cc5084673$exports.default.shrSH(W2h, W2l, 6);
            const s1l = $200a460cc5084673$exports.default.rotrSL(W2h, W2l, 19) ^ $200a460cc5084673$exports.default.rotrBL(W2h, W2l, 61) ^ $200a460cc5084673$exports.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $200a460cc5084673$exports.default.add4L(s0l, s1l, $8e7cc92c618cf71d$var$SHA512_W_L[i - 7], $8e7cc92c618cf71d$var$SHA512_W_L[i - 16]);
            const SUMh = $200a460cc5084673$exports.default.add4H(SUMl, s0h, s1h, $8e7cc92c618cf71d$var$SHA512_W_H[i - 7], $8e7cc92c618cf71d$var$SHA512_W_H[i - 16]);
            $8e7cc92c618cf71d$var$SHA512_W_H[i] = SUMh | 0;
            $8e7cc92c618cf71d$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $200a460cc5084673$exports.default.rotrSH(Eh, El, 14) ^ $200a460cc5084673$exports.default.rotrSH(Eh, El, 18) ^ $200a460cc5084673$exports.default.rotrBH(Eh, El, 41);
            const sigma1l = $200a460cc5084673$exports.default.rotrSL(Eh, El, 14) ^ $200a460cc5084673$exports.default.rotrSL(Eh, El, 18) ^ $200a460cc5084673$exports.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $200a460cc5084673$exports.default.add5L(Hl, sigma1l, CHIl, $8e7cc92c618cf71d$var$SHA512_Kl[i], $8e7cc92c618cf71d$var$SHA512_W_L[i]);
            const T1h = $200a460cc5084673$exports.default.add5H(T1ll, Hh, sigma1h, CHIh, $8e7cc92c618cf71d$var$SHA512_Kh[i], $8e7cc92c618cf71d$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $200a460cc5084673$exports.default.rotrSH(Ah, Al, 28) ^ $200a460cc5084673$exports.default.rotrBH(Ah, Al, 34) ^ $200a460cc5084673$exports.default.rotrBH(Ah, Al, 39);
            const sigma0l = $200a460cc5084673$exports.default.rotrSL(Ah, Al, 28) ^ $200a460cc5084673$exports.default.rotrBL(Ah, Al, 34) ^ $200a460cc5084673$exports.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $200a460cc5084673$exports.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $200a460cc5084673$exports.default.add3L(T1l, sigma0l, MAJl);
            Ah = $200a460cc5084673$exports.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $200a460cc5084673$exports.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $200a460cc5084673$exports.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $200a460cc5084673$exports.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $200a460cc5084673$exports.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $200a460cc5084673$exports.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $200a460cc5084673$exports.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $200a460cc5084673$exports.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $200a460cc5084673$exports.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $8e7cc92c618cf71d$var$SHA512_W_H.fill(0);
        $8e7cc92c618cf71d$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
$8e7cc92c618cf71d$exports.SHA512 = $8e7cc92c618cf71d$var$SHA512;
class $8e7cc92c618cf71d$var$SHA512_224 extends $8e7cc92c618cf71d$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $8e7cc92c618cf71d$var$SHA512_256 extends $8e7cc92c618cf71d$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $8e7cc92c618cf71d$var$SHA384 extends $8e7cc92c618cf71d$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
$8e7cc92c618cf71d$exports.sha512 = (0, $61b84c5a52451a70$exports.wrapConstructor)(()=>new $8e7cc92c618cf71d$var$SHA512());
$8e7cc92c618cf71d$exports.sha512_224 = (0, $61b84c5a52451a70$exports.wrapConstructor)(()=>new $8e7cc92c618cf71d$var$SHA512_224());
$8e7cc92c618cf71d$exports.sha512_256 = (0, $61b84c5a52451a70$exports.wrapConstructor)(()=>new $8e7cc92c618cf71d$var$SHA512_256());
$8e7cc92c618cf71d$exports.sha384 = (0, $61b84c5a52451a70$exports.wrapConstructor)(()=>new $8e7cc92c618cf71d$var$SHA384());



function $15a6e7f1608663ad$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $15a6e7f1608663ad$var$anyGlobal = $15a6e7f1608663ad$var$getGlobal();
const $15a6e7f1608663ad$var$crypto = $15a6e7f1608663ad$var$anyGlobal.crypto || $15a6e7f1608663ad$var$anyGlobal.msCrypto;
function $15a6e7f1608663ad$export$2fb37efbf6ae0c0e(algo) {
    switch(algo){
        case "sha256":
            return (0, $0dea00f7ce276413$exports.sha256).create();
        case "sha512":
            return (0, $8e7cc92c618cf71d$exports.sha512).create();
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid hashing algorithm name", "algorithm", algo);
}
function $15a6e7f1608663ad$export$da39cf97e1eb7c91(_algo, key) {
    const algo = {
        sha256: $0dea00f7ce276413$exports.sha256,
        sha512: $8e7cc92c618cf71d$exports.sha512
    }[_algo];
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(algo != null, "invalid hmac algorithm", "algorithm", _algo);
    return (0, $2cf13bab2f682ab6$exports.hmac).create(algo, key);
}
function $15a6e7f1608663ad$export$b80c7ba289c8fa56(password, salt, iterations, keylen, _algo) {
    const algo = {
        sha256: $0dea00f7ce276413$exports.sha256,
        sha512: $8e7cc92c618cf71d$exports.sha512
    }[_algo];
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(algo != null, "invalid pbkdf2 algorithm", "algorithm", _algo);
    return (0, $ea6196dd1a9277ad$exports.pbkdf2)(algo, password, salt, {
        c: iterations,
        dkLen: keylen
    });
}
function $15a6e7f1608663ad$export$5f828d93ff035aa8(length) {
    (0, $634aa51198273feb$export$a7a9523472993e97)($15a6e7f1608663ad$var$crypto != null, "platform does not support secure random numbers", "UNSUPPORTED_OPERATION", {
        operation: "randomBytes"
    });
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(Number.isInteger(length) && length > 0 && length <= 1024, "invalid length", "length", length);
    const result = new Uint8Array(length);
    $15a6e7f1608663ad$var$crypto.getRandomValues(result);
    return result;
}



let $be13a0f2e0d9ad05$var$locked = false;
const $be13a0f2e0d9ad05$var$_computeHmac = function(algorithm, key, data) {
    return (0, $15a6e7f1608663ad$export$da39cf97e1eb7c91)(algorithm, key).update(data).digest();
};
let $be13a0f2e0d9ad05$var$__computeHmac = $be13a0f2e0d9ad05$var$_computeHmac;
function $be13a0f2e0d9ad05$export$967075d2f3b8e7ff(algorithm, _key, _data) {
    const key = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_key, "key");
    const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data, "data");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($be13a0f2e0d9ad05$var$__computeHmac(algorithm, key, data));
}
$be13a0f2e0d9ad05$export$967075d2f3b8e7ff._ = $be13a0f2e0d9ad05$var$_computeHmac;
$be13a0f2e0d9ad05$export$967075d2f3b8e7ff.lock = function() {
    $be13a0f2e0d9ad05$var$locked = true;
};
$be13a0f2e0d9ad05$export$967075d2f3b8e7ff.register = function(func) {
    if ($be13a0f2e0d9ad05$var$locked) throw new Error("computeHmac is locked");
    $be13a0f2e0d9ad05$var$__computeHmac = func;
};
Object.freeze($be13a0f2e0d9ad05$export$967075d2f3b8e7ff);


/**
 *  Cryptographic hashing functions
 *
 *  @_subsection: api/crypto:Hash Functions [about-crypto-hashing]
 */ var $29432a366a57d814$exports = {};
"use strict";
Object.defineProperty($29432a366a57d814$exports, "__esModule", {
    value: true
});
$29432a366a57d814$exports.shake256 = $29432a366a57d814$exports.shake128 = $29432a366a57d814$exports.keccak_512 = $29432a366a57d814$exports.keccak_384 = $29432a366a57d814$exports.keccak_256 = $29432a366a57d814$exports.keccak_224 = $29432a366a57d814$exports.sha3_512 = $29432a366a57d814$exports.sha3_384 = $29432a366a57d814$exports.sha3_256 = $29432a366a57d814$exports.sha3_224 = $29432a366a57d814$exports.Keccak = $29432a366a57d814$exports.keccakP = void 0;



// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$29432a366a57d814$var$SHA3_PI, $29432a366a57d814$var$SHA3_ROTL, $29432a366a57d814$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $29432a366a57d814$var$_0n = /* @__PURE__ */ BigInt(0);
const $29432a366a57d814$var$_1n = /* @__PURE__ */ BigInt(1);
const $29432a366a57d814$var$_2n = /* @__PURE__ */ BigInt(2);
const $29432a366a57d814$var$_7n = /* @__PURE__ */ BigInt(7);
const $29432a366a57d814$var$_256n = /* @__PURE__ */ BigInt(256);
const $29432a366a57d814$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $29432a366a57d814$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $29432a366a57d814$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $29432a366a57d814$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $29432a366a57d814$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $29432a366a57d814$var$_1n ^ (R >> $29432a366a57d814$var$_7n) * $29432a366a57d814$var$_0x71n) % $29432a366a57d814$var$_256n;
        if (R & $29432a366a57d814$var$_2n) t ^= $29432a366a57d814$var$_1n << ($29432a366a57d814$var$_1n << /* @__PURE__ */ BigInt(j)) - $29432a366a57d814$var$_1n;
    }
    $29432a366a57d814$var$_SHA3_IOTA.push(t);
}
const [$29432a366a57d814$var$SHA3_IOTA_H, $29432a366a57d814$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $200a460cc5084673$exports.split)($29432a366a57d814$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $29432a366a57d814$var$rotlH = (h, l, s)=>s > 32 ? (0, $200a460cc5084673$exports.rotlBH)(h, l, s) : (0, $200a460cc5084673$exports.rotlSH)(h, l, s);
const $29432a366a57d814$var$rotlL = (h, l, s)=>s > 32 ? (0, $200a460cc5084673$exports.rotlBL)(h, l, s) : (0, $200a460cc5084673$exports.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $29432a366a57d814$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $29432a366a57d814$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $29432a366a57d814$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $29432a366a57d814$var$SHA3_ROTL[t];
            const Th = $29432a366a57d814$var$rotlH(curH, curL, shift);
            const Tl = $29432a366a57d814$var$rotlL(curH, curL, shift);
            const PI = $29432a366a57d814$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $29432a366a57d814$var$SHA3_IOTA_H[round];
        s[1] ^= $29432a366a57d814$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
$29432a366a57d814$exports.keccakP = $29432a366a57d814$var$keccakP;
class $29432a366a57d814$var$Keccak extends $61b84c5a52451a70$exports.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $1cde114f57cd2105$exports.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $61b84c5a52451a70$exports.u32)(this.state);
    }
    keccak() {
        $29432a366a57d814$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $1cde114f57cd2105$exports.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $61b84c5a52451a70$exports.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $1cde114f57cd2105$exports.exists)(this, false);
        (0, $1cde114f57cd2105$exports.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $1cde114f57cd2105$exports.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $1cde114f57cd2105$exports.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $29432a366a57d814$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
$29432a366a57d814$exports.Keccak = $29432a366a57d814$var$Keccak;
const $29432a366a57d814$var$gen = (suffix, blockLen, outputLen)=>(0, $61b84c5a52451a70$exports.wrapConstructor)(()=>new $29432a366a57d814$var$Keccak(blockLen, suffix, outputLen));
$29432a366a57d814$exports.sha3_224 = $29432a366a57d814$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ $29432a366a57d814$exports.sha3_256 = $29432a366a57d814$var$gen(0x06, 136, 32);
$29432a366a57d814$exports.sha3_384 = $29432a366a57d814$var$gen(0x06, 104, 48);
$29432a366a57d814$exports.sha3_512 = $29432a366a57d814$var$gen(0x06, 72, 64);
$29432a366a57d814$exports.keccak_224 = $29432a366a57d814$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ $29432a366a57d814$exports.keccak_256 = $29432a366a57d814$var$gen(0x01, 136, 32);
$29432a366a57d814$exports.keccak_384 = $29432a366a57d814$var$gen(0x01, 104, 48);
$29432a366a57d814$exports.keccak_512 = $29432a366a57d814$var$gen(0x01, 72, 64);
const $29432a366a57d814$var$genShake = (suffix, blockLen, outputLen)=>(0, $61b84c5a52451a70$exports.wrapXOFConstructorWithOpts)((opts = {})=>new $29432a366a57d814$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
$29432a366a57d814$exports.shake128 = $29432a366a57d814$var$genShake(0x1f, 168, 16);
$29432a366a57d814$exports.shake256 = $29432a366a57d814$var$genShake(0x1f, 136, 32);



let $9bdec2813ce7c52b$var$locked = false;
const $9bdec2813ce7c52b$var$_keccak256 = function(data) {
    return (0, $29432a366a57d814$exports.keccak_256)(data);
};
let $9bdec2813ce7c52b$var$__keccak256 = $9bdec2813ce7c52b$var$_keccak256;
function $9bdec2813ce7c52b$export$f8151fce47ad1c35(_data) {
    const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data, "data");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($9bdec2813ce7c52b$var$__keccak256(data));
}
$9bdec2813ce7c52b$export$f8151fce47ad1c35._ = $9bdec2813ce7c52b$var$_keccak256;
$9bdec2813ce7c52b$export$f8151fce47ad1c35.lock = function() {
    $9bdec2813ce7c52b$var$locked = true;
};
$9bdec2813ce7c52b$export$f8151fce47ad1c35.register = function(func) {
    if ($9bdec2813ce7c52b$var$locked) throw new TypeError("keccak256 is locked");
    $9bdec2813ce7c52b$var$__keccak256 = func;
};
Object.freeze($9bdec2813ce7c52b$export$f8151fce47ad1c35);


var $afdedd6634cee3ba$exports = {};
"use strict";
Object.defineProperty($afdedd6634cee3ba$exports, "__esModule", {
    value: true
});
$afdedd6634cee3ba$exports.ripemd160 = $afdedd6634cee3ba$exports.RIPEMD160 = void 0;


// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
const $afdedd6634cee3ba$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $afdedd6634cee3ba$var$Id = /* @__PURE__ */ Uint8Array.from({
    length: 16
}, (_, i)=>i);
const $afdedd6634cee3ba$var$Pi = /* @__PURE__ */ $afdedd6634cee3ba$var$Id.map((i)=>(9 * i + 5) % 16);
let $afdedd6634cee3ba$var$idxL = [
    $afdedd6634cee3ba$var$Id
];
let $afdedd6634cee3ba$var$idxR = [
    $afdedd6634cee3ba$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $afdedd6634cee3ba$var$idxL,
    $afdedd6634cee3ba$var$idxR
])j.push(j[i].map((k)=>$afdedd6634cee3ba$var$Rho[k]));
const $afdedd6634cee3ba$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $afdedd6634cee3ba$var$shiftsL = /* @__PURE__ */ $afdedd6634cee3ba$var$idxL.map((idx, i)=>idx.map((j)=>$afdedd6634cee3ba$var$shifts[i][j]));
const $afdedd6634cee3ba$var$shiftsR = /* @__PURE__ */ $afdedd6634cee3ba$var$idxR.map((idx, i)=>idx.map((j)=>$afdedd6634cee3ba$var$shifts[i][j]));
const $afdedd6634cee3ba$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $afdedd6634cee3ba$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// The rotate left (circular left shift) operation for uint32
const $afdedd6634cee3ba$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift;
// It's called f() in spec.
function $afdedd6634cee3ba$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $afdedd6634cee3ba$var$BUF = /* @__PURE__ */ new Uint32Array(16);
class $afdedd6634cee3ba$var$RIPEMD160 extends $bcee57f9340bd28e$exports.SHA2 {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$afdedd6634cee3ba$var$BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $afdedd6634cee3ba$var$Kl[group], hbr = $afdedd6634cee3ba$var$Kr[group]; // prettier-ignore
            const rl = $afdedd6634cee3ba$var$idxL[group], rr = $afdedd6634cee3ba$var$idxR[group]; // prettier-ignore
            const sl = $afdedd6634cee3ba$var$shiftsL[group], sr = $afdedd6634cee3ba$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = $afdedd6634cee3ba$var$rotl(al + $afdedd6634cee3ba$var$f(group, bl, cl, dl) + $afdedd6634cee3ba$var$BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = $afdedd6634cee3ba$var$rotl(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = $afdedd6634cee3ba$var$rotl(ar + $afdedd6634cee3ba$var$f(rGroup, br, cr, dr) + $afdedd6634cee3ba$var$BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = $afdedd6634cee3ba$var$rotl(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $afdedd6634cee3ba$var$BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
$afdedd6634cee3ba$exports.RIPEMD160 = $afdedd6634cee3ba$var$RIPEMD160;
/**
 * RIPEMD-160 - a hash function from 1990s.
 * @param message - msg that would be hashed
 */ $afdedd6634cee3ba$exports.ripemd160 = (0, $61b84c5a52451a70$exports.wrapConstructor)(()=>new $afdedd6634cee3ba$var$RIPEMD160());



let $76bdf8351c5898c8$var$locked = false;
const $76bdf8351c5898c8$var$_ripemd160 = function(data) {
    return (0, $afdedd6634cee3ba$exports.ripemd160)(data);
};
let $76bdf8351c5898c8$var$__ripemd160 = $76bdf8351c5898c8$var$_ripemd160;
function $76bdf8351c5898c8$export$d1cea0ee4e3f0d3e(_data) {
    const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data, "data");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($76bdf8351c5898c8$var$__ripemd160(data));
}
$76bdf8351c5898c8$export$d1cea0ee4e3f0d3e._ = $76bdf8351c5898c8$var$_ripemd160;
$76bdf8351c5898c8$export$d1cea0ee4e3f0d3e.lock = function() {
    $76bdf8351c5898c8$var$locked = true;
};
$76bdf8351c5898c8$export$d1cea0ee4e3f0d3e.register = function(func) {
    if ($76bdf8351c5898c8$var$locked) throw new TypeError("ripemd160 is locked");
    $76bdf8351c5898c8$var$__ripemd160 = func;
};
Object.freeze($76bdf8351c5898c8$export$d1cea0ee4e3f0d3e);


/**
 *  A **Password-Based Key-Derivation Function** is designed to create
 *  a sequence of bytes suitible as a **key** from a human-rememberable
 *  password.
 *
 *  @_subsection: api/crypto:Passwords  [about-pbkdf]
 */ 

let $9092348e8cf65603$var$locked = false;
const $9092348e8cf65603$var$_pbkdf2 = function(password, salt, iterations, keylen, algo) {
    return (0, $15a6e7f1608663ad$export$b80c7ba289c8fa56)(password, salt, iterations, keylen, algo);
};
let $9092348e8cf65603$var$__pbkdf2 = $9092348e8cf65603$var$_pbkdf2;
function $9092348e8cf65603$export$448fa22aedc9dbca(_password, _salt, iterations, keylen, algo) {
    const password = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_password, "password");
    const salt = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($9092348e8cf65603$var$__pbkdf2(password, salt, iterations, keylen, algo));
}
$9092348e8cf65603$export$448fa22aedc9dbca._ = $9092348e8cf65603$var$_pbkdf2;
$9092348e8cf65603$export$448fa22aedc9dbca.lock = function() {
    $9092348e8cf65603$var$locked = true;
};
$9092348e8cf65603$export$448fa22aedc9dbca.register = function(func) {
    if ($9092348e8cf65603$var$locked) throw new Error("pbkdf2 is locked");
    $9092348e8cf65603$var$__pbkdf2 = func;
};
Object.freeze($9092348e8cf65603$export$448fa22aedc9dbca);


/**
 *  A **Cryptographically Secure Random Value** is one that has been
 *  generated with additional care take to prevent side-channels
 *  from allowing others to detect it and prevent others from through
 *  coincidence generate the same values.
 *
 *  @_subsection: api/crypto:Random Values  [about-crypto-random]
 */ 
let $90bc03290273a6e1$var$locked = false;
const $90bc03290273a6e1$var$_randomBytes = function(length) {
    return new Uint8Array((0, $15a6e7f1608663ad$export$5f828d93ff035aa8)(length));
};
let $90bc03290273a6e1$var$__randomBytes = $90bc03290273a6e1$var$_randomBytes;
function $90bc03290273a6e1$export$5f828d93ff035aa8(length) {
    return $90bc03290273a6e1$var$__randomBytes(length);
}
$90bc03290273a6e1$export$5f828d93ff035aa8._ = $90bc03290273a6e1$var$_randomBytes;
$90bc03290273a6e1$export$5f828d93ff035aa8.lock = function() {
    $90bc03290273a6e1$var$locked = true;
};
$90bc03290273a6e1$export$5f828d93ff035aa8.register = function(func) {
    if ($90bc03290273a6e1$var$locked) throw new Error("randomBytes is locked");
    $90bc03290273a6e1$var$__randomBytes = func;
};
Object.freeze($90bc03290273a6e1$export$5f828d93ff035aa8);


var $5caff4160219eda0$exports = {};
"use strict";
Object.defineProperty($5caff4160219eda0$exports, "__esModule", {
    value: true
});
$5caff4160219eda0$exports.scryptAsync = $5caff4160219eda0$exports.scrypt = void 0;




// RFC 7914 Scrypt KDF
// Left rotate for uint32
const $5caff4160219eda0$var$rotl = (a, b)=>a << b | a >>> 32 - b;
// The main Scrypt loop: uses Salsa extensively.
// Six versions of the function were tried, this is the fastest one.
// prettier-ignore
function $5caff4160219eda0$var$XorAndSalsa(prev, pi, input, ii, out, oi) {
    // Based on https://cr.yp.to/salsa20.html
    // Xor blocks
    let y00 = prev[pi++] ^ input[ii++], y01 = prev[pi++] ^ input[ii++];
    let y02 = prev[pi++] ^ input[ii++], y03 = prev[pi++] ^ input[ii++];
    let y04 = prev[pi++] ^ input[ii++], y05 = prev[pi++] ^ input[ii++];
    let y06 = prev[pi++] ^ input[ii++], y07 = prev[pi++] ^ input[ii++];
    let y08 = prev[pi++] ^ input[ii++], y09 = prev[pi++] ^ input[ii++];
    let y10 = prev[pi++] ^ input[ii++], y11 = prev[pi++] ^ input[ii++];
    let y12 = prev[pi++] ^ input[ii++], y13 = prev[pi++] ^ input[ii++];
    let y14 = prev[pi++] ^ input[ii++], y15 = prev[pi++] ^ input[ii++];
    // Save state to temporary variables (salsa)
    let x00 = y00, x01 = y01, x02 = y02, x03 = y03, x04 = y04, x05 = y05, x06 = y06, x07 = y07, x08 = y08, x09 = y09, x10 = y10, x11 = y11, x12 = y12, x13 = y13, x14 = y14, x15 = y15;
    // Main loop (salsa)
    for(let i = 0; i < 8; i += 2){
        x04 ^= $5caff4160219eda0$var$rotl(x00 + x12 | 0, 7);
        x08 ^= $5caff4160219eda0$var$rotl(x04 + x00 | 0, 9);
        x12 ^= $5caff4160219eda0$var$rotl(x08 + x04 | 0, 13);
        x00 ^= $5caff4160219eda0$var$rotl(x12 + x08 | 0, 18);
        x09 ^= $5caff4160219eda0$var$rotl(x05 + x01 | 0, 7);
        x13 ^= $5caff4160219eda0$var$rotl(x09 + x05 | 0, 9);
        x01 ^= $5caff4160219eda0$var$rotl(x13 + x09 | 0, 13);
        x05 ^= $5caff4160219eda0$var$rotl(x01 + x13 | 0, 18);
        x14 ^= $5caff4160219eda0$var$rotl(x10 + x06 | 0, 7);
        x02 ^= $5caff4160219eda0$var$rotl(x14 + x10 | 0, 9);
        x06 ^= $5caff4160219eda0$var$rotl(x02 + x14 | 0, 13);
        x10 ^= $5caff4160219eda0$var$rotl(x06 + x02 | 0, 18);
        x03 ^= $5caff4160219eda0$var$rotl(x15 + x11 | 0, 7);
        x07 ^= $5caff4160219eda0$var$rotl(x03 + x15 | 0, 9);
        x11 ^= $5caff4160219eda0$var$rotl(x07 + x03 | 0, 13);
        x15 ^= $5caff4160219eda0$var$rotl(x11 + x07 | 0, 18);
        x01 ^= $5caff4160219eda0$var$rotl(x00 + x03 | 0, 7);
        x02 ^= $5caff4160219eda0$var$rotl(x01 + x00 | 0, 9);
        x03 ^= $5caff4160219eda0$var$rotl(x02 + x01 | 0, 13);
        x00 ^= $5caff4160219eda0$var$rotl(x03 + x02 | 0, 18);
        x06 ^= $5caff4160219eda0$var$rotl(x05 + x04 | 0, 7);
        x07 ^= $5caff4160219eda0$var$rotl(x06 + x05 | 0, 9);
        x04 ^= $5caff4160219eda0$var$rotl(x07 + x06 | 0, 13);
        x05 ^= $5caff4160219eda0$var$rotl(x04 + x07 | 0, 18);
        x11 ^= $5caff4160219eda0$var$rotl(x10 + x09 | 0, 7);
        x08 ^= $5caff4160219eda0$var$rotl(x11 + x10 | 0, 9);
        x09 ^= $5caff4160219eda0$var$rotl(x08 + x11 | 0, 13);
        x10 ^= $5caff4160219eda0$var$rotl(x09 + x08 | 0, 18);
        x12 ^= $5caff4160219eda0$var$rotl(x15 + x14 | 0, 7);
        x13 ^= $5caff4160219eda0$var$rotl(x12 + x15 | 0, 9);
        x14 ^= $5caff4160219eda0$var$rotl(x13 + x12 | 0, 13);
        x15 ^= $5caff4160219eda0$var$rotl(x14 + x13 | 0, 18);
    }
    // Write output (salsa)
    out[oi++] = y00 + x00 | 0;
    out[oi++] = y01 + x01 | 0;
    out[oi++] = y02 + x02 | 0;
    out[oi++] = y03 + x03 | 0;
    out[oi++] = y04 + x04 | 0;
    out[oi++] = y05 + x05 | 0;
    out[oi++] = y06 + x06 | 0;
    out[oi++] = y07 + x07 | 0;
    out[oi++] = y08 + x08 | 0;
    out[oi++] = y09 + x09 | 0;
    out[oi++] = y10 + x10 | 0;
    out[oi++] = y11 + x11 | 0;
    out[oi++] = y12 + x12 | 0;
    out[oi++] = y13 + x13 | 0;
    out[oi++] = y14 + x14 | 0;
    out[oi++] = y15 + x15 | 0;
}
function $5caff4160219eda0$var$BlockMix(input, ii, out, oi, r) {
    // The block B is r 128-byte chunks (which is equivalent of 2r 64-byte chunks)
    let head = oi + 0;
    let tail = oi + 16 * r;
    for(let i = 0; i < 16; i++)out[tail + i] = input[ii + (2 * r - 1) * 16 + i]; // X ← B[2r−1]
    for(let i = 0; i < r; i++, head += 16, ii += 16){
        // We write odd & even Yi at same time. Even: 0bXXXXX0 Odd:  0bXXXXX1
        $5caff4160219eda0$var$XorAndSalsa(out, tail, input, ii, out, head); // head[i] = Salsa(blockIn[2*i] ^ tail[i-1])
        if (i > 0) tail += 16; // First iteration overwrites tmp value in tail
        $5caff4160219eda0$var$XorAndSalsa(out, head, input, ii += 16, out, tail); // tail[i] = Salsa(blockIn[2*i+1] ^ head[i])
    }
}
// Common prologue and epilogue for sync/async functions
function $5caff4160219eda0$var$scryptInit(password, salt, _opts) {
    // Maxmem - 1GB+1KB by default
    const opts = (0, $61b84c5a52451a70$exports.checkOpts)({
        dkLen: 32,
        asyncTick: 10,
        maxmem: 1024 ** 3 + 1024
    }, _opts);
    const { N: N, r: r, p: p, dkLen: dkLen, asyncTick: asyncTick, maxmem: maxmem, onProgress: onProgress } = opts;
    (0, $1cde114f57cd2105$exports.number)(N);
    (0, $1cde114f57cd2105$exports.number)(r);
    (0, $1cde114f57cd2105$exports.number)(p);
    (0, $1cde114f57cd2105$exports.number)(dkLen);
    (0, $1cde114f57cd2105$exports.number)(asyncTick);
    (0, $1cde114f57cd2105$exports.number)(maxmem);
    if (onProgress !== undefined && typeof onProgress !== "function") throw new Error("progressCb should be function");
    const blockSize = 128 * r;
    const blockSize32 = blockSize / 4;
    if (N <= 1 || (N & N - 1) !== 0 || N >= 2 ** (blockSize / 8) || N > 2 ** 32) // NOTE: we limit N to be less than 2**32 because of 32 bit variant of Integrify function
    // There is no JS engines that allows alocate more than 4GB per single Uint8Array for now, but can change in future.
    throw new Error("Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32");
    if (p < 0 || p > (2 ** 32 - 1) * 32 / blockSize) throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
    if (dkLen < 0 || dkLen > (2 ** 32 - 1) * 32) throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
    const memUsed = blockSize * (N + p);
    if (memUsed > maxmem) throw new Error(`Scrypt: parameters too large, ${memUsed} (128 * r * (N + p)) > ${maxmem} (maxmem)`);
    // [B0...Bp−1] ← PBKDF2HMAC-SHA256(Passphrase, Salt, 1, blockSize*ParallelizationFactor)
    // Since it has only one iteration there is no reason to use async variant
    const B = (0, $ea6196dd1a9277ad$exports.pbkdf2)($0dea00f7ce276413$exports.sha256, password, salt, {
        c: 1,
        dkLen: blockSize * p
    });
    const B32 = (0, $61b84c5a52451a70$exports.u32)(B);
    // Re-used between parallel iterations. Array(iterations) of B
    const V = (0, $61b84c5a52451a70$exports.u32)(new Uint8Array(blockSize * N));
    const tmp = (0, $61b84c5a52451a70$exports.u32)(new Uint8Array(blockSize));
    let blockMixCb = ()=>{};
    if (onProgress) {
        const totalBlockMix = 2 * N * p;
        // Invoke callback if progress changes from 10.01 to 10.02
        // Allows to draw smooth progress bar on up to 8K screen
        const callbackPer = Math.max(Math.floor(totalBlockMix / 10000), 1);
        let blockMixCnt = 0;
        blockMixCb = ()=>{
            blockMixCnt++;
            if (onProgress && (!(blockMixCnt % callbackPer) || blockMixCnt === totalBlockMix)) onProgress(blockMixCnt / totalBlockMix);
        };
    }
    return {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        blockSize32: blockSize32,
        V: V,
        B32: B32,
        B: B,
        tmp: tmp,
        blockMixCb: blockMixCb,
        asyncTick: asyncTick
    };
}
function $5caff4160219eda0$var$scryptOutput(password, dkLen, B, V, tmp) {
    const res = (0, $ea6196dd1a9277ad$exports.pbkdf2)($0dea00f7ce276413$exports.sha256, password, B, {
        c: 1,
        dkLen: dkLen
    });
    B.fill(0);
    V.fill(0);
    tmp.fill(0);
    return res;
}
/**
 * Scrypt KDF from RFC 7914.
 * @param password - pass
 * @param salt - salt
 * @param opts - parameters
 * - `N` is cpu/mem work factor (power of 2 e.g. 2**18)
 * - `r` is block size (8 is common), fine-tunes sequential memory read size and performance
 * - `p` is parallelization factor (1 is common)
 * - `dkLen` is output key length in bytes e.g. 32.
 * - `asyncTick` - (default: 10) max time in ms for which async function can block execution
 * - `maxmem` - (default: `1024 ** 3 + 1024` aka 1GB+1KB). A limit that the app could use for scrypt
 * - `onProgress` - callback function that would be executed for progress report
 * @returns Derived key
 */ function $5caff4160219eda0$var$scrypt(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb } = $5caff4160219eda0$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        for(let i = 0, pos = 0; i < N - 1; i++){
            $5caff4160219eda0$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        }
        $5caff4160219eda0$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        for(let i = 0; i < N; i++){
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $5caff4160219eda0$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        }
    }
    return $5caff4160219eda0$var$scryptOutput(password, dkLen, B, V, tmp);
}
$5caff4160219eda0$exports.scrypt = $5caff4160219eda0$var$scrypt;
/**
 * Scrypt KDF from RFC 7914.
 */ async function $5caff4160219eda0$var$scryptAsync(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb, asyncTick: asyncTick } = $5caff4160219eda0$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        let pos = 0;
        await (0, $61b84c5a52451a70$exports.asyncLoop)(N - 1, asyncTick, ()=>{
            $5caff4160219eda0$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        });
        $5caff4160219eda0$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        await (0, $61b84c5a52451a70$exports.asyncLoop)(N, asyncTick, ()=>{
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $5caff4160219eda0$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        });
    }
    return $5caff4160219eda0$var$scryptOutput(password, dkLen, B, V, tmp);
}
$5caff4160219eda0$exports.scryptAsync = $5caff4160219eda0$var$scryptAsync;



let $e794241b1cb9b0d3$var$lockedSync = false, $e794241b1cb9b0d3$var$lockedAsync = false;
const $e794241b1cb9b0d3$var$_scryptAsync = async function(passwd, salt, N, r, p, dkLen, onProgress) {
    return await (0, $5caff4160219eda0$exports.scryptAsync)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        onProgress: onProgress
    });
};
const $e794241b1cb9b0d3$var$_scryptSync = function(passwd, salt, N, r, p, dkLen) {
    return (0, $5caff4160219eda0$exports.scrypt)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen
    });
};
let $e794241b1cb9b0d3$var$__scryptAsync = $e794241b1cb9b0d3$var$_scryptAsync;
let $e794241b1cb9b0d3$var$__scryptSync = $e794241b1cb9b0d3$var$_scryptSync;
async function $e794241b1cb9b0d3$export$7cf7c2f1ec457bf3(_passwd, _salt, N, r, p, dkLen, progress) {
    const passwd = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_passwd, "passwd");
    const salt = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(await $e794241b1cb9b0d3$var$__scryptAsync(passwd, salt, N, r, p, dkLen, progress));
}
$e794241b1cb9b0d3$export$7cf7c2f1ec457bf3._ = $e794241b1cb9b0d3$var$_scryptAsync;
$e794241b1cb9b0d3$export$7cf7c2f1ec457bf3.lock = function() {
    $e794241b1cb9b0d3$var$lockedAsync = true;
};
$e794241b1cb9b0d3$export$7cf7c2f1ec457bf3.register = function(func) {
    if ($e794241b1cb9b0d3$var$lockedAsync) throw new Error("scrypt is locked");
    $e794241b1cb9b0d3$var$__scryptAsync = func;
};
Object.freeze($e794241b1cb9b0d3$export$7cf7c2f1ec457bf3);
function $e794241b1cb9b0d3$export$86c79e0734c26a76(_passwd, _salt, N, r, p, dkLen) {
    const passwd = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_passwd, "passwd");
    const salt = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($e794241b1cb9b0d3$var$__scryptSync(passwd, salt, N, r, p, dkLen));
}
$e794241b1cb9b0d3$export$86c79e0734c26a76._ = $e794241b1cb9b0d3$var$_scryptSync;
$e794241b1cb9b0d3$export$86c79e0734c26a76.lock = function() {
    $e794241b1cb9b0d3$var$lockedSync = true;
};
$e794241b1cb9b0d3$export$86c79e0734c26a76.register = function(func) {
    if ($e794241b1cb9b0d3$var$lockedSync) throw new Error("scryptSync is locked");
    $e794241b1cb9b0d3$var$__scryptSync = func;
};
Object.freeze($e794241b1cb9b0d3$export$86c79e0734c26a76);




const $c1049352abb4e7c6$var$_sha256 = function(data) {
    return (0, $15a6e7f1608663ad$export$2fb37efbf6ae0c0e)("sha256").update(data).digest();
};
const $c1049352abb4e7c6$var$_sha512 = function(data) {
    return (0, $15a6e7f1608663ad$export$2fb37efbf6ae0c0e)("sha512").update(data).digest();
};
let $c1049352abb4e7c6$var$__sha256 = $c1049352abb4e7c6$var$_sha256;
let $c1049352abb4e7c6$var$__sha512 = $c1049352abb4e7c6$var$_sha512;
let $c1049352abb4e7c6$var$locked256 = false, $c1049352abb4e7c6$var$locked512 = false;
function $c1049352abb4e7c6$export$bced8d2aada2d1c9(_data) {
    const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data, "data");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($c1049352abb4e7c6$var$__sha256(data));
}
$c1049352abb4e7c6$export$bced8d2aada2d1c9._ = $c1049352abb4e7c6$var$_sha256;
$c1049352abb4e7c6$export$bced8d2aada2d1c9.lock = function() {
    $c1049352abb4e7c6$var$locked256 = true;
};
$c1049352abb4e7c6$export$bced8d2aada2d1c9.register = function(func) {
    if ($c1049352abb4e7c6$var$locked256) throw new Error("sha256 is locked");
    $c1049352abb4e7c6$var$__sha256 = func;
};
Object.freeze($c1049352abb4e7c6$export$bced8d2aada2d1c9);
function $c1049352abb4e7c6$export$a888d2532e6dc7bb(_data) {
    const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data, "data");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($c1049352abb4e7c6$var$__sha512(data));
}
$c1049352abb4e7c6$export$a888d2532e6dc7bb._ = $c1049352abb4e7c6$var$_sha512;
$c1049352abb4e7c6$export$a888d2532e6dc7bb.lock = function() {
    $c1049352abb4e7c6$var$locked512 = true;
};
$c1049352abb4e7c6$export$a888d2532e6dc7bb.register = function(func) {
    if ($c1049352abb4e7c6$var$locked512) throw new Error("sha512 is locked");
    $c1049352abb4e7c6$var$__sha512 = func;
};
Object.freeze($c1049352abb4e7c6$export$bced8d2aada2d1c9);




/**
 *  Once called, prevents any future change to the underlying cryptographic
 *  primitives using the ``.register`` feature for hooks.
 */ function $0c0373556082ea84$export$6a9f04c98a658ecb() {
    (0, $be13a0f2e0d9ad05$export$967075d2f3b8e7ff).lock();
    (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35).lock();
    (0, $9092348e8cf65603$export$448fa22aedc9dbca).lock();
    (0, $90bc03290273a6e1$export$5f828d93ff035aa8).lock();
    (0, $76bdf8351c5898c8$export$d1cea0ee4e3f0d3e).lock();
    (0, $e794241b1cb9b0d3$export$7cf7c2f1ec457bf3).lock();
    (0, $e794241b1cb9b0d3$export$86c79e0734c26a76).lock();
    (0, $c1049352abb4e7c6$export$bced8d2aada2d1c9).lock();
    (0, $c1049352abb4e7c6$export$a888d2532e6dc7bb).lock();
    (0, $90bc03290273a6e1$export$5f828d93ff035aa8).lock();
}


/**
 *  Using strings in Ethereum (or any security-basd system) requires
 *  additional care. These utilities attempt to mitigate some of the
 *  safety issues as well as provide the ability to recover and analyse
 *  strings.
 *
 *  @_subsection api/utils:Strings and UTF-8  [about-strings]
 */ 

function $50aa15ceb128a952$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $50aa15ceb128a952$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === "BAD_PREFIX" || reason === "UNEXPECTED_CONTINUE") {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === "OVERRUN") return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $50aa15ceb128a952$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === "OVERLONG") {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof badCodepoint === "number", "invalid bad code point for replacement", "badCodepoint", badCodepoint);
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $50aa15ceb128a952$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $50aa15ceb128a952$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $50aa15ceb128a952$var$errorFunc,
    ignore: $50aa15ceb128a952$var$ignoreFunc,
    replace: $50aa15ceb128a952$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $50aa15ceb128a952$var$getUtf8CodePoints(_bytes, onError) {
    if (onError == null) onError = $50aa15ceb128a952$export$c6e2180c5bb5bc05.error;
    const bytes = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_bytes, "bytes");
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError("UNEXPECTED_CONTINUE", i - 1, bytes, result);
            else i += onError("BAD_PREFIX", i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError("OVERRUN", i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError("MISSING_CONTINUE", i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError("OUT_OF_RANGE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError("UTF16_SURROGATE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError("OVERLONG", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $50aa15ceb128a952$export$8feeb310b4b4752f(str, form) {
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof str === "string", "invalid string value", "str", str);
    if (form != null) {
        (0, $634aa51198273feb$export$d993e67fefdfecda)(form);
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(i < str.length && (c2 & 0xfc00) === 0xdc00, "invalid surrogate pair", "str", str);
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return new Uint8Array(result);
}
//export 
function $50aa15ceb128a952$var$_toUtf8String(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $50aa15ceb128a952$export$7643a1dc2c38d5eb(bytes, onError) {
    return $50aa15ceb128a952$var$_toUtf8String($50aa15ceb128a952$var$getUtf8CodePoints(bytes, onError));
}
function $50aa15ceb128a952$export$ae470a36a31b28c2(str, form) {
    return $50aa15ceb128a952$var$getUtf8CodePoints($50aa15ceb128a952$export$8feeb310b4b4752f(str, form));
}


function $697215a61e1ccd96$export$d560c7e4a29451c2(value) {
    return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)((0, $50aa15ceb128a952$export$8feeb310b4b4752f)(value));
}


// [ "a", "b" ] => { "a": 1, "b": 1 }
function $7316d9256af52303$var$setify(items) {
    const result = new Set();
    items.forEach((k)=>result.add(k));
    return Object.freeze(result);
}
const $7316d9256af52303$var$_kwVisibDeploy = "external public payable override";
const $7316d9256af52303$var$KwVisibDeploy = $7316d9256af52303$var$setify($7316d9256af52303$var$_kwVisibDeploy.split(" "));
// Visibility Keywords
const $7316d9256af52303$var$_kwVisib = "constant external internal payable private public pure view override";
const $7316d9256af52303$var$KwVisib = $7316d9256af52303$var$setify($7316d9256af52303$var$_kwVisib.split(" "));
const $7316d9256af52303$var$_kwTypes = "constructor error event fallback function receive struct";
const $7316d9256af52303$var$KwTypes = $7316d9256af52303$var$setify($7316d9256af52303$var$_kwTypes.split(" "));
const $7316d9256af52303$var$_kwModifiers = "calldata memory storage payable indexed";
const $7316d9256af52303$var$KwModifiers = $7316d9256af52303$var$setify($7316d9256af52303$var$_kwModifiers.split(" "));
const $7316d9256af52303$var$_kwOther = "tuple returns";
// All Keywords
const $7316d9256af52303$var$_keywords = [
    $7316d9256af52303$var$_kwTypes,
    $7316d9256af52303$var$_kwModifiers,
    $7316d9256af52303$var$_kwOther,
    $7316d9256af52303$var$_kwVisib
].join(" ");
const $7316d9256af52303$var$Keywords = $7316d9256af52303$var$setify($7316d9256af52303$var$_keywords.split(" "));
// Single character tokens
const $7316d9256af52303$var$SimpleTokens = {
    "(": "OPEN_PAREN",
    ")": "CLOSE_PAREN",
    "[": "OPEN_BRACKET",
    "]": "CLOSE_BRACKET",
    ",": "COMMA",
    "@": "AT"
};
// Parser regexes to consume the next token
const $7316d9256af52303$var$regexWhitespacePrefix = new RegExp("^(\\s*)");
const $7316d9256af52303$var$regexNumberPrefix = new RegExp("^([0-9]+)");
const $7316d9256af52303$var$regexIdPrefix = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)");
// Parser regexs to check validity
const $7316d9256af52303$var$regexId = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$");
const $7316d9256af52303$var$regexType = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$");
class $7316d9256af52303$var$TokenString {
    #offset;
    #tokens;
    get offset() {
        return this.#offset;
    }
    get length() {
        return this.#tokens.length - this.#offset;
    }
    constructor(tokens){
        this.#offset = 0;
        this.#tokens = tokens.slice();
    }
    clone() {
        return new $7316d9256af52303$var$TokenString(this.#tokens);
    }
    reset() {
        this.#offset = 0;
    }
    #subTokenString(from = 0, to = 0) {
        return new $7316d9256af52303$var$TokenString(this.#tokens.slice(from, to).map((t)=>{
            return Object.freeze(Object.assign({}, t, {
                match: t.match - from,
                linkBack: t.linkBack - from,
                linkNext: t.linkNext - from
            }));
        }));
    }
    // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
    popKeyword(allowed) {
        const top = this.peek();
        if (top.type !== "KEYWORD" || !allowed.has(top.text)) throw new Error(`expected keyword ${top.text}`);
        return this.pop().text;
    }
    // Pops and returns the value of the next token if it is `type`; throws if out of tokens
    popType(type) {
        if (this.peek().type !== type) {
            const top = this.peek();
            throw new Error(`expected ${type}; got ${top.type} ${JSON.stringify(top.text)}`);
        }
        return this.pop().text;
    }
    // Pops and returns a "(" TOKENS ")"
    popParen() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = this.#subTokenString(this.#offset + 1, top.match + 1);
        this.#offset = top.match + 1;
        return result;
    }
    // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
    popParams() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = [];
        while(this.#offset < top.match - 1){
            const link = this.peek().linkNext;
            result.push(this.#subTokenString(this.#offset + 1, link));
            this.#offset = link;
        }
        this.#offset = top.match + 1;
        return result;
    }
    // Returns the top Token, throwing if out of tokens
    peek() {
        if (this.#offset >= this.#tokens.length) throw new Error("out-of-bounds");
        return this.#tokens[this.#offset];
    }
    // Returns the next value, if it is a keyword in `allowed`
    peekKeyword(allowed) {
        const top = this.peekType("KEYWORD");
        return top != null && allowed.has(top) ? top : null;
    }
    // Returns the value of the next token if it is `type`
    peekType(type) {
        if (this.length === 0) return null;
        const top = this.peek();
        return top.type === type ? top.text : null;
    }
    // Returns the next token; throws if out of tokens
    pop() {
        const result = this.peek();
        this.#offset++;
        return result;
    }
    toString() {
        const tokens = [];
        for(let i = this.#offset; i < this.#tokens.length; i++){
            const token = this.#tokens[i];
            tokens.push(`${token.type}:${token.text}`);
        }
        return `<TokenString ${tokens.join(" ")}>`;
    }
}
function $7316d9256af52303$var$lex(text) {
    const tokens = [];
    const throwError = (message)=>{
        const token = offset < text.length ? JSON.stringify(text[offset]) : "$EOI";
        throw new Error(`invalid token ${token} at ${offset}: ${message}`);
    };
    let brackets = [];
    let commas = [];
    let offset = 0;
    while(offset < text.length){
        // Strip off any leading whitespace
        let cur = text.substring(offset);
        let match = cur.match($7316d9256af52303$var$regexWhitespacePrefix);
        if (match) {
            offset += match[1].length;
            cur = text.substring(offset);
        }
        const token = {
            depth: brackets.length,
            linkBack: -1,
            linkNext: -1,
            match: -1,
            type: "",
            text: "",
            offset: offset,
            value: -1
        };
        tokens.push(token);
        let type = $7316d9256af52303$var$SimpleTokens[cur[0]] || "";
        if (type) {
            token.type = type;
            token.text = cur[0];
            offset++;
            if (type === "OPEN_PAREN") {
                brackets.push(tokens.length - 1);
                commas.push(tokens.length - 1);
            } else if (type == "CLOSE_PAREN") {
                if (brackets.length === 0) throwError("no matching open bracket");
                token.match = brackets.pop();
                tokens[token.match].match = tokens.length - 1;
                token.depth--;
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
            } else if (type === "COMMA") {
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
                commas.push(tokens.length - 1);
            } else if (type === "OPEN_BRACKET") token.type = "BRACKET";
            else if (type === "CLOSE_BRACKET") {
                // Remove the CLOSE_BRACKET
                let suffix = tokens.pop().text;
                if (tokens.length > 0 && tokens[tokens.length - 1].type === "NUMBER") {
                    const value = tokens.pop().text;
                    suffix = value + suffix;
                    tokens[tokens.length - 1].value = (0, $6fa405e57bb6371e$export$b14f2714108df84)(value);
                }
                if (tokens.length === 0 || tokens[tokens.length - 1].type !== "BRACKET") throw new Error("missing opening bracket");
                tokens[tokens.length - 1].text += suffix;
            }
            continue;
        }
        match = cur.match($7316d9256af52303$var$regexIdPrefix);
        if (match) {
            token.text = match[1];
            offset += token.text.length;
            if ($7316d9256af52303$var$Keywords.has(token.text)) {
                token.type = "KEYWORD";
                continue;
            }
            if (token.text.match($7316d9256af52303$var$regexType)) {
                token.type = "TYPE";
                continue;
            }
            token.type = "ID";
            continue;
        }
        match = cur.match($7316d9256af52303$var$regexNumberPrefix);
        if (match) {
            token.text = match[1];
            token.type = "NUMBER";
            offset += token.text.length;
            continue;
        }
        throw new Error(`unexpected token ${JSON.stringify(cur[0])} at position ${offset}`);
    }
    return new $7316d9256af52303$var$TokenString(tokens.map((t)=>Object.freeze(t)));
}
// Check only one of `allowed` is in `set`
function $7316d9256af52303$var$allowSingle(set, allowed) {
    let included = [];
    for(const key in allowed.keys())if (set.has(key)) included.push(key);
    if (included.length > 1) throw new Error(`conflicting types: ${included.join(", ")}`);
}
// Functions to process a Solidity Signature TokenString from left-to-right for...
// ...the name with an optional type, returning the name
function $7316d9256af52303$var$consumeName(type, tokens) {
    if (tokens.peekKeyword($7316d9256af52303$var$KwTypes)) {
        const keyword = tokens.pop().text;
        if (keyword !== type) throw new Error(`expected ${type}, got ${keyword}`);
    }
    return tokens.popType("ID");
}
// ...all keywords matching allowed, returning the keywords
function $7316d9256af52303$var$consumeKeywords(tokens, allowed) {
    const keywords = new Set();
    while(true){
        const keyword = tokens.peekType("KEYWORD");
        if (keyword == null || allowed && !allowed.has(keyword)) break;
        tokens.pop();
        if (keywords.has(keyword)) throw new Error(`duplicate keywords: ${JSON.stringify(keyword)}`);
        keywords.add(keyword);
    }
    return Object.freeze(keywords);
}
// ...all visibility keywords, returning the coalesced mutability
function $7316d9256af52303$var$consumeMutability(tokens) {
    let modifiers = $7316d9256af52303$var$consumeKeywords(tokens, $7316d9256af52303$var$KwVisib);
    // Detect conflicting modifiers
    $7316d9256af52303$var$allowSingle(modifiers, $7316d9256af52303$var$setify("constant payable nonpayable".split(" ")));
    $7316d9256af52303$var$allowSingle(modifiers, $7316d9256af52303$var$setify("pure view payable nonpayable".split(" ")));
    // Process mutability states
    if (modifiers.has("view")) return "view";
    if (modifiers.has("pure")) return "pure";
    if (modifiers.has("payable")) return "payable";
    if (modifiers.has("nonpayable")) return "nonpayable";
    // Process legacy `constant` last
    if (modifiers.has("constant")) return "view";
    return "nonpayable";
}
// ...a parameter list, returning the ParamType list
function $7316d9256af52303$var$consumeParams(tokens, allowIndexed) {
    return tokens.popParams().map((t)=>$7316d9256af52303$export$426dc07f493a4c47.from(t, allowIndexed));
}
// ...a gas limit, returning a BigNumber or null if none
function $7316d9256af52303$var$consumeGas(tokens) {
    if (tokens.peekType("AT")) {
        tokens.pop();
        if (tokens.peekType("NUMBER")) return (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(tokens.pop().text);
        throw new Error("invalid gas");
    }
    return null;
}
function $7316d9256af52303$var$consumeEoi(tokens) {
    if (tokens.length) throw new Error(`unexpected tokens at offset ${tokens.offset}: ${tokens.toString()}`);
}
const $7316d9256af52303$var$regexArrayType = new RegExp(/^(.*)\[([0-9]*)\]$/);
function $7316d9256af52303$var$verifyBasicType(type) {
    const match = type.match($7316d9256af52303$var$regexType);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(match, "invalid type", "type", type);
    if (type === "uint") return "uint256";
    if (type === "int") return "int256";
    if (match[2]) {
        // bytesXX
        const length = parseInt(match[2]);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(length !== 0 && length <= 32, "invalid bytes length", "type", type);
    } else if (match[3]) {
        // intXX or uintXX
        const size = parseInt(match[3]);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(size !== 0 && size <= 256 && size % 8 === 0, "invalid numeric width", "type", type);
    }
    return type;
}
// Make the Fragment constructors effectively private
const $7316d9256af52303$var$_guard = {};
const $7316d9256af52303$var$internal = Symbol.for("_ethers_internal");
const $7316d9256af52303$var$ParamTypeInternal = "_ParamTypeInternal";
const $7316d9256af52303$var$ErrorFragmentInternal = "_ErrorInternal";
const $7316d9256af52303$var$EventFragmentInternal = "_EventInternal";
const $7316d9256af52303$var$ConstructorFragmentInternal = "_ConstructorInternal";
const $7316d9256af52303$var$FallbackFragmentInternal = "_FallbackInternal";
const $7316d9256af52303$var$FunctionFragmentInternal = "_FunctionInternal";
const $7316d9256af52303$var$StructFragmentInternal = "_StructInternal";
class $7316d9256af52303$export$426dc07f493a4c47 {
    /**
     *  The local name of the parameter (or ``""`` if unbound)
     */ name;
    /**
     *  The fully qualified type (e.g. ``"address"``, ``"tuple(address)"``,
     *  ``"uint256[3][]"``)
     */ type;
    /**
     *  The base type (e.g. ``"address"``, ``"tuple"``, ``"array"``)
     */ baseType;
    /**
     *  True if the parameters is indexed.
     *
     *  For non-indexable types this is ``null``.
     */ indexed;
    /**
     *  The components for the tuple.
     *
     *  For non-tuple types this is ``null``.
     */ components;
    /**
     *  The array length, or ``-1`` for dynamic-lengthed arrays.
     *
     *  For non-array types this is ``null``.
     */ arrayLength;
    /**
     *  The type of each child in the array.
     *
     *  For non-array types this is ``null``.
     */ arrayChildren;
    /**
     *  @private
     */ constructor(guard, name, type, baseType, indexed, components, arrayLength, arrayChildren){
        (0, $634aa51198273feb$export$ac1a938d48ec8c7b)(guard, $7316d9256af52303$var$_guard, "ParamType");
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$ParamTypeInternal
        });
        if (components) components = Object.freeze(components.slice());
        if (baseType === "array") {
            if (arrayLength == null || arrayChildren == null) throw new Error("");
        } else if (arrayLength != null || arrayChildren != null) throw new Error("");
        if (baseType === "tuple") {
            if (components == null) throw new Error("");
        } else if (components != null) throw new Error("");
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            name: name,
            type: type,
            baseType: baseType,
            indexed: indexed,
            components: components,
            arrayLength: arrayLength,
            arrayChildren: arrayChildren
        });
    }
    /**
     *  Return a string representation of this type.
     *
     *  For example,
     *
     *  ``sighash" => "(uint256,address)"``
     *
     *  ``"minimal" => "tuple(uint256,address) indexed"``
     *
     *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") {
            const name = this.name || "";
            if (this.isArray()) {
                const result = JSON.parse(this.arrayChildren.format("json"));
                result.name = name;
                result.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
                return JSON.stringify(result);
            }
            const result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: name
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.isTuple()) result.components = this.components.map((c)=>JSON.parse(c.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.isArray()) {
            result += this.arrayChildren.format(format);
            result += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
        } else if (this.isTuple()) result += "(" + this.components.map((comp)=>comp.format(format)).join(format === "full" ? ", " : ",") + ")";
        else result += this.type;
        if (format !== "sighash") {
            if (this.indexed === true) result += " indexed";
            if (format === "full" && this.name) result += " " + this.name;
        }
        return result;
    }
    /**
     *  Returns true if %%this%% is an Array type.
     *
     *  This provides a type gaurd ensuring that [[arrayChildren]]
     *  and [[arrayLength]] are non-null.
     */ isArray() {
        return this.baseType === "array";
    }
    /**
     *  Returns true if %%this%% is a Tuple type.
     *
     *  This provides a type gaurd ensuring that [[components]]
     *  is non-null.
     */ isTuple() {
        return this.baseType === "tuple";
    }
    /**
     *  Returns true if %%this%% is an Indexable type.
     *
     *  This provides a type gaurd ensuring that [[indexed]]
     *  is non-null.
     */ isIndexable() {
        return this.indexed != null;
    }
    /**
     *  Walks the **ParamType** with %%value%%, calling %%process%%
     *  on each type, destructing the %%value%% recursively.
     */ walk(value, process) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v)=>_this.arrayChildren.walk(v, process));
        }
        if (this.isTuple()) {
            if (!Array.isArray(value)) throw new Error("invalid tuple value");
            if (value.length !== this.components.length) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v, i)=>_this.components[i].walk(v, process));
        }
        return process(this.type, value);
    }
    #walkAsync(promises, value, process, setValue) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const childType = this.arrayChildren;
            const result = value.slice();
            result.forEach((value, index)=>{
                childType.#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        if (this.isTuple()) {
            const components = this.components;
            // Convert the object into an array
            let result;
            if (Array.isArray(value)) result = value.slice();
            else {
                if (value == null || typeof value !== "object") throw new Error("invalid tuple value");
                result = components.map((param)=>{
                    if (!param.name) throw new Error("cannot use object value with unnamed components");
                    if (!(param.name in value)) throw new Error(`missing value for component ${param.name}`);
                    return value[param.name];
                });
            }
            if (result.length !== this.components.length) throw new Error("array is wrong length");
            result.forEach((value, index)=>{
                components[index].#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        const result = process(this.type, value);
        if (result.then) promises.push(async function() {
            setValue(await result);
        }());
        else setValue(result);
    }
    /**
     *  Walks the **ParamType** with %%value%%, asynchronously calling
     *  %%process%% on each type, destructing the %%value%% recursively.
     *
     *  This can be used to resolve ENS names by walking and resolving each
     *  ``"address"`` type.
     */ async walkAsync(value, process) {
        const promises = [];
        const result = [
            value
        ];
        this.#walkAsync(promises, value, process, (value)=>{
            result[0] = value;
        });
        if (promises.length) await Promise.all(promises);
        return result[0];
    }
    /**
     *  Creates a new **ParamType** for %%obj%%.
     *
     *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
     *  otherwise the ``indexed`` keyword will throw an error.
     */ static from(obj, allowIndexed) {
        if ($7316d9256af52303$export$426dc07f493a4c47.isParamType(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$426dc07f493a4c47.from($7316d9256af52303$var$lex(obj), allowIndexed);
        } catch (error) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid param type", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            let type = "", baseType = "";
            let comps = null;
            if ($7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "tuple"
            ])).has("tuple") || obj.peekType("OPEN_PAREN")) {
                // Tuple
                baseType = "tuple";
                comps = obj.popParams().map((t)=>$7316d9256af52303$export$426dc07f493a4c47.from(t));
                type = `tuple(${comps.map((c)=>c.format()).join(",")})`;
            } else {
                // Normal
                type = $7316d9256af52303$var$verifyBasicType(obj.popType("TYPE"));
                baseType = type;
            }
            // Check for Array
            let arrayChildren = null;
            let arrayLength = null;
            while(obj.length && obj.peekType("BRACKET")){
                const bracket = obj.pop(); //arrays[i];
                arrayChildren = new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, "", type, baseType, null, comps, arrayLength, arrayChildren);
                arrayLength = bracket.value;
                type += bracket.text;
                baseType = "array";
                comps = null;
            }
            let indexed = null;
            const keywords = $7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$KwModifiers);
            if (keywords.has("indexed")) {
                if (!allowIndexed) throw new Error("");
                indexed = true;
            }
            const name = obj.peekType("ID") ? obj.pop().text : "";
            if (obj.length) throw new Error("leftover tokens");
            return new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, name, type, baseType, indexed, comps, arrayLength, arrayChildren);
        }
        const name = obj.name;
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(!name || typeof name === "string" && name.match($7316d9256af52303$var$regexId), "invalid name", "obj.name", name);
        let indexed = obj.indexed;
        if (indexed != null) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(allowIndexed, "parameter cannot be indexed", "obj.indexed", obj.indexed);
            indexed = !!indexed;
        }
        let type = obj.type;
        let arrayMatch = type.match($7316d9256af52303$var$regexArrayType);
        if (arrayMatch) {
            const arrayLength = parseInt(arrayMatch[2] || "-1");
            const arrayChildren = $7316d9256af52303$export$426dc07f493a4c47.from({
                type: arrayMatch[1],
                components: obj.components
            });
            return new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, name || "", type, "array", indexed, null, arrayLength, arrayChildren);
        }
        if (type === "tuple" || type.startsWith("tuple(" /* fix: ) */ ) || type.startsWith("(" /* fix: ) */ )) {
            const comps = obj.components != null ? obj.components.map((c)=>$7316d9256af52303$export$426dc07f493a4c47.from(c)) : null;
            const tuple = new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, name || "", type, "tuple", indexed, comps, null, null);
            // @TODO: use lexer to validate and normalize type
            return tuple;
        }
        type = $7316d9256af52303$var$verifyBasicType(obj.type);
        return new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, name || "", type, type, indexed, null, null, null);
    }
    /**
     *  Returns true if %%value%% is a **ParamType**.
     */ static isParamType(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$ParamTypeInternal;
    }
}
class $7316d9256af52303$export$ffb0004e005737fa {
    /**
     *  The type of the fragment.
     */ type;
    /**
     *  The inputs for the fragment.
     */ inputs;
    /**
     *  @private
     */ constructor(guard, type, inputs){
        (0, $634aa51198273feb$export$ac1a938d48ec8c7b)(guard, $7316d9256af52303$var$_guard, "Fragment");
        inputs = Object.freeze(inputs.slice());
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            type: type,
            inputs: inputs
        });
    }
    /**
     *  Creates a new **Fragment** for %%obj%%, wich can be any supported
     *  ABI frgament type.
     */ static from(obj) {
        if (typeof obj === "string") {
            // Try parsing JSON...
            try {
                $7316d9256af52303$export$ffb0004e005737fa.from(JSON.parse(obj));
            } catch (e) {}
            // ...otherwise, use the human-readable lexer
            return $7316d9256af52303$export$ffb0004e005737fa.from($7316d9256af52303$var$lex(obj));
        }
        if (obj instanceof $7316d9256af52303$var$TokenString) {
            // Human-readable ABI (already lexed)
            const type = obj.peekKeyword($7316d9256af52303$var$KwTypes);
            switch(type){
                case "constructor":
                    return $7316d9256af52303$export$3ac5c9504f801ea4.from(obj);
                case "error":
                    return $7316d9256af52303$export$2c42c6d543aa9b59.from(obj);
                case "event":
                    return $7316d9256af52303$export$958548f08bac2833.from(obj);
                case "fallback":
                case "receive":
                    return $7316d9256af52303$export$71b1ea64c89c20fc.from(obj);
                case "function":
                    return $7316d9256af52303$export$8d576c928b93668f.from(obj);
                case "struct":
                    return $7316d9256af52303$export$9f91ba10bb234ec7.from(obj);
            }
        } else if (typeof obj === "object") {
            // JSON ABI
            switch(obj.type){
                case "constructor":
                    return $7316d9256af52303$export$3ac5c9504f801ea4.from(obj);
                case "error":
                    return $7316d9256af52303$export$2c42c6d543aa9b59.from(obj);
                case "event":
                    return $7316d9256af52303$export$958548f08bac2833.from(obj);
                case "fallback":
                case "receive":
                    return $7316d9256af52303$export$71b1ea64c89c20fc.from(obj);
                case "function":
                    return $7316d9256af52303$export$8d576c928b93668f.from(obj);
                case "struct":
                    return $7316d9256af52303$export$9f91ba10bb234ec7.from(obj);
            }
            (0, $634aa51198273feb$export$a7a9523472993e97)(false, `unsupported type: ${obj.type}`, "UNSUPPORTED_OPERATION", {
                operation: "Fragment.from"
            });
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "unsupported frgament object", "obj", obj);
    }
    /**
     *  Returns true if %%value%% is a [[ConstructorFragment]].
     */ static isConstructor(value) {
        return $7316d9256af52303$export$3ac5c9504f801ea4.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[ErrorFragment]].
     */ static isError(value) {
        return $7316d9256af52303$export$2c42c6d543aa9b59.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[EventFragment]].
     */ static isEvent(value) {
        return $7316d9256af52303$export$958548f08bac2833.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[FunctionFragment]].
     */ static isFunction(value) {
        return $7316d9256af52303$export$8d576c928b93668f.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[StructFragment]].
     */ static isStruct(value) {
        return $7316d9256af52303$export$9f91ba10bb234ec7.isFragment(value);
    }
}
class $7316d9256af52303$export$85c6fc53d6299173 extends $7316d9256af52303$export$ffb0004e005737fa {
    /**
     *  The name of the fragment.
     */ name;
    /**
     *  @private
     */ constructor(guard, type, name, inputs){
        super(guard, type, inputs);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof name === "string" && name.match($7316d9256af52303$var$regexId), "invalid identifier", "name", name);
        inputs = Object.freeze(inputs.slice());
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
}
function $7316d9256af52303$var$joinParams(format, params) {
    return "(" + params.map((p)=>p.format(format)).join(format === "full" ? ", " : ",") + ")";
}
class $7316d9256af52303$export$2c42c6d543aa9b59 extends $7316d9256af52303$export$85c6fc53d6299173 {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "error", name, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$ErrorFragmentInternal
        });
    }
    /**
     *  The Custom Error selector.
     */ get selector() {
        return (0, $697215a61e1ccd96$export$d560c7e4a29451c2)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this fragment as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("error");
        result.push(this.name + $7316d9256af52303$var$joinParams(format, this.inputs));
        return result.join(" ");
    }
    /**
     *  Returns a new **ErrorFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$2c42c6d543aa9b59.isFragment(obj)) return obj;
        if (typeof obj === "string") return $7316d9256af52303$export$2c42c6d543aa9b59.from($7316d9256af52303$var$lex(obj));
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const name = $7316d9256af52303$var$consumeName("error", obj);
            const inputs = $7316d9256af52303$var$consumeParams(obj);
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$2c42c6d543aa9b59($7316d9256af52303$var$_guard, name, inputs);
        }
        return new $7316d9256af52303$export$2c42c6d543aa9b59($7316d9256af52303$var$_guard, obj.name, obj.inputs ? obj.inputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : []);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **ErrorFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$ErrorFragmentInternal;
    }
}
class $7316d9256af52303$export$958548f08bac2833 extends $7316d9256af52303$export$85c6fc53d6299173 {
    /**
     *  Whether this event is anonymous.
     */ anonymous;
    /**
     *  @private
     */ constructor(guard, name, inputs, anonymous){
        super(guard, "event", name, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$EventFragmentInternal
        });
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            anonymous: anonymous
        });
    }
    /**
     *  The Event topic hash.
     */ get topicHash() {
        return (0, $697215a61e1ccd96$export$d560c7e4a29451c2)(this.format("sighash"));
    }
    /**
     *  Returns a string representation of this event as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("event");
        result.push(this.name + $7316d9256af52303$var$joinParams(format, this.inputs));
        if (format !== "sighash" && this.anonymous) result.push("anonymous");
        return result.join(" ");
    }
    /**
     *  Return the topic hash for an event with %%name%% and %%params%%.
     */ static getTopicHash(name, params) {
        params = (params || []).map((p)=>$7316d9256af52303$export$426dc07f493a4c47.from(p));
        const fragment = new $7316d9256af52303$export$958548f08bac2833($7316d9256af52303$var$_guard, name, params, false);
        return fragment.topicHash;
    }
    /**
     *  Returns a new **EventFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$958548f08bac2833.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$958548f08bac2833.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid event fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const name = $7316d9256af52303$var$consumeName("event", obj);
            const inputs = $7316d9256af52303$var$consumeParams(obj, true);
            const anonymous = !!$7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "anonymous"
            ])).has("anonymous");
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$958548f08bac2833($7316d9256af52303$var$_guard, name, inputs, anonymous);
        }
        return new $7316d9256af52303$export$958548f08bac2833($7316d9256af52303$var$_guard, obj.name, obj.inputs ? obj.inputs.map((p)=>$7316d9256af52303$export$426dc07f493a4c47.from(p, true)) : [], !!obj.anonymous);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **EventFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$EventFragmentInternal;
    }
}
class $7316d9256af52303$export$3ac5c9504f801ea4 extends $7316d9256af52303$export$ffb0004e005737fa {
    /**
     *  Whether the constructor can receive an endowment.
     */ payable;
    /**
     *  The recommended gas limit for deployment or ``null``.
     */ gas;
    /**
     *  @private
     */ constructor(guard, type, inputs, payable, gas){
        super(guard, type, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$ConstructorFragmentInternal
        });
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            payable: payable,
            gas: gas
        });
    }
    /**
     *  Returns a string representation of this constructor as %%format%%.
     */ format(format) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(format != null && format !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", {
            operation: "format(sighash)"
        });
        if (format === "json") return JSON.stringify({
            type: "constructor",
            stateMutability: this.payable ? "payable" : "undefined",
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [
            `constructor${$7316d9256af52303$var$joinParams(format, this.inputs)}`
        ];
        if (this.payable) result.push("payable");
        if (this.gas != null) result.push(`@${this.gas.toString()}`);
        return result.join(" ");
    }
    /**
     *  Returns a new **ConstructorFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$3ac5c9504f801ea4.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$3ac5c9504f801ea4.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid constuctor fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            $7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "constructor"
            ]));
            const inputs = $7316d9256af52303$var$consumeParams(obj);
            const payable = !!$7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$KwVisibDeploy).has("payable");
            const gas = $7316d9256af52303$var$consumeGas(obj);
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$3ac5c9504f801ea4($7316d9256af52303$var$_guard, "constructor", inputs, payable, gas);
        }
        return new $7316d9256af52303$export$3ac5c9504f801ea4($7316d9256af52303$var$_guard, "constructor", obj.inputs ? obj.inputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : [], !!obj.payable, obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **ConstructorFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$ConstructorFragmentInternal;
    }
}
class $7316d9256af52303$export$71b1ea64c89c20fc extends $7316d9256af52303$export$ffb0004e005737fa {
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    constructor(guard, inputs, payable){
        super(guard, "fallback", inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$FallbackFragmentInternal
        });
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            payable: payable
        });
    }
    /**
     *  Returns a string representation of this fallback as %%format%%.
     */ format(format) {
        const type = this.inputs.length === 0 ? "receive" : "fallback";
        if (format === "json") {
            const stateMutability = this.payable ? "payable" : "nonpayable";
            return JSON.stringify({
                type: type,
                stateMutability: stateMutability
            });
        }
        return `${type}()${this.payable ? " payable" : ""}`;
    }
    /**
     *  Returns a new **FallbackFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$71b1ea64c89c20fc.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$71b1ea64c89c20fc.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid fallback fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const errorObj = obj.toString();
            const topIsValid = obj.peekKeyword($7316d9256af52303$var$setify([
                "fallback",
                "receive"
            ]));
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(topIsValid, "type must be fallback or receive", "obj", errorObj);
            const type = obj.popKeyword($7316d9256af52303$var$setify([
                "fallback",
                "receive"
            ]));
            // receive()
            if (type === "receive") {
                const inputs = $7316d9256af52303$var$consumeParams(obj);
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(inputs.length === 0, `receive cannot have arguments`, "obj.inputs", inputs);
                $7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                    "payable"
                ]));
                $7316d9256af52303$var$consumeEoi(obj);
                return new $7316d9256af52303$export$71b1ea64c89c20fc($7316d9256af52303$var$_guard, [], true);
            }
            // fallback() [payable]
            // fallback(bytes) [payable] returns (bytes)
            let inputs = $7316d9256af52303$var$consumeParams(obj);
            if (inputs.length) (0, $634aa51198273feb$export$c3d31707e5030f5e)(inputs.length === 1 && inputs[0].type === "bytes", "invalid fallback inputs", "obj.inputs", inputs.map((i)=>i.format("minimal")).join(", "));
            else inputs = [
                $7316d9256af52303$export$426dc07f493a4c47.from("bytes")
            ];
            const mutability = $7316d9256af52303$var$consumeMutability(obj);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(mutability === "nonpayable" || mutability === "payable", "fallback cannot be constants", "obj.stateMutability", mutability);
            if ($7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "returns"
            ])).has("returns")) {
                const outputs = $7316d9256af52303$var$consumeParams(obj);
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(outputs.length === 1 && outputs[0].type === "bytes", "invalid fallback outputs", "obj.outputs", outputs.map((i)=>i.format("minimal")).join(", "));
            }
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$71b1ea64c89c20fc($7316d9256af52303$var$_guard, inputs, mutability === "payable");
        }
        if (obj.type === "receive") return new $7316d9256af52303$export$71b1ea64c89c20fc($7316d9256af52303$var$_guard, [], true);
        if (obj.type === "fallback") {
            const inputs = [
                $7316d9256af52303$export$426dc07f493a4c47.from("bytes")
            ];
            const payable = obj.stateMutability === "payable";
            return new $7316d9256af52303$export$71b1ea64c89c20fc($7316d9256af52303$var$_guard, inputs, payable);
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid fallback description", "obj", obj);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FallbackFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$FallbackFragmentInternal;
    }
}
class $7316d9256af52303$export$8d576c928b93668f extends $7316d9256af52303$export$85c6fc53d6299173 {
    /**
     *  If the function is constant (e.g. ``pure`` or ``view`` functions).
     */ constant;
    /**
     *  The returned types for the result of calling this function.
     */ outputs;
    /**
     *  The state mutability (e.g. ``payable``, ``nonpayable``, ``view``
     *  or ``pure``)
     */ stateMutability;
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    /**
     *  The recommended gas limit to send when calling this function.
     */ gas;
    /**
     *  @private
     */ constructor(guard, name, stateMutability, inputs, outputs, gas){
        super(guard, "function", name, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$FunctionFragmentInternal
        });
        outputs = Object.freeze(outputs.slice());
        const constant = stateMutability === "view" || stateMutability === "pure";
        const payable = stateMutability === "payable";
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            constant: constant,
            gas: gas,
            outputs: outputs,
            payable: payable,
            stateMutability: stateMutability
        });
    }
    /**
     *  The Function selector.
     */ get selector() {
        return (0, $697215a61e1ccd96$export$d560c7e4a29451c2)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this function as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format))),
            outputs: this.outputs.map((o)=>JSON.parse(o.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("function");
        result.push(this.name + $7316d9256af52303$var$joinParams(format, this.inputs));
        if (format !== "sighash") {
            if (this.stateMutability !== "nonpayable") result.push(this.stateMutability);
            if (this.outputs && this.outputs.length) {
                result.push("returns");
                result.push($7316d9256af52303$var$joinParams(format, this.outputs));
            }
            if (this.gas != null) result.push(`@${this.gas.toString()}`);
        }
        return result.join(" ");
    }
    /**
     *  Return the selector for a function with %%name%% and %%params%%.
     */ static getSelector(name, params) {
        params = (params || []).map((p)=>$7316d9256af52303$export$426dc07f493a4c47.from(p));
        const fragment = new $7316d9256af52303$export$8d576c928b93668f($7316d9256af52303$var$_guard, name, "view", params, [], null);
        return fragment.selector;
    }
    /**
     *  Returns a new **FunctionFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$8d576c928b93668f.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$8d576c928b93668f.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid function fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const name = $7316d9256af52303$var$consumeName("function", obj);
            const inputs = $7316d9256af52303$var$consumeParams(obj);
            const mutability = $7316d9256af52303$var$consumeMutability(obj);
            let outputs = [];
            if ($7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "returns"
            ])).has("returns")) outputs = $7316d9256af52303$var$consumeParams(obj);
            const gas = $7316d9256af52303$var$consumeGas(obj);
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$8d576c928b93668f($7316d9256af52303$var$_guard, name, mutability, inputs, outputs, gas);
        }
        let stateMutability = obj.stateMutability;
        // Use legacy Solidity ABI logic if stateMutability is missing
        if (stateMutability == null) {
            stateMutability = "payable";
            if (typeof obj.constant === "boolean") {
                stateMutability = "view";
                if (!obj.constant) {
                    stateMutability = "payable";
                    if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
                }
            } else if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
        }
        // @TODO: verifyState for stateMutability (e.g. throw if
        //        payable: false but stateMutability is "nonpayable")
        return new $7316d9256af52303$export$8d576c928b93668f($7316d9256af52303$var$_guard, obj.name, stateMutability, obj.inputs ? obj.inputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : [], obj.outputs ? obj.outputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : [], obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FunctionFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$FunctionFragmentInternal;
    }
}
class $7316d9256af52303$export$9f91ba10bb234ec7 extends $7316d9256af52303$export$85c6fc53d6299173 {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "struct", name, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$StructFragmentInternal
        });
    }
    /**
     *  Returns a string representation of this struct as %%format%%.
     */ format() {
        throw new Error("@TODO");
    }
    /**
     *  Returns a new **StructFragment** for %%obj%%.
     */ static from(obj) {
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$9f91ba10bb234ec7.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid struct fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const name = $7316d9256af52303$var$consumeName("struct", obj);
            const inputs = $7316d9256af52303$var$consumeParams(obj);
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$9f91ba10bb234ec7($7316d9256af52303$var$_guard, name, inputs);
        }
        return new $7316d9256af52303$export$9f91ba10bb234ec7($7316d9256af52303$var$_guard, obj.name, obj.inputs ? obj.inputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : []);
    }
    // @TODO: fix this return type
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **StructFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$StructFragmentInternal;
    }
}





var $1FoUm = parcelRequire("1FoUm");
var $dbc5c4a080b2aff5$var$__defProp = Object.defineProperty;
var $dbc5c4a080b2aff5$var$__export = (target, all)=>{
    for(var name in all)$dbc5c4a080b2aff5$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/errors.ts
var $dbc5c4a080b2aff5$export$30f3b02011db23c0 = {};
$dbc5c4a080b2aff5$var$__export($dbc5c4a080b2aff5$export$30f3b02011db23c0, {
    CannotFindTransaction: ()=>$dbc5c4a080b2aff5$export$c4e383fb745c6d52,
    CertificateSignatureMismatch: ()=>$dbc5c4a080b2aff5$export$1b27f6f6c44c7f6f,
    ContractDeploymentFailed: ()=>$dbc5c4a080b2aff5$export$da2c6ca4dce9010b,
    InvalidAbiDataToEncodeOrDecode: ()=>$dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3,
    InvalidAbiItem: ()=>$dbc5c4a080b2aff5$export$9960ae42b8fea6ed,
    InvalidAbiSignatureFormat: ()=>$dbc5c4a080b2aff5$export$339ba41ff2f37747,
    InvalidAddress: ()=>$dbc5c4a080b2aff5$export$953b602d2269ceba,
    InvalidBloom: ()=>$dbc5c4a080b2aff5$export$5c11d54afac0da76,
    InvalidBloomParams: ()=>$dbc5c4a080b2aff5$export$93084e9b5c99abb,
    InvalidCommandLineArguments: ()=>$dbc5c4a080b2aff5$export$f3d7a8c369aa633e,
    InvalidConfigurationFile: ()=>$dbc5c4a080b2aff5$export$3d7f730362736a82,
    InvalidConfigurationFilePath: ()=>$dbc5c4a080b2aff5$export$286f4d16148d835d,
    InvalidDataType: ()=>$dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0,
    InvalidHDKey: ()=>$dbc5c4a080b2aff5$export$b2ab323886c7b7a5,
    InvalidHDKeyMnemonic: ()=>$dbc5c4a080b2aff5$export$46042050702202eb,
    InvalidHTTPRequest: ()=>$dbc5c4a080b2aff5$export$1589e424e1d39768,
    InvalidKeystore: ()=>$dbc5c4a080b2aff5$export$8324255666e439a9,
    InvalidKeystoreParams: ()=>$dbc5c4a080b2aff5$export$b37f7abe5580d6c3,
    InvalidOperation: ()=>$dbc5c4a080b2aff5$export$8df2d8bae05b1dae,
    InvalidRLP: ()=>$dbc5c4a080b2aff5$export$d9c51ea6c57e8044,
    InvalidSecp256k1MessageHash: ()=>$dbc5c4a080b2aff5$export$6971695315864e63,
    InvalidSecp256k1PrivateKey: ()=>$dbc5c4a080b2aff5$export$b154d91e70ffbd5,
    InvalidSecp256k1Signature: ()=>$dbc5c4a080b2aff5$export$58f1681432c844df,
    InvalidTransactionField: ()=>$dbc5c4a080b2aff5$export$9da713663f1e9273,
    JSONRPCInternalError: ()=>$dbc5c4a080b2aff5$export$a98da31ae8d03b61,
    JSONRPCInvalidParams: ()=>$dbc5c4a080b2aff5$export$b8013e98c8c2c84,
    JSONRPCInvalidRequest: ()=>$dbc5c4a080b2aff5$export$ff4d5df15bdc06c6,
    JSONRPCMethodNotFound: ()=>$dbc5c4a080b2aff5$export$ab38de10560b28f0,
    JSONRPCParseError: ()=>$dbc5c4a080b2aff5$export$cd8a8240f0e977c1,
    JSONRPCProviderError: ()=>$dbc5c4a080b2aff5$export$307c99b394b00697,
    JSONRPCServerError: ()=>$dbc5c4a080b2aff5$export$e8226684352c5f77,
    NotDelegatedTransaction: ()=>$dbc5c4a080b2aff5$export$3417a5e4a3dd8321,
    PollExecution: ()=>$dbc5c4a080b2aff5$export$d6193ce6b2f49a35,
    UnavailableTransactionField: ()=>$dbc5c4a080b2aff5$export$9837e391a96a1f54,
    UnsupportedOperation: ()=>$dbc5c4a080b2aff5$export$ab5855187feed10d,
    VechainSDKError: ()=>$dbc5c4a080b2aff5$export$184d527870751d14,
    assertInnerError: ()=>$dbc5c4a080b2aff5$export$7717fdc3fc4d0a33,
    createErrorMessage: ()=>$dbc5c4a080b2aff5$export$a2b2d8b55704c18e,
    stringifyData: ()=>$dbc5c4a080b2aff5$export$d0f957c4a26c5e4e
});
// src/helpers/helpers.ts
var $dbc5c4a080b2aff5$export$d0f957c4a26c5e4e = (data)=>{
    const getCircularReplacer = ()=>{
        const seen = /* @__PURE__ */ new WeakSet();
        return (_key, value)=>{
            if (typeof value === "object" && value !== null && _key !== "") {
                if (seen.has(value)) return;
                seen.add(value);
            }
            return value;
        };
    };
    return JSON.stringify(data, getCircularReplacer(), 2);
};
function $dbc5c4a080b2aff5$export$7717fdc3fc4d0a33(error) {
    if (error instanceof Error) return error;
    return new Error(`Inner error is not an instance of Error. Object:
	${$dbc5c4a080b2aff5$export$d0f957c4a26c5e4e(error)}`);
}
function $dbc5c4a080b2aff5$export$a2b2d8b55704c18e(methodName, errorMessage, inputData, innerError) {
    return `Method '${methodName}' failed.
-Reason: '${errorMessage}'
-Parameters: 
	${$dbc5c4a080b2aff5$export$d0f957c4a26c5e4e(inputData)}${innerError?.message !== void 0 ? `
-Internal error: 
	${innerError.message}` : ""}`;
}
// src/available-errors/sdk-error.ts
var $dbc5c4a080b2aff5$export$184d527870751d14 = class extends Error {
    constructor(methodName, errorMessage, data, innerError){
        super($dbc5c4a080b2aff5$export$a2b2d8b55704c18e(methodName, errorMessage, data, innerError === void 0 ? void 0 : $dbc5c4a080b2aff5$export$7717fdc3fc4d0a33(innerError)));
        this.methodName = methodName;
        this.errorMessage = errorMessage;
        this.data = data;
        this.innerError = innerError;
    }
};
// src/available-errors/abi/abi.ts
var $dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3 = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
var $dbc5c4a080b2aff5$export$9960ae42b8fea6ed = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
var $dbc5c4a080b2aff5$export$339ba41ff2f37747 = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
// src/available-errors/address/address.ts
var $dbc5c4a080b2aff5$export$953b602d2269ceba = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
// src/available-errors/bloom/bloom.ts
var $dbc5c4a080b2aff5$export$5c11d54afac0da76 = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
var $dbc5c4a080b2aff5$export$93084e9b5c99abb = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
// src/available-errors/certificate/certificate.ts
var $dbc5c4a080b2aff5$export$1b27f6f6c44c7f6f = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
// src/available-errors/contract/contract.ts
var $dbc5c4a080b2aff5$export$da2c6ca4dce9010b = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
// src/available-errors/data/data.ts
var $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0 = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
var $dbc5c4a080b2aff5$export$ab5855187feed10d = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
// src/available-errors/hdkey/hdnode.ts
var $dbc5c4a080b2aff5$export$46042050702202eb = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
var $dbc5c4a080b2aff5$export$b2ab323886c7b7a5 = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
// src/available-errors/http/http.ts
var $dbc5c4a080b2aff5$export$1589e424e1d39768 = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
// src/available-errors/keystore/keystore.ts
var $dbc5c4a080b2aff5$export$8324255666e439a9 = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
var $dbc5c4a080b2aff5$export$b37f7abe5580d6c3 = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
// src/available-errors/poll/poll.ts
var $dbc5c4a080b2aff5$export$d6193ce6b2f49a35 = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
// src/available-errors/provider/provider.ts
var $dbc5c4a080b2aff5$export$307c99b394b00697 = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
    constructor(methodName, code, message, data, innerError){
        super(methodName, message, {
            code: code,
            message: message,
            data: data
        }, innerError);
        this.methodName = methodName;
        this.innerError = innerError;
    }
};
var $dbc5c4a080b2aff5$export$cd8a8240f0e977c1 = class extends $dbc5c4a080b2aff5$export$307c99b394b00697 {
};
var $dbc5c4a080b2aff5$export$ff4d5df15bdc06c6 = class extends $dbc5c4a080b2aff5$export$307c99b394b00697 {
};
var $dbc5c4a080b2aff5$export$ab38de10560b28f0 = class extends $dbc5c4a080b2aff5$export$307c99b394b00697 {
};
var $dbc5c4a080b2aff5$export$b8013e98c8c2c84 = class extends $dbc5c4a080b2aff5$export$307c99b394b00697 {
};
var $dbc5c4a080b2aff5$export$a98da31ae8d03b61 = class extends $dbc5c4a080b2aff5$export$307c99b394b00697 {
};
var $dbc5c4a080b2aff5$export$e8226684352c5f77 = class extends $dbc5c4a080b2aff5$export$307c99b394b00697 {
};
// src/available-errors/rlp/rlp.ts
var $dbc5c4a080b2aff5$export$d9c51ea6c57e8044 = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
// src/available-errors/rpc-proxy/rpc-proxy.ts
var $dbc5c4a080b2aff5$export$f3d7a8c369aa633e = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
var $dbc5c4a080b2aff5$export$286f4d16148d835d = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
var $dbc5c4a080b2aff5$export$3d7f730362736a82 = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
// src/available-errors/secp256k1/secp256k1.ts
var $dbc5c4a080b2aff5$export$b154d91e70ffbd5 = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
var $dbc5c4a080b2aff5$export$6971695315864e63 = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
var $dbc5c4a080b2aff5$export$58f1681432c844df = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
// src/available-errors/transaction/transaction.ts
var $dbc5c4a080b2aff5$export$9837e391a96a1f54 = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
var $dbc5c4a080b2aff5$export$9da713663f1e9273 = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
var $dbc5c4a080b2aff5$export$3417a5e4a3dd8321 = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
var $dbc5c4a080b2aff5$export$c4e383fb745c6d52 = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};
// src/available-errors/vcdm/vcdm.ts
var $dbc5c4a080b2aff5$export$8df2d8bae05b1dae = class extends $dbc5c4a080b2aff5$export$184d527870751d14 {
};



function $3b23739180d8154a$export$dc5d0ff4fc2fdee1(abiItem, { includeName: includeName = false } = {}) {
    if (abiItem.type !== "function" && abiItem.type !== "event" && abiItem.type !== "error") throw new (0, $20f14537aa29b220$export$81781a0fcfb9ed95)(abiItem.type);
    return `${abiItem.name}(${$3b23739180d8154a$export$849e499971de75b3(abiItem.inputs, {
        includeName: includeName
    })})`;
}
function $3b23739180d8154a$export$849e499971de75b3(params, { includeName: includeName = false } = {}) {
    if (!params) return "";
    return params.map((param)=>$3b23739180d8154a$var$formatAbiParam(param, {
            includeName: includeName
        })).join(includeName ? ", " : ",");
}
function $3b23739180d8154a$var$formatAbiParam(param, { includeName: includeName }) {
    if (param.type.startsWith("tuple")) return `(${$3b23739180d8154a$export$849e499971de75b3(param.components, {
        includeName: includeName
    })})${param.type.slice(5)}`;
    return param.type + (includeName && param.name ? ` ${param.name}` : "");
}


function $da701c4ca2469e62$export$8a9b6341a7c96bc(value, { strict: strict = true } = {}) {
    if (!value) return false;
    if (typeof value !== "string") return false;
    return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith("0x");
}


function $990136dfff8e7c95$export$346677f925de839c(value) {
    if ((0, $da701c4ca2469e62$export$8a9b6341a7c96bc)(value, {
        strict: false
    })) return Math.ceil((value.length - 2) / 2);
    return value.length;
}


const $6748856796f40ac2$export$83d89fbfd8236492 = "2.23.4";


let $d010b9492b892711$var$errorConfig = {
    getDocsUrl: ({ docsBaseUrl: docsBaseUrl, docsPath: docsPath = "", docsSlug: docsSlug })=>docsPath ? `${docsBaseUrl ?? "https://viem.sh"}${docsPath}${docsSlug ? `#${docsSlug}` : ""}` : undefined,
    version: `viem@${(0, $6748856796f40ac2$export$83d89fbfd8236492)}`
};
function $d010b9492b892711$export$4ac109df0c5244e9(config) {
    $d010b9492b892711$var$errorConfig = config;
}
class $d010b9492b892711$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        const details = (()=>{
            if (args.cause instanceof $d010b9492b892711$export$a490eb03cb7a0a5e) return args.cause.details;
            if (args.cause?.message) return args.cause.message;
            return args.details;
        })();
        const docsPath = (()=>{
            if (args.cause instanceof $d010b9492b892711$export$a490eb03cb7a0a5e) return args.cause.docsPath || args.docsPath;
            return args.docsPath;
        })();
        const docsUrl = $d010b9492b892711$var$errorConfig.getDocsUrl?.({
            ...args,
            docsPath: docsPath
        });
        const message = [
            shortMessage || "An error occurred.",
            "",
            ...args.metaMessages ? [
                ...args.metaMessages,
                ""
            ] : [],
            ...docsUrl ? [
                `Docs: ${docsUrl}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            ...$d010b9492b892711$var$errorConfig.version ? [
                `Version: ${$d010b9492b892711$var$errorConfig.version}`
            ] : []
        ].join("\n");
        super(message, args.cause ? {
            cause: args.cause
        } : undefined);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BaseError"
        });
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.name = args.name ?? this.name;
        this.shortMessage = shortMessage;
        this.version = (0, $6748856796f40ac2$export$83d89fbfd8236492);
    }
    walk(fn) {
        return $d010b9492b892711$var$walk(this, fn);
    }
}
function $d010b9492b892711$var$walk(err, fn) {
    if (fn?.(err)) return err;
    if (err && typeof err === "object" && "cause" in err && err.cause !== undefined) return $d010b9492b892711$var$walk(err.cause, fn);
    return fn ? null : err;
}


class $20f14537aa29b220$export$efa723f306cf6168 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ docsPath: docsPath }){
        super([
            "A constructor was not found on the ABI.",
            "Make sure you are using the correct ABI and that the constructor exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiConstructorNotFoundError"
        });
    }
}
class $20f14537aa29b220$export$4faec14323ef9c47 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ docsPath: docsPath }){
        super([
            "Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.",
            "Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiConstructorParamsNotFoundError"
        });
    }
}
class $20f14537aa29b220$export$68a7b570091cba69 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ data: data, size: size }){
        super([
            `Data size of ${size} bytes is invalid.`,
            "Size must be in increments of 32 bytes (size % 32 === 0)."
        ].join("\n"), {
            metaMessages: [
                `Data: ${data} (${size} bytes)`
            ],
            name: "AbiDecodingDataSizeInvalidError"
        });
    }
}
class $20f14537aa29b220$export$7a409e433c5f3a8c extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for given parameters.`
        ].join("\n"), {
            metaMessages: [
                `Params: (${(0, $3b23739180d8154a$export$849e499971de75b3)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ],
            name: "AbiDecodingDataSizeTooSmallError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $20f14537aa29b220$export$a063cde4013f1935 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor(){
        super('Cannot decode zero data ("0x") with ABI parameters.', {
            name: "AbiDecodingZeroDataError"
        });
    }
}
class $20f14537aa29b220$export$a851da9bf50b557 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength, type: type }){
        super([
            `ABI encoding array length mismatch for type ${type}.`,
            `Expected length: ${expectedLength}`,
            `Given length: ${givenLength}`
        ].join("\n"), {
            name: "AbiEncodingArrayLengthMismatchError"
        });
    }
}
class $20f14537aa29b220$export$19c281dc8e23a2ea extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ expectedSize: expectedSize, value: value }){
        super(`Size of bytes "${value}" (bytes${(0, $990136dfff8e7c95$export$346677f925de839c)(value)}) does not match expected size (bytes${expectedSize}).`, {
            name: "AbiEncodingBytesSizeMismatchError"
        });
    }
}
class $20f14537aa29b220$export$20737d495bb13c2d extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength }){
        super([
            "ABI encoding params/values length mismatch.",
            `Expected length (params): ${expectedLength}`,
            `Given length (values): ${givenLength}`
        ].join("\n"), {
            name: "AbiEncodingLengthMismatchError"
        });
    }
}
class $20f14537aa29b220$export$d47cf5ef47eda817 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor(errorName, { docsPath: docsPath }){
        super([
            `Arguments (\`args\`) were provided to "${errorName}", but "${errorName}" on the ABI does not contain any parameters (\`inputs\`).`,
            "Cannot encode error result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the inputs exist on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorInputsNotFoundError"
        });
    }
}
class $20f14537aa29b220$export$86b719574b683f04 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor(errorName, { docsPath: docsPath } = {}){
        super([
            `Error ${errorName ? `"${errorName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the error exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorNotFoundError"
        });
    }
}
class $20f14537aa29b220$export$8959cb729fefe1ea extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded error signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the error exists on it.",
            `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorSignatureNotFoundError"
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.signature = signature;
    }
}
class $20f14537aa29b220$export$f83210ce5f9b901f extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ docsPath: docsPath }){
        super("Cannot extract event signature from empty topics.", {
            docsPath: docsPath,
            name: "AbiEventSignatureEmptyTopicsError"
        });
    }
}
class $20f14537aa29b220$export$3b44baeac92e4d3a extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded event signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the event exists on it.",
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiEventSignatureNotFoundError"
        });
    }
}
class $20f14537aa29b220$export$c7be62baad13b157 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor(eventName, { docsPath: docsPath } = {}){
        super([
            `Event ${eventName ? `"${eventName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the event exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiEventNotFoundError"
        });
    }
}
class $20f14537aa29b220$export$c4faa308ea7f9b2 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor(functionName, { docsPath: docsPath } = {}){
        super([
            `Function ${functionName ? `"${functionName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionNotFoundError"
        });
    }
}
class $20f14537aa29b220$export$26f2edb605108b34 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor(functionName, { docsPath: docsPath }){
        super([
            `Function "${functionName}" does not contain any \`outputs\` on ABI.`,
            "Cannot decode function result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionOutputsNotFoundError"
        });
    }
}
class $20f14537aa29b220$export$14373147a0e60810 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded function signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the function exists on it.",
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionSignatureNotFoundError"
        });
    }
}
class $20f14537aa29b220$export$fdbba54ba15f2c2d extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor(x, y){
        super("Found ambiguous types in overloaded ABI items.", {
            metaMessages: [
                `\`${x.type}\` in \`${(0, $3b23739180d8154a$export$dc5d0ff4fc2fdee1)(x.abiItem)}\`, and`,
                `\`${y.type}\` in \`${(0, $3b23739180d8154a$export$dc5d0ff4fc2fdee1)(y.abiItem)}\``,
                "",
                "These types encode differently and cannot be distinguished at runtime.",
                "Remove one of the ambiguous items in the ABI."
            ],
            name: "AbiItemAmbiguityError"
        });
    }
}
class $20f14537aa29b220$export$a0eb884ede5c87eb extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ expectedSize: expectedSize, givenSize: givenSize }){
        super(`Expected bytes${expectedSize}, got bytes${givenSize}.`, {
            name: "BytesSizeMismatchError"
        });
    }
}
class $20f14537aa29b220$export$3978f86c08fc8c25 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ abiItem: abiItem, data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for non-indexed event parameters.`
        ].join("\n"), {
            metaMessages: [
                `Params: (${(0, $3b23739180d8154a$export$849e499971de75b3)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ],
            name: "DecodeLogDataMismatch"
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $20f14537aa29b220$export$6d7c6f419cf52377 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ abiItem: abiItem, param: param }){
        super([
            `Expected a topic for indexed event parameter${param.name ? ` "${param.name}"` : ""} on event "${(0, $3b23739180d8154a$export$dc5d0ff4fc2fdee1)(abiItem, {
                includeName: true
            })}".`
        ].join("\n"), {
            name: "DecodeLogTopicsMismatch"
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
    }
}
class $20f14537aa29b220$export$53ed98b886965f49 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid encoding type.`,
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath,
            name: "InvalidAbiEncodingType"
        });
    }
}
class $20f14537aa29b220$export$cf94ccff0ff97c65 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid decoding type.`,
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath,
            name: "InvalidAbiDecodingType"
        });
    }
}
class $20f14537aa29b220$export$710dd6d4f78cc47e extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor(value){
        super([
            `Value "${value}" is not a valid array.`
        ].join("\n"), {
            name: "InvalidArrayError"
        });
    }
}
class $20f14537aa29b220$export$81781a0fcfb9ed95 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor(type){
        super([
            `"${type}" is not a valid definition type.`,
            'Valid types: "function", "event", "error"'
        ].join("\n"), {
            name: "InvalidDefinitionTypeError"
        });
    }
}
class $20f14537aa29b220$export$a16541e2fe420ef1 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor(type){
        super(`Type "${type}" is not supported for packed encoding.`, {
            name: "UnsupportedPackedAbiType"
        });
    }
}



class $e607ba54ff7126d5$export$66c44d927ffead98 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ address: address }){
        super(`Address "${address}" is invalid.`, {
            metaMessages: [
                "- Address must be a hex value of 20 bytes (40 hex characters).",
                "- Address must match its checksum counterpart."
            ],
            name: "InvalidAddressError"
        });
    }
}





class $35aa9bb753fdb2e9$export$cfcd41bba8b36dbd extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ offset: offset, position: position, size: size }){
        super(`Slice ${position === "start" ? "starting" : "ending"} at offset "${offset}" is out-of-bounds (size: ${size}).`, {
            name: "SliceOffsetOutOfBoundsError"
        });
    }
}
class $35aa9bb753fdb2e9$export$70445dc308a7f3d5 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (${size}) exceeds padding size (${targetSize}).`, {
            name: "SizeExceedsPaddingSizeError"
        });
    }
}
class $35aa9bb753fdb2e9$export$8a5469becf223114 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} is expected to be ${targetSize} ${type} long, but is ${size} ${type} long.`, {
            name: "InvalidBytesLengthError"
        });
    }
}


function $001cab9b3ba1fae8$export$5d04458e2a6c373e(hexOrBytes, { dir: dir, size: size = 32 } = {}) {
    if (typeof hexOrBytes === "string") return $001cab9b3ba1fae8$export$1bcd51c0fce8ee55(hexOrBytes, {
        dir: dir,
        size: size
    });
    return $001cab9b3ba1fae8$export$4c6b868113605df3(hexOrBytes, {
        dir: dir,
        size: size
    });
}
function $001cab9b3ba1fae8$export$1bcd51c0fce8ee55(hex_, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return hex_;
    const hex = hex_.replace("0x", "");
    if (hex.length > size * 2) throw new (0, $35aa9bb753fdb2e9$export$70445dc308a7f3d5)({
        size: Math.ceil(hex.length / 2),
        targetSize: size,
        type: "hex"
    });
    return `0x${hex[dir === "right" ? "padEnd" : "padStart"](size * 2, "0")}`;
}
function $001cab9b3ba1fae8$export$4c6b868113605df3(bytes, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return bytes;
    if (bytes.length > size) throw new (0, $35aa9bb753fdb2e9$export$70445dc308a7f3d5)({
        size: bytes.length,
        targetSize: size,
        type: "bytes"
    });
    const paddedBytes = new Uint8Array(size);
    for(let i = 0; i < size; i++){
        const padEnd = dir === "right";
        paddedBytes[padEnd ? i : size - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
    }
    return paddedBytes;
}



class $0c5b41f05f61c54b$export$47d164a8071229a9 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ max: max, min: min, signed: signed, size: size, value: value }){
        super(`Number "${value}" is not in safe ${size ? `${size * 8}-bit ${signed ? "signed" : "unsigned"} ` : ""}integer range ${max ? `(${min} to ${max})` : `(above ${min})`}`, {
            name: "IntegerOutOfRangeError"
        });
    }
}
class $0c5b41f05f61c54b$export$52fc62e5266c8838 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor(bytes){
        super(`Bytes value "${bytes}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`, {
            name: "InvalidBytesBooleanError"
        });
    }
}
class $0c5b41f05f61c54b$export$f574ac54e35514c extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor(hex){
        super(`Hex value "${hex}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`, {
            name: "InvalidHexBooleanError"
        });
    }
}
class $0c5b41f05f61c54b$export$ef05eafd11dd4a83 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor(value){
        super(`Hex value "${value}" is an odd length (${value.length}). It must be an even length.`, {
            name: "InvalidHexValueError"
        });
    }
}
class $0c5b41f05f61c54b$export$beb44ed4f8747d0e extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ givenSize: givenSize, maxSize: maxSize }){
        super(`Size cannot exceed ${maxSize} bytes. Given size: ${givenSize} bytes.`, {
            name: "SizeOverflowError"
        });
    }
}



function $1e192641aae89f01$export$87c2784dc9fc4ab(hexOrBytes, { dir: dir = "left" } = {}) {
    let data = typeof hexOrBytes === "string" ? hexOrBytes.replace("0x", "") : hexOrBytes;
    let sliceLength = 0;
    for(let i = 0; i < data.length - 1; i++){
        if (data[dir === "left" ? i : data.length - i - 1].toString() === "0") sliceLength++;
        else break;
    }
    data = dir === "left" ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    if (typeof hexOrBytes === "string") {
        if (data.length === 1 && dir === "right") data = `${data}0`;
        return `0x${data.length % 2 === 1 ? `0${data}` : data}`;
    }
    return data;
}



function $4f654bfc0c73014b$export$2af489edb7fa35fe(hexOrBytes, { size: size }) {
    if ((0, $990136dfff8e7c95$export$346677f925de839c)(hexOrBytes) > size) throw new (0, $0c5b41f05f61c54b$export$beb44ed4f8747d0e)({
        givenSize: (0, $990136dfff8e7c95$export$346677f925de839c)(hexOrBytes),
        maxSize: size
    });
}
function $4f654bfc0c73014b$export$1a8ceedbd5845648(hex, toOrOpts) {
    const opts = typeof toOrOpts === "string" ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === "number") return $4f654bfc0c73014b$export$d57f2bacc26b4249(hex, opts);
    if (to === "bigint") return $4f654bfc0c73014b$export$92a44656ec81b584(hex, opts);
    if (to === "string") return $4f654bfc0c73014b$export$f4bc7e46f3eb3ac3(hex, opts);
    if (to === "boolean") return $4f654bfc0c73014b$export$bde1d77e6fe6c41e(hex, opts);
    return (0, $6c2dc9783e770609$export$31c96b9df38bc8d4)(hex, opts);
}
function $4f654bfc0c73014b$export$92a44656ec81b584(hex, opts = {}) {
    const { signed: signed } = opts;
    if (opts.size) $4f654bfc0c73014b$export$2af489edb7fa35fe(hex, {
        size: opts.size
    });
    const value = BigInt(hex);
    if (!signed) return value;
    const size = (hex.length - 2) / 2;
    const max = (1n << BigInt(size) * 8n - 1n) - 1n;
    if (value <= max) return value;
    return value - BigInt(`0x${"f".padStart(size * 2, "f")}`) - 1n;
}
function $4f654bfc0c73014b$export$bde1d77e6fe6c41e(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        $4f654bfc0c73014b$export$2af489edb7fa35fe(hex, {
            size: opts.size
        });
        hex = (0, $1e192641aae89f01$export$87c2784dc9fc4ab)(hex);
    }
    if ((0, $1e192641aae89f01$export$87c2784dc9fc4ab)(hex) === "0x00") return false;
    if ((0, $1e192641aae89f01$export$87c2784dc9fc4ab)(hex) === "0x01") return true;
    throw new (0, $0c5b41f05f61c54b$export$f574ac54e35514c)(hex);
}
function $4f654bfc0c73014b$export$d57f2bacc26b4249(hex, opts = {}) {
    return Number($4f654bfc0c73014b$export$92a44656ec81b584(hex, opts));
}
function $4f654bfc0c73014b$export$f4bc7e46f3eb3ac3(hex, opts = {}) {
    let bytes = (0, $6c2dc9783e770609$export$31c96b9df38bc8d4)(hex);
    if (opts.size) {
        $4f654bfc0c73014b$export$2af489edb7fa35fe(bytes, {
            size: opts.size
        });
        bytes = (0, $1e192641aae89f01$export$87c2784dc9fc4ab)(bytes, {
            dir: "right"
        });
    }
    return new TextDecoder().decode(bytes);
}





const $831332fc79f505bb$var$hexes = /*#__PURE__*/ Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, "0"));
function $831332fc79f505bb$export$7ea66e3774a60b67(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $831332fc79f505bb$export$4e87185b7ecfeec4(value, opts);
    if (typeof value === "string") return $831332fc79f505bb$export$551c48dea6f88e6d(value, opts);
    if (typeof value === "boolean") return $831332fc79f505bb$export$b5c95dec4f62ef7a(value, opts);
    return $831332fc79f505bb$export$58b867e287a802c8(value, opts);
}
function $831332fc79f505bb$export$b5c95dec4f62ef7a(value, opts = {}) {
    const hex = `0x${Number(value)}`;
    if (typeof opts.size === "number") {
        (0, $4f654bfc0c73014b$export$2af489edb7fa35fe)(hex, {
            size: opts.size
        });
        return (0, $001cab9b3ba1fae8$export$5d04458e2a6c373e)(hex, {
            size: opts.size
        });
    }
    return hex;
}
function $831332fc79f505bb$export$58b867e287a802c8(value, opts = {}) {
    let string = "";
    for(let i = 0; i < value.length; i++)string += $831332fc79f505bb$var$hexes[value[i]];
    const hex = `0x${string}`;
    if (typeof opts.size === "number") {
        (0, $4f654bfc0c73014b$export$2af489edb7fa35fe)(hex, {
            size: opts.size
        });
        return (0, $001cab9b3ba1fae8$export$5d04458e2a6c373e)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    return hex;
}
function $831332fc79f505bb$export$4e87185b7ecfeec4(value_, opts = {}) {
    const { signed: signed, size: size } = opts;
    const value = BigInt(value_);
    let maxValue;
    if (size) {
        if (signed) maxValue = (1n << BigInt(size) * 8n - 1n) - 1n;
        else maxValue = 2n ** (BigInt(size) * 8n) - 1n;
    } else if (typeof value_ === "number") maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    const minValue = typeof maxValue === "bigint" && signed ? -maxValue - 1n : 0;
    if (maxValue && value > maxValue || value < minValue) {
        const suffix = typeof value_ === "bigint" ? "n" : "";
        throw new (0, $0c5b41f05f61c54b$export$47d164a8071229a9)({
            max: maxValue ? `${maxValue}${suffix}` : undefined,
            min: `${minValue}${suffix}`,
            signed: signed,
            size: size,
            value: `${value_}${suffix}`
        });
    }
    const hex = `0x${(signed && value < 0 ? (1n << BigInt(size * 8)) + BigInt(value) : value).toString(16)}`;
    if (size) return (0, $001cab9b3ba1fae8$export$5d04458e2a6c373e)(hex, {
        size: size
    });
    return hex;
}
const $831332fc79f505bb$var$encoder = /*#__PURE__*/ new TextEncoder();
function $831332fc79f505bb$export$551c48dea6f88e6d(value_, opts = {}) {
    const value = $831332fc79f505bb$var$encoder.encode(value_);
    return $831332fc79f505bb$export$58b867e287a802c8(value, opts);
}


const $6c2dc9783e770609$var$encoder = /*#__PURE__*/ new TextEncoder();
function $6c2dc9783e770609$export$30a71edf0753ed6b(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $6c2dc9783e770609$export$49ad9be85c347998(value, opts);
    if (typeof value === "boolean") return $6c2dc9783e770609$export$771517697a68241(value, opts);
    if ((0, $da701c4ca2469e62$export$8a9b6341a7c96bc)(value)) return $6c2dc9783e770609$export$31c96b9df38bc8d4(value, opts);
    return $6c2dc9783e770609$export$c8dd6bc66a63753c(value, opts);
}
function $6c2dc9783e770609$export$771517697a68241(value, opts = {}) {
    const bytes = new Uint8Array(1);
    bytes[0] = Number(value);
    if (typeof opts.size === "number") {
        (0, $4f654bfc0c73014b$export$2af489edb7fa35fe)(bytes, {
            size: opts.size
        });
        return (0, $001cab9b3ba1fae8$export$5d04458e2a6c373e)(bytes, {
            size: opts.size
        });
    }
    return bytes;
}
// We use very optimized technique to convert hex string to byte array
const $6c2dc9783e770609$var$charCodeMap = {
    zero: 48,
    nine: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $6c2dc9783e770609$var$charCodeToBase16(char) {
    if (char >= $6c2dc9783e770609$var$charCodeMap.zero && char <= $6c2dc9783e770609$var$charCodeMap.nine) return char - $6c2dc9783e770609$var$charCodeMap.zero;
    if (char >= $6c2dc9783e770609$var$charCodeMap.A && char <= $6c2dc9783e770609$var$charCodeMap.F) return char - ($6c2dc9783e770609$var$charCodeMap.A - 10);
    if (char >= $6c2dc9783e770609$var$charCodeMap.a && char <= $6c2dc9783e770609$var$charCodeMap.f) return char - ($6c2dc9783e770609$var$charCodeMap.a - 10);
    return undefined;
}
function $6c2dc9783e770609$export$31c96b9df38bc8d4(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        (0, $4f654bfc0c73014b$export$2af489edb7fa35fe)(hex, {
            size: opts.size
        });
        hex = (0, $001cab9b3ba1fae8$export$5d04458e2a6c373e)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    let hexString = hex.slice(2);
    if (hexString.length % 2) hexString = `0${hexString}`;
    const length = hexString.length / 2;
    const bytes = new Uint8Array(length);
    for(let index = 0, j = 0; index < length; index++){
        const nibbleLeft = $6c2dc9783e770609$var$charCodeToBase16(hexString.charCodeAt(j++));
        const nibbleRight = $6c2dc9783e770609$var$charCodeToBase16(hexString.charCodeAt(j++));
        if (nibbleLeft === undefined || nibbleRight === undefined) throw new (0, $d010b9492b892711$export$a490eb03cb7a0a5e)(`Invalid byte sequence ("${hexString[j - 2]}${hexString[j - 1]}" in "${hexString}").`);
        bytes[index] = nibbleLeft * 16 + nibbleRight;
    }
    return bytes;
}
function $6c2dc9783e770609$export$49ad9be85c347998(value, opts) {
    const hex = (0, $831332fc79f505bb$export$4e87185b7ecfeec4)(value, opts);
    return $6c2dc9783e770609$export$31c96b9df38bc8d4(hex);
}
function $6c2dc9783e770609$export$c8dd6bc66a63753c(value, opts = {}) {
    const bytes = $6c2dc9783e770609$var$encoder.encode(value);
    if (typeof opts.size === "number") {
        (0, $4f654bfc0c73014b$export$2af489edb7fa35fe)(bytes, {
            size: opts.size
        });
        return (0, $001cab9b3ba1fae8$export$5d04458e2a6c373e)(bytes, {
            dir: "right",
            size: opts.size
        });
    }
    return bytes;
}


var $08748f983f07956b$exports = {};
"use strict";
Object.defineProperty($08748f983f07956b$exports, "__esModule", {
    value: true
});
$08748f983f07956b$exports.shake256 = $08748f983f07956b$exports.shake128 = $08748f983f07956b$exports.keccak_512 = $08748f983f07956b$exports.keccak_384 = $08748f983f07956b$exports.keccak_256 = $08748f983f07956b$exports.keccak_224 = $08748f983f07956b$exports.sha3_512 = $08748f983f07956b$exports.sha3_384 = $08748f983f07956b$exports.sha3_256 = $08748f983f07956b$exports.sha3_224 = $08748f983f07956b$exports.Keccak = void 0;
$08748f983f07956b$exports.keccakP = $08748f983f07956b$var$keccakP;
var $a0ae23f5901291b4$exports = {};
"use strict";
/**
 * Internal assertion helpers.
 * @module
 */ Object.defineProperty($a0ae23f5901291b4$exports, "__esModule", {
    value: true
});
$a0ae23f5901291b4$exports.anumber = $a0ae23f5901291b4$var$anumber;
$a0ae23f5901291b4$exports.abytes = $a0ae23f5901291b4$var$abytes;
$a0ae23f5901291b4$exports.ahash = $a0ae23f5901291b4$var$ahash;
$a0ae23f5901291b4$exports.aexists = $a0ae23f5901291b4$var$aexists;
$a0ae23f5901291b4$exports.aoutput = $a0ae23f5901291b4$var$aoutput;
/** Asserts something is positive integer. */ function $a0ae23f5901291b4$var$anumber(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error("positive integer expected, got " + n);
}
/** Is number an Uint8Array? Copied from utils for perf. */ function $a0ae23f5901291b4$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
/** Asserts something is Uint8Array. */ function $a0ae23f5901291b4$var$abytes(b, ...lengths) {
    if (!$a0ae23f5901291b4$var$isBytes(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error("Uint8Array expected of length " + lengths + ", got length=" + b.length);
}
/** Asserts something is hash */ function $a0ae23f5901291b4$var$ahash(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $a0ae23f5901291b4$var$anumber(h.outputLen);
    $a0ae23f5901291b4$var$anumber(h.blockLen);
}
/** Asserts a hash instance has not been destroyed / finished */ function $a0ae23f5901291b4$var$aexists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
/** Asserts output is properly-sized byte array */ function $a0ae23f5901291b4$var$aoutput(out, instance) {
    $a0ae23f5901291b4$var$abytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error("digestInto() expects output buffer of length at least " + min);
}


var $aa71b30d36adb919$exports = {};
"use strict";
Object.defineProperty($aa71b30d36adb919$exports, "__esModule", {
    value: true
});
$aa71b30d36adb919$exports.add5L = $aa71b30d36adb919$exports.add5H = $aa71b30d36adb919$exports.add4H = $aa71b30d36adb919$exports.add4L = $aa71b30d36adb919$exports.add3H = $aa71b30d36adb919$exports.add3L = $aa71b30d36adb919$exports.rotlBL = $aa71b30d36adb919$exports.rotlBH = $aa71b30d36adb919$exports.rotlSL = $aa71b30d36adb919$exports.rotlSH = $aa71b30d36adb919$exports.rotr32L = $aa71b30d36adb919$exports.rotr32H = $aa71b30d36adb919$exports.rotrBL = $aa71b30d36adb919$exports.rotrBH = $aa71b30d36adb919$exports.rotrSL = $aa71b30d36adb919$exports.rotrSH = $aa71b30d36adb919$exports.shrSL = $aa71b30d36adb919$exports.shrSH = $aa71b30d36adb919$exports.toBig = void 0;
$aa71b30d36adb919$exports.fromBig = $aa71b30d36adb919$var$fromBig;
$aa71b30d36adb919$exports.split = $aa71b30d36adb919$var$split;
$aa71b30d36adb919$exports.add = $aa71b30d36adb919$var$add;
/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const $aa71b30d36adb919$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $aa71b30d36adb919$var$_32n = /* @__PURE__ */ BigInt(32);
function $aa71b30d36adb919$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $aa71b30d36adb919$var$U32_MASK64),
        l: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64)
    };
    return {
        h: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64) | 0,
        l: Number(n & $aa71b30d36adb919$var$U32_MASK64) | 0
    };
}
function $aa71b30d36adb919$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $aa71b30d36adb919$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $aa71b30d36adb919$var$toBig = (h, l)=>BigInt(h >>> 0) << $aa71b30d36adb919$var$_32n | BigInt(l >>> 0);
$aa71b30d36adb919$exports.toBig = $aa71b30d36adb919$var$toBig;
// for Shift in [0, 32)
const $aa71b30d36adb919$var$shrSH = (h, _l, s)=>h >>> s;
$aa71b30d36adb919$exports.shrSH = $aa71b30d36adb919$var$shrSH;
const $aa71b30d36adb919$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
$aa71b30d36adb919$exports.shrSL = $aa71b30d36adb919$var$shrSL;
// Right rotate for Shift in [1, 32)
const $aa71b30d36adb919$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
$aa71b30d36adb919$exports.rotrSH = $aa71b30d36adb919$var$rotrSH;
const $aa71b30d36adb919$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
$aa71b30d36adb919$exports.rotrSL = $aa71b30d36adb919$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
$aa71b30d36adb919$exports.rotrBH = $aa71b30d36adb919$var$rotrBH;
const $aa71b30d36adb919$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
$aa71b30d36adb919$exports.rotrBL = $aa71b30d36adb919$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $aa71b30d36adb919$var$rotr32H = (_h, l)=>l;
$aa71b30d36adb919$exports.rotr32H = $aa71b30d36adb919$var$rotr32H;
const $aa71b30d36adb919$var$rotr32L = (h, _l)=>h;
$aa71b30d36adb919$exports.rotr32L = $aa71b30d36adb919$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $aa71b30d36adb919$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
$aa71b30d36adb919$exports.rotlSH = $aa71b30d36adb919$var$rotlSH;
const $aa71b30d36adb919$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
$aa71b30d36adb919$exports.rotlSL = $aa71b30d36adb919$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
$aa71b30d36adb919$exports.rotlBH = $aa71b30d36adb919$var$rotlBH;
const $aa71b30d36adb919$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
$aa71b30d36adb919$exports.rotlBL = $aa71b30d36adb919$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $aa71b30d36adb919$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $aa71b30d36adb919$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
$aa71b30d36adb919$exports.add3L = $aa71b30d36adb919$var$add3L;
const $aa71b30d36adb919$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
$aa71b30d36adb919$exports.add3H = $aa71b30d36adb919$var$add3H;
const $aa71b30d36adb919$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
$aa71b30d36adb919$exports.add4L = $aa71b30d36adb919$var$add4L;
const $aa71b30d36adb919$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
$aa71b30d36adb919$exports.add4H = $aa71b30d36adb919$var$add4H;
const $aa71b30d36adb919$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
$aa71b30d36adb919$exports.add5L = $aa71b30d36adb919$var$add5L;
const $aa71b30d36adb919$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
$aa71b30d36adb919$exports.add5H = $aa71b30d36adb919$var$add5H;
// prettier-ignore
const $aa71b30d36adb919$var$u64 = {
    fromBig: $aa71b30d36adb919$var$fromBig,
    split: $aa71b30d36adb919$var$split,
    toBig: $aa71b30d36adb919$var$toBig,
    shrSH: $aa71b30d36adb919$var$shrSH,
    shrSL: $aa71b30d36adb919$var$shrSL,
    rotrSH: $aa71b30d36adb919$var$rotrSH,
    rotrSL: $aa71b30d36adb919$var$rotrSL,
    rotrBH: $aa71b30d36adb919$var$rotrBH,
    rotrBL: $aa71b30d36adb919$var$rotrBL,
    rotr32H: $aa71b30d36adb919$var$rotr32H,
    rotr32L: $aa71b30d36adb919$var$rotr32L,
    rotlSH: $aa71b30d36adb919$var$rotlSH,
    rotlSL: $aa71b30d36adb919$var$rotlSL,
    rotlBH: $aa71b30d36adb919$var$rotlBH,
    rotlBL: $aa71b30d36adb919$var$rotlBL,
    add: $aa71b30d36adb919$var$add,
    add3L: $aa71b30d36adb919$var$add3L,
    add3H: $aa71b30d36adb919$var$add3H,
    add4L: $aa71b30d36adb919$var$add4L,
    add4H: $aa71b30d36adb919$var$add4H,
    add5H: $aa71b30d36adb919$var$add5H,
    add5L: $aa71b30d36adb919$var$add5L
};
$aa71b30d36adb919$exports.default = $aa71b30d36adb919$var$u64;


var $29ee4d3171d9809b$exports = {};
"use strict";
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty($29ee4d3171d9809b$exports, "__esModule", {
    value: true
});
$29ee4d3171d9809b$exports.Hash = $29ee4d3171d9809b$exports.nextTick = $29ee4d3171d9809b$exports.byteSwapIfBE = $29ee4d3171d9809b$exports.isLE = void 0;
$29ee4d3171d9809b$exports.isBytes = $29ee4d3171d9809b$var$isBytes;
$29ee4d3171d9809b$exports.u8 = $29ee4d3171d9809b$var$u8;
$29ee4d3171d9809b$exports.u32 = $29ee4d3171d9809b$var$u32;
$29ee4d3171d9809b$exports.createView = $29ee4d3171d9809b$var$createView;
$29ee4d3171d9809b$exports.rotr = $29ee4d3171d9809b$var$rotr;
$29ee4d3171d9809b$exports.rotl = $29ee4d3171d9809b$var$rotl;
$29ee4d3171d9809b$exports.byteSwap = $29ee4d3171d9809b$var$byteSwap;
$29ee4d3171d9809b$exports.byteSwap32 = $29ee4d3171d9809b$var$byteSwap32;
$29ee4d3171d9809b$exports.bytesToHex = $29ee4d3171d9809b$var$bytesToHex;
$29ee4d3171d9809b$exports.hexToBytes = $29ee4d3171d9809b$var$hexToBytes;
$29ee4d3171d9809b$exports.asyncLoop = $29ee4d3171d9809b$var$asyncLoop;
$29ee4d3171d9809b$exports.utf8ToBytes = $29ee4d3171d9809b$var$utf8ToBytes;
$29ee4d3171d9809b$exports.toBytes = $29ee4d3171d9809b$var$toBytes;
$29ee4d3171d9809b$exports.concatBytes = $29ee4d3171d9809b$var$concatBytes;
$29ee4d3171d9809b$exports.checkOpts = $29ee4d3171d9809b$var$checkOpts;
$29ee4d3171d9809b$exports.wrapConstructor = $29ee4d3171d9809b$var$wrapConstructor;
$29ee4d3171d9809b$exports.wrapConstructorWithOpts = $29ee4d3171d9809b$var$wrapConstructorWithOpts;
$29ee4d3171d9809b$exports.wrapXOFConstructorWithOpts = $29ee4d3171d9809b$var$wrapXOFConstructorWithOpts;
$29ee4d3171d9809b$exports.randomBytes = $29ee4d3171d9809b$var$randomBytes;
var $a20ad0ecd1be3cb3$exports = {};
"use strict";
Object.defineProperty($a20ad0ecd1be3cb3$exports, "__esModule", {
    value: true
});
$a20ad0ecd1be3cb3$exports.crypto = void 0;
$a20ad0ecd1be3cb3$exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;



// export { isBytes } from './_assert.js';
// We can't reuse isBytes from _assert, because somehow this causes huge perf issues
function $29ee4d3171d9809b$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
// Cast array to different type
function $29ee4d3171d9809b$var$u8(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $29ee4d3171d9809b$var$u32(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
// Cast array to view
function $29ee4d3171d9809b$var$createView(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** The rotate right (circular right shift) operation for uint32 */ function $29ee4d3171d9809b$var$rotr(word, shift) {
    return word << 32 - shift | word >>> shift;
}
/** The rotate left (circular left shift) operation for uint32 */ function $29ee4d3171d9809b$var$rotl(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
/** Is current platform little-endian? Most are. Big-Endian platform: IBM */ $29ee4d3171d9809b$exports.isLE = (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
// The byte swap operation for uint32
function $29ee4d3171d9809b$var$byteSwap(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
/** Conditionally byte swap if on a big-endian platform */ $29ee4d3171d9809b$exports.byteSwapIfBE = $29ee4d3171d9809b$exports.isLE ? (n)=>n : (n)=>$29ee4d3171d9809b$var$byteSwap(n);
/** In place byte swap for Uint32Array */ function $29ee4d3171d9809b$var$byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $29ee4d3171d9809b$var$byteSwap(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $29ee4d3171d9809b$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * Convert byte array to hex string.
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $29ee4d3171d9809b$var$bytesToHex(bytes) {
    (0, $a0ae23f5901291b4$exports.abytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $29ee4d3171d9809b$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $29ee4d3171d9809b$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $29ee4d3171d9809b$var$asciiToBase16(ch) {
    if (ch >= $29ee4d3171d9809b$var$asciis._0 && ch <= $29ee4d3171d9809b$var$asciis._9) return ch - $29ee4d3171d9809b$var$asciis._0; // '2' => 50-48
    if (ch >= $29ee4d3171d9809b$var$asciis.A && ch <= $29ee4d3171d9809b$var$asciis.F) return ch - ($29ee4d3171d9809b$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $29ee4d3171d9809b$var$asciis.a && ch <= $29ee4d3171d9809b$var$asciis.f) return ch - ($29ee4d3171d9809b$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * Convert hex string to byte array.
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $29ee4d3171d9809b$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $29ee4d3171d9809b$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $29ee4d3171d9809b$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
/**
 * There is no setImmediate in browser and setTimeout is slow.
 * Call of async fn will return Promise, which will be fullfiled only on
 * next scheduler queue processing step and this is exactly what we need.
 */ const $29ee4d3171d9809b$var$nextTick = async ()=>{};
$29ee4d3171d9809b$exports.nextTick = $29ee4d3171d9809b$var$nextTick;
/** Returns control to thread each 'tick' ms to avoid blocking. */ async function $29ee4d3171d9809b$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, $29ee4d3171d9809b$exports.nextTick)();
        ts += diff;
    }
}
/**
 * Convert JS string to byte array.
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $29ee4d3171d9809b$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error("utf8ToBytes expected string, got " + typeof str);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $29ee4d3171d9809b$var$toBytes(data) {
    if (typeof data === "string") data = $29ee4d3171d9809b$var$utf8ToBytes(data);
    (0, $a0ae23f5901291b4$exports.abytes)(data);
    return data;
}
/**
 * Copies several Uint8Arrays into one.
 */ function $29ee4d3171d9809b$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $a0ae23f5901291b4$exports.abytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
/** For runtime check if class implements interface */ class $29ee4d3171d9809b$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
$29ee4d3171d9809b$exports.Hash = $29ee4d3171d9809b$var$Hash;
function $29ee4d3171d9809b$var$checkOpts(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
/** Wraps hash function, creating an interface on top of it */ function $29ee4d3171d9809b$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $29ee4d3171d9809b$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $29ee4d3171d9809b$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
/** Cryptographically secure PRNG. Uses internal OS-level `crypto.getRandomValues`. */ function $29ee4d3171d9809b$var$randomBytes(bytesLength = 32) {
    if ($a20ad0ecd1be3cb3$exports.crypto && typeof $a20ad0ecd1be3cb3$exports.crypto.getRandomValues === "function") return $a20ad0ecd1be3cb3$exports.crypto.getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ($a20ad0ecd1be3cb3$exports.crypto && typeof $a20ad0ecd1be3cb3$exports.crypto.randomBytes === "function") return $a20ad0ecd1be3cb3$exports.crypto.randomBytes(bytesLength);
    throw new Error("crypto.getRandomValues must be defined");
}


// Various per round constants calculations
const $08748f983f07956b$var$SHA3_PI = [];
const $08748f983f07956b$var$SHA3_ROTL = [];
const $08748f983f07956b$var$_SHA3_IOTA = [];
const $08748f983f07956b$var$_0n = /* @__PURE__ */ BigInt(0);
const $08748f983f07956b$var$_1n = /* @__PURE__ */ BigInt(1);
const $08748f983f07956b$var$_2n = /* @__PURE__ */ BigInt(2);
const $08748f983f07956b$var$_7n = /* @__PURE__ */ BigInt(7);
const $08748f983f07956b$var$_256n = /* @__PURE__ */ BigInt(256);
const $08748f983f07956b$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $08748f983f07956b$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $08748f983f07956b$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $08748f983f07956b$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $08748f983f07956b$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $08748f983f07956b$var$_1n ^ (R >> $08748f983f07956b$var$_7n) * $08748f983f07956b$var$_0x71n) % $08748f983f07956b$var$_256n;
        if (R & $08748f983f07956b$var$_2n) t ^= $08748f983f07956b$var$_1n << ($08748f983f07956b$var$_1n << /* @__PURE__ */ BigInt(j)) - $08748f983f07956b$var$_1n;
    }
    $08748f983f07956b$var$_SHA3_IOTA.push(t);
}
const [$08748f983f07956b$var$SHA3_IOTA_H, $08748f983f07956b$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $aa71b30d36adb919$exports.split)($08748f983f07956b$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $08748f983f07956b$var$rotlH = (h, l, s)=>s > 32 ? (0, $aa71b30d36adb919$exports.rotlBH)(h, l, s) : (0, $aa71b30d36adb919$exports.rotlSH)(h, l, s);
const $08748f983f07956b$var$rotlL = (h, l, s)=>s > 32 ? (0, $aa71b30d36adb919$exports.rotlBL)(h, l, s) : (0, $aa71b30d36adb919$exports.rotlSL)(h, l, s);
/** `keccakf1600` internal function, additionally allows to adjust round count. */ function $08748f983f07956b$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $08748f983f07956b$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $08748f983f07956b$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $08748f983f07956b$var$SHA3_ROTL[t];
            const Th = $08748f983f07956b$var$rotlH(curH, curL, shift);
            const Tl = $08748f983f07956b$var$rotlL(curH, curL, shift);
            const PI = $08748f983f07956b$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $08748f983f07956b$var$SHA3_IOTA_H[round];
        s[1] ^= $08748f983f07956b$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
/** Keccak sponge function. */ class $08748f983f07956b$var$Keccak extends $29ee4d3171d9809b$exports.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $a0ae23f5901291b4$exports.anumber)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        // 0 < blockLen < 200
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $29ee4d3171d9809b$exports.u32)(this.state);
    }
    keccak() {
        if (!$29ee4d3171d9809b$exports.isLE) (0, $29ee4d3171d9809b$exports.byteSwap32)(this.state32);
        $08748f983f07956b$var$keccakP(this.state32, this.rounds);
        if (!$29ee4d3171d9809b$exports.isLE) (0, $29ee4d3171d9809b$exports.byteSwap32)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $a0ae23f5901291b4$exports.aexists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $29ee4d3171d9809b$exports.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $a0ae23f5901291b4$exports.aexists)(this, false);
        (0, $a0ae23f5901291b4$exports.abytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $a0ae23f5901291b4$exports.anumber)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $a0ae23f5901291b4$exports.aoutput)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $08748f983f07956b$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
$08748f983f07956b$exports.Keccak = $08748f983f07956b$var$Keccak;
const $08748f983f07956b$var$gen = (suffix, blockLen, outputLen)=>(0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $08748f983f07956b$var$Keccak(blockLen, suffix, outputLen));
/** SHA3-224 hash function. */ $08748f983f07956b$exports.sha3_224 = $08748f983f07956b$var$gen(0x06, 144, 28);
/** SHA3-256 hash function. Different from keccak-256. */ $08748f983f07956b$exports.sha3_256 = $08748f983f07956b$var$gen(0x06, 136, 32);
/** SHA3-384 hash function. */ $08748f983f07956b$exports.sha3_384 = $08748f983f07956b$var$gen(0x06, 104, 48);
/** SHA3-512 hash function. */ $08748f983f07956b$exports.sha3_512 = $08748f983f07956b$var$gen(0x06, 72, 64);
/** keccak-224 hash function. */ $08748f983f07956b$exports.keccak_224 = $08748f983f07956b$var$gen(0x01, 144, 28);
/** keccak-256 hash function. Different from SHA3-256. */ $08748f983f07956b$exports.keccak_256 = $08748f983f07956b$var$gen(0x01, 136, 32);
/** keccak-384 hash function. */ $08748f983f07956b$exports.keccak_384 = $08748f983f07956b$var$gen(0x01, 104, 48);
/** keccak-512 hash function. */ $08748f983f07956b$exports.keccak_512 = $08748f983f07956b$var$gen(0x01, 72, 64);
const $08748f983f07956b$var$genShake = (suffix, blockLen, outputLen)=>(0, $29ee4d3171d9809b$exports.wrapXOFConstructorWithOpts)((opts = {})=>new $08748f983f07956b$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
/** SHAKE128 XOF with 128-bit security. */ $08748f983f07956b$exports.shake128 = $08748f983f07956b$var$genShake(0x1f, 168, 16);
/** SHAKE256 XOF with 256-bit security. */ $08748f983f07956b$exports.shake256 = $08748f983f07956b$var$genShake(0x1f, 136, 32);





function $a28596abd2959842$export$f8151fce47ad1c35(value, to_) {
    const to = to_ || "hex";
    const bytes = (0, $08748f983f07956b$exports.keccak_256)((0, $da701c4ca2469e62$export$8a9b6341a7c96bc)(value, {
        strict: false
    }) ? (0, $6c2dc9783e770609$export$30a71edf0753ed6b)(value) : value);
    if (to === "bytes") return bytes;
    return (0, $831332fc79f505bb$export$7ea66e3774a60b67)(bytes);
}


/**
 * Map with a LRU (Least recently used) policy.
 *
 * @link https://en.wikipedia.org/wiki/Cache_replacement_policies#LRU
 */ class $37ee2d67f93d3d69$export$fcb3b6cad79d7e3a extends Map {
    constructor(size){
        super();
        Object.defineProperty(this, "maxSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.maxSize = size;
    }
    get(key) {
        const value = super.get(key);
        if (super.has(key) && value !== undefined) {
            this.delete(key);
            super.set(key, value);
        }
        return value;
    }
    set(key, value) {
        super.set(key, value);
        if (this.maxSize && this.size > this.maxSize) {
            const firstKey = this.keys().next().value;
            if (firstKey) this.delete(firstKey);
        }
        return this;
    }
}




const $0dea83085c68c005$var$addressRegex = /^0x[a-fA-F0-9]{40}$/;
const $0dea83085c68c005$export$ef83598cc5072ce = /*#__PURE__*/ new (0, $37ee2d67f93d3d69$export$fcb3b6cad79d7e3a)(8192);
function $0dea83085c68c005$export$977e255126d763d6(address, options) {
    const { strict: strict = true } = options ?? {};
    const cacheKey = `${address}.${strict}`;
    if ($0dea83085c68c005$export$ef83598cc5072ce.has(cacheKey)) return $0dea83085c68c005$export$ef83598cc5072ce.get(cacheKey);
    const result = (()=>{
        if (!$0dea83085c68c005$var$addressRegex.test(address)) return false;
        if (address.toLowerCase() === address) return true;
        if (strict) return (0, $fed5fc0c8fc663c6$export$9ff46e8f6df13548)(address) === address;
        return true;
    })();
    $0dea83085c68c005$export$ef83598cc5072ce.set(cacheKey, result);
    return result;
}


const $fed5fc0c8fc663c6$var$checksumAddressCache = /*#__PURE__*/ new (0, $37ee2d67f93d3d69$export$fcb3b6cad79d7e3a)(8192);
function $fed5fc0c8fc663c6$export$9ff46e8f6df13548(address_, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if ($fed5fc0c8fc663c6$var$checksumAddressCache.has(`${address_}.${chainId}`)) return $fed5fc0c8fc663c6$var$checksumAddressCache.get(`${address_}.${chainId}`);
    const hexAddress = chainId ? `${chainId}${address_.toLowerCase()}` : address_.substring(2).toLowerCase();
    const hash = (0, $a28596abd2959842$export$f8151fce47ad1c35)((0, $6c2dc9783e770609$export$c8dd6bc66a63753c)(hexAddress), "bytes");
    const address = (chainId ? hexAddress.substring(`${chainId}0x`.length) : hexAddress).split("");
    for(let i = 0; i < 40; i += 2){
        if (hash[i >> 1] >> 4 >= 8 && address[i]) address[i] = address[i].toUpperCase();
        if ((hash[i >> 1] & 0x0f) >= 8 && address[i + 1]) address[i + 1] = address[i + 1].toUpperCase();
    }
    const result = `0x${address.join("")}`;
    $fed5fc0c8fc663c6$var$checksumAddressCache.set(`${address_}.${chainId}`, result);
    return result;
}
function $fed5fc0c8fc663c6$export$88411125f012957a(address, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if (!(0, $0dea83085c68c005$export$977e255126d763d6)(address, {
        strict: false
    })) throw new (0, $e607ba54ff7126d5$export$66c44d927ffead98)({
        address: address
    });
    return $fed5fc0c8fc663c6$export$9ff46e8f6df13548(address, chainId);
}



class $2f98d290720ccd0a$export$4741ff085e62ac19 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ offset: offset }){
        super(`Offset \`${offset}\` cannot be negative.`, {
            name: "NegativeOffsetError"
        });
    }
}
class $2f98d290720ccd0a$export$72dcc4230cbf50ba extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ length: length, position: position }){
        super(`Position \`${position}\` is out of bounds (\`0 < position < ${length}\`).`, {
            name: "PositionOutOfBoundsError"
        });
    }
}
class $2f98d290720ccd0a$export$4952f5c6336a7cc7 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor({ count: count, limit: limit }){
        super(`Recursive read limit of \`${limit}\` exceeded (recursive read count: \`${count}\`).`, {
            name: "RecursiveReadLimitExceededError"
        });
    }
}


const $4b04bd67011f0839$var$staticCursor = {
    bytes: new Uint8Array(),
    dataView: new DataView(new ArrayBuffer(0)),
    position: 0,
    positionReadCount: new Map(),
    recursiveReadCount: 0,
    recursiveReadLimit: Number.POSITIVE_INFINITY,
    assertReadLimit () {
        if (this.recursiveReadCount >= this.recursiveReadLimit) throw new (0, $2f98d290720ccd0a$export$4952f5c6336a7cc7)({
            count: this.recursiveReadCount + 1,
            limit: this.recursiveReadLimit
        });
    },
    assertPosition (position) {
        if (position < 0 || position > this.bytes.length - 1) throw new (0, $2f98d290720ccd0a$export$72dcc4230cbf50ba)({
            length: this.bytes.length,
            position: position
        });
    },
    decrementPosition (offset) {
        if (offset < 0) throw new (0, $2f98d290720ccd0a$export$4741ff085e62ac19)({
            offset: offset
        });
        const position = this.position - offset;
        this.assertPosition(position);
        this.position = position;
    },
    getReadCount (position) {
        return this.positionReadCount.get(position || this.position) || 0;
    },
    incrementPosition (offset) {
        if (offset < 0) throw new (0, $2f98d290720ccd0a$export$4741ff085e62ac19)({
            offset: offset
        });
        const position = this.position + offset;
        this.assertPosition(position);
        this.position = position;
    },
    inspectByte (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectBytes (length, position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + length - 1);
        return this.bytes.subarray(position, position + length);
    },
    inspectUint8 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectUint16 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 1);
        return this.dataView.getUint16(position);
    },
    inspectUint24 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 2);
        return (this.dataView.getUint16(position) << 8) + this.dataView.getUint8(position + 2);
    },
    inspectUint32 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 3);
        return this.dataView.getUint32(position);
    },
    pushByte (byte) {
        this.assertPosition(this.position);
        this.bytes[this.position] = byte;
        this.position++;
    },
    pushBytes (bytes) {
        this.assertPosition(this.position + bytes.length - 1);
        this.bytes.set(bytes, this.position);
        this.position += bytes.length;
    },
    pushUint8 (value) {
        this.assertPosition(this.position);
        this.bytes[this.position] = value;
        this.position++;
    },
    pushUint16 (value) {
        this.assertPosition(this.position + 1);
        this.dataView.setUint16(this.position, value);
        this.position += 2;
    },
    pushUint24 (value) {
        this.assertPosition(this.position + 2);
        this.dataView.setUint16(this.position, value >> 8);
        this.dataView.setUint8(this.position + 2, value & 255);
        this.position += 3;
    },
    pushUint32 (value) {
        this.assertPosition(this.position + 3);
        this.dataView.setUint32(this.position, value);
        this.position += 4;
    },
    readByte () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectByte();
        this.position++;
        return value;
    },
    readBytes (length, size) {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectBytes(length);
        this.position += size ?? length;
        return value;
    },
    readUint8 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint8();
        this.position += 1;
        return value;
    },
    readUint16 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint16();
        this.position += 2;
        return value;
    },
    readUint24 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint24();
        this.position += 3;
        return value;
    },
    readUint32 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint32();
        this.position += 4;
        return value;
    },
    get remaining () {
        return this.bytes.length - this.position;
    },
    setPosition (position) {
        const oldPosition = this.position;
        this.assertPosition(position);
        this.position = position;
        return ()=>this.position = oldPosition;
    },
    _touch () {
        if (this.recursiveReadLimit === Number.POSITIVE_INFINITY) return;
        const count = this.getReadCount();
        this.positionReadCount.set(this.position, count + 1);
        if (count > 0) this.recursiveReadCount++;
    }
};
function $4b04bd67011f0839$export$fb542681b7c0dc55(bytes, { recursiveReadLimit: recursiveReadLimit = 8192 } = {}) {
    const cursor = Object.create($4b04bd67011f0839$var$staticCursor);
    cursor.bytes = bytes;
    cursor.dataView = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    cursor.positionReadCount = new Map();
    cursor.recursiveReadLimit = recursiveReadLimit;
    return cursor;
}






function $4a4073b8520c524e$export$58adb3bec8346d0f(value, start, end, { strict: strict } = {}) {
    if ((0, $da701c4ca2469e62$export$8a9b6341a7c96bc)(value, {
        strict: false
    })) return $4a4073b8520c524e$export$728fe14c970402fe(value, start, end, {
        strict: strict
    });
    return $4a4073b8520c524e$export$8bac03c8c1da551(value, start, end, {
        strict: strict
    });
}
function $4a4073b8520c524e$var$assertStartOffset(value, start) {
    if (typeof start === "number" && start > 0 && start > (0, $990136dfff8e7c95$export$346677f925de839c)(value) - 1) throw new (0, $35aa9bb753fdb2e9$export$cfcd41bba8b36dbd)({
        offset: start,
        position: "start",
        size: (0, $990136dfff8e7c95$export$346677f925de839c)(value)
    });
}
function $4a4073b8520c524e$var$assertEndOffset(value, start, end) {
    if (typeof start === "number" && typeof end === "number" && (0, $990136dfff8e7c95$export$346677f925de839c)(value) !== end - start) throw new (0, $35aa9bb753fdb2e9$export$cfcd41bba8b36dbd)({
        offset: end,
        position: "end",
        size: (0, $990136dfff8e7c95$export$346677f925de839c)(value)
    });
}
function $4a4073b8520c524e$export$8bac03c8c1da551(value_, start, end, { strict: strict } = {}) {
    $4a4073b8520c524e$var$assertStartOffset(value_, start);
    const value = value_.slice(start, end);
    if (strict) $4a4073b8520c524e$var$assertEndOffset(value, start, end);
    return value;
}
function $4a4073b8520c524e$export$728fe14c970402fe(value_, start, end, { strict: strict } = {}) {
    $4a4073b8520c524e$var$assertStartOffset(value_, start);
    const value = `0x${value_.replace("0x", "").slice((start ?? 0) * 2, (end ?? value_.length) * 2)}`;
    if (strict) $4a4073b8520c524e$var$assertEndOffset(value, start, end);
    return value;
}







function $5cfc8a9ea672892f$export$de2da3025c30316c(bytes, toOrOpts) {
    const opts = typeof toOrOpts === "string" ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === "number") return $5cfc8a9ea672892f$export$c0cca17bcf674749(bytes, opts);
    if (to === "bigint") return $5cfc8a9ea672892f$export$2a52511e4f35930a(bytes, opts);
    if (to === "boolean") return $5cfc8a9ea672892f$export$aa06fda122958d5d(bytes, opts);
    if (to === "string") return $5cfc8a9ea672892f$export$7c746b75f47c9c7d(bytes, opts);
    return (0, $831332fc79f505bb$export$58b867e287a802c8)(bytes, opts);
}
function $5cfc8a9ea672892f$export$2a52511e4f35930a(bytes, opts = {}) {
    if (typeof opts.size !== "undefined") (0, $4f654bfc0c73014b$export$2af489edb7fa35fe)(bytes, {
        size: opts.size
    });
    const hex = (0, $831332fc79f505bb$export$58b867e287a802c8)(bytes, opts);
    return (0, $4f654bfc0c73014b$export$92a44656ec81b584)(hex, opts);
}
function $5cfc8a9ea672892f$export$aa06fda122958d5d(bytes_, opts = {}) {
    let bytes = bytes_;
    if (typeof opts.size !== "undefined") {
        (0, $4f654bfc0c73014b$export$2af489edb7fa35fe)(bytes, {
            size: opts.size
        });
        bytes = (0, $1e192641aae89f01$export$87c2784dc9fc4ab)(bytes);
    }
    if (bytes.length > 1 || bytes[0] > 1) throw new (0, $0c5b41f05f61c54b$export$52fc62e5266c8838)(bytes);
    return Boolean(bytes[0]);
}
function $5cfc8a9ea672892f$export$c0cca17bcf674749(bytes, opts = {}) {
    if (typeof opts.size !== "undefined") (0, $4f654bfc0c73014b$export$2af489edb7fa35fe)(bytes, {
        size: opts.size
    });
    const hex = (0, $831332fc79f505bb$export$58b867e287a802c8)(bytes, opts);
    return (0, $4f654bfc0c73014b$export$d57f2bacc26b4249)(hex, opts);
}
function $5cfc8a9ea672892f$export$7c746b75f47c9c7d(bytes_, opts = {}) {
    let bytes = bytes_;
    if (typeof opts.size !== "undefined") {
        (0, $4f654bfc0c73014b$export$2af489edb7fa35fe)(bytes, {
            size: opts.size
        });
        bytes = (0, $1e192641aae89f01$export$87c2784dc9fc4ab)(bytes, {
            dir: "right"
        });
    }
    return new TextDecoder().decode(bytes);
}









function $84c53fba14a7a078$export$ee1b3e54f0441b22(values) {
    if (typeof values[0] === "string") return $84c53fba14a7a078$export$f6cc0b64b5a999af(values);
    return $84c53fba14a7a078$export$287dd7971339c972(values);
}
function $84c53fba14a7a078$export$287dd7971339c972(values) {
    let length = 0;
    for (const arr of values)length += arr.length;
    const result = new Uint8Array(length);
    let offset = 0;
    for (const arr of values){
        result.set(arr, offset);
        offset += arr.length;
    }
    return result;
}
function $84c53fba14a7a078$export$f6cc0b64b5a999af(values) {
    return `0x${values.reduce((acc, x)=>acc + x.replace("0x", ""), "")}`;
}






const $a6902703a90e015d$export$6cd562aaf6380f0e = /^(.*)\[([0-9]*)\]$/;
const $a6902703a90e015d$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $a6902703a90e015d$export$45902cc189596eef = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;


function $a68160cb4cac9140$export$448ea0950d6dd7d7(params, values) {
    if (params.length !== values.length) throw new (0, $20f14537aa29b220$export$20737d495bb13c2d)({
        expectedLength: params.length,
        givenLength: values.length
    });
    // Prepare the parameters to determine dynamic types to encode.
    const preparedParams = $a68160cb4cac9140$var$prepareParams({
        params: params,
        values: values
    });
    const data = $a68160cb4cac9140$var$encodeParams(preparedParams);
    if (data.length === 0) return "0x";
    return data;
}
function $a68160cb4cac9140$var$prepareParams({ params: params, values: values }) {
    const preparedParams = [];
    for(let i = 0; i < params.length; i++)preparedParams.push($a68160cb4cac9140$var$prepareParam({
        param: params[i],
        value: values[i]
    }));
    return preparedParams;
}
function $a68160cb4cac9140$var$prepareParam({ param: param, value: value }) {
    const arrayComponents = $a68160cb4cac9140$export$ab502cfdbb1a0d07(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $a68160cb4cac9140$var$encodeArray(value, {
            length: length,
            param: {
                ...param,
                type: type
            }
        });
    }
    if (param.type === "tuple") return $a68160cb4cac9140$var$encodeTuple(value, {
        param: param
    });
    if (param.type === "address") return $a68160cb4cac9140$var$encodeAddress(value);
    if (param.type === "bool") return $a68160cb4cac9140$var$encodeBool(value);
    if (param.type.startsWith("uint") || param.type.startsWith("int")) {
        const signed = param.type.startsWith("int");
        const [, , size = "256"] = (0, $a6902703a90e015d$export$45902cc189596eef).exec(param.type) ?? [];
        return $a68160cb4cac9140$var$encodeNumber(value, {
            signed: signed,
            size: Number(size)
        });
    }
    if (param.type.startsWith("bytes")) return $a68160cb4cac9140$var$encodeBytes(value, {
        param: param
    });
    if (param.type === "string") return $a68160cb4cac9140$var$encodeString(value);
    throw new (0, $20f14537aa29b220$export$53ed98b886965f49)(param.type, {
        docsPath: "/docs/contract/encodeAbiParameters"
    });
}
function $a68160cb4cac9140$var$encodeParams(preparedParams) {
    // 1. Compute the size of the static part of the parameters.
    let staticSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) staticSize += 32;
        else staticSize += (0, $990136dfff8e7c95$export$346677f925de839c)(encoded);
    }
    // 2. Split the parameters into static and dynamic parts.
    const staticParams = [];
    const dynamicParams = [];
    let dynamicSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) {
            staticParams.push((0, $831332fc79f505bb$export$4e87185b7ecfeec4)(staticSize + dynamicSize, {
                size: 32
            }));
            dynamicParams.push(encoded);
            dynamicSize += (0, $990136dfff8e7c95$export$346677f925de839c)(encoded);
        } else staticParams.push(encoded);
    }
    // 3. Concatenate static and dynamic parts.
    return (0, $84c53fba14a7a078$export$ee1b3e54f0441b22)([
        ...staticParams,
        ...dynamicParams
    ]);
}
function $a68160cb4cac9140$var$encodeAddress(value) {
    if (!(0, $0dea83085c68c005$export$977e255126d763d6)(value)) throw new (0, $e607ba54ff7126d5$export$66c44d927ffead98)({
        address: value
    });
    return {
        dynamic: false,
        encoded: (0, $001cab9b3ba1fae8$export$1bcd51c0fce8ee55)(value.toLowerCase())
    };
}
function $a68160cb4cac9140$var$encodeArray(value, { length: length, param: param }) {
    const dynamic = length === null;
    if (!Array.isArray(value)) throw new (0, $20f14537aa29b220$export$710dd6d4f78cc47e)(value);
    if (!dynamic && value.length !== length) throw new (0, $20f14537aa29b220$export$a851da9bf50b557)({
        expectedLength: length,
        givenLength: value.length,
        type: `${param.type}[${length}]`
    });
    let dynamicChild = false;
    const preparedParams = [];
    for(let i = 0; i < value.length; i++){
        const preparedParam = $a68160cb4cac9140$var$prepareParam({
            param: param,
            value: value[i]
        });
        if (preparedParam.dynamic) dynamicChild = true;
        preparedParams.push(preparedParam);
    }
    if (dynamic || dynamicChild) {
        const data = $a68160cb4cac9140$var$encodeParams(preparedParams);
        if (dynamic) {
            const length = (0, $831332fc79f505bb$export$4e87185b7ecfeec4)(preparedParams.length, {
                size: 32
            });
            return {
                dynamic: true,
                encoded: preparedParams.length > 0 ? (0, $84c53fba14a7a078$export$ee1b3e54f0441b22)([
                    length,
                    data
                ]) : length
            };
        }
        if (dynamicChild) return {
            dynamic: true,
            encoded: data
        };
    }
    return {
        dynamic: false,
        encoded: (0, $84c53fba14a7a078$export$ee1b3e54f0441b22)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $a68160cb4cac9140$var$encodeBytes(value, { param: param }) {
    const [, paramSize] = param.type.split("bytes");
    const bytesSize = (0, $990136dfff8e7c95$export$346677f925de839c)(value);
    if (!paramSize) {
        let value_ = value;
        // If the size is not divisible by 32 bytes, pad the end
        // with empty bytes to the ceiling 32 bytes.
        if (bytesSize % 32 !== 0) value_ = (0, $001cab9b3ba1fae8$export$1bcd51c0fce8ee55)(value_, {
            dir: "right",
            size: Math.ceil((value.length - 2) / 2 / 32) * 32
        });
        return {
            dynamic: true,
            encoded: (0, $84c53fba14a7a078$export$ee1b3e54f0441b22)([
                (0, $001cab9b3ba1fae8$export$1bcd51c0fce8ee55)((0, $831332fc79f505bb$export$4e87185b7ecfeec4)(bytesSize, {
                    size: 32
                })),
                value_
            ])
        };
    }
    if (bytesSize !== Number.parseInt(paramSize)) throw new (0, $20f14537aa29b220$export$19c281dc8e23a2ea)({
        expectedSize: Number.parseInt(paramSize),
        value: value
    });
    return {
        dynamic: false,
        encoded: (0, $001cab9b3ba1fae8$export$1bcd51c0fce8ee55)(value, {
            dir: "right"
        })
    };
}
function $a68160cb4cac9140$var$encodeBool(value) {
    if (typeof value !== "boolean") throw new (0, $d010b9492b892711$export$a490eb03cb7a0a5e)(`Invalid boolean value: "${value}" (type: ${typeof value}). Expected: \`true\` or \`false\`.`);
    return {
        dynamic: false,
        encoded: (0, $001cab9b3ba1fae8$export$1bcd51c0fce8ee55)((0, $831332fc79f505bb$export$b5c95dec4f62ef7a)(value))
    };
}
function $a68160cb4cac9140$var$encodeNumber(value, { signed: signed, size: size = 256 }) {
    if (typeof size === "number") {
        const max = 2n ** (BigInt(size) - (signed ? 1n : 0n)) - 1n;
        const min = signed ? -max - 1n : 0n;
        if (value > max || value < min) throw new (0, $0c5b41f05f61c54b$export$47d164a8071229a9)({
            max: max.toString(),
            min: min.toString(),
            signed: signed,
            size: size / 8,
            value: value.toString()
        });
    }
    return {
        dynamic: false,
        encoded: (0, $831332fc79f505bb$export$4e87185b7ecfeec4)(value, {
            size: 32,
            signed: signed
        })
    };
}
function $a68160cb4cac9140$var$encodeString(value) {
    const hexValue = (0, $831332fc79f505bb$export$551c48dea6f88e6d)(value);
    const partsLength = Math.ceil((0, $990136dfff8e7c95$export$346677f925de839c)(hexValue) / 32);
    const parts = [];
    for(let i = 0; i < partsLength; i++)parts.push((0, $001cab9b3ba1fae8$export$1bcd51c0fce8ee55)((0, $4a4073b8520c524e$export$58adb3bec8346d0f)(hexValue, i * 32, (i + 1) * 32), {
        dir: "right"
    }));
    return {
        dynamic: true,
        encoded: (0, $84c53fba14a7a078$export$ee1b3e54f0441b22)([
            (0, $001cab9b3ba1fae8$export$1bcd51c0fce8ee55)((0, $831332fc79f505bb$export$4e87185b7ecfeec4)((0, $990136dfff8e7c95$export$346677f925de839c)(hexValue), {
                size: 32
            })),
            ...parts
        ])
    };
}
function $a68160cb4cac9140$var$encodeTuple(value, { param: param }) {
    let dynamic = false;
    const preparedParams = [];
    for(let i = 0; i < param.components.length; i++){
        const param_ = param.components[i];
        const index = Array.isArray(value) ? i : param_.name;
        const preparedParam = $a68160cb4cac9140$var$prepareParam({
            param: param_,
            value: value[index]
        });
        preparedParams.push(preparedParam);
        if (preparedParam.dynamic) dynamic = true;
    }
    return {
        dynamic: dynamic,
        encoded: dynamic ? $a68160cb4cac9140$var$encodeParams(preparedParams) : (0, $84c53fba14a7a078$export$ee1b3e54f0441b22)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $a68160cb4cac9140$export$ab502cfdbb1a0d07(type) {
    const matches = type.match(/^(.*)\[(\d+)?\]$/);
    return matches ? [
        matches[2] ? Number(matches[2]) : null,
        matches[1]
    ] : undefined;
}


function $47afb998e2da2e21$export$84d51ac2fffabd56(params, data) {
    const bytes = typeof data === "string" ? (0, $6c2dc9783e770609$export$31c96b9df38bc8d4)(data) : data;
    const cursor = (0, $4b04bd67011f0839$export$fb542681b7c0dc55)(bytes);
    if ((0, $990136dfff8e7c95$export$346677f925de839c)(bytes) === 0 && params.length > 0) throw new (0, $20f14537aa29b220$export$a063cde4013f1935)();
    if ((0, $990136dfff8e7c95$export$346677f925de839c)(data) && (0, $990136dfff8e7c95$export$346677f925de839c)(data) < 32) throw new (0, $20f14537aa29b220$export$7a409e433c5f3a8c)({
        data: typeof data === "string" ? data : (0, $831332fc79f505bb$export$58b867e287a802c8)(data),
        params: params,
        size: (0, $990136dfff8e7c95$export$346677f925de839c)(data)
    });
    let consumed = 0;
    const values = [];
    for(let i = 0; i < params.length; ++i){
        const param = params[i];
        cursor.setPosition(consumed);
        const [data, consumed_] = $47afb998e2da2e21$var$decodeParameter(cursor, param, {
            staticPosition: 0
        });
        consumed += consumed_;
        values.push(data);
    }
    return values;
}
function $47afb998e2da2e21$var$decodeParameter(cursor, param, { staticPosition: staticPosition }) {
    const arrayComponents = (0, $a68160cb4cac9140$export$ab502cfdbb1a0d07)(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $47afb998e2da2e21$var$decodeArray(cursor, {
            ...param,
            type: type
        }, {
            length: length,
            staticPosition: staticPosition
        });
    }
    if (param.type === "tuple") return $47afb998e2da2e21$var$decodeTuple(cursor, param, {
        staticPosition: staticPosition
    });
    if (param.type === "address") return $47afb998e2da2e21$var$decodeAddress(cursor);
    if (param.type === "bool") return $47afb998e2da2e21$var$decodeBool(cursor);
    if (param.type.startsWith("bytes")) return $47afb998e2da2e21$var$decodeBytes(cursor, param, {
        staticPosition: staticPosition
    });
    if (param.type.startsWith("uint") || param.type.startsWith("int")) return $47afb998e2da2e21$var$decodeNumber(cursor, param);
    if (param.type === "string") return $47afb998e2da2e21$var$decodeString(cursor, {
        staticPosition: staticPosition
    });
    throw new (0, $20f14537aa29b220$export$cf94ccff0ff97c65)(param.type, {
        docsPath: "/docs/contract/decodeAbiParameters"
    });
}
////////////////////////////////////////////////////////////////////
// Type Decoders
const $47afb998e2da2e21$var$sizeOfLength = 32;
const $47afb998e2da2e21$var$sizeOfOffset = 32;
function $47afb998e2da2e21$var$decodeAddress(cursor) {
    const value = cursor.readBytes(32);
    return [
        (0, $fed5fc0c8fc663c6$export$9ff46e8f6df13548)((0, $831332fc79f505bb$export$58b867e287a802c8)((0, $4a4073b8520c524e$export$8bac03c8c1da551)(value, -20))),
        32
    ];
}
function $47afb998e2da2e21$var$decodeArray(cursor, param, { length: length, staticPosition: staticPosition }) {
    // If the length of the array is not known in advance (dynamic array),
    // this means we will need to wonder off to the pointer and decode.
    if (!length) {
        // Dealing with a dynamic type, so get the offset of the array data.
        const offset = (0, $5cfc8a9ea672892f$export$c0cca17bcf674749)(cursor.readBytes($47afb998e2da2e21$var$sizeOfOffset));
        // Start is the static position of current slot + offset.
        const start = staticPosition + offset;
        const startOfData = start + $47afb998e2da2e21$var$sizeOfLength;
        // Get the length of the array from the offset.
        cursor.setPosition(start);
        const length = (0, $5cfc8a9ea672892f$export$c0cca17bcf674749)(cursor.readBytes($47afb998e2da2e21$var$sizeOfLength));
        // Check if the array has any dynamic children.
        const dynamicChild = $47afb998e2da2e21$var$hasDynamicChild(param);
        let consumed = 0;
        const value = [];
        for(let i = 0; i < length; ++i){
            // If any of the children is dynamic, then all elements will be offset pointer, thus size of one slot (32 bytes).
            // Otherwise, elements will be the size of their encoding (consumed bytes).
            cursor.setPosition(startOfData + (dynamicChild ? i * 32 : consumed));
            const [data, consumed_] = $47afb998e2da2e21$var$decodeParameter(cursor, param, {
                staticPosition: startOfData
            });
            consumed += consumed_;
            value.push(data);
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the length of the array is known in advance,
    // and the length of an element deeply nested in the array is not known,
    // we need to decode the offset of the array data.
    if ($47afb998e2da2e21$var$hasDynamicChild(param)) {
        // Dealing with dynamic types, so get the offset of the array data.
        const offset = (0, $5cfc8a9ea672892f$export$c0cca17bcf674749)(cursor.readBytes($47afb998e2da2e21$var$sizeOfOffset));
        // Start is the static position of current slot + offset.
        const start = staticPosition + offset;
        const value = [];
        for(let i = 0; i < length; ++i){
            // Move cursor along to the next slot (next offset pointer).
            cursor.setPosition(start + i * 32);
            const [data] = $47afb998e2da2e21$var$decodeParameter(cursor, param, {
                staticPosition: start
            });
            value.push(data);
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the length of the array is known in advance and the array is deeply static,
    // then we can just decode each element in sequence.
    let consumed = 0;
    const value = [];
    for(let i = 0; i < length; ++i){
        const [data, consumed_] = $47afb998e2da2e21$var$decodeParameter(cursor, param, {
            staticPosition: staticPosition + consumed
        });
        consumed += consumed_;
        value.push(data);
    }
    return [
        value,
        consumed
    ];
}
function $47afb998e2da2e21$var$decodeBool(cursor) {
    return [
        (0, $5cfc8a9ea672892f$export$aa06fda122958d5d)(cursor.readBytes(32), {
            size: 32
        }),
        32
    ];
}
function $47afb998e2da2e21$var$decodeBytes(cursor, param, { staticPosition: staticPosition }) {
    const [_, size] = param.type.split("bytes");
    if (!size) {
        // Dealing with dynamic types, so get the offset of the bytes data.
        const offset = (0, $5cfc8a9ea672892f$export$c0cca17bcf674749)(cursor.readBytes(32));
        // Set position of the cursor to start of bytes data.
        cursor.setPosition(staticPosition + offset);
        const length = (0, $5cfc8a9ea672892f$export$c0cca17bcf674749)(cursor.readBytes(32));
        // If there is no length, we have zero data.
        if (length === 0) {
            // As we have gone wondering, restore to the original position + next slot.
            cursor.setPosition(staticPosition + 32);
            return [
                "0x",
                32
            ];
        }
        const data = cursor.readBytes(length);
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            (0, $831332fc79f505bb$export$58b867e287a802c8)(data),
            32
        ];
    }
    const value = (0, $831332fc79f505bb$export$58b867e287a802c8)(cursor.readBytes(Number.parseInt(size), 32));
    return [
        value,
        32
    ];
}
function $47afb998e2da2e21$var$decodeNumber(cursor, param) {
    const signed = param.type.startsWith("int");
    const size = Number.parseInt(param.type.split("int")[1] || "256");
    const value = cursor.readBytes(32);
    return [
        size > 48 ? (0, $5cfc8a9ea672892f$export$2a52511e4f35930a)(value, {
            signed: signed
        }) : (0, $5cfc8a9ea672892f$export$c0cca17bcf674749)(value, {
            signed: signed
        }),
        32
    ];
}
function $47afb998e2da2e21$var$decodeTuple(cursor, param, { staticPosition: staticPosition }) {
    // Tuples can have unnamed components (i.e. they are arrays), so we must
    // determine whether the tuple is named or unnamed. In the case of a named
    // tuple, the value will be an object where each property is the name of the
    // component. In the case of an unnamed tuple, the value will be an array.
    const hasUnnamedChild = param.components.length === 0 || param.components.some(({ name: name })=>!name);
    // Initialize the value to an object or an array, depending on whether the
    // tuple is named or unnamed.
    const value = hasUnnamedChild ? [] : {};
    let consumed = 0;
    // If the tuple has a dynamic child, we must first decode the offset to the
    // tuple data.
    if ($47afb998e2da2e21$var$hasDynamicChild(param)) {
        // Dealing with dynamic types, so get the offset of the tuple data.
        const offset = (0, $5cfc8a9ea672892f$export$c0cca17bcf674749)(cursor.readBytes($47afb998e2da2e21$var$sizeOfOffset));
        // Start is the static position of referencing slot + offset.
        const start = staticPosition + offset;
        for(let i = 0; i < param.components.length; ++i){
            const component = param.components[i];
            cursor.setPosition(start + consumed);
            const [data, consumed_] = $47afb998e2da2e21$var$decodeParameter(cursor, component, {
                staticPosition: start
            });
            consumed += consumed_;
            value[hasUnnamedChild ? i : component?.name] = data;
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the tuple has static children, we can just decode each component
    // in sequence.
    for(let i = 0; i < param.components.length; ++i){
        const component = param.components[i];
        const [data, consumed_] = $47afb998e2da2e21$var$decodeParameter(cursor, component, {
            staticPosition: staticPosition
        });
        value[hasUnnamedChild ? i : component?.name] = data;
        consumed += consumed_;
    }
    return [
        value,
        consumed
    ];
}
function $47afb998e2da2e21$var$decodeString(cursor, { staticPosition: staticPosition }) {
    // Get offset to start of string data.
    const offset = (0, $5cfc8a9ea672892f$export$c0cca17bcf674749)(cursor.readBytes(32));
    // Start is the static position of current slot + offset.
    const start = staticPosition + offset;
    cursor.setPosition(start);
    const length = (0, $5cfc8a9ea672892f$export$c0cca17bcf674749)(cursor.readBytes(32));
    // If there is no length, we have zero data (empty string).
    if (length === 0) {
        cursor.setPosition(staticPosition + 32);
        return [
            "",
            32
        ];
    }
    const data = cursor.readBytes(length, 32);
    const value = (0, $5cfc8a9ea672892f$export$7c746b75f47c9c7d)((0, $1e192641aae89f01$export$87c2784dc9fc4ab)(data));
    // As we have gone wondering, restore to the original position + next slot.
    cursor.setPosition(staticPosition + 32);
    return [
        value,
        32
    ];
}
function $47afb998e2da2e21$var$hasDynamicChild(param) {
    const { type: type } = param;
    if (type === "string") return true;
    if (type === "bytes") return true;
    if (type.endsWith("[]")) return true;
    if (type === "tuple") return param.components?.some($47afb998e2da2e21$var$hasDynamicChild);
    const arrayComponents = (0, $a68160cb4cac9140$export$ab502cfdbb1a0d07)(param.type);
    if (arrayComponents && $47afb998e2da2e21$var$hasDynamicChild({
        ...param,
        type: arrayComponents[1]
    })) return true;
    return false;
}





const $60d7e51d417093d2$var$hash = (value)=>(0, $a28596abd2959842$export$f8151fce47ad1c35)((0, $6c2dc9783e770609$export$30a71edf0753ed6b)(value));
function $60d7e51d417093d2$export$77bbcd7aaec17976(sig) {
    return $60d7e51d417093d2$var$hash(sig);
}


// TODO: This looks cool. Need to check the performance of `new RegExp` versus defined inline though.
// https://twitter.com/GabrielVergnaud/status/1622906834343366657
function $7320f466c7c65e27$export$1cca4755fb17f5bd(regex, string) {
    const match = regex.exec(string);
    return match?.groups;
}
const $7320f466c7c65e27$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $7320f466c7c65e27$export$45902cc189596eef = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
const $7320f466c7c65e27$export$5c1628af1434aed0 = /^\(.+?\).*?$/;


// https://regexr.com/7f7rv
const $2c5edbbf92f45fc3$var$tupleRegex = /^tuple(?<array>(\[(\d*)\])*)$/;
function $2c5edbbf92f45fc3$export$c75e01ebc733dc6b(abiParameter) {
    let type = abiParameter.type;
    if ($2c5edbbf92f45fc3$var$tupleRegex.test(abiParameter.type) && "components" in abiParameter) {
        type = "(";
        const length = abiParameter.components.length;
        for(let i = 0; i < length; i++){
            const component = abiParameter.components[i];
            type += $2c5edbbf92f45fc3$export$c75e01ebc733dc6b(component);
            if (i < length - 1) type += ", ";
        }
        const result = (0, $7320f466c7c65e27$export$1cca4755fb17f5bd)($2c5edbbf92f45fc3$var$tupleRegex, abiParameter.type);
        type += `)${result?.array ?? ""}`;
        return $2c5edbbf92f45fc3$export$c75e01ebc733dc6b({
            ...abiParameter,
            type: type
        });
    }
    // Add `indexed` to type if in `abiParameter`
    if ("indexed" in abiParameter && abiParameter.indexed) type = `${type} indexed`;
    // Return human-readable ABI parameter
    if (abiParameter.name) return `${type} ${abiParameter.name}`;
    return type;
}


function $168d4996e2f9406f$export$c55dbda1a081631e(abiParameters) {
    let params = "";
    const length = abiParameters.length;
    for(let i = 0; i < length; i++){
        const abiParameter = abiParameters[i];
        params += (0, $2c5edbbf92f45fc3$export$c75e01ebc733dc6b)(abiParameter);
        if (i !== length - 1) params += ", ";
    }
    return params;
}


function $33b5976a3fd81ad5$export$dc5d0ff4fc2fdee1(abiItem) {
    if (abiItem.type === "function") return `function ${abiItem.name}(${(0, $168d4996e2f9406f$export$c55dbda1a081631e)(abiItem.inputs)})${abiItem.stateMutability && abiItem.stateMutability !== "nonpayable" ? ` ${abiItem.stateMutability}` : ""}${abiItem.outputs?.length ? ` returns (${(0, $168d4996e2f9406f$export$c55dbda1a081631e)(abiItem.outputs)})` : ""}`;
    if (abiItem.type === "event") return `event ${abiItem.name}(${(0, $168d4996e2f9406f$export$c55dbda1a081631e)(abiItem.inputs)})`;
    if (abiItem.type === "error") return `error ${abiItem.name}(${(0, $168d4996e2f9406f$export$c55dbda1a081631e)(abiItem.inputs)})`;
    if (abiItem.type === "constructor") return `constructor(${(0, $168d4996e2f9406f$export$c55dbda1a081631e)(abiItem.inputs)})${abiItem.stateMutability === "payable" ? " payable" : ""}`;
    if (abiItem.type === "fallback") return `fallback() external${abiItem.stateMutability === "payable" ? " payable" : ""}`;
    return "receive() external payable";
}



function $965769b556f6e292$export$5cba87ebe4d0307a(signature) {
    let active = true;
    let current = "";
    let level = 0;
    let result = "";
    let valid = false;
    for(let i = 0; i < signature.length; i++){
        const char = signature[i];
        // If the character is a separator, we want to reactivate.
        if ([
            "(",
            ")",
            ","
        ].includes(char)) active = true;
        // If the character is a "level" token, we want to increment/decrement.
        if (char === "(") level++;
        if (char === ")") level--;
        // If we aren't active, we don't want to mutate the result.
        if (!active) continue;
        // If level === 0, we are at the definition level.
        if (level === 0) {
            if (char === " " && [
                "event",
                "function",
                ""
            ].includes(result)) result = "";
            else {
                result += char;
                // If we are at the end of the definition, we must be finished.
                if (char === ")") {
                    valid = true;
                    break;
                }
            }
            continue;
        }
        // Ignore spaces
        if (char === " ") {
            // If the previous character is a separator, and the current section isn't empty, we want to deactivate.
            if (signature[i - 1] !== "," && current !== "," && current !== ",(") {
                current = "";
                active = false;
            }
            continue;
        }
        result += char;
        current += char;
    }
    if (!valid) throw new (0, $d010b9492b892711$export$a490eb03cb7a0a5e)("Unable to normalize signature.");
    return result;
}


const $820c09f8aadb68c2$export$d075a2fd83e0ecb = (def)=>{
    const def_ = (()=>{
        if (typeof def === "string") return def;
        return (0, $33b5976a3fd81ad5$export$dc5d0ff4fc2fdee1)(def);
    })();
    return (0, $965769b556f6e292$export$5cba87ebe4d0307a)(def_);
};


function $ed00d60e343845c7$export$d809beebc9c913db(fn) {
    return (0, $60d7e51d417093d2$export$77bbcd7aaec17976)((0, $820c09f8aadb68c2$export$d075a2fd83e0ecb)(fn));
}


const $b217a041af3b46f3$export$351f40ec61b2972 = (0, $ed00d60e343845c7$export$d809beebc9c913db);





const $59d586112e63de06$var$docsPath = "/docs/contract/decodeEventLog";
function $59d586112e63de06$export$ec0597e81db3d947(parameters) {
    const { abi: abi, data: data, strict: strict_, topics: topics } = parameters;
    const strict = strict_ ?? true;
    const [signature, ...argTopics] = topics;
    if (!signature) throw new (0, $20f14537aa29b220$export$f83210ce5f9b901f)({
        docsPath: $59d586112e63de06$var$docsPath
    });
    const abiItem = (()=>{
        if (abi.length === 1) return abi[0];
        return abi.find((x)=>x.type === "event" && signature === (0, $b217a041af3b46f3$export$351f40ec61b2972)((0, $3b23739180d8154a$export$dc5d0ff4fc2fdee1)(x)));
    })();
    if (!(abiItem && "name" in abiItem) || abiItem.type !== "event") throw new (0, $20f14537aa29b220$export$3b44baeac92e4d3a)(signature, {
        docsPath: $59d586112e63de06$var$docsPath
    });
    const { name: name, inputs: inputs } = abiItem;
    const isUnnamed = inputs?.some((x)=>!("name" in x && x.name));
    let args = isUnnamed ? [] : {};
    // Decode topics (indexed args).
    const indexedInputs = inputs.filter((x)=>"indexed" in x && x.indexed);
    for(let i = 0; i < indexedInputs.length; i++){
        const param = indexedInputs[i];
        const topic = argTopics[i];
        if (!topic) throw new (0, $20f14537aa29b220$export$6d7c6f419cf52377)({
            abiItem: abiItem,
            param: param
        });
        args[isUnnamed ? i : param.name || i] = $59d586112e63de06$var$decodeTopic({
            param: param,
            value: topic
        });
    }
    // Decode data (non-indexed args).
    const nonIndexedInputs = inputs.filter((x)=>!("indexed" in x && x.indexed));
    if (nonIndexedInputs.length > 0) {
        if (data && data !== "0x") try {
            const decodedData = (0, $47afb998e2da2e21$export$84d51ac2fffabd56)(nonIndexedInputs, data);
            if (decodedData) {
                if (isUnnamed) args = [
                    ...args,
                    ...decodedData
                ];
                else for(let i = 0; i < nonIndexedInputs.length; i++)args[nonIndexedInputs[i].name] = decodedData[i];
            }
        } catch (err) {
            if (strict) {
                if (err instanceof (0, $20f14537aa29b220$export$7a409e433c5f3a8c) || err instanceof (0, $2f98d290720ccd0a$export$72dcc4230cbf50ba)) throw new (0, $20f14537aa29b220$export$3978f86c08fc8c25)({
                    abiItem: abiItem,
                    data: data,
                    params: nonIndexedInputs,
                    size: (0, $990136dfff8e7c95$export$346677f925de839c)(data)
                });
                throw err;
            }
        }
        else if (strict) throw new (0, $20f14537aa29b220$export$3978f86c08fc8c25)({
            abiItem: abiItem,
            data: "0x",
            params: nonIndexedInputs,
            size: 0
        });
    }
    return {
        eventName: name,
        args: Object.values(args).length > 0 ? args : undefined
    };
}
function $59d586112e63de06$var$decodeTopic({ param: param, value: value }) {
    if (param.type === "string" || param.type === "bytes" || param.type === "tuple" || param.type.match(/^(.*)\[(\d+)?\]$/)) return value;
    const decodedArg = (0, $47afb998e2da2e21$export$84d51ac2fffabd56)([
        param
    ], value) || [];
    return decodedArg[0];
}





const $1e04d64bbe3bdbac$export$e2442488533809cb = (fn)=>(0, $4a4073b8520c524e$export$58adb3bec8346d0f)((0, $ed00d60e343845c7$export$d809beebc9c913db)(fn), 0, 4);




function $1c62abca4c636563$export$4508701cc9c71c1c(parameters) {
    const { abi: abi, data: data } = parameters;
    const signature = (0, $4a4073b8520c524e$export$58adb3bec8346d0f)(data, 0, 4);
    const description = abi.find((x)=>x.type === "function" && signature === (0, $1e04d64bbe3bdbac$export$e2442488533809cb)((0, $3b23739180d8154a$export$dc5d0ff4fc2fdee1)(x)));
    if (!description) throw new (0, $20f14537aa29b220$export$14373147a0e60810)(signature, {
        docsPath: "/docs/contract/decodeFunctionData"
    });
    return {
        functionName: description.name,
        args: "inputs" in description && description.inputs && description.inputs.length > 0 ? (0, $47afb998e2da2e21$export$84d51ac2fffabd56)(description.inputs, (0, $4a4073b8520c524e$export$58adb3bec8346d0f)(data, 4)) : undefined
    };
}








function $2fe73cac1a6a91a6$export$99b134cd177e9574(parameters) {
    const { abi: abi, args: args = [], name: name } = parameters;
    const isSelector = (0, $da701c4ca2469e62$export$8a9b6341a7c96bc)(name, {
        strict: false
    });
    const abiItems = abi.filter((abiItem)=>{
        if (isSelector) {
            if (abiItem.type === "function") return (0, $1e04d64bbe3bdbac$export$e2442488533809cb)(abiItem) === name;
            if (abiItem.type === "event") return (0, $b217a041af3b46f3$export$351f40ec61b2972)(abiItem) === name;
            return false;
        }
        return "name" in abiItem && abiItem.name === name;
    });
    if (abiItems.length === 0) return undefined;
    if (abiItems.length === 1) return abiItems[0];
    let matchedAbiItem = undefined;
    for (const abiItem of abiItems){
        if (!("inputs" in abiItem)) continue;
        if (!args || args.length === 0) {
            if (!abiItem.inputs || abiItem.inputs.length === 0) return abiItem;
            continue;
        }
        if (!abiItem.inputs) continue;
        if (abiItem.inputs.length === 0) continue;
        if (abiItem.inputs.length !== args.length) continue;
        const matched = args.every((arg, index)=>{
            const abiParameter = "inputs" in abiItem && abiItem.inputs[index];
            if (!abiParameter) return false;
            return $2fe73cac1a6a91a6$export$697eff86d182a8c1(arg, abiParameter);
        });
        if (matched) {
            // Check for ambiguity against already matched parameters (e.g. `address` vs `bytes20`).
            if (matchedAbiItem && "inputs" in matchedAbiItem && matchedAbiItem.inputs) {
                const ambiguousTypes = $2fe73cac1a6a91a6$export$79fd08820d2778aa(abiItem.inputs, matchedAbiItem.inputs, args);
                if (ambiguousTypes) throw new (0, $20f14537aa29b220$export$fdbba54ba15f2c2d)({
                    abiItem: abiItem,
                    type: ambiguousTypes[0]
                }, {
                    abiItem: matchedAbiItem,
                    type: ambiguousTypes[1]
                });
            }
            matchedAbiItem = abiItem;
        }
    }
    if (matchedAbiItem) return matchedAbiItem;
    return abiItems[0];
}
function $2fe73cac1a6a91a6$export$697eff86d182a8c1(arg, abiParameter) {
    const argType = typeof arg;
    const abiParameterType = abiParameter.type;
    switch(abiParameterType){
        case "address":
            return (0, $0dea83085c68c005$export$977e255126d763d6)(arg, {
                strict: false
            });
        case "bool":
            return argType === "boolean";
        case "function":
            return argType === "string";
        case "string":
            return argType === "string";
        default:
            if (abiParameterType === "tuple" && "components" in abiParameter) return Object.values(abiParameter.components).every((component, index)=>{
                return $2fe73cac1a6a91a6$export$697eff86d182a8c1(Object.values(arg)[index], component);
            });
            // `(u)int<M>`: (un)signed integer type of `M` bits, `0 < M <= 256`, `M % 8 == 0`
            // https://regexr.com/6v8hp
            if (/^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(abiParameterType)) return argType === "number" || argType === "bigint";
            // `bytes<M>`: binary type of `M` bytes, `0 < M <= 32`
            // https://regexr.com/6va55
            if (/^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(abiParameterType)) return argType === "string" || arg instanceof Uint8Array;
            // fixed-length (`<type>[M]`) and dynamic (`<type>[]`) arrays
            // https://regexr.com/6va6i
            if (/[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(abiParameterType)) return Array.isArray(arg) && arg.every((x)=>$2fe73cac1a6a91a6$export$697eff86d182a8c1(x, {
                    ...abiParameter,
                    // Pop off `[]` or `[M]` from end of type
                    type: abiParameterType.replace(/(\[[0-9]{0,}\])$/, "")
                }));
            return false;
    }
}
function $2fe73cac1a6a91a6$export$79fd08820d2778aa(sourceParameters, targetParameters, args) {
    for(const parameterIndex in sourceParameters){
        const sourceParameter = sourceParameters[parameterIndex];
        const targetParameter = targetParameters[parameterIndex];
        if (sourceParameter.type === "tuple" && targetParameter.type === "tuple" && "components" in sourceParameter && "components" in targetParameter) return $2fe73cac1a6a91a6$export$79fd08820d2778aa(sourceParameter.components, targetParameter.components, args[parameterIndex]);
        const types = [
            sourceParameter.type,
            targetParameter.type
        ];
        const ambiguous = (()=>{
            if (types.includes("address") && types.includes("bytes20")) return true;
            if (types.includes("address") && types.includes("string")) return (0, $0dea83085c68c005$export$977e255126d763d6)(args[parameterIndex], {
                strict: false
            });
            if (types.includes("address") && types.includes("bytes")) return (0, $0dea83085c68c005$export$977e255126d763d6)(args[parameterIndex], {
                strict: false
            });
            return false;
        })();
        if (ambiguous) return types;
    }
    return;
}


const $94e04a664e716c2d$var$docsPath = "/docs/contract/decodeFunctionResult";
function $94e04a664e716c2d$export$3a05a90c230f925(parameters) {
    const { abi: abi, args: args, functionName: functionName, data: data } = parameters;
    let abiItem = abi[0];
    if (functionName) {
        const item = (0, $2fe73cac1a6a91a6$export$99b134cd177e9574)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!item) throw new (0, $20f14537aa29b220$export$c4faa308ea7f9b2)(functionName, {
            docsPath: $94e04a664e716c2d$var$docsPath
        });
        abiItem = item;
    }
    if (abiItem.type !== "function") throw new (0, $20f14537aa29b220$export$c4faa308ea7f9b2)(undefined, {
        docsPath: $94e04a664e716c2d$var$docsPath
    });
    if (!abiItem.outputs) throw new (0, $20f14537aa29b220$export$26f2edb605108b34)(abiItem.name, {
        docsPath: $94e04a664e716c2d$var$docsPath
    });
    const values = (0, $47afb998e2da2e21$export$84d51ac2fffabd56)(abiItem.outputs, data);
    if (values && values.length > 1) return values;
    if (values && values.length === 1) return values[0];
    return undefined;
}



class $d17f4a15651495be$export$f71f080d25382681 extends (0, $d010b9492b892711$export$a490eb03cb7a0a5e) {
    constructor(type){
        super(`Filter type "${type}" is not supported.`, {
            name: "FilterTypeNotSupportedError"
        });
    }
}








const $cde759743388e706$var$docsPath = "/docs/contract/encodeEventTopics";
function $cde759743388e706$export$64e9f7ca5ce29acd(parameters) {
    const { abi: abi, eventName: eventName, args: args } = parameters;
    let abiItem = abi[0];
    if (eventName) {
        const item = (0, $2fe73cac1a6a91a6$export$99b134cd177e9574)({
            abi: abi,
            name: eventName
        });
        if (!item) throw new (0, $20f14537aa29b220$export$c7be62baad13b157)(eventName, {
            docsPath: $cde759743388e706$var$docsPath
        });
        abiItem = item;
    }
    if (abiItem.type !== "event") throw new (0, $20f14537aa29b220$export$c7be62baad13b157)(undefined, {
        docsPath: $cde759743388e706$var$docsPath
    });
    const definition = (0, $3b23739180d8154a$export$dc5d0ff4fc2fdee1)(abiItem);
    const signature = (0, $b217a041af3b46f3$export$351f40ec61b2972)(definition);
    let topics = [];
    if (args && "inputs" in abiItem) {
        const indexedInputs = abiItem.inputs?.filter((param)=>"indexed" in param && param.indexed);
        const args_ = Array.isArray(args) ? args : Object.values(args).length > 0 ? indexedInputs?.map((x)=>args[x.name]) ?? [] : [];
        if (args_.length > 0) topics = indexedInputs?.map((param, i)=>{
            if (Array.isArray(args_[i])) return args_[i].map((_, j)=>$cde759743388e706$var$encodeArg({
                    param: param,
                    value: args_[i][j]
                }));
            return typeof args_[i] !== "undefined" && args_[i] !== null ? $cde759743388e706$var$encodeArg({
                param: param,
                value: args_[i]
            }) : null;
        }) ?? [];
    }
    return [
        signature,
        ...topics
    ];
}
function $cde759743388e706$var$encodeArg({ param: param, value: value }) {
    if (param.type === "string" || param.type === "bytes") return (0, $a28596abd2959842$export$f8151fce47ad1c35)((0, $6c2dc9783e770609$export$30a71edf0753ed6b)(value));
    if (param.type === "tuple" || param.type.match(/^(.*)\[(\d+)?\]$/)) throw new (0, $d17f4a15651495be$export$f71f080d25382681)(param.type);
    return (0, $a68160cb4cac9140$export$448ea0950d6dd7d7)([
        param
    ], [
        value
    ]);
}







const $00370f66f70d6ede$var$docsPath = "/docs/contract/encodeFunctionData";
function $00370f66f70d6ede$export$bb3e0a434581ff8(parameters) {
    const { abi: abi, args: args, functionName: functionName } = parameters;
    let abiItem = abi[0];
    if (functionName) {
        const item = (0, $2fe73cac1a6a91a6$export$99b134cd177e9574)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!item) throw new (0, $20f14537aa29b220$export$c4faa308ea7f9b2)(functionName, {
            docsPath: $00370f66f70d6ede$var$docsPath
        });
        abiItem = item;
    }
    if (abiItem.type !== "function") throw new (0, $20f14537aa29b220$export$c4faa308ea7f9b2)(undefined, {
        docsPath: $00370f66f70d6ede$var$docsPath
    });
    return {
        abi: [
            abiItem
        ],
        functionName: (0, $1e04d64bbe3bdbac$export$e2442488533809cb)((0, $3b23739180d8154a$export$dc5d0ff4fc2fdee1)(abiItem))
    };
}


function $0122c1167c15ac5f$export$f4ee15df45da9f03(parameters) {
    const { args: args } = parameters;
    const { abi: abi, functionName: functionName } = (()=>{
        if (parameters.abi.length === 1 && parameters.functionName?.startsWith("0x")) return parameters;
        return (0, $00370f66f70d6ede$export$bb3e0a434581ff8)(parameters);
    })();
    const abiItem = abi[0];
    const signature = functionName;
    const data = "inputs" in abiItem && abiItem.inputs ? (0, $a68160cb4cac9140$export$448ea0950d6dd7d7)(abiItem.inputs, args ?? []) : undefined;
    return (0, $84c53fba14a7a078$export$f6cc0b64b5a999af)([
        signature,
        data ?? "0x"
    ]);
}


// https://regexr.com/7gmok
const $1200d553fa50a83c$var$errorSignatureRegex = /^error (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function $1200d553fa50a83c$export$33be303020ecaff5(signature) {
    return $1200d553fa50a83c$var$errorSignatureRegex.test(signature);
}
function $1200d553fa50a83c$export$a8b67e842e5c116d(signature) {
    return (0, $7320f466c7c65e27$export$1cca4755fb17f5bd)($1200d553fa50a83c$var$errorSignatureRegex, signature);
}
// https://regexr.com/7gmoq
const $1200d553fa50a83c$var$eventSignatureRegex = /^event (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function $1200d553fa50a83c$export$7912f33b3b4526ca(signature) {
    return $1200d553fa50a83c$var$eventSignatureRegex.test(signature);
}
function $1200d553fa50a83c$export$87d5ec49338ff6f(signature) {
    return (0, $7320f466c7c65e27$export$1cca4755fb17f5bd)($1200d553fa50a83c$var$eventSignatureRegex, signature);
}
// https://regexr.com/7gmot
const $1200d553fa50a83c$var$functionSignatureRegex = /^function (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)(?: (?<scope>external|public{1}))?(?: (?<stateMutability>pure|view|nonpayable|payable{1}))?(?: returns\s?\((?<returns>.*?)\))?$/;
function $1200d553fa50a83c$export$fa8ae1a8bca33200(signature) {
    return $1200d553fa50a83c$var$functionSignatureRegex.test(signature);
}
function $1200d553fa50a83c$export$8a14253893829398(signature) {
    return (0, $7320f466c7c65e27$export$1cca4755fb17f5bd)($1200d553fa50a83c$var$functionSignatureRegex, signature);
}
// https://regexr.com/7gmp3
const $1200d553fa50a83c$var$structSignatureRegex = /^struct (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*) \{(?<properties>.*?)\}$/;
function $1200d553fa50a83c$export$130f77ea18c25fb8(signature) {
    return $1200d553fa50a83c$var$structSignatureRegex.test(signature);
}
function $1200d553fa50a83c$export$432f3b6c467d7b70(signature) {
    return (0, $7320f466c7c65e27$export$1cca4755fb17f5bd)($1200d553fa50a83c$var$structSignatureRegex, signature);
}
// https://regexr.com/78u01
const $1200d553fa50a83c$var$constructorSignatureRegex = /^constructor\((?<parameters>.*?)\)(?:\s(?<stateMutability>payable{1}))?$/;
function $1200d553fa50a83c$export$7ec9623fe58e8638(signature) {
    return $1200d553fa50a83c$var$constructorSignatureRegex.test(signature);
}
function $1200d553fa50a83c$export$4713f9c79c855460(signature) {
    return (0, $7320f466c7c65e27$export$1cca4755fb17f5bd)($1200d553fa50a83c$var$constructorSignatureRegex, signature);
}
// https://regexr.com/7srtn
const $1200d553fa50a83c$var$fallbackSignatureRegex = /^fallback\(\) external(?:\s(?<stateMutability>payable{1}))?$/;
function $1200d553fa50a83c$export$f99ebae7027f9f2f(signature) {
    return $1200d553fa50a83c$var$fallbackSignatureRegex.test(signature);
}
function $1200d553fa50a83c$export$3a925f26585db196(signature) {
    return (0, $7320f466c7c65e27$export$1cca4755fb17f5bd)($1200d553fa50a83c$var$fallbackSignatureRegex, signature);
}
// https://regexr.com/78u1k
const $1200d553fa50a83c$var$receiveSignatureRegex = /^receive\(\) external payable$/;
function $1200d553fa50a83c$export$555d9bfe0f07ab3d(signature) {
    return $1200d553fa50a83c$var$receiveSignatureRegex.test(signature);
}
const $1200d553fa50a83c$export$c2f15f629432a51d = new Set([
    "memory",
    "indexed",
    "storage",
    "calldata"
]);
const $1200d553fa50a83c$export$e4045f69b6b17e16 = new Set([
    "indexed"
]);
const $1200d553fa50a83c$export$d304f1652f422b6b = new Set([
    "calldata",
    "memory",
    "storage"
]);



const $1ef14acd4369c234$export$83d89fbfd8236492 = "1.0.8";


class $ae0fba261263c4bc$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        const details = args.cause instanceof $ae0fba261263c4bc$export$a490eb03cb7a0a5e ? args.cause.details : args.cause?.message ? args.cause.message : args.details;
        const docsPath = args.cause instanceof $ae0fba261263c4bc$export$a490eb03cb7a0a5e ? args.cause.docsPath || args.docsPath : args.docsPath;
        const message = [
            shortMessage || "An error occurred.",
            "",
            ...args.metaMessages ? [
                ...args.metaMessages,
                ""
            ] : [],
            ...docsPath ? [
                `Docs: https://abitype.dev${docsPath}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            `Version: abitype@${(0, $1ef14acd4369c234$export$83d89fbfd8236492)}`
        ].join("\n");
        super(message);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiTypeError"
        });
        if (args.cause) this.cause = args.cause;
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.shortMessage = shortMessage;
    }
}


class $39357366650758c8$export$a4e0854b60f599b6 extends (0, $ae0fba261263c4bc$export$a490eb03cb7a0a5e) {
    constructor({ signature: signature }){
        super("Failed to parse ABI item.", {
            details: `parseAbiItem(${JSON.stringify(signature, null, 2)})`,
            docsPath: "/api/human#parseabiitem-1"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiItemError"
        });
    }
}
class $39357366650758c8$export$9e77a92da3bcd5ca extends (0, $ae0fba261263c4bc$export$a490eb03cb7a0a5e) {
    constructor({ type: type }){
        super("Unknown type.", {
            metaMessages: [
                `Type "${type}" is not a valid ABI type. Perhaps you forgot to include a struct signature?`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownTypeError"
        });
    }
}
class $39357366650758c8$export$5a36348a2ac471a3 extends (0, $ae0fba261263c4bc$export$a490eb03cb7a0a5e) {
    constructor({ type: type }){
        super("Unknown type.", {
            metaMessages: [
                `Type "${type}" is not a valid ABI type.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownSolidityTypeError"
        });
    }
}



class $8bcc24327f3cc46c$export$bdcd4054531f5b35 extends (0, $ae0fba261263c4bc$export$a490eb03cb7a0a5e) {
    constructor({ param: param }){
        super("Failed to parse ABI parameter.", {
            details: `parseAbiParameter(${JSON.stringify(param, null, 2)})`,
            docsPath: "/api/human#parseabiparameter-1"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiParameterError"
        });
    }
}
class $8bcc24327f3cc46c$export$f35df31806e96ff extends (0, $ae0fba261263c4bc$export$a490eb03cb7a0a5e) {
    constructor({ params: params }){
        super("Failed to parse ABI parameters.", {
            details: `parseAbiParameters(${JSON.stringify(params, null, 2)})`,
            docsPath: "/api/human#parseabiparameters-1"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiParametersError"
        });
    }
}
class $8bcc24327f3cc46c$export$e569b97a5d46005c extends (0, $ae0fba261263c4bc$export$a490eb03cb7a0a5e) {
    constructor({ param: param }){
        super("Invalid ABI parameter.", {
            details: param
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidParameterError"
        });
    }
}
class $8bcc24327f3cc46c$export$58697cc8f790f211 extends (0, $ae0fba261263c4bc$export$a490eb03cb7a0a5e) {
    constructor({ param: param, name: name }){
        super("Invalid ABI parameter.", {
            details: param,
            metaMessages: [
                `"${name}" is a protected Solidity keyword. More info: https://docs.soliditylang.org/en/latest/cheatsheet.html`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SolidityProtectedKeywordError"
        });
    }
}
class $8bcc24327f3cc46c$export$f837e6b0dee0e468 extends (0, $ae0fba261263c4bc$export$a490eb03cb7a0a5e) {
    constructor({ param: param, type: type, modifier: modifier }){
        super("Invalid ABI parameter.", {
            details: param,
            metaMessages: [
                `Modifier "${modifier}" not allowed${type ? ` in "${type}" type` : ""}.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidModifierError"
        });
    }
}
class $8bcc24327f3cc46c$export$7afd0f25b8fdbbd8 extends (0, $ae0fba261263c4bc$export$a490eb03cb7a0a5e) {
    constructor({ param: param, type: type, modifier: modifier }){
        super("Invalid ABI parameter.", {
            details: param,
            metaMessages: [
                `Modifier "${modifier}" not allowed${type ? ` in "${type}" type` : ""}.`,
                `Data location can only be specified for array, struct, or mapping types, but "${modifier}" was given.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidFunctionModifierError"
        });
    }
}
class $8bcc24327f3cc46c$export$b5451545b6c52dc8 extends (0, $ae0fba261263c4bc$export$a490eb03cb7a0a5e) {
    constructor({ abiParameter: abiParameter }){
        super("Invalid ABI parameter.", {
            details: JSON.stringify(abiParameter, null, 2),
            metaMessages: [
                "ABI parameter type is invalid."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiTypeParameterError"
        });
    }
}



class $4504075bf32b551c$export$ccc2f68ef106615a extends (0, $ae0fba261263c4bc$export$a490eb03cb7a0a5e) {
    constructor({ signature: signature, type: type }){
        super(`Invalid ${type} signature.`, {
            details: signature
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidSignatureError"
        });
    }
}
class $4504075bf32b551c$export$3727c00c40963d37 extends (0, $ae0fba261263c4bc$export$a490eb03cb7a0a5e) {
    constructor({ signature: signature }){
        super("Unknown signature.", {
            details: signature
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownSignatureError"
        });
    }
}
class $4504075bf32b551c$export$769955518e5ea753 extends (0, $ae0fba261263c4bc$export$a490eb03cb7a0a5e) {
    constructor({ signature: signature }){
        super("Invalid struct signature.", {
            details: signature,
            metaMessages: [
                "No properties exist."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidStructSignatureError"
        });
    }
}



class $f9bbf4cf7e295c9e$export$3b7cb2315fb6b103 extends (0, $ae0fba261263c4bc$export$a490eb03cb7a0a5e) {
    constructor({ type: type }){
        super("Circular reference detected.", {
            metaMessages: [
                `Struct "${type}" is a circular reference.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "CircularReferenceError"
        });
    }
}








class $7c28a413763cdbee$export$a13d6673dbe1ad6e extends (0, $ae0fba261263c4bc$export$a490eb03cb7a0a5e) {
    constructor({ current: current, depth: depth }){
        super("Unbalanced parentheses.", {
            metaMessages: [
                `"${current.trim()}" has too many ${depth > 0 ? "opening" : "closing"} parentheses.`
            ],
            details: `Depth "${depth}"`
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidParenthesisError"
        });
    }
}


/**
 * Gets {@link parameterCache} cache key namespaced by {@link type}. This prevents parameters from being accessible to types that don't allow them (e.g. `string indexed foo` not allowed outside of `type: 'event'`).
 * @param param ABI parameter string
 * @param type ABI parameter type
 * @returns Cache key for {@link parameterCache}
 */ function $0d645b9182ab92ae$export$516f1eedf0355404(param, type, structs) {
    let structKey = "";
    if (structs) for (const struct of Object.entries(structs)){
        if (!struct) continue;
        let propertyKey = "";
        for (const property of struct[1])propertyKey += `[${property.type}${property.name ? `:${property.name}` : ""}]`;
        structKey += `(${struct[0]}{${propertyKey}})`;
    }
    if (type) return `${type}:${param}${structKey}`;
    return param;
}
const $0d645b9182ab92ae$export$da1654d628010643 = new Map([
    // Unnamed
    [
        "address",
        {
            type: "address"
        }
    ],
    [
        "bool",
        {
            type: "bool"
        }
    ],
    [
        "bytes",
        {
            type: "bytes"
        }
    ],
    [
        "bytes32",
        {
            type: "bytes32"
        }
    ],
    [
        "int",
        {
            type: "int256"
        }
    ],
    [
        "int256",
        {
            type: "int256"
        }
    ],
    [
        "string",
        {
            type: "string"
        }
    ],
    [
        "uint",
        {
            type: "uint256"
        }
    ],
    [
        "uint8",
        {
            type: "uint8"
        }
    ],
    [
        "uint16",
        {
            type: "uint16"
        }
    ],
    [
        "uint24",
        {
            type: "uint24"
        }
    ],
    [
        "uint32",
        {
            type: "uint32"
        }
    ],
    [
        "uint64",
        {
            type: "uint64"
        }
    ],
    [
        "uint96",
        {
            type: "uint96"
        }
    ],
    [
        "uint112",
        {
            type: "uint112"
        }
    ],
    [
        "uint160",
        {
            type: "uint160"
        }
    ],
    [
        "uint192",
        {
            type: "uint192"
        }
    ],
    [
        "uint256",
        {
            type: "uint256"
        }
    ],
    // Named
    [
        "address owner",
        {
            type: "address",
            name: "owner"
        }
    ],
    [
        "address to",
        {
            type: "address",
            name: "to"
        }
    ],
    [
        "bool approved",
        {
            type: "bool",
            name: "approved"
        }
    ],
    [
        "bytes _data",
        {
            type: "bytes",
            name: "_data"
        }
    ],
    [
        "bytes data",
        {
            type: "bytes",
            name: "data"
        }
    ],
    [
        "bytes signature",
        {
            type: "bytes",
            name: "signature"
        }
    ],
    [
        "bytes32 hash",
        {
            type: "bytes32",
            name: "hash"
        }
    ],
    [
        "bytes32 r",
        {
            type: "bytes32",
            name: "r"
        }
    ],
    [
        "bytes32 root",
        {
            type: "bytes32",
            name: "root"
        }
    ],
    [
        "bytes32 s",
        {
            type: "bytes32",
            name: "s"
        }
    ],
    [
        "string name",
        {
            type: "string",
            name: "name"
        }
    ],
    [
        "string symbol",
        {
            type: "string",
            name: "symbol"
        }
    ],
    [
        "string tokenURI",
        {
            type: "string",
            name: "tokenURI"
        }
    ],
    [
        "uint tokenId",
        {
            type: "uint256",
            name: "tokenId"
        }
    ],
    [
        "uint8 v",
        {
            type: "uint8",
            name: "v"
        }
    ],
    [
        "uint256 balance",
        {
            type: "uint256",
            name: "balance"
        }
    ],
    [
        "uint256 tokenId",
        {
            type: "uint256",
            name: "tokenId"
        }
    ],
    [
        "uint256 value",
        {
            type: "uint256",
            name: "value"
        }
    ],
    // Indexed
    [
        "event:address indexed from",
        {
            type: "address",
            name: "from",
            indexed: true
        }
    ],
    [
        "event:address indexed to",
        {
            type: "address",
            name: "to",
            indexed: true
        }
    ],
    [
        "event:uint indexed tokenId",
        {
            type: "uint256",
            name: "tokenId",
            indexed: true
        }
    ],
    [
        "event:uint256 indexed tokenId",
        {
            type: "uint256",
            name: "tokenId",
            indexed: true
        }
    ]
]);



function $65731fe66aff3f64$export$dc1dc22ccf24efef(signature, structs = {}) {
    if ((0, $1200d553fa50a83c$export$fa8ae1a8bca33200)(signature)) return $65731fe66aff3f64$export$d79eb8ab55e2a331(signature, structs);
    if ((0, $1200d553fa50a83c$export$7912f33b3b4526ca)(signature)) return $65731fe66aff3f64$export$25d6467a8776aab1(signature, structs);
    if ((0, $1200d553fa50a83c$export$33be303020ecaff5)(signature)) return $65731fe66aff3f64$export$c1ace8fbd46164f1(signature, structs);
    if ((0, $1200d553fa50a83c$export$7ec9623fe58e8638)(signature)) return $65731fe66aff3f64$export$57fb927a1bb13269(signature, structs);
    if ((0, $1200d553fa50a83c$export$f99ebae7027f9f2f)(signature)) return $65731fe66aff3f64$export$59f3352106efd66(signature);
    if ((0, $1200d553fa50a83c$export$555d9bfe0f07ab3d)(signature)) return {
        type: "receive",
        stateMutability: "payable"
    };
    throw new (0, $4504075bf32b551c$export$3727c00c40963d37)({
        signature: signature
    });
}
function $65731fe66aff3f64$export$d79eb8ab55e2a331(signature, structs = {}) {
    const match = (0, $1200d553fa50a83c$export$8a14253893829398)(signature);
    if (!match) throw new (0, $4504075bf32b551c$export$ccc2f68ef106615a)({
        signature: signature,
        type: "function"
    });
    const inputParams = $65731fe66aff3f64$export$8350908b11ff5aef(match.parameters);
    const inputs = [];
    const inputLength = inputParams.length;
    for(let i = 0; i < inputLength; i++)inputs.push($65731fe66aff3f64$export$357229f9e2d85552(inputParams[i], {
        modifiers: (0, $1200d553fa50a83c$export$d304f1652f422b6b),
        structs: structs,
        type: "function"
    }));
    const outputs = [];
    if (match.returns) {
        const outputParams = $65731fe66aff3f64$export$8350908b11ff5aef(match.returns);
        const outputLength = outputParams.length;
        for(let i = 0; i < outputLength; i++)outputs.push($65731fe66aff3f64$export$357229f9e2d85552(outputParams[i], {
            modifiers: (0, $1200d553fa50a83c$export$d304f1652f422b6b),
            structs: structs,
            type: "function"
        }));
    }
    return {
        name: match.name,
        type: "function",
        stateMutability: match.stateMutability ?? "nonpayable",
        inputs: inputs,
        outputs: outputs
    };
}
function $65731fe66aff3f64$export$25d6467a8776aab1(signature, structs = {}) {
    const match = (0, $1200d553fa50a83c$export$87d5ec49338ff6f)(signature);
    if (!match) throw new (0, $4504075bf32b551c$export$ccc2f68ef106615a)({
        signature: signature,
        type: "event"
    });
    const params = $65731fe66aff3f64$export$8350908b11ff5aef(match.parameters);
    const abiParameters = [];
    const length = params.length;
    for(let i = 0; i < length; i++)abiParameters.push($65731fe66aff3f64$export$357229f9e2d85552(params[i], {
        modifiers: (0, $1200d553fa50a83c$export$e4045f69b6b17e16),
        structs: structs,
        type: "event"
    }));
    return {
        name: match.name,
        type: "event",
        inputs: abiParameters
    };
}
function $65731fe66aff3f64$export$c1ace8fbd46164f1(signature, structs = {}) {
    const match = (0, $1200d553fa50a83c$export$a8b67e842e5c116d)(signature);
    if (!match) throw new (0, $4504075bf32b551c$export$ccc2f68ef106615a)({
        signature: signature,
        type: "error"
    });
    const params = $65731fe66aff3f64$export$8350908b11ff5aef(match.parameters);
    const abiParameters = [];
    const length = params.length;
    for(let i = 0; i < length; i++)abiParameters.push($65731fe66aff3f64$export$357229f9e2d85552(params[i], {
        structs: structs,
        type: "error"
    }));
    return {
        name: match.name,
        type: "error",
        inputs: abiParameters
    };
}
function $65731fe66aff3f64$export$57fb927a1bb13269(signature, structs = {}) {
    const match = (0, $1200d553fa50a83c$export$4713f9c79c855460)(signature);
    if (!match) throw new (0, $4504075bf32b551c$export$ccc2f68ef106615a)({
        signature: signature,
        type: "constructor"
    });
    const params = $65731fe66aff3f64$export$8350908b11ff5aef(match.parameters);
    const abiParameters = [];
    const length = params.length;
    for(let i = 0; i < length; i++)abiParameters.push($65731fe66aff3f64$export$357229f9e2d85552(params[i], {
        structs: structs,
        type: "constructor"
    }));
    return {
        type: "constructor",
        stateMutability: match.stateMutability ?? "nonpayable",
        inputs: abiParameters
    };
}
function $65731fe66aff3f64$export$59f3352106efd66(signature) {
    const match = (0, $1200d553fa50a83c$export$3a925f26585db196)(signature);
    if (!match) throw new (0, $4504075bf32b551c$export$ccc2f68ef106615a)({
        signature: signature,
        type: "fallback"
    });
    return {
        type: "fallback",
        stateMutability: match.stateMutability ?? "nonpayable"
    };
}
const $65731fe66aff3f64$var$abiParameterWithoutTupleRegex = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/;
const $65731fe66aff3f64$var$abiParameterWithTupleRegex = /^\((?<type>.+?)\)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/;
const $65731fe66aff3f64$var$dynamicIntegerRegex = /^u?int$/;
function $65731fe66aff3f64$export$357229f9e2d85552(param, options) {
    // optional namespace cache by `type`
    const parameterCacheKey = (0, $0d645b9182ab92ae$export$516f1eedf0355404)(param, options?.type, options?.structs);
    if ((0, $0d645b9182ab92ae$export$da1654d628010643).has(parameterCacheKey)) return (0, $0d645b9182ab92ae$export$da1654d628010643).get(parameterCacheKey);
    const isTuple = (0, $7320f466c7c65e27$export$5c1628af1434aed0).test(param);
    const match = (0, $7320f466c7c65e27$export$1cca4755fb17f5bd)(isTuple ? $65731fe66aff3f64$var$abiParameterWithTupleRegex : $65731fe66aff3f64$var$abiParameterWithoutTupleRegex, param);
    if (!match) throw new (0, $8bcc24327f3cc46c$export$e569b97a5d46005c)({
        param: param
    });
    if (match.name && $65731fe66aff3f64$export$d83e1b8970d84409(match.name)) throw new (0, $8bcc24327f3cc46c$export$58697cc8f790f211)({
        param: param,
        name: match.name
    });
    const name = match.name ? {
        name: match.name
    } : {};
    const indexed = match.modifier === "indexed" ? {
        indexed: true
    } : {};
    const structs = options?.structs ?? {};
    let type;
    let components = {};
    if (isTuple) {
        type = "tuple";
        const params = $65731fe66aff3f64$export$8350908b11ff5aef(match.type);
        const components_ = [];
        const length = params.length;
        for(let i = 0; i < length; i++)// remove `modifiers` from `options` to prevent from being added to tuple components
        components_.push($65731fe66aff3f64$export$357229f9e2d85552(params[i], {
            structs: structs
        }));
        components = {
            components: components_
        };
    } else if (match.type in structs) {
        type = "tuple";
        components = {
            components: structs[match.type]
        };
    } else if ($65731fe66aff3f64$var$dynamicIntegerRegex.test(match.type)) type = `${match.type}256`;
    else {
        type = match.type;
        if (!(options?.type === "struct") && !$65731fe66aff3f64$export$640ecc6f40db6417(type)) throw new (0, $39357366650758c8$export$5a36348a2ac471a3)({
            type: type
        });
    }
    if (match.modifier) {
        // Check if modifier exists, but is not allowed (e.g. `indexed` in `functionModifiers`)
        if (!options?.modifiers?.has?.(match.modifier)) throw new (0, $8bcc24327f3cc46c$export$f837e6b0dee0e468)({
            param: param,
            type: options?.type,
            modifier: match.modifier
        });
        // Check if resolved `type` is valid if there is a function modifier
        if ((0, $1200d553fa50a83c$export$d304f1652f422b6b).has(match.modifier) && !$65731fe66aff3f64$export$7265528696368a9(type, !!match.array)) throw new (0, $8bcc24327f3cc46c$export$7afd0f25b8fdbbd8)({
            param: param,
            type: options?.type,
            modifier: match.modifier
        });
    }
    const abiParameter = {
        type: `${type}${match.array ?? ""}`,
        ...name,
        ...indexed,
        ...components
    };
    (0, $0d645b9182ab92ae$export$da1654d628010643).set(parameterCacheKey, abiParameter);
    return abiParameter;
}
function $65731fe66aff3f64$export$8350908b11ff5aef(params, result = [], current = "", depth = 0) {
    const length = params.trim().length;
    // biome-ignore lint/correctness/noUnreachable: recursive
    for(let i = 0; i < length; i++){
        const char = params[i];
        const tail = params.slice(i + 1);
        switch(char){
            case ",":
                return depth === 0 ? $65731fe66aff3f64$export$8350908b11ff5aef(tail, [
                    ...result,
                    current.trim()
                ]) : $65731fe66aff3f64$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth);
            case "(":
                return $65731fe66aff3f64$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth + 1);
            case ")":
                return $65731fe66aff3f64$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth - 1);
            default:
                return $65731fe66aff3f64$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth);
        }
    }
    if (current === "") return result;
    if (depth !== 0) throw new (0, $7c28a413763cdbee$export$a13d6673dbe1ad6e)({
        current: current,
        depth: depth
    });
    result.push(current.trim());
    return result;
}
function $65731fe66aff3f64$export$640ecc6f40db6417(type) {
    return type === "address" || type === "bool" || type === "function" || type === "string" || (0, $7320f466c7c65e27$export$94d7303c0d9f263a).test(type) || (0, $7320f466c7c65e27$export$45902cc189596eef).test(type);
}
const $65731fe66aff3f64$var$protectedKeywordsRegex = /^(?:after|alias|anonymous|apply|auto|byte|calldata|case|catch|constant|copyof|default|defined|error|event|external|false|final|function|immutable|implements|in|indexed|inline|internal|let|mapping|match|memory|mutable|null|of|override|partial|private|promise|public|pure|reference|relocatable|return|returns|sizeof|static|storage|struct|super|supports|switch|this|true|try|typedef|typeof|var|view|virtual)$/;
function $65731fe66aff3f64$export$d83e1b8970d84409(name) {
    return name === "address" || name === "bool" || name === "function" || name === "string" || name === "tuple" || (0, $7320f466c7c65e27$export$94d7303c0d9f263a).test(name) || (0, $7320f466c7c65e27$export$45902cc189596eef).test(name) || $65731fe66aff3f64$var$protectedKeywordsRegex.test(name);
}
function $65731fe66aff3f64$export$7265528696368a9(type, isArray) {
    return isArray || type === "bytes" || type === "string" || type === "tuple";
}


function $a55e1b07ce17f7ff$export$6e5e6f927c48b857(signatures) {
    // Create "shallow" version of each struct (and filter out non-structs or invalid structs)
    const shallowStructs = {};
    const signaturesLength = signatures.length;
    for(let i = 0; i < signaturesLength; i++){
        const signature = signatures[i];
        if (!(0, $1200d553fa50a83c$export$130f77ea18c25fb8)(signature)) continue;
        const match = (0, $1200d553fa50a83c$export$432f3b6c467d7b70)(signature);
        if (!match) throw new (0, $4504075bf32b551c$export$ccc2f68ef106615a)({
            signature: signature,
            type: "struct"
        });
        const properties = match.properties.split(";");
        const components = [];
        const propertiesLength = properties.length;
        for(let k = 0; k < propertiesLength; k++){
            const property = properties[k];
            const trimmed = property.trim();
            if (!trimmed) continue;
            const abiParameter = (0, $65731fe66aff3f64$export$357229f9e2d85552)(trimmed, {
                type: "struct"
            });
            components.push(abiParameter);
        }
        if (!components.length) throw new (0, $4504075bf32b551c$export$769955518e5ea753)({
            signature: signature
        });
        shallowStructs[match.name] = components;
    }
    // Resolve nested structs inside each parameter
    const resolvedStructs = {};
    const entries = Object.entries(shallowStructs);
    const entriesLength = entries.length;
    for(let i = 0; i < entriesLength; i++){
        const [name, parameters] = entries[i];
        resolvedStructs[name] = $a55e1b07ce17f7ff$var$resolveStructs(parameters, shallowStructs);
    }
    return resolvedStructs;
}
const $a55e1b07ce17f7ff$var$typeWithoutTupleRegex = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?$/;
function $a55e1b07ce17f7ff$var$resolveStructs(abiParameters, structs, ancestors = new Set()) {
    const components = [];
    const length = abiParameters.length;
    for(let i = 0; i < length; i++){
        const abiParameter = abiParameters[i];
        const isTuple = (0, $7320f466c7c65e27$export$5c1628af1434aed0).test(abiParameter.type);
        if (isTuple) components.push(abiParameter);
        else {
            const match = (0, $7320f466c7c65e27$export$1cca4755fb17f5bd)($a55e1b07ce17f7ff$var$typeWithoutTupleRegex, abiParameter.type);
            if (!match?.type) throw new (0, $8bcc24327f3cc46c$export$b5451545b6c52dc8)({
                abiParameter: abiParameter
            });
            const { array: array, type: type } = match;
            if (type in structs) {
                if (ancestors.has(type)) throw new (0, $f9bbf4cf7e295c9e$export$3b7cb2315fb6b103)({
                    type: type
                });
                components.push({
                    ...abiParameter,
                    type: `tuple${array ?? ""}`,
                    components: $a55e1b07ce17f7ff$var$resolveStructs(structs[type] ?? [], structs, new Set([
                        ...ancestors,
                        type
                    ]))
                });
            } else {
                if ((0, $65731fe66aff3f64$export$640ecc6f40db6417)(type)) components.push(abiParameter);
                else throw new (0, $39357366650758c8$export$9e77a92da3bcd5ca)({
                    type: type
                });
            }
        }
    }
    return components;
}



function $419f32aea2288367$export$4ab3f466fb8f069(signatures) {
    const structs = (0, $a55e1b07ce17f7ff$export$6e5e6f927c48b857)(signatures);
    const abi = [];
    const length = signatures.length;
    for(let i = 0; i < length; i++){
        const signature = signatures[i];
        if ((0, $1200d553fa50a83c$export$130f77ea18c25fb8)(signature)) continue;
        abi.push((0, $65731fe66aff3f64$export$dc1dc22ccf24efef)(signature, structs));
    }
    return abi;
}





function $c7d8ae1c33480f79$export$1e31c38713b34060(signature) {
    let abiItem;
    if (typeof signature === "string") abiItem = (0, $65731fe66aff3f64$export$dc1dc22ccf24efef)(signature);
    else {
        const structs = (0, $a55e1b07ce17f7ff$export$6e5e6f927c48b857)(signature);
        const length = signature.length;
        for(let i = 0; i < length; i++){
            const signature_ = signature[i];
            if ((0, $1200d553fa50a83c$export$130f77ea18c25fb8)(signature_)) continue;
            abiItem = (0, $65731fe66aff3f64$export$dc1dc22ccf24efef)(signature_, structs);
            break;
        }
    }
    if (!abiItem) throw new (0, $39357366650758c8$export$a4e0854b60f599b6)({
        signature: signature
    });
    return abiItem;
}





function $3c0c8f801fb7bf74$export$660dc560f0dcce7a(params) {
    const abiParameters = [];
    if (typeof params === "string") {
        const parameters = (0, $65731fe66aff3f64$export$8350908b11ff5aef)(params);
        const length = parameters.length;
        for(let i = 0; i < length; i++)abiParameters.push((0, $65731fe66aff3f64$export$357229f9e2d85552)(parameters[i], {
            modifiers: $1200d553fa50a83c$export$c2f15f629432a51d
        }));
    } else {
        const structs = (0, $a55e1b07ce17f7ff$export$6e5e6f927c48b857)(params);
        const length = params.length;
        for(let i = 0; i < length; i++){
            const signature = params[i];
            if ((0, $1200d553fa50a83c$export$130f77ea18c25fb8)(signature)) continue;
            const parameters = (0, $65731fe66aff3f64$export$8350908b11ff5aef)(signature);
            const length = parameters.length;
            for(let k = 0; k < length; k++)abiParameters.push((0, $65731fe66aff3f64$export$357229f9e2d85552)(parameters[k], {
                modifiers: $1200d553fa50a83c$export$c2f15f629432a51d,
                structs: structs
            }));
        }
    }
    if (abiParameters.length === 0) throw new (0, $8bcc24327f3cc46c$export$f35df31806e96ff)({
        params: params
    });
    return abiParameters;
}



var $esaJO = parcelRequire("esaJO");


/**
 * @module BIP32 hierarchical deterministic (HD) wallets over secp256k1.
 * @example
 * ```js
 * import { HDKey } from "@scure/bip32";
 * const hdkey1 = HDKey.fromMasterSeed(seed);
 * const hdkey2 = HDKey.fromExtendedKey(base58key);
 * const hdkey3 = HDKey.fromJSON({ xpriv: string });
 *
 * // props
 * [hdkey1.depth, hdkey1.index, hdkey1.chainCode];
 * console.log(hdkey2.privateKey, hdkey2.publicKey);
 * console.log(hdkey3.derive("m/0/2147483647'/1"));
 * const sig = hdkey3.sign(hash);
 * hdkey3.verify(hash, sig);
 * ```
 */ /*! scure-bip32 - MIT License (c) 2022 Patricio Palladino, Paul Miller (paulmillr.com) */ var $51b6b372898f65c0$exports = {};
"use strict";
Object.defineProperty($51b6b372898f65c0$exports, "__esModule", {
    value: true
});
$51b6b372898f65c0$exports.hmac = $51b6b372898f65c0$exports.HMAC = void 0;


class $51b6b372898f65c0$var$HMAC extends $29ee4d3171d9809b$exports.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $a0ae23f5901291b4$exports.ahash)(hash);
        const key = (0, $29ee4d3171d9809b$exports.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $a0ae23f5901291b4$exports.aexists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $a0ae23f5901291b4$exports.aexists)(this);
        (0, $a0ae23f5901291b4$exports.abytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
$51b6b372898f65c0$exports.HMAC = $51b6b372898f65c0$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 * @example
 * import { hmac } from '@noble/hashes/hmac';
 * import { sha256 } from '@noble/hashes/sha2';
 * const mac1 = hmac(sha256, 'key', 'message');
 */ const $51b6b372898f65c0$var$hmac = (hash, key, message)=>new $51b6b372898f65c0$var$HMAC(hash, key).update(message).digest();
$51b6b372898f65c0$exports.hmac = $51b6b372898f65c0$var$hmac;
$51b6b372898f65c0$exports.hmac.create = (hash, key)=>new $51b6b372898f65c0$var$HMAC(hash, key);


var $de58877bbb165fd5$exports = {};
"use strict";
Object.defineProperty($de58877bbb165fd5$exports, "__esModule", {
    value: true
});
$de58877bbb165fd5$exports.ripemd160 = $de58877bbb165fd5$exports.RIPEMD160 = void 0;
var $dd17a2ee919821c7$exports = {};
"use strict";
Object.defineProperty($dd17a2ee919821c7$exports, "__esModule", {
    value: true
});
$dd17a2ee919821c7$exports.HashMD = void 0;
$dd17a2ee919821c7$exports.setBigUint64 = $dd17a2ee919821c7$var$setBigUint64;
$dd17a2ee919821c7$exports.Chi = $dd17a2ee919821c7$var$Chi;
$dd17a2ee919821c7$exports.Maj = $dd17a2ee919821c7$var$Maj;


/** Polyfill for Safari 14. https://caniuse.com/mdn-javascript_builtins_dataview_setbiguint64 */ function $dd17a2ee919821c7$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
/** Choice: a ? b : c */ function $dd17a2ee919821c7$var$Chi(a, b, c) {
    return a & b ^ ~a & c;
}
/** Majority function, true if any two inputs is true. */ function $dd17a2ee919821c7$var$Maj(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */ class $dd17a2ee919821c7$var$HashMD extends $29ee4d3171d9809b$exports.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $29ee4d3171d9809b$exports.createView)(this.buffer);
    }
    update(data) {
        (0, $a0ae23f5901291b4$exports.aexists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $29ee4d3171d9809b$exports.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $29ee4d3171d9809b$exports.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $a0ae23f5901291b4$exports.aexists)(this);
        (0, $a0ae23f5901291b4$exports.aoutput)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $dd17a2ee919821c7$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $29ee4d3171d9809b$exports.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
$dd17a2ee919821c7$exports.HashMD = $dd17a2ee919821c7$var$HashMD;



const $de58877bbb165fd5$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $de58877bbb165fd5$var$Id = /* @__PURE__ */ new Uint8Array(new Array(16).fill(0).map((_, i)=>i));
const $de58877bbb165fd5$var$Pi = /* @__PURE__ */ $de58877bbb165fd5$var$Id.map((i)=>(9 * i + 5) % 16);
let $de58877bbb165fd5$var$idxL = [
    $de58877bbb165fd5$var$Id
];
let $de58877bbb165fd5$var$idxR = [
    $de58877bbb165fd5$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $de58877bbb165fd5$var$idxL,
    $de58877bbb165fd5$var$idxR
])j.push(j[i].map((k)=>$de58877bbb165fd5$var$Rho[k]));
const $de58877bbb165fd5$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $de58877bbb165fd5$var$shiftsL = /* @__PURE__ */ $de58877bbb165fd5$var$idxL.map((idx, i)=>idx.map((j)=>$de58877bbb165fd5$var$shifts[i][j]));
const $de58877bbb165fd5$var$shiftsR = /* @__PURE__ */ $de58877bbb165fd5$var$idxR.map((idx, i)=>idx.map((j)=>$de58877bbb165fd5$var$shifts[i][j]));
const $de58877bbb165fd5$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $de58877bbb165fd5$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// It's called f() in spec.
function $de58877bbb165fd5$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $de58877bbb165fd5$var$R_BUF = /* @__PURE__ */ new Uint32Array(16);
class $de58877bbb165fd5$var$RIPEMD160 extends $dd17a2ee919821c7$exports.HashMD {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$de58877bbb165fd5$var$R_BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $de58877bbb165fd5$var$Kl[group], hbr = $de58877bbb165fd5$var$Kr[group]; // prettier-ignore
            const rl = $de58877bbb165fd5$var$idxL[group], rr = $de58877bbb165fd5$var$idxR[group]; // prettier-ignore
            const sl = $de58877bbb165fd5$var$shiftsL[group], sr = $de58877bbb165fd5$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = (0, $29ee4d3171d9809b$exports.rotl)(al + $de58877bbb165fd5$var$f(group, bl, cl, dl) + $de58877bbb165fd5$var$R_BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = (0, $29ee4d3171d9809b$exports.rotl)(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = (0, $29ee4d3171d9809b$exports.rotl)(ar + $de58877bbb165fd5$var$f(rGroup, br, cr, dr) + $de58877bbb165fd5$var$R_BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = (0, $29ee4d3171d9809b$exports.rotl)(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $de58877bbb165fd5$var$R_BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
$de58877bbb165fd5$exports.RIPEMD160 = $de58877bbb165fd5$var$RIPEMD160;
/** RIPEMD-160 - a legacy hash function from 1990s. */ $de58877bbb165fd5$exports.ripemd160 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $de58877bbb165fd5$var$RIPEMD160());


var $510ad3657d73a9d2$exports = {};
"use strict";
Object.defineProperty($510ad3657d73a9d2$exports, "__esModule", {
    value: true
});
$510ad3657d73a9d2$exports.sha224 = $510ad3657d73a9d2$exports.sha256 = $510ad3657d73a9d2$exports.SHA256 = void 0;


/** Round constants: first 32 bits of fractional parts of the cube roots of the first 64 primes 2..311). */ // prettier-ignore
const $510ad3657d73a9d2$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Initial state: first 32 bits of fractional parts of the square roots of the first 8 primes 2..19. */ // prettier-ignore
const $510ad3657d73a9d2$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
/**
 * Temporary buffer, not used to store anything between runs.
 * Named this way because it matches specification.
 */ const $510ad3657d73a9d2$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $510ad3657d73a9d2$var$SHA256 extends $dd17a2ee919821c7$exports.HashMD {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $510ad3657d73a9d2$var$SHA256_IV[0] | 0;
        this.B = $510ad3657d73a9d2$var$SHA256_IV[1] | 0;
        this.C = $510ad3657d73a9d2$var$SHA256_IV[2] | 0;
        this.D = $510ad3657d73a9d2$var$SHA256_IV[3] | 0;
        this.E = $510ad3657d73a9d2$var$SHA256_IV[4] | 0;
        this.F = $510ad3657d73a9d2$var$SHA256_IV[5] | 0;
        this.G = $510ad3657d73a9d2$var$SHA256_IV[6] | 0;
        this.H = $510ad3657d73a9d2$var$SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$510ad3657d73a9d2$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $510ad3657d73a9d2$var$SHA256_W[i - 15];
            const W2 = $510ad3657d73a9d2$var$SHA256_W[i - 2];
            const s0 = (0, $29ee4d3171d9809b$exports.rotr)(W15, 7) ^ (0, $29ee4d3171d9809b$exports.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $29ee4d3171d9809b$exports.rotr)(W2, 17) ^ (0, $29ee4d3171d9809b$exports.rotr)(W2, 19) ^ W2 >>> 10;
            $510ad3657d73a9d2$var$SHA256_W[i] = s1 + $510ad3657d73a9d2$var$SHA256_W[i - 7] + s0 + $510ad3657d73a9d2$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $29ee4d3171d9809b$exports.rotr)(E, 6) ^ (0, $29ee4d3171d9809b$exports.rotr)(E, 11) ^ (0, $29ee4d3171d9809b$exports.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $dd17a2ee919821c7$exports.Chi)(E, F, G) + $510ad3657d73a9d2$var$SHA256_K[i] + $510ad3657d73a9d2$var$SHA256_W[i] | 0;
            const sigma0 = (0, $29ee4d3171d9809b$exports.rotr)(A, 2) ^ (0, $29ee4d3171d9809b$exports.rotr)(A, 13) ^ (0, $29ee4d3171d9809b$exports.rotr)(A, 22);
            const T2 = sigma0 + (0, $dd17a2ee919821c7$exports.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $510ad3657d73a9d2$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
$510ad3657d73a9d2$exports.SHA256 = $510ad3657d73a9d2$var$SHA256;
/**
 * Constants taken from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf.
 */ class $510ad3657d73a9d2$var$SHA224 extends $510ad3657d73a9d2$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/** SHA2-256 hash function */ $510ad3657d73a9d2$exports.sha256 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $510ad3657d73a9d2$var$SHA256());
/** SHA2-224 hash function */ $510ad3657d73a9d2$exports.sha224 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $510ad3657d73a9d2$var$SHA224());


var $2579977b4e52adba$exports = {};
"use strict";
Object.defineProperty($2579977b4e52adba$exports, "__esModule", {
    value: true
});
$2579977b4e52adba$exports.sha384 = $2579977b4e52adba$exports.sha512_256 = $2579977b4e52adba$exports.sha512_224 = $2579977b4e52adba$exports.sha512 = $2579977b4e52adba$exports.SHA384 = $2579977b4e52adba$exports.SHA512_256 = $2579977b4e52adba$exports.SHA512_224 = $2579977b4e52adba$exports.SHA512 = void 0;



// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$2579977b4e52adba$var$SHA512_Kh, $2579977b4e52adba$var$SHA512_Kl] = /* @__PURE__ */ (()=>$aa71b30d36adb919$exports.default.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $2579977b4e52adba$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $2579977b4e52adba$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $2579977b4e52adba$var$SHA512 extends $dd17a2ee919821c7$exports.HashMD {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $2579977b4e52adba$var$SHA512_W_H[i] = view.getUint32(offset);
            $2579977b4e52adba$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $2579977b4e52adba$var$SHA512_W_H[i - 15] | 0;
            const W15l = $2579977b4e52adba$var$SHA512_W_L[i - 15] | 0;
            const s0h = $aa71b30d36adb919$exports.default.rotrSH(W15h, W15l, 1) ^ $aa71b30d36adb919$exports.default.rotrSH(W15h, W15l, 8) ^ $aa71b30d36adb919$exports.default.shrSH(W15h, W15l, 7);
            const s0l = $aa71b30d36adb919$exports.default.rotrSL(W15h, W15l, 1) ^ $aa71b30d36adb919$exports.default.rotrSL(W15h, W15l, 8) ^ $aa71b30d36adb919$exports.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $2579977b4e52adba$var$SHA512_W_H[i - 2] | 0;
            const W2l = $2579977b4e52adba$var$SHA512_W_L[i - 2] | 0;
            const s1h = $aa71b30d36adb919$exports.default.rotrSH(W2h, W2l, 19) ^ $aa71b30d36adb919$exports.default.rotrBH(W2h, W2l, 61) ^ $aa71b30d36adb919$exports.default.shrSH(W2h, W2l, 6);
            const s1l = $aa71b30d36adb919$exports.default.rotrSL(W2h, W2l, 19) ^ $aa71b30d36adb919$exports.default.rotrBL(W2h, W2l, 61) ^ $aa71b30d36adb919$exports.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $aa71b30d36adb919$exports.default.add4L(s0l, s1l, $2579977b4e52adba$var$SHA512_W_L[i - 7], $2579977b4e52adba$var$SHA512_W_L[i - 16]);
            const SUMh = $aa71b30d36adb919$exports.default.add4H(SUMl, s0h, s1h, $2579977b4e52adba$var$SHA512_W_H[i - 7], $2579977b4e52adba$var$SHA512_W_H[i - 16]);
            $2579977b4e52adba$var$SHA512_W_H[i] = SUMh | 0;
            $2579977b4e52adba$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $aa71b30d36adb919$exports.default.rotrSH(Eh, El, 14) ^ $aa71b30d36adb919$exports.default.rotrSH(Eh, El, 18) ^ $aa71b30d36adb919$exports.default.rotrBH(Eh, El, 41);
            const sigma1l = $aa71b30d36adb919$exports.default.rotrSL(Eh, El, 14) ^ $aa71b30d36adb919$exports.default.rotrSL(Eh, El, 18) ^ $aa71b30d36adb919$exports.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $aa71b30d36adb919$exports.default.add5L(Hl, sigma1l, CHIl, $2579977b4e52adba$var$SHA512_Kl[i], $2579977b4e52adba$var$SHA512_W_L[i]);
            const T1h = $aa71b30d36adb919$exports.default.add5H(T1ll, Hh, sigma1h, CHIh, $2579977b4e52adba$var$SHA512_Kh[i], $2579977b4e52adba$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $aa71b30d36adb919$exports.default.rotrSH(Ah, Al, 28) ^ $aa71b30d36adb919$exports.default.rotrBH(Ah, Al, 34) ^ $aa71b30d36adb919$exports.default.rotrBH(Ah, Al, 39);
            const sigma0l = $aa71b30d36adb919$exports.default.rotrSL(Ah, Al, 28) ^ $aa71b30d36adb919$exports.default.rotrBL(Ah, Al, 34) ^ $aa71b30d36adb919$exports.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $aa71b30d36adb919$exports.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $aa71b30d36adb919$exports.default.add3L(T1l, sigma0l, MAJl);
            Ah = $aa71b30d36adb919$exports.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $aa71b30d36adb919$exports.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $aa71b30d36adb919$exports.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $aa71b30d36adb919$exports.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $aa71b30d36adb919$exports.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $aa71b30d36adb919$exports.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $aa71b30d36adb919$exports.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $aa71b30d36adb919$exports.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $aa71b30d36adb919$exports.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $2579977b4e52adba$var$SHA512_W_H.fill(0);
        $2579977b4e52adba$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
$2579977b4e52adba$exports.SHA512 = $2579977b4e52adba$var$SHA512;
class $2579977b4e52adba$var$SHA512_224 extends $2579977b4e52adba$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
$2579977b4e52adba$exports.SHA512_224 = $2579977b4e52adba$var$SHA512_224;
class $2579977b4e52adba$var$SHA512_256 extends $2579977b4e52adba$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
$2579977b4e52adba$exports.SHA512_256 = $2579977b4e52adba$var$SHA512_256;
class $2579977b4e52adba$var$SHA384 extends $2579977b4e52adba$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
$2579977b4e52adba$exports.SHA384 = $2579977b4e52adba$var$SHA384;
/** SHA2-512 hash function. */ $2579977b4e52adba$exports.sha512 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA512());
/** SHA2-512/224 "truncated" hash function, with improved resistance to length extension attacks. */ $2579977b4e52adba$exports.sha512_224 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA512_224());
/** SHA2-512/256 "truncated" hash function, with improved resistance to length extension attacks. */ $2579977b4e52adba$exports.sha512_256 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA512_256());
/** SHA2-384 hash function. */ $2579977b4e52adba$exports.sha384 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA384());




var $3f551179096121b9$exports = {};
"use strict";
Object.defineProperty($3f551179096121b9$exports, "__esModule", {
    value: true
});
$3f551179096121b9$exports.encodeToCurve = $3f551179096121b9$exports.hashToCurve = $3f551179096121b9$exports.schnorr = $3f551179096121b9$exports.secp256k1 = void 0;


var $5af70d1c5fca3e4e$exports = {};
"use strict";
Object.defineProperty($5af70d1c5fca3e4e$exports, "__esModule", {
    value: true
});
$5af70d1c5fca3e4e$exports.getHash = $5af70d1c5fca3e4e$var$getHash;
$5af70d1c5fca3e4e$exports.createCurve = $5af70d1c5fca3e4e$var$createCurve;


var $c3b91d553ab14e64$exports = {};
"use strict";
Object.defineProperty($c3b91d553ab14e64$exports, "__esModule", {
    value: true
});
$c3b91d553ab14e64$exports.DER = $c3b91d553ab14e64$exports.DERErr = void 0;
$c3b91d553ab14e64$exports.weierstrassPoints = $c3b91d553ab14e64$var$weierstrassPoints;
$c3b91d553ab14e64$exports.weierstrass = $c3b91d553ab14e64$var$weierstrass;
$c3b91d553ab14e64$exports.SWUFpSqrtRatio = $c3b91d553ab14e64$var$SWUFpSqrtRatio;
$c3b91d553ab14e64$exports.mapToCurveSimpleSWU = $c3b91d553ab14e64$var$mapToCurveSimpleSWU;

var $lkFCe = parcelRequire("lkFCe");

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");

var $esaJO = parcelRequire("esaJO");
function $c3b91d553ab14e64$var$validateSigVerOpts(opts) {
    if (opts.lowS !== undefined) (0, $esaJO.abool)("lowS", opts.lowS);
    if (opts.prehash !== undefined) (0, $esaJO.abool)("prehash", opts.prehash);
}
function $c3b91d553ab14e64$var$validatePointOpts(curve) {
    const opts = (0, $lkFCe.validateBasic)(curve);
    $esaJO.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("invalid endomorphism, can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("invalid endomorphism, expected beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
const { bytesToNumberBE: $c3b91d553ab14e64$var$b2n, hexToBytes: $c3b91d553ab14e64$var$h2b } = $esaJO;
class $c3b91d553ab14e64$var$DERErr extends Error {
    constructor(m = ""){
        super(m);
    }
}
$c3b91d553ab14e64$exports.DERErr = $c3b91d553ab14e64$var$DERErr;
/**
 * ASN.1 DER encoding utilities. ASN is very complex & fragile. Format:
 *
 *     [0x30 (SEQUENCE), bytelength, 0x02 (INTEGER), intLength, R, 0x02 (INTEGER), intLength, S]
 *
 * Docs: https://letsencrypt.org/docs/a-warm-welcome-to-asn1-and-der/, https://luca.ntop.org/Teaching/Appunti/asn1.html
 */ $c3b91d553ab14e64$exports.DER = {
    // asn.1 DER encoding utils
    Err: $c3b91d553ab14e64$var$DERErr,
    // Basic building block is TLV (Tag-Length-Value)
    _tlv: {
        encode: (tag, data)=>{
            const { Err: E } = $c3b91d553ab14e64$exports.DER;
            if (tag < 0 || tag > 256) throw new E("tlv.encode: wrong tag");
            if (data.length & 1) throw new E("tlv.encode: unpadded data");
            const dataLen = data.length / 2;
            const len = $esaJO.numberToHexUnpadded(dataLen);
            if (len.length / 2 & 128) throw new E("tlv.encode: long form length too big");
            // length of length with long form flag
            const lenLen = dataLen > 127 ? $esaJO.numberToHexUnpadded(len.length / 2 | 128) : "";
            const t = $esaJO.numberToHexUnpadded(tag);
            return t + lenLen + len + data;
        },
        // v - value, l - left bytes (unparsed)
        decode (tag, data) {
            const { Err: E } = $c3b91d553ab14e64$exports.DER;
            let pos = 0;
            if (tag < 0 || tag > 256) throw new E("tlv.encode: wrong tag");
            if (data.length < 2 || data[pos++] !== tag) throw new E("tlv.decode: wrong tlv");
            const first = data[pos++];
            const isLong = !!(first & 128); // First bit of first length byte is flag for short/long form
            let length = 0;
            if (!isLong) length = first;
            else {
                // Long form: [longFlag(1bit), lengthLength(7bit), length (BE)]
                const lenLen = first & 127;
                if (!lenLen) throw new E("tlv.decode(long): indefinite length not supported");
                if (lenLen > 4) throw new E("tlv.decode(long): byte length is too big"); // this will overflow u32 in js
                const lengthBytes = data.subarray(pos, pos + lenLen);
                if (lengthBytes.length !== lenLen) throw new E("tlv.decode: length bytes not complete");
                if (lengthBytes[0] === 0) throw new E("tlv.decode(long): zero leftmost byte");
                for (const b of lengthBytes)length = length << 8 | b;
                pos += lenLen;
                if (length < 128) throw new E("tlv.decode(long): not minimal encoding");
            }
            const v = data.subarray(pos, pos + length);
            if (v.length !== length) throw new E("tlv.decode: wrong value length");
            return {
                v: v,
                l: data.subarray(pos + length)
            };
        }
    },
    // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
    // since we always use positive integers here. It must always be empty:
    // - add zero byte if exists
    // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
    _int: {
        encode (num) {
            const { Err: E } = $c3b91d553ab14e64$exports.DER;
            if (num < $c3b91d553ab14e64$var$_0n) throw new E("integer: negative integers are not allowed");
            let hex = $esaJO.numberToHexUnpadded(num);
            // Pad with zero byte if negative flag is present
            if (Number.parseInt(hex[0], 16) & 8) hex = "00" + hex;
            if (hex.length & 1) throw new E("unexpected DER parsing assertion: unpadded hex");
            return hex;
        },
        decode (data) {
            const { Err: E } = $c3b91d553ab14e64$exports.DER;
            if (data[0] & 128) throw new E("invalid signature integer: negative");
            if (data[0] === 0x00 && !(data[1] & 128)) throw new E("invalid signature integer: unnecessary leading zero");
            return $c3b91d553ab14e64$var$b2n(data);
        }
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E, _int: int, _tlv: tlv } = $c3b91d553ab14e64$exports.DER;
        const data = typeof hex === "string" ? $c3b91d553ab14e64$var$h2b(hex) : hex;
        $esaJO.abytes(data);
        const { v: seqBytes, l: seqLeftBytes } = tlv.decode(0x30, data);
        if (seqLeftBytes.length) throw new E("invalid signature: left bytes after parsing");
        const { v: rBytes, l: rLeftBytes } = tlv.decode(0x02, seqBytes);
        const { v: sBytes, l: sLeftBytes } = tlv.decode(0x02, rLeftBytes);
        if (sLeftBytes.length) throw new E("invalid signature: left bytes after parsing");
        return {
            r: int.decode(rBytes),
            s: int.decode(sBytes)
        };
    },
    hexFromSig (sig) {
        const { _tlv: tlv, _int: int } = $c3b91d553ab14e64$exports.DER;
        const rs = tlv.encode(0x02, int.encode(sig.r));
        const ss = tlv.encode(0x02, int.encode(sig.s));
        const seq = rs + ss;
        return tlv.encode(0x30, seq);
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $c3b91d553ab14e64$var$_0n = BigInt(0), $c3b91d553ab14e64$var$_1n = BigInt(1), $c3b91d553ab14e64$var$_2n = BigInt(2), $c3b91d553ab14e64$var$_3n = BigInt(3), $c3b91d553ab14e64$var$_4n = BigInt(4);
function $c3b91d553ab14e64$var$weierstrassPoints(opts) {
    const CURVE = $c3b91d553ab14e64$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const Fn = (0, $2D9sF.Field)(CURVE.n, CURVE.nBitLength);
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $esaJO.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return $esaJO.inRange(num, $c3b91d553ab14e64$var$_1n, CURVE.n);
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: N } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if ($esaJO.isBytes(key)) key = $esaJO.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("invalid private key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $esaJO.bytesToNumberBE((0, $esaJO.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error("invalid private key, expected hex or " + nByteLength + " bytes, got " + typeof key);
        }
        if (wrapPrivateKey) num = (0, $2D9sF.mod)(num, N); // disabled by default, enabled for BLS
        $esaJO.aInRange("private key", num, $c3b91d553ab14e64$var$_1n, N); // num in range [1..N-1]
        return num;
    }
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    // Memoized toAffine / validity check. They are heavy. Points are immutable.
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    const toAffineMemo = (0, $esaJO.memoized)((p, iz)=>{
        const { px: x, py: y, pz: z } = p;
        // Fast-path for normalized points
        if (Fp.eql(z, Fp.ONE)) return {
            x: x,
            y: y
        };
        const is0 = p.is0();
        // If invZ was 0, we return zero point. However we still want to execute
        // all operations, so we replace invZ with a random number, 1.
        if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
        const ax = Fp.mul(x, iz);
        const ay = Fp.mul(y, iz);
        const zz = Fp.mul(z, iz);
        if (is0) return {
            x: Fp.ZERO,
            y: Fp.ZERO
        };
        if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
        return {
            x: ax,
            y: ay
        };
    });
    // NOTE: on exception this will crash 'cached' and no value will be set.
    // Otherwise true will be return
    const assertValidMemo = (0, $esaJO.memoized)((p)=>{
        if (p.is0()) {
            // (0, 1, 0) aka ZERO is invalid in most contexts.
            // In BLS, ZERO can be serialized, so we allow it.
            // (0, 0, 0) is invalid representation of ZERO.
            if (CURVE.allowInfinityPoint && !Fp.is0(p.py)) return;
            throw new Error("bad point: ZERO");
        }
        // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
        const { x: x, y: y } = p.toAffine();
        // Check if x, y are valid field elements
        if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
        const left = Fp.sqr(y); // y²
        const right = weierstrassEquation(x); // x³ + ax + b
        if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
        if (!p.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        return true;
    });
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
            Object.freeze(this);
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $esaJO.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // Multiscalar Multiplication
        static msm(points, scalars) {
            return (0, $lkFCe.pippenger)(Point, Fn, points, scalars);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            wnaf.setWindowSize(this, windowSize);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            assertValidMemo(this);
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $c3b91d553ab14e64$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $c3b91d553ab14e64$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, n, Point.normalizeZ);
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(sc) {
            const { endo: endo, n: N } = CURVE;
            $esaJO.aInRange("scalar", sc, $c3b91d553ab14e64$var$_0n, N);
            const I = Point.ZERO;
            if (sc === $c3b91d553ab14e64$var$_0n) return I;
            if (this.is0() || sc === $c3b91d553ab14e64$var$_1n) return this;
            // Case a: no endomorphism. Case b: has precomputes.
            if (!endo || wnaf.hasPrecomputes(this)) return wnaf.wNAFCachedUnsafe(this, sc, Point.normalizeZ);
            // Case c: endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(sc);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $c3b91d553ab14e64$var$_0n || k2 > $c3b91d553ab14e64$var$_0n){
                if (k1 & $c3b91d553ab14e64$var$_1n) k1p = k1p.add(d);
                if (k2 & $c3b91d553ab14e64$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $c3b91d553ab14e64$var$_1n;
                k2 >>= $c3b91d553ab14e64$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            const { endo: endo, n: N } = CURVE;
            $esaJO.aInRange("scalar", scalar, $c3b91d553ab14e64$var$_1n, N);
            let point, fake; // Fake point is used to const-time mult
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(scalar);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(scalar);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $c3b91d553ab14e64$var$_0n || a === $c3b91d553ab14e64$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            return toAffineMemo(this, iz);
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $c3b91d553ab14e64$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $c3b91d553ab14e64$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            (0, $esaJO.abool)("isCompressed", isCompressed);
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            (0, $esaJO.abool)("isCompressed", isCompressed);
            return $esaJO.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $lkFCe.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
function $c3b91d553ab14e64$var$validateOpts(curve) {
    const opts = (0, $lkFCe.validateBasic)(curve);
    $esaJO.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
/**
 * Creates short weierstrass curve and ECDSA signature methods for it.
 * @example
 * import { Field } from '@noble/curves/abstract/modular';
 * // Before that, define BigInt-s: a, b, p, n, Gx, Gy
 * const curve = weierstrass({ a, b, Fp: Field(p), n, Gx, Gy, h: 1n })
 */ function $c3b91d553ab14e64$var$weierstrass(curveDef) {
    const CURVE = $c3b91d553ab14e64$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function modN(a) {
        return (0, $2D9sF.mod)(a, CURVE_ORDER);
    }
    function invN(a) {
        return (0, $2D9sF.invert)(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $c3b91d553ab14e64$var$weierstrassPoints({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $esaJO.concatBytes;
            (0, $esaJO.abool)("isCompressed", isCompressed);
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $esaJO.bytesToNumberBE(tail);
                if (!$esaJO.inRange(x, $c3b91d553ab14e64$var$_1n, Fp.ORDER)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y;
                try {
                    y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                } catch (sqrtError) {
                    const suffix = sqrtError instanceof Error ? ": " + sqrtError.message : "";
                    throw new Error("Point is not on curve" + suffix);
                }
                const isYOdd = (y & $c3b91d553ab14e64$var$_1n) === $c3b91d553ab14e64$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else {
                const cl = compressedLen;
                const ul = uncompressedLen;
                throw new Error("invalid Point, expected length of " + cl + ", or uncompressed " + ul + ", got " + len);
            }
        }
    });
    const numToNByteStr = (num)=>$esaJO.bytesToHex($esaJO.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $c3b91d553ab14e64$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$esaJO.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $esaJO.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $c3b91d553ab14e64$exports.DER.toSig((0, $esaJO.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            $esaJO.aInRange("r", this.r, $c3b91d553ab14e64$var$_1n, CURVE_ORDER); // r in [1..N]
            $esaJO.aInRange("s", this.s, $c3b91d553ab14e64$var$_1n, CURVE_ORDER); // s in [1..N]
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $esaJO.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $esaJO.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return $c3b91d553ab14e64$exports.DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $esaJO.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = (0, $2D9sF.getMinHashLength)(CURVE.n);
            return (0, $2D9sF.mapHashToField)(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = $esaJO.isBytes(item);
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // Our custom check "just in case"
        if (bytes.length > 8192) throw new Error("input is too large");
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $esaJO.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $esaJO.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        $esaJO.aInRange("num < 2^" + CURVE.nBitLength, num, $c3b91d553ab14e64$var$_0n, ORDER_MASK);
        // works with order, can have different size than numToField!
        return $esaJO.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order,
    // this will be invalid at least for P521. Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $esaJO.ensureBytes)("msgHash", msgHash);
        $c3b91d553ab14e64$var$validateSigVerOpts(opts);
        if (prehash) msgHash = (0, $esaJO.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null && ent !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $esaJO.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $esaJO.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $c3b91d553ab14e64$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $c3b91d553ab14e64$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $c3b91d553ab14e64$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $esaJO.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $esaJO.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $esaJO.ensureBytes)("publicKey", publicKey);
        const { lowS: lowS, prehash: prehash, format: format } = opts;
        // Verify opts, deduce signature format
        $c3b91d553ab14e64$var$validateSigVerOpts(opts);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        if (format !== undefined && format !== "compact" && format !== "der") throw new Error("format must be compact or der");
        const isHex = typeof sg === "string" || $esaJO.isBytes(sg);
        const isObj = !isHex && !format && typeof sg === "object" && sg !== null && typeof sg.r === "bigint" && typeof sg.s === "bigint";
        if (!isHex && !isObj) throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
        let _sig = undefined;
        let P;
        try {
            if (isObj) _sig = new Signature(sg.r, sg.s);
            if (isHex) {
                // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
                // Since DER can also be 2*nByteLength bytes, we check for it first.
                try {
                    if (format !== "compact") _sig = Signature.fromDER(sg);
                } catch (derError) {
                    if (!(derError instanceof $c3b91d553ab14e64$exports.DER.Err)) throw derError;
                }
                if (!_sig && format !== "der") _sig = Signature.fromCompact(sg);
            }
            P = Point.fromHex(publicKey);
        } catch (error) {
            return false;
        }
        if (!_sig) return false;
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function $c3b91d553ab14e64$var$SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $c3b91d553ab14e64$var$_0n;
    for(let o = q - $c3b91d553ab14e64$var$_1n; o % $c3b91d553ab14e64$var$_2n === $c3b91d553ab14e64$var$_0n; o /= $c3b91d553ab14e64$var$_2n)l += $c3b91d553ab14e64$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $c3b91d553ab14e64$var$_2n << c1 - $c3b91d553ab14e64$var$_1n - $c3b91d553ab14e64$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $c3b91d553ab14e64$var$_2n;
    const c2 = (q - $c3b91d553ab14e64$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $c3b91d553ab14e64$var$_1n) / $c3b91d553ab14e64$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $c3b91d553ab14e64$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $c3b91d553ab14e64$var$_1n) / $c3b91d553ab14e64$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $c3b91d553ab14e64$var$_1n; i--){
            let tv5 = i - $c3b91d553ab14e64$var$_2n; // 18.    tv5 = i - 2
            tv5 = $c3b91d553ab14e64$var$_2n << tv5 - $c3b91d553ab14e64$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $c3b91d553ab14e64$var$_4n === $c3b91d553ab14e64$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $c3b91d553ab14e64$var$_3n) / $c3b91d553ab14e64$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function $c3b91d553ab14e64$var$mapToCurveSimpleSWU(Fp, opts) {
    (0, $2D9sF.validateField)(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $c3b91d553ab14e64$var$SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}


/** connects noble-curves to noble-hashes */ function $5af70d1c5fca3e4e$var$getHash(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $51b6b372898f65c0$exports.hmac)(hash, key, (0, $29ee4d3171d9809b$exports.concatBytes)(...msgs)),
        randomBytes: $29ee4d3171d9809b$exports.randomBytes
    };
}
function $5af70d1c5fca3e4e$var$createCurve(curveDef, defHash) {
    const create = (hash)=>(0, $c3b91d553ab14e64$exports.weierstrass)({
            ...curveDef,
            ...$5af70d1c5fca3e4e$var$getHash(hash)
        });
    return {
        ...create(defHash),
        create: create
    };
}


var $0522aeca5769187c$exports = {};
"use strict";
Object.defineProperty($0522aeca5769187c$exports, "__esModule", {
    value: true
});
$0522aeca5769187c$exports.expand_message_xmd = $0522aeca5769187c$var$expand_message_xmd;
$0522aeca5769187c$exports.expand_message_xof = $0522aeca5769187c$var$expand_message_xof;
$0522aeca5769187c$exports.hash_to_field = $0522aeca5769187c$var$hash_to_field;
$0522aeca5769187c$exports.isogenyMap = $0522aeca5769187c$var$isogenyMap;
$0522aeca5769187c$exports.createHasher = $0522aeca5769187c$var$createHasher;

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $0522aeca5769187c$var$os2ip = $esaJO.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function $0522aeca5769187c$var$i2osp(value, length) {
    $0522aeca5769187c$var$anum(value);
    $0522aeca5769187c$var$anum(length);
    if (value < 0 || value >= 1 << 8 * length) throw new Error("invalid I2OSP input: " + value);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $0522aeca5769187c$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $0522aeca5769187c$var$anum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
/**
 * Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits.
 * [RFC 9380 5.3.1](https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1).
 */ function $0522aeca5769187c$var$expand_message_xmd(msg, DST, lenInBytes, H) {
    (0, $esaJO.abytes)(msg);
    (0, $esaJO.abytes)(DST);
    $0522aeca5769187c$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $esaJO.concatBytes)((0, $esaJO.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (lenInBytes > 65535 || ell > 255) throw new Error("expand_message_xmd: invalid lenInBytes");
    const DST_prime = (0, $esaJO.concatBytes)(DST, $0522aeca5769187c$var$i2osp(DST.length, 1));
    const Z_pad = $0522aeca5769187c$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $0522aeca5769187c$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $esaJO.concatBytes)(Z_pad, msg, l_i_b_str, $0522aeca5769187c$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $esaJO.concatBytes)(b_0, $0522aeca5769187c$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $0522aeca5769187c$var$strxor(b_0, b[i - 1]),
            $0522aeca5769187c$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $esaJO.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $esaJO.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
/**
 * Produces a uniformly random byte string using an extendable-output function (XOF) H.
 * 1. The collision resistance of H MUST be at least k bits.
 * 2. H MUST be an XOF that has been proved indifferentiable from
 *    a random oracle under a reasonable cryptographic assumption.
 * [RFC 9380 5.3.2](https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2).
 */ function $0522aeca5769187c$var$expand_message_xof(msg, DST, lenInBytes, k, H) {
    (0, $esaJO.abytes)(msg);
    (0, $esaJO.abytes)(DST);
    $0522aeca5769187c$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $esaJO.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($0522aeca5769187c$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($0522aeca5769187c$var$i2osp(DST.length, 1)).digest();
}
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F.
 * [RFC 9380 5.2](https://www.rfc-editor.org/rfc/rfc9380#section-5.2).
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function $0522aeca5769187c$var$hash_to_field(msg, count, options) {
    (0, $esaJO.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    (0, $esaJO.abytes)(msg);
    $0522aeca5769187c$var$anum(count);
    const DST = typeof _DST === "string" ? (0, $esaJO.utf8ToBytes)(_DST) : _DST;
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $0522aeca5769187c$var$expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $0522aeca5769187c$var$expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $2D9sF.mod)($0522aeca5769187c$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $0522aeca5769187c$var$isogenyMap(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
/** Creates hash-to-curve methods from EC Point and mapToCurve function. */ function $0522aeca5769187c$var$createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $0522aeca5769187c$var$hash_to_field(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $0522aeca5769187c$var$hash_to_field(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Same as encodeToCurve, but without hash
        mapToCurve (scalars) {
            if (!Array.isArray(scalars)) throw new Error("mapToCurve: expected array of bigints");
            for (const i of scalars)if (typeof i !== "bigint") throw new Error("mapToCurve: expected array of bigints");
            const P = Point.fromAffine(mapToCurve(scalars)).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}



var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");

const $3f551179096121b9$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $3f551179096121b9$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $3f551179096121b9$var$_1n = BigInt(1);
const $3f551179096121b9$var$_2n = BigInt(2);
const $3f551179096121b9$var$divNearest = (a, b)=>(a + b / $3f551179096121b9$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $3f551179096121b9$var$sqrtMod(y) {
    const P = $3f551179096121b9$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $2D9sF.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $2D9sF.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $2D9sF.pow2)(b9, $3f551179096121b9$var$_2n, P) * b2 % P;
    const b22 = (0, $2D9sF.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $2D9sF.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $2D9sF.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $2D9sF.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $2D9sF.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $2D9sF.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $2D9sF.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $2D9sF.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $2D9sF.pow2)(t2, $3f551179096121b9$var$_2n, P);
    if (!$3f551179096121b9$var$Fpk1.eql($3f551179096121b9$var$Fpk1.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $3f551179096121b9$var$Fpk1 = (0, $2D9sF.Field)($3f551179096121b9$var$secp256k1P, undefined, undefined, {
    sqrt: $3f551179096121b9$var$sqrtMod
});
/**
 * secp256k1 short weierstrass curve and ECDSA signatures over it.
 *
 * @example
 * import { secp256k1 } from '@noble/curves/secp256k1';
 *
 * const priv = secp256k1.utils.randomPrivateKey();
 * const pub = secp256k1.getPublicKey(priv);
 * const msg = new Uint8Array(32).fill(1); // message hash (not message) in ecdsa
 * const sig = secp256k1.sign(msg, priv); // `{prehash: true}` option is available
 * const isValid = secp256k1.verify(sig, msg, pub) === true;
 */ $3f551179096121b9$exports.secp256k1 = (0, $5af70d1c5fca3e4e$exports.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $3f551179096121b9$var$Fpk1,
    n: $3f551179096121b9$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    endo: {
        // Endomorphism, see above
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $3f551179096121b9$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$3f551179096121b9$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $3f551179096121b9$var$divNearest(b2 * k, n);
            const c2 = $3f551179096121b9$var$divNearest(-b1 * k, n);
            let k1 = (0, $2D9sF.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $2D9sF.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, $510ad3657d73a9d2$exports.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $3f551179096121b9$var$_0n = BigInt(0);
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $3f551179096121b9$var$TAGGED_HASH_PREFIXES = {};
function $3f551179096121b9$var$taggedHash(tag, ...messages) {
    let tagP = $3f551179096121b9$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $510ad3657d73a9d2$exports.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $esaJO.concatBytes)(tagH, tagH);
        $3f551179096121b9$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $510ad3657d73a9d2$exports.sha256)((0, $esaJO.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $3f551179096121b9$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $3f551179096121b9$var$numTo32b = (n)=>(0, $esaJO.numberToBytesBE)(n, 32);
const $3f551179096121b9$var$modP = (x)=>(0, $2D9sF.mod)(x, $3f551179096121b9$var$secp256k1P);
const $3f551179096121b9$var$modN = (x)=>(0, $2D9sF.mod)(x, $3f551179096121b9$var$secp256k1N);
const $3f551179096121b9$var$Point = $3f551179096121b9$exports.secp256k1.ProjectivePoint;
const $3f551179096121b9$var$GmulAdd = (Q, a, b)=>$3f551179096121b9$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $3f551179096121b9$var$schnorrGetExtPubKey(priv) {
    let d_ = $3f551179096121b9$exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $3f551179096121b9$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $3f551179096121b9$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $3f551179096121b9$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $3f551179096121b9$var$lift_x(x) {
    (0, $esaJO.aInRange)("x", x, $3f551179096121b9$var$_1n, $3f551179096121b9$var$secp256k1P); // Fail if x ≥ p.
    const xx = $3f551179096121b9$var$modP(x * x);
    const c = $3f551179096121b9$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $3f551179096121b9$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $3f551179096121b9$var$_2n !== $3f551179096121b9$var$_0n) y = $3f551179096121b9$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $3f551179096121b9$var$Point(x, y, $3f551179096121b9$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
const $3f551179096121b9$var$num = $esaJO.bytesToNumberBE;
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $3f551179096121b9$var$challenge(...args) {
    return $3f551179096121b9$var$modN($3f551179096121b9$var$num($3f551179096121b9$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $3f551179096121b9$var$schnorrGetPublicKey(privateKey) {
    return $3f551179096121b9$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $3f551179096121b9$var$schnorrSign(message, privateKey, auxRand = (0, $29ee4d3171d9809b$exports.randomBytes)(32)) {
    const m = (0, $esaJO.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $3f551179096121b9$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $esaJO.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $3f551179096121b9$var$numTo32b(d ^ $3f551179096121b9$var$num($3f551179096121b9$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $3f551179096121b9$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $3f551179096121b9$var$modN($3f551179096121b9$var$num(rand)); // Let k' = int(rand) mod n
    if (k_ === $3f551179096121b9$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $3f551179096121b9$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $3f551179096121b9$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($3f551179096121b9$var$numTo32b($3f551179096121b9$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$3f551179096121b9$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $3f551179096121b9$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $esaJO.ensureBytes)("signature", signature, 64);
    const m = (0, $esaJO.ensureBytes)("message", message);
    const pub = (0, $esaJO.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $3f551179096121b9$var$lift_x($3f551179096121b9$var$num(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = $3f551179096121b9$var$num(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!(0, $esaJO.inRange)(r, $3f551179096121b9$var$_1n, $3f551179096121b9$var$secp256k1P)) return false;
        const s = $3f551179096121b9$var$num(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!(0, $esaJO.inRange)(s, $3f551179096121b9$var$_1n, $3f551179096121b9$var$secp256k1N)) return false;
        const e = $3f551179096121b9$var$challenge($3f551179096121b9$var$numTo32b(r), $3f551179096121b9$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $3f551179096121b9$var$GmulAdd(P, s, $3f551179096121b9$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
/**
 * Schnorr signatures over secp256k1.
 * https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
 * @example
 * import { schnorr } from '@noble/curves/secp256k1';
 * const priv = schnorr.utils.randomPrivateKey();
 * const pub = schnorr.getPublicKey(priv);
 * const msg = new TextEncoder().encode('hello');
 * const sig = schnorr.sign(msg, priv);
 * const isValid = schnorr.verify(sig, msg, pub);
 */ $3f551179096121b9$exports.schnorr = (()=>({
        getPublicKey: $3f551179096121b9$var$schnorrGetPublicKey,
        sign: $3f551179096121b9$var$schnorrSign,
        verify: $3f551179096121b9$var$schnorrVerify,
        utils: {
            randomPrivateKey: $3f551179096121b9$exports.secp256k1.utils.randomPrivateKey,
            lift_x: $3f551179096121b9$var$lift_x,
            pointToBytes: $3f551179096121b9$var$pointToBytes,
            numberToBytesBE: $esaJO.numberToBytesBE,
            bytesToNumberBE: $esaJO.bytesToNumberBE,
            taggedHash: $3f551179096121b9$var$taggedHash,
            mod: $2D9sF.mod
        }
    }))();
const $3f551179096121b9$var$isoMap = /* @__PURE__ */ (()=>(0, $0522aeca5769187c$exports.isogenyMap)($3f551179096121b9$var$Fpk1, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $3f551179096121b9$var$mapSWU = /* @__PURE__ */ (()=>(0, $c3b91d553ab14e64$exports.mapToCurveSimpleSWU)($3f551179096121b9$var$Fpk1, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $3f551179096121b9$var$Fpk1.create(BigInt("-11"))
    }))();
const $3f551179096121b9$var$htf = /* @__PURE__ */ (()=>(0, $0522aeca5769187c$exports.createHasher)($3f551179096121b9$exports.secp256k1.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $3f551179096121b9$var$mapSWU($3f551179096121b9$var$Fpk1.create(scalars[0]));
        return $3f551179096121b9$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $3f551179096121b9$var$Fpk1.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: $510ad3657d73a9d2$exports.sha256
    }))();
/** secp256k1 hash-to-curve from [RFC 9380](https://www.rfc-editor.org/rfc/rfc9380). */ $3f551179096121b9$exports.hashToCurve = (()=>$3f551179096121b9$var$htf.hashToCurve)();
/** secp256k1 encode-to-curve from [RFC 9380](https://www.rfc-editor.org/rfc/rfc9380). */ $3f551179096121b9$exports.encodeToCurve = (()=>$3f551179096121b9$var$htf.encodeToCurve)();



var $2D9sF = parcelRequire("2D9sF");
/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */ function $3600b4829dff8fa9$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
function $3600b4829dff8fa9$var$isArrayOf(isString, arr) {
    if (!Array.isArray(arr)) return false;
    if (arr.length === 0) return true;
    if (isString) return arr.every((item)=>typeof item === "string");
    else return arr.every((item)=>Number.isSafeInteger(item));
}
// no abytes: seems to have 10% slowdown. Why?!
function $3600b4829dff8fa9$var$afn(input) {
    if (typeof input !== "function") throw new Error("function expected");
    return true;
}
function $3600b4829dff8fa9$var$astr(label, input) {
    if (typeof input !== "string") throw new Error(`${label}: string expected`);
    return true;
}
function $3600b4829dff8fa9$var$anumber(n) {
    if (!Number.isSafeInteger(n)) throw new Error(`invalid integer: ${n}`);
}
const $3600b4829dff8fa9$export$dfbcecb440255e4a = $3600b4829dff8fa9$var$anumber;
function $3600b4829dff8fa9$var$aArr(input) {
    if (!Array.isArray(input)) throw new Error("array expected");
}
function $3600b4829dff8fa9$var$astrArr(label, input) {
    if (!$3600b4829dff8fa9$var$isArrayOf(true, input)) throw new Error(`${label}: array of strings expected`);
}
function $3600b4829dff8fa9$var$anumArr(label, input) {
    if (!$3600b4829dff8fa9$var$isArrayOf(false, input)) throw new Error(`${label}: array of numbers expected`);
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$chain(...args) {
    const id = (a)=>a;
    // Wrap call in closure so JIT can inline calls
    const wrap = (a, b)=>(c)=>a(b(c));
    // Construct chain of args[-1].encode(args[-2].encode([...]))
    const encode = args.map((x)=>x.encode).reduceRight(wrap, id);
    // Construct chain of args[0].decode(args[1].decode(...))
    const decode = args.map((x)=>x.decode).reduce(wrap, id);
    return {
        encode: encode,
        decode: decode
    };
}
/**
 * Encodes integer radix representation to array of strings using alphabet and back.
 * Could also be array of strings.
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$alphabet(letters) {
    // mapping 1 to "b"
    const lettersA = typeof letters === "string" ? letters.split("") : letters;
    const len = lettersA.length;
    $3600b4829dff8fa9$var$astrArr("alphabet", lettersA);
    // mapping "b" to 1
    const indexes = new Map(lettersA.map((l, i)=>[
            l,
            i
        ]));
    return {
        encode: (digits)=>{
            $3600b4829dff8fa9$var$aArr(digits);
            return digits.map((i)=>{
                if (!Number.isSafeInteger(i) || i < 0 || i >= len) throw new Error(`alphabet.encode: digit index outside alphabet "${i}". Allowed: ${letters}`);
                return lettersA[i];
            });
        },
        decode: (input)=>{
            $3600b4829dff8fa9$var$aArr(input);
            return input.map((letter)=>{
                $3600b4829dff8fa9$var$astr("alphabet.decode", letter);
                const i = indexes.get(letter);
                if (i === undefined) throw new Error(`Unknown letter: "${letter}". Allowed: ${letters}`);
                return i;
            });
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$join(separator = "") {
    $3600b4829dff8fa9$var$astr("join", separator);
    return {
        encode: (from)=>{
            $3600b4829dff8fa9$var$astrArr("join.decode", from);
            return from.join(separator);
        },
        decode: (to)=>{
            $3600b4829dff8fa9$var$astr("join.decode", to);
            return to.split(separator);
        }
    };
}
/**
 * Pad strings array so it has integer number of bits
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$padding(bits, chr = "=") {
    $3600b4829dff8fa9$var$anumber(bits);
    $3600b4829dff8fa9$var$astr("padding", chr);
    return {
        encode (data) {
            $3600b4829dff8fa9$var$astrArr("padding.encode", data);
            while(data.length * bits % 8)data.push(chr);
            return data;
        },
        decode (input) {
            $3600b4829dff8fa9$var$astrArr("padding.decode", input);
            let end = input.length;
            if (end * bits % 8) throw new Error("padding: invalid, string should have whole number of bytes");
            for(; end > 0 && input[end - 1] === chr; end--){
                const last = end - 1;
                const byte = last * bits;
                if (byte % 8 === 0) throw new Error("padding: invalid, string has too much padding");
            }
            return input.slice(0, end);
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$normalize(fn) {
    $3600b4829dff8fa9$var$afn(fn);
    return {
        encode: (from)=>from,
        decode: (to)=>fn(to)
    };
}
/**
 * Slow: O(n^2) time complexity
 */ function $3600b4829dff8fa9$var$convertRadix(data, from, to) {
    // base 1 is impossible
    if (from < 2) throw new Error(`convertRadix: invalid from=${from}, base cannot be less than 2`);
    if (to < 2) throw new Error(`convertRadix: invalid to=${to}, base cannot be less than 2`);
    $3600b4829dff8fa9$var$aArr(data);
    if (!data.length) return [];
    let pos = 0;
    const res = [];
    const digits = Array.from(data, (d)=>{
        $3600b4829dff8fa9$var$anumber(d);
        if (d < 0 || d >= from) throw new Error(`invalid integer: ${d}`);
        return d;
    });
    const dlen = digits.length;
    while(true){
        let carry = 0;
        let done = true;
        for(let i = pos; i < dlen; i++){
            const digit = digits[i];
            const fromCarry = from * carry;
            const digitBase = fromCarry + digit;
            if (!Number.isSafeInteger(digitBase) || fromCarry / from !== carry || digitBase - digit !== fromCarry) throw new Error("convertRadix: carry overflow");
            const div = digitBase / to;
            carry = digitBase % to;
            const rounded = Math.floor(div);
            digits[i] = rounded;
            if (!Number.isSafeInteger(rounded) || rounded * to + carry !== digitBase) throw new Error("convertRadix: carry overflow");
            if (!done) continue;
            else if (!rounded) pos = i;
            else done = false;
        }
        res.push(carry);
        if (done) break;
    }
    for(let i = 0; i < data.length - 1 && data[i] === 0; i++)res.push(0);
    return res.reverse();
}
const $3600b4829dff8fa9$var$gcd = (a, b)=>b === 0 ? a : $3600b4829dff8fa9$var$gcd(b, a % b);
const $3600b4829dff8fa9$var$radix2carry = /* @__NO_SIDE_EFFECTS__ */ (from, to)=>from + (to - $3600b4829dff8fa9$var$gcd(from, to));
const $3600b4829dff8fa9$var$powers = /* @__PURE__ */ (()=>{
    let res = [];
    for(let i = 0; i < 40; i++)res.push(2 ** i);
    return res;
})();
/**
 * Implemented with numbers, because BigInt is 5x slower
 */ function $3600b4829dff8fa9$var$convertRadix2(data, from, to, padding) {
    $3600b4829dff8fa9$var$aArr(data);
    if (from <= 0 || from > 32) throw new Error(`convertRadix2: wrong from=${from}`);
    if (to <= 0 || to > 32) throw new Error(`convertRadix2: wrong to=${to}`);
    if ($3600b4829dff8fa9$var$radix2carry(from, to) > 32) throw new Error(`convertRadix2: carry overflow from=${from} to=${to} carryBits=${$3600b4829dff8fa9$var$radix2carry(from, to)}`);
    let carry = 0;
    let pos = 0; // bitwise position in current element
    const max = $3600b4829dff8fa9$var$powers[from];
    const mask = $3600b4829dff8fa9$var$powers[to] - 1;
    const res = [];
    for (const n of data){
        $3600b4829dff8fa9$var$anumber(n);
        if (n >= max) throw new Error(`convertRadix2: invalid data word=${n} from=${from}`);
        carry = carry << from | n;
        if (pos + from > 32) throw new Error(`convertRadix2: carry overflow pos=${pos} from=${from}`);
        pos += from;
        for(; pos >= to; pos -= to)res.push((carry >> pos - to & mask) >>> 0);
        const pow = $3600b4829dff8fa9$var$powers[pos];
        if (pow === undefined) throw new Error("invalid carry");
        carry &= pow - 1; // clean carry, otherwise it will cause overflow
    }
    carry = carry << to - pos & mask;
    if (!padding && pos >= from) throw new Error("Excess padding");
    if (!padding && carry > 0) throw new Error(`Non-zero padding: ${carry}`);
    if (padding && pos > 0) res.push(carry >>> 0);
    return res;
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$radix(num) {
    $3600b4829dff8fa9$var$anumber(num);
    const _256 = 256;
    return {
        encode: (bytes)=>{
            if (!$3600b4829dff8fa9$var$isBytes(bytes)) throw new Error("radix.encode input should be Uint8Array");
            return $3600b4829dff8fa9$var$convertRadix(Array.from(bytes), _256, num);
        },
        decode: (digits)=>{
            $3600b4829dff8fa9$var$anumArr("radix.decode", digits);
            return Uint8Array.from($3600b4829dff8fa9$var$convertRadix(digits, num, _256));
        }
    };
}
/**
 * If both bases are power of same number (like `2**8 <-> 2**64`),
 * there is a linear algorithm. For now we have implementation for power-of-two bases only.
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$radix2(bits, revPadding = false) {
    $3600b4829dff8fa9$var$anumber(bits);
    if (bits <= 0 || bits > 32) throw new Error("radix2: bits should be in (0..32]");
    if ($3600b4829dff8fa9$var$radix2carry(8, bits) > 32 || $3600b4829dff8fa9$var$radix2carry(bits, 8) > 32) throw new Error("radix2: carry overflow");
    return {
        encode: (bytes)=>{
            if (!$3600b4829dff8fa9$var$isBytes(bytes)) throw new Error("radix2.encode input should be Uint8Array");
            return $3600b4829dff8fa9$var$convertRadix2(Array.from(bytes), 8, bits, !revPadding);
        },
        decode: (digits)=>{
            $3600b4829dff8fa9$var$anumArr("radix2.decode", digits);
            return Uint8Array.from($3600b4829dff8fa9$var$convertRadix2(digits, bits, 8, revPadding));
        }
    };
}
function $3600b4829dff8fa9$var$unsafeWrapper(fn) {
    $3600b4829dff8fa9$var$afn(fn);
    return function(...args) {
        try {
            return fn.apply(null, args);
        } catch (e) {}
    };
}
function $3600b4829dff8fa9$var$checksum(len, fn) {
    $3600b4829dff8fa9$var$anumber(len);
    $3600b4829dff8fa9$var$afn(fn);
    return {
        encode (data) {
            if (!$3600b4829dff8fa9$var$isBytes(data)) throw new Error("checksum.encode: input should be Uint8Array");
            const sum = fn(data).slice(0, len);
            const res = new Uint8Array(data.length + len);
            res.set(data);
            res.set(sum, data.length);
            return res;
        },
        decode (data) {
            if (!$3600b4829dff8fa9$var$isBytes(data)) throw new Error("checksum.decode: input should be Uint8Array");
            const payload = data.slice(0, -len);
            const oldChecksum = data.slice(-len);
            const newChecksum = fn(payload).slice(0, len);
            for(let i = 0; i < len; i++)if (newChecksum[i] !== oldChecksum[i]) throw new Error("Invalid checksum");
            return payload;
        }
    };
}
const $3600b4829dff8fa9$export$eab97d15b1788b8d = {
    alphabet: $3600b4829dff8fa9$var$alphabet,
    chain: $3600b4829dff8fa9$var$chain,
    checksum: $3600b4829dff8fa9$var$checksum,
    convertRadix: $3600b4829dff8fa9$var$convertRadix,
    convertRadix2: $3600b4829dff8fa9$var$convertRadix2,
    radix: $3600b4829dff8fa9$var$radix,
    radix2: $3600b4829dff8fa9$var$radix2,
    join: $3600b4829dff8fa9$var$join,
    padding: $3600b4829dff8fa9$var$padding
};
const $3600b4829dff8fa9$export$586f61c71cb02fe4 = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(4), $3600b4829dff8fa9$var$alphabet("0123456789ABCDEF"), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$export$4a4d5965e2738b2a = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(5), $3600b4829dff8fa9$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), $3600b4829dff8fa9$var$padding(5), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$export$e077e39445e9b6db = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(5), $3600b4829dff8fa9$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$export$c57d6760d519c8ac = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(5), $3600b4829dff8fa9$var$alphabet("0123456789ABCDEFGHIJKLMNOPQRSTUV"), $3600b4829dff8fa9$var$padding(5), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$export$e37c85831a779eb9 = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(5), $3600b4829dff8fa9$var$alphabet("0123456789ABCDEFGHIJKLMNOPQRSTUV"), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$export$5fbcb08925249358 = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(5), $3600b4829dff8fa9$var$alphabet("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), $3600b4829dff8fa9$var$join(""), $3600b4829dff8fa9$var$normalize((s)=>s.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1")));
const $3600b4829dff8fa9$export$b3b2de96497acc47 = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(6), $3600b4829dff8fa9$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), $3600b4829dff8fa9$var$padding(6), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$export$c907e660b9401ec7 = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(6), $3600b4829dff8fa9$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$export$7d21597c7bc64465 = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(6), $3600b4829dff8fa9$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), $3600b4829dff8fa9$var$padding(6), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$export$963cd24a38dd2f90 = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(6), $3600b4829dff8fa9$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), $3600b4829dff8fa9$var$join(""));
// base58 code
// -----------
const $3600b4829dff8fa9$var$genBase58 = /* @__NO_SIDE_EFFECTS__ */ (abc)=>$3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix(58), $3600b4829dff8fa9$var$alphabet(abc), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$export$61f53211c069eefb = $3600b4829dff8fa9$var$genBase58("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
const $3600b4829dff8fa9$export$c6a7baed2941aad2 = $3600b4829dff8fa9$var$genBase58("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ");
const $3600b4829dff8fa9$export$cbd4c72942a9201d = $3600b4829dff8fa9$var$genBase58("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz");
// Data len (index) -> encoded block len
const $3600b4829dff8fa9$var$XMR_BLOCK_LEN = [
    0,
    2,
    3,
    5,
    6,
    7,
    9,
    10,
    11
];
const $3600b4829dff8fa9$export$e86cd8e7f8cff4a6 = {
    encode (data) {
        let res = "";
        for(let i = 0; i < data.length; i += 8){
            const block = data.subarray(i, i + 8);
            res += $3600b4829dff8fa9$export$61f53211c069eefb.encode(block).padStart($3600b4829dff8fa9$var$XMR_BLOCK_LEN[block.length], "1");
        }
        return res;
    },
    decode (str) {
        let res = [];
        for(let i = 0; i < str.length; i += 11){
            const slice = str.slice(i, i + 11);
            const blockLen = $3600b4829dff8fa9$var$XMR_BLOCK_LEN.indexOf(slice.length);
            const block = $3600b4829dff8fa9$export$61f53211c069eefb.decode(slice);
            for(let j = 0; j < block.length - blockLen; j++){
                if (block[j] !== 0) throw new Error("base58xmr: wrong padding");
            }
            res = res.concat(Array.from(block.slice(block.length - blockLen)));
        }
        return Uint8Array.from(res);
    }
};
const $3600b4829dff8fa9$export$2217e0412f7b06b6 = (sha256)=>$3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$checksum(4, (data)=>sha256(sha256(data))), $3600b4829dff8fa9$export$61f53211c069eefb);
const $3600b4829dff8fa9$export$fff625c574161df6 = $3600b4829dff8fa9$export$2217e0412f7b06b6;
const $3600b4829dff8fa9$var$BECH_ALPHABET = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$alphabet("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$var$POLYMOD_GENERATORS = [
    0x3b6a57b2,
    0x26508e6d,
    0x1ea119fa,
    0x3d4233dd,
    0x2a1462b3
];
function $3600b4829dff8fa9$var$bech32Polymod(pre) {
    const b = pre >> 25;
    let chk = (pre & 0x1ffffff) << 5;
    for(let i = 0; i < $3600b4829dff8fa9$var$POLYMOD_GENERATORS.length; i++)if ((b >> i & 1) === 1) chk ^= $3600b4829dff8fa9$var$POLYMOD_GENERATORS[i];
    return chk;
}
function $3600b4829dff8fa9$var$bechChecksum(prefix, words, encodingConst = 1) {
    const len = prefix.length;
    let chk = 1;
    for(let i = 0; i < len; i++){
        const c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) throw new Error(`Invalid prefix (${prefix})`);
        chk = $3600b4829dff8fa9$var$bech32Polymod(chk) ^ c >> 5;
    }
    chk = $3600b4829dff8fa9$var$bech32Polymod(chk);
    for(let i = 0; i < len; i++)chk = $3600b4829dff8fa9$var$bech32Polymod(chk) ^ prefix.charCodeAt(i) & 0x1f;
    for (let v of words)chk = $3600b4829dff8fa9$var$bech32Polymod(chk) ^ v;
    for(let i = 0; i < 6; i++)chk = $3600b4829dff8fa9$var$bech32Polymod(chk);
    chk ^= encodingConst;
    return $3600b4829dff8fa9$var$BECH_ALPHABET.encode($3600b4829dff8fa9$var$convertRadix2([
        chk % $3600b4829dff8fa9$var$powers[30]
    ], 30, 5, false));
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$genBech32(encoding) {
    const ENCODING_CONST = encoding === "bech32" ? 1 : 0x2bc830a3;
    const _words = $3600b4829dff8fa9$var$radix2(5);
    const fromWords = _words.decode;
    const toWords = _words.encode;
    const fromWordsUnsafe = $3600b4829dff8fa9$var$unsafeWrapper(fromWords);
    function encode(prefix, words, limit = 90) {
        $3600b4829dff8fa9$var$astr("bech32.encode prefix", prefix);
        if ($3600b4829dff8fa9$var$isBytes(words)) words = Array.from(words);
        $3600b4829dff8fa9$var$anumArr("bech32.encode", words);
        const plen = prefix.length;
        if (plen === 0) throw new TypeError(`Invalid prefix length ${plen}`);
        const actualLength = plen + 7 + words.length;
        if (limit !== false && actualLength > limit) throw new TypeError(`Length ${actualLength} exceeds limit ${limit}`);
        const lowered = prefix.toLowerCase();
        const sum = $3600b4829dff8fa9$var$bechChecksum(lowered, words, ENCODING_CONST);
        return `${lowered}1${$3600b4829dff8fa9$var$BECH_ALPHABET.encode(words)}${sum}`;
    }
    function decode(str, limit = 90) {
        $3600b4829dff8fa9$var$astr("bech32.decode input", str);
        const slen = str.length;
        if (slen < 8 || limit !== false && slen > limit) throw new TypeError(`invalid string length: ${slen} (${str}). Expected (8..${limit})`);
        // don't allow mixed case
        const lowered = str.toLowerCase();
        if (str !== lowered && str !== str.toUpperCase()) throw new Error(`String must be lowercase or uppercase`);
        const sepIndex = lowered.lastIndexOf("1");
        if (sepIndex === 0 || sepIndex === -1) throw new Error(`Letter "1" must be present between prefix and data only`);
        const prefix = lowered.slice(0, sepIndex);
        const data = lowered.slice(sepIndex + 1);
        if (data.length < 6) throw new Error("Data must be at least 6 characters long");
        const words = $3600b4829dff8fa9$var$BECH_ALPHABET.decode(data).slice(0, -6);
        const sum = $3600b4829dff8fa9$var$bechChecksum(prefix, words, ENCODING_CONST);
        if (!data.endsWith(sum)) throw new Error(`Invalid checksum in ${str}: expected "${sum}"`);
        return {
            prefix: prefix,
            words: words
        };
    }
    const decodeUnsafe = $3600b4829dff8fa9$var$unsafeWrapper(decode);
    function decodeToBytes(str) {
        const { prefix: prefix, words: words } = decode(str, false);
        return {
            prefix: prefix,
            words: words,
            bytes: fromWords(words)
        };
    }
    function encodeFromBytes(prefix, bytes) {
        return encode(prefix, toWords(bytes));
    }
    return {
        encode: encode,
        decode: decode,
        encodeFromBytes: encodeFromBytes,
        decodeToBytes: decodeToBytes,
        decodeUnsafe: decodeUnsafe,
        fromWords: fromWords,
        fromWordsUnsafe: fromWordsUnsafe,
        toWords: toWords
    };
}
const $3600b4829dff8fa9$export$27c42482533637da = $3600b4829dff8fa9$var$genBech32("bech32");
const $3600b4829dff8fa9$export$4963f7e473ccf819 = $3600b4829dff8fa9$var$genBech32("bech32m");
const $3600b4829dff8fa9$export$74329b762b589566 = {
    encode: (data)=>new TextDecoder().decode(data),
    decode: (str)=>new TextEncoder().encode(str)
};
const $3600b4829dff8fa9$export$834dfc94dde4b3d8 = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(4), $3600b4829dff8fa9$var$alphabet("0123456789abcdef"), $3600b4829dff8fa9$var$join(""), $3600b4829dff8fa9$var$normalize((s)=>{
    if (typeof s !== "string" || s.length % 2 !== 0) throw new TypeError(`hex.decode: expected string, got ${typeof s} with length ${s.length}`);
    return s.toLowerCase();
}));
// prettier-ignore
const $3600b4829dff8fa9$var$CODERS = {
    utf8: $3600b4829dff8fa9$export$74329b762b589566,
    hex: $3600b4829dff8fa9$export$834dfc94dde4b3d8,
    base16: $3600b4829dff8fa9$export$586f61c71cb02fe4,
    base32: $3600b4829dff8fa9$export$4a4d5965e2738b2a,
    base64: $3600b4829dff8fa9$export$b3b2de96497acc47,
    base64url: $3600b4829dff8fa9$export$7d21597c7bc64465,
    base58: $3600b4829dff8fa9$export$61f53211c069eefb,
    base58xmr: $3600b4829dff8fa9$export$e86cd8e7f8cff4a6
};
const $3600b4829dff8fa9$var$coderTypeError = "Invalid encoding type. Available types: utf8, hex, base16, base32, base64, base64url, base58, base58xmr";
const $3600b4829dff8fa9$export$7c746b75f47c9c7d = (type, bytes)=>{
    if (typeof type !== "string" || !$3600b4829dff8fa9$var$CODERS.hasOwnProperty(type)) throw new TypeError($3600b4829dff8fa9$var$coderTypeError);
    if (!$3600b4829dff8fa9$var$isBytes(bytes)) throw new TypeError("bytesToString() expects Uint8Array");
    return $3600b4829dff8fa9$var$CODERS[type].encode(bytes);
};
const $3600b4829dff8fa9$export$42d51816ce590c93 = $3600b4829dff8fa9$export$7c746b75f47c9c7d; // as in python, but for bytes only
const $3600b4829dff8fa9$export$c8dd6bc66a63753c = (type, str)=>{
    if (!$3600b4829dff8fa9$var$CODERS.hasOwnProperty(type)) throw new TypeError($3600b4829dff8fa9$var$coderTypeError);
    if (typeof str !== "string") throw new TypeError("stringToBytes() expects string");
    return $3600b4829dff8fa9$var$CODERS[type].decode(str);
};
const $3600b4829dff8fa9$export$b3317979f9250576 = $3600b4829dff8fa9$export$c8dd6bc66a63753c;


const $c1c39050bd418416$var$Point = (0, $3f551179096121b9$exports.secp256k1).ProjectivePoint;
const $c1c39050bd418416$var$base58check = (0, $3600b4829dff8fa9$export$2217e0412f7b06b6)((0, $510ad3657d73a9d2$exports.sha256));
function $c1c39050bd418416$var$bytesToNumber(bytes) {
    (0, $a0ae23f5901291b4$exports.abytes)(bytes);
    const h = bytes.length === 0 ? "0" : (0, $29ee4d3171d9809b$exports.bytesToHex)(bytes);
    return BigInt("0x" + h);
}
function $c1c39050bd418416$var$numberToBytes(num) {
    if (typeof num !== "bigint") throw new Error("bigint expected");
    return (0, $29ee4d3171d9809b$exports.hexToBytes)(num.toString(16).padStart(64, "0"));
}
const $c1c39050bd418416$var$MASTER_SECRET = (0, $29ee4d3171d9809b$exports.utf8ToBytes)("Bitcoin seed");
// Bitcoin hardcoded by default
const $c1c39050bd418416$var$BITCOIN_VERSIONS = {
    private: 0x0488ade4,
    public: 0x0488b21e
};
const $c1c39050bd418416$export$c16360648dc994f8 = 0x80000000;
const $c1c39050bd418416$var$hash160 = (data)=>(0, $de58877bbb165fd5$exports.ripemd160)((0, $510ad3657d73a9d2$exports.sha256)(data));
const $c1c39050bd418416$var$fromU32 = (data)=>(0, $29ee4d3171d9809b$exports.createView)(data).getUint32(0, false);
const $c1c39050bd418416$var$toU32 = (n)=>{
    if (!Number.isSafeInteger(n) || n < 0 || n > 2 ** 32 - 1) throw new Error("invalid number, should be from 0 to 2**32-1, got " + n);
    const buf = new Uint8Array(4);
    (0, $29ee4d3171d9809b$exports.createView)(buf).setUint32(0, n, false);
    return buf;
};
class $c1c39050bd418416$export$bb670963070b393a {
    get fingerprint() {
        if (!this.pubHash) throw new Error("No publicKey set!");
        return $c1c39050bd418416$var$fromU32(this.pubHash);
    }
    get identifier() {
        return this.pubHash;
    }
    get pubKeyHash() {
        return this.pubHash;
    }
    get privateKey() {
        return this.privKeyBytes || null;
    }
    get publicKey() {
        return this.pubKey || null;
    }
    get privateExtendedKey() {
        const priv = this.privateKey;
        if (!priv) throw new Error("No private key");
        return $c1c39050bd418416$var$base58check.encode(this.serialize(this.versions.private, (0, $29ee4d3171d9809b$exports.concatBytes)(new Uint8Array([
            0
        ]), priv)));
    }
    get publicExtendedKey() {
        if (!this.pubKey) throw new Error("No public key");
        return $c1c39050bd418416$var$base58check.encode(this.serialize(this.versions.public, this.pubKey));
    }
    static fromMasterSeed(seed, versions = $c1c39050bd418416$var$BITCOIN_VERSIONS) {
        (0, $a0ae23f5901291b4$exports.abytes)(seed);
        if (8 * seed.length < 128 || 8 * seed.length > 512) throw new Error("HDKey: seed length must be between 128 and 512 bits; 256 bits is advised, got " + seed.length);
        const I = (0, $51b6b372898f65c0$exports.hmac)((0, $2579977b4e52adba$exports.sha512), $c1c39050bd418416$var$MASTER_SECRET, seed);
        return new $c1c39050bd418416$export$bb670963070b393a({
            versions: versions,
            chainCode: I.slice(32),
            privateKey: I.slice(0, 32)
        });
    }
    static fromExtendedKey(base58key, versions = $c1c39050bd418416$var$BITCOIN_VERSIONS) {
        // => version(4) || depth(1) || fingerprint(4) || index(4) || chain(32) || key(33)
        const keyBuffer = $c1c39050bd418416$var$base58check.decode(base58key);
        const keyView = (0, $29ee4d3171d9809b$exports.createView)(keyBuffer);
        const version = keyView.getUint32(0, false);
        const opt = {
            versions: versions,
            depth: keyBuffer[4],
            parentFingerprint: keyView.getUint32(5, false),
            index: keyView.getUint32(9, false),
            chainCode: keyBuffer.slice(13, 45)
        };
        const key = keyBuffer.slice(45);
        const isPriv = key[0] === 0;
        if (version !== versions[isPriv ? "private" : "public"]) throw new Error("Version mismatch");
        if (isPriv) return new $c1c39050bd418416$export$bb670963070b393a({
            ...opt,
            privateKey: key.slice(1)
        });
        else return new $c1c39050bd418416$export$bb670963070b393a({
            ...opt,
            publicKey: key
        });
    }
    static fromJSON(json) {
        return $c1c39050bd418416$export$bb670963070b393a.fromExtendedKey(json.xpriv);
    }
    constructor(opt){
        this.depth = 0;
        this.index = 0;
        this.chainCode = null;
        this.parentFingerprint = 0;
        if (!opt || typeof opt !== "object") throw new Error("HDKey.constructor must not be called directly");
        this.versions = opt.versions || $c1c39050bd418416$var$BITCOIN_VERSIONS;
        this.depth = opt.depth || 0;
        this.chainCode = opt.chainCode || null;
        this.index = opt.index || 0;
        this.parentFingerprint = opt.parentFingerprint || 0;
        if (!this.depth) {
            if (this.parentFingerprint || this.index) throw new Error("HDKey: zero depth with non-zero index/parent fingerprint");
        }
        if (opt.publicKey && opt.privateKey) throw new Error("HDKey: publicKey and privateKey at same time.");
        if (opt.privateKey) {
            if (!(0, $3f551179096121b9$exports.secp256k1).utils.isValidPrivateKey(opt.privateKey)) throw new Error("Invalid private key");
            this.privKey = typeof opt.privateKey === "bigint" ? opt.privateKey : $c1c39050bd418416$var$bytesToNumber(opt.privateKey);
            this.privKeyBytes = $c1c39050bd418416$var$numberToBytes(this.privKey);
            this.pubKey = (0, $3f551179096121b9$exports.secp256k1).getPublicKey(opt.privateKey, true);
        } else if (opt.publicKey) this.pubKey = $c1c39050bd418416$var$Point.fromHex(opt.publicKey).toRawBytes(true); // force compressed point
        else throw new Error("HDKey: no public or private key provided");
        this.pubHash = $c1c39050bd418416$var$hash160(this.pubKey);
    }
    derive(path) {
        if (!/^[mM]'?/.test(path)) throw new Error('Path must start with "m" or "M"');
        if (/^[mM]'?$/.test(path)) return this;
        const parts = path.replace(/^[mM]'?\//, "").split("/");
        // tslint:disable-next-line
        let child = this;
        for (const c of parts){
            const m = /^(\d+)('?)$/.exec(c);
            const m1 = m && m[1];
            if (!m || m.length !== 3 || typeof m1 !== "string") throw new Error("invalid child index: " + c);
            let idx = +m1;
            if (!Number.isSafeInteger(idx) || idx >= $c1c39050bd418416$export$c16360648dc994f8) throw new Error("Invalid index");
            // hardened key
            if (m[2] === "'") idx += $c1c39050bd418416$export$c16360648dc994f8;
            child = child.deriveChild(idx);
        }
        return child;
    }
    deriveChild(index) {
        if (!this.pubKey || !this.chainCode) throw new Error("No publicKey or chainCode set");
        let data = $c1c39050bd418416$var$toU32(index);
        if (index >= $c1c39050bd418416$export$c16360648dc994f8) {
            // Hardened
            const priv = this.privateKey;
            if (!priv) throw new Error("Could not derive hardened child key");
            // Hardened child: 0x00 || ser256(kpar) || ser32(index)
            data = (0, $29ee4d3171d9809b$exports.concatBytes)(new Uint8Array([
                0
            ]), priv, data);
        } else // Normal child: serP(point(kpar)) || ser32(index)
        data = (0, $29ee4d3171d9809b$exports.concatBytes)(this.pubKey, data);
        const I = (0, $51b6b372898f65c0$exports.hmac)((0, $2579977b4e52adba$exports.sha512), this.chainCode, data);
        const childTweak = $c1c39050bd418416$var$bytesToNumber(I.slice(0, 32));
        const chainCode = I.slice(32);
        if (!(0, $3f551179096121b9$exports.secp256k1).utils.isValidPrivateKey(childTweak)) throw new Error("Tweak bigger than curve order");
        const opt = {
            versions: this.versions,
            chainCode: chainCode,
            depth: this.depth + 1,
            parentFingerprint: this.fingerprint,
            index: index
        };
        try {
            // Private parent key -> private child key
            if (this.privateKey) {
                const added = (0, $2D9sF.mod)(this.privKey + childTweak, (0, $3f551179096121b9$exports.secp256k1).CURVE.n);
                if (!(0, $3f551179096121b9$exports.secp256k1).utils.isValidPrivateKey(added)) throw new Error("The tweak was out of range or the resulted private key is invalid");
                opt.privateKey = added;
            } else {
                const added = $c1c39050bd418416$var$Point.fromHex(this.pubKey).add($c1c39050bd418416$var$Point.fromPrivateKey(childTweak));
                // Cryptographically impossible: hmac-sha512 preimage would need to be found
                if (added.equals($c1c39050bd418416$var$Point.ZERO)) throw new Error("The tweak was equal to negative P, which made the result key invalid");
                opt.publicKey = added.toRawBytes(true);
            }
            return new $c1c39050bd418416$export$bb670963070b393a(opt);
        } catch (err) {
            return this.deriveChild(index + 1);
        }
    }
    sign(hash) {
        if (!this.privateKey) throw new Error("No privateKey set!");
        (0, $a0ae23f5901291b4$exports.abytes)(hash, 32);
        return (0, $3f551179096121b9$exports.secp256k1).sign(hash, this.privKey).toCompactRawBytes();
    }
    verify(hash, signature) {
        (0, $a0ae23f5901291b4$exports.abytes)(hash, 32);
        (0, $a0ae23f5901291b4$exports.abytes)(signature, 64);
        if (!this.publicKey) throw new Error("No publicKey set!");
        let sig;
        try {
            sig = (0, $3f551179096121b9$exports.secp256k1).Signature.fromCompact(signature);
        } catch (error) {
            return false;
        }
        return (0, $3f551179096121b9$exports.secp256k1).verify(sig, hash, this.publicKey);
    }
    wipePrivateData() {
        this.privKey = undefined;
        if (this.privKeyBytes) {
            this.privKeyBytes.fill(0);
            this.privKeyBytes = undefined;
        }
        return this;
    }
    toJSON() {
        return {
            xpriv: this.privateExtendedKey,
            xpub: this.publicExtendedKey
        };
    }
    serialize(version, key) {
        if (!this.chainCode) throw new Error("No chainCode set");
        (0, $a0ae23f5901291b4$exports.abytes)(key, 33);
        // version(4) || depth(1) || fingerprint(4) || index(4) || chain(32) || key(33)
        return (0, $29ee4d3171d9809b$exports.concatBytes)($c1c39050bd418416$var$toU32(version), new Uint8Array([
            this.depth
        ]), $c1c39050bd418416$var$toU32(this.parentFingerprint), $c1c39050bd418416$var$toU32(this.index), this.chainCode, key);
    }
}


var $836cf4f0e2c80e2c$exports = {};
"use strict";
/**
 * Audited & minimal JS implementation of
 * [BIP39 mnemonic phrases](https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki).
 * @module
 * @example
```js
import * as bip39 from '@scure/bip39';
import { wordlist } from '@scure/bip39/wordlists/english';
const mn = bip39.generateMnemonic(wordlist);
console.log(mn);
const ent = bip39.mnemonicToEntropy(mn, wordlist)
bip39.entropyToMnemonic(ent, wordlist);
bip39.validateMnemonic(mn, wordlist);
await bip39.mnemonicToSeed(mn, 'password');
bip39.mnemonicToSeedSync(mn, 'password');

// Wordlists
import { wordlist as czech } from '@scure/bip39/wordlists/czech';
import { wordlist as english } from '@scure/bip39/wordlists/english';
import { wordlist as french } from '@scure/bip39/wordlists/french';
import { wordlist as italian } from '@scure/bip39/wordlists/italian';
import { wordlist as japanese } from '@scure/bip39/wordlists/japanese';
import { wordlist as korean } from '@scure/bip39/wordlists/korean';
import { wordlist as portuguese } from '@scure/bip39/wordlists/portuguese';
import { wordlist as simplifiedChinese } from '@scure/bip39/wordlists/simplified-chinese';
import { wordlist as spanish } from '@scure/bip39/wordlists/spanish';
import { wordlist as traditionalChinese } from '@scure/bip39/wordlists/traditional-chinese';
```
 */ Object.defineProperty($836cf4f0e2c80e2c$exports, "__esModule", {
    value: true
});
$836cf4f0e2c80e2c$exports.generateMnemonic = $836cf4f0e2c80e2c$var$generateMnemonic;
$836cf4f0e2c80e2c$exports.mnemonicToEntropy = $836cf4f0e2c80e2c$var$mnemonicToEntropy;
$836cf4f0e2c80e2c$exports.entropyToMnemonic = $836cf4f0e2c80e2c$var$entropyToMnemonic;
$836cf4f0e2c80e2c$exports.validateMnemonic = $836cf4f0e2c80e2c$var$validateMnemonic;
$836cf4f0e2c80e2c$exports.mnemonicToSeed = $836cf4f0e2c80e2c$var$mnemonicToSeed;
$836cf4f0e2c80e2c$exports.mnemonicToSeedSync = $836cf4f0e2c80e2c$var$mnemonicToSeedSync;

var $8c2f54a153cf1baf$exports = {};
"use strict";
Object.defineProperty($8c2f54a153cf1baf$exports, "__esModule", {
    value: true
});
$8c2f54a153cf1baf$exports.pbkdf2 = $8c2f54a153cf1baf$var$pbkdf2;
$8c2f54a153cf1baf$exports.pbkdf2Async = $8c2f54a153cf1baf$var$pbkdf2Async;



// Common prologue and epilogue for sync/async functions
function $8c2f54a153cf1baf$var$pbkdf2Init(hash, _password, _salt, _opts) {
    (0, $a0ae23f5901291b4$exports.ahash)(hash);
    const opts = (0, $29ee4d3171d9809b$exports.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c: c, dkLen: dkLen, asyncTick: asyncTick } = opts;
    (0, $a0ae23f5901291b4$exports.anumber)(c);
    (0, $a0ae23f5901291b4$exports.anumber)(dkLen);
    (0, $a0ae23f5901291b4$exports.anumber)(asyncTick);
    if (c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
    const password = (0, $29ee4d3171d9809b$exports.toBytes)(_password);
    const salt = (0, $29ee4d3171d9809b$exports.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = $51b6b372898f65c0$exports.hmac.create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $8c2f54a153cf1baf$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 * @example
 * const key = pbkdf2(sha256, 'password', 'salt', { dkLen: 32, c: 2 ** 18 });
 */ function $8c2f54a153cf1baf$var$pbkdf2(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $8c2f54a153cf1baf$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $29ee4d3171d9809b$exports.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $8c2f54a153cf1baf$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function. Async version.
 * @example
 * await pbkdf2Async(sha256, 'password', 'salt', { dkLen: 32, c: 500_000 });
 */ async function $8c2f54a153cf1baf$var$pbkdf2Async(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, asyncTick: asyncTick, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $8c2f54a153cf1baf$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $29ee4d3171d9809b$exports.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, $29ee4d3171d9809b$exports.asyncLoop)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return $8c2f54a153cf1baf$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}






// Japanese wordlist
const $836cf4f0e2c80e2c$var$isJapanese = (wordlist)=>wordlist[0] === "\u3042\u3044\u3053\u304F\u3057\u3093";
// Normalization replaces equivalent sequences of characters
// so that any two texts that are equivalent will be reduced
// to the same sequence of code points, called the normal form of the original text.
// https://tonsky.me/blog/unicode/#why-is-a----
function $836cf4f0e2c80e2c$var$nfkd(str) {
    if (typeof str !== "string") throw new TypeError("invalid mnemonic type: " + typeof str);
    return str.normalize("NFKD");
}
function $836cf4f0e2c80e2c$var$normalize(str) {
    const norm = $836cf4f0e2c80e2c$var$nfkd(str);
    const words = norm.split(" ");
    if (![
        12,
        15,
        18,
        21,
        24
    ].includes(words.length)) throw new Error("Invalid mnemonic");
    return {
        nfkd: norm,
        words: words
    };
}
function $836cf4f0e2c80e2c$var$aentropy(ent) {
    (0, $a0ae23f5901291b4$exports.abytes)(ent, 16, 20, 24, 28, 32);
}
/**
 * Generate x random words. Uses Cryptographically-Secure Random Number Generator.
 * @param wordlist imported wordlist for specific language
 * @param strength mnemonic strength 128-256 bits
 * @example
 * generateMnemonic(wordlist, 128)
 * // 'legal winner thank year wave sausage worth useful legal winner thank yellow'
 */ function $836cf4f0e2c80e2c$var$generateMnemonic(wordlist, strength = 128) {
    (0, $a0ae23f5901291b4$exports.anumber)(strength);
    if (strength % 32 !== 0 || strength > 256) throw new TypeError("Invalid entropy");
    return $836cf4f0e2c80e2c$var$entropyToMnemonic((0, $29ee4d3171d9809b$exports.randomBytes)(strength / 8), wordlist);
}
const $836cf4f0e2c80e2c$var$calcChecksum = (entropy)=>{
    // Checksum is ent.length/4 bits long
    const bitsLeft = 8 - entropy.length / 4;
    // Zero rightmost "bitsLeft" bits in byte
    // For example: bitsLeft=4 val=10111101 -> 10110000
    return new Uint8Array([
        (0, $510ad3657d73a9d2$exports.sha256)(entropy)[0] >> bitsLeft << bitsLeft
    ]);
};
function $836cf4f0e2c80e2c$var$getCoder(wordlist) {
    if (!Array.isArray(wordlist) || wordlist.length !== 2048 || typeof wordlist[0] !== "string") throw new Error("Wordlist: expected array of 2048 strings");
    wordlist.forEach((i)=>{
        if (typeof i !== "string") throw new Error("wordlist: non-string element: " + i);
    });
    return $3600b4829dff8fa9$export$eab97d15b1788b8d.chain($3600b4829dff8fa9$export$eab97d15b1788b8d.checksum(1, $836cf4f0e2c80e2c$var$calcChecksum), $3600b4829dff8fa9$export$eab97d15b1788b8d.radix2(11, true), $3600b4829dff8fa9$export$eab97d15b1788b8d.alphabet(wordlist));
}
/**
 * Reversible: Converts mnemonic string to raw entropy in form of byte array.
 * @param mnemonic 12-24 words
 * @param wordlist imported wordlist for specific language
 * @example
 * const mnem = 'legal winner thank year wave sausage worth useful legal winner thank yellow';
 * mnemonicToEntropy(mnem, wordlist)
 * // Produces
 * new Uint8Array([
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f,
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f
 * ])
 */ function $836cf4f0e2c80e2c$var$mnemonicToEntropy(mnemonic, wordlist) {
    const { words: words } = $836cf4f0e2c80e2c$var$normalize(mnemonic);
    const entropy = $836cf4f0e2c80e2c$var$getCoder(wordlist).decode(words);
    $836cf4f0e2c80e2c$var$aentropy(entropy);
    return entropy;
}
/**
 * Reversible: Converts raw entropy in form of byte array to mnemonic string.
 * @param entropy byte array
 * @param wordlist imported wordlist for specific language
 * @returns 12-24 words
 * @example
 * const ent = new Uint8Array([
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f,
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f
 * ]);
 * entropyToMnemonic(ent, wordlist);
 * // 'legal winner thank year wave sausage worth useful legal winner thank yellow'
 */ function $836cf4f0e2c80e2c$var$entropyToMnemonic(entropy, wordlist) {
    $836cf4f0e2c80e2c$var$aentropy(entropy);
    const words = $836cf4f0e2c80e2c$var$getCoder(wordlist).encode(entropy);
    return words.join($836cf4f0e2c80e2c$var$isJapanese(wordlist) ? "\u3000" : " ");
}
/**
 * Validates mnemonic for being 12-24 words contained in `wordlist`.
 */ function $836cf4f0e2c80e2c$var$validateMnemonic(mnemonic, wordlist) {
    try {
        $836cf4f0e2c80e2c$var$mnemonicToEntropy(mnemonic, wordlist);
    } catch (e) {
        return false;
    }
    return true;
}
const $836cf4f0e2c80e2c$var$psalt = (passphrase)=>$836cf4f0e2c80e2c$var$nfkd("mnemonic" + passphrase);
/**
 * Irreversible: Uses KDF to derive 64 bytes of key data from mnemonic + optional password.
 * @param mnemonic 12-24 words
 * @param passphrase string that will additionally protect the key
 * @returns 64 bytes of key data
 * @example
 * const mnem = 'legal winner thank year wave sausage worth useful legal winner thank yellow';
 * await mnemonicToSeed(mnem, 'password');
 * // new Uint8Array([...64 bytes])
 */ function $836cf4f0e2c80e2c$var$mnemonicToSeed(mnemonic, passphrase = "") {
    return (0, $8c2f54a153cf1baf$exports.pbkdf2Async)($2579977b4e52adba$exports.sha512, $836cf4f0e2c80e2c$var$normalize(mnemonic).nfkd, $836cf4f0e2c80e2c$var$psalt(passphrase), {
        c: 2048,
        dkLen: 64
    });
}
/**
 * Irreversible: Uses KDF to derive 64 bytes of key data from mnemonic + optional password.
 * @param mnemonic 12-24 words
 * @param passphrase string that will additionally protect the key
 * @returns 64 bytes of key data
 * @example
 * const mnem = 'legal winner thank year wave sausage worth useful legal winner thank yellow';
 * mnemonicToSeedSync(mnem, 'password');
 * // new Uint8Array([...64 bytes])
 */ function $836cf4f0e2c80e2c$var$mnemonicToSeedSync(mnemonic, passphrase = "") {
    return (0, $8c2f54a153cf1baf$exports.pbkdf2)($2579977b4e52adba$exports.sha512, $836cf4f0e2c80e2c$var$normalize(mnemonic).nfkd, $836cf4f0e2c80e2c$var$psalt(passphrase), {
        c: 2048,
        dkLen: 64
    });
}





var $13c18d22617e7179$exports = {};
"use strict";
Object.defineProperty($13c18d22617e7179$exports, "__esModule", {
    value: true
});
$13c18d22617e7179$exports.blake2b = $13c18d22617e7179$exports.BLAKE2b = void 0;
var $9fd25c68da634772$exports = {};
"use strict";
Object.defineProperty($9fd25c68da634772$exports, "__esModule", {
    value: true
});
$9fd25c68da634772$exports.BLAKE = $9fd25c68da634772$exports.SIGMA = void 0;


/**
 * Internal blake variable.
 * For BLAKE2b, the two extra permutations for rounds 10 and 11 are SIGMA[10..11] = SIGMA[0..1].
 */ // prettier-ignore
$9fd25c68da634772$exports.SIGMA = new Uint8Array([
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9,
    12,
    5,
    1,
    15,
    14,
    13,
    4,
    10,
    0,
    7,
    6,
    3,
    9,
    2,
    8,
    11,
    13,
    11,
    7,
    14,
    12,
    1,
    3,
    9,
    5,
    0,
    15,
    4,
    8,
    6,
    2,
    10,
    6,
    15,
    14,
    9,
    11,
    3,
    0,
    8,
    12,
    2,
    13,
    7,
    1,
    4,
    10,
    5,
    10,
    2,
    8,
    4,
    7,
    6,
    1,
    5,
    15,
    11,
    9,
    14,
    3,
    12,
    13,
    0,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    // Blake1, unused in others
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9
]);
/** Class, from which others are subclassed. */ class $9fd25c68da634772$var$BLAKE extends $29ee4d3171d9809b$exports.Hash {
    constructor(blockLen, outputLen, opts = {}, keyLen, saltLen, persLen){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.length = 0;
        this.pos = 0;
        this.finished = false;
        this.destroyed = false;
        (0, $a0ae23f5901291b4$exports.anumber)(blockLen);
        (0, $a0ae23f5901291b4$exports.anumber)(outputLen);
        (0, $a0ae23f5901291b4$exports.anumber)(keyLen);
        if (outputLen < 0 || outputLen > keyLen) throw new Error("outputLen bigger than keyLen");
        if (opts.key !== undefined && (opts.key.length < 1 || opts.key.length > keyLen)) throw new Error("key length must be undefined or 1.." + keyLen);
        if (opts.salt !== undefined && opts.salt.length !== saltLen) throw new Error("salt must be undefined or " + saltLen);
        if (opts.personalization !== undefined && opts.personalization.length !== persLen) throw new Error("personalization must be undefined or " + persLen);
        this.buffer = new Uint8Array(blockLen);
        this.buffer32 = (0, $29ee4d3171d9809b$exports.u32)(this.buffer);
    }
    update(data) {
        (0, $a0ae23f5901291b4$exports.aexists)(this);
        // Main difference with other hashes: there is flag for last block,
        // so we cannot process current block before we know that there
        // is the next one. This significantly complicates logic and reduces ability
        // to do zero-copy processing
        const { blockLen: blockLen, buffer: buffer, buffer32: buffer32 } = this;
        data = (0, $29ee4d3171d9809b$exports.toBytes)(data);
        const len = data.length;
        const offset = data.byteOffset;
        const buf = data.buffer;
        for(let pos = 0; pos < len;){
            // If buffer is full and we still have input (don't process last block, same as blake2s)
            if (this.pos === blockLen) {
                if (!$29ee4d3171d9809b$exports.isLE) (0, $29ee4d3171d9809b$exports.byteSwap32)(buffer32);
                this.compress(buffer32, 0, false);
                if (!$29ee4d3171d9809b$exports.isLE) (0, $29ee4d3171d9809b$exports.byteSwap32)(buffer32);
                this.pos = 0;
            }
            const take = Math.min(blockLen - this.pos, len - pos);
            const dataOffset = offset + pos;
            // full block && aligned to 4 bytes && not last in input
            if (take === blockLen && !(dataOffset % 4) && pos + take < len) {
                const data32 = new Uint32Array(buf, dataOffset, Math.floor((len - pos) / 4));
                if (!$29ee4d3171d9809b$exports.isLE) (0, $29ee4d3171d9809b$exports.byteSwap32)(data32);
                for(let pos32 = 0; pos + blockLen < len; pos32 += buffer32.length, pos += blockLen){
                    this.length += blockLen;
                    this.compress(data32, pos32, false);
                }
                if (!$29ee4d3171d9809b$exports.isLE) (0, $29ee4d3171d9809b$exports.byteSwap32)(data32);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            this.length += take;
            pos += take;
        }
        return this;
    }
    digestInto(out) {
        (0, $a0ae23f5901291b4$exports.aexists)(this);
        (0, $a0ae23f5901291b4$exports.aoutput)(out, this);
        const { pos: pos, buffer32: buffer32 } = this;
        this.finished = true;
        // Padding
        this.buffer.subarray(pos).fill(0);
        if (!$29ee4d3171d9809b$exports.isLE) (0, $29ee4d3171d9809b$exports.byteSwap32)(buffer32);
        this.compress(buffer32, 0, true);
        if (!$29ee4d3171d9809b$exports.isLE) (0, $29ee4d3171d9809b$exports.byteSwap32)(buffer32);
        const out32 = (0, $29ee4d3171d9809b$exports.u32)(out);
        this.get().forEach((v, i)=>out32[i] = (0, $29ee4d3171d9809b$exports.byteSwapIfBE)(v));
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        const { buffer: buffer, length: length, finished: finished, destroyed: destroyed, outputLen: outputLen, pos: pos } = this;
        to || (to = new this.constructor({
            dkLen: outputLen
        }));
        to.set(...this.get());
        to.length = length;
        to.finished = finished;
        to.destroyed = destroyed;
        to.outputLen = outputLen;
        to.buffer.set(buffer);
        to.pos = pos;
        return to;
    }
}
$9fd25c68da634772$exports.BLAKE = $9fd25c68da634772$var$BLAKE;




// Same as SHA-512 but LE
// prettier-ignore
const $13c18d22617e7179$var$B2B_IV = /* @__PURE__ */ new Uint32Array([
    0xf3bcc908,
    0x6a09e667,
    0x84caa73b,
    0xbb67ae85,
    0xfe94f82b,
    0x3c6ef372,
    0x5f1d36f1,
    0xa54ff53a,
    0xade682d1,
    0x510e527f,
    0x2b3e6c1f,
    0x9b05688c,
    0xfb41bd6b,
    0x1f83d9ab,
    0x137e2179,
    0x5be0cd19
]);
// Temporary buffer
const $13c18d22617e7179$var$BBUF = /* @__PURE__ */ new Uint32Array(32);
// Mixing function G splitted in two halfs
function $13c18d22617e7179$var$G1b(a, b, c, d, msg, x) {
    // NOTE: V is LE here
    const Xl = msg[x], Xh = msg[x + 1]; // prettier-ignore
    let Al = $13c18d22617e7179$var$BBUF[2 * a], Ah = $13c18d22617e7179$var$BBUF[2 * a + 1]; // prettier-ignore
    let Bl = $13c18d22617e7179$var$BBUF[2 * b], Bh = $13c18d22617e7179$var$BBUF[2 * b + 1]; // prettier-ignore
    let Cl = $13c18d22617e7179$var$BBUF[2 * c], Ch = $13c18d22617e7179$var$BBUF[2 * c + 1]; // prettier-ignore
    let Dl = $13c18d22617e7179$var$BBUF[2 * d], Dh = $13c18d22617e7179$var$BBUF[2 * d + 1]; // prettier-ignore
    // v[a] = (v[a] + v[b] + x) | 0;
    let ll = $aa71b30d36adb919$exports.default.add3L(Al, Bl, Xl);
    Ah = $aa71b30d36adb919$exports.default.add3H(ll, Ah, Bh, Xh);
    Al = ll | 0;
    // v[d] = rotr(v[d] ^ v[a], 32)
    ({ Dh: Dh, Dl: Dl } = {
        Dh: Dh ^ Ah,
        Dl: Dl ^ Al
    });
    ({ Dh: Dh, Dl: Dl } = {
        Dh: $aa71b30d36adb919$exports.default.rotr32H(Dh, Dl),
        Dl: $aa71b30d36adb919$exports.default.rotr32L(Dh, Dl)
    });
    // v[c] = (v[c] + v[d]) | 0;
    ({ h: Ch, l: Cl } = $aa71b30d36adb919$exports.default.add(Ch, Cl, Dh, Dl));
    // v[b] = rotr(v[b] ^ v[c], 24)
    ({ Bh: Bh, Bl: Bl } = {
        Bh: Bh ^ Ch,
        Bl: Bl ^ Cl
    });
    ({ Bh: Bh, Bl: Bl } = {
        Bh: $aa71b30d36adb919$exports.default.rotrSH(Bh, Bl, 24),
        Bl: $aa71b30d36adb919$exports.default.rotrSL(Bh, Bl, 24)
    });
    $13c18d22617e7179$var$BBUF[2 * a] = Al, $13c18d22617e7179$var$BBUF[2 * a + 1] = Ah;
    $13c18d22617e7179$var$BBUF[2 * b] = Bl, $13c18d22617e7179$var$BBUF[2 * b + 1] = Bh;
    $13c18d22617e7179$var$BBUF[2 * c] = Cl, $13c18d22617e7179$var$BBUF[2 * c + 1] = Ch;
    $13c18d22617e7179$var$BBUF[2 * d] = Dl, $13c18d22617e7179$var$BBUF[2 * d + 1] = Dh;
}
function $13c18d22617e7179$var$G2b(a, b, c, d, msg, x) {
    // NOTE: V is LE here
    const Xl = msg[x], Xh = msg[x + 1]; // prettier-ignore
    let Al = $13c18d22617e7179$var$BBUF[2 * a], Ah = $13c18d22617e7179$var$BBUF[2 * a + 1]; // prettier-ignore
    let Bl = $13c18d22617e7179$var$BBUF[2 * b], Bh = $13c18d22617e7179$var$BBUF[2 * b + 1]; // prettier-ignore
    let Cl = $13c18d22617e7179$var$BBUF[2 * c], Ch = $13c18d22617e7179$var$BBUF[2 * c + 1]; // prettier-ignore
    let Dl = $13c18d22617e7179$var$BBUF[2 * d], Dh = $13c18d22617e7179$var$BBUF[2 * d + 1]; // prettier-ignore
    // v[a] = (v[a] + v[b] + x) | 0;
    let ll = $aa71b30d36adb919$exports.default.add3L(Al, Bl, Xl);
    Ah = $aa71b30d36adb919$exports.default.add3H(ll, Ah, Bh, Xh);
    Al = ll | 0;
    // v[d] = rotr(v[d] ^ v[a], 16)
    ({ Dh: Dh, Dl: Dl } = {
        Dh: Dh ^ Ah,
        Dl: Dl ^ Al
    });
    ({ Dh: Dh, Dl: Dl } = {
        Dh: $aa71b30d36adb919$exports.default.rotrSH(Dh, Dl, 16),
        Dl: $aa71b30d36adb919$exports.default.rotrSL(Dh, Dl, 16)
    });
    // v[c] = (v[c] + v[d]) | 0;
    ({ h: Ch, l: Cl } = $aa71b30d36adb919$exports.default.add(Ch, Cl, Dh, Dl));
    // v[b] = rotr(v[b] ^ v[c], 63)
    ({ Bh: Bh, Bl: Bl } = {
        Bh: Bh ^ Ch,
        Bl: Bl ^ Cl
    });
    ({ Bh: Bh, Bl: Bl } = {
        Bh: $aa71b30d36adb919$exports.default.rotrBH(Bh, Bl, 63),
        Bl: $aa71b30d36adb919$exports.default.rotrBL(Bh, Bl, 63)
    });
    $13c18d22617e7179$var$BBUF[2 * a] = Al, $13c18d22617e7179$var$BBUF[2 * a + 1] = Ah;
    $13c18d22617e7179$var$BBUF[2 * b] = Bl, $13c18d22617e7179$var$BBUF[2 * b + 1] = Bh;
    $13c18d22617e7179$var$BBUF[2 * c] = Cl, $13c18d22617e7179$var$BBUF[2 * c + 1] = Ch;
    $13c18d22617e7179$var$BBUF[2 * d] = Dl, $13c18d22617e7179$var$BBUF[2 * d + 1] = Dh;
}
class $13c18d22617e7179$var$BLAKE2b extends $9fd25c68da634772$exports.BLAKE {
    constructor(opts = {}){
        super(128, opts.dkLen === undefined ? 64 : opts.dkLen, opts, 64, 16, 16);
        // Same as SHA-512, but LE
        this.v0l = $13c18d22617e7179$var$B2B_IV[0] | 0;
        this.v0h = $13c18d22617e7179$var$B2B_IV[1] | 0;
        this.v1l = $13c18d22617e7179$var$B2B_IV[2] | 0;
        this.v1h = $13c18d22617e7179$var$B2B_IV[3] | 0;
        this.v2l = $13c18d22617e7179$var$B2B_IV[4] | 0;
        this.v2h = $13c18d22617e7179$var$B2B_IV[5] | 0;
        this.v3l = $13c18d22617e7179$var$B2B_IV[6] | 0;
        this.v3h = $13c18d22617e7179$var$B2B_IV[7] | 0;
        this.v4l = $13c18d22617e7179$var$B2B_IV[8] | 0;
        this.v4h = $13c18d22617e7179$var$B2B_IV[9] | 0;
        this.v5l = $13c18d22617e7179$var$B2B_IV[10] | 0;
        this.v5h = $13c18d22617e7179$var$B2B_IV[11] | 0;
        this.v6l = $13c18d22617e7179$var$B2B_IV[12] | 0;
        this.v6h = $13c18d22617e7179$var$B2B_IV[13] | 0;
        this.v7l = $13c18d22617e7179$var$B2B_IV[14] | 0;
        this.v7h = $13c18d22617e7179$var$B2B_IV[15] | 0;
        const keyLength = opts.key ? opts.key.length : 0;
        this.v0l ^= this.outputLen | keyLength << 8 | 16842752;
        if (opts.salt) {
            const salt = (0, $29ee4d3171d9809b$exports.u32)((0, $29ee4d3171d9809b$exports.toBytes)(opts.salt));
            this.v4l ^= (0, $29ee4d3171d9809b$exports.byteSwapIfBE)(salt[0]);
            this.v4h ^= (0, $29ee4d3171d9809b$exports.byteSwapIfBE)(salt[1]);
            this.v5l ^= (0, $29ee4d3171d9809b$exports.byteSwapIfBE)(salt[2]);
            this.v5h ^= (0, $29ee4d3171d9809b$exports.byteSwapIfBE)(salt[3]);
        }
        if (opts.personalization) {
            const pers = (0, $29ee4d3171d9809b$exports.u32)((0, $29ee4d3171d9809b$exports.toBytes)(opts.personalization));
            this.v6l ^= (0, $29ee4d3171d9809b$exports.byteSwapIfBE)(pers[0]);
            this.v6h ^= (0, $29ee4d3171d9809b$exports.byteSwapIfBE)(pers[1]);
            this.v7l ^= (0, $29ee4d3171d9809b$exports.byteSwapIfBE)(pers[2]);
            this.v7h ^= (0, $29ee4d3171d9809b$exports.byteSwapIfBE)(pers[3]);
        }
        if (opts.key) {
            // Pad to blockLen and update
            const tmp = new Uint8Array(this.blockLen);
            tmp.set((0, $29ee4d3171d9809b$exports.toBytes)(opts.key));
            this.update(tmp);
        }
    }
    // prettier-ignore
    get() {
        let { v0l: v0l, v0h: v0h, v1l: v1l, v1h: v1h, v2l: v2l, v2h: v2h, v3l: v3l, v3h: v3h, v4l: v4l, v4h: v4h, v5l: v5l, v5h: v5h, v6l: v6l, v6h: v6h, v7l: v7l, v7h: v7h } = this;
        return [
            v0l,
            v0h,
            v1l,
            v1h,
            v2l,
            v2h,
            v3l,
            v3h,
            v4l,
            v4h,
            v5l,
            v5h,
            v6l,
            v6h,
            v7l,
            v7h
        ];
    }
    // prettier-ignore
    set(v0l, v0h, v1l, v1h, v2l, v2h, v3l, v3h, v4l, v4h, v5l, v5h, v6l, v6h, v7l, v7h) {
        this.v0l = v0l | 0;
        this.v0h = v0h | 0;
        this.v1l = v1l | 0;
        this.v1h = v1h | 0;
        this.v2l = v2l | 0;
        this.v2h = v2h | 0;
        this.v3l = v3l | 0;
        this.v3h = v3h | 0;
        this.v4l = v4l | 0;
        this.v4h = v4h | 0;
        this.v5l = v5l | 0;
        this.v5h = v5h | 0;
        this.v6l = v6l | 0;
        this.v6h = v6h | 0;
        this.v7l = v7l | 0;
        this.v7h = v7h | 0;
    }
    compress(msg, offset, isLast) {
        this.get().forEach((v, i)=>$13c18d22617e7179$var$BBUF[i] = v); // First half from state.
        $13c18d22617e7179$var$BBUF.set($13c18d22617e7179$var$B2B_IV, 16); // Second half from IV.
        let { h: h, l: l } = $aa71b30d36adb919$exports.default.fromBig(BigInt(this.length));
        $13c18d22617e7179$var$BBUF[24] = $13c18d22617e7179$var$B2B_IV[8] ^ l; // Low word of the offset.
        $13c18d22617e7179$var$BBUF[25] = $13c18d22617e7179$var$B2B_IV[9] ^ h; // High word.
        // Invert all bits for last block
        if (isLast) {
            $13c18d22617e7179$var$BBUF[28] = ~$13c18d22617e7179$var$BBUF[28];
            $13c18d22617e7179$var$BBUF[29] = ~$13c18d22617e7179$var$BBUF[29];
        }
        let j = 0;
        const s = $9fd25c68da634772$exports.SIGMA;
        for(let i = 0; i < 12; i++){
            $13c18d22617e7179$var$G1b(0, 4, 8, 12, msg, offset + 2 * s[j++]);
            $13c18d22617e7179$var$G2b(0, 4, 8, 12, msg, offset + 2 * s[j++]);
            $13c18d22617e7179$var$G1b(1, 5, 9, 13, msg, offset + 2 * s[j++]);
            $13c18d22617e7179$var$G2b(1, 5, 9, 13, msg, offset + 2 * s[j++]);
            $13c18d22617e7179$var$G1b(2, 6, 10, 14, msg, offset + 2 * s[j++]);
            $13c18d22617e7179$var$G2b(2, 6, 10, 14, msg, offset + 2 * s[j++]);
            $13c18d22617e7179$var$G1b(3, 7, 11, 15, msg, offset + 2 * s[j++]);
            $13c18d22617e7179$var$G2b(3, 7, 11, 15, msg, offset + 2 * s[j++]);
            $13c18d22617e7179$var$G1b(0, 5, 10, 15, msg, offset + 2 * s[j++]);
            $13c18d22617e7179$var$G2b(0, 5, 10, 15, msg, offset + 2 * s[j++]);
            $13c18d22617e7179$var$G1b(1, 6, 11, 12, msg, offset + 2 * s[j++]);
            $13c18d22617e7179$var$G2b(1, 6, 11, 12, msg, offset + 2 * s[j++]);
            $13c18d22617e7179$var$G1b(2, 7, 8, 13, msg, offset + 2 * s[j++]);
            $13c18d22617e7179$var$G2b(2, 7, 8, 13, msg, offset + 2 * s[j++]);
            $13c18d22617e7179$var$G1b(3, 4, 9, 14, msg, offset + 2 * s[j++]);
            $13c18d22617e7179$var$G2b(3, 4, 9, 14, msg, offset + 2 * s[j++]);
        }
        this.v0l ^= $13c18d22617e7179$var$BBUF[0] ^ $13c18d22617e7179$var$BBUF[16];
        this.v0h ^= $13c18d22617e7179$var$BBUF[1] ^ $13c18d22617e7179$var$BBUF[17];
        this.v1l ^= $13c18d22617e7179$var$BBUF[2] ^ $13c18d22617e7179$var$BBUF[18];
        this.v1h ^= $13c18d22617e7179$var$BBUF[3] ^ $13c18d22617e7179$var$BBUF[19];
        this.v2l ^= $13c18d22617e7179$var$BBUF[4] ^ $13c18d22617e7179$var$BBUF[20];
        this.v2h ^= $13c18d22617e7179$var$BBUF[5] ^ $13c18d22617e7179$var$BBUF[21];
        this.v3l ^= $13c18d22617e7179$var$BBUF[6] ^ $13c18d22617e7179$var$BBUF[22];
        this.v3h ^= $13c18d22617e7179$var$BBUF[7] ^ $13c18d22617e7179$var$BBUF[23];
        this.v4l ^= $13c18d22617e7179$var$BBUF[8] ^ $13c18d22617e7179$var$BBUF[24];
        this.v4h ^= $13c18d22617e7179$var$BBUF[9] ^ $13c18d22617e7179$var$BBUF[25];
        this.v5l ^= $13c18d22617e7179$var$BBUF[10] ^ $13c18d22617e7179$var$BBUF[26];
        this.v5h ^= $13c18d22617e7179$var$BBUF[11] ^ $13c18d22617e7179$var$BBUF[27];
        this.v6l ^= $13c18d22617e7179$var$BBUF[12] ^ $13c18d22617e7179$var$BBUF[28];
        this.v6h ^= $13c18d22617e7179$var$BBUF[13] ^ $13c18d22617e7179$var$BBUF[29];
        this.v7l ^= $13c18d22617e7179$var$BBUF[14] ^ $13c18d22617e7179$var$BBUF[30];
        this.v7h ^= $13c18d22617e7179$var$BBUF[15] ^ $13c18d22617e7179$var$BBUF[31];
        $13c18d22617e7179$var$BBUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer32.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
$13c18d22617e7179$exports.BLAKE2b = $13c18d22617e7179$var$BLAKE2b;
/**
 * Blake2b hash function. Focuses on 64-bit platforms, but in JS speed different from Blake2s is negligible.
 * @param msg - message that would be hashed
 * @param opts - dkLen output length, key for MAC mode, salt, personalization
 */ $13c18d22617e7179$exports.blake2b = (0, $29ee4d3171d9809b$exports.wrapConstructorWithOpts)((opts)=>new $13c18d22617e7179$var$BLAKE2b(opts));


/**
 * RLP Encoding based on https://ethereum.org/en/developers/docs/data-structures-and-encoding/rlp/
 * This function takes in data, converts it to Uint8Array if not,
 * and adds a length for recursion.
 * @param input Will be converted to Uint8Array
 * @returns Uint8Array of encoded data
 **/ function $f335153bf9367773$export$c564cdbbe6da493(input) {
    if (Array.isArray(input)) {
        const output = [];
        let outputLength = 0;
        for(let i = 0; i < input.length; i++){
            const encoded = $f335153bf9367773$export$c564cdbbe6da493(input[i]);
            output.push(encoded);
            outputLength += encoded.length;
        }
        return $f335153bf9367773$var$concatBytes($f335153bf9367773$var$encodeLength(outputLength, 192), ...output);
    }
    const inputBuf = $f335153bf9367773$var$toBytes(input);
    if (inputBuf.length === 1 && inputBuf[0] < 128) return inputBuf;
    return $f335153bf9367773$var$concatBytes($f335153bf9367773$var$encodeLength(inputBuf.length, 128), inputBuf);
}
/**
 * Slices a Uint8Array, throws if the slice goes out-of-bounds of the Uint8Array.
 * E.g. `safeSlice(hexToBytes('aa'), 1, 2)` will throw.
 * @param input
 * @param start
 * @param end
 */ function $f335153bf9367773$var$safeSlice(input, start, end) {
    if (end > input.length) throw new Error("invalid RLP (safeSlice): end slice of Uint8Array out-of-bounds");
    return input.slice(start, end);
}
/**
 * Parse integers. Check if there is no leading zeros
 * @param v The value to parse
 */ function $f335153bf9367773$var$decodeLength(v) {
    if (v[0] === 0) throw new Error("invalid RLP: extra zeros");
    return $f335153bf9367773$var$parseHexByte($f335153bf9367773$var$bytesToHex(v));
}
function $f335153bf9367773$var$encodeLength(len, offset) {
    if (len < 56) return Uint8Array.from([
        len + offset
    ]);
    const hexLength = $f335153bf9367773$var$numberToHex(len);
    const lLength = hexLength.length / 2;
    const firstByte = $f335153bf9367773$var$numberToHex(offset + 55 + lLength);
    return Uint8Array.from($f335153bf9367773$var$hexToBytes(firstByte + hexLength));
}
function $f335153bf9367773$export$2f872c0f2117be69(input, stream = false) {
    if (typeof input === "undefined" || input === null || input.length === 0) return Uint8Array.from([]);
    const inputBytes = $f335153bf9367773$var$toBytes(input);
    const decoded = $f335153bf9367773$var$_decode(inputBytes);
    if (stream) return {
        data: decoded.data,
        remainder: decoded.remainder.slice()
    };
    if (decoded.remainder.length !== 0) throw new Error("invalid RLP: remainder must be zero");
    return decoded.data;
}
/** Decode an input with RLP */ function $f335153bf9367773$var$_decode(input) {
    let length, llength, data, innerRemainder, d;
    const decoded = [];
    const firstByte = input[0];
    if (firstByte <= 0x7f) // a single byte whose value is in the [0x00, 0x7f] range, that byte is its own RLP encoding.
    return {
        data: input.slice(0, 1),
        remainder: input.subarray(1)
    };
    else if (firstByte <= 0xb7) {
        // string is 0-55 bytes long. A single byte with value 0x80 plus the length of the string followed by the string
        // The range of the first byte is [0x80, 0xb7]
        length = firstByte - 0x7f;
        // set 0x80 null to 0
        if (firstByte === 0x80) data = Uint8Array.from([]);
        else data = $f335153bf9367773$var$safeSlice(input, 1, length);
        if (length === 2 && data[0] < 0x80) throw new Error("invalid RLP encoding: invalid prefix, single byte < 0x80 are not prefixed");
        return {
            data: data,
            remainder: input.subarray(length)
        };
    } else if (firstByte <= 0xbf) {
        // string is greater than 55 bytes long. A single byte with the value (0xb7 plus the length of the length),
        // followed by the length, followed by the string
        llength = firstByte - 0xb6;
        if (input.length - 1 < llength) throw new Error("invalid RLP: not enough bytes for string length");
        length = $f335153bf9367773$var$decodeLength($f335153bf9367773$var$safeSlice(input, 1, llength));
        if (length <= 55) throw new Error("invalid RLP: expected string length to be greater than 55");
        data = $f335153bf9367773$var$safeSlice(input, llength, length + llength);
        return {
            data: data,
            remainder: input.subarray(length + llength)
        };
    } else if (firstByte <= 0xf7) {
        // a list between 0-55 bytes long
        length = firstByte - 0xbf;
        innerRemainder = $f335153bf9367773$var$safeSlice(input, 1, length);
        while(innerRemainder.length){
            d = $f335153bf9367773$var$_decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.subarray(length)
        };
    } else {
        // a list over 55 bytes long
        llength = firstByte - 0xf6;
        length = $f335153bf9367773$var$decodeLength($f335153bf9367773$var$safeSlice(input, 1, llength));
        if (length < 56) throw new Error("invalid RLP: encoded list too short");
        const totalLength = llength + length;
        if (totalLength > input.length) throw new Error("invalid RLP: total length is larger than the data");
        innerRemainder = $f335153bf9367773$var$safeSlice(input, llength, totalLength);
        while(innerRemainder.length){
            d = $f335153bf9367773$var$_decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.subarray(totalLength)
        };
    }
}
const $f335153bf9367773$var$cachedHexes = Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, "0"));
function $f335153bf9367773$var$bytesToHex(uint8a) {
    // Pre-caching chars with `cachedHexes` speeds this up 6x
    let hex = "";
    for(let i = 0; i < uint8a.length; i++)hex += $f335153bf9367773$var$cachedHexes[uint8a[i]];
    return hex;
}
function $f335153bf9367773$var$parseHexByte(hexByte) {
    const byte = Number.parseInt(hexByte, 16);
    if (Number.isNaN(byte)) throw new Error("Invalid byte sequence");
    return byte;
}
// Caching slows it down 2-3x
function $f335153bf9367773$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new TypeError("hexToBytes: expected string, got " + typeof hex);
    if (hex.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
    const array = new Uint8Array(hex.length / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        array[i] = $f335153bf9367773$var$parseHexByte(hex.slice(j, j + 2));
    }
    return array;
}
/** Concatenates two Uint8Arrays into one. */ function $f335153bf9367773$var$concatBytes(...arrays) {
    if (arrays.length === 1) return arrays[0];
    const length = arrays.reduce((a, arr)=>a + arr.length, 0);
    const result = new Uint8Array(length);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const arr = arrays[i];
        result.set(arr, pad);
        pad += arr.length;
    }
    return result;
}
function $f335153bf9367773$var$utf8ToBytes(utf) {
    return new TextEncoder().encode(utf);
}
/** Transform an integer into its hexadecimal value */ function $f335153bf9367773$var$numberToHex(integer) {
    if (integer < 0) throw new Error("Invalid integer as argument, must be unsigned!");
    const hex = integer.toString(16);
    return hex.length % 2 ? `0${hex}` : hex;
}
/** Pad a string to be even */ function $f335153bf9367773$var$padToEven(a) {
    return a.length % 2 ? `0${a}` : a;
}
/** Check if a string is prefixed by 0x */ function $f335153bf9367773$var$isHexPrefixed(str) {
    return str.length >= 2 && str[0] === "0" && str[1] === "x";
}
/** Removes 0x from a given String */ function $f335153bf9367773$var$stripHexPrefix(str) {
    if (typeof str !== "string") return str;
    return $f335153bf9367773$var$isHexPrefixed(str) ? str.slice(2) : str;
}
/** Transform anything into a Uint8Array */ function $f335153bf9367773$var$toBytes(v) {
    if (v instanceof Uint8Array) return v;
    if (typeof v === "string") {
        if ($f335153bf9367773$var$isHexPrefixed(v)) return $f335153bf9367773$var$hexToBytes($f335153bf9367773$var$padToEven($f335153bf9367773$var$stripHexPrefix(v)));
        return $f335153bf9367773$var$utf8ToBytes(v);
    }
    if (typeof v === "number" || typeof v === "bigint") {
        if (!v) return Uint8Array.from([]);
        return $f335153bf9367773$var$hexToBytes($f335153bf9367773$var$numberToHex(v));
    }
    if (v === null || v === undefined) return Uint8Array.from([]);
    throw new Error("toBytes: received unsupported type " + typeof v);
}
const $f335153bf9367773$export$eab97d15b1788b8d = {
    bytesToHex: $f335153bf9367773$var$bytesToHex,
    concatBytes: $f335153bf9367773$var$concatBytes,
    hexToBytes: $f335153bf9367773$var$hexToBytes,
    utf8ToBytes: $f335153bf9367773$var$utf8ToBytes
};
const $f335153bf9367773$export$4859e6f62c4b9b84 = {
    encode: $f335153bf9367773$export$c564cdbbe6da493,
    decode: $f335153bf9367773$export$2f872c0f2117be69
};


var $248bf24903c02b9f$exports = {};
"use strict";
Object.defineProperty($248bf24903c02b9f$exports, "__esModule", {
    value: true
});
$248bf24903c02b9f$exports.wrapCipher = $248bf24903c02b9f$exports.Hash = $248bf24903c02b9f$exports.nextTick = $248bf24903c02b9f$exports.isLE = $248bf24903c02b9f$exports.createView = $248bf24903c02b9f$exports.u32 = $248bf24903c02b9f$exports.u8 = void 0;
$248bf24903c02b9f$exports.bytesToHex = $248bf24903c02b9f$var$bytesToHex;
$248bf24903c02b9f$exports.hexToBytes = $248bf24903c02b9f$var$hexToBytes;
$248bf24903c02b9f$exports.hexToNumber = $248bf24903c02b9f$var$hexToNumber;
$248bf24903c02b9f$exports.bytesToNumberBE = $248bf24903c02b9f$var$bytesToNumberBE;
$248bf24903c02b9f$exports.numberToBytesBE = $248bf24903c02b9f$var$numberToBytesBE;
$248bf24903c02b9f$exports.utf8ToBytes = $248bf24903c02b9f$var$utf8ToBytes;
$248bf24903c02b9f$exports.bytesToUtf8 = $248bf24903c02b9f$var$bytesToUtf8;
$248bf24903c02b9f$exports.toBytes = $248bf24903c02b9f$var$toBytes;
$248bf24903c02b9f$exports.overlapBytes = $248bf24903c02b9f$var$overlapBytes;
$248bf24903c02b9f$exports.complexOverlapBytes = $248bf24903c02b9f$var$complexOverlapBytes;
$248bf24903c02b9f$exports.concatBytes = $248bf24903c02b9f$var$concatBytes;
$248bf24903c02b9f$exports.checkOpts = $248bf24903c02b9f$var$checkOpts;
$248bf24903c02b9f$exports.equalBytes = $248bf24903c02b9f$var$equalBytes;
$248bf24903c02b9f$exports.getOutput = $248bf24903c02b9f$var$getOutput;
$248bf24903c02b9f$exports.setBigUint64 = $248bf24903c02b9f$var$setBigUint64;
$248bf24903c02b9f$exports.u64Lengths = $248bf24903c02b9f$var$u64Lengths;
$248bf24903c02b9f$exports.isAligned32 = $248bf24903c02b9f$var$isAligned32;
$248bf24903c02b9f$exports.copyBytes = $248bf24903c02b9f$var$copyBytes;
$248bf24903c02b9f$exports.clean = $248bf24903c02b9f$var$clean;
var $5e86e7af933ab8a1$exports = {};
"use strict";
/**
 * Internal assertion helpers.
 * @module
 */ Object.defineProperty($5e86e7af933ab8a1$exports, "__esModule", {
    value: true
});
$5e86e7af933ab8a1$exports.abool = $5e86e7af933ab8a1$var$abool;
$5e86e7af933ab8a1$exports.abytes = $5e86e7af933ab8a1$var$abytes;
$5e86e7af933ab8a1$exports.aexists = $5e86e7af933ab8a1$var$aexists;
$5e86e7af933ab8a1$exports.ahash = $5e86e7af933ab8a1$var$ahash;
$5e86e7af933ab8a1$exports.anumber = $5e86e7af933ab8a1$var$anumber;
$5e86e7af933ab8a1$exports.aoutput = $5e86e7af933ab8a1$var$aoutput;
$5e86e7af933ab8a1$exports.isBytes = $5e86e7af933ab8a1$var$isBytes;
function $5e86e7af933ab8a1$var$anumber(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error("positive integer expected, got " + n);
}
// copied from utils
function $5e86e7af933ab8a1$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
function $5e86e7af933ab8a1$var$abytes(b, ...lengths) {
    if (!$5e86e7af933ab8a1$var$isBytes(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error("Uint8Array expected of length " + lengths + ", got length=" + b.length);
}
function $5e86e7af933ab8a1$var$ahash(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $5e86e7af933ab8a1$var$anumber(h.outputLen);
    $5e86e7af933ab8a1$var$anumber(h.blockLen);
}
function $5e86e7af933ab8a1$var$aexists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $5e86e7af933ab8a1$var$aoutput(out, instance) {
    $5e86e7af933ab8a1$var$abytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error("digestInto() expects output buffer of length at least " + min);
}
function $5e86e7af933ab8a1$var$abool(b) {
    if (typeof b !== "boolean") throw new Error(`boolean expected, not ${b}`);
}


// Cast array to different type
const $248bf24903c02b9f$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
$248bf24903c02b9f$exports.u8 = $248bf24903c02b9f$var$u8;
const $248bf24903c02b9f$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
$248bf24903c02b9f$exports.u32 = $248bf24903c02b9f$var$u32;
// Cast array to view
const $248bf24903c02b9f$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
$248bf24903c02b9f$exports.createView = $248bf24903c02b9f$var$createView;
// big-endian hardware is rare. Just in case someone still decides to run ciphers:
// early-throw an error because we don't support BE yet.
$248bf24903c02b9f$exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!$248bf24903c02b9f$exports.isLE) throw new Error("Non little-endian hardware is not supported");
// Array where index 0xf0 (240) is mapped to string 'f0'
const $248bf24903c02b9f$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $248bf24903c02b9f$var$bytesToHex(bytes) {
    (0, $5e86e7af933ab8a1$exports.abytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $248bf24903c02b9f$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $248bf24903c02b9f$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $248bf24903c02b9f$var$asciiToBase16(ch) {
    if (ch >= $248bf24903c02b9f$var$asciis._0 && ch <= $248bf24903c02b9f$var$asciis._9) return ch - $248bf24903c02b9f$var$asciis._0; // '2' => 50-48
    if (ch >= $248bf24903c02b9f$var$asciis.A && ch <= $248bf24903c02b9f$var$asciis.F) return ch - ($248bf24903c02b9f$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $248bf24903c02b9f$var$asciis.a && ch <= $248bf24903c02b9f$var$asciis.f) return ch - ($248bf24903c02b9f$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $248bf24903c02b9f$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $248bf24903c02b9f$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $248bf24903c02b9f$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
function $248bf24903c02b9f$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    return BigInt(hex === "" ? "0" : "0x" + hex); // Big Endian
}
// BE: Big Endian, LE: Little Endian
function $248bf24903c02b9f$var$bytesToNumberBE(bytes) {
    return $248bf24903c02b9f$var$hexToNumber($248bf24903c02b9f$var$bytesToHex(bytes));
}
function $248bf24903c02b9f$var$numberToBytesBE(n, len) {
    return $248bf24903c02b9f$var$hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $248bf24903c02b9f$var$nextTick = async ()=>{};
$248bf24903c02b9f$exports.nextTick = $248bf24903c02b9f$var$nextTick;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $248bf24903c02b9f$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error("string expected");
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * @example bytesToUtf8(new Uint8Array([97, 98, 99])) // 'abc'
 */ function $248bf24903c02b9f$var$bytesToUtf8(bytes) {
    return new TextDecoder().decode(bytes);
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $248bf24903c02b9f$var$toBytes(data) {
    if (typeof data === "string") data = $248bf24903c02b9f$var$utf8ToBytes(data);
    else if ((0, $5e86e7af933ab8a1$exports.isBytes)(data)) data = $248bf24903c02b9f$var$copyBytes(data);
    else throw new Error("Uint8Array expected, got " + typeof data);
    return data;
}
/**
 * Checks if two U8A use same underlying buffer and overlaps (will corrupt and break if input and output same)
 */ function $248bf24903c02b9f$var$overlapBytes(a, b) {
    return a.buffer === b.buffer && // probably will fail with some obscure proxies, but this is best we can do
    a.byteOffset < b.byteOffset + b.byteLength && // a starts before b end
    b.byteOffset < a.byteOffset + a.byteLength // b starts before a end
    ;
}
/**
 * If input and output overlap and input starts before output, we will overwrite end of input before
 * we start processing it, so this is not supported for most ciphers (except chacha/salse, which designed with this)
 */ function $248bf24903c02b9f$var$complexOverlapBytes(input, output) {
    // This is very cursed. It works somehow, but I'm completely unsure,
    // reasoning about overlapping aligned windows is very hard.
    if ($248bf24903c02b9f$var$overlapBytes(input, output) && input.byteOffset < output.byteOffset) throw new Error("complex overlap of input and output is not supported");
}
/**
 * Copies several Uint8Arrays into one.
 */ function $248bf24903c02b9f$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $5e86e7af933ab8a1$exports.abytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $248bf24903c02b9f$var$checkOpts(defaults, opts) {
    if (opts == null || typeof opts !== "object") throw new Error("options must be defined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
// Compares 2 u8a-s in kinda constant time
function $248bf24903c02b9f$var$equalBytes(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
// For runtime check if class implements interface
class $248bf24903c02b9f$var$Hash {
}
$248bf24903c02b9f$exports.Hash = $248bf24903c02b9f$var$Hash;
/**
 * @__NO_SIDE_EFFECTS__
 */ const $248bf24903c02b9f$var$wrapCipher = (params, constructor)=>{
    function wrappedCipher(key, ...args) {
        // Validate key
        (0, $5e86e7af933ab8a1$exports.abytes)(key);
        // Validate nonce if nonceLength is present
        if (params.nonceLength !== undefined) {
            const nonce = args[0];
            if (!nonce) throw new Error("nonce / iv required");
            if (params.varSizeNonce) (0, $5e86e7af933ab8a1$exports.abytes)(nonce);
            else (0, $5e86e7af933ab8a1$exports.abytes)(nonce, params.nonceLength);
        }
        // Validate AAD if tagLength present
        const tagl = params.tagLength;
        if (tagl && args[1] !== undefined) (0, $5e86e7af933ab8a1$exports.abytes)(args[1]);
        const cipher = constructor(key, ...args);
        const checkOutput = (fnLength, output)=>{
            if (output !== undefined) {
                if (fnLength !== 2) throw new Error("cipher output not supported");
                (0, $5e86e7af933ab8a1$exports.abytes)(output);
            }
        };
        // Create wrapped cipher with validation and single-use encryption
        let called = false;
        const wrCipher = {
            encrypt (data, output) {
                if (called) throw new Error("cannot encrypt() twice with same key + nonce");
                called = true;
                (0, $5e86e7af933ab8a1$exports.abytes)(data);
                checkOutput(cipher.encrypt.length, output);
                return cipher.encrypt(data, output);
            },
            decrypt (data, output) {
                (0, $5e86e7af933ab8a1$exports.abytes)(data);
                if (tagl && data.length < tagl) throw new Error("invalid ciphertext length: smaller than tagLength=" + tagl);
                checkOutput(cipher.decrypt.length, output);
                return cipher.decrypt(data, output);
            }
        };
        return wrCipher;
    }
    Object.assign(wrappedCipher, params);
    return wrappedCipher;
};
$248bf24903c02b9f$exports.wrapCipher = $248bf24903c02b9f$var$wrapCipher;
function $248bf24903c02b9f$var$getOutput(expectedLength, out, onlyAligned = true) {
    if (out === undefined) return new Uint8Array(expectedLength);
    if (out.length !== expectedLength) throw new Error("invalid output length, expected " + expectedLength + ", got: " + out.length);
    if (onlyAligned && !$248bf24903c02b9f$var$isAligned32(out)) throw new Error("invalid output, must be aligned");
    return out;
}
// Polyfill for Safari 14
function $248bf24903c02b9f$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
function $248bf24903c02b9f$var$u64Lengths(ciphertext, AAD) {
    const num = new Uint8Array(16);
    const view = (0, $248bf24903c02b9f$exports.createView)(num);
    $248bf24903c02b9f$var$setBigUint64(view, 0, BigInt(AAD ? AAD.length : 0), true);
    $248bf24903c02b9f$var$setBigUint64(view, 8, BigInt(ciphertext.length), true);
    return num;
}
// Is byte array aligned to 4 byte offset (u32)?
function $248bf24903c02b9f$var$isAligned32(bytes) {
    return bytes.byteOffset % 4 === 0;
}
// copy bytes to new u8a (aligned). Because Buffer.slice is broken.
function $248bf24903c02b9f$var$copyBytes(bytes) {
    return Uint8Array.from(bytes);
}
function $248bf24903c02b9f$var$clean(...arrays) {
    for(let i = 0; i < arrays.length; i++)arrays[i].fill(0);
}


var $d248fb36c996c0d4$exports = {};
"use strict";
Object.defineProperty($d248fb36c996c0d4$exports, "__esModule", {
    value: true
});
$d248fb36c996c0d4$exports.wordlist = void 0;
$d248fb36c996c0d4$exports.wordlist = `abandon
ability
able
about
above
absent
absorb
abstract
absurd
abuse
access
accident
account
accuse
achieve
acid
acoustic
acquire
across
act
action
actor
actress
actual
adapt
add
addict
address
adjust
admit
adult
advance
advice
aerobic
affair
afford
afraid
again
age
agent
agree
ahead
aim
air
airport
aisle
alarm
album
alcohol
alert
alien
all
alley
allow
almost
alone
alpha
already
also
alter
always
amateur
amazing
among
amount
amused
analyst
anchor
ancient
anger
angle
angry
animal
ankle
announce
annual
another
answer
antenna
antique
anxiety
any
apart
apology
appear
apple
approve
april
arch
arctic
area
arena
argue
arm
armed
armor
army
around
arrange
arrest
arrive
arrow
art
artefact
artist
artwork
ask
aspect
assault
asset
assist
assume
asthma
athlete
atom
attack
attend
attitude
attract
auction
audit
august
aunt
author
auto
autumn
average
avocado
avoid
awake
aware
away
awesome
awful
awkward
axis
baby
bachelor
bacon
badge
bag
balance
balcony
ball
bamboo
banana
banner
bar
barely
bargain
barrel
base
basic
basket
battle
beach
bean
beauty
because
become
beef
before
begin
behave
behind
believe
below
belt
bench
benefit
best
betray
better
between
beyond
bicycle
bid
bike
bind
biology
bird
birth
bitter
black
blade
blame
blanket
blast
bleak
bless
blind
blood
blossom
blouse
blue
blur
blush
board
boat
body
boil
bomb
bone
bonus
book
boost
border
boring
borrow
boss
bottom
bounce
box
boy
bracket
brain
brand
brass
brave
bread
breeze
brick
bridge
brief
bright
bring
brisk
broccoli
broken
bronze
broom
brother
brown
brush
bubble
buddy
budget
buffalo
build
bulb
bulk
bullet
bundle
bunker
burden
burger
burst
bus
business
busy
butter
buyer
buzz
cabbage
cabin
cable
cactus
cage
cake
call
calm
camera
camp
can
canal
cancel
candy
cannon
canoe
canvas
canyon
capable
capital
captain
car
carbon
card
cargo
carpet
carry
cart
case
cash
casino
castle
casual
cat
catalog
catch
category
cattle
caught
cause
caution
cave
ceiling
celery
cement
census
century
cereal
certain
chair
chalk
champion
change
chaos
chapter
charge
chase
chat
cheap
check
cheese
chef
cherry
chest
chicken
chief
child
chimney
choice
choose
chronic
chuckle
chunk
churn
cigar
cinnamon
circle
citizen
city
civil
claim
clap
clarify
claw
clay
clean
clerk
clever
click
client
cliff
climb
clinic
clip
clock
clog
close
cloth
cloud
clown
club
clump
cluster
clutch
coach
coast
coconut
code
coffee
coil
coin
collect
color
column
combine
come
comfort
comic
common
company
concert
conduct
confirm
congress
connect
consider
control
convince
cook
cool
copper
copy
coral
core
corn
correct
cost
cotton
couch
country
couple
course
cousin
cover
coyote
crack
cradle
craft
cram
crane
crash
crater
crawl
crazy
cream
credit
creek
crew
cricket
crime
crisp
critic
crop
cross
crouch
crowd
crucial
cruel
cruise
crumble
crunch
crush
cry
crystal
cube
culture
cup
cupboard
curious
current
curtain
curve
cushion
custom
cute
cycle
dad
damage
damp
dance
danger
daring
dash
daughter
dawn
day
deal
debate
debris
decade
december
decide
decline
decorate
decrease
deer
defense
define
defy
degree
delay
deliver
demand
demise
denial
dentist
deny
depart
depend
deposit
depth
deputy
derive
describe
desert
design
desk
despair
destroy
detail
detect
develop
device
devote
diagram
dial
diamond
diary
dice
diesel
diet
differ
digital
dignity
dilemma
dinner
dinosaur
direct
dirt
disagree
discover
disease
dish
dismiss
disorder
display
distance
divert
divide
divorce
dizzy
doctor
document
dog
doll
dolphin
domain
donate
donkey
donor
door
dose
double
dove
draft
dragon
drama
drastic
draw
dream
dress
drift
drill
drink
drip
drive
drop
drum
dry
duck
dumb
dune
during
dust
dutch
duty
dwarf
dynamic
eager
eagle
early
earn
earth
easily
east
easy
echo
ecology
economy
edge
edit
educate
effort
egg
eight
either
elbow
elder
electric
elegant
element
elephant
elevator
elite
else
embark
embody
embrace
emerge
emotion
employ
empower
empty
enable
enact
end
endless
endorse
enemy
energy
enforce
engage
engine
enhance
enjoy
enlist
enough
enrich
enroll
ensure
enter
entire
entry
envelope
episode
equal
equip
era
erase
erode
erosion
error
erupt
escape
essay
essence
estate
eternal
ethics
evidence
evil
evoke
evolve
exact
example
excess
exchange
excite
exclude
excuse
execute
exercise
exhaust
exhibit
exile
exist
exit
exotic
expand
expect
expire
explain
expose
express
extend
extra
eye
eyebrow
fabric
face
faculty
fade
faint
faith
fall
false
fame
family
famous
fan
fancy
fantasy
farm
fashion
fat
fatal
father
fatigue
fault
favorite
feature
february
federal
fee
feed
feel
female
fence
festival
fetch
fever
few
fiber
fiction
field
figure
file
film
filter
final
find
fine
finger
finish
fire
firm
first
fiscal
fish
fit
fitness
fix
flag
flame
flash
flat
flavor
flee
flight
flip
float
flock
floor
flower
fluid
flush
fly
foam
focus
fog
foil
fold
follow
food
foot
force
forest
forget
fork
fortune
forum
forward
fossil
foster
found
fox
fragile
frame
frequent
fresh
friend
fringe
frog
front
frost
frown
frozen
fruit
fuel
fun
funny
furnace
fury
future
gadget
gain
galaxy
gallery
game
gap
garage
garbage
garden
garlic
garment
gas
gasp
gate
gather
gauge
gaze
general
genius
genre
gentle
genuine
gesture
ghost
giant
gift
giggle
ginger
giraffe
girl
give
glad
glance
glare
glass
glide
glimpse
globe
gloom
glory
glove
glow
glue
goat
goddess
gold
good
goose
gorilla
gospel
gossip
govern
gown
grab
grace
grain
grant
grape
grass
gravity
great
green
grid
grief
grit
grocery
group
grow
grunt
guard
guess
guide
guilt
guitar
gun
gym
habit
hair
half
hammer
hamster
hand
happy
harbor
hard
harsh
harvest
hat
have
hawk
hazard
head
health
heart
heavy
hedgehog
height
hello
helmet
help
hen
hero
hidden
high
hill
hint
hip
hire
history
hobby
hockey
hold
hole
holiday
hollow
home
honey
hood
hope
horn
horror
horse
hospital
host
hotel
hour
hover
hub
huge
human
humble
humor
hundred
hungry
hunt
hurdle
hurry
hurt
husband
hybrid
ice
icon
idea
identify
idle
ignore
ill
illegal
illness
image
imitate
immense
immune
impact
impose
improve
impulse
inch
include
income
increase
index
indicate
indoor
industry
infant
inflict
inform
inhale
inherit
initial
inject
injury
inmate
inner
innocent
input
inquiry
insane
insect
inside
inspire
install
intact
interest
into
invest
invite
involve
iron
island
isolate
issue
item
ivory
jacket
jaguar
jar
jazz
jealous
jeans
jelly
jewel
job
join
joke
journey
joy
judge
juice
jump
jungle
junior
junk
just
kangaroo
keen
keep
ketchup
key
kick
kid
kidney
kind
kingdom
kiss
kit
kitchen
kite
kitten
kiwi
knee
knife
knock
know
lab
label
labor
ladder
lady
lake
lamp
language
laptop
large
later
latin
laugh
laundry
lava
law
lawn
lawsuit
layer
lazy
leader
leaf
learn
leave
lecture
left
leg
legal
legend
leisure
lemon
lend
length
lens
leopard
lesson
letter
level
liar
liberty
library
license
life
lift
light
like
limb
limit
link
lion
liquid
list
little
live
lizard
load
loan
lobster
local
lock
logic
lonely
long
loop
lottery
loud
lounge
love
loyal
lucky
luggage
lumber
lunar
lunch
luxury
lyrics
machine
mad
magic
magnet
maid
mail
main
major
make
mammal
man
manage
mandate
mango
mansion
manual
maple
marble
march
margin
marine
market
marriage
mask
mass
master
match
material
math
matrix
matter
maximum
maze
meadow
mean
measure
meat
mechanic
medal
media
melody
melt
member
memory
mention
menu
mercy
merge
merit
merry
mesh
message
metal
method
middle
midnight
milk
million
mimic
mind
minimum
minor
minute
miracle
mirror
misery
miss
mistake
mix
mixed
mixture
mobile
model
modify
mom
moment
monitor
monkey
monster
month
moon
moral
more
morning
mosquito
mother
motion
motor
mountain
mouse
move
movie
much
muffin
mule
multiply
muscle
museum
mushroom
music
must
mutual
myself
mystery
myth
naive
name
napkin
narrow
nasty
nation
nature
near
neck
need
negative
neglect
neither
nephew
nerve
nest
net
network
neutral
never
news
next
nice
night
noble
noise
nominee
noodle
normal
north
nose
notable
note
nothing
notice
novel
now
nuclear
number
nurse
nut
oak
obey
object
oblige
obscure
observe
obtain
obvious
occur
ocean
october
odor
off
offer
office
often
oil
okay
old
olive
olympic
omit
once
one
onion
online
only
open
opera
opinion
oppose
option
orange
orbit
orchard
order
ordinary
organ
orient
original
orphan
ostrich
other
outdoor
outer
output
outside
oval
oven
over
own
owner
oxygen
oyster
ozone
pact
paddle
page
pair
palace
palm
panda
panel
panic
panther
paper
parade
parent
park
parrot
party
pass
patch
path
patient
patrol
pattern
pause
pave
payment
peace
peanut
pear
peasant
pelican
pen
penalty
pencil
people
pepper
perfect
permit
person
pet
phone
photo
phrase
physical
piano
picnic
picture
piece
pig
pigeon
pill
pilot
pink
pioneer
pipe
pistol
pitch
pizza
place
planet
plastic
plate
play
please
pledge
pluck
plug
plunge
poem
poet
point
polar
pole
police
pond
pony
pool
popular
portion
position
possible
post
potato
pottery
poverty
powder
power
practice
praise
predict
prefer
prepare
present
pretty
prevent
price
pride
primary
print
priority
prison
private
prize
problem
process
produce
profit
program
project
promote
proof
property
prosper
protect
proud
provide
public
pudding
pull
pulp
pulse
pumpkin
punch
pupil
puppy
purchase
purity
purpose
purse
push
put
puzzle
pyramid
quality
quantum
quarter
question
quick
quit
quiz
quote
rabbit
raccoon
race
rack
radar
radio
rail
rain
raise
rally
ramp
ranch
random
range
rapid
rare
rate
rather
raven
raw
razor
ready
real
reason
rebel
rebuild
recall
receive
recipe
record
recycle
reduce
reflect
reform
refuse
region
regret
regular
reject
relax
release
relief
rely
remain
remember
remind
remove
render
renew
rent
reopen
repair
repeat
replace
report
require
rescue
resemble
resist
resource
response
result
retire
retreat
return
reunion
reveal
review
reward
rhythm
rib
ribbon
rice
rich
ride
ridge
rifle
right
rigid
ring
riot
ripple
risk
ritual
rival
river
road
roast
robot
robust
rocket
romance
roof
rookie
room
rose
rotate
rough
round
route
royal
rubber
rude
rug
rule
run
runway
rural
sad
saddle
sadness
safe
sail
salad
salmon
salon
salt
salute
same
sample
sand
satisfy
satoshi
sauce
sausage
save
say
scale
scan
scare
scatter
scene
scheme
school
science
scissors
scorpion
scout
scrap
screen
script
scrub
sea
search
season
seat
second
secret
section
security
seed
seek
segment
select
sell
seminar
senior
sense
sentence
series
service
session
settle
setup
seven
shadow
shaft
shallow
share
shed
shell
sheriff
shield
shift
shine
ship
shiver
shock
shoe
shoot
shop
short
shoulder
shove
shrimp
shrug
shuffle
shy
sibling
sick
side
siege
sight
sign
silent
silk
silly
silver
similar
simple
since
sing
siren
sister
situate
six
size
skate
sketch
ski
skill
skin
skirt
skull
slab
slam
sleep
slender
slice
slide
slight
slim
slogan
slot
slow
slush
small
smart
smile
smoke
smooth
snack
snake
snap
sniff
snow
soap
soccer
social
sock
soda
soft
solar
soldier
solid
solution
solve
someone
song
soon
sorry
sort
soul
sound
soup
source
south
space
spare
spatial
spawn
speak
special
speed
spell
spend
sphere
spice
spider
spike
spin
spirit
split
spoil
sponsor
spoon
sport
spot
spray
spread
spring
spy
square
squeeze
squirrel
stable
stadium
staff
stage
stairs
stamp
stand
start
state
stay
steak
steel
stem
step
stereo
stick
still
sting
stock
stomach
stone
stool
story
stove
strategy
street
strike
strong
struggle
student
stuff
stumble
style
subject
submit
subway
success
such
sudden
suffer
sugar
suggest
suit
summer
sun
sunny
sunset
super
supply
supreme
sure
surface
surge
surprise
surround
survey
suspect
sustain
swallow
swamp
swap
swarm
swear
sweet
swift
swim
swing
switch
sword
symbol
symptom
syrup
system
table
tackle
tag
tail
talent
talk
tank
tape
target
task
taste
tattoo
taxi
teach
team
tell
ten
tenant
tennis
tent
term
test
text
thank
that
theme
then
theory
there
they
thing
this
thought
three
thrive
throw
thumb
thunder
ticket
tide
tiger
tilt
timber
time
tiny
tip
tired
tissue
title
toast
tobacco
today
toddler
toe
together
toilet
token
tomato
tomorrow
tone
tongue
tonight
tool
tooth
top
topic
topple
torch
tornado
tortoise
toss
total
tourist
toward
tower
town
toy
track
trade
traffic
tragic
train
transfer
trap
trash
travel
tray
treat
tree
trend
trial
tribe
trick
trigger
trim
trip
trophy
trouble
truck
true
truly
trumpet
trust
truth
try
tube
tuition
tumble
tuna
tunnel
turkey
turn
turtle
twelve
twenty
twice
twin
twist
two
type
typical
ugly
umbrella
unable
unaware
uncle
uncover
under
undo
unfair
unfold
unhappy
uniform
unique
unit
universe
unknown
unlock
until
unusual
unveil
update
upgrade
uphold
upon
upper
upset
urban
urge
usage
use
used
useful
useless
usual
utility
vacant
vacuum
vague
valid
valley
valve
van
vanish
vapor
various
vast
vault
vehicle
velvet
vendor
venture
venue
verb
verify
version
very
vessel
veteran
viable
vibrant
vicious
victory
video
view
village
vintage
violin
virtual
virus
visa
visit
visual
vital
vivid
vocal
voice
void
volcano
volume
vote
voyage
wage
wagon
wait
walk
wall
walnut
want
warfare
warm
warrior
wash
wasp
waste
water
wave
way
wealth
weapon
wear
weasel
weather
web
wedding
weekend
weird
welcome
west
wet
whale
what
wheat
wheel
when
where
whip
whisper
wide
width
wife
wild
will
win
window
wine
wing
wink
winner
winter
wire
wisdom
wise
wish
witness
wolf
woman
wonder
wood
wool
word
work
world
worry
worth
wrap
wreck
wrestle
wrist
write
wrong
yard
year
yellow
you
young
youth
zebra
zero
zone
zoo`.split("\n");


var $4e5b5d36d7595504$var$__defProp = Object.defineProperty;
var $4e5b5d36d7595504$var$__export = (target, all)=>{
    for(var name in all)$4e5b5d36d7595504$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/logging.ts
var $4e5b5d36d7595504$export$45697122e627faf2 = {};
$4e5b5d36d7595504$var$__export($4e5b5d36d7595504$export$45697122e627faf2, {
    VeChainSDKLogger: ()=>$4e5b5d36d7595504$export$924d43bf16eee9cc
});
// src/logger/log-logger/log-logger.ts
var $4e5b5d36d7595504$var$_logLogFunction = {
    log: (data)=>{
        const messagesAsString = data.messages.map((message)=>`- ${message}`).join("\n");
        console.log(`
****************** EVENT: ${data.title} ******************
` + messagesAsString + `
`);
    }
};
// src/logger/error-logger/error-logger.ts
var $4e5b5d36d7595504$var$_logErrorFunction = {
    log: (error)=>{
        console.error(`
****************** ERROR ON: ${error.methodName} ******************
- Error message: '${error.errorMessage}'
- Error data:
`, error.data, `
- Internal error:
`, error.innerError, `
`);
    }
};
// src/logger/warning-logger/warning-logger.ts
var $4e5b5d36d7595504$var$_logWarningFunction = {
    log: (data)=>{
        const messagesAsString = data.messages.map((message)=>`- ${message}`).join("\n");
        console.warn(`
****************** WARNING: ${data.title} ******************
` + messagesAsString + `
`);
    }
};
// src/logger/vechainSDKLogger.ts
var $4e5b5d36d7595504$export$924d43bf16eee9cc = (loggerType)=>{
    if (loggerType === "error") return $4e5b5d36d7595504$var$_logErrorFunction;
    if (loggerType === "warning") return $4e5b5d36d7595504$var$_logWarningFunction;
    return $4e5b5d36d7595504$var$_logLogFunction;
};


var $2d0e1e19edfeea80$exports = {};
"use strict";
Object.defineProperty($2d0e1e19edfeea80$exports, "__esModule", {
    value: true
});
$2d0e1e19edfeea80$exports.unsafe = $2d0e1e19edfeea80$exports.aeskwp = $2d0e1e19edfeea80$exports.aeskw = $2d0e1e19edfeea80$exports.siv = $2d0e1e19edfeea80$exports.gcm = $2d0e1e19edfeea80$exports.cfb = $2d0e1e19edfeea80$exports.cbc = $2d0e1e19edfeea80$exports.ecb = $2d0e1e19edfeea80$exports.ctr = void 0;

var $634456ee3058786c$exports = {};
"use strict";
Object.defineProperty($634456ee3058786c$exports, "__esModule", {
    value: true
});
$634456ee3058786c$exports.polyval = $634456ee3058786c$exports.ghash = void 0;
$634456ee3058786c$exports._toGHASHKey = $634456ee3058786c$var$_toGHASHKey;


const $634456ee3058786c$var$BLOCK_SIZE = 16;
// TODO: rewrite
// temporary padding buffer
const $634456ee3058786c$var$ZEROS16 = /* @__PURE__ */ new Uint8Array(16);
const $634456ee3058786c$var$ZEROS32 = (0, $248bf24903c02b9f$exports.u32)($634456ee3058786c$var$ZEROS16);
const $634456ee3058786c$var$POLY = 0xe1; // v = 2*v % POLY
// v = 2*v % POLY
// NOTE: because x + x = 0 (add/sub is same), mul2(x) != x+x
// We can multiply any number using montgomery ladder and this function (works as double, add is simple xor)
const $634456ee3058786c$var$mul2 = (s0, s1, s2, s3)=>{
    const hiBit = s3 & 1;
    return {
        s3: s2 << 31 | s3 >>> 1,
        s2: s1 << 31 | s2 >>> 1,
        s1: s0 << 31 | s1 >>> 1,
        s0: s0 >>> 1 ^ $634456ee3058786c$var$POLY << 24 & -(hiBit & 1)
    };
};
const $634456ee3058786c$var$swapLE = (n)=>(n >>> 0 & 0xff) << 24 | (n >>> 8 & 0xff) << 16 | (n >>> 16 & 0xff) << 8 | n >>> 24 & 0xff | 0;
/**
 * `mulX_POLYVAL(ByteReverse(H))` from spec
 * @param k mutated in place
 */ function $634456ee3058786c$var$_toGHASHKey(k) {
    k.reverse();
    const hiBit = k[15] & 1;
    // k >>= 1
    let carry = 0;
    for(let i = 0; i < k.length; i++){
        const t = k[i];
        k[i] = t >>> 1 | carry;
        carry = (t & 1) << 7;
    }
    k[0] ^= -hiBit & 0xe1; // if (hiBit) n ^= 0xe1000000000000000000000000000000;
    return k;
}
const $634456ee3058786c$var$estimateWindow = (bytes)=>{
    if (bytes > 65536) return 8;
    if (bytes > 1024) return 4;
    return 2;
};
class $634456ee3058786c$var$GHASH {
    // We select bits per window adaptively based on expectedLength
    constructor(key, expectedLength){
        this.blockLen = $634456ee3058786c$var$BLOCK_SIZE;
        this.outputLen = $634456ee3058786c$var$BLOCK_SIZE;
        this.s0 = 0;
        this.s1 = 0;
        this.s2 = 0;
        this.s3 = 0;
        this.finished = false;
        key = (0, $248bf24903c02b9f$exports.toBytes)(key);
        (0, $5e86e7af933ab8a1$exports.abytes)(key, 16);
        const kView = (0, $248bf24903c02b9f$exports.createView)(key);
        let k0 = kView.getUint32(0, false);
        let k1 = kView.getUint32(4, false);
        let k2 = kView.getUint32(8, false);
        let k3 = kView.getUint32(12, false);
        // generate table of doubled keys (half of montgomery ladder)
        const doubles = [];
        for(let i = 0; i < 128; i++){
            doubles.push({
                s0: $634456ee3058786c$var$swapLE(k0),
                s1: $634456ee3058786c$var$swapLE(k1),
                s2: $634456ee3058786c$var$swapLE(k2),
                s3: $634456ee3058786c$var$swapLE(k3)
            });
            ({ s0: k0, s1: k1, s2: k2, s3: k3 } = $634456ee3058786c$var$mul2(k0, k1, k2, k3));
        }
        const W = $634456ee3058786c$var$estimateWindow(expectedLength || 1024);
        if (![
            1,
            2,
            4,
            8
        ].includes(W)) throw new Error("ghash: invalid window size, expected 2, 4 or 8");
        this.W = W;
        const bits = 128; // always 128 bits;
        const windows = bits / W;
        const windowSize = this.windowSize = 2 ** W;
        const items = [];
        // Create precompute table for window of W bits
        for(let w = 0; w < windows; w++)// truth table: 00, 01, 10, 11
        for(let byte = 0; byte < windowSize; byte++){
            // prettier-ignore
            let s0 = 0, s1 = 0, s2 = 0, s3 = 0;
            for(let j = 0; j < W; j++){
                const bit = byte >>> W - j - 1 & 1;
                if (!bit) continue;
                const { s0: d0, s1: d1, s2: d2, s3: d3 } = doubles[W * w + j];
                s0 ^= d0, s1 ^= d1, s2 ^= d2, s3 ^= d3;
            }
            items.push({
                s0: s0,
                s1: s1,
                s2: s2,
                s3: s3
            });
        }
        this.t = items;
    }
    _updateBlock(s0, s1, s2, s3) {
        s0 ^= this.s0, s1 ^= this.s1, s2 ^= this.s2, s3 ^= this.s3;
        const { W: W, t: t, windowSize: windowSize } = this;
        // prettier-ignore
        let o0 = 0, o1 = 0, o2 = 0, o3 = 0;
        const mask = (1 << W) - 1; // 2**W will kill performance.
        let w = 0;
        for (const num of [
            s0,
            s1,
            s2,
            s3
        ])for(let bytePos = 0; bytePos < 4; bytePos++){
            const byte = num >>> 8 * bytePos & 0xff;
            for(let bitPos = 8 / W - 1; bitPos >= 0; bitPos--){
                const bit = byte >>> W * bitPos & mask;
                const { s0: e0, s1: e1, s2: e2, s3: e3 } = t[w * windowSize + bit];
                o0 ^= e0, o1 ^= e1, o2 ^= e2, o3 ^= e3;
                w += 1;
            }
        }
        this.s0 = o0;
        this.s1 = o1;
        this.s2 = o2;
        this.s3 = o3;
    }
    update(data) {
        data = (0, $248bf24903c02b9f$exports.toBytes)(data);
        (0, $5e86e7af933ab8a1$exports.aexists)(this);
        const b32 = (0, $248bf24903c02b9f$exports.u32)(data);
        const blocks = Math.floor(data.length / $634456ee3058786c$var$BLOCK_SIZE);
        const left = data.length % $634456ee3058786c$var$BLOCK_SIZE;
        for(let i = 0; i < blocks; i++)this._updateBlock(b32[i * 4 + 0], b32[i * 4 + 1], b32[i * 4 + 2], b32[i * 4 + 3]);
        if (left) {
            $634456ee3058786c$var$ZEROS16.set(data.subarray(blocks * $634456ee3058786c$var$BLOCK_SIZE));
            this._updateBlock($634456ee3058786c$var$ZEROS32[0], $634456ee3058786c$var$ZEROS32[1], $634456ee3058786c$var$ZEROS32[2], $634456ee3058786c$var$ZEROS32[3]);
            (0, $248bf24903c02b9f$exports.clean)($634456ee3058786c$var$ZEROS32); // clean tmp buffer
        }
        return this;
    }
    destroy() {
        const { t: t } = this;
        // clean precompute table
        for (const elm of t)elm.s0 = 0, elm.s1 = 0, elm.s2 = 0, elm.s3 = 0;
    }
    digestInto(out) {
        (0, $5e86e7af933ab8a1$exports.aexists)(this);
        (0, $5e86e7af933ab8a1$exports.aoutput)(out, this);
        this.finished = true;
        const { s0: s0, s1: s1, s2: s2, s3: s3 } = this;
        const o32 = (0, $248bf24903c02b9f$exports.u32)(out);
        o32[0] = s0;
        o32[1] = s1;
        o32[2] = s2;
        o32[3] = s3;
        return out;
    }
    digest() {
        const res = new Uint8Array($634456ee3058786c$var$BLOCK_SIZE);
        this.digestInto(res);
        this.destroy();
        return res;
    }
}
class $634456ee3058786c$var$Polyval extends $634456ee3058786c$var$GHASH {
    constructor(key, expectedLength){
        key = (0, $248bf24903c02b9f$exports.toBytes)(key);
        const ghKey = $634456ee3058786c$var$_toGHASHKey((0, $248bf24903c02b9f$exports.copyBytes)(key));
        super(ghKey, expectedLength);
        (0, $248bf24903c02b9f$exports.clean)(ghKey);
    }
    update(data) {
        data = (0, $248bf24903c02b9f$exports.toBytes)(data);
        (0, $5e86e7af933ab8a1$exports.aexists)(this);
        const b32 = (0, $248bf24903c02b9f$exports.u32)(data);
        const left = data.length % $634456ee3058786c$var$BLOCK_SIZE;
        const blocks = Math.floor(data.length / $634456ee3058786c$var$BLOCK_SIZE);
        for(let i = 0; i < blocks; i++)this._updateBlock($634456ee3058786c$var$swapLE(b32[i * 4 + 3]), $634456ee3058786c$var$swapLE(b32[i * 4 + 2]), $634456ee3058786c$var$swapLE(b32[i * 4 + 1]), $634456ee3058786c$var$swapLE(b32[i * 4 + 0]));
        if (left) {
            $634456ee3058786c$var$ZEROS16.set(data.subarray(blocks * $634456ee3058786c$var$BLOCK_SIZE));
            this._updateBlock($634456ee3058786c$var$swapLE($634456ee3058786c$var$ZEROS32[3]), $634456ee3058786c$var$swapLE($634456ee3058786c$var$ZEROS32[2]), $634456ee3058786c$var$swapLE($634456ee3058786c$var$ZEROS32[1]), $634456ee3058786c$var$swapLE($634456ee3058786c$var$ZEROS32[0]));
            (0, $248bf24903c02b9f$exports.clean)($634456ee3058786c$var$ZEROS32);
        }
        return this;
    }
    digestInto(out) {
        (0, $5e86e7af933ab8a1$exports.aexists)(this);
        (0, $5e86e7af933ab8a1$exports.aoutput)(out, this);
        this.finished = true;
        // tmp ugly hack
        const { s0: s0, s1: s1, s2: s2, s3: s3 } = this;
        const o32 = (0, $248bf24903c02b9f$exports.u32)(out);
        o32[0] = s0;
        o32[1] = s1;
        o32[2] = s2;
        o32[3] = s3;
        return out.reverse();
    }
}
function $634456ee3058786c$var$wrapConstructorWithKey(hashCons) {
    const hashC = (msg, key)=>hashCons(key, msg.length).update((0, $248bf24903c02b9f$exports.toBytes)(msg)).digest();
    const tmp = hashCons(new Uint8Array(16), 0);
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (key, expectedLength)=>hashCons(key, expectedLength);
    return hashC;
}
/** GHash MAC for AES-GCM. */ $634456ee3058786c$exports.ghash = $634456ee3058786c$var$wrapConstructorWithKey((key, expectedLength)=>new $634456ee3058786c$var$GHASH(key, expectedLength));
/** Polyval MAC for AES-SIV. */ $634456ee3058786c$exports.polyval = $634456ee3058786c$var$wrapConstructorWithKey((key, expectedLength)=>new $634456ee3058786c$var$Polyval(key, expectedLength));



const $2d0e1e19edfeea80$var$BLOCK_SIZE = 16;
const $2d0e1e19edfeea80$var$BLOCK_SIZE32 = 4;
const $2d0e1e19edfeea80$var$EMPTY_BLOCK = /* @__PURE__ */ new Uint8Array($2d0e1e19edfeea80$var$BLOCK_SIZE);
const $2d0e1e19edfeea80$var$POLY = 0x11b; // 1 + x + x**3 + x**4 + x**8
// TODO: remove multiplication, binary ops only
function $2d0e1e19edfeea80$var$mul2(n) {
    return n << 1 ^ $2d0e1e19edfeea80$var$POLY & -(n >> 7);
}
function $2d0e1e19edfeea80$var$mul(a, b) {
    let res = 0;
    for(; b > 0; b >>= 1){
        // Montgomery ladder
        res ^= a & -(b & 1); // if (b&1) res ^=a (but const-time).
        a = $2d0e1e19edfeea80$var$mul2(a); // a = 2*a
    }
    return res;
}
// AES S-box is generated using finite field inversion,
// an affine transform, and xor of a constant 0x63.
const $2d0e1e19edfeea80$var$sbox = /* @__PURE__ */ (()=>{
    const t = new Uint8Array(256);
    for(let i = 0, x = 1; i < 256; i++, x ^= $2d0e1e19edfeea80$var$mul2(x))t[i] = x;
    const box = new Uint8Array(256);
    box[0] = 0x63; // first elm
    for(let i = 0; i < 255; i++){
        let x = t[255 - i];
        x |= x << 8;
        box[t[i]] = (x ^ x >> 4 ^ x >> 5 ^ x >> 6 ^ x >> 7 ^ 0x63) & 0xff;
    }
    (0, $248bf24903c02b9f$exports.clean)(t);
    return box;
})();
// Inverted S-box
const $2d0e1e19edfeea80$var$invSbox = /* @__PURE__ */ $2d0e1e19edfeea80$var$sbox.map((_, j)=>$2d0e1e19edfeea80$var$sbox.indexOf(j));
// Rotate u32 by 8
const $2d0e1e19edfeea80$var$rotr32_8 = (n)=>n << 24 | n >>> 8;
const $2d0e1e19edfeea80$var$rotl32_8 = (n)=>n << 8 | n >>> 24;
// The byte swap operation for uint32 (LE<->BE)
const $2d0e1e19edfeea80$var$byteSwap = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
// T-table is optimization suggested in 5.2 of original proposal (missed from FIPS-197). Changes:
// - LE instead of BE
// - bigger tables: T0 and T1 are merged into T01 table and T2 & T3 into T23;
//   so index is u16, instead of u8. This speeds up things, unexpectedly
function $2d0e1e19edfeea80$var$genTtable(sbox, fn) {
    if (sbox.length !== 256) throw new Error("Wrong sbox length");
    const T0 = new Uint32Array(256).map((_, j)=>fn(sbox[j]));
    const T1 = T0.map($2d0e1e19edfeea80$var$rotl32_8);
    const T2 = T1.map($2d0e1e19edfeea80$var$rotl32_8);
    const T3 = T2.map($2d0e1e19edfeea80$var$rotl32_8);
    const T01 = new Uint32Array(65536);
    const T23 = new Uint32Array(65536);
    const sbox2 = new Uint16Array(65536);
    for(let i = 0; i < 256; i++)for(let j = 0; j < 256; j++){
        const idx = i * 256 + j;
        T01[idx] = T0[i] ^ T1[j];
        T23[idx] = T2[i] ^ T3[j];
        sbox2[idx] = sbox[i] << 8 | sbox[j];
    }
    return {
        sbox: sbox,
        sbox2: sbox2,
        T0: T0,
        T1: T1,
        T2: T2,
        T3: T3,
        T01: T01,
        T23: T23
    };
}
const $2d0e1e19edfeea80$var$tableEncoding = /* @__PURE__ */ $2d0e1e19edfeea80$var$genTtable($2d0e1e19edfeea80$var$sbox, (s)=>$2d0e1e19edfeea80$var$mul(s, 3) << 24 | s << 16 | s << 8 | $2d0e1e19edfeea80$var$mul(s, 2));
const $2d0e1e19edfeea80$var$tableDecoding = /* @__PURE__ */ $2d0e1e19edfeea80$var$genTtable($2d0e1e19edfeea80$var$invSbox, (s)=>$2d0e1e19edfeea80$var$mul(s, 11) << 24 | $2d0e1e19edfeea80$var$mul(s, 13) << 16 | $2d0e1e19edfeea80$var$mul(s, 9) << 8 | $2d0e1e19edfeea80$var$mul(s, 14));
const $2d0e1e19edfeea80$var$xPowers = /* @__PURE__ */ (()=>{
    const p = new Uint8Array(16);
    for(let i = 0, x = 1; i < 16; i++, x = $2d0e1e19edfeea80$var$mul2(x))p[i] = x;
    return p;
})();
/** Key expansion used in CTR. */ function $2d0e1e19edfeea80$var$expandKeyLE(key) {
    (0, $5e86e7af933ab8a1$exports.abytes)(key);
    const len = key.length;
    if (![
        16,
        24,
        32
    ].includes(len)) throw new Error("aes: invalid key size, should be 16, 24 or 32, got " + len);
    const { sbox2: sbox2 } = $2d0e1e19edfeea80$var$tableEncoding;
    const toClean = [];
    if (!(0, $248bf24903c02b9f$exports.isAligned32)(key)) toClean.push(key = (0, $248bf24903c02b9f$exports.copyBytes)(key));
    const k32 = (0, $248bf24903c02b9f$exports.u32)(key);
    const Nk = k32.length;
    const subByte = (n)=>$2d0e1e19edfeea80$var$applySbox(sbox2, n, n, n, n);
    const xk = new Uint32Array(len + 28); // expanded key
    xk.set(k32);
    // 4.3.1 Key expansion
    for(let i = Nk; i < xk.length; i++){
        let t = xk[i - 1];
        if (i % Nk === 0) t = subByte($2d0e1e19edfeea80$var$rotr32_8(t)) ^ $2d0e1e19edfeea80$var$xPowers[i / Nk - 1];
        else if (Nk > 6 && i % Nk === 4) t = subByte(t);
        xk[i] = xk[i - Nk] ^ t;
    }
    (0, $248bf24903c02b9f$exports.clean)(...toClean);
    return xk;
}
function $2d0e1e19edfeea80$var$expandKeyDecLE(key) {
    const encKey = $2d0e1e19edfeea80$var$expandKeyLE(key);
    const xk = encKey.slice();
    const Nk = encKey.length;
    const { sbox2: sbox2 } = $2d0e1e19edfeea80$var$tableEncoding;
    const { T0: T0, T1: T1, T2: T2, T3: T3 } = $2d0e1e19edfeea80$var$tableDecoding;
    // Inverse key by chunks of 4 (rounds)
    for(let i = 0; i < Nk; i += 4)for(let j = 0; j < 4; j++)xk[i + j] = encKey[Nk - i - 4 + j];
    (0, $248bf24903c02b9f$exports.clean)(encKey);
    // apply InvMixColumn except first & last round
    for(let i = 4; i < Nk - 4; i++){
        const x = xk[i];
        const w = $2d0e1e19edfeea80$var$applySbox(sbox2, x, x, x, x);
        xk[i] = T0[w & 0xff] ^ T1[w >>> 8 & 0xff] ^ T2[w >>> 16 & 0xff] ^ T3[w >>> 24];
    }
    return xk;
}
// Apply tables
function $2d0e1e19edfeea80$var$apply0123(T01, T23, s0, s1, s2, s3) {
    return T01[s0 << 8 & 0xff00 | s1 >>> 8 & 0xff] ^ T23[s2 >>> 8 & 0xff00 | s3 >>> 24 & 0xff];
}
function $2d0e1e19edfeea80$var$applySbox(sbox2, s0, s1, s2, s3) {
    return sbox2[s0 & 0xff | s1 & 0xff00] | sbox2[s2 >>> 16 & 0xff | s3 >>> 16 & 0xff00] << 16;
}
function $2d0e1e19edfeea80$var$encrypt(xk, s0, s1, s2, s3) {
    const { sbox2: sbox2, T01: T01, T23: T23 } = $2d0e1e19edfeea80$var$tableEncoding;
    let k = 0;
    s0 ^= xk[k++], s1 ^= xk[k++], s2 ^= xk[k++], s3 ^= xk[k++];
    const rounds = xk.length / 4 - 2;
    for(let i = 0; i < rounds; i++){
        const t0 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s0, s1, s2, s3);
        const t1 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s1, s2, s3, s0);
        const t2 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s2, s3, s0, s1);
        const t3 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s3, s0, s1, s2);
        s0 = t0, s1 = t1, s2 = t2, s3 = t3;
    }
    // last round (without mixcolumns, so using SBOX2 table)
    const t0 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s0, s1, s2, s3);
    const t1 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s1, s2, s3, s0);
    const t2 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s2, s3, s0, s1);
    const t3 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s3, s0, s1, s2);
    return {
        s0: t0,
        s1: t1,
        s2: t2,
        s3: t3
    };
}
// Can't be merged with encrypt: arg positions for apply0123 / applySbox are different
function $2d0e1e19edfeea80$var$decrypt(xk, s0, s1, s2, s3) {
    const { sbox2: sbox2, T01: T01, T23: T23 } = $2d0e1e19edfeea80$var$tableDecoding;
    let k = 0;
    s0 ^= xk[k++], s1 ^= xk[k++], s2 ^= xk[k++], s3 ^= xk[k++];
    const rounds = xk.length / 4 - 2;
    for(let i = 0; i < rounds; i++){
        const t0 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s0, s3, s2, s1);
        const t1 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s1, s0, s3, s2);
        const t2 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s2, s1, s0, s3);
        const t3 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s3, s2, s1, s0);
        s0 = t0, s1 = t1, s2 = t2, s3 = t3;
    }
    // Last round
    const t0 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s0, s3, s2, s1);
    const t1 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s1, s0, s3, s2);
    const t2 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s2, s1, s0, s3);
    const t3 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s3, s2, s1, s0);
    return {
        s0: t0,
        s1: t1,
        s2: t2,
        s3: t3
    };
}
// TODO: investigate merging with ctr32
function $2d0e1e19edfeea80$var$ctrCounter(xk, nonce, src, dst) {
    (0, $5e86e7af933ab8a1$exports.abytes)(nonce, $2d0e1e19edfeea80$var$BLOCK_SIZE);
    (0, $5e86e7af933ab8a1$exports.abytes)(src);
    const srcLen = src.length;
    dst = (0, $248bf24903c02b9f$exports.getOutput)(srcLen, dst);
    (0, $248bf24903c02b9f$exports.complexOverlapBytes)(src, dst);
    const ctr = nonce;
    const c32 = (0, $248bf24903c02b9f$exports.u32)(ctr);
    // Fill block (empty, ctr=0)
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]);
    const src32 = (0, $248bf24903c02b9f$exports.u32)(src);
    const dst32 = (0, $248bf24903c02b9f$exports.u32)(dst);
    // process blocks
    for(let i = 0; i + 4 <= src32.length; i += 4){
        dst32[i + 0] = src32[i + 0] ^ s0;
        dst32[i + 1] = src32[i + 1] ^ s1;
        dst32[i + 2] = src32[i + 2] ^ s2;
        dst32[i + 3] = src32[i + 3] ^ s3;
        // Full 128 bit counter with wrap around
        let carry = 1;
        for(let i = ctr.length - 1; i >= 0; i--){
            carry = carry + (ctr[i] & 0xff) | 0;
            ctr[i] = carry & 0xff;
            carry >>>= 8;
        }
        ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]));
    }
    // leftovers (less than block)
    // It's possible to handle > u32 fast, but is it worth it?
    const start = $2d0e1e19edfeea80$var$BLOCK_SIZE * Math.floor(src32.length / $2d0e1e19edfeea80$var$BLOCK_SIZE32);
    if (start < srcLen) {
        const b32 = new Uint32Array([
            s0,
            s1,
            s2,
            s3
        ]);
        const buf = (0, $248bf24903c02b9f$exports.u8)(b32);
        for(let i = start, pos = 0; i < srcLen; i++, pos++)dst[i] = src[i] ^ buf[pos];
        (0, $248bf24903c02b9f$exports.clean)(b32);
    }
    return dst;
}
// AES CTR with overflowing 32 bit counter
// It's possible to do 32le significantly simpler (and probably faster) by using u32.
// But, we need both, and perf bottleneck is in ghash anyway.
function $2d0e1e19edfeea80$var$ctr32(xk, isLE, nonce, src, dst) {
    (0, $5e86e7af933ab8a1$exports.abytes)(nonce, $2d0e1e19edfeea80$var$BLOCK_SIZE);
    (0, $5e86e7af933ab8a1$exports.abytes)(src);
    dst = (0, $248bf24903c02b9f$exports.getOutput)(src.length, dst);
    const ctr = nonce; // write new value to nonce, so it can be re-used
    const c32 = (0, $248bf24903c02b9f$exports.u32)(ctr);
    const view = (0, $248bf24903c02b9f$exports.createView)(ctr);
    const src32 = (0, $248bf24903c02b9f$exports.u32)(src);
    const dst32 = (0, $248bf24903c02b9f$exports.u32)(dst);
    const ctrPos = isLE ? 0 : 12;
    const srcLen = src.length;
    // Fill block (empty, ctr=0)
    let ctrNum = view.getUint32(ctrPos, isLE); // read current counter value
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]);
    // process blocks
    for(let i = 0; i + 4 <= src32.length; i += 4){
        dst32[i + 0] = src32[i + 0] ^ s0;
        dst32[i + 1] = src32[i + 1] ^ s1;
        dst32[i + 2] = src32[i + 2] ^ s2;
        dst32[i + 3] = src32[i + 3] ^ s3;
        ctrNum = ctrNum + 1 >>> 0; // u32 wrap
        view.setUint32(ctrPos, ctrNum, isLE);
        ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]));
    }
    // leftovers (less than a block)
    const start = $2d0e1e19edfeea80$var$BLOCK_SIZE * Math.floor(src32.length / $2d0e1e19edfeea80$var$BLOCK_SIZE32);
    if (start < srcLen) {
        const b32 = new Uint32Array([
            s0,
            s1,
            s2,
            s3
        ]);
        const buf = (0, $248bf24903c02b9f$exports.u8)(b32);
        for(let i = start, pos = 0; i < srcLen; i++, pos++)dst[i] = src[i] ^ buf[pos];
        (0, $248bf24903c02b9f$exports.clean)(b32);
    }
    return dst;
}
/**
 * CTR: counter mode. Creates stream cipher.
 * Requires good IV. Parallelizable. OK, but no MAC.
 */ $2d0e1e19edfeea80$exports.ctr = (0, $248bf24903c02b9f$exports.wrapCipher)({
    blockSize: 16,
    nonceLength: 16
}, function aesctr(key, nonce) {
    function processCtr(buf, dst) {
        (0, $5e86e7af933ab8a1$exports.abytes)(buf);
        if (dst !== undefined) {
            (0, $5e86e7af933ab8a1$exports.abytes)(dst);
            if (!(0, $248bf24903c02b9f$exports.isAligned32)(dst)) throw new Error("unaligned destination");
        }
        const xk = $2d0e1e19edfeea80$var$expandKeyLE(key);
        const n = (0, $248bf24903c02b9f$exports.copyBytes)(nonce); // align + avoid changing
        const toClean = [
            xk,
            n
        ];
        if (!(0, $248bf24903c02b9f$exports.isAligned32)(buf)) toClean.push(buf = (0, $248bf24903c02b9f$exports.copyBytes)(buf));
        const out = $2d0e1e19edfeea80$var$ctrCounter(xk, n, buf, dst);
        (0, $248bf24903c02b9f$exports.clean)(...toClean);
        return out;
    }
    return {
        encrypt: (plaintext, dst)=>processCtr(plaintext, dst),
        decrypt: (ciphertext, dst)=>processCtr(ciphertext, dst)
    };
});
function $2d0e1e19edfeea80$var$validateBlockDecrypt(data) {
    (0, $5e86e7af933ab8a1$exports.abytes)(data);
    if (data.length % $2d0e1e19edfeea80$var$BLOCK_SIZE !== 0) throw new Error("aes-(cbc/ecb).decrypt ciphertext should consist of blocks with size " + $2d0e1e19edfeea80$var$BLOCK_SIZE);
}
function $2d0e1e19edfeea80$var$validateBlockEncrypt(plaintext, pcks5, dst) {
    (0, $5e86e7af933ab8a1$exports.abytes)(plaintext);
    let outLen = plaintext.length;
    const remaining = outLen % $2d0e1e19edfeea80$var$BLOCK_SIZE;
    if (!pcks5 && remaining !== 0) throw new Error("aec/(cbc-ecb): unpadded plaintext with disabled padding");
    if (!(0, $248bf24903c02b9f$exports.isAligned32)(plaintext)) plaintext = (0, $248bf24903c02b9f$exports.copyBytes)(plaintext);
    const b = (0, $248bf24903c02b9f$exports.u32)(plaintext);
    if (pcks5) {
        let left = $2d0e1e19edfeea80$var$BLOCK_SIZE - remaining;
        if (!left) left = $2d0e1e19edfeea80$var$BLOCK_SIZE; // if no bytes left, create empty padding block
        outLen = outLen + left;
    }
    dst = (0, $248bf24903c02b9f$exports.getOutput)(outLen, dst);
    (0, $248bf24903c02b9f$exports.complexOverlapBytes)(plaintext, dst);
    const o = (0, $248bf24903c02b9f$exports.u32)(dst);
    return {
        b: b,
        o: o,
        out: dst
    };
}
function $2d0e1e19edfeea80$var$validatePCKS(data, pcks5) {
    if (!pcks5) return data;
    const len = data.length;
    if (!len) throw new Error("aes/pcks5: empty ciphertext not allowed");
    const lastByte = data[len - 1];
    if (lastByte <= 0 || lastByte > 16) throw new Error("aes/pcks5: wrong padding");
    const out = data.subarray(0, -lastByte);
    for(let i = 0; i < lastByte; i++)if (data[len - i - 1] !== lastByte) throw new Error("aes/pcks5: wrong padding");
    return out;
}
function $2d0e1e19edfeea80$var$padPCKS(left) {
    const tmp = new Uint8Array(16);
    const tmp32 = (0, $248bf24903c02b9f$exports.u32)(tmp);
    tmp.set(left);
    const paddingByte = $2d0e1e19edfeea80$var$BLOCK_SIZE - left.length;
    for(let i = $2d0e1e19edfeea80$var$BLOCK_SIZE - paddingByte; i < $2d0e1e19edfeea80$var$BLOCK_SIZE; i++)tmp[i] = paddingByte;
    return tmp32;
}
/**
 * ECB: Electronic CodeBook. Simple deterministic replacement.
 * Dangerous: always map x to y. See [AES Penguin](https://words.filippo.io/the-ecb-penguin/).
 */ $2d0e1e19edfeea80$exports.ecb = (0, $248bf24903c02b9f$exports.wrapCipher)({
    blockSize: 16
}, function aesecb(key, opts = {}) {
    const pcks5 = !opts.disablePadding;
    return {
        encrypt (plaintext, dst) {
            const { b: b, o: o, out: _out } = $2d0e1e19edfeea80$var$validateBlockEncrypt(plaintext, pcks5, dst);
            const xk = $2d0e1e19edfeea80$var$expandKeyLE(key);
            let i = 0;
            for(; i + 4 <= b.length;){
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, b[i + 0], b[i + 1], b[i + 2], b[i + 3]);
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            if (pcks5) {
                const tmp32 = $2d0e1e19edfeea80$var$padPCKS(plaintext.subarray(i * 4));
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, tmp32[0], tmp32[1], tmp32[2], tmp32[3]);
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            (0, $248bf24903c02b9f$exports.clean)(xk);
            return _out;
        },
        decrypt (ciphertext, dst) {
            $2d0e1e19edfeea80$var$validateBlockDecrypt(ciphertext);
            const xk = $2d0e1e19edfeea80$var$expandKeyDecLE(key);
            dst = (0, $248bf24903c02b9f$exports.getOutput)(ciphertext.length, dst);
            const toClean = [
                xk
            ];
            if (!(0, $248bf24903c02b9f$exports.isAligned32)(ciphertext)) toClean.push(ciphertext = (0, $248bf24903c02b9f$exports.copyBytes)(ciphertext));
            (0, $248bf24903c02b9f$exports.complexOverlapBytes)(ciphertext, dst);
            const b = (0, $248bf24903c02b9f$exports.u32)(ciphertext);
            const o = (0, $248bf24903c02b9f$exports.u32)(dst);
            for(let i = 0; i + 4 <= b.length;){
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$decrypt(xk, b[i + 0], b[i + 1], b[i + 2], b[i + 3]);
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            (0, $248bf24903c02b9f$exports.clean)(...toClean);
            return $2d0e1e19edfeea80$var$validatePCKS(dst, pcks5);
        }
    };
});
/**
 * CBC: Cipher-Block-Chaining. Key is previous round’s block.
 * Fragile: needs proper padding. Unauthenticated: needs MAC.
 */ $2d0e1e19edfeea80$exports.cbc = (0, $248bf24903c02b9f$exports.wrapCipher)({
    blockSize: 16,
    nonceLength: 16
}, function aescbc(key, iv, opts = {}) {
    const pcks5 = !opts.disablePadding;
    return {
        encrypt (plaintext, dst) {
            const xk = $2d0e1e19edfeea80$var$expandKeyLE(key);
            const { b: b, o: o, out: _out } = $2d0e1e19edfeea80$var$validateBlockEncrypt(plaintext, pcks5, dst);
            let _iv = iv;
            const toClean = [
                xk
            ];
            if (!(0, $248bf24903c02b9f$exports.isAligned32)(_iv)) toClean.push(_iv = (0, $248bf24903c02b9f$exports.copyBytes)(_iv));
            const n32 = (0, $248bf24903c02b9f$exports.u32)(_iv);
            // prettier-ignore
            let s0 = n32[0], s1 = n32[1], s2 = n32[2], s3 = n32[3];
            let i = 0;
            for(; i + 4 <= b.length;){
                s0 ^= b[i + 0], s1 ^= b[i + 1], s2 ^= b[i + 2], s3 ^= b[i + 3];
                ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, s0, s1, s2, s3));
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            if (pcks5) {
                const tmp32 = $2d0e1e19edfeea80$var$padPCKS(plaintext.subarray(i * 4));
                s0 ^= tmp32[0], s1 ^= tmp32[1], s2 ^= tmp32[2], s3 ^= tmp32[3];
                ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, s0, s1, s2, s3));
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            (0, $248bf24903c02b9f$exports.clean)(...toClean);
            return _out;
        },
        decrypt (ciphertext, dst) {
            $2d0e1e19edfeea80$var$validateBlockDecrypt(ciphertext);
            const xk = $2d0e1e19edfeea80$var$expandKeyDecLE(key);
            let _iv = iv;
            const toClean = [
                xk
            ];
            if (!(0, $248bf24903c02b9f$exports.isAligned32)(_iv)) toClean.push(_iv = (0, $248bf24903c02b9f$exports.copyBytes)(_iv));
            const n32 = (0, $248bf24903c02b9f$exports.u32)(_iv);
            dst = (0, $248bf24903c02b9f$exports.getOutput)(ciphertext.length, dst);
            if (!(0, $248bf24903c02b9f$exports.isAligned32)(ciphertext)) toClean.push(ciphertext = (0, $248bf24903c02b9f$exports.copyBytes)(ciphertext));
            (0, $248bf24903c02b9f$exports.complexOverlapBytes)(ciphertext, dst);
            const b = (0, $248bf24903c02b9f$exports.u32)(ciphertext);
            const o = (0, $248bf24903c02b9f$exports.u32)(dst);
            // prettier-ignore
            let s0 = n32[0], s1 = n32[1], s2 = n32[2], s3 = n32[3];
            for(let i = 0; i + 4 <= b.length;){
                // prettier-ignore
                const ps0 = s0, ps1 = s1, ps2 = s2, ps3 = s3;
                s0 = b[i + 0], s1 = b[i + 1], s2 = b[i + 2], s3 = b[i + 3];
                const { s0: o0, s1: o1, s2: o2, s3: o3 } = $2d0e1e19edfeea80$var$decrypt(xk, s0, s1, s2, s3);
                o[i++] = o0 ^ ps0, o[i++] = o1 ^ ps1, o[i++] = o2 ^ ps2, o[i++] = o3 ^ ps3;
            }
            (0, $248bf24903c02b9f$exports.clean)(...toClean);
            return $2d0e1e19edfeea80$var$validatePCKS(dst, pcks5);
        }
    };
});
/**
 * CFB: Cipher Feedback Mode. The input for the block cipher is the previous cipher output.
 * Unauthenticated: needs MAC.
 */ $2d0e1e19edfeea80$exports.cfb = (0, $248bf24903c02b9f$exports.wrapCipher)({
    blockSize: 16,
    nonceLength: 16
}, function aescfb(key, iv) {
    function processCfb(src, isEncrypt, dst) {
        (0, $5e86e7af933ab8a1$exports.abytes)(src);
        const srcLen = src.length;
        dst = (0, $248bf24903c02b9f$exports.getOutput)(srcLen, dst);
        if ((0, $248bf24903c02b9f$exports.overlapBytes)(src, dst)) throw new Error("overlapping src and dst not supported.");
        const xk = $2d0e1e19edfeea80$var$expandKeyLE(key);
        let _iv = iv;
        const toClean = [
            xk
        ];
        if (!(0, $248bf24903c02b9f$exports.isAligned32)(_iv)) toClean.push(_iv = (0, $248bf24903c02b9f$exports.copyBytes)(_iv));
        if (!(0, $248bf24903c02b9f$exports.isAligned32)(src)) toClean.push(src = (0, $248bf24903c02b9f$exports.copyBytes)(src));
        const src32 = (0, $248bf24903c02b9f$exports.u32)(src);
        const dst32 = (0, $248bf24903c02b9f$exports.u32)(dst);
        const next32 = isEncrypt ? dst32 : src32;
        const n32 = (0, $248bf24903c02b9f$exports.u32)(_iv);
        // prettier-ignore
        let s0 = n32[0], s1 = n32[1], s2 = n32[2], s3 = n32[3];
        for(let i = 0; i + 4 <= src32.length;){
            const { s0: e0, s1: e1, s2: e2, s3: e3 } = $2d0e1e19edfeea80$var$encrypt(xk, s0, s1, s2, s3);
            dst32[i + 0] = src32[i + 0] ^ e0;
            dst32[i + 1] = src32[i + 1] ^ e1;
            dst32[i + 2] = src32[i + 2] ^ e2;
            dst32[i + 3] = src32[i + 3] ^ e3;
            s0 = next32[i++], s1 = next32[i++], s2 = next32[i++], s3 = next32[i++];
        }
        // leftovers (less than block)
        const start = $2d0e1e19edfeea80$var$BLOCK_SIZE * Math.floor(src32.length / $2d0e1e19edfeea80$var$BLOCK_SIZE32);
        if (start < srcLen) {
            ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, s0, s1, s2, s3));
            const buf = (0, $248bf24903c02b9f$exports.u8)(new Uint32Array([
                s0,
                s1,
                s2,
                s3
            ]));
            for(let i = start, pos = 0; i < srcLen; i++, pos++)dst[i] = src[i] ^ buf[pos];
            (0, $248bf24903c02b9f$exports.clean)(buf);
        }
        (0, $248bf24903c02b9f$exports.clean)(...toClean);
        return dst;
    }
    return {
        encrypt: (plaintext, dst)=>processCfb(plaintext, true, dst),
        decrypt: (ciphertext, dst)=>processCfb(ciphertext, false, dst)
    };
});
// TODO: merge with chacha, however gcm has bitLen while chacha has byteLen
function $2d0e1e19edfeea80$var$computeTag(fn, isLE, key, data, AAD) {
    const aadLength = AAD == null ? 0 : AAD.length;
    const h = fn.create(key, data.length + aadLength);
    if (AAD) h.update(AAD);
    h.update(data);
    const num = new Uint8Array(16);
    const view = (0, $248bf24903c02b9f$exports.createView)(num);
    if (AAD) (0, $248bf24903c02b9f$exports.setBigUint64)(view, 0, BigInt(aadLength * 8), isLE);
    (0, $248bf24903c02b9f$exports.setBigUint64)(view, 8, BigInt(data.length * 8), isLE);
    h.update(num);
    const res = h.digest();
    (0, $248bf24903c02b9f$exports.clean)(num);
    return res;
}
/**
 * GCM: Galois/Counter Mode.
 * Modern, parallel version of CTR, with MAC.
 * Be careful: MACs can be forged.
 * Unsafe to use random nonces under the same key, due to collision chance.
 * As for nonce size, prefer 12-byte, instead of 8-byte.
 */ $2d0e1e19edfeea80$exports.gcm = (0, $248bf24903c02b9f$exports.wrapCipher)({
    blockSize: 16,
    nonceLength: 12,
    tagLength: 16,
    varSizeNonce: true
}, function aesgcm(key, nonce, AAD) {
    // NIST 800-38d doesn't enforce minimum nonce length.
    // We enforce 8 bytes for compat with openssl.
    // 12 bytes are recommended. More than 12 bytes would be converted into 12.
    if (nonce.length < 8) throw new Error("aes/gcm: invalid nonce length");
    const tagLength = 16;
    function _computeTag(authKey, tagMask, data) {
        const tag = $2d0e1e19edfeea80$var$computeTag($634456ee3058786c$exports.ghash, false, authKey, data, AAD);
        for(let i = 0; i < tagMask.length; i++)tag[i] ^= tagMask[i];
        return tag;
    }
    function deriveKeys() {
        const xk = $2d0e1e19edfeea80$var$expandKeyLE(key);
        const authKey = $2d0e1e19edfeea80$var$EMPTY_BLOCK.slice();
        const counter = $2d0e1e19edfeea80$var$EMPTY_BLOCK.slice();
        $2d0e1e19edfeea80$var$ctr32(xk, false, counter, counter, authKey);
        // NIST 800-38d, page 15: different behavior for 96-bit and non-96-bit nonces
        if (nonce.length === 12) counter.set(nonce);
        else {
            const nonceLen = $2d0e1e19edfeea80$var$EMPTY_BLOCK.slice();
            const view = (0, $248bf24903c02b9f$exports.createView)(nonceLen);
            (0, $248bf24903c02b9f$exports.setBigUint64)(view, 8, BigInt(nonce.length * 8), false);
            // ghash(nonce || u64be(0) || u64be(nonceLen*8))
            const g = $634456ee3058786c$exports.ghash.create(authKey).update(nonce).update(nonceLen);
            g.digestInto(counter); // digestInto doesn't trigger '.destroy'
            g.destroy();
        }
        const tagMask = $2d0e1e19edfeea80$var$ctr32(xk, false, counter, $2d0e1e19edfeea80$var$EMPTY_BLOCK);
        return {
            xk: xk,
            authKey: authKey,
            counter: counter,
            tagMask: tagMask
        };
    }
    return {
        encrypt (plaintext) {
            const { xk: xk, authKey: authKey, counter: counter, tagMask: tagMask } = deriveKeys();
            const out = new Uint8Array(plaintext.length + tagLength);
            const toClean = [
                xk,
                authKey,
                counter,
                tagMask
            ];
            if (!(0, $248bf24903c02b9f$exports.isAligned32)(plaintext)) toClean.push(plaintext = (0, $248bf24903c02b9f$exports.copyBytes)(plaintext));
            $2d0e1e19edfeea80$var$ctr32(xk, false, counter, plaintext, out.subarray(0, plaintext.length));
            const tag = _computeTag(authKey, tagMask, out.subarray(0, out.length - tagLength));
            toClean.push(tag);
            out.set(tag, plaintext.length);
            (0, $248bf24903c02b9f$exports.clean)(...toClean);
            return out;
        },
        decrypt (ciphertext) {
            const { xk: xk, authKey: authKey, counter: counter, tagMask: tagMask } = deriveKeys();
            const toClean = [
                xk,
                authKey,
                tagMask,
                counter
            ];
            if (!(0, $248bf24903c02b9f$exports.isAligned32)(ciphertext)) toClean.push(ciphertext = (0, $248bf24903c02b9f$exports.copyBytes)(ciphertext));
            const data = ciphertext.subarray(0, -tagLength);
            const passedTag = ciphertext.subarray(-tagLength);
            const tag = _computeTag(authKey, tagMask, data);
            toClean.push(tag);
            if (!(0, $248bf24903c02b9f$exports.equalBytes)(tag, passedTag)) throw new Error("aes/gcm: invalid ghash tag");
            const out = $2d0e1e19edfeea80$var$ctr32(xk, false, counter, data);
            (0, $248bf24903c02b9f$exports.clean)(...toClean);
            return out;
        }
    };
});
const $2d0e1e19edfeea80$var$limit = (name, min, max)=>(value)=>{
        if (!Number.isSafeInteger(value) || min > value || value > max) {
            const minmax = "[" + min + ".." + max + "]";
            throw new Error("" + name + ": expected value in range " + minmax + ", got " + value);
        }
    };
/**
 * AES-GCM-SIV: classic AES-GCM with nonce-misuse resistance.
 * Guarantees that, when a nonce is repeated, the only security loss is that identical
 * plaintexts will produce identical ciphertexts.
 * RFC 8452, https://datatracker.ietf.org/doc/html/rfc8452
 */ $2d0e1e19edfeea80$exports.siv = (0, $248bf24903c02b9f$exports.wrapCipher)({
    blockSize: 16,
    nonceLength: 12,
    tagLength: 16,
    varSizeNonce: true
}, function aessiv(key, nonce, AAD) {
    const tagLength = 16;
    // From RFC 8452: Section 6
    const AAD_LIMIT = $2d0e1e19edfeea80$var$limit("AAD", 0, 2 ** 36);
    const PLAIN_LIMIT = $2d0e1e19edfeea80$var$limit("plaintext", 0, 2 ** 36);
    const NONCE_LIMIT = $2d0e1e19edfeea80$var$limit("nonce", 12, 12);
    const CIPHER_LIMIT = $2d0e1e19edfeea80$var$limit("ciphertext", 16, 2 ** 36 + 16);
    (0, $5e86e7af933ab8a1$exports.abytes)(key, 16, 24, 32);
    NONCE_LIMIT(nonce.length);
    if (AAD !== undefined) AAD_LIMIT(AAD.length);
    function deriveKeys() {
        const xk = $2d0e1e19edfeea80$var$expandKeyLE(key);
        const encKey = new Uint8Array(key.length);
        const authKey = new Uint8Array(16);
        const toClean = [
            xk,
            encKey
        ];
        let _nonce = nonce;
        if (!(0, $248bf24903c02b9f$exports.isAligned32)(_nonce)) toClean.push(_nonce = (0, $248bf24903c02b9f$exports.copyBytes)(_nonce));
        const n32 = (0, $248bf24903c02b9f$exports.u32)(_nonce);
        // prettier-ignore
        let s0 = 0, s1 = n32[0], s2 = n32[1], s3 = n32[2];
        let counter = 0;
        for (const derivedKey of [
            authKey,
            encKey
        ].map($248bf24903c02b9f$exports.u32)){
            const d32 = (0, $248bf24903c02b9f$exports.u32)(derivedKey);
            for(let i = 0; i < d32.length; i += 2){
                // aes(u32le(0) || nonce)[:8] || aes(u32le(1) || nonce)[:8] ...
                const { s0: o0, s1: o1 } = $2d0e1e19edfeea80$var$encrypt(xk, s0, s1, s2, s3);
                d32[i + 0] = o0;
                d32[i + 1] = o1;
                s0 = ++counter; // increment counter inside state
            }
        }
        const res = {
            authKey: authKey,
            encKey: $2d0e1e19edfeea80$var$expandKeyLE(encKey)
        };
        // Cleanup
        (0, $248bf24903c02b9f$exports.clean)(...toClean);
        return res;
    }
    function _computeTag(encKey, authKey, data) {
        const tag = $2d0e1e19edfeea80$var$computeTag($634456ee3058786c$exports.polyval, true, authKey, data, AAD);
        // Compute the expected tag by XORing S_s and the nonce, clearing the
        // most significant bit of the last byte and encrypting with the
        // message-encryption key.
        for(let i = 0; i < 12; i++)tag[i] ^= nonce[i];
        tag[15] &= 0x7f; // Clear the highest bit
        // encrypt tag as block
        const t32 = (0, $248bf24903c02b9f$exports.u32)(tag);
        // prettier-ignore
        let s0 = t32[0], s1 = t32[1], s2 = t32[2], s3 = t32[3];
        ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(encKey, s0, s1, s2, s3));
        t32[0] = s0, t32[1] = s1, t32[2] = s2, t32[3] = s3;
        return tag;
    }
    // actual decrypt/encrypt of message.
    function processSiv(encKey, tag, input) {
        let block = (0, $248bf24903c02b9f$exports.copyBytes)(tag);
        block[15] |= 0x80; // Force highest bit
        const res = $2d0e1e19edfeea80$var$ctr32(encKey, true, block, input);
        // Cleanup
        (0, $248bf24903c02b9f$exports.clean)(block);
        return res;
    }
    return {
        encrypt (plaintext) {
            PLAIN_LIMIT(plaintext.length);
            const { encKey: encKey, authKey: authKey } = deriveKeys();
            const tag = _computeTag(encKey, authKey, plaintext);
            const toClean = [
                encKey,
                authKey,
                tag
            ];
            if (!(0, $248bf24903c02b9f$exports.isAligned32)(plaintext)) toClean.push(plaintext = (0, $248bf24903c02b9f$exports.copyBytes)(plaintext));
            const out = new Uint8Array(plaintext.length + tagLength);
            out.set(tag, plaintext.length);
            out.set(processSiv(encKey, tag, plaintext));
            // Cleanup
            (0, $248bf24903c02b9f$exports.clean)(...toClean);
            return out;
        },
        decrypt (ciphertext) {
            CIPHER_LIMIT(ciphertext.length);
            const tag = ciphertext.subarray(-tagLength);
            const { encKey: encKey, authKey: authKey } = deriveKeys();
            const toClean = [
                encKey,
                authKey
            ];
            if (!(0, $248bf24903c02b9f$exports.isAligned32)(ciphertext)) toClean.push(ciphertext = (0, $248bf24903c02b9f$exports.copyBytes)(ciphertext));
            const plaintext = processSiv(encKey, tag, ciphertext.subarray(0, -tagLength));
            const expectedTag = _computeTag(encKey, authKey, plaintext);
            toClean.push(expectedTag);
            if (!(0, $248bf24903c02b9f$exports.equalBytes)(tag, expectedTag)) {
                (0, $248bf24903c02b9f$exports.clean)(...toClean);
                throw new Error("invalid polyval tag");
            }
            // Cleanup
            (0, $248bf24903c02b9f$exports.clean)(...toClean);
            return plaintext;
        }
    };
});
function $2d0e1e19edfeea80$var$isBytes32(a) {
    return a instanceof Uint32Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint32Array";
}
function $2d0e1e19edfeea80$var$encryptBlock(xk, block) {
    (0, $5e86e7af933ab8a1$exports.abytes)(block, 16);
    if (!$2d0e1e19edfeea80$var$isBytes32(xk)) throw new Error("_encryptBlock accepts result of expandKeyLE");
    const b32 = (0, $248bf24903c02b9f$exports.u32)(block);
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, b32[0], b32[1], b32[2], b32[3]);
    b32[0] = s0, b32[1] = s1, b32[2] = s2, b32[3] = s3;
    return block;
}
function $2d0e1e19edfeea80$var$decryptBlock(xk, block) {
    (0, $5e86e7af933ab8a1$exports.abytes)(block, 16);
    if (!$2d0e1e19edfeea80$var$isBytes32(xk)) throw new Error("_decryptBlock accepts result of expandKeyLE");
    const b32 = (0, $248bf24903c02b9f$exports.u32)(block);
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$decrypt(xk, b32[0], b32[1], b32[2], b32[3]);
    b32[0] = s0, b32[1] = s1, b32[2] = s2, b32[3] = s3;
    return block;
}
/**
 * AES-W (base for AESKW/AESKWP).
 * Specs: [SP800-38F](https://nvlpubs.nist.gov/nistpubs/SpecialPublications/NIST.SP.800-38F.pdf),
 * [RFC 3394](https://datatracker.ietf.org/doc/rfc3394/),
 * [RFC 5649](https://datatracker.ietf.org/doc/rfc5649/).
 */ const $2d0e1e19edfeea80$var$AESW = {
    /*
    High-level pseudocode:
    ```
    A: u64 = IV
    out = []
    for (let i=0, ctr = 0; i<6; i++) {
      for (const chunk of chunks(plaintext, 8)) {
        A ^= swapEndianess(ctr++)
        [A, res] = chunks(encrypt(A || chunk), 8);
        out ||= res
      }
    }
    out = A || out
    ```
    Decrypt is the same, but reversed.
    */ encrypt (kek, out) {
        // Size is limited to 4GB, otherwise ctr will overflow and we'll need to switch to bigints.
        // If you need it larger, open an issue.
        if (out.length >= 2 ** 32) throw new Error("plaintext should be less than 4gb");
        const xk = $2d0e1e19edfeea80$var$expandKeyLE(kek);
        if (out.length === 16) $2d0e1e19edfeea80$var$encryptBlock(xk, out);
        else {
            const o32 = (0, $248bf24903c02b9f$exports.u32)(out);
            // prettier-ignore
            let a0 = o32[0], a1 = o32[1]; // A
            for(let j = 0, ctr = 1; j < 6; j++)for(let pos = 2; pos < o32.length; pos += 2, ctr++){
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, a0, a1, o32[pos], o32[pos + 1]);
                // A = MSB(64, B) ^ t where t = (n*j)+i
                a0 = s0, a1 = s1 ^ $2d0e1e19edfeea80$var$byteSwap(ctr), o32[pos] = s2, o32[pos + 1] = s3;
            }
            o32[0] = a0, o32[1] = a1; // out = A || out
        }
        xk.fill(0);
    },
    decrypt (kek, out) {
        if (out.length - 8 >= 2 ** 32) throw new Error("ciphertext should be less than 4gb");
        const xk = $2d0e1e19edfeea80$var$expandKeyDecLE(kek);
        const chunks = out.length / 8 - 1; // first chunk is IV
        if (chunks === 1) $2d0e1e19edfeea80$var$decryptBlock(xk, out);
        else {
            const o32 = (0, $248bf24903c02b9f$exports.u32)(out);
            // prettier-ignore
            let a0 = o32[0], a1 = o32[1]; // A
            for(let j = 0, ctr = chunks * 6; j < 6; j++)for(let pos = chunks * 2; pos >= 1; pos -= 2, ctr--){
                a1 ^= $2d0e1e19edfeea80$var$byteSwap(ctr);
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$decrypt(xk, a0, a1, o32[pos], o32[pos + 1]);
                a0 = s0, a1 = s1, o32[pos] = s2, o32[pos + 1] = s3;
            }
            o32[0] = a0, o32[1] = a1;
        }
        xk.fill(0);
    }
};
const $2d0e1e19edfeea80$var$AESKW_IV = /* @__PURE__ */ new Uint8Array(8).fill(0xa6); // A6A6A6A6A6A6A6A6
/**
 * AES-KW (key-wrap). Injects static IV into plaintext, adds counter, encrypts 6 times.
 * Reduces block size from 16 to 8 bytes.
 * For padded version, use aeskwp.
 * [RFC 3394](https://datatracker.ietf.org/doc/rfc3394/),
 * [NIST.SP.800-38F](https://nvlpubs.nist.gov/nistpubs/SpecialPublications/NIST.SP.800-38F.pdf).
 */ $2d0e1e19edfeea80$exports.aeskw = (0, $248bf24903c02b9f$exports.wrapCipher)({
    blockSize: 8
}, (kek)=>({
        encrypt (plaintext) {
            if (!plaintext.length || plaintext.length % 8 !== 0) throw new Error("invalid plaintext length");
            if (plaintext.length === 8) throw new Error("8-byte keys not allowed in AESKW, use AESKWP instead");
            const out = (0, $248bf24903c02b9f$exports.concatBytes)($2d0e1e19edfeea80$var$AESKW_IV, plaintext);
            $2d0e1e19edfeea80$var$AESW.encrypt(kek, out);
            return out;
        },
        decrypt (ciphertext) {
            // ciphertext must be at least 24 bytes and a multiple of 8 bytes
            // 24 because should have at least two block (1 iv + 2).
            // Replace with 16 to enable '8-byte keys'
            if (ciphertext.length % 8 !== 0 || ciphertext.length < 24) throw new Error("invalid ciphertext length");
            const out = (0, $248bf24903c02b9f$exports.copyBytes)(ciphertext);
            $2d0e1e19edfeea80$var$AESW.decrypt(kek, out);
            if (!(0, $248bf24903c02b9f$exports.equalBytes)(out.subarray(0, 8), $2d0e1e19edfeea80$var$AESKW_IV)) throw new Error("integrity check failed");
            out.subarray(0, 8).fill(0); // ciphertext.subarray(0, 8) === IV, but we clean it anyway
            return out.subarray(8);
        }
    }));
/*
We don't support 8-byte keys. The rabbit hole:

- Wycheproof says: "NIST SP 800-38F does not define the wrapping of 8 byte keys.
  RFC 3394 Section 2  on the other hand specifies that 8 byte keys are wrapped
  by directly encrypting one block with AES."
    - https://github.com/C2SP/wycheproof/blob/master/doc/key_wrap.md
    - "RFC 3394 specifies in Section 2, that the input for the key wrap
      algorithm must be at least two blocks and otherwise the constant
      field and key are simply encrypted with ECB as a single block"
- What RFC 3394 actually says (in Section 2):
    - "Before being wrapped, the key data is parsed into n blocks of 64 bits.
      The only restriction the key wrap algorithm places on n is that n be
      at least two"
    - "For key data with length less than or equal to 64 bits, the constant
      field used in this specification and the key data form a single
      128-bit codebook input making this key wrap unnecessary."
- Which means "assert(n >= 2)" and "use something else for 8 byte keys"
- NIST SP800-38F actually prohibits 8-byte in "5.3.1 Mandatory Limits".
  It states that plaintext for KW should be "2 to 2^54 -1 semiblocks".
- So, where does "directly encrypt single block with AES" come from?
    - Not RFC 3394. Pseudocode of key wrap in 2.2 explicitly uses
      loop of 6 for any code path
    - There is a weird W3C spec:
      https://www.w3.org/TR/2002/REC-xmlenc-core-20021210/Overview.html#kw-aes128
    - This spec is outdated, as admitted by Wycheproof authors
    - There is RFC 5649 for padded key wrap, which is padding construction on
      top of AESKW. In '4.1.2' it says: "If the padded plaintext contains exactly
      eight octets, then prepend the AIV as defined in Section 3 above to P[1] and
      encrypt the resulting 128-bit block using AES in ECB mode [Modes] with key
      K (the KEK).  In this case, the output is two 64-bit blocks C[0] and C[1]:"
    - Browser subtle crypto is actually crashes on wrapping keys less than 16 bytes:
      `Error: error:1C8000E6:Provider routines::invalid input length] { opensslErrorStack: [ 'error:030000BD:digital envelope routines::update error' ]`

In the end, seems like a bug in Wycheproof.
The 8-byte check can be easily disabled inside of AES_W.
*/ const $2d0e1e19edfeea80$var$AESKWP_IV = 0xa65959a6; // single u32le value
/**
 * AES-KW, but with padding and allows random keys.
 * Second u32 of IV is used as counter for length.
 * [RFC 5649](https://www.rfc-editor.org/rfc/rfc5649)
 */ $2d0e1e19edfeea80$exports.aeskwp = (0, $248bf24903c02b9f$exports.wrapCipher)({
    blockSize: 8
}, (kek)=>({
        encrypt (plaintext) {
            if (!plaintext.length) throw new Error("invalid plaintext length");
            const padded = Math.ceil(plaintext.length / 8) * 8;
            const out = new Uint8Array(8 + padded);
            out.set(plaintext, 8);
            const out32 = (0, $248bf24903c02b9f$exports.u32)(out);
            out32[0] = $2d0e1e19edfeea80$var$AESKWP_IV;
            out32[1] = $2d0e1e19edfeea80$var$byteSwap(plaintext.length);
            $2d0e1e19edfeea80$var$AESW.encrypt(kek, out);
            return out;
        },
        decrypt (ciphertext) {
            // 16 because should have at least one block
            if (ciphertext.length < 16) throw new Error("invalid ciphertext length");
            const out = (0, $248bf24903c02b9f$exports.copyBytes)(ciphertext);
            const o32 = (0, $248bf24903c02b9f$exports.u32)(out);
            $2d0e1e19edfeea80$var$AESW.decrypt(kek, out);
            const len = $2d0e1e19edfeea80$var$byteSwap(o32[1]) >>> 0;
            const padded = Math.ceil(len / 8) * 8;
            if (o32[0] !== $2d0e1e19edfeea80$var$AESKWP_IV || out.length - 8 !== padded) throw new Error("integrity check failed");
            for(let i = len; i < padded; i++)if (out[8 + i] !== 0) throw new Error("integrity check failed");
            out.subarray(0, 8).fill(0); // ciphertext.subarray(0, 8) === IV, but we clean it anyway
            return out.subarray(8, 8 + len);
        }
    }));
/** Unsafe low-level internal methods. May change at any time. */ $2d0e1e19edfeea80$exports.unsafe = {
    expandKeyLE: $2d0e1e19edfeea80$var$expandKeyLE,
    expandKeyDecLE: $2d0e1e19edfeea80$var$expandKeyDecLE,
    encrypt: $2d0e1e19edfeea80$var$encrypt,
    decrypt: $2d0e1e19edfeea80$var$decrypt,
    encryptBlock: $2d0e1e19edfeea80$var$encryptBlock,
    decryptBlock: $2d0e1e19edfeea80$var$decryptBlock,
    ctrCounter: $2d0e1e19edfeea80$var$ctrCounter,
    ctr32: $2d0e1e19edfeea80$var$ctr32
};


var $dd94f1d283dd7b2d$exports = {};
"use strict";
Object.defineProperty($dd94f1d283dd7b2d$exports, "__esModule", {
    value: true
});
$dd94f1d283dd7b2d$exports.scrypt = $dd94f1d283dd7b2d$var$scrypt;
$dd94f1d283dd7b2d$exports.scryptAsync = $dd94f1d283dd7b2d$var$scryptAsync;




// The main Scrypt loop: uses Salsa extensively.
// Six versions of the function were tried, this is the fastest one.
// prettier-ignore
function $dd94f1d283dd7b2d$var$XorAndSalsa(prev, pi, input, ii, out, oi) {
    // Based on https://cr.yp.to/salsa20.html
    // Xor blocks
    let y00 = prev[pi++] ^ input[ii++], y01 = prev[pi++] ^ input[ii++];
    let y02 = prev[pi++] ^ input[ii++], y03 = prev[pi++] ^ input[ii++];
    let y04 = prev[pi++] ^ input[ii++], y05 = prev[pi++] ^ input[ii++];
    let y06 = prev[pi++] ^ input[ii++], y07 = prev[pi++] ^ input[ii++];
    let y08 = prev[pi++] ^ input[ii++], y09 = prev[pi++] ^ input[ii++];
    let y10 = prev[pi++] ^ input[ii++], y11 = prev[pi++] ^ input[ii++];
    let y12 = prev[pi++] ^ input[ii++], y13 = prev[pi++] ^ input[ii++];
    let y14 = prev[pi++] ^ input[ii++], y15 = prev[pi++] ^ input[ii++];
    // Save state to temporary variables (salsa)
    let x00 = y00, x01 = y01, x02 = y02, x03 = y03, x04 = y04, x05 = y05, x06 = y06, x07 = y07, x08 = y08, x09 = y09, x10 = y10, x11 = y11, x12 = y12, x13 = y13, x14 = y14, x15 = y15;
    // Main loop (salsa)
    for(let i = 0; i < 8; i += 2){
        x04 ^= (0, $29ee4d3171d9809b$exports.rotl)(x00 + x12 | 0, 7);
        x08 ^= (0, $29ee4d3171d9809b$exports.rotl)(x04 + x00 | 0, 9);
        x12 ^= (0, $29ee4d3171d9809b$exports.rotl)(x08 + x04 | 0, 13);
        x00 ^= (0, $29ee4d3171d9809b$exports.rotl)(x12 + x08 | 0, 18);
        x09 ^= (0, $29ee4d3171d9809b$exports.rotl)(x05 + x01 | 0, 7);
        x13 ^= (0, $29ee4d3171d9809b$exports.rotl)(x09 + x05 | 0, 9);
        x01 ^= (0, $29ee4d3171d9809b$exports.rotl)(x13 + x09 | 0, 13);
        x05 ^= (0, $29ee4d3171d9809b$exports.rotl)(x01 + x13 | 0, 18);
        x14 ^= (0, $29ee4d3171d9809b$exports.rotl)(x10 + x06 | 0, 7);
        x02 ^= (0, $29ee4d3171d9809b$exports.rotl)(x14 + x10 | 0, 9);
        x06 ^= (0, $29ee4d3171d9809b$exports.rotl)(x02 + x14 | 0, 13);
        x10 ^= (0, $29ee4d3171d9809b$exports.rotl)(x06 + x02 | 0, 18);
        x03 ^= (0, $29ee4d3171d9809b$exports.rotl)(x15 + x11 | 0, 7);
        x07 ^= (0, $29ee4d3171d9809b$exports.rotl)(x03 + x15 | 0, 9);
        x11 ^= (0, $29ee4d3171d9809b$exports.rotl)(x07 + x03 | 0, 13);
        x15 ^= (0, $29ee4d3171d9809b$exports.rotl)(x11 + x07 | 0, 18);
        x01 ^= (0, $29ee4d3171d9809b$exports.rotl)(x00 + x03 | 0, 7);
        x02 ^= (0, $29ee4d3171d9809b$exports.rotl)(x01 + x00 | 0, 9);
        x03 ^= (0, $29ee4d3171d9809b$exports.rotl)(x02 + x01 | 0, 13);
        x00 ^= (0, $29ee4d3171d9809b$exports.rotl)(x03 + x02 | 0, 18);
        x06 ^= (0, $29ee4d3171d9809b$exports.rotl)(x05 + x04 | 0, 7);
        x07 ^= (0, $29ee4d3171d9809b$exports.rotl)(x06 + x05 | 0, 9);
        x04 ^= (0, $29ee4d3171d9809b$exports.rotl)(x07 + x06 | 0, 13);
        x05 ^= (0, $29ee4d3171d9809b$exports.rotl)(x04 + x07 | 0, 18);
        x11 ^= (0, $29ee4d3171d9809b$exports.rotl)(x10 + x09 | 0, 7);
        x08 ^= (0, $29ee4d3171d9809b$exports.rotl)(x11 + x10 | 0, 9);
        x09 ^= (0, $29ee4d3171d9809b$exports.rotl)(x08 + x11 | 0, 13);
        x10 ^= (0, $29ee4d3171d9809b$exports.rotl)(x09 + x08 | 0, 18);
        x12 ^= (0, $29ee4d3171d9809b$exports.rotl)(x15 + x14 | 0, 7);
        x13 ^= (0, $29ee4d3171d9809b$exports.rotl)(x12 + x15 | 0, 9);
        x14 ^= (0, $29ee4d3171d9809b$exports.rotl)(x13 + x12 | 0, 13);
        x15 ^= (0, $29ee4d3171d9809b$exports.rotl)(x14 + x13 | 0, 18);
    }
    // Write output (salsa)
    out[oi++] = y00 + x00 | 0;
    out[oi++] = y01 + x01 | 0;
    out[oi++] = y02 + x02 | 0;
    out[oi++] = y03 + x03 | 0;
    out[oi++] = y04 + x04 | 0;
    out[oi++] = y05 + x05 | 0;
    out[oi++] = y06 + x06 | 0;
    out[oi++] = y07 + x07 | 0;
    out[oi++] = y08 + x08 | 0;
    out[oi++] = y09 + x09 | 0;
    out[oi++] = y10 + x10 | 0;
    out[oi++] = y11 + x11 | 0;
    out[oi++] = y12 + x12 | 0;
    out[oi++] = y13 + x13 | 0;
    out[oi++] = y14 + x14 | 0;
    out[oi++] = y15 + x15 | 0;
}
function $dd94f1d283dd7b2d$var$BlockMix(input, ii, out, oi, r) {
    // The block B is r 128-byte chunks (which is equivalent of 2r 64-byte chunks)
    let head = oi + 0;
    let tail = oi + 16 * r;
    for(let i = 0; i < 16; i++)out[tail + i] = input[ii + (2 * r - 1) * 16 + i]; // X ← B[2r−1]
    for(let i = 0; i < r; i++, head += 16, ii += 16){
        // We write odd & even Yi at same time. Even: 0bXXXXX0 Odd:  0bXXXXX1
        $dd94f1d283dd7b2d$var$XorAndSalsa(out, tail, input, ii, out, head); // head[i] = Salsa(blockIn[2*i] ^ tail[i-1])
        if (i > 0) tail += 16; // First iteration overwrites tmp value in tail
        $dd94f1d283dd7b2d$var$XorAndSalsa(out, head, input, ii += 16, out, tail); // tail[i] = Salsa(blockIn[2*i+1] ^ head[i])
    }
}
// Common prologue and epilogue for sync/async functions
function $dd94f1d283dd7b2d$var$scryptInit(password, salt, _opts) {
    // Maxmem - 1GB+1KB by default
    const opts = (0, $29ee4d3171d9809b$exports.checkOpts)({
        dkLen: 32,
        asyncTick: 10,
        maxmem: 1024 ** 3 + 1024
    }, _opts);
    const { N: N, r: r, p: p, dkLen: dkLen, asyncTick: asyncTick, maxmem: maxmem, onProgress: onProgress } = opts;
    (0, $a0ae23f5901291b4$exports.anumber)(N);
    (0, $a0ae23f5901291b4$exports.anumber)(r);
    (0, $a0ae23f5901291b4$exports.anumber)(p);
    (0, $a0ae23f5901291b4$exports.anumber)(dkLen);
    (0, $a0ae23f5901291b4$exports.anumber)(asyncTick);
    (0, $a0ae23f5901291b4$exports.anumber)(maxmem);
    if (onProgress !== undefined && typeof onProgress !== "function") throw new Error("progressCb should be function");
    const blockSize = 128 * r;
    const blockSize32 = blockSize / 4;
    // Max N is 2^32 (Integrify is 32-bit). Real limit is 2^22: JS engines Uint8Array limit is 4GB in 2024.
    // Spec check `N >= 2 ** (blockSize / 8)` is not done for compat with popular libs,
    // which used incorrect r: 1, p: 8. Also, the check seems to be a spec error:
    // https://www.rfc-editor.org/errata_search.php?rfc=7914
    if (N <= 1 || (N & N - 1) !== 0 || N > 2 ** 32) throw new Error("Scrypt: N must be larger than 1, a power of 2, and less than 2^32");
    if (p < 0 || p > (2 ** 32 - 1) * 32 / blockSize) throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
    if (dkLen < 0 || dkLen > (2 ** 32 - 1) * 32) throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
    const memUsed = blockSize * (N + p);
    if (memUsed > maxmem) throw new Error("Scrypt: memused is bigger than maxMem. Expected 128 * r * (N + p) > maxmem of " + maxmem);
    // [B0...Bp−1] ← PBKDF2HMAC-SHA256(Passphrase, Salt, 1, blockSize*ParallelizationFactor)
    // Since it has only one iteration there is no reason to use async variant
    const B = (0, $8c2f54a153cf1baf$exports.pbkdf2)($510ad3657d73a9d2$exports.sha256, password, salt, {
        c: 1,
        dkLen: blockSize * p
    });
    const B32 = (0, $29ee4d3171d9809b$exports.u32)(B);
    // Re-used between parallel iterations. Array(iterations) of B
    const V = (0, $29ee4d3171d9809b$exports.u32)(new Uint8Array(blockSize * N));
    const tmp = (0, $29ee4d3171d9809b$exports.u32)(new Uint8Array(blockSize));
    let blockMixCb = ()=>{};
    if (onProgress) {
        const totalBlockMix = 2 * N * p;
        // Invoke callback if progress changes from 10.01 to 10.02
        // Allows to draw smooth progress bar on up to 8K screen
        const callbackPer = Math.max(Math.floor(totalBlockMix / 10000), 1);
        let blockMixCnt = 0;
        blockMixCb = ()=>{
            blockMixCnt++;
            if (onProgress && (!(blockMixCnt % callbackPer) || blockMixCnt === totalBlockMix)) onProgress(blockMixCnt / totalBlockMix);
        };
    }
    return {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        blockSize32: blockSize32,
        V: V,
        B32: B32,
        B: B,
        tmp: tmp,
        blockMixCb: blockMixCb,
        asyncTick: asyncTick
    };
}
function $dd94f1d283dd7b2d$var$scryptOutput(password, dkLen, B, V, tmp) {
    const res = (0, $8c2f54a153cf1baf$exports.pbkdf2)($510ad3657d73a9d2$exports.sha256, password, B, {
        c: 1,
        dkLen: dkLen
    });
    B.fill(0);
    V.fill(0);
    tmp.fill(0);
    return res;
}
/**
 * Scrypt KDF from RFC 7914.
 * @param password - pass
 * @param salt - salt
 * @param opts - parameters
 * - `N` is cpu/mem work factor (power of 2 e.g. 2**18)
 * - `r` is block size (8 is common), fine-tunes sequential memory read size and performance
 * - `p` is parallelization factor (1 is common)
 * - `dkLen` is output key length in bytes e.g. 32.
 * - `asyncTick` - (default: 10) max time in ms for which async function can block execution
 * - `maxmem` - (default: `1024 ** 3 + 1024` aka 1GB+1KB). A limit that the app could use for scrypt
 * - `onProgress` - callback function that would be executed for progress report
 * @returns Derived key
 * @example
 * scrypt('password', 'salt', { N: 2**18, r: 8, p: 1, dkLen: 32 });
 */ function $dd94f1d283dd7b2d$var$scrypt(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb } = $dd94f1d283dd7b2d$var$scryptInit(password, salt, opts);
    if (!$29ee4d3171d9809b$exports.isLE) (0, $29ee4d3171d9809b$exports.byteSwap32)(B32);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        for(let i = 0, pos = 0; i < N - 1; i++){
            $dd94f1d283dd7b2d$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        }
        $dd94f1d283dd7b2d$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        for(let i = 0; i < N; i++){
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $dd94f1d283dd7b2d$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        }
    }
    if (!$29ee4d3171d9809b$exports.isLE) (0, $29ee4d3171d9809b$exports.byteSwap32)(B32);
    return $dd94f1d283dd7b2d$var$scryptOutput(password, dkLen, B, V, tmp);
}
/**
 * Scrypt KDF from RFC 7914. Async version.
 * @example
 * await scryptAsync('password', 'salt', { N: 2**18, r: 8, p: 1, dkLen: 32 });
 */ async function $dd94f1d283dd7b2d$var$scryptAsync(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb, asyncTick: asyncTick } = $dd94f1d283dd7b2d$var$scryptInit(password, salt, opts);
    if (!$29ee4d3171d9809b$exports.isLE) (0, $29ee4d3171d9809b$exports.byteSwap32)(B32);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        let pos = 0;
        await (0, $29ee4d3171d9809b$exports.asyncLoop)(N - 1, asyncTick, ()=>{
            $dd94f1d283dd7b2d$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        });
        $dd94f1d283dd7b2d$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        await (0, $29ee4d3171d9809b$exports.asyncLoop)(N, asyncTick, ()=>{
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $dd94f1d283dd7b2d$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        });
    }
    if (!$29ee4d3171d9809b$exports.isLE) (0, $29ee4d3171d9809b$exports.byteSwap32)(B32);
    return $dd94f1d283dd7b2d$var$scryptOutput(password, dkLen, B, V, tmp);
}


var $564ad8f2c6689928$var$__defProp = Object.defineProperty;
var $564ad8f2c6689928$var$__export = (target, all)=>{
    for(var name in all)$564ad8f2c6689928$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/core.ts
var $564ad8f2c6689928$export$b75f8c4f8f3fbd14 = {};
$564ad8f2c6689928$var$__export($564ad8f2c6689928$export$b75f8c4f8f3fbd14, {
    ABIContract: ()=>$564ad8f2c6689928$export$c64f24a8950c1687,
    ABIEvent: ()=>$564ad8f2c6689928$export$53dc4a052c6fe7a9,
    ABIFunction: ()=>$564ad8f2c6689928$export$91fefeed79eabb73,
    ABIItem: ()=>$564ad8f2c6689928$export$243e6f55a096985,
    Account: ()=>$564ad8f2c6689928$export$1ed4b10e4aba04a7,
    Address: ()=>$564ad8f2c6689928$export$73974d1f547d9d48,
    Blake2b256: ()=>$564ad8f2c6689928$export$d2458fb5f52b75a6,
    BloomFilter: ()=>$564ad8f2c6689928$export$fbc160adde9cf656,
    BufferKind: ()=>$564ad8f2c6689928$export$1183026c469db464,
    Certificate: ()=>$564ad8f2c6689928$export$ca20b3ed1788c40a,
    Clause: ()=>$564ad8f2c6689928$export$af2fe57fe6540b02,
    Coin: ()=>$564ad8f2c6689928$export$19600bc7e7f23c95,
    CompactFixedHexBlobKind: ()=>$564ad8f2c6689928$export$d307fa5bdcfc61d4,
    ERC1155_ABI: ()=>$564ad8f2c6689928$export$b49cca313196bde1,
    ERC20_ABI: ()=>$564ad8f2c6689928$export$89843982d7e60b14,
    ERC721_ABI: ()=>$564ad8f2c6689928$export$364c28d882341a8a,
    FixedHexBlobKind: ()=>$564ad8f2c6689928$export$bc2dc8c724ed4216,
    FixedPointNumber: ()=>$564ad8f2c6689928$export$3dede3b6cc153eb5,
    HDKey: ()=>$564ad8f2c6689928$export$bb670963070b393a,
    Hex: ()=>$564ad8f2c6689928$export$9ccf03a0aa23a1ca,
    HexBlobKind: ()=>$564ad8f2c6689928$export$f32667dbae7bc3ad,
    HexInt: ()=>$564ad8f2c6689928$export$8cd63f50dbdefc2e,
    HexUInt: ()=>$564ad8f2c6689928$export$7c2a2de09ea3c4f2,
    Keccak256: ()=>$564ad8f2c6689928$export$83afadb7dd1667bc,
    MAINNET_NETWORK: ()=>$564ad8f2c6689928$export$e2c0255dbe2e5514,
    Mnemonic: ()=>$564ad8f2c6689928$export$93018d515d60db37,
    NUMERIC_REGEX: ()=>$564ad8f2c6689928$export$a86766d7e0fe156e,
    NumericKind: ()=>$564ad8f2c6689928$export$16dfabb5959ce479,
    OptionalFixedHexBlobKind: ()=>$564ad8f2c6689928$export$4a5ff240fb77900,
    Quantity: ()=>$564ad8f2c6689928$export$d90fb187180e94e,
    RLP: ()=>$564ad8f2c6689928$export$4859e6f62c4b9b84,
    RLPProfiler: ()=>$564ad8f2c6689928$export$5011fcbb6c0dc14a,
    Revision: ()=>$564ad8f2c6689928$export$65528947809bf36b,
    SOLO_NETWORK: ()=>$564ad8f2c6689928$export$d84d61bc169eec4a,
    ScalarKind: ()=>$564ad8f2c6689928$export$26597e1450faf9d1,
    Secp256k1: ()=>$564ad8f2c6689928$export$4807b1fbad07ca78,
    Sha256: ()=>$564ad8f2c6689928$export$3b58ea8124ac5e28,
    TESTNET_NETWORK: ()=>$564ad8f2c6689928$export$42a42ef9fe6426c3,
    ThorId: ()=>$564ad8f2c6689928$export$876173816e2392b2,
    Transaction: ()=>$564ad8f2c6689928$export$febc5573c75cefb0,
    Txt: ()=>$564ad8f2c6689928$export$1d5cbbbdccc512f9,
    Units: ()=>$564ad8f2c6689928$export$dd3b792fda2f69f8,
    VET: ()=>$564ad8f2c6689928$export$ae9c3c05238a9d5d,
    VIP180_ABI: ()=>$564ad8f2c6689928$export$b88e3c60e3a2c614,
    VIP181_ABI: ()=>$564ad8f2c6689928$export$2f934eae26d73cbf,
    VIP210_ABI: ()=>$564ad8f2c6689928$export$d6edb80a15697662,
    VTHO: ()=>$564ad8f2c6689928$export$27cc1e5993feb517,
    VTHO_ADDRESS: ()=>$564ad8f2c6689928$export$1a34dfc454d6ad5b,
    ZERO_ADDRESS: ()=>$564ad8f2c6689928$export$b47284de06fcec83,
    ZERO_BYTES: ()=>$564ad8f2c6689928$export$1e076aab5837ca50,
    abi: ()=>$564ad8f2c6689928$export$3de1df63de3dd8b4,
    addressUtils: ()=>$564ad8f2c6689928$export$678e08479eeb6ed8,
    assertCompactFixedHexBlobBuffer: ()=>$564ad8f2c6689928$export$e5b7472edee9798e,
    assertFixedHexBlobKindBuffer: ()=>$564ad8f2c6689928$export$ab717f4e4f82779e,
    assertFixedHexBlobKindData: ()=>$564ad8f2c6689928$export$36194bd8ca205f39,
    assertValidHexBlobKindData: ()=>$564ad8f2c6689928$export$958fe0abc7a4c8a5,
    assertValidNumericKindBuffer: ()=>$564ad8f2c6689928$export$1a9c4ad470188a27,
    blake2b256: ()=>$564ad8f2c6689928$export$a00142b13614340a,
    dataUtils: ()=>$564ad8f2c6689928$export$b48793c3df80d83a,
    decodeBufferToHexWithLeadingZeros: ()=>$564ad8f2c6689928$export$7fbcd0959b9d4c86,
    decodeBufferToNumberOrHex: ()=>$564ad8f2c6689928$export$169c089fe0e56a68,
    encodeBigIntToBuffer: ()=>$564ad8f2c6689928$export$92ea27a9faa2387d,
    encodeCompactFixedHexBlob: ()=>$564ad8f2c6689928$export$6ab8c5ca73295e04,
    keccak256: ()=>$564ad8f2c6689928$export$f8151fce47ad1c35,
    keystore: ()=>$564ad8f2c6689928$export$fc6a5346165a11f2,
    mnemonic: ()=>$564ad8f2c6689928$export$87e0516a9045c2f1,
    networkInfo: ()=>$564ad8f2c6689928$export$c26faa1d7c00b5bf,
    revisionUtils: ()=>$564ad8f2c6689928$export$59a0ed0fd7475d0,
    sha256: ()=>$564ad8f2c6689928$export$bced8d2aada2d1c9,
    validateNumericKindData: ()=>$564ad8f2c6689928$export$8ba36ab12859905e,
    vechain_sdk_core_ethers: ()=>(0, $75de98094ef1e4ed$re_export$ethers)
});
var $564ad8f2c6689928$export$9ccf03a0aa23a1ca = class _Hex {
    /**
   * Negative multiplier of the {@link digits} absolute value.
   *
   * @type {number}
   */ static NEGATIVE = -1;
    /**
   * Positive multiplier of the {@link digits} absolute value.
   *
   * @type {number}
   */ static POSITIVE = 1;
    /**
   * A constant string prefix used in hexadecimal notation.
   */ static PREFIX = "0x";
    /**
   * The radix used for representing numbers base 16 in a positional numeral notation system.
   *
   * @typedef {number} RADIX
   */ static RADIX = 16;
    /**
   * Regular expression for matching hexadecimal strings.
   * An empty input is represented as a empty digits.
   *
   * @type {RegExp}
   */ static REGEX_HEX = /^-?(0x)?[0-9a-f]*$/i;
    /**
   * Regular expression pattern to match a prefix indicating hexadecimal number.
   *
   * @type {RegExp}
   */ static REGEX_HEX_PREFIX = /^-?0x/i;
    /**
       * Returns the hexadecimal digits expressing this absolute value, sign and `0x` prefix omitted.
  
       * @remarks An empty content results in an empty string returned.
       */ digits;
    /**
   * Represents the sign multiplier of a given number:
   * * {@link NEGATIVE} `-1` if negative,
   * * {@link POSITIVE} `1` if positive.
   */ sign;
    /**
   * Creates a new instance of this class to represent the value
   * built multiplying `sign` for the absolute value expressed by the hexadecimal `digits`.
   *
   * @param {number} sign - The sign of the value.
   * @param {string} digits - The digits of the absolute value in hexadecimal base.
   * @param {function} [normalize] - The function used to normalize the digits. Defaults to converting digits to lowercase.
   */ constructor(sign, digits, normalize = (digits2)=>digits2.toLowerCase()){
        this.digits = normalize(digits);
        this.sign = sign;
    }
    /**
   * Returns the absolute value of this Hex object.
   *
   * @return {Hex} A new Hex object representing the absolute value of this Hex.
   */ get abs() {
        return new _Hex(_Hex.POSITIVE, this.digits);
    }
    /**
   * Returns the value of `bi` as a `BigInt` type.
   *
   * @returns {bigint} The value of `bi` as a `BigInt`.
   */ get bi() {
        return BigInt(this.sign) * $esaJO.hexToNumber(this.digits);
    }
    /**
   * Returns the Uint8Array representation of the aligned bytes.
   *
   * @return {Uint8Array} The Uint8Array representation of the aligned bytes.
   */ get bytes() {
        return $esaJO.hexToBytes(this.alignToBytes().digits);
    }
    /**
   * Returns the value of n.
   *
   * @return {number} The value of n.
   *
   * @throws {InvalidOperation<Hex>} Throws an error if this instance doesn't represent
   * an [IEEE 754 double precision 64 bits floating point format](https://en.wikipedia.org/wiki/Double-precision_floating-point_format).
   */ get n() {
        if (this.isNumber()) return new DataView(this.bytes.buffer).getFloat64(0);
        throw new (0, $dbc5c4a080b2aff5$export$8df2d8bae05b1dae)("Hex.n", "not an IEEE 754 float 64 number", {
            hex: this.toString()
        });
    }
    /**
   * Aligns the hexadecimal string to bytes by adding a leading '0' if the string length is odd.
   *
   * @returns {Hex} - The aligned hexadecimal string.
   */ alignToBytes() {
        return this.digits.length % 2 === 0 ? this : new _Hex(this.sign, "0" + this.digits);
    }
    /**
   * Compares the current Hex object with another Hex object.
   *
   * @param {Hex} that - The Hex object to compare with.
   *
   * @return {number} - Returns a negative number if the current Hex object is less than the given Hex object,
   *                    zero if they are equal, or a positive number if the current Hex object is greater than the given Hex object.
   */ compareTo(that) {
        if (this.sign === that.sign) {
            const digits = Math.max(this.digits.length, that.digits.length);
            const thisBytes = this.fit(digits).bytes;
            const thatBytes = that.fit(digits).bytes;
            let i = 0;
            let compareByte = 0;
            while(compareByte === 0 && i < thisBytes.length){
                compareByte = thisBytes[i] - thatBytes[i];
                i++;
            }
            return compareByte;
        }
        return this.sign - that.sign;
    }
    /**
   * Returns a new instance of the Hex class, its value fits to the specified number of digits.
   *
   * @param {number} digits - The number of digits to fit the Hex value into.
   *
   * @returns {Hex} - A new Hex instance that represents the fitted Hex value.
   *
   * @throws {InvalidDataType} - If the Hex value cannot be fit into the specified number of digits.
   */ fit(digits) {
        if (digits < this.digits.length) {
            let cue = 0;
            while(this.digits.length - cue > digits && this.digits.at(cue) === "0")cue++;
            if (this.digits.length - cue === digits) return new _Hex(this.sign, this.digits.slice(cue));
            throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Hex.fit", `can't fit in ${digits} digits`, {
                digits: digits,
                hex: this
            });
        }
        if (digits > this.digits.length) return new _Hex(this.sign, "0".repeat(digits - this.digits.length) + this.digits);
        return this;
    }
    /**
   * Determines whether this Hex instance is equal to the given Hex instance.
   *
   * @param {Hex} that - The Hex instance to compare with.
   * @return {boolean} - True if the Hex instances are equal, otherwise false.
   */ isEqual(that) {
        return this.compareTo(that) === 0;
    }
    /**
   * Checks if this instance expresses a valid {@link Number} value
   * according the
   * [IEEE 754 double precision 64 bits floating point format](https://en.wikipedia.org/wiki/Double-precision_floating-point_format).
   *
   * @returns {boolean} Returns true if this instance expresses 32 hex digits (16 bytes, 128 bits) needed to represent
   * a {@link Number} value, else it returns false.
   */ isNumber() {
        return this.digits.length === 32;
    }
    /**
   * Checks if the given string expression is a valid hexadecimal value.
   *
   * @param {string} exp - The string representation of a hexadecimal value.
   *
   * @return {boolean} - True if the expression is a valid hexadecimal value, case-insensitive,
   * optionally prefixed with `0x`; false otherwise.
   */ static isValid(exp) {
        return _Hex.REGEX_HEX.test(exp);
    }
    /**
   * Determines whether the given string is a valid hexadecimal number prefixed with '0x'.
   *
   * @param {string} exp - The string to be evaluated.
   * @return {boolean} - True if the string is a valid hexadecimal number prefixed with '0x', otherwise false.
   */ static isValid0x(exp) {
        return _Hex.REGEX_HEX_PREFIX.test(exp) && _Hex.isValid(exp);
    }
    /**
   * Create a Hex instance from a bigint, number, string, or Uint8Array.
   *
   * @param {bigint | number | string | Uint8Array} exp - The value to represent in a Hex instance:
   * * bigint is always representable in hexadecimal base notation;
   * * number, encoded as [IEEE 754 double precision 64 bits floating point format](https://en.wikipedia.org/wiki/Double-precision_floating-point_format);
   * * string is parsed as the hexadecimal expression of a bigint value, optionally tagged with `0x`;
   * * Uint8Array is interpreted as the sequence of bytes.
   *
   * @returns {Hex} - A Hex instance representing the input value.
   *
   * @throws {InvalidDataType} if the given `exp` can't be represented as a hexadecimal expression.
   */ static of(exp) {
        try {
            if (exp instanceof Uint8Array) return new _Hex(this.POSITIVE, $esaJO.bytesToHex(exp));
            else if (typeof exp === "bigint") {
                if (exp < 0n) return new _Hex(this.NEGATIVE, $esaJO.numberToHexUnpadded(-1n * exp));
                return new _Hex(this.POSITIVE, $esaJO.numberToHexUnpadded(exp));
            } else if (typeof exp === "number") {
                const dataView = new DataView(new ArrayBuffer(16));
                dataView.setFloat64(0, exp);
                return new _Hex(exp < 0 ? this.NEGATIVE : this.POSITIVE, $esaJO.bytesToHex(new Uint8Array(dataView.buffer)));
            }
            if (this.isValid(exp)) {
                if (exp.startsWith("-")) return new _Hex(this.NEGATIVE, this.REGEX_HEX_PREFIX.test(exp) ? exp.slice(3) : exp.slice(1));
                return new _Hex(this.POSITIVE, this.REGEX_HEX_PREFIX.test(exp) ? exp.slice(2) : exp);
            }
            throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Hex.of", "not an hexadecimal string", {
                exp: exp
            });
        } catch (e) {
            throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Hex.of", "not an hexadecimal expression", {
                exp: `${exp}`
            }, // Needed to serialize bigint values.
            e);
        }
    }
    /**
   * Generates a random Hex value of the given number of bytes length.
   *
   * @param {number} bytes - The number of bytes to generate.
   * @throws {InvalidDataType} - If the bytes argument is not greater than 0.
   * @returns {Hex} - A randomly generated Hex value.
   *
   * @remarks Security auditable method, depends on
   * * [`nh_utils.randomBytes`](https://github.com/paulmillr/noble-hashes?tab=readme-ov-file#utils).
   */ static random(bytes) {
        if (bytes > 0) return _Hex.of($29ee4d3171d9809b$exports.randomBytes(bytes));
        throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Hex.random", "bytes argument not > 0", {
            bytes: bytes
        });
    }
    /**
   * Returns a string representation of the object.
   *
   * @return {string} The string representation of the object.
   */ toString() {
        return (this.sign < 0 ? "-0x" : "0x") + this.digits;
    }
};
// src/vcdm/abi/ABI.ts
var $564ad8f2c6689928$var$ABI = class _ABI {
    types;
    values;
    /**
   * ABI constructor from types and values.
   *
   * @param {string | AbiParameter[]} types - A list of ABI types representing the types of the values.
   * @param {unknown[]} values - An array of values according to the specified ABI types.
   **/ constructor(types = [], values = []){
        this.types = typeof types === "string" ? (0, $3c0c8f801fb7bf74$export$660dc560f0dcce7a)(types) : types;
        this.values = values;
    }
    /**
   * Compares the current ABI instance with another ABI instance.
   * @param that The ABI to compare with.
   * @returns {number} A non-zero number if the current ABI is different to the other ABI or zero if they are equal.
   * @override {@link VeChainDataModel#compareTo}
   * @remark The comparison is done by comparing the types and values of the ABI instances.
   **/ compareTo(that) {
        this.types.forEach((type, index)=>{
            if (type !== that.types[index]) return -1;
        });
        this.values.forEach((value, index)=>{
            if (value !== that.values[index]) return 1;
        });
        return 0;
    }
    /**
   * Checks if the current ABI object is equal to the given ABI object.
   * @param that The ABI object to compare with.
   * @returns {boolean} True if the objects are equal, false otherwise.
   * @override {@link VeChainDataModel#isEqual}
   * @remark The comparison is done by comparing the types and values of the ABI instances.
   **/ isEqual(that) {
        return this.compareTo(that) === 0;
    }
    /**
   * Throws an exception because the ABI cannot be represented as a big integer.
   * @returns {bigint} The BigInt representation of the ABI.
   * @throws {InvalidOperation} The ABI cannot be represented as a bigint.
   * @override {@link VeChainDataModel#bi}
   * @remark The conversion to BigInt is not supported for an ABI.
   */ get bi() {
        throw new (0, $dbc5c4a080b2aff5$export$8df2d8bae05b1dae)("ABI.bi", "There is no big integer representation for an ABI.", {
            data: ""
        });
    }
    /**
   * Encodes the values according to the specified ABI types when creating the ABI instance.
   *
   * @returns The ABI-encoded bytes representing the given values.
   * @throws {InvalidAbiDataToEncodeOrDecode, InvalidDataType}
   */ get bytes() {
        return this.toHex().bytes;
    }
    /**
   * Throws an exception because the ABI cannot be represented as a number.
   * @returns {bigint} The number representation of the ABI.
   * @throws {InvalidOperation} The mnemonic cannot be represented as a number.
   * @override {@link VeChainDataModel#n}
   * @remark The conversion to number is not supported for an ABI.
   */ get n() {
        throw new (0, $dbc5c4a080b2aff5$export$8df2d8bae05b1dae)("ABI.n", "There is no number representation for an ABI.", {
            data: ""
        });
    }
    /**
   * Instantiates an ABI object from the given types and values.
   * @param {string | AbiParameter[]} types ABI parameters representing the types of the values.
   * @param {unknown[]} values ABI values.
   * @returns {ABI} The ABI object with the given types and values.
   */ static of(types, values) {
        try {
            return new _ABI(types, values);
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3)("ABI.of", "Types and values must be valid ABI parameters.", {
                types: types,
                values: values
            }, error);
        }
    }
    /**
   * Decodes the ABI values from the given ABI types and encoded data.
   * @param {string| AbiParameter[]} types The list of ABI types representing the types of the values to decode.
   * @param {Hex} dataEncoded The encoded data to decode.
   * @returns An ABI instance with the decoded values.
   */ static ofEncoded(types, dataEncoded) {
        try {
            const hexDataEncoded = $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(dataEncoded);
            let values;
            if (typeof types === "string") {
                const parsedAbiParams = (0, $3c0c8f801fb7bf74$export$660dc560f0dcce7a)(types);
                values = (0, $47afb998e2da2e21$export$84d51ac2fffabd56)(parsedAbiParams, hexDataEncoded.bytes);
            } else values = (0, $47afb998e2da2e21$export$84d51ac2fffabd56)([
                ...types
            ], hexDataEncoded.bytes);
            return new _ABI(types, [
                ...values
            ]);
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3)("ABI.of", "Decoding failed: Data must be a valid ABI type with corresponding valid data.", {
                types: types,
                data: dataEncoded
            }, error);
        }
    }
    /**
   * Recursively parses an object and collects the values of each attribute into an array,
   * with nested arrays for nested objects.
   * @param {object} obj - The object to parse.
   * @returns {unknown[]} An array of values from the object, with nested arrays for nested objects.
   */ parseObjectValues(obj) {
        const values = [];
        const recursiveParse = (currentObj)=>{
            const currentValues = [];
            for(const key in currentObj)if (Object.prototype.hasOwnProperty.call(currentObj, key)) {
                const value = currentObj[key];
                if (typeof value === "object" && value !== null) currentValues.push(recursiveParse(value));
                else currentValues.push(value);
            }
            return currentValues;
        };
        values.push(...recursiveParse(obj));
        return values;
    }
    /**
   * It gets the first decoded value from the ABI.
   * @returns {ReturnType} The first decoded value from the ABI.
   */ getFirstDecodedValue() {
        if (this.values[0] instanceof Object) return this.parseObjectValues(this.values[0]);
        return this.values[0];
    }
    /**
   * Parses an ABI to its Hex representation.
   * @returns {Hex} The Hex representation of the ABI.
   */ toHex() {
        try {
            const abiParametersEncoded = (0, $a68160cb4cac9140$export$448ea0950d6dd7d7)(this.types, this.values);
            return $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(abiParametersEncoded);
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3)("ABI.toHex", "Encoding failed: Data must be a valid ABI type with corresponding valid data.", {
                types: this.types,
                values: this.values
            }, error);
        }
    }
};
var $564ad8f2c6689928$export$3de1df63de3dd8b4 = {
    encode: (type, value)=>$564ad8f2c6689928$var$ABI.of(type instanceof (0, $7316d9256af52303$export$426dc07f493a4c47) ? // This condition is here to enable compatibility with ethers regarding tuple[] types.
        type.format("full").replace(" list", "") : type, [
            value
        ]).toHex().toString(),
    encodeParams: (types, values)=>{
        const stringTypes = types instanceof (0, $7316d9256af52303$export$426dc07f493a4c47) ? types.map((type)=>type.format("full").replace(" list", "")) : types;
        const typesParam = (0, $3c0c8f801fb7bf74$export$660dc560f0dcce7a)(stringTypes.join(", "));
        return $564ad8f2c6689928$var$ABI.of([
            ...typesParam
        ], values).toHex().toString();
    },
    decode: (types, data)=>$564ad8f2c6689928$var$ABI.ofEncoded(types instanceof (0, $7316d9256af52303$export$426dc07f493a4c47) ? // This condition is here to enable compatibility with ethers regarding tuple[] types.
        types.format("full").replace(" list", "") : types, data).getFirstDecodedValue()
};
var $564ad8f2c6689928$export$243e6f55a096985 = class extends $564ad8f2c6689928$var$ABI {
    signature;
    stringSignature;
    /**
   * ABIItem constructor from item (Event, Function...) signature.
   *
   * @param {string | ViemABI} signature - The signature of the ABI item (Function, Event...).
   **/ constructor(signature){
        super();
        switch(typeof signature){
            case "string":
                this.stringSignature = signature;
                break;
            case "object":
                this.stringSignature = (0, $820c09f8aadb68c2$export$d075a2fd83e0ecb)(signature);
                break;
            default:
                this.stringSignature = "";
        }
        this.signature = typeof signature === "string" ? (0, $c7d8ae1c33480f79$export$1e31c38713b34060)([
            signature
        ]) : signature;
    }
    /**
   * Returns and instance of an ABIItem from a signature.
   * @param ABIItemConstructor ABIItem constructor.
   * @param {string | ABIItemType} signature Signature of the ABIIItem.
   * @returns {T} An instance of the ABIItem.
   */ static ofSignature(ABIItemConstructor, signature) {
        return new ABIItemConstructor(signature);
    }
    /**
   * Returns a string representation of a JSON object or a string.
   * @param {'json' | 'string'} formatType Either JSON or String
   * @returns The string representation of the ABI item.
   */ format(formatType = "string") {
        return formatType === "json" ? JSON.stringify(this.signature) : this.stringSignature;
    }
    /**
   * The signature hash of the ABIItem.
   * @returns {string} The signature hash of the ABIItem.
   * @remarks Wrapper for {@link toFunctionHash}.
   **/ get signatureHash() {
        return (0, $ed00d60e343845c7$export$d809beebc9c913db)(this.stringSignature);
    }
    /**
   * Compares the current ABIItem instance with another ABIItem instance.
   * @param {ABIItem} that The item to compare with.
   * @returns {number} A non-zero number if the current ABIItem is different to the other ABI or zero if they are equal.
   * @override {@link VeChainDataModel#compareTo}
   **/ compareTo(that) {
        if (super.compareTo(that) !== 0) return -1;
        return this.stringSignature.localeCompare(that.stringSignature);
    }
};
// src/vcdm/abi/ABIEvent.ts
var $564ad8f2c6689928$export$53dc4a052c6fe7a9 = class _ABIEvent extends $564ad8f2c6689928$export$243e6f55a096985 {
    abiEvent;
    constructor(signature){
        try {
            super(signature);
            this.abiEvent = this.signature;
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$9960ae42b8fea6ed)("ABIEvent constructor", "Initialization failed: Cannot create Event ABI. Event format is invalid.", {
                type: "event",
                value: signature
            }, error);
        }
    }
    /**
   * Decode event log data using the event's ABI.
   *
   * @param abi - Event to decode.
   * @returns Decoding results.
   * @throws {InvalidAbiDataToEncodeOrDecode}
   */ static parseLog(abi, eventData) {
        try {
            return (0, $59d586112e63de06$export$ec0597e81db3d947)({
                abi: abi,
                data: eventData.data.toString(),
                topics: eventData.topics.map((topic)=>{
                    if (topic === null) return topic;
                    else if (Array.isArray(topic)) return topic.map((t)=>t.toString());
                    return topic.toString();
                })
            });
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3)("ABIEvent.parseLog", "Decoding failed: Data must be a valid hex string encoding a compliant ABI type.", {
                data: {
                    abi: abi,
                    data: eventData.data,
                    topics: eventData.topics
                }
            }, error);
        }
    }
    /**
   * Decode event log data using the event's ABI.
   *
   * @param event - Event to decode.
   * @returns Decoding results.
   * @throws {InvalidAbiDataToEncodeOrDecode}
   */ decodeEventLog(event) {
        try {
            return _ABIEvent.parseLog([
                this.abiEvent
            ], event);
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3)("ABIEvent.decodeEventLog", "Decoding failed: Data must be a valid hex string encoding a compliant ABI type.", {
                data: event
            }, error);
        }
    }
    /**
   * Decode event log data as an array of values
   * @param {ABIEvent} event The data to decode.
   * @returns {unknown[]} The decoded data as array of values.
   */ decodeEventLogAsArray(event) {
        try {
            const rawDecodedData = this.decodeEventLog(event);
            if (rawDecodedData.args === void 0) return [];
            else if (rawDecodedData.args instanceof Object) return Object.values(rawDecodedData.args);
            return rawDecodedData.args;
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3)("ABIEvent.decodeEventLogAsArray", "Decoding failed: Data must be a valid hex string encoding a compliant ABI type.", {
                data: event
            }, error);
        }
    }
    /**
   * Encode event log data returning the encoded data and topics.
   * @param dataToEncode - Data to encode.
   * @returns {ABIEventData} Encoded data along with topics.
   * @remarks There is no equivalent to encodeEventLog in viem {@link https://viem.sh/docs/ethers-migration}. Discussion started here {@link https://github.com/wevm/viem/discussions/2676}.
   */ encodeEventLog(dataToEncode) {
        try {
            const topics = this.encodeFilterTopics(dataToEncode);
            const dataTypes = [];
            const dataValues = [];
            this.abiEvent.inputs.forEach((param, index)=>{
                if (param.indexed ?? false) return;
                const value = dataToEncode[index];
                dataTypes.push(param);
                dataValues.push(value);
            });
            return {
                data: $564ad8f2c6689928$var$ABI.of(dataTypes, dataValues).toHex(),
                topics: topics.map((topic)=>{
                    if (topic === null) return topic;
                    else if (Array.isArray(topic)) return topic.map((t)=>$564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(t));
                    return $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(topic);
                })
            };
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3)("ABIEvent.encodeEventLog", "Encoding failed: Data format is invalid. Event data must be correctly formatted for ABI-compliant encoding.", {
                dataToEncode: dataToEncode
            }, error);
        }
    }
    /**
   * Encode event log topics using the event's ABI.
   *
   * @param valuesToEncode - values to encode as topics. Non-indexed values are ignored.
   *                         Only the values of the indexed parameters are needed.
   * @returns Encoded topics array.
   * @throws {InvalidAbiDataToEncodeOrDecode}
   */ encodeFilterTopics(valuesToEncode) {
        if (this.abiEvent.inputs.length < valuesToEncode.length) throw new (0, $dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3)("ABIEvent.encodeEventLog", "Encoding failed: Data format is invalid. Number of values to encode is greater than the inputs.", {
            valuesToEncode: valuesToEncode
        });
        try {
            return (0, $cde759743388e706$export$64e9f7ca5ce29acd)({
                abi: [
                    this.abiEvent
                ],
                args: valuesToEncode
            });
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3)("ABIEvent.encodeEventLog", "Encoding failed: Data format is invalid. Event topics values must be correctly formatted for ABI-compliant encoding.", {
                valuesToEncode: valuesToEncode
            }, error);
        }
    }
    /**
   * Encode event log topics using the event's ABI, replacing null values with undefined.
   * @param valuesToEncode - values to encode as topics. Non-indexed values are ignored.
   *                         Only the values of the indexed parameters are needed.
   * @returns Encoded topics array.
   * @throws {InvalidAbiDataToEncodeOrDecode}
   */ encodeFilterTopicsNoNull(valuesToEncode) {
        const encodedTopics = this.encodeFilterTopics(valuesToEncode);
        return encodedTopics.map((topic)=>topic === null ? void 0 : topic);
    }
};
var $564ad8f2c6689928$export$91fefeed79eabb73 = class extends $564ad8f2c6689928$export$243e6f55a096985 {
    abiFunction;
    constructor(signature){
        try {
            super(signature);
            this.abiFunction = this.signature;
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$9960ae42b8fea6ed)("ABIFunction constructor", "Initialization failed: Cannot create Function ABI. Function format is invalid.", {
                type: "function",
                value: signature
            }, error);
        }
    }
    /**
   * Get the function selector.
   * @returns {string} The function selector.
   * @override {@link ABIItem#signatureHash}
   */ get signatureHash() {
        return super.signatureHash.substring(0, 10);
    }
    /**
   * Decode data using the function's ABI.
   *
   * @param {Hex} data - Data to decode.
   * @returns Decoding results.
   * @throws {InvalidAbiDataToEncodeOrDecode}
   */ decodeData(data) {
        try {
            return (0, $1c62abca4c636563$export$4508701cc9c71c1c)({
                abi: [
                    this.abiFunction
                ],
                data: data.toString()
            });
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3)("ABIFunction.decodeData", "Decoding failed: Data must be a valid hex string encoding a compliant ABI type.", {
                data: data
            }, error);
        }
    }
    /**
   * Encode data using the function's ABI.
   *
   * @param dataToEncode - Data to encode.
   * @returns {Hex} Encoded data.
   * @throws {InvalidAbiDataToEncodeOrDecode}
   */ encodeData(dataToEncode) {
        try {
            return $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of((0, $0122c1167c15ac5f$export$f4ee15df45da9f03)({
                abi: [
                    this.abiFunction
                ],
                args: dataToEncode
            }));
        } catch (e) {
            throw new (0, $dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3)("ABIFunction.encodeData", "Encoding failed: Data format is invalid. Function data does not match the expected format for ABI type encoding.", {
                dataToEncode: dataToEncode
            }, e);
        }
    }
    /**
   * Decodes the output data from a transaction based on ABI (Application Binary Interface) specifications.
   * This method attempts to decode the given hex-like data into a readable format using the contract's interface.
   *
   * @param {Hex} data - The data to be decoded, typically representing the output of a contract function call.
   * @returns {DecodeFunctionResultReturnType} An object containing the decoded data.
   * @throws {InvalidAbiDataToEncodeOrDecode}
   *
   * @example
   * ```typescript
   *   const decoded = abiFunctionInstance.decodeResult(rawTransactionOutput);
   *   console.log('Decoded Output:', decoded);
   * ```
   */ decodeResult(data) {
        try {
            return (0, $94e04a664e716c2d$export$3a05a90c230f925)({
                abi: [
                    this.abiFunction
                ],
                data: data.toString()
            });
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3)("ABIFunction.decodeResult", "Decoding failed: Data must be a valid hex string encoding a compliant ABI type.", {
                data: data
            }, error);
        }
    }
    /**
   * Decodes a function output returning an array of values.
   * @param {Hex} data The data to be decoded
   * @returns {unknown[]} The decoded data as array of values
   */ decodeOutputAsArray(data) {
        const resultDecoded = this.decodeResult(data);
        if (this.abiFunction.outputs.length > 1) return this.parseObjectValues(resultDecoded);
        else if (this.abiFunction.outputs.length === 1 && this.abiFunction.outputs[0].type === "tuple") return [
            this.parseObjectValues(resultDecoded)
        ];
        return [
            resultDecoded
        ];
    }
};
// src/vcdm/abi/ABIContract.ts
var $564ad8f2c6689928$export$c64f24a8950c1687 = class _ABIContract extends $564ad8f2c6689928$var$ABI {
    abi;
    constructor(abi){
        super();
        this.abi = abi;
    }
    /**
   * Creates an ABIContract instance from a viem ABI.
   * @param {ViemABI} abi representation of the contract.
   * @returns New instance of ABIContract.
   */ static ofAbi(abi) {
        return new _ABIContract(abi);
    }
    /**
   * Creates an ABIContract instance from an ABI string.
   * @param {string} abi representation of the contract.
   * @returns New instance of ABIContract.
   */ static ofStringAbi(abi) {
        return new _ABIContract((0, $419f32aea2288367$export$4ab3f466fb8f069)([
            abi
        ]));
    }
    /**
   * Returns the function with the given name.
   * @param {string} name The function's name.
   * @returns {ABIFunction} The function with the given name.
   * @throws {InvalidAbiItem}
   */ getFunction(name) {
        const functionAbiItem = (0, $2fe73cac1a6a91a6$export$99b134cd177e9574)({
            abi: this.abi,
            name: name
        });
        if (functionAbiItem === null || functionAbiItem === void 0) throw new (0, $dbc5c4a080b2aff5$export$9960ae42b8fea6ed)("ABIContract.getFunction()", `Function '${name}' not found in contract ABI.`, {
            type: "function",
            value: name
        });
        return new $564ad8f2c6689928$export$91fefeed79eabb73(functionAbiItem);
    }
    /**
   * Returns the event with the given name.
   * @param {string} name The event's name.
   * @returns {ABIEvent} The event with the given name.
   * @throws {InvalidAbiItem}
   */ getEvent(name) {
        const eventAbiItem = (0, $2fe73cac1a6a91a6$export$99b134cd177e9574)({
            abi: this.abi,
            name: name
        });
        if (eventAbiItem === null || eventAbiItem === void 0) throw new (0, $dbc5c4a080b2aff5$export$9960ae42b8fea6ed)("ABIContract.getEvent()", `Function '${name}' not found in contract ABI.`, {
            type: "event",
            value: name
        });
        return new $564ad8f2c6689928$export$53dc4a052c6fe7a9(eventAbiItem);
    }
    /**
   * Encode function data that can be used to send a transaction.
   * @param {string} functionName The name of the function defined in the ABI.
   * @param {unknown[]} functionData The data to pass to the function.
   * @returns {Hex} The encoded data in hexadecimal that can be used to send a transaction.
   * @throws {InvalidAbiDataToEncodeOrDecode}
   */ encodeFunctionInput(functionName, functionData) {
        try {
            const functionAbiItem = (0, $2fe73cac1a6a91a6$export$99b134cd177e9574)({
                abi: this.abi,
                name: functionName
            });
            const functionAbi = new $564ad8f2c6689928$export$91fefeed79eabb73(functionAbiItem);
            return functionAbi.encodeData(functionData);
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3)("ABIContract.encodeFunctionInput()", `Encoding failed: Data format is invalid. Function data does not match the expected format for ABI type encoding.`, {
                functionName: functionName,
                functionData: functionData
            }, error);
        }
    }
    /**
   * Decode the function data of an encoded function
   * @param {string} functionName The name of the function defined in the ABI.
   * @param {Hex} encodedFunctionInput The encoded function data.
   * @returns {DecodeFunctionDataReturnType} an array of the decoded function data
   * @throws {InvalidAbiDataToEncodeOrDecode}
   */ decodeFunctionInput(functionName, encodedFunctionInput) {
        try {
            const functionAbiItem = (0, $2fe73cac1a6a91a6$export$99b134cd177e9574)({
                abi: this.abi,
                name: functionName
            });
            const functionAbi = new $564ad8f2c6689928$export$91fefeed79eabb73(functionAbiItem);
            return functionAbi.decodeData(encodedFunctionInput);
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3)("ABIContract.decodeFunctionInput()", "Decoding failed: Data must be a valid hex string encoding a compliant ABI type.", {
                functionName: functionName,
                encodedFunctionInput: encodedFunctionInput
            }, error);
        }
    }
    /**
   * Decodes the output from a contract function using the specified ABI and function name.
   * It takes the encoded function output and attempts to decode it according to the ABI definition.
   *
   * @param {string} functionName - The name of the function in the contract to decode the output for.
   * @param {Hex} encodedFunctionOutput - The encoded output data from the contract function.
   * @returns {DecodeFunctionResultReturnType} - The decoded output, which provides a user-friendly way
   * to interact with the decoded data.
   * @throws {InvalidAbiDataToEncodeOrDecode}
   *
   * @example
   * // Example of decoding output for a function called "getValue":
   * const decodedOutput = decodeFunctionOutput('getValue', encodedValue);
   *
   */ decodeFunctionOutput(functionName, encodedFunctionOutput) {
        try {
            const functionAbiItem = (0, $2fe73cac1a6a91a6$export$99b134cd177e9574)({
                abi: this.abi,
                name: functionName
            });
            const functionAbi = new $564ad8f2c6689928$export$91fefeed79eabb73(functionAbiItem);
            return functionAbi.decodeResult(encodedFunctionOutput);
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3)("ABIContract.decodeFunctionOutput()", "Decoding failed: Data must be a valid hex string encoding a compliant ABI type.", {
                functionName: functionName,
                encodedFunctionOutput: encodedFunctionOutput
            }, error);
        }
    }
    /**
   * Encodes event log data based on the provided event name, and data to encode.
   * @param {string} eventName - The name of the event to be encoded.
   * @param {unknown[]} eventArgs - An array of data to be encoded in the event log.
   * @returns {ABIEventData} An object containing the encoded data and topics.
   * @throws {InvalidAbiDataToEncodeOrDecode}
   */ encodeEventLog(eventName, eventArgs) {
        try {
            const eventAbiItem = (0, $2fe73cac1a6a91a6$export$99b134cd177e9574)({
                abi: this.abi,
                name: eventName
            });
            const eventAbi = new $564ad8f2c6689928$export$53dc4a052c6fe7a9(eventAbiItem);
            return eventAbi.encodeEventLog(eventArgs);
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3)("ABIContract.encodeEventLog()", `Encoding failed: Data format is invalid. Event data does not match the expected format for ABI type encoding.`, {
                eventName: eventName,
                dataToEncode: eventArgs
            }, error);
        }
    }
    /**
   * Decodes event log data based on the provided event name, and data/topics to decode.
   * @param {string} eventName - The name of the event to be decoded.
   * @param {ABIEventData} eventToDecode - An object containing the data and topics to be decoded.
   * @returns {DecodeEventLogReturnType} The decoded data of the event log.
   * @throws {InvalidAbiDataToEncodeOrDecode}
   */ decodeEventLog(eventName, eventToDecode) {
        try {
            const eventAbiItem = (0, $2fe73cac1a6a91a6$export$99b134cd177e9574)({
                abi: this.abi,
                name: eventName
            });
            const eventAbi = new $564ad8f2c6689928$export$53dc4a052c6fe7a9(eventAbiItem);
            return eventAbi.decodeEventLog(eventToDecode);
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3)("ABIContract.encodeEventLog()", `Encoding failed: Data format is invalid. Event data does not match the expected format for ABI type encoding.`, {
                eventName: eventName,
                dataToDecode: eventToDecode
            }, error);
        }
    }
    /**
   * Decodes a VeChain log based on the ABI definition.
   *
   * This method takes raw `data` and `topics` from a VeChain log and attempts
   * to decode them using the contract's ABI definition. If the decoding is successful,
   * it returns a log object representing the decoded information. If the decoding fails,
   * it throws a custom error with detailed information.
   *
   * @param {Hex} data - The hexadecimal string of the data field in the log.
   * @param {Hex[]} topics - An array of hexadecimal strings representing the topics of the log.
   * @returns {DecodeEventLogReturnType} - A log object representing the decoded log or null if decoding fails.
   * @throws {InvalidAbiDataToEncodeOrDecode}
   */ parseLog(data, topics) {
        try {
            return $564ad8f2c6689928$export$53dc4a052c6fe7a9.parseLog(this.abi, {
                data: data,
                topics: topics
            });
        } catch (e) {
            throw new (0, $dbc5c4a080b2aff5$export$c6bbdfa82e9d70f3)("ABIContract.parseLog()", `Decoding failed: Data must be a valid hex string encoding a compliant ABI type.`, {
                data: data,
                topics: topics
            }, e);
        }
    }
    /**
   *
   * Parses the log data and topics into an array of values.
   *
   * @param {Hex} data - The hexadecimal string of the data field in the log.
   * @param {Hex[]} topics - An array of hexadecimal strings representing the topics of the log.
   * @returns {unknown[]} - An array of values of the decoded log data.
   */ parseLogAsArray(data, topics) {
        const eventLogDecoded = this.parseLog(data, topics);
        if (eventLogDecoded.args === void 0) return [];
        else if (eventLogDecoded.args instanceof Object) return Object.values(eventLogDecoded.args);
        return eventLogDecoded.args;
    }
};
var $564ad8f2c6689928$export$1ed4b10e4aba04a7 = class {
    address;
    balance;
    // Replace the string array with a Transaction class #1162
    transactions;
    type;
    constructor(address, balance, type = "EOA", transactions){
        this.address = address;
        this.balance = balance;
        this.type = type;
        this.transactions = transactions ?? [];
    }
    /**
   * Throws an exception because the account cannot be represented as a big integer.
   * @returns {bigint} The BigInt representation of the account.
   * @throws {InvalidOperation} The account cannot be represented as a bigint.
   * @override {@link VeChainDataModel#bi}
   * @remarks The conversion to BigInt is not supported for an account.
   */ get bi() {
        throw new (0, $dbc5c4a080b2aff5$export$8df2d8bae05b1dae)("Account.bi", "There is no big integer representation for an account.", {
            data: ""
        });
    }
    /**
   * Throws an exception because the account cannot be represented as a byte array.
   * @returns {Uint8Array} The byte array representation of the account.
   * @throws {InvalidOperation} The account cannot be represented as a byte array.
   * @override {@link VeChainDataModel#bytes}
   * @remarks The conversion to byte array is not supported for an account.
   */ get bytes() {
        throw new (0, $dbc5c4a080b2aff5$export$8df2d8bae05b1dae)("Account.bytes", "There is no bytes representation for an account.", {
            data: ""
        });
    }
    /**
   * Throws an exception because the account cannot be represented as a number.
   * @returns {bigint} The number representation of the account.
   * @throws {InvalidOperation} The account cannot be represented as a number.
   * @override {@link VeChainDataModel#n}
   * @remarks The conversion to number is not supported for an account.
   */ get n() {
        throw new (0, $dbc5c4a080b2aff5$export$8df2d8bae05b1dae)("Account.n", "There is no number representation for an account.", {
            data: ""
        });
    }
    /**
   * Adds a transaction to the account.
   * @param {string} transaction The transaction to add.
   */ addTransaction(transaction) {
        this.transactions.push(transaction);
    }
    /**
   * Compare this instance with `that` in a meaningful way.
   *
   * @param {Account} that object to compare.
   * @return a negative number if `this` < `that`, zero if `this` = `that`, a positive number if `this` > that`.
   * @override {@link VeChainDataModel#compareTo}
   */ compareTo(that) {
        const typeDiff = this.type.localeCompare(that.type);
        if (typeDiff === 0) {
            const addressDiff = this.address.compareTo(that.address);
            if (addressDiff === 0) {
                const codeDiff = this.balance.code.compareTo(that.balance.code);
                if (codeDiff === 0) return this.balance.value.compareTo(that.balance.value);
                return codeDiff;
            }
            return addressDiff;
        }
        return typeDiff;
    }
    /**
   * Checks if the given value is equal to the current instance.
   *
   * @param {Account} that - The value to compare.
   * @returns {boolean} - True if the values are equal, false otherwise.
   * @override {@link VeChainDataModel#isEqual}
   */ isEqual(that) {
        return this.compareTo(that) === 0;
    }
    /**
   * Returns a string representation of the account.
   *
   * @returns {string} A string representation of the account.
   */ toString() {
        return `${this.type} Address: ${this.address.toString()} Balance: ${this.balance.value} ${this.balance.code}`;
    }
};
var $564ad8f2c6689928$export$8cd63f50dbdefc2e = class _HexInt extends $564ad8f2c6689928$export$9ccf03a0aa23a1ca {
    /**
   * Retrieves the value of n cast from this instance interpreted as the hexadecimal expression of a bigint value.
   *
   * @return {number} The value of n.
   *
   * @throws {InvalidDataType} If n is not within the safe number range, if the number representation of this
   * instance results approximated.
   *
   * @remarks This class makes equal instances created from the same value as number or as bigint.
   */ get n() {
        const bi = this.bi;
        if (Number.MIN_SAFE_INTEGER <= bi && bi <= Number.MAX_SAFE_INTEGER) return Number(bi);
        throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("HexInt.n", "not in the safe number range", {
            bi: `${bi}`,
            hex: this.toString()
        });
    }
    /**
   * Create a HexInt instance from a bigint, number, string, Uint8Array, or {@link Hex}.
   *
   * @param {bigint | number | string | Uint8Array | Hex} exp - The expression to be interpreted as an integer:
   * * bigint is always representable in hexadecimal base notation;
   * * number is converted to a bigint then represented in hexadecimal base notation;
   *   it throws {@link InvalidDataType} if not an integer value;
   * * string is parsed as the hexadecimal expression of a bigint value, optionally tagged with `0x`;
   * * Uint8Array is interpreted as the sequence of bytes expressing a bigint value;
   * * {@link Hex} is interpreted as expressing a bigint value.
   *
   * @returns {HexInt} - The new HexInt object representing the given `exp`.
   *
   * @throws {InvalidDataType} - If the given `exp` is not a valid hexadecimal integer expression,
   * if `exp` is a not integer number.
   *
   * @remarks This class makes equal instances created from the same value as number or as bigint.
   */ static of(exp) {
        try {
            if (exp instanceof $564ad8f2c6689928$export$9ccf03a0aa23a1ca) return new _HexInt(exp.sign, exp.digits);
            if (typeof exp === "number") {
                if (Number.isInteger(exp)) {
                    const hex2 = $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(BigInt(exp));
                    return new _HexInt(hex2.sign, hex2.digits);
                }
                throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("HexInt.of", "not an integer", {
                    exp: exp
                });
            }
            const hex = $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(exp);
            return new _HexInt(hex.sign, hex.digits);
        } catch (e) {
            throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("HexInt.of", "not an hexadecimal integer expression", {
                exp: `${exp}`,
                e: e
            });
        }
    }
};
var $564ad8f2c6689928$export$7c2a2de09ea3c4f2 = class _HexUInt extends $564ad8f2c6689928$export$8cd63f50dbdefc2e {
    /**
   * Regular expression for matching hexadecimal strings.
   * An empty input is represented as a empty digits.
   *
   * @type {RegExp}
   */ static REGEX_HEXUINT = /^(0x)?[0-9a-f]*$/i;
    /**
   * Regular expression pattern to match a prefix indicating hexadecimal number.
   *
   * @type {RegExp}
   */ static REGEX_HEXUINT_PREFIX = /^0x/i;
    /**
   * Checks if the given string expression is a valid unsigned hexadecimal value.
   *
   * @param {string} exp - The string representation of a hexadecimal value.
   *
   * @return {boolean} - True if the expression is a valid unsigned hexadecimal value, case-insensitive,
   * optionally prefixed with `0x`; false otherwise.
   */ static isValid(exp) {
        return _HexUInt.REGEX_HEXUINT.test(exp);
    }
    /**
   * Determines whether the given string is a valid unsigned hexadecimal number prefixed with '0x'.
   *
   * @param {string} exp - The string to be evaluated.
   * @return {boolean} - True if the string is a valid unsigned hexadecimal number prefixed with '0x', otherwise false.
   */ static isValid0x(exp) {
        return _HexUInt.REGEX_HEX_PREFIX.test(exp) && $564ad8f2c6689928$export$9ccf03a0aa23a1ca.isValid(exp);
    }
    /**
   * Create a HexUInt instance from a bigint, number, string, Uint8Array, or {@link HexInt}.
   *
   * @param {bigint | number | string | Uint8Array | HexInt} exp - The expression to be interpreted as an unsigned integer:
   * * bigint is always representable in hexadecimal base notation,
   *   it throws {@link InvalidDataType} if not positive;
   * * number is converted to a bigint then represented in hexadecimal base notation,
   *   it throws {@link InvalidDataType} if not a positive integer value;
   * * string is parsed as the hexadecimal expression of a bigint value, optionally tagged with `0x`;
   *   it throws {@link InvalidDataType} if not positive;
   * * Uint8Array is interpreted as the sequence of bytes expressing a positive bigint value;
   * * {@link HexInt} is interpreted as expressing a bigint value,
   *   it throws {@link InvalidDataType} if not positive.
   *
   * @returns {HexUInt} he new HexInt object representing the given `exp`.
   *
   * @throws {InvalidDataType} If the given expression is not a valid hexadecimal positive integer expression.
   */ static of(exp) {
        try {
            const hint = $564ad8f2c6689928$export$8cd63f50dbdefc2e.of(exp);
            if (hint.sign >= $564ad8f2c6689928$export$9ccf03a0aa23a1ca.POSITIVE) return new _HexUInt(hint.sign, hint.digits);
            throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("HexUInt.of", "not positive", {
                exp: `${exp}`
            });
        } catch (e) {
            throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("HexUInt.of", "not a hexadecimal positive integer expression", {
                exp: `${exp}`,
                e: e
            }, // Needed to serialize bigint values.
            e);
        }
    }
};
var $564ad8f2c6689928$export$1d5cbbbdccc512f9 = class _Txt extends String {
    /**
   * Decoder object used for decoding bytes as text data.
   *
   * @class
   * @constructor
   */ static DECODER = new TextDecoder();
    /**
   * *Normalization Form Canonical Composition*
   * [Unicode Equivalence](https://en.wikipedia.org/wiki/Unicode_equivalence)
   * flag.
   *
   * @type {string}
   * @constant
   */ static NFC = "NFC";
    /**
   * A TextEncoder instance used for encoding text to bytes.
   *
   * @type {TextEncoder}
   */ static ENCODER = new TextEncoder();
    /**
   * Creates a new instance of this class representing the `exp` string
   * normalized according the *Canonical Composition Form*
   * [Unicode Equivalence](https://en.wikipedia.org/wiki/Unicode_equivalence).
   *
   * @param {string} exp - The expression to be passed to the constructor.
   * @protected
   * @constructor
   */ constructor(exp){
        super(exp.normalize(_Txt.NFC));
    }
    /**
   * Converts the current Txt string to a BigInt.
   *
   * @returns {bigint} The BigInt representation of the Txt string.
   *
   *  @throws {InvalidOperation} If the conversion to BigInt fails because this Txt string doesn't represent an integer.
   */ get bi() {
        try {
            return BigInt(this.toString());
        } catch (e) {
            throw new (0, $dbc5c4a080b2aff5$export$8df2d8bae05b1dae)("Txt.bi()", "Can't cast to big integer", {
                txt: this.toString()
            }, e);
        }
    }
    /**
   * Converts the current Txt string to a buffer of bytes.
   *
   * @returns {Uint8Array} The bytes representation of the Txt string.
   */ get bytes() {
        return _Txt.ENCODER.encode(this.toString());
    }
    /**
   * Returns the value of n as a number.
   *
   * @returns {number} The value of n as a number.
   */ /**
   * Converts the current Txt string to a number.
   *
   * @returns {number} The numeric value of the Txt string.
   *
   * @throws {InvalidOperation} If the conversion to number fails because this Txt string doesn't represent a decimal number.
   */ get n() {
        return Number(this.toString());
    }
    /**
   * Compares the current instance to another instance of Txt.
   *
   * @param {Txt} that - The instance to compare with.
   *
   * @return {number} - A negative number if the current instance is less than the specified instance,
   *                    zero if they are equal, or a positive number if the current instance is greater.
   */ compareTo(that) {
        return this.toString().localeCompare(that.toString());
    }
    /**
   * Checks if the current Txt object is equal to the given Txt object.
   *
   * @param {Txt} that - The Txt object to compare with.
   *
   *  @return {boolean} - True if the objects are equal, false otherwise.
   */ isEqual(that) {
        return this.compareTo(that) === 0;
    }
    /**
   * Returns a string representation of the object.
   *
   * @returns {string} A string representation of the object.
   */ toString() {
        return this.valueOf();
    }
    /**
   * Creates a new Txt instance from the provided expression.
   *
   * @param {bigint | number | string | Uint8Array} exp - The expression to convert to Txt:
   * * {@link bigint} is represented as a {@link NFC} encoded string expressing the value in base 10;
   * * {@link number} is represented as a {@link NFC} encoded string expressing the value in base 10;
   * * {@link string} is encoded as {@link NFC} string;
   * * {@link Uint8Array} is {@link NFC} decoded to a string.
   *
   * @returns {Txt} - A new Txt instance.
   */ static of(exp) {
        if (exp instanceof Uint8Array) return new _Txt(_Txt.DECODER.decode(exp));
        else if (typeof exp === "bigint" || typeof exp === "number") return new _Txt(exp.toString());
        return new _Txt(exp);
    }
};
// src/vcdm/hash/Keccak256.ts
var $564ad8f2c6689928$export$83afadb7dd1667bc = class _Keccak256 extends $564ad8f2c6689928$export$7c2a2de09ea3c4f2 {
    /**
   * Generates the [SHA-3](https://en.wikipedia.org/wiki/SHA-3) [KECCAK 256](https://keccak.team/keccak.html) hash of the given input.
   *
   * @param {bigint | number | string | Uint8Array | Hex} exp - The input value to hash.
   *
   * @returns {Sha256} - The [KECCAK 256](https://keccak.team/keccak.html) hash of the input value.
   *
   * @throws {InvalidOperation} - If a hash error occurs.
   *
   * @remarks Security auditable method, depends on
   * * [`nh_keccak_256`](https://github.com/paulmillr/noble-hashes#sha3-fips-shake-keccak).
   */ static of(exp) {
        try {
            const hash2 = (0, $08748f983f07956b$exports.keccak_256)($564ad8f2c6689928$export$7c2a2de09ea3c4f2.of(exp).bytes);
            return new _Keccak256($564ad8f2c6689928$export$9ccf03a0aa23a1ca.POSITIVE, $564ad8f2c6689928$export$7c2a2de09ea3c4f2.of(hash2).digits);
        } catch (e) {
            throw new (0, $dbc5c4a080b2aff5$export$8df2d8bae05b1dae)("Keccak256.of", "hash error", {
                exp: `${exp}`,
                e: // Needed to serialize bigint values.
                e
            });
        }
    }
};
function $564ad8f2c6689928$export$f8151fce47ad1c35(data, returnType = "buffer") {
    return returnType === "buffer" ? $564ad8f2c6689928$export$83afadb7dd1667bc.of($564ad8f2c6689928$export$1d5cbbbdccc512f9.of(data).bytes).bytes : $564ad8f2c6689928$export$83afadb7dd1667bc.of($564ad8f2c6689928$export$1d5cbbbdccc512f9.of(data).bytes).toString();
}
var $564ad8f2c6689928$export$3dede3b6cc153eb5 = class _FixedPointNumber {
    /**
   * The default number of decimal places to use for fixed-point math.
   *
   * @see
   * [bignumber.js DECIMAL_PLACES](https://mikemcl.github.io/bignumber.js/#decimal-places)
   *
   * @constant {bigint}
   */ static DEFAULT_FRACTIONAL_DECIMALS = 20n;
    /**
   * Not a Number.
   *
   * @remarks {@link fd} and {@link sv} not meaningful.
   *
   * @see [Number.NaN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/NaN)
   *
   */ static NaN = new _FixedPointNumber(0n, 0n, NaN);
    /**
   * The negative Infinity value.
   *
   * @remarks {@link fd} and {@link sv} not meaningful.
   *
   * @see [Number.NEGATIVE_INFINITY](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/NEGATIVE_INFINITY)
   */ static NEGATIVE_INFINITY = new _FixedPointNumber(0n, 0n, Number.NEGATIVE_INFINITY);
    /**
   * The positive Infinite value.
   *
   * @remarks {@link fd} and {@link sv} not meaningful.
   *
   * @see [Number.POSITIVE_INFINITY](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/POSITIVE_INFINITY)
   */ static POSITIVE_INFINITY = new _FixedPointNumber(0n, 0n, Number.POSITIVE_INFINITY);
    /**
   * Regular expression pattern for matching integers expressed as base 10 strings.
   */ static REGEX_INTEGER = /^[-+]?\d+$/;
    /**
   * Regular expression for matching numeric values expressed as base 10 strings.
   */ static REGEX_NUMBER = /(^[-+]?\d+(\.\d+)?)$|(^[-+]?\.\d+)$/;
    /**
   * Regular expression pattern for matching natural numbers expressed as base 10 strings.
   */ static REGEX_NATURAL = /^\d+$/;
    /**
   * Represents the zero constant.
   */ static ZERO = new _FixedPointNumber(0n, 0n, 0);
    /**
   * Edge Flag denotes the {@link NaN} or {@link NEGATIVE_INFINITY} or {@link POSITIVE_INFINITY} value.
   *
   * @remarks If `ef` is not zero, {@link fd} and {@link sv} are not meaningful.
   */ ef;
    /**
   * Fractional Digits or decimal places.
   */ fd;
    /**
   * Scaled Value = value * 10 ^ {@link fd}.
   */ sv;
    /**
   * Returns the integer part of this FixedPointNumber value.
   *
   * @return {bigint} the integer part of this FixedPointNumber value.
   *
   * @throws {InvalidOperation} If the value is not finite.
   */ get bi() {
        if (this.isFinite()) return this.sv / 10n ** this.fd;
        throw new (0, $dbc5c4a080b2aff5$export$8df2d8bae05b1dae)("FixedPointNumber.bi", "not finite value cannot cast to big integer", {
            this: this.toString()
        });
    }
    /**
   * Returns the array of bytes representing the *Normalization Form Canonical Composition*
   * [Unicode Equivalence](https://en.wikipedia.org/wiki/Unicode_equivalence)
   * of this value expressed in decimal base.
   */ get bytes() {
        return $564ad8f2c6689928$export$1d5cbbbdccc512f9.of(this.toString()).bytes;
    }
    /**
   * Return this value approximated as {@link number}.
   */ get n() {
        if (this.isNaN()) return Number.NaN;
        if (this.isNegativeInfinite()) return Number.NEGATIVE_INFINITY;
        if (this.isPositiveInfinite()) return Number.POSITIVE_INFINITY;
        if (this.isZero()) return 0;
        return Number(this.sv) * 10 ** -Number(this.fd);
    }
    /**
   * Returns the new Fixed-Point Number (FixedPointNumber) instance having
   *
   * @param {bigint} fd - Number of Fractional Digits (or decimal places).
   * @param {bigint} sv - Scaled Value.
   * @param {number} [ef=0] - Edge Flag.
   */ constructor(fd, sv, ef = 0){
        this.fd = fd;
        this.ef = ef;
        this.sv = sv;
    }
    /**
   * Returns a FixedPointNumber whose value is the absolute value, i.e. the magnitude, of the value of this FixedPointNumber.
   *
   * @return {FixedPointNumber} the absolute value of this FixedPointNumber.
   *
   * @see [bignumber.js absoluteValue](https://mikemcl.github.io/bignumber.js/#abs)
   */ abs() {
        if (this.isNaN()) return _FixedPointNumber.NaN;
        if (this.isNegativeInfinite()) return _FixedPointNumber.POSITIVE_INFINITY;
        return new _FixedPointNumber(this.fd, this.sv < 0n ? -this.sv : this.sv, this.ef);
    }
    /**
   * Compares this instance with `that` FixedPointNumber instance.
   * * Returns 0 if this is equal to `that` FixedPointNumber, including infinite with equal sign;
   * * Returns -1, if this is -Infinite or less than `that` FixedPointNumber;,
   * * Returns 1 if this is +Infinite or greater than `that` FixedPointNumber.
   *
   * @param {FixedPointNumber} that - The instance to compare with this instance.
   * @return {number} Returns -1, 0, or 1 if this instance is less than, equal to, or greater
   * than the specified instance, respectively.
   * @throw InvalidOperation If this or `that` FixedPointNumber is {@link NaN}.
   *
   * @see [bignumber.js comparedTo](https://mikemcl.github.io/bignumber.js/#cmp)
   */ compareTo(that) {
        if (this.isNaN() || that.isNaN()) throw new (0, $dbc5c4a080b2aff5$export$8df2d8bae05b1dae)("FixedPointNumber.compareTo", "compare between NaN", {
            this: `${this}`,
            that: `${that}`
        });
        if (this.isNegativeInfinite()) return that.isNegativeInfinite() ? 0 : -1;
        if (this.isPositiveInfinite()) return that.isPositiveInfinite() ? 0 : 1;
        if (that.isNegativeInfinite()) return 1;
        if (that.isPositiveInfinite()) return -1;
        const fd = this.fd > that.fd ? this.fd : that.fd;
        const delta = this.dp(fd).sv - that.dp(fd).sv;
        return delta < 0n ? -1 : delta === 0n ? 0 : 1;
    }
    /**
   * Compares this instance with `that` FixedPointNumber instance.
   * * **Returns `null` if either instance is NaN;**
   * * Returns 0 if this is equal to `that` FixedPointNumber, including infinite with equal sign;
   * * Returns -1, if this is -Infinite or less than `that` FixedPointNumber;,
   * * Returns 1 if this is +Infinite or greater than `that` FixedPointNumber.
   *
   * @param {FixedPointNumber} that - The instance to compare with this instance.
   * @return {null | number} A null if either instance is NaN;
   * -1, 0, or 1 if this instance is less than, equal to, or greater
   * than the specified instance, respectively.
   *
   * @remarks This method uses internally {@link compareTo} wrapping the {@link InvalidOperation} exception
   * when comparing between {@link NaN} values to behave according the
   * [[bignumber.js comparedTo](https://mikemcl.github.io/bignumber.js/#cmp)] rules.
   */ comparedTo(that) {
        try {
            return this.compareTo(that);
        } catch (e) {
            return null;
        }
    }
    /**
   * Returns a FixedPointNumber whose value is the value of this FixedPointNumber divided by `that` FixedPointNumber.
   *
   * Limit cases
   * * 0 / 0 = NaN
   * * NaN / ±n = NaN
   * * ±Infinity / ±Infinity = NaN
   * * +n / NaN = NaN
   * * +n / ±Infinity = 0
   * * -n / 0 = -Infinity
   * * +n / 0 = +Infinity
   *
   * @param {FixedPointNumber} that - The fixed-point number to divide by.
   * @return {FixedPointNumber} The result of the division.
   *
   * @remarks The precision is the greater of the precision of the two operands.
   *
   * @see [bignumber.js dividedBy](https://mikemcl.github.io/bignumber.js/#div)
   */ div(that) {
        if (this.isNaN() || that.isNaN()) return _FixedPointNumber.NaN;
        if (this.isNegativeInfinite()) return that.isInfinite() ? _FixedPointNumber.NaN : that.isPositive() ? _FixedPointNumber.NEGATIVE_INFINITY : _FixedPointNumber.POSITIVE_INFINITY;
        if (this.isPositiveInfinite()) return that.isInfinite() ? _FixedPointNumber.NaN : that.isPositive() ? _FixedPointNumber.POSITIVE_INFINITY : _FixedPointNumber.NEGATIVE_INFINITY;
        if (that.isInfinite()) return _FixedPointNumber.ZERO;
        if (that.isZero()) return this.isZero() ? _FixedPointNumber.NaN : this.isNegative() ? _FixedPointNumber.NEGATIVE_INFINITY : _FixedPointNumber.POSITIVE_INFINITY;
        const fd = this.fd > that.fd ? this.fd : that.fd;
        return new _FixedPointNumber(fd, _FixedPointNumber.div(fd, this.dp(fd).sv, that.dp(fd).sv));
    }
    /**
   * Divides the given dividend by the given divisor, adjusted by a factor based on fd.
   *
   * @param {bigint} fd - The factor determining the power of 10 to apply to the dividend.
   * @param {bigint} dividend - The number to be divided.
   * @param {bigint} divisor - The number by which to divide the dividend.
   *
   * @return {bigint} - The result of the division, adjusted by the given factor fd.
   */ static div(fd, dividend, divisor) {
        return 10n ** fd * dividend / divisor;
    }
    /**
   * Adjusts the precision of the floating-point number by the specified
   * number of decimal places.
   *
   * @param {bigint | number} decimalPlaces - The number of decimal places to adjust to.
   * @return {FixedPointNumber} A new FixedPointNumber instance with the adjusted precision.
   */ dp(decimalPlaces) {
        const fp = BigInt(decimalPlaces);
        const dd = fp - this.fd;
        if (dd < 0) return new _FixedPointNumber(fp, this.sv / 10n ** -dd);
        else return new _FixedPointNumber(fp, this.sv * 10n ** dd);
    }
    /**
   * Returns `true `if the value of thisFPN is equal to the value of `that` FixedPointNumber, otherwise returns `false`.
   *
   * As with JavaScript, `NaN` does not equal `NaN`.
   *
   * @param {FixedPointNumber} that - The FixedPointNumber to compare against.
   * @return {boolean} `true` if the FixedPointNumber numbers are equal, otherwise `false`.
   *
   * @remarks This method uses {@link comparedTo} internally.
   *
   * @see [bigbumber.js isEqualTo](https://mikemcl.github.io/bignumber.js/#eq)
   */ eq(that) {
        return this.comparedTo(that) === 0;
    }
    /**
   * Returns `true` if the value of this FixedPointNumber is greater than `that` FixedPointNumber`, otherwise returns `false`.
   *
   * @param {FixedPointNumber} - that The FixedPointNumber to compare against.
   * @return {boolean} `true` if this FixedPointNumber is greater than `that` FixedPointNumber, otherwise `false`.
   *
   * @remarks This method uses {@link comparedTo} internally.
   *
   * @see [bignummber.js isGreaterThan](https://mikemcl.github.io/bignumber.js/#gt)
   */ gt(that) {
        const cmp = this.comparedTo(that);
        return cmp !== null && cmp > 0;
    }
    /**
   * Returns `true` if the value of this FixedPointNumber is greater or equal than `that` FixedPointNumber`, otherwise returns `false`.
   *
   * @param {FixedPointNumber} that - The FixedPointNumber to compare against.
   * @return {boolean} `true` if this FixedPointNumber is greater or equal than `that` FixedPointNumber, otherwise `false`.
   *
   * @remarks This method uses {@link comparedTo} internally.
   *
   * @see [bignumber.js isGreaterThanOrEqualTo](https://mikemcl.github.io/bignumber.js/#gte)
   */ gte(that) {
        const cmp = this.comparedTo(that);
        return cmp !== null && cmp >= 0;
    }
    /**
   * Returns a fixed-point number whose value is the integer part of dividing the value of this fixed-point number
   * by `that` fixed point number.
   *
   * Limit cases
   * * 0 / 0 = NaN
   * * NaN / ±n = NaN
   * * ±Infinity / ±Infinity = NaN
   * * +n / NaN = NaN
   * * +n / ±Infinite = 0
   * * -n / 0 = -Infinite
   * * +n / 0 = +Infinite
   *
   * @param {FixedPointNumber} that - The fixed-point number to divide by.
   * @return {FixedPointNumber} The result of the division.
   *
   * @remarks The precision is the greater of the precision of the two operands.
   *
   * @see [bignumber.js dividedToIntegerBy](https://mikemcl.github.io/bignumber.js/#divInt)
   */ idiv(that) {
        if (this.isNaN() || that.isNaN()) return _FixedPointNumber.NaN;
        if (this.isNegativeInfinite()) return that.isInfinite() ? _FixedPointNumber.NaN : that.isPositive() ? _FixedPointNumber.NEGATIVE_INFINITY : _FixedPointNumber.POSITIVE_INFINITY;
        if (this.isPositiveInfinite()) return that.isInfinite() ? _FixedPointNumber.NaN : that.isPositive() ? _FixedPointNumber.POSITIVE_INFINITY : _FixedPointNumber.NEGATIVE_INFINITY;
        if (that.isInfinite()) return _FixedPointNumber.ZERO;
        if (that.isZero()) return this.isZero() ? _FixedPointNumber.NaN : this.isNegative() ? _FixedPointNumber.NEGATIVE_INFINITY : _FixedPointNumber.POSITIVE_INFINITY;
        const fd = this.fd > that.fd ? this.fd : that.fd;
        return new _FixedPointNumber(fd, _FixedPointNumber.idiv(fd, this.dp(fd).sv, that.dp(fd).sv));
    }
    /**
   * Performs integer division on two big integers and scales the result by a factor of 10 raised to the power of fd.
   *
   * @param {bigint} fd - The power to which 10 is raised to scale the result.
   * @param {bigint} dividend - The number to be divided.
   * @param {bigint} divisor - The number by which dividend is divided.
   * @return {bigint} - The scaled result of the integer division.
   */ static idiv(fd, dividend, divisor) {
        return dividend / divisor * 10n ** fd;
    }
    /**
   * Returns `true `if the value of thisFPN is equal to the value of `that` FixedPointNumber, otherwise returns `false`.
   *
   * As with JavaScript, `NaN` does not equal `NaN`.
   *
   * @param {FixedPointNumber} that - The FixedPointNumber to compare against.
   * @return {boolean} `true` if the FixedPointNumber numbers are equal, otherwise `false`.
   *
   * @remarks This method uses {@link eq} internally.
   */ isEqual(that) {
        return this.eq(that);
    }
    /**
   * Returns `true` if the value of this FixedPointNumber is a finite number, otherwise returns `false`.
   *
   * The only possible non-finite values of a FixedPointNumber are {@link NaN}, {@link NEGATIVE_INFINITY} and {@link POSITIVE_INFINITY}.
   *
   * @return `true` if the value of this FixedPointNumber is a finite number, otherwise returns `false`.
   *
   * @see [bignumber.js isFinite](https://mikemcl.github.io/bignumber.js/#isF)
   */ isFinite() {
        return this.ef === 0;
    }
    /**
   * Return `true` if the value of this FixedPointNumber is {@link NEGATIVE_INFINITY} and {@link POSITIVE_INFINITY},
   * otherwise returns false.
   *
   * @return true` if the value of this FixedPointNumber is {@link NEGATIVE_INFINITY} and {@link POSITIVE_INFINITY},
   */ isInfinite() {
        return this.isNegativeInfinite() || this.isPositiveInfinite();
    }
    /**
   * Returns `true` if the value of this FixedPointNumber is an integer,
   * otherwise returns `false`.
   *
   * @return `true` if the value of this FixedPointNumber is an integer.
   *
   * @see [bignumber.js isInteger](https://mikemcl.github.io/bignumber.js/#isInt)
   */ isInteger() {
        if (this.isFinite()) return this.sv % 10n ** this.fd === 0n;
        return false;
    }
    /**
   * Checks if a given string expression is an integer in base 10 notation,
   * considering `-` for negative and `+` optional for positive values.
   *
   * @param {string} exp - The string expression to be tested.
   *
   * @return {boolean} `true` if the expression is an integer,
   * `false` otherwise.
   */ static isIntegerExpression(exp) {
        return this.REGEX_INTEGER.test(exp);
    }
    /**
   *  Returns `true` if the value of this FixedPointNumber is `NaN`, otherwise returns `false`.
   *
   *  @return `true` if the value of this FixedPointNumber is `NaN`, otherwise returns `false`.
   *
   *  @see [bignumber.js isNaN](https://mikemcl.github.io/bignumber.js/#isNaN)
   */ isNaN() {
        return Number.isNaN(this.ef);
    }
    /**
   * Checks if a given string expression is a natural (unsigned positive integer)
   * number in base 10 notation.
   *
   * @param {string} exp - The string expression to be tested.
   *
   * @return {boolean} `true` if the expression is a natural number,
   * `false` otherwise.
   */ static isNaturalExpression(exp) {
        return this.REGEX_NATURAL.test(exp);
    }
    /**
   * Returns `true` if the sign of this FixedPointNumber is negative, otherwise returns `false`.
   *
   * @return `true` if the sign of this FixedPointNumber is negative, otherwise returns `false`.
   *
   * @see [bignumber.js isNegative](https://mikemcl.github.io/bignumber.js/#isNeg)
   */ isNegative() {
        return this.isFinite() && this.sv < 0n || this.isNegativeInfinite();
    }
    /**
   * Returns `true` if this FixedPointNumber value is {@link NEGATIVE_INFINITY}, otherwise returns `false`.
   */ isNegativeInfinite() {
        return this.ef === Number.NEGATIVE_INFINITY;
    }
    /**
   * Checks if a given string expression is a number in base 10 notation,
   * considering `-` for negative and `+` optional for positive values.
   *
   * The method returns `true` for the following cases.
   * - Whole numbers:
   *   - Positive whole numbers, optionally signed: 1, +2, 3, ...
   *   - Negative whole numbers: -1, -2, -3, ...
   * - Decimal numbers:
   *   - Positive decimal numbers, optionally signed: 1.0, +2.5, 3.14, ...
   *   - Negative decimal numbers: -1.0, -2.5, -3.14, ...
   *   - Decimal numbers without whole part:
   *     - Positive decimal numbers, optionally signed: .1, +.5, .75, ...
   *     - Negative decimal numbers: -.1, -.5, -.75, ...
   *
   * @param exp - The string expression to be checked.
   *
   * @return `true` is `exp` represents a number, otherwise `false`.
   */ static isNumberExpression(exp) {
        return _FixedPointNumber.REGEX_NUMBER.test(exp);
    }
    /**
   * Returns `true` if the sign of this FixedPointNumber is positive, otherwise returns `false`.
   *
   * @return `true` if the sign of this FixedPointNumber is positive, otherwise returns `false`.
   *
   * @see [bignumber.js isPositive](https://mikemcl.github.io/bignumber.js/#isPos)
   */ isPositive() {
        return this.isFinite() && this.sv >= 0n || this.isPositiveInfinite();
    }
    /**
   * Returns `true` if this FixedPointNumber value is {@link POSITIVE_INFINITY}, otherwise returns `false`.
   *
   * @return `true` if this FixedPointNumber value is {@link POSITIVE_INFINITY}, otherwise returns `false`.
   */ isPositiveInfinite() {
        return this.ef === Number.POSITIVE_INFINITY;
    }
    /**
   * Returns `true` if the value of this FixedPointNumber is zero or minus zero, otherwise returns `false`.
   *
   * @return `true` if the value of this FixedPointNumber is zero or minus zero, otherwise returns `false`.
   *
   * [see bignumber.js isZero](https://mikemcl.github.io/bignumber.js/#isZ)
   */ isZero() {
        return this.isFinite() && this.sv === 0n;
    }
    /**
   * Returns `true` if the value of this FixedPointNumber is less than the value of `that` FixedPointNumber, otherwise returns `false`.
   *
   * @param {FixedPointNumber} that - The FixedPointNumber to compare against.
   *
   * @return {boolean} `true` if the value of this FixedPointNumber is less than the value of `that` FixedPointNumber, otherwise returns `false`.
   *
   * @remarks This method uses {@link comparedTo} internally.
   *
   * @see [bignumber.js isLessThan](https://mikemcl.github.io/bignumber.js/#lt)
   */ lt(that) {
        const cmp = this.comparedTo(that);
        return cmp !== null && cmp < 0;
    }
    /**
   * Returns `true` if the value of this FixedPointNumber is less than or equal to the value of `that` FixedPointNumber,
   * otherwise returns `false`.
   *
   * @param {FixedPointNumber} that - The FixedPointNumber to compare against.
   * @return {boolean} `true` if the value of this FixedPointNumber is less than or equal to the value of `that` FixedPointNumber,
   * otherwise returns `false`.
   *
   * @remarks This method uses {@link comparedTo} internally.
   *
   * @see [bignumber.js isLessThanOrEqualTo](https://mikemcl.github.io/bignumber.js/#lte)
   */ lte(that) {
        const cmp = this.comparedTo(that);
        return cmp !== null && cmp <= 0;
    }
    /**
   * Returns a FixedPointNumber whose value is the value of this FixedPointNumber minus `that` FixedPointNumber.
   *
   * Limit cases
   * * NaN - ±n = NaN
   * * ±n - NaN = NaN
   * * -Infinity - -Infinity = NaN
   * * -Infinity - +n = -Infinity
   * * +Infinity - +Infinity = NaN
   * * +Infinity - +n = +Infinity
   *
   * @param {FixedPointNumber} that - The fixed-point number to subtract.
   * @return {FixedPointNumber} The result of the subtraction. The return value is always exact and unrounded.
   *
   * @remarks The precision is the greater of the precision of the two operands.
   *
   * @see [bignumber.js minus](https://mikemcl.github.io/bignumber.js/#minus)
   */ minus(that) {
        if (this.isNaN() || that.isNaN()) return _FixedPointNumber.NaN;
        if (this.isNegativeInfinite()) return that.isNegativeInfinite() ? _FixedPointNumber.NaN : _FixedPointNumber.NEGATIVE_INFINITY;
        if (this.isPositiveInfinite()) return that.isPositiveInfinite() ? _FixedPointNumber.NaN : _FixedPointNumber.POSITIVE_INFINITY;
        const fd = this.fd > that.fd ? this.fd : that.fd;
        return new _FixedPointNumber(fd, this.dp(fd).sv - that.dp(fd).sv);
    }
    /**
   * Returns a FixedPointNumber whose value is the value of this FixedPointNumber modulo `that` FixedPointNumber,
   * i.e. the integer remainder of dividing this FixedPointNumber by `that`.
   *
   * Limit cases
   * * NaN % ±n = NaN
   * * ±n % NaN = NaN
   * * ±Infinity % n = NaN
   * * n % ±Infinity = NaN
   *
   * @param that {FixedPointNumber} - The fixed-point number to divide by.
   * @return {FixedPointNumber} the integer remainder of dividing this FixedPointNumber by `that`.
   *
   * @remarks The precision is the greater of the precision of the two operands.
   *
   * @see [bignumber.js modulo](https://mikemcl.github.io/bignumber.js/#mod)
   */ modulo(that) {
        if (this.isNaN() || that.isNaN()) return _FixedPointNumber.NaN;
        if (this.isInfinite() || that.isInfinite()) return _FixedPointNumber.NaN;
        if (that.isZero()) return _FixedPointNumber.NaN;
        const fd = this.fd > that.fd ? this.fd : that.fd;
        let modulo = this.abs().dp(fd).sv;
        const divisor = that.abs().dp(fd).sv;
        while(modulo >= divisor)modulo -= divisor;
        return new _FixedPointNumber(fd, modulo);
    }
    /**
   * Multiplies two big integer values and divides by a factor of ten raised to a specified power.
   *
   * @param {bigint} multiplicand - The first number to be multiplied.
   * @param {bigint} multiplicator - The second number to be multiplied.
   * @param {bigint} fd - The power of ten by which the product is to be divided.
   *
   * @return {bigint} The result of the multiplication divided by ten raised to the specified power.
   */ static mul(multiplicand, multiplicator, fd) {
        return multiplicand * multiplicator / 10n ** fd;
    }
    /**
   * Returns a new instance of FixedPointNumber whose value is the value of this FixedPointNumber value
   * negated, i.e. multiplied by -1.
   *
   * @see [bignumber.js negated](https://mikemcl.github.io/bignumber.js/#neg)
   */ negated() {
        if (this.isNegativeInfinite()) return _FixedPointNumber.POSITIVE_INFINITY;
        if (this.isPositiveInfinite()) return _FixedPointNumber.NEGATIVE_INFINITY;
        return new _FixedPointNumber(this.fd, -this.sv, this.ef);
    }
    /**
   * Constructs a new instance of FixedPointNumber (Fixed Point Number) parsing the
   * `exp` numeric expression in base 10 and representing the value with the
   * precision of `decimalPlaces` fractional decimal digits.
   *
   * @param {bigint|number|string} exp - The value to represent.
   * It can be a bigint, number, or string representation of the number.
   * @param {bigint} [decimalPlaces=this.DEFAULT_FRACTIONAL_DECIMALS] - The
   * number of fractional decimal digits to be used to represent the value.
   *
   * @return {FixedPointNumber} A new instance of FixedPointNumber with the given parameters.
   *
   * @throws {InvalidDataType} If `exp` is not a numeric expression.
   */ static of(exp, decimalPlaces = this.DEFAULT_FRACTIONAL_DECIMALS) {
        try {
            if (Number.isNaN(exp)) return new _FixedPointNumber(decimalPlaces, 0n, Number.NaN);
            if (exp === Number.NEGATIVE_INFINITY) return new _FixedPointNumber(decimalPlaces, -1n, Number.NEGATIVE_INFINITY);
            if (exp === Number.POSITIVE_INFINITY) return new _FixedPointNumber(decimalPlaces, 1n, Number.POSITIVE_INFINITY);
            return new _FixedPointNumber(decimalPlaces, this.txtToSV(exp.toString(), decimalPlaces));
        } catch (e) {
            throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("FixedPointNumber.of", "not a number", {
                exp: exp
            }, e);
        }
    }
    /**
   * Returns a FixedPointNumber whose value is the value of this FixedPointNumber plus `that` FixedPointNumber.
   *
   * Limit cases
   * * NaN + ±n = NaN
   * * ±n + NaN = NaN
   * * -Infinity + -Infinity = -Infinity
   * * -Infinity + +Infinity = NaN
   * * +Infinity + -Infinity = NaN
   * * +Infinity + +Infinity = +Infinity
   *
   * @param {FixedPointNumber} that - The fixed-point number to add to the current number.
   * @return {FixedPointNumber} The result of the addition. The return value is always exact and unrounded.
   *
   * @remarks The precision is the greater of the precision of the two operands.
   *
   * @see [bignumber.js plus](https://mikemcl.github.io/bignumber.js/#plus)
   */ plus(that) {
        if (this.isNaN() || that.isNaN()) return _FixedPointNumber.NaN;
        if (this.isNegativeInfinite()) return that.isPositiveInfinite() ? _FixedPointNumber.NaN : _FixedPointNumber.NEGATIVE_INFINITY;
        if (this.isPositiveInfinite()) return that.isNegativeInfinite() ? _FixedPointNumber.NaN : _FixedPointNumber.POSITIVE_INFINITY;
        const fd = this.fd > that.fd ? this.fd : that.fd;
        return new _FixedPointNumber(fd, this.dp(fd).sv + that.dp(fd).sv);
    }
    /**
   * Returns a FixedPointNumber whose value is the value of this FixedPointNumber raised to the power of `that` FixedPointNumber.
   *
   * Limit cases
   * * NaN ^ e = NaN
   * * b ^ NaN = NaN
   * * b ^ -Infinite = 0
   * * b ^ 0 = 1
   * * b ^ +Infinite = +Infinite
   * * ±Infinite ^ -e = 0
   * * ±Infinite ^ +e = +Infinite
   *
   * @param {FixedPointNumber} that - The exponent as a fixed-point number.
   * It can be negative, it can be not an integer value
   * ([bignumber.js pow](https://mikemcl.github.io/bignumber.js/#pow)
   * doesn't support not integer exponents).
   * @return {FixedPointNumber} - The result of raising this fixed-point number to the power of the given exponent.
   *
   * @remarks The precision is the greater of the precision of the two operands.
   * @remarks In fixed-precision math, the comparisons between powers of operands having different fractional
   * precision can lead to differences.
   *
   * @see [bignumber.js exponentiatedBy](https://mikemcl.github.io/bignumber.js/#pow)
   */ pow(that) {
        if (this.isNaN() || that.isNaN()) return _FixedPointNumber.NaN;
        if (this.isInfinite()) return that.isZero() ? _FixedPointNumber.of(1) : that.isNegative() ? _FixedPointNumber.ZERO : _FixedPointNumber.POSITIVE_INFINITY;
        if (that.isNegativeInfinite()) return _FixedPointNumber.ZERO;
        if (that.isPositiveInfinite()) return _FixedPointNumber.POSITIVE_INFINITY;
        const fd = this.fd > that.fd ? this.fd : that.fd;
        return new _FixedPointNumber(fd, _FixedPointNumber.pow(fd, this.dp(fd).sv, that.dp(fd).sv));
    }
    /**
   * Computes the power of a given base raised to a specified exponent.
   *
   * @param {bigint} fd - The scale factor for decimal precision.
   * @param {bigint} base - The base number to be raised to the power.
   * @param {bigint} exponent - The exponent to which the base should be raised.
   * @return {bigint} The result of base raised to the power of exponent, scaled by the scale factor.
   */ static pow(fd, base, exponent) {
        const sf = 10n ** fd;
        if (exponent < 0n) return _FixedPointNumber.pow(fd, _FixedPointNumber.div(fd, sf, base), -exponent);
        if (exponent === 0n) return 1n * sf;
        if (exponent === sf) return base;
        return _FixedPointNumber.pow(fd, this.mul(base, base, fd), exponent - sf);
    }
    /**
   * Computes the square root of a given positive bigint value using a fixed-point iteration method.
   *
   * @param {bigint} value - The positive bigint value for which the square root is to be calculated.
   * @param {bigint} fd - The iteration factor determinant.
   * @return {bigint} The calculated square root of the input bigint value.
   *
   * @throws {RangeError} If the input value is negative.
   */ static sqr(value, fd) {
        if (value < 0n) throw new RangeError(`Value must be positive`);
        const sf = fd * 10n;
        let iteration = 0;
        let actualResult = value;
        let storedResult = 0n;
        while(actualResult !== storedResult && iteration < sf){
            storedResult = actualResult;
            actualResult = (actualResult + _FixedPointNumber.div(fd, value, actualResult)) / 2n;
            iteration++;
        }
        return actualResult;
    }
    /**
   * Returns a FixedPointNumber whose value is the square root of the value of this FixedPointNumber
   *
   * Limit cases
   * * NaN = NaN
   * * +Infinite = +Infinite
   * * -n = NaN
   *
   * @return {FixedPointNumber} The square root of the number.
   *
   * @see [bignumber.js sqrt](https://mikemcl.github.io/bignumber.js/#sqrt)
   */ sqrt() {
        if (this.isNaN()) return _FixedPointNumber.NaN;
        if (this.isNegativeInfinite()) return _FixedPointNumber.NaN;
        if (this.isPositiveInfinite()) return _FixedPointNumber.POSITIVE_INFINITY;
        try {
            return new _FixedPointNumber(this.fd, _FixedPointNumber.sqr(this.sv, this.fd));
        } catch (e) {
            return _FixedPointNumber.NaN;
        }
    }
    /**
   * Returns a FixedPointNumber whose value is the value of this FixedPointNumber multiplied by `that` FixedPointNumber.
   *
   * Limits cases
   * * NaN * n = NaN
   * * n * NaN = NaN
   * * -Infinite * -n = +Infinite
   * * -Infinite * +n = -Infinite
   * * +Infinite * -n = -Infinite
   * * +Infinite * +n = +Infinite
   *
   * @param {FixedPointNumber} that - The fixed-point number to multiply with this number.
   * @return {FixedPointNumber} a FixedPointNumber whose value is the value of this FixedPointNumber multiplied by `that` FixedPointNumber.
   *
   * @remarks The precision is the greater of the precision of the two operands.
   *
   * @see [bignumber.js multipliedBy](https://mikemcl.github.io/bignumber.js/#times)
   */ times(that) {
        if (this.isNaN() || that.isNaN()) return _FixedPointNumber.NaN;
        if (this.isNegativeInfinite()) return that.isNegative() ? _FixedPointNumber.POSITIVE_INFINITY : _FixedPointNumber.NEGATIVE_INFINITY;
        if (this.isPositiveInfinite()) return that.isNegative() ? _FixedPointNumber.NEGATIVE_INFINITY : _FixedPointNumber.POSITIVE_INFINITY;
        const fd = this.fd > that.fd ? this.fd : that.fd;
        return new _FixedPointNumber(fd, _FixedPointNumber.mul(this.dp(fd).sv, that.dp(fd).sv, fd));
    }
    /**
   * Converts the fixed-point number to its string representation.
   *
   * @param {string} [decimalSeparator='.'] - The character to use as the decimal separator in the string representation. Default is '.'.
   * @return {string} A string representation of the fixed-point number.
   */ toString(decimalSeparator = ".") {
        if (this.ef === 0) {
            const sign = this.sv < 0n ? "-" : "";
            const digits = this.sv < 0n ? (-this.sv).toString() : this.sv.toString();
            const padded = digits.padStart(Number(this.fd), "0");
            const decimals = this.fd > 0 ? padded.slice(Number(-this.fd)) : "";
            const integers = padded.slice(0, padded.length - decimals.length);
            const integersShow = integers.length < 1 ? "0" : integers;
            const decimalsShow = _FixedPointNumber.trimEnd(decimals);
            return sign + integersShow + (decimalsShow.length > 0 ? decimalSeparator + decimalsShow : "");
        }
        return this.ef.toString();
    }
    /**
   * Trims the specified trailing substring from the end of the input string recursively.
   *
   * @param {string} str - The input string to be trimmed.
   * @param {string} [sub='0'] - The substring to be removed from the end of the input string. Defaults to '0' if not provided.
   * @return {string} The trimmed string with the specified trailing substring removed.
   */ static trimEnd(str, sub = "0") {
        if (str.endsWith(sub)) return _FixedPointNumber.trimEnd(str.substring(0, str.length - sub.length), sub);
        return str;
    }
    /**
   * Converts a string expression of a number into a scaled value.
   *
   * @param {string} exp - The string expression of the number to be converted.
   * @param {bigint} fd - The scale factor to be used for conversion.
   * @param {string} [decimalSeparator='.'] - The character used as the decimal separator in the string expression.
   * @return {bigint} - The converted scaled value as a bigint.
   */ static txtToSV(exp, fd, decimalSeparator = ".") {
        const fc = exp.charAt(0);
        let sign = 1n;
        if (fc === "-") {
            sign = -1n;
            exp = exp.substring(1);
        } else if (fc === "+") exp = exp.substring(1);
        const sf = 10n ** fd;
        const di = exp.lastIndexOf(decimalSeparator);
        if (di < 0) return sign * sf * BigInt(exp);
        const ie = exp.substring(0, di);
        const fe = exp.substring(di + 1);
        return sign * sf * BigInt(ie) + // Integer part
        sign * (sf * BigInt(fe)) / BigInt(10 ** fe.length);
    }
};
var $564ad8f2c6689928$export$3b58ea8124ac5e28 = class _Sha256 extends $564ad8f2c6689928$export$7c2a2de09ea3c4f2 {
    /**
   * Generates the [SHA 256](https://en.wikipedia.org/wiki/SHA-2) hash of the given input.
   *
   * @param {bigint | number | string | Uint8Array | Hex} exp - The input value to hash.
   *
   * @returns {Sha256} - The [SHA256](https://en.wikipedia.org/wiki/SHA-2) hash of the input value.
   *
   * @throws {InvalidOperation} - If a hash error occurs.
   *
   * @remarks Security auditable method, depends on
   * * [`nh_sha256.sha256`](https://github.com/paulmillr/noble-hashes#sha2-sha256-sha384-sha512-and-others).
   */ static of(exp) {
        try {
            const hash2 = $510ad3657d73a9d2$exports.sha256($564ad8f2c6689928$export$7c2a2de09ea3c4f2.of(exp).bytes);
            return new _Sha256($564ad8f2c6689928$export$9ccf03a0aa23a1ca.POSITIVE, $564ad8f2c6689928$export$7c2a2de09ea3c4f2.of(hash2).digits);
        } catch (e) {
            throw new (0, $dbc5c4a080b2aff5$export$8df2d8bae05b1dae)("Sha256.of", "hash error", {
                exp: `${exp}`,
                e: // Needed to serialize bigint values.
                e
            });
        }
    }
};
function $564ad8f2c6689928$export$bced8d2aada2d1c9(data, returnType = "buffer") {
    return returnType === "buffer" ? $564ad8f2c6689928$export$3b58ea8124ac5e28.of($564ad8f2c6689928$export$1d5cbbbdccc512f9.of(data).bytes).bytes : $564ad8f2c6689928$export$3b58ea8124ac5e28.of($564ad8f2c6689928$export$1d5cbbbdccc512f9.of(data).bytes).toString();
}
var $564ad8f2c6689928$export$4807b1fbad07ca78 = class _Secp256k1 {
    /**
   * This value is used to identify compressed public key.
   */ static COMPRESSED_PREFIX = 2;
    /**
   * Represents the fixed length of the cryptographic signature.
   * The value is set to 65, which is the size in bytes
   * required for a 520-bit signature.
   *
   * @constant {number} SIGNATURE_LENGTH
   */ static SIGNATURE_LENGTH = 65;
    /**
   * This value is used to identify uncompressed public key.
   */ static UNCOMPRESS_PREFIX = 4;
    /**
   * Defines the required length for a valid hash.
   */ static VALID_HASH_LENGTH = 32;
    /**
   * Compresses an uncompressed public key.
   *
   * @param {Uint8Array} publicKey - The uncompressed public key to be compressed.
   * @return {Uint8Array} - The compressed public key.
   *
   * @see Secp256k1.inflatePublicKey
   */ static compressPublicKey(publicKey) {
        const prefix = publicKey.at(0);
        if (prefix === _Secp256k1.UNCOMPRESS_PREFIX) {
            const x = publicKey.slice(1, 33);
            const y = publicKey.slice(33, 65);
            const isYOdd = y[y.length - 1] & 1;
            return $esaJO.concatBytes(Uint8Array.of(_Secp256k1.COMPRESSED_PREFIX + isYOdd), x);
        } else return publicKey;
    }
    /**
   * Derives the public key from a given private key.
   *
   * @param {Uint8Array} privateKey - The private key in Uint8Array format. Must be a valid 32-byte secp256k1 private key.
   * @param {boolean} [isCompressed=true] - Indicates whether the derived public key should be in compressed format.
   * @return {Uint8Array} The derived public key in Uint8Array format.
   * @throws {InvalidSecp256k1PrivateKey} Throws an error if the provided private key is not valid.
   *
   * @remarks Security auditable method, depends on
   * * [nc_secp256k1.getPublicKey](https://github.com/paulmillr/noble-secp256k1).
   */ static derivePublicKey(privateKey, isCompressed = true) {
        if (_Secp256k1.isValidPrivateKey(privateKey)) return (0, $3f551179096121b9$exports.secp256k1).getPublicKey(privateKey, isCompressed);
        throw new (0, $dbc5c4a080b2aff5$export$b154d91e70ffbd5)("Secp256k1.derivePublicKey", "Invalid private key given as input. Ensure it is a valid 32-byte secp256k1 private key.", void 0);
    }
    /**
   * Generates a new random private key.
   * If an error occurs during generation using
   * [nc_secp256k1](https://github.com/paulmillr/noble-secp256k1),
   * an AES-GCM key is generated as a fallback in runtimes not supported
   * by `nc_secp256k1`, if those support {@link {@link global.crypto}.
   *
   * @return {Promise<Uint8Array>} The generated private key as a Uint8Array.
   *
   * @remarks Security auditable method, depends on
   * * {@link global.crypto.subtle.exportKey};
   * * {@link global.crypto.subtle.generateKey};
   * * [nc_secp256k1.utils.randomPrivateKey](https://github.com/paulmillr/noble-secp256k1).
   */ static async generatePrivateKey() {
        try {
            return (0, $3f551179096121b9$exports.secp256k1).utils.randomPrivateKey();
        } catch (e) {
            const cryptoKey = await $parcel$global.crypto.subtle.generateKey({
                name: "AES-GCM",
                length: 256
            }, true, [
                "encrypt",
                "decrypt"
            ]);
            const rawKey = await $parcel$global.crypto.subtle.exportKey("raw", cryptoKey);
            return new Uint8Array(rawKey);
        }
    }
    /**
   * Inflate a compressed public key to its uncompressed form.
   *
   * @param {Uint8Array} publicKey - The compressed public key to be inflated.
   * @return {Uint8Array} - The uncompressed public key.
   *
   * @remarks Security auditable method, depends on
   * * [nc_secp256k1.ProjectivePoint.fromAffine](https://github.com/paulmillr/noble-secp256k1);
   * * [nc_secp256k1.ProjectivePoint.fromHex](https://github.com/paulmillr/noble-secp256k1);
   * * [nc_secp256k1.ProjectivePoint.toAffine](https://github.com/paulmillr/noble-secp256k1).
   *
   * @see Secp256K1.compressPublicKey
   */ static inflatePublicKey(publicKey) {
        const prefix = publicKey.at(0);
        if (prefix !== _Secp256k1.UNCOMPRESS_PREFIX) {
            const x = publicKey.slice(0, 33);
            const p = (0, $3f551179096121b9$exports.secp256k1).ProjectivePoint.fromAffine((0, $3f551179096121b9$exports.secp256k1).ProjectivePoint.fromHex($564ad8f2c6689928$export$7c2a2de09ea3c4f2.of(x).digits).toAffine());
            return p.toRawBytes(false);
        } else return publicKey;
    }
    /**
   * Checks whether the provided hash is a valid message hash.
   *
   * @param {Uint8Array} hash - The hash to be validated.
   * @return {boolean} `true` if the hash is 32 bytes long, otherwise `false`.
   */ static isValidMessageHash(hash2) {
        return hash2.length === _Secp256k1.VALID_HASH_LENGTH;
    }
    /**
   * Checks if the provided private key is valid.
   *
   * @param {Uint8Array} privateKey - The private key to validate.
   * @return {boolean} `true` if the private key is valid, `false` otherwise.
   *
   * @remarks Security auditable method, depends on
   * * [nc_secp256k1.utils.isValidPrivateKey](https://github.com/paulmillr/noble-secp256k1).
   */ static isValidPrivateKey(privateKey) {
        return (0, $3f551179096121b9$exports.secp256k1).utils.isValidPrivateKey(privateKey);
    }
    /**
   * Generates a random sequence of bytes.
   * If an error occurs during generation using
   * [nc_secp256k1](https://github.com/paulmillr/noble-secp256k1),
   * {@link {@link global.crypto} is used as fall back togenerate
   * the random sequence.
   *
   * @param {number} [bytesLength=32] - Optional. The number of random bytes to generate.
   * @return {Uint8Array} - A Uint8Array containing the random bytes.
   *
   * @remarks Security auditable method, depends on
   *  * {@link global.crypto.getRandomValues};
   * * [nh_randomBytes](https://github.com/paulmillr/noble-hashes).
   */ static randomBytes(bytesLength) {
        try {
            return (0, $29ee4d3171d9809b$exports.randomBytes)(bytesLength);
        } catch (e) {
            return $parcel$global.crypto.getRandomValues(new Uint8Array(bytesLength ?? 32));
        }
    }
    /**
   * Recovers the public key associated with the message hash from the given signature.
   *
   * @param {Uint8Array} messageHash - The 32-byte message hash to be verified.
   * @param {Uint8Array} sig - The 65-byte signature used for recovery, consisting of the compact signature and recovery byte.
   * @return {Uint8Array} The recovered public key in its raw bytes form.
   * @throws {InvalidSecp256k1MessageHash} If the provided message hash is invalid.
   * @throws {InvalidSecp256k1Signature} If the provided signature is not 65 bytes or contains an invalid recovery value.
   *
   * @remarks Security auditable method, depends on
   * * [nc_secp256k1.Signature](https://github.com/paulmillr/noble-secp256k1).
   *
   * @see Secp256k1.isValidMessageHash
   */ static recover(messageHash, sig) {
        if (!_Secp256k1.isValidMessageHash(messageHash)) throw new (0, $dbc5c4a080b2aff5$export$6971695315864e63)("Secp256k1.recover", "Invalid message hash given as input. Ensure it is a valid 32-byte message hash.", {
            messageHash: messageHash
        });
        if (sig.length !== _Secp256k1.SIGNATURE_LENGTH) throw new (0, $dbc5c4a080b2aff5$export$58f1681432c844df)("Secp256k1.recover", "Invalid signature given as input. Length must be exactly 65 bytes.", {
            signature: sig
        });
        const recovery = sig[64];
        if (recovery !== 0 && recovery !== 1) throw new (0, $dbc5c4a080b2aff5$export$58f1681432c844df)("Secp256k1.recover", "Invalid signature recovery value. Signature bytes at position 64 must be 0 or 1.", {
            signature: sig,
            recovery: recovery
        });
        return (0, $3f551179096121b9$exports.secp256k1).Signature.fromCompact(sig.slice(0, 64)).addRecoveryBit(recovery).recoverPublicKey(messageHash).toRawBytes(false);
    }
    /**
   * Signs a given message hash using the provided private key.
   *
   * @param messageHash - A 32-byte message hash that needs to be signed.
   * @param privateKey - A 32-byte private key used for signing the message hash.
   * @return The signature of the message hash consisting of the r, s, and recovery values.
   * @throws InvalidSecp256k1MessageHash if the message hash is not a valid 32-byte hash.
   * @throws InvalidSecp256k1PrivateKey if the private key is not a valid 32-byte private key.
   *
   * @remarks Security auditable method, depends on
   * * [nc_secp256k1.sign](https://github.com/paulmillr/noble-secp256k1).
   *
   * @see Secp256k1.isValidMessageHash
   * @see Secp256k1.isValidPrivateKey
   */ static sign(messageHash, privateKey) {
        if (!_Secp256k1.isValidMessageHash(messageHash)) throw new (0, $dbc5c4a080b2aff5$export$6971695315864e63)("Secp256k1.sign", "Invalid message hash given as input. Ensure it is a valid 32-byte message hash.", {
            messageHash: messageHash
        });
        if (!_Secp256k1.isValidPrivateKey(privateKey)) throw new (0, $dbc5c4a080b2aff5$export$b154d91e70ffbd5)("Secp256k1.sign", "Invalid private key given as input. Ensure it is a valid 32-byte secp256k1 private key.", void 0);
        const sig = (0, $3f551179096121b9$exports.secp256k1).sign(messageHash, privateKey);
        return $esaJO.concatBytes($esaJO.numberToBytesBE(sig.r, 32), $esaJO.numberToBytesBE(sig.s, 32), $esaJO.numberToVarBytesBE(sig.recovery));
    }
};
var $564ad8f2c6689928$export$bb670963070b393a = class extends $c1c39050bd418416$export$bb670963070b393a {
    /**
   * Prefix for extended private key
   */ static EXTENDED_PRIVATE_KEY_PREFIX = $564ad8f2c6689928$export$7c2a2de09ea3c4f2.of("0488ade4000000000000000000").bytes;
    /**
   * Prefix for extended public key
   */ static EXTENDED_PUBLIC_KEY_PREFIX = $564ad8f2c6689928$export$7c2a2de09ea3c4f2.of("0488b21e000000000000000000").bytes;
    /**
   * Default VET derivation path.
   *
   * See
   * [SLIP-0044 : Registered coin types for BIP-0044](https://github.com/satoshilabs/slips/blob/master/slip-0044.md)
   * for more info.
   */ static VET_DERIVATION_PATH = "m/44'/818'/0'/0";
    /**
   * Creates a
   * [BIP32 Hierarchical Deterministic Key](https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki)
   * from
   * [BIP39 Mnemonic Words](https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki)
   * and the given derivation path.
   *
   * @param {string[]} words - An array of words representing the mnemonic.
   * @param {string} path - The derivation path to derive the child node.
   * Default value is {@link VET_DERIVATION_PATH}.
   *
   * @return The derived child hierarchical deterministic key.
   *
   * @throws {InvalidHDKey} If `path` is not valid to derive a node wallet.
   * @throws {InvalidHDKeyMnemonic} If `words` is an invalid array mnemonic.
   *
   * @remarks Security auditable method, depends on
   * * [s_bip32.HDKey.derive](https://github.com/paulmillr/scure-bip32);
   * * [s_bip32.HDKey.fromMasterSeed](https://github.com/paulmillr/scure-bip32);
   * * [s_bip39.mnemonicToSeedSync](https://github.com/paulmillr/scure-bip39).
   */ static fromMnemonic(words, path = this.VET_DERIVATION_PATH) {
        let master;
        try {
            master = $c1c39050bd418416$export$bb670963070b393a.fromMasterSeed($836cf4f0e2c80e2c$exports.mnemonicToSeedSync(words.join(" ").toLowerCase()));
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$46042050702202eb)("HDNode.fromMnemonic", "Invalid mnemonic words given as input.", void 0, error);
        }
        try {
            return master.derive(path);
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$b2ab323886c7b7a5)("HDNode.fromMnemonic", "Invalid derivation path given as input.", {
                derivationPath: path
            }, error);
        }
    }
    /**
   * Creates a
   * [BIP32 Hierarchical Deterministic Key](https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki)
   * from a private key and chain code.
   *
   * @param {Uint8Array} - privateKey The private key.
   * @param {Uint8Array} - chainCode The chain code.
   *
   * @returns Returns the hierarchical deterministic key from `privateKey` and `chainCode`.
   *
   * @throws {InvalidSecp256k1PrivateKey} If the `privateKey` is invalid.
   *
   * @remarks **This method wipes `privateKey`** for security reasons.
   * @remarks Security auditable method, depends on
   * * [base58.encode](https://github.com/paulmillr/scure-base);
   * * {@link Sha256};
   * * [s_bip32.HDKey.fromExtendedKey](https://github.com/paulmillr/scure-bip32).
   */ static fromPrivateKey(privateKey, chainCode) {
        if (privateKey.length === 32) {
            const header = $esaJO.concatBytes(this.EXTENDED_PRIVATE_KEY_PREFIX, chainCode, Uint8Array.of(0), privateKey);
            privateKey.fill(0);
            const checksum = $564ad8f2c6689928$export$3b58ea8124ac5e28.of($564ad8f2c6689928$export$3b58ea8124ac5e28.of(header).bytes).bytes.subarray(0, 4);
            const expandedPrivateKey = $esaJO.concatBytes(header, checksum);
            try {
                return $c1c39050bd418416$export$bb670963070b393a.fromExtendedKey((0, $3600b4829dff8fa9$export$61f53211c069eefb).encode(expandedPrivateKey));
            } catch (e) {
                throw new (0, $dbc5c4a080b2aff5$export$b154d91e70ffbd5)("HDNode.fromPrivateKey", "Invalid private key path given as input.", void 0);
            }
        }
        privateKey.fill(0);
        throw new (0, $dbc5c4a080b2aff5$export$b154d91e70ffbd5)("HDNode.fromPrivateKey()", "Invalid private key path given as input. Length must be exactly 32 bytes.", void 0);
    }
    /**
   * Creates a
   * [BIP32 Hierarchical Deterministic Key](https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki)
   * key from a public key and chain code.
   *
   * @param {Uint8Array} publicKey - The public key bytes.
   * @param {Uint8Array} chainCode - The chain code bytes.
   *
   * @returns {HDKey} Returns the hierarchical deterministic key from `public` and `chainCode`.
   *
   * @throws {InvalidHDKey} if the `publicKey` is invalid.
   *
   * @remarks Security auditable method, depends on
   * * [base58.encode](https://github.com/paulmillr/scure-base);
   * * {@link Secp256k1.compressPublicKey};
   * * {@link Sha256};
   * * [HDKey.fromExtendedKey](https://github.com/paulmillr/scure-bip32).
   */ static fromPublicKey(publicKey, chainCode) {
        if (chainCode.length === 32) {
            const header = $esaJO.concatBytes(this.EXTENDED_PUBLIC_KEY_PREFIX, chainCode, $564ad8f2c6689928$export$4807b1fbad07ca78.compressPublicKey(publicKey));
            const checksum = $564ad8f2c6689928$export$3b58ea8124ac5e28.of($564ad8f2c6689928$export$3b58ea8124ac5e28.of(header).bytes).bytes.subarray(0, 4);
            const expandedPublicKey = $esaJO.concatBytes(header, checksum);
            try {
                return $c1c39050bd418416$export$bb670963070b393a.fromExtendedKey((0, $3600b4829dff8fa9$export$61f53211c069eefb).encode(expandedPublicKey));
            } catch (error) {
                throw new (0, $dbc5c4a080b2aff5$export$b2ab323886c7b7a5)("HDNode.fromPublicKey()", "Invalid public key path given as input.", {
                    publicKey: publicKey
                }, error);
            }
        }
        throw new (0, $dbc5c4a080b2aff5$export$b2ab323886c7b7a5)("HDNode.fromPublicKey()", "Invalid chain code given as input. Length must be exactly 32 bytes.", {
            chainCode: chainCode
        });
    }
    /**
   * Checks if derivation path single component is valid
   *
   * @param component - Derivation path single component to check
   * @param index - Derivation path single component index
   *
   * @returns `true`` if derivation path single component is valid, otherwise `false`.
   *
   */ static isDerivationPathComponentValid(component, index) {
        return(// m
        (index === 0 ? component === "m" : false) || // "number"
        $564ad8f2c6689928$export$3dede3b6cc153eb5.isNaturalExpression(component) || // "number'"
        $564ad8f2c6689928$export$3dede3b6cc153eb5.isNaturalExpression(component.slice(0, -1)) && component.endsWith("'"));
    }
    /**
   * Checks if derivation path is valid.
   *
   * @param derivationPath - Derivation path to check.
   *
   * @returns `true` if derivation path is valid, otherwise `false`.
   */ static isDerivationPathValid(derivationPath) {
        const pathComponents = derivationPath.split("/");
        for(let i = 0; i < pathComponents.length; i++){
            if (!this.isDerivationPathComponentValid(pathComponents[i], i)) return false;
        }
        return true;
    }
};
var $564ad8f2c6689928$export$73974d1f547d9d48 = class _Address extends $564ad8f2c6689928$export$7c2a2de09ea3c4f2 {
    /**
   * It checksums a given hexadecimal address.
   *
   * @param {HexUInt} huint - The HexUInt object representing the hexadecimal value.
   *
   * @returns {string} The checksummed address.
   */ static checksum(huint) {
        const stringAddress = huint.digits;
        const hash2 = $564ad8f2c6689928$export$83afadb7dd1667bc.of($564ad8f2c6689928$export$1d5cbbbdccc512f9.of(stringAddress).bytes).digits;
        let checksum = "";
        for(let i = 0; i < stringAddress.length; i++)checksum += parseInt(hash2[i], 16) > 7 ? stringAddress[i].toUpperCase() : stringAddress[i];
        return "0x" + checksum;
    }
    /**
   * Validate the given expression to be a valid address.
   *
   *  @param {string} exp - Expression to validate
   *
   * @returns {boolean} true if the expression is a valid address, false otherwise
   */ static isValid(exp) {
        return $564ad8f2c6689928$export$9ccf03a0aa23a1ca.isValid0x(exp) && exp.length === 42;
    }
    /**
   * Create ab Address instance from the given expression interpreted as an unsigned integer.
   *
   * @param exp - The expression to convert. It can be of type bigint, number, string, Uint8Array, or HexUInt.
   *
   * @returns {Address} The converted hexadecimal unsigned integer.
   *
   * @throws {InvalidDataType} If the expression is not a valid hexadecimal positive integer expression.
   */ static of(exp) {
        try {
            const huint = $564ad8f2c6689928$export$7c2a2de09ea3c4f2.of(exp);
            if (_Address.isValid(huint.toString())) {
                const addressChecksummed = _Address.checksum(huint);
                return new _Address($564ad8f2c6689928$export$9ccf03a0aa23a1ca.POSITIVE, "0x0", // When we normalize we return the checksummed address as digits
                ()=>addressChecksummed.substring(2));
            } else throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Address.of", "not a valid address", {
                huint: huint
            });
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Address.of", "not a valid hexadecimal positive integer expression", {
                exp: `${exp}`
            }, error);
        }
    }
    /**
   * Create an Address instance from the given private key.
   *
   * @param {Uint8Array} privateKey - The private key to convert.
   *
   * @param {boolean} [isCompressed=true] - The flag to indicate if the derived public key should be compressed.
   *
   * @returns {Address} The converted address.
   *
   * @remarks Security auditable method, depends on
   * * {@link Secp256k1.derivePublicKey}.
   */ static ofPrivateKey(privateKey, isCompressed = true) {
        try {
            return _Address.ofPublicKey($564ad8f2c6689928$export$4807b1fbad07ca78.derivePublicKey(privateKey, isCompressed));
        } catch (error) {
            if (error instanceof (0, $dbc5c4a080b2aff5$export$b154d91e70ffbd5)) throw error;
            throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Address.ofPrivateKey", "not a valid private key", {
                privateKey: `${privateKey}`
            }, error);
        }
    }
    /**
   * Create an Address instance from the given public key.
   *
   * @param {Uint8Array} publicKey - The public key to convert.
   *
   * @returns {Address} The converted address.
   *
   * @remarks Security auditable method, depends on
   * * {@link Secp256k1.inflatePublicKey}.
   */ static ofPublicKey(publicKey) {
        try {
            const publicKeyInflated = $564ad8f2c6689928$export$4807b1fbad07ca78.inflatePublicKey(publicKey);
            const publicKeyHash = $564ad8f2c6689928$export$83afadb7dd1667bc.of(publicKeyInflated.slice(1)).bytes;
            return _Address.of(publicKeyHash.slice(12));
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Address.ofPublicKey", "not a valid public key", {
                publicKey: `${publicKey}`
            }, error);
        }
    }
    /**
   * Derives the address from a given list of words of
   * [BIP39 Mnemonic Words](https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki)
   * and a [BIP44 Derivation Path](https://github.com/satoshilabs/slips/blob/master/slip-0044.md)
   * as in the examples.
   *
   * Secure audit function.
   * - {@link bip32.HDKey}(https://github.com/paulmillr/scure-bip32)
   * - {@link HDKey}
   *
   * @example `m/0` (default)
   * @example `m/0/2`
   * @example `m/0/2/4/6`
   *
   * @param {string[]} mnemonic - Mnemonic used to generate the HD node.
   * @param {string} [path='m/0'] - The derivation path from the current node.
   * @return {Address} - The derived address.
   * @throws {InvalidHDKey}
   *
   */ static ofMnemonic(mnemonic2, path = "m/0") {
        const root = $564ad8f2c6689928$export$bb670963070b393a.fromMnemonic(mnemonic2);
        try {
            return _Address.ofPublicKey(root.derive(path).publicKey);
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$b2ab323886c7b7a5)("mnemonic.deriveAddress()", "Invalid derivation path given as input.", {
                derivationPath: path
            }, error);
        }
    }
};
var $564ad8f2c6689928$export$678e08479eeb6ed8 = {
    fromPrivateKey: (privateKey)=>$564ad8f2c6689928$export$73974d1f547d9d48.ofPrivateKey(privateKey).toString(),
    fromPublicKey: (publicKey)=>$564ad8f2c6689928$export$73974d1f547d9d48.ofPublicKey(publicKey).toString(),
    isAddress: (addressToVerify)=>$564ad8f2c6689928$export$73974d1f547d9d48.isValid(addressToVerify),
    toERC55Checksum: (address)=>$564ad8f2c6689928$export$73974d1f547d9d48.checksum($564ad8f2c6689928$export$7c2a2de09ea3c4f2.of(address)).toString()
};
var $564ad8f2c6689928$export$d2458fb5f52b75a6 = class _Blake2b256 extends $564ad8f2c6689928$export$7c2a2de09ea3c4f2 {
    /**
   * Generates the [BLAKE](https://en.wikipedia.org/wiki/BLAKE_(hash_function)) [BLAKE2B 256](https://www.blake2.net/) hash of the given input.
   *
   * @param {bigint | number | string | Uint8Array | Hex} exp - The input value to hash.
   *
   * @returns {Sha256} - The [BLAKE2B 256](https://www.blake2.net/) hash of the input value.
   *
   * @throws {InvalidOperation} - If a hash error occurs.
   *
   * @remarks Security auditable method, depends on
   * * [`nh_blake2b.create(...).update(...).digest(...)`](https://github.com/paulmillr/noble-hashes#sha3-fips-shake-keccak).
   */ static of(exp) {
        try {
            const hash2 = (0, $13c18d22617e7179$exports.blake2b).create({
                dkLen: 32
            }).update($564ad8f2c6689928$export$7c2a2de09ea3c4f2.of(exp).bytes).digest();
            return new _Blake2b256($564ad8f2c6689928$export$9ccf03a0aa23a1ca.POSITIVE, $564ad8f2c6689928$export$7c2a2de09ea3c4f2.of(hash2).digits);
        } catch (e) {
            throw new (0, $dbc5c4a080b2aff5$export$8df2d8bae05b1dae)("Blake2b256.of", "hash error", {
                exp: `${exp}`,
                e: // Needed to serialize bigint values.
                e
            });
        }
    }
};
function $564ad8f2c6689928$export$a00142b13614340a(data, returnType = "buffer") {
    return returnType === "buffer" ? $564ad8f2c6689928$export$d2458fb5f52b75a6.of($564ad8f2c6689928$export$1d5cbbbdccc512f9.of(data).bytes).bytes : $564ad8f2c6689928$export$d2458fb5f52b75a6.of($564ad8f2c6689928$export$1d5cbbbdccc512f9.of(data).bytes).toString();
}
var $564ad8f2c6689928$export$fbc160adde9cf656 = class _BloomFilter {
    /**
   * Return the Bloom filter structure: an array of `m` bits per key encoding if a key is not part of the structure.
   *
   * @typedef {Uint8Array} bytes
   */ bytes;
    /**
   * Return the number of hash functions used to compute this Bloom filter.
   *
   * @type {number}
   */ k;
    /**
   * Creates a new instance of this class.
   *
   * @param {Uint8Array} bytes - The Bloom filter structure of `m` bits per key encoding if the key
   *                             likely belongs to the structure or surely doesn't.
   * @param {number} k - The number of hash functions used to compute this Bloom filter.
   *
   */ constructor(bytes, k){
        this.bytes = bytes;
        this.k = k;
    }
    /**
   * Return the Bloom filter data structure represented as a {@link bigint} value.
   *
   * @returns {bigint} - The Bloom filter data structure represented as a {@link bigint} value.
   */ get bi() {
        return $esaJO.bytesToNumberBE(this.bytes);
    }
    /**
   * Return the Bloom filter data structure represented as a {@link number} value.
   *
   * @returns {bigint} - The Bloom filter data structure represented as a {@link number} value.
   *
   * @throws InvalidDataType if the data structure of the bloom filter can't be represented as a number
   * because underflow or overflow number safe integer range according
   * [IEEE 754 double precision 64 bits floating point format](https://en.wikipedia.org/wiki/Double-precision_floating-point_format).
   *
   * @remarks Preferably use {@link bi} because the Bloom filter data structure can always be represented as a {@link bigint} value.
   */ get n() {
        const bi = this.bi;
        if (Number.MIN_SAFE_INTEGER <= bi && bi <= Number.MAX_SAFE_INTEGER) return Number(bi);
        throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("BloomFilter.n", "not in the safe number range", {
            bytes: this.bytes,
            k: this.k
        });
    }
    /**
   * Compare the current BloomFilter instance with another BloomFilter instance according their
   * * {@link bytes} data structure first,
   * * {@link k} if the data structures are equal.
   *
   * @param {BloomFilter} that - The BloomFilter instance to compare with.
   *
   * @return {number} - Returns a negative number if the current instance is less than the provided instance,
   *                   returns zero if they are equal, and returns a positive number if the current instance is greater than the provided instance.
   */ compareTo(that) {
        return this.bi < that.bi ? -1 : this.bi === that.bi ? this.k - that.k : 1;
    }
    /**
   * Checks if the current BloomFilter instance is equal to another BloomFilter instance.
   *
   * @param {BloomFilter} that - The other BloomFilter instance to compare with.
   *
   * @return {boolean} - Returns true if the current BloomFilter instance is equal to the other BloomFilter instance, otherwise returns false.
   */ isEqual(that) {
        return this.bi === that.bi && this.k === that.k;
    }
    /**
   * Checks if the specified key may be contained within this Bloom filter or surely isn't.
   *
   * @param {Hex|Uint8Array} key - The key to check. It can be either a Hex object or a Uint8Array.
   *
   * @return {boolean} Returns true if this Bloom filter may contain the key, otherwise returns false.
   *
   * @remarks False positive matches are possible, but false negatives are not.
   * @remarks Security auditable method, depends on
   * * {@link hash}.
   */ contains(key) {
        return $564ad8f2c6689928$var$distribute($564ad8f2c6689928$var$hash(key instanceof $564ad8f2c6689928$export$9ccf03a0aa23a1ca ? key.bytes : key), this.k, this.bytes.byteLength * 8, (index, bit)=>{
            return (this.bytes[index] & bit) === bit;
        });
    }
    /**
   * Calculates the optimal number of bits per key (`m` in math literature) based
   * on the number of hash functions (`k` in math literature) used to generate the Bloom Filter.
   *
   * Mathematically, `m` is approximated as `(k / ln(2))` which is simplified
   * to the higher integer close to `(m / 0.69)` for computational efficiency.
   * It also ensures that `k` is within a practical range [1, 30], hence the function
   * - returns `2` for `k = 1`,
   * - returns `44` for `k >= 30`.
   *
   * @param {number} k - The number of keys.
   *
   * @return {number} - The number of bits per key.
   */ static computeBestBitsPerKey(k) {
        if (k <= 1) return 2;
        return k >= 30 ? 44 : Math.ceil(k / 0.69);
    }
    /**
   * Calculates the optimal number of hash functions (`k` in math literature)
   * based on bits per key (`m` in math literature).
   *
   * Mathematically, `k` is approximated as `(m * ln(2))` which is simplified
   * to the lower integer close to `(m * 0.69)` for computational efficiency.
   * It also ensures that `k` stays within a practical range [1, 30].
   *
   * @param m - The number of bits per key.
   *
   * @returns The calculated optimal `k` value.
   */ static computeBestHashFunctionsQuantity(m) {
        const k = Math.floor(m * 0.69);
        if (k < 1) return 1;
        return k > 30 ? 30 : k;
    }
    /**
   * Checks if the current BloomFilter instance is possible to join with another BloomFilter instance.
   *
   * @param {BloomFilter} other - The BloomFilter instance to check if it is possible to join with the current instance.
   *
   * @return {boolean} - Returns true if the BloomFilter instances have the same 'k' value and 'bytes' length, false otherwise.
   */ isJoinable(other) {
        return this.k === other.k && this.bytes.length === other.bytes.length;
    }
    /**
   * Joins the current BloomFilter with another BloomFilter by performing a bitwise OR operation on the
   * data structures of the filters.
   * Both filters must have been generated with the same number of hash functions, and they must have the same length.
   *
   * @param other - The BloomFilter to join with.
   *
   * @returns A new BloomFilter that represents the result of the join operation.
   *          They keys made this and `other` filter may belong to the returned filter.
   *          Any key not part of the joined filter surely doesn't belong to the returned filter.
   *
   * @throws {InvalidOperation} If the k values of the BloomFilters are different.
   * @throws {InvalidOperation} If the length of the byte arrays are different.
   */ join(other) {
        if (this.k === other.k) {
            if (this.bytes.length === other.bytes.length) return new _BloomFilter(new Uint8Array(this.bytes.map((byte, index)=>byte | other.bytes[index])), this.k);
            throw new (0, $dbc5c4a080b2aff5$export$8df2d8bae05b1dae)("BloomFilter.join", "different length values", {
                this: this,
                other: other
            });
        }
        throw new (0, $dbc5c4a080b2aff5$export$8df2d8bae05b1dae)("BloomFilter.join", "different k values", {
            this: this,
            other: other
        });
    }
    /**
   * Creates a new instance of BloomFilterBuilder and adds the specified keys to it.
   * * Call {@link BloomFilterBuilder.add} to add more keys.
   * * Call {@link BloomFilterBuilder.build} to create a new Bloom filter once
   *
   * @param {...(Hex[] | Uint8Array[])} keys - The keys to be added to the BloomFilterBuilder.
   *
   * @returns {BloomFilterBuilder} - A new instance of BloomFilterBuilder with the specified keys added.
   *
   * @remarks Security auditable method, depends on
   * * {@link BloomFilterBuilder.add}.
   */ static of(...keys) {
        const builder = new $564ad8f2c6689928$var$BloomFilterBuilder();
        builder.add(...keys);
        return builder;
    }
};
var $564ad8f2c6689928$var$BloomFilterBuilder = class _BloomFilterBuilder {
    /**
   * The default value number of hash functions used to create {@link BloomFilter} instances.
   */ static DEFAULT_K = 5;
    /**
   * Map each element of the keys as likely part of the data structure of the Bloom filter to build.
   * Each key is mapped in `m` bits using `k` hash functions.
   *
   * @see {hash}
   */ hashMap = /* @__PURE__ */ new Map();
    /**
   * Adds one or more keys to the Bloom filter to create.
   *
   * @param {Hex[] | Uint8Array[]} keys - The keys to be added to Bloom filter to create.
   *
   * @return {this} - Returns this {@link BloomFilterBuilder} instance, the {@link this.hashMap} is updated to
   * map the keys presence in the filter data structure.
   *
   * @remarks Security auditable method, depends on
   * * {@link hash}.
   */ add(...keys) {
        for (const key of keys)this.hashMap.set($564ad8f2c6689928$var$hash(key instanceof $564ad8f2c6689928$export$9ccf03a0aa23a1ca ? key.bytes : key), true);
        return this;
    }
    /**
   * Builds a Bloom filter with the specified parameters and returns it.
   *
   * @param k - The number of hash functions to use in the Bloom filter.  to BloomFilterBuilder.DEFAULT_K.
   * @param m - The number of bits per key in the Bloom filter. Defaults to the value computed by BloomFilter.computeBestBitsPerKey(k).
   *
   * @return The built Bloom filter.
   */ build(k = _BloomFilterBuilder.DEFAULT_K, m = $564ad8f2c6689928$export$fbc160adde9cf656.computeBestBitsPerKey(k)) {
        let nBytes = Math.floor((this.hashMap.size * m + 7) / 8);
        nBytes = nBytes < 8 ? 8 : nBytes;
        const bits = new Uint8Array(nBytes);
        const nBits = nBytes * 8;
        for (const hash2 of this.hashMap.keys())$564ad8f2c6689928$var$distribute(hash2, k, nBits, (index, bit)=>{
            bits[index] |= bit;
            return true;
        });
        return new $564ad8f2c6689928$export$fbc160adde9cf656(bits, k);
    }
};
var $564ad8f2c6689928$var$UINT32_LIMIT = 2 ** 32;
function $564ad8f2c6689928$var$addAndWrapAsUInt32(a, b) {
    return (a + b) % $564ad8f2c6689928$var$UINT32_LIMIT;
}
function $564ad8f2c6689928$var$distribute(hash2, k, m, collision) {
    const delta = (hash2 >>> 17 | hash2 << 15) >>> 0;
    for(let i = 0; i < k; i++){
        const bitPos = hash2 % m;
        if (!collision(Math.floor(bitPos / 8), 1 << bitPos % 8)) return false;
        hash2 = $564ad8f2c6689928$var$addAndWrapAsUInt32(hash2, delta);
    }
    return true;
}
function $564ad8f2c6689928$var$hash(key) {
    return Number($esaJO.bytesToNumberBE($564ad8f2c6689928$export$d2458fb5f52b75a6.of(key).bytes.slice(0, 4)));
}
var $564ad8f2c6689928$export$19600bc7e7f23c95 = class {
    /**
   * Represent coin {@link code} denomination.
   */ _code;
    /**
   * Represent the coin {@link value}.
   *
   * @type {FixedPointNumber}
   */ _value;
    /**
   * Creates an instance of the class with the specified code and value.
   *
   * @param {Txt} code - The code associated with this instance.
   * @param {FixedPointNumber} value - The value associated with this instance.
   */ constructor(code, value){
        this._code = code;
        this._value = value;
    }
    /**
   * Return the code as a Txt object.
   *
   * @return {Txt} The code object
   *
   * @remarks Since currency codes likely use Unicode composite symbols,
   * {@link Txt} type enforce the representation of the code is normalized.
   */ get code() {
        return this._code;
    }
    /**
   * Return the current value as an FixedPointNumber (Fixed-Point Number).
   *
   * @return {FixedPointNumber} The current value in Fixed-Point Number format.
   */ get value() {
        return this._value;
    }
    /**
   * Returns the integer part of the FixedPointNumber {@link value}.
   *
   * @return {bigint} the integer part of this FixedPointNumber {@link value}.
   *
   * @throws {InvalidOperation} If the {@link value} is not finite.
   *
   * @remarks Do not use for financial math: apply {@link FixedPointNumber} methods instead.
   */ get bi() {
        return this._value.bi;
    }
    /**
   * Returns the array of bytes representing the *Normalization Form Canonical Composition*
   * [Unicode Equivalence](https://en.wikipedia.org/wiki/Unicode_equivalence)
   * of the textual expression '{@link value} {@link code}'.
   */ get bytes() {
        return $564ad8f2c6689928$export$1d5cbbbdccc512f9.of(this.toString()).bytes;
    }
    /**
   * Return this {@linl value} approximated as {@link number}.
   *
   * @remarks Do not use for financial math: apply {@link FixedPointNumber} methods instead.
   */ get n() {
        return this._value.n;
    }
    /**
   * Compares this Currency object with another Currency object for order.
   *
   * @param {Currency} that - The Currency object to be compared.
   * @return {number} A negative integer, zero, or a positive integer as this Currency
   *     is less than, equal to, or greater than the specified Currency.
   * @throws {InvalidDataType} If the currency codes do not match.
   */ compareTo(that) {
        if (this.code.isEqual(that.code)) return this.value.compareTo(that.value);
        throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Coin.compareTo", "not VET currency", {
            // eslint-disable-next-line @typescript-eslint/no-base-to-string
            that: `${that}`
        });
    }
    /**
   * Determines if this Currency object is equal to another Currency object.
   *
   * @param {Currency} that - The Currency object to compare with the current instance.
   * @return {boolean} - `true` if the objects are considered equal, otherwise `false`.
   */ isEqual(that) {
        try {
            return this.compareTo(that) === 0;
        } catch (e) {
            return false;
        }
    }
    /**
   * Returns the textual representation of this currency as
   * '{@link value} {@link code}'.
   *
   * @return A string that contains the value and code properties of the object.
   */ toString() {
        return `${this.value.toString()} ${this._code}`;
    }
};
// src/vcdm/currency/Units.ts
var $564ad8f2c6689928$export$dd3b792fda2f69f8 = /* @__PURE__ */ ((Units2)=>{
    Units2[Units2["wei"] = 0] = "wei";
    Units2[Units2["kwei"] = 3] = "kwei";
    Units2[Units2["mwei"] = 6] = "mwei";
    Units2[Units2["gwei"] = 9] = "gwei";
    Units2[Units2["szabo"] = 12] = "szabo";
    Units2[Units2["finney"] = 15] = "finney";
    Units2[Units2["ether"] = 18] = "ether";
    return Units2;
})($564ad8f2c6689928$export$dd3b792fda2f69f8 || {});
((Units2)=>{
    function formatEther(wei) {
        return formatUnits(wei, 18 /* ether */ );
    }
    Units2.formatEther = formatEther;
    function formatUnits(wei, unit = 18 /* ether */ ) {
        const fpn = wei.div($564ad8f2c6689928$export$3dede3b6cc153eb5.of(10n ** BigInt(unit)));
        return fpn.isInteger() ? `${fpn}.0` : `${fpn}`;
    }
    Units2.formatUnits = formatUnits;
    function parseEther(ether) {
        return parseUnits(ether, 18 /* ether */ );
    }
    Units2.parseEther = parseEther;
    function parseUnits(exp, unit = 18 /* ether */ ) {
        return $564ad8f2c6689928$export$3dede3b6cc153eb5.of(exp).times($564ad8f2c6689928$export$3dede3b6cc153eb5.of(10n ** BigInt(unit)));
    }
    Units2.parseUnits = parseUnits;
})($564ad8f2c6689928$export$dd3b792fda2f69f8 || ($564ad8f2c6689928$export$dd3b792fda2f69f8 = {}));
// src/vcdm/currency/VET.ts
var $564ad8f2c6689928$export$ae9c3c05238a9d5d = class _VET extends $564ad8f2c6689928$export$19600bc7e7f23c95 {
    /**
   * The code for VET is the sequence of Unicode
   * - U+1D64D - mathematical double strike capital letter 'V',
   * - U+039F - Greek capital letter 'Xi',
   * - U+0054 - Latin capital letter 'T'.
   */ static CODE = $564ad8f2c6689928$export$1d5cbbbdccc512f9.of("\uD835\uDD4D\u039ET");
    /**
   * Wei fractional digits to express this value.
   */ static WEI_FD = 18n;
    /**
   * Represents this monetary amount in terms of {@link Units.wei}.
   *
   * @type {bigint}
   */ wei = this.value.dp(_VET.WEI_FD).sv;
    /**
   * Create a new instance with the given `value`.
   *
   * @param {FixedPointNumber} value The value to be used for initializing the instance.
   */ constructor(value){
        super(_VET.CODE, value);
    }
    /**
   * Return a new VET instance with the specified value and unit.
   *
   * @param {bigint | number | string | FixedPointNumber} value - The numerical value for the VET instance.
   * @param {Units} unit - The unit for the value.
   *                     Defaults to {@link Units.ether} if not provided.
   * @return {VET} A new VET instance with the provided value and unit.
   *
   * @throws {InvalidDataType} If `value` is not a numeric expression.
   */ static of(value, unit = 18 /* ether */ ) {
        const fpn = value instanceof $564ad8f2c6689928$export$3dede3b6cc153eb5 ? value : $564ad8f2c6689928$export$3dede3b6cc153eb5.of(value);
        return new _VET(fpn.div($564ad8f2c6689928$export$3dede3b6cc153eb5.of(10n ** (_VET.WEI_FD - BigInt(unit)))));
    }
};
// src/vcdm/currency/VTHO.ts
var $564ad8f2c6689928$export$27cc1e5993feb517 = class _VTHO extends $564ad8f2c6689928$export$19600bc7e7f23c95 {
    /**
   * The code for VET is the sequence of Unicode
   * - U+1D64D - mathematical double strike capital letter 'V',
   * - U+0054 - Latin capital letter 'T',
   * - U+0048 - Latin capital letter 'H',
   * - U+004F - Latin capital letter 'O'.
   */ static CODE = $564ad8f2c6689928$export$1d5cbbbdccc512f9.of("\uD835\uDD4DTHO");
    /**
   * Wei fractional digits to express this value.
   */ static WEI_FD = 18n;
    /**
   * Represents this monetary amount in terms of {@link Units.wei}.
   *
   * @type {bigint}
   */ wei = this.value.dp(_VTHO.WEI_FD).sv;
    /**
   * Create a new instance with the given `value`.
   *
   * @param {FixedPointNumber} value The value to be used for initializing the instance.
   */ constructor(value){
        super(_VTHO.CODE, value);
    }
    /**
   * Return a new VTHO instance with the specified value and unit.
   *
   * @param {bigint | number | string | FixedPointNumber} value - The numerical value for the VTHO instance.
   * @param {Units} unit - The unit for the value.
   *                       Defaults to {@link Units.ether} if not provided.
   * @return {VTHO} A new VTHO instance with the provided value and unit.
   *
   * @throws {InvalidDataType} If `value` is not a numeric expression.
   */ static of(value, unit = 18 /* ether */ ) {
        const fpn = value instanceof $564ad8f2c6689928$export$3dede3b6cc153eb5 ? value : $564ad8f2c6689928$export$3dede3b6cc153eb5.of(value);
        return new _VTHO(fpn.div($564ad8f2c6689928$export$3dede3b6cc153eb5.of(10n ** (_VTHO.WEI_FD - BigInt(unit)))));
    }
};
// src/vcdm/encoding/rlp/kind/ScalarKind.ts
var $564ad8f2c6689928$export$26597e1450faf9d1 = class {
};
// src/vcdm/encoding/rlp/RLP.ts
var $564ad8f2c6689928$export$4859e6f62c4b9b84 = class _RLP {
    encoded;
    decoded;
    constructor(data){
        this.decoded = data instanceof Uint8Array ? (0, $f335153bf9367773$export$4859e6f62c4b9b84).decode(data) : data;
        this.encoded = data instanceof Uint8Array ? data : (0, $f335153bf9367773$export$4859e6f62c4b9b84).encode(data);
    }
    /**
   * Returns the bigint representation of the encoded data in the RLP instance.
   * @returns {bigint} The bigint representation of the encoded data.
   */ get bi() {
        return (0, $248bf24903c02b9f$exports.bytesToNumberBE)(this.bytes);
    }
    /**
   * Returns the encoded data as a Uint8Array.
   * @returns {Uint8Array} The encoded data.
   */ get bytes() {
        return this.encoded;
    }
    /**
   * Returns the number representation of the encoded data in the RLP instance.
   * @returns {number} The number representation of the encoded data.
   */ get n() {
        const bi = this.bi;
        if (bi <= Number.MAX_SAFE_INTEGER) return Number(bi);
        throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("RLP.n", "not in the safe number range", {
            bytes: this.bytes
        });
    }
    /**
   * Compares the current RLP instance with another RLP instance.
   * @param {RLP} that The RLP instance to compare.
   * @returns 0 if the RLP instances are equal, -1/1 if they are not.
   */ compareTo(that) {
        if (this.encoded.length !== that.encoded.length) return -1;
        for(let i = 0; i < this.encoded.length; i++){
            if (this.encoded[i] !== that.encoded[i]) return 1;
        }
        return 0;
    }
    /**
   * Relies on compareTo to check if the RLP instances are equal.
   * @param {RLP} that The RLP instance to compare.
   * @returns true if the RLP instances are equal, false otherwise.
   */ isEqual(that) {
        return this.compareTo(that) === 0;
    }
    /**
   * Creates {@link Hex} instance from the RLP encoded value.
   * @returns {Hex} The Hex instance.
   */ toHex() {
        return $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(this.bytes);
    }
    /**
   * Returns an RLP instance from a plain value.
   * @param data - The plain data
   * @returns {RLP} The RLP instance.
   */ static of(data) {
        try {
            return new _RLP(data);
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("RLP.of()", `Error when creating an RLP instance for data ${data}`, {
                context: "This method creates an RLP instance from a plain value.",
                data: {
                    data: data
                }
            }, error);
        }
    }
    /**
   * Returns an RLP instancen from an encoded value.
   * @param {Uint8Array} encodedData - The RLP-encoded data.
   * @returns The decoded data or null if decoding fails.
   */ static ofEncoded(encodedData) {
        try {
            return new _RLP(encodedData);
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("RLP.ofEncoded()", `Error when creating an RLP instance for encoded data.`, {
                context: "This method creates an RLP instance from an encoded value.",
                data: {
                    encodedData: encodedData
                }
            }, error);
        }
    }
    /**
   * Handles the RLP packing of data.
   * Recursively processes through object properties or array elements to prepare data for RLP encoding.
   *
   * @param obj - The object data to be packed.
   * @param profile - Profile for encoding structures.
   * @param context - Encoding context for error tracing.
   * @returns Packed data as RLPInput.
   * @throws {InvalidRLP}
   *
   */ static packData(obj, profile, context) {
        context = context !== "" ? context + "." + profile.name : profile.name;
        const kind = profile.kind;
        if (kind instanceof $564ad8f2c6689928$export$26597e1450faf9d1) return kind.data(obj, context).encode();
        if (Array.isArray(kind)) return kind.map((k)=>this.packData(obj[k.name], k, context));
        if (!Array.isArray(obj)) throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("RLP.packData()", `Validation error: Expected an array in ${context}.`, {
            context: context,
            data: {
                obj: obj,
                profile: profile
            }
        });
        if ("item" in kind && Array.isArray(obj)) {
            const item = kind.item;
            return obj.map((part, i)=>this.packData(part, {
                    name: "#" + i,
                    kind: item
                }, context));
        }
    }
    /**
   * Handles the RLP unpacking of data.
   * Recursively processes through packed properties or elements to prepare data post RLP decoding.
   *
   * @param packed - The packed data to be unpacked.
   * @param profile - Profile for decoding structures.
   * @param context - Decoding context for error tracing.
   * @returns Unpacked data as RLPValueType.
   * @throws {InvalidRLP}
   *
   */ static unpackData(packed, profile, context) {
        context = context !== "" ? context + "." + profile.name : profile.name;
        const kind = profile.kind;
        if (kind instanceof $564ad8f2c6689928$export$26597e1450faf9d1) {
            if (!(packed instanceof Uint8Array)) throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("RLP.unpackData()", `Unpacking error: Expected data type is Uint8Array.`, {
                context: context,
                data: {
                    packed: packed,
                    profile: profile
                }
            });
            return kind.buffer(packed, context).decode();
        }
        if (Array.isArray(kind) && Array.isArray(packed)) {
            const parts = packed;
            if (kind.length !== parts.length) throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("RLP.unpackData()", `Unpacking error: Expected ${kind.length} items, but got ${parts.length}.`, {
                context: context,
                data: {
                    packed: packed,
                    profile: profile
                }
            });
            return kind.reduce((obj, profile2, index)=>{
                obj[profile2.name] = this.unpackData(parts[index], profile2, context);
                return obj;
            }, {});
        }
        if (!Array.isArray(packed)) throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("RLP.unpackData()", `Validation error: Expected an array in ${context}.`, {
            context: context,
            data: {
                packed: packed,
                profile: profile
            }
        });
        if ("item" in kind && Array.isArray(packed)) {
            const item = kind.item;
            return packed.map((part, index)=>this.unpackData(part, {
                    name: "#" + index,
                    kind: item
                }, context));
        }
    }
};
// src/vcdm/encoding/rlp/RLPProfiler.ts
var $564ad8f2c6689928$export$5011fcbb6c0dc14a = class _RLPProfiler extends $564ad8f2c6689928$export$4859e6f62c4b9b84 {
    /**
   * Creates a new Profiler instance.
   * @param profile - Profile for encoding/decoding structures.
   */ constructor(data, profile){
        super(data);
        this.profile = profile;
    }
    /**
   * Creates an RLPProfiler instance from a valid object.
   * @param {RLPValidObject} validObject Object to be encoded.
   * @returns {RLPProfiler} RLPProfiler instance.
   */ static ofObject(validObject, profile) {
        const packedData = this.packData(validObject, profile, "");
        return new _RLPProfiler(packedData, profile);
    }
    /**
   * Decodes an object following the provided profile.
   * @param encodedData Data to be decoded.
   * @param profile Profile for encoding/decoding structures.
   * @returns - Decoded data as RLPValueType.
   */ static ofObjectEncoded(encodedData, profile) {
        const packedData = $564ad8f2c6689928$export$4859e6f62c4b9b84.ofEncoded(encodedData).decoded;
        return new _RLPProfiler(packedData, profile);
    }
    /**
   * Returns the decoded unpacked object.
   * @returns {RLPValueType} Decoded unpacked object.
   */ get object() {
        return _RLPProfiler.unpackData(this.decoded, this.profile, "");
    }
};
var $564ad8f2c6689928$export$8ba36ab12859905e = (data, context)=>{
    if (typeof data !== "number" && typeof data !== "string") throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("validateNumericKindData()", `Validation error: Input in ${context} must be a string or number.`, {
        context: context,
        data: {
            data: data
        }
    });
    if (typeof data === "number") $564ad8f2c6689928$var$_validateNumericKindNumber(data, context);
    else if (typeof data === "string") $564ad8f2c6689928$var$_validateNumericKindString(data, context);
    return BigInt(data);
};
var $564ad8f2c6689928$var$_validateNumericKindNumber = (num, context)=>{
    if (!Number.isSafeInteger(num) || num < 0) throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("_validateNumericKindNumber()", `Validation error: Number in ${context} must be a safe and non-negative integer.`, {
        context: context,
        data: {
            num: num
        }
    });
};
var $564ad8f2c6689928$var$_validateNumericKindString = (str, context)=>{
    const isHexUInt = $564ad8f2c6689928$export$7c2a2de09ea3c4f2.isValid0x(str);
    const isDecimal = $564ad8f2c6689928$export$3dede3b6cc153eb5.isNaturalExpression(str);
    if (!isHexUInt && !isDecimal) throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("_validateNumericKindString()", `Validation error: String in ${context} must represent a non-negative integer in hex or decimal format.`, {
        context: context,
        data: {
            str: str
        }
    });
    if (isHexUInt && str.length <= 2) throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("_validateNumericKindString()", `Validation error: Hex string number in ${context} must be of valid length.`, {
        context: context,
        data: {
            str: str
        }
    });
};
var $564ad8f2c6689928$export$1a9c4ad470188a27 = (buf, context, maxBytes)=>{
    if (maxBytes !== void 0 && buf.length > maxBytes) throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("assertValidNumericKindBuffer()", `Validation error: Buffer in ${context} must be less than ${maxBytes} bytes.`, {
        context: context,
        data: {
            buf: buf,
            maxBytes: maxBytes
        }
    });
    if (buf[0] === 0) throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("assertValidNumericKindBuffer()", `Validation error: Buffer in ${context} must represent a canonical integer (no leading zeros).`, {
        context: context,
        data: {
            buf: buf,
            maxBytes: maxBytes
        }
    });
};
var $564ad8f2c6689928$export$92ea27a9faa2387d = (bi, maxBytes, context)=>{
    if (bi === 0n) return Uint8Array.from([]);
    const hex = $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(bi).digits;
    if (maxBytes !== void 0 && hex.length > maxBytes * 2) throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("encodeBigIntToBuffer()", `Validation error: Encoded number in ${context} must fit within ${maxBytes} bytes.`, {
        context: context,
        data: {
            hex: hex,
            maxBytes: maxBytes
        }
    });
    return $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(hex).bytes;
};
var $564ad8f2c6689928$export$169c089fe0e56a68 = (buffer)=>{
    if (buffer.length === 0) return 0;
    const bi = $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(buffer).bi;
    const num = Number(bi);
    return Number.isSafeInteger(num) ? num : "0x" + bi.toString(16);
};
var $564ad8f2c6689928$export$958fe0abc7a4c8a5 = (data, context)=>{
    if (typeof data !== "string") throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("assertValidHexBlobKindData()", `Validation error: Input must be a string.`, {
        context: context,
        data: {
            data: data
        }
    });
    if (!$564ad8f2c6689928$export$9ccf03a0aa23a1ca.isValid(data)) throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("assertValidHexBlobKindData()", `Validation error: Input must be a valid hex string with a '0x' prefix.`, {
        context: context,
        data: {
            data: data
        }
    });
    if (data.length % 2 !== 0) throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("assertValidHexBlobKindData()", `Validation error: Hex string must have an even length.`, {
        context: context,
        data: {
            data: data
        }
    });
};
var $564ad8f2c6689928$export$36194bd8ca205f39 = (data, context, bytes)=>{
    if (data.length !== bytes * 2 + 2) throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("assertFixedHexBlobKindData()", `Validation error: Hex string in ${context} must be exactly ${bytes} bytes in length.`, {
        context: context,
        data: {
            data: data,
            bytes: bytes
        }
    });
};
var $564ad8f2c6689928$export$ab717f4e4f82779e = (buffer, context, bytes)=>{
    if (buffer.length !== bytes) throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("assertFixedHexBlobKindData()", `Validation error: Hex string in ${context} must be exactly ${bytes} bytes in length.`, {
        context: context,
        data: {
            buffer: buffer,
            bytes: bytes
        }
    });
};
var $564ad8f2c6689928$export$e5b7472edee9798e = (buffer, context, bytes)=>{
    if (buffer.length > bytes) throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("assertCompactFixedHexBlobBuffer()", `Validation error: Buffer in ${context} must be at most ${bytes} bytes.`, {
        context: context,
        data: {
            buffer: buffer,
            bytes: bytes
        }
    });
    if (buffer.length !== 0 && buffer[0] === 0) throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("assertCompactFixedHexBlobBuffer()", `Validation error: Buffer in ${context} should not have leading zero bytes.`, {
        context: context,
        data: {
            buffer: buffer,
            bytes: bytes
        }
    });
};
var $564ad8f2c6689928$export$6ab8c5ca73295e04 = (buffer)=>{
    const zeroIndex = buffer.findIndex((byte)=>byte !== 0);
    return zeroIndex !== -1 ? buffer.subarray(zeroIndex) : Uint8Array.from([]);
};
var $564ad8f2c6689928$export$7fbcd0959b9d4c86 = (buffer, bytes)=>{
    return $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(buffer).fit(bytes * 2).toString();
};
var $564ad8f2c6689928$export$1183026c469db464 = class extends $564ad8f2c6689928$export$26597e1450faf9d1 {
    /**
   * Encodes the input data into buffer format.
   *
   * @param {RLPInput} data The data to encode, expected to be of Uint8Array type.
   * @param {string} context Descriptive context for error messages
   * @returns {DataOutput} Object with an encode function.
   * @throws {InvalidRLP}
   */ data(data, context) {
        if (!(data instanceof Uint8Array)) throw new (0, $dbc5c4a080b2aff5$export$d9c51ea6c57e8044)("BufferKind.data()", `Validation error: Expected a Uint8Array type in ${context}.`, {
            context: context,
            data: {
                data: data
            }
        });
        return {
            encode: ()=>data
        };
    }
    /**
   * Decodes the input buffer.
   *
   * @param {Uint8Array} buffer - The buffer to decode, expected to be of buffer type.
   * @returns BufferOutput object with a decode function.
   * @throws {InvalidRLP}
   */ buffer(buffer) {
        return {
            decode: ()=>buffer
        };
    }
};
// src/vcdm/encoding/rlp/kind/NumericKind.ts
var $564ad8f2c6689928$export$16dfabb5959ce479 = class extends $564ad8f2c6689928$export$26597e1450faf9d1 {
    /**
   * Constructs a new instance of NumericKind.
   *
   * @param maxBytes - Optional parameter that specifies the maximum number of bytes that numeric data can occupy when encoded.
   */ constructor(maxBytes){
        super();
        this.maxBytes = maxBytes;
    }
    /**
   * Encodes the input data into numeric format and ensures it doesn't exceed the maximum bytes, if specified.
   *
   * @param data - The data to encode, expected to be numeric.
   * @param context - Descriptive context for error messages
   * @returns DataOutput object with an encode function.
   * @throws Will throw an error if data validation fails or encoding issues occur.
   */ data(data, context) {
        const dataBI = $564ad8f2c6689928$export$8ba36ab12859905e(data, context);
        return {
            encode: ()=>$564ad8f2c6689928$export$92ea27a9faa2387d(dataBI, this.maxBytes, context)
        };
    }
    /**
   * Decodes the input buffer into a number or hexadecimal string, ensuring it meets numeric data constraints.
   *
   * @param {Uint8Array} buffer - The buffer to decode, containing numeric data.
   * @param context - Descriptive context for error messages.
   * @returns BufferOutput object with a decode function.
   * @throws Will throw an error if buffer validation fails.
   */ buffer(buffer, context) {
        $564ad8f2c6689928$export$1a9c4ad470188a27(buffer, context, this.maxBytes);
        return {
            decode: ()=>$564ad8f2c6689928$export$169c089fe0e56a68(buffer)
        };
    }
};
// src/vcdm/encoding/rlp/kind/hexblob/HexBlobKind.ts
var $564ad8f2c6689928$export$f32667dbae7bc3ad = class extends $564ad8f2c6689928$export$26597e1450faf9d1 {
    /**
   * Encodes the input data into a Uint8Array.
   *
   * @param data - The data to encode, expected to be a '0x' prefixed even sized hex string.
   * @param context - Context string for error handling.
   * @returns An object containing an encode function which returns the encoded Uint8Array.
   */ data(data, context) {
        $564ad8f2c6689928$export$958fe0abc7a4c8a5(data, context);
        return {
            encode: ()=>$564ad8f2c6689928$export$7c2a2de09ea3c4f2.of(data.slice(2)).bytes
        };
    }
    /**
   * Decodes the input buffer into a hex string.
   *
   * @param buffer - The buffer to decode.
   * @param context - Context string for error handling.
   * @returns An object containing a decode function which returns the decoded hex string.
   */ buffer(buffer, _context) {
        return {
            decode: ()=>$564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(buffer).toString()
        };
    }
};
// src/vcdm/encoding/rlp/kind/hexblob/FixedHexBlobKind.ts
var $564ad8f2c6689928$export$bc2dc8c724ed4216 = class extends $564ad8f2c6689928$export$f32667dbae7bc3ad {
    /**
   * Creates a new instance of the {@link FixedHexBlobKind} class.
   * @param bytes - The number of bytes the blob must have.
   */ constructor(bytes){
        super();
        this.bytes = bytes;
    }
    /**
   * Encodes the input data into a Uint8Array with validation against fixed size.
   *
   * @param data - The data to encode, expected to be a '0x' prefixed even sized hex string.
   * @param context - Context string for error handling.
   * @returns An object containing an encode function which returns the encoded Uint8Array.
   */ data(data, context) {
        const encoder = super.data(data, context);
        $564ad8f2c6689928$export$36194bd8ca205f39(data, context, this.bytes);
        return encoder;
    }
    /**
   * Decodes the input buffer into a hex string with validation against fixed size.
   *
   * @param buffer - The buffer to decode.
   * @param context - Context string for error handling.
   * @returns An object containing a decode function which returns the decoded hex string.
   */ buffer(buffer, context) {
        const decoder = super.buffer(buffer, context);
        $564ad8f2c6689928$export$ab717f4e4f82779e(buffer, context, this.bytes);
        return decoder;
    }
};
// src/vcdm/encoding/rlp/kind/hexblob/OptionalFixedHexBlobKind.ts
var $564ad8f2c6689928$export$4a5ff240fb77900 = class extends $564ad8f2c6689928$export$bc2dc8c724ed4216 {
    /**
   * Encodes the input data (which can be null or undefined) into a Uint8Array.
   *
   * @param data - The data to encode, can be null or undefined.
   * @param context - Context string for error handling.
   * @returns An object containing an encode function which returns the encoded Uint8Array.
   */ data(data, context) {
        return data == null ? {
            encode: ()=>Uint8Array.from([])
        } : super.data(data, context);
    }
    /**
   * Decodes the input buffer into a hex string or null if the buffer is empty.
   *
   * @param buffer - The buffer to decode, can be empty.
   * @param context - Context string for error handling.
   * @returns An object containing a decode function which returns the decoded hex string or null.
   */ buffer(buffer, context) {
        return buffer.length === 0 ? {
            decode: ()=>null
        } : super.buffer(buffer, context);
    }
};
// src/vcdm/encoding/rlp/kind/hexblob/CompactFixedHexBlobKind.ts
var $564ad8f2c6689928$export$d307fa5bdcfc61d4 = class extends $564ad8f2c6689928$export$bc2dc8c724ed4216 {
    /**
   * Encodes the input data into a Uint8Array, trimming leading zeros.
   *
   * @param data - The data to encode, expected to be a '0x' prefixed hex string.
   * @param context - Context string for error handling.
   * @returns An object containing an encode function which returns the encoded Uint8Array.
   */ data(data, context) {
        const buffer = super.data(data, context).encode();
        return {
            encode: ()=>$564ad8f2c6689928$export$6ab8c5ca73295e04(buffer)
        };
    }
    /**
   * Decodes the input buffer into a number or hexadecimal string, ensuring it meets the fixed size by padding with zeros.
   *
   * @param buffer - The buffer to decode, containing numeric data.
   * @param context - Descriptive context for error messages, usually representing the caller's identity.
   * @returns BufferOutput object with a decode function.
   * @throws Will throw an error if buffer validation fails.
   */ buffer(buffer, context) {
        $564ad8f2c6689928$export$e5b7472edee9798e(buffer, context, this.bytes);
        return {
            decode: ()=>// Decode the buffer, returning a hex string with leading zeros.
                $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(buffer).fit(this.bytes * 2).toString()
        };
    }
};
var $564ad8f2c6689928$export$93018d515d60db37 = class _Mnemonic {
    /**
   * A TextEncoder instance used for encoding text to bytes.
   *
   * @type {TextEncoder}
   */ static ENCODER = new TextEncoder();
    /**
   * Throws an exception because the mnemonic cannot be represented as a big integer.
   * @returns {bigint} The BigInt representation of the mnemonic.
   * @throws {InvalidOperation} The mnemonic cannot be represented as a bigint.
   * @override {@link VeChainDataModel#bi}
   * @remark The conversion to BigInt is not supported for a mnemonic.
   */ get bi() {
        throw new (0, $dbc5c4a080b2aff5$export$8df2d8bae05b1dae)("Mnemonic.bi", "There is no big integer representation for a mnemonic.", {
            data: ""
        });
    }
    /**
   * Generates a mnemonic as encoded bytes.
   *
   * @returns {Uint8Array} The bytes representation of the words with spaces.
   */ get bytes() {
        return _Mnemonic.ENCODER.encode(_Mnemonic.of().join(" "));
    }
    /**
   * Throws an exception because the mnemonic cannot be represented as a number.
   * @returns {bigint} The number representation of the mnemonic.
   * @throws {InvalidOperation} The mnemonic cannot be represented as a number.
   * @override {@link VeChainDataModel#n}
   * @remark The conversion to number is not supported for a mnemonic.
   */ get n() {
        throw new (0, $dbc5c4a080b2aff5$export$8df2d8bae05b1dae)("Mnemonic.n", "There is no number representation for a mnemonic.", {
            data: ""
        });
    }
    /**
   *
   * @param that - The mnemonic to compare with.
   */ compareTo(_that) {
        throw new (0, $dbc5c4a080b2aff5$export$8df2d8bae05b1dae)("Mnemonic.compareTo", "There is no comparison for a mnemonic since it is not stored in memory.", {
            data: ""
        });
    }
    isEqual(_that) {
        throw new (0, $dbc5c4a080b2aff5$export$8df2d8bae05b1dae)("Mnemonic.isEqual", "There is no comparison for a mnemonic since it is not stored in memory.", {
            data: ""
        });
    }
    /**
   * Convert the number of words to the corresponding strength.
   *
   * @param numberOfWords - The number of words.
   *
   * @returns {number} The corresponding strength.
   *
   * @throws {InvalidDataType} If the number of words is not valid.
   */ static wordsNoToStrength(numberOfWords) {
        switch(numberOfWords){
            case 12:
                return 128;
            case 15:
                return 160;
            case 18:
                return 192;
            case 21:
                return 224;
            case 24:
                return 256;
            default:
                throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Mnemonic.wordsNoToStrength", "not a valid number of words", {
                    numberOfWords: numberOfWords
                });
        }
    }
    // Legacy method, probably should be part of a Private Key class (ofMnemonic) #1122
    /**
   * Derives a private key from a given list of
   * [BIP39 Mnemonic Words](https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki)
   * and a derivation path as in the examples.
   *
   * @example `m/0` (default)
   * @example `m/0/2`
   * @example `m/0/2/4/6`
   *
   * @param {string[]} words - The set of words used for mnemonic generation.
   * @param {string} [path='m/0'] - The derivation path from the current node.
   *
   * @returns {Uint8Array} - The derived private key as a Uint8Array.
   *
   * @throws {InvalidHDKey}
   *
   * @remarks Security auditable method, depends on
   * * {@link HDKey}.
   */ static toPrivateKey(words, path = "m/0") {
        const root = $564ad8f2c6689928$export$bb670963070b393a.fromMnemonic(words);
        try {
            return root.derive(path).privateKey;
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$b2ab323886c7b7a5)("mnemonic.derivePrivateKey()", "Invalid derivation path given as input.", {
                derivationPath: path
            }, error);
        }
    }
    /**
   * Generates a
   * [BIP39 Mnemonic Words](https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki)
   * phrase using the specified wordlist size and random generator.
   *
   * @param {WordlistSizeType} wordlistSize - The number of words to generate the mnemonic.
   * @param {function} [randomGenerator] - The random generator function used to generate the entropy.
   *
   * @returns {Mnemonic} The generated mnemonic.
   *
   * @throws {InvalidDataType} If the number of words is not valid.
   *
   * @remarks Security auditable method, depends on
   * * [entropyToMnemonic](https://github.com/paulmillr/scure-bip39);
   * * [generateMnemonic](https://github.com/paulmillr/scure-bip39);
   * * `randomGenerator` - **Must provide a cryptographic secure source of entropy
   *    else any secure audit certification related with this software is invalid.**
   */ static of(wordlistSize = 12, randomGenerator) {
        try {
            const strength = _Mnemonic.wordsNoToStrength(wordlistSize);
            if (randomGenerator != null) {
                const numberOfBytes = strength / 8;
                return (0, $836cf4f0e2c80e2c$exports.entropyToMnemonic)(randomGenerator(numberOfBytes), (0, $d248fb36c996c0d4$exports.wordlist)).split(" ");
            }
            return (0, $836cf4f0e2c80e2c$exports.generateMnemonic)((0, $d248fb36c996c0d4$exports.wordlist), strength).split(" ");
        } catch (error) {
            throw new (0, $dbc5c4a080b2aff5$export$46042050702202eb)("Mnemonic.of", "error while generating mnemonic", {
                wordlistSize: wordlistSize
            }, error);
        }
    }
    /**
   * Check if the given mnemonic words are valid.
   *
   * @param {string | string[]} words - The mnemonic words to check.
   *
   * @returns {boolean} true if the words are valid, false otherwise.
   *
   * @remarks Security auditable method, depends on
   * * [validateMnemonic](https://github.com/paulmillr/scure-bip39).
   */ static isValid(words) {
        const wordsToValidate = Array.isArray(words) ? words.join(" ") : words;
        return (0, $836cf4f0e2c80e2c$exports.validateMnemonic)(wordsToValidate, (0, $d248fb36c996c0d4$exports.wordlist));
    }
};
var $564ad8f2c6689928$export$87e0516a9045c2f1 = {
    deriveAddress: (words, path = "m/0")=>$564ad8f2c6689928$export$73974d1f547d9d48.ofMnemonic(words, path).toString(),
    derivePrivateKey: (words, path = "m/0")=>$564ad8f2c6689928$export$93018d515d60db37.toPrivateKey(words, path),
    generate: (wordlistSize, randomGenerator)=>$564ad8f2c6689928$export$93018d515d60db37.of(wordlistSize, randomGenerator),
    isValid: (words)=>$564ad8f2c6689928$export$93018d515d60db37.isValid(words)
};
var $564ad8f2c6689928$export$d90fb187180e94e = class _Quantity extends $564ad8f2c6689928$export$7c2a2de09ea3c4f2 {
    /**
   * Creates a Quantity instance from a bigint or number given expression
   *
   * @param {bigint | number} exp - The value to be expressed as Quantity object:
   * * bigint must be positive;
   * * number must be positive, it is converted to bigint to create the Quantity.
   *
   * @returns {Quantity} - The new Quantity object.
   *
   * @throws {InvalidDataType} - If the provided expression is not a positive integer value.
   */ static of(exp) {
        try {
            const huint = $564ad8f2c6689928$export$7c2a2de09ea3c4f2.of(exp);
            let cue = 0;
            while(cue < huint.digits.length && huint.digits.at(cue) === "0")cue++;
            return new _Quantity(huint.sign, cue === huint.digits.length ? "0" : huint.digits.slice(cue));
        } catch (e) {
            throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Quantity.of", "not a Quantity expression", {
                exp: `${exp}`
            }, // Needed to serialize bigint values.
            e);
        }
    }
};
var $564ad8f2c6689928$export$65528947809bf36b = class _Revision extends $564ad8f2c6689928$export$1d5cbbbdccc512f9 {
    /**
   * Regular expression pattern for revision strings.
   * Revision strings can be one of the following:
   * - "best": indicating the best revision
   * - "finalized": indicating a finalized revision
   * - A positive numeric string indicating a specific revision
   *
   * @type {RegExp}
   */ static REGEX_DECIMAL_REVISION = /^(best|finalized|\d+)$/;
    /**
   * Determines if the given value is valid.
   * This is true if the given value is
   * - "best" string or {@link Txt}: indicating the best revision;
   * - "finalized" string or {@link Txt}: indicating a finalized revision;
   * - a positive number;
   * - a positive numeric decimal or `0x` prefixed hexadecimal string indicating a specific revision,
   *
   * @param {bigint | number | string | Hex | Txt} value - The value to be validated.
   * @returns {boolean} - Returns `true` if the value is valid, `false` otherwise.
   */ static isValid(value) {
        if (typeof value === "number") return Number.isInteger(value) && value >= 0;
        return $564ad8f2c6689928$export$7c2a2de09ea3c4f2.isValid0x(value) || _Revision.REGEX_DECIMAL_REVISION.test(value);
    }
    /**
   * Creates a new Revision object from the given value.
   *
   * @param {bigint | number | string | Uint8Array | Hex } value - The value to create the Revision from:
   * * {@link Hex} must be positive;
   * * {@link Uint8Array} is decoded as a string: see {@link Txt.of}.
   *
   * @returns {Revision} - The created Revision object.
   *
   *  @throws {InvalidDataType} if the given value is not a valid revision: see {@link isValid}.
   *
   * @remarks The string representation of the revision is always expressed as a number in base 10.
   * @remarks The {@link Uint8Array} value is decoded as a string content: see {@link Txt.of}.
   */ static of(value) {
        try {
            let txt;
            if (value instanceof $564ad8f2c6689928$export$9ccf03a0aa23a1ca) txt = value.bi.toString();
            else if (value instanceof Uint8Array) txt = $564ad8f2c6689928$export$1d5cbbbdccc512f9.of(value).toString();
            else txt = `${value}`;
            if (_Revision.isValid(txt)) return new _Revision(txt);
            throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Revision.of", "not a revision", {
                value: `${value}`
            });
        } catch (e) {
            throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Revision.of", "not a revision", {
                value: `${value}`,
                e: e
            });
        }
    }
};
var $564ad8f2c6689928$export$59a0ed0fd7475d0 = {
    isRevisionAccount: (revision)=>$564ad8f2c6689928$export$65528947809bf36b.isValid(revision),
    isRevisionBlock: (revision)=>$564ad8f2c6689928$export$65528947809bf36b.isValid(revision)
};
var $564ad8f2c6689928$export$876173816e2392b2 = class _ThorId extends $564ad8f2c6689928$export$7c2a2de09ea3c4f2 {
    /**
   * Number of digits to represent a Thor ID value.
   *
   * @remarks The `0x` prefix is excluded.
   *
   * @type {number}
   */ static DIGITS = 64;
    /**
   * Constructs a ThorId object with the provided hexadecimal value.
   *
   * @param {HexUInt} huint - The hexadecimal value representing the ThorId.
   */ constructor(huint){
        super($564ad8f2c6689928$export$9ccf03a0aa23a1ca.POSITIVE, huint.fit(_ThorId.DIGITS).digits);
    }
    /**
   * Check if the given expression is a valid ThorId.
   *
   * @param {string} exp - The expression to be validated.
   *
   * @return {boolean} Returns true if the expression is a valid ThorId, false otherwise.
   */ static isValid(exp) {
        return $564ad8f2c6689928$export$9ccf03a0aa23a1ca.isValid(exp) && $564ad8f2c6689928$export$7c2a2de09ea3c4f2.REGEX_HEXUINT_PREFIX.test(exp) ? exp.length === _ThorId.DIGITS + 2 : exp.length === _ThorId.DIGITS;
    }
    /**
   * Determines whether the given string is a valid hex number prefixed with '0x'.
   *
   * @param {string} exp - The hex number to be checked.
   *
   *  @returns {boolean} - True if the hex number is valid, false otherwise.
   */ static isValid0x(exp) {
        return $564ad8f2c6689928$export$7c2a2de09ea3c4f2.REGEX_HEXUINT_PREFIX.test(exp) && _ThorId.isValid(exp);
    }
    /**
   * Creates a new ThorId object from the given expression.
   *
   * @param {bigint | number | string | Hex | Uint8Array} exp - The expression to create the ThorId from.
   *     It can be one of the following types:
   *     - bigint: A BigInteger value that represents the ThorId.
   *     - number: A number value that represents the ThorId.
   *     - string: A string value that represents the ThorId.
   *     - HexUInt: A HexUInt object that represents the ThorId.
   *     - Uint8Array: A Uint8Array object that represents the ThorId.
   *
   * @returns {ThorId} - A new ThorId object created from the given expression.
   *
   * @throws {InvalidDataType} If the given expression is not a valid hexadecimal positive integer expression.
   */ static of(exp) {
        try {
            if (exp instanceof $564ad8f2c6689928$export$7c2a2de09ea3c4f2) return new _ThorId(exp);
            return new _ThorId($564ad8f2c6689928$export$7c2a2de09ea3c4f2.of(exp));
        } catch (e) {
            throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("ThorId.of", "not a ThorId expression", {
                exp: `${exp}`
            }, // Needed to serialize bigint values.
            e);
        }
    }
};
var $564ad8f2c6689928$export$ca20b3ed1788c40a = class _Certificate {
    /**
   * Return the intended use or context of the certificate.
   */ purpose;
    /**
   * Returns the content of the certificate.
   */ payload;
    /**
   * Return the description of the context of validity of this certificate.
   */ domain;
    /**
   * The value expressed as of milliseconds elapsed since the
   * [epoch](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date),
   * when the certificate was issued.
   *
   * @remarks
   * The value is a natural number in the safe integer range of JS `number` type.
   */ timestamp;
    /**
   * Return the address of the entity signed the certificate, as
   * a lowercase hexadecimal expression prefixed by `0x`.
   *
   * @remarks
   * Normalized lowercase prefixed expression is needed because
   * the content of this property is part of the {@signature} computation:
   * certificates made from checksum case address of the signer should
   * result valid as the certificate made from the same signer address
   * not checksum case.
   */ signer;
    /**
   * Return the signature computed evaluating the properties of this object
   * and the private key of the signer.
   *
   * @remarks
   * The signature is a lowercase hexadecimal expression prefixed with `0x`.
   */ signature;
    /**
   * Returns a new instance of this class assuring the formal validity of the
   * arguments used to build the object.
   *
   * @param {string} purpose - The purpose of the certificate.
   * @param {Object} payload - The payload containing type and content.
   * @param {string} payload.type - The type of the payload.
   * @param {string} payload.content - The content of the payload.
   * @param {string} domain - The domain associated with the certificate.
   * @param {number} timestamp - The time at which the certificate is created;
   * must be a positive safe integer.
   * @param {string} signer - The signer of the certificate;
   * must be a valid address.
   * @param {string|undefined} [signature] - The signature of the certificate;
   * optional parameter.
   *
   * @throws {InvalidDataType} If timestamp is not a positive safe integer.
   * @throws {InvalidDataType} If signer is not a valid address.
   * @throws {InvalidDataType} If signature is invalid.
   *
   * @remarks
   * The `signer` address is represented lowercase and `0x` prefixed.
   */ constructor(purpose, payload, domain, timestamp, signer, signature){
        if (Number.isSafeInteger(timestamp) && timestamp >= 0) {
            if ($564ad8f2c6689928$export$73974d1f547d9d48.isValid(signer)) {
                this.purpose = purpose;
                this.payload = payload;
                this.domain = domain;
                this.timestamp = timestamp;
                this.signer = signer.toString().toLowerCase();
                try {
                    this.signature = typeof signature === "string" ? $564ad8f2c6689928$export$7c2a2de09ea3c4f2.of(signature).alignToBytes().toString() : signature;
                } catch (e) {
                    throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Certificate.constructor", "invalid signature", {
                        signature: signature
                    }, e);
                }
            } else throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Certificate.constructor", "signer is not an address", {
                signer: signer
            });
        } else throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Certificate.constructor", "not positive safe integer timestamp", {
            timestamp: timestamp
        });
    }
    /**
   * Encodes a given object into a Uint8Array representation
   * applying the following operation to normalize the content:
   * - the properties are sorted in ascending alphabetic order;
   * - the key/value properties are delimited with `"` when serialized as JSON
   *   before to be encoded as bytes;
   * - any not meaningful blank characters are ignored;
   * - the JSON representation of this object is byte encoded using the UTF-8
   *   [normalization form for canonical composition](https://en.wikipedia.org/wiki/Unicode_equivalence#Normal_forms).
   *
   * @param {unknown} object - The input object to be encoded.
   * @return {Uint8Array} The encoded Uint8Array representation of the input object.
   */ static encode(object) {
        return $564ad8f2c6689928$export$1d5cbbbdccc512f9.of((0, (/*@__PURE__*/$parcel$interopDefault($1FoUm)))(object)).bytes;
    }
    /**
   * Return `true` if the current instance has a signature.
   *
   * @return {boolean} `true` if the signature is a valid hexadecimal string,
   * otherwise `false`.
   */ isSigned() {
        return typeof this.signature === "string" && $564ad8f2c6689928$export$7c2a2de09ea3c4f2.isValid(this.signature);
    }
    /**
   * Creates a new Certificate instance from the provided CertificateData.
   *
   * @param {CertificateData} data - The data required to create the Certificate.
   * @return {Certificate} A new Certificate instance.
   * @throws {InvalidDataType} If the provided data is invalid:
   * - if timestamp is not a positive safe integer;
   * - if signer is not a valid address;
   * - if signature is an invalid hexadecimal expression.
   *
   * @remarks
   * This method supports {@link signer}
   * [mixed-case checksum address encoding](https://eips.ethereum.org/EIPS/eip-55).
   *
   * @see constructor
   */ static of(data) {
        try {
            return new _Certificate(data.purpose, data.payload, data.domain, data.timestamp, data.signer, data.signature);
        } catch (e) {
            throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Certificate.of", "invalid certificate data", {
                certifiable: data
            }, e);
        }
    }
    /**
   * Signs the current object using a given private key.
   *
   * The {@link signature} is computed encoding this object according
   * the following normalization rules:
   * - the {@link signature} property is ignored, because its value
   *   is the result of this method.
   * - the properties are sorted in ascending alphabetic order;
   * - the key/value properties are delimited with `"` when serialized as JSON
   *   before to be encoded as bytes;
   * - any not meaningful blank characters are ignored;
   * - the JSON representation of this object is byte encoded using the UTF-8
   *   [normalization form for canonical composition](https://en.wikipedia.org/wiki/Unicode_equivalence#Normal_forms).
   *
   * @param {Uint8Array} privateKey - The private key used for signing.
   * @return {this} The current instance after signing.
   *
   * @throws {InvalidOperation} - If a hash error occurs.
   * @throws {InvalidSecp256k1PrivateKey} - If the private key is not a valid 32-byte private key.
   *
   * @remarks Security auditable method, depends on
   * * {@link Blake2b256.of};
   * * {@link Secp256k1.sign}.
   *
   * @see encode
   * @see verify
   */ sign(privateKey) {
        this.signature = void 0;
        this.signature = $564ad8f2c6689928$export$7c2a2de09ea3c4f2.of($564ad8f2c6689928$export$4807b1fbad07ca78.sign($564ad8f2c6689928$export$d2458fb5f52b75a6.of(_Certificate.encode(this)).bytes, privateKey)).toString();
        return this;
    }
    /**
   * Verifies the certificate by checking its signature.
   *
   * @throws {CertificateSignatureMismatch} if the certificate
   * - is not signed, or
   * - the signature does not match the signer's public key.
   *
   * @remarks
   * This method supports {@link signer}
   * [mixed-case checksum address encoding](https://eips.ethereum.org/EIPS/eip-55).
   *
   * @remarks Security auditable method, depends on
   * * {@link Blake2b256.of};
   * * {@link Secp256k1.recover}.
   */ verify() {
        if (!this.isSigned()) throw new (0, $dbc5c4a080b2aff5$export$1b27f6f6c44c7f6f)("Certificate.verify", "signature missing", {
            certificate: this
        });
        const signer = $564ad8f2c6689928$export$73974d1f547d9d48.ofPublicKey($564ad8f2c6689928$export$4807b1fbad07ca78.recover($564ad8f2c6689928$export$d2458fb5f52b75a6.of(_Certificate.encode({
            ...this,
            signature: void 0
        })).bytes, $564ad8f2c6689928$export$7c2a2de09ea3c4f2.of(this.signature).bytes));
        if (signer.toString().toLowerCase() !== this.signer) throw new (0, $dbc5c4a080b2aff5$export$1b27f6f6c44c7f6f)("Certificate.verify", "signature doesn't match with signer's public key", {
            certificate: this
        });
    }
};
// src/keystore/cryptography/ethers/const/keystore.ts
var $564ad8f2c6689928$var$SCRYPT_PARAMS = {
    N: 131072,
    r: 8,
    p: 1
};
// src/keystore/cryptography/ethers/keystore.ts
async function $564ad8f2c6689928$var$encrypt(privateKey, password) {
    const derivePublicKey = $564ad8f2c6689928$export$4807b1fbad07ca78.derivePublicKey(privateKey);
    const deriveAddress = $564ad8f2c6689928$export$73974d1f547d9d48.ofPublicKey(derivePublicKey).toString();
    const keystoreAccount = {
        address: deriveAddress,
        privateKey: $564ad8f2c6689928$export$7c2a2de09ea3c4f2.of(privateKey).toString()
    };
    const encryptOptions = {
        scrypt: {
            N: $564ad8f2c6689928$var$SCRYPT_PARAMS.N,
            r: $564ad8f2c6689928$var$SCRYPT_PARAMS.r,
            p: $564ad8f2c6689928$var$SCRYPT_PARAMS.p
        }
    };
    const keystoreJsonString = await (0, $75de98094ef1e4ed$re_export$ethers).encryptKeystoreJson(keystoreAccount, password, encryptOptions);
    return JSON.parse(keystoreJsonString);
}
async function $564ad8f2c6689928$var$decrypt(keystore4, password) {
    if (!$564ad8f2c6689928$var$isValid(keystore4)) throw new (0, $dbc5c4a080b2aff5$export$8324255666e439a9)("keystore.decrypt()", "Invalid keystore. Ensure the keystore is properly formatted and contains the necessary data.", {
        keystore: keystore4
    });
    try {
        return await (0, $75de98094ef1e4ed$re_export$ethers).decryptKeystoreJson((0, $dbc5c4a080b2aff5$export$d0f957c4a26c5e4e)(keystore4), password);
    } catch (e) {
        throw new (0, $dbc5c4a080b2aff5$export$b37f7abe5580d6c3)("keystore.decrypt()", "Decryption failed: Invalid Password for the given keystore.", // @NOTE: We are not exposing the password in the error data for security reasons.
        {
            keystore: keystore4
        });
    }
}
function $564ad8f2c6689928$var$isValid(keystore4) {
    return (0, $75de98094ef1e4ed$re_export$ethers).isKeystoreJson((0, $dbc5c4a080b2aff5$export$d0f957c4a26c5e4e)(keystore4));
}
var $564ad8f2c6689928$var$keystore = {
    encrypt: $564ad8f2c6689928$var$encrypt,
    decrypt: $564ad8f2c6689928$var$decrypt,
    isValid: $564ad8f2c6689928$var$isValid
};
var $564ad8f2c6689928$var$KEYSTORE_CRYPTO_CIPHER = "aes-128-ctr";
var $564ad8f2c6689928$var$KEYSTORE_CRYPTO_PARAMS_DKLEN = 32;
var $564ad8f2c6689928$var$KEYSTORE_CRYPTO_KDF = "scrypt";
var $564ad8f2c6689928$var$KEYSTORE_VERSION = 3;
var $564ad8f2c6689928$var$SCRYPT_PARAMS2 = {
    N: 131072,
    r: 8,
    p: 1
};
function $564ad8f2c6689928$var$decodeScryptParams(keystore4) {
    const salt = $esaJO.hexToBytes(keystore4.crypto.kdfparams.salt);
    const N = keystore4.crypto.kdfparams.n;
    const r = keystore4.crypto.kdfparams.r;
    const p = keystore4.crypto.kdfparams.p;
    if (N <= 0 || (N & N - 1) !== 0) throw new (0, $dbc5c4a080b2aff5$export$b37f7abe5580d6c3)("(EXPERIMENTAL) keystore.decodeScryptParams()", "Decryption failed: invalid  keystore.crypto.kdfparams.n parameter.", {
        keystore: keystore4,
        N: N
    });
    if (r <= 0 || p <= 0) throw new (0, $dbc5c4a080b2aff5$export$b37f7abe5580d6c3)("(EXPERIMENTAL) keystore.decodeScryptParams()", "Decryption failed: both keystore.crypto.kdfparams.r or keystore.crypto.kdfparams.p parameter must be > 0.", {
        keystore: keystore4,
        r: r,
        p: p
    });
    const dkLen = keystore4.crypto.kdfparams.dklen;
    if (dkLen !== $564ad8f2c6689928$var$KEYSTORE_CRYPTO_PARAMS_DKLEN) throw new (0, $dbc5c4a080b2aff5$export$b37f7abe5580d6c3)("(EXPERIMENTAL) keystore.decodeScryptParams()", `Decryption failed: keystore.crypto.kdfparams.dklen parameter must be ${$564ad8f2c6689928$var$KEYSTORE_CRYPTO_PARAMS_DKLEN}`, {
        keystore: keystore4,
        dkLen: dkLen
    });
    return {
        N: N,
        dkLen: $564ad8f2c6689928$var$KEYSTORE_CRYPTO_PARAMS_DKLEN,
        name: $564ad8f2c6689928$var$KEYSTORE_CRYPTO_KDF,
        p: p,
        r: r,
        salt: salt
    };
}
function $564ad8f2c6689928$var$encodeScryptParams(options) {
    const salt = options.salt ?? $564ad8f2c6689928$export$4807b1fbad07ca78.randomBytes($564ad8f2c6689928$var$KEYSTORE_CRYPTO_PARAMS_DKLEN);
    let N = $564ad8f2c6689928$var$SCRYPT_PARAMS2.N;
    let r = $564ad8f2c6689928$var$SCRYPT_PARAMS2.r;
    let p = $564ad8f2c6689928$var$SCRYPT_PARAMS2.p;
    if (options.scrypt != null) {
        if (options.scrypt.N != null) N = options.scrypt.N;
        if (options.scrypt.r != null) r = options.scrypt.r;
        if (options.scrypt.p != null) p = options.scrypt.p;
    }
    if (N <= 0 || (BigInt(N) & BigInt(N - 1)) !== BigInt(0)) throw new (0, $dbc5c4a080b2aff5$export$b37f7abe5580d6c3)("(EXPERIMENTAL) keystore.encodeScryptParams()", "Encryption failed: invalid options.scrypt.N parameter.", {
        options: options,
        N: N
    });
    if (r <= 0 || !Number.isSafeInteger(r)) throw new (0, $dbc5c4a080b2aff5$export$b37f7abe5580d6c3)("(EXPERIMENTAL) keystore.encodeScryptParams()", "Encryption failed: invalid options.scrypt.r parameter.", {
        options: options,
        r: r
    });
    if (p <= 0 || !Number.isSafeInteger(p)) throw new (0, $dbc5c4a080b2aff5$export$b37f7abe5580d6c3)("(EXPERIMENTAL) keystore.encodeScryptParams()", "Encryption failed: invalid options.scrypt.p parameter.", {
        options: options,
        p: p
    });
    return {
        name: $564ad8f2c6689928$var$KEYSTORE_CRYPTO_KDF,
        dkLen: $564ad8f2c6689928$var$KEYSTORE_CRYPTO_PARAMS_DKLEN,
        N: N,
        p: p,
        r: r,
        salt: salt
    };
}
function $564ad8f2c6689928$var$encrypt2(privateKey, password) {
    return $564ad8f2c6689928$var$encryptKeystore(privateKey, password, {
        scrypt: {
            N: $564ad8f2c6689928$var$SCRYPT_PARAMS2.N,
            r: $564ad8f2c6689928$var$SCRYPT_PARAMS2.r,
            p: $564ad8f2c6689928$var$SCRYPT_PARAMS2.p
        }
    });
}
function $564ad8f2c6689928$var$encryptKeystore(privateKey, password, options) {
    try {
        const kdf = $564ad8f2c6689928$var$encodeScryptParams(options);
        const key = (0, $dd94f1d283dd7b2d$exports.scrypt)(password, kdf.salt, {
            N: kdf.N,
            r: kdf.r,
            p: kdf.p,
            dkLen: kdf.dkLen
        });
        const iv = options.iv ?? $564ad8f2c6689928$export$4807b1fbad07ca78.randomBytes(16);
        if (iv.length !== 16) throw new (0, $dbc5c4a080b2aff5$export$b37f7abe5580d6c3)("(EXPERIMENTAL) keystore.encryptKeystore()", "Encryption failed: invalid options.iv length.", {
            iv: iv
        });
        const uuidRandom = options.uuid ?? $564ad8f2c6689928$export$4807b1fbad07ca78.randomBytes(16);
        if (uuidRandom.length !== 16) throw new (0, $dbc5c4a080b2aff5$export$b37f7abe5580d6c3)("(EXPERIMENTAL) keystore.encryptKeystore()", "Encryption failed: invalid options.uuid length.", {
            uuidRandom: uuidRandom
        });
        const macPrefix = key.slice(16, 32);
        const ciphertext = (0, $2d0e1e19edfeea80$exports.ctr)(key.slice(0, 16), iv).encrypt(privateKey);
        return {
            address: $564ad8f2c6689928$export$73974d1f547d9d48.ofPrivateKey(privateKey).toString(),
            crypto: {
                cipher: $564ad8f2c6689928$var$KEYSTORE_CRYPTO_CIPHER,
                cipherparams: {
                    iv: $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(iv).digits
                },
                ciphertext: $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(ciphertext).digits,
                kdf: "scrypt",
                kdfparams: {
                    dklen: $564ad8f2c6689928$var$KEYSTORE_CRYPTO_PARAMS_DKLEN,
                    n: kdf.N,
                    p: kdf.p,
                    r: kdf.r,
                    salt: $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(kdf.salt).digits
                },
                // Compute the message authentication code, used to check the password.
                mac: $564ad8f2c6689928$export$83afadb7dd1667bc.of($esaJO.concatBytes(macPrefix, ciphertext)).digits
            },
            id: $564ad8f2c6689928$var$uuidV4(uuidRandom),
            version: $564ad8f2c6689928$var$KEYSTORE_VERSION
        };
    } finally{
        privateKey.fill(0);
        password.fill(0);
    }
}
function $564ad8f2c6689928$var$decrypt2(keystore4, password) {
    return $564ad8f2c6689928$var$decryptKeystore(keystore4, password);
}
function $564ad8f2c6689928$var$decryptKeystore(keystore4, password) {
    try {
        if (keystore4.crypto.cipher.toLowerCase() !== $564ad8f2c6689928$var$KEYSTORE_CRYPTO_CIPHER) throw new (0, $dbc5c4a080b2aff5$export$b37f7abe5580d6c3)("(EXPERIMENTAL) keystore.decryptKeystore()", "Decryption failed: unsupported crypto cipher algorithm.", {
            cipher: keystore4.crypto.cipher.toLowerCase()
        });
        if (keystore4.crypto.kdf.toLowerCase() !== $564ad8f2c6689928$var$KEYSTORE_CRYPTO_KDF) throw new (0, $dbc5c4a080b2aff5$export$b37f7abe5580d6c3)("(EXPERIMENTAL) keystore.decryptKeystore()", "Decryption failed: unsupported crypto key derivation function.", {
            keyDerivationFunction: keystore4.crypto.kdf.toLowerCase()
        });
        if (keystore4.version !== $564ad8f2c6689928$var$KEYSTORE_VERSION) throw new (0, $dbc5c4a080b2aff5$export$b37f7abe5580d6c3)("(EXPERIMENTAL) keystore.decryptKeystore()", "Decryption failed: unsupported keystore version.", {
            version: keystore4.version
        });
        const kdf = $564ad8f2c6689928$var$decodeScryptParams(keystore4);
        const key = (0, $dd94f1d283dd7b2d$exports.scrypt)(password, kdf.salt, {
            N: kdf.N,
            r: kdf.r,
            p: kdf.p,
            dkLen: kdf.dkLen
        });
        const ciphertext = $esaJO.hexToBytes(keystore4.crypto.ciphertext);
        if (keystore4.crypto.mac !== $564ad8f2c6689928$export$83afadb7dd1667bc.of($esaJO.concatBytes(key.slice(16, 32), ciphertext)).digits) throw new (0, $dbc5c4a080b2aff5$export$b37f7abe5580d6c3)("(EXPERIMENTAL) keystore.decryptKeystore()", "Decryption failed: Invalid Password for the given keystore.", // @NOTE: We are not exposing the password in the error data for security reasons.
        {
            keystore: keystore4
        });
        const privateKey = (0, $2d0e1e19edfeea80$exports.ctr)(key.slice(0, 16), $esaJO.hexToBytes(keystore4.crypto.cipherparams.iv)).decrypt(ciphertext);
        const address = $564ad8f2c6689928$export$73974d1f547d9d48.ofPrivateKey(privateKey).toString();
        if (keystore4.address !== "" && address !== $564ad8f2c6689928$export$73974d1f547d9d48.checksum($564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(keystore4.address))) throw new (0, $dbc5c4a080b2aff5$export$b37f7abe5580d6c3)("(EXPERIMENTAL) keystore.decryptKeystore()", "Decryption failed: address/password mismatch.", {
            keystoreAddress: keystore4.address
        });
        return {
            address: address,
            // @note: Convert the private key to a string to be compatible with ethers
            privateKey: $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(privateKey).toString()
        };
    } finally{
        password.fill(0);
    }
}
function $564ad8f2c6689928$var$isValid2(keystore4) {
    try {
        const copy = JSON.parse((0, $dbc5c4a080b2aff5$export$d0f957c4a26c5e4e)(keystore4));
        if (copy.crypto.cipher.toLowerCase() === $564ad8f2c6689928$var$KEYSTORE_CRYPTO_CIPHER && copy.crypto.kdf.toLowerCase() === $564ad8f2c6689928$var$KEYSTORE_CRYPTO_KDF && copy.version === $564ad8f2c6689928$var$KEYSTORE_VERSION) return true;
    } catch (e) {}
    return false;
}
function $564ad8f2c6689928$var$uuidV4(bytes) {
    bytes[6] = bytes[6] & 15 | 64;
    bytes[8] = bytes[8] & 63 | 128;
    const value = $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(bytes).digits;
    return [
        value.substring(0, 8),
        value.substring(8, 12),
        value.substring(12, 16),
        value.substring(16, 20),
        value.substring(20, 32)
    ].join("-");
}
var $564ad8f2c6689928$var$keystore2 = {
    decrypt: $564ad8f2c6689928$var$decrypt2,
    encrypt: $564ad8f2c6689928$var$encrypt2,
    isValid: $564ad8f2c6689928$var$isValid2
};
// src/keystore/keystore.ts
var $564ad8f2c6689928$var$EXPERIMENTAL_CRYPTOGRAPHY = false;
function $564ad8f2c6689928$var$useExperimentalCryptography(experimentalCryptography) {
    $564ad8f2c6689928$var$EXPERIMENTAL_CRYPTOGRAPHY = experimentalCryptography;
}
async function $564ad8f2c6689928$var$encrypt3(privateKey, password) {
    if ($564ad8f2c6689928$var$EXPERIMENTAL_CRYPTOGRAPHY) (0, $4e5b5d36d7595504$export$924d43bf16eee9cc)("warning").log({
        title: `Experimental cryptography`,
        messages: [
            `Remember, you are using an experimental cryptography library.`,
            "functions: keystore.encrypt"
        ]
    });
    return $564ad8f2c6689928$var$EXPERIMENTAL_CRYPTOGRAPHY ? $564ad8f2c6689928$var$keystore2.encrypt(privateKey, $564ad8f2c6689928$export$1d5cbbbdccc512f9.of(password).bytes) : await $564ad8f2c6689928$var$keystore.encrypt(privateKey, password);
}
async function $564ad8f2c6689928$var$decrypt3(keystore4, password) {
    if ($564ad8f2c6689928$var$EXPERIMENTAL_CRYPTOGRAPHY) (0, $4e5b5d36d7595504$export$924d43bf16eee9cc)("warning").log({
        title: `Experimental cryptography`,
        messages: [
            `Remember, you are using an experimental cryptography library.`,
            "functions: keystore.decrypt"
        ]
    });
    return $564ad8f2c6689928$var$EXPERIMENTAL_CRYPTOGRAPHY ? $564ad8f2c6689928$var$keystore2.decrypt(keystore4, $564ad8f2c6689928$export$1d5cbbbdccc512f9.of(password).bytes) : await $564ad8f2c6689928$var$keystore.decrypt(keystore4, password);
}
function $564ad8f2c6689928$var$isValid3(keystore4) {
    if ($564ad8f2c6689928$var$EXPERIMENTAL_CRYPTOGRAPHY) (0, $4e5b5d36d7595504$export$924d43bf16eee9cc)("warning").log({
        title: `Experimental cryptography`,
        messages: [
            `Remember, you are using an experimental cryptography library.`,
            "functions: keystore.isValid"
        ]
    });
    return $564ad8f2c6689928$var$EXPERIMENTAL_CRYPTOGRAPHY ? $564ad8f2c6689928$var$keystore2.isValid(keystore4) : $564ad8f2c6689928$var$keystore.isValid(keystore4);
}
var $564ad8f2c6689928$export$fc6a5346165a11f2 = {
    encrypt: $564ad8f2c6689928$var$encrypt3,
    decrypt: $564ad8f2c6689928$var$decrypt3,
    isValid: $564ad8f2c6689928$var$isValid3,
    useExperimentalCryptography: $564ad8f2c6689928$var$useExperimentalCryptography
};
// src/utils/const/abi.ts
var $564ad8f2c6689928$export$89843982d7e60b14 = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "allowance",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256"
            }
        ],
        name: "ERC20InsufficientAllowance",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256"
            }
        ],
        name: "ERC20InsufficientBalance",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "approver",
                type: "address"
            }
        ],
        name: "ERC20InvalidApprover",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "ERC20InvalidReceiver",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            }
        ],
        name: "ERC20InvalidSender",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            }
        ],
        name: "ERC20InvalidSpender",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];
var $564ad8f2c6689928$export$364c28d882341a8a = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "ERC721IncorrectOwner",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ERC721InsufficientApproval",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "approver",
                type: "address"
            }
        ],
        name: "ERC721InvalidApprover",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "ERC721InvalidOperator",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "ERC721InvalidOwner",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "ERC721InvalidReceiver",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            }
        ],
        name: "ERC721InvalidSender",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ERC721NonexistentToken",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "mintItem",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
var $564ad8f2c6689928$export$b49cca313196bde1 = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]"
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]"
            }
        ],
        name: "TransferBatch",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "TransferSingle",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "value",
                type: "string"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "id",
                type: "uint256"
            }
        ],
        name: "URI",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "accounts",
                type: "address[]"
            },
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]"
            }
        ],
        name: "balanceOfBatch",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]"
            },
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeBatchTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256"
            }
        ],
        name: "uri",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
var $564ad8f2c6689928$export$b88e3c60e3a2c614 = $564ad8f2c6689928$export$89843982d7e60b14;
var $564ad8f2c6689928$export$2f934eae26d73cbf = $564ad8f2c6689928$export$364c28d882341a8a;
var $564ad8f2c6689928$export$d6edb80a15697662 = $564ad8f2c6689928$export$b49cca313196bde1;
// src/utils/const/data.ts
var $564ad8f2c6689928$export$1e076aab5837ca50 = (size)=>new Uint8Array(size);
var $564ad8f2c6689928$export$a86766d7e0fe156e = /(^-?\d+(\.\d+)?)$|(^-?\.\d+)$/;
var $564ad8f2c6689928$var$decodeBytes32String = (hex)=>{
    if (!$564ad8f2c6689928$export$9ccf03a0aa23a1ca.isValid(hex) || $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(hex).digits.length !== 64) throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("dataUtils.decodeBytes32String()", `Failed to decode value ${hex} to string. Value is not a valid hex string or it is not 64 characters long`, {
        value: hex
    });
    const valueInBytes = $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of(hex).bytes;
    const firstZeroIndex = valueInBytes.findIndex((byte)=>byte === 0);
    if (firstZeroIndex === 0) {
        const firstNotZeroIndex = valueInBytes.findIndex((byte)=>byte !== 0);
        return $564ad8f2c6689928$export$1d5cbbbdccc512f9.of(valueInBytes.subarray(firstNotZeroIndex)).toString();
    } else if (firstZeroIndex !== -1) return $564ad8f2c6689928$export$1d5cbbbdccc512f9.of(valueInBytes.subarray(0, firstZeroIndex)).toString();
    else return $564ad8f2c6689928$export$1d5cbbbdccc512f9.of(valueInBytes).toString();
};
var $564ad8f2c6689928$var$encodeBytes32String = (value, zeroPadding = "right")=>{
    try {
        const valueInBytes = $564ad8f2c6689928$export$1d5cbbbdccc512f9.of(value).bytes;
        if (valueInBytes.length > 32) throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("dataUtils.encodeBytes32String()", `Failed to encode value ${value} to bytes32 string. Value exceeds 32 bytes.`, {
            value: value
        });
        const pad = $564ad8f2c6689928$export$1e076aab5837ca50(32 - valueInBytes.length);
        return zeroPadding === "left" ? $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of($esaJO.concatBytes(pad, valueInBytes)).toString() : $564ad8f2c6689928$export$9ccf03a0aa23a1ca.of($esaJO.concatBytes(valueInBytes, pad)).toString();
    } catch (e) {
        throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("dataUtils.encodeBytes32String()", `Failed to encode value ${value} to bytes32 string.`, {
            value: value
        }, e);
    }
};
var $564ad8f2c6689928$export$b48793c3df80d83a = {
    decodeBytes32String: $564ad8f2c6689928$var$decodeBytes32String,
    encodeBytes32String: $564ad8f2c6689928$var$encodeBytes32String
};
var $564ad8f2c6689928$export$af2fe57fe6540b02 = class _Clause {
    /**
   * Used internally in {@link Clause.callFunction}.
   */ static FORMAT_TYPE = "json";
    /**
   * Used internally to tag a transaction not tranferring token amount.
   */ static NO_VALUE = $564ad8f2c6689928$export$9ccf03a0aa23a1ca.PREFIX + "0";
    /**
   * Used internally to tag a transaction without data.
   */ static NO_DATA = $564ad8f2c6689928$export$9ccf03a0aa23a1ca.PREFIX;
    /**
   * Used internally in {@link Clause.transferNFT} method.
   */ static TRANSFER_NFT_FUNCTION = "transferFrom";
    /**
   * Used internally in {@link Clause.transferToken} method.
   */ static TRANSFER_TOKEN_FUNCTION = "transfer";
    /**
   * Represents the address where:
   * - transfer token to, or
   * - invoke contract method on.
   */ to;
    /**
   * Return the hexadecimal expression of the amount of VET or VTHO
   * token in {@link Units.wei} to transfer to the destination.
   *
   * @see {Clause.callFunction}
   * @see {Clause.transferToken}
   * @see {Clause.transferVET}
   */ value;
    /**
   * Return the hexadecimal expression of the encoding of the arguments
   * of the called function of a smart contract.
   */ data;
    /**
   * An optional comment to describe the purpose of the clause.
   */ comment;
    /**
   * An optional  Application Binary Interface (ABI) of the called
   * function of a smart contract.
   */ abi;
    /**
   * Creates an instance of the class.
   *
   * @param {string|null} to - The address to transfer token
   * or the smart contract to call, can be null.
   * @param {string} value - The token amount being transferred in wei units
   * as hexadecimal expression.
   * @param {string} data - Arguments of the smart contract function called
   * as encoded as a hexadecimal expression
   * @param {string} [comment] - An optional comment.
   * @param {string} [abi] - An optional ABI string.
   */ constructor(to, value, data, comment, abi){
        this.to = to;
        this.value = value;
        this.data = data;
        this.comment = comment;
        this.abi = abi;
    }
    /**
   * Return the amount of {@link VET} or {@link VTHO} token
   * in {@link Units.wei} to transfer to the destination.
   *
   * @return {FixedPointNumber} The amount as a fixed-point number.
   */ amount() {
        return $564ad8f2c6689928$export$3dede3b6cc153eb5.of($564ad8f2c6689928$export$8cd63f50dbdefc2e.of(this.value).bi);
    }
    /**
   * Return a new clause to call a function of a smart contract.
   *
   * @param {Address} contractAddress - The address of the smart contract.
   * @param {ABIFunction} functionAbi - The ABI definition of the function to be called.
   * @param {unknown[]} args - The arguments for the function.
   * @param {VET} [amount=VET.of(FixedPointNumber.ZERO)] - The amount of VET to be sent with the transaction calling the function.
   * @param {ClauseOptions} [clauseOptions] - Optional clause settings.
   * @return {Clause} A clause object to call the function in a transaction.
   * @throws {InvalidDataType} Throws an error if the amount is not a finite positive value.
   */ static callFunction(contractAddress, functionAbi, args, amount = $564ad8f2c6689928$export$ae9c3c05238a9d5d.of($564ad8f2c6689928$export$3dede3b6cc153eb5.ZERO), clauseOptions) {
        if (amount.value.isFinite() && amount.value.isPositive()) return new _Clause(contractAddress.toString().toLowerCase(), $564ad8f2c6689928$export$9ccf03a0aa23a1ca.PREFIX + amount.wei.toString($564ad8f2c6689928$export$9ccf03a0aa23a1ca.RADIX), functionAbi.encodeData(args).toString(), clauseOptions?.comment, clauseOptions?.includeABI === true ? functionAbi.format(_Clause.FORMAT_TYPE) : void 0);
        throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Clause.callFunction", "not finite positive amount", {
            amount: `${amount.value}`
        });
    }
    /**
   * Returns a new clause to deploy a smart contract.
   *
   * @param {HexUInt} contractBytecode - The bytecode of the contract to be deployed.
   * @param {DeployParams} [deployParams] - Optional parameters to pass to the smart contract constructor.
   * @param {ClauseOptions} [clauseOptions] - Optional clause settings.
   * @return {Clause} The clause to deploy the smart contract as part of a transaction.
   */ static deployContract(contractBytecode, deployParams, clauseOptions) {
        const data = deployParams !== null && deployParams !== void 0 ? contractBytecode.digits + $564ad8f2c6689928$export$3de1df63de3dd8b4.encodeParams(deployParams.types, deployParams.values).replace($564ad8f2c6689928$export$9ccf03a0aa23a1ca.PREFIX, "") : contractBytecode.digits;
        return new _Clause(null, _Clause.NO_VALUE, $564ad8f2c6689928$export$9ccf03a0aa23a1ca.PREFIX + data, clauseOptions?.comment);
    }
    /**
   * Transfers an NFT from the sender to the recipient.
   *
   * @param {Address} contractAddress - The address of the NFT contract.
   * @param {Address} senderAddress - The address of the current owner (sender) of the NFT.
   * @param {Address} recipientAddress - The address of the new owner (recipient) of the NFT.
   * @param {HexUInt} tokenId - The unique identifier of the NFT to be transferred.
   * @param {ClauseOptions} [clauseOptions] - Optional clause settings.
   * @return {Clause} The clause object representing the transfer operation as part of a transaction.
   */ static transferNFT(contractAddress, senderAddress, recipientAddress, tokenId, clauseOptions) {
        return _Clause.callFunction(contractAddress, $564ad8f2c6689928$export$c64f24a8950c1687.ofAbi($564ad8f2c6689928$export$364c28d882341a8a).getFunction(_Clause.TRANSFER_NFT_FUNCTION), [
            senderAddress.toString(),
            recipientAddress.toString(),
            tokenId.bi.toString()
        ], void 0, clauseOptions);
    }
    /**
   * Return a new clause to transfers the specified amount of
   * [VIP180](https://docs.vechain.org/introduction-to-vechain/dual-token-economic-model/vethor-vtho#vip180-vechains-fungible-token-standard)
   * token.
   *
   * @param {Address} tokenAddress - The address of the VIP180 token.
   * @param {Address} recipientAddress - The address of the recipient.
   * @param {VTHO} amount - The amount of token to be transferred.
   * @param {ClauseOptions} [clauseOptions] - Optional clause settings.
   * @return {Clause} The clause to transfer VIP180 tokens as part of a transaction.
   * @throws {InvalidDataType} Throws an error if the amount is not a positive integer.
   *
   * @see VTHO.transferTokenTo
   */ static transferToken(tokenAddress, recipientAddress, amount, clauseOptions) {
        if (amount.value.isFinite() && amount.value.isPositive()) return this.callFunction(tokenAddress, $564ad8f2c6689928$export$c64f24a8950c1687.ofAbi($564ad8f2c6689928$export$b88e3c60e3a2c614).getFunction(_Clause.TRANSFER_TOKEN_FUNCTION), [
            recipientAddress.toString(),
            amount.wei
        ], void 0, clauseOptions);
        throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Clause.transferToken", "not positive integer amount", {
            amount: `${amount.value}`
        });
    }
    /**
   * Return a new clause to transfers VET to a specified recipient address.
   *
   * @param {Address} recipientAddress - The address of the recipient.
   * @param {VET} amount - The amount of VET to transfer.
   * @param {ClauseOptions} [clauseOptions] - Optional clause settings.
   * @return {Clause} - The clause object to transfer VET as part of a transaction.
   * @throws {InvalidDataType} - If the amount is not a finite positive value.
   *
   * @see VET.transferTo
   */ static transferVET(recipientAddress, amount, clauseOptions) {
        if (amount.value.isFinite() && amount.value.isPositive()) return new _Clause(recipientAddress.toString().toLowerCase(), $564ad8f2c6689928$export$9ccf03a0aa23a1ca.PREFIX + amount.wei.toString($564ad8f2c6689928$export$9ccf03a0aa23a1ca.RADIX), _Clause.NO_DATA, clauseOptions?.comment);
        throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Clause.transferVET", "not finite positive amount", {
            amount: `${amount.value}`
        });
    }
};
var $564ad8f2c6689928$export$febc5573c75cefb0 = class _Transaction {
    /**
   * Represent the block reference length in bytes.
   */ static BLOCK_REF_LENGTH = 8;
    /**
   * A collection of constants used for gas calculations in transactions.
   *
   * Properties
   * - `TX_GAS` - The base gas cost for a transaction.
   * - `CLAUSE_GAS` - The gas cost for executing a clause in a transaction.
   * - `CLAUSE_GAS_CONTRACT_CREATION` - The gas cost for creating a contract via a clause.
   * - `ZERO_GAS_DATA` - The gas cost for transmitting zero bytes of data.
   * - `NON_ZERO_GAS_DATA` - The gas cost for transmitting non-zero bytes of data.
   */ static GAS_CONSTANTS = {
        TX_GAS: 5000n,
        CLAUSE_GAS: 16000n,
        CLAUSE_GAS_CONTRACT_CREATION: 48000n,
        ZERO_GAS_DATA: 4n,
        NON_ZERO_GAS_DATA: 68n
    };
    /**
   * RLP_FIELDS is an array of objects that defines the structure and encoding scheme
   * for various components in a transaction using Recursive Length Prefix (RLP) encoding.
   * Each object in the array represents a field in the transaction, specifying its name and kind.
   * The `kind` attribute is an instance of an RLP coder that determines how the field is encoded.
   *
   * Properties
   * - `chainTag` - Represent the id of the chain the transaction is sent to.
   * - `blockRef` - Represent the last block of the chain the transaction is sent to.
   * - `expiration` -  Represent the expiration date of the transaction.
   * - `clauses` - List of clause objects, each containing:
   *   - `to` - Represent the destination of the transaction.
   *   - `value` - Represent the 'wei' quantity (VET or VTHO) value the transaction is worth.
   *   - `data` - Represent the content of the transaction.
   * - `gasPriceCoef` - Represent the gas price coefficient of the transaction.
   * - `gas` - Represent the gas limit of the transaction.
   * - `dependsOn` - Represent the hash of the transaction the current transaction depends on.
   * - `nonce` - Represent the nonce of the transaction.
   * - `reserved` -  Reserved field.
   */ static RLP_FIELDS = [
        {
            name: "chainTag",
            kind: new $564ad8f2c6689928$export$16dfabb5959ce479(1)
        },
        {
            name: "blockRef",
            kind: new $564ad8f2c6689928$export$d307fa5bdcfc61d4(8)
        },
        {
            name: "expiration",
            kind: new $564ad8f2c6689928$export$16dfabb5959ce479(4)
        },
        {
            name: "clauses",
            kind: {
                item: [
                    {
                        name: "to",
                        kind: new $564ad8f2c6689928$export$4a5ff240fb77900(20)
                    },
                    {
                        name: "value",
                        kind: new $564ad8f2c6689928$export$16dfabb5959ce479(32)
                    },
                    {
                        name: "data",
                        kind: new $564ad8f2c6689928$export$f32667dbae7bc3ad()
                    }
                ]
            }
        },
        {
            name: "gasPriceCoef",
            kind: new $564ad8f2c6689928$export$16dfabb5959ce479(1)
        },
        {
            name: "gas",
            kind: new $564ad8f2c6689928$export$16dfabb5959ce479(8)
        },
        {
            name: "dependsOn",
            kind: new $564ad8f2c6689928$export$4a5ff240fb77900(32)
        },
        {
            name: "nonce",
            kind: new $564ad8f2c6689928$export$16dfabb5959ce479(8)
        },
        {
            name: "reserved",
            kind: {
                item: new $564ad8f2c6689928$export$1183026c469db464()
            }
        }
    ];
    /**
   * Represent the Recursive Length Prefix (RLP) of the transaction features.
   *
   * Properties
   * - `name` - A string indicating the name of the field in the RLP structure.
   * - `kind` - RLP profile type.
   */ static RLP_FEATURES = {
        name: "reserved.features",
        kind: new $564ad8f2c6689928$export$16dfabb5959ce479(4)
    };
    /**
   * Represents a Recursive Length Prefix (RLP) of the transaction signature.
   *
   * Properties
   * - `name` - A string indicating the name of the field in the RLP structure.
   * - `kind` - RLP profile type.
   */ static RLP_SIGNATURE = {
        name: "signature",
        kind: new $564ad8f2c6689928$export$1183026c469db464()
    };
    /**
   * Represents a Recursive Length Prefix (RLP) of the signed transaction.
   *
   * Properties
   * - `name` - A string indicating the name of the field in the RLP structure.
   * - `kind` - RLP profile type.
   */ static RLP_SIGNED_TRANSACTION_PROFILE = {
        name: "tx",
        kind: _Transaction.RLP_FIELDS.concat([
            _Transaction.RLP_SIGNATURE
        ])
    };
    /**
   * Represents a Recursive Length Prefix (RLP) of the unsigned transaction.
   *
   * Properties
   * - `name` - A string indicating the name of the field in the RLP structure.
   * - `kind` - RLP profile type.
   */ static RLP_UNSIGNED_TRANSACTION_PROFILE = {
        name: "tx",
        kind: _Transaction.RLP_FIELDS
    };
    /**
   * It represents the content of the transaction.
   */ body;
    /**
   * It represents the signature of the transaction content.
   */ signature;
    /**
   * Creates a new instance of the class with the specified transaction body and optional signature.
   *
   * @param {TransactionBody} body The transaction body to be used.
   * @param {Uint8Array} [signature] The optional signature for the transaction.
   */ constructor(body, signature){
        this.body = body;
        this.signature = signature;
    }
    // ********** GET COMPUTED PROPERTIES **********
    /**
   * Get the delegator's address if the transaction is delegated.
   *
   * If the transaction is delegated and a signature is available, this method recovers
   * the delegator parameter from the signature and subsequently recovers the delegator's public key
   * to derive the delegator's address.
   *
   * @return {Address} The address of the delegator.
   * @throws {UnavailableTransactionField} If the transaction is delegated but the signature is missing.
   * @throws {NotDelegatedTransaction} If the transaction is not delegated.
   *
   * @remarks Security auditable method, depends on
   * - {@link Address.ofPublicKey};
   * - {@link Secp256k1.recover};
   * - {@link Transaction.getSignatureHash}.
   */ get delegator() {
        if (this.isDelegated) {
            if (this.signature !== void 0) {
                const delegator = this.signature.slice($564ad8f2c6689928$export$4807b1fbad07ca78.SIGNATURE_LENGTH, this.signature.length);
                const delegatorPublicKey = $564ad8f2c6689928$export$4807b1fbad07ca78.recover(this.getSignatureHash(this.origin).bytes, delegator);
                return $564ad8f2c6689928$export$73974d1f547d9d48.ofPublicKey(delegatorPublicKey);
            }
            throw new (0, $dbc5c4a080b2aff5$export$9837e391a96a1f54)("Transaction.delegator()", "missing delegator", {
                fieldName: "delegator"
            });
        }
        throw new (0, $dbc5c4a080b2aff5$export$3417a5e4a3dd8321)("Transaction.delegator()", "not delegated transaction", void 0);
    }
    /**
   * Get the encoded bytes as a Uint8Array.
   * The encoding is determined by whether the data is signed.
   *
   * @return {Uint8Array} The encoded byte array.
   *
   * @see decode
   */ get encoded() {
        return this.encode(this.isSigned);
    }
    /**
   * Get transaction ID.
   *
   * The ID is the Blake2b256 hash of the transaction's signature
   * concatenated with the origin's address.
   * If the transaction is not signed,
   * it throws an UnavailableTransactionField error.
   *
   * @return {Blake2b256} The concatenated hash of the signature
   * and origin if the transaction is signed.
   * @throws {UnavailableTransactionField} If the transaction is not signed.
   *
   * @remarks Security auditable method, depends on
   * - {@link Blake2b256.of}
   */ get id() {
        if (this.isSigned) return $564ad8f2c6689928$export$d2458fb5f52b75a6.of($esaJO.concatBytes(this.getSignatureHash().bytes, this.origin.bytes));
        throw new (0, $dbc5c4a080b2aff5$export$9837e391a96a1f54)("Transaction.id()", "not signed transaction: id unavailable", {
            fieldName: "id"
        });
    }
    /**
   * Return the intrinsic gas required for this transaction.
   *
   * @return {VTHO} The computed intrinsic gas for the transaction.
   */ get intrinsicGas() {
        return _Transaction.intrinsicGas(this.body.clauses);
    }
    /**
   * Returns `true` if the transaction is delegated, otherwise `false`.
   *
   * @return {boolean} `true` if the transaction is delegated,
   * otherwise `false`.
   */ get isDelegated() {
        return _Transaction.isDelegated(this.body);
    }
    /**
   * Return `true` if the signature is defined, otherwise `false`.
   *
   * @return {boolean} return `true` if the signature is defined, otherwise `false`.
   */ get isSigned() {
        return this.signature !== void 0;
    }
    /**
   * Return the origin address of the transaction.
   *
   * The origin is determined by recovering the public key from the transaction's signature.
   *
   * @return {Address} The address derived from the public key of the transaction's signer.
   * @throws {UnavailableTransactionField} If the transaction is not signed, an exception is thrown indicating the absence of the origin field.
   *
   * @remarks Security auditable method, depends on
   * - {@link Address.ofPublicKey};
   * - {@link Secp256k1.recover}.
   */ get origin() {
        if (this.signature !== void 0) return $564ad8f2c6689928$export$73974d1f547d9d48.ofPublicKey(// Get the origin public key.
        $564ad8f2c6689928$export$4807b1fbad07ca78.recover(this.getSignatureHash().bytes, // Get the (r, s) of ECDSA digital signature without delegator params.
        this.signature.slice(0, $564ad8f2c6689928$export$4807b1fbad07ca78.SIGNATURE_LENGTH)));
        throw new (0, $dbc5c4a080b2aff5$export$9837e391a96a1f54)("Transaction.origin()", "not signed transaction, no origin", {
            fieldName: "origin"
        });
    }
    // ********** PUBLIC METHODS **********
    /**
   * Decodes a raw transaction byte array into a new Transaction object.
   *
   * @param {Uint8Array} rawTransaction - The raw transaction bytes to decode.
   * @param {boolean} isSigned - Flag indicating if the transaction is signed.
   * @return {Transaction} The decoded transaction object.
   *
   * @see encoded
   */ static decode(rawTransaction, isSigned) {
        const profile = isSigned ? _Transaction.RLP_SIGNED_TRANSACTION_PROFILE : _Transaction.RLP_UNSIGNED_TRANSACTION_PROFILE;
        const decodedRLPBody = $564ad8f2c6689928$export$5011fcbb6c0dc14a.ofObjectEncoded(rawTransaction, profile).object;
        const bodyWithoutReservedField = {
            blockRef: decodedRLPBody.blockRef,
            chainTag: decodedRLPBody.chainTag,
            clauses: decodedRLPBody.clauses,
            dependsOn: decodedRLPBody.dependsOn,
            expiration: decodedRLPBody.expiration,
            gas: decodedRLPBody.gas,
            gasPriceCoef: decodedRLPBody.gasPriceCoef,
            nonce: decodedRLPBody.nonce
        };
        const correctTransactionBody = decodedRLPBody.reserved.length > 0 ? {
            ...bodyWithoutReservedField,
            reserved: _Transaction.decodeReservedField(decodedRLPBody.reserved)
        } : bodyWithoutReservedField;
        return decodedRLPBody.signature !== void 0 ? _Transaction.of(correctTransactionBody, decodedRLPBody.signature) : _Transaction.of(correctTransactionBody);
    }
    /**
   * Computes the signature hash, optionally incorporating a delegator's address.
   *
   * @param {Address} [delegator] - Optional delegator's address to include in the hash computation.
   * @return {Blake2b256} - The computed signature hash.
   *
   * @remarks
   * `delegator` is used to sign a transaction on behalf of another account.
   *
   * @remarks Security auditable method, depends on
   * - {@link Blake2b256.of}.
   */ getSignatureHash(delegator) {
        const txHash = $564ad8f2c6689928$export$d2458fb5f52b75a6.of(this.encode(false));
        if (delegator !== void 0) return $564ad8f2c6689928$export$d2458fb5f52b75a6.of($esaJO.concatBytes(txHash.bytes, delegator.bytes));
        return txHash;
    }
    /**
   * Calculates the intrinsic gas required for the given transaction clauses.
   *
   * @param {TransactionClause[]} clauses - An array of transaction clauses to calculate the intrinsic gas for.
   * @return {VTHO} The total intrinsic gas required for the provided clauses.
   * @throws {InvalidDataType} If clauses have invalid data as invalid addresses.
   */ static intrinsicGas(clauses) {
        if (clauses.length > 0) return $564ad8f2c6689928$export$27cc1e5993feb517.of(clauses.reduce((sum, clause)=>{
            if (clause.to !== null) {
                if (!$564ad8f2c6689928$export$73974d1f547d9d48.isValid(clause.to) && !clause.to.includes(".")) throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("Transaction.intrinsicGas", "invalid data type in clause: each `to` field must be a valid address.", {
                    clause: clause
                });
                sum += _Transaction.GAS_CONSTANTS.CLAUSE_GAS;
            } else sum += _Transaction.GAS_CONSTANTS.CLAUSE_GAS_CONTRACT_CREATION;
            sum += _Transaction.computeUsedGasFor(clause.data);
            return sum;
        }, _Transaction.GAS_CONSTANTS.TX_GAS), 0 /* wei */ );
        return $564ad8f2c6689928$export$27cc1e5993feb517.of(_Transaction.GAS_CONSTANTS.TX_GAS + _Transaction.GAS_CONSTANTS.CLAUSE_GAS, 0 /* wei */ );
    }
    /**
   * Return `true` if the transaction body is valid, `false` otherwise.
   *
   * @param {TransactionBody} body - The transaction body to validate.
   * @return {boolean} `true` if the transaction body is valid, `false` otherwise.
   */ static isValidBody(body) {
        return(// Chain tag
        body.chainTag !== void 0 && body.chainTag >= 0 && body.chainTag <= 255 && // Block reference
        body.blockRef !== void 0 && $564ad8f2c6689928$export$9ccf03a0aa23a1ca.isValid0x(body.blockRef) && $564ad8f2c6689928$export$7c2a2de09ea3c4f2.of(body.blockRef).bytes.length === _Transaction.BLOCK_REF_LENGTH && // Expiration
        body.expiration !== void 0 && // Clauses
        body.clauses !== void 0 && // Gas price coef
        body.gasPriceCoef !== void 0 && // Gas
        body.gas !== void 0 && // Depends on
        body.dependsOn !== void 0 && // Nonce
        body.nonce !== void 0);
    }
    /**
   * Creates a new Transaction instance if the provided body and optional
   * signature are valid.
   *
   * @param {TransactionBody} body - The transaction body to be validated.
   * @param {Uint8Array} [signature] - Optional signature to be validated.
   * @return {Transaction} A new Transaction instance if validation is successful.
   * @throws {InvalidSecp256k1Signature} If the provided signature is invalid.
   * @throws {InvalidTransactionField} If the provided body is invalid.
   */ static of(body, signature) {
        if (_Transaction.isValidBody(body)) {
            if (signature === void 0 || _Transaction.isSignatureValid(body, signature)) return new _Transaction(body, signature);
            throw new (0, $dbc5c4a080b2aff5$export$58f1681432c844df)("Transaction.of", "invalid signature", {
                signature: signature
            });
        }
        throw new (0, $dbc5c4a080b2aff5$export$9da713663f1e9273)("Transaction.of", "invalid body", {
            fieldName: "body",
            body: body
        });
    }
    /**
   * Signs the transaction using the provided private key.
   *
   * @param {Uint8Array} signerPrivateKey - The private key used to sign the transaction.
   * @return {Transaction} The signed transaction.
   * @throws {InvalidTransactionField} If attempting to sign a delegated transaction.
   * @throws {InvalidSecp256k1PrivateKey} If the provided private key is not valid.
   *
   * @remarks Security auditable method, depends on
   * - {@link Secp256k1.isValidPrivateKey};
   * - {@link Secp256k1.sign}.
   */ sign(signerPrivateKey) {
        if ($564ad8f2c6689928$export$4807b1fbad07ca78.isValidPrivateKey(signerPrivateKey)) {
            if (!this.isDelegated) {
                const signature = $564ad8f2c6689928$export$4807b1fbad07ca78.sign(this.getSignatureHash().bytes, signerPrivateKey);
                return _Transaction.of(this.body, signature);
            }
            throw new (0, $dbc5c4a080b2aff5$export$9da713663f1e9273)(`Transaction.sign`, "delegated transaction: use signWithDelegator method", {
                fieldName: "delegator",
                body: this.body
            });
        }
        throw new (0, $dbc5c4a080b2aff5$export$b154d91e70ffbd5)(`Transaction.sign`, "invalid private key: ensure it is a secp256k1 key", void 0);
    }
    /**
   * Signs the transaction using both the signer and the delegator private keys.
   *
   * @param {Uint8Array} signerPrivateKey - The private key of the signer.
   * @param {Uint8Array} delegatorPrivateKey - The private key of the delegator.
   * @return {Transaction} A new transaction with the concatenated signatures
   * of the signer and the delegator.
   * @throws {InvalidSecp256k1PrivateKey} - If either the signer or delegator private key is invalid.
   * @throws {NotDelegatedTransaction} - If the transaction is not delegated.
   *
   * @remarks Security auditable method, depends on
   * - {@link Address.ofPublicKey}
   * - {@link Secp256k1.isValidPrivateKey};
   * - {@link Secp256k1.sign}.
   */ signWithDelegator(signerPrivateKey, delegatorPrivateKey) {
        if ($564ad8f2c6689928$export$4807b1fbad07ca78.isValidPrivateKey(signerPrivateKey)) {
            if ($564ad8f2c6689928$export$4807b1fbad07ca78.isValidPrivateKey(delegatorPrivateKey)) {
                if (this.isDelegated) {
                    const transactionHash = this.getSignatureHash().bytes;
                    const delegatedHash = this.getSignatureHash($564ad8f2c6689928$export$73974d1f547d9d48.ofPublicKey($564ad8f2c6689928$export$4807b1fbad07ca78.derivePublicKey(signerPrivateKey))).bytes;
                    return _Transaction.of(this.body, $esaJO.concatBytes($564ad8f2c6689928$export$4807b1fbad07ca78.sign(transactionHash, signerPrivateKey), $564ad8f2c6689928$export$4807b1fbad07ca78.sign(delegatedHash, delegatorPrivateKey)));
                }
                throw new (0, $dbc5c4a080b2aff5$export$3417a5e4a3dd8321)("Transaction.signWithDelegator", "not delegated transaction: use sign method", void 0);
            }
            throw new (0, $dbc5c4a080b2aff5$export$b154d91e70ffbd5)(`Transaction.signWithDelegator`, "invalid delegator private: ensure it is a secp256k1 key", void 0);
        }
        throw new (0, $dbc5c4a080b2aff5$export$b154d91e70ffbd5)(`Transaction.signWithDelegator`, "invalid signer private key: ensure it is a secp256k1 key", void 0);
    }
    // ********** PRIVATE FUNCTIONS **********
    /**
   * Computes the amount of gas used for the given data.
   *
   * @param {string} data - The hexadecimal string data for which the gas usage is computed.
   * @return {bigint} The total gas used for the provided data.
   * @throws {InvalidDataType} If the data is not a valid hexadecimal string.
   *
   * @remarks gas value is expressed in {@link Units.wei} unit.
   */ static computeUsedGasFor(data) {
        if (data !== "" && !$564ad8f2c6689928$export$9ccf03a0aa23a1ca.isValid(data)) throw new (0, $dbc5c4a080b2aff5$export$5f7d1818d7e4f3c0)("calculateDataUsedGas()", `Invalid data type for gas calculation. Data should be a hexadecimal string.`, {
            data: data
        });
        let sum = 0n;
        for(let i = 2; i < data.length; i += 2)if (data.substring(i, i + 2) === "00") sum += _Transaction.GAS_CONSTANTS.ZERO_GAS_DATA;
        else sum += _Transaction.GAS_CONSTANTS.NON_ZERO_GAS_DATA;
        return sum;
    }
    /**
   * Decodes the {@link TransactionBody.reserved} field from the given buffer array.
   *
   * @param {Buffer[]} reserved  - An array of Uint8Array objects representing the reserved field data.
   * @return {Object} An object containing the decoded features and any unused buffer data.
   * @return {number} [return.features] The decoded features from the reserved field.
   * @return {Buffer[]} [return.unused] An array of Buffer objects representing unused data, if any.
   * @throws {InvalidTransactionField} Thrown if the reserved field is not properly trimmed.
   */ static decodeReservedField(reserved) {
        if (reserved[reserved.length - 1].length > 0) {
            const featuresField = _Transaction.RLP_FEATURES.kind.buffer(reserved[0], _Transaction.RLP_FEATURES.name).decode();
            return reserved.length > 1 ? {
                features: featuresField,
                unused: reserved.slice(1)
            } : {
                features: featuresField
            };
        }
        throw new (0, $dbc5c4a080b2aff5$export$9da713663f1e9273)("Transaction.decodeReservedField", "invalid reserved field: fields in the `reserved` property must be properly trimmed", {
            fieldName: "reserved",
            reserved: reserved
        });
    }
    /**
   * Encodes the transaction body using RLP encoding.
   *
   * @param {boolean} isSigned - Indicates whether the transaction is signed.
   * @return {Uint8Array} The RLP encoded transaction body.
   *
   * @see encoded
   */ encode(isSigned) {
        return this.encodeBodyField({
            // Existing body and the optional `reserved` field if present.
            ...this.body,
            /*
         * The `body.clauses` property is already an array,
         * albeit TypeScript realize, hence cast is needed
         * otherwise encodeObject will throw an error.
         */ clauses: this.body.clauses,
            // New reserved field.
            reserved: this.encodeReservedField()
        }, isSigned);
    }
    /**
   * Encodes the given transaction body into a Uint8Array, depending on whether
   * the transaction is signed or not.
   *
   * @param body - The transaction object adhering to the RLPValidObject structure.
   * @param isSigned - A boolean indicating if the transaction is signed.
   * @return A Uint8Array representing the encoded transaction.
   *
   * @see encoded
   */ encodeBodyField(body, isSigned) {
        if (isSigned) return $564ad8f2c6689928$export$5011fcbb6c0dc14a.ofObject({
            ...body,
            signature: Uint8Array.from(this.signature)
        }, _Transaction.RLP_SIGNED_TRANSACTION_PROFILE).encoded;
        return $564ad8f2c6689928$export$5011fcbb6c0dc14a.ofObject(body, _Transaction.RLP_UNSIGNED_TRANSACTION_PROFILE).encoded;
    }
    /**
   * Encodes the {@link TransactionBody.reserved} field data for a transaction.
   *
   * @return {Uint8Array[]} The encoded list of reserved features.
   * It removes any trailing unused features that have zero length from the list.
   *
   * @remarks The {@link TransactionBody.reserved} is optional, albeit
   * is required to perform RLP encoding.
   *
   * @see encode
   */ encodeReservedField() {
        const reserved = this.body.reserved ?? {};
        const featuresKind = _Transaction.RLP_FEATURES.kind;
        const featuresList = [
            featuresKind.data(reserved.features ?? 0, _Transaction.RLP_FEATURES.name).encode(),
            ...reserved.unused ?? []
        ];
        while(featuresList.length > 0){
            if (featuresList[featuresList.length - 1].length === 0) featuresList.pop();
            else break;
        }
        return featuresList;
    }
    /**
   * Return `true` if the transaction is delegated, else `false`.
   *
   * @param {TransactionBody} body - The transaction body.
   * @return {boolean} `true` if the transaction is delegated, else `false`.
   */ static isDelegated(body) {
        const reserved = body.reserved ?? {};
        const features = reserved.features ?? 0;
        return (features & 1) === 1;
    }
    /**
   * Return Returns true if the signature is valid, otherwise false.
   *
   * @param {TransactionBody} body - The transaction body to be checked.
   * @param {Uint8Array} signature - The signature to validate.
   * @return {boolean} - Returns true if the signature is valid, otherwise false.
   */ static isSignatureValid(body, signature) {
        const expectedSignatureLength = this.isDelegated(body) ? $564ad8f2c6689928$export$4807b1fbad07ca78.SIGNATURE_LENGTH * 2 : $564ad8f2c6689928$export$4807b1fbad07ca78.SIGNATURE_LENGTH;
        return signature.length === expectedSignatureLength;
    }
};
// src/utils/const/network.ts
var $564ad8f2c6689928$var$VECHAIN_MAINNET_CHAIN_TAG = 74;
var $564ad8f2c6689928$var$VECHAIN_TESTNET_CHAIN_TAG = 39;
var $564ad8f2c6689928$var$VECHAIN_SOLO_CHAIN_TAG = 246;
var $564ad8f2c6689928$export$b47284de06fcec83 = "0x0000000000000000000000000000000000000000";
var $564ad8f2c6689928$export$1a34dfc454d6ad5b = "0x0000000000000000000000000000456e65726779";
var $564ad8f2c6689928$var$mainnetGenesisBlock = {
    number: 0,
    id: "0x00000000851caf3cfdb6e899cf5958bfb1ac3413d346d43539627e6be7ec1b4a",
    size: 170,
    parentID: "0xffffffff53616c757465202620526573706563742c20457468657265756d2100",
    timestamp: 1530316800,
    gasLimit: 1e7,
    beneficiary: "0x0000000000000000000000000000000000000000",
    gasUsed: 0,
    totalScore: 0,
    txsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
    txsFeatures: 0,
    stateRoot: "0x09bfdf9e24dd5cd5b63f3c1b5d58b97ff02ca0490214a021ed7d99b93867839c",
    receiptsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
    signer: "0x0000000000000000000000000000000000000000",
    isTrunk: true,
    transactions: []
};
var $564ad8f2c6689928$var$testnetGenesisBlock = {
    number: 0,
    id: "0x000000000b2bce3c70bc649a02749e8687721b09ed2e15997f466536b20bb127",
    size: 170,
    parentID: "0xffffffff00000000000000000000000000000000000000000000000000000000",
    timestamp: 1530014400,
    gasLimit: 1e7,
    beneficiary: "0x0000000000000000000000000000000000000000",
    gasUsed: 0,
    totalScore: 0,
    txsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
    txsFeatures: 0,
    stateRoot: "0x4ec3af0acbad1ae467ad569337d2fe8576fe303928d35b8cdd91de47e9ac84bb",
    receiptsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
    signer: "0x0000000000000000000000000000000000000000",
    isTrunk: true,
    transactions: []
};
var $564ad8f2c6689928$var$soloGenesisBlock = {
    number: 0,
    id: "0x00000000c05a20fbca2bf6ae3affba6af4a74b800b585bf7a4988aba7aea69f6",
    size: 170,
    parentID: "0xffffffff00000000000000000000000000000000000000000000000000000000",
    timestamp: 15264e5,
    gasLimit: 1e7,
    beneficiary: "0x0000000000000000000000000000000000000000",
    gasUsed: 0,
    totalScore: 0,
    txsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
    txsFeatures: 0,
    stateRoot: "0x93de0ffb1f33bc0af053abc2a87c4af44594f5dcb1cb879dd823686a15d68550",
    receiptsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
    signer: "0x0000000000000000000000000000000000000000",
    isTrunk: true,
    transactions: []
};
var $564ad8f2c6689928$export$e2c0255dbe2e5514 = {
    genesisBlock: $564ad8f2c6689928$var$mainnetGenesisBlock,
    chainTag: $564ad8f2c6689928$var$VECHAIN_MAINNET_CHAIN_TAG
};
var $564ad8f2c6689928$export$42a42ef9fe6426c3 = {
    genesisBlock: $564ad8f2c6689928$var$testnetGenesisBlock,
    chainTag: $564ad8f2c6689928$var$VECHAIN_TESTNET_CHAIN_TAG
};
var $564ad8f2c6689928$export$d84d61bc169eec4a = {
    genesisBlock: $564ad8f2c6689928$var$soloGenesisBlock,
    chainTag: $564ad8f2c6689928$var$VECHAIN_SOLO_CHAIN_TAG
};
var $564ad8f2c6689928$export$c26faa1d7c00b5bf = {
    mainnet: $564ad8f2c6689928$export$e2c0255dbe2e5514,
    testnet: $564ad8f2c6689928$export$42a42ef9fe6426c3,
    solo: $564ad8f2c6689928$export$d84d61bc169eec4a
};



var $lDt57 = parcelRequire("lDt57");
var $cae0866804f4505b$export$b84fff6f79a56fa3;
var $cae0866804f4505b$export$78ed5b3305815fc7;
var $cae0866804f4505b$export$6922d3b3a607469e;
var $cae0866804f4505b$export$17aaac2670e0d2b9;
var $cae0866804f4505b$export$339ebc24fb22ad80;
var $cae0866804f4505b$export$64a33e9109220e08;
var $cae0866804f4505b$export$32f3091caa3ecf1e;
var $cae0866804f4505b$export$7faad7f6b3708314;
var $cae0866804f4505b$export$992ed2abb18cb90;
var $cae0866804f4505b$export$5bb85a5dcd872eb9;
var $cae0866804f4505b$export$3db5d71bdb2d5499;
"use strict";

var $lDt57 = parcelRequire("lDt57");
function $cae0866804f4505b$var$subscribeKey(proxyObject, key, callback, notifyInSync) {
    var prevValue = proxyObject[key];
    return $lDt57.subscribe(proxyObject, function() {
        var nextValue = proxyObject[key];
        if (!Object.is(prevValue, nextValue)) callback(prevValue = nextValue);
    }, notifyInSync);
}
var $cae0866804f4505b$var$currentCleanups;
function $cae0866804f4505b$var$watch(callback, options) {
    var alive = true;
    var cleanups = new Set();
    var subscriptions = new Map();
    var cleanup = function cleanup() {
        if (alive) {
            alive = false;
            cleanups.forEach(function(clean) {
                return clean();
            });
            cleanups.clear();
            subscriptions.forEach(function(unsubscribe) {
                return unsubscribe();
            });
            subscriptions.clear();
        }
    };
    var revalidate = function revalidate() {
        if (!alive) return;
        cleanups.forEach(function(clean) {
            return clean();
        });
        cleanups.clear();
        var proxiesToSubscribe = new Set();
        var parent = $cae0866804f4505b$var$currentCleanups;
        $cae0866804f4505b$var$currentCleanups = cleanups;
        try {
            var cleanupReturn = callback(function(proxyObject) {
                proxiesToSubscribe.add(proxyObject);
                return proxyObject;
            });
            if (cleanupReturn) cleanups.add(cleanupReturn);
        } finally{
            $cae0866804f4505b$var$currentCleanups = parent;
        }
        subscriptions.forEach(function(unsubscribe, proxyObject) {
            if (proxiesToSubscribe.has(proxyObject)) proxiesToSubscribe.delete(proxyObject);
            else {
                subscriptions.delete(proxyObject);
                unsubscribe();
            }
        });
        proxiesToSubscribe.forEach(function(proxyObject) {
            var unsubscribe = $lDt57.subscribe(proxyObject, revalidate, options == null ? void 0 : options.sync);
            subscriptions.set(proxyObject, unsubscribe);
        });
    };
    if ($cae0866804f4505b$var$currentCleanups) $cae0866804f4505b$var$currentCleanups.add(cleanup);
    revalidate();
    return cleanup;
}
function $cae0866804f4505b$var$_defineAccessor(type, obj, key, fn) {
    var desc = {
        configurable: !0,
        enumerable: !0
    };
    return desc[type] = fn, Object.defineProperty(obj, key, desc);
}
function $cae0866804f4505b$var$_extends() {
    $cae0866804f4505b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cae0866804f4505b$var$_extends.apply(this, arguments);
}
function $cae0866804f4505b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $cae0866804f4505b$var$_excluded = [
    "enabled",
    "name"
];
var $cae0866804f4505b$var$DEVTOOLS = Symbol();
function $cae0866804f4505b$var$devtools(proxyObject, options) {
    if (typeof options === "string") {
        console.warn("string name option is deprecated, use { name }. https://github.com/pmndrs/valtio/pull/400");
        options = {
            name: options
        };
    }
    var _ref = options || {}, enabled = _ref.enabled, _ref$name = _ref.name, name = _ref$name === void 0 ? "" : _ref$name, rest = $cae0866804f4505b$var$_objectWithoutPropertiesLoose(_ref, $cae0866804f4505b$var$_excluded);
    var extension;
    try {
        extension = (enabled != null ? enabled : true) && window.__REDUX_DEVTOOLS_EXTENSION__;
    } catch (_unused) {}
    if (!extension) {
        if (enabled) console.warn("[Warning] Please install/enable Redux devtools extension");
        return;
    }
    var isTimeTraveling = false;
    var devtools = extension.connect($cae0866804f4505b$var$_extends({
        name: name
    }, rest));
    var unsub1 = $lDt57.subscribe(proxyObject, function(ops) {
        var action = ops.filter(function(_ref2) {
            _ref2[0];
            var path = _ref2[1];
            return path[0] !== $cae0866804f4505b$var$DEVTOOLS;
        }).map(function(_ref3) {
            var op = _ref3[0], path = _ref3[1];
            return op + ":" + path.map(String).join(".");
        }).join(", ");
        if (!action) return;
        if (isTimeTraveling) isTimeTraveling = false;
        else {
            var snapWithoutDevtools = Object.assign({}, $lDt57.snapshot(proxyObject));
            delete snapWithoutDevtools[$cae0866804f4505b$var$DEVTOOLS];
            devtools.send({
                type: action,
                updatedAt: new Date().toLocaleString()
            }, snapWithoutDevtools);
        }
    });
    var unsub2 = devtools.subscribe(function(message) {
        var _message$payload3, _message$payload4;
        if (message.type === "ACTION" && message.payload) try {
            Object.assign(proxyObject, JSON.parse(message.payload));
        } catch (e) {
            console.error("please dispatch a serializable value that JSON.parse() and proxy() support\n", e);
        }
        if (message.type === "DISPATCH" && message.state) {
            var _message$payload, _message$payload2;
            if (((_message$payload = message.payload) == null ? void 0 : _message$payload.type) === "JUMP_TO_ACTION" || ((_message$payload2 = message.payload) == null ? void 0 : _message$payload2.type) === "JUMP_TO_STATE") {
                isTimeTraveling = true;
                var state = JSON.parse(message.state);
                Object.assign(proxyObject, state);
            }
            proxyObject[$cae0866804f4505b$var$DEVTOOLS] = message;
        } else if (message.type === "DISPATCH" && ((_message$payload3 = message.payload) == null ? void 0 : _message$payload3.type) === "COMMIT") devtools.init($lDt57.snapshot(proxyObject));
        else if (message.type === "DISPATCH" && ((_message$payload4 = message.payload) == null ? void 0 : _message$payload4.type) === "IMPORT_STATE") {
            var _message$payload$next, _message$payload$next2;
            var actions = (_message$payload$next = message.payload.nextLiftedState) == null ? void 0 : _message$payload$next.actionsById;
            var computedStates = ((_message$payload$next2 = message.payload.nextLiftedState) == null ? void 0 : _message$payload$next2.computedStates) || [];
            isTimeTraveling = true;
            computedStates.forEach(function(_ref4, index) {
                var state = _ref4.state;
                var action = actions[index] || "No action found";
                Object.assign(proxyObject, state);
                if (index === 0) devtools.init($lDt57.snapshot(proxyObject));
                else devtools.send(action, $lDt57.snapshot(proxyObject));
            });
        }
    });
    devtools.init($lDt57.snapshot(proxyObject));
    return function() {
        unsub1();
        unsub2 == null || unsub2();
    };
}
var $cae0866804f4505b$var$sourceObjectMap = new WeakMap();
var $cae0866804f4505b$var$derivedObjectMap = new WeakMap();
var $cae0866804f4505b$var$markPending = function markPending(sourceObject, callback) {
    var sourceObjectEntry = $cae0866804f4505b$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        sourceObjectEntry[0].forEach(function(subscription) {
            var derivedObject = subscription.d;
            if (sourceObject !== derivedObject) markPending(derivedObject);
        });
        ++sourceObjectEntry[2];
        if (callback) sourceObjectEntry[3].add(callback);
    }
};
var $cae0866804f4505b$var$checkPending = function checkPending(sourceObject, callback) {
    var sourceObjectEntry = $cae0866804f4505b$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry != null && sourceObjectEntry[2]) {
        sourceObjectEntry[3].add(callback);
        return true;
    }
    return false;
};
var $cae0866804f4505b$var$unmarkPending = function unmarkPending(sourceObject) {
    var sourceObjectEntry = $cae0866804f4505b$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        --sourceObjectEntry[2];
        if (!sourceObjectEntry[2]) {
            sourceObjectEntry[3].forEach(function(callback) {
                return callback();
            });
            sourceObjectEntry[3].clear();
        }
        sourceObjectEntry[0].forEach(function(subscription) {
            var derivedObject = subscription.d;
            if (sourceObject !== derivedObject) unmarkPending(derivedObject);
        });
    }
};
var $cae0866804f4505b$var$addSubscription = function addSubscription(subscription) {
    var sourceObject = subscription.s, derivedObject = subscription.d;
    var derivedObjectEntry = $cae0866804f4505b$var$derivedObjectMap.get(derivedObject);
    if (!derivedObjectEntry) {
        derivedObjectEntry = [
            new Set()
        ];
        $cae0866804f4505b$var$derivedObjectMap.set(subscription.d, derivedObjectEntry);
    }
    derivedObjectEntry[0].add(subscription);
    var sourceObjectEntry = $cae0866804f4505b$var$sourceObjectMap.get(sourceObject);
    if (!sourceObjectEntry) {
        var _subscriptions = new Set();
        var _unsubscribe = $lDt57.subscribe(sourceObject, function(ops) {
            _subscriptions.forEach(function(subscription) {
                var derivedObject = subscription.d, callback = subscription.c, notifyInSync = subscription.n, ignoreKeys = subscription.i;
                if (sourceObject === derivedObject && ops.every(function(op) {
                    return op[1].length === 1 && ignoreKeys.includes(op[1][0]);
                })) return;
                if (subscription.p) return;
                $cae0866804f4505b$var$markPending(sourceObject, callback);
                if (notifyInSync) $cae0866804f4505b$var$unmarkPending(sourceObject);
                else subscription.p = Promise.resolve().then(function() {
                    delete subscription.p;
                    $cae0866804f4505b$var$unmarkPending(sourceObject);
                });
            });
        }, true);
        sourceObjectEntry = [
            _subscriptions,
            _unsubscribe,
            0,
            new Set()
        ];
        $cae0866804f4505b$var$sourceObjectMap.set(sourceObject, sourceObjectEntry);
    }
    sourceObjectEntry[0].add(subscription);
};
var $cae0866804f4505b$var$removeSubscription = function removeSubscription(subscription) {
    var sourceObject = subscription.s, derivedObject = subscription.d;
    var derivedObjectEntry = $cae0866804f4505b$var$derivedObjectMap.get(derivedObject);
    derivedObjectEntry == null || derivedObjectEntry[0].delete(subscription);
    if ((derivedObjectEntry == null ? void 0 : derivedObjectEntry[0].size) === 0) $cae0866804f4505b$var$derivedObjectMap.delete(derivedObject);
    var sourceObjectEntry = $cae0866804f4505b$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        var _subscriptions2 = sourceObjectEntry[0], _unsubscribe2 = sourceObjectEntry[1];
        _subscriptions2.delete(subscription);
        if (!_subscriptions2.size) {
            _unsubscribe2();
            $cae0866804f4505b$var$sourceObjectMap.delete(sourceObject);
        }
    }
};
var $cae0866804f4505b$var$listSubscriptions = function listSubscriptions(derivedObject) {
    var derivedObjectEntry = $cae0866804f4505b$var$derivedObjectMap.get(derivedObject);
    if (derivedObjectEntry) return Array.from(derivedObjectEntry[0]);
    return [];
};
var $cae0866804f4505b$var$unstable_deriveSubscriptions = {
    add: $cae0866804f4505b$var$addSubscription,
    remove: $cae0866804f4505b$var$removeSubscription,
    list: $cae0866804f4505b$var$listSubscriptions
};
function $cae0866804f4505b$var$derive(derivedFns, options) {
    var proxyObject = (options == null ? void 0 : options.proxy) || $lDt57.proxy({});
    var notifyInSync = !!(options != null && options.sync);
    var derivedKeys = Object.keys(derivedFns);
    derivedKeys.forEach(function(key) {
        if (Object.getOwnPropertyDescriptor(proxyObject, key)) throw new Error("object property already defined");
        var fn = derivedFns[key];
        var lastDependencies = null;
        var evaluate = function evaluate() {
            if (lastDependencies) {
                if (Array.from(lastDependencies).map(function(_ref) {
                    var p = _ref[0];
                    return $cae0866804f4505b$var$checkPending(p, evaluate);
                }).some(function(isPending) {
                    return isPending;
                })) return;
                if (Array.from(lastDependencies).every(function(_ref2) {
                    var p = _ref2[0], entry = _ref2[1];
                    return $lDt57.getVersion(p) === entry.v;
                })) return;
            }
            var dependencies = new Map();
            var get = function get(p) {
                dependencies.set(p, {
                    v: $lDt57.getVersion(p)
                });
                return p;
            };
            var value = fn(get);
            var subscribeToDependencies = function subscribeToDependencies() {
                var _lastDependencies2;
                dependencies.forEach(function(entry, p) {
                    var _lastDependencies;
                    var lastSubscription = (_lastDependencies = lastDependencies) == null || (_lastDependencies = _lastDependencies.get(p)) == null ? void 0 : _lastDependencies.s;
                    if (lastSubscription) entry.s = lastSubscription;
                    else {
                        var subscription = {
                            s: p,
                            d: proxyObject,
                            k: key,
                            c: evaluate,
                            n: notifyInSync,
                            i: derivedKeys
                        };
                        $cae0866804f4505b$var$addSubscription(subscription);
                        entry.s = subscription;
                    }
                });
                (_lastDependencies2 = lastDependencies) == null || _lastDependencies2.forEach(function(entry, p) {
                    if (!dependencies.has(p) && entry.s) $cae0866804f4505b$var$removeSubscription(entry.s);
                });
                lastDependencies = dependencies;
            };
            if (value instanceof Promise) value.finally(subscribeToDependencies);
            else subscribeToDependencies();
            proxyObject[key] = value;
        };
        evaluate();
    });
    return proxyObject;
}
function $cae0866804f4505b$var$underive(proxyObject, options) {
    var keysToDelete = options != null && options.delete ? new Set() : null;
    $cae0866804f4505b$var$listSubscriptions(proxyObject).forEach(function(subscription) {
        var key = subscription.k;
        if (!(options != null && options.keys) || options.keys.includes(key)) {
            $cae0866804f4505b$var$removeSubscription(subscription);
            if (keysToDelete) keysToDelete.add(key);
        }
    });
    if (keysToDelete) keysToDelete.forEach(function(key) {
        delete proxyObject[key];
    });
}
function $cae0866804f4505b$var$addComputed_DEPRECATED(proxyObject, computedFns_FAKE, targetObject) {
    if (targetObject === void 0) targetObject = proxyObject;
    console.warn("addComputed is deprecated. Please consider using `derive`. Falling back to emulation with derive. https://github.com/pmndrs/valtio/pull/201");
    var derivedFns = {};
    Object.keys(computedFns_FAKE).forEach(function(key) {
        derivedFns[key] = function(get) {
            return computedFns_FAKE[key](get(proxyObject));
        };
    });
    return $cae0866804f4505b$var$derive(derivedFns, {
        proxy: targetObject
    });
}
function $cae0866804f4505b$var$proxyWithComputed_DEPRECATED(initialObject, computedFns) {
    console.warn('proxyWithComputed is deprecated. Please follow "Computed Properties" guide in docs.');
    Object.keys(computedFns).forEach(function(key) {
        if (Object.getOwnPropertyDescriptor(initialObject, key)) throw new Error("object property already defined");
        var computedFn = computedFns[key];
        var _ref = typeof computedFn === "function" ? {
            get: computedFn
        } : computedFn, get = _ref.get, set = _ref.set;
        var desc = {};
        desc.get = function() {
            return get($lDt57.snapshot(proxyObject));
        };
        if (set) desc.set = function(newValue) {
            return set(proxyObject, newValue);
        };
        Object.defineProperty(initialObject, key, desc);
    });
    var proxyObject = $lDt57.proxy(initialObject);
    return proxyObject;
}
var $cae0866804f4505b$var$isObject = function isObject(x) {
    return typeof x === "object" && x !== null;
};
var $cae0866804f4505b$var$refSet;
var $cae0866804f4505b$var$deepClone = function deepClone(obj) {
    if (!$cae0866804f4505b$var$refSet) $cae0866804f4505b$var$refSet = $lDt57.unstable_buildProxyFunction()[2];
    if (!$cae0866804f4505b$var$isObject(obj) || $cae0866804f4505b$var$refSet.has(obj)) return obj;
    var baseObject = Array.isArray(obj) ? [] : Object.create(Object.getPrototypeOf(obj));
    Reflect.ownKeys(obj).forEach(function(key) {
        baseObject[key] = deepClone(obj[key]);
    });
    return baseObject;
};
function $cae0866804f4505b$var$proxyWithHistory(initialValue, skipSubscribe) {
    if (skipSubscribe === void 0) skipSubscribe = false;
    var proxyObject = $lDt57.proxy({
        value: initialValue,
        history: $lDt57.ref({
            wip: undefined,
            snapshots: [],
            index: -1
        }),
        clone: $cae0866804f4505b$var$deepClone,
        canUndo: function canUndo() {
            return proxyObject.history.index > 0;
        },
        undo: function undo() {
            if (proxyObject.canUndo()) proxyObject.value = proxyObject.history.wip = proxyObject.clone(proxyObject.history.snapshots[--proxyObject.history.index]);
        },
        canRedo: function canRedo() {
            return proxyObject.history.index < proxyObject.history.snapshots.length - 1;
        },
        redo: function redo() {
            if (proxyObject.canRedo()) proxyObject.value = proxyObject.history.wip = proxyObject.clone(proxyObject.history.snapshots[++proxyObject.history.index]);
        },
        saveHistory: function saveHistory() {
            proxyObject.history.snapshots.splice(proxyObject.history.index + 1);
            proxyObject.history.snapshots.push($lDt57.snapshot(proxyObject).value);
            ++proxyObject.history.index;
        },
        subscribe: function subscribe() {
            return $lDt57.subscribe(proxyObject, function(ops) {
                if (ops.every(function(op) {
                    return op[1][0] === "value" && (op[0] !== "set" || op[2] !== proxyObject.history.wip);
                })) proxyObject.saveHistory();
            });
        }
    });
    proxyObject.saveHistory();
    if (!skipSubscribe) proxyObject.subscribe();
    return proxyObject;
}
function $cae0866804f4505b$var$proxySet(initialValues) {
    var _proxy;
    var set = $lDt57.proxy((_proxy = {
        data: Array.from(new Set(initialValues)),
        has: function has(value) {
            return this.data.indexOf(value) !== -1;
        },
        add: function add(value) {
            var hasProxy = false;
            if (typeof value === "object" && value !== null) hasProxy = this.data.indexOf($lDt57.proxy(value)) !== -1;
            if (this.data.indexOf(value) === -1 && !hasProxy) this.data.push(value);
            return this;
        },
        delete: function _delete(value) {
            var index = this.data.indexOf(value);
            if (index === -1) return false;
            this.data.splice(index, 1);
            return true;
        },
        clear: function clear() {
            this.data.splice(0);
        },
        get size () {
            return this.data.length;
        },
        forEach: function forEach(cb) {
            var _this = this;
            this.data.forEach(function(value) {
                cb(value, value, _this);
            });
        }
    }, $cae0866804f4505b$var$_defineAccessor("get", _proxy, Symbol.toStringTag, function() {
        return "Set";
    }), _proxy.toJSON = function toJSON() {
        return new Set(this.data);
    }, _proxy[Symbol.iterator] = function() {
        return this.data[Symbol.iterator]();
    }, _proxy.values = function values() {
        return this.data.values();
    }, _proxy.keys = function keys() {
        return this.data.values();
    }, _proxy.entries = function entries() {
        return new Set(this.data).entries();
    }, _proxy));
    Object.defineProperties(set, {
        data: {
            enumerable: false
        },
        size: {
            enumerable: false
        },
        toJSON: {
            enumerable: false
        }
    });
    Object.seal(set);
    return set;
}
function $cae0866804f4505b$var$proxyMap(entries) {
    var _proxy;
    var map = $lDt57.proxy((_proxy = {
        data: Array.from(entries || []),
        has: function has(key) {
            return this.data.some(function(p) {
                return p[0] === key;
            });
        },
        set: function set(key, value) {
            var record = this.data.find(function(p) {
                return p[0] === key;
            });
            if (record) record[1] = value;
            else this.data.push([
                key,
                value
            ]);
            return this;
        },
        get: function get(key) {
            var _this$data$find;
            return (_this$data$find = this.data.find(function(p) {
                return p[0] === key;
            })) == null ? void 0 : _this$data$find[1];
        },
        delete: function _delete(key) {
            var index = this.data.findIndex(function(p) {
                return p[0] === key;
            });
            if (index === -1) return false;
            this.data.splice(index, 1);
            return true;
        },
        clear: function clear() {
            this.data.splice(0);
        },
        get size () {
            return this.data.length;
        },
        toJSON: function toJSON() {
            return new Map(this.data);
        },
        forEach: function forEach(cb) {
            var _this = this;
            this.data.forEach(function(p) {
                cb(p[1], p[0], _this);
            });
        },
        keys: function keys() {
            return this.data.map(function(p) {
                return p[0];
            }).values();
        },
        values: function values() {
            return this.data.map(function(p) {
                return p[1];
            }).values();
        },
        entries: function entries() {
            return new Map(this.data).entries();
        }
    }, $cae0866804f4505b$var$_defineAccessor("get", _proxy, Symbol.toStringTag, function() {
        return "Map";
    }), _proxy[Symbol.iterator] = function() {
        return this.entries();
    }, _proxy));
    Object.defineProperties(map, {
        data: {
            enumerable: false
        },
        size: {
            enumerable: false
        },
        toJSON: {
            enumerable: false
        }
    });
    Object.seal(map);
    return map;
}
$cae0866804f4505b$export$b84fff6f79a56fa3 = $cae0866804f4505b$var$addComputed_DEPRECATED;
$cae0866804f4505b$export$78ed5b3305815fc7 = $cae0866804f4505b$var$derive;
$cae0866804f4505b$export$6922d3b3a607469e = $cae0866804f4505b$var$devtools;
$cae0866804f4505b$export$17aaac2670e0d2b9 = $cae0866804f4505b$var$proxyMap;
$cae0866804f4505b$export$339ebc24fb22ad80 = $cae0866804f4505b$var$proxySet;
$cae0866804f4505b$export$64a33e9109220e08 = $cae0866804f4505b$var$proxyWithComputed_DEPRECATED;
$cae0866804f4505b$export$32f3091caa3ecf1e = $cae0866804f4505b$var$proxyWithHistory;
$cae0866804f4505b$export$7faad7f6b3708314 = $cae0866804f4505b$var$subscribeKey;
$cae0866804f4505b$export$992ed2abb18cb90 = $cae0866804f4505b$var$underive;
$cae0866804f4505b$export$5bb85a5dcd872eb9 = $cae0866804f4505b$var$unstable_deriveSubscriptions;
$cae0866804f4505b$export$3db5d71bdb2d5499 = $cae0866804f4505b$var$watch;


var $fac7b04398ee9187$exports = {};

var $hPtJY = parcelRequire("hPtJY");
(function webpackUniversalModuleDefinition(root, factory) {
    var a, i;
    $fac7b04398ee9187$exports = factory();
})(self, function() {
    return /******/ (()=>{
        /******/ var __webpack_modules__ = {
            /***/ 280: /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                "use strict";
                // ESM COMPAT FLAG
                __webpack_require__.r(__webpack_exports__);
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "Connex": ()=>/* binding */ ConnexClass,
                    "default": ()=>/* binding */ esm
                });
                // EXTERNAL MODULE: ../framework/node_modules/@vechain/ethers/utils/abi-coder.js
                var abi_coder = __webpack_require__(2046);
                // EXTERNAL MODULE: ../framework/node_modules/js-sha3/src/sha3.js
                var sha3 = __webpack_require__(747);
                // CONCATENATED MODULE: ../framework/node_modules/thor-devkit/esm/keccak.js
                /* provided dependency */ var Buffer = __webpack_require__(8764)["Buffer"];
                /**
 * computes keccak256 hash of given data
 * @param data one or more Buffer | string
 */ function keccak256(...data) {
                    const h = sha3.keccak_256.create();
                    data.forEach((d)=>{
                        if (Buffer.isBuffer(d)) h.update(d);
                        else h.update(Buffer.from(d, "utf8"));
                    });
                    return Buffer.from(h.digest());
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2VjY2FrLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2tlY2Nhay50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sU0FBUyxDQUFBO0FBQ3BDOzs7R0FHRztBQUNILE1BQU0sVUFBVSxTQUFTLENBQUMsR0FBRyxJQUE0QjtJQUNyRCxNQUFNLENBQUMsR0FBRyxVQUFVLENBQUMsTUFBTSxFQUFFLENBQUE7SUFDN0IsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsRUFBRTtRQUNiLElBQUksTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsRUFBRTtZQUNwQixDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFBO1NBQ2Q7YUFBTTtZQUNILENBQUMsQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUUsTUFBTSxDQUFDLENBQUMsQ0FBQTtTQUNuQztJQUNMLENBQUMsQ0FBQyxDQUFBO0lBQ0YsT0FBTyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxDQUFBO0FBQ2xDLENBQUMifQ==
                // CONCATENATED MODULE: ../framework/node_modules/thor-devkit/esm/abi.js
                /* provided dependency */ var abi_Buffer = __webpack_require__(8764)["Buffer"];
                class Coder extends abi_coder.AbiCoder {
                    constructor(){
                        super((type, value)=>{
                            if (type.match(/^u?int/) && !Array.isArray(value) && typeof value !== "object" || value._ethersType === "BigNumber") return value.toString();
                            return value;
                        });
                    }
                    encode(types, values) {
                        try {
                            return super.encode(types, values);
                        } catch (err) {
                            if (err.reason) throw new Error(err.reason);
                            throw err;
                        }
                    }
                    decode(types, data) {
                        try {
                            return super.decode(types, data);
                        } catch (err) {
                            if (err.reason) throw new Error(err.reason);
                            throw err;
                        }
                    }
                }
                const coder = new Coder();
                function formatSignature(fragment) {
                    try {
                        return (0, abi_coder.formatSignature)(fragment).replace(/\(tuple\(/g, "((").replace(/\,tuple\(/g, ",(");
                    } catch (err) {
                        if (err.reason) throw new Error(err.reason);
                        throw err;
                    }
                }
                /** encode/decode parameters of contract function call, event log, according to ABI JSON */ var abi;
                (function(abi) {
                    /**
     * encode single parameter
     * @param type type of the parameter
     * @param value value of the parameter
     * @returns encoded value in hex string
     */ function encodeParameter(type, value) {
                        return coder.encode([
                            type
                        ], [
                            value
                        ]);
                    }
                    abi.encodeParameter = encodeParameter;
                    /**
     * decode single parameter
     * @param type type of the parameter
     * @param data encoded parameter in hex string
     * @returns decoded value
     */ function decodeParameter(type, data) {
                        return coder.decode([
                            type
                        ], data)[0];
                    }
                    abi.decodeParameter = decodeParameter;
                    /**
     * encode a group of parameters
     * @param types type array
     * @param values value array
     * @returns encoded values in hex string
     */ function encodeParameters(types, values) {
                        return coder.encode(types, values);
                    }
                    abi.encodeParameters = encodeParameters;
                    /**
     * decode a group of parameters
     * @param types type array
     * @param data encoded values in hex string
     * @returns decoded object
     */ function decodeParameters(types, data) {
                        const result = coder.decode(types, data);
                        const decoded = {};
                        types.forEach((t, i)=>{
                            decoded[i] = result[i];
                            if (t.name) decoded[t.name] = result[i];
                        });
                        return decoded;
                    }
                    abi.decodeParameters = decodeParameters;
                    /** for contract function */ class Function1 {
                        /**
         * create a function object
         * @param definition abi definition of the function
         */ constructor(definition){
                            this.definition = definition;
                            this.canonicalName = formatSignature(definition);
                            this.signature = "0x" + keccak256(this.canonicalName).slice(0, 4).toString("hex");
                        }
                        /**
         * encode input parameters into call data
         * @param args arguments for the function
         */ encode(...args) {
                            return this.signature + encodeParameters(this.definition.inputs, args).slice(2);
                        }
                        /**
         * decode output data
         * @param outputData output data to decode
         */ decode(outputData) {
                            return decodeParameters(this.definition.outputs, outputData);
                        }
                    }
                    abi.Function = Function1;
                    /** for contract event */ class Event {
                        /** for contract event */ constructor(definition){
                            this.definition = definition;
                            this.canonicalName = formatSignature(definition);
                            this.signature = "0x" + keccak256(this.canonicalName).toString("hex");
                        }
                        /**
         * encode an object of indexed keys into topics.
         * @param indexed an object contains indexed keys
         */ encode(indexed) {
                            const topics = [];
                            if (!this.definition.anonymous) topics.push(this.signature);
                            for (const input of this.definition.inputs){
                                if (!input.indexed) continue;
                                const value = indexed[input.name];
                                if (value === undefined || value === null) topics.push(null);
                                else {
                                    let topic;
                                    // https://docs.soliditylang.org/en/v0.8.11/abi-spec.html#encoding-of-indexed-event-parameters
                                    if (isValueType(input.type)) topic = encodeParameter(input.type, value);
                                    else {
                                        if (input.type === "string") topic = "0x" + keccak256(value).toString("hex");
                                        else if (typeof value === "string" && /^0x[0-9a-f]+$/i.test(value) && value.length % 2 === 0) // value is encoded
                                        topic = "0x" + keccak256(abi_Buffer.from(value.slice(2), "hex")).toString("hex");
                                        else throw new Error(`event.encode: invalid ${input.type} value`);
                                    }
                                    topics.push(topic);
                                }
                            }
                            return topics;
                        }
                        /**
         * decode event log
         * @param data data in event output
         * @param topics topics in event
         */ decode(data, topics) {
                            if (!this.definition.anonymous) topics = topics.slice(1);
                            if (this.definition.inputs.filter((t)=>t.indexed).length !== topics.length) throw new Error("invalid topics count");
                            const decodedNonIndexed = coder.decode(this.definition.inputs.filter((t)=>!t.indexed), data);
                            const decoded = {};
                            this.definition.inputs.forEach((t, i)=>{
                                if (t.indexed) {
                                    const topic = topics.shift();
                                    decoded[i] = isValueType(t.type) ? decodeParameter(t.type, topic) : topic;
                                } else decoded[i] = decodedNonIndexed.shift();
                                if (t.name) decoded[t.name] = decoded[i];
                            });
                            return decoded;
                        }
                    }
                    abi.Event = Event;
                    function isValueType(type) {
                        return type === "address" || type === "bool" || /^(u?int)([0-9]*)$/.test(type) || /^bytes([0-9]+)$/.test(type);
                    }
                })(abi || (abi = {}));
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ../framework/esm/revert-reason.js
                // https://docs.soliditylang.org/en/v0.8.16/control-structures.html#error-handling-assert-require-revert-and-exceptions
                // builtin errors in solidity, Error(string) and Panic(uint256)
                const errorSelector = "0x" + keccak256("Error(string)").toString("hex").slice(0, 8);
                const panicSelector = "0x" + keccak256("Panic(uint256)").toString("hex").slice(0, 8);
                function decodeRevertReason(data) {
                    try {
                        if (data.startsWith(errorSelector)) return abi.decodeParameter("string", "0x" + data.slice(errorSelector.length));
                        else if (data.startsWith(panicSelector)) {
                            const decoded = abi.decodeParameter("uint256", "0x" + data.slice(panicSelector.length));
                            return `Panic(0x${parseInt(decoded).toString(16).padStart(2, "0")})`;
                        }
                        return "";
                    } catch (_a) {
                        return "";
                    }
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmV2ZXJ0LXJlYXNvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9yZXZlcnQtcmVhc29uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxHQUFHLEVBQUUsU0FBUyxFQUFFLE1BQU0sYUFBYSxDQUFBO0FBRTVDLHVIQUF1SDtBQUN2SCwrREFBK0Q7QUFFL0QsTUFBTSxhQUFhLEdBQUcsSUFBSSxHQUFHLFNBQVMsQ0FBQyxlQUFlLENBQUMsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLENBQUMsS0FBSyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQTtBQUNuRixNQUFNLGFBQWEsR0FBRyxJQUFJLEdBQUcsU0FBUyxDQUFDLGdCQUFnQixDQUFDLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUE7QUFFcEYsTUFBTSxVQUFVLGtCQUFrQixDQUFDLElBQVk7SUFDM0MsSUFBSTtRQUNBLElBQUksSUFBSSxDQUFDLFVBQVUsQ0FBQyxhQUFhLENBQUMsRUFBRTtZQUNoQyxPQUFPLEdBQUcsQ0FBQyxlQUFlLENBQUMsUUFBUSxFQUFFLElBQUksR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLGFBQWEsQ0FBQyxNQUFNLENBQUMsQ0FBVyxDQUFBO1NBQzFGO2FBQU0sSUFBSSxJQUFJLENBQUMsVUFBVSxDQUFDLGFBQWEsQ0FBQyxFQUFFO1lBQ3ZDLE1BQU0sT0FBTyxHQUFHLEdBQUcsQ0FBQyxlQUFlLENBQUMsU0FBUyxFQUFFLElBQUksR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLGFBQWEsQ0FBQyxNQUFNLENBQUMsQ0FBVyxDQUFBO1lBQ2pHLE9BQU8sV0FBVyxRQUFRLENBQUMsT0FBTyxDQUFDLENBQUMsUUFBUSxDQUFDLEVBQUUsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxDQUFDLEVBQUUsR0FBRyxDQUFDLEdBQUcsQ0FBQTtTQUN2RTtRQUNELE9BQU8sRUFBRSxDQUFBO0tBQ1o7SUFBQyxXQUFNO1FBQ0osT0FBTyxFQUFFLENBQUE7S0FDWjtBQUNMLENBQUMifQ==
                // EXTERNAL MODULE: ../framework/node_modules/validator-ts/dist/index.js
                var dist = __webpack_require__(6462);
                // CONCATENATED MODULE: ../framework/esm/rules.js
                /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ function isDecString(val) {
                    return typeof val === "string" && /^[0-9]+$/.test(val);
                }
                function isHexString(val) {
                    return typeof val === "string" && /^0x[0-9a-f]+$/i.test(val);
                }
                function isHexBytes(val, n) {
                    if (typeof val !== "string" || !/^0x[0-9a-f]*$/i.test(val)) return false;
                    return n ? val.length === n * 2 + 2 : val.length % 2 === 0;
                }
                function isUInt(val, bit) {
                    if (val < 0 || !Number.isInteger(val)) return false;
                    return bit ? val < Math.pow(2, bit) : true;
                }
                function isBigInt(v) {
                    return typeof v === "string" ? isDecString(v) || isHexString(v) : isUInt(v, 0);
                }
                class BadParameter extends Error {
                    constructor(msg){
                        super(msg);
                    }
                }
                BadParameter.prototype.name = "BadParameter";
                function ensure(b, msg) {
                    if (!b) throw new BadParameter(msg);
                }
                function test(value, scheme, context) {
                    try {
                        return dist /* validate */ .Gu(value, scheme, context);
                    } catch (err) {
                        if (err instanceof dist /* ValidationError */ .p8) throw new BadParameter(err.message);
                        throw err;
                    }
                }
                // rules
                function bytes(v) {
                    return isHexBytes(v) ? "" : "expected bytes in hex string";
                }
                function bytes8(v) {
                    return isHexBytes(v, 8) ? "" : "expected bytes8";
                }
                function bytes32(v) {
                    return isHexBytes(v, 32) ? "" : "expected bytes32";
                }
                function uint8(v) {
                    return isUInt(v, 8) ? "" : "expected 8-bit unsigned integer";
                }
                function uint32(v) {
                    return isUInt(v, 32) ? "" : "expected 32-bit unsigned integer";
                }
                function uint64(v) {
                    return isUInt(v, 64) ? "" : "expected 64-bit unsigned integer";
                }
                function bool(v) {
                    return typeof v === "boolean" ? "" : "expected boolean";
                }
                function bigInt(v) {
                    return isBigInt(v) ? "" : "expected unsigned integer in number or string";
                }
                function hexString(v) {
                    return isHexString(v) ? "" : "expected integer in hex string";
                }
                function address(v) {
                    return isHexBytes(v, 20) ? "" : "expected address";
                }
                function string(v) {
                    return typeof v === "string" ? "" : "expected string";
                }
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ../framework/esm/filter.js
                const MAX_LIMIT = 256;
                function newFilter(readyDriver, kind, criteria) {
                    const filterBody = {
                        range: {
                            unit: "block",
                            from: 0,
                            to: Math.pow(2, 32) - 1
                        },
                        options: {
                            offset: 0,
                            limit: 10
                        },
                        criteriaSet: criteria,
                        order: "asc"
                    };
                    let cacheHints;
                    return {
                        range (range) {
                            test(range, {
                                unit: (v)=>v === "block" || v === "time" ? "" : `expected 'block' or 'time'`,
                                from: uint64,
                                to: uint64
                            }, "arg0");
                            ensure(range.from <= range.to, "arg0.from: expected <= arg0.to");
                            filterBody.range = Object.assign({}, range);
                            return this;
                        },
                        order (order) {
                            ensure(order === "asc" || order === "desc", `arg0: expected 'asc' or 'desc'`);
                            filterBody.order = order;
                            return this;
                        },
                        cache (hints) {
                            cacheHints = test(hints, [
                                address
                            ], "arg0").map((t)=>t.toLowerCase());
                            return this;
                        },
                        apply (offset, limit) {
                            test(offset, uint64, "arg0");
                            ensure(limit >= 0 && limit <= MAX_LIMIT && Number.isInteger(limit), `arg1: expected unsigned integer <= ${MAX_LIMIT}`);
                            filterBody.options.offset = offset;
                            filterBody.options.limit = limit;
                            if (kind === "transfer") return readyDriver.then((d)=>d.filterTransferLogs(filterBody, cacheHints));
                            else return readyDriver.then((d)=>d.filterEventLogs(filterBody, cacheHints));
                        }
                    };
                }
                //# sourceMappingURL=data:application/json;base64,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
                // EXTERNAL MODULE: ../framework/node_modules/bignumber.js/bignumber.js
                var bignumber = __webpack_require__(634);
                var bignumber_default = /*#__PURE__*/ __webpack_require__.n(bignumber);
                // CONCATENATED MODULE: ../framework/esm/vendor.js
                var __awaiter = function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                function newVendor(driver) {
                    return {
                        sign: (kind, msg)=>{
                            if (kind === "tx") {
                                test(msg, [
                                    clauseScheme
                                ], "arg1");
                                return newTxSigningService(Promise.resolve(driver), msg);
                            } else if (kind === "cert") {
                                test(msg, {
                                    purpose: (v)=>v === "agreement" || v === "identification" ? "" : `expected 'agreement' or 'identification'`,
                                    payload: {
                                        type: (v)=>v === "text" ? "" : `expected 'text'`,
                                        content: string
                                    }
                                }, "arg1");
                                return newCertSigningService(Promise.resolve(driver), msg);
                            } else throw new BadParameter(`arg0: expected 'tx' or 'cert'`);
                        }
                    };
                }
                function newTxSigningService(readyDriver, msg) {
                    const opts = {};
                    return {
                        signer (addr) {
                            opts.signer = test(addr, address, "arg0").toLowerCase();
                            return this;
                        },
                        gas (gas) {
                            opts.gas = test(gas, uint64, "arg0");
                            return this;
                        },
                        dependsOn (txid) {
                            opts.dependsOn = test(txid, bytes32, "arg0").toLowerCase();
                            return this;
                        },
                        link (url) {
                            opts.link = test(url, string, "arg0");
                            return this;
                        },
                        comment (text) {
                            opts.comment = test(text, string, "arg0");
                            return this;
                        },
                        delegate (url, signer) {
                            ensure(typeof url === "string", `arg0: expected url string`);
                            test(signer, dist /* optional */ .jt(address), "arg1");
                            opts.delegator = {
                                url: url,
                                signer: signer && signer.toLowerCase()
                            };
                            return this;
                        },
                        accepted (cb) {
                            ensure(typeof cb === "function", "arg0: expected function");
                            opts.onAccepted = cb;
                            return this;
                        },
                        request () {
                            const transformedMsg = msg.map((c)=>Object.assign(Object.assign({}, c), {
                                    value: new (bignumber_default())(c.value).toString(10)
                                }));
                            return (()=>__awaiter(this, void 0, void 0, function*() {
                                    try {
                                        const driver = yield readyDriver;
                                        return yield driver.signTx(transformedMsg, opts);
                                    } catch (err) {
                                        throw new Rejected(err.message);
                                    }
                                }))();
                        }
                    };
                }
                function newCertSigningService(readyDriver, msg) {
                    const opts = {};
                    return {
                        signer (addr) {
                            opts.signer = test(addr, address, "arg0").toLowerCase();
                            return this;
                        },
                        link (url) {
                            opts.link = test(url, string, "arg0");
                            return this;
                        },
                        accepted (cb) {
                            ensure(typeof cb === "function", "arg0: expected function");
                            opts.onAccepted = cb;
                            return this;
                        },
                        request () {
                            return (()=>__awaiter(this, void 0, void 0, function*() {
                                    try {
                                        const driver = yield readyDriver;
                                        return yield driver.signCert(msg, opts);
                                    } catch (err) {
                                        throw new Rejected(err.message);
                                    }
                                }))();
                        }
                    };
                }
                class Rejected extends Error {
                    constructor(msg){
                        super(msg);
                    }
                }
                Rejected.prototype.name = "Rejected";
                const clauseScheme = {
                    to: dist /* nullable */ .AG(address),
                    value: bigInt,
                    data: dist /* optional */ .jt(bytes),
                    comment: dist /* optional */ .jt(string),
                    abi: dist /* optional */ .jt((v)=>{
                        if (!(v instanceof Object)) return "expected object";
                        try {
                            new abi.Function(v).signature;
                            return "";
                        } catch (err) {
                            return `expected valid ABI (${err.message})`;
                        }
                    })
                };
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ../framework/esm/account-visitor.js
                function newAccountVisitor(readyDriver, addr) {
                    return {
                        get address () {
                            return addr;
                        },
                        get: ()=>{
                            return readyDriver.then((d)=>d.getAccount(addr, d.head.id));
                        },
                        getCode: ()=>{
                            return readyDriver.then((d)=>d.getCode(addr, d.head.id));
                        },
                        getStorage: (key)=>{
                            key = test(key, bytes32, "arg0").toLowerCase();
                            return readyDriver.then((d)=>d.getStorage(addr, key, d.head.id));
                        },
                        method: (jsonABI)=>{
                            let coder;
                            try {
                                coder = new abi.Function(JSON.parse(JSON.stringify(jsonABI)));
                            } catch (err) {
                                throw new BadParameter(`arg0: expected valid ABI (${err.message})`);
                            }
                            return newMethod(readyDriver, addr, coder);
                        },
                        event: (jsonABI)=>{
                            let coder;
                            try {
                                coder = new abi.Event(JSON.parse(JSON.stringify(jsonABI)));
                            } catch (err) {
                                throw new BadParameter(`arg0: expected valid ABI (${err.message})`);
                            }
                            return newEvent(readyDriver, addr, coder);
                        }
                    };
                }
                function newMethod(readyDriver, addr, coder) {
                    let value = 0;
                    const opts = {};
                    let cacheHints;
                    return {
                        value (val) {
                            value = test(val, bigInt, "arg0");
                            return this;
                        },
                        caller (addr) {
                            opts.caller = test(addr, address, "arg0").toLowerCase();
                            return this;
                        },
                        gas (gas) {
                            opts.gas = test(gas, uint64, "arg0");
                            return this;
                        },
                        gasPrice (gp) {
                            opts.gasPrice = test(gp, bigInt, "arg0").toString().toLowerCase();
                            return this;
                        },
                        gasPayer (addr) {
                            opts.gasPayer = test(addr, address, "arg0").toLowerCase();
                            return this;
                        },
                        cache (hints) {
                            cacheHints = test(hints, [
                                address
                            ], "arg0").map((t)=>t.toLowerCase());
                            return this;
                        },
                        asClause: (...args)=>{
                            const inputsLen = (coder.definition.inputs || []).length;
                            ensure(inputsLen === args.length, `args count expected ${inputsLen}`);
                            try {
                                const data = coder.encode(...args);
                                return {
                                    to: addr,
                                    value: value.toString().toLowerCase(),
                                    data: data
                                };
                            } catch (err) {
                                throw new BadParameter(`args can not be encoded (${err.message})`);
                            }
                        },
                        call (...args) {
                            const clause = this.asClause(...args);
                            return readyDriver.then((d)=>d.explain(Object.assign({
                                    clauses: [
                                        clause
                                    ]
                                }, opts), d.head.id, cacheHints)).then((outputs)=>outputs[0]).then((output)=>{
                                if (output.reverted) {
                                    const revertReason = decodeRevertReason(output.data);
                                    return Object.assign(Object.assign({}, output), {
                                        revertReason: revertReason,
                                        decoded: {}
                                    });
                                } else {
                                    const decoded = coder.decode(output.data);
                                    return Object.assign(Object.assign({}, output), {
                                        decoded: decoded
                                    });
                                }
                            });
                        },
                        transact (...args) {
                            const clause = this.asClause(...args);
                            return newTxSigningService(readyDriver, [
                                Object.assign(Object.assign({}, clause), {
                                    abi: coder.definition
                                })
                            ]);
                        }
                    };
                }
                function newEvent(readyDriver, addr, coder) {
                    const encode = (indexed)=>{
                        const topics = coder.encode(indexed);
                        return {
                            address: addr,
                            topic0: topics[0] || undefined,
                            topic1: topics[1] || undefined,
                            topic2: topics[2] || undefined,
                            topic3: topics[3] || undefined,
                            topic4: topics[4] || undefined
                        };
                    };
                    return {
                        asCriteria: (indexed)=>{
                            try {
                                return encode(indexed);
                            } catch (err) {
                                throw new BadParameter(`arg0: can not be encoded (${err.message})`);
                            }
                        },
                        filter: (indexed)=>{
                            test(indexed, [
                                {}
                            ], "arg0");
                            if (indexed.length === 0) indexed = [
                                {}
                            ];
                            const criteria = indexed.map((o, i)=>{
                                try {
                                    return encode(o);
                                } catch (err) {
                                    throw new BadParameter(`arg0.#${i}: can not be encoded (${err.message})`);
                                }
                            });
                            const filter = newFilter(readyDriver, "event", criteria);
                            return {
                                range (range) {
                                    filter.range(range);
                                    return this;
                                },
                                order (order) {
                                    filter.order(order);
                                    return this;
                                },
                                cache (hints) {
                                    filter.cache(hints);
                                    return this;
                                },
                                apply (offset, limit) {
                                    return filter.apply(offset, limit).then((events)=>events.map((event)=>{
                                            const decoded = coder.decode(event.data, event.topics);
                                            return Object.assign(Object.assign({}, event), {
                                                decoded: decoded
                                            });
                                        }));
                                }
                            };
                        }
                    };
                }
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ../framework/esm/block-visitor.js
                function newBlockVisitor(driver, revision) {
                    return {
                        get revision () {
                            return revision;
                        },
                        get: ()=>driver.getBlock(revision)
                    };
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmxvY2stdmlzaXRvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9ibG9jay12aXNpdG9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sVUFBVSxlQUFlLENBQzNCLE1BQXFCLEVBQ3JCLFFBQXlCO0lBR3pCLE9BQU87UUFDSCxJQUFJLFFBQVEsS0FBSyxPQUFPLFFBQVEsQ0FBQSxDQUFDLENBQUM7UUFDbEMsR0FBRyxFQUFFLEdBQUcsRUFBRSxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUMsUUFBUSxDQUFDO0tBQ3ZDLENBQUE7QUFDTCxDQUFDIn0=
                // CONCATENATED MODULE: ../framework/esm/tx-visitor.js
                function newTxVisitor(readyDriver, id) {
                    let allowPending = false;
                    return {
                        get id () {
                            return id;
                        },
                        allowPending () {
                            allowPending = true;
                            return this;
                        },
                        get: ()=>readyDriver.then((d)=>d.getTransaction(id, allowPending)),
                        getReceipt: ()=>readyDriver.then((d)=>d.getReceipt(id))
                    };
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHgtdmlzaXRvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy90eC12aXNpdG9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sVUFBVSxZQUFZLENBQ3hCLFdBQW1DLEVBQ25DLEVBQVU7SUFFVixJQUFJLFlBQVksR0FBRyxLQUFLLENBQUE7SUFDeEIsT0FBTztRQUNILElBQUksRUFBRTtZQUNGLE9BQU8sRUFBRSxDQUFBO1FBQ2IsQ0FBQztRQUNELFlBQVk7WUFDUixZQUFZLEdBQUcsSUFBSSxDQUFBO1lBQ25CLE9BQU8sSUFBSSxDQUFBO1FBQ2YsQ0FBQztRQUNELEdBQUcsRUFBRSxHQUFHLEVBQUUsQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLGNBQWMsQ0FBQyxFQUFFLEVBQUUsWUFBWSxDQUFDLENBQUM7UUFDcEUsVUFBVSxFQUFFLEdBQUcsRUFBRSxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsVUFBVSxDQUFDLEVBQUUsQ0FBQyxDQUFDO0tBQzVELENBQUE7QUFDTCxDQUFDIn0=
                // CONCATENATED MODULE: ../framework/esm/head-tracker.js
                var head_tracker_awaiter = function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                const checkpointInterval = 180;
                function newHeadTracker(driver) {
                    let head = Object.assign({}, driver.head);
                    let finalized = driver.genesis.id;
                    let resolvers = [];
                    (()=>head_tracker_awaiter(this, void 0, void 0, function*() {
                            for(;;)try {
                                const newHead = yield driver.pollHead();
                                if (newHead.id !== head.id && newHead.number >= head.number) {
                                    if (head.number === 0 || (newHead.number + 1) % checkpointInterval === 0) try {
                                        const finalizedBlk = yield driver.getBlock("finalized");
                                        if (finalizedBlk && finalizedBlk.id != finalized) finalized = finalizedBlk.id;
                                    } catch (_a) {}
                                    head = Object.assign({}, newHead);
                                    const resolversCopy = resolvers;
                                    resolvers = [];
                                    resolversCopy.forEach((r)=>r(newHead));
                                } else yield new Promise((resolve)=>setTimeout(resolve, 1000));
                            } catch (_b) {
                                break;
                            }
                        }))();
                    const genesisTs = driver.genesis.timestamp;
                    return {
                        get head () {
                            return head;
                        },
                        get progress () {
                            const nowTsMs = Date.now();
                            const headTsMs = head.timestamp * 1000;
                            if (nowTsMs - headTsMs < 30000) return 1;
                            const genesisTsMs = genesisTs * 1000;
                            const p = (headTsMs - genesisTsMs) / (nowTsMs - genesisTsMs);
                            return p < 0 ? NaN : p;
                        },
                        get finalized () {
                            return finalized;
                        },
                        ticker: ()=>{
                            let lastHeadId = head.id;
                            return {
                                next: ()=>{
                                    return new Promise((resolve)=>{
                                        if (lastHeadId !== head.id) return resolve(Object.assign({}, head));
                                        resolvers.push((newHead)=>{
                                            resolve(Object.assign({}, newHead));
                                        });
                                    }).then((h)=>{
                                        lastHeadId = h.id;
                                        return h;
                                    });
                                }
                            };
                        }
                    };
                }
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ../framework/esm/explainer.js
                function newExplainer(readyDriver, clauses) {
                    const opts = {};
                    let cacheHints;
                    return {
                        caller (addr) {
                            opts.caller = test(addr, address, "arg0").toLowerCase();
                            return this;
                        },
                        gas (gas) {
                            opts.gas = test(gas, uint64, "arg0");
                            return this;
                        },
                        gasPrice (gp) {
                            opts.gasPrice = test(gp, bigInt, "arg0").toString().toLowerCase();
                            return this;
                        },
                        gasPayer (addr) {
                            opts.gasPayer = test(addr, address, "arg0").toLowerCase();
                            return this;
                        },
                        cache (hints) {
                            cacheHints = test(hints, [
                                address
                            ], "arg0").map((t)=>t.toLowerCase());
                            return this;
                        },
                        execute () {
                            const transformedClauses = clauses.map((c)=>{
                                return {
                                    to: c.to ? c.to.toLowerCase() : null,
                                    value: new (bignumber_default())(c.value).toString(10),
                                    data: (c.data || "0x").toLowerCase()
                                };
                            });
                            return readyDriver.then((d)=>d.explain(Object.assign({
                                    clauses: transformedClauses
                                }, opts), d.head.id, cacheHints)).then((outputs)=>{
                                return outputs.map((o)=>{
                                    if (o.reverted) {
                                        const revertReason = decodeRevertReason(o.data);
                                        return Object.assign(Object.assign({}, o), {
                                            revertReason: revertReason
                                        });
                                    }
                                    return o;
                                });
                            });
                        }
                    };
                }
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ../framework/esm/thor.js
                var thor_awaiter = function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                function newThor(driver) {
                    const headTracker = newHeadTracker(driver);
                    const readyDriver = (()=>thor_awaiter(this, void 0, void 0, function*() {
                            if (headTracker.head.number > 0) return driver;
                            yield headTracker.ticker().next();
                            return driver;
                        }))();
                    const genesis = JSON.parse(JSON.stringify(driver.genesis));
                    return {
                        get genesis () {
                            return genesis;
                        },
                        get status () {
                            return {
                                head: headTracker.head,
                                progress: headTracker.progress,
                                finalized: headTracker.finalized
                            };
                        },
                        ticker: ()=>headTracker.ticker(),
                        account: (addr)=>{
                            addr = test(addr, address, "arg0").toLowerCase();
                            return newAccountVisitor(readyDriver, addr);
                        },
                        block: (revision)=>{
                            if (typeof revision === "undefined") revision = driver.head.id;
                            else ensure(typeof revision === "string" ? isHexBytes(revision, 32) : isUInt(revision, 32), "arg0: expected bytes32 or unsigned 32-bit integer");
                            return newBlockVisitor(driver, typeof revision === "string" ? revision.toLowerCase() : revision);
                        },
                        transaction: (id)=>{
                            id = test(id, bytes32, "arg0").toLowerCase();
                            return newTxVisitor(readyDriver, id);
                        },
                        filter: (kind, criteria)=>{
                            ensure(kind === "event" || kind === "transfer", `arg0: expected 'event' or 'transfer'`);
                            if (kind === "event") {
                                test(criteria, [
                                    eventCriteriaScheme
                                ], "arg1");
                                return newFilter(readyDriver, "event", criteria.map((c)=>{
                                    return {
                                        address: c.address ? c.address.toLowerCase() : undefined,
                                        topic0: c.topic0 ? c.topic0.toLowerCase() : undefined,
                                        topic1: c.topic1 ? c.topic1.toLowerCase() : undefined,
                                        topic2: c.topic2 ? c.topic2.toLowerCase() : undefined,
                                        topic3: c.topic3 ? c.topic3.toLowerCase() : undefined,
                                        topic4: c.topic4 ? c.topic4.toLowerCase() : undefined
                                    };
                                }));
                            } else {
                                test(criteria, [
                                    transferCriteriaScheme
                                ], "arg1");
                                return newFilter(readyDriver, "transfer", criteria.map((c)=>{
                                    return {
                                        txOrigin: c.txOrigin ? c.txOrigin.toLowerCase() : undefined,
                                        sender: c.sender ? c.sender.toLowerCase() : undefined,
                                        recipient: c.recipient ? c.recipient.toLowerCase() : undefined
                                    };
                                }));
                            }
                        },
                        explain: (clauses)=>{
                            test(clauses, [
                                thor_clauseScheme
                            ], "arg0");
                            return newExplainer(readyDriver, clauses);
                        }
                    };
                }
                const thor_clauseScheme = {
                    to: dist /* nullable */ .AG(address),
                    value: bigInt,
                    data: dist /* optional */ .jt(bytes)
                };
                const eventCriteriaScheme = {
                    address: dist /* optional */ .jt(address),
                    topic0: dist /* optional */ .jt(bytes32),
                    topic1: dist /* optional */ .jt(bytes32),
                    topic2: dist /* optional */ .jt(bytes32),
                    topic3: dist /* optional */ .jt(bytes32),
                    topic4: dist /* optional */ .jt(bytes32)
                };
                const transferCriteriaScheme = {
                    sender: dist /* optional */ .jt(address),
                    recipient: dist /* optional */ .jt(address),
                    txOrigin: dist /* optional */ .jt(address)
                };
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ../framework/esm/driver-guard.js
                function newDriverGuard(driver, errHandler) {
                    const test = (obj, scheme, path)=>{
                        try {
                            dist /* validate */ .Gu(obj, scheme, path);
                        } catch (err) {
                            if (errHandler) errHandler(err);
                            else // tslint:disable-next-line:no-console
                            console.warn(`Connex-Driver[MALFORMED RESPONSE]: ${err.message}`);
                        }
                        return obj;
                    };
                    const genesis = test(driver.genesis, blockScheme, "genesis");
                    return {
                        genesis: genesis,
                        get head () {
                            return test(driver.head, headScheme, "head");
                        },
                        pollHead () {
                            return driver.pollHead().then((h)=>test(h, headScheme, "getHead()"));
                        },
                        getBlock (revision) {
                            return driver.getBlock(revision).then((b)=>b ? test(b, blockScheme, "getBlock()") : b);
                        },
                        getTransaction (id, allowPending) {
                            return driver.getTransaction(id, allowPending).then((tx)=>tx ? test(tx, txScheme, "getTransaction()") : tx);
                        },
                        getReceipt (id) {
                            return driver.getReceipt(id).then((r)=>r ? test(r, receiptScheme, "getReceipt()") : r);
                        },
                        getAccount (addr, revision) {
                            return driver.getAccount(addr, revision).then((a)=>test(a, {
                                    balance: hexString,
                                    energy: hexString,
                                    hasCode: bool
                                }, "getAccount()"));
                        },
                        getCode (addr, revision) {
                            return driver.getCode(addr, revision).then((c)=>test(c, {
                                    code: bytes
                                }, "getCode()"));
                        },
                        getStorage (addr, key, revision) {
                            return driver.getStorage(addr, key, revision).then((s)=>test(s, {
                                    value: bytes32
                                }, "getStorage()"));
                        },
                        explain (arg, revision) {
                            return driver.explain(arg, revision).then((r)=>test(r, [
                                    vmOutputScheme
                                ], "explain()"));
                        },
                        filterEventLogs (arg) {
                            return driver.filterEventLogs(arg).then((r)=>test(r, [
                                    eventWithMetaScheme
                                ], "filterEventLogs()"));
                        },
                        filterTransferLogs (arg) {
                            return driver.filterTransferLogs(arg).then((r)=>test(r, [
                                    transferWithMetaScheme
                                ], "filterTransferLogs()"));
                        },
                        signTx (msg, options) {
                            return driver.signTx(msg, options).then((r)=>test(r, {
                                    txid: bytes32,
                                    signer: address
                                }, "signTx()"));
                        },
                        signCert (msg, options) {
                            return driver.signCert(msg, options).then((r)=>test(r, {
                                    annex: {
                                        domain: string,
                                        timestamp: uint64,
                                        signer: address
                                    },
                                    signature: (v)=>isHexBytes(v, 65) ? "" : "expected 65 bytes"
                                }, "signCert()"));
                        }
                    };
                }
                const headScheme = {
                    id: bytes32,
                    number: uint32,
                    timestamp: uint64,
                    parentID: bytes32,
                    txsFeatures: dist /* optional */ .jt(uint32),
                    gasLimit: uint64
                };
                const blockScheme = {
                    id: bytes32,
                    number: uint32,
                    size: uint32,
                    parentID: bytes32,
                    timestamp: uint64,
                    gasLimit: uint64,
                    beneficiary: address,
                    gasUsed: uint64,
                    totalScore: uint64,
                    txsRoot: bytes32,
                    txsFeatures: dist /* optional */ .jt(uint32),
                    stateRoot: bytes32,
                    receiptsRoot: bytes32,
                    signer: address,
                    com: dist /* optional */ .jt(bool),
                    isFinalized: dist /* optional */ .jt(bool),
                    isTrunk: bool,
                    transactions: [
                        bytes32
                    ]
                };
                const txScheme = {
                    id: bytes32,
                    chainTag: uint8,
                    blockRef: bytes8,
                    expiration: uint32,
                    gasPriceCoef: uint8,
                    gas: uint64,
                    origin: address,
                    delegator: dist /* nullable */ .AG(dist /* optional */ .jt(address)),
                    nonce: hexString,
                    dependsOn: dist /* nullable */ .AG(bytes32),
                    size: uint32,
                    clauses: [
                        {
                            to: dist /* nullable */ .AG(address),
                            value: hexString,
                            data: bytes
                        }
                    ],
                    meta: dist /* nullable */ .AG({
                        blockID: bytes32,
                        blockNumber: uint32,
                        blockTimestamp: uint64
                    })
                };
                const logMetaScheme = {
                    blockID: bytes32,
                    blockNumber: uint32,
                    blockTimestamp: uint64,
                    txID: bytes32,
                    txOrigin: address,
                    clauseIndex: uint32
                };
                const eventScheme = {
                    address: address,
                    topics: [
                        bytes32
                    ],
                    data: bytes
                };
                const eventWithMetaScheme = Object.assign(Object.assign({}, eventScheme), {
                    meta: logMetaScheme
                });
                const transferScheme = {
                    sender: address,
                    recipient: address,
                    amount: hexString
                };
                const transferWithMetaScheme = Object.assign(Object.assign({}, transferScheme), {
                    meta: logMetaScheme
                });
                const receiptScheme = {
                    gasUsed: uint64,
                    gasPayer: address,
                    paid: hexString,
                    reward: hexString,
                    reverted: bool,
                    outputs: [
                        {
                            contractAddress: dist /* nullable */ .AG(address),
                            events: [
                                eventScheme
                            ],
                            transfers: [
                                transferScheme
                            ]
                        }
                    ],
                    meta: {
                        blockID: bytes32,
                        blockNumber: uint32,
                        blockTimestamp: uint64,
                        txID: bytes32,
                        txOrigin: address
                    }
                };
                const vmOutputScheme = {
                    data: bytes,
                    vmError: string,
                    gasUsed: uint64,
                    reverted: bool,
                    revertReason: ()=>"",
                    events: [
                        {
                            address: address,
                            topics: [
                                bytes32
                            ],
                            data: bytes
                        }
                    ],
                    transfers: [
                        {
                            sender: address,
                            recipient: address,
                            amount: hexString
                        }
                    ]
                };
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ../framework/esm/index.js
                /**
 * Class implements Connex interface
 */ class Framework {
                    /**
     * constructor
     * @param driver the driver instance
     */ constructor(driver){
                        this.thor = newThor(driver);
                        this.vendor = newVendor(driver);
                    }
                    /**
     * create a wrapper for driver, to validate responses. it should be helpful to make sure driver is properly
     * implemented in development stage.
     * @param driver the driver to be wrapped
     * @param errorHandler optional error handler. If omitted, error message will be printed via console.warn.
     */ static guardDriver(driver, errorHandler) {
                        return newDriverGuard(driver, errorHandler);
                    }
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLFFBQVEsQ0FBQTtBQUNoQyxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sVUFBVSxDQUFBO0FBQ3BDLE9BQU8sRUFBRSxjQUFjLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQTtBQUUvQzs7R0FFRztBQUNILE1BQU0sT0FBTyxTQUFTO0lBaUJsQjs7O09BR0c7SUFDSCxZQUFZLE1BQXFCO1FBQzdCLElBQUksQ0FBQyxJQUFJLEdBQUcsT0FBTyxDQUFDLE1BQU0sQ0FBQyxDQUFBO1FBQzNCLElBQUksQ0FBQyxNQUFNLEdBQUcsU0FBUyxDQUFDLE1BQU0sQ0FBQyxDQUFBO0lBQ25DLENBQUM7SUF2QkQ7Ozs7O09BS0c7SUFDSSxNQUFNLENBQUMsV0FBVyxDQUNyQixNQUFxQixFQUNyQixZQUFtQztRQUVuQyxPQUFPLGNBQWMsQ0FBQyxNQUFNLEVBQUUsWUFBWSxDQUFDLENBQUE7SUFDL0MsQ0FBQztDQWFKO0FBRUQsT0FBTyxFQUFFLFNBQVMsRUFBRSxDQUFBIn0=
                // CONCATENATED MODULE: ./esm/config.js
                const genesisBlocks = {
                    main: {
                        number: 0,
                        id: "0x00000000851caf3cfdb6e899cf5958bfb1ac3413d346d43539627e6be7ec1b4a",
                        size: 170,
                        parentID: "0xffffffff53616c757465202620526573706563742c20457468657265756d2100",
                        timestamp: 1530316800,
                        gasLimit: 10000000,
                        beneficiary: "0x0000000000000000000000000000000000000000",
                        gasUsed: 0,
                        totalScore: 0,
                        txsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
                        txsFeatures: 0,
                        stateRoot: "0x09bfdf9e24dd5cd5b63f3c1b5d58b97ff02ca0490214a021ed7d99b93867839c",
                        receiptsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
                        signer: "0x0000000000000000000000000000000000000000",
                        isTrunk: true,
                        transactions: []
                    },
                    test: {
                        number: 0,
                        id: "0x000000000b2bce3c70bc649a02749e8687721b09ed2e15997f466536b20bb127",
                        size: 170,
                        parentID: "0xffffffff00000000000000000000000000000000000000000000000000000000",
                        timestamp: 1530014400,
                        gasLimit: 10000000,
                        beneficiary: "0x0000000000000000000000000000000000000000",
                        gasUsed: 0,
                        totalScore: 0,
                        txsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
                        txsFeatures: 0,
                        stateRoot: "0x4ec3af0acbad1ae467ad569337d2fe8576fe303928d35b8cdd91de47e9ac84bb",
                        receiptsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
                        signer: "0x0000000000000000000000000000000000000000",
                        isTrunk: true,
                        transactions: []
                    }
                };
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NvbmZpZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUc7SUFDekIsSUFBSSxFQUFFO1FBQ0YsTUFBTSxFQUFFLENBQUM7UUFDVCxFQUFFLEVBQUUsb0VBQW9FO1FBQ3hFLElBQUksRUFBRSxHQUFHO1FBQ1QsUUFBUSxFQUFFLG9FQUFvRTtRQUM5RSxTQUFTLEVBQUUsVUFBVTtRQUNyQixRQUFRLEVBQUUsUUFBUTtRQUNsQixXQUFXLEVBQUUsNENBQTRDO1FBQ3pELE9BQU8sRUFBRSxDQUFDO1FBQ1YsVUFBVSxFQUFFLENBQUM7UUFDYixPQUFPLEVBQUUsb0VBQW9FO1FBQzdFLFdBQVcsRUFBRSxDQUFDO1FBQ2QsU0FBUyxFQUFFLG9FQUFvRTtRQUMvRSxZQUFZLEVBQUUsb0VBQW9FO1FBQ2xGLE1BQU0sRUFBRSw0Q0FBNEM7UUFDcEQsT0FBTyxFQUFFLElBQUk7UUFDYixZQUFZLEVBQUUsRUFBRTtLQUNuQjtJQUNELElBQUksRUFBRTtRQUNGLE1BQU0sRUFBRSxDQUFDO1FBQ1QsRUFBRSxFQUFFLG9FQUFvRTtRQUN4RSxJQUFJLEVBQUUsR0FBRztRQUNULFFBQVEsRUFBRSxvRUFBb0U7UUFDOUUsU0FBUyxFQUFFLFVBQVU7UUFDckIsUUFBUSxFQUFFLFFBQVE7UUFDbEIsV0FBVyxFQUFFLDRDQUE0QztRQUN6RCxPQUFPLEVBQUUsQ0FBQztRQUNWLFVBQVUsRUFBRSxDQUFDO1FBQ2IsT0FBTyxFQUFFLG9FQUFvRTtRQUM3RSxXQUFXLEVBQUUsQ0FBQztRQUNkLFNBQVMsRUFBRSxvRUFBb0U7UUFDL0UsWUFBWSxFQUFFLG9FQUFvRTtRQUNsRixNQUFNLEVBQUUsNENBQTRDO1FBQ3BELE9BQU8sRUFBRSxJQUFJO1FBQ2IsWUFBWSxFQUFFLEVBQUU7S0FDbkI7Q0FDSixDQUFBIn0=
                // CONCATENATED MODULE: ../driver/esm/promint.js
                /** class to make promise interruptable */ class PromInt {
                    constructor(){
                        this.rejectors = new Set();
                    }
                    /**
     * interrupt all wrapped promises
     */ interrupt() {
                        const rejectors = this.rejectors;
                        this.rejectors = new Set();
                        rejectors.forEach((r)=>r(new InterruptedError()));
                    }
                    /**
     * wrap the promise
     * @param p the given promise
     * @returns the wrapped promise which will raise InterruptedError on interruption
     */ wrap(p) {
                        return new Promise((resolve, reject)=>{
                            const rejectors = this.rejectors;
                            rejectors.add(reject);
                            p.then(resolve).catch(reject).then(()=>rejectors.delete(reject));
                        });
                    }
                }
                class InterruptedError extends Error {
                    constructor(){
                        super("promise interrupted");
                    }
                }
                InterruptedError.prototype.name = "InterruptedError";
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvbWludC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9wcm9taW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLDBDQUEwQztBQUMxQyxNQUFNLE9BQU8sT0FBTztJQUFwQjtRQUNZLGNBQVMsR0FBRyxJQUFJLEdBQUcsRUFBd0IsQ0FBQTtJQTJCdkQsQ0FBQztJQXpCRzs7T0FFRztJQUNJLFNBQVM7UUFDWixNQUFNLFNBQVMsR0FBRyxJQUFJLENBQUMsU0FBUyxDQUFBO1FBQ2hDLElBQUksQ0FBQyxTQUFTLEdBQUcsSUFBSSxHQUFHLEVBQUUsQ0FBQTtRQUUxQixTQUFTLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLElBQUksZ0JBQWdCLEVBQUUsQ0FBQyxDQUFDLENBQUE7SUFDckQsQ0FBQztJQUVEOzs7O09BSUc7SUFDSSxJQUFJLENBQUksQ0FBYTtRQUN4QixPQUFPLElBQUksT0FBTyxDQUFJLENBQUMsT0FBTyxFQUFFLE1BQU0sRUFBRSxFQUFFO1lBQ3RDLE1BQU0sU0FBUyxHQUFHLElBQUksQ0FBQyxTQUFTLENBQUE7WUFDaEMsU0FBUyxDQUFDLEdBQUcsQ0FBQyxNQUFNLENBQUMsQ0FBQTtZQUVyQixLQUFLLENBQUMsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDO2lCQUNmLEtBQUssQ0FBQyxNQUFNLENBQUM7aUJBQ2IsSUFBSSxDQUFDLEdBQUcsRUFBRSxDQUFDLFNBQVMsQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQTtRQUM3QyxDQUFDLENBQUMsQ0FBQTtJQUNOLENBQUM7Q0FDSjtBQUVELE1BQU0sT0FBTyxnQkFBaUIsU0FBUSxLQUFLO0lBQ3ZDO1FBQ0ksS0FBSyxDQUFDLHFCQUFxQixDQUFDLENBQUE7SUFDaEMsQ0FBQztDQUNKO0FBRUQsZ0JBQWdCLENBQUMsU0FBUyxDQUFDLElBQUksR0FBRyxrQkFBa0IsQ0FBQSJ9
                // EXTERNAL MODULE: ../driver/node_modules/lru-cache/index.js
                var lru_cache = __webpack_require__(9992);
                // EXTERNAL MODULE: ../driver/node_modules/bignumber.js/bignumber.js
                var bignumber_js_bignumber = __webpack_require__(4491);
                var bignumber_js_bignumber_default = /*#__PURE__*/ __webpack_require__.n(bignumber_js_bignumber);
                // CONCATENATED MODULE: ../driver/node_modules/thor-devkit/esm/blake2b.js
                /* provided dependency */ var blake2b_Buffer = __webpack_require__(8764)["Buffer"];
                const blake = __webpack_require__(1161);
                /**
 * computes blake2b 256bit hash of given data
 * @param data one or more Buffer | string
 */ function blake2b256(...data) {
                    const ctx = blake.blake2bInit(32, null);
                    data.forEach((d)=>{
                        if (blake2b_Buffer.isBuffer(d)) blake.blake2bUpdate(ctx, d);
                        else blake.blake2bUpdate(ctx, blake2b_Buffer.from(d, "utf8"));
                    });
                    return blake2b_Buffer.from(blake.blake2bFinal(ctx));
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmxha2UyYi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9ibGFrZTJiLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sS0FBSyxHQUFHLE9BQU8sQ0FBQyxTQUFTLENBQUMsQ0FBQTtBQUVoQzs7O0dBR0c7QUFDSCxNQUFNLFVBQVUsVUFBVSxDQUFDLEdBQUcsSUFBNEI7SUFDdEQsTUFBTSxHQUFHLEdBQUcsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLEVBQUUsSUFBSSxDQUFDLENBQUE7SUFDdkMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsRUFBRTtRQUNiLElBQUksTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsRUFBRTtZQUNwQixLQUFLLENBQUMsYUFBYSxDQUFDLEdBQUcsRUFBRSxDQUFDLENBQUMsQ0FBQTtTQUM5QjthQUFNO1lBQ0gsS0FBSyxDQUFDLGFBQWEsQ0FBQyxHQUFHLEVBQUUsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUUsTUFBTSxDQUFDLENBQUMsQ0FBQTtTQUNuRDtJQUNMLENBQUMsQ0FBQyxDQUFBO0lBQ0YsT0FBTyxNQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxZQUFZLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQTtBQUMvQyxDQUFDIn0=
                // CONCATENATED MODULE: ../driver/esm/bloom.js
                function bloom_newFilter(bits, k) {
                    const nBits = bits.length * 8;
                    return {
                        contains (key) {
                            let hash = blake2b256(key).readUInt32BE(0);
                            const delta = hash >>> 17 | hash << 15 >>> 0;
                            for(let i = 0; i < k; i++){
                                const bitPos = hash % nBits;
                                const index = bitPos >>> 3;
                                const bit = 1 << bitPos % 8;
                                if (!(bits[index] & bit)) return false;
                                hash = hash + delta >>> 0;
                            }
                            return true;
                        }
                    };
                }
                // // test vector
                // const bits = Buffer.from('63b2a4758c74e246c818e080b870437f5327a15cf81172512d98e61c54361a851ba8f108420e6b2b74a4196fb8e7bfe2b96c985e49abddb21c0600063997c93edb7c54921551600bcfc80fb62bfcd045c030b328eb8b5498e06dce610d22e901201226226441b8da094141526e0e58f5baf53064d63d598a4024bf68e0', 'hex')
                // const f = newFilter(bits, 6)
                // for (let i = 0; i < 100; i++) {
                //     if (!f.contains(Buffer.from(i + ''))) {
                //         throw new Error('should return true')
                //     }
                // }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmxvb20uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvYmxvb20udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFVBQVUsRUFBRSxNQUFNLGFBQWEsQ0FBQTtBQUV4QyxNQUFNLFVBQVUsU0FBUyxDQUFDLElBQVksRUFBRSxDQUFTO0lBQzdDLE1BQU0sS0FBSyxHQUFHLElBQUksQ0FBQyxNQUFNLEdBQUcsQ0FBQyxDQUFBO0lBQzdCLE9BQU87UUFDSCxRQUFRLENBQUMsR0FBVztZQUNoQixJQUFJLElBQUksR0FBRyxVQUFVLENBQUMsR0FBRyxDQUFDLENBQUMsWUFBWSxDQUFDLENBQUMsQ0FBQyxDQUFBO1lBQzFDLE1BQU0sS0FBSyxHQUFHLENBQUMsSUFBSSxLQUFLLEVBQUUsQ0FBQyxHQUFHLENBQUMsSUFBSSxJQUFJLEVBQUUsS0FBSyxDQUFDLENBQUMsQ0FBQTtZQUNoRCxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsRUFBRSxFQUFFO2dCQUN4QixNQUFNLE1BQU0sR0FBRyxJQUFJLEdBQUcsS0FBSyxDQUFBO2dCQUMzQixNQUFNLEtBQUssR0FBRyxNQUFNLEtBQUssQ0FBQyxDQUFBO2dCQUMxQixNQUFNLEdBQUcsR0FBRyxDQUFDLElBQUksQ0FBQyxNQUFNLEdBQUcsQ0FBQyxDQUFDLENBQUE7Z0JBQzdCLElBQUksQ0FBQyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsR0FBRyxHQUFHLENBQUMsRUFBRTtvQkFDdEIsT0FBTyxLQUFLLENBQUE7aUJBQ2Y7Z0JBQ0QsSUFBSSxHQUFHLENBQUMsSUFBSSxHQUFHLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQTthQUM5QjtZQUNELE9BQU8sSUFBSSxDQUFBO1FBQ2YsQ0FBQztLQUNKLENBQUE7QUFDTCxDQUFDO0FBQ0QsaUJBQWlCO0FBQ2pCLGdTQUFnUztBQUNoUywrQkFBK0I7QUFDL0Isa0NBQWtDO0FBQ2xDLDhDQUE4QztBQUM5QyxnREFBZ0Q7QUFDaEQsUUFBUTtBQUNSLElBQUkifQ==
                // CONCATENATED MODULE: ../driver/esm/cache.js
                /* provided dependency */ var cache_Buffer = __webpack_require__(8764)["Buffer"];
                var cache_awaiter = function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                const WINDOW_LEN = 12;
                class Cache {
                    constructor(){
                        this.irreversible = {
                            blocks: new lru_cache(256),
                            txs: new lru_cache(512),
                            receipts: new lru_cache(512)
                        };
                        this.window = [];
                    }
                    handleNewBlock(head, bloom, block) {
                        while(this.window.length > 0){
                            const top = this.window[this.window.length - 1];
                            if (top.id === head.id) return;
                            if (top.id === head.parentID) break;
                            this.window.pop();
                        }
                        this.window.push(Object.assign(Object.assign({}, head), {
                            bloom: bloom ? bloom_newFilter(cache_Buffer.from(bloom.bits.slice(2), "hex"), bloom.k) : undefined,
                            block: block,
                            accounts: new Map(),
                            txs: new Map(),
                            receipts: new Map(),
                            tied: new Map()
                        }));
                        // shift out old slots and move cached items into frozen cache
                        while(this.window.length > WINDOW_LEN){
                            const bottom = this.window.shift();
                            bottom.txs.forEach((v, k)=>this.irreversible.txs.set(k, v));
                            bottom.receipts.forEach((v, k)=>this.irreversible.receipts.set(k, v));
                            if (bottom.block) {
                                this.irreversible.blocks.set(bottom.block.id, bottom.block);
                                this.irreversible.blocks.set(bottom.block.number, bottom.block);
                            }
                        }
                    }
                    getBlock(revision, fetch1) {
                        return cache_awaiter(this, void 0, void 0, function*() {
                            let block = this.irreversible.blocks.get(revision) || null;
                            if (block) return block;
                            const { slot: slot } = this.findSlot(revision);
                            if (slot && slot.block) return slot.block;
                            block = yield fetch1();
                            if (block) {
                                if (slot && slot.id === block.id) slot.block = block;
                                if (this.isIrreversible(block.number)) {
                                    this.irreversible.blocks.set(block.id, block);
                                    if (block.isTrunk) this.irreversible.blocks.set(block.number, block);
                                }
                            }
                            return block;
                        });
                    }
                    getTx(txid, fetch1) {
                        return cache_awaiter(this, void 0, void 0, function*() {
                            let tx = this.irreversible.txs.get(txid) || null;
                            if (tx) return tx;
                            for (const slot of this.window){
                                tx = slot.txs.get(txid) || null;
                                if (tx) return tx;
                            }
                            tx = yield fetch1();
                            if (tx && tx.meta) {
                                const { slot: slot } = this.findSlot(tx.meta.blockID);
                                if (slot) slot.txs.set(txid, tx);
                                if (this.isIrreversible(tx.meta.blockNumber)) this.irreversible.txs.set(txid, tx);
                            }
                            return tx;
                        });
                    }
                    getReceipt(txid, fetch1) {
                        return cache_awaiter(this, void 0, void 0, function*() {
                            let receipt = this.irreversible.receipts.get(txid) || null;
                            if (receipt) return receipt;
                            for (const slot of this.window){
                                receipt = slot.receipts.get(txid) || null;
                                if (receipt) return receipt;
                            }
                            receipt = yield fetch1();
                            if (receipt) {
                                const { slot: slot } = this.findSlot(receipt.meta.blockID);
                                if (slot) slot.receipts.set(txid, receipt);
                                if (this.isIrreversible(receipt.meta.blockNumber)) this.irreversible.receipts.set(txid, receipt);
                            }
                            return receipt;
                        });
                    }
                    getAccount(addr, revision, fetch1) {
                        return cache_awaiter(this, void 0, void 0, function*() {
                            const found = this.findSlot(revision);
                            for(let i = found.index; i >= 0; i--){
                                const slot = this.window[i];
                                const acc = slot.accounts.get(addr);
                                if (acc) {
                                    if (i !== found.index) found.slot.accounts.set(addr, acc);
                                    return acc.snapshot(found.slot.timestamp);
                                }
                                if (!slot.bloom || testBytesHex(slot.bloom, addr)) break;
                            }
                            const accObj = yield fetch1();
                            if (found.slot) found.slot.accounts.set(addr, new Account(accObj, found.slot.timestamp));
                            return accObj;
                        });
                    }
                    /**
     * get cached entry which is tied to a batch of addresses
     * @param key the cache key
     * @param revision block id where cache bound to
     * @param fetch to fetch value when cache missing
     * @param hints array of tied addresses, as the gist to invalidate cache key. undefined means the key is always
     * invalidated on different revision.
     */ getTied(key, revision, fetch1, hints) {
                        return cache_awaiter(this, void 0, void 0, function*() {
                            const found = this.findSlot(revision);
                            for(let i = found.index; i >= 0; i--){
                                const slot = this.window[i];
                                const v = slot.tied.get(key);
                                if (v) {
                                    if (i !== found.index) found.slot.tied.set(key, v);
                                    return v;
                                }
                                if (!slot.bloom || !hints) break;
                                // if hints.length === 0, never invalidate cache
                                if (hints.some((t)=>testBytesHex(slot.bloom, t))) break;
                            }
                            const value = yield fetch1();
                            if (found.slot) found.slot.tied.set(key, value);
                            return value;
                        });
                    }
                    findSlot(revision) {
                        const index = this.window.findIndex((s)=>s.id === revision || s.number === revision);
                        if (index >= 0) return {
                            slot: this.window[index],
                            index: index
                        };
                        return {
                            index: index
                        };
                    }
                    isIrreversible(n) {
                        if (this.window.length > 0) return n < this.window[this.window.length - 1].number - WINDOW_LEN;
                        return false;
                    }
                }
                function testBytesHex(filter, hex) {
                    let buf = cache_Buffer.from(hex.slice(2), "hex");
                    const nzIndex = buf.findIndex((v)=>v !== 0);
                    if (nzIndex < 0) buf = cache_Buffer.alloc(0);
                    else buf = buf.slice(nzIndex);
                    return filter.contains(buf);
                }
                const ENERGY_GROWTH_RATE = 5000000000;
                class Account {
                    constructor(obj, initTimestamp){
                        this.obj = obj;
                        this.initTimestamp = initTimestamp;
                    }
                    snapshot(timestamp) {
                        return Object.assign(Object.assign({}, this.obj), {
                            energy: this.energyAt(timestamp)
                        });
                    }
                    energyAt(timestamp) {
                        if (timestamp < this.initTimestamp) return this.obj.energy;
                        return "0x" + new (bignumber_js_bignumber_default())(this.obj.balance).times(timestamp - this.initTimestamp).times(ENERGY_GROWTH_RATE).dividedToIntegerBy(1e18).plus(this.obj.energy).toString(16);
                    }
                }
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ../driver/esm/common.js
                function sleep(ms) {
                    return new Promise((resolve)=>setTimeout(resolve, ms));
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NvbW1vbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxNQUFNLFVBQVUsS0FBSyxDQUFDLEVBQVU7SUFDNUIsT0FBTyxJQUFJLE9BQU8sQ0FBQyxPQUFPLENBQUMsRUFBRSxDQUFDLFVBQVUsQ0FBQyxPQUFPLEVBQUUsRUFBRSxDQUFDLENBQUMsQ0FBQTtBQUMxRCxDQUFDIn0=
                // CONCATENATED MODULE: ../driver/esm/driver-no-vendor.js
                var driver_no_vendor_awaiter = function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /** class implements Connex.Driver leaves out Vendor related methods */ class DriverNoVendor {
                    constructor(net, genesis, initialHead){
                        this.net = net;
                        this.genesis = genesis;
                        this.headResolvers = [];
                        this.int = new PromInt();
                        this.cache = new Cache();
                        // to merge concurrent identical remote requests
                        this.pendingRequests = {};
                        if (initialHead) this.head = initialHead;
                        else this.head = {
                            id: genesis.id,
                            number: genesis.number,
                            timestamp: genesis.timestamp,
                            parentID: genesis.parentID,
                            txsFeatures: genesis.txsFeatures,
                            gasLimit: genesis.gasLimit
                        };
                        this.headTrackerLoop();
                    }
                    // close the driver to prevent mem leak
                    close() {
                        this.int.interrupt();
                    }
                    // implementations
                    pollHead() {
                        return this.int.wrap(new Promise((resolve)=>{
                            this.headResolvers.push(()=>resolve(this.head));
                        }));
                    }
                    getBlock(revision) {
                        return this.cache.getBlock(revision, ()=>this.httpGet(`blocks/${revision}`));
                    }
                    getTransaction(id, allowPending) {
                        return this.cache.getTx(id, ()=>{
                            const query = {
                                head: this.head.id
                            };
                            if (allowPending) query.pending = "true";
                            return this.httpGet(`transactions/${id}`, query);
                        });
                    }
                    getReceipt(id) {
                        return this.cache.getReceipt(id, ()=>this.httpGet(`transactions/${id}/receipt`, {
                                head: this.head.id
                            }));
                    }
                    getAccount(addr, revision) {
                        return this.cache.getAccount(addr, revision, ()=>this.httpGet(`accounts/${addr}`, {
                                revision: revision
                            }));
                    }
                    getCode(addr, revision) {
                        return this.cache.getTied(`code-${addr}`, revision, ()=>this.httpGet(`accounts/${addr}/code`, {
                                revision: revision
                            }));
                    }
                    getStorage(addr, key, revision) {
                        return this.cache.getTied(`storage-${addr}-${key}`, revision, ()=>this.httpGet(`accounts/${addr}/storage/${key}`, {
                                revision: revision
                            }));
                    }
                    explain(arg, revision, cacheHints) {
                        const cacheKey = `explain-${blake2b256(JSON.stringify(arg)).toString("hex")}`;
                        return this.cache.getTied(cacheKey, revision, ()=>this.httpPost("accounts/*", arg, {
                                revision: revision
                            }), cacheHints);
                    }
                    filterEventLogs(arg, cacheHints) {
                        const cacheKey = `event-${blake2b256(JSON.stringify(arg)).toString("hex")}`;
                        return this.cache.getTied(cacheKey, this.head.id, ()=>this.httpPost("logs/event", arg), cacheHints);
                    }
                    filterTransferLogs(arg, cacheHints) {
                        const cacheKey = `transfer-${blake2b256(JSON.stringify(arg)).toString("hex")}`;
                        return this.cache.getTied(cacheKey, this.head.id, ()=>this.httpPost("logs/transfer", arg), cacheHints);
                    }
                    signTx(msg, options) {
                        throw new Error("signer not implemented");
                    }
                    signCert(msg, options) {
                        throw new Error("signer not implemented");
                    }
                    //////
                    mergeRequest(req, ...keyParts) {
                        const key = JSON.stringify(keyParts);
                        const pending = this.pendingRequests[key];
                        // eslint-disable-next-line @typescript-eslint/no-misused-promises
                        if (pending) return pending;
                        return this.pendingRequests[key] = (()=>driver_no_vendor_awaiter(this, void 0, void 0, function*() {
                                try {
                                    return yield req();
                                } finally{
                                    delete this.pendingRequests[key];
                                }
                            }))();
                    }
                    httpGet(path, query) {
                        return this.mergeRequest(()=>{
                            return this.net.http("GET", path, {
                                query: query,
                                validateResponseHeader: this.headerValidator
                            });
                        }, path, query || "");
                    }
                    httpPost(path, body, query) {
                        return this.mergeRequest(()=>{
                            return this.net.http("POST", path, {
                                query: query,
                                body: body,
                                validateResponseHeader: this.headerValidator
                            });
                        }, path, query || "", body || "");
                    }
                    get headerValidator() {
                        return (headers)=>{
                            const xgid = headers["x-genesis-id"];
                            if (xgid && xgid !== this.genesis.id) throw new Error(`responded 'x-genesis-id' not matched`);
                        };
                    }
                    emitNewHead() {
                        const resolvers = this.headResolvers;
                        this.headResolvers = [];
                        resolvers.forEach((r)=>r());
                    }
                    headTrackerLoop() {
                        return driver_no_vendor_awaiter(this, void 0, void 0, function*() {
                            for(;;){
                                let attemptWs = false;
                                try {
                                    const best = yield this.int.wrap(this.httpGet("blocks/best"));
                                    if (best.id !== this.head.id && best.number >= this.head.number) {
                                        this.head = {
                                            id: best.id,
                                            number: best.number,
                                            timestamp: best.timestamp,
                                            parentID: best.parentID,
                                            txsFeatures: best.txsFeatures,
                                            gasLimit: best.gasLimit
                                        };
                                        this.cache.handleNewBlock(this.head, undefined, best);
                                        this.emitNewHead();
                                        if (Date.now() - this.head.timestamp * 1000 < 60000) // nearly synced
                                        attemptWs = true;
                                    }
                                } catch (err) {
                                    if (err instanceof InterruptedError) break;
                                }
                                if (attemptWs) try {
                                    yield this.trackWs();
                                } catch (err) {
                                    if (err instanceof InterruptedError) break;
                                }
                                try {
                                    yield this.int.wrap(sleep(8000));
                                } catch (_a) {
                                    break;
                                }
                            }
                        });
                    }
                    trackWs() {
                        return driver_no_vendor_awaiter(this, void 0, void 0, function*() {
                            const wsPath = `subscriptions/beat2?pos=${this.head.parentID}`;
                            const wsr = this.net.openWebSocketReader(wsPath);
                            try {
                                for(;;){
                                    const data = yield this.int.wrap(wsr.read());
                                    const beat = JSON.parse(data);
                                    if (!beat.obsolete && beat.id !== this.head.id && beat.number >= this.head.number) {
                                        this.head = {
                                            id: beat.id,
                                            number: beat.number,
                                            timestamp: beat.timestamp,
                                            parentID: beat.parentID,
                                            txsFeatures: beat.txsFeatures,
                                            gasLimit: beat.gasLimit
                                        };
                                        this.cache.handleNewBlock(this.head, {
                                            k: beat.k,
                                            bits: beat.bloom
                                        });
                                        this.emitNewHead();
                                    }
                                }
                            } finally{
                                wsr.close();
                            }
                        });
                    }
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZHJpdmVyLW5vLXZlbmRvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9kcml2ZXItbm8tdmVuZG9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUNBLE9BQU8sRUFBRSxPQUFPLEVBQUUsZ0JBQWdCLEVBQUUsTUFBTSxXQUFXLENBQUE7QUFDckQsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLFNBQVMsQ0FBQTtBQUMvQixPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sYUFBYSxDQUFBO0FBQ3hDLE9BQU8sRUFBRSxLQUFLLEVBQUUsTUFBTSxVQUFVLENBQUE7QUFFaEMsdUVBQXVFO0FBQ3ZFLE1BQU0sT0FBTyxjQUFjO0lBU3ZCLFlBQ3VCLEdBQVEsRUFDbEIsT0FBMEIsRUFDbkMsV0FBd0M7UUFGckIsUUFBRyxHQUFILEdBQUcsQ0FBSztRQUNsQixZQUFPLEdBQVAsT0FBTyxDQUFtQjtRQVIvQixrQkFBYSxHQUFHLEVBQXVCLENBQUE7UUFDOUIsUUFBRyxHQUFHLElBQUksT0FBTyxFQUFFLENBQUE7UUFDbkIsVUFBSyxHQUFHLElBQUksS0FBSyxFQUFFLENBQUE7UUFDcEMsZ0RBQWdEO1FBQy9CLG9CQUFlLEdBQWlDLEVBQUUsQ0FBQTtRQU8vRCxJQUFJLFdBQVcsRUFBRTtZQUNiLElBQUksQ0FBQyxJQUFJLEdBQUcsV0FBVyxDQUFBO1NBQzFCO2FBQU07WUFDSCxJQUFJLENBQUMsSUFBSSxHQUFHO2dCQUNSLEVBQUUsRUFBRSxPQUFPLENBQUMsRUFBRTtnQkFDZCxNQUFNLEVBQUUsT0FBTyxDQUFDLE1BQU07Z0JBQ3RCLFNBQVMsRUFBRSxPQUFPLENBQUMsU0FBUztnQkFDNUIsUUFBUSxFQUFFLE9BQU8sQ0FBQyxRQUFRO2dCQUMxQixXQUFXLEVBQUUsT0FBTyxDQUFDLFdBQVc7Z0JBQ2hDLFFBQVEsRUFBRSxPQUFPLENBQUMsUUFBUTthQUM3QixDQUFBO1NBQ0o7UUFDRCxLQUFLLElBQUksQ0FBQyxlQUFlLEVBQUUsQ0FBQTtJQUMvQixDQUFDO0lBRUQsdUNBQXVDO0lBQ2hDLEtBQUs7UUFDUixJQUFJLENBQUMsR0FBRyxDQUFDLFNBQVMsRUFBRSxDQUFBO0lBQ3hCLENBQUM7SUFFRCxrQkFBa0I7SUFDWCxRQUFRO1FBQ1gsT0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLElBQUksQ0FDaEIsSUFBSSxPQUFPLENBQTZCLE9BQU8sQ0FBQyxFQUFFO1lBQzlDLElBQUksQ0FBQyxhQUFhLENBQUMsSUFBSSxDQUFDLEdBQUcsRUFBRSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQTtRQUNyRCxDQUFDLENBQUMsQ0FBQyxDQUFBO0lBQ1gsQ0FBQztJQUVNLFFBQVEsQ0FBQyxRQUF5QjtRQUNyQyxPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxDQUFDLFFBQVEsRUFBRSxHQUFHLEVBQUUsQ0FDdEMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxVQUFVLFFBQVEsRUFBRSxDQUFDLENBQUMsQ0FBQTtJQUMzQyxDQUFDO0lBQ00sY0FBYyxDQUFDLEVBQVUsRUFBRSxZQUFxQjtRQUNuRCxPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLEVBQUUsRUFBRSxHQUFHLEVBQUU7WUFDN0IsTUFBTSxLQUFLLEdBQTJCLEVBQUUsSUFBSSxFQUFFLElBQUksQ0FBQyxJQUFJLENBQUMsRUFBRSxFQUFFLENBQUE7WUFDNUQsSUFBSSxZQUFZLEVBQUU7Z0JBQ2QsS0FBSyxDQUFDLE9BQU8sR0FBRyxNQUFNLENBQUE7YUFDekI7WUFDRCxPQUFPLElBQUksQ0FBQyxPQUFPLENBQUMsZ0JBQWdCLEVBQUUsRUFBRSxFQUFFLEtBQUssQ0FBQyxDQUFBO1FBQ3BELENBQUMsQ0FBQyxDQUFBO0lBQ04sQ0FBQztJQUNNLFVBQVUsQ0FBQyxFQUFVO1FBQ3hCLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxVQUFVLENBQUMsRUFBRSxFQUFFLEdBQUcsRUFBRSxDQUNsQyxJQUFJLENBQUMsT0FBTyxDQUFDLGdCQUFnQixFQUFFLFVBQVUsRUFBRSxFQUFFLElBQUksRUFBRSxJQUFJLENBQUMsSUFBSSxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUMsQ0FBQTtJQUMzRSxDQUFDO0lBQ00sVUFBVSxDQUFDLElBQVksRUFBRSxRQUFnQjtRQUM1QyxPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsVUFBVSxDQUFDLElBQUksRUFBRSxRQUFRLEVBQUUsR0FBRyxFQUFFLENBQzlDLElBQUksQ0FBQyxPQUFPLENBQUMsWUFBWSxJQUFJLEVBQUUsRUFBRSxFQUFFLFFBQVEsRUFBRSxDQUFDLENBQUMsQ0FBQTtJQUN2RCxDQUFDO0lBQ00sT0FBTyxDQUFDLElBQVksRUFBRSxRQUFnQjtRQUN6QyxPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLFFBQVEsSUFBSSxFQUFFLEVBQUUsUUFBUSxFQUFFLEdBQUcsRUFBRSxDQUNyRCxJQUFJLENBQUMsT0FBTyxDQUFDLFlBQVksSUFBSSxPQUFPLEVBQUUsRUFBRSxRQUFRLEVBQUUsQ0FBQyxDQUFDLENBQUE7SUFDNUQsQ0FBQztJQUNNLFVBQVUsQ0FBQyxJQUFZLEVBQUUsR0FBVyxFQUFFLFFBQWdCO1FBQ3pELE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUMsV0FBVyxJQUFJLElBQUksR0FBRyxFQUFFLEVBQUUsUUFBUSxFQUFFLEdBQUcsRUFBRSxDQUMvRCxJQUFJLENBQUMsT0FBTyxDQUFDLFlBQVksSUFBSSxZQUFZLEdBQUcsRUFBRSxFQUFFLEVBQUUsUUFBUSxFQUFFLENBQUMsQ0FBQyxDQUFBO0lBQ3RFLENBQUM7SUFDTSxPQUFPLENBQUMsR0FBNkIsRUFBRSxRQUFnQixFQUFFLFVBQXFCO1FBQ2pGLE1BQU0sUUFBUSxHQUFHLFdBQVcsVUFBVSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQTtRQUM3RSxPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLFFBQVEsRUFBRSxRQUFRLEVBQUUsR0FBRyxFQUFFLENBQy9DLElBQUksQ0FBQyxRQUFRLENBQUMsWUFBWSxFQUFFLEdBQUcsRUFBRSxFQUFFLFFBQVEsRUFBRSxDQUFDLEVBQUUsVUFBVSxDQUFDLENBQUE7SUFDbkUsQ0FBQztJQUNNLGVBQWUsQ0FBQyxHQUFxQyxFQUFFLFVBQXFCO1FBQy9FLE1BQU0sUUFBUSxHQUFHLFNBQVMsVUFBVSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQTtRQUMzRSxPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLFFBQVEsRUFBRSxJQUFJLENBQUMsSUFBSSxDQUFDLEVBQUUsRUFBRSxHQUFHLEVBQUUsQ0FDbkQsSUFBSSxDQUFDLFFBQVEsQ0FBQyxZQUFZLEVBQUUsR0FBRyxDQUFDLEVBQUUsVUFBVSxDQUFDLENBQUE7SUFDckQsQ0FBQztJQUNNLGtCQUFrQixDQUFDLEdBQXdDLEVBQUUsVUFBcUI7UUFDckYsTUFBTSxRQUFRLEdBQUcsWUFBWSxVQUFVLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFBO1FBQzlFLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUMsUUFBUSxFQUFFLElBQUksQ0FBQyxJQUFJLENBQUMsRUFBRSxFQUFFLEdBQUcsRUFBRSxDQUNuRCxJQUFJLENBQUMsUUFBUSxDQUFDLGVBQWUsRUFBRSxHQUFHLENBQUMsRUFBRSxVQUFVLENBQUMsQ0FBQTtJQUN4RCxDQUFDO0lBQ00sTUFBTSxDQUNULEdBQTRCLEVBQzVCLE9BQWdDO1FBRWhDLE1BQU0sSUFBSSxLQUFLLENBQUMsd0JBQXdCLENBQUMsQ0FBQTtJQUM3QyxDQUFDO0lBQ00sUUFBUSxDQUNYLEdBQThCLEVBQzlCLE9BQWtDO1FBRWxDLE1BQU0sSUFBSSxLQUFLLENBQUMsd0JBQXdCLENBQUMsQ0FBQTtJQUM3QyxDQUFDO0lBQ0QsTUFBTTtJQUNJLFlBQVksQ0FBQyxHQUF1QixFQUFFLEdBQUcsUUFBZTtRQUM5RCxNQUFNLEdBQUcsR0FBRyxJQUFJLENBQUMsU0FBUyxDQUFDLFFBQVEsQ0FBQyxDQUFBO1FBQ3BDLE1BQU0sT0FBTyxHQUFHLElBQUksQ0FBQyxlQUFlLENBQUMsR0FBRyxDQUFDLENBQUE7UUFDekMsa0VBQWtFO1FBQ2xFLElBQUksT0FBTyxFQUFFO1lBQ1QsT0FBTyxPQUFPLENBQUE7U0FDakI7UUFDRCxPQUFPLElBQUksQ0FBQyxlQUFlLENBQUMsR0FBRyxDQUFDLEdBQUcsQ0FBQyxHQUFTLEVBQUU7WUFDM0MsSUFBSTtnQkFDQSxPQUFPLE1BQU0sR0FBRyxFQUFFLENBQUE7YUFDckI7b0JBQVM7Z0JBQ04sT0FBTyxJQUFJLENBQUMsZUFBZSxDQUFDLEdBQUcsQ0FBQyxDQUFBO2FBQ25DO1FBQ0wsQ0FBQyxDQUFBLENBQUMsRUFBRSxDQUFBO0lBQ1IsQ0FBQztJQUNTLE9BQU8sQ0FBQyxJQUFZLEVBQUUsS0FBOEI7UUFDMUQsT0FBTyxJQUFJLENBQUMsWUFBWSxDQUNwQixHQUFHLEVBQUU7WUFDRCxPQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLEtBQUssRUFBRSxJQUFJLEVBQUU7Z0JBQzlCLEtBQUs7Z0JBQ0wsc0JBQXNCLEVBQUUsSUFBSSxDQUFDLGVBQWU7YUFDL0MsQ0FBQyxDQUFBO1FBQ04sQ0FBQyxFQUNELElBQUksRUFDSixLQUFLLElBQUksRUFBRSxDQUFDLENBQUE7SUFDcEIsQ0FBQztJQUVTLFFBQVEsQ0FBQyxJQUFZLEVBQUUsSUFBUyxFQUFFLEtBQThCO1FBQ3RFLE9BQU8sSUFBSSxDQUFDLFlBQVksQ0FDcEIsR0FBRyxFQUFFO1lBQ0QsT0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBQyxNQUFNLEVBQUUsSUFBSSxFQUFFO2dCQUMvQixLQUFLO2dCQUNMLElBQUk7Z0JBQ0osc0JBQXNCLEVBQUUsSUFBSSxDQUFDLGVBQWU7YUFDL0MsQ0FBQyxDQUFBO1FBQ04sQ0FBQyxFQUNELElBQUksRUFDSixLQUFLLElBQUksRUFBRSxFQUNYLElBQUksSUFBSSxFQUFFLENBQUMsQ0FBQTtJQUNuQixDQUFDO0lBRUQsSUFBWSxlQUFlO1FBQ3ZCLE9BQU8sQ0FBQyxPQUErQixFQUFFLEVBQUU7WUFDdkMsTUFBTSxJQUFJLEdBQUcsT0FBTyxDQUFDLGNBQWMsQ0FBQyxDQUFBO1lBQ3BDLElBQUksSUFBSSxJQUFJLElBQUksS0FBSyxJQUFJLENBQUMsT0FBTyxDQUFDLEVBQUUsRUFBRTtnQkFDbEMsTUFBTSxJQUFJLEtBQUssQ0FBQyxzQ0FBc0MsQ0FBQyxDQUFBO2FBQzFEO1FBQ0wsQ0FBQyxDQUFBO0lBQ0wsQ0FBQztJQUVPLFdBQVc7UUFDZixNQUFNLFNBQVMsR0FBRyxJQUFJLENBQUMsYUFBYSxDQUFBO1FBQ3BDLElBQUksQ0FBQyxhQUFhLEdBQUcsRUFBRSxDQUFBO1FBQ3ZCLFNBQVMsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFBO0lBQy9CLENBQUM7SUFFYSxlQUFlOztZQUN6QixTQUFVO2dCQUNOLElBQUksU0FBUyxHQUFHLEtBQUssQ0FBQTtnQkFDckIsSUFBSTtvQkFDQSxNQUFNLElBQUksR0FBRyxNQUFNLElBQUksQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFvQixJQUFJLENBQUMsT0FBTyxDQUFDLGFBQWEsQ0FBQyxDQUFDLENBQUE7b0JBQ2hGLElBQUksSUFBSSxDQUFDLEVBQUUsS0FBSyxJQUFJLENBQUMsSUFBSSxDQUFDLEVBQUUsSUFBSSxJQUFJLENBQUMsTUFBTSxJQUFJLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxFQUFFO3dCQUM3RCxJQUFJLENBQUMsSUFBSSxHQUFHOzRCQUNSLEVBQUUsRUFBRSxJQUFJLENBQUMsRUFBRTs0QkFDWCxNQUFNLEVBQUUsSUFBSSxDQUFDLE1BQU07NEJBQ25CLFNBQVMsRUFBRSxJQUFJLENBQUMsU0FBUzs0QkFDekIsUUFBUSxFQUFFLElBQUksQ0FBQyxRQUFROzRCQUN2QixXQUFXLEVBQUUsSUFBSSxDQUFDLFdBQVc7NEJBQzdCLFFBQVEsRUFBRSxJQUFJLENBQUMsUUFBUTt5QkFDMUIsQ0FBQTt3QkFDRCxJQUFJLENBQUMsS0FBSyxDQUFDLGNBQWMsQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFLFNBQVMsRUFBRSxJQUFJLENBQUMsQ0FBQTt3QkFDckQsSUFBSSxDQUFDLFdBQVcsRUFBRSxDQUFBO3dCQUVsQixJQUFJLElBQUksQ0FBQyxHQUFHLEVBQUUsR0FBRyxJQUFJLENBQUMsSUFBSSxDQUFDLFNBQVMsR0FBRyxJQUFJLEdBQUcsRUFBRSxHQUFHLElBQUksRUFBRTs0QkFDckQsZ0JBQWdCOzRCQUNoQixTQUFTLEdBQUcsSUFBSSxDQUFBO3lCQUNuQjtxQkFDSjtpQkFDSjtnQkFBQyxPQUFPLEdBQUcsRUFBRTtvQkFDVixJQUFJLEdBQUcsWUFBWSxnQkFBZ0IsRUFBRTt3QkFDakMsTUFBSztxQkFDUjtpQkFDSjtnQkFFRCxJQUFJLFNBQVMsRUFBRTtvQkFDWCxJQUFJO3dCQUNBLE1BQU0sSUFBSSxDQUFDLE9BQU8sRUFBRSxDQUFBO3FCQUN2QjtvQkFBQyxPQUFPLEdBQUcsRUFBRTt3QkFDVixJQUFJLEdBQUcsWUFBWSxnQkFBZ0IsRUFBRTs0QkFDakMsTUFBSzt5QkFDUjtxQkFDSjtpQkFDSjtnQkFDRCxJQUFJO29CQUNBLE1BQU0sSUFBSSxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUMsR0FBRyxJQUFJLENBQUMsQ0FBQyxDQUFBO2lCQUN2QztnQkFBQyxXQUFNO29CQUNKLE1BQUs7aUJBQ1I7YUFDSjtRQUNMLENBQUM7S0FBQTtJQUVhLE9BQU87O1lBQ2pCLE1BQU0sTUFBTSxHQUNSLDJCQUEyQixJQUFJLENBQUMsSUFBSSxDQUFDLFFBQVEsRUFBRSxDQUFBO1lBRW5ELE1BQU0sR0FBRyxHQUFHLElBQUksQ0FBQyxHQUFHLENBQUMsbUJBQW1CLENBQUMsTUFBTSxDQUFDLENBQUE7WUFFaEQsSUFBSTtnQkFDQSxTQUFVO29CQUNOLE1BQU0sSUFBSSxHQUFHLE1BQU0sSUFBSSxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLElBQUksRUFBRSxDQUFDLENBQUE7b0JBQzVDLE1BQU0sSUFBSSxHQUFVLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLENBQUE7b0JBQ3BDLElBQUksQ0FBQyxJQUFJLENBQUMsUUFBUSxJQUFJLElBQUksQ0FBQyxFQUFFLEtBQUssSUFBSSxDQUFDLElBQUksQ0FBQyxFQUFFLElBQUksSUFBSSxDQUFDLE1BQU0sSUFBSSxJQUFJLENBQUMsSUFBSSxDQUFDLE1BQU0sRUFBRTt3QkFDL0UsSUFBSSxDQUFDLElBQUksR0FBRzs0QkFDUixFQUFFLEVBQUUsSUFBSSxDQUFDLEVBQUU7NEJBQ1gsTUFBTSxFQUFFLElBQUksQ0FBQyxNQUFNOzRCQUNuQixTQUFTLEVBQUUsSUFBSSxDQUFDLFNBQVM7NEJBQ3pCLFFBQVEsRUFBRSxJQUFJLENBQUMsUUFBUTs0QkFDdkIsV0FBVyxFQUFFLElBQUksQ0FBQyxXQUFXOzRCQUM3QixRQUFRLEVBQUUsSUFBSSxDQUFDLFFBQVE7eUJBQzFCLENBQUE7d0JBQ0QsSUFBSSxDQUFDLEtBQUssQ0FBQyxjQUFjLENBQUMsSUFBSSxDQUFDLElBQUksRUFBRSxFQUFFLENBQUMsRUFBRSxJQUFJLENBQUMsQ0FBQyxFQUFFLElBQUksRUFBRSxJQUFJLENBQUMsS0FBSyxFQUFFLENBQUMsQ0FBQTt3QkFDckUsSUFBSSxDQUFDLFdBQVcsRUFBRSxDQUFBO3FCQUNyQjtpQkFDSjthQUNKO29CQUFTO2dCQUNOLEdBQUcsQ0FBQyxLQUFLLEVBQUUsQ0FBQTthQUNkO1FBQ0wsQ0FBQztLQUFBO0NBQ0oifQ==
                // EXTERNAL MODULE: ../driver/node_modules/axios/index.js
                var axios = __webpack_require__(8416);
                var axios_default = /*#__PURE__*/ __webpack_require__.n(axios);
                // EXTERNAL MODULE: ../driver/node_modules/isomorphic-ws/browser.js
                var browser = __webpack_require__(9347);
                // CONCATENATED MODULE: ../driver/esm/simple-websocket-reader.js
                class SimpleWebSocketReader {
                    constructor(url, timeout = 30000){
                        this.timeout = timeout;
                        this.callbacks = [];
                        this.ws = new browser(url);
                        this.ws.onmessage = (ev)=>{
                            try {
                                const cbs = this.callbacks;
                                this.callbacks = [];
                                cbs.forEach((cb)=>cb(ev.data));
                            } catch (err) {
                                this.setError(err);
                                this.ws.close();
                            }
                        };
                        this.ws.onerror = (ev)=>{
                            this.setError(ev.error);
                            this.ws.close();
                        };
                        this.ws.onclose = ()=>{
                            this.setError(new Error("closed"));
                        };
                    }
                    read() {
                        return new Promise((resolve, reject)=>{
                            if (this.error) return reject(this.error);
                            const timer = setTimeout(()=>{
                                reject(new Error("ws read timeout"));
                            }, this.timeout);
                            this.callbacks.push((data, err)=>{
                                clearTimeout(timer);
                                if (err) return reject(err);
                                resolve(data);
                            });
                        });
                    }
                    close() {
                        this.ws.close();
                    }
                    setError(err) {
                        if (!this.error) {
                            this.error = err;
                            const cbs = this.callbacks;
                            this.callbacks = [];
                            cbs.forEach((cb)=>cb(null, err));
                        }
                    }
                }
                //# sourceMappingURL=data:application/json;base64,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
                // EXTERNAL MODULE: ./node_modules/url/url.js
                var url_url = __webpack_require__(8575);
                // CONCATENATED MODULE: ./dummy-http-agent.js
                class Agent {
                    constructor(){
                        return undefined;
                    }
                }
                // CONCATENATED MODULE: ../driver/esm/simple-net.js
                var simple_net_awaiter = function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /** class simply implements Net interface */ class SimpleNet {
                    constructor(baseURL, timeout = 30000, wsTimeout = 30000){
                        this.baseURL = baseURL;
                        this.wsTimeout = wsTimeout;
                        this.axios = axios_default().create({
                            httpAgent: new Agent({
                                keepAlive: true
                            }),
                            httpsAgent: new Agent({
                                keepAlive: true
                            }),
                            baseURL: baseURL,
                            timeout: timeout
                        });
                    }
                    http(method, path, params) {
                        return simple_net_awaiter(this, void 0, void 0, function*() {
                            params = params || {};
                            try {
                                const resp = yield this.axios.request({
                                    method: method,
                                    url: path,
                                    data: params.body,
                                    headers: params.headers,
                                    params: params.query
                                });
                                if (params.validateResponseHeader) params.validateResponseHeader(resp.headers);
                                return resp.data;
                            } catch (err) {
                                if (err.isAxiosError) throw convertError(err);
                                throw new Error(`${method} ${(0, url_url /* resolve */ .DB)(this.baseURL, path)}: ${err.message}`);
                            }
                        });
                    }
                    openWebSocketReader(path) {
                        const url = (0, url_url /* resolve */ .DB)(this.baseURL, path).replace(/^http:/i, "ws:").replace(/^https:/i, "wss:");
                        return new SimpleWebSocketReader(url, this.wsTimeout);
                    }
                }
                function convertError(err) {
                    if (err.response) {
                        const resp = err.response;
                        if (typeof resp.data === "string") {
                            let text = resp.data.trim();
                            if (text.length > 50) text = text.slice(0, 50) + "...";
                            return new Error(`${resp.status} ${err.config.method} ${err.config.url}: ${text}`);
                        } else return new Error(`${resp.status} ${err.config.method} ${err.config.url}`);
                    } else return new Error(`${err.config.method} ${err.config.url}: ${err.message}`);
                }
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ./node_modules/thor-devkit/esm/blake2b.js
                /* provided dependency */ var esm_blake2b_Buffer = __webpack_require__(8764)["Buffer"];
                const blake2b_blake = __webpack_require__(1191);
                /**
 * computes blake2b 256bit hash of given data
 * @param data one or more Buffer | string
 */ function blake2b_blake2b256(...data) {
                    const ctx = blake2b_blake.blake2bInit(32, null);
                    data.forEach((d)=>{
                        if (esm_blake2b_Buffer.isBuffer(d)) blake2b_blake.blake2bUpdate(ctx, d);
                        else blake2b_blake.blake2bUpdate(ctx, esm_blake2b_Buffer.from(d, "utf8"));
                    });
                    return esm_blake2b_Buffer.from(blake2b_blake.blake2bFinal(ctx));
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmxha2UyYi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9ibGFrZTJiLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sS0FBSyxHQUFHLE9BQU8sQ0FBQyxTQUFTLENBQUMsQ0FBQTtBQUVoQzs7O0dBR0c7QUFDSCxNQUFNLFVBQVUsVUFBVSxDQUFDLEdBQUcsSUFBNEI7SUFDdEQsTUFBTSxHQUFHLEdBQUcsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLEVBQUUsSUFBSSxDQUFDLENBQUE7SUFDdkMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsRUFBRTtRQUNiLElBQUksTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsRUFBRTtZQUNwQixLQUFLLENBQUMsYUFBYSxDQUFDLEdBQUcsRUFBRSxDQUFDLENBQUMsQ0FBQTtTQUM5QjthQUFNO1lBQ0gsS0FBSyxDQUFDLGFBQWEsQ0FBQyxHQUFHLEVBQUUsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUUsTUFBTSxDQUFDLENBQUMsQ0FBQTtTQUNuRDtJQUNMLENBQUMsQ0FBQyxDQUFBO0lBQ0YsT0FBTyxNQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxZQUFZLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQTtBQUMvQyxDQUFDIn0=
                // CONCATENATED MODULE: ./esm/driver.js
                var driver_awaiter = function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /* eslint-disable @typescript-eslint/no-unused-vars */ /** the LazyDriver implements vendor methods at construction but allows attaching NoVendorDriver later to be a full one*/ class LazyDriver {
                    constructor(signer){
                        this.signer = signer;
                        this._driver = null;
                    }
                    get noVendor() {
                        if (!this._driver) throw new Error("thor driver is not ready");
                        return this._driver;
                    }
                    setNoVendor(driver) {
                        this._driver = driver;
                    }
                    get genesis() {
                        return this.noVendor.genesis;
                    }
                    get head() {
                        return this.noVendor.head;
                    }
                    pollHead() {
                        return this.noVendor.pollHead();
                    }
                    getBlock(revision) {
                        return this.noVendor.getBlock(revision);
                    }
                    getTransaction(id, allowPending) {
                        return this.noVendor.getTransaction(id, allowPending);
                    }
                    getReceipt(id) {
                        return this.noVendor.getReceipt(id);
                    }
                    getAccount(addr, revision) {
                        return this.noVendor.getAccount(addr, revision);
                    }
                    getCode(addr, revision) {
                        return this.noVendor.getCode(addr, revision);
                    }
                    getStorage(addr, key, revision) {
                        return this.noVendor.getStorage(addr, key, revision);
                    }
                    explain(arg, revision, cacheHints) {
                        return this.noVendor.explain(arg, revision, cacheHints);
                    }
                    filterEventLogs(arg) {
                        return this.noVendor.filterEventLogs(arg);
                    }
                    filterTransferLogs(arg) {
                        return this.noVendor.filterTransferLogs(arg);
                    }
                    signTx(msg, options) {
                        return driver_awaiter(this, void 0, void 0, function*() {
                            return this.signer.then((b)=>b.signTx(msg, options));
                        });
                    }
                    signCert(msg, options) {
                        return driver_awaiter(this, void 0, void 0, function*() {
                            return this.signer.then((b)=>b.signCert(msg, options));
                        });
                    }
                }
                const cache = {};
                /**
 * create a no vendor driver
 * @param node the url of thor node
 * @param genesis the enforced genesis block
 */ function createNoVendor(node, genesis) {
                    const key = blake2b_blake2b256(JSON.stringify({
                        node: node,
                        genesis: genesis
                    })).toString("hex");
                    let driver = cache[key];
                    if (!driver) cache[key] = driver = new DriverNoVendor(new SimpleNet(node), genesis);
                    return driver;
                }
                /**
 * create a full driver
 * @param node the url of thor node
 * @param genesis the enforced genesis block
 * @param newSigner a function to create signer
 */ function createFull(node, genesis, newSigner) {
                    const driver = new LazyDriver(newSigner(genesis.id));
                    driver.setNoVendor(createNoVendor(node, genesis));
                    return driver;
                }
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ./esm/script-loader.js
                // maps src to library promise
                const script_loader_cache = {};
                function loadLibrary(src, libName) {
                    let lib = script_loader_cache[src];
                    if (!lib) {
                        const script = document.createElement("script");
                        script_loader_cache[src] = lib = new Promise((resolve, reject)=>{
                            script.onload = ()=>resolve(window[libName]);
                            script.onerror = (err)=>reject(new Error(err.toString()));
                        });
                        script.src = src;
                        document.body.appendChild(script);
                    }
                    return lib;
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2NyaXB0LWxvYWRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9zY3JpcHQtbG9hZGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLDhCQUE4QjtBQUM5QixNQUFNLEtBQUssR0FBcUMsRUFBRSxDQUFBO0FBRWxELE1BQU0sVUFBVSxXQUFXLENBQUksR0FBVyxFQUFFLE9BQWU7SUFDdkQsSUFBSSxHQUFHLEdBQUcsS0FBSyxDQUFDLEdBQUcsQ0FBMkIsQ0FBQTtJQUM5QyxJQUFJLENBQUMsR0FBRyxFQUFFO1FBQ04sTUFBTSxNQUFNLEdBQUcsUUFBUSxDQUFDLGFBQWEsQ0FBQyxRQUFRLENBQUMsQ0FBQTtRQUMvQyxLQUFLLENBQUMsR0FBRyxDQUFDLEdBQUcsR0FBRyxHQUFHLElBQUksT0FBTyxDQUFDLENBQUMsT0FBTyxFQUFFLE1BQU0sRUFBRSxFQUFFO1lBQy9DLE1BQU0sQ0FBQyxNQUFNLEdBQUcsR0FBRyxFQUFFLENBQUMsT0FBTyxDQUFFLE1BQWdCLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQTtZQUN6RCxNQUFNLENBQUMsT0FBTyxHQUFHLEdBQUcsQ0FBQyxFQUFFLENBQUMsTUFBTSxDQUFDLElBQUksS0FBSyxDQUFDLEdBQUcsQ0FBQyxRQUFRLEVBQUUsQ0FBQyxDQUFDLENBQUE7UUFDN0QsQ0FBQyxDQUFDLENBQUE7UUFDRixNQUFNLENBQUMsR0FBRyxHQUFHLEdBQUcsQ0FBQTtRQUNoQixRQUFRLENBQUMsSUFBSSxDQUFDLFdBQVcsQ0FBQyxNQUFNLENBQUMsQ0FBQTtLQUNwQztJQUNELE9BQU8sR0FBRyxDQUFBO0FBQ2QsQ0FBQyJ9
                // EXTERNAL MODULE: ./node_modules/randombytes/browser.js
                var randombytes_browser = __webpack_require__(1798);
                var randombytes_browser_default = /*#__PURE__*/ __webpack_require__.n(randombytes_browser);
                // CONCATENATED MODULE: ./esm/signer.js
                var signer_awaiter = function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                const BUDDY_SRC = "https://unpkg.com/@vechain/connex-wallet-buddy@0.1";
                const BUDDY_LIB_NAME = "ConnexWalletBuddy";
                const createSync2 = (genesisId)=>signer_awaiter(void 0, void 0, void 0, function*() {
                        return loadLibrary(BUDDY_SRC, BUDDY_LIB_NAME).then((lib)=>lib.create(genesisId, ()=>randombytes_browser_default()(16).toString("hex"), (val)=>blake2b_blake2b256(val).toString("hex")));
                    });
                const createSync = (genesisId)=>signer_awaiter(void 0, void 0, void 0, function*() {
                        const v1 = window.connex.vendor;
                        return Promise.resolve({
                            signTx: (msg, options)=>{
                                const s1 = v1.sign("tx");
                                options.signer && s1.signer(options.signer);
                                options.gas && s1.gas(options.gas);
                                options.dependsOn && s1.dependsOn(options.dependsOn);
                                options.link && s1.link(options.link);
                                options.comment && s1.link(options.comment);
                                if (options.delegator) {
                                    const url = options.delegator.url;
                                    s1.delegate((unsignedTx)=>signer_awaiter(void 0, void 0, void 0, function*() {
                                            const res = yield fetch(url, {
                                                method: "POST",
                                                body: JSON.stringify(unsignedTx),
                                                headers: {
                                                    "Content-Type": "application/json"
                                                }
                                            });
                                            return res.json();
                                        }));
                                }
                                options.onAccepted && options.onAccepted();
                                return s1.request(msg);
                            },
                            signCert: (msg, options)=>{
                                const s1 = v1.sign("cert");
                                options.signer && s1.signer(options.signer);
                                options.link && s1.link(options.link);
                                options.onAccepted && options.onAccepted();
                                return s1.request(msg);
                            }
                        });
                    });
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ./esm/index.js
                /** convert options.network to Connex.Thor.Block */ function normalizeNetwork(n) {
                    n = n || "main";
                    if (typeof n === "string") {
                        const gb = genesisBlocks[n];
                        if (!gb) throw new Error("invalid network");
                        return gb;
                    } else return n;
                }
                /** convert network name to genesis id */ function normalizeGenesisId(id) {
                    id = id || "main";
                    if (/^0x[0-9a-f]{64}$/.test(id)) return id;
                    const gb = genesisBlocks[id];
                    if (gb) return gb.id;
                    throw new Error("invalid genesis id");
                }
                /** convert options.signer to a signer creation function */ function normalizeSigner(genesisId, signer) {
                    switch(signer.toLocaleLowerCase()){
                        case "sync":
                            if (!window.connex) throw new Error("Sync not found");
                            if (window.connex.thor.genesis.id !== genesisId) throw new Error("Network mismatch");
                            return createSync;
                        case "sync2":
                            return createSync2;
                        default:
                            throw new Error("unsupported signer");
                    }
                }
                /** Thor class which can work stand alone to provide reading-services only */ class ThorClass {
                    constructor(opts){
                        const genesis = normalizeNetwork(opts.network);
                        const driver = createNoVendor(opts.node, genesis);
                        const framework = new Framework(driver);
                        return {
                            get genesis () {
                                return framework.thor.genesis;
                            },
                            get status () {
                                return framework.thor.status;
                            },
                            get ticker () {
                                return framework.thor.ticker.bind(framework.thor);
                            },
                            get account () {
                                return framework.thor.account.bind(framework.thor);
                            },
                            get block () {
                                return framework.thor.block.bind(framework.thor);
                            },
                            get transaction () {
                                return framework.thor.transaction.bind(framework.thor);
                            },
                            get filter () {
                                return framework.thor.filter.bind(framework.thor);
                            },
                            get explain () {
                                return framework.thor.explain.bind(framework.thor);
                            }
                        };
                    }
                }
                /** Vendor class which can work standalone to provides signing-services only */ class VendorClass {
                    constructor(genesisId, signer = "sync2"){
                        genesisId = normalizeGenesisId(genesisId);
                        const newSigner = normalizeSigner(genesisId, signer);
                        const driver = new LazyDriver(newSigner(genesisId));
                        const vendor = newVendor(driver);
                        return {
                            get sign () {
                                return vendor.sign.bind(vendor);
                            }
                        };
                    }
                }
                /** Connex class */ class ConnexClass {
                    constructor(opts){
                        var _a;
                        const genesis = normalizeNetwork(opts.network);
                        const newSigner = normalizeSigner(genesis.id, (_a = opts.signer) !== null && _a !== void 0 ? _a : "sync2");
                        const driver = createFull(opts.node, genesis, newSigner);
                        const framework = new Framework(driver);
                        return {
                            get thor () {
                                return framework.thor;
                            },
                            get vendor () {
                                return framework.vendor;
                            }
                        };
                    }
                }
                ConnexClass.Thor = ThorClass;
                ConnexClass.Vendor = VendorClass;
                /* harmony default export */ const esm = ConnexClass;
            //# sourceMappingURL=data:application/json;base64,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
            /***/ },
            /***/ 9742: /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                exports.byteLength = byteLength;
                exports.toByteArray = toByteArray;
                exports.fromByteArray = fromByteArray;
                var lookup = [];
                var revLookup = [];
                var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
                var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
                for(var i = 0, len = code.length; i < len; ++i){
                    lookup[i] = code[i];
                    revLookup[code.charCodeAt(i)] = i;
                }
                // Support decoding URL-safe base64 strings, as Node.js does.
                // See: https://en.wikipedia.org/wiki/Base64#URL_applications
                revLookup["-".charCodeAt(0)] = 62;
                revLookup["_".charCodeAt(0)] = 63;
                function getLens(b64) {
                    var len = b64.length;
                    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                    // Trim off extra bytes after placeholder bytes are found
                    // See: https://github.com/beatgammit/base64-js/issues/42
                    var validLen = b64.indexOf("=");
                    if (validLen === -1) validLen = len;
                    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
                    return [
                        validLen,
                        placeHoldersLen
                    ];
                }
                // base64 is 4/3 + up to two characters of the original data
                function byteLength(b64) {
                    var lens = getLens(b64);
                    var validLen = lens[0];
                    var placeHoldersLen = lens[1];
                    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
                }
                function _byteLength(b64, validLen, placeHoldersLen) {
                    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
                }
                function toByteArray(b64) {
                    var tmp;
                    var lens = getLens(b64);
                    var validLen = lens[0];
                    var placeHoldersLen = lens[1];
                    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
                    var curByte = 0;
                    // if there are placeholders, only get up to the last complete 4 chars
                    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
                    var i;
                    for(i = 0; i < len; i += 4){
                        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
                        arr[curByte++] = tmp >> 16 & 0xFF;
                        arr[curByte++] = tmp >> 8 & 0xFF;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    if (placeHoldersLen === 2) {
                        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    if (placeHoldersLen === 1) {
                        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
                        arr[curByte++] = tmp >> 8 & 0xFF;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    return arr;
                }
                function tripletToBase64(num) {
                    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
                }
                function encodeChunk(uint8, start, end) {
                    var tmp;
                    var output = [];
                    for(var i = start; i < end; i += 3){
                        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
                        output.push(tripletToBase64(tmp));
                    }
                    return output.join("");
                }
                function fromByteArray(uint8) {
                    var tmp;
                    var len = uint8.length;
                    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
                    ;
                    var parts = [];
                    var maxChunkLength = 16383 // must be multiple of 3
                    ;
                    // go through the array every three bytes, we'll deal with trailing stuff later
                    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
                    // pad the end with zeros, but make sure to not forget the extra bytes
                    if (extraBytes === 1) {
                        tmp = uint8[len - 1];
                        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
                    } else if (extraBytes === 2) {
                        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
                        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
                    }
                    return parts.join("");
                }
            /***/ },
            /***/ 8442: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                // Blake2B in pure Javascript
                // Adapted from the reference implementation in RFC7693
                // Ported to Javascript by DC - https://github.com/dcposch
                const util = __webpack_require__(9488);
                // 64-bit unsigned addition
                // Sets v[a,a+1] += v[b,b+1]
                // v should be a Uint32Array
                function ADD64AA(v, a, b) {
                    const o0 = v[a] + v[b];
                    let o1 = v[a + 1] + v[b + 1];
                    if (o0 >= 0x100000000) o1++;
                    v[a] = o0;
                    v[a + 1] = o1;
                }
                // 64-bit unsigned addition
                // Sets v[a,a+1] += b
                // b0 is the low 32 bits of b, b1 represents the high 32 bits
                function ADD64AC(v, a, b0, b1) {
                    let o0 = v[a] + b0;
                    if (b0 < 0) o0 += 0x100000000;
                    let o1 = v[a + 1] + b1;
                    if (o0 >= 0x100000000) o1++;
                    v[a] = o0;
                    v[a + 1] = o1;
                }
                // Little-endian byte access
                function B2B_GET32(arr, i) {
                    return arr[i] ^ arr[i + 1] << 8 ^ arr[i + 2] << 16 ^ arr[i + 3] << 24;
                }
                // G Mixing function
                // The ROTRs are inlined for speed
                function B2B_G(a, b, c, d, ix, iy) {
                    const x0 = m[ix];
                    const x1 = m[ix + 1];
                    const y0 = m[iy];
                    const y1 = m[iy + 1];
                    ADD64AA(v, a, b) // v[a,a+1] += v[b,b+1] ... in JS we must store a uint64 as two uint32s
                    ;
                    ADD64AC(v, a, x0, x1) // v[a, a+1] += x ... x0 is the low 32 bits of x, x1 is the high 32 bits
                    ;
                    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated to the right by 32 bits
                    let xor0 = v[d] ^ v[a];
                    let xor1 = v[d + 1] ^ v[a + 1];
                    v[d] = xor1;
                    v[d + 1] = xor0;
                    ADD64AA(v, c, d);
                    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 24 bits
                    xor0 = v[b] ^ v[c];
                    xor1 = v[b + 1] ^ v[c + 1];
                    v[b] = xor0 >>> 24 ^ xor1 << 8;
                    v[b + 1] = xor1 >>> 24 ^ xor0 << 8;
                    ADD64AA(v, a, b);
                    ADD64AC(v, a, y0, y1);
                    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated right by 16 bits
                    xor0 = v[d] ^ v[a];
                    xor1 = v[d + 1] ^ v[a + 1];
                    v[d] = xor0 >>> 16 ^ xor1 << 16;
                    v[d + 1] = xor1 >>> 16 ^ xor0 << 16;
                    ADD64AA(v, c, d);
                    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 63 bits
                    xor0 = v[b] ^ v[c];
                    xor1 = v[b + 1] ^ v[c + 1];
                    v[b] = xor1 >>> 31 ^ xor0 << 1;
                    v[b + 1] = xor0 >>> 31 ^ xor1 << 1;
                }
                // Initialization Vector
                const BLAKE2B_IV32 = new Uint32Array([
                    0xf3bcc908,
                    0x6a09e667,
                    0x84caa73b,
                    0xbb67ae85,
                    0xfe94f82b,
                    0x3c6ef372,
                    0x5f1d36f1,
                    0xa54ff53a,
                    0xade682d1,
                    0x510e527f,
                    0x2b3e6c1f,
                    0x9b05688c,
                    0xfb41bd6b,
                    0x1f83d9ab,
                    0x137e2179,
                    0x5be0cd19
                ]);
                const SIGMA8 = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    14,
                    10,
                    4,
                    8,
                    9,
                    15,
                    13,
                    6,
                    1,
                    12,
                    0,
                    2,
                    11,
                    7,
                    5,
                    3,
                    11,
                    8,
                    12,
                    0,
                    5,
                    2,
                    15,
                    13,
                    10,
                    14,
                    3,
                    6,
                    7,
                    1,
                    9,
                    4,
                    7,
                    9,
                    3,
                    1,
                    13,
                    12,
                    11,
                    14,
                    2,
                    6,
                    5,
                    10,
                    4,
                    0,
                    15,
                    8,
                    9,
                    0,
                    5,
                    7,
                    2,
                    4,
                    10,
                    15,
                    14,
                    1,
                    11,
                    12,
                    6,
                    8,
                    3,
                    13,
                    2,
                    12,
                    6,
                    10,
                    0,
                    11,
                    8,
                    3,
                    4,
                    13,
                    7,
                    5,
                    15,
                    14,
                    1,
                    9,
                    12,
                    5,
                    1,
                    15,
                    14,
                    13,
                    4,
                    10,
                    0,
                    7,
                    6,
                    3,
                    9,
                    2,
                    8,
                    11,
                    13,
                    11,
                    7,
                    14,
                    12,
                    1,
                    3,
                    9,
                    5,
                    0,
                    15,
                    4,
                    8,
                    6,
                    2,
                    10,
                    6,
                    15,
                    14,
                    9,
                    11,
                    3,
                    0,
                    8,
                    12,
                    2,
                    13,
                    7,
                    1,
                    4,
                    10,
                    5,
                    10,
                    2,
                    8,
                    4,
                    7,
                    6,
                    1,
                    5,
                    15,
                    11,
                    9,
                    14,
                    3,
                    12,
                    13,
                    0,
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    14,
                    10,
                    4,
                    8,
                    9,
                    15,
                    13,
                    6,
                    1,
                    12,
                    0,
                    2,
                    11,
                    7,
                    5,
                    3
                ];
                // These are offsets into a uint64 buffer.
                // Multiply them all by 2 to make them offsets into a uint32 buffer,
                // because this is Javascript and we don't have uint64s
                const SIGMA82 = new Uint8Array(SIGMA8.map(function(x) {
                    return x * 2;
                }));
                // Compression function. 'last' flag indicates last block.
                // Note we're representing 16 uint64s as 32 uint32s
                const v = new Uint32Array(32);
                const m = new Uint32Array(32);
                function blake2bCompress(ctx, last) {
                    let i = 0;
                    // init work variables
                    for(i = 0; i < 16; i++){
                        v[i] = ctx.h[i];
                        v[i + 16] = BLAKE2B_IV32[i];
                    }
                    // low 64 bits of offset
                    v[24] = v[24] ^ ctx.t;
                    v[25] = v[25] ^ ctx.t / 0x100000000;
                    // high 64 bits not supported, offset may not be higher than 2**53-1
                    // last block flag set ?
                    if (last) {
                        v[28] = ~v[28];
                        v[29] = ~v[29];
                    }
                    // get little-endian words
                    for(i = 0; i < 32; i++)m[i] = B2B_GET32(ctx.b, 4 * i);
                    // twelve rounds of mixing
                    // uncomment the DebugPrint calls to log the computation
                    // and match the RFC sample documentation
                    // util.debugPrint('          m[16]', m, 64)
                    for(i = 0; i < 12; i++){
                        // util.debugPrint('   (i=' + (i < 10 ? ' ' : '') + i + ') v[16]', v, 64)
                        B2B_G(0, 8, 16, 24, SIGMA82[i * 16 + 0], SIGMA82[i * 16 + 1]);
                        B2B_G(2, 10, 18, 26, SIGMA82[i * 16 + 2], SIGMA82[i * 16 + 3]);
                        B2B_G(4, 12, 20, 28, SIGMA82[i * 16 + 4], SIGMA82[i * 16 + 5]);
                        B2B_G(6, 14, 22, 30, SIGMA82[i * 16 + 6], SIGMA82[i * 16 + 7]);
                        B2B_G(0, 10, 20, 30, SIGMA82[i * 16 + 8], SIGMA82[i * 16 + 9]);
                        B2B_G(2, 12, 22, 24, SIGMA82[i * 16 + 10], SIGMA82[i * 16 + 11]);
                        B2B_G(4, 14, 16, 26, SIGMA82[i * 16 + 12], SIGMA82[i * 16 + 13]);
                        B2B_G(6, 8, 18, 28, SIGMA82[i * 16 + 14], SIGMA82[i * 16 + 15]);
                    }
                    // util.debugPrint('   (i=12) v[16]', v, 64)
                    for(i = 0; i < 16; i++)ctx.h[i] = ctx.h[i] ^ v[i] ^ v[i + 16];
                // util.debugPrint('h[8]', ctx.h, 64)
                }
                // Creates a BLAKE2b hashing context
                // Requires an output length between 1 and 64 bytes
                // Takes an optional Uint8Array key
                function blake2bInit(outlen, key) {
                    if (outlen === 0 || outlen > 64) throw new Error("Illegal output length, expected 0 < length <= 64");
                    if (key && key.length > 64) throw new Error("Illegal key, expected Uint8Array with 0 < length <= 64");
                    // state, 'param block'
                    const ctx = {
                        b: new Uint8Array(128),
                        h: new Uint32Array(16),
                        t: 0,
                        c: 0,
                        outlen: outlen // output length in bytes
                    };
                    // initialize hash state
                    for(let i = 0; i < 16; i++)ctx.h[i] = BLAKE2B_IV32[i];
                    const keylen = key ? key.length : 0;
                    ctx.h[0] ^= 0x01010000 ^ keylen << 8 ^ outlen;
                    // key the hash, if applicable
                    if (key) {
                        blake2bUpdate(ctx, key);
                        // at the end
                        ctx.c = 128;
                    }
                    return ctx;
                }
                // Updates a BLAKE2b streaming hash
                // Requires hash context and Uint8Array (byte array)
                function blake2bUpdate(ctx, input) {
                    for(let i = 0; i < input.length; i++){
                        if (ctx.c === 128) {
                            // buffer full ?
                            ctx.t += ctx.c // add counters
                            ;
                            blake2bCompress(ctx, false) // compress (not last)
                            ;
                            ctx.c = 0 // counter to zero
                            ;
                        }
                        ctx.b[ctx.c++] = input[i];
                    }
                }
                // Completes a BLAKE2b streaming hash
                // Returns a Uint8Array containing the message digest
                function blake2bFinal(ctx) {
                    ctx.t += ctx.c // mark last block offset
                    ;
                    while(ctx.c < 128)// fill up with zeros
                    ctx.b[ctx.c++] = 0;
                    blake2bCompress(ctx, true) // final block flag = 1
                    ;
                    // little endian convert and store
                    const out = new Uint8Array(ctx.outlen);
                    for(let i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3);
                    return out;
                }
                // Computes the BLAKE2B hash of a string or byte array, and returns a Uint8Array
                //
                // Returns a n-byte Uint8Array
                //
                // Parameters:
                // - input - the input bytes, as a string, Buffer or Uint8Array
                // - key - optional key Uint8Array, up to 64 bytes
                // - outlen - optional output length in bytes, default 64
                function blake2b(input, key, outlen) {
                    // preprocess inputs
                    outlen = outlen || 64;
                    input = util.normalizeInput(input);
                    // do the math
                    const ctx = blake2bInit(outlen, key);
                    blake2bUpdate(ctx, input);
                    return blake2bFinal(ctx);
                }
                // Computes the BLAKE2B hash of a string or byte array
                //
                // Returns an n-byte hash in hex, all lowercase
                //
                // Parameters:
                // - input - the input bytes, as a string, Buffer, or Uint8Array
                // - key - optional key Uint8Array, up to 64 bytes
                // - outlen - optional output length in bytes, default 64
                function blake2bHex(input, key, outlen) {
                    const output = blake2b(input, key, outlen);
                    return util.toHex(output);
                }
                module1.exports = {
                    blake2b: blake2b,
                    blake2bHex: blake2bHex,
                    blake2bInit: blake2bInit,
                    blake2bUpdate: blake2bUpdate,
                    blake2bFinal: blake2bFinal
                };
            /***/ },
            /***/ 5297: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                // BLAKE2s hash function in pure Javascript
                // Adapted from the reference implementation in RFC7693
                // Ported to Javascript by DC - https://github.com/dcposch
                const util = __webpack_require__(9488);
                // Little-endian byte access.
                // Expects a Uint8Array and an index
                // Returns the little-endian uint32 at v[i..i+3]
                function B2S_GET32(v, i) {
                    return v[i] ^ v[i + 1] << 8 ^ v[i + 2] << 16 ^ v[i + 3] << 24;
                }
                // Mixing function G.
                function B2S_G(a, b, c, d, x, y) {
                    v[a] = v[a] + v[b] + x;
                    v[d] = ROTR32(v[d] ^ v[a], 16);
                    v[c] = v[c] + v[d];
                    v[b] = ROTR32(v[b] ^ v[c], 12);
                    v[a] = v[a] + v[b] + y;
                    v[d] = ROTR32(v[d] ^ v[a], 8);
                    v[c] = v[c] + v[d];
                    v[b] = ROTR32(v[b] ^ v[c], 7);
                }
                // 32-bit right rotation
                // x should be a uint32
                // y must be between 1 and 31, inclusive
                function ROTR32(x, y) {
                    return x >>> y ^ x << 32 - y;
                }
                // Initialization Vector.
                const BLAKE2S_IV = new Uint32Array([
                    0x6a09e667,
                    0xbb67ae85,
                    0x3c6ef372,
                    0xa54ff53a,
                    0x510e527f,
                    0x9b05688c,
                    0x1f83d9ab,
                    0x5be0cd19
                ]);
                const SIGMA = new Uint8Array([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    14,
                    10,
                    4,
                    8,
                    9,
                    15,
                    13,
                    6,
                    1,
                    12,
                    0,
                    2,
                    11,
                    7,
                    5,
                    3,
                    11,
                    8,
                    12,
                    0,
                    5,
                    2,
                    15,
                    13,
                    10,
                    14,
                    3,
                    6,
                    7,
                    1,
                    9,
                    4,
                    7,
                    9,
                    3,
                    1,
                    13,
                    12,
                    11,
                    14,
                    2,
                    6,
                    5,
                    10,
                    4,
                    0,
                    15,
                    8,
                    9,
                    0,
                    5,
                    7,
                    2,
                    4,
                    10,
                    15,
                    14,
                    1,
                    11,
                    12,
                    6,
                    8,
                    3,
                    13,
                    2,
                    12,
                    6,
                    10,
                    0,
                    11,
                    8,
                    3,
                    4,
                    13,
                    7,
                    5,
                    15,
                    14,
                    1,
                    9,
                    12,
                    5,
                    1,
                    15,
                    14,
                    13,
                    4,
                    10,
                    0,
                    7,
                    6,
                    3,
                    9,
                    2,
                    8,
                    11,
                    13,
                    11,
                    7,
                    14,
                    12,
                    1,
                    3,
                    9,
                    5,
                    0,
                    15,
                    4,
                    8,
                    6,
                    2,
                    10,
                    6,
                    15,
                    14,
                    9,
                    11,
                    3,
                    0,
                    8,
                    12,
                    2,
                    13,
                    7,
                    1,
                    4,
                    10,
                    5,
                    10,
                    2,
                    8,
                    4,
                    7,
                    6,
                    1,
                    5,
                    15,
                    11,
                    9,
                    14,
                    3,
                    12,
                    13,
                    0
                ]);
                // Compression function. "last" flag indicates last block
                const v = new Uint32Array(16);
                const m = new Uint32Array(16);
                function blake2sCompress(ctx, last) {
                    let i = 0;
                    for(i = 0; i < 8; i++){
                        // init work variables
                        v[i] = ctx.h[i];
                        v[i + 8] = BLAKE2S_IV[i];
                    }
                    v[12] ^= ctx.t // low 32 bits of offset
                    ;
                    v[13] ^= ctx.t / 0x100000000 // high 32 bits
                    ;
                    if (last) // last block flag set ?
                    v[14] = ~v[14];
                    for(i = 0; i < 16; i++)// get little-endian words
                    m[i] = B2S_GET32(ctx.b, 4 * i);
                    // ten rounds of mixing
                    // uncomment the DebugPrint calls to log the computation
                    // and match the RFC sample documentation
                    // util.debugPrint('          m[16]', m, 32)
                    for(i = 0; i < 10; i++){
                        // util.debugPrint('   (i=' + i + ')  v[16]', v, 32)
                        B2S_G(0, 4, 8, 12, m[SIGMA[i * 16 + 0]], m[SIGMA[i * 16 + 1]]);
                        B2S_G(1, 5, 9, 13, m[SIGMA[i * 16 + 2]], m[SIGMA[i * 16 + 3]]);
                        B2S_G(2, 6, 10, 14, m[SIGMA[i * 16 + 4]], m[SIGMA[i * 16 + 5]]);
                        B2S_G(3, 7, 11, 15, m[SIGMA[i * 16 + 6]], m[SIGMA[i * 16 + 7]]);
                        B2S_G(0, 5, 10, 15, m[SIGMA[i * 16 + 8]], m[SIGMA[i * 16 + 9]]);
                        B2S_G(1, 6, 11, 12, m[SIGMA[i * 16 + 10]], m[SIGMA[i * 16 + 11]]);
                        B2S_G(2, 7, 8, 13, m[SIGMA[i * 16 + 12]], m[SIGMA[i * 16 + 13]]);
                        B2S_G(3, 4, 9, 14, m[SIGMA[i * 16 + 14]], m[SIGMA[i * 16 + 15]]);
                    }
                    // util.debugPrint('   (i=10) v[16]', v, 32)
                    for(i = 0; i < 8; i++)ctx.h[i] ^= v[i] ^ v[i + 8];
                // util.debugPrint('h[8]', ctx.h, 32)
                }
                // Creates a BLAKE2s hashing context
                // Requires an output length between 1 and 32 bytes
                // Takes an optional Uint8Array key
                function blake2sInit(outlen, key) {
                    if (!(outlen > 0 && outlen <= 32)) throw new Error("Incorrect output length, should be in [1, 32]");
                    const keylen = key ? key.length : 0;
                    if (key && !(keylen > 0 && keylen <= 32)) throw new Error("Incorrect key length, should be in [1, 32]");
                    const ctx = {
                        h: new Uint32Array(BLAKE2S_IV),
                        b: new Uint8Array(64),
                        c: 0,
                        t: 0,
                        outlen: outlen // output length in bytes
                    };
                    ctx.h[0] ^= 0x01010000 ^ keylen << 8 ^ outlen;
                    if (keylen > 0) {
                        blake2sUpdate(ctx, key);
                        ctx.c = 64 // at the end
                        ;
                    }
                    return ctx;
                }
                // Updates a BLAKE2s streaming hash
                // Requires hash context and Uint8Array (byte array)
                function blake2sUpdate(ctx, input) {
                    for(let i = 0; i < input.length; i++){
                        if (ctx.c === 64) {
                            // buffer full ?
                            ctx.t += ctx.c // add counters
                            ;
                            blake2sCompress(ctx, false) // compress (not last)
                            ;
                            ctx.c = 0 // counter to zero
                            ;
                        }
                        ctx.b[ctx.c++] = input[i];
                    }
                }
                // Completes a BLAKE2s streaming hash
                // Returns a Uint8Array containing the message digest
                function blake2sFinal(ctx) {
                    ctx.t += ctx.c // mark last block offset
                    ;
                    while(ctx.c < 64)// fill up with zeros
                    ctx.b[ctx.c++] = 0;
                    blake2sCompress(ctx, true) // final block flag = 1
                    ;
                    // little endian convert and store
                    const out = new Uint8Array(ctx.outlen);
                    for(let i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3) & 0xff;
                    return out;
                }
                // Computes the BLAKE2S hash of a string or byte array, and returns a Uint8Array
                //
                // Returns a n-byte Uint8Array
                //
                // Parameters:
                // - input - the input bytes, as a string, Buffer, or Uint8Array
                // - key - optional key Uint8Array, up to 32 bytes
                // - outlen - optional output length in bytes, default 64
                function blake2s(input, key, outlen) {
                    // preprocess inputs
                    outlen = outlen || 32;
                    input = util.normalizeInput(input);
                    // do the math
                    const ctx = blake2sInit(outlen, key);
                    blake2sUpdate(ctx, input);
                    return blake2sFinal(ctx);
                }
                // Computes the BLAKE2S hash of a string or byte array
                //
                // Returns an n-byte hash in hex, all lowercase
                //
                // Parameters:
                // - input - the input bytes, as a string, Buffer, or Uint8Array
                // - key - optional key Uint8Array, up to 32 bytes
                // - outlen - optional output length in bytes, default 64
                function blake2sHex(input, key, outlen) {
                    const output = blake2s(input, key, outlen);
                    return util.toHex(output);
                }
                module1.exports = {
                    blake2s: blake2s,
                    blake2sHex: blake2sHex,
                    blake2sInit: blake2sInit,
                    blake2sUpdate: blake2sUpdate,
                    blake2sFinal: blake2sFinal
                };
            /***/ },
            /***/ 1191: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                const b2b = __webpack_require__(8442);
                const b2s = __webpack_require__(5297);
                module1.exports = {
                    blake2b: b2b.blake2b,
                    blake2bHex: b2b.blake2bHex,
                    blake2bInit: b2b.blake2bInit,
                    blake2bUpdate: b2b.blake2bUpdate,
                    blake2bFinal: b2b.blake2bFinal,
                    blake2s: b2s.blake2s,
                    blake2sHex: b2s.blake2sHex,
                    blake2sInit: b2s.blake2sInit,
                    blake2sUpdate: b2s.blake2sUpdate,
                    blake2sFinal: b2s.blake2sFinal
                };
            /***/ },
            /***/ 9488: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /* provided dependency */ var Buffer = __webpack_require__(8764)["Buffer"];
                const ERROR_MSG_INPUT = "Input must be an string, Buffer or Uint8Array";
                // For convenience, let people hash a string, not just a Uint8Array
                function normalizeInput(input) {
                    let ret;
                    if (input instanceof Uint8Array) ret = input;
                    else if (input instanceof Buffer) ret = new Uint8Array(input);
                    else if (typeof input === "string") ret = new Uint8Array(Buffer.from(input, "utf8"));
                    else throw new Error(ERROR_MSG_INPUT);
                    return ret;
                }
                // Converts a Uint8Array to a hexadecimal string
                // For example, toHex([255, 0, 255]) returns "ff00ff"
                function toHex(bytes) {
                    return Array.prototype.map.call(bytes, function(n) {
                        return (n < 16 ? "0" : "") + n.toString(16);
                    }).join("");
                }
                // Converts any value in [0...2^32-1] to an 8-character hex string
                function uint32ToHex(val) {
                    return (0x100000000 + val).toString(16).substring(1);
                }
                // For debugging: prints out hash state in the same format as the RFC
                // sample computation exactly, so that you can diff
                function debugPrint(label, arr, size) {
                    let msg = "\n" + label + " = ";
                    for(let i = 0; i < arr.length; i += 2){
                        if (size === 32) {
                            msg += uint32ToHex(arr[i]).toUpperCase();
                            msg += " ";
                            msg += uint32ToHex(arr[i + 1]).toUpperCase();
                        } else if (size === 64) {
                            msg += uint32ToHex(arr[i + 1]).toUpperCase();
                            msg += uint32ToHex(arr[i]).toUpperCase();
                        } else throw new Error("Invalid size " + size);
                        if (i % 6 === 4) msg += "\n" + new Array(label.length + 4).join(" ");
                        else if (i < arr.length - 2) msg += " ";
                    }
                    console.log(msg);
                }
                // For performance testing: generates N bytes of input, hashes M times
                // Measures and prints MB/second hash performance each time
                function testSpeed(hashFn, N, M) {
                    let startMs = new Date().getTime();
                    const input = new Uint8Array(N);
                    for(let i = 0; i < N; i++)input[i] = i % 256;
                    const genMs = new Date().getTime();
                    console.log("Generated random input in " + (genMs - startMs) + "ms");
                    startMs = genMs;
                    for(let i = 0; i < M; i++){
                        const hashHex = hashFn(input);
                        const hashMs = new Date().getTime();
                        const ms = hashMs - startMs;
                        startMs = hashMs;
                        console.log("Hashed in " + ms + "ms: " + hashHex.substring(0, 20) + "...");
                        console.log(Math.round(N / 1048576 / (ms / 1000) * 100) / 100 + " MB PER SECOND");
                    }
                }
                module1.exports = {
                    normalizeInput: normalizeInput,
                    toHex: toHex,
                    debugPrint: debugPrint,
                    testSpeed: testSpeed
                };
            /***/ },
            /***/ 8764: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var base64 = __webpack_require__(9742);
                var ieee754 = __webpack_require__(645);
                var customInspectSymbol = typeof Symbol === "function" && typeof Symbol.for === "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
                exports.Buffer = Buffer;
                exports.SlowBuffer = SlowBuffer;
                exports.INSPECT_MAX_BYTES = 50;
                var K_MAX_LENGTH = 0x7fffffff;
                exports.kMaxLength = K_MAX_LENGTH;
                /**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
                if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
                function typedArraySupport() {
                    // Can typed array instances can be augmented?
                    try {
                        var arr = new Uint8Array(1);
                        var proto = {
                            foo: function() {
                                return 42;
                            }
                        };
                        Object.setPrototypeOf(proto, Uint8Array.prototype);
                        Object.setPrototypeOf(arr, proto);
                        return arr.foo() === 42;
                    } catch (e) {
                        return false;
                    }
                }
                Object.defineProperty(Buffer.prototype, "parent", {
                    enumerable: true,
                    get: function() {
                        if (!Buffer.isBuffer(this)) return undefined;
                        return this.buffer;
                    }
                });
                Object.defineProperty(Buffer.prototype, "offset", {
                    enumerable: true,
                    get: function() {
                        if (!Buffer.isBuffer(this)) return undefined;
                        return this.byteOffset;
                    }
                });
                function createBuffer(length) {
                    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
                    // Return an augmented `Uint8Array` instance
                    var buf = new Uint8Array(length);
                    Object.setPrototypeOf(buf, Buffer.prototype);
                    return buf;
                }
                /**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
                    // Common case.
                    if (typeof arg === "number") {
                        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
                        return allocUnsafe(arg);
                    }
                    return from(arg, encodingOrOffset, length);
                }
                Buffer.poolSize = 8192 // not used by this implementation
                ;
                function from(value, encodingOrOffset, length) {
                    if (typeof value === "string") return fromString(value, encodingOrOffset);
                    if (ArrayBuffer.isView(value)) return fromArrayLike(value);
                    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
                    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
                    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
                    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
                    var valueOf = value.valueOf && value.valueOf();
                    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
                    var b = fromObject(value);
                    if (b) return b;
                    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
                    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
                }
                /**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
                    return from(value, encodingOrOffset, length);
                };
                // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
                // https://github.com/feross/buffer/pull/148
                Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
                Object.setPrototypeOf(Buffer, Uint8Array);
                function assertSize(size) {
                    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
                    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
                }
                function alloc(size, fill, encoding) {
                    assertSize(size);
                    if (size <= 0) return createBuffer(size);
                    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
                    // prevents accidentally sending in a number that would
                    // be interpretted as a start offset.
                    return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
                    return createBuffer(size);
                }
                /**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
                    return alloc(size, fill, encoding);
                };
                function allocUnsafe(size) {
                    assertSize(size);
                    return createBuffer(size < 0 ? 0 : checked(size) | 0);
                }
                /**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
                    return allocUnsafe(size);
                };
                /**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
                    return allocUnsafe(size);
                };
                function fromString(string, encoding) {
                    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
                    if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
                    var length = byteLength(string, encoding) | 0;
                    var buf = createBuffer(length);
                    var actual = buf.write(string, encoding);
                    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
                    // cause everything after the first invalid character to be ignored. (e.g.
                    // 'abxxcd' will be treated as 'ab')
                    buf = buf.slice(0, actual);
                    return buf;
                }
                function fromArrayLike(array) {
                    var length = array.length < 0 ? 0 : checked(array.length) | 0;
                    var buf = createBuffer(length);
                    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
                    return buf;
                }
                function fromArrayBuffer(array, byteOffset, length) {
                    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
                    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
                    var buf;
                    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
                    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
                    else buf = new Uint8Array(array, byteOffset, length);
                    // Return an augmented `Uint8Array` instance
                    Object.setPrototypeOf(buf, Buffer.prototype);
                    return buf;
                }
                function fromObject(obj) {
                    if (Buffer.isBuffer(obj)) {
                        var len = checked(obj.length) | 0;
                        var buf = createBuffer(len);
                        if (buf.length === 0) return buf;
                        obj.copy(buf, 0, 0, len);
                        return buf;
                    }
                    if (obj.length !== undefined) {
                        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
                        return fromArrayLike(obj);
                    }
                    if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
                }
                function checked(length) {
                    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
                    // length is NaN (which is otherwise coerced to zero.)
                    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
                    return length | 0;
                }
                function SlowBuffer(length) {
                    if (+length != length) length = 0;
                    return Buffer.alloc(+length);
                }
                Buffer.isBuffer = function isBuffer(b) {
                    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
                    ;
                };
                Buffer.compare = function compare(a, b) {
                    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
                    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
                    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                    if (a === b) return 0;
                    var x = a.length;
                    var y = b.length;
                    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
                        x = a[i];
                        y = b[i];
                        break;
                    }
                    if (x < y) return -1;
                    if (y < x) return 1;
                    return 0;
                };
                Buffer.isEncoding = function isEncoding(encoding) {
                    switch(String(encoding).toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "latin1":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return true;
                        default:
                            return false;
                    }
                };
                Buffer.concat = function concat(list, length) {
                    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
                    if (list.length === 0) return Buffer.alloc(0);
                    var i;
                    if (length === undefined) {
                        length = 0;
                        for(i = 0; i < list.length; ++i)length += list[i].length;
                    }
                    var buffer = Buffer.allocUnsafe(length);
                    var pos = 0;
                    for(i = 0; i < list.length; ++i){
                        var buf = list[i];
                        if (isInstance(buf, Uint8Array)) buf = Buffer.from(buf);
                        if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
                        buf.copy(buffer, pos);
                        pos += buf.length;
                    }
                    return buffer;
                };
                function byteLength(string, encoding) {
                    if (Buffer.isBuffer(string)) return string.length;
                    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
                    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
                    var len = string.length;
                    var mustMatch = arguments.length > 2 && arguments[2] === true;
                    if (!mustMatch && len === 0) return 0;
                    // Use a for loop to avoid recursion
                    var loweredCase = false;
                    for(;;)switch(encoding){
                        case "ascii":
                        case "latin1":
                        case "binary":
                            return len;
                        case "utf8":
                        case "utf-8":
                            return utf8ToBytes(string).length;
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return len * 2;
                        case "hex":
                            return len >>> 1;
                        case "base64":
                            return base64ToBytes(string).length;
                        default:
                            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
                            ;
                            encoding = ("" + encoding).toLowerCase();
                            loweredCase = true;
                    }
                }
                Buffer.byteLength = byteLength;
                function slowToString(encoding, start, end) {
                    var loweredCase = false;
                    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
                    // property of a typed array.
                    // This behaves neither like String nor Uint8Array in that we set start/end
                    // to their upper/lower bounds if the value passed is out of range.
                    // undefined is handled specially as per ECMA-262 6th Edition,
                    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
                    if (start === undefined || start < 0) start = 0;
                    // Return early if start > this.length. Done here to prevent potential uint32
                    // coercion fail below.
                    if (start > this.length) return "";
                    if (end === undefined || end > this.length) end = this.length;
                    if (end <= 0) return "";
                    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
                    end >>>= 0;
                    start >>>= 0;
                    if (end <= start) return "";
                    if (!encoding) encoding = "utf8";
                    while(true)switch(encoding){
                        case "hex":
                            return hexSlice(this, start, end);
                        case "utf8":
                        case "utf-8":
                            return utf8Slice(this, start, end);
                        case "ascii":
                            return asciiSlice(this, start, end);
                        case "latin1":
                        case "binary":
                            return latin1Slice(this, start, end);
                        case "base64":
                            return base64Slice(this, start, end);
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return utf16leSlice(this, start, end);
                        default:
                            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                            encoding = (encoding + "").toLowerCase();
                            loweredCase = true;
                    }
                }
                // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
                // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
                // reliably in a browserify context because there could be multiple different
                // copies of the 'buffer' package in use. This method works even for Buffer
                // instances that were created from another copy of the `buffer` package.
                // See: https://github.com/feross/buffer/issues/154
                Buffer.prototype._isBuffer = true;
                function swap(b, n, m) {
                    var i = b[n];
                    b[n] = b[m];
                    b[m] = i;
                }
                Buffer.prototype.swap16 = function swap16() {
                    var len = this.length;
                    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
                    return this;
                };
                Buffer.prototype.swap32 = function swap32() {
                    var len = this.length;
                    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                    for(var i = 0; i < len; i += 4){
                        swap(this, i, i + 3);
                        swap(this, i + 1, i + 2);
                    }
                    return this;
                };
                Buffer.prototype.swap64 = function swap64() {
                    var len = this.length;
                    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                    for(var i = 0; i < len; i += 8){
                        swap(this, i, i + 7);
                        swap(this, i + 1, i + 6);
                        swap(this, i + 2, i + 5);
                        swap(this, i + 3, i + 4);
                    }
                    return this;
                };
                Buffer.prototype.toString = function toString() {
                    var length = this.length;
                    if (length === 0) return "";
                    if (arguments.length === 0) return utf8Slice(this, 0, length);
                    return slowToString.apply(this, arguments);
                };
                Buffer.prototype.toLocaleString = Buffer.prototype.toString;
                Buffer.prototype.equals = function equals(b) {
                    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
                    if (this === b) return true;
                    return Buffer.compare(this, b) === 0;
                };
                Buffer.prototype.inspect = function inspect() {
                    var str = "";
                    var max = exports.INSPECT_MAX_BYTES;
                    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
                    if (this.length > max) str += " ... ";
                    return "<Buffer " + str + ">";
                };
                if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
                Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
                    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
                    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
                    if (start === undefined) start = 0;
                    if (end === undefined) end = target ? target.length : 0;
                    if (thisStart === undefined) thisStart = 0;
                    if (thisEnd === undefined) thisEnd = this.length;
                    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
                    if (thisStart >= thisEnd && start >= end) return 0;
                    if (thisStart >= thisEnd) return -1;
                    if (start >= end) return 1;
                    start >>>= 0;
                    end >>>= 0;
                    thisStart >>>= 0;
                    thisEnd >>>= 0;
                    if (this === target) return 0;
                    var x = thisEnd - thisStart;
                    var y = end - start;
                    var len = Math.min(x, y);
                    var thisCopy = this.slice(thisStart, thisEnd);
                    var targetCopy = target.slice(start, end);
                    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
                        x = thisCopy[i];
                        y = targetCopy[i];
                        break;
                    }
                    if (x < y) return -1;
                    if (y < x) return 1;
                    return 0;
                };
                // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
                // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
                //
                // Arguments:
                // - buffer - a Buffer to search
                // - val - a string, Buffer, or number
                // - byteOffset - an index into `buffer`; will be clamped to an int32
                // - encoding - an optional encoding, relevant is val is a string
                // - dir - true for indexOf, false for lastIndexOf
                function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
                    // Empty buffer means no match
                    if (buffer.length === 0) return -1;
                    // Normalize byteOffset
                    if (typeof byteOffset === "string") {
                        encoding = byteOffset;
                        byteOffset = 0;
                    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
                    else if (byteOffset < -2147483648) byteOffset = -2147483648;
                    byteOffset = +byteOffset // Coerce to Number.
                    ;
                    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
                    byteOffset = dir ? 0 : buffer.length - 1;
                    // Normalize byteOffset: negative offsets start from the end of the buffer
                    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
                    if (byteOffset >= buffer.length) {
                        if (dir) return -1;
                        else byteOffset = buffer.length - 1;
                    } else if (byteOffset < 0) {
                        if (dir) byteOffset = 0;
                        else return -1;
                    }
                    // Normalize val
                    if (typeof val === "string") val = Buffer.from(val, encoding);
                    // Finally, search either indexOf (if dir is true) or lastIndexOf
                    if (Buffer.isBuffer(val)) {
                        // Special case: looking for empty string/buffer always fails
                        if (val.length === 0) return -1;
                        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
                    } else if (typeof val === "number") {
                        val = val & 0xFF // Search for a byte value [0-255]
                        ;
                        if (typeof Uint8Array.prototype.indexOf === "function") {
                            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
                        }
                        return arrayIndexOf(buffer, [
                            val
                        ], byteOffset, encoding, dir);
                    }
                    throw new TypeError("val must be string, number or Buffer");
                }
                function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
                    var indexSize = 1;
                    var arrLength = arr.length;
                    var valLength = val.length;
                    if (encoding !== undefined) {
                        encoding = String(encoding).toLowerCase();
                        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
                            if (arr.length < 2 || val.length < 2) return -1;
                            indexSize = 2;
                            arrLength /= 2;
                            valLength /= 2;
                            byteOffset /= 2;
                        }
                    }
                    function read(buf, i) {
                        if (indexSize === 1) return buf[i];
                        else return buf.readUInt16BE(i * indexSize);
                    }
                    var i;
                    if (dir) {
                        var foundIndex = -1;
                        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                            if (foundIndex === -1) foundIndex = i;
                            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
                        } else {
                            if (foundIndex !== -1) i -= i - foundIndex;
                            foundIndex = -1;
                        }
                    } else {
                        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
                        for(i = byteOffset; i >= 0; i--){
                            var found = true;
                            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                                found = false;
                                break;
                            }
                            if (found) return i;
                        }
                    }
                    return -1;
                }
                Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
                    return this.indexOf(val, byteOffset, encoding) !== -1;
                };
                Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
                    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
                };
                Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
                    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
                };
                function hexWrite(buf, string, offset, length) {
                    offset = Number(offset) || 0;
                    var remaining = buf.length - offset;
                    if (!length) length = remaining;
                    else {
                        length = Number(length);
                        if (length > remaining) length = remaining;
                    }
                    var strLen = string.length;
                    if (length > strLen / 2) length = strLen / 2;
                    for(var i = 0; i < length; ++i){
                        var parsed = parseInt(string.substr(i * 2, 2), 16);
                        if (numberIsNaN(parsed)) return i;
                        buf[offset + i] = parsed;
                    }
                    return i;
                }
                function utf8Write(buf, string, offset, length) {
                    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
                }
                function asciiWrite(buf, string, offset, length) {
                    return blitBuffer(asciiToBytes(string), buf, offset, length);
                }
                function latin1Write(buf, string, offset, length) {
                    return asciiWrite(buf, string, offset, length);
                }
                function base64Write(buf, string, offset, length) {
                    return blitBuffer(base64ToBytes(string), buf, offset, length);
                }
                function ucs2Write(buf, string, offset, length) {
                    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
                }
                Buffer.prototype.write = function write(string, offset, length, encoding) {
                    // Buffer#write(string)
                    if (offset === undefined) {
                        encoding = "utf8";
                        length = this.length;
                        offset = 0;
                    // Buffer#write(string, encoding)
                    } else if (length === undefined && typeof offset === "string") {
                        encoding = offset;
                        length = this.length;
                        offset = 0;
                    // Buffer#write(string, offset[, length][, encoding])
                    } else if (isFinite(offset)) {
                        offset = offset >>> 0;
                        if (isFinite(length)) {
                            length = length >>> 0;
                            if (encoding === undefined) encoding = "utf8";
                        } else {
                            encoding = length;
                            length = undefined;
                        }
                    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                    var remaining = this.length - offset;
                    if (length === undefined || length > remaining) length = remaining;
                    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                    if (!encoding) encoding = "utf8";
                    var loweredCase = false;
                    for(;;)switch(encoding){
                        case "hex":
                            return hexWrite(this, string, offset, length);
                        case "utf8":
                        case "utf-8":
                            return utf8Write(this, string, offset, length);
                        case "ascii":
                            return asciiWrite(this, string, offset, length);
                        case "latin1":
                        case "binary":
                            return latin1Write(this, string, offset, length);
                        case "base64":
                            // Warning: maxLength not taken into account in base64Write
                            return base64Write(this, string, offset, length);
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return ucs2Write(this, string, offset, length);
                        default:
                            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                            encoding = ("" + encoding).toLowerCase();
                            loweredCase = true;
                    }
                };
                Buffer.prototype.toJSON = function toJSON() {
                    return {
                        type: "Buffer",
                        data: Array.prototype.slice.call(this._arr || this, 0)
                    };
                };
                function base64Slice(buf, start, end) {
                    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
                    else return base64.fromByteArray(buf.slice(start, end));
                }
                function utf8Slice(buf, start, end) {
                    end = Math.min(buf.length, end);
                    var res = [];
                    var i = start;
                    while(i < end){
                        var firstByte = buf[i];
                        var codePoint = null;
                        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
                        if (i + bytesPerSequence <= end) {
                            var secondByte, thirdByte, fourthByte, tempCodePoint;
                            switch(bytesPerSequence){
                                case 1:
                                    if (firstByte < 0x80) codePoint = firstByte;
                                    break;
                                case 2:
                                    secondByte = buf[i + 1];
                                    if ((secondByte & 0xC0) === 0x80) {
                                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                                    }
                                    break;
                                case 3:
                                    secondByte = buf[i + 1];
                                    thirdByte = buf[i + 2];
                                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                                    }
                                    break;
                                case 4:
                                    secondByte = buf[i + 1];
                                    thirdByte = buf[i + 2];
                                    fourthByte = buf[i + 3];
                                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                                    }
                            }
                        }
                        if (codePoint === null) {
                            // we did not generate a valid codePoint so insert a
                            // replacement char (U+FFFD) and advance only 1 byte
                            codePoint = 0xFFFD;
                            bytesPerSequence = 1;
                        } else if (codePoint > 0xFFFF) {
                            // encode to utf16 (surrogate pair dance)
                            codePoint -= 0x10000;
                            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                            codePoint = 0xDC00 | codePoint & 0x3FF;
                        }
                        res.push(codePoint);
                        i += bytesPerSequence;
                    }
                    return decodeCodePointsArray(res);
                }
                // Based on http://stackoverflow.com/a/22747272/680742, the browser with
                // the lowest limit is Chrome, with 0x10000 args.
                // We go 1 magnitude less, for safety
                var MAX_ARGUMENTS_LENGTH = 0x1000;
                function decodeCodePointsArray(codePoints) {
                    var len = codePoints.length;
                    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
                    ;
                    // Decode in chunks to avoid "call stack size exceeded".
                    var res = "";
                    var i = 0;
                    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
                    return res;
                }
                function asciiSlice(buf, start, end) {
                    var ret = "";
                    end = Math.min(buf.length, end);
                    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
                    return ret;
                }
                function latin1Slice(buf, start, end) {
                    var ret = "";
                    end = Math.min(buf.length, end);
                    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
                    return ret;
                }
                function hexSlice(buf, start, end) {
                    var len = buf.length;
                    if (!start || start < 0) start = 0;
                    if (!end || end < 0 || end > len) end = len;
                    var out = "";
                    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
                    return out;
                }
                function utf16leSlice(buf, start, end) {
                    var bytes = buf.slice(start, end);
                    var res = "";
                    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
                    return res;
                }
                Buffer.prototype.slice = function slice(start, end) {
                    var len = this.length;
                    start = ~~start;
                    end = end === undefined ? len : ~~end;
                    if (start < 0) {
                        start += len;
                        if (start < 0) start = 0;
                    } else if (start > len) start = len;
                    if (end < 0) {
                        end += len;
                        if (end < 0) end = 0;
                    } else if (end > len) end = len;
                    if (end < start) end = start;
                    var newBuf = this.subarray(start, end);
                    // Return an augmented `Uint8Array` instance
                    Object.setPrototypeOf(newBuf, Buffer.prototype);
                    return newBuf;
                };
                /*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
                    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
                    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
                }
                Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) checkOffset(offset, byteLength, this.length);
                    var val = this[offset];
                    var mul = 1;
                    var i = 0;
                    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
                    return val;
                };
                Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) checkOffset(offset, byteLength, this.length);
                    var val = this[offset + --byteLength];
                    var mul = 1;
                    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
                    return val;
                };
                Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 1, this.length);
                    return this[offset];
                };
                Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 2, this.length);
                    return this[offset] | this[offset + 1] << 8;
                };
                Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 2, this.length);
                    return this[offset] << 8 | this[offset + 1];
                };
                Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
                };
                Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
                };
                Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) checkOffset(offset, byteLength, this.length);
                    var val = this[offset];
                    var mul = 1;
                    var i = 0;
                    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
                    mul *= 0x80;
                    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
                    return val;
                };
                Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) checkOffset(offset, byteLength, this.length);
                    var i = byteLength;
                    var mul = 1;
                    var val = this[offset + --i];
                    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
                    mul *= 0x80;
                    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
                    return val;
                };
                Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 1, this.length);
                    if (!(this[offset] & 0x80)) return this[offset];
                    return (0xff - this[offset] + 1) * -1;
                };
                Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 2, this.length);
                    var val = this[offset] | this[offset + 1] << 8;
                    return val & 0x8000 ? val | 0xFFFF0000 : val;
                };
                Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 2, this.length);
                    var val = this[offset + 1] | this[offset] << 8;
                    return val & 0x8000 ? val | 0xFFFF0000 : val;
                };
                Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
                };
                Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
                };
                Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return ieee754.read(this, offset, true, 23, 4);
                };
                Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return ieee754.read(this, offset, false, 23, 4);
                };
                Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 8, this.length);
                    return ieee754.read(this, offset, true, 52, 8);
                };
                Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 8, this.length);
                    return ieee754.read(this, offset, false, 52, 8);
                };
                function checkInt(buf, value, offset, ext, max, min) {
                    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
                    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
                    if (offset + ext > buf.length) throw new RangeError("Index out of range");
                }
                Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) {
                        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                        checkInt(this, value, offset, byteLength, maxBytes, 0);
                    }
                    var mul = 1;
                    var i = 0;
                    this[offset] = value & 0xFF;
                    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
                    return offset + byteLength;
                };
                Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) {
                        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                        checkInt(this, value, offset, byteLength, maxBytes, 0);
                    }
                    var i = byteLength - 1;
                    var mul = 1;
                    this[offset + i] = value & 0xFF;
                    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
                    return offset + byteLength;
                };
                Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
                    this[offset] = value & 0xff;
                    return offset + 1;
                };
                Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                    this[offset] = value & 0xff;
                    this[offset + 1] = value >>> 8;
                    return offset + 2;
                };
                Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                    this[offset] = value >>> 8;
                    this[offset + 1] = value & 0xff;
                    return offset + 2;
                };
                Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
                    this[offset + 3] = value >>> 24;
                    this[offset + 2] = value >>> 16;
                    this[offset + 1] = value >>> 8;
                    this[offset] = value & 0xff;
                    return offset + 4;
                };
                Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
                    this[offset] = value >>> 24;
                    this[offset + 1] = value >>> 16;
                    this[offset + 2] = value >>> 8;
                    this[offset + 3] = value & 0xff;
                    return offset + 4;
                };
                Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) {
                        var limit = Math.pow(2, 8 * byteLength - 1);
                        checkInt(this, value, offset, byteLength, limit - 1, -limit);
                    }
                    var i = 0;
                    var mul = 1;
                    var sub = 0;
                    this[offset] = value & 0xFF;
                    while(++i < byteLength && (mul *= 0x100)){
                        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
                        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
                    }
                    return offset + byteLength;
                };
                Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) {
                        var limit = Math.pow(2, 8 * byteLength - 1);
                        checkInt(this, value, offset, byteLength, limit - 1, -limit);
                    }
                    var i = byteLength - 1;
                    var mul = 1;
                    var sub = 0;
                    this[offset + i] = value & 0xFF;
                    while(--i >= 0 && (mul *= 0x100)){
                        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
                        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
                    }
                    return offset + byteLength;
                };
                Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
                    if (value < 0) value = 0xff + value + 1;
                    this[offset] = value & 0xff;
                    return offset + 1;
                };
                Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
                    this[offset] = value & 0xff;
                    this[offset + 1] = value >>> 8;
                    return offset + 2;
                };
                Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
                    this[offset] = value >>> 8;
                    this[offset + 1] = value & 0xff;
                    return offset + 2;
                };
                Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
                    this[offset] = value & 0xff;
                    this[offset + 1] = value >>> 8;
                    this[offset + 2] = value >>> 16;
                    this[offset + 3] = value >>> 24;
                    return offset + 4;
                };
                Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
                    if (value < 0) value = 0xffffffff + value + 1;
                    this[offset] = value >>> 24;
                    this[offset + 1] = value >>> 16;
                    this[offset + 2] = value >>> 8;
                    this[offset + 3] = value & 0xff;
                    return offset + 4;
                };
                function checkIEEE754(buf, value, offset, ext, max, min) {
                    if (offset + ext > buf.length) throw new RangeError("Index out of range");
                    if (offset < 0) throw new RangeError("Index out of range");
                }
                function writeFloat(buf, value, offset, littleEndian, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
                    ieee754.write(buf, value, offset, littleEndian, 23, 4);
                    return offset + 4;
                }
                Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
                    return writeFloat(this, value, offset, true, noAssert);
                };
                Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
                    return writeFloat(this, value, offset, false, noAssert);
                };
                function writeDouble(buf, value, offset, littleEndian, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
                    ieee754.write(buf, value, offset, littleEndian, 52, 8);
                    return offset + 8;
                }
                Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
                    return writeDouble(this, value, offset, true, noAssert);
                };
                Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
                    return writeDouble(this, value, offset, false, noAssert);
                };
                // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
                Buffer.prototype.copy = function copy(target, targetStart, start, end) {
                    if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
                    if (!start) start = 0;
                    if (!end && end !== 0) end = this.length;
                    if (targetStart >= target.length) targetStart = target.length;
                    if (!targetStart) targetStart = 0;
                    if (end > 0 && end < start) end = start;
                    // Copy 0 bytes; we're done
                    if (end === start) return 0;
                    if (target.length === 0 || this.length === 0) return 0;
                    // Fatal error conditions
                    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
                    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
                    if (end < 0) throw new RangeError("sourceEnd out of bounds");
                    // Are we oob?
                    if (end > this.length) end = this.length;
                    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
                    var len = end - start;
                    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
                    this.copyWithin(targetStart, start, end);
                    else if (this === target && start < targetStart && targetStart < end) // descending copy from end
                    for(var i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
                    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
                    return len;
                };
                // Usage:
                //    buffer.fill(number[, offset[, end]])
                //    buffer.fill(buffer[, offset[, end]])
                //    buffer.fill(string[, offset[, end]][, encoding])
                Buffer.prototype.fill = function fill(val, start, end, encoding) {
                    // Handle string cases:
                    if (typeof val === "string") {
                        if (typeof start === "string") {
                            encoding = start;
                            start = 0;
                            end = this.length;
                        } else if (typeof end === "string") {
                            encoding = end;
                            end = this.length;
                        }
                        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
                        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
                        if (val.length === 1) {
                            var code = val.charCodeAt(0);
                            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
                            val = code;
                        }
                    } else if (typeof val === "number") val = val & 255;
                    else if (typeof val === "boolean") val = Number(val);
                    // Invalid ranges are not set to a default, so can range check early.
                    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
                    if (end <= start) return this;
                    start = start >>> 0;
                    end = end === undefined ? this.length : end >>> 0;
                    if (!val) val = 0;
                    var i;
                    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
                    else {
                        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
                        var len = bytes.length;
                        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
                        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
                    }
                    return this;
                };
                // HELPER FUNCTIONS
                // ================
                var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
                function base64clean(str) {
                    // Node takes equal signs as end of the Base64 encoding
                    str = str.split("=")[0];
                    // Node strips out invalid characters like \n and \t from the string, base64-js does not
                    str = str.trim().replace(INVALID_BASE64_RE, "");
                    // Node converts strings with length < 2 to ''
                    if (str.length < 2) return "";
                    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
                    while(str.length % 4 !== 0)str = str + "=";
                    return str;
                }
                function utf8ToBytes(string, units) {
                    units = units || Infinity;
                    var codePoint;
                    var length = string.length;
                    var leadSurrogate = null;
                    var bytes = [];
                    for(var i = 0; i < length; ++i){
                        codePoint = string.charCodeAt(i);
                        // is surrogate component
                        if (codePoint > 0xD7FF && codePoint < 0xE000) {
                            // last char was a lead
                            if (!leadSurrogate) {
                                // no lead yet
                                if (codePoint > 0xDBFF) {
                                    // unexpected trail
                                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                    continue;
                                } else if (i + 1 === length) {
                                    // unpaired lead
                                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                    continue;
                                }
                                // valid lead
                                leadSurrogate = codePoint;
                                continue;
                            }
                            // 2 leads in a row
                            if (codePoint < 0xDC00) {
                                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                leadSurrogate = codePoint;
                                continue;
                            }
                            // valid surrogate pair
                            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
                        } else if (leadSurrogate) // valid bmp char, but last char was a lead
                        {
                            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        }
                        leadSurrogate = null;
                        // encode utf8
                        if (codePoint < 0x80) {
                            if ((units -= 1) < 0) break;
                            bytes.push(codePoint);
                        } else if (codePoint < 0x800) {
                            if ((units -= 2) < 0) break;
                            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
                        } else if (codePoint < 0x10000) {
                            if ((units -= 3) < 0) break;
                            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                        } else if (codePoint < 0x110000) {
                            if ((units -= 4) < 0) break;
                            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                        } else throw new Error("Invalid code point");
                    }
                    return bytes;
                }
                function asciiToBytes(str) {
                    var byteArray = [];
                    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
                    byteArray.push(str.charCodeAt(i) & 0xFF);
                    return byteArray;
                }
                function utf16leToBytes(str, units) {
                    var c, hi, lo;
                    var byteArray = [];
                    for(var i = 0; i < str.length; ++i){
                        if ((units -= 2) < 0) break;
                        c = str.charCodeAt(i);
                        hi = c >> 8;
                        lo = c % 256;
                        byteArray.push(lo);
                        byteArray.push(hi);
                    }
                    return byteArray;
                }
                function base64ToBytes(str) {
                    return base64.toByteArray(base64clean(str));
                }
                function blitBuffer(src, dst, offset, length) {
                    for(var i = 0; i < length; ++i){
                        if (i + offset >= dst.length || i >= src.length) break;
                        dst[i + offset] = src[i];
                    }
                    return i;
                }
                // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
                // the `instanceof` check but they should be treated as of that type.
                // See: https://github.com/feross/buffer/issues/166
                function isInstance(obj, type) {
                    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
                }
                function numberIsNaN(obj) {
                    // For IE11 support
                    return obj !== obj // eslint-disable-line no-self-compare
                    ;
                }
                // Create lookup table for `toString('hex')`
                // See: https://github.com/feross/buffer/issues/219
                var hexSliceLookupTable = function() {
                    var alphabet = "0123456789abcdef";
                    var table = new Array(256);
                    for(var i = 0; i < 16; ++i){
                        var i16 = i * 16;
                        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
                    }
                    return table;
                }();
            /***/ },
            /***/ 645: /***/ (__unused_webpack_module, exports)=>{
                exports.read = function(buffer, offset, isLE, mLen, nBytes) {
                    var e, m;
                    var eLen = nBytes * 8 - mLen - 1;
                    var eMax = (1 << eLen) - 1;
                    var eBias = eMax >> 1;
                    var nBits = -7;
                    var i = isLE ? nBytes - 1 : 0;
                    var d = isLE ? -1 : 1;
                    var s = buffer[offset + i];
                    i += d;
                    e = s & (1 << -nBits) - 1;
                    s >>= -nBits;
                    nBits += eLen;
                    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
                    m = e & (1 << -nBits) - 1;
                    e >>= -nBits;
                    nBits += mLen;
                    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
                    if (e === 0) e = 1 - eBias;
                    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
                    else {
                        m = m + Math.pow(2, mLen);
                        e = e - eBias;
                    }
                    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
                };
                exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
                    var e, m, c;
                    var eLen = nBytes * 8 - mLen - 1;
                    var eMax = (1 << eLen) - 1;
                    var eBias = eMax >> 1;
                    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
                    var i = isLE ? 0 : nBytes - 1;
                    var d = isLE ? 1 : -1;
                    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
                    value = Math.abs(value);
                    if (isNaN(value) || value === Infinity) {
                        m = isNaN(value) ? 1 : 0;
                        e = eMax;
                    } else {
                        e = Math.floor(Math.log(value) / Math.LN2);
                        if (value * (c = Math.pow(2, -e)) < 1) {
                            e--;
                            c *= 2;
                        }
                        if (e + eBias >= 1) value += rt / c;
                        else value += rt * Math.pow(2, 1 - eBias);
                        if (value * c >= 2) {
                            e++;
                            c /= 2;
                        }
                        if (e + eBias >= eMax) {
                            m = 0;
                            e = eMax;
                        } else if (e + eBias >= 1) {
                            m = (value * c - 1) * Math.pow(2, mLen);
                            e = e + eBias;
                        } else {
                            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
                            e = 0;
                        }
                    }
                    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
                    e = e << mLen | m;
                    eLen += mLen;
                    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
                    buffer[offset + i - d] |= s * 128;
                };
            /***/ },
            /***/ 2587: /***/ (module1)=>{
                "use strict";
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                // If obj.hasOwnProperty has been overridden, then calling
                // obj.hasOwnProperty(prop) will break.
                // See: https://github.com/joyent/node/issues/1707
                function hasOwnProperty(obj, prop) {
                    return Object.prototype.hasOwnProperty.call(obj, prop);
                }
                module1.exports = function(qs, sep, eq, options) {
                    sep = sep || "&";
                    eq = eq || "=";
                    var obj = {};
                    if (typeof qs !== "string" || qs.length === 0) return obj;
                    var regexp = /\+/g;
                    qs = qs.split(sep);
                    var maxKeys = 1000;
                    if (options && typeof options.maxKeys === "number") maxKeys = options.maxKeys;
                    var len = qs.length;
                    // maxKeys <= 0 means that we should not limit keys count
                    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
                    for(var i = 0; i < len; ++i){
                        var x = qs[i].replace(regexp, "%20"), idx = x.indexOf(eq), kstr, vstr, k, v;
                        if (idx >= 0) {
                            kstr = x.substr(0, idx);
                            vstr = x.substr(idx + 1);
                        } else {
                            kstr = x;
                            vstr = "";
                        }
                        k = decodeURIComponent(kstr);
                        v = decodeURIComponent(vstr);
                        if (!hasOwnProperty(obj, k)) obj[k] = v;
                        else if (Array.isArray(obj[k])) obj[k].push(v);
                        else obj[k] = [
                            obj[k],
                            v
                        ];
                    }
                    return obj;
                };
            /***/ },
            /***/ 2361: /***/ (module1)=>{
                "use strict";
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                var stringifyPrimitive = function(v) {
                    switch(typeof v){
                        case "string":
                            return v;
                        case "boolean":
                            return v ? "true" : "false";
                        case "number":
                            return isFinite(v) ? v : "";
                        default:
                            return "";
                    }
                };
                module1.exports = function(obj, sep, eq, name1) {
                    sep = sep || "&";
                    eq = eq || "=";
                    if (obj === null) obj = undefined;
                    if (typeof obj === "object") return Object.keys(obj).map(function(k) {
                        var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
                        if (Array.isArray(obj[k])) return obj[k].map(function(v) {
                            return ks + encodeURIComponent(stringifyPrimitive(v));
                        }).join(sep);
                        else return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
                    }).join(sep);
                    if (!name1) return "";
                    return encodeURIComponent(stringifyPrimitive(name1)) + eq + encodeURIComponent(stringifyPrimitive(obj));
                };
            /***/ },
            /***/ 7673: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                exports.decode = exports.parse = __webpack_require__(2587);
                exports.encode = exports.stringify = __webpack_require__(2361);
            /***/ },
            /***/ 1798: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                // limit of Crypto.getRandomValues()
                // https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
                var MAX_BYTES = 65536;
                // Node supports requesting up to this number of bytes
                // https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
                var MAX_UINT32 = 4294967295;
                function oldBrowser() {
                    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
                }
                var Buffer = __webpack_require__(9509).Buffer;
                var crypto1 = __webpack_require__.g.crypto || __webpack_require__.g.msCrypto;
                if (crypto1 && crypto1.getRandomValues) module1.exports = randomBytes;
                else module1.exports = oldBrowser;
                function randomBytes(size, cb) {
                    // phantomjs needs to throw
                    if (size > MAX_UINT32) throw new RangeError("requested too many random bytes");
                    var bytes = Buffer.allocUnsafe(size);
                    if (size > 0) {
                        if (size > MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
                        for(var generated = 0; generated < size; generated += MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
                        // the buffer so we don't have to here
                        crypto1.getRandomValues(bytes.slice(generated, generated + MAX_BYTES));
                        else crypto1.getRandomValues(bytes);
                    }
                    if (typeof cb === "function") return $hPtJY.nextTick(function() {
                        cb(null, bytes);
                    });
                    return bytes;
                }
            /***/ },
            /***/ 9509: /***/ (module1, exports, __webpack_require__)=>{
                /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ var buffer = __webpack_require__(8764);
                var Buffer = buffer.Buffer;
                // alternative to using Object.keys for old browsers
                function copyProps(src, dst) {
                    for(var key in src)dst[key] = src[key];
                }
                if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module1.exports = buffer;
                else {
                    // Copy properties from require('buffer')
                    copyProps(buffer, exports);
                    exports.Buffer = SafeBuffer;
                }
                function SafeBuffer(arg, encodingOrOffset, length) {
                    return Buffer(arg, encodingOrOffset, length);
                }
                SafeBuffer.prototype = Object.create(Buffer.prototype);
                // Copy static methods from Buffer
                copyProps(Buffer, SafeBuffer);
                SafeBuffer.from = function(arg, encodingOrOffset, length) {
                    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
                    return Buffer(arg, encodingOrOffset, length);
                };
                SafeBuffer.alloc = function(size, fill, encoding) {
                    if (typeof size !== "number") throw new TypeError("Argument must be a number");
                    var buf = Buffer(size);
                    if (fill !== undefined) {
                        if (typeof encoding === "string") buf.fill(fill, encoding);
                        else buf.fill(fill);
                    } else buf.fill(0);
                    return buf;
                };
                SafeBuffer.allocUnsafe = function(size) {
                    if (typeof size !== "number") throw new TypeError("Argument must be a number");
                    return Buffer(size);
                };
                SafeBuffer.allocUnsafeSlow = function(size) {
                    if (typeof size !== "number") throw new TypeError("Argument must be a number");
                    return buffer.SlowBuffer(size);
                };
            /***/ },
            /***/ 2511: /***/ function(module1, exports, __webpack_require__) {
                /* module decorator */ module1 = __webpack_require__.nmd(module1);
                var __WEBPACK_AMD_DEFINE_RESULT__; /*! https://mths.be/punycode v1.3.2 by @mathias */ 
                (function(root) {
                    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
                    var freeModule = module1 && !module1.nodeType && module1;
                    var freeGlobal = typeof __webpack_require__.g == "object" && __webpack_require__.g;
                    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
                    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
                        "overflow": "Overflow: input needs wider integers to process",
                        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                        "invalid-input": "Invalid input"
                    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
                    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
                        throw RangeError(errors[type]);
                    }
                    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
                        var length = array.length;
                        var result = [];
                        while(length--)result[length] = fn(array[length]);
                        return result;
                    }
                    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
                        var parts = string.split("@");
                        var result = "";
                        if (parts.length > 1) {
                            // In email addresses, only the domain name should be punycoded. Leave
                            // the local part (i.e. everything up to `@`) intact.
                            result = parts[0] + "@";
                            string = parts[1];
                        }
                        // Avoid `split(regex)` for IE8 compatibility. See #17.
                        string = string.replace(regexSeparators, ".");
                        var labels = string.split(".");
                        var encoded = map(labels, fn).join(".");
                        return result + encoded;
                    }
                    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
                        var output = [], counter = 0, length = string.length, value, extra;
                        while(counter < length){
                            value = string.charCodeAt(counter++);
                            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                                // high surrogate, and there is a next character
                                extra = string.charCodeAt(counter++);
                                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                                else {
                                    // unmatched surrogate; only append this code unit, in case the next
                                    // code unit is the high surrogate of a surrogate pair
                                    output.push(value);
                                    counter--;
                                }
                            } else output.push(value);
                        }
                        return output;
                    }
                    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
                        return map(array, function(value) {
                            var output = "";
                            if (value > 0xFFFF) {
                                value -= 0x10000;
                                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                                value = 0xDC00 | value & 0x3FF;
                            }
                            output += stringFromCharCode(value);
                            return output;
                        }).join("");
                    }
                    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
                        if (codePoint - 48 < 10) return codePoint - 22;
                        if (codePoint - 65 < 26) return codePoint - 65;
                        if (codePoint - 97 < 26) return codePoint - 97;
                        return base;
                    }
                    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
                        //  0..25 map to ASCII a..z or A..Z
                        // 26..35 map to ASCII 0..9
                        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
                    }
                    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
                        var k = 0;
                        delta = firstTime ? floor(delta / damp) : delta >> 1;
                        delta += floor(delta / numPoints);
                        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
                        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
                    }
                    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
                        // Don't use UCS-2
                        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
                        // Handle the basic code points: let `basic` be the number of input code
                        // points before the last delimiter, or `0` if there is none, then copy
                        // the first basic code points to the output.
                        basic = input.lastIndexOf(delimiter);
                        if (basic < 0) basic = 0;
                        for(j = 0; j < basic; ++j){
                            // if it's not a basic code point
                            if (input.charCodeAt(j) >= 0x80) error("not-basic");
                            output.push(input.charCodeAt(j));
                        }
                        // Main decoding loop: start just after the last delimiter if any basic code
                        // points were copied; start at the beginning otherwise.
                        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
                            // `index` is the index of the next character to be consumed.
                            // Decode a generalized variable-length integer into `delta`,
                            // which gets added to `i`. The overflow checking is easier
                            // if we increase `i` as we go, then subtract off its starting
                            // value at the end to obtain `delta`.
                            for(oldi = i, w = 1, k = base;; k += base){
                                if (index >= inputLength) error("invalid-input");
                                digit = basicToDigit(input.charCodeAt(index++));
                                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                                i += digit * w;
                                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                                if (digit < t) break;
                                baseMinusT = base - t;
                                if (w > floor(maxInt / baseMinusT)) error("overflow");
                                w *= baseMinusT;
                            }
                            out = output.length + 1;
                            bias = adapt(i - oldi, out, oldi == 0);
                            // `i` was supposed to wrap around from `out` to `0`,
                            // incrementing `n` each time, so we'll fix that now:
                            if (floor(i / out) > maxInt - n) error("overflow");
                            n += floor(i / out);
                            i %= out;
                            // Insert `n` at position `i` of the output
                            output.splice(i++, 0, n);
                        }
                        return ucs2encode(output);
                    }
                    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
                        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
                        // Convert the input in UCS-2 to Unicode
                        input = ucs2decode(input);
                        // Cache the length
                        inputLength = input.length;
                        // Initialize the state
                        n = initialN;
                        delta = 0;
                        bias = initialBias;
                        // Handle the basic code points
                        for(j = 0; j < inputLength; ++j){
                            currentValue = input[j];
                            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
                        }
                        handledCPCount = basicLength = output.length;
                        // `handledCPCount` is the number of code points that have been handled;
                        // `basicLength` is the number of basic code points.
                        // Finish the basic string - if it is not empty - with a delimiter
                        if (basicLength) output.push(delimiter);
                        // Main encoding loop:
                        while(handledCPCount < inputLength){
                            // All non-basic code points < n have been handled already. Find the next
                            // larger one:
                            for(m = maxInt, j = 0; j < inputLength; ++j){
                                currentValue = input[j];
                                if (currentValue >= n && currentValue < m) m = currentValue;
                            }
                            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
                            // but guard against overflow
                            handledCPCountPlusOne = handledCPCount + 1;
                            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
                            delta += (m - n) * handledCPCountPlusOne;
                            n = m;
                            for(j = 0; j < inputLength; ++j){
                                currentValue = input[j];
                                if (currentValue < n && ++delta > maxInt) error("overflow");
                                if (currentValue == n) {
                                    // Represent delta as a generalized variable-length integer
                                    for(q = delta, k = base;; k += base){
                                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                                        if (q < t) break;
                                        qMinusT = q - t;
                                        baseMinusT = base - t;
                                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                                        q = floor(qMinusT / baseMinusT);
                                    }
                                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                                    delta = 0;
                                    ++handledCPCount;
                                }
                            }
                            ++delta;
                            ++n;
                        }
                        return output.join("");
                    }
                    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
                        return mapDomain(input, function(string) {
                            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
                        });
                    }
                    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
                        return mapDomain(input, function(string) {
                            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
                        });
                    }
                    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
                        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.3.2",
                        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
                            "decode": ucs2decode,
                            "encode": ucs2encode
                        },
                        "decode": decode,
                        "encode": encode,
                        "toASCII": toASCII,
                        "toUnicode": toUnicode
                    };
                    __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                        return punycode;
                    }).call(exports, __webpack_require__, exports, module1), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__);
                })(this);
            /***/ },
            /***/ 8575: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                var __webpack_unused_export__;
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                var punycode = __webpack_require__(2511);
                var util = __webpack_require__(2502);
                __webpack_unused_export__ = urlParse;
                exports.DB = urlResolve;
                __webpack_unused_export__ = urlResolveObject;
                __webpack_unused_export__ = urlFormat;
                __webpack_unused_export__ = Url;
                function Url() {
                    this.protocol = null;
                    this.slashes = null;
                    this.auth = null;
                    this.host = null;
                    this.port = null;
                    this.hostname = null;
                    this.hash = null;
                    this.search = null;
                    this.query = null;
                    this.pathname = null;
                    this.path = null;
                    this.href = null;
                }
                // Reference: RFC 3986, RFC 1808, RFC 2396
                // define these here so at least they only have to be
                // compiled once on the first module load.
                var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
                simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
                // We actually just auto-escape these.
                delims = [
                    "<",
                    ">",
                    '"',
                    "`",
                    " ",
                    "\r",
                    "\n",
                    "	"
                ], // RFC 2396: characters not allowed for various reasons.
                unwise = [
                    "{",
                    "}",
                    "|",
                    "\\",
                    "^",
                    "`"
                ].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
                autoEscape = [
                    "'"
                ].concat(unwise), // Characters that are never ever allowed in a hostname.
                // Note that any invalid chars are also handled, but these
                // are the ones that are *expected* to be seen, so we fast-path
                // them.
                nonHostChars = [
                    "%",
                    "/",
                    "?",
                    ";",
                    "#"
                ].concat(autoEscape), hostEndingChars = [
                    "/",
                    "?",
                    "#"
                ], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
                unsafeProtocol = {
                    "javascript": true,
                    "javascript:": true
                }, // protocols that never have a hostname.
                hostlessProtocol = {
                    "javascript": true,
                    "javascript:": true
                }, // protocols that always contain a // bit.
                slashedProtocol = {
                    "http": true,
                    "https": true,
                    "ftp": true,
                    "gopher": true,
                    "file": true,
                    "http:": true,
                    "https:": true,
                    "ftp:": true,
                    "gopher:": true,
                    "file:": true
                }, querystring = __webpack_require__(7673);
                function urlParse(url, parseQueryString, slashesDenoteHost) {
                    if (url && util.isObject(url) && url instanceof Url) return url;
                    var u = new Url;
                    u.parse(url, parseQueryString, slashesDenoteHost);
                    return u;
                }
                Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
                    if (!util.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
                    // Copy chrome, IE, opera backslash-handling behavior.
                    // Back slashes before the query string get converted to forward slashes
                    // See: https://code.google.com/p/chromium/issues/detail?id=25916
                    var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
                    uSplit[0] = uSplit[0].replace(slashRegex, "/");
                    url = uSplit.join(splitter);
                    var rest = url;
                    // trim before proceeding.
                    // This is to support parse stuff like "  http://foo.com  \n"
                    rest = rest.trim();
                    if (!slashesDenoteHost && url.split("#").length === 1) {
                        // Try fast path regexp
                        var simplePath = simplePathPattern.exec(rest);
                        if (simplePath) {
                            this.path = rest;
                            this.href = rest;
                            this.pathname = simplePath[1];
                            if (simplePath[2]) {
                                this.search = simplePath[2];
                                if (parseQueryString) this.query = querystring.parse(this.search.substr(1));
                                else this.query = this.search.substr(1);
                            } else if (parseQueryString) {
                                this.search = "";
                                this.query = {};
                            }
                            return this;
                        }
                    }
                    var proto = protocolPattern.exec(rest);
                    if (proto) {
                        proto = proto[0];
                        var lowerProto = proto.toLowerCase();
                        this.protocol = lowerProto;
                        rest = rest.substr(proto.length);
                    }
                    // figure out if it's got a host
                    // user@server is *always* interpreted as a hostname, and url
                    // resolution will treat //foo/bar as host=foo,path=bar because that's
                    // how the browser resolves relative URLs.
                    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
                        var slashes = rest.substr(0, 2) === "//";
                        if (slashes && !(proto && hostlessProtocol[proto])) {
                            rest = rest.substr(2);
                            this.slashes = true;
                        }
                    }
                    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
                        // there's a hostname.
                        // the first instance of /, ?, ;, or # ends the host.
                        //
                        // If there is an @ in the hostname, then non-host chars *are* allowed
                        // to the left of the last @ sign, unless some host-ending character
                        // comes *before* the @-sign.
                        // URLs are obnoxious.
                        //
                        // ex:
                        // http://a@b@c/ => user:a@b host:c
                        // http://a@b?@c => user:a host:c path:/?@c
                        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
                        // Review our test case against browsers more comprehensively.
                        // find the first instance of any hostEndingChars
                        var hostEnd = -1;
                        for(var i = 0; i < hostEndingChars.length; i++){
                            var hec = rest.indexOf(hostEndingChars[i]);
                            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
                        }
                        // at this point, either we have an explicit point where the
                        // auth portion cannot go past, or the last @ char is the decider.
                        var auth, atSign;
                        if (hostEnd === -1) // atSign can be anywhere.
                        atSign = rest.lastIndexOf("@");
                        else // atSign must be in auth portion.
                        // http://a@b/c@d => host:b auth:a path:/c@d
                        atSign = rest.lastIndexOf("@", hostEnd);
                        // Now we have a portion which is definitely the auth.
                        // Pull that off.
                        if (atSign !== -1) {
                            auth = rest.slice(0, atSign);
                            rest = rest.slice(atSign + 1);
                            this.auth = decodeURIComponent(auth);
                        }
                        // the host is the remaining to the left of the first non-host char
                        hostEnd = -1;
                        for(var i = 0; i < nonHostChars.length; i++){
                            var hec = rest.indexOf(nonHostChars[i]);
                            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
                        }
                        // if we still have not hit it, then the entire thing is a host.
                        if (hostEnd === -1) hostEnd = rest.length;
                        this.host = rest.slice(0, hostEnd);
                        rest = rest.slice(hostEnd);
                        // pull out port.
                        this.parseHost();
                        // we've indicated that there is a hostname,
                        // so even if it's empty, it has to be present.
                        this.hostname = this.hostname || "";
                        // if hostname begins with [ and ends with ]
                        // assume that it's an IPv6 address.
                        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
                        // validate a little.
                        if (!ipv6Hostname) {
                            var hostparts = this.hostname.split(/\./);
                            for(var i = 0, l = hostparts.length; i < l; i++){
                                var part = hostparts[i];
                                if (!part) continue;
                                if (!part.match(hostnamePartPattern)) {
                                    var newpart = "";
                                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                                    // we need this to make sure size of hostname is not
                                    // broken by replacing non-ASCII by nothing
                                    newpart += "x";
                                    else newpart += part[j];
                                    // we test again with ASCII char only
                                    if (!newpart.match(hostnamePartPattern)) {
                                        var validParts = hostparts.slice(0, i);
                                        var notHost = hostparts.slice(i + 1);
                                        var bit = part.match(hostnamePartStart);
                                        if (bit) {
                                            validParts.push(bit[1]);
                                            notHost.unshift(bit[2]);
                                        }
                                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                                        this.hostname = validParts.join(".");
                                        break;
                                    }
                                }
                            }
                        }
                        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
                        else // hostnames are always lower case.
                        this.hostname = this.hostname.toLowerCase();
                        if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
                        // It only converts parts of the domain name that
                        // have non-ASCII characters, i.e. it doesn't matter if
                        // you call it with a domain that already is ASCII-only.
                        this.hostname = punycode.toASCII(this.hostname);
                        var p = this.port ? ":" + this.port : "";
                        var h = this.hostname || "";
                        this.host = h + p;
                        this.href += this.host;
                        // strip [ and ] from the hostname
                        // the host field still retains them, though
                        if (ipv6Hostname) {
                            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
                            if (rest[0] !== "/") rest = "/" + rest;
                        }
                    }
                    // now rest is set to the post-host stuff.
                    // chop off any delim chars.
                    if (!unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
                    // escaped, even if encodeURIComponent doesn't think they
                    // need to be.
                    for(var i = 0, l = autoEscape.length; i < l; i++){
                        var ae = autoEscape[i];
                        if (rest.indexOf(ae) === -1) continue;
                        var esc = encodeURIComponent(ae);
                        if (esc === ae) esc = escape(ae);
                        rest = rest.split(ae).join(esc);
                    }
                    // chop off from the tail first.
                    var hash = rest.indexOf("#");
                    if (hash !== -1) {
                        // got a fragment string.
                        this.hash = rest.substr(hash);
                        rest = rest.slice(0, hash);
                    }
                    var qm = rest.indexOf("?");
                    if (qm !== -1) {
                        this.search = rest.substr(qm);
                        this.query = rest.substr(qm + 1);
                        if (parseQueryString) this.query = querystring.parse(this.query);
                        rest = rest.slice(0, qm);
                    } else if (parseQueryString) {
                        // no query string, but parseQueryString still requested
                        this.search = "";
                        this.query = {};
                    }
                    if (rest) this.pathname = rest;
                    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
                    //to support http.request
                    if (this.pathname || this.search) {
                        var p = this.pathname || "";
                        var s = this.search || "";
                        this.path = p + s;
                    }
                    // finally, reconstruct the href based on what has been validated.
                    this.href = this.format();
                    return this;
                };
                // format a parsed object into a url string
                function urlFormat(obj) {
                    // ensure it's an object, and not a string url.
                    // If it's an obj, this is a no-op.
                    // this way, you can call url_format() on strings
                    // to clean up potentially wonky urls.
                    if (util.isString(obj)) obj = urlParse(obj);
                    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
                    return obj.format();
                }
                Url.prototype.format = function() {
                    var auth = this.auth || "";
                    if (auth) {
                        auth = encodeURIComponent(auth);
                        auth = auth.replace(/%3A/i, ":");
                        auth += "@";
                    }
                    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
                    if (this.host) host = auth + this.host;
                    else if (this.hostname) {
                        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
                        if (this.port) host += ":" + this.port;
                    }
                    if (this.query && util.isObject(this.query) && Object.keys(this.query).length) query = querystring.stringify(this.query);
                    var search = this.search || query && "?" + query || "";
                    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
                    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
                    // unless they had them to begin with.
                    if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
                        host = "//" + (host || "");
                        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
                    } else if (!host) host = "";
                    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
                    if (search && search.charAt(0) !== "?") search = "?" + search;
                    pathname = pathname.replace(/[?#]/g, function(match) {
                        return encodeURIComponent(match);
                    });
                    search = search.replace("#", "%23");
                    return protocol + host + pathname + search + hash;
                };
                function urlResolve(source, relative) {
                    return urlParse(source, false, true).resolve(relative);
                }
                Url.prototype.resolve = function(relative) {
                    return this.resolveObject(urlParse(relative, false, true)).format();
                };
                function urlResolveObject(source, relative) {
                    if (!source) return relative;
                    return urlParse(source, false, true).resolveObject(relative);
                }
                Url.prototype.resolveObject = function(relative) {
                    if (util.isString(relative)) {
                        var rel = new Url();
                        rel.parse(relative, false, true);
                        relative = rel;
                    }
                    var result = new Url();
                    var tkeys = Object.keys(this);
                    for(var tk = 0; tk < tkeys.length; tk++){
                        var tkey = tkeys[tk];
                        result[tkey] = this[tkey];
                    }
                    // hash is always overridden, no matter what.
                    // even href="" will remove it.
                    result.hash = relative.hash;
                    // if the relative url is empty, then there's nothing left to do here.
                    if (relative.href === "") {
                        result.href = result.format();
                        return result;
                    }
                    // hrefs like //foo/bar always cut to the protocol.
                    if (relative.slashes && !relative.protocol) {
                        // take everything except the protocol from relative
                        var rkeys = Object.keys(relative);
                        for(var rk = 0; rk < rkeys.length; rk++){
                            var rkey = rkeys[rk];
                            if (rkey !== "protocol") result[rkey] = relative[rkey];
                        }
                        //urlParse appends trailing / to urls like http://www.example.com
                        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = "/";
                        result.href = result.format();
                        return result;
                    }
                    if (relative.protocol && relative.protocol !== result.protocol) {
                        // if it's a known url protocol, then changing
                        // the protocol does weird things
                        // first, if it's not file:, then we MUST have a host,
                        // and if there was a path
                        // to begin with, then we MUST have a path.
                        // if it is file:, then the host is dropped,
                        // because that's known to be hostless.
                        // anything else is assumed to be absolute.
                        if (!slashedProtocol[relative.protocol]) {
                            var keys = Object.keys(relative);
                            for(var v = 0; v < keys.length; v++){
                                var k = keys[v];
                                result[k] = relative[k];
                            }
                            result.href = result.format();
                            return result;
                        }
                        result.protocol = relative.protocol;
                        if (!relative.host && !hostlessProtocol[relative.protocol]) {
                            var relPath = (relative.pathname || "").split("/");
                            while(relPath.length && !(relative.host = relPath.shift()));
                            if (!relative.host) relative.host = "";
                            if (!relative.hostname) relative.hostname = "";
                            if (relPath[0] !== "") relPath.unshift("");
                            if (relPath.length < 2) relPath.unshift("");
                            result.pathname = relPath.join("/");
                        } else result.pathname = relative.pathname;
                        result.search = relative.search;
                        result.query = relative.query;
                        result.host = relative.host || "";
                        result.auth = relative.auth;
                        result.hostname = relative.hostname || relative.host;
                        result.port = relative.port;
                        // to support http.request
                        if (result.pathname || result.search) {
                            var p = result.pathname || "";
                            var s = result.search || "";
                            result.path = p + s;
                        }
                        result.slashes = result.slashes || relative.slashes;
                        result.href = result.format();
                        return result;
                    }
                    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
                    // if the url is a non-slashed url, then relative
                    // links like ../.. should be able
                    // to crawl up to the hostname, as well.  This is strange.
                    // result.protocol has already been set by now.
                    // Later on, put the first path part into the host field.
                    if (psychotic) {
                        result.hostname = "";
                        result.port = null;
                        if (result.host) {
                            if (srcPath[0] === "") srcPath[0] = result.host;
                            else srcPath.unshift(result.host);
                        }
                        result.host = "";
                        if (relative.protocol) {
                            relative.hostname = null;
                            relative.port = null;
                            if (relative.host) {
                                if (relPath[0] === "") relPath[0] = relative.host;
                                else relPath.unshift(relative.host);
                            }
                            relative.host = null;
                        }
                        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
                    }
                    if (isRelAbs) {
                        // it's absolute.
                        result.host = relative.host || relative.host === "" ? relative.host : result.host;
                        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
                        result.search = relative.search;
                        result.query = relative.query;
                        srcPath = relPath;
                    // fall through to the dot-handling below.
                    } else if (relPath.length) {
                        // it's relative
                        // throw away the existing file, and take the new path instead.
                        if (!srcPath) srcPath = [];
                        srcPath.pop();
                        srcPath = srcPath.concat(relPath);
                        result.search = relative.search;
                        result.query = relative.query;
                    } else if (!util.isNullOrUndefined(relative.search)) {
                        // just pull out the search.
                        // like href='?foo'.
                        // Put this after the other two cases because it simplifies the booleans
                        if (psychotic) {
                            result.hostname = result.host = srcPath.shift();
                            //occationaly the auth can get stuck only in host
                            //this especially happens in cases like
                            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
                            var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
                            if (authInHost) {
                                result.auth = authInHost.shift();
                                result.host = result.hostname = authInHost.shift();
                            }
                        }
                        result.search = relative.search;
                        result.query = relative.query;
                        //to support http.request
                        if (!util.isNull(result.pathname) || !util.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
                        result.href = result.format();
                        return result;
                    }
                    if (!srcPath.length) {
                        // no path at all.  easy.
                        // we've already handled the other stuff above.
                        result.pathname = null;
                        //to support http.request
                        if (result.search) result.path = "/" + result.search;
                        else result.path = null;
                        result.href = result.format();
                        return result;
                    }
                    // if a url ENDs in . or .., then it must get a trailing slash.
                    // however, if it ends in anything else non-slashy,
                    // then it must NOT get a trailing slash.
                    var last = srcPath.slice(-1)[0];
                    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
                    // strip single dots, resolve double dots to parent dir
                    // if the path tries to go above the root, `up` ends up > 0
                    var up = 0;
                    for(var i = srcPath.length; i >= 0; i--){
                        last = srcPath[i];
                        if (last === ".") srcPath.splice(i, 1);
                        else if (last === "..") {
                            srcPath.splice(i, 1);
                            up++;
                        } else if (up) {
                            srcPath.splice(i, 1);
                            up--;
                        }
                    }
                    // if the path is allowed to go above the root, restore leading ..s
                    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
                    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
                    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
                    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
                    // put the host back
                    if (psychotic) {
                        result.hostname = result.host = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
                        //occationaly the auth can get stuck only in host
                        //this especially happens in cases like
                        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
                        var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
                        if (authInHost) {
                            result.auth = authInHost.shift();
                            result.host = result.hostname = authInHost.shift();
                        }
                    }
                    mustEndAbs = mustEndAbs || result.host && srcPath.length;
                    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
                    if (!srcPath.length) {
                        result.pathname = null;
                        result.path = null;
                    } else result.pathname = srcPath.join("/");
                    //to support request.http
                    if (!util.isNull(result.pathname) || !util.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
                    result.auth = relative.auth || result.auth;
                    result.slashes = result.slashes || relative.slashes;
                    result.href = result.format();
                    return result;
                };
                Url.prototype.parseHost = function() {
                    var host = this.host;
                    var port = portPattern.exec(host);
                    if (port) {
                        port = port[0];
                        if (port !== ":") this.port = port.substr(1);
                        host = host.substr(0, host.length - port.length);
                    }
                    if (host) this.hostname = host;
                };
            /***/ },
            /***/ 2502: /***/ (module1)=>{
                "use strict";
                module1.exports = {
                    isString: function(arg) {
                        return typeof arg === "string";
                    },
                    isObject: function(arg) {
                        return typeof arg === "object" && arg !== null;
                    },
                    isNull: function(arg) {
                        return arg === null;
                    },
                    isNullOrUndefined: function(arg) {
                        return arg == null;
                    }
                };
            /***/ },
            /***/ 8416: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                module1.exports = __webpack_require__(41);
            /***/ },
            /***/ 6347: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                var settle = __webpack_require__(8762);
                var cookies = __webpack_require__(6164);
                var buildURL = __webpack_require__(51);
                var buildFullPath = __webpack_require__(6672);
                var parseHeaders = __webpack_require__(9942);
                var isURLSameOrigin = __webpack_require__(3789);
                var createError = __webpack_require__(2604);
                module1.exports = function xhrAdapter(config) {
                    return new Promise(function dispatchXhrRequest(resolve, reject) {
                        var requestData = config.data;
                        var requestHeaders = config.headers;
                        if (utils.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
                        var request = new XMLHttpRequest();
                        // HTTP basic authentication
                        if (config.auth) {
                            var username = config.auth.username || "";
                            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
                            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
                        }
                        var fullPath = buildFullPath(config.baseURL, config.url);
                        request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
                        // Set the request timeout in MS
                        request.timeout = config.timeout;
                        // Listen for ready state
                        request.onreadystatechange = function handleLoad() {
                            if (!request || request.readyState !== 4) return;
                            // The request errored out and we didn't get a response, this will be
                            // handled by onerror instead
                            // With one exception: request that using file: protocol, most browsers
                            // will return status as 0 even though it's a successful request
                            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
                            // Prepare the response
                            var responseHeaders = "getAllResponseHeaders" in request ? parseHeaders(request.getAllResponseHeaders()) : null;
                            var responseData = !config.responseType || config.responseType === "text" ? request.responseText : request.response;
                            var response = {
                                data: responseData,
                                status: request.status,
                                statusText: request.statusText,
                                headers: responseHeaders,
                                config: config,
                                request: request
                            };
                            settle(resolve, reject, response);
                            // Clean up request
                            request = null;
                        };
                        // Handle browser request cancellation (as opposed to a manual cancellation)
                        request.onabort = function handleAbort() {
                            if (!request) return;
                            reject(createError("Request aborted", config, "ECONNABORTED", request));
                            // Clean up request
                            request = null;
                        };
                        // Handle low level network errors
                        request.onerror = function handleError() {
                            // Real errors are hidden from us by the browser
                            // onerror should only fire if it's a network error
                            reject(createError("Network Error", config, null, request));
                            // Clean up request
                            request = null;
                        };
                        // Handle timeout
                        request.ontimeout = function handleTimeout() {
                            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
                            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
                            reject(createError(timeoutErrorMessage, config, "ECONNABORTED", request));
                            // Clean up request
                            request = null;
                        };
                        // Add xsrf header
                        // This is only done if running in a standard browser environment.
                        // Specifically not if we're in a web worker, or react-native.
                        if (utils.isStandardBrowserEnv()) {
                            // Add xsrf header
                            var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
                            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
                        }
                        // Add headers to the request
                        if ("setRequestHeader" in request) utils.forEach(requestHeaders, function setRequestHeader(val, key) {
                            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
                            delete requestHeaders[key];
                            else // Otherwise add header to the request
                            request.setRequestHeader(key, val);
                        });
                        // Add withCredentials to request if needed
                        if (!utils.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
                        // Add responseType to request if needed
                        if (config.responseType) try {
                            request.responseType = config.responseType;
                        } catch (e) {
                            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
                            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
                            if (config.responseType !== "json") throw e;
                        }
                        // Handle progress if needed
                        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
                        // Not all browsers support upload events
                        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
                        if (config.cancelToken) // Handle cancellation
                        config.cancelToken.promise.then(function onCanceled(cancel) {
                            if (!request) return;
                            request.abort();
                            reject(cancel);
                            // Clean up request
                            request = null;
                        });
                        if (!requestData) requestData = null;
                        // Send the request
                        request.send(requestData);
                    });
                };
            /***/ },
            /***/ 41: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                var bind = __webpack_require__(1330);
                var Axios = __webpack_require__(2819);
                var mergeConfig = __webpack_require__(7711);
                var defaults = __webpack_require__(6450);
                /**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
                    var context = new Axios(defaultConfig);
                    var instance = bind(Axios.prototype.request, context);
                    // Copy axios.prototype to instance
                    utils.extend(instance, Axios.prototype, context);
                    // Copy context to instance
                    utils.extend(instance, context);
                    return instance;
                }
                // Create the default instance to be exported
                var axios = createInstance(defaults);
                // Expose Axios class to allow class inheritance
                axios.Axios = Axios;
                // Factory for creating new instances
                axios.create = function create(instanceConfig) {
                    return createInstance(mergeConfig(axios.defaults, instanceConfig));
                };
                // Expose Cancel & CancelToken
                axios.Cancel = __webpack_require__(7623);
                axios.CancelToken = __webpack_require__(3803);
                axios.isCancel = __webpack_require__(9328);
                // Expose all/spread
                axios.all = function all(promises) {
                    return Promise.all(promises);
                };
                axios.spread = __webpack_require__(348);
                // Expose isAxiosError
                axios.isAxiosError = __webpack_require__(839);
                module1.exports = axios;
                // Allow use of default import syntax in TypeScript
                module1.exports.default = axios;
            /***/ },
            /***/ 7623: /***/ (module1)=>{
                "use strict";
                /**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function Cancel(message) {
                    this.message = message;
                }
                Cancel.prototype.toString = function toString() {
                    return "Cancel" + (this.message ? ": " + this.message : "");
                };
                Cancel.prototype.__CANCEL__ = true;
                module1.exports = Cancel;
            /***/ },
            /***/ 3803: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var Cancel = __webpack_require__(7623);
                /**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function CancelToken(executor) {
                    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
                    var resolvePromise;
                    this.promise = new Promise(function promiseExecutor(resolve) {
                        resolvePromise = resolve;
                    });
                    var token = this;
                    executor(function cancel(message) {
                        if (token.reason) // Cancellation has already been requested
                        return;
                        token.reason = new Cancel(message);
                        resolvePromise(token.reason);
                    });
                }
                /**
 * Throws a `Cancel` if cancellation has been requested.
 */ CancelToken.prototype.throwIfRequested = function throwIfRequested() {
                    if (this.reason) throw this.reason;
                };
                /**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ CancelToken.source = function source() {
                    var cancel;
                    var token = new CancelToken(function executor(c) {
                        cancel = c;
                    });
                    return {
                        token: token,
                        cancel: cancel
                    };
                };
                module1.exports = CancelToken;
            /***/ },
            /***/ 9328: /***/ (module1)=>{
                "use strict";
                module1.exports = function isCancel(value) {
                    return !!(value && value.__CANCEL__);
                };
            /***/ },
            /***/ 2819: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                var buildURL = __webpack_require__(51);
                var InterceptorManager = __webpack_require__(3973);
                var dispatchRequest = __webpack_require__(1639);
                var mergeConfig = __webpack_require__(7711);
                /**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function Axios(instanceConfig) {
                    this.defaults = instanceConfig;
                    this.interceptors = {
                        request: new InterceptorManager(),
                        response: new InterceptorManager()
                    };
                }
                /**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ Axios.prototype.request = function request(config) {
                    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
                    if (typeof config === "string") {
                        config = arguments[1] || {};
                        config.url = arguments[0];
                    } else config = config || {};
                    config = mergeConfig(this.defaults, config);
                    // Set config.method
                    if (config.method) config.method = config.method.toLowerCase();
                    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
                    else config.method = "get";
                    // Hook up interceptors middleware
                    var chain = [
                        dispatchRequest,
                        undefined
                    ];
                    var promise = Promise.resolve(config);
                    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
                        chain.unshift(interceptor.fulfilled, interceptor.rejected);
                    });
                    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
                        chain.push(interceptor.fulfilled, interceptor.rejected);
                    });
                    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
                    return promise;
                };
                Axios.prototype.getUri = function getUri(config) {
                    config = mergeConfig(this.defaults, config);
                    return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
                };
                // Provide aliases for supported request methods
                utils.forEach([
                    "delete",
                    "get",
                    "head",
                    "options"
                ], function forEachMethodNoData(method) {
                    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
                        return this.request(mergeConfig(config || {}, {
                            method: method,
                            url: url,
                            data: (config || {}).data
                        }));
                    };
                });
                utils.forEach([
                    "post",
                    "put",
                    "patch"
                ], function forEachMethodWithData(method) {
                    /*eslint func-names:0*/ Axios.prototype[method] = function(url, data, config) {
                        return this.request(mergeConfig(config || {}, {
                            method: method,
                            url: url,
                            data: data
                        }));
                    };
                });
                module1.exports = Axios;
            /***/ },
            /***/ 3973: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                function InterceptorManager() {
                    this.handlers = [];
                }
                /**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ InterceptorManager.prototype.use = function use(fulfilled, rejected) {
                    this.handlers.push({
                        fulfilled: fulfilled,
                        rejected: rejected
                    });
                    return this.handlers.length - 1;
                };
                /**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ InterceptorManager.prototype.eject = function eject(id) {
                    if (this.handlers[id]) this.handlers[id] = null;
                };
                /**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ InterceptorManager.prototype.forEach = function forEach(fn) {
                    utils.forEach(this.handlers, function forEachHandler(h) {
                        if (h !== null) fn(h);
                    });
                };
                module1.exports = InterceptorManager;
            /***/ },
            /***/ 6672: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var isAbsoluteURL = __webpack_require__(1275);
                var combineURLs = __webpack_require__(2345);
                /**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module1.exports = function buildFullPath(baseURL, requestedURL) {
                    if (baseURL && !isAbsoluteURL(requestedURL)) return combineURLs(baseURL, requestedURL);
                    return requestedURL;
                };
            /***/ },
            /***/ 2604: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var enhanceError = __webpack_require__(5898);
                /**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module1.exports = function createError(message, config, code, request, response) {
                    var error = new Error(message);
                    return enhanceError(error, config, code, request, response);
                };
            /***/ },
            /***/ 1639: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                var transformData = __webpack_require__(2244);
                var isCancel = __webpack_require__(9328);
                var defaults = __webpack_require__(6450);
                /**
 * Throws a `Cancel` if cancellation has been requested.
 */ function throwIfCancellationRequested(config) {
                    if (config.cancelToken) config.cancelToken.throwIfRequested();
                }
                /**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module1.exports = function dispatchRequest(config) {
                    throwIfCancellationRequested(config);
                    // Ensure headers exist
                    config.headers = config.headers || {};
                    // Transform request data
                    config.data = transformData(config.data, config.headers, config.transformRequest);
                    // Flatten headers
                    config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
                    utils.forEach([
                        "delete",
                        "get",
                        "head",
                        "post",
                        "put",
                        "patch",
                        "common"
                    ], function cleanHeaderConfig(method) {
                        delete config.headers[method];
                    });
                    var adapter = config.adapter || defaults.adapter;
                    return adapter(config).then(function onAdapterResolution(response) {
                        throwIfCancellationRequested(config);
                        // Transform response data
                        response.data = transformData(response.data, response.headers, config.transformResponse);
                        return response;
                    }, function onAdapterRejection(reason) {
                        if (!isCancel(reason)) {
                            throwIfCancellationRequested(config);
                            // Transform response data
                            if (reason && reason.response) reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
                        }
                        return Promise.reject(reason);
                    });
                };
            /***/ },
            /***/ 5898: /***/ (module1)=>{
                "use strict";
                /**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module1.exports = function enhanceError(error, config, code, request, response) {
                    error.config = config;
                    if (code) error.code = code;
                    error.request = request;
                    error.response = response;
                    error.isAxiosError = true;
                    error.toJSON = function toJSON() {
                        return {
                            // Standard
                            message: this.message,
                            name: this.name,
                            // Microsoft
                            description: this.description,
                            number: this.number,
                            // Mozilla
                            fileName: this.fileName,
                            lineNumber: this.lineNumber,
                            columnNumber: this.columnNumber,
                            stack: this.stack,
                            // Axios
                            config: this.config,
                            code: this.code
                        };
                    };
                    return error;
                };
            /***/ },
            /***/ 7711: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                /**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module1.exports = function mergeConfig(config1, config2) {
                    // eslint-disable-next-line no-param-reassign
                    config2 = config2 || {};
                    var config = {};
                    var valueFromConfig2Keys = [
                        "url",
                        "method",
                        "data"
                    ];
                    var mergeDeepPropertiesKeys = [
                        "headers",
                        "auth",
                        "proxy",
                        "params"
                    ];
                    var defaultToConfig2Keys = [
                        "baseURL",
                        "transformRequest",
                        "transformResponse",
                        "paramsSerializer",
                        "timeout",
                        "timeoutMessage",
                        "withCredentials",
                        "adapter",
                        "responseType",
                        "xsrfCookieName",
                        "xsrfHeaderName",
                        "onUploadProgress",
                        "onDownloadProgress",
                        "decompress",
                        "maxContentLength",
                        "maxBodyLength",
                        "maxRedirects",
                        "transport",
                        "httpAgent",
                        "httpsAgent",
                        "cancelToken",
                        "socketPath",
                        "responseEncoding"
                    ];
                    var directMergeKeys = [
                        "validateStatus"
                    ];
                    function getMergedValue(target, source) {
                        if (utils.isPlainObject(target) && utils.isPlainObject(source)) return utils.merge(target, source);
                        else if (utils.isPlainObject(source)) return utils.merge({}, source);
                        else if (utils.isArray(source)) return source.slice();
                        return source;
                    }
                    function mergeDeepProperties(prop) {
                        if (!utils.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
                        else if (!utils.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
                    }
                    utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
                        if (!utils.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
                    });
                    utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
                    utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
                        if (!utils.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
                        else if (!utils.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
                    });
                    utils.forEach(directMergeKeys, function merge(prop) {
                        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
                        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
                    });
                    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
                    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
                        return axiosKeys.indexOf(key) === -1;
                    });
                    utils.forEach(otherKeys, mergeDeepProperties);
                    return config;
                };
            /***/ },
            /***/ 8762: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var createError = __webpack_require__(2604);
                /**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module1.exports = function settle(resolve, reject, response) {
                    var validateStatus = response.config.validateStatus;
                    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
                    else reject(createError("Request failed with status code " + response.status, response.config, null, response.request, response));
                };
            /***/ },
            /***/ 2244: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                /**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module1.exports = function transformData(data, headers, fns) {
                    /*eslint no-param-reassign:0*/ utils.forEach(fns, function transform(fn) {
                        data = fn(data, headers);
                    });
                    return data;
                };
            /***/ },
            /***/ 6450: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                var normalizeHeaderName = __webpack_require__(2854);
                var DEFAULT_CONTENT_TYPE = {
                    "Content-Type": "application/x-www-form-urlencoded"
                };
                function setContentTypeIfUnset(headers, value) {
                    if (!utils.isUndefined(headers) && utils.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
                }
                function getDefaultAdapter() {
                    var adapter;
                    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
                    adapter = __webpack_require__(6347);
                    else if (typeof $hPtJY !== "undefined" && Object.prototype.toString.call($hPtJY) === "[object process]") // For node use HTTP adapter
                    adapter = __webpack_require__(6347);
                    return adapter;
                }
                var defaults = {
                    adapter: getDefaultAdapter(),
                    transformRequest: [
                        function transformRequest(data, headers) {
                            normalizeHeaderName(headers, "Accept");
                            normalizeHeaderName(headers, "Content-Type");
                            if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) return data;
                            if (utils.isArrayBufferView(data)) return data.buffer;
                            if (utils.isURLSearchParams(data)) {
                                setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                                return data.toString();
                            }
                            if (utils.isObject(data)) {
                                setContentTypeIfUnset(headers, "application/json;charset=utf-8");
                                return JSON.stringify(data);
                            }
                            return data;
                        }
                    ],
                    transformResponse: [
                        function transformResponse(data) {
                            /*eslint no-param-reassign:0*/ if (typeof data === "string") try {
                                data = JSON.parse(data);
                            } catch (e) {}
                            return data;
                        }
                    ],
                    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
                    xsrfCookieName: "XSRF-TOKEN",
                    xsrfHeaderName: "X-XSRF-TOKEN",
                    maxContentLength: -1,
                    maxBodyLength: -1,
                    validateStatus: function validateStatus(status) {
                        return status >= 200 && status < 300;
                    }
                };
                defaults.headers = {
                    common: {
                        "Accept": "application/json, text/plain, */*"
                    }
                };
                utils.forEach([
                    "delete",
                    "get",
                    "head"
                ], function forEachMethodNoData(method) {
                    defaults.headers[method] = {};
                });
                utils.forEach([
                    "post",
                    "put",
                    "patch"
                ], function forEachMethodWithData(method) {
                    defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
                });
                module1.exports = defaults;
            /***/ },
            /***/ 1330: /***/ (module1)=>{
                "use strict";
                module1.exports = function bind(fn, thisArg) {
                    return function wrap() {
                        var args = new Array(arguments.length);
                        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
                        return fn.apply(thisArg, args);
                    };
                };
            /***/ },
            /***/ 51: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                function encode(val) {
                    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
                }
                /**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module1.exports = function buildURL(url, params, paramsSerializer) {
                    /*eslint no-param-reassign:0*/ if (!params) return url;
                    var serializedParams;
                    if (paramsSerializer) serializedParams = paramsSerializer(params);
                    else if (utils.isURLSearchParams(params)) serializedParams = params.toString();
                    else {
                        var parts = [];
                        utils.forEach(params, function serialize(val, key) {
                            if (val === null || typeof val === "undefined") return;
                            if (utils.isArray(val)) key = key + "[]";
                            else val = [
                                val
                            ];
                            utils.forEach(val, function parseValue(v) {
                                if (utils.isDate(v)) v = v.toISOString();
                                else if (utils.isObject(v)) v = JSON.stringify(v);
                                parts.push(encode(key) + "=" + encode(v));
                            });
                        });
                        serializedParams = parts.join("&");
                    }
                    if (serializedParams) {
                        var hashmarkIndex = url.indexOf("#");
                        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
                        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
                    }
                    return url;
                };
            /***/ },
            /***/ 2345: /***/ (module1)=>{
                "use strict";
                /**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module1.exports = function combineURLs(baseURL, relativeURL) {
                    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
                };
            /***/ },
            /***/ 6164: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                module1.exports = utils.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
                function standardBrowserEnv() {
                    return {
                        write: function write(name1, value, expires, path, domain, secure) {
                            var cookie = [];
                            cookie.push(name1 + "=" + encodeURIComponent(value));
                            if (utils.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
                            if (utils.isString(path)) cookie.push("path=" + path);
                            if (utils.isString(domain)) cookie.push("domain=" + domain);
                            if (secure === true) cookie.push("secure");
                            document.cookie = cookie.join("; ");
                        },
                        read: function read(name1) {
                            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name1 + ")=([^;]*)"));
                            return match ? decodeURIComponent(match[3]) : null;
                        },
                        remove: function remove(name1) {
                            this.write(name1, "", Date.now() - 86400000);
                        }
                    };
                }() : // Non standard browser env (web workers, react-native) lack needed support.
                function nonStandardBrowserEnv() {
                    return {
                        write: function write() {},
                        read: function read() {
                            return null;
                        },
                        remove: function remove() {}
                    };
                }();
            /***/ },
            /***/ 1275: /***/ (module1)=>{
                "use strict";
                /**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module1.exports = function isAbsoluteURL(url) {
                    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
                    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
                    // by any combination of letters, digits, plus, period, or hyphen.
                    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
                };
            /***/ },
            /***/ 839: /***/ (module1)=>{
                "use strict";
                /**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module1.exports = function isAxiosError(payload) {
                    return typeof payload === "object" && payload.isAxiosError === true;
                };
            /***/ },
            /***/ 3789: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                module1.exports = utils.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
                // whether the request URL is of the same origin as current location.
                function standardBrowserEnv() {
                    var msie = /(msie|trident)/i.test(navigator.userAgent);
                    var urlParsingNode = document.createElement("a");
                    var originURL;
                    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
                        var href = url;
                        if (msie) {
                            // IE needs attribute set twice to normalize properties
                            urlParsingNode.setAttribute("href", href);
                            href = urlParsingNode.href;
                        }
                        urlParsingNode.setAttribute("href", href);
                        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
                        return {
                            href: urlParsingNode.href,
                            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
                            host: urlParsingNode.host,
                            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
                            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
                            hostname: urlParsingNode.hostname,
                            port: urlParsingNode.port,
                            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
                        };
                    }
                    originURL = resolveURL(window.location.href);
                    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
                        var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
                        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
                    };
                }() : // Non standard browser envs (web workers, react-native) lack needed support.
                function nonStandardBrowserEnv() {
                    return function isURLSameOrigin() {
                        return true;
                    };
                }();
            /***/ },
            /***/ 2854: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                module1.exports = function normalizeHeaderName(headers, normalizedName) {
                    utils.forEach(headers, function processHeader(value, name1) {
                        if (name1 !== normalizedName && name1.toUpperCase() === normalizedName.toUpperCase()) {
                            headers[normalizedName] = value;
                            delete headers[name1];
                        }
                    });
                };
            /***/ },
            /***/ 9942: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                // Headers whose duplicates are ignored by node
                // c.f. https://nodejs.org/api/http.html#http_message_headers
                var ignoreDuplicateOf = [
                    "age",
                    "authorization",
                    "content-length",
                    "content-type",
                    "etag",
                    "expires",
                    "from",
                    "host",
                    "if-modified-since",
                    "if-unmodified-since",
                    "last-modified",
                    "location",
                    "max-forwards",
                    "proxy-authorization",
                    "referer",
                    "retry-after",
                    "user-agent"
                ];
                /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module1.exports = function parseHeaders(headers) {
                    var parsed = {};
                    var key;
                    var val;
                    var i;
                    if (!headers) return parsed;
                    utils.forEach(headers.split("\n"), function parser(line) {
                        i = line.indexOf(":");
                        key = utils.trim(line.substr(0, i)).toLowerCase();
                        val = utils.trim(line.substr(i + 1));
                        if (key) {
                            if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) return;
                            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                                val
                            ]);
                            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
                        }
                    });
                    return parsed;
                };
            /***/ },
            /***/ 348: /***/ (module1)=>{
                "use strict";
                /**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module1.exports = function spread(callback) {
                    return function wrap(arr) {
                        return callback.apply(null, arr);
                    };
                };
            /***/ },
            /***/ 9053: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var bind = __webpack_require__(1330);
                /*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
                var toString = Object.prototype.toString;
                /**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function isArray(val) {
                    return toString.call(val) === "[object Array]";
                }
                /**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function isUndefined(val) {
                    return typeof val === "undefined";
                }
                /**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
                    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
                }
                /**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function isArrayBuffer(val) {
                    return toString.call(val) === "[object ArrayBuffer]";
                }
                /**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function isFormData(val) {
                    return typeof FormData !== "undefined" && val instanceof FormData;
                }
                /**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
                    var result;
                    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
                    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
                    return result;
                }
                /**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function isString(val) {
                    return typeof val === "string";
                }
                /**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function isNumber(val) {
                    return typeof val === "number";
                }
                /**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function isObject(val) {
                    return val !== null && typeof val === "object";
                }
                /**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function isPlainObject(val) {
                    if (toString.call(val) !== "[object Object]") return false;
                    var prototype = Object.getPrototypeOf(val);
                    return prototype === null || prototype === Object.prototype;
                }
                /**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function isDate(val) {
                    return toString.call(val) === "[object Date]";
                }
                /**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function isFile(val) {
                    return toString.call(val) === "[object File]";
                }
                /**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function isBlob(val) {
                    return toString.call(val) === "[object Blob]";
                }
                /**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function isFunction(val) {
                    return toString.call(val) === "[object Function]";
                }
                /**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function isStream(val) {
                    return isObject(val) && isFunction(val.pipe);
                }
                /**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function isURLSearchParams(val) {
                    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
                }
                /**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function trim(str) {
                    return str.replace(/^\s*/, "").replace(/\s*$/, "");
                }
                /**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function isStandardBrowserEnv() {
                    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
                    return typeof window !== "undefined" && typeof document !== "undefined";
                }
                /**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function forEach(obj, fn) {
                    // Don't bother if no value provided
                    if (obj === null || typeof obj === "undefined") return;
                    // Force an array if not already something iterable
                    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
                        obj
                    ];
                    if (isArray(obj)) // Iterate over array values
                    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
                    else {
                        // Iterate over object keys
                        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
                    }
                }
                /**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function merge() {
                    var result = {};
                    function assignValue(val, key) {
                        if (isPlainObject(result[key]) && isPlainObject(val)) result[key] = merge(result[key], val);
                        else if (isPlainObject(val)) result[key] = merge({}, val);
                        else if (isArray(val)) result[key] = val.slice();
                        else result[key] = val;
                    }
                    for(var i = 0, l = arguments.length; i < l; i++)forEach(arguments[i], assignValue);
                    return result;
                }
                /**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function extend(a, b, thisArg) {
                    forEach(b, function assignValue(val, key) {
                        if (thisArg && typeof val === "function") a[key] = bind(val, thisArg);
                        else a[key] = val;
                    });
                    return a;
                }
                /**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function stripBOM(content) {
                    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
                    return content;
                }
                module1.exports = {
                    isArray: isArray,
                    isArrayBuffer: isArrayBuffer,
                    isBuffer: isBuffer,
                    isFormData: isFormData,
                    isArrayBufferView: isArrayBufferView,
                    isString: isString,
                    isNumber: isNumber,
                    isObject: isObject,
                    isPlainObject: isPlainObject,
                    isUndefined: isUndefined,
                    isDate: isDate,
                    isFile: isFile,
                    isBlob: isBlob,
                    isFunction: isFunction,
                    isStream: isStream,
                    isURLSearchParams: isURLSearchParams,
                    isStandardBrowserEnv: isStandardBrowserEnv,
                    forEach: forEach,
                    merge: merge,
                    extend: extend,
                    trim: trim,
                    stripBOM: stripBOM
                };
            /***/ },
            /***/ 4491: /***/ function(module1, exports, __webpack_require__) {
                var __WEBPACK_AMD_DEFINE_RESULT__;
                (function(globalObject) {
                    "use strict";
                    /*
 *      bignumber.js v7.2.1
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2018 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
                    POWS_TEN = [
                        1,
                        10,
                        100,
                        1e3,
                        1e4,
                        1e5,
                        1e6,
                        1e7,
                        1e8,
                        1e9,
                        1e10,
                        1e11,
                        1e12,
                        1e13
                    ], SQRT_BASE = 1e7, // EDITABLE
                    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
                    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
                    MAX = 1E9; // 0 to MAX_INT32
                    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
                        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
                            constructor: BigNumber,
                            toString: null,
                            valueOf: null
                        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
                        // The default values below must be integers within the inclusive ranges stated.
                        // The values can also be changed at run-time using BigNumber.set.
                        // The maximum number of decimal places for operations involving division.
                        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
                        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
                        // UP         0 Away from zero.
                        // DOWN       1 Towards zero.
                        // CEIL       2 Towards +Infinity.
                        // FLOOR      3 Towards -Infinity.
                        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
                        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
                        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
                        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
                        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
                        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
                        // The exponent value at and beneath which toString returns exponential notation.
                        // Number type: -7
                        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
                        // Number type: 21
                        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
                        // The minimum exponent value, beneath which underflow to zero occurs.
                        // Number type: -324  (5e-324)
                        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
                        // Number type:  308  (1.7976931348623157e+308)
                        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
                        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
                        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
                        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
                        // The remainder (r) is calculated as: r = a - n * q.
                        //
                        // UP        0 The remainder is positive if the dividend is negative, else is negative.
                        // DOWN      1 The remainder has the same sign as the dividend.
                        //             This modulo mode is commonly known as 'truncated division' and is
                        //             equivalent to (a % n) in JavaScript.
                        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
                        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
                        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
                        //             The remainder is always positive.
                        //
                        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
                        // modes are commonly used for the modulus operation.
                        // Although the other rounding modes can also be used, they may not give useful results.
                        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
                        // If POW_PRECISION is 0, there will be unlimited significant digits.
                        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
                        FORMAT = {
                            decimalSeparator: ".",
                            groupSeparator: ",",
                            groupSize: 3,
                            secondaryGroupSize: 0,
                            fractionGroupSeparator: "\xa0",
                            fractionGroupSize: 0
                        }, // The alphabet used for base conversion.
                        // It must be at least 2 characters long, with no '.' or repeated character.
                        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
                        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
                        //------------------------------------------------------------------------------------------
                        // CONSTRUCTOR
                        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * n {number|string|BigNumber} A numeric value.
     * [b] {number} The base of n. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(n, b) {
                            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
                            // Enable constructor usage without new.
                            if (!(x instanceof BigNumber)) // Don't throw on constructor call without new (#81).
                            // '[BigNumber Error] Constructor call without new: {n}'
                            //throw Error(bignumberError + ' Constructor call without new: ' + n);
                            return new BigNumber(n, b);
                            if (b == null) {
                                // Duplicate.
                                if (n instanceof BigNumber) {
                                    x.s = n.s;
                                    x.e = n.e;
                                    x.c = (n = n.c) ? n.slice() : n;
                                    return;
                                }
                                isNum = typeof n == "number";
                                if (isNum && n * 0 == 0) {
                                    // Use `1 / n` to handle minus zero also.
                                    x.s = 1 / n < 0 ? (n = -n, -1) : 1;
                                    // Faster path for integers.
                                    if (n === ~~n) {
                                        for(e = 0, i = n; i >= 10; i /= 10, e++);
                                        x.e = e;
                                        x.c = [
                                            n
                                        ];
                                        return;
                                    }
                                    str = n + "";
                                } else {
                                    if (!isNumeric.test(str = n + "")) return parseNumeric(x, str, isNum);
                                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                                }
                                // Decimal point?
                                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                                // Exponential form?
                                if ((i = str.search(/e/i)) > 0) {
                                    // Determine exponent.
                                    if (e < 0) e = i;
                                    e += +str.slice(i + 1);
                                    str = str.substring(0, i);
                                } else if (e < 0) // Integer.
                                e = str.length;
                            } else {
                                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                                intCheck(b, 2, ALPHABET.length, "Base");
                                str = n + "";
                                // Allow exponential notation to be used with base 10 argument, while
                                // also rounding to DECIMAL_PLACES as with other bases.
                                if (b == 10) {
                                    x = new BigNumber(n instanceof BigNumber ? n : str);
                                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                                }
                                isNum = typeof n == "number";
                                if (isNum) {
                                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                                    if (n * 0 != 0) return parseNumeric(x, str, isNum, b);
                                    x.s = 1 / n < 0 ? (str = str.slice(1), -1) : 1;
                                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + n);
                                    // Prevent later check for length on converted number.
                                    isNum = false;
                                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                                alphabet = ALPHABET.slice(0, b);
                                e = i = 0;
                                // Check that str is a valid base b number.
                                // Don't use RegExp so alphabet can contain special characters.
                                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                                    if (c == ".") // If '.' is not the first character and it has not be found before.
                                    {
                                        if (i > e) {
                                            e = len;
                                            continue;
                                        }
                                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                                    {
                                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                                            caseChanged = true;
                                            i = -1;
                                            e = 0;
                                            continue;
                                        }
                                    }
                                    return parseNumeric(x, n + "", isNum, b);
                                }
                                str = convertBase(str, b, 10, x.s);
                                // Decimal point?
                                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                                else e = str.length;
                            }
                            // Determine leading zeros.
                            for(i = 0; str.charCodeAt(i) === 48; i++);
                            // Determine trailing zeros.
                            for(len = str.length; str.charCodeAt(--len) === 48;);
                            str = str.slice(i, ++len);
                            if (str) {
                                len -= i;
                                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                                if (isNum && BigNumber.DEBUG && len > 15 && (n > MAX_SAFE_INTEGER || n !== mathfloor(n))) throw Error(tooManyDigits + x.s * n);
                                e = e - i - 1;
                                // Overflow?
                                if (e > MAX_EXP) // Infinity.
                                x.c = x.e = null;
                                else if (e < MIN_EXP) // Zero.
                                x.c = [
                                    x.e = 0
                                ];
                                else {
                                    x.e = e;
                                    x.c = [];
                                    // Transform base
                                    // e is the base 10 exponent.
                                    // i is where to slice str to get the first element of the coefficient array.
                                    i = (e + 1) % LOG_BASE;
                                    if (e < 0) i += LOG_BASE;
                                    if (i < len) {
                                        if (i) x.c.push(+str.slice(0, i));
                                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                                        str = str.slice(i);
                                        i = LOG_BASE - str.length;
                                    } else i -= len;
                                    for(; i--; str += "0");
                                    x.c.push(+str);
                                }
                            } else // Zero.
                            x.c = [
                                x.e = 0
                            ];
                        }
                        // CONSTRUCTOR PROPERTIES
                        BigNumber.clone = clone;
                        BigNumber.ROUND_UP = 0;
                        BigNumber.ROUND_DOWN = 1;
                        BigNumber.ROUND_CEIL = 2;
                        BigNumber.ROUND_FLOOR = 3;
                        BigNumber.ROUND_HALF_UP = 4;
                        BigNumber.ROUND_HALF_DOWN = 5;
                        BigNumber.ROUND_HALF_EVEN = 6;
                        BigNumber.ROUND_HALF_CEIL = 7;
                        BigNumber.ROUND_HALF_FLOOR = 8;
                        BigNumber.EUCLID = 9;
                        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *      decimalSeparator       {string}
     *      groupSeparator         {string}
     *      groupSize              {number}
     *      secondaryGroupSize     {number}
     *      fractionGroupSeparator {string}
     *      fractionGroupSize      {number}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
                            var p, v;
                            if (obj != null) {
                                if (typeof obj == "object") {
                                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                                        v = obj[p];
                                        intCheck(v, 0, MAX, p);
                                        DECIMAL_PLACES = v;
                                    }
                                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                                        v = obj[p];
                                        intCheck(v, 0, 8, p);
                                        ROUNDING_MODE = v;
                                    }
                                    // EXPONENTIAL_AT {number|number[]}
                                    // Integer, -MAX to MAX inclusive or
                                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                                        v = obj[p];
                                        if (isArray(v)) {
                                            intCheck(v[0], -MAX, 0, p);
                                            intCheck(v[1], 0, MAX, p);
                                            TO_EXP_NEG = v[0];
                                            TO_EXP_POS = v[1];
                                        } else {
                                            intCheck(v, -MAX, MAX, p);
                                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                                        }
                                    }
                                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                                    if (obj.hasOwnProperty(p = "RANGE")) {
                                        v = obj[p];
                                        if (isArray(v)) {
                                            intCheck(v[0], -MAX, -1, p);
                                            intCheck(v[1], 1, MAX, p);
                                            MIN_EXP = v[0];
                                            MAX_EXP = v[1];
                                        } else {
                                            intCheck(v, -MAX, MAX, p);
                                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                                        }
                                    }
                                    // CRYPTO {boolean} true or false.
                                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                                    // '[BigNumber Error] crypto unavailable'
                                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                                        v = obj[p];
                                        if (v === !!v) {
                                            if (v) {
                                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                                else {
                                                    CRYPTO = !v;
                                                    throw Error(bignumberError + "crypto unavailable");
                                                }
                                            } else CRYPTO = v;
                                        } else throw Error(bignumberError + p + " not true or false: " + v);
                                    }
                                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                                        v = obj[p];
                                        intCheck(v, 0, 9, p);
                                        MODULO_MODE = v;
                                    }
                                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                                        v = obj[p];
                                        intCheck(v, 0, MAX, p);
                                        POW_PRECISION = v;
                                    }
                                    // FORMAT {object}
                                    // '[BigNumber Error] FORMAT not an object: {v}'
                                    if (obj.hasOwnProperty(p = "FORMAT")) {
                                        v = obj[p];
                                        if (typeof v == "object") FORMAT = v;
                                        else throw Error(bignumberError + p + " not an object: " + v);
                                    }
                                    // ALPHABET {string}
                                    // '[BigNumber Error] ALPHABET invalid: {v}'
                                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                                        v = obj[p];
                                        // Disallow if only one character, or contains '.' or a repeated character.
                                        if (typeof v == "string" && !/^.$|\.|(.).*\1/.test(v)) ALPHABET = v;
                                        else throw Error(bignumberError + p + " invalid: " + v);
                                    }
                                } else // '[BigNumber Error] Object expected: {v}'
                                throw Error(bignumberError + "Object expected: " + obj);
                            }
                            return {
                                DECIMAL_PLACES: DECIMAL_PLACES,
                                ROUNDING_MODE: ROUNDING_MODE,
                                EXPONENTIAL_AT: [
                                    TO_EXP_NEG,
                                    TO_EXP_POS
                                ],
                                RANGE: [
                                    MIN_EXP,
                                    MAX_EXP
                                ],
                                CRYPTO: CRYPTO,
                                MODULO_MODE: MODULO_MODE,
                                POW_PRECISION: POW_PRECISION,
                                FORMAT: FORMAT,
                                ALPHABET: ALPHABET
                            };
                        };
                        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * v {any}
     */ BigNumber.isBigNumber = function(v) {
                            return v instanceof BigNumber || v && v._isBigNumber === true || false;
                        };
                        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
                            return maxOrMin(arguments, P.lt);
                        };
                        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
                            return maxOrMin(arguments, P.gt);
                        };
                        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
                            var pow2_53 = 0x20000000000000;
                            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
                            // Check if Math.random() produces more than 32 bits of randomness.
                            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
                            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
                            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                                return mathfloor(Math.random() * pow2_53);
                            } : function() {
                                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
                            };
                            return function(dp) {
                                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                                if (dp == null) dp = DECIMAL_PLACES;
                                else intCheck(dp, 0, MAX);
                                k = mathceil(dp / LOG_BASE);
                                if (CRYPTO) {
                                    // Browsers supporting crypto.getRandomValues.
                                    if (crypto.getRandomValues) {
                                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                                        for(; i < k;){
                                            // 53 bits:
                                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                                            //                                     11111 11111111 11111111
                                            // 0x20000 is 2^21.
                                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                                            // Rejection sampling:
                                            // 0 <= v < 9007199254740992
                                            // Probability that v >= 9e15, is
                                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                                            if (v >= 9e15) {
                                                b = crypto.getRandomValues(new Uint32Array(2));
                                                a[i] = b[0];
                                                a[i + 1] = b[1];
                                            } else {
                                                // 0 <= v <= 8999999999999999
                                                // 0 <= (v % 1e14) <= 99999999999999
                                                c.push(v % 1e14);
                                                i += 2;
                                            }
                                        }
                                        i = k / 2;
                                    // Node.js supporting crypto.randomBytes.
                                    } else if (crypto.randomBytes) {
                                        // buffer
                                        a = crypto.randomBytes(k *= 7);
                                        for(; i < k;){
                                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                                            // 0 <= v < 9007199254740992
                                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                                            else {
                                                // 0 <= (v % 1e14) <= 99999999999999
                                                c.push(v % 1e14);
                                                i += 7;
                                            }
                                        }
                                        i = k / 7;
                                    } else {
                                        CRYPTO = false;
                                        throw Error(bignumberError + "crypto unavailable");
                                    }
                                }
                                // Use Math.random.
                                if (!CRYPTO) for(; i < k;){
                                    v = random53bitInt();
                                    if (v < 9e15) c[i++] = v % 1e14;
                                }
                                k = c[--i];
                                dp %= LOG_BASE;
                                // Convert trailing digits to zeros according to dp.
                                if (k && dp) {
                                    v = POWS_TEN[LOG_BASE - dp];
                                    c[i] = mathfloor(k / v) * v;
                                }
                                // Remove trailing elements which are zero.
                                for(; c[i] === 0; c.pop(), i--);
                                // Zero?
                                if (i < 0) c = [
                                    e = 0
                                ];
                                else {
                                    // Remove leading elements which are zero and adjust exponent accordingly.
                                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                                    // Count the digits of the first element of c to determine leading zeros, and...
                                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                                    // adjust the exponent accordingly.
                                    if (i < LOG_BASE) e -= LOG_BASE - i;
                                }
                                rand.e = e;
                                rand.c = c;
                                return rand;
                            };
                        }();
                        // PRIVATE FUNCTIONS
                        // Called by BigNumber and BigNumber.prototype.toString.
                        convertBase = function() {
                            var decimal = "0123456789";
                            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                                var j, arr = [
                                    0
                                ], arrL, i = 0, len = str.length;
                                for(; i < len;){
                                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                                    arr[0] += alphabet.indexOf(str.charAt(i++));
                                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                                        if (arr[j + 1] == null) arr[j + 1] = 0;
                                        arr[j + 1] += arr[j] / baseOut | 0;
                                        arr[j] %= baseOut;
                                    }
                                }
                                return arr.reverse();
                            }
                            // Convert a numeric string of baseIn to a numeric string of baseOut.
                            // If the caller is toString, we are converting from base 10 to baseOut.
                            // If the caller is BigNumber, we are converting from baseIn to base 10.
                            return function(str, baseIn, baseOut, sign, callerIsToString) {
                                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                                // Non-integer.
                                if (i >= 0) {
                                    k = POW_PRECISION;
                                    // Unlimited precision.
                                    POW_PRECISION = 0;
                                    str = str.replace(".", "");
                                    y = new BigNumber(baseIn);
                                    x = y.pow(str.length - i);
                                    POW_PRECISION = k;
                                    // Convert str as if an integer, then restore the fraction part by dividing the
                                    // result by its base raised to a power.
                                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                                    y.e = y.c.length;
                                }
                                // Convert the number as integer.
                                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                                e = k = xc.length;
                                // Remove trailing zeros.
                                for(; xc[--k] == 0; xc.pop());
                                // Zero?
                                if (!xc[0]) return alphabet.charAt(0);
                                // Does str represent an integer? If so, no need for the division.
                                if (i < 0) --e;
                                else {
                                    x.c = xc;
                                    x.e = e;
                                    // The sign is needed for correct rounding.
                                    x.s = sign;
                                    x = div(x, y, dp, rm, baseOut);
                                    xc = x.c;
                                    r = x.r;
                                    e = x.e;
                                }
                                // xc now represents str converted to baseOut.
                                // THe index of the rounding digit.
                                d = e + dp + 1;
                                // The rounding digit: the digit to the right of the digit that may be rounded up.
                                i = xc[d];
                                // Look at the rounding digits and mode to determine whether to round up.
                                k = baseOut / 2;
                                r = r || d < 0 || xc[d + 1] != null;
                                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                                // If the index of the rounding digit is not greater than zero, or xc represents
                                // zero, then the result of the base conversion is zero or, if rounding up, a value
                                // such as 0.00001.
                                if (d < 1 || !xc[0]) // 1^-dp or 0
                                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                                else {
                                    // Truncate xc to the required number of decimal places.
                                    xc.length = d;
                                    // Round up?
                                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                                    for(--baseOut; ++xc[--d] > baseOut;){
                                        xc[d] = 0;
                                        if (!d) {
                                            ++e;
                                            xc = [
                                                1
                                            ].concat(xc);
                                        }
                                    }
                                    // Determine trailing zeros.
                                    for(k = xc.length; !xc[--k];);
                                    // E.g. [4, 11, 15] becomes 4bf.
                                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                                    // Add leading zeros, decimal point and trailing zeros as required.
                                    str = toFixedPoint(str, e, alphabet.charAt(0));
                                }
                                // The caller will add the sign.
                                return str;
                            };
                        }();
                        // Perform division in the specified base. Called by div and convertBase.
                        div = function() {
                            // Assume non-zero x and k.
                            function multiply(x, k, base) {
                                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                                for(x = x.slice(); i--;){
                                    xlo = x[i] % SQRT_BASE;
                                    xhi = x[i] / SQRT_BASE | 0;
                                    m = khi * xlo + xhi * klo;
                                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                                    x[i] = temp % base;
                                }
                                if (carry) x = [
                                    carry
                                ].concat(x);
                                return x;
                            }
                            function compare(a, b, aL, bL) {
                                var i, cmp;
                                if (aL != bL) cmp = aL > bL ? 1 : -1;
                                else {
                                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                                        cmp = a[i] > b[i] ? 1 : -1;
                                        break;
                                    }
                                }
                                return cmp;
                            }
                            function subtract(a, b, aL, base) {
                                var i = 0;
                                // Subtract b from a.
                                for(; aL--;){
                                    a[aL] -= i;
                                    i = a[aL] < b[aL] ? 1 : 0;
                                    a[aL] = i * base + a[aL] - b[aL];
                                }
                                // Remove leading zeros.
                                for(; !a[0] && a.length > 1; a.splice(0, 1));
                            }
                            // x: dividend, y: divisor.
                            return function(x, y, dp, rm, base) {
                                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                                // Either NaN, Infinity or 0?
                                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                                q = new BigNumber(s);
                                qc = q.c = [];
                                e = x.e - y.e;
                                s = dp + e + 1;
                                if (!base) {
                                    base = BASE;
                                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                                    s = s / LOG_BASE | 0;
                                }
                                // Result exponent may be one less then the current value of e.
                                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                                for(i = 0; yc[i] == (xc[i] || 0); i++);
                                if (yc[i] > (xc[i] || 0)) e--;
                                if (s < 0) {
                                    qc.push(1);
                                    more = true;
                                } else {
                                    xL = xc.length;
                                    yL = yc.length;
                                    i = 0;
                                    s += 2;
                                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                                    n = mathfloor(base / (yc[0] + 1));
                                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                                    if (n > 1) {
                                        yc = multiply(yc, n, base);
                                        xc = multiply(xc, n, base);
                                        yL = yc.length;
                                        xL = xc.length;
                                    }
                                    xi = yL;
                                    rem = xc.slice(0, yL);
                                    remL = rem.length;
                                    // Add zeros to make remainder as long as divisor.
                                    for(; remL < yL; rem[remL++] = 0);
                                    yz = yc.slice();
                                    yz = [
                                        0
                                    ].concat(yz);
                                    yc0 = yc[0];
                                    if (yc[1] >= base / 2) yc0++;
                                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                                    do {
                                        n = 0;
                                        // Compare divisor and remainder.
                                        cmp = compare(yc, rem, yL, remL);
                                        // If divisor < remainder.
                                        if (cmp < 0) {
                                            // Calculate trial digit, n.
                                            rem0 = rem[0];
                                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                                            // n is how many times the divisor goes into the current remainder.
                                            n = mathfloor(rem0 / yc0);
                                            //  Algorithm:
                                            //  product = divisor multiplied by trial digit (n).
                                            //  Compare product and remainder.
                                            //  If product is greater than remainder:
                                            //    Subtract divisor from product, decrement trial digit.
                                            //  Subtract product from remainder.
                                            //  If product was less than remainder at the last compare:
                                            //    Compare new remainder and divisor.
                                            //    If remainder is greater than divisor:
                                            //      Subtract divisor from remainder, increment trial digit.
                                            if (n > 1) {
                                                // n may be > base only when base is 3.
                                                if (n >= base) n = base - 1;
                                                // product = divisor * trial digit.
                                                prod = multiply(yc, n, base);
                                                prodL = prod.length;
                                                remL = rem.length;
                                                // Compare product and remainder.
                                                // If product > remainder then trial digit n too high.
                                                // n is 1 too high about 5% of the time, and is not known to have
                                                // ever been more than 1 too high.
                                                while(compare(prod, rem, prodL, remL) == 1){
                                                    n--;
                                                    // Subtract divisor from product.
                                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                                    prodL = prod.length;
                                                    cmp = 1;
                                                }
                                            } else {
                                                // n is 0 or 1, cmp is -1.
                                                // If n is 0, there is no need to compare yc and rem again below,
                                                // so change cmp to 1 to avoid it.
                                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                                cmp = n = 1;
                                                // product = divisor
                                                prod = yc.slice();
                                                prodL = prod.length;
                                            }
                                            if (prodL < remL) prod = [
                                                0
                                            ].concat(prod);
                                            // Subtract product from remainder.
                                            subtract(rem, prod, remL, base);
                                            remL = rem.length;
                                            // If product was < remainder.
                                            if (cmp == -1) // Compare divisor and new remainder.
                                            // If divisor < new remainder, subtract divisor from remainder.
                                            // Trial digit n too low.
                                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                                            while(compare(yc, rem, yL, remL) < 1){
                                                n++;
                                                // Subtract divisor from remainder.
                                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                                remL = rem.length;
                                            }
                                        } else if (cmp === 0) {
                                            n++;
                                            rem = [
                                                0
                                            ];
                                        } // else cmp === 1 and n will be 0
                                        // Add the next digit, n, to the result array.
                                        qc[i++] = n;
                                        // Update the remainder.
                                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                                        else {
                                            rem = [
                                                xc[xi]
                                            ];
                                            remL = 1;
                                        }
                                    }while ((xi++ < xL || rem[0] != null) && s--);
                                    more = rem[0] != null;
                                    // Leading zero?
                                    if (!qc[0]) qc.splice(0, 1);
                                }
                                if (base == BASE) {
                                    // To calculate q.e, first get the number of digits of qc[0].
                                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                                // Caller is convertBase.
                                } else {
                                    q.e = e;
                                    q.r = +more;
                                }
                                return q;
                            };
                        }();
                        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
                            var c0, e, ne, len, str;
                            if (rm == null) rm = ROUNDING_MODE;
                            else intCheck(rm, 0, 8);
                            if (!n.c) return n.toString();
                            c0 = n.c[0];
                            ne = n.e;
                            if (i == null) {
                                str = coeffToString(n.c);
                                str = id == 1 || id == 2 && ne <= TO_EXP_NEG ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
                            } else {
                                n = round(new BigNumber(n), i, rm);
                                // n.e may have changed if the value was rounded up.
                                e = n.e;
                                str = coeffToString(n.c);
                                len = str.length;
                                // toPrecision returns exponential notation if the number of significant digits
                                // specified is less than the number of digits necessary to represent the integer
                                // part of the value in fixed-point notation.
                                // Exponential notation.
                                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                                    // Append zeros?
                                    for(; len < i; str += "0", len++);
                                    str = toExponential(str, e);
                                // Fixed-point notation.
                                } else {
                                    i -= ne;
                                    str = toFixedPoint(str, e, "0");
                                    // Append zeros?
                                    if (e + 1 > len) {
                                        if (--i > 0) for(str += "."; i--; str += "0");
                                    } else {
                                        i += e - len;
                                        if (i > 0) {
                                            if (e + 1 == len) str += ".";
                                            for(; i--; str += "0");
                                        }
                                    }
                                }
                            }
                            return n.s < 0 && c0 ? "-" + str : str;
                        }
                        // Handle BigNumber.max and BigNumber.min.
                        function maxOrMin(args, method) {
                            var m, n, i = 0;
                            if (isArray(args[0])) args = args[0];
                            m = new BigNumber(args[0]);
                            for(; ++i < args.length;){
                                n = new BigNumber(args[i]);
                                // If any number is NaN, return NaN.
                                if (!n.s) {
                                    m = n;
                                    break;
                                } else if (method.call(m, n)) m = n;
                            }
                            return m;
                        }
                        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
                            var i = 1, j = c.length;
                            // Remove trailing zeros.
                            for(; !c[--j]; c.pop());
                            // Calculate the base 10 exponent. First get the number of digits of c[0].
                            for(j = c[0]; j >= 10; j /= 10, i++);
                            // Overflow?
                            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
                            n.c = n.e = null;
                            else if (e < MIN_EXP) // Zero.
                            n.c = [
                                n.e = 0
                            ];
                            else {
                                n.e = e;
                                n.c = c;
                            }
                            return n;
                        }
                        // Handle values that fail the validity test in BigNumber.
                        parseNumeric = function() {
                            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
                            return function(x, str, isNum, b) {
                                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                                // No exception on ±Infinity or NaN.
                                if (isInfinityOrNaN.test(s)) {
                                    x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                                    x.c = x.e = null;
                                } else {
                                    if (!isNum) {
                                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                                        s = s.replace(basePrefix, function(m, p1, p2) {
                                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                                            return !b || b == base ? p1 : m;
                                        });
                                        if (b) {
                                            base = b;
                                            // E.g. '1.' to '1', '.1' to '0.1'
                                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                                        }
                                        if (str != s) return new BigNumber(s, base);
                                    }
                                    // '[BigNumber Error] Not a number: {n}'
                                    // '[BigNumber Error] Not a base {b} number: {n}'
                                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                                    // NaN
                                    x.c = x.e = x.s = null;
                                }
                            };
                        }();
                        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
                            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
                            // if x is not Infinity or NaN...
                            if (xc) {
                                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                                // ni is the index of n within x.c.
                                // d is the number of digits of n.
                                // i is the index of rd within n including leading zeros.
                                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                                out: {
                                    // Get the number of digits of the first element of xc.
                                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                                    i = sd - d;
                                    // If the rounding digit is in the first element of xc...
                                    if (i < 0) {
                                        i += LOG_BASE;
                                        j = sd;
                                        n = xc[ni = 0];
                                        // Get the rounding digit at index j of n.
                                        rd = n / pows10[d - j - 1] % 10 | 0;
                                    } else {
                                        ni = mathceil((i + 1) / LOG_BASE);
                                        if (ni >= xc.length) {
                                            if (r) {
                                                // Needed by sqrt.
                                                for(; xc.length <= ni; xc.push(0));
                                                n = rd = 0;
                                                d = 1;
                                                i %= LOG_BASE;
                                                j = i - LOG_BASE + 1;
                                            } else break out;
                                        } else {
                                            n = k = xc[ni];
                                            // Get the number of digits of n.
                                            for(d = 1; k >= 10; k /= 10, d++);
                                            // Get the index of rd within n.
                                            i %= LOG_BASE;
                                            // Get the index of rd within n, adjusted for leading zeros.
                                            // The number of leading zeros of n is given by LOG_BASE - d.
                                            j = i - LOG_BASE + d;
                                            // Get the rounding digit at index j of n.
                                            rd = j < 0 ? 0 : n / pows10[d - j - 1] % 10 | 0;
                                        }
                                    }
                                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                                    if (sd < 1 || !xc[0]) {
                                        xc.length = 0;
                                        if (r) {
                                            // Convert sd to decimal places.
                                            sd -= x.e + 1;
                                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                                            x.e = -sd || 0;
                                        } else // Zero.
                                        xc[0] = x.e = 0;
                                        return x;
                                    }
                                    // Remove excess digits.
                                    if (i == 0) {
                                        xc.length = ni;
                                        k = 1;
                                        ni--;
                                    } else {
                                        xc.length = ni + 1;
                                        k = pows10[LOG_BASE - i];
                                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                                        // j > 0 means i > number of leading zeros of n.
                                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                                    }
                                    // Round up?
                                    if (r) {
                                        for(;;)// If the digit to be rounded up is in the first element of xc...
                                        if (ni == 0) {
                                            // i will be the length of xc[0] before k is added.
                                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                                            j = xc[0] += k;
                                            for(k = 1; j >= 10; j /= 10, k++);
                                            // if i != k the length has increased.
                                            if (i != k) {
                                                x.e++;
                                                if (xc[0] == BASE) xc[0] = 1;
                                            }
                                            break;
                                        } else {
                                            xc[ni] += k;
                                            if (xc[ni] != BASE) break;
                                            xc[ni--] = 0;
                                            k = 1;
                                        }
                                    }
                                    // Remove trailing zeros.
                                    for(i = xc.length; xc[--i] === 0; xc.pop());
                                }
                                // Overflow? Infinity.
                                if (x.e > MAX_EXP) x.c = x.e = null;
                                else if (x.e < MIN_EXP) x.c = [
                                    x.e = 0
                                ];
                            }
                            return x;
                        }
                        // PROTOTYPE/INSTANCE METHODS
                        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
                            var x = new BigNumber(this);
                            if (x.s < 0) x.s = 1;
                            return x;
                        };
                        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
                            return compare(this, new BigNumber(y, b));
                        };
                        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
                            var c, n, v, x = this;
                            if (dp != null) {
                                intCheck(dp, 0, MAX);
                                if (rm == null) rm = ROUNDING_MODE;
                                else intCheck(rm, 0, 8);
                                return round(new BigNumber(x), dp + x.e + 1, rm);
                            }
                            if (!(c = x.c)) return null;
                            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
                            // Subtract the number of trailing zeros of the last number.
                            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
                            if (n < 0) n = 0;
                            return n;
                        };
                        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
                            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
                        };
                        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
                            return div(this, new BigNumber(y, b), 0, 1);
                        };
                        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
                            var half, isModExp, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
                            n = new BigNumber(n);
                            // Allow NaN and ±Infinity, but not other non-integers.
                            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + n);
                            if (m != null) m = new BigNumber(m);
                            // Exponent of MAX_SAFE_INTEGER is 15.
                            nIsBig = n.e > 14;
                            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
                            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                                // The sign of the result of pow when x is negative depends on the evenness of n.
                                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                                y = new BigNumber(Math.pow(+x.valueOf(), nIsBig ? 2 - isOdd(n) : +n));
                                return m ? y.mod(m) : y;
                            }
                            nIsNeg = n.s < 0;
                            if (m) {
                                // x % m returns NaN if abs(m) is zero, or m is NaN.
                                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                                if (isModExp) x = x.mod(m);
                            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
                            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
                            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                                // If x is negative and n is odd, k = -0, else k = 0.
                                k = x.s < 0 && isOdd(n) ? -0 : 0;
                                // If x >= 1, k = ±Infinity.
                                if (x.e > -1) k = 1 / k;
                                // If n is negative return ±0, else return ±Infinity.
                                return new BigNumber(nIsNeg ? 1 / k : k);
                            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
                            // equates to truncating significant digits to POW_PRECISION + [28, 41],
                            // i.e. there will be a minimum of 28 guard digits retained.
                            k = mathceil(POW_PRECISION / LOG_BASE + 2);
                            if (nIsBig) {
                                half = new BigNumber(0.5);
                                nIsOdd = isOdd(n);
                            } else nIsOdd = n % 2;
                            if (nIsNeg) n.s = 1;
                            y = new BigNumber(ONE);
                            // Performs 54 loop iterations for n of 9007199254740991.
                            for(;;){
                                if (nIsOdd) {
                                    y = y.times(x);
                                    if (!y.c) break;
                                    if (k) {
                                        if (y.c.length > k) y.c.length = k;
                                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                                }
                                if (nIsBig) {
                                    n = n.times(half);
                                    round(n, n.e + 1, 1);
                                    if (!n.c[0]) break;
                                    nIsBig = n.e > 14;
                                    nIsOdd = isOdd(n);
                                } else {
                                    n = mathfloor(n / 2);
                                    if (!n) break;
                                    nIsOdd = n % 2;
                                }
                                x = x.times(x);
                                if (k) {
                                    if (x.c && x.c.length > k) x.c.length = k;
                                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
                            }
                            if (isModExp) return y;
                            if (nIsNeg) y = ONE.div(y);
                            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
                        };
                        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
                            var n = new BigNumber(this);
                            if (rm == null) rm = ROUNDING_MODE;
                            else intCheck(rm, 0, 8);
                            return round(n, n.e + 1, rm);
                        };
                        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
                            return compare(this, new BigNumber(y, b)) === 0;
                        };
                        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
                            return !!this.c;
                        };
                        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
                            return compare(this, new BigNumber(y, b)) > 0;
                        };
                        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
                            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
                        };
                        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
                            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
                        };
                        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
                            return compare(this, new BigNumber(y, b)) < 0;
                        };
                        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
                            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
                        };
                        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
                            return !this.s;
                        };
                        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
                            return this.s < 0;
                        };
                        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
                            return this.s > 0;
                        };
                        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
                            return !!this.c && this.c[0] == 0;
                        };
                        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
                            var i, j, t, xLTy, x = this, a = x.s;
                            y = new BigNumber(y, b);
                            b = y.s;
                            // Either NaN?
                            if (!a || !b) return new BigNumber(NaN);
                            // Signs differ?
                            if (a != b) {
                                y.s = -b;
                                return x.plus(y);
                            }
                            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
                            if (!xe || !ye) {
                                // Either Infinity?
                                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                                // Either zero?
                                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                                ROUNDING_MODE == 3 ? -0 : 0);
                            }
                            xe = bitFloor(xe);
                            ye = bitFloor(ye);
                            xc = xc.slice();
                            // Determine which is the bigger number.
                            if (a = xe - ye) {
                                if (xLTy = a < 0) {
                                    a = -a;
                                    t = xc;
                                } else {
                                    ye = xe;
                                    t = yc;
                                }
                                t.reverse();
                                // Prepend zeros to equalise exponents.
                                for(b = a; b--; t.push(0));
                                t.reverse();
                            } else {
                                // Exponents equal. Check digit by digit.
                                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                                    xLTy = xc[b] < yc[b];
                                    break;
                                }
                            }
                            // x < y? Point xc to the array of the bigger number.
                            if (xLTy) t = xc, xc = yc, yc = t, y.s = -y.s;
                            b = (j = yc.length) - (i = xc.length);
                            // Append zeros to xc if shorter.
                            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
                            if (b > 0) for(; b--; xc[i++] = 0);
                            b = BASE - 1;
                            // Subtract yc from xc.
                            for(; j > a;){
                                if (xc[--j] < yc[j]) {
                                    for(i = j; i && !xc[--i]; xc[i] = b);
                                    --xc[i];
                                    xc[j] += BASE;
                                }
                                xc[j] -= yc[j];
                            }
                            // Remove leading zeros and adjust exponent accordingly.
                            for(; xc[0] == 0; xc.splice(0, 1), --ye);
                            // Zero?
                            if (!xc[0]) {
                                // Following IEEE 754 (2008) 6.3,
                                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                                y.c = [
                                    y.e = 0
                                ];
                                return y;
                            }
                            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
                            // for finite x and y.
                            return normalise(y, xc, ye);
                        };
                        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
                            var q, s, x = this;
                            y = new BigNumber(y, b);
                            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
                            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
                            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
                            if (MODULO_MODE == 9) {
                                // Euclidian division: q = sign(y) * floor(x / abs(y))
                                // r = x - qy    where  0 <= r < abs(y)
                                s = y.s;
                                y.s = 1;
                                q = div(x, y, 0, 3);
                                y.s = s;
                                q.s *= s;
                            } else q = div(x, y, 0, MODULO_MODE);
                            y = x.minus(q.times(y));
                            // To match JavaScript %, ensure sign of zero is sign of dividend.
                            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
                            return y;
                        };
                        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
                            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
                            // Either NaN, ±Infinity or ±0?
                            if (!xc || !yc || !xc[0] || !yc[0]) {
                                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                                else {
                                    y.s *= x.s;
                                    // Return ±Infinity if either is ±Infinity.
                                    if (!xc || !yc) y.c = y.e = null;
                                    else {
                                        y.c = [
                                            0
                                        ];
                                        y.e = 0;
                                    }
                                }
                                return y;
                            }
                            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
                            y.s *= x.s;
                            xcL = xc.length;
                            ycL = yc.length;
                            // Ensure xc points to longer array and xcL to its length.
                            if (xcL < ycL) zc = xc, xc = yc, yc = zc, i = xcL, xcL = ycL, ycL = i;
                            // Initialise the result array with zeros.
                            for(i = xcL + ycL, zc = []; i--; zc.push(0));
                            base = BASE;
                            sqrtBase = SQRT_BASE;
                            for(i = ycL; --i >= 0;){
                                c = 0;
                                ylo = yc[i] % sqrtBase;
                                yhi = yc[i] / sqrtBase | 0;
                                for(k = xcL, j = i + k; j > i;){
                                    xlo = xc[--k] % sqrtBase;
                                    xhi = xc[k] / sqrtBase | 0;
                                    m = yhi * xlo + xhi * ylo;
                                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                                    zc[j--] = xlo % base;
                                }
                                zc[j] = c;
                            }
                            if (c) ++e;
                            else zc.splice(0, 1);
                            return normalise(y, zc, e);
                        };
                        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
                            var x = new BigNumber(this);
                            x.s = -x.s || null;
                            return x;
                        };
                        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
                            var t, x = this, a = x.s;
                            y = new BigNumber(y, b);
                            b = y.s;
                            // Either NaN?
                            if (!a || !b) return new BigNumber(NaN);
                            // Signs differ?
                            if (a != b) {
                                y.s = -b;
                                return x.minus(y);
                            }
                            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
                            if (!xe || !ye) {
                                // Return ±Infinity if either ±Infinity.
                                if (!xc || !yc) return new BigNumber(a / 0);
                                // Either zero?
                                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
                            }
                            xe = bitFloor(xe);
                            ye = bitFloor(ye);
                            xc = xc.slice();
                            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
                            if (a = xe - ye) {
                                if (a > 0) {
                                    ye = xe;
                                    t = yc;
                                } else {
                                    a = -a;
                                    t = xc;
                                }
                                t.reverse();
                                for(; a--; t.push(0));
                                t.reverse();
                            }
                            a = xc.length;
                            b = yc.length;
                            // Point xc to the longer array, and b to the shorter length.
                            if (a - b < 0) t = yc, yc = xc, xc = t, b = a;
                            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
                            for(a = 0; b;){
                                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
                            }
                            if (a) {
                                xc = [
                                    a
                                ].concat(xc);
                                ++ye;
                            }
                            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
                            // ye = MAX_EXP + 1 possible
                            return normalise(y, xc, ye);
                        };
                        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
                            var c, n, v, x = this;
                            if (sd != null && sd !== !!sd) {
                                intCheck(sd, 1, MAX);
                                if (rm == null) rm = ROUNDING_MODE;
                                else intCheck(rm, 0, 8);
                                return round(new BigNumber(x), sd, rm);
                            }
                            if (!(c = x.c)) return null;
                            v = c.length - 1;
                            n = v * LOG_BASE + 1;
                            if (v = c[v]) {
                                // Subtract the number of trailing zeros of the last element.
                                for(; v % 10 == 0; v /= 10, n--);
                                // Add the number of digits of the first element.
                                for(v = c[0]; v >= 10; v /= 10, n++);
                            }
                            if (sd && x.e + 1 > n) n = x.e + 1;
                            return n;
                        };
                        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
                            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
                            return this.times("1e" + k);
                        };
                        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
                            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
                            // Negative/NaN/Infinity/zero?
                            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
                            // Initial estimate.
                            s = Math.sqrt(+x);
                            // Math.sqrt underflow/overflow?
                            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
                            if (s == 0 || s == 1 / 0) {
                                n = coeffToString(c);
                                if ((n.length + e) % 2 == 0) n += "0";
                                s = Math.sqrt(n);
                                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                                if (s == 1 / 0) n = "1e" + e;
                                else {
                                    n = s.toExponential();
                                    n = n.slice(0, n.indexOf("e") + 1) + e;
                                }
                                r = new BigNumber(n);
                            } else r = new BigNumber(s + "");
                            // Check for zero.
                            // r could be zero if MIN_EXP is changed after the this value was created.
                            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
                            // coeffToString to throw.
                            if (r.c[0]) {
                                e = r.e;
                                s = e + dp;
                                if (s < 3) s = 0;
                                // Newton-Raphson iteration.
                                for(;;){
                                    t = r;
                                    r = half.times(t.plus(div(x, t, dp, 1)));
                                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                                        // The exponent of r may here be one less than the final result exponent,
                                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                                        // are indexed correctly.
                                        if (r.e < e) --s;
                                        n = n.slice(s - 3, s + 1);
                                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                                        // iteration.
                                        if (n == "9999" || !rep && n == "4999") {
                                            // On the first iteration only, check to see if rounding up gives the
                                            // exact result as the nines may infinitely repeat.
                                            if (!rep) {
                                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                                if (t.times(t).eq(x)) {
                                                    r = t;
                                                    break;
                                                }
                                            }
                                            dp += 4;
                                            s += 4;
                                            rep = 1;
                                        } else {
                                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                                            // result. If not, then there are further digits and m will be truthy.
                                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                                // Truncate to the first rounding digit.
                                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                                m = !r.times(r).eq(x);
                                            }
                                            break;
                                        }
                                    }
                                }
                            }
                            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
                        };
                        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
                            if (dp != null) {
                                intCheck(dp, 0, MAX);
                                dp++;
                            }
                            return format(this, dp, rm, 1);
                        };
                        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
                            if (dp != null) {
                                intCheck(dp, 0, MAX);
                                dp = dp + this.e + 1;
                            }
                            return format(this, dp, rm);
                        };
                        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the FORMAT object (see BigNumber.set).
     *
     * FORMAT = {
     *      decimalSeparator : '.',
     *      groupSeparator : ',',
     *      groupSize : 3,
     *      secondaryGroupSize : 0,
     *      fractionGroupSeparator : '\xA0',    // non-breaking space
     *      fractionGroupSize : 0
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFormat = function(dp, rm) {
                            var str = this.toFixed(dp, rm);
                            if (this.c) {
                                var i, arr = str.split("."), g1 = +FORMAT.groupSize, g2 = +FORMAT.secondaryGroupSize, groupSeparator = FORMAT.groupSeparator, intPart = arr[0], fractionPart = arr[1], isNeg = this.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                                if (g2) i = g1, g1 = g2, g2 = i, len -= i;
                                if (g1 > 0 && len > 0) {
                                    i = len % g1 || g1;
                                    intPart = intDigits.substr(0, i);
                                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                                    if (isNeg) intPart = "-" + intPart;
                                }
                                str = fractionPart ? intPart + FORMAT.decimalSeparator + ((g2 = +FORMAT.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + FORMAT.fractionGroupSeparator) : fractionPart) : intPart;
                            }
                            return str;
                        };
                        /*
     * Return a string array representing the value of this BigNumber as a simple fraction with
     * an integer numerator and an integer denominator. The denominator will be a positive
     * non-zero value less than or equal to the specified maximum denominator. If a maximum
     * denominator is not specified, the denominator will be the lowest value necessary to
     * represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
                            var arr, d, d0, d1, d2, e, exp, n, n0, n1, q, s, x = this, xc = x.c;
                            if (md != null) {
                                n = new BigNumber(md);
                                // Throw if md is less than one or is not an integer, unless it is Infinity.
                                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + md);
                            }
                            if (!xc) return x.toString();
                            d = new BigNumber(ONE);
                            n1 = d0 = new BigNumber(ONE);
                            d1 = n0 = new BigNumber(ONE);
                            s = coeffToString(xc);
                            // Determine initial denominator.
                            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
                            e = d.e = s.length - x.e - 1;
                            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
                            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
                            exp = MAX_EXP;
                            MAX_EXP = 1 / 0;
                            n = new BigNumber(s);
                            // n0 = d1 = 0
                            n0.c[0] = 0;
                            for(;;){
                                q = div(n, d, 0, 1);
                                d2 = d0.plus(q.times(d1));
                                if (d2.comparedTo(md) == 1) break;
                                d0 = d1;
                                d1 = d2;
                                n1 = n0.plus(q.times(d2 = n1));
                                n0 = d2;
                                d = n.minus(q.times(d2 = d));
                                n = d2;
                            }
                            d2 = div(md.minus(d0), d1, 0, 1);
                            n0 = n0.plus(d2.times(n1));
                            d0 = d0.plus(d2.times(d1));
                            n0.s = n1.s = x.s;
                            e *= 2;
                            // Determine which fraction is closer to x, n0/d0 or n1/d1
                            arr = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                                n1.toString(),
                                d1.toString()
                            ] : [
                                n0.toString(),
                                d0.toString()
                            ];
                            MAX_EXP = exp;
                            return arr;
                        };
                        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
                            return +this;
                        };
                        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
                            if (sd != null) intCheck(sd, 1, MAX);
                            return format(this, sd, rm, 2);
                        };
                        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
                            var str, n = this, s = n.s, e = n.e;
                            // Infinity or NaN?
                            if (e === null) {
                                if (s) {
                                    str = "Infinity";
                                    if (s < 0) str = "-" + str;
                                } else str = "NaN";
                            } else {
                                str = coeffToString(n.c);
                                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
                                else {
                                    intCheck(b, 2, ALPHABET.length, "Base");
                                    str = convertBase(toFixedPoint(str, e, "0"), 10, b, s, true);
                                }
                                if (s < 0 && n.c[0]) str = "-" + str;
                            }
                            return str;
                        };
                        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
                            var str, n = this, e = n.e;
                            if (e === null) return n.toString();
                            str = coeffToString(n.c);
                            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
                            return n.s < 0 ? "-" + str : str;
                        };
                        P._isBigNumber = true;
                        if (configObject != null) BigNumber.set(configObject);
                        return BigNumber;
                    }
                    // PRIVATE HELPER FUNCTIONS
                    function bitFloor(n) {
                        var i = n | 0;
                        return n > 0 || n === i ? i : i - 1;
                    }
                    // Return a coefficient array as a string of base 10 digits.
                    function coeffToString(a) {
                        var s, z, i = 1, j = a.length, r = a[0] + "";
                        for(; i < j;){
                            s = a[i++] + "";
                            z = LOG_BASE - s.length;
                            for(; z--; s = "0" + s);
                            r += s;
                        }
                        // Determine trailing zeros.
                        for(j = r.length; r.charCodeAt(--j) === 48;);
                        return r.slice(0, j + 1 || 1);
                    }
                    // Compare the value of BigNumbers x and y.
                    function compare(x, y) {
                        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
                        // Either NaN?
                        if (!i || !j) return null;
                        a = xc && !xc[0];
                        b = yc && !yc[0];
                        // Either zero?
                        if (a || b) return a ? b ? 0 : -j : i;
                        // Signs differ?
                        if (i != j) return i;
                        a = i < 0;
                        b = k == l;
                        // Either Infinity?
                        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
                        // Compare exponents.
                        if (!b) return k > l ^ a ? 1 : -1;
                        j = (k = xc.length) < (l = yc.length) ? k : l;
                        // Compare digit by digit.
                        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
                        // Compare lengths.
                        return k == l ? 0 : k > l ^ a ? 1 : -1;
                    }
                    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name1) {
                        if (n < min || n > max || n !== (n < 0 ? mathceil(n) : mathfloor(n))) throw Error(bignumberError + (name1 || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + n);
                    }
                    function isArray(obj) {
                        return Object.prototype.toString.call(obj) == "[object Array]";
                    }
                    // Assumes finite n.
                    function isOdd(n) {
                        var k = n.c.length - 1;
                        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
                    }
                    function toExponential(str, e) {
                        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
                    }
                    function toFixedPoint(str, e, z) {
                        var len, zs;
                        // Negative exponent?
                        if (e < 0) {
                            // Prepend zeros.
                            for(zs = z + "."; ++e; zs += z);
                            str = zs + str;
                        // Positive exponent
                        } else {
                            len = str.length;
                            // Append zeros.
                            if (++e > len) {
                                for(zs = z, e -= len; --e; zs += z);
                                str += zs;
                            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
                        }
                        return str;
                    }
                    // EXPORT
                    BigNumber = clone();
                    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
                    __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                        return BigNumber;
                    }).call(exports, __webpack_require__, exports, module1), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__);
                })(this);
            /***/ },
            /***/ 7318: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                // Blake2B in pure Javascript
                // Adapted from the reference implementation in RFC7693
                // Ported to Javascript by DC - https://github.com/dcposch
                const util = __webpack_require__(1022);
                // 64-bit unsigned addition
                // Sets v[a,a+1] += v[b,b+1]
                // v should be a Uint32Array
                function ADD64AA(v, a, b) {
                    const o0 = v[a] + v[b];
                    let o1 = v[a + 1] + v[b + 1];
                    if (o0 >= 0x100000000) o1++;
                    v[a] = o0;
                    v[a + 1] = o1;
                }
                // 64-bit unsigned addition
                // Sets v[a,a+1] += b
                // b0 is the low 32 bits of b, b1 represents the high 32 bits
                function ADD64AC(v, a, b0, b1) {
                    let o0 = v[a] + b0;
                    if (b0 < 0) o0 += 0x100000000;
                    let o1 = v[a + 1] + b1;
                    if (o0 >= 0x100000000) o1++;
                    v[a] = o0;
                    v[a + 1] = o1;
                }
                // Little-endian byte access
                function B2B_GET32(arr, i) {
                    return arr[i] ^ arr[i + 1] << 8 ^ arr[i + 2] << 16 ^ arr[i + 3] << 24;
                }
                // G Mixing function
                // The ROTRs are inlined for speed
                function B2B_G(a, b, c, d, ix, iy) {
                    const x0 = m[ix];
                    const x1 = m[ix + 1];
                    const y0 = m[iy];
                    const y1 = m[iy + 1];
                    ADD64AA(v, a, b) // v[a,a+1] += v[b,b+1] ... in JS we must store a uint64 as two uint32s
                    ;
                    ADD64AC(v, a, x0, x1) // v[a, a+1] += x ... x0 is the low 32 bits of x, x1 is the high 32 bits
                    ;
                    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated to the right by 32 bits
                    let xor0 = v[d] ^ v[a];
                    let xor1 = v[d + 1] ^ v[a + 1];
                    v[d] = xor1;
                    v[d + 1] = xor0;
                    ADD64AA(v, c, d);
                    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 24 bits
                    xor0 = v[b] ^ v[c];
                    xor1 = v[b + 1] ^ v[c + 1];
                    v[b] = xor0 >>> 24 ^ xor1 << 8;
                    v[b + 1] = xor1 >>> 24 ^ xor0 << 8;
                    ADD64AA(v, a, b);
                    ADD64AC(v, a, y0, y1);
                    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated right by 16 bits
                    xor0 = v[d] ^ v[a];
                    xor1 = v[d + 1] ^ v[a + 1];
                    v[d] = xor0 >>> 16 ^ xor1 << 16;
                    v[d + 1] = xor1 >>> 16 ^ xor0 << 16;
                    ADD64AA(v, c, d);
                    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 63 bits
                    xor0 = v[b] ^ v[c];
                    xor1 = v[b + 1] ^ v[c + 1];
                    v[b] = xor1 >>> 31 ^ xor0 << 1;
                    v[b + 1] = xor0 >>> 31 ^ xor1 << 1;
                }
                // Initialization Vector
                const BLAKE2B_IV32 = new Uint32Array([
                    0xf3bcc908,
                    0x6a09e667,
                    0x84caa73b,
                    0xbb67ae85,
                    0xfe94f82b,
                    0x3c6ef372,
                    0x5f1d36f1,
                    0xa54ff53a,
                    0xade682d1,
                    0x510e527f,
                    0x2b3e6c1f,
                    0x9b05688c,
                    0xfb41bd6b,
                    0x1f83d9ab,
                    0x137e2179,
                    0x5be0cd19
                ]);
                const SIGMA8 = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    14,
                    10,
                    4,
                    8,
                    9,
                    15,
                    13,
                    6,
                    1,
                    12,
                    0,
                    2,
                    11,
                    7,
                    5,
                    3,
                    11,
                    8,
                    12,
                    0,
                    5,
                    2,
                    15,
                    13,
                    10,
                    14,
                    3,
                    6,
                    7,
                    1,
                    9,
                    4,
                    7,
                    9,
                    3,
                    1,
                    13,
                    12,
                    11,
                    14,
                    2,
                    6,
                    5,
                    10,
                    4,
                    0,
                    15,
                    8,
                    9,
                    0,
                    5,
                    7,
                    2,
                    4,
                    10,
                    15,
                    14,
                    1,
                    11,
                    12,
                    6,
                    8,
                    3,
                    13,
                    2,
                    12,
                    6,
                    10,
                    0,
                    11,
                    8,
                    3,
                    4,
                    13,
                    7,
                    5,
                    15,
                    14,
                    1,
                    9,
                    12,
                    5,
                    1,
                    15,
                    14,
                    13,
                    4,
                    10,
                    0,
                    7,
                    6,
                    3,
                    9,
                    2,
                    8,
                    11,
                    13,
                    11,
                    7,
                    14,
                    12,
                    1,
                    3,
                    9,
                    5,
                    0,
                    15,
                    4,
                    8,
                    6,
                    2,
                    10,
                    6,
                    15,
                    14,
                    9,
                    11,
                    3,
                    0,
                    8,
                    12,
                    2,
                    13,
                    7,
                    1,
                    4,
                    10,
                    5,
                    10,
                    2,
                    8,
                    4,
                    7,
                    6,
                    1,
                    5,
                    15,
                    11,
                    9,
                    14,
                    3,
                    12,
                    13,
                    0,
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    14,
                    10,
                    4,
                    8,
                    9,
                    15,
                    13,
                    6,
                    1,
                    12,
                    0,
                    2,
                    11,
                    7,
                    5,
                    3
                ];
                // These are offsets into a uint64 buffer.
                // Multiply them all by 2 to make them offsets into a uint32 buffer,
                // because this is Javascript and we don't have uint64s
                const SIGMA82 = new Uint8Array(SIGMA8.map(function(x) {
                    return x * 2;
                }));
                // Compression function. 'last' flag indicates last block.
                // Note we're representing 16 uint64s as 32 uint32s
                const v = new Uint32Array(32);
                const m = new Uint32Array(32);
                function blake2bCompress(ctx, last) {
                    let i = 0;
                    // init work variables
                    for(i = 0; i < 16; i++){
                        v[i] = ctx.h[i];
                        v[i + 16] = BLAKE2B_IV32[i];
                    }
                    // low 64 bits of offset
                    v[24] = v[24] ^ ctx.t;
                    v[25] = v[25] ^ ctx.t / 0x100000000;
                    // high 64 bits not supported, offset may not be higher than 2**53-1
                    // last block flag set ?
                    if (last) {
                        v[28] = ~v[28];
                        v[29] = ~v[29];
                    }
                    // get little-endian words
                    for(i = 0; i < 32; i++)m[i] = B2B_GET32(ctx.b, 4 * i);
                    // twelve rounds of mixing
                    // uncomment the DebugPrint calls to log the computation
                    // and match the RFC sample documentation
                    // util.debugPrint('          m[16]', m, 64)
                    for(i = 0; i < 12; i++){
                        // util.debugPrint('   (i=' + (i < 10 ? ' ' : '') + i + ') v[16]', v, 64)
                        B2B_G(0, 8, 16, 24, SIGMA82[i * 16 + 0], SIGMA82[i * 16 + 1]);
                        B2B_G(2, 10, 18, 26, SIGMA82[i * 16 + 2], SIGMA82[i * 16 + 3]);
                        B2B_G(4, 12, 20, 28, SIGMA82[i * 16 + 4], SIGMA82[i * 16 + 5]);
                        B2B_G(6, 14, 22, 30, SIGMA82[i * 16 + 6], SIGMA82[i * 16 + 7]);
                        B2B_G(0, 10, 20, 30, SIGMA82[i * 16 + 8], SIGMA82[i * 16 + 9]);
                        B2B_G(2, 12, 22, 24, SIGMA82[i * 16 + 10], SIGMA82[i * 16 + 11]);
                        B2B_G(4, 14, 16, 26, SIGMA82[i * 16 + 12], SIGMA82[i * 16 + 13]);
                        B2B_G(6, 8, 18, 28, SIGMA82[i * 16 + 14], SIGMA82[i * 16 + 15]);
                    }
                    // util.debugPrint('   (i=12) v[16]', v, 64)
                    for(i = 0; i < 16; i++)ctx.h[i] = ctx.h[i] ^ v[i] ^ v[i + 16];
                // util.debugPrint('h[8]', ctx.h, 64)
                }
                // Creates a BLAKE2b hashing context
                // Requires an output length between 1 and 64 bytes
                // Takes an optional Uint8Array key
                function blake2bInit(outlen, key) {
                    if (outlen === 0 || outlen > 64) throw new Error("Illegal output length, expected 0 < length <= 64");
                    if (key && key.length > 64) throw new Error("Illegal key, expected Uint8Array with 0 < length <= 64");
                    // state, 'param block'
                    const ctx = {
                        b: new Uint8Array(128),
                        h: new Uint32Array(16),
                        t: 0,
                        c: 0,
                        outlen: outlen // output length in bytes
                    };
                    // initialize hash state
                    for(let i = 0; i < 16; i++)ctx.h[i] = BLAKE2B_IV32[i];
                    const keylen = key ? key.length : 0;
                    ctx.h[0] ^= 0x01010000 ^ keylen << 8 ^ outlen;
                    // key the hash, if applicable
                    if (key) {
                        blake2bUpdate(ctx, key);
                        // at the end
                        ctx.c = 128;
                    }
                    return ctx;
                }
                // Updates a BLAKE2b streaming hash
                // Requires hash context and Uint8Array (byte array)
                function blake2bUpdate(ctx, input) {
                    for(let i = 0; i < input.length; i++){
                        if (ctx.c === 128) {
                            // buffer full ?
                            ctx.t += ctx.c // add counters
                            ;
                            blake2bCompress(ctx, false) // compress (not last)
                            ;
                            ctx.c = 0 // counter to zero
                            ;
                        }
                        ctx.b[ctx.c++] = input[i];
                    }
                }
                // Completes a BLAKE2b streaming hash
                // Returns a Uint8Array containing the message digest
                function blake2bFinal(ctx) {
                    ctx.t += ctx.c // mark last block offset
                    ;
                    while(ctx.c < 128)// fill up with zeros
                    ctx.b[ctx.c++] = 0;
                    blake2bCompress(ctx, true) // final block flag = 1
                    ;
                    // little endian convert and store
                    const out = new Uint8Array(ctx.outlen);
                    for(let i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3);
                    return out;
                }
                // Computes the BLAKE2B hash of a string or byte array, and returns a Uint8Array
                //
                // Returns a n-byte Uint8Array
                //
                // Parameters:
                // - input - the input bytes, as a string, Buffer or Uint8Array
                // - key - optional key Uint8Array, up to 64 bytes
                // - outlen - optional output length in bytes, default 64
                function blake2b(input, key, outlen) {
                    // preprocess inputs
                    outlen = outlen || 64;
                    input = util.normalizeInput(input);
                    // do the math
                    const ctx = blake2bInit(outlen, key);
                    blake2bUpdate(ctx, input);
                    return blake2bFinal(ctx);
                }
                // Computes the BLAKE2B hash of a string or byte array
                //
                // Returns an n-byte hash in hex, all lowercase
                //
                // Parameters:
                // - input - the input bytes, as a string, Buffer, or Uint8Array
                // - key - optional key Uint8Array, up to 64 bytes
                // - outlen - optional output length in bytes, default 64
                function blake2bHex(input, key, outlen) {
                    const output = blake2b(input, key, outlen);
                    return util.toHex(output);
                }
                module1.exports = {
                    blake2b: blake2b,
                    blake2bHex: blake2bHex,
                    blake2bInit: blake2bInit,
                    blake2bUpdate: blake2bUpdate,
                    blake2bFinal: blake2bFinal
                };
            /***/ },
            /***/ 8855: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                // BLAKE2s hash function in pure Javascript
                // Adapted from the reference implementation in RFC7693
                // Ported to Javascript by DC - https://github.com/dcposch
                const util = __webpack_require__(1022);
                // Little-endian byte access.
                // Expects a Uint8Array and an index
                // Returns the little-endian uint32 at v[i..i+3]
                function B2S_GET32(v, i) {
                    return v[i] ^ v[i + 1] << 8 ^ v[i + 2] << 16 ^ v[i + 3] << 24;
                }
                // Mixing function G.
                function B2S_G(a, b, c, d, x, y) {
                    v[a] = v[a] + v[b] + x;
                    v[d] = ROTR32(v[d] ^ v[a], 16);
                    v[c] = v[c] + v[d];
                    v[b] = ROTR32(v[b] ^ v[c], 12);
                    v[a] = v[a] + v[b] + y;
                    v[d] = ROTR32(v[d] ^ v[a], 8);
                    v[c] = v[c] + v[d];
                    v[b] = ROTR32(v[b] ^ v[c], 7);
                }
                // 32-bit right rotation
                // x should be a uint32
                // y must be between 1 and 31, inclusive
                function ROTR32(x, y) {
                    return x >>> y ^ x << 32 - y;
                }
                // Initialization Vector.
                const BLAKE2S_IV = new Uint32Array([
                    0x6a09e667,
                    0xbb67ae85,
                    0x3c6ef372,
                    0xa54ff53a,
                    0x510e527f,
                    0x9b05688c,
                    0x1f83d9ab,
                    0x5be0cd19
                ]);
                const SIGMA = new Uint8Array([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    14,
                    10,
                    4,
                    8,
                    9,
                    15,
                    13,
                    6,
                    1,
                    12,
                    0,
                    2,
                    11,
                    7,
                    5,
                    3,
                    11,
                    8,
                    12,
                    0,
                    5,
                    2,
                    15,
                    13,
                    10,
                    14,
                    3,
                    6,
                    7,
                    1,
                    9,
                    4,
                    7,
                    9,
                    3,
                    1,
                    13,
                    12,
                    11,
                    14,
                    2,
                    6,
                    5,
                    10,
                    4,
                    0,
                    15,
                    8,
                    9,
                    0,
                    5,
                    7,
                    2,
                    4,
                    10,
                    15,
                    14,
                    1,
                    11,
                    12,
                    6,
                    8,
                    3,
                    13,
                    2,
                    12,
                    6,
                    10,
                    0,
                    11,
                    8,
                    3,
                    4,
                    13,
                    7,
                    5,
                    15,
                    14,
                    1,
                    9,
                    12,
                    5,
                    1,
                    15,
                    14,
                    13,
                    4,
                    10,
                    0,
                    7,
                    6,
                    3,
                    9,
                    2,
                    8,
                    11,
                    13,
                    11,
                    7,
                    14,
                    12,
                    1,
                    3,
                    9,
                    5,
                    0,
                    15,
                    4,
                    8,
                    6,
                    2,
                    10,
                    6,
                    15,
                    14,
                    9,
                    11,
                    3,
                    0,
                    8,
                    12,
                    2,
                    13,
                    7,
                    1,
                    4,
                    10,
                    5,
                    10,
                    2,
                    8,
                    4,
                    7,
                    6,
                    1,
                    5,
                    15,
                    11,
                    9,
                    14,
                    3,
                    12,
                    13,
                    0
                ]);
                // Compression function. "last" flag indicates last block
                const v = new Uint32Array(16);
                const m = new Uint32Array(16);
                function blake2sCompress(ctx, last) {
                    let i = 0;
                    for(i = 0; i < 8; i++){
                        // init work variables
                        v[i] = ctx.h[i];
                        v[i + 8] = BLAKE2S_IV[i];
                    }
                    v[12] ^= ctx.t // low 32 bits of offset
                    ;
                    v[13] ^= ctx.t / 0x100000000 // high 32 bits
                    ;
                    if (last) // last block flag set ?
                    v[14] = ~v[14];
                    for(i = 0; i < 16; i++)// get little-endian words
                    m[i] = B2S_GET32(ctx.b, 4 * i);
                    // ten rounds of mixing
                    // uncomment the DebugPrint calls to log the computation
                    // and match the RFC sample documentation
                    // util.debugPrint('          m[16]', m, 32)
                    for(i = 0; i < 10; i++){
                        // util.debugPrint('   (i=' + i + ')  v[16]', v, 32)
                        B2S_G(0, 4, 8, 12, m[SIGMA[i * 16 + 0]], m[SIGMA[i * 16 + 1]]);
                        B2S_G(1, 5, 9, 13, m[SIGMA[i * 16 + 2]], m[SIGMA[i * 16 + 3]]);
                        B2S_G(2, 6, 10, 14, m[SIGMA[i * 16 + 4]], m[SIGMA[i * 16 + 5]]);
                        B2S_G(3, 7, 11, 15, m[SIGMA[i * 16 + 6]], m[SIGMA[i * 16 + 7]]);
                        B2S_G(0, 5, 10, 15, m[SIGMA[i * 16 + 8]], m[SIGMA[i * 16 + 9]]);
                        B2S_G(1, 6, 11, 12, m[SIGMA[i * 16 + 10]], m[SIGMA[i * 16 + 11]]);
                        B2S_G(2, 7, 8, 13, m[SIGMA[i * 16 + 12]], m[SIGMA[i * 16 + 13]]);
                        B2S_G(3, 4, 9, 14, m[SIGMA[i * 16 + 14]], m[SIGMA[i * 16 + 15]]);
                    }
                    // util.debugPrint('   (i=10) v[16]', v, 32)
                    for(i = 0; i < 8; i++)ctx.h[i] ^= v[i] ^ v[i + 8];
                // util.debugPrint('h[8]', ctx.h, 32)
                }
                // Creates a BLAKE2s hashing context
                // Requires an output length between 1 and 32 bytes
                // Takes an optional Uint8Array key
                function blake2sInit(outlen, key) {
                    if (!(outlen > 0 && outlen <= 32)) throw new Error("Incorrect output length, should be in [1, 32]");
                    const keylen = key ? key.length : 0;
                    if (key && !(keylen > 0 && keylen <= 32)) throw new Error("Incorrect key length, should be in [1, 32]");
                    const ctx = {
                        h: new Uint32Array(BLAKE2S_IV),
                        b: new Uint8Array(64),
                        c: 0,
                        t: 0,
                        outlen: outlen // output length in bytes
                    };
                    ctx.h[0] ^= 0x01010000 ^ keylen << 8 ^ outlen;
                    if (keylen > 0) {
                        blake2sUpdate(ctx, key);
                        ctx.c = 64 // at the end
                        ;
                    }
                    return ctx;
                }
                // Updates a BLAKE2s streaming hash
                // Requires hash context and Uint8Array (byte array)
                function blake2sUpdate(ctx, input) {
                    for(let i = 0; i < input.length; i++){
                        if (ctx.c === 64) {
                            // buffer full ?
                            ctx.t += ctx.c // add counters
                            ;
                            blake2sCompress(ctx, false) // compress (not last)
                            ;
                            ctx.c = 0 // counter to zero
                            ;
                        }
                        ctx.b[ctx.c++] = input[i];
                    }
                }
                // Completes a BLAKE2s streaming hash
                // Returns a Uint8Array containing the message digest
                function blake2sFinal(ctx) {
                    ctx.t += ctx.c // mark last block offset
                    ;
                    while(ctx.c < 64)// fill up with zeros
                    ctx.b[ctx.c++] = 0;
                    blake2sCompress(ctx, true) // final block flag = 1
                    ;
                    // little endian convert and store
                    const out = new Uint8Array(ctx.outlen);
                    for(let i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3) & 0xff;
                    return out;
                }
                // Computes the BLAKE2S hash of a string or byte array, and returns a Uint8Array
                //
                // Returns a n-byte Uint8Array
                //
                // Parameters:
                // - input - the input bytes, as a string, Buffer, or Uint8Array
                // - key - optional key Uint8Array, up to 32 bytes
                // - outlen - optional output length in bytes, default 64
                function blake2s(input, key, outlen) {
                    // preprocess inputs
                    outlen = outlen || 32;
                    input = util.normalizeInput(input);
                    // do the math
                    const ctx = blake2sInit(outlen, key);
                    blake2sUpdate(ctx, input);
                    return blake2sFinal(ctx);
                }
                // Computes the BLAKE2S hash of a string or byte array
                //
                // Returns an n-byte hash in hex, all lowercase
                //
                // Parameters:
                // - input - the input bytes, as a string, Buffer, or Uint8Array
                // - key - optional key Uint8Array, up to 32 bytes
                // - outlen - optional output length in bytes, default 64
                function blake2sHex(input, key, outlen) {
                    const output = blake2s(input, key, outlen);
                    return util.toHex(output);
                }
                module1.exports = {
                    blake2s: blake2s,
                    blake2sHex: blake2sHex,
                    blake2sInit: blake2sInit,
                    blake2sUpdate: blake2sUpdate,
                    blake2sFinal: blake2sFinal
                };
            /***/ },
            /***/ 1161: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                const b2b = __webpack_require__(7318);
                const b2s = __webpack_require__(8855);
                module1.exports = {
                    blake2b: b2b.blake2b,
                    blake2bHex: b2b.blake2bHex,
                    blake2bInit: b2b.blake2bInit,
                    blake2bUpdate: b2b.blake2bUpdate,
                    blake2bFinal: b2b.blake2bFinal,
                    blake2s: b2s.blake2s,
                    blake2sHex: b2s.blake2sHex,
                    blake2sInit: b2s.blake2sInit,
                    blake2sUpdate: b2s.blake2sUpdate,
                    blake2sFinal: b2s.blake2sFinal
                };
            /***/ },
            /***/ 1022: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /* provided dependency */ var Buffer = __webpack_require__(8764)["Buffer"];
                const ERROR_MSG_INPUT = "Input must be an string, Buffer or Uint8Array";
                // For convenience, let people hash a string, not just a Uint8Array
                function normalizeInput(input) {
                    let ret;
                    if (input instanceof Uint8Array) ret = input;
                    else if (input instanceof Buffer) ret = new Uint8Array(input);
                    else if (typeof input === "string") ret = new Uint8Array(Buffer.from(input, "utf8"));
                    else throw new Error(ERROR_MSG_INPUT);
                    return ret;
                }
                // Converts a Uint8Array to a hexadecimal string
                // For example, toHex([255, 0, 255]) returns "ff00ff"
                function toHex(bytes) {
                    return Array.prototype.map.call(bytes, function(n) {
                        return (n < 16 ? "0" : "") + n.toString(16);
                    }).join("");
                }
                // Converts any value in [0...2^32-1] to an 8-character hex string
                function uint32ToHex(val) {
                    return (0x100000000 + val).toString(16).substring(1);
                }
                // For debugging: prints out hash state in the same format as the RFC
                // sample computation exactly, so that you can diff
                function debugPrint(label, arr, size) {
                    let msg = "\n" + label + " = ";
                    for(let i = 0; i < arr.length; i += 2){
                        if (size === 32) {
                            msg += uint32ToHex(arr[i]).toUpperCase();
                            msg += " ";
                            msg += uint32ToHex(arr[i + 1]).toUpperCase();
                        } else if (size === 64) {
                            msg += uint32ToHex(arr[i + 1]).toUpperCase();
                            msg += uint32ToHex(arr[i]).toUpperCase();
                        } else throw new Error("Invalid size " + size);
                        if (i % 6 === 4) msg += "\n" + new Array(label.length + 4).join(" ");
                        else if (i < arr.length - 2) msg += " ";
                    }
                    console.log(msg);
                }
                // For performance testing: generates N bytes of input, hashes M times
                // Measures and prints MB/second hash performance each time
                function testSpeed(hashFn, N, M) {
                    let startMs = new Date().getTime();
                    const input = new Uint8Array(N);
                    for(let i = 0; i < N; i++)input[i] = i % 256;
                    const genMs = new Date().getTime();
                    console.log("Generated random input in " + (genMs - startMs) + "ms");
                    startMs = genMs;
                    for(let i = 0; i < M; i++){
                        const hashHex = hashFn(input);
                        const hashMs = new Date().getTime();
                        const ms = hashMs - startMs;
                        startMs = hashMs;
                        console.log("Hashed in " + ms + "ms: " + hashHex.substring(0, 20) + "...");
                        console.log(Math.round(N / 1048576 / (ms / 1000) * 100) / 100 + " MB PER SECOND");
                    }
                }
                module1.exports = {
                    normalizeInput: normalizeInput,
                    toHex: toHex,
                    debugPrint: debugPrint,
                    testSpeed: testSpeed
                };
            /***/ },
            /***/ 9347: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                // https://github.com/maxogden/websocket-stream/blob/48dc3ddf943e5ada668c31ccd94e9186f02fafbd/ws-fallback.js
                var ws = null;
                if (typeof WebSocket !== "undefined") ws = WebSocket;
                else if (typeof MozWebSocket !== "undefined") ws = MozWebSocket;
                else if (typeof __webpack_require__.g !== "undefined") ws = __webpack_require__.g.WebSocket || __webpack_require__.g.MozWebSocket;
                else if (typeof window !== "undefined") ws = window.WebSocket || window.MozWebSocket;
                else if (typeof self !== "undefined") ws = self.WebSocket || self.MozWebSocket;
                module1.exports = ws;
            /***/ },
            /***/ 9992: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                // A linked list to keep track of recently-used-ness
                const Yallist = __webpack_require__(7279);
                const MAX = Symbol("max");
                const LENGTH = Symbol("length");
                const LENGTH_CALCULATOR = Symbol("lengthCalculator");
                const ALLOW_STALE = Symbol("allowStale");
                const MAX_AGE = Symbol("maxAge");
                const DISPOSE = Symbol("dispose");
                const NO_DISPOSE_ON_SET = Symbol("noDisposeOnSet");
                const LRU_LIST = Symbol("lruList");
                const CACHE = Symbol("cache");
                const UPDATE_AGE_ON_GET = Symbol("updateAgeOnGet");
                const naiveLength = ()=>1;
                // lruList is a yallist where the head is the youngest
                // item, and the tail is the oldest.  the list contains the Hit
                // objects as the entries.
                // Each Hit object has a reference to its Yallist.Node.  This
                // never changes.
                //
                // cache is a Map (or PseudoMap) that matches the keys to
                // the Yallist.Node object.
                class LRUCache {
                    constructor(options){
                        if (typeof options === "number") options = {
                            max: options
                        };
                        if (!options) options = {};
                        if (options.max && (typeof options.max !== "number" || options.max < 0)) throw new TypeError("max must be a non-negative number");
                        // Kind of weird to have a default max of Infinity, but oh well.
                        const max = this[MAX] = options.max || Infinity;
                        const lc = options.length || naiveLength;
                        this[LENGTH_CALCULATOR] = typeof lc !== "function" ? naiveLength : lc;
                        this[ALLOW_STALE] = options.stale || false;
                        if (options.maxAge && typeof options.maxAge !== "number") throw new TypeError("maxAge must be a number");
                        this[MAX_AGE] = options.maxAge || 0;
                        this[DISPOSE] = options.dispose;
                        this[NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false;
                        this[UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false;
                        this.reset();
                    }
                    // resize the cache when the max changes.
                    set max(mL) {
                        if (typeof mL !== "number" || mL < 0) throw new TypeError("max must be a non-negative number");
                        this[MAX] = mL || Infinity;
                        trim(this);
                    }
                    get max() {
                        return this[MAX];
                    }
                    set allowStale(allowStale) {
                        this[ALLOW_STALE] = !!allowStale;
                    }
                    get allowStale() {
                        return this[ALLOW_STALE];
                    }
                    set maxAge(mA) {
                        if (typeof mA !== "number") throw new TypeError("maxAge must be a non-negative number");
                        this[MAX_AGE] = mA;
                        trim(this);
                    }
                    get maxAge() {
                        return this[MAX_AGE];
                    }
                    // resize the cache when the lengthCalculator changes.
                    set lengthCalculator(lC) {
                        if (typeof lC !== "function") lC = naiveLength;
                        if (lC !== this[LENGTH_CALCULATOR]) {
                            this[LENGTH_CALCULATOR] = lC;
                            this[LENGTH] = 0;
                            this[LRU_LIST].forEach((hit)=>{
                                hit.length = this[LENGTH_CALCULATOR](hit.value, hit.key);
                                this[LENGTH] += hit.length;
                            });
                        }
                        trim(this);
                    }
                    get lengthCalculator() {
                        return this[LENGTH_CALCULATOR];
                    }
                    get length() {
                        return this[LENGTH];
                    }
                    get itemCount() {
                        return this[LRU_LIST].length;
                    }
                    rforEach(fn, thisp) {
                        thisp = thisp || this;
                        for(let walker = this[LRU_LIST].tail; walker !== null;){
                            const prev = walker.prev;
                            forEachStep(this, fn, walker, thisp);
                            walker = prev;
                        }
                    }
                    forEach(fn, thisp) {
                        thisp = thisp || this;
                        for(let walker = this[LRU_LIST].head; walker !== null;){
                            const next = walker.next;
                            forEachStep(this, fn, walker, thisp);
                            walker = next;
                        }
                    }
                    keys() {
                        return this[LRU_LIST].toArray().map((k)=>k.key);
                    }
                    values() {
                        return this[LRU_LIST].toArray().map((k)=>k.value);
                    }
                    reset() {
                        if (this[DISPOSE] && this[LRU_LIST] && this[LRU_LIST].length) this[LRU_LIST].forEach((hit)=>this[DISPOSE](hit.key, hit.value));
                        this[CACHE] = new Map() // hash of items by key
                        ;
                        this[LRU_LIST] = new Yallist() // list of items in order of use recency
                        ;
                        this[LENGTH] = 0 // length of items in the list
                        ;
                    }
                    dump() {
                        return this[LRU_LIST].map((hit)=>isStale(this, hit) ? false : {
                                k: hit.key,
                                v: hit.value,
                                e: hit.now + (hit.maxAge || 0)
                            }).toArray().filter((h)=>h);
                    }
                    dumpLru() {
                        return this[LRU_LIST];
                    }
                    set(key, value, maxAge) {
                        maxAge = maxAge || this[MAX_AGE];
                        if (maxAge && typeof maxAge !== "number") throw new TypeError("maxAge must be a number");
                        const now = maxAge ? Date.now() : 0;
                        const len = this[LENGTH_CALCULATOR](value, key);
                        if (this[CACHE].has(key)) {
                            if (len > this[MAX]) {
                                del(this, this[CACHE].get(key));
                                return false;
                            }
                            const node = this[CACHE].get(key);
                            const item = node.value;
                            // dispose of the old one before overwriting
                            // split out into 2 ifs for better coverage tracking
                            if (this[DISPOSE]) {
                                if (!this[NO_DISPOSE_ON_SET]) this[DISPOSE](key, item.value);
                            }
                            item.now = now;
                            item.maxAge = maxAge;
                            item.value = value;
                            this[LENGTH] += len - item.length;
                            item.length = len;
                            this.get(key);
                            trim(this);
                            return true;
                        }
                        const hit = new Entry(key, value, len, now, maxAge);
                        // oversized objects fall out of cache automatically.
                        if (hit.length > this[MAX]) {
                            if (this[DISPOSE]) this[DISPOSE](key, value);
                            return false;
                        }
                        this[LENGTH] += hit.length;
                        this[LRU_LIST].unshift(hit);
                        this[CACHE].set(key, this[LRU_LIST].head);
                        trim(this);
                        return true;
                    }
                    has(key) {
                        if (!this[CACHE].has(key)) return false;
                        const hit = this[CACHE].get(key).value;
                        return !isStale(this, hit);
                    }
                    get(key) {
                        return get(this, key, true);
                    }
                    peek(key) {
                        return get(this, key, false);
                    }
                    pop() {
                        const node = this[LRU_LIST].tail;
                        if (!node) return null;
                        del(this, node);
                        return node.value;
                    }
                    del(key) {
                        del(this, this[CACHE].get(key));
                    }
                    load(arr) {
                        // reset the cache
                        this.reset();
                        const now = Date.now();
                        // A previous serialized cache has the most recent items first
                        for(let l = arr.length - 1; l >= 0; l--){
                            const hit = arr[l];
                            const expiresAt = hit.e || 0;
                            if (expiresAt === 0) // the item was created without expiration in a non aged cache
                            this.set(hit.k, hit.v);
                            else {
                                const maxAge = expiresAt - now;
                                // dont add already expired items
                                if (maxAge > 0) this.set(hit.k, hit.v, maxAge);
                            }
                        }
                    }
                    prune() {
                        this[CACHE].forEach((value, key)=>get(this, key, false));
                    }
                }
                const get = (self1, key, doUse)=>{
                    const node = self1[CACHE].get(key);
                    if (node) {
                        const hit = node.value;
                        if (isStale(self1, hit)) {
                            del(self1, node);
                            if (!self1[ALLOW_STALE]) return undefined;
                        } else if (doUse) {
                            if (self1[UPDATE_AGE_ON_GET]) node.value.now = Date.now();
                            self1[LRU_LIST].unshiftNode(node);
                        }
                        return hit.value;
                    }
                };
                const isStale = (self1, hit)=>{
                    if (!hit || !hit.maxAge && !self1[MAX_AGE]) return false;
                    const diff = Date.now() - hit.now;
                    return hit.maxAge ? diff > hit.maxAge : self1[MAX_AGE] && diff > self1[MAX_AGE];
                };
                const trim = (self1)=>{
                    if (self1[LENGTH] > self1[MAX]) for(let walker = self1[LRU_LIST].tail; self1[LENGTH] > self1[MAX] && walker !== null;){
                        // We know that we're about to delete this one, and also
                        // what the next least recently used key will be, so just
                        // go ahead and set it now.
                        const prev = walker.prev;
                        del(self1, walker);
                        walker = prev;
                    }
                };
                const del = (self1, node)=>{
                    if (node) {
                        const hit = node.value;
                        if (self1[DISPOSE]) self1[DISPOSE](hit.key, hit.value);
                        self1[LENGTH] -= hit.length;
                        self1[CACHE].delete(hit.key);
                        self1[LRU_LIST].removeNode(node);
                    }
                };
                class Entry {
                    constructor(key, value, length, now, maxAge){
                        this.key = key;
                        this.value = value;
                        this.length = length;
                        this.now = now;
                        this.maxAge = maxAge || 0;
                    }
                }
                const forEachStep = (self1, fn, node, thisp)=>{
                    let hit = node.value;
                    if (isStale(self1, hit)) {
                        del(self1, node);
                        if (!self1[ALLOW_STALE]) hit = undefined;
                    }
                    if (hit) fn.call(thisp, hit.value, hit.key, self1);
                };
                module1.exports = LRUCache;
            /***/ },
            /***/ 862: /***/ (module1)=>{
                "use strict";
                module1.exports = function(Yallist) {
                    Yallist.prototype[Symbol.iterator] = function*() {
                        for(let walker = this.head; walker; walker = walker.next)yield walker.value;
                    };
                };
            /***/ },
            /***/ 7279: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                module1.exports = Yallist;
                Yallist.Node = Node;
                Yallist.create = Yallist;
                function Yallist(list) {
                    var self1 = this;
                    if (!(self1 instanceof Yallist)) self1 = new Yallist();
                    self1.tail = null;
                    self1.head = null;
                    self1.length = 0;
                    if (list && typeof list.forEach === "function") list.forEach(function(item) {
                        self1.push(item);
                    });
                    else if (arguments.length > 0) for(var i = 0, l = arguments.length; i < l; i++)self1.push(arguments[i]);
                    return self1;
                }
                Yallist.prototype.removeNode = function(node) {
                    if (node.list !== this) throw new Error("removing node which does not belong to this list");
                    var next = node.next;
                    var prev = node.prev;
                    if (next) next.prev = prev;
                    if (prev) prev.next = next;
                    if (node === this.head) this.head = next;
                    if (node === this.tail) this.tail = prev;
                    node.list.length--;
                    node.next = null;
                    node.prev = null;
                    node.list = null;
                };
                Yallist.prototype.unshiftNode = function(node) {
                    if (node === this.head) return;
                    if (node.list) node.list.removeNode(node);
                    var head = this.head;
                    node.list = this;
                    node.next = head;
                    if (head) head.prev = node;
                    this.head = node;
                    if (!this.tail) this.tail = node;
                    this.length++;
                };
                Yallist.prototype.pushNode = function(node) {
                    if (node === this.tail) return;
                    if (node.list) node.list.removeNode(node);
                    var tail = this.tail;
                    node.list = this;
                    node.prev = tail;
                    if (tail) tail.next = node;
                    this.tail = node;
                    if (!this.head) this.head = node;
                    this.length++;
                };
                Yallist.prototype.push = function() {
                    for(var i = 0, l = arguments.length; i < l; i++)push(this, arguments[i]);
                    return this.length;
                };
                Yallist.prototype.unshift = function() {
                    for(var i = 0, l = arguments.length; i < l; i++)unshift(this, arguments[i]);
                    return this.length;
                };
                Yallist.prototype.pop = function() {
                    if (!this.tail) return undefined;
                    var res = this.tail.value;
                    this.tail = this.tail.prev;
                    if (this.tail) this.tail.next = null;
                    else this.head = null;
                    this.length--;
                    return res;
                };
                Yallist.prototype.shift = function() {
                    if (!this.head) return undefined;
                    var res = this.head.value;
                    this.head = this.head.next;
                    if (this.head) this.head.prev = null;
                    else this.tail = null;
                    this.length--;
                    return res;
                };
                Yallist.prototype.forEach = function(fn, thisp) {
                    thisp = thisp || this;
                    for(var walker = this.head, i = 0; walker !== null; i++){
                        fn.call(thisp, walker.value, i, this);
                        walker = walker.next;
                    }
                };
                Yallist.prototype.forEachReverse = function(fn, thisp) {
                    thisp = thisp || this;
                    for(var walker = this.tail, i = this.length - 1; walker !== null; i--){
                        fn.call(thisp, walker.value, i, this);
                        walker = walker.prev;
                    }
                };
                Yallist.prototype.get = function(n) {
                    for(var i = 0, walker = this.head; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
                    walker = walker.next;
                    if (i === n && walker !== null) return walker.value;
                };
                Yallist.prototype.getReverse = function(n) {
                    for(var i = 0, walker = this.tail; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
                    walker = walker.prev;
                    if (i === n && walker !== null) return walker.value;
                };
                Yallist.prototype.map = function(fn, thisp) {
                    thisp = thisp || this;
                    var res = new Yallist();
                    for(var walker = this.head; walker !== null;){
                        res.push(fn.call(thisp, walker.value, this));
                        walker = walker.next;
                    }
                    return res;
                };
                Yallist.prototype.mapReverse = function(fn, thisp) {
                    thisp = thisp || this;
                    var res = new Yallist();
                    for(var walker = this.tail; walker !== null;){
                        res.push(fn.call(thisp, walker.value, this));
                        walker = walker.prev;
                    }
                    return res;
                };
                Yallist.prototype.reduce = function(fn, initial) {
                    var acc;
                    var walker = this.head;
                    if (arguments.length > 1) acc = initial;
                    else if (this.head) {
                        walker = this.head.next;
                        acc = this.head.value;
                    } else throw new TypeError("Reduce of empty list with no initial value");
                    for(var i = 0; walker !== null; i++){
                        acc = fn(acc, walker.value, i);
                        walker = walker.next;
                    }
                    return acc;
                };
                Yallist.prototype.reduceReverse = function(fn, initial) {
                    var acc;
                    var walker = this.tail;
                    if (arguments.length > 1) acc = initial;
                    else if (this.tail) {
                        walker = this.tail.prev;
                        acc = this.tail.value;
                    } else throw new TypeError("Reduce of empty list with no initial value");
                    for(var i = this.length - 1; walker !== null; i--){
                        acc = fn(acc, walker.value, i);
                        walker = walker.prev;
                    }
                    return acc;
                };
                Yallist.prototype.toArray = function() {
                    var arr = new Array(this.length);
                    for(var i = 0, walker = this.head; walker !== null; i++){
                        arr[i] = walker.value;
                        walker = walker.next;
                    }
                    return arr;
                };
                Yallist.prototype.toArrayReverse = function() {
                    var arr = new Array(this.length);
                    for(var i = 0, walker = this.tail; walker !== null; i++){
                        arr[i] = walker.value;
                        walker = walker.prev;
                    }
                    return arr;
                };
                Yallist.prototype.slice = function(from, to) {
                    to = to || this.length;
                    if (to < 0) to += this.length;
                    from = from || 0;
                    if (from < 0) from += this.length;
                    var ret = new Yallist();
                    if (to < from || to < 0) return ret;
                    if (from < 0) from = 0;
                    if (to > this.length) to = this.length;
                    for(var i = 0, walker = this.head; walker !== null && i < from; i++)walker = walker.next;
                    for(; walker !== null && i < to; i++, walker = walker.next)ret.push(walker.value);
                    return ret;
                };
                Yallist.prototype.sliceReverse = function(from, to) {
                    to = to || this.length;
                    if (to < 0) to += this.length;
                    from = from || 0;
                    if (from < 0) from += this.length;
                    var ret = new Yallist();
                    if (to < from || to < 0) return ret;
                    if (from < 0) from = 0;
                    if (to > this.length) to = this.length;
                    for(var i = this.length, walker = this.tail; walker !== null && i > to; i--)walker = walker.prev;
                    for(; walker !== null && i > from; i--, walker = walker.prev)ret.push(walker.value);
                    return ret;
                };
                Yallist.prototype.reverse = function() {
                    var head = this.head;
                    var tail = this.tail;
                    for(var walker = head; walker !== null; walker = walker.prev){
                        var p = walker.prev;
                        walker.prev = walker.next;
                        walker.next = p;
                    }
                    this.head = tail;
                    this.tail = head;
                    return this;
                };
                function push(self1, item) {
                    self1.tail = new Node(item, self1.tail, null, self1);
                    if (!self1.head) self1.head = self1.tail;
                    self1.length++;
                }
                function unshift(self1, item) {
                    self1.head = new Node(item, null, self1.head, self1);
                    if (!self1.tail) self1.tail = self1.head;
                    self1.length++;
                }
                function Node(value, prev, next, list) {
                    if (!(this instanceof Node)) return new Node(value, prev, next, list);
                    this.list = list;
                    this.value = value;
                    if (prev) {
                        prev.next = this;
                        this.prev = prev;
                    } else this.prev = null;
                    if (next) {
                        next.prev = this;
                        this.next = next;
                    } else this.next = null;
                }
                try {
                    // add if support for Symbol.iterator is present
                    __webpack_require__(862)(Yallist);
                } catch (er) {}
            /***/ },
            /***/ 3609: /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.version = "4.0.27-5";
            /***/ },
            /***/ 8707: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var bignumber_1 = __webpack_require__(4759);
                var AddressZero = "0x0000000000000000000000000000000000000000";
                exports.AddressZero = AddressZero;
                var HashZero = "0x0000000000000000000000000000000000000000000000000000000000000000";
                exports.HashZero = HashZero;
                // NFKD (decomposed)
                //const EtherSymbol = '\uD835\uDF63';
                // NFKC (composed)
                var EtherSymbol = "\u039E";
                exports.EtherSymbol = EtherSymbol;
                var NegativeOne = bignumber_1.bigNumberify(-1);
                exports.NegativeOne = NegativeOne;
                var Zero = bignumber_1.bigNumberify(0);
                exports.Zero = Zero;
                var One = bignumber_1.bigNumberify(1);
                exports.One = One;
                var Two = bignumber_1.bigNumberify(2);
                exports.Two = Two;
                var WeiPerEther = bignumber_1.bigNumberify("1000000000000000000");
                exports.WeiPerEther = WeiPerEther;
                var MaxUint256 = bignumber_1.bigNumberify("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
                exports.MaxUint256 = MaxUint256;
            /***/ },
            /***/ 6459: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _version_1 = __webpack_require__(3609);
                // Unknown Error
                exports.UNKNOWN_ERROR = "UNKNOWN_ERROR";
                // Not implemented
                exports.NOT_IMPLEMENTED = "NOT_IMPLEMENTED";
                // Missing new operator to an object
                //  - name: The name of the class
                exports.MISSING_NEW = "MISSING_NEW";
                // Call exception
                //  - transaction: the transaction
                //  - address?: the contract address
                //  - args?: The arguments passed into the function
                //  - method?: The Solidity method signature
                //  - errorSignature?: The EIP848 error signature
                //  - errorArgs?: The EIP848 error parameters
                //  - reason: The reason (only for EIP848 "Error(string)")
                exports.CALL_EXCEPTION = "CALL_EXCEPTION";
                // Invalid argument (e.g. value is incompatible with type) to a function:
                //   - argument: The argument name that was invalid
                //   - value: The value of the argument
                exports.INVALID_ARGUMENT = "INVALID_ARGUMENT";
                // Missing argument to a function:
                //   - count: The number of arguments received
                //   - expectedCount: The number of arguments expected
                exports.MISSING_ARGUMENT = "MISSING_ARGUMENT";
                // Too many arguments
                //   - count: The number of arguments received
                //   - expectedCount: The number of arguments expected
                exports.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT";
                // Numeric Fault
                //   - operation: the operation being executed
                //   - fault: the reason this faulted
                exports.NUMERIC_FAULT = "NUMERIC_FAULT";
                // Insufficien funds (< value + gasLimit * gasPrice)
                //   - transaction: the transaction attempted
                exports.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS";
                // Nonce has already been used
                //   - transaction: the transaction attempted
                exports.NONCE_EXPIRED = "NONCE_EXPIRED";
                // The replacement fee for the transaction is too low
                //   - transaction: the transaction attempted
                exports.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED";
                // Unsupported operation
                //   - operation
                exports.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION";
                var _permanentCensorErrors = false;
                var _censorErrors = false;
                // @TODO: Enum
                function throwError(message, code, params) {
                    if (_censorErrors) throw new Error("unknown error");
                    if (!code) code = exports.UNKNOWN_ERROR;
                    if (!params) params = {};
                    var messageDetails = [];
                    Object.keys(params).forEach(function(key) {
                        try {
                            messageDetails.push(key + "=" + JSON.stringify(params[key]));
                        } catch (error) {
                            messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
                        }
                    });
                    messageDetails.push("version=" + _version_1.version);
                    var reason = message;
                    if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
                    // @TODO: Any??
                    var error = new Error(message);
                    error.reason = reason;
                    error.code = code;
                    Object.keys(params).forEach(function(key) {
                        error[key] = params[key];
                    });
                    throw error;
                }
                exports.throwError = throwError;
                function checkNew(self1, kind) {
                    if (!(self1 instanceof kind)) throwError("missing new", exports.MISSING_NEW, {
                        name: kind.name
                    });
                }
                exports.checkNew = checkNew;
                function checkArgumentCount(count, expectedCount, suffix) {
                    if (!suffix) suffix = "";
                    if (count < expectedCount) throwError("missing argument" + suffix, exports.MISSING_ARGUMENT, {
                        count: count,
                        expectedCount: expectedCount
                    });
                    if (count > expectedCount) throwError("too many arguments" + suffix, exports.UNEXPECTED_ARGUMENT, {
                        count: count,
                        expectedCount: expectedCount
                    });
                }
                exports.checkArgumentCount = checkArgumentCount;
                function setCensorship(censorship, permanent) {
                    if (_permanentCensorErrors) throwError("error censorship permanent", exports.UNSUPPORTED_OPERATION, {
                        operation: "setCensorship"
                    });
                    _censorErrors = !!censorship;
                    _permanentCensorErrors = !!permanent;
                }
                exports.setCensorship = setCensorship;
                function checkNormalize() {
                    try {
                        // Make sure all forms of normalization are supported
                        [
                            "NFD",
                            "NFC",
                            "NFKD",
                            "NFKC"
                        ].forEach(function(form) {
                            try {
                                "test".normalize(form);
                            } catch (error) {
                                throw new Error("missing " + form);
                            }
                        });
                        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
                    } catch (error) {
                        throwError("platform missing String.prototype.normalize", exports.UNSUPPORTED_OPERATION, {
                            operation: "String.prototype.normalize",
                            form: error.message
                        });
                    }
                }
                exports.checkNormalize = checkNormalize;
                var LogLevels = {
                    debug: 1,
                    "default": 2,
                    info: 2,
                    warn: 3,
                    error: 4,
                    off: 5
                };
                var LogLevel = LogLevels["default"];
                function setLogLevel(logLevel) {
                    var level = LogLevels[logLevel];
                    if (level == null) {
                        warn("invliad log level - " + logLevel);
                        return;
                    }
                    LogLevel = level;
                }
                exports.setLogLevel = setLogLevel;
                function log(logLevel, args) {
                    if (LogLevel > LogLevels[logLevel]) return;
                    console.log.apply(console, args);
                }
                function warn() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    log("warn", args);
                }
                exports.warn = warn;
                function info() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    log("info", args);
                }
                exports.info = info;
            /***/ },
            /***/ 2046: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __extends = this && this.__extends || function() {
                    var extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return function(d, b) {
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __importStar = this && this.__importStar || function(mod) {
                    if (mod && mod.__esModule) return mod;
                    var result = {};
                    if (mod != null) {
                        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
                    }
                    result["default"] = mod;
                    return result;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                // See: https://github.com/ethereum/wiki/wiki/Ethereum-Contract-ABI
                var constants_1 = __webpack_require__(8707);
                var errors = __importStar(__webpack_require__(6459));
                var address_1 = __webpack_require__(5638);
                var bignumber_1 = __webpack_require__(4759);
                var bytes_1 = __webpack_require__(8458);
                var utf8_1 = __webpack_require__(1165);
                var properties_1 = __webpack_require__(8184);
                ///////////////////////////////
                var paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
                var paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
                var paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
                exports.defaultCoerceFunc = function(type, value) {
                    var match = type.match(paramTypeNumber);
                    if (match && parseInt(match[2]) <= 48) return value.toNumber();
                    return value;
                };
                ///////////////////////////////////
                // Parsing for Solidity Signatures
                var regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
                var regexIdentifier = new RegExp("^[A-Za-z_][A-Za-z0-9_]*$");
                function verifyType(type) {
                    // These need to be transformed to their full description
                    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
                    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
                    return type;
                }
                function parseParam(param, allowIndexed) {
                    var originalParam = param;
                    function throwError(i) {
                        throw new Error('unexpected character "' + originalParam[i] + '" at position ' + i + ' in "' + originalParam + '"');
                    }
                    param = param.replace(/\s/g, " ");
                    var parent = {
                        type: "",
                        name: "",
                        state: {
                            allowType: true
                        }
                    };
                    var node = parent;
                    for(var i = 0; i < param.length; i++){
                        var c = param[i];
                        switch(c){
                            case "(":
                                if (!node.state.allowParams) throwError(i);
                                node.state.allowType = false;
                                node.type = verifyType(node.type);
                                node.components = [
                                    {
                                        type: "",
                                        name: "",
                                        parent: node,
                                        state: {
                                            allowType: true
                                        }
                                    }
                                ];
                                node = node.components[0];
                                break;
                            case ")":
                                delete node.state;
                                if (allowIndexed && node.name === "indexed") {
                                    node.indexed = true;
                                    node.name = "";
                                }
                                node.type = verifyType(node.type);
                                var child = node;
                                node = node.parent;
                                if (!node) throwError(i);
                                delete child.parent;
                                node.state.allowParams = false;
                                node.state.allowName = true;
                                node.state.allowArray = true;
                                break;
                            case ",":
                                delete node.state;
                                if (allowIndexed && node.name === "indexed") {
                                    node.indexed = true;
                                    node.name = "";
                                }
                                node.type = verifyType(node.type);
                                var sibling = {
                                    type: "",
                                    name: "",
                                    parent: node.parent,
                                    state: {
                                        allowType: true
                                    }
                                };
                                node.parent.components.push(sibling);
                                delete node.parent;
                                node = sibling;
                                break;
                            // Hit a space...
                            case " ":
                                // If reading type, the type is done and may read a param or name
                                if (node.state.allowType) {
                                    if (node.type !== "") {
                                        node.type = verifyType(node.type);
                                        delete node.state.allowType;
                                        node.state.allowName = true;
                                        node.state.allowParams = true;
                                    }
                                }
                                // If reading name, the name is done
                                if (node.state.allowName) {
                                    if (node.name !== "") {
                                        if (allowIndexed && node.name === "indexed") {
                                            node.indexed = true;
                                            node.name = "";
                                        } else node.state.allowName = false;
                                    }
                                }
                                break;
                            case "[":
                                if (!node.state.allowArray) throwError(i);
                                node.type += c;
                                node.state.allowArray = false;
                                node.state.allowName = false;
                                node.state.readArray = true;
                                break;
                            case "]":
                                if (!node.state.readArray) throwError(i);
                                node.type += c;
                                node.state.readArray = false;
                                node.state.allowArray = true;
                                node.state.allowName = true;
                                break;
                            default:
                                if (node.state.allowType) {
                                    node.type += c;
                                    node.state.allowParams = true;
                                    node.state.allowArray = true;
                                } else if (node.state.allowName) {
                                    node.name += c;
                                    delete node.state.allowArray;
                                } else if (node.state.readArray) node.type += c;
                                else throwError(i);
                        }
                    }
                    if (node.parent) throw new Error("unexpected eof");
                    delete parent.state;
                    if (allowIndexed && node.name === "indexed") {
                        node.indexed = true;
                        node.name = "";
                    }
                    parent.type = verifyType(parent.type);
                    return parent;
                }
                // @TODO: Better return type
                function parseSignatureEvent(fragment) {
                    var abi = {
                        anonymous: false,
                        inputs: [],
                        name: "",
                        type: "event"
                    };
                    var match = fragment.match(regexParen);
                    if (!match) throw new Error("invalid event: " + fragment);
                    abi.name = match[1].trim();
                    splitNesting(match[2]).forEach(function(param) {
                        param = parseParam(param, true);
                        param.indexed = !!param.indexed;
                        abi.inputs.push(param);
                    });
                    match[3].split(" ").forEach(function(modifier) {
                        switch(modifier){
                            case "anonymous":
                                abi.anonymous = true;
                                break;
                            case "":
                                break;
                            default:
                                errors.info("unknown modifier: " + modifier);
                        }
                    });
                    if (abi.name && !abi.name.match(regexIdentifier)) throw new Error('invalid identifier: "' + abi.name + '"');
                    return abi;
                }
                function parseSignatureFunction(fragment) {
                    var abi = {
                        constant: false,
                        gas: null,
                        inputs: [],
                        name: "",
                        outputs: [],
                        payable: false,
                        stateMutability: null,
                        type: "function"
                    };
                    var comps = fragment.split("@");
                    if (comps.length !== 1) {
                        if (comps.length > 2) throw new Error("invalid signature");
                        if (!comps[1].match(/^[0-9]+$/)) throw new Error("invalid signature gas");
                        abi.gas = bignumber_1.bigNumberify(comps[1]);
                        fragment = comps[0];
                    }
                    comps = fragment.split(" returns ");
                    var left = comps[0].match(regexParen);
                    if (!left) throw new Error("invalid signature");
                    abi.name = left[1].trim();
                    if (!abi.name.match(regexIdentifier)) throw new Error('invalid identifier: "' + left[1] + '"');
                    splitNesting(left[2]).forEach(function(param) {
                        abi.inputs.push(parseParam(param));
                    });
                    left[3].split(" ").forEach(function(modifier) {
                        switch(modifier){
                            case "constant":
                                abi.constant = true;
                                break;
                            case "payable":
                                abi.payable = true;
                                abi.stateMutability = "payable";
                                break;
                            case "pure":
                                abi.constant = true;
                                abi.stateMutability = "pure";
                                break;
                            case "view":
                                abi.constant = true;
                                abi.stateMutability = "view";
                                break;
                            case "external":
                            case "public":
                            case "":
                                break;
                            default:
                                errors.info("unknown modifier: " + modifier);
                        }
                    });
                    // We have outputs
                    if (comps.length > 1) {
                        var right = comps[1].match(regexParen);
                        if (right[1].trim() != "" || right[3].trim() != "") throw new Error("unexpected tokens");
                        splitNesting(right[2]).forEach(function(param) {
                            abi.outputs.push(parseParam(param));
                        });
                    }
                    if (abi.name === "constructor") {
                        abi.type = "constructor";
                        if (abi.outputs.length) throw new Error("constructor may not have outputs");
                        delete abi.name;
                        delete abi.outputs;
                    }
                    return abi;
                }
                function parseParamType(type) {
                    return parseParam(type, true);
                }
                exports.parseParamType = parseParamType;
                // @TODO: Allow a second boolean to expose names
                function formatParamType(paramType) {
                    return getParamCoder(exports.defaultCoerceFunc, paramType).type;
                }
                exports.formatParamType = formatParamType;
                // @TODO: Allow a second boolean to expose names and modifiers
                function formatSignature(fragment) {
                    return fragment.name + "(" + fragment.inputs.map(function(i) {
                        return formatParamType(i);
                    }).join(",") + ")";
                }
                exports.formatSignature = formatSignature;
                function parseSignature(fragment) {
                    if (typeof fragment === "string") {
                        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
                        fragment = fragment.replace(/\s/g, " ");
                        fragment = fragment.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
                        fragment = fragment.trim();
                        if (fragment.substring(0, 6) === "event ") return parseSignatureEvent(fragment.substring(6).trim());
                        else {
                            if (fragment.substring(0, 9) === "function ") fragment = fragment.substring(9);
                            return parseSignatureFunction(fragment.trim());
                        }
                    }
                    throw new Error("unknown signature");
                }
                exports.parseSignature = parseSignature;
                var Coder = /** @class */ function() {
                    function Coder(coerceFunc, name1, type, localName, dynamic) {
                        this.coerceFunc = coerceFunc;
                        this.name = name1;
                        this.type = type;
                        this.localName = localName;
                        this.dynamic = dynamic;
                    }
                    return Coder;
                }();
                // Clones the functionality of an existing Coder, but without a localName
                var CoderAnonymous = /** @class */ function(_super) {
                    __extends(CoderAnonymous, _super);
                    function CoderAnonymous(coder) {
                        var _this = _super.call(this, coder.coerceFunc, coder.name, coder.type, undefined, coder.dynamic) || this;
                        properties_1.defineReadOnly(_this, "coder", coder);
                        return _this;
                    }
                    CoderAnonymous.prototype.encode = function(value) {
                        return this.coder.encode(value);
                    };
                    CoderAnonymous.prototype.decode = function(data, offset) {
                        return this.coder.decode(data, offset);
                    };
                    return CoderAnonymous;
                }(Coder);
                var CoderNull = /** @class */ function(_super) {
                    __extends(CoderNull, _super);
                    function CoderNull(coerceFunc, localName) {
                        return _super.call(this, coerceFunc, "null", "", localName, false) || this;
                    }
                    CoderNull.prototype.encode = function(value) {
                        return bytes_1.arrayify([]);
                    };
                    CoderNull.prototype.decode = function(data, offset) {
                        if (offset > data.length) throw new Error("invalid null");
                        return {
                            consumed: 0,
                            value: this.coerceFunc("null", undefined)
                        };
                    };
                    return CoderNull;
                }(Coder);
                var CoderNumber = /** @class */ function(_super) {
                    __extends(CoderNumber, _super);
                    function CoderNumber(coerceFunc, size, signed, localName) {
                        var _this = this;
                        var name1 = (signed ? "int" : "uint") + size * 8;
                        _this = _super.call(this, coerceFunc, name1, name1, localName, false) || this;
                        _this.size = size;
                        _this.signed = signed;
                        return _this;
                    }
                    CoderNumber.prototype.encode = function(value) {
                        try {
                            var v = bignumber_1.bigNumberify(value);
                            if (this.signed) {
                                var bounds = constants_1.MaxUint256.maskn(this.size * 8 - 1);
                                if (v.gt(bounds)) throw new Error("out-of-bounds");
                                bounds = bounds.add(constants_1.One).mul(constants_1.NegativeOne);
                                if (v.lt(bounds)) throw new Error("out-of-bounds");
                            } else if (v.lt(constants_1.Zero) || v.gt(constants_1.MaxUint256.maskn(this.size * 8))) throw new Error("out-of-bounds");
                            v = v.toTwos(this.size * 8).maskn(this.size * 8);
                            if (this.signed) v = v.fromTwos(this.size * 8).toTwos(256);
                            return bytes_1.padZeros(bytes_1.arrayify(v), 32);
                        } catch (error) {
                            errors.throwError("invalid number value", errors.INVALID_ARGUMENT, {
                                arg: this.localName,
                                coderType: this.name,
                                value: value
                            });
                        }
                        return null;
                    };
                    CoderNumber.prototype.decode = function(data, offset) {
                        if (data.length < offset + 32) errors.throwError("insufficient data for " + this.name + " type", errors.INVALID_ARGUMENT, {
                            arg: this.localName,
                            coderType: this.name,
                            value: bytes_1.hexlify(data.slice(offset, offset + 32))
                        });
                        var junkLength = 32 - this.size;
                        var value = bignumber_1.bigNumberify(data.slice(offset + junkLength, offset + 32));
                        if (this.signed) value = value.fromTwos(this.size * 8);
                        else value = value.maskn(this.size * 8);
                        return {
                            consumed: 32,
                            value: this.coerceFunc(this.name, value)
                        };
                    };
                    return CoderNumber;
                }(Coder);
                var uint256Coder = new CoderNumber(function(type, value) {
                    return value;
                }, 32, false, "none");
                var CoderBoolean = /** @class */ function(_super) {
                    __extends(CoderBoolean, _super);
                    function CoderBoolean(coerceFunc, localName) {
                        return _super.call(this, coerceFunc, "bool", "bool", localName, false) || this;
                    }
                    CoderBoolean.prototype.encode = function(value) {
                        return uint256Coder.encode(!!value ? 1 : 0);
                    };
                    CoderBoolean.prototype.decode = function(data, offset) {
                        try {
                            var result = uint256Coder.decode(data, offset);
                        } catch (error) {
                            if (error.reason === "insufficient data for uint256 type") errors.throwError("insufficient data for boolean type", errors.INVALID_ARGUMENT, {
                                arg: this.localName,
                                coderType: "boolean",
                                value: error.value
                            });
                            throw error;
                        }
                        return {
                            consumed: result.consumed,
                            value: this.coerceFunc("bool", !result.value.isZero())
                        };
                    };
                    return CoderBoolean;
                }(Coder);
                var CoderFixedBytes = /** @class */ function(_super) {
                    __extends(CoderFixedBytes, _super);
                    function CoderFixedBytes(coerceFunc, length, localName) {
                        var _this = this;
                        var name1 = "bytes" + length;
                        _this = _super.call(this, coerceFunc, name1, name1, localName, false) || this;
                        _this.length = length;
                        return _this;
                    }
                    CoderFixedBytes.prototype.encode = function(value) {
                        var result = new Uint8Array(32);
                        try {
                            var data = bytes_1.arrayify(value);
                            if (data.length !== this.length) throw new Error("incorrect data length");
                            result.set(data);
                        } catch (error) {
                            errors.throwError("invalid " + this.name + " value", errors.INVALID_ARGUMENT, {
                                arg: this.localName,
                                coderType: this.name,
                                value: error.value || value
                            });
                        }
                        return result;
                    };
                    CoderFixedBytes.prototype.decode = function(data, offset) {
                        if (data.length < offset + 32) errors.throwError("insufficient data for " + name + " type", errors.INVALID_ARGUMENT, {
                            arg: this.localName,
                            coderType: this.name,
                            value: bytes_1.hexlify(data.slice(offset, offset + 32))
                        });
                        return {
                            consumed: 32,
                            value: this.coerceFunc(this.name, bytes_1.hexlify(data.slice(offset, offset + this.length)))
                        };
                    };
                    return CoderFixedBytes;
                }(Coder);
                var CoderAddress = /** @class */ function(_super) {
                    __extends(CoderAddress, _super);
                    function CoderAddress(coerceFunc, localName) {
                        return _super.call(this, coerceFunc, "address", "address", localName, false) || this;
                    }
                    CoderAddress.prototype.encode = function(value) {
                        var result = new Uint8Array(32);
                        try {
                            result.set(bytes_1.arrayify(address_1.getAddress(value, false)), 12);
                        } catch (error) {
                            errors.throwError("invalid address", errors.INVALID_ARGUMENT, {
                                arg: this.localName,
                                coderType: "address",
                                value: value
                            });
                        }
                        return result;
                    };
                    CoderAddress.prototype.decode = function(data, offset) {
                        if (data.length < offset + 32) errors.throwError("insufficuent data for address type", errors.INVALID_ARGUMENT, {
                            arg: this.localName,
                            coderType: "address",
                            value: bytes_1.hexlify(data.slice(offset, offset + 32))
                        });
                        return {
                            consumed: 32,
                            value: this.coerceFunc("address", address_1.getAddress(bytes_1.hexlify(data.slice(offset + 12, offset + 32)), false))
                        };
                    };
                    return CoderAddress;
                }(Coder);
                function _encodeDynamicBytes(value) {
                    var dataLength = 32 * Math.ceil(value.length / 32);
                    var padding = new Uint8Array(dataLength - value.length);
                    return bytes_1.concat([
                        uint256Coder.encode(value.length),
                        value,
                        padding
                    ]);
                }
                function _decodeDynamicBytes(data, offset, localName) {
                    if (data.length < offset + 32) errors.throwError("insufficient data for dynamicBytes length", errors.INVALID_ARGUMENT, {
                        arg: localName,
                        coderType: "dynamicBytes",
                        value: bytes_1.hexlify(data.slice(offset, offset + 32))
                    });
                    var length = uint256Coder.decode(data, offset).value;
                    try {
                        length = length.toNumber();
                    } catch (error) {
                        errors.throwError("dynamic bytes count too large", errors.INVALID_ARGUMENT, {
                            arg: localName,
                            coderType: "dynamicBytes",
                            value: length.toString()
                        });
                    }
                    if (data.length < offset + 32 + length) errors.throwError("insufficient data for dynamicBytes type", errors.INVALID_ARGUMENT, {
                        arg: localName,
                        coderType: "dynamicBytes",
                        value: bytes_1.hexlify(data.slice(offset, offset + 32 + length))
                    });
                    return {
                        consumed: 32 + 32 * Math.ceil(length / 32),
                        value: data.slice(offset + 32, offset + 32 + length)
                    };
                }
                var CoderDynamicBytes = /** @class */ function(_super) {
                    __extends(CoderDynamicBytes, _super);
                    function CoderDynamicBytes(coerceFunc, localName) {
                        return _super.call(this, coerceFunc, "bytes", "bytes", localName, true) || this;
                    }
                    CoderDynamicBytes.prototype.encode = function(value) {
                        try {
                            return _encodeDynamicBytes(bytes_1.arrayify(value));
                        } catch (error) {
                            errors.throwError("invalid bytes value", errors.INVALID_ARGUMENT, {
                                arg: this.localName,
                                coderType: "bytes",
                                value: error.value
                            });
                        }
                        return null;
                    };
                    CoderDynamicBytes.prototype.decode = function(data, offset) {
                        var result = _decodeDynamicBytes(data, offset, this.localName);
                        result.value = this.coerceFunc("bytes", bytes_1.hexlify(result.value));
                        return result;
                    };
                    return CoderDynamicBytes;
                }(Coder);
                var CoderString = /** @class */ function(_super) {
                    __extends(CoderString, _super);
                    function CoderString(coerceFunc, localName) {
                        return _super.call(this, coerceFunc, "string", "string", localName, true) || this;
                    }
                    CoderString.prototype.encode = function(value) {
                        if (typeof value !== "string") errors.throwError("invalid string value", errors.INVALID_ARGUMENT, {
                            arg: this.localName,
                            coderType: "string",
                            value: value
                        });
                        return _encodeDynamicBytes(utf8_1.toUtf8Bytes(value));
                    };
                    CoderString.prototype.decode = function(data, offset) {
                        var result = _decodeDynamicBytes(data, offset, this.localName);
                        result.value = this.coerceFunc("string", utf8_1.toUtf8String(result.value));
                        return result;
                    };
                    return CoderString;
                }(Coder);
                function alignSize(size) {
                    return 32 * Math.ceil(size / 32);
                }
                function pack(coders, values) {
                    if (Array.isArray(values)) ;
                    else if (values && typeof values === "object") {
                        var arrayValues = [];
                        coders.forEach(function(coder) {
                            arrayValues.push(values[coder.localName]);
                        });
                        values = arrayValues;
                    } else errors.throwError("invalid tuple value", errors.INVALID_ARGUMENT, {
                        coderType: "tuple",
                        value: values
                    });
                    if (coders.length !== values.length) errors.throwError("types/value length mismatch", errors.INVALID_ARGUMENT, {
                        coderType: "tuple",
                        value: values
                    });
                    var parts = [];
                    coders.forEach(function(coder, index) {
                        parts.push({
                            dynamic: coder.dynamic,
                            value: coder.encode(values[index])
                        });
                    });
                    var staticSize = 0, dynamicSize = 0;
                    parts.forEach(function(part) {
                        if (part.dynamic) {
                            staticSize += 32;
                            dynamicSize += alignSize(part.value.length);
                        } else staticSize += alignSize(part.value.length);
                    });
                    var offset = 0, dynamicOffset = staticSize;
                    var data = new Uint8Array(staticSize + dynamicSize);
                    parts.forEach(function(part) {
                        if (part.dynamic) {
                            //uint256Coder.encode(dynamicOffset).copy(data, offset);
                            data.set(uint256Coder.encode(dynamicOffset), offset);
                            offset += 32;
                            //part.value.copy(data, dynamicOffset);  @TODO
                            data.set(part.value, dynamicOffset);
                            dynamicOffset += alignSize(part.value.length);
                        } else {
                            //part.value.copy(data, offset);  @TODO
                            data.set(part.value, offset);
                            offset += alignSize(part.value.length);
                        }
                    });
                    return data;
                }
                function unpack(coders, data, offset) {
                    var baseOffset = offset;
                    var consumed = 0;
                    var value = [];
                    coders.forEach(function(coder) {
                        if (coder.dynamic) {
                            var dynamicOffset = uint256Coder.decode(data, offset);
                            var result = coder.decode(data, baseOffset + dynamicOffset.value.toNumber());
                            // The dynamic part is leap-frogged somewhere else; doesn't count towards size
                            result.consumed = dynamicOffset.consumed;
                        } else var result = coder.decode(data, offset);
                        if (result.value != undefined) value.push(result.value);
                        offset += result.consumed;
                        consumed += result.consumed;
                    });
                    coders.forEach(function(coder, index) {
                        var name1 = coder.localName;
                        if (!name1) return;
                        if (name1 === "length") name1 = "_length";
                        if (value[name1] != null) return;
                        value[name1] = value[index];
                    });
                    return {
                        value: value,
                        consumed: consumed
                    };
                }
                var CoderArray = /** @class */ function(_super) {
                    __extends(CoderArray, _super);
                    function CoderArray(coerceFunc, coder, length, localName) {
                        var _this = this;
                        var type = coder.type + "[" + (length >= 0 ? length : "") + "]";
                        var dynamic = length === -1 || coder.dynamic;
                        _this = _super.call(this, coerceFunc, "array", type, localName, dynamic) || this;
                        _this.coder = coder;
                        _this.length = length;
                        return _this;
                    }
                    CoderArray.prototype.encode = function(value) {
                        if (!Array.isArray(value)) errors.throwError("expected array value", errors.INVALID_ARGUMENT, {
                            arg: this.localName,
                            coderType: "array",
                            value: value
                        });
                        var count = this.length;
                        var result = new Uint8Array(0);
                        if (count === -1) {
                            count = value.length;
                            result = uint256Coder.encode(count);
                        }
                        errors.checkArgumentCount(count, value.length, " in coder array" + (this.localName ? " " + this.localName : ""));
                        var coders = [];
                        for(var i = 0; i < value.length; i++)coders.push(this.coder);
                        return bytes_1.concat([
                            result,
                            pack(coders, value)
                        ]);
                    };
                    CoderArray.prototype.decode = function(data, offset) {
                        // @TODO:
                        //if (data.length < offset + length * 32) { throw new Error('invalid array'); }
                        var consumed = 0;
                        var count = this.length;
                        if (count === -1) {
                            try {
                                var decodedLength = uint256Coder.decode(data, offset);
                            } catch (error) {
                                errors.throwError("insufficient data for dynamic array length", errors.INVALID_ARGUMENT, {
                                    arg: this.localName,
                                    coderType: "array",
                                    value: error.value
                                });
                            }
                            try {
                                count = decodedLength.value.toNumber();
                            } catch (error) {
                                errors.throwError("array count too large", errors.INVALID_ARGUMENT, {
                                    arg: this.localName,
                                    coderType: "array",
                                    value: decodedLength.value.toString()
                                });
                            }
                            consumed += decodedLength.consumed;
                            offset += decodedLength.consumed;
                        }
                        var coders = [];
                        for(var i = 0; i < count; i++)coders.push(new CoderAnonymous(this.coder));
                        var result = unpack(coders, data, offset);
                        result.consumed += consumed;
                        result.value = this.coerceFunc(this.type, result.value);
                        return result;
                    };
                    return CoderArray;
                }(Coder);
                var CoderTuple = /** @class */ function(_super) {
                    __extends(CoderTuple, _super);
                    function CoderTuple(coerceFunc, coders, localName) {
                        var _this = this;
                        var dynamic = false;
                        var types = [];
                        coders.forEach(function(coder) {
                            if (coder.dynamic) dynamic = true;
                            types.push(coder.type);
                        });
                        var type = "tuple(" + types.join(",") + ")";
                        _this = _super.call(this, coerceFunc, "tuple", type, localName, dynamic) || this;
                        _this.coders = coders;
                        return _this;
                    }
                    CoderTuple.prototype.encode = function(value) {
                        return pack(this.coders, value);
                    };
                    CoderTuple.prototype.decode = function(data, offset) {
                        var result = unpack(this.coders, data, offset);
                        result.value = this.coerceFunc(this.type, result.value);
                        return result;
                    };
                    return CoderTuple;
                }(Coder);
                /*
function getTypes(coders) {
    var type = coderTuple(coders).type;
    return type.substring(6, type.length - 1);
}
*/ function splitNesting(value) {
                    value = value.trim();
                    var result = [];
                    var accum = "";
                    var depth = 0;
                    for(var offset = 0; offset < value.length; offset++){
                        var c = value[offset];
                        if (c === "," && depth === 0) {
                            result.push(accum);
                            accum = "";
                        } else {
                            accum += c;
                            if (c === "(") depth++;
                            else if (c === ")") {
                                depth--;
                                if (depth === -1) throw new Error("unbalanced parenthsis");
                            }
                        }
                    }
                    if (accum) result.push(accum);
                    return result;
                }
                // @TODO: Is there a way to return "class"?
                var paramTypeSimple = {
                    address: CoderAddress,
                    bool: CoderBoolean,
                    string: CoderString,
                    bytes: CoderDynamicBytes
                };
                function getTupleParamCoder(coerceFunc, components, localName) {
                    if (!components) components = [];
                    var coders = [];
                    components.forEach(function(component) {
                        coders.push(getParamCoder(coerceFunc, component));
                    });
                    return new CoderTuple(coerceFunc, coders, localName);
                }
                function getParamCoder(coerceFunc, param) {
                    var coder = paramTypeSimple[param.type];
                    if (coder) return new coder(coerceFunc, param.name);
                    var match = param.type.match(paramTypeNumber);
                    if (match) {
                        var size = parseInt(match[2] || "256");
                        if (size === 0 || size > 256 || size % 8 !== 0) errors.throwError("invalid " + match[1] + " bit length", errors.INVALID_ARGUMENT, {
                            arg: "param",
                            value: param
                        });
                        return new CoderNumber(coerceFunc, size / 8, match[1] === "int", param.name);
                    }
                    var match = param.type.match(paramTypeBytes);
                    if (match) {
                        var size = parseInt(match[1]);
                        if (size === 0 || size > 32) errors.throwError("invalid bytes length", errors.INVALID_ARGUMENT, {
                            arg: "param",
                            value: param
                        });
                        return new CoderFixedBytes(coerceFunc, size, param.name);
                    }
                    var match = param.type.match(paramTypeArray);
                    if (match) {
                        var size = parseInt(match[2] || "-1");
                        param = properties_1.shallowCopy(param);
                        param.type = match[1];
                        param = properties_1.deepCopy(param);
                        return new CoderArray(coerceFunc, getParamCoder(coerceFunc, param), size, param.name);
                    }
                    if (param.type.substring(0, 5) === "tuple") return getTupleParamCoder(coerceFunc, param.components, param.name);
                    if (param.type === "") return new CoderNull(coerceFunc, param.name);
                    errors.throwError("invalid type", errors.INVALID_ARGUMENT, {
                        arg: "type",
                        value: param.type
                    });
                    return null;
                }
                var AbiCoder = /** @class */ function() {
                    function AbiCoder(coerceFunc) {
                        errors.checkNew(this, AbiCoder);
                        if (!coerceFunc) coerceFunc = exports.defaultCoerceFunc;
                        properties_1.defineReadOnly(this, "coerceFunc", coerceFunc);
                    }
                    AbiCoder.prototype.encode = function(types, values) {
                        if (types.length !== values.length) errors.throwError("types/values length mismatch", errors.INVALID_ARGUMENT, {
                            count: {
                                types: types.length,
                                values: values.length
                            },
                            value: {
                                types: types,
                                values: values
                            }
                        });
                        var coders = [];
                        types.forEach(function(type) {
                            // Convert types to type objects
                            //   - "uint foo" => { type: "uint", name: "foo" }
                            //   - "tuple(uint, uint)" => { type: "tuple", components: [ { type: "uint" }, { type: "uint" }, ] }
                            var typeObject = null;
                            if (typeof type === "string") typeObject = parseParam(type);
                            else typeObject = type;
                            coders.push(getParamCoder(this.coerceFunc, typeObject));
                        }, this);
                        return bytes_1.hexlify(new CoderTuple(this.coerceFunc, coders, "_").encode(values));
                    };
                    AbiCoder.prototype.decode = function(types, data) {
                        var coders = [];
                        types.forEach(function(type) {
                            // See encode for details
                            var typeObject = null;
                            if (typeof type === "string") typeObject = parseParam(type);
                            else typeObject = properties_1.deepCopy(type);
                            coders.push(getParamCoder(this.coerceFunc, typeObject));
                        }, this);
                        return new CoderTuple(this.coerceFunc, coders, "_").decode(bytes_1.arrayify(data), 0).value;
                    };
                    return AbiCoder;
                }();
                exports.AbiCoder = AbiCoder;
                exports.defaultAbiCoder = new AbiCoder();
            /***/ },
            /***/ 5638: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                // We use this for base 36 maths
                var bn_js_1 = __importDefault(__webpack_require__(5697));
                var bytes_1 = __webpack_require__(8458);
                var keccak256_1 = __webpack_require__(918);
                var rlp_1 = __webpack_require__(6100);
                var errors = __webpack_require__(6459);
                ///////////////////////////////
                function getChecksumAddress(address) {
                    if (typeof address !== "string" || !address.match(/^0x[0-9A-Fa-f]{40}$/)) errors.throwError("invalid address", errors.INVALID_ARGUMENT, {
                        arg: "address",
                        value: address
                    });
                    address = address.toLowerCase();
                    var chars = address.substring(2).split("");
                    var hashed = new Uint8Array(40);
                    for(var i_1 = 0; i_1 < 40; i_1++)hashed[i_1] = chars[i_1].charCodeAt(0);
                    hashed = bytes_1.arrayify(keccak256_1.keccak256(hashed));
                    for(var i = 0; i < 40; i += 2){
                        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
                        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
                    }
                    return "0x" + chars.join("");
                }
                // Shims for environments that are missing some required constants and functions
                var MAX_SAFE_INTEGER = 0x1fffffffffffff;
                function log10(x) {
                    if (Math.log10) return Math.log10(x);
                    return Math.log(x) / Math.LN10;
                }
                // See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
                // Create lookup table
                var ibanLookup = {};
                for(var i = 0; i < 10; i++)ibanLookup[String(i)] = String(i);
                for(var i = 0; i < 26; i++)ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
                // How many decimal digits can we process? (for 64-bit float, this is 15)
                var safeDigits = Math.floor(log10(MAX_SAFE_INTEGER));
                function ibanChecksum(address) {
                    address = address.toUpperCase();
                    address = address.substring(4) + address.substring(0, 2) + "00";
                    var expanded = "";
                    address.split("").forEach(function(c) {
                        expanded += ibanLookup[c];
                    });
                    // Javascript can handle integers safely up to 15 (decimal) digits
                    while(expanded.length >= safeDigits){
                        var block = expanded.substring(0, safeDigits);
                        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
                    }
                    var checksum = String(98 - parseInt(expanded, 10) % 97);
                    while(checksum.length < 2)checksum = "0" + checksum;
                    return checksum;
                }
                function getAddress(address, checksum) {
                    if (checksum === void 0) checksum = true;
                    var result = null;
                    if (typeof address !== "string") errors.throwError("invalid address", errors.INVALID_ARGUMENT, {
                        arg: "address",
                        value: address
                    });
                    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
                        // Missing the 0x prefix
                        if (address.substring(0, 2) !== "0x") address = "0x" + address;
                        if (checksum) {
                            result = getChecksumAddress(address);
                            // It is a checksummed address with a bad checksum
                            if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) errors.throwError("bad address checksum", errors.INVALID_ARGUMENT, {
                                arg: "address",
                                value: address
                            });
                        } else result = address;
                    // Maybe ICAP? (we only support direct mode)
                    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
                        // It is an ICAP address with a bad checksum
                        if (address.substring(2, 4) !== ibanChecksum(address)) errors.throwError("bad icap checksum", errors.INVALID_ARGUMENT, {
                            arg: "address",
                            value: address
                        });
                        result = new bn_js_1.default.BN(address.substring(4), 36).toString(16);
                        while(result.length < 40)result = "0" + result;
                        result = checksum ? getChecksumAddress("0x" + result) : "0x" + result;
                    } else errors.throwError("invalid address", errors.INVALID_ARGUMENT, {
                        arg: "address",
                        value: address
                    });
                    return result;
                }
                exports.getAddress = getAddress;
                function getIcapAddress(address) {
                    var base36 = new bn_js_1.default.BN(getAddress(address).substring(2), 16).toString(36).toUpperCase();
                    while(base36.length < 30)base36 = "0" + base36;
                    return "XE" + ibanChecksum("XE00" + base36) + base36;
                }
                exports.getIcapAddress = getIcapAddress;
                // http://ethereum.stackexchange.com/questions/760/how-is-the-address-of-an-ethereum-contract-computed
                function getContractAddress(transaction) {
                    if (!transaction.from) throw new Error("missing from address");
                    var nonce = transaction.nonce;
                    return getAddress("0x" + keccak256_1.keccak256(rlp_1.encode([
                        getAddress(transaction.from),
                        bytes_1.stripZeros(bytes_1.hexlify(nonce))
                    ])).substring(26));
                }
                exports.getContractAddress = getContractAddress;
            /***/ },
            /***/ 4759: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                var __importStar = this && this.__importStar || function(mod) {
                    if (mod && mod.__esModule) return mod;
                    var result = {};
                    if (mod != null) {
                        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
                    }
                    result["default"] = mod;
                    return result;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                /**
 *  BigNumber
 *
 *  A wrapper around the BN.js object. We use the BN.js library
 *  because it is used by elliptic, so it is required regardles.
 *
 */ var bn_js_1 = __importDefault(__webpack_require__(5697));
                var bytes_1 = __webpack_require__(8458);
                var properties_1 = __webpack_require__(8184);
                var errors = __importStar(__webpack_require__(6459));
                var BN_1 = new bn_js_1.default.BN(-1);
                function toHex(bn) {
                    var value = bn.toString(16);
                    if (value[0] === "-") {
                        if (value.length % 2 === 0) return "-0x0" + value.substring(1);
                        return "-0x" + value.substring(1);
                    }
                    if (value.length % 2 === 1) return "0x0" + value;
                    return "0x" + value;
                }
                function toBN(value) {
                    return _bnify(bigNumberify(value));
                }
                function toBigNumber(bn) {
                    return new BigNumber(toHex(bn));
                }
                function _bnify(value) {
                    var hex = value._hex;
                    if (hex[0] === "-") return new bn_js_1.default.BN(hex.substring(3), 16).mul(BN_1);
                    return new bn_js_1.default.BN(hex.substring(2), 16);
                }
                var BigNumber = /** @class */ function() {
                    function BigNumber(value) {
                        errors.checkNew(this, BigNumber);
                        properties_1.setType(this, "BigNumber");
                        if (typeof value === "string") {
                            if (bytes_1.isHexString(value)) {
                                if (value == "0x") value = "0x0";
                                properties_1.defineReadOnly(this, "_hex", value);
                            } else if (value[0] === "-" && bytes_1.isHexString(value.substring(1))) properties_1.defineReadOnly(this, "_hex", value);
                            else if (value.match(/^-?[0-9]*$/)) {
                                if (value == "") value = "0";
                                properties_1.defineReadOnly(this, "_hex", toHex(new bn_js_1.default.BN(value)));
                            } else errors.throwError("invalid BigNumber string value", errors.INVALID_ARGUMENT, {
                                arg: "value",
                                value: value
                            });
                        } else if (typeof value === "number") {
                            if (parseInt(String(value)) !== value) errors.throwError("underflow", errors.NUMERIC_FAULT, {
                                operation: "setValue",
                                fault: "underflow",
                                value: value,
                                outputValue: parseInt(String(value))
                            });
                            try {
                                properties_1.defineReadOnly(this, "_hex", toHex(new bn_js_1.default.BN(value)));
                            } catch (error) {
                                errors.throwError("overflow", errors.NUMERIC_FAULT, {
                                    operation: "setValue",
                                    fault: "overflow",
                                    details: error.message
                                });
                            }
                        } else if (value instanceof BigNumber) properties_1.defineReadOnly(this, "_hex", value._hex);
                        else if (value.toHexString) properties_1.defineReadOnly(this, "_hex", toHex(toBN(value.toHexString())));
                        else if (value._hex && bytes_1.isHexString(value._hex)) properties_1.defineReadOnly(this, "_hex", value._hex);
                        else if (bytes_1.isArrayish(value)) properties_1.defineReadOnly(this, "_hex", toHex(new bn_js_1.default.BN(bytes_1.hexlify(value).substring(2), 16)));
                        else errors.throwError("invalid BigNumber value", errors.INVALID_ARGUMENT, {
                            arg: "value",
                            value: value
                        });
                    }
                    BigNumber.prototype.fromTwos = function(value) {
                        return toBigNumber(_bnify(this).fromTwos(value));
                    };
                    BigNumber.prototype.toTwos = function(value) {
                        return toBigNumber(_bnify(this).toTwos(value));
                    };
                    BigNumber.prototype.abs = function() {
                        if (this._hex[0] === "-") return toBigNumber(_bnify(this).mul(BN_1));
                        return this;
                    };
                    BigNumber.prototype.add = function(other) {
                        return toBigNumber(_bnify(this).add(toBN(other)));
                    };
                    BigNumber.prototype.sub = function(other) {
                        return toBigNumber(_bnify(this).sub(toBN(other)));
                    };
                    BigNumber.prototype.div = function(other) {
                        var o = bigNumberify(other);
                        if (o.isZero()) errors.throwError("division by zero", errors.NUMERIC_FAULT, {
                            operation: "divide",
                            fault: "division by zero"
                        });
                        return toBigNumber(_bnify(this).div(toBN(other)));
                    };
                    BigNumber.prototype.mul = function(other) {
                        return toBigNumber(_bnify(this).mul(toBN(other)));
                    };
                    BigNumber.prototype.mod = function(other) {
                        return toBigNumber(_bnify(this).mod(toBN(other)));
                    };
                    BigNumber.prototype.pow = function(other) {
                        return toBigNumber(_bnify(this).pow(toBN(other)));
                    };
                    BigNumber.prototype.maskn = function(value) {
                        return toBigNumber(_bnify(this).maskn(value));
                    };
                    BigNumber.prototype.eq = function(other) {
                        return _bnify(this).eq(toBN(other));
                    };
                    BigNumber.prototype.lt = function(other) {
                        return _bnify(this).lt(toBN(other));
                    };
                    BigNumber.prototype.lte = function(other) {
                        return _bnify(this).lte(toBN(other));
                    };
                    BigNumber.prototype.gt = function(other) {
                        return _bnify(this).gt(toBN(other));
                    };
                    BigNumber.prototype.gte = function(other) {
                        return _bnify(this).gte(toBN(other));
                    };
                    BigNumber.prototype.isZero = function() {
                        return _bnify(this).isZero();
                    };
                    BigNumber.prototype.toNumber = function() {
                        try {
                            return _bnify(this).toNumber();
                        } catch (error) {
                            errors.throwError("overflow", errors.NUMERIC_FAULT, {
                                operation: "setValue",
                                fault: "overflow",
                                details: error.message
                            });
                        }
                        return null;
                    };
                    BigNumber.prototype.toString = function() {
                        return _bnify(this).toString(10);
                    };
                    BigNumber.prototype.toHexString = function() {
                        return this._hex;
                    };
                    BigNumber.isBigNumber = function(value) {
                        return properties_1.isType(value, "BigNumber");
                    };
                    return BigNumber;
                }();
                exports.BigNumber = BigNumber;
                function bigNumberify(value) {
                    if (BigNumber.isBigNumber(value)) return value;
                    return new BigNumber(value);
                }
                exports.bigNumberify = bigNumberify;
            /***/ },
            /***/ 8458: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                /**
 *  Conversion Utilities
 *
 */ var __importStar = this && this.__importStar || function(mod) {
                    if (mod && mod.__esModule) return mod;
                    var result = {};
                    if (mod != null) {
                        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
                    }
                    result["default"] = mod;
                    return result;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var errors = __importStar(__webpack_require__(6459));
                ///////////////////////////////
                function isHexable(value) {
                    return !!value.toHexString;
                }
                exports.isHexable = isHexable;
                function addSlice(array) {
                    if (array.slice) return array;
                    array.slice = function() {
                        var args = Array.prototype.slice.call(arguments);
                        return addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
                    };
                    return array;
                }
                function isArrayish(value) {
                    if (!value || parseInt(String(value.length)) != value.length || typeof value === "string") return false;
                    for(var i = 0; i < value.length; i++){
                        var v = value[i];
                        if (v < 0 || v >= 256 || parseInt(String(v)) != v) return false;
                    }
                    return true;
                }
                exports.isArrayish = isArrayish;
                function arrayify(value) {
                    if (value == null) errors.throwError("cannot convert null value to array", errors.INVALID_ARGUMENT, {
                        arg: "value",
                        value: value
                    });
                    if (isHexable(value)) value = value.toHexString();
                    if (typeof value === "string") {
                        var match = value.match(/^(0x)?[0-9a-fA-F]*$/);
                        if (!match) errors.throwError("invalid hexidecimal string", errors.INVALID_ARGUMENT, {
                            arg: "value",
                            value: value
                        });
                        if (match[1] !== "0x") errors.throwError("hex string must have 0x prefix", errors.INVALID_ARGUMENT, {
                            arg: "value",
                            value: value
                        });
                        value = value.substring(2);
                        if (value.length % 2) value = "0" + value;
                        var result = [];
                        for(var i = 0; i < value.length; i += 2)result.push(parseInt(value.substr(i, 2), 16));
                        return addSlice(new Uint8Array(result));
                    }
                    if (isArrayish(value)) return addSlice(new Uint8Array(value));
                    errors.throwError("invalid arrayify value", null, {
                        arg: "value",
                        value: value,
                        type: typeof value
                    });
                    return null;
                }
                exports.arrayify = arrayify;
                function concat(objects) {
                    var arrays = [];
                    var length = 0;
                    for(var i = 0; i < objects.length; i++){
                        var object = arrayify(objects[i]);
                        arrays.push(object);
                        length += object.length;
                    }
                    var result = new Uint8Array(length);
                    var offset = 0;
                    for(var i = 0; i < arrays.length; i++){
                        result.set(arrays[i], offset);
                        offset += arrays[i].length;
                    }
                    return addSlice(result);
                }
                exports.concat = concat;
                function stripZeros(value) {
                    var result = arrayify(value);
                    if (result.length === 0) return result;
                    // Find the first non-zero entry
                    var start = 0;
                    while(result[start] === 0)start++;
                    // If we started with zeros, strip them
                    if (start) result = result.slice(start);
                    return result;
                }
                exports.stripZeros = stripZeros;
                function padZeros(value, length) {
                    value = arrayify(value);
                    if (length < value.length) throw new Error("cannot pad");
                    var result = new Uint8Array(length);
                    result.set(value, length - value.length);
                    return addSlice(result);
                }
                exports.padZeros = padZeros;
                function isHexString(value, length) {
                    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
                    if (length && value.length !== 2 + 2 * length) return false;
                    return true;
                }
                exports.isHexString = isHexString;
                var HexCharacters = "0123456789abcdef";
                function hexlify(value) {
                    if (isHexable(value)) return value.toHexString();
                    if (typeof value === "number") {
                        if (value < 0) errors.throwError("cannot hexlify negative value", errors.INVALID_ARGUMENT, {
                            arg: "value",
                            value: value
                        });
                        // @TODO: Roll this into the above error as a numeric fault (overflow); next version, not backward compatible
                        // We can about (value == MAX_INT) to as well, since that may indicate we underflowed already
                        if (value >= 9007199254740991) errors.throwError("out-of-range", errors.NUMERIC_FAULT, {
                            operartion: "hexlify",
                            fault: "out-of-safe-range"
                        });
                        var hex = "";
                        while(value){
                            hex = HexCharacters[value & 0x0f] + hex;
                            value = Math.floor(value / 16);
                        }
                        if (hex.length) {
                            if (hex.length % 2) hex = "0" + hex;
                            return "0x" + hex;
                        }
                        return "0x00";
                    }
                    if (typeof value === "string") {
                        var match = value.match(/^(0x)?[0-9a-fA-F]*$/);
                        if (!match) errors.throwError("invalid hexidecimal string", errors.INVALID_ARGUMENT, {
                            arg: "value",
                            value: value
                        });
                        if (match[1] !== "0x") errors.throwError("hex string must have 0x prefix", errors.INVALID_ARGUMENT, {
                            arg: "value",
                            value: value
                        });
                        if (value.length % 2) value = "0x0" + value.substring(2);
                        return value;
                    }
                    if (isArrayish(value)) {
                        var result = [];
                        for(var i = 0; i < value.length; i++){
                            var v = value[i];
                            result.push(HexCharacters[(v & 0xf0) >> 4] + HexCharacters[v & 0x0f]);
                        }
                        return "0x" + result.join("");
                    }
                    errors.throwError("invalid hexlify value", null, {
                        arg: "value",
                        value: value
                    });
                    return "never";
                }
                exports.hexlify = hexlify;
                function hexDataLength(data) {
                    if (!isHexString(data) || data.length % 2 !== 0) return null;
                    return (data.length - 2) / 2;
                }
                exports.hexDataLength = hexDataLength;
                function hexDataSlice(data, offset, endOffset) {
                    if (!isHexString(data)) errors.throwError("invalid hex data", errors.INVALID_ARGUMENT, {
                        arg: "value",
                        value: data
                    });
                    if (data.length % 2 !== 0) errors.throwError("hex data length must be even", errors.INVALID_ARGUMENT, {
                        arg: "value",
                        value: data
                    });
                    offset = 2 + 2 * offset;
                    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
                    return "0x" + data.substring(offset);
                }
                exports.hexDataSlice = hexDataSlice;
                function hexStripZeros(value) {
                    if (!isHexString(value)) errors.throwError("invalid hex string", errors.INVALID_ARGUMENT, {
                        arg: "value",
                        value: value
                    });
                    while(value.length > 3 && value.substring(0, 3) === "0x0")value = "0x" + value.substring(3);
                    return value;
                }
                exports.hexStripZeros = hexStripZeros;
                function hexZeroPad(value, length) {
                    if (!isHexString(value)) errors.throwError("invalid hex string", errors.INVALID_ARGUMENT, {
                        arg: "value",
                        value: value
                    });
                    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
                    return value;
                }
                exports.hexZeroPad = hexZeroPad;
                function isSignature(value) {
                    return value && value.r != null && value.s != null;
                }
                function splitSignature(signature) {
                    var v = 0;
                    var r = "0x", s = "0x";
                    if (isSignature(signature)) {
                        if (signature.v == null && signature.recoveryParam == null) errors.throwError("at least on of recoveryParam or v must be specified", errors.INVALID_ARGUMENT, {
                            argument: "signature",
                            value: signature
                        });
                        r = hexZeroPad(signature.r, 32);
                        s = hexZeroPad(signature.s, 32);
                        v = signature.v;
                        if (typeof v === "string") v = parseInt(v, 16);
                        var recoveryParam = signature.recoveryParam;
                        if (recoveryParam == null && signature.v != null) recoveryParam = 1 - v % 2;
                        v = 27 + recoveryParam;
                    } else {
                        var bytes = arrayify(signature);
                        if (bytes.length !== 65) throw new Error("invalid signature");
                        r = hexlify(bytes.slice(0, 32));
                        s = hexlify(bytes.slice(32, 64));
                        v = bytes[64];
                        if (v !== 27 && v !== 28) v = 27 + v % 2;
                    }
                    return {
                        r: r,
                        s: s,
                        recoveryParam: v - 27,
                        v: v
                    };
                }
                exports.splitSignature = splitSignature;
                function joinSignature(signature) {
                    signature = splitSignature(signature);
                    return hexlify(concat([
                        signature.r,
                        signature.s,
                        signature.recoveryParam ? "0x1c" : "0x1b"
                    ]));
                }
                exports.joinSignature = joinSignature;
            /***/ },
            /***/ 918: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var sha3 = __webpack_require__(747);
                var bytes_1 = __webpack_require__(8458);
                function keccak256(data) {
                    return "0x" + sha3.keccak_256(bytes_1.arrayify(data));
                }
                exports.keccak256 = keccak256;
            /***/ },
            /***/ 8184: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importStar = this && this.__importStar || function(mod) {
                    if (mod && mod.__esModule) return mod;
                    var result = {};
                    if (mod != null) {
                        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
                    }
                    result["default"] = mod;
                    return result;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var errors = __importStar(__webpack_require__(6459));
                function defineReadOnly(object, name1, value) {
                    Object.defineProperty(object, name1, {
                        enumerable: true,
                        value: value,
                        writable: false
                    });
                }
                exports.defineReadOnly = defineReadOnly;
                // There are some issues with instanceof with npm link, so we use this
                // to ensure types are what we expect.
                function setType(object, type) {
                    Object.defineProperty(object, "_ethersType", {
                        configurable: false,
                        value: type,
                        writable: false
                    });
                }
                exports.setType = setType;
                function isType(object, type) {
                    return object && object._ethersType === type;
                }
                exports.isType = isType;
                function resolveProperties(object) {
                    var result = {};
                    var promises = [];
                    Object.keys(object).forEach(function(key) {
                        var value = object[key];
                        if (value instanceof Promise) promises.push(value.then(function(value) {
                            result[key] = value;
                            return null;
                        }));
                        else result[key] = value;
                    });
                    return Promise.all(promises).then(function() {
                        return result;
                    });
                }
                exports.resolveProperties = resolveProperties;
                function checkProperties(object, properties) {
                    if (!object || typeof object !== "object") errors.throwError("invalid object", errors.INVALID_ARGUMENT, {
                        argument: "object",
                        value: object
                    });
                    Object.keys(object).forEach(function(key) {
                        if (!properties[key]) errors.throwError("invalid object key - " + key, errors.INVALID_ARGUMENT, {
                            argument: "transaction",
                            value: object,
                            key: key
                        });
                    });
                }
                exports.checkProperties = checkProperties;
                function shallowCopy(object) {
                    var result = {};
                    for(var key in object)result[key] = object[key];
                    return result;
                }
                exports.shallowCopy = shallowCopy;
                var opaque = {
                    boolean: true,
                    number: true,
                    string: true
                };
                function deepCopy(object, frozen) {
                    // Opaque objects are not mutable, so safe to copy by assignment
                    if (object === undefined || object === null || opaque[typeof object]) return object;
                    // Arrays are mutable, so we need to create a copy
                    if (Array.isArray(object)) {
                        var result = object.map(function(item) {
                            return deepCopy(item, frozen);
                        });
                        if (frozen) Object.freeze(result);
                        return result;
                    }
                    if (typeof object === "object") {
                        // Some internal objects, which are already immutable
                        if (isType(object, "BigNumber")) return object;
                        if (isType(object, "Description")) return object;
                        if (isType(object, "Indexed")) return object;
                        var result = {};
                        for(var key in object){
                            var value = object[key];
                            if (value === undefined) continue;
                            defineReadOnly(result, key, deepCopy(value, frozen));
                        }
                        if (frozen) Object.freeze(result);
                        return result;
                    }
                    // The function type is also immutable, so safe to copy by assignment
                    if (typeof object === "function") return object;
                    throw new Error("Cannot deepCopy " + typeof object);
                }
                exports.deepCopy = deepCopy;
                // See: https://github.com/isaacs/inherits/blob/master/inherits_browser.js
                function inherits(ctor, superCtor) {
                    ctor.super_ = superCtor;
                    ctor.prototype = Object.create(superCtor.prototype, {
                        constructor: {
                            value: ctor,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                }
                function inheritable(parent) {
                    return function(child) {
                        inherits(child, parent);
                        defineReadOnly(child, "inherits", inheritable(child));
                    };
                }
                exports.inheritable = inheritable;
            /***/ },
            /***/ 6100: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                //See: https://github.com/ethereum/wiki/wiki/RLP
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var bytes_1 = __webpack_require__(8458);
                function arrayifyInteger(value) {
                    var result = [];
                    while(value){
                        result.unshift(value & 0xff);
                        value >>= 8;
                    }
                    return result;
                }
                function unarrayifyInteger(data, offset, length) {
                    var result = 0;
                    for(var i = 0; i < length; i++)result = result * 256 + data[offset + i];
                    return result;
                }
                function _encode(object) {
                    if (Array.isArray(object)) {
                        var payload = [];
                        object.forEach(function(child) {
                            payload = payload.concat(_encode(child));
                        });
                        if (payload.length <= 55) {
                            payload.unshift(0xc0 + payload.length);
                            return payload;
                        }
                        var length = arrayifyInteger(payload.length);
                        length.unshift(0xf7 + length.length);
                        return length.concat(payload);
                    }
                    var data = Array.prototype.slice.call(bytes_1.arrayify(object));
                    if (data.length === 1 && data[0] <= 0x7f) return data;
                    else if (data.length <= 55) {
                        data.unshift(0x80 + data.length);
                        return data;
                    }
                    var length = arrayifyInteger(data.length);
                    length.unshift(0xb7 + length.length);
                    return length.concat(data);
                }
                function encode(object) {
                    return bytes_1.hexlify(_encode(object));
                }
                exports.encode = encode;
                function _decodeChildren(data, offset, childOffset, length) {
                    var result = [];
                    while(childOffset < offset + 1 + length){
                        var decoded = _decode(data, childOffset);
                        result.push(decoded.result);
                        childOffset += decoded.consumed;
                        if (childOffset > offset + 1 + length) throw new Error("invalid rlp");
                    }
                    return {
                        consumed: 1 + length,
                        result: result
                    };
                }
                // returns { consumed: number, result: Object }
                function _decode(data, offset) {
                    if (data.length === 0) throw new Error("invalid rlp data");
                    // Array with extra length prefix
                    if (data[offset] >= 0xf8) {
                        var lengthLength = data[offset] - 0xf7;
                        if (offset + 1 + lengthLength > data.length) throw new Error("too short");
                        var length = unarrayifyInteger(data, offset + 1, lengthLength);
                        if (offset + 1 + lengthLength + length > data.length) throw new Error("to short");
                        return _decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
                    } else if (data[offset] >= 0xc0) {
                        var length = data[offset] - 0xc0;
                        if (offset + 1 + length > data.length) throw new Error("invalid rlp data");
                        return _decodeChildren(data, offset, offset + 1, length);
                    } else if (data[offset] >= 0xb8) {
                        var lengthLength = data[offset] - 0xb7;
                        if (offset + 1 + lengthLength > data.length) throw new Error("invalid rlp data");
                        var length = unarrayifyInteger(data, offset + 1, lengthLength);
                        if (offset + 1 + lengthLength + length > data.length) throw new Error("invalid rlp data");
                        var result = bytes_1.hexlify(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
                        return {
                            consumed: 1 + lengthLength + length,
                            result: result
                        };
                    } else if (data[offset] >= 0x80) {
                        var length = data[offset] - 0x80;
                        if (offset + 1 + length > data.length) throw new Error("invlaid rlp data");
                        var result = bytes_1.hexlify(data.slice(offset + 1, offset + 1 + length));
                        return {
                            consumed: 1 + length,
                            result: result
                        };
                    }
                    return {
                        consumed: 1,
                        result: bytes_1.hexlify(data[offset])
                    };
                }
                function decode(data) {
                    var bytes = bytes_1.arrayify(data);
                    var decoded = _decode(bytes, 0);
                    if (decoded.consumed !== bytes.length) throw new Error("invalid rlp data");
                    return decoded.result;
                }
                exports.decode = decode;
            /***/ },
            /***/ 1165: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var constants_1 = __webpack_require__(8707);
                var errors_1 = __webpack_require__(6459);
                var bytes_1 = __webpack_require__(8458);
                ///////////////////////////////
                var UnicodeNormalizationForm;
                (function(UnicodeNormalizationForm) {
                    UnicodeNormalizationForm["current"] = "";
                    UnicodeNormalizationForm["NFC"] = "NFC";
                    UnicodeNormalizationForm["NFD"] = "NFD";
                    UnicodeNormalizationForm["NFKC"] = "NFKC";
                    UnicodeNormalizationForm["NFKD"] = "NFKD";
                })(UnicodeNormalizationForm = exports.UnicodeNormalizationForm || (exports.UnicodeNormalizationForm = {}));
                // http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array
                function toUtf8Bytes(str, form) {
                    if (form === void 0) form = UnicodeNormalizationForm.current;
                    if (form != UnicodeNormalizationForm.current) {
                        errors_1.checkNormalize();
                        str = str.normalize(form);
                    }
                    var result = [];
                    for(var i = 0; i < str.length; i++){
                        var c = str.charCodeAt(i);
                        if (c < 0x80) result.push(c);
                        else if (c < 0x800) {
                            result.push(c >> 6 | 0xc0);
                            result.push(c & 0x3f | 0x80);
                        } else if ((c & 0xfc00) == 0xd800) {
                            i++;
                            var c2 = str.charCodeAt(i);
                            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
                            // Surrogate Pair
                            c = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
                            result.push(c >> 18 | 0xf0);
                            result.push(c >> 12 & 0x3f | 0x80);
                            result.push(c >> 6 & 0x3f | 0x80);
                            result.push(c & 0x3f | 0x80);
                        } else {
                            result.push(c >> 12 | 0xe0);
                            result.push(c >> 6 & 0x3f | 0x80);
                            result.push(c & 0x3f | 0x80);
                        }
                    }
                    return bytes_1.arrayify(result);
                }
                exports.toUtf8Bytes = toUtf8Bytes;
                // http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
                function toUtf8String(bytes, ignoreErrors) {
                    bytes = bytes_1.arrayify(bytes);
                    var result = "";
                    var i = 0;
                    // Invalid bytes are ignored
                    while(i < bytes.length){
                        var c = bytes[i++];
                        // 0xxx xxxx
                        if (c >> 7 === 0) {
                            result += String.fromCharCode(c);
                            continue;
                        }
                        // Multibyte; how many bytes left for this character?
                        var extraLength = null;
                        var overlongMask = null;
                        // 110x xxxx 10xx xxxx
                        if ((c & 0xe0) === 0xc0) {
                            extraLength = 1;
                            overlongMask = 0x7f;
                        // 1110 xxxx 10xx xxxx 10xx xxxx
                        } else if ((c & 0xf0) === 0xe0) {
                            extraLength = 2;
                            overlongMask = 0x7ff;
                        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
                        } else if ((c & 0xf8) === 0xf0) {
                            extraLength = 3;
                            overlongMask = 0xffff;
                        } else {
                            if (!ignoreErrors) {
                                if ((c & 0xc0) === 0x80) throw new Error("invalid utf8 byte sequence; unexpected continuation byte");
                                throw new Error("invalid utf8 byte sequence; invalid prefix");
                            }
                            continue;
                        }
                        // Do we have enough bytes in our data?
                        if (i + extraLength > bytes.length) {
                            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; too short");
                            // If there is an invalid unprocessed byte, skip continuation bytes
                            for(; i < bytes.length; i++){
                                if (bytes[i] >> 6 !== 0x02) break;
                            }
                            continue;
                        }
                        // Remove the length prefix from the char
                        var res = c & (1 << 8 - extraLength - 1) - 1;
                        for(var j = 0; j < extraLength; j++){
                            var nextChar = bytes[i];
                            // Invalid continuation byte
                            if ((nextChar & 0xc0) != 0x80) {
                                res = null;
                                break;
                            }
                            res = res << 6 | nextChar & 0x3f;
                            i++;
                        }
                        if (res === null) {
                            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; invalid continuation byte");
                            continue;
                        }
                        // Check for overlong seuences (more bytes than needed)
                        if (res <= overlongMask) {
                            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; overlong");
                            continue;
                        }
                        // Maximum code point
                        if (res > 0x10ffff) {
                            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; out-of-range");
                            continue;
                        }
                        // Reserved for UTF-16 surrogate halves
                        if (res >= 0xd800 && res <= 0xdfff) {
                            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; utf-16 surrogate");
                            continue;
                        }
                        if (res <= 0xffff) {
                            result += String.fromCharCode(res);
                            continue;
                        }
                        res -= 0x10000;
                        result += String.fromCharCode((res >> 10 & 0x3ff) + 0xd800, (res & 0x3ff) + 0xdc00);
                    }
                    return result;
                }
                exports.toUtf8String = toUtf8String;
                function formatBytes32String(text) {
                    // Get the bytes
                    var bytes = toUtf8Bytes(text);
                    // Check we have room for null-termination
                    if (bytes.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
                    // Zero-pad (implicitly null-terminates)
                    return bytes_1.hexlify(bytes_1.concat([
                        bytes,
                        constants_1.HashZero
                    ]).slice(0, 32));
                }
                exports.formatBytes32String = formatBytes32String;
                function parseBytes32String(bytes) {
                    var data = bytes_1.arrayify(bytes);
                    // Must be 32 bytes with a null-termination
                    if (data.length !== 32) throw new Error("invalid bytes32 - not 32 bytes long");
                    if (data[31] !== 0) throw new Error("invalid bytes32 sdtring - no null terminator");
                    // Find the null termination
                    var length = 31;
                    while(data[length - 1] === 0)length--;
                    // Determine the string value
                    return toUtf8String(data.slice(0, length));
                }
                exports.parseBytes32String = parseBytes32String;
            /***/ },
            /***/ 634: /***/ function(module1, exports, __webpack_require__) {
                var __WEBPACK_AMD_DEFINE_RESULT__;
                (function(globalObject) {
                    "use strict";
                    /*
 *      bignumber.js v7.2.1
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2018 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
                    POWS_TEN = [
                        1,
                        10,
                        100,
                        1e3,
                        1e4,
                        1e5,
                        1e6,
                        1e7,
                        1e8,
                        1e9,
                        1e10,
                        1e11,
                        1e12,
                        1e13
                    ], SQRT_BASE = 1e7, // EDITABLE
                    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
                    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
                    MAX = 1E9; // 0 to MAX_INT32
                    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
                        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
                            constructor: BigNumber,
                            toString: null,
                            valueOf: null
                        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
                        // The default values below must be integers within the inclusive ranges stated.
                        // The values can also be changed at run-time using BigNumber.set.
                        // The maximum number of decimal places for operations involving division.
                        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
                        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
                        // UP         0 Away from zero.
                        // DOWN       1 Towards zero.
                        // CEIL       2 Towards +Infinity.
                        // FLOOR      3 Towards -Infinity.
                        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
                        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
                        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
                        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
                        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
                        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
                        // The exponent value at and beneath which toString returns exponential notation.
                        // Number type: -7
                        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
                        // Number type: 21
                        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
                        // The minimum exponent value, beneath which underflow to zero occurs.
                        // Number type: -324  (5e-324)
                        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
                        // Number type:  308  (1.7976931348623157e+308)
                        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
                        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
                        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
                        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
                        // The remainder (r) is calculated as: r = a - n * q.
                        //
                        // UP        0 The remainder is positive if the dividend is negative, else is negative.
                        // DOWN      1 The remainder has the same sign as the dividend.
                        //             This modulo mode is commonly known as 'truncated division' and is
                        //             equivalent to (a % n) in JavaScript.
                        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
                        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
                        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
                        //             The remainder is always positive.
                        //
                        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
                        // modes are commonly used for the modulus operation.
                        // Although the other rounding modes can also be used, they may not give useful results.
                        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
                        // If POW_PRECISION is 0, there will be unlimited significant digits.
                        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
                        FORMAT = {
                            decimalSeparator: ".",
                            groupSeparator: ",",
                            groupSize: 3,
                            secondaryGroupSize: 0,
                            fractionGroupSeparator: "\xa0",
                            fractionGroupSize: 0
                        }, // The alphabet used for base conversion.
                        // It must be at least 2 characters long, with no '.' or repeated character.
                        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
                        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
                        //------------------------------------------------------------------------------------------
                        // CONSTRUCTOR
                        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * n {number|string|BigNumber} A numeric value.
     * [b] {number} The base of n. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(n, b) {
                            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
                            // Enable constructor usage without new.
                            if (!(x instanceof BigNumber)) // Don't throw on constructor call without new (#81).
                            // '[BigNumber Error] Constructor call without new: {n}'
                            //throw Error(bignumberError + ' Constructor call without new: ' + n);
                            return new BigNumber(n, b);
                            if (b == null) {
                                // Duplicate.
                                if (n instanceof BigNumber) {
                                    x.s = n.s;
                                    x.e = n.e;
                                    x.c = (n = n.c) ? n.slice() : n;
                                    return;
                                }
                                isNum = typeof n == "number";
                                if (isNum && n * 0 == 0) {
                                    // Use `1 / n` to handle minus zero also.
                                    x.s = 1 / n < 0 ? (n = -n, -1) : 1;
                                    // Faster path for integers.
                                    if (n === ~~n) {
                                        for(e = 0, i = n; i >= 10; i /= 10, e++);
                                        x.e = e;
                                        x.c = [
                                            n
                                        ];
                                        return;
                                    }
                                    str = n + "";
                                } else {
                                    if (!isNumeric.test(str = n + "")) return parseNumeric(x, str, isNum);
                                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                                }
                                // Decimal point?
                                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                                // Exponential form?
                                if ((i = str.search(/e/i)) > 0) {
                                    // Determine exponent.
                                    if (e < 0) e = i;
                                    e += +str.slice(i + 1);
                                    str = str.substring(0, i);
                                } else if (e < 0) // Integer.
                                e = str.length;
                            } else {
                                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                                intCheck(b, 2, ALPHABET.length, "Base");
                                str = n + "";
                                // Allow exponential notation to be used with base 10 argument, while
                                // also rounding to DECIMAL_PLACES as with other bases.
                                if (b == 10) {
                                    x = new BigNumber(n instanceof BigNumber ? n : str);
                                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                                }
                                isNum = typeof n == "number";
                                if (isNum) {
                                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                                    if (n * 0 != 0) return parseNumeric(x, str, isNum, b);
                                    x.s = 1 / n < 0 ? (str = str.slice(1), -1) : 1;
                                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + n);
                                    // Prevent later check for length on converted number.
                                    isNum = false;
                                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                                alphabet = ALPHABET.slice(0, b);
                                e = i = 0;
                                // Check that str is a valid base b number.
                                // Don't use RegExp so alphabet can contain special characters.
                                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                                    if (c == ".") // If '.' is not the first character and it has not be found before.
                                    {
                                        if (i > e) {
                                            e = len;
                                            continue;
                                        }
                                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                                    {
                                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                                            caseChanged = true;
                                            i = -1;
                                            e = 0;
                                            continue;
                                        }
                                    }
                                    return parseNumeric(x, n + "", isNum, b);
                                }
                                str = convertBase(str, b, 10, x.s);
                                // Decimal point?
                                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                                else e = str.length;
                            }
                            // Determine leading zeros.
                            for(i = 0; str.charCodeAt(i) === 48; i++);
                            // Determine trailing zeros.
                            for(len = str.length; str.charCodeAt(--len) === 48;);
                            str = str.slice(i, ++len);
                            if (str) {
                                len -= i;
                                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                                if (isNum && BigNumber.DEBUG && len > 15 && (n > MAX_SAFE_INTEGER || n !== mathfloor(n))) throw Error(tooManyDigits + x.s * n);
                                e = e - i - 1;
                                // Overflow?
                                if (e > MAX_EXP) // Infinity.
                                x.c = x.e = null;
                                else if (e < MIN_EXP) // Zero.
                                x.c = [
                                    x.e = 0
                                ];
                                else {
                                    x.e = e;
                                    x.c = [];
                                    // Transform base
                                    // e is the base 10 exponent.
                                    // i is where to slice str to get the first element of the coefficient array.
                                    i = (e + 1) % LOG_BASE;
                                    if (e < 0) i += LOG_BASE;
                                    if (i < len) {
                                        if (i) x.c.push(+str.slice(0, i));
                                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                                        str = str.slice(i);
                                        i = LOG_BASE - str.length;
                                    } else i -= len;
                                    for(; i--; str += "0");
                                    x.c.push(+str);
                                }
                            } else // Zero.
                            x.c = [
                                x.e = 0
                            ];
                        }
                        // CONSTRUCTOR PROPERTIES
                        BigNumber.clone = clone;
                        BigNumber.ROUND_UP = 0;
                        BigNumber.ROUND_DOWN = 1;
                        BigNumber.ROUND_CEIL = 2;
                        BigNumber.ROUND_FLOOR = 3;
                        BigNumber.ROUND_HALF_UP = 4;
                        BigNumber.ROUND_HALF_DOWN = 5;
                        BigNumber.ROUND_HALF_EVEN = 6;
                        BigNumber.ROUND_HALF_CEIL = 7;
                        BigNumber.ROUND_HALF_FLOOR = 8;
                        BigNumber.EUCLID = 9;
                        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *      decimalSeparator       {string}
     *      groupSeparator         {string}
     *      groupSize              {number}
     *      secondaryGroupSize     {number}
     *      fractionGroupSeparator {string}
     *      fractionGroupSize      {number}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
                            var p, v;
                            if (obj != null) {
                                if (typeof obj == "object") {
                                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                                        v = obj[p];
                                        intCheck(v, 0, MAX, p);
                                        DECIMAL_PLACES = v;
                                    }
                                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                                        v = obj[p];
                                        intCheck(v, 0, 8, p);
                                        ROUNDING_MODE = v;
                                    }
                                    // EXPONENTIAL_AT {number|number[]}
                                    // Integer, -MAX to MAX inclusive or
                                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                                        v = obj[p];
                                        if (isArray(v)) {
                                            intCheck(v[0], -MAX, 0, p);
                                            intCheck(v[1], 0, MAX, p);
                                            TO_EXP_NEG = v[0];
                                            TO_EXP_POS = v[1];
                                        } else {
                                            intCheck(v, -MAX, MAX, p);
                                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                                        }
                                    }
                                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                                    if (obj.hasOwnProperty(p = "RANGE")) {
                                        v = obj[p];
                                        if (isArray(v)) {
                                            intCheck(v[0], -MAX, -1, p);
                                            intCheck(v[1], 1, MAX, p);
                                            MIN_EXP = v[0];
                                            MAX_EXP = v[1];
                                        } else {
                                            intCheck(v, -MAX, MAX, p);
                                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                                        }
                                    }
                                    // CRYPTO {boolean} true or false.
                                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                                    // '[BigNumber Error] crypto unavailable'
                                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                                        v = obj[p];
                                        if (v === !!v) {
                                            if (v) {
                                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                                else {
                                                    CRYPTO = !v;
                                                    throw Error(bignumberError + "crypto unavailable");
                                                }
                                            } else CRYPTO = v;
                                        } else throw Error(bignumberError + p + " not true or false: " + v);
                                    }
                                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                                        v = obj[p];
                                        intCheck(v, 0, 9, p);
                                        MODULO_MODE = v;
                                    }
                                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                                        v = obj[p];
                                        intCheck(v, 0, MAX, p);
                                        POW_PRECISION = v;
                                    }
                                    // FORMAT {object}
                                    // '[BigNumber Error] FORMAT not an object: {v}'
                                    if (obj.hasOwnProperty(p = "FORMAT")) {
                                        v = obj[p];
                                        if (typeof v == "object") FORMAT = v;
                                        else throw Error(bignumberError + p + " not an object: " + v);
                                    }
                                    // ALPHABET {string}
                                    // '[BigNumber Error] ALPHABET invalid: {v}'
                                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                                        v = obj[p];
                                        // Disallow if only one character, or contains '.' or a repeated character.
                                        if (typeof v == "string" && !/^.$|\.|(.).*\1/.test(v)) ALPHABET = v;
                                        else throw Error(bignumberError + p + " invalid: " + v);
                                    }
                                } else // '[BigNumber Error] Object expected: {v}'
                                throw Error(bignumberError + "Object expected: " + obj);
                            }
                            return {
                                DECIMAL_PLACES: DECIMAL_PLACES,
                                ROUNDING_MODE: ROUNDING_MODE,
                                EXPONENTIAL_AT: [
                                    TO_EXP_NEG,
                                    TO_EXP_POS
                                ],
                                RANGE: [
                                    MIN_EXP,
                                    MAX_EXP
                                ],
                                CRYPTO: CRYPTO,
                                MODULO_MODE: MODULO_MODE,
                                POW_PRECISION: POW_PRECISION,
                                FORMAT: FORMAT,
                                ALPHABET: ALPHABET
                            };
                        };
                        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * v {any}
     */ BigNumber.isBigNumber = function(v) {
                            return v instanceof BigNumber || v && v._isBigNumber === true || false;
                        };
                        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
                            return maxOrMin(arguments, P.lt);
                        };
                        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
                            return maxOrMin(arguments, P.gt);
                        };
                        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
                            var pow2_53 = 0x20000000000000;
                            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
                            // Check if Math.random() produces more than 32 bits of randomness.
                            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
                            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
                            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                                return mathfloor(Math.random() * pow2_53);
                            } : function() {
                                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
                            };
                            return function(dp) {
                                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                                if (dp == null) dp = DECIMAL_PLACES;
                                else intCheck(dp, 0, MAX);
                                k = mathceil(dp / LOG_BASE);
                                if (CRYPTO) {
                                    // Browsers supporting crypto.getRandomValues.
                                    if (crypto.getRandomValues) {
                                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                                        for(; i < k;){
                                            // 53 bits:
                                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                                            //                                     11111 11111111 11111111
                                            // 0x20000 is 2^21.
                                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                                            // Rejection sampling:
                                            // 0 <= v < 9007199254740992
                                            // Probability that v >= 9e15, is
                                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                                            if (v >= 9e15) {
                                                b = crypto.getRandomValues(new Uint32Array(2));
                                                a[i] = b[0];
                                                a[i + 1] = b[1];
                                            } else {
                                                // 0 <= v <= 8999999999999999
                                                // 0 <= (v % 1e14) <= 99999999999999
                                                c.push(v % 1e14);
                                                i += 2;
                                            }
                                        }
                                        i = k / 2;
                                    // Node.js supporting crypto.randomBytes.
                                    } else if (crypto.randomBytes) {
                                        // buffer
                                        a = crypto.randomBytes(k *= 7);
                                        for(; i < k;){
                                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                                            // 0 <= v < 9007199254740992
                                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                                            else {
                                                // 0 <= (v % 1e14) <= 99999999999999
                                                c.push(v % 1e14);
                                                i += 7;
                                            }
                                        }
                                        i = k / 7;
                                    } else {
                                        CRYPTO = false;
                                        throw Error(bignumberError + "crypto unavailable");
                                    }
                                }
                                // Use Math.random.
                                if (!CRYPTO) for(; i < k;){
                                    v = random53bitInt();
                                    if (v < 9e15) c[i++] = v % 1e14;
                                }
                                k = c[--i];
                                dp %= LOG_BASE;
                                // Convert trailing digits to zeros according to dp.
                                if (k && dp) {
                                    v = POWS_TEN[LOG_BASE - dp];
                                    c[i] = mathfloor(k / v) * v;
                                }
                                // Remove trailing elements which are zero.
                                for(; c[i] === 0; c.pop(), i--);
                                // Zero?
                                if (i < 0) c = [
                                    e = 0
                                ];
                                else {
                                    // Remove leading elements which are zero and adjust exponent accordingly.
                                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                                    // Count the digits of the first element of c to determine leading zeros, and...
                                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                                    // adjust the exponent accordingly.
                                    if (i < LOG_BASE) e -= LOG_BASE - i;
                                }
                                rand.e = e;
                                rand.c = c;
                                return rand;
                            };
                        }();
                        // PRIVATE FUNCTIONS
                        // Called by BigNumber and BigNumber.prototype.toString.
                        convertBase = function() {
                            var decimal = "0123456789";
                            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                                var j, arr = [
                                    0
                                ], arrL, i = 0, len = str.length;
                                for(; i < len;){
                                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                                    arr[0] += alphabet.indexOf(str.charAt(i++));
                                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                                        if (arr[j + 1] == null) arr[j + 1] = 0;
                                        arr[j + 1] += arr[j] / baseOut | 0;
                                        arr[j] %= baseOut;
                                    }
                                }
                                return arr.reverse();
                            }
                            // Convert a numeric string of baseIn to a numeric string of baseOut.
                            // If the caller is toString, we are converting from base 10 to baseOut.
                            // If the caller is BigNumber, we are converting from baseIn to base 10.
                            return function(str, baseIn, baseOut, sign, callerIsToString) {
                                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                                // Non-integer.
                                if (i >= 0) {
                                    k = POW_PRECISION;
                                    // Unlimited precision.
                                    POW_PRECISION = 0;
                                    str = str.replace(".", "");
                                    y = new BigNumber(baseIn);
                                    x = y.pow(str.length - i);
                                    POW_PRECISION = k;
                                    // Convert str as if an integer, then restore the fraction part by dividing the
                                    // result by its base raised to a power.
                                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                                    y.e = y.c.length;
                                }
                                // Convert the number as integer.
                                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                                e = k = xc.length;
                                // Remove trailing zeros.
                                for(; xc[--k] == 0; xc.pop());
                                // Zero?
                                if (!xc[0]) return alphabet.charAt(0);
                                // Does str represent an integer? If so, no need for the division.
                                if (i < 0) --e;
                                else {
                                    x.c = xc;
                                    x.e = e;
                                    // The sign is needed for correct rounding.
                                    x.s = sign;
                                    x = div(x, y, dp, rm, baseOut);
                                    xc = x.c;
                                    r = x.r;
                                    e = x.e;
                                }
                                // xc now represents str converted to baseOut.
                                // THe index of the rounding digit.
                                d = e + dp + 1;
                                // The rounding digit: the digit to the right of the digit that may be rounded up.
                                i = xc[d];
                                // Look at the rounding digits and mode to determine whether to round up.
                                k = baseOut / 2;
                                r = r || d < 0 || xc[d + 1] != null;
                                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                                // If the index of the rounding digit is not greater than zero, or xc represents
                                // zero, then the result of the base conversion is zero or, if rounding up, a value
                                // such as 0.00001.
                                if (d < 1 || !xc[0]) // 1^-dp or 0
                                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                                else {
                                    // Truncate xc to the required number of decimal places.
                                    xc.length = d;
                                    // Round up?
                                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                                    for(--baseOut; ++xc[--d] > baseOut;){
                                        xc[d] = 0;
                                        if (!d) {
                                            ++e;
                                            xc = [
                                                1
                                            ].concat(xc);
                                        }
                                    }
                                    // Determine trailing zeros.
                                    for(k = xc.length; !xc[--k];);
                                    // E.g. [4, 11, 15] becomes 4bf.
                                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                                    // Add leading zeros, decimal point and trailing zeros as required.
                                    str = toFixedPoint(str, e, alphabet.charAt(0));
                                }
                                // The caller will add the sign.
                                return str;
                            };
                        }();
                        // Perform division in the specified base. Called by div and convertBase.
                        div = function() {
                            // Assume non-zero x and k.
                            function multiply(x, k, base) {
                                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                                for(x = x.slice(); i--;){
                                    xlo = x[i] % SQRT_BASE;
                                    xhi = x[i] / SQRT_BASE | 0;
                                    m = khi * xlo + xhi * klo;
                                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                                    x[i] = temp % base;
                                }
                                if (carry) x = [
                                    carry
                                ].concat(x);
                                return x;
                            }
                            function compare(a, b, aL, bL) {
                                var i, cmp;
                                if (aL != bL) cmp = aL > bL ? 1 : -1;
                                else {
                                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                                        cmp = a[i] > b[i] ? 1 : -1;
                                        break;
                                    }
                                }
                                return cmp;
                            }
                            function subtract(a, b, aL, base) {
                                var i = 0;
                                // Subtract b from a.
                                for(; aL--;){
                                    a[aL] -= i;
                                    i = a[aL] < b[aL] ? 1 : 0;
                                    a[aL] = i * base + a[aL] - b[aL];
                                }
                                // Remove leading zeros.
                                for(; !a[0] && a.length > 1; a.splice(0, 1));
                            }
                            // x: dividend, y: divisor.
                            return function(x, y, dp, rm, base) {
                                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                                // Either NaN, Infinity or 0?
                                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                                q = new BigNumber(s);
                                qc = q.c = [];
                                e = x.e - y.e;
                                s = dp + e + 1;
                                if (!base) {
                                    base = BASE;
                                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                                    s = s / LOG_BASE | 0;
                                }
                                // Result exponent may be one less then the current value of e.
                                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                                for(i = 0; yc[i] == (xc[i] || 0); i++);
                                if (yc[i] > (xc[i] || 0)) e--;
                                if (s < 0) {
                                    qc.push(1);
                                    more = true;
                                } else {
                                    xL = xc.length;
                                    yL = yc.length;
                                    i = 0;
                                    s += 2;
                                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                                    n = mathfloor(base / (yc[0] + 1));
                                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                                    if (n > 1) {
                                        yc = multiply(yc, n, base);
                                        xc = multiply(xc, n, base);
                                        yL = yc.length;
                                        xL = xc.length;
                                    }
                                    xi = yL;
                                    rem = xc.slice(0, yL);
                                    remL = rem.length;
                                    // Add zeros to make remainder as long as divisor.
                                    for(; remL < yL; rem[remL++] = 0);
                                    yz = yc.slice();
                                    yz = [
                                        0
                                    ].concat(yz);
                                    yc0 = yc[0];
                                    if (yc[1] >= base / 2) yc0++;
                                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                                    do {
                                        n = 0;
                                        // Compare divisor and remainder.
                                        cmp = compare(yc, rem, yL, remL);
                                        // If divisor < remainder.
                                        if (cmp < 0) {
                                            // Calculate trial digit, n.
                                            rem0 = rem[0];
                                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                                            // n is how many times the divisor goes into the current remainder.
                                            n = mathfloor(rem0 / yc0);
                                            //  Algorithm:
                                            //  product = divisor multiplied by trial digit (n).
                                            //  Compare product and remainder.
                                            //  If product is greater than remainder:
                                            //    Subtract divisor from product, decrement trial digit.
                                            //  Subtract product from remainder.
                                            //  If product was less than remainder at the last compare:
                                            //    Compare new remainder and divisor.
                                            //    If remainder is greater than divisor:
                                            //      Subtract divisor from remainder, increment trial digit.
                                            if (n > 1) {
                                                // n may be > base only when base is 3.
                                                if (n >= base) n = base - 1;
                                                // product = divisor * trial digit.
                                                prod = multiply(yc, n, base);
                                                prodL = prod.length;
                                                remL = rem.length;
                                                // Compare product and remainder.
                                                // If product > remainder then trial digit n too high.
                                                // n is 1 too high about 5% of the time, and is not known to have
                                                // ever been more than 1 too high.
                                                while(compare(prod, rem, prodL, remL) == 1){
                                                    n--;
                                                    // Subtract divisor from product.
                                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                                    prodL = prod.length;
                                                    cmp = 1;
                                                }
                                            } else {
                                                // n is 0 or 1, cmp is -1.
                                                // If n is 0, there is no need to compare yc and rem again below,
                                                // so change cmp to 1 to avoid it.
                                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                                cmp = n = 1;
                                                // product = divisor
                                                prod = yc.slice();
                                                prodL = prod.length;
                                            }
                                            if (prodL < remL) prod = [
                                                0
                                            ].concat(prod);
                                            // Subtract product from remainder.
                                            subtract(rem, prod, remL, base);
                                            remL = rem.length;
                                            // If product was < remainder.
                                            if (cmp == -1) // Compare divisor and new remainder.
                                            // If divisor < new remainder, subtract divisor from remainder.
                                            // Trial digit n too low.
                                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                                            while(compare(yc, rem, yL, remL) < 1){
                                                n++;
                                                // Subtract divisor from remainder.
                                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                                remL = rem.length;
                                            }
                                        } else if (cmp === 0) {
                                            n++;
                                            rem = [
                                                0
                                            ];
                                        } // else cmp === 1 and n will be 0
                                        // Add the next digit, n, to the result array.
                                        qc[i++] = n;
                                        // Update the remainder.
                                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                                        else {
                                            rem = [
                                                xc[xi]
                                            ];
                                            remL = 1;
                                        }
                                    }while ((xi++ < xL || rem[0] != null) && s--);
                                    more = rem[0] != null;
                                    // Leading zero?
                                    if (!qc[0]) qc.splice(0, 1);
                                }
                                if (base == BASE) {
                                    // To calculate q.e, first get the number of digits of qc[0].
                                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                                // Caller is convertBase.
                                } else {
                                    q.e = e;
                                    q.r = +more;
                                }
                                return q;
                            };
                        }();
                        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
                            var c0, e, ne, len, str;
                            if (rm == null) rm = ROUNDING_MODE;
                            else intCheck(rm, 0, 8);
                            if (!n.c) return n.toString();
                            c0 = n.c[0];
                            ne = n.e;
                            if (i == null) {
                                str = coeffToString(n.c);
                                str = id == 1 || id == 2 && ne <= TO_EXP_NEG ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
                            } else {
                                n = round(new BigNumber(n), i, rm);
                                // n.e may have changed if the value was rounded up.
                                e = n.e;
                                str = coeffToString(n.c);
                                len = str.length;
                                // toPrecision returns exponential notation if the number of significant digits
                                // specified is less than the number of digits necessary to represent the integer
                                // part of the value in fixed-point notation.
                                // Exponential notation.
                                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                                    // Append zeros?
                                    for(; len < i; str += "0", len++);
                                    str = toExponential(str, e);
                                // Fixed-point notation.
                                } else {
                                    i -= ne;
                                    str = toFixedPoint(str, e, "0");
                                    // Append zeros?
                                    if (e + 1 > len) {
                                        if (--i > 0) for(str += "."; i--; str += "0");
                                    } else {
                                        i += e - len;
                                        if (i > 0) {
                                            if (e + 1 == len) str += ".";
                                            for(; i--; str += "0");
                                        }
                                    }
                                }
                            }
                            return n.s < 0 && c0 ? "-" + str : str;
                        }
                        // Handle BigNumber.max and BigNumber.min.
                        function maxOrMin(args, method) {
                            var m, n, i = 0;
                            if (isArray(args[0])) args = args[0];
                            m = new BigNumber(args[0]);
                            for(; ++i < args.length;){
                                n = new BigNumber(args[i]);
                                // If any number is NaN, return NaN.
                                if (!n.s) {
                                    m = n;
                                    break;
                                } else if (method.call(m, n)) m = n;
                            }
                            return m;
                        }
                        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
                            var i = 1, j = c.length;
                            // Remove trailing zeros.
                            for(; !c[--j]; c.pop());
                            // Calculate the base 10 exponent. First get the number of digits of c[0].
                            for(j = c[0]; j >= 10; j /= 10, i++);
                            // Overflow?
                            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
                            n.c = n.e = null;
                            else if (e < MIN_EXP) // Zero.
                            n.c = [
                                n.e = 0
                            ];
                            else {
                                n.e = e;
                                n.c = c;
                            }
                            return n;
                        }
                        // Handle values that fail the validity test in BigNumber.
                        parseNumeric = function() {
                            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
                            return function(x, str, isNum, b) {
                                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                                // No exception on ±Infinity or NaN.
                                if (isInfinityOrNaN.test(s)) {
                                    x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                                    x.c = x.e = null;
                                } else {
                                    if (!isNum) {
                                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                                        s = s.replace(basePrefix, function(m, p1, p2) {
                                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                                            return !b || b == base ? p1 : m;
                                        });
                                        if (b) {
                                            base = b;
                                            // E.g. '1.' to '1', '.1' to '0.1'
                                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                                        }
                                        if (str != s) return new BigNumber(s, base);
                                    }
                                    // '[BigNumber Error] Not a number: {n}'
                                    // '[BigNumber Error] Not a base {b} number: {n}'
                                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                                    // NaN
                                    x.c = x.e = x.s = null;
                                }
                            };
                        }();
                        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
                            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
                            // if x is not Infinity or NaN...
                            if (xc) {
                                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                                // ni is the index of n within x.c.
                                // d is the number of digits of n.
                                // i is the index of rd within n including leading zeros.
                                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                                out: {
                                    // Get the number of digits of the first element of xc.
                                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                                    i = sd - d;
                                    // If the rounding digit is in the first element of xc...
                                    if (i < 0) {
                                        i += LOG_BASE;
                                        j = sd;
                                        n = xc[ni = 0];
                                        // Get the rounding digit at index j of n.
                                        rd = n / pows10[d - j - 1] % 10 | 0;
                                    } else {
                                        ni = mathceil((i + 1) / LOG_BASE);
                                        if (ni >= xc.length) {
                                            if (r) {
                                                // Needed by sqrt.
                                                for(; xc.length <= ni; xc.push(0));
                                                n = rd = 0;
                                                d = 1;
                                                i %= LOG_BASE;
                                                j = i - LOG_BASE + 1;
                                            } else break out;
                                        } else {
                                            n = k = xc[ni];
                                            // Get the number of digits of n.
                                            for(d = 1; k >= 10; k /= 10, d++);
                                            // Get the index of rd within n.
                                            i %= LOG_BASE;
                                            // Get the index of rd within n, adjusted for leading zeros.
                                            // The number of leading zeros of n is given by LOG_BASE - d.
                                            j = i - LOG_BASE + d;
                                            // Get the rounding digit at index j of n.
                                            rd = j < 0 ? 0 : n / pows10[d - j - 1] % 10 | 0;
                                        }
                                    }
                                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                                    if (sd < 1 || !xc[0]) {
                                        xc.length = 0;
                                        if (r) {
                                            // Convert sd to decimal places.
                                            sd -= x.e + 1;
                                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                                            x.e = -sd || 0;
                                        } else // Zero.
                                        xc[0] = x.e = 0;
                                        return x;
                                    }
                                    // Remove excess digits.
                                    if (i == 0) {
                                        xc.length = ni;
                                        k = 1;
                                        ni--;
                                    } else {
                                        xc.length = ni + 1;
                                        k = pows10[LOG_BASE - i];
                                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                                        // j > 0 means i > number of leading zeros of n.
                                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                                    }
                                    // Round up?
                                    if (r) {
                                        for(;;)// If the digit to be rounded up is in the first element of xc...
                                        if (ni == 0) {
                                            // i will be the length of xc[0] before k is added.
                                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                                            j = xc[0] += k;
                                            for(k = 1; j >= 10; j /= 10, k++);
                                            // if i != k the length has increased.
                                            if (i != k) {
                                                x.e++;
                                                if (xc[0] == BASE) xc[0] = 1;
                                            }
                                            break;
                                        } else {
                                            xc[ni] += k;
                                            if (xc[ni] != BASE) break;
                                            xc[ni--] = 0;
                                            k = 1;
                                        }
                                    }
                                    // Remove trailing zeros.
                                    for(i = xc.length; xc[--i] === 0; xc.pop());
                                }
                                // Overflow? Infinity.
                                if (x.e > MAX_EXP) x.c = x.e = null;
                                else if (x.e < MIN_EXP) x.c = [
                                    x.e = 0
                                ];
                            }
                            return x;
                        }
                        // PROTOTYPE/INSTANCE METHODS
                        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
                            var x = new BigNumber(this);
                            if (x.s < 0) x.s = 1;
                            return x;
                        };
                        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
                            return compare(this, new BigNumber(y, b));
                        };
                        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
                            var c, n, v, x = this;
                            if (dp != null) {
                                intCheck(dp, 0, MAX);
                                if (rm == null) rm = ROUNDING_MODE;
                                else intCheck(rm, 0, 8);
                                return round(new BigNumber(x), dp + x.e + 1, rm);
                            }
                            if (!(c = x.c)) return null;
                            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
                            // Subtract the number of trailing zeros of the last number.
                            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
                            if (n < 0) n = 0;
                            return n;
                        };
                        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
                            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
                        };
                        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
                            return div(this, new BigNumber(y, b), 0, 1);
                        };
                        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
                            var half, isModExp, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
                            n = new BigNumber(n);
                            // Allow NaN and ±Infinity, but not other non-integers.
                            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + n);
                            if (m != null) m = new BigNumber(m);
                            // Exponent of MAX_SAFE_INTEGER is 15.
                            nIsBig = n.e > 14;
                            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
                            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                                // The sign of the result of pow when x is negative depends on the evenness of n.
                                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                                y = new BigNumber(Math.pow(+x.valueOf(), nIsBig ? 2 - isOdd(n) : +n));
                                return m ? y.mod(m) : y;
                            }
                            nIsNeg = n.s < 0;
                            if (m) {
                                // x % m returns NaN if abs(m) is zero, or m is NaN.
                                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                                if (isModExp) x = x.mod(m);
                            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
                            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
                            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                                // If x is negative and n is odd, k = -0, else k = 0.
                                k = x.s < 0 && isOdd(n) ? -0 : 0;
                                // If x >= 1, k = ±Infinity.
                                if (x.e > -1) k = 1 / k;
                                // If n is negative return ±0, else return ±Infinity.
                                return new BigNumber(nIsNeg ? 1 / k : k);
                            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
                            // equates to truncating significant digits to POW_PRECISION + [28, 41],
                            // i.e. there will be a minimum of 28 guard digits retained.
                            k = mathceil(POW_PRECISION / LOG_BASE + 2);
                            if (nIsBig) {
                                half = new BigNumber(0.5);
                                nIsOdd = isOdd(n);
                            } else nIsOdd = n % 2;
                            if (nIsNeg) n.s = 1;
                            y = new BigNumber(ONE);
                            // Performs 54 loop iterations for n of 9007199254740991.
                            for(;;){
                                if (nIsOdd) {
                                    y = y.times(x);
                                    if (!y.c) break;
                                    if (k) {
                                        if (y.c.length > k) y.c.length = k;
                                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                                }
                                if (nIsBig) {
                                    n = n.times(half);
                                    round(n, n.e + 1, 1);
                                    if (!n.c[0]) break;
                                    nIsBig = n.e > 14;
                                    nIsOdd = isOdd(n);
                                } else {
                                    n = mathfloor(n / 2);
                                    if (!n) break;
                                    nIsOdd = n % 2;
                                }
                                x = x.times(x);
                                if (k) {
                                    if (x.c && x.c.length > k) x.c.length = k;
                                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
                            }
                            if (isModExp) return y;
                            if (nIsNeg) y = ONE.div(y);
                            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
                        };
                        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
                            var n = new BigNumber(this);
                            if (rm == null) rm = ROUNDING_MODE;
                            else intCheck(rm, 0, 8);
                            return round(n, n.e + 1, rm);
                        };
                        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
                            return compare(this, new BigNumber(y, b)) === 0;
                        };
                        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
                            return !!this.c;
                        };
                        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
                            return compare(this, new BigNumber(y, b)) > 0;
                        };
                        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
                            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
                        };
                        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
                            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
                        };
                        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
                            return compare(this, new BigNumber(y, b)) < 0;
                        };
                        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
                            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
                        };
                        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
                            return !this.s;
                        };
                        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
                            return this.s < 0;
                        };
                        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
                            return this.s > 0;
                        };
                        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
                            return !!this.c && this.c[0] == 0;
                        };
                        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
                            var i, j, t, xLTy, x = this, a = x.s;
                            y = new BigNumber(y, b);
                            b = y.s;
                            // Either NaN?
                            if (!a || !b) return new BigNumber(NaN);
                            // Signs differ?
                            if (a != b) {
                                y.s = -b;
                                return x.plus(y);
                            }
                            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
                            if (!xe || !ye) {
                                // Either Infinity?
                                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                                // Either zero?
                                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                                ROUNDING_MODE == 3 ? -0 : 0);
                            }
                            xe = bitFloor(xe);
                            ye = bitFloor(ye);
                            xc = xc.slice();
                            // Determine which is the bigger number.
                            if (a = xe - ye) {
                                if (xLTy = a < 0) {
                                    a = -a;
                                    t = xc;
                                } else {
                                    ye = xe;
                                    t = yc;
                                }
                                t.reverse();
                                // Prepend zeros to equalise exponents.
                                for(b = a; b--; t.push(0));
                                t.reverse();
                            } else {
                                // Exponents equal. Check digit by digit.
                                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                                    xLTy = xc[b] < yc[b];
                                    break;
                                }
                            }
                            // x < y? Point xc to the array of the bigger number.
                            if (xLTy) t = xc, xc = yc, yc = t, y.s = -y.s;
                            b = (j = yc.length) - (i = xc.length);
                            // Append zeros to xc if shorter.
                            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
                            if (b > 0) for(; b--; xc[i++] = 0);
                            b = BASE - 1;
                            // Subtract yc from xc.
                            for(; j > a;){
                                if (xc[--j] < yc[j]) {
                                    for(i = j; i && !xc[--i]; xc[i] = b);
                                    --xc[i];
                                    xc[j] += BASE;
                                }
                                xc[j] -= yc[j];
                            }
                            // Remove leading zeros and adjust exponent accordingly.
                            for(; xc[0] == 0; xc.splice(0, 1), --ye);
                            // Zero?
                            if (!xc[0]) {
                                // Following IEEE 754 (2008) 6.3,
                                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                                y.c = [
                                    y.e = 0
                                ];
                                return y;
                            }
                            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
                            // for finite x and y.
                            return normalise(y, xc, ye);
                        };
                        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
                            var q, s, x = this;
                            y = new BigNumber(y, b);
                            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
                            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
                            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
                            if (MODULO_MODE == 9) {
                                // Euclidian division: q = sign(y) * floor(x / abs(y))
                                // r = x - qy    where  0 <= r < abs(y)
                                s = y.s;
                                y.s = 1;
                                q = div(x, y, 0, 3);
                                y.s = s;
                                q.s *= s;
                            } else q = div(x, y, 0, MODULO_MODE);
                            y = x.minus(q.times(y));
                            // To match JavaScript %, ensure sign of zero is sign of dividend.
                            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
                            return y;
                        };
                        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
                            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
                            // Either NaN, ±Infinity or ±0?
                            if (!xc || !yc || !xc[0] || !yc[0]) {
                                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                                else {
                                    y.s *= x.s;
                                    // Return ±Infinity if either is ±Infinity.
                                    if (!xc || !yc) y.c = y.e = null;
                                    else {
                                        y.c = [
                                            0
                                        ];
                                        y.e = 0;
                                    }
                                }
                                return y;
                            }
                            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
                            y.s *= x.s;
                            xcL = xc.length;
                            ycL = yc.length;
                            // Ensure xc points to longer array and xcL to its length.
                            if (xcL < ycL) zc = xc, xc = yc, yc = zc, i = xcL, xcL = ycL, ycL = i;
                            // Initialise the result array with zeros.
                            for(i = xcL + ycL, zc = []; i--; zc.push(0));
                            base = BASE;
                            sqrtBase = SQRT_BASE;
                            for(i = ycL; --i >= 0;){
                                c = 0;
                                ylo = yc[i] % sqrtBase;
                                yhi = yc[i] / sqrtBase | 0;
                                for(k = xcL, j = i + k; j > i;){
                                    xlo = xc[--k] % sqrtBase;
                                    xhi = xc[k] / sqrtBase | 0;
                                    m = yhi * xlo + xhi * ylo;
                                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                                    zc[j--] = xlo % base;
                                }
                                zc[j] = c;
                            }
                            if (c) ++e;
                            else zc.splice(0, 1);
                            return normalise(y, zc, e);
                        };
                        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
                            var x = new BigNumber(this);
                            x.s = -x.s || null;
                            return x;
                        };
                        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
                            var t, x = this, a = x.s;
                            y = new BigNumber(y, b);
                            b = y.s;
                            // Either NaN?
                            if (!a || !b) return new BigNumber(NaN);
                            // Signs differ?
                            if (a != b) {
                                y.s = -b;
                                return x.minus(y);
                            }
                            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
                            if (!xe || !ye) {
                                // Return ±Infinity if either ±Infinity.
                                if (!xc || !yc) return new BigNumber(a / 0);
                                // Either zero?
                                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
                            }
                            xe = bitFloor(xe);
                            ye = bitFloor(ye);
                            xc = xc.slice();
                            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
                            if (a = xe - ye) {
                                if (a > 0) {
                                    ye = xe;
                                    t = yc;
                                } else {
                                    a = -a;
                                    t = xc;
                                }
                                t.reverse();
                                for(; a--; t.push(0));
                                t.reverse();
                            }
                            a = xc.length;
                            b = yc.length;
                            // Point xc to the longer array, and b to the shorter length.
                            if (a - b < 0) t = yc, yc = xc, xc = t, b = a;
                            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
                            for(a = 0; b;){
                                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
                            }
                            if (a) {
                                xc = [
                                    a
                                ].concat(xc);
                                ++ye;
                            }
                            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
                            // ye = MAX_EXP + 1 possible
                            return normalise(y, xc, ye);
                        };
                        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
                            var c, n, v, x = this;
                            if (sd != null && sd !== !!sd) {
                                intCheck(sd, 1, MAX);
                                if (rm == null) rm = ROUNDING_MODE;
                                else intCheck(rm, 0, 8);
                                return round(new BigNumber(x), sd, rm);
                            }
                            if (!(c = x.c)) return null;
                            v = c.length - 1;
                            n = v * LOG_BASE + 1;
                            if (v = c[v]) {
                                // Subtract the number of trailing zeros of the last element.
                                for(; v % 10 == 0; v /= 10, n--);
                                // Add the number of digits of the first element.
                                for(v = c[0]; v >= 10; v /= 10, n++);
                            }
                            if (sd && x.e + 1 > n) n = x.e + 1;
                            return n;
                        };
                        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
                            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
                            return this.times("1e" + k);
                        };
                        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
                            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
                            // Negative/NaN/Infinity/zero?
                            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
                            // Initial estimate.
                            s = Math.sqrt(+x);
                            // Math.sqrt underflow/overflow?
                            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
                            if (s == 0 || s == 1 / 0) {
                                n = coeffToString(c);
                                if ((n.length + e) % 2 == 0) n += "0";
                                s = Math.sqrt(n);
                                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                                if (s == 1 / 0) n = "1e" + e;
                                else {
                                    n = s.toExponential();
                                    n = n.slice(0, n.indexOf("e") + 1) + e;
                                }
                                r = new BigNumber(n);
                            } else r = new BigNumber(s + "");
                            // Check for zero.
                            // r could be zero if MIN_EXP is changed after the this value was created.
                            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
                            // coeffToString to throw.
                            if (r.c[0]) {
                                e = r.e;
                                s = e + dp;
                                if (s < 3) s = 0;
                                // Newton-Raphson iteration.
                                for(;;){
                                    t = r;
                                    r = half.times(t.plus(div(x, t, dp, 1)));
                                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                                        // The exponent of r may here be one less than the final result exponent,
                                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                                        // are indexed correctly.
                                        if (r.e < e) --s;
                                        n = n.slice(s - 3, s + 1);
                                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                                        // iteration.
                                        if (n == "9999" || !rep && n == "4999") {
                                            // On the first iteration only, check to see if rounding up gives the
                                            // exact result as the nines may infinitely repeat.
                                            if (!rep) {
                                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                                if (t.times(t).eq(x)) {
                                                    r = t;
                                                    break;
                                                }
                                            }
                                            dp += 4;
                                            s += 4;
                                            rep = 1;
                                        } else {
                                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                                            // result. If not, then there are further digits and m will be truthy.
                                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                                // Truncate to the first rounding digit.
                                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                                m = !r.times(r).eq(x);
                                            }
                                            break;
                                        }
                                    }
                                }
                            }
                            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
                        };
                        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
                            if (dp != null) {
                                intCheck(dp, 0, MAX);
                                dp++;
                            }
                            return format(this, dp, rm, 1);
                        };
                        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
                            if (dp != null) {
                                intCheck(dp, 0, MAX);
                                dp = dp + this.e + 1;
                            }
                            return format(this, dp, rm);
                        };
                        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the FORMAT object (see BigNumber.set).
     *
     * FORMAT = {
     *      decimalSeparator : '.',
     *      groupSeparator : ',',
     *      groupSize : 3,
     *      secondaryGroupSize : 0,
     *      fractionGroupSeparator : '\xA0',    // non-breaking space
     *      fractionGroupSize : 0
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFormat = function(dp, rm) {
                            var str = this.toFixed(dp, rm);
                            if (this.c) {
                                var i, arr = str.split("."), g1 = +FORMAT.groupSize, g2 = +FORMAT.secondaryGroupSize, groupSeparator = FORMAT.groupSeparator, intPart = arr[0], fractionPart = arr[1], isNeg = this.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                                if (g2) i = g1, g1 = g2, g2 = i, len -= i;
                                if (g1 > 0 && len > 0) {
                                    i = len % g1 || g1;
                                    intPart = intDigits.substr(0, i);
                                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                                    if (isNeg) intPart = "-" + intPart;
                                }
                                str = fractionPart ? intPart + FORMAT.decimalSeparator + ((g2 = +FORMAT.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + FORMAT.fractionGroupSeparator) : fractionPart) : intPart;
                            }
                            return str;
                        };
                        /*
     * Return a string array representing the value of this BigNumber as a simple fraction with
     * an integer numerator and an integer denominator. The denominator will be a positive
     * non-zero value less than or equal to the specified maximum denominator. If a maximum
     * denominator is not specified, the denominator will be the lowest value necessary to
     * represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
                            var arr, d, d0, d1, d2, e, exp, n, n0, n1, q, s, x = this, xc = x.c;
                            if (md != null) {
                                n = new BigNumber(md);
                                // Throw if md is less than one or is not an integer, unless it is Infinity.
                                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + md);
                            }
                            if (!xc) return x.toString();
                            d = new BigNumber(ONE);
                            n1 = d0 = new BigNumber(ONE);
                            d1 = n0 = new BigNumber(ONE);
                            s = coeffToString(xc);
                            // Determine initial denominator.
                            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
                            e = d.e = s.length - x.e - 1;
                            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
                            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
                            exp = MAX_EXP;
                            MAX_EXP = 1 / 0;
                            n = new BigNumber(s);
                            // n0 = d1 = 0
                            n0.c[0] = 0;
                            for(;;){
                                q = div(n, d, 0, 1);
                                d2 = d0.plus(q.times(d1));
                                if (d2.comparedTo(md) == 1) break;
                                d0 = d1;
                                d1 = d2;
                                n1 = n0.plus(q.times(d2 = n1));
                                n0 = d2;
                                d = n.minus(q.times(d2 = d));
                                n = d2;
                            }
                            d2 = div(md.minus(d0), d1, 0, 1);
                            n0 = n0.plus(d2.times(n1));
                            d0 = d0.plus(d2.times(d1));
                            n0.s = n1.s = x.s;
                            e *= 2;
                            // Determine which fraction is closer to x, n0/d0 or n1/d1
                            arr = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                                n1.toString(),
                                d1.toString()
                            ] : [
                                n0.toString(),
                                d0.toString()
                            ];
                            MAX_EXP = exp;
                            return arr;
                        };
                        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
                            return +this;
                        };
                        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
                            if (sd != null) intCheck(sd, 1, MAX);
                            return format(this, sd, rm, 2);
                        };
                        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
                            var str, n = this, s = n.s, e = n.e;
                            // Infinity or NaN?
                            if (e === null) {
                                if (s) {
                                    str = "Infinity";
                                    if (s < 0) str = "-" + str;
                                } else str = "NaN";
                            } else {
                                str = coeffToString(n.c);
                                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
                                else {
                                    intCheck(b, 2, ALPHABET.length, "Base");
                                    str = convertBase(toFixedPoint(str, e, "0"), 10, b, s, true);
                                }
                                if (s < 0 && n.c[0]) str = "-" + str;
                            }
                            return str;
                        };
                        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
                            var str, n = this, e = n.e;
                            if (e === null) return n.toString();
                            str = coeffToString(n.c);
                            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
                            return n.s < 0 ? "-" + str : str;
                        };
                        P._isBigNumber = true;
                        if (configObject != null) BigNumber.set(configObject);
                        return BigNumber;
                    }
                    // PRIVATE HELPER FUNCTIONS
                    function bitFloor(n) {
                        var i = n | 0;
                        return n > 0 || n === i ? i : i - 1;
                    }
                    // Return a coefficient array as a string of base 10 digits.
                    function coeffToString(a) {
                        var s, z, i = 1, j = a.length, r = a[0] + "";
                        for(; i < j;){
                            s = a[i++] + "";
                            z = LOG_BASE - s.length;
                            for(; z--; s = "0" + s);
                            r += s;
                        }
                        // Determine trailing zeros.
                        for(j = r.length; r.charCodeAt(--j) === 48;);
                        return r.slice(0, j + 1 || 1);
                    }
                    // Compare the value of BigNumbers x and y.
                    function compare(x, y) {
                        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
                        // Either NaN?
                        if (!i || !j) return null;
                        a = xc && !xc[0];
                        b = yc && !yc[0];
                        // Either zero?
                        if (a || b) return a ? b ? 0 : -j : i;
                        // Signs differ?
                        if (i != j) return i;
                        a = i < 0;
                        b = k == l;
                        // Either Infinity?
                        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
                        // Compare exponents.
                        if (!b) return k > l ^ a ? 1 : -1;
                        j = (k = xc.length) < (l = yc.length) ? k : l;
                        // Compare digit by digit.
                        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
                        // Compare lengths.
                        return k == l ? 0 : k > l ^ a ? 1 : -1;
                    }
                    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name1) {
                        if (n < min || n > max || n !== (n < 0 ? mathceil(n) : mathfloor(n))) throw Error(bignumberError + (name1 || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + n);
                    }
                    function isArray(obj) {
                        return Object.prototype.toString.call(obj) == "[object Array]";
                    }
                    // Assumes finite n.
                    function isOdd(n) {
                        var k = n.c.length - 1;
                        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
                    }
                    function toExponential(str, e) {
                        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
                    }
                    function toFixedPoint(str, e, z) {
                        var len, zs;
                        // Negative exponent?
                        if (e < 0) {
                            // Prepend zeros.
                            for(zs = z + "."; ++e; zs += z);
                            str = zs + str;
                        // Positive exponent
                        } else {
                            len = str.length;
                            // Append zeros.
                            if (++e > len) {
                                for(zs = z, e -= len; --e; zs += z);
                                str += zs;
                            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
                        }
                        return str;
                    }
                    // EXPORT
                    BigNumber = clone();
                    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
                    __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                        return BigNumber;
                    }).call(exports, __webpack_require__, exports, module1), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__);
                })(this);
            /***/ },
            /***/ 5697: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                /* module decorator */ module1 = __webpack_require__.nmd(module1);
                (function(module1, exports) {
                    "use strict";
                    // Utils
                    function assert(val, msg) {
                        if (!val) throw new Error(msg || "Assertion failed");
                    }
                    // Could use `inherits` module, but don't want to move from single file
                    // architecture yet.
                    function inherits(ctor, superCtor) {
                        ctor.super_ = superCtor;
                        var TempCtor = function() {};
                        TempCtor.prototype = superCtor.prototype;
                        ctor.prototype = new TempCtor();
                        ctor.prototype.constructor = ctor;
                    }
                    // BN
                    function BN(number, base, endian) {
                        if (BN.isBN(number)) return number;
                        this.negative = 0;
                        this.words = null;
                        this.length = 0;
                        // Reduction context
                        this.red = null;
                        if (number !== null) {
                            if (base === "le" || base === "be") {
                                endian = base;
                                base = 10;
                            }
                            this._init(number || 0, base || 10, endian || "be");
                        }
                    }
                    if (typeof module1 === "object") module1.exports = BN;
                    else exports.BN = BN;
                    BN.BN = BN;
                    BN.wordSize = 26;
                    var Buffer;
                    try {
                        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
                        else Buffer = __webpack_require__(2574).Buffer;
                    } catch (e) {}
                    BN.isBN = function isBN(num) {
                        if (num instanceof BN) return true;
                        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
                    };
                    BN.max = function max(left, right) {
                        if (left.cmp(right) > 0) return left;
                        return right;
                    };
                    BN.min = function min(left, right) {
                        if (left.cmp(right) < 0) return left;
                        return right;
                    };
                    BN.prototype._init = function init(number, base, endian) {
                        if (typeof number === "number") return this._initNumber(number, base, endian);
                        if (typeof number === "object") return this._initArray(number, base, endian);
                        if (base === "hex") base = 16;
                        assert(base === (base | 0) && base >= 2 && base <= 36);
                        number = number.toString().replace(/\s+/g, "");
                        var start = 0;
                        if (number[0] === "-") {
                            start++;
                            this.negative = 1;
                        }
                        if (start < number.length) {
                            if (base === 16) this._parseHex(number, start, endian);
                            else {
                                this._parseBase(number, base, start);
                                if (endian === "le") this._initArray(this.toArray(), base, endian);
                            }
                        }
                    };
                    BN.prototype._initNumber = function _initNumber(number, base, endian) {
                        if (number < 0) {
                            this.negative = 1;
                            number = -number;
                        }
                        if (number < 0x4000000) {
                            this.words = [
                                number & 0x3ffffff
                            ];
                            this.length = 1;
                        } else if (number < 0x10000000000000) {
                            this.words = [
                                number & 0x3ffffff,
                                number / 0x4000000 & 0x3ffffff
                            ];
                            this.length = 2;
                        } else {
                            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
                            this.words = [
                                number & 0x3ffffff,
                                number / 0x4000000 & 0x3ffffff,
                                1
                            ];
                            this.length = 3;
                        }
                        if (endian !== "le") return;
                        // Reverse the bytes
                        this._initArray(this.toArray(), base, endian);
                    };
                    BN.prototype._initArray = function _initArray(number, base, endian) {
                        // Perhaps a Uint8Array
                        assert(typeof number.length === "number");
                        if (number.length <= 0) {
                            this.words = [
                                0
                            ];
                            this.length = 1;
                            return this;
                        }
                        this.length = Math.ceil(number.length / 3);
                        this.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)this.words[i] = 0;
                        var j, w;
                        var off = 0;
                        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
                            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
                            this.words[j] |= w << off & 0x3ffffff;
                            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
                            off += 24;
                            if (off >= 26) {
                                off -= 26;
                                j++;
                            }
                        }
                        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
                            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
                            this.words[j] |= w << off & 0x3ffffff;
                            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
                            off += 24;
                            if (off >= 26) {
                                off -= 26;
                                j++;
                            }
                        }
                        return this.strip();
                    };
                    function parseHex4Bits(string, index) {
                        var c = string.charCodeAt(index);
                        // 'A' - 'F'
                        if (c >= 65 && c <= 70) return c - 55;
                        else if (c >= 97 && c <= 102) return c - 87;
                        else return c - 48 & 0xf;
                    }
                    function parseHexByte(string, lowerBound, index) {
                        var r = parseHex4Bits(string, index);
                        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
                        return r;
                    }
                    BN.prototype._parseHex = function _parseHex(number, start, endian) {
                        // Create possibly bigger array to ensure that it fits the number
                        this.length = Math.ceil((number.length - start) / 6);
                        this.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)this.words[i] = 0;
                        // 24-bits chunks
                        var off = 0;
                        var j = 0;
                        var w;
                        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
                            w = parseHexByte(number, start, i) << off;
                            this.words[j] |= w & 0x3ffffff;
                            if (off >= 18) {
                                off -= 18;
                                j += 1;
                                this.words[j] |= w >>> 26;
                            } else off += 8;
                        }
                        else {
                            var parseLength = number.length - start;
                            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                                w = parseHexByte(number, start, i) << off;
                                this.words[j] |= w & 0x3ffffff;
                                if (off >= 18) {
                                    off -= 18;
                                    j += 1;
                                    this.words[j] |= w >>> 26;
                                } else off += 8;
                            }
                        }
                        this.strip();
                    };
                    function parseBase(str, start, end, mul) {
                        var r = 0;
                        var len = Math.min(str.length, end);
                        for(var i = start; i < len; i++){
                            var c = str.charCodeAt(i) - 48;
                            r *= mul;
                            // 'a'
                            if (c >= 49) r += c - 49 + 0xa;
                            else if (c >= 17) r += c - 17 + 0xa;
                            else r += c;
                        }
                        return r;
                    }
                    BN.prototype._parseBase = function _parseBase(number, base, start) {
                        // Initialize as zero
                        this.words = [
                            0
                        ];
                        this.length = 1;
                        // Find length of limb in base
                        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
                        limbLen--;
                        limbPow = limbPow / base | 0;
                        var total = number.length - start;
                        var mod = total % limbLen;
                        var end = Math.min(total, total - mod) + start;
                        var word = 0;
                        for(var i = start; i < end; i += limbLen){
                            word = parseBase(number, i, i + limbLen, base);
                            this.imuln(limbPow);
                            if (this.words[0] + word < 0x4000000) this.words[0] += word;
                            else this._iaddn(word);
                        }
                        if (mod !== 0) {
                            var pow = 1;
                            word = parseBase(number, i, number.length, base);
                            for(i = 0; i < mod; i++)pow *= base;
                            this.imuln(pow);
                            if (this.words[0] + word < 0x4000000) this.words[0] += word;
                            else this._iaddn(word);
                        }
                        this.strip();
                    };
                    BN.prototype.copy = function copy(dest) {
                        dest.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
                        dest.length = this.length;
                        dest.negative = this.negative;
                        dest.red = this.red;
                    };
                    BN.prototype.clone = function clone() {
                        var r = new BN(null);
                        this.copy(r);
                        return r;
                    };
                    BN.prototype._expand = function _expand(size) {
                        while(this.length < size)this.words[this.length++] = 0;
                        return this;
                    };
                    // Remove leading `0` from `this`
                    BN.prototype.strip = function strip() {
                        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
                        return this._normSign();
                    };
                    BN.prototype._normSign = function _normSign() {
                        // -0 = 0
                        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
                        return this;
                    };
                    BN.prototype.inspect = function inspect() {
                        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                    };
                    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
                        "",
                        "0",
                        "00",
                        "000",
                        "0000",
                        "00000",
                        "000000",
                        "0000000",
                        "00000000",
                        "000000000",
                        "0000000000",
                        "00000000000",
                        "000000000000",
                        "0000000000000",
                        "00000000000000",
                        "000000000000000",
                        "0000000000000000",
                        "00000000000000000",
                        "000000000000000000",
                        "0000000000000000000",
                        "00000000000000000000",
                        "000000000000000000000",
                        "0000000000000000000000",
                        "00000000000000000000000",
                        "000000000000000000000000",
                        "0000000000000000000000000"
                    ];
                    var groupSizes = [
                        0,
                        0,
                        25,
                        16,
                        12,
                        11,
                        10,
                        9,
                        8,
                        8,
                        7,
                        7,
                        7,
                        7,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5
                    ];
                    var groupBases = [
                        0,
                        0,
                        33554432,
                        43046721,
                        16777216,
                        48828125,
                        60466176,
                        40353607,
                        16777216,
                        43046721,
                        10000000,
                        19487171,
                        35831808,
                        62748517,
                        7529536,
                        11390625,
                        16777216,
                        24137569,
                        34012224,
                        47045881,
                        64000000,
                        4084101,
                        5153632,
                        6436343,
                        7962624,
                        9765625,
                        11881376,
                        14348907,
                        17210368,
                        20511149,
                        24300000,
                        28629151,
                        33554432,
                        39135393,
                        45435424,
                        52521875,
                        60466176
                    ];
                    BN.prototype.toString = function toString(base, padding) {
                        base = base || 10;
                        padding = padding | 0 || 1;
                        var out;
                        if (base === 16 || base === "hex") {
                            out = "";
                            var off = 0;
                            var carry = 0;
                            for(var i = 0; i < this.length; i++){
                                var w = this.words[i];
                                var word = ((w << off | carry) & 0xffffff).toString(16);
                                carry = w >>> 24 - off & 0xffffff;
                                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                                else out = word + out;
                                off += 2;
                                if (off >= 26) {
                                    off -= 26;
                                    i--;
                                }
                            }
                            if (carry !== 0) out = carry.toString(16) + out;
                            while(out.length % padding !== 0)out = "0" + out;
                            if (this.negative !== 0) out = "-" + out;
                            return out;
                        }
                        if (base === (base | 0) && base >= 2 && base <= 36) {
                            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
                            var groupSize = groupSizes[base];
                            // var groupBase = Math.pow(base, groupSize);
                            var groupBase = groupBases[base];
                            out = "";
                            var c = this.clone();
                            c.negative = 0;
                            while(!c.isZero()){
                                var r = c.modn(groupBase).toString(base);
                                c = c.idivn(groupBase);
                                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                                else out = r + out;
                            }
                            if (this.isZero()) out = "0" + out;
                            while(out.length % padding !== 0)out = "0" + out;
                            if (this.negative !== 0) out = "-" + out;
                            return out;
                        }
                        assert(false, "Base should be between 2 and 36");
                    };
                    BN.prototype.toNumber = function toNumber() {
                        var ret = this.words[0];
                        if (this.length === 2) ret += this.words[1] * 0x4000000;
                        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
                        ret += 0x10000000000000 + this.words[1] * 0x4000000;
                        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
                        return this.negative !== 0 ? -ret : ret;
                    };
                    BN.prototype.toJSON = function toJSON() {
                        return this.toString(16);
                    };
                    BN.prototype.toBuffer = function toBuffer(endian, length) {
                        assert(typeof Buffer !== "undefined");
                        return this.toArrayLike(Buffer, endian, length);
                    };
                    BN.prototype.toArray = function toArray(endian, length) {
                        return this.toArrayLike(Array, endian, length);
                    };
                    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
                        var byteLength = this.byteLength();
                        var reqLength = length || Math.max(1, byteLength);
                        assert(byteLength <= reqLength, "byte array longer than desired length");
                        assert(reqLength > 0, "Requested array length <= 0");
                        this.strip();
                        var littleEndian = endian === "le";
                        var res = new ArrayType(reqLength);
                        var b, i;
                        var q = this.clone();
                        if (!littleEndian) {
                            // Assume big-endian
                            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
                            for(i = 0; !q.isZero(); i++){
                                b = q.andln(0xff);
                                q.iushrn(8);
                                res[reqLength - i - 1] = b;
                            }
                        } else {
                            for(i = 0; !q.isZero(); i++){
                                b = q.andln(0xff);
                                q.iushrn(8);
                                res[i] = b;
                            }
                            for(; i < reqLength; i++)res[i] = 0;
                        }
                        return res;
                    };
                    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
                        return 32 - Math.clz32(w);
                    };
                    else BN.prototype._countBits = function _countBits(w) {
                        var t = w;
                        var r = 0;
                        if (t >= 0x1000) {
                            r += 13;
                            t >>>= 13;
                        }
                        if (t >= 0x40) {
                            r += 7;
                            t >>>= 7;
                        }
                        if (t >= 0x8) {
                            r += 4;
                            t >>>= 4;
                        }
                        if (t >= 0x02) {
                            r += 2;
                            t >>>= 2;
                        }
                        return r + t;
                    };
                    BN.prototype._zeroBits = function _zeroBits(w) {
                        // Short-cut
                        if (w === 0) return 26;
                        var t = w;
                        var r = 0;
                        if ((t & 0x1fff) === 0) {
                            r += 13;
                            t >>>= 13;
                        }
                        if ((t & 0x7f) === 0) {
                            r += 7;
                            t >>>= 7;
                        }
                        if ((t & 0xf) === 0) {
                            r += 4;
                            t >>>= 4;
                        }
                        if ((t & 0x3) === 0) {
                            r += 2;
                            t >>>= 2;
                        }
                        if ((t & 0x1) === 0) r++;
                        return r;
                    };
                    // Return number of used bits in a BN
                    BN.prototype.bitLength = function bitLength() {
                        var w = this.words[this.length - 1];
                        var hi = this._countBits(w);
                        return (this.length - 1) * 26 + hi;
                    };
                    function toBitArray(num) {
                        var w = new Array(num.bitLength());
                        for(var bit = 0; bit < w.length; bit++){
                            var off = bit / 26 | 0;
                            var wbit = bit % 26;
                            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
                        }
                        return w;
                    }
                    // Number of trailing zero bits
                    BN.prototype.zeroBits = function zeroBits() {
                        if (this.isZero()) return 0;
                        var r = 0;
                        for(var i = 0; i < this.length; i++){
                            var b = this._zeroBits(this.words[i]);
                            r += b;
                            if (b !== 26) break;
                        }
                        return r;
                    };
                    BN.prototype.byteLength = function byteLength() {
                        return Math.ceil(this.bitLength() / 8);
                    };
                    BN.prototype.toTwos = function toTwos(width) {
                        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
                        return this.clone();
                    };
                    BN.prototype.fromTwos = function fromTwos(width) {
                        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
                        return this.clone();
                    };
                    BN.prototype.isNeg = function isNeg() {
                        return this.negative !== 0;
                    };
                    // Return negative clone of `this`
                    BN.prototype.neg = function neg() {
                        return this.clone().ineg();
                    };
                    BN.prototype.ineg = function ineg() {
                        if (!this.isZero()) this.negative ^= 1;
                        return this;
                    };
                    // Or `num` with `this` in-place
                    BN.prototype.iuor = function iuor(num) {
                        while(this.length < num.length)this.words[this.length++] = 0;
                        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
                        return this.strip();
                    };
                    BN.prototype.ior = function ior(num) {
                        assert((this.negative | num.negative) === 0);
                        return this.iuor(num);
                    };
                    // Or `num` with `this`
                    BN.prototype.or = function or(num) {
                        if (this.length > num.length) return this.clone().ior(num);
                        return num.clone().ior(this);
                    };
                    BN.prototype.uor = function uor(num) {
                        if (this.length > num.length) return this.clone().iuor(num);
                        return num.clone().iuor(this);
                    };
                    // And `num` with `this` in-place
                    BN.prototype.iuand = function iuand(num) {
                        // b = min-length(num, this)
                        var b;
                        if (this.length > num.length) b = num;
                        else b = this;
                        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
                        this.length = b.length;
                        return this.strip();
                    };
                    BN.prototype.iand = function iand(num) {
                        assert((this.negative | num.negative) === 0);
                        return this.iuand(num);
                    };
                    // And `num` with `this`
                    BN.prototype.and = function and(num) {
                        if (this.length > num.length) return this.clone().iand(num);
                        return num.clone().iand(this);
                    };
                    BN.prototype.uand = function uand(num) {
                        if (this.length > num.length) return this.clone().iuand(num);
                        return num.clone().iuand(this);
                    };
                    // Xor `num` with `this` in-place
                    BN.prototype.iuxor = function iuxor(num) {
                        // a.length > b.length
                        var a;
                        var b;
                        if (this.length > num.length) {
                            a = this;
                            b = num;
                        } else {
                            a = num;
                            b = this;
                        }
                        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
                        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
                        this.length = a.length;
                        return this.strip();
                    };
                    BN.prototype.ixor = function ixor(num) {
                        assert((this.negative | num.negative) === 0);
                        return this.iuxor(num);
                    };
                    // Xor `num` with `this`
                    BN.prototype.xor = function xor(num) {
                        if (this.length > num.length) return this.clone().ixor(num);
                        return num.clone().ixor(this);
                    };
                    BN.prototype.uxor = function uxor(num) {
                        if (this.length > num.length) return this.clone().iuxor(num);
                        return num.clone().iuxor(this);
                    };
                    // Not ``this`` with ``width`` bitwidth
                    BN.prototype.inotn = function inotn(width) {
                        assert(typeof width === "number" && width >= 0);
                        var bytesNeeded = Math.ceil(width / 26) | 0;
                        var bitsLeft = width % 26;
                        // Extend the buffer with leading zeroes
                        this._expand(bytesNeeded);
                        if (bitsLeft > 0) bytesNeeded--;
                        // Handle complete words
                        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
                        // Handle the residue
                        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
                        // And remove leading zeroes
                        return this.strip();
                    };
                    BN.prototype.notn = function notn(width) {
                        return this.clone().inotn(width);
                    };
                    // Set `bit` of `this`
                    BN.prototype.setn = function setn(bit, val) {
                        assert(typeof bit === "number" && bit >= 0);
                        var off = bit / 26 | 0;
                        var wbit = bit % 26;
                        this._expand(off + 1);
                        if (val) this.words[off] = this.words[off] | 1 << wbit;
                        else this.words[off] = this.words[off] & ~(1 << wbit);
                        return this.strip();
                    };
                    // Add `num` to `this` in-place
                    BN.prototype.iadd = function iadd(num) {
                        var r;
                        // negative + positive
                        if (this.negative !== 0 && num.negative === 0) {
                            this.negative = 0;
                            r = this.isub(num);
                            this.negative ^= 1;
                            return this._normSign();
                        // positive + negative
                        } else if (this.negative === 0 && num.negative !== 0) {
                            num.negative = 0;
                            r = this.isub(num);
                            num.negative = 1;
                            return r._normSign();
                        }
                        // a.length > b.length
                        var a, b;
                        if (this.length > num.length) {
                            a = this;
                            b = num;
                        } else {
                            a = num;
                            b = this;
                        }
                        var carry = 0;
                        for(var i = 0; i < b.length; i++){
                            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
                            this.words[i] = r & 0x3ffffff;
                            carry = r >>> 26;
                        }
                        for(; carry !== 0 && i < a.length; i++){
                            r = (a.words[i] | 0) + carry;
                            this.words[i] = r & 0x3ffffff;
                            carry = r >>> 26;
                        }
                        this.length = a.length;
                        if (carry !== 0) {
                            this.words[this.length] = carry;
                            this.length++;
                        // Copy the rest of the words
                        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
                        return this;
                    };
                    // Add `num` to `this`
                    BN.prototype.add = function add(num) {
                        var res;
                        if (num.negative !== 0 && this.negative === 0) {
                            num.negative = 0;
                            res = this.sub(num);
                            num.negative ^= 1;
                            return res;
                        } else if (num.negative === 0 && this.negative !== 0) {
                            this.negative = 0;
                            res = num.sub(this);
                            this.negative = 1;
                            return res;
                        }
                        if (this.length > num.length) return this.clone().iadd(num);
                        return num.clone().iadd(this);
                    };
                    // Subtract `num` from `this` in-place
                    BN.prototype.isub = function isub(num) {
                        // this - (-num) = this + num
                        if (num.negative !== 0) {
                            num.negative = 0;
                            var r = this.iadd(num);
                            num.negative = 1;
                            return r._normSign();
                        // -this - num = -(this + num)
                        } else if (this.negative !== 0) {
                            this.negative = 0;
                            this.iadd(num);
                            this.negative = 1;
                            return this._normSign();
                        }
                        // At this point both numbers are positive
                        var cmp = this.cmp(num);
                        // Optimization - zeroify
                        if (cmp === 0) {
                            this.negative = 0;
                            this.length = 1;
                            this.words[0] = 0;
                            return this;
                        }
                        // a > b
                        var a, b;
                        if (cmp > 0) {
                            a = this;
                            b = num;
                        } else {
                            a = num;
                            b = this;
                        }
                        var carry = 0;
                        for(var i = 0; i < b.length; i++){
                            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
                            carry = r >> 26;
                            this.words[i] = r & 0x3ffffff;
                        }
                        for(; carry !== 0 && i < a.length; i++){
                            r = (a.words[i] | 0) + carry;
                            carry = r >> 26;
                            this.words[i] = r & 0x3ffffff;
                        }
                        // Copy rest of the words
                        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
                        this.length = Math.max(this.length, i);
                        if (a !== this) this.negative = 1;
                        return this.strip();
                    };
                    // Subtract `num` from `this`
                    BN.prototype.sub = function sub(num) {
                        return this.clone().isub(num);
                    };
                    function smallMulTo(self1, num, out) {
                        out.negative = num.negative ^ self1.negative;
                        var len = self1.length + num.length | 0;
                        out.length = len;
                        len = len - 1 | 0;
                        // Peel one iteration (compiler can't do it, because of code complexity)
                        var a = self1.words[0] | 0;
                        var b = num.words[0] | 0;
                        var r = a * b;
                        var lo = r & 0x3ffffff;
                        var carry = r / 0x4000000 | 0;
                        out.words[0] = lo;
                        for(var k = 1; k < len; k++){
                            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
                            // note that ncarry could be >= 0x3ffffff
                            var ncarry = carry >>> 26;
                            var rword = carry & 0x3ffffff;
                            var maxJ = Math.min(k, num.length - 1);
                            for(var j = Math.max(0, k - self1.length + 1); j <= maxJ; j++){
                                var i = k - j | 0;
                                a = self1.words[i] | 0;
                                b = num.words[j] | 0;
                                r = a * b + rword;
                                ncarry += r / 0x4000000 | 0;
                                rword = r & 0x3ffffff;
                            }
                            out.words[k] = rword | 0;
                            carry = ncarry | 0;
                        }
                        if (carry !== 0) out.words[k] = carry | 0;
                        else out.length--;
                        return out.strip();
                    }
                    // TODO(indutny): it may be reasonable to omit it for users who don't need
                    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
                    // multiplication (like elliptic secp256k1).
                    var comb10MulTo = function comb10MulTo(self1, num, out) {
                        var a = self1.words;
                        var b = num.words;
                        var o = out.words;
                        var c = 0;
                        var lo;
                        var mid;
                        var hi;
                        var a0 = a[0] | 0;
                        var al0 = a0 & 0x1fff;
                        var ah0 = a0 >>> 13;
                        var a1 = a[1] | 0;
                        var al1 = a1 & 0x1fff;
                        var ah1 = a1 >>> 13;
                        var a2 = a[2] | 0;
                        var al2 = a2 & 0x1fff;
                        var ah2 = a2 >>> 13;
                        var a3 = a[3] | 0;
                        var al3 = a3 & 0x1fff;
                        var ah3 = a3 >>> 13;
                        var a4 = a[4] | 0;
                        var al4 = a4 & 0x1fff;
                        var ah4 = a4 >>> 13;
                        var a5 = a[5] | 0;
                        var al5 = a5 & 0x1fff;
                        var ah5 = a5 >>> 13;
                        var a6 = a[6] | 0;
                        var al6 = a6 & 0x1fff;
                        var ah6 = a6 >>> 13;
                        var a7 = a[7] | 0;
                        var al7 = a7 & 0x1fff;
                        var ah7 = a7 >>> 13;
                        var a8 = a[8] | 0;
                        var al8 = a8 & 0x1fff;
                        var ah8 = a8 >>> 13;
                        var a9 = a[9] | 0;
                        var al9 = a9 & 0x1fff;
                        var ah9 = a9 >>> 13;
                        var b0 = b[0] | 0;
                        var bl0 = b0 & 0x1fff;
                        var bh0 = b0 >>> 13;
                        var b1 = b[1] | 0;
                        var bl1 = b1 & 0x1fff;
                        var bh1 = b1 >>> 13;
                        var b2 = b[2] | 0;
                        var bl2 = b2 & 0x1fff;
                        var bh2 = b2 >>> 13;
                        var b3 = b[3] | 0;
                        var bl3 = b3 & 0x1fff;
                        var bh3 = b3 >>> 13;
                        var b4 = b[4] | 0;
                        var bl4 = b4 & 0x1fff;
                        var bh4 = b4 >>> 13;
                        var b5 = b[5] | 0;
                        var bl5 = b5 & 0x1fff;
                        var bh5 = b5 >>> 13;
                        var b6 = b[6] | 0;
                        var bl6 = b6 & 0x1fff;
                        var bh6 = b6 >>> 13;
                        var b7 = b[7] | 0;
                        var bl7 = b7 & 0x1fff;
                        var bh7 = b7 >>> 13;
                        var b8 = b[8] | 0;
                        var bl8 = b8 & 0x1fff;
                        var bh8 = b8 >>> 13;
                        var b9 = b[9] | 0;
                        var bl9 = b9 & 0x1fff;
                        var bh9 = b9 >>> 13;
                        out.negative = self1.negative ^ num.negative;
                        out.length = 19;
                        /* k = 0 */ lo = Math.imul(al0, bl0);
                        mid = Math.imul(al0, bh0);
                        mid = mid + Math.imul(ah0, bl0) | 0;
                        hi = Math.imul(ah0, bh0);
                        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
                        w0 &= 0x3ffffff;
                        /* k = 1 */ lo = Math.imul(al1, bl0);
                        mid = Math.imul(al1, bh0);
                        mid = mid + Math.imul(ah1, bl0) | 0;
                        hi = Math.imul(ah1, bh0);
                        lo = lo + Math.imul(al0, bl1) | 0;
                        mid = mid + Math.imul(al0, bh1) | 0;
                        mid = mid + Math.imul(ah0, bl1) | 0;
                        hi = hi + Math.imul(ah0, bh1) | 0;
                        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
                        w1 &= 0x3ffffff;
                        /* k = 2 */ lo = Math.imul(al2, bl0);
                        mid = Math.imul(al2, bh0);
                        mid = mid + Math.imul(ah2, bl0) | 0;
                        hi = Math.imul(ah2, bh0);
                        lo = lo + Math.imul(al1, bl1) | 0;
                        mid = mid + Math.imul(al1, bh1) | 0;
                        mid = mid + Math.imul(ah1, bl1) | 0;
                        hi = hi + Math.imul(ah1, bh1) | 0;
                        lo = lo + Math.imul(al0, bl2) | 0;
                        mid = mid + Math.imul(al0, bh2) | 0;
                        mid = mid + Math.imul(ah0, bl2) | 0;
                        hi = hi + Math.imul(ah0, bh2) | 0;
                        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
                        w2 &= 0x3ffffff;
                        /* k = 3 */ lo = Math.imul(al3, bl0);
                        mid = Math.imul(al3, bh0);
                        mid = mid + Math.imul(ah3, bl0) | 0;
                        hi = Math.imul(ah3, bh0);
                        lo = lo + Math.imul(al2, bl1) | 0;
                        mid = mid + Math.imul(al2, bh1) | 0;
                        mid = mid + Math.imul(ah2, bl1) | 0;
                        hi = hi + Math.imul(ah2, bh1) | 0;
                        lo = lo + Math.imul(al1, bl2) | 0;
                        mid = mid + Math.imul(al1, bh2) | 0;
                        mid = mid + Math.imul(ah1, bl2) | 0;
                        hi = hi + Math.imul(ah1, bh2) | 0;
                        lo = lo + Math.imul(al0, bl3) | 0;
                        mid = mid + Math.imul(al0, bh3) | 0;
                        mid = mid + Math.imul(ah0, bl3) | 0;
                        hi = hi + Math.imul(ah0, bh3) | 0;
                        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
                        w3 &= 0x3ffffff;
                        /* k = 4 */ lo = Math.imul(al4, bl0);
                        mid = Math.imul(al4, bh0);
                        mid = mid + Math.imul(ah4, bl0) | 0;
                        hi = Math.imul(ah4, bh0);
                        lo = lo + Math.imul(al3, bl1) | 0;
                        mid = mid + Math.imul(al3, bh1) | 0;
                        mid = mid + Math.imul(ah3, bl1) | 0;
                        hi = hi + Math.imul(ah3, bh1) | 0;
                        lo = lo + Math.imul(al2, bl2) | 0;
                        mid = mid + Math.imul(al2, bh2) | 0;
                        mid = mid + Math.imul(ah2, bl2) | 0;
                        hi = hi + Math.imul(ah2, bh2) | 0;
                        lo = lo + Math.imul(al1, bl3) | 0;
                        mid = mid + Math.imul(al1, bh3) | 0;
                        mid = mid + Math.imul(ah1, bl3) | 0;
                        hi = hi + Math.imul(ah1, bh3) | 0;
                        lo = lo + Math.imul(al0, bl4) | 0;
                        mid = mid + Math.imul(al0, bh4) | 0;
                        mid = mid + Math.imul(ah0, bl4) | 0;
                        hi = hi + Math.imul(ah0, bh4) | 0;
                        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
                        w4 &= 0x3ffffff;
                        /* k = 5 */ lo = Math.imul(al5, bl0);
                        mid = Math.imul(al5, bh0);
                        mid = mid + Math.imul(ah5, bl0) | 0;
                        hi = Math.imul(ah5, bh0);
                        lo = lo + Math.imul(al4, bl1) | 0;
                        mid = mid + Math.imul(al4, bh1) | 0;
                        mid = mid + Math.imul(ah4, bl1) | 0;
                        hi = hi + Math.imul(ah4, bh1) | 0;
                        lo = lo + Math.imul(al3, bl2) | 0;
                        mid = mid + Math.imul(al3, bh2) | 0;
                        mid = mid + Math.imul(ah3, bl2) | 0;
                        hi = hi + Math.imul(ah3, bh2) | 0;
                        lo = lo + Math.imul(al2, bl3) | 0;
                        mid = mid + Math.imul(al2, bh3) | 0;
                        mid = mid + Math.imul(ah2, bl3) | 0;
                        hi = hi + Math.imul(ah2, bh3) | 0;
                        lo = lo + Math.imul(al1, bl4) | 0;
                        mid = mid + Math.imul(al1, bh4) | 0;
                        mid = mid + Math.imul(ah1, bl4) | 0;
                        hi = hi + Math.imul(ah1, bh4) | 0;
                        lo = lo + Math.imul(al0, bl5) | 0;
                        mid = mid + Math.imul(al0, bh5) | 0;
                        mid = mid + Math.imul(ah0, bl5) | 0;
                        hi = hi + Math.imul(ah0, bh5) | 0;
                        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
                        w5 &= 0x3ffffff;
                        /* k = 6 */ lo = Math.imul(al6, bl0);
                        mid = Math.imul(al6, bh0);
                        mid = mid + Math.imul(ah6, bl0) | 0;
                        hi = Math.imul(ah6, bh0);
                        lo = lo + Math.imul(al5, bl1) | 0;
                        mid = mid + Math.imul(al5, bh1) | 0;
                        mid = mid + Math.imul(ah5, bl1) | 0;
                        hi = hi + Math.imul(ah5, bh1) | 0;
                        lo = lo + Math.imul(al4, bl2) | 0;
                        mid = mid + Math.imul(al4, bh2) | 0;
                        mid = mid + Math.imul(ah4, bl2) | 0;
                        hi = hi + Math.imul(ah4, bh2) | 0;
                        lo = lo + Math.imul(al3, bl3) | 0;
                        mid = mid + Math.imul(al3, bh3) | 0;
                        mid = mid + Math.imul(ah3, bl3) | 0;
                        hi = hi + Math.imul(ah3, bh3) | 0;
                        lo = lo + Math.imul(al2, bl4) | 0;
                        mid = mid + Math.imul(al2, bh4) | 0;
                        mid = mid + Math.imul(ah2, bl4) | 0;
                        hi = hi + Math.imul(ah2, bh4) | 0;
                        lo = lo + Math.imul(al1, bl5) | 0;
                        mid = mid + Math.imul(al1, bh5) | 0;
                        mid = mid + Math.imul(ah1, bl5) | 0;
                        hi = hi + Math.imul(ah1, bh5) | 0;
                        lo = lo + Math.imul(al0, bl6) | 0;
                        mid = mid + Math.imul(al0, bh6) | 0;
                        mid = mid + Math.imul(ah0, bl6) | 0;
                        hi = hi + Math.imul(ah0, bh6) | 0;
                        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
                        w6 &= 0x3ffffff;
                        /* k = 7 */ lo = Math.imul(al7, bl0);
                        mid = Math.imul(al7, bh0);
                        mid = mid + Math.imul(ah7, bl0) | 0;
                        hi = Math.imul(ah7, bh0);
                        lo = lo + Math.imul(al6, bl1) | 0;
                        mid = mid + Math.imul(al6, bh1) | 0;
                        mid = mid + Math.imul(ah6, bl1) | 0;
                        hi = hi + Math.imul(ah6, bh1) | 0;
                        lo = lo + Math.imul(al5, bl2) | 0;
                        mid = mid + Math.imul(al5, bh2) | 0;
                        mid = mid + Math.imul(ah5, bl2) | 0;
                        hi = hi + Math.imul(ah5, bh2) | 0;
                        lo = lo + Math.imul(al4, bl3) | 0;
                        mid = mid + Math.imul(al4, bh3) | 0;
                        mid = mid + Math.imul(ah4, bl3) | 0;
                        hi = hi + Math.imul(ah4, bh3) | 0;
                        lo = lo + Math.imul(al3, bl4) | 0;
                        mid = mid + Math.imul(al3, bh4) | 0;
                        mid = mid + Math.imul(ah3, bl4) | 0;
                        hi = hi + Math.imul(ah3, bh4) | 0;
                        lo = lo + Math.imul(al2, bl5) | 0;
                        mid = mid + Math.imul(al2, bh5) | 0;
                        mid = mid + Math.imul(ah2, bl5) | 0;
                        hi = hi + Math.imul(ah2, bh5) | 0;
                        lo = lo + Math.imul(al1, bl6) | 0;
                        mid = mid + Math.imul(al1, bh6) | 0;
                        mid = mid + Math.imul(ah1, bl6) | 0;
                        hi = hi + Math.imul(ah1, bh6) | 0;
                        lo = lo + Math.imul(al0, bl7) | 0;
                        mid = mid + Math.imul(al0, bh7) | 0;
                        mid = mid + Math.imul(ah0, bl7) | 0;
                        hi = hi + Math.imul(ah0, bh7) | 0;
                        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
                        w7 &= 0x3ffffff;
                        /* k = 8 */ lo = Math.imul(al8, bl0);
                        mid = Math.imul(al8, bh0);
                        mid = mid + Math.imul(ah8, bl0) | 0;
                        hi = Math.imul(ah8, bh0);
                        lo = lo + Math.imul(al7, bl1) | 0;
                        mid = mid + Math.imul(al7, bh1) | 0;
                        mid = mid + Math.imul(ah7, bl1) | 0;
                        hi = hi + Math.imul(ah7, bh1) | 0;
                        lo = lo + Math.imul(al6, bl2) | 0;
                        mid = mid + Math.imul(al6, bh2) | 0;
                        mid = mid + Math.imul(ah6, bl2) | 0;
                        hi = hi + Math.imul(ah6, bh2) | 0;
                        lo = lo + Math.imul(al5, bl3) | 0;
                        mid = mid + Math.imul(al5, bh3) | 0;
                        mid = mid + Math.imul(ah5, bl3) | 0;
                        hi = hi + Math.imul(ah5, bh3) | 0;
                        lo = lo + Math.imul(al4, bl4) | 0;
                        mid = mid + Math.imul(al4, bh4) | 0;
                        mid = mid + Math.imul(ah4, bl4) | 0;
                        hi = hi + Math.imul(ah4, bh4) | 0;
                        lo = lo + Math.imul(al3, bl5) | 0;
                        mid = mid + Math.imul(al3, bh5) | 0;
                        mid = mid + Math.imul(ah3, bl5) | 0;
                        hi = hi + Math.imul(ah3, bh5) | 0;
                        lo = lo + Math.imul(al2, bl6) | 0;
                        mid = mid + Math.imul(al2, bh6) | 0;
                        mid = mid + Math.imul(ah2, bl6) | 0;
                        hi = hi + Math.imul(ah2, bh6) | 0;
                        lo = lo + Math.imul(al1, bl7) | 0;
                        mid = mid + Math.imul(al1, bh7) | 0;
                        mid = mid + Math.imul(ah1, bl7) | 0;
                        hi = hi + Math.imul(ah1, bh7) | 0;
                        lo = lo + Math.imul(al0, bl8) | 0;
                        mid = mid + Math.imul(al0, bh8) | 0;
                        mid = mid + Math.imul(ah0, bl8) | 0;
                        hi = hi + Math.imul(ah0, bh8) | 0;
                        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
                        w8 &= 0x3ffffff;
                        /* k = 9 */ lo = Math.imul(al9, bl0);
                        mid = Math.imul(al9, bh0);
                        mid = mid + Math.imul(ah9, bl0) | 0;
                        hi = Math.imul(ah9, bh0);
                        lo = lo + Math.imul(al8, bl1) | 0;
                        mid = mid + Math.imul(al8, bh1) | 0;
                        mid = mid + Math.imul(ah8, bl1) | 0;
                        hi = hi + Math.imul(ah8, bh1) | 0;
                        lo = lo + Math.imul(al7, bl2) | 0;
                        mid = mid + Math.imul(al7, bh2) | 0;
                        mid = mid + Math.imul(ah7, bl2) | 0;
                        hi = hi + Math.imul(ah7, bh2) | 0;
                        lo = lo + Math.imul(al6, bl3) | 0;
                        mid = mid + Math.imul(al6, bh3) | 0;
                        mid = mid + Math.imul(ah6, bl3) | 0;
                        hi = hi + Math.imul(ah6, bh3) | 0;
                        lo = lo + Math.imul(al5, bl4) | 0;
                        mid = mid + Math.imul(al5, bh4) | 0;
                        mid = mid + Math.imul(ah5, bl4) | 0;
                        hi = hi + Math.imul(ah5, bh4) | 0;
                        lo = lo + Math.imul(al4, bl5) | 0;
                        mid = mid + Math.imul(al4, bh5) | 0;
                        mid = mid + Math.imul(ah4, bl5) | 0;
                        hi = hi + Math.imul(ah4, bh5) | 0;
                        lo = lo + Math.imul(al3, bl6) | 0;
                        mid = mid + Math.imul(al3, bh6) | 0;
                        mid = mid + Math.imul(ah3, bl6) | 0;
                        hi = hi + Math.imul(ah3, bh6) | 0;
                        lo = lo + Math.imul(al2, bl7) | 0;
                        mid = mid + Math.imul(al2, bh7) | 0;
                        mid = mid + Math.imul(ah2, bl7) | 0;
                        hi = hi + Math.imul(ah2, bh7) | 0;
                        lo = lo + Math.imul(al1, bl8) | 0;
                        mid = mid + Math.imul(al1, bh8) | 0;
                        mid = mid + Math.imul(ah1, bl8) | 0;
                        hi = hi + Math.imul(ah1, bh8) | 0;
                        lo = lo + Math.imul(al0, bl9) | 0;
                        mid = mid + Math.imul(al0, bh9) | 0;
                        mid = mid + Math.imul(ah0, bl9) | 0;
                        hi = hi + Math.imul(ah0, bh9) | 0;
                        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
                        w9 &= 0x3ffffff;
                        /* k = 10 */ lo = Math.imul(al9, bl1);
                        mid = Math.imul(al9, bh1);
                        mid = mid + Math.imul(ah9, bl1) | 0;
                        hi = Math.imul(ah9, bh1);
                        lo = lo + Math.imul(al8, bl2) | 0;
                        mid = mid + Math.imul(al8, bh2) | 0;
                        mid = mid + Math.imul(ah8, bl2) | 0;
                        hi = hi + Math.imul(ah8, bh2) | 0;
                        lo = lo + Math.imul(al7, bl3) | 0;
                        mid = mid + Math.imul(al7, bh3) | 0;
                        mid = mid + Math.imul(ah7, bl3) | 0;
                        hi = hi + Math.imul(ah7, bh3) | 0;
                        lo = lo + Math.imul(al6, bl4) | 0;
                        mid = mid + Math.imul(al6, bh4) | 0;
                        mid = mid + Math.imul(ah6, bl4) | 0;
                        hi = hi + Math.imul(ah6, bh4) | 0;
                        lo = lo + Math.imul(al5, bl5) | 0;
                        mid = mid + Math.imul(al5, bh5) | 0;
                        mid = mid + Math.imul(ah5, bl5) | 0;
                        hi = hi + Math.imul(ah5, bh5) | 0;
                        lo = lo + Math.imul(al4, bl6) | 0;
                        mid = mid + Math.imul(al4, bh6) | 0;
                        mid = mid + Math.imul(ah4, bl6) | 0;
                        hi = hi + Math.imul(ah4, bh6) | 0;
                        lo = lo + Math.imul(al3, bl7) | 0;
                        mid = mid + Math.imul(al3, bh7) | 0;
                        mid = mid + Math.imul(ah3, bl7) | 0;
                        hi = hi + Math.imul(ah3, bh7) | 0;
                        lo = lo + Math.imul(al2, bl8) | 0;
                        mid = mid + Math.imul(al2, bh8) | 0;
                        mid = mid + Math.imul(ah2, bl8) | 0;
                        hi = hi + Math.imul(ah2, bh8) | 0;
                        lo = lo + Math.imul(al1, bl9) | 0;
                        mid = mid + Math.imul(al1, bh9) | 0;
                        mid = mid + Math.imul(ah1, bl9) | 0;
                        hi = hi + Math.imul(ah1, bh9) | 0;
                        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
                        w10 &= 0x3ffffff;
                        /* k = 11 */ lo = Math.imul(al9, bl2);
                        mid = Math.imul(al9, bh2);
                        mid = mid + Math.imul(ah9, bl2) | 0;
                        hi = Math.imul(ah9, bh2);
                        lo = lo + Math.imul(al8, bl3) | 0;
                        mid = mid + Math.imul(al8, bh3) | 0;
                        mid = mid + Math.imul(ah8, bl3) | 0;
                        hi = hi + Math.imul(ah8, bh3) | 0;
                        lo = lo + Math.imul(al7, bl4) | 0;
                        mid = mid + Math.imul(al7, bh4) | 0;
                        mid = mid + Math.imul(ah7, bl4) | 0;
                        hi = hi + Math.imul(ah7, bh4) | 0;
                        lo = lo + Math.imul(al6, bl5) | 0;
                        mid = mid + Math.imul(al6, bh5) | 0;
                        mid = mid + Math.imul(ah6, bl5) | 0;
                        hi = hi + Math.imul(ah6, bh5) | 0;
                        lo = lo + Math.imul(al5, bl6) | 0;
                        mid = mid + Math.imul(al5, bh6) | 0;
                        mid = mid + Math.imul(ah5, bl6) | 0;
                        hi = hi + Math.imul(ah5, bh6) | 0;
                        lo = lo + Math.imul(al4, bl7) | 0;
                        mid = mid + Math.imul(al4, bh7) | 0;
                        mid = mid + Math.imul(ah4, bl7) | 0;
                        hi = hi + Math.imul(ah4, bh7) | 0;
                        lo = lo + Math.imul(al3, bl8) | 0;
                        mid = mid + Math.imul(al3, bh8) | 0;
                        mid = mid + Math.imul(ah3, bl8) | 0;
                        hi = hi + Math.imul(ah3, bh8) | 0;
                        lo = lo + Math.imul(al2, bl9) | 0;
                        mid = mid + Math.imul(al2, bh9) | 0;
                        mid = mid + Math.imul(ah2, bl9) | 0;
                        hi = hi + Math.imul(ah2, bh9) | 0;
                        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
                        w11 &= 0x3ffffff;
                        /* k = 12 */ lo = Math.imul(al9, bl3);
                        mid = Math.imul(al9, bh3);
                        mid = mid + Math.imul(ah9, bl3) | 0;
                        hi = Math.imul(ah9, bh3);
                        lo = lo + Math.imul(al8, bl4) | 0;
                        mid = mid + Math.imul(al8, bh4) | 0;
                        mid = mid + Math.imul(ah8, bl4) | 0;
                        hi = hi + Math.imul(ah8, bh4) | 0;
                        lo = lo + Math.imul(al7, bl5) | 0;
                        mid = mid + Math.imul(al7, bh5) | 0;
                        mid = mid + Math.imul(ah7, bl5) | 0;
                        hi = hi + Math.imul(ah7, bh5) | 0;
                        lo = lo + Math.imul(al6, bl6) | 0;
                        mid = mid + Math.imul(al6, bh6) | 0;
                        mid = mid + Math.imul(ah6, bl6) | 0;
                        hi = hi + Math.imul(ah6, bh6) | 0;
                        lo = lo + Math.imul(al5, bl7) | 0;
                        mid = mid + Math.imul(al5, bh7) | 0;
                        mid = mid + Math.imul(ah5, bl7) | 0;
                        hi = hi + Math.imul(ah5, bh7) | 0;
                        lo = lo + Math.imul(al4, bl8) | 0;
                        mid = mid + Math.imul(al4, bh8) | 0;
                        mid = mid + Math.imul(ah4, bl8) | 0;
                        hi = hi + Math.imul(ah4, bh8) | 0;
                        lo = lo + Math.imul(al3, bl9) | 0;
                        mid = mid + Math.imul(al3, bh9) | 0;
                        mid = mid + Math.imul(ah3, bl9) | 0;
                        hi = hi + Math.imul(ah3, bh9) | 0;
                        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
                        w12 &= 0x3ffffff;
                        /* k = 13 */ lo = Math.imul(al9, bl4);
                        mid = Math.imul(al9, bh4);
                        mid = mid + Math.imul(ah9, bl4) | 0;
                        hi = Math.imul(ah9, bh4);
                        lo = lo + Math.imul(al8, bl5) | 0;
                        mid = mid + Math.imul(al8, bh5) | 0;
                        mid = mid + Math.imul(ah8, bl5) | 0;
                        hi = hi + Math.imul(ah8, bh5) | 0;
                        lo = lo + Math.imul(al7, bl6) | 0;
                        mid = mid + Math.imul(al7, bh6) | 0;
                        mid = mid + Math.imul(ah7, bl6) | 0;
                        hi = hi + Math.imul(ah7, bh6) | 0;
                        lo = lo + Math.imul(al6, bl7) | 0;
                        mid = mid + Math.imul(al6, bh7) | 0;
                        mid = mid + Math.imul(ah6, bl7) | 0;
                        hi = hi + Math.imul(ah6, bh7) | 0;
                        lo = lo + Math.imul(al5, bl8) | 0;
                        mid = mid + Math.imul(al5, bh8) | 0;
                        mid = mid + Math.imul(ah5, bl8) | 0;
                        hi = hi + Math.imul(ah5, bh8) | 0;
                        lo = lo + Math.imul(al4, bl9) | 0;
                        mid = mid + Math.imul(al4, bh9) | 0;
                        mid = mid + Math.imul(ah4, bl9) | 0;
                        hi = hi + Math.imul(ah4, bh9) | 0;
                        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
                        w13 &= 0x3ffffff;
                        /* k = 14 */ lo = Math.imul(al9, bl5);
                        mid = Math.imul(al9, bh5);
                        mid = mid + Math.imul(ah9, bl5) | 0;
                        hi = Math.imul(ah9, bh5);
                        lo = lo + Math.imul(al8, bl6) | 0;
                        mid = mid + Math.imul(al8, bh6) | 0;
                        mid = mid + Math.imul(ah8, bl6) | 0;
                        hi = hi + Math.imul(ah8, bh6) | 0;
                        lo = lo + Math.imul(al7, bl7) | 0;
                        mid = mid + Math.imul(al7, bh7) | 0;
                        mid = mid + Math.imul(ah7, bl7) | 0;
                        hi = hi + Math.imul(ah7, bh7) | 0;
                        lo = lo + Math.imul(al6, bl8) | 0;
                        mid = mid + Math.imul(al6, bh8) | 0;
                        mid = mid + Math.imul(ah6, bl8) | 0;
                        hi = hi + Math.imul(ah6, bh8) | 0;
                        lo = lo + Math.imul(al5, bl9) | 0;
                        mid = mid + Math.imul(al5, bh9) | 0;
                        mid = mid + Math.imul(ah5, bl9) | 0;
                        hi = hi + Math.imul(ah5, bh9) | 0;
                        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
                        w14 &= 0x3ffffff;
                        /* k = 15 */ lo = Math.imul(al9, bl6);
                        mid = Math.imul(al9, bh6);
                        mid = mid + Math.imul(ah9, bl6) | 0;
                        hi = Math.imul(ah9, bh6);
                        lo = lo + Math.imul(al8, bl7) | 0;
                        mid = mid + Math.imul(al8, bh7) | 0;
                        mid = mid + Math.imul(ah8, bl7) | 0;
                        hi = hi + Math.imul(ah8, bh7) | 0;
                        lo = lo + Math.imul(al7, bl8) | 0;
                        mid = mid + Math.imul(al7, bh8) | 0;
                        mid = mid + Math.imul(ah7, bl8) | 0;
                        hi = hi + Math.imul(ah7, bh8) | 0;
                        lo = lo + Math.imul(al6, bl9) | 0;
                        mid = mid + Math.imul(al6, bh9) | 0;
                        mid = mid + Math.imul(ah6, bl9) | 0;
                        hi = hi + Math.imul(ah6, bh9) | 0;
                        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
                        w15 &= 0x3ffffff;
                        /* k = 16 */ lo = Math.imul(al9, bl7);
                        mid = Math.imul(al9, bh7);
                        mid = mid + Math.imul(ah9, bl7) | 0;
                        hi = Math.imul(ah9, bh7);
                        lo = lo + Math.imul(al8, bl8) | 0;
                        mid = mid + Math.imul(al8, bh8) | 0;
                        mid = mid + Math.imul(ah8, bl8) | 0;
                        hi = hi + Math.imul(ah8, bh8) | 0;
                        lo = lo + Math.imul(al7, bl9) | 0;
                        mid = mid + Math.imul(al7, bh9) | 0;
                        mid = mid + Math.imul(ah7, bl9) | 0;
                        hi = hi + Math.imul(ah7, bh9) | 0;
                        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
                        w16 &= 0x3ffffff;
                        /* k = 17 */ lo = Math.imul(al9, bl8);
                        mid = Math.imul(al9, bh8);
                        mid = mid + Math.imul(ah9, bl8) | 0;
                        hi = Math.imul(ah9, bh8);
                        lo = lo + Math.imul(al8, bl9) | 0;
                        mid = mid + Math.imul(al8, bh9) | 0;
                        mid = mid + Math.imul(ah8, bl9) | 0;
                        hi = hi + Math.imul(ah8, bh9) | 0;
                        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
                        w17 &= 0x3ffffff;
                        /* k = 18 */ lo = Math.imul(al9, bl9);
                        mid = Math.imul(al9, bh9);
                        mid = mid + Math.imul(ah9, bl9) | 0;
                        hi = Math.imul(ah9, bh9);
                        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
                        w18 &= 0x3ffffff;
                        o[0] = w0;
                        o[1] = w1;
                        o[2] = w2;
                        o[3] = w3;
                        o[4] = w4;
                        o[5] = w5;
                        o[6] = w6;
                        o[7] = w7;
                        o[8] = w8;
                        o[9] = w9;
                        o[10] = w10;
                        o[11] = w11;
                        o[12] = w12;
                        o[13] = w13;
                        o[14] = w14;
                        o[15] = w15;
                        o[16] = w16;
                        o[17] = w17;
                        o[18] = w18;
                        if (c !== 0) {
                            o[19] = c;
                            out.length++;
                        }
                        return out;
                    };
                    // Polyfill comb
                    if (!Math.imul) comb10MulTo = smallMulTo;
                    function bigMulTo(self1, num, out) {
                        out.negative = num.negative ^ self1.negative;
                        out.length = self1.length + num.length;
                        var carry = 0;
                        var hncarry = 0;
                        for(var k = 0; k < out.length - 1; k++){
                            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
                            // note that ncarry could be >= 0x3ffffff
                            var ncarry = hncarry;
                            hncarry = 0;
                            var rword = carry & 0x3ffffff;
                            var maxJ = Math.min(k, num.length - 1);
                            for(var j = Math.max(0, k - self1.length + 1); j <= maxJ; j++){
                                var i = k - j;
                                var a = self1.words[i] | 0;
                                var b = num.words[j] | 0;
                                var r = a * b;
                                var lo = r & 0x3ffffff;
                                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                                lo = lo + rword | 0;
                                rword = lo & 0x3ffffff;
                                ncarry = ncarry + (lo >>> 26) | 0;
                                hncarry += ncarry >>> 26;
                                ncarry &= 0x3ffffff;
                            }
                            out.words[k] = rword;
                            carry = ncarry;
                            ncarry = hncarry;
                        }
                        if (carry !== 0) out.words[k] = carry;
                        else out.length--;
                        return out.strip();
                    }
                    function jumboMulTo(self1, num, out) {
                        var fftm = new FFTM();
                        return fftm.mulp(self1, num, out);
                    }
                    BN.prototype.mulTo = function mulTo(num, out) {
                        var res;
                        var len = this.length + num.length;
                        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
                        else if (len < 63) res = smallMulTo(this, num, out);
                        else if (len < 1024) res = bigMulTo(this, num, out);
                        else res = jumboMulTo(this, num, out);
                        return res;
                    };
                    // Cooley-Tukey algorithm for FFT
                    // slightly revisited to rely on looping instead of recursion
                    function FFTM(x, y) {
                        this.x = x;
                        this.y = y;
                    }
                    FFTM.prototype.makeRBT = function makeRBT(N) {
                        var t = new Array(N);
                        var l = BN.prototype._countBits(N) - 1;
                        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
                        return t;
                    };
                    // Returns binary-reversed representation of `x`
                    FFTM.prototype.revBin = function revBin(x, l, N) {
                        if (x === 0 || x === N - 1) return x;
                        var rb = 0;
                        for(var i = 0; i < l; i++){
                            rb |= (x & 1) << l - i - 1;
                            x >>= 1;
                        }
                        return rb;
                    };
                    // Performs "tweedling" phase, therefore 'emulating'
                    // behaviour of the recursive algorithm
                    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
                        for(var i = 0; i < N; i++){
                            rtws[i] = rws[rbt[i]];
                            itws[i] = iws[rbt[i]];
                        }
                    };
                    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
                        this.permute(rbt, rws, iws, rtws, itws, N);
                        for(var s = 1; s < N; s <<= 1){
                            var l = s << 1;
                            var rtwdf = Math.cos(2 * Math.PI / l);
                            var itwdf = Math.sin(2 * Math.PI / l);
                            for(var p = 0; p < N; p += l){
                                var rtwdf_ = rtwdf;
                                var itwdf_ = itwdf;
                                for(var j = 0; j < s; j++){
                                    var re = rtws[p + j];
                                    var ie = itws[p + j];
                                    var ro = rtws[p + j + s];
                                    var io = itws[p + j + s];
                                    var rx = rtwdf_ * ro - itwdf_ * io;
                                    io = rtwdf_ * io + itwdf_ * ro;
                                    ro = rx;
                                    rtws[p + j] = re + ro;
                                    itws[p + j] = ie + io;
                                    rtws[p + j + s] = re - ro;
                                    itws[p + j + s] = ie - io;
                                    /* jshint maxdepth : false */ if (j !== l) {
                                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                                        rtwdf_ = rx;
                                    }
                                }
                            }
                        }
                    };
                    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
                        var N = Math.max(m, n) | 1;
                        var odd = N & 1;
                        var i = 0;
                        for(N = N / 2 | 0; N; N = N >>> 1)i++;
                        return 1 << i + 1 + odd;
                    };
                    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
                        if (N <= 1) return;
                        for(var i = 0; i < N / 2; i++){
                            var t = rws[i];
                            rws[i] = rws[N - i - 1];
                            rws[N - i - 1] = t;
                            t = iws[i];
                            iws[i] = -iws[N - i - 1];
                            iws[N - i - 1] = -t;
                        }
                    };
                    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
                        var carry = 0;
                        for(var i = 0; i < N / 2; i++){
                            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
                            ws[i] = w & 0x3ffffff;
                            if (w < 0x4000000) carry = 0;
                            else carry = w / 0x4000000 | 0;
                        }
                        return ws;
                    };
                    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
                        var carry = 0;
                        for(var i = 0; i < len; i++){
                            carry = carry + (ws[i] | 0);
                            rws[2 * i] = carry & 0x1fff;
                            carry = carry >>> 13;
                            rws[2 * i + 1] = carry & 0x1fff;
                            carry = carry >>> 13;
                        }
                        // Pad with zeroes
                        for(i = 2 * len; i < N; ++i)rws[i] = 0;
                        assert(carry === 0);
                        assert((carry & -8192) === 0);
                    };
                    FFTM.prototype.stub = function stub(N) {
                        var ph = new Array(N);
                        for(var i = 0; i < N; i++)ph[i] = 0;
                        return ph;
                    };
                    FFTM.prototype.mulp = function mulp(x, y, out) {
                        var N = 2 * this.guessLen13b(x.length, y.length);
                        var rbt = this.makeRBT(N);
                        var _ = this.stub(N);
                        var rws = new Array(N);
                        var rwst = new Array(N);
                        var iwst = new Array(N);
                        var nrws = new Array(N);
                        var nrwst = new Array(N);
                        var niwst = new Array(N);
                        var rmws = out.words;
                        rmws.length = N;
                        this.convert13b(x.words, x.length, rws, N);
                        this.convert13b(y.words, y.length, nrws, N);
                        this.transform(rws, _, rwst, iwst, N, rbt);
                        this.transform(nrws, _, nrwst, niwst, N, rbt);
                        for(var i = 0; i < N; i++){
                            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
                            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
                            rwst[i] = rx;
                        }
                        this.conjugate(rwst, iwst, N);
                        this.transform(rwst, iwst, rmws, _, N, rbt);
                        this.conjugate(rmws, _, N);
                        this.normalize13b(rmws, N);
                        out.negative = x.negative ^ y.negative;
                        out.length = x.length + y.length;
                        return out.strip();
                    };
                    // Multiply `this` by `num`
                    BN.prototype.mul = function mul(num) {
                        var out = new BN(null);
                        out.words = new Array(this.length + num.length);
                        return this.mulTo(num, out);
                    };
                    // Multiply employing FFT
                    BN.prototype.mulf = function mulf(num) {
                        var out = new BN(null);
                        out.words = new Array(this.length + num.length);
                        return jumboMulTo(this, num, out);
                    };
                    // In-place Multiplication
                    BN.prototype.imul = function imul(num) {
                        return this.clone().mulTo(num, this);
                    };
                    BN.prototype.imuln = function imuln(num) {
                        assert(typeof num === "number");
                        assert(num < 0x4000000);
                        // Carry
                        var carry = 0;
                        for(var i = 0; i < this.length; i++){
                            var w = (this.words[i] | 0) * num;
                            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
                            carry >>= 26;
                            carry += w / 0x4000000 | 0;
                            // NOTE: lo is 27bit maximum
                            carry += lo >>> 26;
                            this.words[i] = lo & 0x3ffffff;
                        }
                        if (carry !== 0) {
                            this.words[i] = carry;
                            this.length++;
                        }
                        return this;
                    };
                    BN.prototype.muln = function muln(num) {
                        return this.clone().imuln(num);
                    };
                    // `this` * `this`
                    BN.prototype.sqr = function sqr() {
                        return this.mul(this);
                    };
                    // `this` * `this` in-place
                    BN.prototype.isqr = function isqr() {
                        return this.imul(this.clone());
                    };
                    // Math.pow(`this`, `num`)
                    BN.prototype.pow = function pow(num) {
                        var w = toBitArray(num);
                        if (w.length === 0) return new BN(1);
                        // Skip leading zeroes
                        var res = this;
                        for(var i = 0; i < w.length; i++, res = res.sqr()){
                            if (w[i] !== 0) break;
                        }
                        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
                            if (w[i] === 0) continue;
                            res = res.mul(q);
                        }
                        return res;
                    };
                    // Shift-left in-place
                    BN.prototype.iushln = function iushln(bits) {
                        assert(typeof bits === "number" && bits >= 0);
                        var r = bits % 26;
                        var s = (bits - r) / 26;
                        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
                        var i;
                        if (r !== 0) {
                            var carry = 0;
                            for(i = 0; i < this.length; i++){
                                var newCarry = this.words[i] & carryMask;
                                var c = (this.words[i] | 0) - newCarry << r;
                                this.words[i] = c | carry;
                                carry = newCarry >>> 26 - r;
                            }
                            if (carry) {
                                this.words[i] = carry;
                                this.length++;
                            }
                        }
                        if (s !== 0) {
                            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
                            for(i = 0; i < s; i++)this.words[i] = 0;
                            this.length += s;
                        }
                        return this.strip();
                    };
                    BN.prototype.ishln = function ishln(bits) {
                        // TODO(indutny): implement me
                        assert(this.negative === 0);
                        return this.iushln(bits);
                    };
                    // Shift-right in-place
                    // NOTE: `hint` is a lowest bit before trailing zeroes
                    // NOTE: if `extended` is present - it will be filled with destroyed bits
                    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
                        assert(typeof bits === "number" && bits >= 0);
                        var h;
                        if (hint) h = (hint - hint % 26) / 26;
                        else h = 0;
                        var r = bits % 26;
                        var s = Math.min((bits - r) / 26, this.length);
                        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
                        var maskedWords = extended;
                        h -= s;
                        h = Math.max(0, h);
                        // Extended mode, copy masked part
                        if (maskedWords) {
                            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
                            maskedWords.length = s;
                        }
                        if (s === 0) ;
                        else if (this.length > s) {
                            this.length -= s;
                            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
                        } else {
                            this.words[0] = 0;
                            this.length = 1;
                        }
                        var carry = 0;
                        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
                            var word = this.words[i] | 0;
                            this.words[i] = carry << 26 - r | word >>> r;
                            carry = word & mask;
                        }
                        // Push carried bits as a mask
                        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
                        if (this.length === 0) {
                            this.words[0] = 0;
                            this.length = 1;
                        }
                        return this.strip();
                    };
                    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
                        // TODO(indutny): implement me
                        assert(this.negative === 0);
                        return this.iushrn(bits, hint, extended);
                    };
                    // Shift-left
                    BN.prototype.shln = function shln(bits) {
                        return this.clone().ishln(bits);
                    };
                    BN.prototype.ushln = function ushln(bits) {
                        return this.clone().iushln(bits);
                    };
                    // Shift-right
                    BN.prototype.shrn = function shrn(bits) {
                        return this.clone().ishrn(bits);
                    };
                    BN.prototype.ushrn = function ushrn(bits) {
                        return this.clone().iushrn(bits);
                    };
                    // Test if n bit is set
                    BN.prototype.testn = function testn(bit) {
                        assert(typeof bit === "number" && bit >= 0);
                        var r = bit % 26;
                        var s = (bit - r) / 26;
                        var q = 1 << r;
                        // Fast case: bit is much higher than all existing words
                        if (this.length <= s) return false;
                        // Check bit and return
                        var w = this.words[s];
                        return !!(w & q);
                    };
                    // Return only lowers bits of number (in-place)
                    BN.prototype.imaskn = function imaskn(bits) {
                        assert(typeof bits === "number" && bits >= 0);
                        var r = bits % 26;
                        var s = (bits - r) / 26;
                        assert(this.negative === 0, "imaskn works only with positive numbers");
                        if (this.length <= s) return this;
                        if (r !== 0) s++;
                        this.length = Math.min(s, this.length);
                        if (r !== 0) {
                            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
                            this.words[this.length - 1] &= mask;
                        }
                        return this.strip();
                    };
                    // Return only lowers bits of number
                    BN.prototype.maskn = function maskn(bits) {
                        return this.clone().imaskn(bits);
                    };
                    // Add plain number `num` to `this`
                    BN.prototype.iaddn = function iaddn(num) {
                        assert(typeof num === "number");
                        assert(num < 0x4000000);
                        if (num < 0) return this.isubn(-num);
                        // Possible sign change
                        if (this.negative !== 0) {
                            if (this.length === 1 && (this.words[0] | 0) < num) {
                                this.words[0] = num - (this.words[0] | 0);
                                this.negative = 0;
                                return this;
                            }
                            this.negative = 0;
                            this.isubn(num);
                            this.negative = 1;
                            return this;
                        }
                        // Add without checks
                        return this._iaddn(num);
                    };
                    BN.prototype._iaddn = function _iaddn(num) {
                        this.words[0] += num;
                        // Carry
                        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
                            this.words[i] -= 0x4000000;
                            if (i === this.length - 1) this.words[i + 1] = 1;
                            else this.words[i + 1]++;
                        }
                        this.length = Math.max(this.length, i + 1);
                        return this;
                    };
                    // Subtract plain number `num` from `this`
                    BN.prototype.isubn = function isubn(num) {
                        assert(typeof num === "number");
                        assert(num < 0x4000000);
                        if (num < 0) return this.iaddn(-num);
                        if (this.negative !== 0) {
                            this.negative = 0;
                            this.iaddn(num);
                            this.negative = 1;
                            return this;
                        }
                        this.words[0] -= num;
                        if (this.length === 1 && this.words[0] < 0) {
                            this.words[0] = -this.words[0];
                            this.negative = 1;
                        } else // Carry
                        for(var i = 0; i < this.length && this.words[i] < 0; i++){
                            this.words[i] += 0x4000000;
                            this.words[i + 1] -= 1;
                        }
                        return this.strip();
                    };
                    BN.prototype.addn = function addn(num) {
                        return this.clone().iaddn(num);
                    };
                    BN.prototype.subn = function subn(num) {
                        return this.clone().isubn(num);
                    };
                    BN.prototype.iabs = function iabs() {
                        this.negative = 0;
                        return this;
                    };
                    BN.prototype.abs = function abs() {
                        return this.clone().iabs();
                    };
                    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
                        var len = num.length + shift;
                        var i;
                        this._expand(len);
                        var w;
                        var carry = 0;
                        for(i = 0; i < num.length; i++){
                            w = (this.words[i + shift] | 0) + carry;
                            var right = (num.words[i] | 0) * mul;
                            w -= right & 0x3ffffff;
                            carry = (w >> 26) - (right / 0x4000000 | 0);
                            this.words[i + shift] = w & 0x3ffffff;
                        }
                        for(; i < this.length - shift; i++){
                            w = (this.words[i + shift] | 0) + carry;
                            carry = w >> 26;
                            this.words[i + shift] = w & 0x3ffffff;
                        }
                        if (carry === 0) return this.strip();
                        // Subtraction overflow
                        assert(carry === -1);
                        carry = 0;
                        for(i = 0; i < this.length; i++){
                            w = -(this.words[i] | 0) + carry;
                            carry = w >> 26;
                            this.words[i] = w & 0x3ffffff;
                        }
                        this.negative = 1;
                        return this.strip();
                    };
                    BN.prototype._wordDiv = function _wordDiv(num, mode) {
                        var shift = this.length - num.length;
                        var a = this.clone();
                        var b = num;
                        // Normalize
                        var bhi = b.words[b.length - 1] | 0;
                        var bhiBits = this._countBits(bhi);
                        shift = 26 - bhiBits;
                        if (shift !== 0) {
                            b = b.ushln(shift);
                            a.iushln(shift);
                            bhi = b.words[b.length - 1] | 0;
                        }
                        // Initialize quotient
                        var m = a.length - b.length;
                        var q;
                        if (mode !== "mod") {
                            q = new BN(null);
                            q.length = m + 1;
                            q.words = new Array(q.length);
                            for(var i = 0; i < q.length; i++)q.words[i] = 0;
                        }
                        var diff = a.clone()._ishlnsubmul(b, 1, m);
                        if (diff.negative === 0) {
                            a = diff;
                            if (q) q.words[m] = 1;
                        }
                        for(var j = m - 1; j >= 0; j--){
                            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
                            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
                            // (0x7ffffff)
                            qj = Math.min(qj / bhi | 0, 0x3ffffff);
                            a._ishlnsubmul(b, qj, j);
                            while(a.negative !== 0){
                                qj--;
                                a.negative = 0;
                                a._ishlnsubmul(b, 1, j);
                                if (!a.isZero()) a.negative ^= 1;
                            }
                            if (q) q.words[j] = qj;
                        }
                        if (q) q.strip();
                        a.strip();
                        // Denormalize
                        if (mode !== "div" && shift !== 0) a.iushrn(shift);
                        return {
                            div: q || null,
                            mod: a
                        };
                    };
                    // NOTE: 1) `mode` can be set to `mod` to request mod only,
                    //       to `div` to request div only, or be absent to
                    //       request both div & mod
                    //       2) `positive` is true if unsigned mod is requested
                    BN.prototype.divmod = function divmod(num, mode, positive) {
                        assert(!num.isZero());
                        if (this.isZero()) return {
                            div: new BN(0),
                            mod: new BN(0)
                        };
                        var div, mod, res;
                        if (this.negative !== 0 && num.negative === 0) {
                            res = this.neg().divmod(num, mode);
                            if (mode !== "mod") div = res.div.neg();
                            if (mode !== "div") {
                                mod = res.mod.neg();
                                if (positive && mod.negative !== 0) mod.iadd(num);
                            }
                            return {
                                div: div,
                                mod: mod
                            };
                        }
                        if (this.negative === 0 && num.negative !== 0) {
                            res = this.divmod(num.neg(), mode);
                            if (mode !== "mod") div = res.div.neg();
                            return {
                                div: div,
                                mod: res.mod
                            };
                        }
                        if ((this.negative & num.negative) !== 0) {
                            res = this.neg().divmod(num.neg(), mode);
                            if (mode !== "div") {
                                mod = res.mod.neg();
                                if (positive && mod.negative !== 0) mod.isub(num);
                            }
                            return {
                                div: res.div,
                                mod: mod
                            };
                        }
                        // Both numbers are positive at this point
                        // Strip both numbers to approximate shift value
                        if (num.length > this.length || this.cmp(num) < 0) return {
                            div: new BN(0),
                            mod: this
                        };
                        // Very short reduction
                        if (num.length === 1) {
                            if (mode === "div") return {
                                div: this.divn(num.words[0]),
                                mod: null
                            };
                            if (mode === "mod") return {
                                div: null,
                                mod: new BN(this.modn(num.words[0]))
                            };
                            return {
                                div: this.divn(num.words[0]),
                                mod: new BN(this.modn(num.words[0]))
                            };
                        }
                        return this._wordDiv(num, mode);
                    };
                    // Find `this` / `num`
                    BN.prototype.div = function div(num) {
                        return this.divmod(num, "div", false).div;
                    };
                    // Find `this` % `num`
                    BN.prototype.mod = function mod(num) {
                        return this.divmod(num, "mod", false).mod;
                    };
                    BN.prototype.umod = function umod(num) {
                        return this.divmod(num, "mod", true).mod;
                    };
                    // Find Round(`this` / `num`)
                    BN.prototype.divRound = function divRound(num) {
                        var dm = this.divmod(num);
                        // Fast case - exact division
                        if (dm.mod.isZero()) return dm.div;
                        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
                        var half = num.ushrn(1);
                        var r2 = num.andln(1);
                        var cmp = mod.cmp(half);
                        // Round down
                        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
                        // Round up
                        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
                    };
                    BN.prototype.modn = function modn(num) {
                        assert(num <= 0x3ffffff);
                        var p = 67108864 % num;
                        var acc = 0;
                        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
                        return acc;
                    };
                    // In-place division by number
                    BN.prototype.idivn = function idivn(num) {
                        assert(num <= 0x3ffffff);
                        var carry = 0;
                        for(var i = this.length - 1; i >= 0; i--){
                            var w = (this.words[i] | 0) + carry * 0x4000000;
                            this.words[i] = w / num | 0;
                            carry = w % num;
                        }
                        return this.strip();
                    };
                    BN.prototype.divn = function divn(num) {
                        return this.clone().idivn(num);
                    };
                    BN.prototype.egcd = function egcd(p) {
                        assert(p.negative === 0);
                        assert(!p.isZero());
                        var x = this;
                        var y = p.clone();
                        if (x.negative !== 0) x = x.umod(p);
                        else x = x.clone();
                        // A * x + B * y = x
                        var A = new BN(1);
                        var B = new BN(0);
                        // C * x + D * y = y
                        var C = new BN(0);
                        var D = new BN(1);
                        var g = 0;
                        while(x.isEven() && y.isEven()){
                            x.iushrn(1);
                            y.iushrn(1);
                            ++g;
                        }
                        var yp = y.clone();
                        var xp = x.clone();
                        while(!x.isZero()){
                            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                            if (i > 0) {
                                x.iushrn(i);
                                while(i-- > 0){
                                    if (A.isOdd() || B.isOdd()) {
                                        A.iadd(yp);
                                        B.isub(xp);
                                    }
                                    A.iushrn(1);
                                    B.iushrn(1);
                                }
                            }
                            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                            if (j > 0) {
                                y.iushrn(j);
                                while(j-- > 0){
                                    if (C.isOdd() || D.isOdd()) {
                                        C.iadd(yp);
                                        D.isub(xp);
                                    }
                                    C.iushrn(1);
                                    D.iushrn(1);
                                }
                            }
                            if (x.cmp(y) >= 0) {
                                x.isub(y);
                                A.isub(C);
                                B.isub(D);
                            } else {
                                y.isub(x);
                                C.isub(A);
                                D.isub(B);
                            }
                        }
                        return {
                            a: C,
                            b: D,
                            gcd: y.iushln(g)
                        };
                    };
                    // This is reduced incarnation of the binary EEA
                    // above, designated to invert members of the
                    // _prime_ fields F(p) at a maximal speed
                    BN.prototype._invmp = function _invmp(p) {
                        assert(p.negative === 0);
                        assert(!p.isZero());
                        var a = this;
                        var b = p.clone();
                        if (a.negative !== 0) a = a.umod(p);
                        else a = a.clone();
                        var x1 = new BN(1);
                        var x2 = new BN(0);
                        var delta = b.clone();
                        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
                            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                            if (i > 0) {
                                a.iushrn(i);
                                while(i-- > 0){
                                    if (x1.isOdd()) x1.iadd(delta);
                                    x1.iushrn(1);
                                }
                            }
                            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                            if (j > 0) {
                                b.iushrn(j);
                                while(j-- > 0){
                                    if (x2.isOdd()) x2.iadd(delta);
                                    x2.iushrn(1);
                                }
                            }
                            if (a.cmp(b) >= 0) {
                                a.isub(b);
                                x1.isub(x2);
                            } else {
                                b.isub(a);
                                x2.isub(x1);
                            }
                        }
                        var res;
                        if (a.cmpn(1) === 0) res = x1;
                        else res = x2;
                        if (res.cmpn(0) < 0) res.iadd(p);
                        return res;
                    };
                    BN.prototype.gcd = function gcd(num) {
                        if (this.isZero()) return num.abs();
                        if (num.isZero()) return this.abs();
                        var a = this.clone();
                        var b = num.clone();
                        a.negative = 0;
                        b.negative = 0;
                        // Remove common factor of two
                        for(var shift = 0; a.isEven() && b.isEven(); shift++){
                            a.iushrn(1);
                            b.iushrn(1);
                        }
                        do {
                            while(a.isEven())a.iushrn(1);
                            while(b.isEven())b.iushrn(1);
                            var r = a.cmp(b);
                            if (r < 0) {
                                // Swap `a` and `b` to make `a` always bigger than `b`
                                var t = a;
                                a = b;
                                b = t;
                            } else if (r === 0 || b.cmpn(1) === 0) break;
                            a.isub(b);
                        }while (true);
                        return b.iushln(shift);
                    };
                    // Invert number in the field F(num)
                    BN.prototype.invm = function invm(num) {
                        return this.egcd(num).a.umod(num);
                    };
                    BN.prototype.isEven = function isEven() {
                        return (this.words[0] & 1) === 0;
                    };
                    BN.prototype.isOdd = function isOdd() {
                        return (this.words[0] & 1) === 1;
                    };
                    // And first word and num
                    BN.prototype.andln = function andln(num) {
                        return this.words[0] & num;
                    };
                    // Increment at the bit position in-line
                    BN.prototype.bincn = function bincn(bit) {
                        assert(typeof bit === "number");
                        var r = bit % 26;
                        var s = (bit - r) / 26;
                        var q = 1 << r;
                        // Fast case: bit is much higher than all existing words
                        if (this.length <= s) {
                            this._expand(s + 1);
                            this.words[s] |= q;
                            return this;
                        }
                        // Add bit and propagate, if needed
                        var carry = q;
                        for(var i = s; carry !== 0 && i < this.length; i++){
                            var w = this.words[i] | 0;
                            w += carry;
                            carry = w >>> 26;
                            w &= 0x3ffffff;
                            this.words[i] = w;
                        }
                        if (carry !== 0) {
                            this.words[i] = carry;
                            this.length++;
                        }
                        return this;
                    };
                    BN.prototype.isZero = function isZero() {
                        return this.length === 1 && this.words[0] === 0;
                    };
                    BN.prototype.cmpn = function cmpn(num) {
                        var negative = num < 0;
                        if (this.negative !== 0 && !negative) return -1;
                        if (this.negative === 0 && negative) return 1;
                        this.strip();
                        var res;
                        if (this.length > 1) res = 1;
                        else {
                            if (negative) num = -num;
                            assert(num <= 0x3ffffff, "Number is too big");
                            var w = this.words[0] | 0;
                            res = w === num ? 0 : w < num ? -1 : 1;
                        }
                        if (this.negative !== 0) return -res | 0;
                        return res;
                    };
                    // Compare two numbers and return:
                    // 1 - if `this` > `num`
                    // 0 - if `this` == `num`
                    // -1 - if `this` < `num`
                    BN.prototype.cmp = function cmp(num) {
                        if (this.negative !== 0 && num.negative === 0) return -1;
                        if (this.negative === 0 && num.negative !== 0) return 1;
                        var res = this.ucmp(num);
                        if (this.negative !== 0) return -res | 0;
                        return res;
                    };
                    // Unsigned comparison
                    BN.prototype.ucmp = function ucmp(num) {
                        // At this point both numbers have the same sign
                        if (this.length > num.length) return 1;
                        if (this.length < num.length) return -1;
                        var res = 0;
                        for(var i = this.length - 1; i >= 0; i--){
                            var a = this.words[i] | 0;
                            var b = num.words[i] | 0;
                            if (a === b) continue;
                            if (a < b) res = -1;
                            else if (a > b) res = 1;
                            break;
                        }
                        return res;
                    };
                    BN.prototype.gtn = function gtn(num) {
                        return this.cmpn(num) === 1;
                    };
                    BN.prototype.gt = function gt(num) {
                        return this.cmp(num) === 1;
                    };
                    BN.prototype.gten = function gten(num) {
                        return this.cmpn(num) >= 0;
                    };
                    BN.prototype.gte = function gte(num) {
                        return this.cmp(num) >= 0;
                    };
                    BN.prototype.ltn = function ltn(num) {
                        return this.cmpn(num) === -1;
                    };
                    BN.prototype.lt = function lt(num) {
                        return this.cmp(num) === -1;
                    };
                    BN.prototype.lten = function lten(num) {
                        return this.cmpn(num) <= 0;
                    };
                    BN.prototype.lte = function lte(num) {
                        return this.cmp(num) <= 0;
                    };
                    BN.prototype.eqn = function eqn(num) {
                        return this.cmpn(num) === 0;
                    };
                    BN.prototype.eq = function eq(num) {
                        return this.cmp(num) === 0;
                    };
                    //
                    // A reduce context, could be using montgomery or something better, depending
                    // on the `m` itself.
                    //
                    BN.red = function red(num) {
                        return new Red(num);
                    };
                    BN.prototype.toRed = function toRed(ctx) {
                        assert(!this.red, "Already a number in reduction context");
                        assert(this.negative === 0, "red works only with positives");
                        return ctx.convertTo(this)._forceRed(ctx);
                    };
                    BN.prototype.fromRed = function fromRed() {
                        assert(this.red, "fromRed works only with numbers in reduction context");
                        return this.red.convertFrom(this);
                    };
                    BN.prototype._forceRed = function _forceRed(ctx) {
                        this.red = ctx;
                        return this;
                    };
                    BN.prototype.forceRed = function forceRed(ctx) {
                        assert(!this.red, "Already a number in reduction context");
                        return this._forceRed(ctx);
                    };
                    BN.prototype.redAdd = function redAdd(num) {
                        assert(this.red, "redAdd works only with red numbers");
                        return this.red.add(this, num);
                    };
                    BN.prototype.redIAdd = function redIAdd(num) {
                        assert(this.red, "redIAdd works only with red numbers");
                        return this.red.iadd(this, num);
                    };
                    BN.prototype.redSub = function redSub(num) {
                        assert(this.red, "redSub works only with red numbers");
                        return this.red.sub(this, num);
                    };
                    BN.prototype.redISub = function redISub(num) {
                        assert(this.red, "redISub works only with red numbers");
                        return this.red.isub(this, num);
                    };
                    BN.prototype.redShl = function redShl(num) {
                        assert(this.red, "redShl works only with red numbers");
                        return this.red.shl(this, num);
                    };
                    BN.prototype.redMul = function redMul(num) {
                        assert(this.red, "redMul works only with red numbers");
                        this.red._verify2(this, num);
                        return this.red.mul(this, num);
                    };
                    BN.prototype.redIMul = function redIMul(num) {
                        assert(this.red, "redMul works only with red numbers");
                        this.red._verify2(this, num);
                        return this.red.imul(this, num);
                    };
                    BN.prototype.redSqr = function redSqr() {
                        assert(this.red, "redSqr works only with red numbers");
                        this.red._verify1(this);
                        return this.red.sqr(this);
                    };
                    BN.prototype.redISqr = function redISqr() {
                        assert(this.red, "redISqr works only with red numbers");
                        this.red._verify1(this);
                        return this.red.isqr(this);
                    };
                    // Square root over p
                    BN.prototype.redSqrt = function redSqrt() {
                        assert(this.red, "redSqrt works only with red numbers");
                        this.red._verify1(this);
                        return this.red.sqrt(this);
                    };
                    BN.prototype.redInvm = function redInvm() {
                        assert(this.red, "redInvm works only with red numbers");
                        this.red._verify1(this);
                        return this.red.invm(this);
                    };
                    // Return negative clone of `this` % `red modulo`
                    BN.prototype.redNeg = function redNeg() {
                        assert(this.red, "redNeg works only with red numbers");
                        this.red._verify1(this);
                        return this.red.neg(this);
                    };
                    BN.prototype.redPow = function redPow(num) {
                        assert(this.red && !num.red, "redPow(normalNum)");
                        this.red._verify1(this);
                        return this.red.pow(this, num);
                    };
                    // Prime numbers with efficient reduction
                    var primes = {
                        k256: null,
                        p224: null,
                        p192: null,
                        p25519: null
                    };
                    // Pseudo-Mersenne prime
                    function MPrime(name1, p) {
                        // P = 2 ^ N - K
                        this.name = name1;
                        this.p = new BN(p, 16);
                        this.n = this.p.bitLength();
                        this.k = new BN(1).iushln(this.n).isub(this.p);
                        this.tmp = this._tmp();
                    }
                    MPrime.prototype._tmp = function _tmp() {
                        var tmp = new BN(null);
                        tmp.words = new Array(Math.ceil(this.n / 13));
                        return tmp;
                    };
                    MPrime.prototype.ireduce = function ireduce(num) {
                        // Assumes that `num` is less than `P^2`
                        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
                        var r = num;
                        var rlen;
                        do {
                            this.split(r, this.tmp);
                            r = this.imulK(r);
                            r = r.iadd(this.tmp);
                            rlen = r.bitLength();
                        }while (rlen > this.n);
                        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
                        if (cmp === 0) {
                            r.words[0] = 0;
                            r.length = 1;
                        } else if (cmp > 0) r.isub(this.p);
                        else if (r.strip !== undefined) // r is BN v4 instance
                        r.strip();
                        else // r is BN v5 instance
                        r._strip();
                        return r;
                    };
                    MPrime.prototype.split = function split(input, out) {
                        input.iushrn(this.n, 0, out);
                    };
                    MPrime.prototype.imulK = function imulK(num) {
                        return num.imul(this.k);
                    };
                    function K256() {
                        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                    }
                    inherits(K256, MPrime);
                    K256.prototype.split = function split(input, output) {
                        // 256 = 9 * 26 + 22
                        var mask = 0x3fffff;
                        var outLen = Math.min(input.length, 9);
                        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
                        output.length = outLen;
                        if (input.length <= 9) {
                            input.words[0] = 0;
                            input.length = 1;
                            return;
                        }
                        // Shift by 9 limbs
                        var prev = input.words[9];
                        output.words[output.length++] = prev & mask;
                        for(i = 10; i < input.length; i++){
                            var next = input.words[i] | 0;
                            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
                            prev = next;
                        }
                        prev >>>= 22;
                        input.words[i - 10] = prev;
                        if (prev === 0 && input.length > 10) input.length -= 10;
                        else input.length -= 9;
                    };
                    K256.prototype.imulK = function imulK(num) {
                        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
                        num.words[num.length] = 0;
                        num.words[num.length + 1] = 0;
                        num.length += 2;
                        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
                        var lo = 0;
                        for(var i = 0; i < num.length; i++){
                            var w = num.words[i] | 0;
                            lo += w * 0x3d1;
                            num.words[i] = lo & 0x3ffffff;
                            lo = w * 0x40 + (lo / 0x4000000 | 0);
                        }
                        // Fast length reduction
                        if (num.words[num.length - 1] === 0) {
                            num.length--;
                            if (num.words[num.length - 1] === 0) num.length--;
                        }
                        return num;
                    };
                    function P224() {
                        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                    }
                    inherits(P224, MPrime);
                    function P192() {
                        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                    }
                    inherits(P192, MPrime);
                    function P25519() {
                        // 2 ^ 255 - 19
                        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                    }
                    inherits(P25519, MPrime);
                    P25519.prototype.imulK = function imulK(num) {
                        // K = 0x13
                        var carry = 0;
                        for(var i = 0; i < num.length; i++){
                            var hi = (num.words[i] | 0) * 0x13 + carry;
                            var lo = hi & 0x3ffffff;
                            hi >>>= 26;
                            num.words[i] = lo;
                            carry = hi;
                        }
                        if (carry !== 0) num.words[num.length++] = carry;
                        return num;
                    };
                    // Exported mostly for testing purposes, use plain name instead
                    BN._prime = function prime(name1) {
                        // Cached version of prime
                        if (primes[name1]) return primes[name1];
                        var prime;
                        if (name1 === "k256") prime = new K256();
                        else if (name1 === "p224") prime = new P224();
                        else if (name1 === "p192") prime = new P192();
                        else if (name1 === "p25519") prime = new P25519();
                        else throw new Error("Unknown prime " + name1);
                        primes[name1] = prime;
                        return prime;
                    };
                    //
                    // Base reduction engine
                    //
                    function Red(m) {
                        if (typeof m === "string") {
                            var prime = BN._prime(m);
                            this.m = prime.p;
                            this.prime = prime;
                        } else {
                            assert(m.gtn(1), "modulus must be greater than 1");
                            this.m = m;
                            this.prime = null;
                        }
                    }
                    Red.prototype._verify1 = function _verify1(a) {
                        assert(a.negative === 0, "red works only with positives");
                        assert(a.red, "red works only with red numbers");
                    };
                    Red.prototype._verify2 = function _verify2(a, b) {
                        assert((a.negative | b.negative) === 0, "red works only with positives");
                        assert(a.red && a.red === b.red, "red works only with red numbers");
                    };
                    Red.prototype.imod = function imod(a) {
                        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
                        return a.umod(this.m)._forceRed(this);
                    };
                    Red.prototype.neg = function neg(a) {
                        if (a.isZero()) return a.clone();
                        return this.m.sub(a)._forceRed(this);
                    };
                    Red.prototype.add = function add(a, b) {
                        this._verify2(a, b);
                        var res = a.add(b);
                        if (res.cmp(this.m) >= 0) res.isub(this.m);
                        return res._forceRed(this);
                    };
                    Red.prototype.iadd = function iadd(a, b) {
                        this._verify2(a, b);
                        var res = a.iadd(b);
                        if (res.cmp(this.m) >= 0) res.isub(this.m);
                        return res;
                    };
                    Red.prototype.sub = function sub(a, b) {
                        this._verify2(a, b);
                        var res = a.sub(b);
                        if (res.cmpn(0) < 0) res.iadd(this.m);
                        return res._forceRed(this);
                    };
                    Red.prototype.isub = function isub(a, b) {
                        this._verify2(a, b);
                        var res = a.isub(b);
                        if (res.cmpn(0) < 0) res.iadd(this.m);
                        return res;
                    };
                    Red.prototype.shl = function shl(a, num) {
                        this._verify1(a);
                        return this.imod(a.ushln(num));
                    };
                    Red.prototype.imul = function imul(a, b) {
                        this._verify2(a, b);
                        return this.imod(a.imul(b));
                    };
                    Red.prototype.mul = function mul(a, b) {
                        this._verify2(a, b);
                        return this.imod(a.mul(b));
                    };
                    Red.prototype.isqr = function isqr(a) {
                        return this.imul(a, a.clone());
                    };
                    Red.prototype.sqr = function sqr(a) {
                        return this.mul(a, a);
                    };
                    Red.prototype.sqrt = function sqrt(a) {
                        if (a.isZero()) return a.clone();
                        var mod3 = this.m.andln(3);
                        assert(mod3 % 2 === 1);
                        // Fast case
                        if (mod3 === 3) {
                            var pow = this.m.add(new BN(1)).iushrn(2);
                            return this.pow(a, pow);
                        }
                        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
                        //
                        // Find Q and S, that Q * 2 ^ S = (P - 1)
                        var q = this.m.subn(1);
                        var s = 0;
                        while(!q.isZero() && q.andln(1) === 0){
                            s++;
                            q.iushrn(1);
                        }
                        assert(!q.isZero());
                        var one = new BN(1).toRed(this);
                        var nOne = one.redNeg();
                        // Find quadratic non-residue
                        // NOTE: Max is such because of generalized Riemann hypothesis.
                        var lpow = this.m.subn(1).iushrn(1);
                        var z = this.m.bitLength();
                        z = new BN(2 * z * z).toRed(this);
                        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
                        var c = this.pow(z, q);
                        var r = this.pow(a, q.addn(1).iushrn(1));
                        var t = this.pow(a, q);
                        var m = s;
                        while(t.cmp(one) !== 0){
                            var tmp = t;
                            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
                            assert(i < m);
                            var b = this.pow(c, new BN(1).iushln(m - i - 1));
                            r = r.redMul(b);
                            c = b.redSqr();
                            t = t.redMul(c);
                            m = i;
                        }
                        return r;
                    };
                    Red.prototype.invm = function invm(a) {
                        var inv = a._invmp(this.m);
                        if (inv.negative !== 0) {
                            inv.negative = 0;
                            return this.imod(inv).redNeg();
                        } else return this.imod(inv);
                    };
                    Red.prototype.pow = function pow(a, num) {
                        if (num.isZero()) return new BN(1).toRed(this);
                        if (num.cmpn(1) === 0) return a.clone();
                        var windowSize = 4;
                        var wnd = new Array(1 << windowSize);
                        wnd[0] = new BN(1).toRed(this);
                        wnd[1] = a;
                        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
                        var res = wnd[0];
                        var current = 0;
                        var currentLen = 0;
                        var start = num.bitLength() % 26;
                        if (start === 0) start = 26;
                        for(i = num.length - 1; i >= 0; i--){
                            var word = num.words[i];
                            for(var j = start - 1; j >= 0; j--){
                                var bit = word >> j & 1;
                                if (res !== wnd[0]) res = this.sqr(res);
                                if (bit === 0 && current === 0) {
                                    currentLen = 0;
                                    continue;
                                }
                                current <<= 1;
                                current |= bit;
                                currentLen++;
                                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                                res = this.mul(res, wnd[current]);
                                currentLen = 0;
                                current = 0;
                            }
                            start = 26;
                        }
                        return res;
                    };
                    Red.prototype.convertTo = function convertTo(num) {
                        var r = num.umod(this.m);
                        return r === num ? r.clone() : r;
                    };
                    Red.prototype.convertFrom = function convertFrom(num) {
                        var res = num.clone();
                        res.red = null;
                        return res;
                    };
                    //
                    // Montgomery method engine
                    //
                    BN.mont = function mont(num) {
                        return new Mont(num);
                    };
                    function Mont(m) {
                        Red.call(this, m);
                        this.shift = this.m.bitLength();
                        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
                        this.r = new BN(1).iushln(this.shift);
                        this.r2 = this.imod(this.r.sqr());
                        this.rinv = this.r._invmp(this.m);
                        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
                        this.minv = this.minv.umod(this.r);
                        this.minv = this.r.sub(this.minv);
                    }
                    inherits(Mont, Red);
                    Mont.prototype.convertTo = function convertTo(num) {
                        return this.imod(num.ushln(this.shift));
                    };
                    Mont.prototype.convertFrom = function convertFrom(num) {
                        var r = this.imod(num.mul(this.rinv));
                        r.red = null;
                        return r;
                    };
                    Mont.prototype.imul = function imul(a, b) {
                        if (a.isZero() || b.isZero()) {
                            a.words[0] = 0;
                            a.length = 1;
                            return a;
                        }
                        var t = a.imul(b);
                        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
                        var u = t.isub(c).iushrn(this.shift);
                        var res = u;
                        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
                        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
                        return res._forceRed(this);
                    };
                    Mont.prototype.mul = function mul(a, b) {
                        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
                        var t = a.mul(b);
                        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
                        var u = t.isub(c).iushrn(this.shift);
                        var res = u;
                        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
                        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
                        return res._forceRed(this);
                    };
                    Mont.prototype.invm = function invm(a) {
                        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
                        var res = this.imod(a._invmp(this.m).mul(this.r2));
                        return res._forceRed(this);
                    };
                })(module1, this);
            /***/ },
            /***/ 747: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.5.7
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2016
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
                    "use strict";
                    var root = typeof window === "object" ? window : {};
                    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $hPtJY === "object" && $hPtJY.versions && $hPtJY.versions.node;
                    if (NODE_JS) root = __webpack_require__.g;
                    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module1.exports;
                    var HEX_CHARS = "0123456789abcdef".split("");
                    var SHAKE_PADDING = [
                        31,
                        7936,
                        2031616,
                        520093696
                    ];
                    var KECCAK_PADDING = [
                        1,
                        256,
                        65536,
                        16777216
                    ];
                    var PADDING = [
                        6,
                        1536,
                        393216,
                        100663296
                    ];
                    var SHIFT = [
                        0,
                        8,
                        16,
                        24
                    ];
                    var RC = [
                        1,
                        0,
                        32898,
                        0,
                        32906,
                        2147483648,
                        2147516416,
                        2147483648,
                        32907,
                        0,
                        2147483649,
                        0,
                        2147516545,
                        2147483648,
                        32777,
                        2147483648,
                        138,
                        0,
                        136,
                        0,
                        2147516425,
                        0,
                        2147483658,
                        0,
                        2147516555,
                        0,
                        139,
                        2147483648,
                        32905,
                        2147483648,
                        32771,
                        2147483648,
                        32770,
                        2147483648,
                        128,
                        2147483648,
                        32778,
                        0,
                        2147483658,
                        2147483648,
                        2147516545,
                        2147483648,
                        32896,
                        2147483648,
                        2147483649,
                        0,
                        2147516424,
                        2147483648
                    ];
                    var BITS = [
                        224,
                        256,
                        384,
                        512
                    ];
                    var SHAKE_BITS = [
                        128,
                        256
                    ];
                    var OUTPUT_TYPES = [
                        "hex",
                        "buffer",
                        "arrayBuffer",
                        "array"
                    ];
                    var createOutputMethod = function(bits, padding, outputType) {
                        return function(message) {
                            return new Keccak(bits, padding, bits).update(message)[outputType]();
                        };
                    };
                    var createShakeOutputMethod = function(bits, padding, outputType) {
                        return function(message, outputBits) {
                            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
                        };
                    };
                    var createMethod = function(bits, padding) {
                        var method = createOutputMethod(bits, padding, "hex");
                        method.create = function() {
                            return new Keccak(bits, padding, bits);
                        };
                        method.update = function(message) {
                            return method.create().update(message);
                        };
                        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
                            var type = OUTPUT_TYPES[i];
                            method[type] = createOutputMethod(bits, padding, type);
                        }
                        return method;
                    };
                    var createShakeMethod = function(bits, padding) {
                        var method = createShakeOutputMethod(bits, padding, "hex");
                        method.create = function(outputBits) {
                            return new Keccak(bits, padding, outputBits);
                        };
                        method.update = function(message, outputBits) {
                            return method.create(outputBits).update(message);
                        };
                        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
                            var type = OUTPUT_TYPES[i];
                            method[type] = createShakeOutputMethod(bits, padding, type);
                        }
                        return method;
                    };
                    var algorithms = [
                        {
                            name: "keccak",
                            padding: KECCAK_PADDING,
                            bits: BITS,
                            createMethod: createMethod
                        },
                        {
                            name: "sha3",
                            padding: PADDING,
                            bits: BITS,
                            createMethod: createMethod
                        },
                        {
                            name: "shake",
                            padding: SHAKE_PADDING,
                            bits: SHAKE_BITS,
                            createMethod: createShakeMethod
                        }
                    ];
                    var methods = {}, methodNames = [];
                    for(var i = 0; i < algorithms.length; ++i){
                        var algorithm = algorithms[i];
                        var bits = algorithm.bits;
                        for(var j = 0; j < bits.length; ++j){
                            var methodName = algorithm.name + "_" + bits[j];
                            methodNames.push(methodName);
                            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
                        }
                    }
                    function Keccak(bits, padding, outputBits) {
                        this.blocks = [];
                        this.s = [];
                        this.padding = padding;
                        this.outputBits = outputBits;
                        this.reset = true;
                        this.block = 0;
                        this.start = 0;
                        this.blockCount = 1600 - (bits << 1) >> 5;
                        this.byteCount = this.blockCount << 2;
                        this.outputBlocks = outputBits >> 5;
                        this.extraBytes = (outputBits & 31) >> 3;
                        for(var i = 0; i < 50; ++i)this.s[i] = 0;
                    }
                    Keccak.prototype.update = function(message) {
                        var notString = typeof message !== "string";
                        if (notString && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                        var length = message.length, blocks = this.blocks, byteCount = this.byteCount, blockCount = this.blockCount, index = 0, s = this.s, i, code;
                        while(index < length){
                            if (this.reset) {
                                this.reset = false;
                                blocks[0] = this.block;
                                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
                            }
                            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
                            else for(i = this.start; index < length && i < byteCount; ++index){
                                code = message.charCodeAt(index);
                                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                                else if (code < 0x800) {
                                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                                } else if (code < 0xd800 || code >= 0xe000) {
                                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                                } else {
                                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                                }
                            }
                            this.lastByteIndex = i;
                            if (i >= byteCount) {
                                this.start = i - byteCount;
                                this.block = blocks[blockCount];
                                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                                f(s);
                                this.reset = true;
                            } else this.start = i;
                        }
                        return this;
                    };
                    Keccak.prototype.finalize = function() {
                        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
                        blocks[i >> 2] |= this.padding[i & 3];
                        if (this.lastByteIndex === this.byteCount) {
                            blocks[0] = blocks[blockCount];
                            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
                        }
                        blocks[blockCount - 1] |= 0x80000000;
                        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                        f(s);
                    };
                    Keccak.prototype.toString = Keccak.prototype.hex = function() {
                        this.finalize();
                        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
                        var hex = "", block;
                        while(j < outputBlocks){
                            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                                block = s[i];
                                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
                            }
                            if (j % blockCount === 0) {
                                f(s);
                                i = 0;
                            }
                        }
                        if (extraBytes) {
                            block = s[i];
                            if (extraBytes > 0) hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
                            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
                            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
                        }
                        return hex;
                    };
                    Keccak.prototype.arrayBuffer = function() {
                        this.finalize();
                        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
                        var bytes = this.outputBits >> 3;
                        var buffer;
                        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
                        else buffer = new ArrayBuffer(bytes);
                        var array = new Uint32Array(buffer);
                        while(j < outputBlocks){
                            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
                            if (j % blockCount === 0) f(s);
                        }
                        if (extraBytes) {
                            array[i] = s[i];
                            buffer = buffer.slice(0, bytes);
                        }
                        return buffer;
                    };
                    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
                    Keccak.prototype.digest = Keccak.prototype.array = function() {
                        this.finalize();
                        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
                        var array = [], offset, block;
                        while(j < outputBlocks){
                            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                                offset = j << 2;
                                block = s[i];
                                array[offset] = block & 0xFF;
                                array[offset + 1] = block >> 8 & 0xFF;
                                array[offset + 2] = block >> 16 & 0xFF;
                                array[offset + 3] = block >> 24 & 0xFF;
                            }
                            if (j % blockCount === 0) f(s);
                        }
                        if (extraBytes) {
                            offset = j << 2;
                            block = s[i];
                            if (extraBytes > 0) array[offset] = block & 0xFF;
                            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
                            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
                        }
                        return array;
                    };
                    var f = function(s) {
                        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
                        for(n = 0; n < 48; n += 2){
                            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
                            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
                            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
                            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
                            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
                            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
                            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
                            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
                            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
                            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
                            h = c8 ^ (c2 << 1 | c3 >>> 31);
                            l = c9 ^ (c3 << 1 | c2 >>> 31);
                            s[0] ^= h;
                            s[1] ^= l;
                            s[10] ^= h;
                            s[11] ^= l;
                            s[20] ^= h;
                            s[21] ^= l;
                            s[30] ^= h;
                            s[31] ^= l;
                            s[40] ^= h;
                            s[41] ^= l;
                            h = c0 ^ (c4 << 1 | c5 >>> 31);
                            l = c1 ^ (c5 << 1 | c4 >>> 31);
                            s[2] ^= h;
                            s[3] ^= l;
                            s[12] ^= h;
                            s[13] ^= l;
                            s[22] ^= h;
                            s[23] ^= l;
                            s[32] ^= h;
                            s[33] ^= l;
                            s[42] ^= h;
                            s[43] ^= l;
                            h = c2 ^ (c6 << 1 | c7 >>> 31);
                            l = c3 ^ (c7 << 1 | c6 >>> 31);
                            s[4] ^= h;
                            s[5] ^= l;
                            s[14] ^= h;
                            s[15] ^= l;
                            s[24] ^= h;
                            s[25] ^= l;
                            s[34] ^= h;
                            s[35] ^= l;
                            s[44] ^= h;
                            s[45] ^= l;
                            h = c4 ^ (c8 << 1 | c9 >>> 31);
                            l = c5 ^ (c9 << 1 | c8 >>> 31);
                            s[6] ^= h;
                            s[7] ^= l;
                            s[16] ^= h;
                            s[17] ^= l;
                            s[26] ^= h;
                            s[27] ^= l;
                            s[36] ^= h;
                            s[37] ^= l;
                            s[46] ^= h;
                            s[47] ^= l;
                            h = c6 ^ (c0 << 1 | c1 >>> 31);
                            l = c7 ^ (c1 << 1 | c0 >>> 31);
                            s[8] ^= h;
                            s[9] ^= l;
                            s[18] ^= h;
                            s[19] ^= l;
                            s[28] ^= h;
                            s[29] ^= l;
                            s[38] ^= h;
                            s[39] ^= l;
                            s[48] ^= h;
                            s[49] ^= l;
                            b0 = s[0];
                            b1 = s[1];
                            b32 = s[11] << 4 | s[10] >>> 28;
                            b33 = s[10] << 4 | s[11] >>> 28;
                            b14 = s[20] << 3 | s[21] >>> 29;
                            b15 = s[21] << 3 | s[20] >>> 29;
                            b46 = s[31] << 9 | s[30] >>> 23;
                            b47 = s[30] << 9 | s[31] >>> 23;
                            b28 = s[40] << 18 | s[41] >>> 14;
                            b29 = s[41] << 18 | s[40] >>> 14;
                            b20 = s[2] << 1 | s[3] >>> 31;
                            b21 = s[3] << 1 | s[2] >>> 31;
                            b2 = s[13] << 12 | s[12] >>> 20;
                            b3 = s[12] << 12 | s[13] >>> 20;
                            b34 = s[22] << 10 | s[23] >>> 22;
                            b35 = s[23] << 10 | s[22] >>> 22;
                            b16 = s[33] << 13 | s[32] >>> 19;
                            b17 = s[32] << 13 | s[33] >>> 19;
                            b48 = s[42] << 2 | s[43] >>> 30;
                            b49 = s[43] << 2 | s[42] >>> 30;
                            b40 = s[5] << 30 | s[4] >>> 2;
                            b41 = s[4] << 30 | s[5] >>> 2;
                            b22 = s[14] << 6 | s[15] >>> 26;
                            b23 = s[15] << 6 | s[14] >>> 26;
                            b4 = s[25] << 11 | s[24] >>> 21;
                            b5 = s[24] << 11 | s[25] >>> 21;
                            b36 = s[34] << 15 | s[35] >>> 17;
                            b37 = s[35] << 15 | s[34] >>> 17;
                            b18 = s[45] << 29 | s[44] >>> 3;
                            b19 = s[44] << 29 | s[45] >>> 3;
                            b10 = s[6] << 28 | s[7] >>> 4;
                            b11 = s[7] << 28 | s[6] >>> 4;
                            b42 = s[17] << 23 | s[16] >>> 9;
                            b43 = s[16] << 23 | s[17] >>> 9;
                            b24 = s[26] << 25 | s[27] >>> 7;
                            b25 = s[27] << 25 | s[26] >>> 7;
                            b6 = s[36] << 21 | s[37] >>> 11;
                            b7 = s[37] << 21 | s[36] >>> 11;
                            b38 = s[47] << 24 | s[46] >>> 8;
                            b39 = s[46] << 24 | s[47] >>> 8;
                            b30 = s[8] << 27 | s[9] >>> 5;
                            b31 = s[9] << 27 | s[8] >>> 5;
                            b12 = s[18] << 20 | s[19] >>> 12;
                            b13 = s[19] << 20 | s[18] >>> 12;
                            b44 = s[29] << 7 | s[28] >>> 25;
                            b45 = s[28] << 7 | s[29] >>> 25;
                            b26 = s[38] << 8 | s[39] >>> 24;
                            b27 = s[39] << 8 | s[38] >>> 24;
                            b8 = s[48] << 14 | s[49] >>> 18;
                            b9 = s[49] << 14 | s[48] >>> 18;
                            s[0] = b0 ^ ~b2 & b4;
                            s[1] = b1 ^ ~b3 & b5;
                            s[10] = b10 ^ ~b12 & b14;
                            s[11] = b11 ^ ~b13 & b15;
                            s[20] = b20 ^ ~b22 & b24;
                            s[21] = b21 ^ ~b23 & b25;
                            s[30] = b30 ^ ~b32 & b34;
                            s[31] = b31 ^ ~b33 & b35;
                            s[40] = b40 ^ ~b42 & b44;
                            s[41] = b41 ^ ~b43 & b45;
                            s[2] = b2 ^ ~b4 & b6;
                            s[3] = b3 ^ ~b5 & b7;
                            s[12] = b12 ^ ~b14 & b16;
                            s[13] = b13 ^ ~b15 & b17;
                            s[22] = b22 ^ ~b24 & b26;
                            s[23] = b23 ^ ~b25 & b27;
                            s[32] = b32 ^ ~b34 & b36;
                            s[33] = b33 ^ ~b35 & b37;
                            s[42] = b42 ^ ~b44 & b46;
                            s[43] = b43 ^ ~b45 & b47;
                            s[4] = b4 ^ ~b6 & b8;
                            s[5] = b5 ^ ~b7 & b9;
                            s[14] = b14 ^ ~b16 & b18;
                            s[15] = b15 ^ ~b17 & b19;
                            s[24] = b24 ^ ~b26 & b28;
                            s[25] = b25 ^ ~b27 & b29;
                            s[34] = b34 ^ ~b36 & b38;
                            s[35] = b35 ^ ~b37 & b39;
                            s[44] = b44 ^ ~b46 & b48;
                            s[45] = b45 ^ ~b47 & b49;
                            s[6] = b6 ^ ~b8 & b0;
                            s[7] = b7 ^ ~b9 & b1;
                            s[16] = b16 ^ ~b18 & b10;
                            s[17] = b17 ^ ~b19 & b11;
                            s[26] = b26 ^ ~b28 & b20;
                            s[27] = b27 ^ ~b29 & b21;
                            s[36] = b36 ^ ~b38 & b30;
                            s[37] = b37 ^ ~b39 & b31;
                            s[46] = b46 ^ ~b48 & b40;
                            s[47] = b47 ^ ~b49 & b41;
                            s[8] = b8 ^ ~b0 & b2;
                            s[9] = b9 ^ ~b1 & b3;
                            s[18] = b18 ^ ~b10 & b12;
                            s[19] = b19 ^ ~b11 & b13;
                            s[28] = b28 ^ ~b20 & b22;
                            s[29] = b29 ^ ~b21 & b23;
                            s[38] = b38 ^ ~b30 & b32;
                            s[39] = b39 ^ ~b31 & b33;
                            s[48] = b48 ^ ~b40 & b42;
                            s[49] = b49 ^ ~b41 & b43;
                            s[0] ^= RC[n];
                            s[1] ^= RC[n + 1];
                        }
                    };
                    if (COMMON_JS) module1.exports = methods;
                    else for(var i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
                })();
            /***/ },
            /***/ 6462: /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                var __webpack_unused_export__;
                __webpack_unused_export__ = {
                    value: true
                };
                /**
 * convert the given Scheme into a Rule that allows undefined value
 * @param scheme the scheme
 */ function optional(scheme) {
                    return (value, context)=>{
                        if (value !== undefined) validate(value, scheme, context);
                        return "";
                    };
                }
                exports.jt = optional;
                /**
 * convert the given Scheme into a Rule that allows null value
 * @param scheme the scheme
 */ function nullable(scheme) {
                    return (value, context)=>{
                        if (value !== null) validate(value, scheme, context);
                        return "";
                    };
                }
                exports.AG = nullable;
                /** Validator class */ class Validator {
                    constructor(scheme){
                        this.scheme = scheme;
                    }
                    test(value, context) {
                        return validate(value, this.scheme, context);
                    }
                }
                __webpack_unused_export__ = Validator;
                /** Error class describes validation error */ class ValidationError extends Error {
                    constructor(rawMessage, context){
                        super(context ? `${context}: ${rawMessage}` : rawMessage);
                        this.rawMessage = rawMessage;
                        this.context = context;
                    }
                }
                exports.p8 = ValidationError;
                ValidationError.prototype.name = "ValidationError";
                /**
 * direct function to validate value without construct Validator object
 * @param value value to be validated
 * @param scheme scheme
 * @param context context string appears in error object
 */ function validate(value, scheme, context) {
                    if (Array.isArray(scheme)) {
                        if (!Array.isArray(value)) throw new ValidationError("expected array", context || "");
                        value.forEach((el, i)=>validate(el, scheme[0], context ? `${context}.#${i}` : `#${i}`));
                    } else if (scheme instanceof Function) {
                        const errMsg = scheme(value, context);
                        if (errMsg) throw new ValidationError(errMsg, context || "");
                    } else {
                        if (!(value instanceof Object)) throw new ValidationError("expected object", context || "");
                        for(const key in scheme)if (scheme.hasOwnProperty(key)) validate(value[key], scheme[key], context ? `${context}.${key}` : key);
                    }
                    return value;
                }
                exports.Gu = validate;
            //# sourceMappingURL=data:application/json;base64,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
            /***/ },
            /***/ 2574: /***/ ()=>{
            /* (ignored) */ /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (__webpack_module_cache__[moduleId]) /******/ return __webpack_module_cache__[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ id: moduleId,
                /******/ loaded: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.loaded = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ (()=>{
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = (module1)=>{
                /******/ var getter = module1 && module1.__esModule ? /******/ ()=>module1["default"] : /******/ ()=>module1;
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = (exports, definition)=>{
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/global */ /******/ (()=>{
            /******/ __webpack_require__.g = function() {
                /******/ if (typeof globalThis === "object") return globalThis;
                /******/ try {
                    /******/ return this || new Function("return this")();
                /******/ } catch (e) {
                    /******/ if (typeof window === "object") return window;
                /******/ }
            /******/ }();
        /******/ })();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
            /******/ __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
        /******/ })();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ (()=>{
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = (exports)=>{
                /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
                /******/ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/node module decorator */ /******/ (()=>{
            /******/ __webpack_require__.nmd = (module1)=>{
                /******/ module1.paths = [];
                /******/ if (!module1.children) module1.children = [];
                /******/ return module1;
            /******/ };
        /******/ })();
        /******/ /************************************************************************/ /******/ // module exports must be returned from runtime so entry inlining is disabled
        /******/ // startup
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(280);
    /******/ })();
});



var $7etJZ = parcelRequire("7etJZ");
const $d3904a4891ee1c9a$var$suspectProtoRx = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/;
const $d3904a4891ee1c9a$var$suspectConstructorRx = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
const $d3904a4891ee1c9a$var$JsonSigRx = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function $d3904a4891ee1c9a$var$jsonParseTransform(key, value) {
    if (key === "__proto__" || key === "constructor" && value && typeof value === "object" && "prototype" in value) {
        $d3904a4891ee1c9a$var$warnKeyDropped(key);
        return;
    }
    return value;
}
function $d3904a4891ee1c9a$var$warnKeyDropped(key) {
    console.warn(`[destr] Dropping "${key}" key to prevent prototype pollution.`);
}
function $d3904a4891ee1c9a$export$2e2bcd8739ae039(value, options = {}) {
    if (typeof value !== "string") return value;
    const _value = value.trim();
    if (// eslint-disable-next-line unicorn/prefer-at
    value[0] === '"' && value.at(-1) === '"' && !value.includes("\\")) return _value.slice(1, -1);
    if (_value.length <= 9) {
        const _lval = _value.toLowerCase();
        if (_lval === "true") return true;
        if (_lval === "false") return false;
        if (_lval === "undefined") return void 0;
        if (_lval === "null") return null;
        if (_lval === "nan") return Number.NaN;
        if (_lval === "infinity") return Number.POSITIVE_INFINITY;
        if (_lval === "-infinity") return Number.NEGATIVE_INFINITY;
    }
    if (!$d3904a4891ee1c9a$var$JsonSigRx.test(value)) {
        if (options.strict) throw new SyntaxError("[destr] Invalid JSON");
        return value;
    }
    try {
        if ($d3904a4891ee1c9a$var$suspectProtoRx.test(value) || $d3904a4891ee1c9a$var$suspectConstructorRx.test(value)) {
            if (options.strict) throw new Error("[destr] Possible prototype pollution");
            return JSON.parse(value, $d3904a4891ee1c9a$var$jsonParseTransform);
        }
        return JSON.parse(value);
    } catch (error) {
        if (options.strict) throw error;
        return value;
    }
}
function $d3904a4891ee1c9a$export$4b2a7c187ff4b28c(value, options = {}) {
    return $d3904a4891ee1c9a$export$2e2bcd8739ae039(value, {
        ...options,
        strict: true
    });
}



var $6ZWSX = parcelRequire("6ZWSX");
var $0e062bc0199dd221$require$Buffer = $6ZWSX.Buffer;
function $0e062bc0199dd221$var$wrapToPromise(value) {
    if (!value || typeof value.then !== "function") return Promise.resolve(value);
    return value;
}
function $0e062bc0199dd221$export$8b22cf2602fb60ce(function_, ...arguments_) {
    try {
        return $0e062bc0199dd221$var$wrapToPromise(function_(...arguments_));
    } catch (error) {
        return Promise.reject(error);
    }
}
function $0e062bc0199dd221$var$isPrimitive(value) {
    const type = typeof value;
    return value === null || type !== "object" && type !== "function";
}
function $0e062bc0199dd221$var$isPureObject(value) {
    const proto = Object.getPrototypeOf(value);
    return !proto || proto.isPrototypeOf(Object);
}
function $0e062bc0199dd221$export$2408f22a0fab9ae5(value) {
    if ($0e062bc0199dd221$var$isPrimitive(value)) return String(value);
    if ($0e062bc0199dd221$var$isPureObject(value) || Array.isArray(value)) return JSON.stringify(value);
    if (typeof value.toJSON === "function") return $0e062bc0199dd221$export$2408f22a0fab9ae5(value.toJSON());
    throw new Error("[unstorage] Cannot stringify value!");
}
function $0e062bc0199dd221$var$checkBufferSupport() {}
const $0e062bc0199dd221$var$BASE64_PREFIX = "base64:";
function $0e062bc0199dd221$export$db3b6bfb95261072(value) {
    if (typeof value === "string") return value;
    $0e062bc0199dd221$var$checkBufferSupport();
    const base64 = $0e062bc0199dd221$require$Buffer.from(value).toString("base64");
    return $0e062bc0199dd221$var$BASE64_PREFIX + base64;
}
function $0e062bc0199dd221$export$4368d992c4eafac0(value) {
    if (typeof value !== "string") return value;
    if (!value.startsWith($0e062bc0199dd221$var$BASE64_PREFIX)) return value;
    $0e062bc0199dd221$var$checkBufferSupport();
    return $0e062bc0199dd221$require$Buffer.from(value.slice($0e062bc0199dd221$var$BASE64_PREFIX.length), "base64");
}
const $0e062bc0199dd221$var$storageKeyProperties = [
    "hasItem",
    "getItem",
    "getItemRaw",
    "setItem",
    "setItemRaw",
    "removeItem",
    "getMeta",
    "setMeta",
    "removeMeta",
    "getKeys",
    "clear",
    "mount",
    "unmount"
];
function $0e062bc0199dd221$export$ffb5f4729a158638(storage, base) {
    base = $0e062bc0199dd221$export$7ccc53e8f1e7dfc5(base);
    if (!base) return storage;
    const nsStorage = {
        ...storage
    };
    for (const property of $0e062bc0199dd221$var$storageKeyProperties)nsStorage[property] = (key = "", ...args)=>// @ts-ignore
        storage[property](base + key, ...args);
    nsStorage.getKeys = (key = "", ...arguments_)=>storage.getKeys(base + key, ...arguments_).then((keys)=>keys.map((key2)=>key2.slice(base.length)));
    return nsStorage;
}
function $0e062bc0199dd221$export$407448d2b89b1813(key) {
    if (!key) return "";
    return key.split("?")[0].replace(/[/\\]/g, ":").replace(/:+/g, ":").replace(/^:|:$/g, "");
}
function $0e062bc0199dd221$export$35e795649ee09318(...keys) {
    return $0e062bc0199dd221$export$407448d2b89b1813(keys.join(":"));
}
function $0e062bc0199dd221$export$7ccc53e8f1e7dfc5(base) {
    base = $0e062bc0199dd221$export$407448d2b89b1813(base);
    return base ? base + ":" : "";
}


function $20f36d051f0d8a54$export$b5cf55d52d4cddb(factory) {
    return factory;
}
const $20f36d051f0d8a54$var$DRIVER_NAME = "memory";
const $20f36d051f0d8a54$var$memory = $20f36d051f0d8a54$export$b5cf55d52d4cddb(()=>{
    const data = /* @__PURE__ */ new Map();
    return {
        name: $20f36d051f0d8a54$var$DRIVER_NAME,
        options: {},
        hasItem (key) {
            return data.has(key);
        },
        getItem (key) {
            return data.get(key) ?? null;
        },
        getItemRaw (key) {
            return data.get(key) ?? null;
        },
        setItem (key, value) {
            data.set(key, value);
        },
        setItemRaw (key, value) {
            data.set(key, value);
        },
        removeItem (key) {
            data.delete(key);
        },
        getKeys () {
            return Array.from(data.keys());
        },
        clear () {
            data.clear();
        },
        dispose () {
            data.clear();
        }
    };
});
function $20f36d051f0d8a54$export$d184a47a971dd4b9(options = {}) {
    const context = {
        mounts: {
            "": options.driver || $20f36d051f0d8a54$var$memory()
        },
        mountpoints: [
            ""
        ],
        watching: false,
        watchListeners: [],
        unwatch: {}
    };
    const getMount = (key)=>{
        for (const base of context.mountpoints){
            if (key.startsWith(base)) return {
                base: base,
                relativeKey: key.slice(base.length),
                driver: context.mounts[base]
            };
        }
        return {
            base: "",
            relativeKey: key,
            driver: context.mounts[""]
        };
    };
    const getMounts = (base, includeParent)=>{
        return context.mountpoints.filter((mountpoint)=>mountpoint.startsWith(base) || includeParent && base.startsWith(mountpoint)).map((mountpoint)=>({
                relativeBase: base.length > mountpoint.length ? base.slice(mountpoint.length) : void 0,
                mountpoint: mountpoint,
                driver: context.mounts[mountpoint]
            }));
    };
    const onChange = (event, key)=>{
        if (!context.watching) return;
        key = (0, $0e062bc0199dd221$export$407448d2b89b1813)(key);
        for (const listener of context.watchListeners)listener(event, key);
    };
    const startWatch = async ()=>{
        if (context.watching) return;
        context.watching = true;
        for(const mountpoint in context.mounts)context.unwatch[mountpoint] = await $20f36d051f0d8a54$var$watch(context.mounts[mountpoint], onChange, mountpoint);
    };
    const stopWatch = async ()=>{
        if (!context.watching) return;
        for(const mountpoint in context.unwatch)await context.unwatch[mountpoint]();
        context.unwatch = {};
        context.watching = false;
    };
    const runBatch = (items, commonOptions, cb)=>{
        const batches = /* @__PURE__ */ new Map();
        const getBatch = (mount)=>{
            let batch = batches.get(mount.base);
            if (!batch) {
                batch = {
                    driver: mount.driver,
                    base: mount.base,
                    items: []
                };
                batches.set(mount.base, batch);
            }
            return batch;
        };
        for (const item of items){
            const isStringItem = typeof item === "string";
            const key = (0, $0e062bc0199dd221$export$407448d2b89b1813)(isStringItem ? item : item.key);
            const value = isStringItem ? void 0 : item.value;
            const options2 = isStringItem || !item.options ? commonOptions : {
                ...commonOptions,
                ...item.options
            };
            const mount = getMount(key);
            getBatch(mount).items.push({
                key: key,
                value: value,
                relativeKey: mount.relativeKey,
                options: options2
            });
        }
        return Promise.all([
            ...batches.values()
        ].map((batch)=>cb(batch))).then((r)=>r.flat());
    };
    const storage = {
        // Item
        hasItem (key, opts = {}) {
            key = (0, $0e062bc0199dd221$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            return (0, $0e062bc0199dd221$export$8b22cf2602fb60ce)(driver.hasItem, relativeKey, opts);
        },
        getItem (key, opts = {}) {
            key = (0, $0e062bc0199dd221$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            return (0, $0e062bc0199dd221$export$8b22cf2602fb60ce)(driver.getItem, relativeKey, opts).then((value)=>(0, $d3904a4891ee1c9a$export$2e2bcd8739ae039)(value));
        },
        getItems (items, commonOptions) {
            return runBatch(items, commonOptions, (batch)=>{
                if (batch.driver.getItems) return (0, $0e062bc0199dd221$export$8b22cf2602fb60ce)(batch.driver.getItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        options: item.options
                    })), commonOptions).then((r)=>r.map((item)=>({
                            key: (0, $0e062bc0199dd221$export$35e795649ee09318)(batch.base, item.key),
                            value: (0, $d3904a4891ee1c9a$export$2e2bcd8739ae039)(item.value)
                        })));
                return Promise.all(batch.items.map((item)=>{
                    return (0, $0e062bc0199dd221$export$8b22cf2602fb60ce)(batch.driver.getItem, item.relativeKey, item.options).then((value)=>({
                            key: item.key,
                            value: (0, $d3904a4891ee1c9a$export$2e2bcd8739ae039)(value)
                        }));
                }));
            });
        },
        getItemRaw (key, opts = {}) {
            key = (0, $0e062bc0199dd221$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (driver.getItemRaw) return (0, $0e062bc0199dd221$export$8b22cf2602fb60ce)(driver.getItemRaw, relativeKey, opts);
            return (0, $0e062bc0199dd221$export$8b22cf2602fb60ce)(driver.getItem, relativeKey, opts).then((value)=>(0, $0e062bc0199dd221$export$4368d992c4eafac0)(value));
        },
        async setItem (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key);
            key = (0, $0e062bc0199dd221$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (!driver.setItem) return;
            await (0, $0e062bc0199dd221$export$8b22cf2602fb60ce)(driver.setItem, relativeKey, (0, $0e062bc0199dd221$export$2408f22a0fab9ae5)(value), opts);
            if (!driver.watch) onChange("update", key);
        },
        async setItems (items, commonOptions) {
            await runBatch(items, commonOptions, async (batch)=>{
                if (batch.driver.setItems) await (0, $0e062bc0199dd221$export$8b22cf2602fb60ce)(batch.driver.setItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        value: (0, $0e062bc0199dd221$export$2408f22a0fab9ae5)(item.value),
                        options: item.options
                    })), commonOptions);
                if (!batch.driver.setItem) return;
                await Promise.all(batch.items.map((item)=>{
                    return (0, $0e062bc0199dd221$export$8b22cf2602fb60ce)(batch.driver.setItem, item.relativeKey, (0, $0e062bc0199dd221$export$2408f22a0fab9ae5)(item.value), item.options);
                }));
            });
        },
        async setItemRaw (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key, opts);
            key = (0, $0e062bc0199dd221$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (driver.setItemRaw) await (0, $0e062bc0199dd221$export$8b22cf2602fb60ce)(driver.setItemRaw, relativeKey, value, opts);
            else if (driver.setItem) await (0, $0e062bc0199dd221$export$8b22cf2602fb60ce)(driver.setItem, relativeKey, (0, $0e062bc0199dd221$export$db3b6bfb95261072)(value), opts);
            else return;
            if (!driver.watch) onChange("update", key);
        },
        async removeItem (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                removeMeta: opts
            };
            key = (0, $0e062bc0199dd221$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (!driver.removeItem) return;
            await (0, $0e062bc0199dd221$export$8b22cf2602fb60ce)(driver.removeItem, relativeKey, opts);
            if (opts.removeMeta || opts.removeMata) await (0, $0e062bc0199dd221$export$8b22cf2602fb60ce)(driver.removeItem, relativeKey + "$", opts);
            if (!driver.watch) onChange("remove", key);
        },
        // Meta
        async getMeta (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                nativeOnly: opts
            };
            key = (0, $0e062bc0199dd221$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            const meta = /* @__PURE__ */ Object.create(null);
            if (driver.getMeta) Object.assign(meta, await (0, $0e062bc0199dd221$export$8b22cf2602fb60ce)(driver.getMeta, relativeKey, opts));
            if (!opts.nativeOnly) {
                const value = await (0, $0e062bc0199dd221$export$8b22cf2602fb60ce)(driver.getItem, relativeKey + "$", opts).then((value_)=>(0, $d3904a4891ee1c9a$export$2e2bcd8739ae039)(value_));
                if (value && typeof value === "object") {
                    if (typeof value.atime === "string") value.atime = new Date(value.atime);
                    if (typeof value.mtime === "string") value.mtime = new Date(value.mtime);
                    Object.assign(meta, value);
                }
            }
            return meta;
        },
        setMeta (key, value, opts = {}) {
            return this.setItem(key + "$", value, opts);
        },
        removeMeta (key, opts = {}) {
            return this.removeItem(key + "$", opts);
        },
        // Keys
        async getKeys (base, opts = {}) {
            base = (0, $0e062bc0199dd221$export$7ccc53e8f1e7dfc5)(base);
            const mounts = getMounts(base, true);
            let maskedMounts = [];
            const allKeys = [];
            for (const mount of mounts){
                const rawKeys = await (0, $0e062bc0199dd221$export$8b22cf2602fb60ce)(mount.driver.getKeys, mount.relativeBase, opts);
                const keys = rawKeys.map((key)=>mount.mountpoint + (0, $0e062bc0199dd221$export$407448d2b89b1813)(key)).filter((key)=>!maskedMounts.some((p)=>key.startsWith(p)));
                allKeys.push(...keys);
                maskedMounts = [
                    mount.mountpoint,
                    ...maskedMounts.filter((p)=>!p.startsWith(mount.mountpoint))
                ];
            }
            return base ? allKeys.filter((key)=>key.startsWith(base) && !key.endsWith("$")) : allKeys.filter((key)=>!key.endsWith("$"));
        },
        // Utils
        async clear (base, opts = {}) {
            base = (0, $0e062bc0199dd221$export$7ccc53e8f1e7dfc5)(base);
            await Promise.all(getMounts(base, false).map(async (m)=>{
                if (m.driver.clear) return (0, $0e062bc0199dd221$export$8b22cf2602fb60ce)(m.driver.clear, m.relativeBase, opts);
                if (m.driver.removeItem) {
                    const keys = await m.driver.getKeys(m.relativeBase || "", opts);
                    return Promise.all(keys.map((key)=>m.driver.removeItem(key, opts)));
                }
            }));
        },
        async dispose () {
            await Promise.all(Object.values(context.mounts).map((driver)=>$20f36d051f0d8a54$var$dispose(driver)));
        },
        async watch (callback) {
            await startWatch();
            context.watchListeners.push(callback);
            return async ()=>{
                context.watchListeners = context.watchListeners.filter((listener)=>listener !== callback);
                if (context.watchListeners.length === 0) await stopWatch();
            };
        },
        async unwatch () {
            context.watchListeners = [];
            await stopWatch();
        },
        // Mount
        mount (base, driver) {
            base = (0, $0e062bc0199dd221$export$7ccc53e8f1e7dfc5)(base);
            if (base && context.mounts[base]) throw new Error(`already mounted at ${base}`);
            if (base) {
                context.mountpoints.push(base);
                context.mountpoints.sort((a, b)=>b.length - a.length);
            }
            context.mounts[base] = driver;
            if (context.watching) Promise.resolve($20f36d051f0d8a54$var$watch(driver, onChange, base)).then((unwatcher)=>{
                context.unwatch[base] = unwatcher;
            }).catch(console.error);
            return storage;
        },
        async unmount (base, _dispose = true) {
            base = (0, $0e062bc0199dd221$export$7ccc53e8f1e7dfc5)(base);
            if (!base || !context.mounts[base]) return;
            if (context.watching && base in context.unwatch) {
                context.unwatch[base]();
                delete context.unwatch[base];
            }
            if (_dispose) await $20f36d051f0d8a54$var$dispose(context.mounts[base]);
            context.mountpoints = context.mountpoints.filter((key)=>key !== base);
            delete context.mounts[base];
        },
        getMount (key = "") {
            key = (0, $0e062bc0199dd221$export$407448d2b89b1813)(key) + ":";
            const m = getMount(key);
            return {
                driver: m.driver,
                base: m.base
            };
        },
        getMounts (base = "", opts = {}) {
            base = (0, $0e062bc0199dd221$export$407448d2b89b1813)(base);
            const mounts = getMounts(base, opts.parents);
            return mounts.map((m)=>({
                    driver: m.driver,
                    base: m.mountpoint
                }));
        }
    };
    return storage;
}
async function $20f36d051f0d8a54$export$b8801ea43165ed7d(storage, base) {
    base = (0, $0e062bc0199dd221$export$7ccc53e8f1e7dfc5)(base);
    const keys = await storage.getKeys(base);
    const snapshot2 = {};
    await Promise.all(keys.map(async (key)=>{
        snapshot2[key.slice(base.length)] = await storage.getItem(key);
    }));
    return snapshot2;
}
async function $20f36d051f0d8a54$export$11e5d4541284dd1e(driver, snapshot2, base = "") {
    base = (0, $0e062bc0199dd221$export$7ccc53e8f1e7dfc5)(base);
    await Promise.all(Object.entries(snapshot2).map((e)=>driver.setItem(base + e[0], e[1])));
}
function $20f36d051f0d8a54$var$watch(driver, onChange, base) {
    return driver.watch ? driver.watch((event, key)=>onChange(event, base + key)) : ()=>{};
}
async function $20f36d051f0d8a54$var$dispose(driver) {
    if (typeof driver.dispose === "function") await (0, $0e062bc0199dd221$export$8b22cf2602fb60ce)(driver.dispose);
}
const $20f36d051f0d8a54$export$108bed33247a8bd7 = {
    azureAppConfiguration: "unstorage/drivers/azure-app-configuration",
    azureCosmos: "unstorage/drivers/azure-cosmos",
    azureKeyVault: "unstorage/drivers/azure-key-vault",
    azureStorageBlob: "unstorage/drivers/azure-storage-blob",
    azureStorageTable: "unstorage/drivers/azure-storage-table",
    cloudflareKVBinding: "unstorage/drivers/cloudflare-kv-binding",
    cloudflareKVHTTP: "unstorage/drivers/cloudflare-kv-http",
    cloudflareR2Binding: "unstorage/drivers/cloudflare-r2-binding",
    fs: "unstorage/drivers/fs",
    fsLite: "unstorage/drivers/fs-lite",
    github: "unstorage/drivers/github",
    http: "unstorage/drivers/http",
    indexedb: "unstorage/drivers/indexedb",
    localStorage: "unstorage/drivers/localstorage",
    lruCache: "unstorage/drivers/lru-cache",
    memory: "unstorage/drivers/memory",
    mongodb: "unstorage/drivers/mongodb",
    netlifyBlobs: "unstorage/drivers/netlify-blobs",
    overlay: "unstorage/drivers/overlay",
    planetscale: "unstorage/drivers/planetscale",
    redis: "unstorage/drivers/redis",
    sessionStorage: "unstorage/drivers/session-storage",
    vercelKV: "unstorage/drivers/vercel-kv",
    /** @deprecated */ "cloudflare-kv-binding": "unstorage/drivers/cloudflare-kv-binding",
    /** @deprecated */ "cloudflare-kv-http": "unstorage/drivers/cloudflare-kv-http"
};


function $816683f8c32a91e9$var$_slicedToArray(arr, i) {
    return $816683f8c32a91e9$var$_arrayWithHoles(arr) || $816683f8c32a91e9$var$_iterableToArrayLimit(arr, i) || $816683f8c32a91e9$var$_unsupportedIterableToArray(arr, i) || $816683f8c32a91e9$var$_nonIterableRest();
}
function $816683f8c32a91e9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $816683f8c32a91e9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $816683f8c32a91e9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $816683f8c32a91e9$var$_arrayLikeToArray(o, minLen);
}
function $816683f8c32a91e9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $816683f8c32a91e9$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $816683f8c32a91e9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $816683f8c32a91e9$export$b327150396135fe7(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        }; // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function $816683f8c32a91e9$export$f51a9068ac82ea43(dbName, storeName) {
    var request = indexedDB.open(dbName);
    request.onupgradeneeded = function() {
        return request.result.createObjectStore(storeName);
    };
    var dbp = $816683f8c32a91e9$export$b327150396135fe7(request);
    return function(txMode, callback) {
        return dbp.then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var $816683f8c32a91e9$var$defaultGetStoreFunc;
function $816683f8c32a91e9$var$defaultGetStore() {
    if (!$816683f8c32a91e9$var$defaultGetStoreFunc) $816683f8c32a91e9$var$defaultGetStoreFunc = $816683f8c32a91e9$export$f51a9068ac82ea43("keyval-store", "keyval");
    return $816683f8c32a91e9$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$3988ae62b71be9a3(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return $816683f8c32a91e9$export$b327150396135fe7(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$adaa4cf7ef1b65be(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.put(value, key);
        return $816683f8c32a91e9$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$daa0a5170277c7a8(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return $816683f8c32a91e9$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$5df405cccea42673(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return Promise.all(keys.map(function(key) {
            return $816683f8c32a91e9$export$b327150396135fe7(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$722fbec263ad908a(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        return(// If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($816683f8c32a91e9$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$1d2f21e549771e67(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.delete(key);
        return $816683f8c32a91e9$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$c8aa84257229cac8(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return $816683f8c32a91e9$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$42ffd38884aecdac() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.clear();
        return $816683f8c32a91e9$export$b327150396135fe7(store.transaction);
    });
}
function $816683f8c32a91e9$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $816683f8c32a91e9$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$ed97f33186d4b816() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAllKeys) return $816683f8c32a91e9$export$b327150396135fe7(store.getAllKeys());
        var items = [];
        return $816683f8c32a91e9$var$eachCursor(store, function(cursor) {
            return items.push(cursor.key);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$68c286be0e7e55b7() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAll) return $816683f8c32a91e9$export$b327150396135fe7(store.getAll());
        var items = [];
        return $816683f8c32a91e9$var$eachCursor(store, function(cursor) {
            return items.push(cursor.value);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$3e9f948b41964866() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $816683f8c32a91e9$export$b327150396135fe7(store.getAllKeys()),
            $816683f8c32a91e9$export$b327150396135fe7(store.getAll())
        ]).then(function(_ref) {
            var _ref2 = $816683f8c32a91e9$var$_slicedToArray(_ref, 2), keys = _ref2[0], values = _ref2[1];
            return keys.map(function(key, i) {
                return [
                    key,
                    values[i]
                ];
            });
        });
        var items = [];
        return customStore("readonly", function(store) {
            return $816683f8c32a91e9$var$eachCursor(store, function(cursor) {
                return items.push([
                    cursor.key,
                    cursor.value
                ]);
            }).then(function() {
                return items;
            });
        });
    });
}


const $81c2e06d24b89184$var$JSONStringify = (data)=>JSON.stringify(data, (_, value)=>typeof value === "bigint" ? value.toString() + "n" : value);
const $81c2e06d24b89184$var$JSONParse = (json)=>{
    const numbersBiggerThanMaxInt = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g;
    const serializedData = json.replace(numbersBiggerThanMaxInt, '$1"$2n"$3');
    return JSON.parse(serializedData, (_, value)=>{
        const isCustomFormatBigInt = typeof value === "string" && value.match(/^\d+n$/);
        if (isCustomFormatBigInt) return BigInt(value.substring(0, value.length - 1));
        return value;
    });
};
function $81c2e06d24b89184$export$84137bb44359aed5(value) {
    if (typeof value !== "string") throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    try {
        return $81c2e06d24b89184$var$JSONParse(value);
    } catch (_a) {
        return value;
    }
}
function $81c2e06d24b89184$export$abc3f407e87918a4(value) {
    return typeof value === "string" ? value : $81c2e06d24b89184$var$JSONStringify(value) || "";
}


function $5e575ac853f40acc$var$C(i) {
    return i;
}
const $5e575ac853f40acc$var$x = "idb-keyval";
var $5e575ac853f40acc$var$z = (i = {})=>{
    const t = i.base && i.base.length > 0 ? `${i.base}:` : "", e = (s)=>t + s;
    let n;
    return i.dbName && i.storeName && (n = (0, $816683f8c32a91e9$export$f51a9068ac82ea43)(i.dbName, i.storeName)), {
        name: $5e575ac853f40acc$var$x,
        options: i,
        async hasItem (s) {
            return !(typeof await (0, $816683f8c32a91e9$export$3988ae62b71be9a3)(e(s), n) > "u");
        },
        async getItem (s) {
            return await (0, $816683f8c32a91e9$export$3988ae62b71be9a3)(e(s), n) ?? null;
        },
        setItem (s, a) {
            return (0, $816683f8c32a91e9$export$adaa4cf7ef1b65be)(e(s), a, n);
        },
        removeItem (s) {
            return (0, $816683f8c32a91e9$export$1d2f21e549771e67)(e(s), n);
        },
        getKeys () {
            return (0, $816683f8c32a91e9$export$ed97f33186d4b816)(n);
        },
        clear () {
            return (0, $816683f8c32a91e9$export$42ffd38884aecdac)(n);
        }
    };
};
const $5e575ac853f40acc$var$D = "WALLET_CONNECT_V2_INDEXED_DB", $5e575ac853f40acc$var$E = "keyvaluestorage";
class $5e575ac853f40acc$var$_ {
    constructor(){
        this.indexedDb = (0, $20f36d051f0d8a54$export$d184a47a971dd4b9)({
            driver: $5e575ac853f40acc$var$z({
                dbName: $5e575ac853f40acc$var$D,
                storeName: $5e575ac853f40acc$var$E
            })
        });
    }
    async getKeys() {
        return this.indexedDb.getKeys();
    }
    async getEntries() {
        return (await this.indexedDb.getItems(await this.indexedDb.getKeys())).map((t)=>[
                t.key,
                t.value
            ]);
    }
    async getItem(t) {
        const e = await this.indexedDb.getItem(t);
        if (e !== null) return e;
    }
    async setItem(t, e) {
        await this.indexedDb.setItem(t, (0, $81c2e06d24b89184$export$abc3f407e87918a4)(e));
    }
    async removeItem(t) {
        await this.indexedDb.removeItem(t);
    }
}
var $5e575ac853f40acc$var$l = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {}, $5e575ac853f40acc$var$c = {
    exports: {}
};
(function() {
    let i;
    function t() {}
    i = t, i.prototype.getItem = function(e) {
        return this.hasOwnProperty(e) ? String(this[e]) : null;
    }, i.prototype.setItem = function(e, n) {
        this[e] = String(n);
    }, i.prototype.removeItem = function(e) {
        delete this[e];
    }, i.prototype.clear = function() {
        const e = this;
        Object.keys(e).forEach(function(n) {
            e[n] = void 0, delete e[n];
        });
    }, i.prototype.key = function(e) {
        return e = e || 0, Object.keys(this)[e];
    }, i.prototype.__defineGetter__("length", function() {
        return Object.keys(this).length;
    }), typeof $5e575ac853f40acc$var$l < "u" && $5e575ac853f40acc$var$l.localStorage ? $5e575ac853f40acc$var$c.exports = $5e575ac853f40acc$var$l.localStorage : typeof window < "u" && window.localStorage ? $5e575ac853f40acc$var$c.exports = window.localStorage : $5e575ac853f40acc$var$c.exports = new t;
})();
function $5e575ac853f40acc$var$k(i) {
    var t;
    return [
        i[0],
        (0, $81c2e06d24b89184$export$84137bb44359aed5)((t = i[1]) != null ? t : "")
    ];
}
class $5e575ac853f40acc$var$K {
    constructor(){
        this.localStorage = $5e575ac853f40acc$var$c.exports;
    }
    async getKeys() {
        return Object.keys(this.localStorage);
    }
    async getEntries() {
        return Object.entries(this.localStorage).map($5e575ac853f40acc$var$k);
    }
    async getItem(t) {
        const e = this.localStorage.getItem(t);
        if (e !== null) return (0, $81c2e06d24b89184$export$84137bb44359aed5)(e);
    }
    async setItem(t, e) {
        this.localStorage.setItem(t, (0, $81c2e06d24b89184$export$abc3f407e87918a4)(e));
    }
    async removeItem(t) {
        this.localStorage.removeItem(t);
    }
}
const $5e575ac853f40acc$var$N = "wc_storage_version", $5e575ac853f40acc$var$y = 1, $5e575ac853f40acc$var$O = async (i, t, e)=>{
    const n = $5e575ac853f40acc$var$N, s = await t.getItem(n);
    if (s && s >= $5e575ac853f40acc$var$y) {
        e(t);
        return;
    }
    const a = await i.getKeys();
    if (!a.length) {
        e(t);
        return;
    }
    const m = [];
    for(; a.length;){
        const r = a.shift();
        if (!r) continue;
        const o = r.toLowerCase();
        if (o.includes("wc@") || o.includes("walletconnect") || o.includes("wc_") || o.includes("wallet_connect")) {
            const f = await i.getItem(r);
            await t.setItem(r, f), m.push(r);
        }
    }
    await t.setItem(n, $5e575ac853f40acc$var$y), e(t), $5e575ac853f40acc$var$j(i, m);
}, $5e575ac853f40acc$var$j = async (i, t)=>{
    t.length && t.forEach(async (e)=>{
        await i.removeItem(e);
    });
};
class $5e575ac853f40acc$export$8536778e426ddf92 {
    constructor(){
        this.initialized = !1, this.setInitialized = (e)=>{
            this.storage = e, this.initialized = !0;
        };
        const t = new $5e575ac853f40acc$var$K;
        this.storage = t;
        try {
            const e = new $5e575ac853f40acc$var$_;
            $5e575ac853f40acc$var$O(t, e, this.setInitialized);
        } catch  {
            this.initialized = !0;
        }
    }
    async getKeys() {
        return await this.initialize(), this.storage.getKeys();
    }
    async getEntries() {
        return await this.initialize(), this.storage.getEntries();
    }
    async getItem(t) {
        return await this.initialize(), this.storage.getItem(t);
    }
    async setItem(t, e) {
        return await this.initialize(), this.storage.setItem(t, e);
    }
    async removeItem(t) {
        return await this.initialize(), this.storage.removeItem(t);
    }
    async initialize() {
        this.initialized || await new Promise((t)=>{
            const e = setInterval(()=>{
                this.initialized && (clearInterval(e), t());
            }, 20);
        });
    }
}


var $212993b948b3fe4b$exports = {};
"use strict";
Object.defineProperty($212993b948b3fe4b$exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("48YDT")), $212993b948b3fe4b$exports);

$7WQrb.__exportStar((parcelRequire("5nu18")), $212993b948b3fe4b$exports);

$7WQrb.__exportStar((parcelRequire("1nGZv")), $212993b948b3fe4b$exports);


var $7fc0ce2591a9daef$exports = {};
"use strict";
Object.defineProperty($7fc0ce2591a9daef$exports, "__esModule", {
    value: true
});
$7fc0ce2591a9daef$exports.pino = void 0;

var $7WQrb = parcelRequire("7WQrb");

const $7fc0ce2591a9daef$var$pino_1 = $7WQrb.__importDefault((parcelRequire("kgxrf")));
Object.defineProperty($7fc0ce2591a9daef$exports, "pino", {
    enumerable: true,
    get: function() {
        return $7fc0ce2591a9daef$var$pino_1.default;
    }
});

$7WQrb.__exportStar((parcelRequire("glyO2")), $7fc0ce2591a9daef$exports);

$7WQrb.__exportStar((parcelRequire("cyyD4")), $7fc0ce2591a9daef$exports);


parcelRequire("37EVq");
var $3VSyk = parcelRequire("3VSyk");

var $7etJZ = parcelRequire("7etJZ");
class $bace94c1ef08d1bc$export$ed533416df113881 extends (0, $3VSyk.IEvents) {
    constructor(s){
        super(), this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $bace94c1ef08d1bc$export$a4e7e56f03915894 {
    constructor(s, t, o){
        this.core = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$45b2c2643615b67 extends (0, $3VSyk.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t, this.records = new Map;
    }
}
class $bace94c1ef08d1bc$export$e67570fe0a885c47 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $bace94c1ef08d1bc$export$3b0872bbd7e675a2 extends (0, $3VSyk.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$9a0f755fd4f79434 extends (0, $3VSyk.IEvents) {
    constructor(s){
        super();
    }
}
class $bace94c1ef08d1bc$export$a7f17ba6c54777e7 {
    constructor(s, t, o, M){
        this.core = s, this.logger = t, this.name = o;
    }
}
class $bace94c1ef08d1bc$export$5746ea6dad01660a {
    constructor(){
        this.map = new Map;
    }
}
class $bace94c1ef08d1bc$export$300eed987e764b57 extends (0, $3VSyk.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$be56d986c75c3691 {
    constructor(s, t){
        this.core = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$41aaa3c39f6f2861 extends (0, $3VSyk.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$d6c2d698ffb743f1 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $bace94c1ef08d1bc$export$873b0b865d85ddb6 {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$7db533fb638f979d {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$235ef727e8a26483 extends (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))) {
    constructor(){
        super();
    }
}
class $bace94c1ef08d1bc$export$2ebcf6eeacedad44 {
    constructor(s){
        this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $bace94c1ef08d1bc$export$623dd0f793f15643 extends (0, $7etJZ.EventEmitter) {
    constructor(){
        super();
    }
}
class $bace94c1ef08d1bc$export$87df43c730effa30 {
    constructor(s){
        this.client = s;
    }
}



var $b9995ea5f865dc88$exports = {};
$parcel$export($b9995ea5f865dc88$exports, "generateKeyPair", () => $2281914794d9e636$export$a949d36eab55b41f);
$parcel$export($b9995ea5f865dc88$exports, "signJWT", () => $2281914794d9e636$export$a8dda30659d36d45);
$parcel$export($b9995ea5f865dc88$exports, "encodeIss", () => $f6e90d472e8dfc29$export$1b29ef9371459e10);
var $a1d7ebd43ba0a83c$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($a1d7ebd43ba0a83c$exports, "__esModule", {
    value: true
});
$a1d7ebd43ba0a83c$exports.convertSecretKeyToX25519 = $a1d7ebd43ba0a83c$exports.convertPublicKeyToX25519 = $a1d7ebd43ba0a83c$exports.verify = $a1d7ebd43ba0a83c$exports.sign = $a1d7ebd43ba0a83c$exports.extractPublicKeyFromSecretKey = $a1d7ebd43ba0a83c$exports.generateKeyPair = $a1d7ebd43ba0a83c$exports.generateKeyPairFromSeed = $a1d7ebd43ba0a83c$exports.SEED_LENGTH = $a1d7ebd43ba0a83c$exports.SECRET_KEY_LENGTH = $a1d7ebd43ba0a83c$exports.PUBLIC_KEY_LENGTH = $a1d7ebd43ba0a83c$exports.SIGNATURE_LENGTH = void 0;
var $73945d82524e104e$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($73945d82524e104e$exports, "__esModule", {
    value: true
});
$73945d82524e104e$exports.randomStringForEntropy = $73945d82524e104e$exports.randomString = $73945d82524e104e$exports.randomUint32 = $73945d82524e104e$exports.randomBytes = $73945d82524e104e$exports.defaultRandomSource = void 0;
var $470144fd408ed875$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($470144fd408ed875$exports, "__esModule", {
    value: true
});
$470144fd408ed875$exports.SystemRandomSource = void 0;
var $9ffc14634304d8f4$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($9ffc14634304d8f4$exports, "__esModule", {
    value: true
});
$9ffc14634304d8f4$exports.BrowserRandomSource = void 0;
const $9ffc14634304d8f4$var$QUOTA = 65536;
class $9ffc14634304d8f4$var$BrowserRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        const browserCrypto = typeof self !== "undefined" ? self.crypto || self.msCrypto // IE11 has msCrypto
         : null;
        if (browserCrypto && browserCrypto.getRandomValues !== undefined) {
            this._crypto = browserCrypto;
            this.isAvailable = true;
            this.isInstantiated = true;
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Browser random byte generator is not available.");
        const out = new Uint8Array(length);
        for(let i = 0; i < out.length; i += $9ffc14634304d8f4$var$QUOTA)this._crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, $9ffc14634304d8f4$var$QUOTA)));
        return out;
    }
}
$9ffc14634304d8f4$exports.BrowserRandomSource = $9ffc14634304d8f4$var$BrowserRandomSource;


var $d0085be48b1f2335$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($d0085be48b1f2335$exports, "__esModule", {
    value: true
});
$d0085be48b1f2335$exports.NodeRandomSource = void 0;
var $276678191c4bdb56$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($276678191c4bdb56$exports, "__esModule", {
    value: true
});
/**
 * Sets all values in the given array to zero and returns it.
 *
 * The fact that it sets bytes to zero can be relied on.
 *
 * There is no guarantee that this function makes data disappear from memory,
 * as runtime implementation can, for example, have copying garbage collector
 * that will make copies of sensitive data before we wipe it. Or that an
 * operating system will write our data to swap or sleep image. Another thing
 * is that an optimizing compiler can remove calls to this function or make it
 * no-op. There's nothing we can do with it, so we just do our best and hope
 * that everything will be okay and good will triumph over evil.
 */ function $276678191c4bdb56$var$wipe(array) {
    // Right now it's similar to array.fill(0). If it turns
    // out that runtimes optimize this call away, maybe
    // we can try something else.
    for(var i = 0; i < array.length; i++)array[i] = 0;
    return array;
}
$276678191c4bdb56$exports.wipe = $276678191c4bdb56$var$wipe;



class $d0085be48b1f2335$var$NodeRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        {
            const nodeCrypto = (parcelRequire("kjyEk"));
            if (nodeCrypto && nodeCrypto.randomBytes) {
                this._crypto = nodeCrypto;
                this.isAvailable = true;
                this.isInstantiated = true;
            }
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Node.js random byte generator is not available.");
        // Get random bytes (result is Buffer).
        let buffer = this._crypto.randomBytes(length);
        // Make sure we got the length that we requested.
        if (buffer.length !== length) throw new Error("NodeRandomSource: got fewer bytes than requested");
        // Allocate output array.
        const out = new Uint8Array(length);
        // Copy bytes from buffer to output.
        for(let i = 0; i < out.length; i++)out[i] = buffer[i];
        // Cleanup.
        (0, $276678191c4bdb56$exports.wipe)(buffer);
        return out;
    }
}
$d0085be48b1f2335$exports.NodeRandomSource = $d0085be48b1f2335$var$NodeRandomSource;


class $470144fd408ed875$var$SystemRandomSource {
    constructor(){
        this.isAvailable = false;
        this.name = "";
        // Try browser.
        this._source = new $9ffc14634304d8f4$exports.BrowserRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Browser";
            return;
        }
        // If no browser source, try Node.
        this._source = new $d0085be48b1f2335$exports.NodeRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Node";
            return;
        }
    // No sources, we're out of options.
    }
    randomBytes(length) {
        if (!this.isAvailable) throw new Error("System random byte generator is not available.");
        return this._source.randomBytes(length);
    }
}
$470144fd408ed875$exports.SystemRandomSource = $470144fd408ed875$var$SystemRandomSource;


var $ddd89ca0ca71c6d3$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($ddd89ca0ca71c6d3$exports, "__esModule", {
    value: true
});
var $51a3ca76628cc201$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($51a3ca76628cc201$exports, "__esModule", {
    value: true
});
/**
 * Package int provides helper functions for integerss.
 */ // Shim using 16-bit pieces.
function $51a3ca76628cc201$var$imulShim(a, b) {
    var ah = a >>> 16 & 0xffff, al = a & 0xffff;
    var bh = b >>> 16 & 0xffff, bl = b & 0xffff;
    return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
}
/** 32-bit integer multiplication.  */ // Use system Math.imul if available, otherwise use our shim.
$51a3ca76628cc201$exports.mul = Math.imul || $51a3ca76628cc201$var$imulShim;
/** 32-bit integer addition.  */ function $51a3ca76628cc201$var$add(a, b) {
    return a + b | 0;
}
$51a3ca76628cc201$exports.add = $51a3ca76628cc201$var$add;
/**  32-bit integer subtraction.  */ function $51a3ca76628cc201$var$sub(a, b) {
    return a - b | 0;
}
$51a3ca76628cc201$exports.sub = $51a3ca76628cc201$var$sub;
/** 32-bit integer left rotation */ function $51a3ca76628cc201$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
$51a3ca76628cc201$exports.rotl = $51a3ca76628cc201$var$rotl;
/** 32-bit integer left rotation */ function $51a3ca76628cc201$var$rotr(x, n) {
    return x << 32 - n | x >>> n;
}
$51a3ca76628cc201$exports.rotr = $51a3ca76628cc201$var$rotr;
function $51a3ca76628cc201$var$isIntegerShim(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
}
/**
 * Returns true if the argument is an integer number.
 *
 * In ES2015, Number.isInteger.
 */ $51a3ca76628cc201$exports.isInteger = Number.isInteger || $51a3ca76628cc201$var$isIntegerShim;
/**
 *  Math.pow(2, 53) - 1
 *
 *  In ES2015 Number.MAX_SAFE_INTEGER.
 */ $51a3ca76628cc201$exports.MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Returns true if the argument is a safe integer number
 * (-MIN_SAFE_INTEGER < number <= MAX_SAFE_INTEGER)
 *
 * In ES2015, Number.isSafeInteger.
 */ $51a3ca76628cc201$exports.isSafeInteger = function(n) {
    return $51a3ca76628cc201$exports.isInteger(n) && n >= -$51a3ca76628cc201$exports.MAX_SAFE_INTEGER && n <= $51a3ca76628cc201$exports.MAX_SAFE_INTEGER;
};


// TODO(dchest): add asserts for correct value ranges and array offsets.
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * signed 16-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readInt16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) << 16 >> 16;
}
$ddd89ca0ca71c6d3$exports.readInt16BE = $ddd89ca0ca71c6d3$var$readInt16BE;
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * unsigned 16-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readUint16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) >>> 0;
}
$ddd89ca0ca71c6d3$exports.readUint16BE = $ddd89ca0ca71c6d3$var$readUint16BE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * signed 16-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readInt16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) << 16 >> 16;
}
$ddd89ca0ca71c6d3$exports.readInt16LE = $ddd89ca0ca71c6d3$var$readInt16LE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * unsigned 16-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readUint16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) >>> 0;
}
$ddd89ca0ca71c6d3$exports.readUint16LE = $ddd89ca0ca71c6d3$var$readUint16LE;
/**
 * Writes 2-byte big-endian representation of 16-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint16BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 8;
    out[offset + 1] = value >>> 0;
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUint16BE = $ddd89ca0ca71c6d3$var$writeUint16BE;
$ddd89ca0ca71c6d3$exports.writeInt16BE = $ddd89ca0ca71c6d3$var$writeUint16BE;
/**
 * Writes 2-byte little-endian representation of 16-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint16LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUint16LE = $ddd89ca0ca71c6d3$var$writeUint16LE;
$ddd89ca0ca71c6d3$exports.writeInt16LE = $ddd89ca0ca71c6d3$var$writeUint16LE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * signed 32-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readInt32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3];
}
$ddd89ca0ca71c6d3$exports.readInt32BE = $ddd89ca0ca71c6d3$var$readInt32BE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * unsigned 32-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readUint32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3]) >>> 0;
}
$ddd89ca0ca71c6d3$exports.readUint32BE = $ddd89ca0ca71c6d3$var$readUint32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * signed 32-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readInt32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset];
}
$ddd89ca0ca71c6d3$exports.readInt32LE = $ddd89ca0ca71c6d3$var$readInt32LE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * unsigned 32-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readUint32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset]) >>> 0;
}
$ddd89ca0ca71c6d3$exports.readUint32LE = $ddd89ca0ca71c6d3$var$readUint32LE;
/**
 * Writes 4-byte big-endian representation of 32-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 24;
    out[offset + 1] = value >>> 16;
    out[offset + 2] = value >>> 8;
    out[offset + 3] = value >>> 0;
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUint32BE = $ddd89ca0ca71c6d3$var$writeUint32BE;
$ddd89ca0ca71c6d3$exports.writeInt32BE = $ddd89ca0ca71c6d3$var$writeUint32BE;
/**
 * Writes 4-byte little-endian representation of 32-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    out[offset + 2] = value >>> 16;
    out[offset + 3] = value >>> 24;
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUint32LE = $ddd89ca0ca71c6d3$var$writeUint32LE;
$ddd89ca0ca71c6d3$exports.writeInt32LE = $ddd89ca0ca71c6d3$var$writeUint32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $ddd89ca0ca71c6d3$var$readInt64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $ddd89ca0ca71c6d3$var$readInt32BE(array, offset);
    var lo = $ddd89ca0ca71c6d3$var$readInt32BE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
$ddd89ca0ca71c6d3$exports.readInt64BE = $ddd89ca0ca71c6d3$var$readInt64BE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $ddd89ca0ca71c6d3$var$readUint64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $ddd89ca0ca71c6d3$var$readUint32BE(array, offset);
    var lo = $ddd89ca0ca71c6d3$var$readUint32BE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
$ddd89ca0ca71c6d3$exports.readUint64BE = $ddd89ca0ca71c6d3$var$readUint64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $ddd89ca0ca71c6d3$var$readInt64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $ddd89ca0ca71c6d3$var$readInt32LE(array, offset);
    var hi = $ddd89ca0ca71c6d3$var$readInt32LE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
$ddd89ca0ca71c6d3$exports.readInt64LE = $ddd89ca0ca71c6d3$var$readInt64LE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $ddd89ca0ca71c6d3$var$readUint64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $ddd89ca0ca71c6d3$var$readUint32LE(array, offset);
    var hi = $ddd89ca0ca71c6d3$var$readUint32LE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
$ddd89ca0ca71c6d3$exports.readUint64LE = $ddd89ca0ca71c6d3$var$readUint64LE;
/**
 * Writes 8-byte big-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $ddd89ca0ca71c6d3$var$writeUint32BE(value / 0x100000000 >>> 0, out, offset);
    $ddd89ca0ca71c6d3$var$writeUint32BE(value >>> 0, out, offset + 4);
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUint64BE = $ddd89ca0ca71c6d3$var$writeUint64BE;
$ddd89ca0ca71c6d3$exports.writeInt64BE = $ddd89ca0ca71c6d3$var$writeUint64BE;
/**
 * Writes 8-byte little-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $ddd89ca0ca71c6d3$var$writeUint32LE(value >>> 0, out, offset);
    $ddd89ca0ca71c6d3$var$writeUint32LE(value / 0x100000000 >>> 0, out, offset + 4);
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUint64LE = $ddd89ca0ca71c6d3$var$writeUint64LE;
$ddd89ca0ca71c6d3$exports.writeInt64LE = $ddd89ca0ca71c6d3$var$writeUint64LE;
/**
 * Reads bytes from array starting at offset as big-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $ddd89ca0ca71c6d3$var$readUintBE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintBE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintBE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
$ddd89ca0ca71c6d3$exports.readUintBE = $ddd89ca0ca71c6d3$var$readUintBE;
/**
 * Reads bytes from array starting at offset as little-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $ddd89ca0ca71c6d3$var$readUintLE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintLE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintLE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
$ddd89ca0ca71c6d3$exports.readUintLE = $ddd89ca0ca71c6d3$var$readUintLE;
/**
 * Writes a big-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUintBE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintBE supports only bitLengths divisible by 8");
    if (!$51a3ca76628cc201$exports.isSafeInteger(value)) throw new Error("writeUintBE value must be an integer");
    var div = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUintBE = $ddd89ca0ca71c6d3$var$writeUintBE;
/**
 * Writes a little-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUintLE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintLE supports only bitLengths divisible by 8");
    if (!$51a3ca76628cc201$exports.isSafeInteger(value)) throw new Error("writeUintLE value must be an integer");
    var div = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUintLE = $ddd89ca0ca71c6d3$var$writeUintLE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * 32-bit floating-point number and returns it.
 */ function $ddd89ca0ca71c6d3$var$readFloat32BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset);
}
$ddd89ca0ca71c6d3$exports.readFloat32BE = $ddd89ca0ca71c6d3$var$readFloat32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * 32-bit floating-point number and returns it.
 */ function $ddd89ca0ca71c6d3$var$readFloat32LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset, true);
}
$ddd89ca0ca71c6d3$exports.readFloat32LE = $ddd89ca0ca71c6d3$var$readFloat32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $ddd89ca0ca71c6d3$var$readFloat64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset);
}
$ddd89ca0ca71c6d3$exports.readFloat64BE = $ddd89ca0ca71c6d3$var$readFloat64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $ddd89ca0ca71c6d3$var$readFloat64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset, true);
}
$ddd89ca0ca71c6d3$exports.readFloat64LE = $ddd89ca0ca71c6d3$var$readFloat64LE;
/**
 * Writes 4-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeFloat32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value);
    return out;
}
$ddd89ca0ca71c6d3$exports.writeFloat32BE = $ddd89ca0ca71c6d3$var$writeFloat32BE;
/**
 * Writes 4-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeFloat32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value, true);
    return out;
}
$ddd89ca0ca71c6d3$exports.writeFloat32LE = $ddd89ca0ca71c6d3$var$writeFloat32LE;
/**
 * Writes 8-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeFloat64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value);
    return out;
}
$ddd89ca0ca71c6d3$exports.writeFloat64BE = $ddd89ca0ca71c6d3$var$writeFloat64BE;
/**
 * Writes 8-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeFloat64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value, true);
    return out;
}
$ddd89ca0ca71c6d3$exports.writeFloat64LE = $ddd89ca0ca71c6d3$var$writeFloat64LE;



$73945d82524e104e$exports.defaultRandomSource = new $470144fd408ed875$exports.SystemRandomSource();
function $73945d82524e104e$var$randomBytes(length, prng = $73945d82524e104e$exports.defaultRandomSource) {
    return prng.randomBytes(length);
}
$73945d82524e104e$exports.randomBytes = $73945d82524e104e$var$randomBytes;
/**
 * Returns a uniformly random unsigned 32-bit integer.
 */ function $73945d82524e104e$var$randomUint32(prng = $73945d82524e104e$exports.defaultRandomSource) {
    // Generate 4-byte random buffer.
    const buf = $73945d82524e104e$var$randomBytes(4, prng);
    // Convert bytes from buffer into a 32-bit integer.
    // It's not important which byte order to use, since
    // the result is random.
    const result = (0, $ddd89ca0ca71c6d3$exports.readUint32LE)(buf);
    // Clean the buffer.
    (0, $276678191c4bdb56$exports.wipe)(buf);
    return result;
}
$73945d82524e104e$exports.randomUint32 = $73945d82524e104e$var$randomUint32;
/** 62 alphanumeric characters for default charset of randomString() */ const $73945d82524e104e$var$ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
/**
 * Returns a uniform random string of the given length
 * with characters from the given charset.
 *
 * Charset must not have more than 256 characters.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $73945d82524e104e$var$randomString(length, charset = $73945d82524e104e$var$ALPHANUMERIC, prng = $73945d82524e104e$exports.defaultRandomSource) {
    if (charset.length < 2) throw new Error("randomString charset is too short");
    if (charset.length > 256) throw new Error("randomString charset is too long");
    let out = "";
    const charsLen = charset.length;
    const maxByte = 256 - 256 % charsLen;
    while(length > 0){
        const buf = $73945d82524e104e$var$randomBytes(Math.ceil(length * 256 / maxByte), prng);
        for(let i = 0; i < buf.length && length > 0; i++){
            const randomByte = buf[i];
            if (randomByte < maxByte) {
                out += charset.charAt(randomByte % charsLen);
                length--;
            }
        }
        (0, $276678191c4bdb56$exports.wipe)(buf);
    }
    return out;
}
$73945d82524e104e$exports.randomString = $73945d82524e104e$var$randomString;
/**
 * Returns uniform random string containing at least the given
 * number of bits of entropy.
 *
 * For example, randomStringForEntropy(128) will return a 22-character
 * alphanumeric string, while randomStringForEntropy(128, "0123456789")
 * will return a 39-character numeric string, both will contain at
 * least 128 bits of entropy.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $73945d82524e104e$var$randomStringForEntropy(bits, charset = $73945d82524e104e$var$ALPHANUMERIC, prng = $73945d82524e104e$exports.defaultRandomSource) {
    const length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
    return $73945d82524e104e$var$randomString(length, charset, prng);
}
$73945d82524e104e$exports.randomStringForEntropy = $73945d82524e104e$var$randomStringForEntropy;


var $2cc6b12a8ccb780d$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($2cc6b12a8ccb780d$exports, "__esModule", {
    value: true
});


$2cc6b12a8ccb780d$exports.DIGEST_LENGTH = 64;
$2cc6b12a8ccb780d$exports.BLOCK_SIZE = 128;
/**
 * SHA-2-512 cryptographic hash algorithm.
 */ var $2cc6b12a8ccb780d$var$SHA512 = /** @class */ function() {
    function SHA512() {
        /** Length of hash output */ this.digestLength = $2cc6b12a8ccb780d$exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = $2cc6b12a8ccb780d$exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._stateHi = new Int32Array(8); // hash state, high bytes
        this._stateLo = new Int32Array(8); // hash state, low bytes
        this._tempHi = new Int32Array(16); // temporary state, high bytes
        this._tempLo = new Int32Array(16); // temporary state, low bytes
        this._buffer = new Uint8Array(256); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA512.prototype._initState = function() {
        this._stateHi[0] = 0x6a09e667;
        this._stateHi[1] = 0xbb67ae85;
        this._stateHi[2] = 0x3c6ef372;
        this._stateHi[3] = 0xa54ff53a;
        this._stateHi[4] = 0x510e527f;
        this._stateHi[5] = 0x9b05688c;
        this._stateHi[6] = 0x1f83d9ab;
        this._stateHi[7] = 0x5be0cd19;
        this._stateLo[0] = 0xf3bcc908;
        this._stateLo[1] = 0x84caa73b;
        this._stateLo[2] = 0xfe94f82b;
        this._stateLo[3] = 0x5f1d36f1;
        this._stateLo[4] = 0xade682d1;
        this._stateLo[5] = 0x2b3e6c1f;
        this._stateLo[6] = 0xfb41bd6b;
        this._stateLo[7] = 0x137e2179;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA512.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA512.prototype.clean = function() {
        $276678191c4bdb56$exports.wipe(this._buffer);
        $276678191c4bdb56$exports.wipe(this._tempHi);
        $276678191c4bdb56$exports.wipe(this._tempLo);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA512.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA512: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < $2cc6b12a8ccb780d$exports.BLOCK_SIZE && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $2cc6b12a8ccb780d$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $2cc6b12a8ccb780d$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA512.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 128 < 112 ? 128 : 256;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $ddd89ca0ca71c6d3$exports.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $ddd89ca0ca71c6d3$exports.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $2cc6b12a8ccb780d$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 8; i++){
            $ddd89ca0ca71c6d3$exports.writeUint32BE(this._stateHi[i], out, i * 8);
            $ddd89ca0ca71c6d3$exports.writeUint32BE(this._stateLo[i], out, i * 8 + 4);
        }
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA512.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Returns hash state to be
     * used with restoreState(). Only chain value is saved, not buffers or
     * other state variables.
     */ SHA512.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            stateHi: new Int32Array(this._stateHi),
            stateLo: new Int32Array(this._stateLo),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Restores state saved by
     * saveState() and sets bytesHashed to the given value.
     */ SHA512.prototype.restoreState = function(savedState) {
        this._stateHi.set(savedState.stateHi);
        this._stateLo.set(savedState.stateLo);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA512.prototype.cleanSavedState = function(savedState) {
        $276678191c4bdb56$exports.wipe(savedState.stateHi);
        $276678191c4bdb56$exports.wipe(savedState.stateLo);
        if (savedState.buffer) $276678191c4bdb56$exports.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA512;
}();
$2cc6b12a8ccb780d$exports.SHA512 = $2cc6b12a8ccb780d$var$SHA512;
// Constants
var $2cc6b12a8ccb780d$var$K = new Int32Array([
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
]);
function $2cc6b12a8ccb780d$var$hashBlocks(wh, wl, hh, hl, m, pos, len) {
    var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
    var h, l;
    var th, tl;
    var a, b, c, d;
    while(len >= 128){
        for(var i = 0; i < 16; i++){
            var j = 8 * i + pos;
            wh[i] = $ddd89ca0ca71c6d3$exports.readUint32BE(m, j);
            wl[i] = $ddd89ca0ca71c6d3$exports.readUint32BE(m, j + 4);
        }
        for(var i = 0; i < 80; i++){
            var bh0 = ah0;
            var bh1 = ah1;
            var bh2 = ah2;
            var bh3 = ah3;
            var bh4 = ah4;
            var bh5 = ah5;
            var bh6 = ah6;
            var bh7 = ah7;
            var bl0 = al0;
            var bl1 = al1;
            var bl2 = al2;
            var bl3 = al3;
            var bl4 = al4;
            var bl5 = al5;
            var bl6 = al6;
            var bl7 = al7;
            // add
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma1
            h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
            l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Ch
            h = ah4 & ah5 ^ ~ah4 & ah6;
            l = al4 & al5 ^ ~al4 & al6;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // K
            h = $2cc6b12a8ccb780d$var$K[i * 2];
            l = $2cc6b12a8ccb780d$var$K[i * 2 + 1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // w
            h = wh[i % 16];
            l = wl[i % 16];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            th = c & 0xffff | d << 16;
            tl = a & 0xffff | b << 16;
            // add
            h = th;
            l = tl;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma0
            h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
            l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Maj
            h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
            l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh7 = c & 0xffff | d << 16;
            bl7 = a & 0xffff | b << 16;
            // add
            h = bh3;
            l = bl3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = th;
            l = tl;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh3 = c & 0xffff | d << 16;
            bl3 = a & 0xffff | b << 16;
            ah1 = bh0;
            ah2 = bh1;
            ah3 = bh2;
            ah4 = bh3;
            ah5 = bh4;
            ah6 = bh5;
            ah7 = bh6;
            ah0 = bh7;
            al1 = bl0;
            al2 = bl1;
            al3 = bl2;
            al4 = bl3;
            al5 = bl4;
            al6 = bl5;
            al7 = bl6;
            al0 = bl7;
            if (i % 16 === 15) for(var j = 0; j < 16; j++){
                // add
                h = wh[j];
                l = wl[j];
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = wh[(j + 9) % 16];
                l = wl[(j + 9) % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma0
                th = wh[(j + 1) % 16];
                tl = wl[(j + 1) % 16];
                h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma1
                th = wh[(j + 14) % 16];
                tl = wl[(j + 14) % 16];
                h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                wh[j] = c & 0xffff | d << 16;
                wl[j] = a & 0xffff | b << 16;
            }
        }
        // add
        h = ah0;
        l = al0;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[0];
        l = hl[0];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[0] = ah0 = c & 0xffff | d << 16;
        hl[0] = al0 = a & 0xffff | b << 16;
        h = ah1;
        l = al1;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[1];
        l = hl[1];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[1] = ah1 = c & 0xffff | d << 16;
        hl[1] = al1 = a & 0xffff | b << 16;
        h = ah2;
        l = al2;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[2];
        l = hl[2];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[2] = ah2 = c & 0xffff | d << 16;
        hl[2] = al2 = a & 0xffff | b << 16;
        h = ah3;
        l = al3;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[3];
        l = hl[3];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[3] = ah3 = c & 0xffff | d << 16;
        hl[3] = al3 = a & 0xffff | b << 16;
        h = ah4;
        l = al4;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[4];
        l = hl[4];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[4] = ah4 = c & 0xffff | d << 16;
        hl[4] = al4 = a & 0xffff | b << 16;
        h = ah5;
        l = al5;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[5];
        l = hl[5];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[5] = ah5 = c & 0xffff | d << 16;
        hl[5] = al5 = a & 0xffff | b << 16;
        h = ah6;
        l = al6;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[6];
        l = hl[6];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[6] = ah6 = c & 0xffff | d << 16;
        hl[6] = al6 = a & 0xffff | b << 16;
        h = ah7;
        l = al7;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[7];
        l = hl[7];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[7] = ah7 = c & 0xffff | d << 16;
        hl[7] = al7 = a & 0xffff | b << 16;
        pos += 128;
        len -= 128;
    }
    return pos;
}
function $2cc6b12a8ccb780d$var$hash(data) {
    var h = new $2cc6b12a8ccb780d$var$SHA512();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$2cc6b12a8ccb780d$exports.hash = $2cc6b12a8ccb780d$var$hash;



$a1d7ebd43ba0a83c$exports.SIGNATURE_LENGTH = 64;
$a1d7ebd43ba0a83c$exports.PUBLIC_KEY_LENGTH = 32;
$a1d7ebd43ba0a83c$exports.SECRET_KEY_LENGTH = 64;
$a1d7ebd43ba0a83c$exports.SEED_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $a1d7ebd43ba0a83c$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $a1d7ebd43ba0a83c$var$_9 = new Uint8Array(32);
$a1d7ebd43ba0a83c$var$_9[0] = 9;
const $a1d7ebd43ba0a83c$var$gf0 = $a1d7ebd43ba0a83c$var$gf();
const $a1d7ebd43ba0a83c$var$gf1 = $a1d7ebd43ba0a83c$var$gf([
    1
]);
const $a1d7ebd43ba0a83c$var$D = $a1d7ebd43ba0a83c$var$gf([
    0x78a3,
    0x1359,
    0x4dca,
    0x75eb,
    0xd8ab,
    0x4141,
    0x0a4d,
    0x0070,
    0xe898,
    0x7779,
    0x4079,
    0x8cc7,
    0xfe73,
    0x2b6f,
    0x6cee,
    0x5203
]);
const $a1d7ebd43ba0a83c$var$D2 = $a1d7ebd43ba0a83c$var$gf([
    0xf159,
    0x26b2,
    0x9b94,
    0xebd6,
    0xb156,
    0x8283,
    0x149a,
    0x00e0,
    0xd130,
    0xeef3,
    0x80f2,
    0x198e,
    0xfce7,
    0x56df,
    0xd9dc,
    0x2406
]);
const $a1d7ebd43ba0a83c$var$X = $a1d7ebd43ba0a83c$var$gf([
    0xd51a,
    0x8f25,
    0x2d60,
    0xc956,
    0xa7b2,
    0x9525,
    0xc760,
    0x692c,
    0xdc5c,
    0xfdd6,
    0xe231,
    0xc0a4,
    0x53fe,
    0xcd6e,
    0x36d3,
    0x2169
]);
const $a1d7ebd43ba0a83c$var$Y = $a1d7ebd43ba0a83c$var$gf([
    0x6658,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666
]);
const $a1d7ebd43ba0a83c$var$I = $a1d7ebd43ba0a83c$var$gf([
    0xa0b0,
    0x4a0e,
    0x1b27,
    0xc4ee,
    0xe478,
    0xad2f,
    0x1806,
    0x2f43,
    0xd7a7,
    0x3dfb,
    0x0099,
    0x2b4d,
    0xdf0b,
    0x4fc1,
    0x2480,
    0x2b83
]);
function $a1d7ebd43ba0a83c$var$set25519(r, a) {
    for(let i = 0; i < 16; i++)r[i] = a[i] | 0;
}
function $a1d7ebd43ba0a83c$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $a1d7ebd43ba0a83c$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $a1d7ebd43ba0a83c$var$pack25519(o, n) {
    const m = $a1d7ebd43ba0a83c$var$gf();
    const t = $a1d7ebd43ba0a83c$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $a1d7ebd43ba0a83c$var$car25519(t);
    $a1d7ebd43ba0a83c$var$car25519(t);
    $a1d7ebd43ba0a83c$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $a1d7ebd43ba0a83c$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $a1d7ebd43ba0a83c$var$verify32(x, y) {
    let d = 0;
    for(let i = 0; i < 32; i++)d |= x[i] ^ y[i];
    return (1 & d - 1 >>> 8) - 1;
}
function $a1d7ebd43ba0a83c$var$neq25519(a, b) {
    const c = new Uint8Array(32);
    const d = new Uint8Array(32);
    $a1d7ebd43ba0a83c$var$pack25519(c, a);
    $a1d7ebd43ba0a83c$var$pack25519(d, b);
    return $a1d7ebd43ba0a83c$var$verify32(c, d);
}
function $a1d7ebd43ba0a83c$var$par25519(a) {
    const d = new Uint8Array(32);
    $a1d7ebd43ba0a83c$var$pack25519(d, a);
    return d[0] & 1;
}
function $a1d7ebd43ba0a83c$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $a1d7ebd43ba0a83c$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $a1d7ebd43ba0a83c$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $a1d7ebd43ba0a83c$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $a1d7ebd43ba0a83c$var$square(o, a) {
    $a1d7ebd43ba0a83c$var$mul(o, a, a);
}
function $a1d7ebd43ba0a83c$var$inv25519(o, i) {
    const c = $a1d7ebd43ba0a83c$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 253; a >= 0; a--){
        $a1d7ebd43ba0a83c$var$square(c, c);
        if (a !== 2 && a !== 4) $a1d7ebd43ba0a83c$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $a1d7ebd43ba0a83c$var$pow2523(o, i) {
    const c = $a1d7ebd43ba0a83c$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 250; a >= 0; a--){
        $a1d7ebd43ba0a83c$var$square(c, c);
        if (a !== 1) $a1d7ebd43ba0a83c$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $a1d7ebd43ba0a83c$var$edadd(p, q) {
    const a = $a1d7ebd43ba0a83c$var$gf(), b = $a1d7ebd43ba0a83c$var$gf(), c = $a1d7ebd43ba0a83c$var$gf(), d = $a1d7ebd43ba0a83c$var$gf(), e = $a1d7ebd43ba0a83c$var$gf(), f = $a1d7ebd43ba0a83c$var$gf(), g = $a1d7ebd43ba0a83c$var$gf(), h = $a1d7ebd43ba0a83c$var$gf(), t = $a1d7ebd43ba0a83c$var$gf();
    $a1d7ebd43ba0a83c$var$sub(a, p[1], p[0]);
    $a1d7ebd43ba0a83c$var$sub(t, q[1], q[0]);
    $a1d7ebd43ba0a83c$var$mul(a, a, t);
    $a1d7ebd43ba0a83c$var$add(b, p[0], p[1]);
    $a1d7ebd43ba0a83c$var$add(t, q[0], q[1]);
    $a1d7ebd43ba0a83c$var$mul(b, b, t);
    $a1d7ebd43ba0a83c$var$mul(c, p[3], q[3]);
    $a1d7ebd43ba0a83c$var$mul(c, c, $a1d7ebd43ba0a83c$var$D2);
    $a1d7ebd43ba0a83c$var$mul(d, p[2], q[2]);
    $a1d7ebd43ba0a83c$var$add(d, d, d);
    $a1d7ebd43ba0a83c$var$sub(e, b, a);
    $a1d7ebd43ba0a83c$var$sub(f, d, c);
    $a1d7ebd43ba0a83c$var$add(g, d, c);
    $a1d7ebd43ba0a83c$var$add(h, b, a);
    $a1d7ebd43ba0a83c$var$mul(p[0], e, f);
    $a1d7ebd43ba0a83c$var$mul(p[1], h, g);
    $a1d7ebd43ba0a83c$var$mul(p[2], g, f);
    $a1d7ebd43ba0a83c$var$mul(p[3], e, h);
}
function $a1d7ebd43ba0a83c$var$cswap(p, q, b) {
    for(let i = 0; i < 4; i++)$a1d7ebd43ba0a83c$var$sel25519(p[i], q[i], b);
}
function $a1d7ebd43ba0a83c$var$pack(r, p) {
    const tx = $a1d7ebd43ba0a83c$var$gf(), ty = $a1d7ebd43ba0a83c$var$gf(), zi = $a1d7ebd43ba0a83c$var$gf();
    $a1d7ebd43ba0a83c$var$inv25519(zi, p[2]);
    $a1d7ebd43ba0a83c$var$mul(tx, p[0], zi);
    $a1d7ebd43ba0a83c$var$mul(ty, p[1], zi);
    $a1d7ebd43ba0a83c$var$pack25519(r, ty);
    r[31] ^= $a1d7ebd43ba0a83c$var$par25519(tx) << 7;
}
function $a1d7ebd43ba0a83c$var$scalarmult(p, q, s) {
    $a1d7ebd43ba0a83c$var$set25519(p[0], $a1d7ebd43ba0a83c$var$gf0);
    $a1d7ebd43ba0a83c$var$set25519(p[1], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$set25519(p[2], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$set25519(p[3], $a1d7ebd43ba0a83c$var$gf0);
    for(let i = 255; i >= 0; --i){
        const b = s[i / 8 | 0] >> (i & 7) & 1;
        $a1d7ebd43ba0a83c$var$cswap(p, q, b);
        $a1d7ebd43ba0a83c$var$edadd(q, p);
        $a1d7ebd43ba0a83c$var$edadd(p, p);
        $a1d7ebd43ba0a83c$var$cswap(p, q, b);
    }
}
function $a1d7ebd43ba0a83c$var$scalarbase(p, s) {
    const q = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    $a1d7ebd43ba0a83c$var$set25519(q[0], $a1d7ebd43ba0a83c$var$X);
    $a1d7ebd43ba0a83c$var$set25519(q[1], $a1d7ebd43ba0a83c$var$Y);
    $a1d7ebd43ba0a83c$var$set25519(q[2], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$mul(q[3], $a1d7ebd43ba0a83c$var$X, $a1d7ebd43ba0a83c$var$Y);
    $a1d7ebd43ba0a83c$var$scalarmult(p, q, s);
}
// Generates key pair from secret 32-byte seed.
function $a1d7ebd43ba0a83c$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== $a1d7ebd43ba0a83c$exports.SEED_LENGTH) throw new Error(`ed25519: seed must be ${$a1d7ebd43ba0a83c$exports.SEED_LENGTH} bytes`);
    const d = (0, $2cc6b12a8ccb780d$exports.hash)(seed);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const publicKey = new Uint8Array(32);
    const p = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    $a1d7ebd43ba0a83c$var$scalarbase(p, d);
    $a1d7ebd43ba0a83c$var$pack(publicKey, p);
    const secretKey = new Uint8Array(64);
    secretKey.set(seed);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
$a1d7ebd43ba0a83c$exports.generateKeyPairFromSeed = $a1d7ebd43ba0a83c$var$generateKeyPairFromSeed;
function $a1d7ebd43ba0a83c$var$generateKeyPair(prng) {
    const seed = (0, $73945d82524e104e$exports.randomBytes)(32, prng);
    const result = $a1d7ebd43ba0a83c$var$generateKeyPairFromSeed(seed);
    (0, $276678191c4bdb56$exports.wipe)(seed);
    return result;
}
$a1d7ebd43ba0a83c$exports.generateKeyPair = $a1d7ebd43ba0a83c$var$generateKeyPair;
function $a1d7ebd43ba0a83c$var$extractPublicKeyFromSecretKey(secretKey) {
    if (secretKey.length !== $a1d7ebd43ba0a83c$exports.SECRET_KEY_LENGTH) throw new Error(`ed25519: secret key must be ${$a1d7ebd43ba0a83c$exports.SECRET_KEY_LENGTH} bytes`);
    return new Uint8Array(secretKey.subarray(32));
}
$a1d7ebd43ba0a83c$exports.extractPublicKeyFromSecretKey = $a1d7ebd43ba0a83c$var$extractPublicKeyFromSecretKey;
const $a1d7ebd43ba0a83c$var$L = new Float64Array([
    0xed,
    0xd3,
    0xf5,
    0x5c,
    0x1a,
    0x63,
    0x12,
    0x58,
    0xd6,
    0x9c,
    0xf7,
    0xa2,
    0xde,
    0xf9,
    0xde,
    0x14,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0x10
]);
function $a1d7ebd43ba0a83c$var$modL(r, x) {
    let carry;
    let i;
    let j;
    let k;
    for(i = 63; i >= 32; --i){
        carry = 0;
        for(j = i - 32, k = i - 12; j < k; ++j){
            x[j] += carry - 16 * x[i] * $a1d7ebd43ba0a83c$var$L[j - (i - 32)];
            carry = Math.floor((x[j] + 128) / 256);
            x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
    }
    carry = 0;
    for(j = 0; j < 32; j++){
        x[j] += carry - (x[31] >> 4) * $a1d7ebd43ba0a83c$var$L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
    }
    for(j = 0; j < 32; j++)x[j] -= carry * $a1d7ebd43ba0a83c$var$L[j];
    for(i = 0; i < 32; i++){
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
    }
}
function $a1d7ebd43ba0a83c$var$reduce(r) {
    const x = new Float64Array(64);
    for(let i = 0; i < 64; i++)x[i] = r[i];
    for(let i = 0; i < 64; i++)r[i] = 0;
    $a1d7ebd43ba0a83c$var$modL(r, x);
}
// Returns 64-byte signature of the message under the 64-byte secret key.
function $a1d7ebd43ba0a83c$var$sign(secretKey, message) {
    const x = new Float64Array(64);
    const p = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    const d = (0, $2cc6b12a8ccb780d$exports.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const signature = new Uint8Array(64);
    signature.set(d.subarray(32), 32);
    const hs = new $2cc6b12a8ccb780d$exports.SHA512();
    hs.update(signature.subarray(32));
    hs.update(message);
    const r = hs.digest();
    hs.clean();
    $a1d7ebd43ba0a83c$var$reduce(r);
    $a1d7ebd43ba0a83c$var$scalarbase(p, r);
    $a1d7ebd43ba0a83c$var$pack(signature, p);
    hs.reset();
    hs.update(signature.subarray(0, 32));
    hs.update(secretKey.subarray(32));
    hs.update(message);
    const h = hs.digest();
    $a1d7ebd43ba0a83c$var$reduce(h);
    for(let i = 0; i < 32; i++)x[i] = r[i];
    for(let i = 0; i < 32; i++)for(let j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
    $a1d7ebd43ba0a83c$var$modL(signature.subarray(32), x);
    return signature;
}
$a1d7ebd43ba0a83c$exports.sign = $a1d7ebd43ba0a83c$var$sign;
function $a1d7ebd43ba0a83c$var$unpackneg(r, p) {
    const t = $a1d7ebd43ba0a83c$var$gf(), chk = $a1d7ebd43ba0a83c$var$gf(), num = $a1d7ebd43ba0a83c$var$gf(), den = $a1d7ebd43ba0a83c$var$gf(), den2 = $a1d7ebd43ba0a83c$var$gf(), den4 = $a1d7ebd43ba0a83c$var$gf(), den6 = $a1d7ebd43ba0a83c$var$gf();
    $a1d7ebd43ba0a83c$var$set25519(r[2], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$unpack25519(r[1], p);
    $a1d7ebd43ba0a83c$var$square(num, r[1]);
    $a1d7ebd43ba0a83c$var$mul(den, num, $a1d7ebd43ba0a83c$var$D);
    $a1d7ebd43ba0a83c$var$sub(num, num, r[2]);
    $a1d7ebd43ba0a83c$var$add(den, r[2], den);
    $a1d7ebd43ba0a83c$var$square(den2, den);
    $a1d7ebd43ba0a83c$var$square(den4, den2);
    $a1d7ebd43ba0a83c$var$mul(den6, den4, den2);
    $a1d7ebd43ba0a83c$var$mul(t, den6, num);
    $a1d7ebd43ba0a83c$var$mul(t, t, den);
    $a1d7ebd43ba0a83c$var$pow2523(t, t);
    $a1d7ebd43ba0a83c$var$mul(t, t, num);
    $a1d7ebd43ba0a83c$var$mul(t, t, den);
    $a1d7ebd43ba0a83c$var$mul(t, t, den);
    $a1d7ebd43ba0a83c$var$mul(r[0], t, den);
    $a1d7ebd43ba0a83c$var$square(chk, r[0]);
    $a1d7ebd43ba0a83c$var$mul(chk, chk, den);
    if ($a1d7ebd43ba0a83c$var$neq25519(chk, num)) $a1d7ebd43ba0a83c$var$mul(r[0], r[0], $a1d7ebd43ba0a83c$var$I);
    $a1d7ebd43ba0a83c$var$square(chk, r[0]);
    $a1d7ebd43ba0a83c$var$mul(chk, chk, den);
    if ($a1d7ebd43ba0a83c$var$neq25519(chk, num)) return -1;
    if ($a1d7ebd43ba0a83c$var$par25519(r[0]) === p[31] >> 7) $a1d7ebd43ba0a83c$var$sub(r[0], $a1d7ebd43ba0a83c$var$gf0, r[0]);
    $a1d7ebd43ba0a83c$var$mul(r[3], r[0], r[1]);
    return 0;
}
function $a1d7ebd43ba0a83c$var$verify(publicKey, message, signature) {
    const t = new Uint8Array(32);
    const p = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    const q = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    if (signature.length !== $a1d7ebd43ba0a83c$exports.SIGNATURE_LENGTH) throw new Error(`ed25519: signature must be ${$a1d7ebd43ba0a83c$exports.SIGNATURE_LENGTH} bytes`);
    if ($a1d7ebd43ba0a83c$var$unpackneg(q, publicKey)) return false;
    const hs = new $2cc6b12a8ccb780d$exports.SHA512();
    hs.update(signature.subarray(0, 32));
    hs.update(publicKey);
    hs.update(message);
    const h = hs.digest();
    $a1d7ebd43ba0a83c$var$reduce(h);
    $a1d7ebd43ba0a83c$var$scalarmult(p, q, h);
    $a1d7ebd43ba0a83c$var$scalarbase(q, signature.subarray(32));
    $a1d7ebd43ba0a83c$var$edadd(p, q);
    $a1d7ebd43ba0a83c$var$pack(t, p);
    if ($a1d7ebd43ba0a83c$var$verify32(signature, t)) return false;
    return true;
}
$a1d7ebd43ba0a83c$exports.verify = $a1d7ebd43ba0a83c$var$verify;
/**
 * Convert Ed25519 public key to X25519 public key.
 *
 * Throws if given an invalid public key.
 */ function $a1d7ebd43ba0a83c$var$convertPublicKeyToX25519(publicKey) {
    let q = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    if ($a1d7ebd43ba0a83c$var$unpackneg(q, publicKey)) throw new Error("Ed25519: invalid public key");
    // Formula: montgomeryX = (edwardsY + 1)*inverse(1 - edwardsY) mod p
    let a = $a1d7ebd43ba0a83c$var$gf();
    let b = $a1d7ebd43ba0a83c$var$gf();
    let y = q[1];
    $a1d7ebd43ba0a83c$var$add(a, $a1d7ebd43ba0a83c$var$gf1, y);
    $a1d7ebd43ba0a83c$var$sub(b, $a1d7ebd43ba0a83c$var$gf1, y);
    $a1d7ebd43ba0a83c$var$inv25519(b, b);
    $a1d7ebd43ba0a83c$var$mul(a, a, b);
    let z = new Uint8Array(32);
    $a1d7ebd43ba0a83c$var$pack25519(z, a);
    return z;
}
$a1d7ebd43ba0a83c$exports.convertPublicKeyToX25519 = $a1d7ebd43ba0a83c$var$convertPublicKeyToX25519;
/**
 *  Convert Ed25519 secret (private) key to X25519 secret key.
 */ function $a1d7ebd43ba0a83c$var$convertSecretKeyToX25519(secretKey) {
    const d = (0, $2cc6b12a8ccb780d$exports.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const o = new Uint8Array(d.subarray(0, 32));
    (0, $276678191c4bdb56$exports.wipe)(d);
    return o;
}
$a1d7ebd43ba0a83c$exports.convertSecretKeyToX25519 = $a1d7ebd43ba0a83c$var$convertSecretKeyToX25519;




var $aG48A = parcelRequire("aG48A");
const $57cb2bb50a99d8e7$export$51745f7832485c34 = "EdDSA";
const $57cb2bb50a99d8e7$export$f51b45e220f2ba98 = "JWT";
const $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef = ".";
const $57cb2bb50a99d8e7$export$d2e6fe38c55f8e23 = "base64url";
const $57cb2bb50a99d8e7$export$c09c2801e10a2b95 = "utf8";
const $57cb2bb50a99d8e7$export$1e9219c0b91a4257 = "utf8";
const $57cb2bb50a99d8e7$export$d4057275de9d060b = ":";
const $57cb2bb50a99d8e7$export$acf13c61a1a0ccf3 = "did";
const $57cb2bb50a99d8e7$export$b908fe81ccf30934 = "key";
const $57cb2bb50a99d8e7$export$7bd18b7a7a4d0471 = "base58btc";
const $57cb2bb50a99d8e7$export$6d6d3d2e39be8d68 = "z";
const $57cb2bb50a99d8e7$export$9902a33a5776d1fc = "K36";
const $57cb2bb50a99d8e7$export$ca477e91394a742a = 32;
const $57cb2bb50a99d8e7$export$f09ad228919f26fb = 32;


var $475c4a512fd4a246$exports = {};
"use strict";
Object.defineProperty($475c4a512fd4a246$exports, "__esModule", {
    value: true
});
var $6082a548169c7b42$exports = {};
"use strict";
Object.defineProperty($6082a548169c7b42$exports, "__esModule", {
    value: true
});
var $784ac8dd0f23c14d$exports = {};
"use strict";
Object.defineProperty($784ac8dd0f23c14d$exports, "__esModule", {
    value: true
});
function $784ac8dd0f23c14d$var$asUint8Array(buf) {
    if (globalThis.Buffer != null) return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    return buf;
}
$784ac8dd0f23c14d$exports.asUint8Array = $784ac8dd0f23c14d$var$asUint8Array;


function $6082a548169c7b42$var$alloc(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.alloc != null) return $784ac8dd0f23c14d$exports.asUint8Array(globalThis.Buffer.alloc(size));
    return new Uint8Array(size);
}
function $6082a548169c7b42$var$allocUnsafe(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) return $784ac8dd0f23c14d$exports.asUint8Array(globalThis.Buffer.allocUnsafe(size));
    return new Uint8Array(size);
}
$6082a548169c7b42$exports.alloc = $6082a548169c7b42$var$alloc;
$6082a548169c7b42$exports.allocUnsafe = $6082a548169c7b42$var$allocUnsafe;



function $475c4a512fd4a246$var$concat(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = $6082a548169c7b42$exports.allocUnsafe(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return $784ac8dd0f23c14d$exports.asUint8Array(output);
}
$475c4a512fd4a246$exports.concat = $475c4a512fd4a246$var$concat;


var $bdf44057d833ab1f$exports = {};
"use strict";
Object.defineProperty($bdf44057d833ab1f$exports, "__esModule", {
    value: true
});
var $5884b53a084a924d$exports = {};
"use strict";
var $b633fa38a7f8a649$exports = {};
"use strict";
Object.defineProperty($b633fa38a7f8a649$exports, "__esModule", {
    value: true
});
var $fab4e33fc8c0336e$exports = {};
"use strict";
Object.defineProperty($fab4e33fc8c0336e$exports, "__esModule", {
    value: true
});
var $de6c852f920490b4$exports = {};
"use strict";
Object.defineProperty($de6c852f920490b4$exports, "__esModule", {
    value: true
});
var $0340df4a7a7e39d8$exports = {};
"use strict";
function $0340df4a7a7e39d8$var$base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === " ") return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        if (source[psz] === " ") return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $0340df4a7a7e39d8$var$src = $0340df4a7a7e39d8$var$base;
var $0340df4a7a7e39d8$var$_brrp__multiformats_scope_baseX = $0340df4a7a7e39d8$var$src;
$0340df4a7a7e39d8$exports = $0340df4a7a7e39d8$var$_brrp__multiformats_scope_baseX;


var $4d55dbc11a5f1aec$exports = {};
"use strict";
Object.defineProperty($4d55dbc11a5f1aec$exports, "__esModule", {
    value: true
});
const $4d55dbc11a5f1aec$var$empty = new Uint8Array(0);
const $4d55dbc11a5f1aec$var$toHex = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, "0"), "");
const $4d55dbc11a5f1aec$var$fromHex = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : $4d55dbc11a5f1aec$var$empty;
};
const $4d55dbc11a5f1aec$var$equals = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const $4d55dbc11a5f1aec$var$coerce = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
};
const $4d55dbc11a5f1aec$var$isBinary = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const $4d55dbc11a5f1aec$var$fromString = (str)=>new TextEncoder().encode(str);
const $4d55dbc11a5f1aec$var$toString = (b)=>new TextDecoder().decode(b);
$4d55dbc11a5f1aec$exports.coerce = $4d55dbc11a5f1aec$var$coerce;
$4d55dbc11a5f1aec$exports.empty = $4d55dbc11a5f1aec$var$empty;
$4d55dbc11a5f1aec$exports.equals = $4d55dbc11a5f1aec$var$equals;
$4d55dbc11a5f1aec$exports.fromHex = $4d55dbc11a5f1aec$var$fromHex;
$4d55dbc11a5f1aec$exports.fromString = $4d55dbc11a5f1aec$var$fromString;
$4d55dbc11a5f1aec$exports.isBinary = $4d55dbc11a5f1aec$var$isBinary;
$4d55dbc11a5f1aec$exports.toHex = $4d55dbc11a5f1aec$var$toHex;
$4d55dbc11a5f1aec$exports.toString = $4d55dbc11a5f1aec$var$toString;


class $de6c852f920490b4$var$Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error("Unknown type, must be binary type");
    }
}
class $de6c852f920490b4$var$Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error("Invalid prefix character");
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === "string") {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(decoder) {
        return $de6c852f920490b4$var$or(this, decoder);
    }
}
class $de6c852f920490b4$var$ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return $de6c852f920490b4$var$or(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $de6c852f920490b4$var$or = (left, right)=>new $de6c852f920490b4$var$ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class $de6c852f920490b4$var$Codec {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new $de6c852f920490b4$var$Encoder(name, prefix, baseEncode);
        this.decoder = new $de6c852f920490b4$var$Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const $de6c852f920490b4$var$from = ({ name: name, prefix: prefix, encode: encode, decode: decode })=>new $de6c852f920490b4$var$Codec(name, prefix, encode, decode);
const $de6c852f920490b4$var$baseX = ({ prefix: prefix, name: name, alphabet: alphabet })=>{
    const { encode: encode, decode: decode } = $0340df4a7a7e39d8$exports(alphabet, name);
    return $de6c852f920490b4$var$from({
        prefix: prefix,
        name: name,
        encode: encode,
        decode: (text)=>$4d55dbc11a5f1aec$exports.coerce(decode(text))
    });
};
const $de6c852f920490b4$var$decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === "=")--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError("Unexpected end of data");
    return out;
};
const $de6c852f920490b4$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === "=";
    const mask = (1 << bitsPerChar) - 1;
    let out = "";
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += "=";
    return out;
};
const $de6c852f920490b4$var$rfc4648 = ({ name: name, prefix: prefix, bitsPerChar: bitsPerChar, alphabet: alphabet })=>{
    return $de6c852f920490b4$var$from({
        prefix: prefix,
        name: name,
        encode (input) {
            return $de6c852f920490b4$var$encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return $de6c852f920490b4$var$decode(input, alphabet, bitsPerChar, name);
        }
    });
};
$de6c852f920490b4$exports.Codec = $de6c852f920490b4$var$Codec;
$de6c852f920490b4$exports.baseX = $de6c852f920490b4$var$baseX;
$de6c852f920490b4$exports.from = $de6c852f920490b4$var$from;
$de6c852f920490b4$exports.or = $de6c852f920490b4$var$or;
$de6c852f920490b4$exports.rfc4648 = $de6c852f920490b4$var$rfc4648;



const $fab4e33fc8c0336e$var$identity = $de6c852f920490b4$exports.from({
    prefix: "\x00",
    name: "identity",
    encode: (buf)=>$4d55dbc11a5f1aec$exports.toString(buf),
    decode: (str)=>$4d55dbc11a5f1aec$exports.fromString(str)
});
$fab4e33fc8c0336e$exports.identity = $fab4e33fc8c0336e$var$identity;


var $444f725972ab843c$exports = {};
"use strict";
Object.defineProperty($444f725972ab843c$exports, "__esModule", {
    value: true
});

const $444f725972ab843c$var$base2 = $de6c852f920490b4$exports.rfc4648({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
$444f725972ab843c$exports.base2 = $444f725972ab843c$var$base2;


var $7330be652d1faeae$exports = {};
"use strict";
Object.defineProperty($7330be652d1faeae$exports, "__esModule", {
    value: true
});

const $7330be652d1faeae$var$base8 = $de6c852f920490b4$exports.rfc4648({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
$7330be652d1faeae$exports.base8 = $7330be652d1faeae$var$base8;


var $7c7f7dd3c1547a66$exports = {};
"use strict";
Object.defineProperty($7c7f7dd3c1547a66$exports, "__esModule", {
    value: true
});

const $7c7f7dd3c1547a66$var$base10 = $de6c852f920490b4$exports.baseX({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
$7c7f7dd3c1547a66$exports.base10 = $7c7f7dd3c1547a66$var$base10;


var $4e3d0e6f3707af45$exports = {};
"use strict";
Object.defineProperty($4e3d0e6f3707af45$exports, "__esModule", {
    value: true
});

const $4e3d0e6f3707af45$var$base16 = $de6c852f920490b4$exports.rfc4648({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
});
const $4e3d0e6f3707af45$var$base16upper = $de6c852f920490b4$exports.rfc4648({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
$4e3d0e6f3707af45$exports.base16 = $4e3d0e6f3707af45$var$base16;
$4e3d0e6f3707af45$exports.base16upper = $4e3d0e6f3707af45$var$base16upper;


var $6d183b7418ac11d8$exports = {};
"use strict";
Object.defineProperty($6d183b7418ac11d8$exports, "__esModule", {
    value: true
});

const $6d183b7418ac11d8$var$base32 = $de6c852f920490b4$exports.rfc4648({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32upper = $de6c852f920490b4$exports.rfc4648({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32pad = $de6c852f920490b4$exports.rfc4648({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32padupper = $de6c852f920490b4$exports.rfc4648({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hex = $de6c852f920490b4$exports.rfc4648({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hexupper = $de6c852f920490b4$exports.rfc4648({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hexpad = $de6c852f920490b4$exports.rfc4648({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hexpadupper = $de6c852f920490b4$exports.rfc4648({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32z = $de6c852f920490b4$exports.rfc4648({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
$6d183b7418ac11d8$exports.base32 = $6d183b7418ac11d8$var$base32;
$6d183b7418ac11d8$exports.base32hex = $6d183b7418ac11d8$var$base32hex;
$6d183b7418ac11d8$exports.base32hexpad = $6d183b7418ac11d8$var$base32hexpad;
$6d183b7418ac11d8$exports.base32hexpadupper = $6d183b7418ac11d8$var$base32hexpadupper;
$6d183b7418ac11d8$exports.base32hexupper = $6d183b7418ac11d8$var$base32hexupper;
$6d183b7418ac11d8$exports.base32pad = $6d183b7418ac11d8$var$base32pad;
$6d183b7418ac11d8$exports.base32padupper = $6d183b7418ac11d8$var$base32padupper;
$6d183b7418ac11d8$exports.base32upper = $6d183b7418ac11d8$var$base32upper;
$6d183b7418ac11d8$exports.base32z = $6d183b7418ac11d8$var$base32z;


var $2478ed668ff199ad$exports = {};
"use strict";
Object.defineProperty($2478ed668ff199ad$exports, "__esModule", {
    value: true
});

const $2478ed668ff199ad$var$base36 = $de6c852f920490b4$exports.baseX({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
});
const $2478ed668ff199ad$var$base36upper = $de6c852f920490b4$exports.baseX({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
$2478ed668ff199ad$exports.base36 = $2478ed668ff199ad$var$base36;
$2478ed668ff199ad$exports.base36upper = $2478ed668ff199ad$var$base36upper;


var $bb23e06a31e86f7c$exports = {};
"use strict";
Object.defineProperty($bb23e06a31e86f7c$exports, "__esModule", {
    value: true
});

const $bb23e06a31e86f7c$var$base58btc = $de6c852f920490b4$exports.baseX({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
});
const $bb23e06a31e86f7c$var$base58flickr = $de6c852f920490b4$exports.baseX({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
$bb23e06a31e86f7c$exports.base58btc = $bb23e06a31e86f7c$var$base58btc;
$bb23e06a31e86f7c$exports.base58flickr = $bb23e06a31e86f7c$var$base58flickr;


var $de0d70bb34ca5e4e$exports = {};
"use strict";
Object.defineProperty($de0d70bb34ca5e4e$exports, "__esModule", {
    value: true
});

const $de0d70bb34ca5e4e$var$base64 = $de6c852f920490b4$exports.rfc4648({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64pad = $de6c852f920490b4$exports.rfc4648({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64url = $de6c852f920490b4$exports.rfc4648({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64urlpad = $de6c852f920490b4$exports.rfc4648({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
$de0d70bb34ca5e4e$exports.base64 = $de0d70bb34ca5e4e$var$base64;
$de0d70bb34ca5e4e$exports.base64pad = $de0d70bb34ca5e4e$var$base64pad;
$de0d70bb34ca5e4e$exports.base64url = $de0d70bb34ca5e4e$var$base64url;
$de0d70bb34ca5e4e$exports.base64urlpad = $de0d70bb34ca5e4e$var$base64urlpad;


var $c9e395f0a3e1277d$exports = {};
"use strict";
Object.defineProperty($c9e395f0a3e1277d$exports, "__esModule", {
    value: true
});

const $c9e395f0a3e1277d$var$alphabet = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42");
const $c9e395f0a3e1277d$var$alphabetBytesToChars = $c9e395f0a3e1277d$var$alphabet.reduce((p, c, i)=>{
    p[i] = c;
    return p;
}, []);
const $c9e395f0a3e1277d$var$alphabetCharsToBytes = $c9e395f0a3e1277d$var$alphabet.reduce((p, c, i)=>{
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function $c9e395f0a3e1277d$var$encode(data) {
    return data.reduce((p, c)=>{
        p += $c9e395f0a3e1277d$var$alphabetBytesToChars[c];
        return p;
    }, "");
}
function $c9e395f0a3e1277d$var$decode(str) {
    const byts = [];
    for (const char of str){
        const byt = $c9e395f0a3e1277d$var$alphabetCharsToBytes[char.codePointAt(0)];
        if (byt === undefined) throw new Error(`Non-base256emoji character: ${char}`);
        byts.push(byt);
    }
    return new Uint8Array(byts);
}
const $c9e395f0a3e1277d$var$base256emoji = $de6c852f920490b4$exports.from({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $c9e395f0a3e1277d$var$encode,
    decode: $c9e395f0a3e1277d$var$decode
});
$c9e395f0a3e1277d$exports.base256emoji = $c9e395f0a3e1277d$var$base256emoji;


var $fc5536b924e664f3$exports = {};
"use strict";
Object.defineProperty($fc5536b924e664f3$exports, "__esModule", {
    value: true
});
var $baed353b52eedd46$exports = {};
"use strict";
Object.defineProperty($baed353b52eedd46$exports, "__esModule", {
    value: true
});
var $f302a42295b946b3$exports = {};
"use strict";
Object.defineProperty($f302a42295b946b3$exports, "__esModule", {
    value: true
});

var $32dd57f0aae68c66$exports = {};
"use strict";
Object.defineProperty($32dd57f0aae68c66$exports, "__esModule", {
    value: true
});
var $fa05a038af787ba8$exports = {};
"use strict";
var $fa05a038af787ba8$var$encode_1 = $fa05a038af787ba8$var$encode;
var $fa05a038af787ba8$var$MSB = 128, $fa05a038af787ba8$var$REST = 127, $fa05a038af787ba8$var$MSBALL = ~$fa05a038af787ba8$var$REST, $fa05a038af787ba8$var$INT = Math.pow(2, 31);
function $fa05a038af787ba8$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $fa05a038af787ba8$var$INT){
        out[offset++] = num & 255 | $fa05a038af787ba8$var$MSB;
        num /= 128;
    }
    while(num & $fa05a038af787ba8$var$MSBALL){
        out[offset++] = num & 255 | $fa05a038af787ba8$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $fa05a038af787ba8$var$encode.bytes = offset - oldOffset + 1;
    return out;
}
var $fa05a038af787ba8$var$decode = $fa05a038af787ba8$var$read;
var $fa05a038af787ba8$var$MSB$1 = 128, $fa05a038af787ba8$var$REST$1 = 127;
function $fa05a038af787ba8$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $fa05a038af787ba8$var$read.bytes = 0;
            throw new RangeError("Could not decode varint");
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $fa05a038af787ba8$var$REST$1) << shift : (b & $fa05a038af787ba8$var$REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $fa05a038af787ba8$var$MSB$1);
    $fa05a038af787ba8$var$read.bytes = counter - offset;
    return res;
}
var $fa05a038af787ba8$var$N1 = Math.pow(2, 7);
var $fa05a038af787ba8$var$N2 = Math.pow(2, 14);
var $fa05a038af787ba8$var$N3 = Math.pow(2, 21);
var $fa05a038af787ba8$var$N4 = Math.pow(2, 28);
var $fa05a038af787ba8$var$N5 = Math.pow(2, 35);
var $fa05a038af787ba8$var$N6 = Math.pow(2, 42);
var $fa05a038af787ba8$var$N7 = Math.pow(2, 49);
var $fa05a038af787ba8$var$N8 = Math.pow(2, 56);
var $fa05a038af787ba8$var$N9 = Math.pow(2, 63);
var $fa05a038af787ba8$var$length = function(value) {
    return value < $fa05a038af787ba8$var$N1 ? 1 : value < $fa05a038af787ba8$var$N2 ? 2 : value < $fa05a038af787ba8$var$N3 ? 3 : value < $fa05a038af787ba8$var$N4 ? 4 : value < $fa05a038af787ba8$var$N5 ? 5 : value < $fa05a038af787ba8$var$N6 ? 6 : value < $fa05a038af787ba8$var$N7 ? 7 : value < $fa05a038af787ba8$var$N8 ? 8 : value < $fa05a038af787ba8$var$N9 ? 9 : 10;
};
var $fa05a038af787ba8$var$varint = {
    encode: $fa05a038af787ba8$var$encode_1,
    decode: $fa05a038af787ba8$var$decode,
    encodingLength: $fa05a038af787ba8$var$length
};
var $fa05a038af787ba8$var$_brrp_varint = $fa05a038af787ba8$var$varint;
var $fa05a038af787ba8$var$varint$1 = $fa05a038af787ba8$var$_brrp_varint;
$fa05a038af787ba8$exports = $fa05a038af787ba8$var$varint$1;


const $32dd57f0aae68c66$var$decode = (data, offset = 0)=>{
    const code = $fa05a038af787ba8$exports.decode(data, offset);
    return [
        code,
        $fa05a038af787ba8$exports.decode.bytes
    ];
};
const $32dd57f0aae68c66$var$encodeTo = (int, target, offset = 0)=>{
    $fa05a038af787ba8$exports.encode(int, target, offset);
    return target;
};
const $32dd57f0aae68c66$var$encodingLength = (int)=>{
    return $fa05a038af787ba8$exports.encodingLength(int);
};
$32dd57f0aae68c66$exports.decode = $32dd57f0aae68c66$var$decode;
$32dd57f0aae68c66$exports.encodeTo = $32dd57f0aae68c66$var$encodeTo;
$32dd57f0aae68c66$exports.encodingLength = $32dd57f0aae68c66$var$encodingLength;


const $f302a42295b946b3$var$create = (code, digest)=>{
    const size = digest.byteLength;
    const sizeOffset = $32dd57f0aae68c66$exports.encodingLength(code);
    const digestOffset = sizeOffset + $32dd57f0aae68c66$exports.encodingLength(size);
    const bytes = new Uint8Array(digestOffset + size);
    $32dd57f0aae68c66$exports.encodeTo(code, bytes, 0);
    $32dd57f0aae68c66$exports.encodeTo(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new $f302a42295b946b3$var$Digest(code, size, digest, bytes);
};
const $f302a42295b946b3$var$decode = (multihash)=>{
    const bytes$1 = $4d55dbc11a5f1aec$exports.coerce(multihash);
    const [code, sizeOffset] = $32dd57f0aae68c66$exports.decode(bytes$1);
    const [size, digestOffset] = $32dd57f0aae68c66$exports.decode(bytes$1.subarray(sizeOffset));
    const digest = bytes$1.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error("Incorrect length");
    return new $f302a42295b946b3$var$Digest(code, size, digest, bytes$1);
};
const $f302a42295b946b3$var$equals = (a, b)=>{
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && $4d55dbc11a5f1aec$exports.equals(a.bytes, b.bytes);
};
class $f302a42295b946b3$var$Digest {
    constructor(code, size, digest, bytes){
        this.code = code;
        this.size = size;
        this.digest = digest;
        this.bytes = bytes;
    }
}
$f302a42295b946b3$exports.Digest = $f302a42295b946b3$var$Digest;
$f302a42295b946b3$exports.create = $f302a42295b946b3$var$create;
$f302a42295b946b3$exports.decode = $f302a42295b946b3$var$decode;
$f302a42295b946b3$exports.equals = $f302a42295b946b3$var$equals;


const $baed353b52eedd46$var$from = ({ name: name, code: code, encode: encode })=>new $baed353b52eedd46$var$Hasher(name, code, encode);
class $baed353b52eedd46$var$Hasher {
    constructor(name, code, encode){
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    digest(input) {
        if (input instanceof Uint8Array) {
            const result = this.encode(input);
            return result instanceof Uint8Array ? $f302a42295b946b3$exports.create(this.code, result) : result.then((digest$1)=>$f302a42295b946b3$exports.create(this.code, digest$1));
        } else throw Error("Unknown type, must be binary type");
    }
}
$baed353b52eedd46$exports.Hasher = $baed353b52eedd46$var$Hasher;
$baed353b52eedd46$exports.from = $baed353b52eedd46$var$from;


const $fc5536b924e664f3$var$sha = (name)=>async (data)=>new Uint8Array(await crypto.subtle.digest(name, data));
const $fc5536b924e664f3$var$sha256 = $baed353b52eedd46$exports.from({
    name: "sha2-256",
    code: 18,
    encode: $fc5536b924e664f3$var$sha("SHA-256")
});
const $fc5536b924e664f3$var$sha512 = $baed353b52eedd46$exports.from({
    name: "sha2-512",
    code: 19,
    encode: $fc5536b924e664f3$var$sha("SHA-512")
});
$fc5536b924e664f3$exports.sha256 = $fc5536b924e664f3$var$sha256;
$fc5536b924e664f3$exports.sha512 = $fc5536b924e664f3$var$sha512;


var $60ad3b9242aa2ade$exports = {};
"use strict";
Object.defineProperty($60ad3b9242aa2ade$exports, "__esModule", {
    value: true
});


const $60ad3b9242aa2ade$var$code = 0;
const $60ad3b9242aa2ade$var$name = "identity";
const $60ad3b9242aa2ade$var$encode = $4d55dbc11a5f1aec$exports.coerce;
const $60ad3b9242aa2ade$var$digest = (input)=>$f302a42295b946b3$exports.create($60ad3b9242aa2ade$var$code, $60ad3b9242aa2ade$var$encode(input));
const $60ad3b9242aa2ade$var$identity = {
    code: $60ad3b9242aa2ade$var$code,
    name: $60ad3b9242aa2ade$var$name,
    encode: $60ad3b9242aa2ade$var$encode,
    digest: $60ad3b9242aa2ade$var$digest
};
$60ad3b9242aa2ade$exports.identity = $60ad3b9242aa2ade$var$identity;


var $00eb0d0ec1c470ae$exports = {};
"use strict";
Object.defineProperty($00eb0d0ec1c470ae$exports, "__esModule", {
    value: true
});

const $00eb0d0ec1c470ae$var$name = "raw";
const $00eb0d0ec1c470ae$var$code = 85;
const $00eb0d0ec1c470ae$var$encode = (node)=>$4d55dbc11a5f1aec$exports.coerce(node);
const $00eb0d0ec1c470ae$var$decode = (data)=>$4d55dbc11a5f1aec$exports.coerce(data);
$00eb0d0ec1c470ae$exports.code = $00eb0d0ec1c470ae$var$code;
$00eb0d0ec1c470ae$exports.decode = $00eb0d0ec1c470ae$var$decode;
$00eb0d0ec1c470ae$exports.encode = $00eb0d0ec1c470ae$var$encode;
$00eb0d0ec1c470ae$exports.name = $00eb0d0ec1c470ae$var$name;


var $5df44c55fa70023d$exports = {};
"use strict";
Object.defineProperty($5df44c55fa70023d$exports, "__esModule", {
    value: true
});
const $5df44c55fa70023d$var$textEncoder = new TextEncoder();
const $5df44c55fa70023d$var$textDecoder = new TextDecoder();
const $5df44c55fa70023d$var$name = "json";
const $5df44c55fa70023d$var$code = 512;
const $5df44c55fa70023d$var$encode = (node)=>$5df44c55fa70023d$var$textEncoder.encode(JSON.stringify(node));
const $5df44c55fa70023d$var$decode = (data)=>JSON.parse($5df44c55fa70023d$var$textDecoder.decode(data));
$5df44c55fa70023d$exports.code = $5df44c55fa70023d$var$code;
$5df44c55fa70023d$exports.decode = $5df44c55fa70023d$var$decode;
$5df44c55fa70023d$exports.encode = $5df44c55fa70023d$var$encode;
$5df44c55fa70023d$exports.name = $5df44c55fa70023d$var$name;


var $ce2f798d02e53aa4$exports = {};
"use strict";
Object.defineProperty($ce2f798d02e53aa4$exports, "__esModule", {
    value: true
});
var $75176e30f12252bd$exports = {};
"use strict";
Object.defineProperty($75176e30f12252bd$exports, "__esModule", {
    value: true
});





class $75176e30f12252bd$var$CID {
    constructor(version, code, multihash, bytes){
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: $75176e30f12252bd$var$hidden,
            byteLength: $75176e30f12252bd$var$hidden,
            code: $75176e30f12252bd$var$readonly,
            version: $75176e30f12252bd$var$readonly,
            multihash: $75176e30f12252bd$var$readonly,
            bytes: $75176e30f12252bd$var$readonly,
            _baseCache: $75176e30f12252bd$var$hidden,
            asCID: $75176e30f12252bd$var$hidden
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code: code, multihash: multihash } = this;
                    if (code !== $75176e30f12252bd$var$DAG_PB_CODE) throw new Error("Cannot convert a non dag-pb CID to CIDv0");
                    if (multihash.code !== $75176e30f12252bd$var$SHA_256_CODE) throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
                    return $75176e30f12252bd$var$CID.createV0(multihash);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code: code, digest: digest$1 } = this.multihash;
                    const multihash = $f302a42295b946b3$exports.create(code, digest$1);
                    return $75176e30f12252bd$var$CID.createV1(this.code, multihash);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(other) {
        return other && this.code === other.code && this.version === other.version && $f302a42295b946b3$exports.equals(this.multihash, other.multihash);
    }
    toString(base) {
        const { bytes: bytes, version: version, _baseCache: _baseCache } = this;
        switch(version){
            case 0:
                return $75176e30f12252bd$var$toStringV0(bytes, _baseCache, base || $bb23e06a31e86f7c$exports.base58btc.encoder);
            default:
                return $75176e30f12252bd$var$toStringV1(bytes, _baseCache, base || $6d183b7418ac11d8$exports.base32.encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return "CID";
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return "CID(" + this.toString() + ")";
    }
    static isCID(value) {
        $75176e30f12252bd$var$deprecate(/^0\.0/, $75176e30f12252bd$var$IS_CID_DEPRECATION);
        return !!(value && (value[$75176e30f12252bd$var$cidSymbol] || value.asCID === value));
    }
    get toBaseEncodedString() {
        throw new Error("Deprecated, use .toString()");
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error("Deprecated .buffer property, use .bytes to get Uint8Array instead");
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(value) {
        if (value instanceof $75176e30f12252bd$var$CID) return value;
        else if (value != null && value.asCID === value) {
            const { version: version, code: code, multihash: multihash, bytes: bytes } = value;
            return new $75176e30f12252bd$var$CID(version, code, multihash, bytes || $75176e30f12252bd$var$encodeCID(version, code, multihash.bytes));
        } else if (value != null && value[$75176e30f12252bd$var$cidSymbol] === true) {
            const { version: version, multihash: multihash, code: code } = value;
            const digest$1 = $f302a42295b946b3$exports.decode(multihash);
            return $75176e30f12252bd$var$CID.create(version, code, digest$1);
        } else return null;
    }
    static create(version, code, digest) {
        if (typeof code !== "number") throw new Error("String codecs are no longer supported");
        switch(version){
            case 0:
                if (code !== $75176e30f12252bd$var$DAG_PB_CODE) throw new Error(`Version 0 CID must use dag-pb (code: ${$75176e30f12252bd$var$DAG_PB_CODE}) block encoding`);
                else return new $75176e30f12252bd$var$CID(version, code, digest, digest.bytes);
            case 1:
                {
                    const bytes = $75176e30f12252bd$var$encodeCID(version, code, digest.bytes);
                    return new $75176e30f12252bd$var$CID(version, code, digest, bytes);
                }
            default:
                throw new Error("Invalid version");
        }
    }
    static createV0(digest) {
        return $75176e30f12252bd$var$CID.create(0, $75176e30f12252bd$var$DAG_PB_CODE, digest);
    }
    static createV1(code, digest) {
        return $75176e30f12252bd$var$CID.create(1, code, digest);
    }
    static decode(bytes) {
        const [cid, remainder] = $75176e30f12252bd$var$CID.decodeFirst(bytes);
        if (remainder.length) throw new Error("Incorrect length");
        return cid;
    }
    static decodeFirst(bytes$1) {
        const specs = $75176e30f12252bd$var$CID.inspectBytes(bytes$1);
        const prefixSize = specs.size - specs.multihashSize;
        const multihashBytes = $4d55dbc11a5f1aec$exports.coerce(bytes$1.subarray(prefixSize, prefixSize + specs.multihashSize));
        if (multihashBytes.byteLength !== specs.multihashSize) throw new Error("Incorrect length");
        const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
        const digest$1 = new $f302a42295b946b3$exports.Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
        const cid = specs.version === 0 ? $75176e30f12252bd$var$CID.createV0(digest$1) : $75176e30f12252bd$var$CID.createV1(specs.codec, digest$1);
        return [
            cid,
            bytes$1.subarray(specs.size)
        ];
    }
    static inspectBytes(initialBytes) {
        let offset = 0;
        const next = ()=>{
            const [i, length] = $32dd57f0aae68c66$exports.decode(initialBytes.subarray(offset));
            offset += length;
            return i;
        };
        let version = next();
        let codec = $75176e30f12252bd$var$DAG_PB_CODE;
        if (version === 18) {
            version = 0;
            offset = 0;
        } else if (version === 1) codec = next();
        if (version !== 0 && version !== 1) throw new RangeError(`Invalid CID version ${version}`);
        const prefixSize = offset;
        const multihashCode = next();
        const digestSize = next();
        const size = offset + digestSize;
        const multihashSize = size - prefixSize;
        return {
            version: version,
            codec: codec,
            multihashCode: multihashCode,
            digestSize: digestSize,
            multihashSize: multihashSize,
            size: size
        };
    }
    static parse(source, base) {
        const [prefix, bytes] = $75176e30f12252bd$var$parseCIDtoBytes(source, base);
        const cid = $75176e30f12252bd$var$CID.decode(bytes);
        cid._baseCache.set(prefix, source);
        return cid;
    }
}
const $75176e30f12252bd$var$parseCIDtoBytes = (source, base)=>{
    switch(source[0]){
        case "Q":
            {
                const decoder = base || $bb23e06a31e86f7c$exports.base58btc;
                return [
                    $bb23e06a31e86f7c$exports.base58btc.prefix,
                    decoder.decode(`${$bb23e06a31e86f7c$exports.base58btc.prefix}${source}`)
                ];
            }
        case $bb23e06a31e86f7c$exports.base58btc.prefix:
            {
                const decoder = base || $bb23e06a31e86f7c$exports.base58btc;
                return [
                    $bb23e06a31e86f7c$exports.base58btc.prefix,
                    decoder.decode(source)
                ];
            }
        case $6d183b7418ac11d8$exports.base32.prefix:
            {
                const decoder = base || $6d183b7418ac11d8$exports.base32;
                return [
                    $6d183b7418ac11d8$exports.base32.prefix,
                    decoder.decode(source)
                ];
            }
        default:
            if (base == null) throw Error("To parse non base32 or base58btc encoded CID multibase decoder must be provided");
            return [
                source[0],
                base.decode(source)
            ];
    }
};
const $75176e30f12252bd$var$toStringV0 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    if (prefix !== $bb23e06a31e86f7c$exports.base58btc.prefix) throw Error(`Cannot string encode V0 in ${base.name} encoding`);
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes).slice(1);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $75176e30f12252bd$var$toStringV1 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $75176e30f12252bd$var$DAG_PB_CODE = 112;
const $75176e30f12252bd$var$SHA_256_CODE = 18;
const $75176e30f12252bd$var$encodeCID = (version, code, multihash)=>{
    const codeOffset = $32dd57f0aae68c66$exports.encodingLength(version);
    const hashOffset = codeOffset + $32dd57f0aae68c66$exports.encodingLength(code);
    const bytes = new Uint8Array(hashOffset + multihash.byteLength);
    $32dd57f0aae68c66$exports.encodeTo(version, bytes, 0);
    $32dd57f0aae68c66$exports.encodeTo(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
const $75176e30f12252bd$var$cidSymbol = Symbol.for("@ipld/js-cid/CID");
const $75176e30f12252bd$var$readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
const $75176e30f12252bd$var$hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
const $75176e30f12252bd$var$version = "0.0.0-dev";
const $75176e30f12252bd$var$deprecate = (range, message)=>{
    if (range.test($75176e30f12252bd$var$version)) console.warn(message);
    else throw new Error(message);
};
const $75176e30f12252bd$var$IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;
$75176e30f12252bd$exports.CID = $75176e30f12252bd$var$CID;






$ce2f798d02e53aa4$exports.CID = $75176e30f12252bd$exports.CID;
$ce2f798d02e53aa4$exports.varint = $32dd57f0aae68c66$exports;
$ce2f798d02e53aa4$exports.bytes = $4d55dbc11a5f1aec$exports;
$ce2f798d02e53aa4$exports.hasher = $baed353b52eedd46$exports;
$ce2f798d02e53aa4$exports.digest = $f302a42295b946b3$exports;







const $b633fa38a7f8a649$var$bases = {
    ...$fab4e33fc8c0336e$exports,
    ...$444f725972ab843c$exports,
    ...$7330be652d1faeae$exports,
    ...$7c7f7dd3c1547a66$exports,
    ...$4e3d0e6f3707af45$exports,
    ...$6d183b7418ac11d8$exports,
    ...$2478ed668ff199ad$exports,
    ...$bb23e06a31e86f7c$exports,
    ...$de0d70bb34ca5e4e$exports,
    ...$c9e395f0a3e1277d$exports
};
const $b633fa38a7f8a649$var$hashes = {
    ...$fc5536b924e664f3$exports,
    ...$60ad3b9242aa2ade$exports
};
const $b633fa38a7f8a649$var$codecs = {
    raw: $00eb0d0ec1c470ae$exports,
    json: $5df44c55fa70023d$exports
};
$b633fa38a7f8a649$exports.CID = $75176e30f12252bd$exports.CID;
$b633fa38a7f8a649$exports.hasher = $baed353b52eedd46$exports;
$b633fa38a7f8a649$exports.digest = $f302a42295b946b3$exports;
$b633fa38a7f8a649$exports.varint = $32dd57f0aae68c66$exports;
$b633fa38a7f8a649$exports.bytes = $4d55dbc11a5f1aec$exports;
$b633fa38a7f8a649$exports.bases = $b633fa38a7f8a649$var$bases;
$b633fa38a7f8a649$exports.codecs = $b633fa38a7f8a649$var$codecs;
$b633fa38a7f8a649$exports.hashes = $b633fa38a7f8a649$var$hashes;



function $5884b53a084a924d$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
const $5884b53a084a924d$var$string = $5884b53a084a924d$var$createCodec("utf8", "u", (buf)=>{
    const decoder = new TextDecoder("utf8");
    return "u" + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const $5884b53a084a924d$var$ascii = $5884b53a084a924d$var$createCodec("ascii", "a", (buf)=>{
    let string = "a";
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = $6082a548169c7b42$exports.allocUnsafe(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
const $5884b53a084a924d$var$BASES = {
    utf8: $5884b53a084a924d$var$string,
    "utf-8": $5884b53a084a924d$var$string,
    hex: $b633fa38a7f8a649$exports.bases.base16,
    latin1: $5884b53a084a924d$var$ascii,
    ascii: $5884b53a084a924d$var$ascii,
    binary: $5884b53a084a924d$var$ascii,
    ...$b633fa38a7f8a649$exports.bases
};
$5884b53a084a924d$exports = $5884b53a084a924d$var$BASES;


function $bdf44057d833ab1f$var$toString(array, encoding = "utf8") {
    const base = $5884b53a084a924d$exports[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString("utf8");
    return base.encoder.encode(array).substring(1);
}
$bdf44057d833ab1f$exports.toString = $bdf44057d833ab1f$var$toString;


var $a4ed053a1131469e$exports = {};
"use strict";
Object.defineProperty($a4ed053a1131469e$exports, "__esModule", {
    value: true
});


function $a4ed053a1131469e$var$fromString(string, encoding = "utf8") {
    const base = $5884b53a084a924d$exports[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return $784ac8dd0f23c14d$exports.asUint8Array(globalThis.Buffer.from(string, "utf-8"));
    return base.decoder.decode(`${base.prefix}${string}`);
}
$a4ed053a1131469e$exports.fromString = $a4ed053a1131469e$var$fromString;




function $f6e90d472e8dfc29$export$2030d1af6cd0ef93(str) {
    return (0, $81c2e06d24b89184$export$84137bb44359aed5)((0, $bdf44057d833ab1f$exports.toString)((0, $a4ed053a1131469e$exports.fromString)(str, (0, $57cb2bb50a99d8e7$export$d2e6fe38c55f8e23)), (0, $57cb2bb50a99d8e7$export$c09c2801e10a2b95)));
}
function $f6e90d472e8dfc29$export$84046f8082657cdf(val) {
    return (0, $bdf44057d833ab1f$exports.toString)((0, $a4ed053a1131469e$exports.fromString)((0, $81c2e06d24b89184$export$abc3f407e87918a4)(val), (0, $57cb2bb50a99d8e7$export$c09c2801e10a2b95)), (0, $57cb2bb50a99d8e7$export$d2e6fe38c55f8e23));
}
function $f6e90d472e8dfc29$export$1b29ef9371459e10(publicKey) {
    const header = (0, $a4ed053a1131469e$exports.fromString)((0, $57cb2bb50a99d8e7$export$9902a33a5776d1fc), (0, $57cb2bb50a99d8e7$export$7bd18b7a7a4d0471));
    const multicodec = (0, $57cb2bb50a99d8e7$export$6d6d3d2e39be8d68) + (0, $bdf44057d833ab1f$exports.toString)((0, $475c4a512fd4a246$exports.concat)([
        header,
        publicKey
    ]), (0, $57cb2bb50a99d8e7$export$7bd18b7a7a4d0471));
    return [
        (0, $57cb2bb50a99d8e7$export$acf13c61a1a0ccf3),
        (0, $57cb2bb50a99d8e7$export$b908fe81ccf30934),
        multicodec
    ].join((0, $57cb2bb50a99d8e7$export$d4057275de9d060b));
}
function $f6e90d472e8dfc29$export$86ac046d72244356(issuer) {
    const [prefix, method, multicodec] = issuer.split((0, $57cb2bb50a99d8e7$export$d4057275de9d060b));
    if (prefix !== (0, $57cb2bb50a99d8e7$export$acf13c61a1a0ccf3) || method !== (0, $57cb2bb50a99d8e7$export$b908fe81ccf30934)) throw new Error(`Issuer must be a DID with method "key"`);
    const base = multicodec.slice(0, 1);
    if (base !== (0, $57cb2bb50a99d8e7$export$6d6d3d2e39be8d68)) throw new Error(`Issuer must be a key in mulicodec format`);
    const bytes = (0, $a4ed053a1131469e$exports.fromString)(multicodec.slice(1), (0, $57cb2bb50a99d8e7$export$7bd18b7a7a4d0471));
    const type = (0, $bdf44057d833ab1f$exports.toString)(bytes.slice(0, 2), (0, $57cb2bb50a99d8e7$export$7bd18b7a7a4d0471));
    if (type !== (0, $57cb2bb50a99d8e7$export$9902a33a5776d1fc)) throw new Error(`Issuer must be a public key with type "Ed25519"`);
    const publicKey = bytes.slice(2);
    if (publicKey.length !== (0, $57cb2bb50a99d8e7$export$ca477e91394a742a)) throw new Error(`Issuer must be a public key with length 32 bytes`);
    return publicKey;
}
function $f6e90d472e8dfc29$export$d9746ef301b2089b(bytes) {
    return (0, $bdf44057d833ab1f$exports.toString)(bytes, (0, $57cb2bb50a99d8e7$export$d2e6fe38c55f8e23));
}
function $f6e90d472e8dfc29$export$c37aeb372ac07c0e(encoded) {
    return (0, $a4ed053a1131469e$exports.fromString)(encoded, (0, $57cb2bb50a99d8e7$export$d2e6fe38c55f8e23));
}
function $f6e90d472e8dfc29$export$cfdd1f2478131e3d(params) {
    return (0, $a4ed053a1131469e$exports.fromString)([
        $f6e90d472e8dfc29$export$84046f8082657cdf(params.header),
        $f6e90d472e8dfc29$export$84046f8082657cdf(params.payload)
    ].join((0, $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef)), (0, $57cb2bb50a99d8e7$export$1e9219c0b91a4257));
}
function $f6e90d472e8dfc29$export$13923bea59211b58(data) {
    const params = (0, $bdf44057d833ab1f$exports.toString)(data, (0, $57cb2bb50a99d8e7$export$1e9219c0b91a4257)).split((0, $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef));
    const header = $f6e90d472e8dfc29$export$2030d1af6cd0ef93(params[0]);
    const payload = $f6e90d472e8dfc29$export$2030d1af6cd0ef93(params[1]);
    return {
        header: header,
        payload: payload
    };
}
function $f6e90d472e8dfc29$export$1b70f4551c751d68(params) {
    return [
        $f6e90d472e8dfc29$export$84046f8082657cdf(params.header),
        $f6e90d472e8dfc29$export$84046f8082657cdf(params.payload),
        $f6e90d472e8dfc29$export$d9746ef301b2089b(params.signature)
    ].join((0, $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef));
}
function $f6e90d472e8dfc29$export$9a62e6c0a30e00bc(jwt) {
    const params = jwt.split((0, $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef));
    const header = $f6e90d472e8dfc29$export$2030d1af6cd0ef93(params[0]);
    const payload = $f6e90d472e8dfc29$export$2030d1af6cd0ef93(params[1]);
    const signature = $f6e90d472e8dfc29$export$c37aeb372ac07c0e(params[2]);
    const data = (0, $a4ed053a1131469e$exports.fromString)(params.slice(0, 2).join((0, $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef)), (0, $57cb2bb50a99d8e7$export$1e9219c0b91a4257));
    return {
        header: header,
        payload: payload,
        signature: signature,
        data: data
    };
}


function $2281914794d9e636$export$a949d36eab55b41f(seed = (0, $73945d82524e104e$exports.randomBytes)((0, $57cb2bb50a99d8e7$export$f09ad228919f26fb))) {
    return $a1d7ebd43ba0a83c$exports.generateKeyPairFromSeed(seed);
}
async function $2281914794d9e636$export$a8dda30659d36d45(sub, aud, ttl, keyPair, iat = (0, $aG48A.fromMiliseconds)(Date.now())) {
    const header = {
        alg: (0, $57cb2bb50a99d8e7$export$51745f7832485c34),
        typ: (0, $57cb2bb50a99d8e7$export$f51b45e220f2ba98)
    };
    const iss = (0, $f6e90d472e8dfc29$export$1b29ef9371459e10)(keyPair.publicKey);
    const exp = iat + ttl;
    const payload = {
        iss: iss,
        sub: sub,
        aud: aud,
        iat: iat,
        exp: exp
    };
    const data = (0, $f6e90d472e8dfc29$export$cfdd1f2478131e3d)({
        header: header,
        payload: payload
    });
    const signature = $a1d7ebd43ba0a83c$exports.sign(keyPair.secretKey, data);
    return (0, $f6e90d472e8dfc29$export$1b70f4551c751d68)({
        header: header,
        payload: payload,
        signature: signature
    });
}
async function $2281914794d9e636$export$7b6fc79aa8c5b79c(jwt) {
    const { header: header, payload: payload, data: data, signature: signature } = (0, $f6e90d472e8dfc29$export$9a62e6c0a30e00bc)(jwt);
    if (header.alg !== (0, $57cb2bb50a99d8e7$export$51745f7832485c34) || header.typ !== (0, $57cb2bb50a99d8e7$export$f51b45e220f2ba98)) throw new Error("JWT must use EdDSA algorithm");
    const publicKey = (0, $f6e90d472e8dfc29$export$86ac046d72244356)(payload.iss);
    return $a1d7ebd43ba0a83c$exports.verify(publicKey, data, signature);
}



var $212b43c5ef62f705$exports = {};



$parcel$exportWildcard($b9995ea5f865dc88$exports, $212b43c5ef62f705$exports);


var $1ca962bc0b1868f1$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($1ca962bc0b1868f1$exports, "__esModule", {
    value: true
});
var $3ca0635e21db662f$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($3ca0635e21db662f$exports, "__esModule", {
    value: true
});


// Number of ChaCha rounds (ChaCha20).
var $3ca0635e21db662f$var$ROUNDS = 20;
// Applies the ChaCha core function to 16-byte input,
// 32-byte key key, and puts the result into 64-byte array out.
function $3ca0635e21db662f$var$core(out, input, key) {
    var j0 = 0x61707865; // "expa"  -- ChaCha's "sigma" constant
    var j1 = 0x3320646E; // "nd 3"     for 32-byte keys
    var j2 = 0x79622D32; // "2-by"
    var j3 = 0x6B206574; // "te k"
    var j4 = key[3] << 24 | key[2] << 16 | key[1] << 8 | key[0];
    var j5 = key[7] << 24 | key[6] << 16 | key[5] << 8 | key[4];
    var j6 = key[11] << 24 | key[10] << 16 | key[9] << 8 | key[8];
    var j7 = key[15] << 24 | key[14] << 16 | key[13] << 8 | key[12];
    var j8 = key[19] << 24 | key[18] << 16 | key[17] << 8 | key[16];
    var j9 = key[23] << 24 | key[22] << 16 | key[21] << 8 | key[20];
    var j10 = key[27] << 24 | key[26] << 16 | key[25] << 8 | key[24];
    var j11 = key[31] << 24 | key[30] << 16 | key[29] << 8 | key[28];
    var j12 = input[3] << 24 | input[2] << 16 | input[1] << 8 | input[0];
    var j13 = input[7] << 24 | input[6] << 16 | input[5] << 8 | input[4];
    var j14 = input[11] << 24 | input[10] << 16 | input[9] << 8 | input[8];
    var j15 = input[15] << 24 | input[14] << 16 | input[13] << 8 | input[12];
    var x0 = j0;
    var x1 = j1;
    var x2 = j2;
    var x3 = j3;
    var x4 = j4;
    var x5 = j5;
    var x6 = j6;
    var x7 = j7;
    var x8 = j8;
    var x9 = j9;
    var x10 = j10;
    var x11 = j11;
    var x12 = j12;
    var x13 = j13;
    var x14 = j14;
    var x15 = j15;
    for(var i = 0; i < $3ca0635e21db662f$var$ROUNDS; i += 2){
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 16 | x12 << 16;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 20 | x4 << 12;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 16 | x13 << 16;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 20 | x5 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 16 | x14 << 16;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 20 | x6 << 12;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 16 | x15 << 16;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 20 | x7 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 24 | x14 << 8;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 25 | x6 << 7;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 24 | x15 << 8;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 25 | x7 << 7;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 24 | x13 << 8;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 25 | x5 << 7;
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 24 | x12 << 8;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 25 | x4 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 16 | x15 << 16;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 20 | x5 << 12;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 16 | x12 << 16;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 20 | x6 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 16 | x13 << 16;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 20 | x7 << 12;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 16 | x14 << 16;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 20 | x4 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 24 | x13 << 8;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 25 | x7 << 7;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 24 | x14 << 8;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 25 | x4 << 7;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 24 | x12 << 8;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 25 | x6 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 24 | x15 << 8;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 25 | x5 << 7;
    }
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x0 + j0 | 0, out, 0);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x1 + j1 | 0, out, 4);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x2 + j2 | 0, out, 8);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x3 + j3 | 0, out, 12);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x4 + j4 | 0, out, 16);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x5 + j5 | 0, out, 20);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x6 + j6 | 0, out, 24);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x7 + j7 | 0, out, 28);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x8 + j8 | 0, out, 32);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x9 + j9 | 0, out, 36);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x10 + j10 | 0, out, 40);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x11 + j11 | 0, out, 44);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x12 + j12 | 0, out, 48);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x13 + j13 | 0, out, 52);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x14 + j14 | 0, out, 56);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x15 + j15 | 0, out, 60);
}
/**
 * Encrypt src with ChaCha20 stream generated for the given 32-byte key and
 * 8-byte (as in original implementation) or 12-byte (as in RFC7539) nonce and
 * write the result into dst and return it.
 *
 * dst and src may be the same, but otherwise must not overlap.
 *
 * If nonce is 12 bytes, users should not encrypt more than 256 GiB with the
 * same key and nonce, otherwise the stream will repeat. The function will
 * throw error if counter overflows to prevent this.
 *
 * If nonce is 8 bytes, the output is practically unlimited (2^70 bytes, which
 * is more than a million petabytes). However, it is not recommended to
 * generate 8-byte nonces randomly, as the chance of collision is high.
 *
 * Never use the same key and nonce to encrypt more than one message.
 *
 * If nonceInplaceCounterLength is not 0, the nonce is assumed to be a 16-byte
 * array with stream counter in first nonceInplaceCounterLength bytes and nonce
 * in the last remaining bytes. The counter will be incremented inplace for
 * each ChaCha block. This is useful if you need to encrypt one stream of data
 * in chunks.
 */ function $3ca0635e21db662f$var$streamXOR(key, nonce, src, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    // We only support 256-bit keys.
    if (key.length !== 32) throw new Error("ChaCha: key size must be 32 bytes");
    if (dst.length < src.length) throw new Error("ChaCha: destination is shorter than source");
    var nc;
    var counterLength;
    if (nonceInplaceCounterLength === 0) {
        if (nonce.length !== 8 && nonce.length !== 12) throw new Error("ChaCha nonce must be 8 or 12 bytes");
        nc = new Uint8Array(16);
        // First counterLength bytes of nc are counter, starting with zero.
        counterLength = nc.length - nonce.length;
        // Last bytes of nc after counterLength are nonce, set them.
        nc.set(nonce, counterLength);
    } else {
        if (nonce.length !== 16) throw new Error("ChaCha nonce with counter must be 16 bytes");
        // This will update passed nonce with counter inplace.
        nc = nonce;
        counterLength = nonceInplaceCounterLength;
    }
    // Allocate temporary space for ChaCha block.
    var block = new Uint8Array(64);
    for(var i = 0; i < src.length; i += 64){
        // Generate a block.
        $3ca0635e21db662f$var$core(block, nc, key);
        // XOR block bytes with src into dst.
        for(var j = i; j < i + 64 && j < src.length; j++)dst[j] = src[j] ^ block[j - i];
        // Increment counter.
        $3ca0635e21db662f$var$incrementCounter(nc, 0, counterLength);
    }
    // Cleanup temporary space.
    $276678191c4bdb56$exports.wipe(block);
    if (nonceInplaceCounterLength === 0) // Cleanup counter.
    $276678191c4bdb56$exports.wipe(nc);
    return dst;
}
$3ca0635e21db662f$exports.streamXOR = $3ca0635e21db662f$var$streamXOR;
/**
 * Generate ChaCha20 stream for the given 32-byte key and 8-byte or 12-byte
 * nonce and write it into dst and return it.
 *
 * Never use the same key and nonce to generate more than one stream.
 *
 * If nonceInplaceCounterLength is not 0, it behaves the same with respect to
 * the nonce as described in the streamXOR documentation.
 *
 * stream is like streamXOR with all-zero src.
 */ function $3ca0635e21db662f$var$stream(key, nonce, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    $276678191c4bdb56$exports.wipe(dst);
    return $3ca0635e21db662f$var$streamXOR(key, nonce, dst, dst, nonceInplaceCounterLength);
}
$3ca0635e21db662f$exports.stream = $3ca0635e21db662f$var$stream;
function $3ca0635e21db662f$var$incrementCounter(counter, pos, len) {
    var carry = 1;
    while(len--){
        carry = carry + (counter[pos] & 0xff) | 0;
        counter[pos] = carry & 0xff;
        carry >>>= 8;
        pos++;
    }
    if (carry > 0) throw new Error("ChaCha: counter overflow");
}


var $bc2eb21e5dd3f530$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($bc2eb21e5dd3f530$exports, "__esModule", {
    value: true
});
var $0806512cf7f87b87$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($0806512cf7f87b87$exports, "__esModule", {
    value: true
});
/**
 * Package constant-time provides functions for performing algorithmically constant-time operations.
 */ /**
 * NOTE! Due to the inability to guarantee real constant time evaluation of
 * anything in JavaScript VM, this is module is the best effort.
 */ /**
 * Returns resultIfOne if subject is 1, or resultIfZero if subject is 0.
 *
 * Supports only 32-bit integers, so resultIfOne or resultIfZero are not
 * integers, they'll be converted to them with bitwise operations.
 */ function $0806512cf7f87b87$var$select(subject, resultIfOne, resultIfZero) {
    return ~(subject - 1) & resultIfOne | subject - 1 & resultIfZero;
}
$0806512cf7f87b87$exports.select = $0806512cf7f87b87$var$select;
/**
 * Returns 1 if a <= b, or 0 if not.
 * Arguments must be positive 32-bit integers less than or equal to 2^31 - 1.
 */ function $0806512cf7f87b87$var$lessOrEqual(a, b) {
    return (a | 0) - (b | 0) - 1 >>> 31 & 1;
}
$0806512cf7f87b87$exports.lessOrEqual = $0806512cf7f87b87$var$lessOrEqual;
/**
 * Returns 1 if a and b are of equal length and their contents
 * are equal, or 0 otherwise.
 *
 * Note that unlike in equal(), zero-length inputs are considered
 * the same, so this function will return 1.
 */ function $0806512cf7f87b87$var$compare(a, b) {
    if (a.length !== b.length) return 0;
    var result = 0;
    for(var i = 0; i < a.length; i++)result |= a[i] ^ b[i];
    return 1 & result - 1 >>> 8;
}
$0806512cf7f87b87$exports.compare = $0806512cf7f87b87$var$compare;
/**
 * Returns true if a and b are of equal non-zero length,
 * and their contents are equal, or false otherwise.
 *
 * Note that unlike in compare() zero-length inputs are considered
 * _not_ equal, so this function will return false.
 */ function $0806512cf7f87b87$var$equal(a, b) {
    if (a.length === 0 || b.length === 0) return false;
    return $0806512cf7f87b87$var$compare(a, b) !== 0;
}
$0806512cf7f87b87$exports.equal = $0806512cf7f87b87$var$equal;



$bc2eb21e5dd3f530$exports.DIGEST_LENGTH = 16;
// Port of Andrew Moon's Poly1305-donna-16. Public domain.
// https://github.com/floodyberry/poly1305-donna
/**
 * Poly1305 computes 16-byte authenticator of message using
 * a one-time 32-byte key.
 *
 * Important: key should be used for only one message,
 * it should never repeat.
 */ var $bc2eb21e5dd3f530$var$Poly1305 = /** @class */ function() {
    function Poly1305(key) {
        this.digestLength = $bc2eb21e5dd3f530$exports.DIGEST_LENGTH;
        this._buffer = new Uint8Array(16);
        this._r = new Uint16Array(10);
        this._h = new Uint16Array(10);
        this._pad = new Uint16Array(8);
        this._leftover = 0;
        this._fin = 0;
        this._finished = false;
        var t0 = key[0] | key[1] << 8;
        this._r[0] = t0 & 0x1fff;
        var t1 = key[2] | key[3] << 8;
        this._r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        var t2 = key[4] | key[5] << 8;
        this._r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        var t3 = key[6] | key[7] << 8;
        this._r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        var t4 = key[8] | key[9] << 8;
        this._r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this._r[5] = t4 >>> 1 & 0x1ffe;
        var t5 = key[10] | key[11] << 8;
        this._r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        var t6 = key[12] | key[13] << 8;
        this._r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        var t7 = key[14] | key[15] << 8;
        this._r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this._r[9] = t7 >>> 5 & 0x007f;
        this._pad[0] = key[16] | key[17] << 8;
        this._pad[1] = key[18] | key[19] << 8;
        this._pad[2] = key[20] | key[21] << 8;
        this._pad[3] = key[22] | key[23] << 8;
        this._pad[4] = key[24] | key[25] << 8;
        this._pad[5] = key[26] | key[27] << 8;
        this._pad[6] = key[28] | key[29] << 8;
        this._pad[7] = key[30] | key[31] << 8;
    }
    Poly1305.prototype._blocks = function(m, mpos, bytes) {
        var hibit = this._fin ? 0 : 2048;
        var h0 = this._h[0], h1 = this._h[1], h2 = this._h[2], h3 = this._h[3], h4 = this._h[4], h5 = this._h[5], h6 = this._h[6], h7 = this._h[7], h8 = this._h[8], h9 = this._h[9];
        var r0 = this._r[0], r1 = this._r[1], r2 = this._r[2], r3 = this._r[3], r4 = this._r[4], r5 = this._r[5], r6 = this._r[6], r7 = this._r[7], r8 = this._r[8], r9 = this._r[9];
        while(bytes >= 16){
            var t0 = m[mpos + 0] | m[mpos + 1] << 8;
            h0 += t0 & 0x1fff;
            var t1 = m[mpos + 2] | m[mpos + 3] << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            var t2 = m[mpos + 4] | m[mpos + 5] << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            var t3 = m[mpos + 6] | m[mpos + 7] << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            var t4 = m[mpos + 8] | m[mpos + 9] << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            var t5 = m[mpos + 10] | m[mpos + 11] << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            var t6 = m[mpos + 12] | m[mpos + 13] << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            var t7 = m[mpos + 14] | m[mpos + 15] << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            var c = 0;
            var d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            var d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            var d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            var d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            var d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            var d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            var d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            var d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            var d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            var d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this._h[0] = h0;
        this._h[1] = h1;
        this._h[2] = h2;
        this._h[3] = h3;
        this._h[4] = h4;
        this._h[5] = h5;
        this._h[6] = h6;
        this._h[7] = h7;
        this._h[8] = h8;
        this._h[9] = h9;
    };
    Poly1305.prototype.finish = function(mac, macpos) {
        if (macpos === void 0) macpos = 0;
        var g = new Uint16Array(10);
        var c;
        var mask;
        var f;
        var i;
        if (this._leftover) {
            i = this._leftover;
            this._buffer[i++] = 1;
            for(; i < 16; i++)this._buffer[i] = 0;
            this._fin = 1;
            this._blocks(this._buffer, 0, 16);
        }
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this._h[i] += c;
            c = this._h[i] >>> 13;
            this._h[i] &= 0x1fff;
        }
        this._h[0] += c * 5;
        c = this._h[0] >>> 13;
        this._h[0] &= 0x1fff;
        this._h[1] += c;
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        this._h[2] += c;
        g[0] = this._h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this._h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this._h[i] = this._h[i] & mask | g[i];
        this._h[0] = (this._h[0] | this._h[1] << 13) & 0xffff;
        this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 0xffff;
        this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 0xffff;
        this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 0xffff;
        this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 0xffff;
        this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 0xffff;
        this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 0xffff;
        this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 0xffff;
        f = this._h[0] + this._pad[0];
        this._h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this._h[i] + this._pad[i] | 0) + (f >>> 16) | 0;
            this._h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this._h[0] >>> 0;
        mac[macpos + 1] = this._h[0] >>> 8;
        mac[macpos + 2] = this._h[1] >>> 0;
        mac[macpos + 3] = this._h[1] >>> 8;
        mac[macpos + 4] = this._h[2] >>> 0;
        mac[macpos + 5] = this._h[2] >>> 8;
        mac[macpos + 6] = this._h[3] >>> 0;
        mac[macpos + 7] = this._h[3] >>> 8;
        mac[macpos + 8] = this._h[4] >>> 0;
        mac[macpos + 9] = this._h[4] >>> 8;
        mac[macpos + 10] = this._h[5] >>> 0;
        mac[macpos + 11] = this._h[5] >>> 8;
        mac[macpos + 12] = this._h[6] >>> 0;
        mac[macpos + 13] = this._h[6] >>> 8;
        mac[macpos + 14] = this._h[7] >>> 0;
        mac[macpos + 15] = this._h[7] >>> 8;
        this._finished = true;
        return this;
    };
    Poly1305.prototype.update = function(m) {
        var mpos = 0;
        var bytes = m.length;
        var want;
        if (this._leftover) {
            want = 16 - this._leftover;
            if (want > bytes) want = bytes;
            for(var i = 0; i < want; i++)this._buffer[this._leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this._leftover += want;
            if (this._leftover < 16) return this;
            this._blocks(this._buffer, 0, 16);
            this._leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this._blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(var i = 0; i < bytes; i++)this._buffer[this._leftover + i] = m[mpos + i];
            this._leftover += bytes;
        }
        return this;
    };
    Poly1305.prototype.digest = function() {
        // TODO(dchest): it behaves differently than other hashes/HMAC,
        // because it throws when finished — others just return saved result.
        if (this._finished) throw new Error("Poly1305 was finished");
        var mac = new Uint8Array(16);
        this.finish(mac);
        return mac;
    };
    Poly1305.prototype.clean = function() {
        $276678191c4bdb56$exports.wipe(this._buffer);
        $276678191c4bdb56$exports.wipe(this._r);
        $276678191c4bdb56$exports.wipe(this._h);
        $276678191c4bdb56$exports.wipe(this._pad);
        this._leftover = 0;
        this._fin = 0;
        this._finished = true; // mark as finished even if not
        return this;
    };
    return Poly1305;
}();
$bc2eb21e5dd3f530$exports.Poly1305 = $bc2eb21e5dd3f530$var$Poly1305;
/**
 * Returns 16-byte authenticator of data using a one-time 32-byte key.
 *
 * Important: key should be used for only one message, it should never repeat.
 */ function $bc2eb21e5dd3f530$var$oneTimeAuth(key, data) {
    var h = new $bc2eb21e5dd3f530$var$Poly1305(key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$bc2eb21e5dd3f530$exports.oneTimeAuth = $bc2eb21e5dd3f530$var$oneTimeAuth;
/**
 * Returns true if two authenticators are 16-byte long and equal.
 * Uses contant-time comparison to avoid leaking timing information.
 */ function $bc2eb21e5dd3f530$var$equal(a, b) {
    if (a.length !== $bc2eb21e5dd3f530$exports.DIGEST_LENGTH || b.length !== $bc2eb21e5dd3f530$exports.DIGEST_LENGTH) return false;
    return $0806512cf7f87b87$exports.equal(a, b);
}
$bc2eb21e5dd3f530$exports.equal = $bc2eb21e5dd3f530$var$equal;





$1ca962bc0b1868f1$exports.KEY_LENGTH = 32;
$1ca962bc0b1868f1$exports.NONCE_LENGTH = 12;
$1ca962bc0b1868f1$exports.TAG_LENGTH = 16;
var $1ca962bc0b1868f1$var$ZEROS = new Uint8Array(16);
/**
 * ChaCha20-Poly1305 Authenticated Encryption with Associated Data.
 *
 * Defined in RFC7539.
 */ var $1ca962bc0b1868f1$var$ChaCha20Poly1305 = /** @class */ function() {
    /**
     * Creates a new instance with the given 32-byte key.
     */ function ChaCha20Poly1305(key) {
        this.nonceLength = $1ca962bc0b1868f1$exports.NONCE_LENGTH;
        this.tagLength = $1ca962bc0b1868f1$exports.TAG_LENGTH;
        if (key.length !== $1ca962bc0b1868f1$exports.KEY_LENGTH) throw new Error("ChaCha20Poly1305 needs 32-byte key");
        // Copy key.
        this._key = new Uint8Array(key);
    }
    /**
     * Encrypts and authenticates plaintext, authenticates associated data,
     * and returns sealed ciphertext, which includes authentication tag.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If dst is given (it must be the size of plaintext + the size of tag
     * length) the result will be put into it. Dst and plaintext must not
     * overlap.
     */ ChaCha20Poly1305.prototype.seal = function(nonce, plaintext, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        // We pass full counter, which has 12-byte nonce and 4-byte block counter,
        // and it will get incremented after generating the block, which is
        // exactly what we need: we only use the first 32 bytes of 64-byte
        // ChaCha block and discard the next 32 bytes.
        var authKey = new Uint8Array(32);
        $3ca0635e21db662f$exports.stream(this._key, counter, authKey, 4);
        // Allocate space for sealed ciphertext.
        var resultLength = plaintext.length + this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Encrypt plaintext.
        $3ca0635e21db662f$exports.streamXOR(this._key, counter, plaintext, result, 4);
        // Authenticate.
        // XXX: can "simplify" here: pass full result (which is already padded
        // due to zeroes prepared for tag), and ciphertext length instead of
        // subarray of result.
        this._authenticate(result.subarray(result.length - this.tagLength, result.length), authKey, result.subarray(0, result.length - this.tagLength), associatedData);
        // Cleanup.
        $276678191c4bdb56$exports.wipe(counter);
        return result;
    };
    /**
     * Authenticates sealed ciphertext (which includes authentication tag) and
     * associated data, decrypts ciphertext and returns decrypted plaintext.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If authentication fails, it returns null.
     *
     * If dst is given (it must be of ciphertext length minus tag length),
     * the result will be put into it. Dst and plaintext must not overlap.
     */ ChaCha20Poly1305.prototype.open = function(nonce, sealed, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Sealed ciphertext should at least contain tag.
        if (sealed.length < this.tagLength) // TODO(dchest): should we throw here instead?
        return null;
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        var authKey = new Uint8Array(32);
        $3ca0635e21db662f$exports.stream(this._key, counter, authKey, 4);
        // Authenticate.
        // XXX: can simplify and avoid allocation: since authenticate()
        // already allocates tag (from Poly1305.digest(), it can return)
        // it instead of copying to calculatedTag. But then in seal()
        // we'll need to copy it.
        var calculatedTag = new Uint8Array(this.tagLength);
        this._authenticate(calculatedTag, authKey, sealed.subarray(0, sealed.length - this.tagLength), associatedData);
        // Constant-time compare tags and return null if they differ.
        if (!$0806512cf7f87b87$exports.equal(calculatedTag, sealed.subarray(sealed.length - this.tagLength, sealed.length))) return null;
        // Allocate space for decrypted plaintext.
        var resultLength = sealed.length - this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Decrypt.
        $3ca0635e21db662f$exports.streamXOR(this._key, counter, sealed.subarray(0, sealed.length - this.tagLength), result, 4);
        // Cleanup.
        $276678191c4bdb56$exports.wipe(counter);
        return result;
    };
    ChaCha20Poly1305.prototype.clean = function() {
        $276678191c4bdb56$exports.wipe(this._key);
        return this;
    };
    ChaCha20Poly1305.prototype._authenticate = function(tagOut, authKey, ciphertext, associatedData) {
        // Initialize Poly1305 with authKey.
        var h = new $bc2eb21e5dd3f530$exports.Poly1305(authKey);
        // Authenticate padded associated data.
        if (associatedData) {
            h.update(associatedData);
            if (associatedData.length % 16 > 0) h.update($1ca962bc0b1868f1$var$ZEROS.subarray(associatedData.length % 16));
        }
        // Authenticate padded ciphertext.
        h.update(ciphertext);
        if (ciphertext.length % 16 > 0) h.update($1ca962bc0b1868f1$var$ZEROS.subarray(ciphertext.length % 16));
        // Authenticate length of associated data.
        // XXX: can avoid allocation here?
        var length = new Uint8Array(8);
        if (associatedData) $ddd89ca0ca71c6d3$exports.writeUint64LE(associatedData.length, length);
        h.update(length);
        // Authenticate length of ciphertext.
        $ddd89ca0ca71c6d3$exports.writeUint64LE(ciphertext.length, length);
        h.update(length);
        // Get tag and copy it into tagOut.
        var tag = h.digest();
        for(var i = 0; i < tag.length; i++)tagOut[i] = tag[i];
        // Cleanup.
        h.clean();
        $276678191c4bdb56$exports.wipe(tag);
        $276678191c4bdb56$exports.wipe(length);
    };
    return ChaCha20Poly1305;
}();
$1ca962bc0b1868f1$exports.ChaCha20Poly1305 = $1ca962bc0b1868f1$var$ChaCha20Poly1305;


var $eea881cb204cba82$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($eea881cb204cba82$exports, "__esModule", {
    value: true
});
var $34e6ca18c8d3a670$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($34e6ca18c8d3a670$exports, "__esModule", {
    value: true
});
var $c3d16a0ee606048e$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($c3d16a0ee606048e$exports, "__esModule", {
    value: true
});
function $c3d16a0ee606048e$var$isSerializableHash(h) {
    return typeof h.saveState !== "undefined" && typeof h.restoreState !== "undefined" && typeof h.cleanSavedState !== "undefined";
}
$c3d16a0ee606048e$exports.isSerializableHash = $c3d16a0ee606048e$var$isSerializableHash; // TODO(dchest): figure out the standardized interface for XOF such as
 // SHAKE and BLAKE2X.




/**
 *  HMAC implements hash-based message authentication algorithm.
 */ var $34e6ca18c8d3a670$var$HMAC = /** @class */ function() {
    /**
     * Constructs a new HMAC with the given Hash and secret key.
     */ function HMAC(hash, key) {
        this._finished = false; // true if HMAC was finalized
        // Initialize inner and outer hashes.
        this._inner = new hash();
        this._outer = new hash();
        // Set block and digest sizes for this HMAC
        // instance to values from the hash.
        this.blockSize = this._outer.blockSize;
        this.digestLength = this._outer.digestLength;
        // Pad temporary stores a key (or its hash) padded with zeroes.
        var pad = new Uint8Array(this.blockSize);
        if (key.length > this.blockSize) // If key is bigger than hash block size, it must be
        // hashed and this hash is used as a key instead.
        this._inner.update(key).finish(pad).clean();
        else // Otherwise, copy the key into pad.
        pad.set(key);
        // Now two different keys are derived from padded key
        // by xoring a different byte value to each.
        // To make inner hash key, xor byte 0x36 into pad.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        // Update inner hash with the result.
        this._inner.update(pad);
        // To make outer hash key, xor byte 0x5c into pad.
        // But since we already xored 0x36 there, we must
        // first undo this by xoring it again.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 106;
        // Update outer hash with the result.
        this._outer.update(pad);
        // Save states of both hashes, so that we can quickly restore
        // them later in reset() without the need to remember the actual
        // key and perform this initialization again.
        if ($c3d16a0ee606048e$exports.isSerializableHash(this._inner) && $c3d16a0ee606048e$exports.isSerializableHash(this._outer)) {
            this._innerKeyedState = this._inner.saveState();
            this._outerKeyedState = this._outer.saveState();
        }
        // Clean pad.
        $276678191c4bdb56$exports.wipe(pad);
    }
    /**
     * Returns HMAC state to the state initialized with key
     * to make it possible to run HMAC over the other data with the same
     * key without creating a new instance.
     */ HMAC.prototype.reset = function() {
        if (!$c3d16a0ee606048e$exports.isSerializableHash(this._inner) || !$c3d16a0ee606048e$exports.isSerializableHash(this._outer)) throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
        // Restore keyed states of inner and outer hashes.
        this._inner.restoreState(this._innerKeyedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    /**
     * Cleans HMAC state.
     */ HMAC.prototype.clean = function() {
        if ($c3d16a0ee606048e$exports.isSerializableHash(this._inner)) this._inner.cleanSavedState(this._innerKeyedState);
        if ($c3d16a0ee606048e$exports.isSerializableHash(this._outer)) this._outer.cleanSavedState(this._outerKeyedState);
        this._inner.clean();
        this._outer.clean();
    };
    /**
     * Updates state with provided data.
     */ HMAC.prototype.update = function(data) {
        this._inner.update(data);
        return this;
    };
    /**
     * Finalizes HMAC and puts the result in out.
     */ HMAC.prototype.finish = function(out) {
        if (this._finished) {
            // If HMAC was finalized, outer hash is also finalized,
            // so it produces the same digest it produced when it
            // was finalized.
            this._outer.finish(out);
            return this;
        }
        // Finalize inner hash and store the result temporarily.
        this._inner.finish(out);
        // Update outer hash with digest of inner hash and and finalize it.
        this._outer.update(out.subarray(0, this.digestLength)).finish(out);
        this._finished = true;
        return this;
    };
    /**
     * Returns the computed message authentication code.
     */ HMAC.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Saves HMAC state.
     * This function is needed for PBKDF2 optimization.
     */ HMAC.prototype.saveState = function() {
        if (!$c3d16a0ee606048e$exports.isSerializableHash(this._inner)) throw new Error("hmac: can't saveState() because hash doesn't implement it");
        return this._inner.saveState();
    };
    HMAC.prototype.restoreState = function(savedState) {
        if (!$c3d16a0ee606048e$exports.isSerializableHash(this._inner) || !$c3d16a0ee606048e$exports.isSerializableHash(this._outer)) throw new Error("hmac: can't restoreState() because hash doesn't implement it");
        this._inner.restoreState(savedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    HMAC.prototype.cleanSavedState = function(savedState) {
        if (!$c3d16a0ee606048e$exports.isSerializableHash(this._inner)) throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
        this._inner.cleanSavedState(savedState);
    };
    return HMAC;
}();
$34e6ca18c8d3a670$exports.HMAC = $34e6ca18c8d3a670$var$HMAC;
/**
 * Returns HMAC using the given hash constructor for the key over data.
 */ function $34e6ca18c8d3a670$var$hmac(hash, key, data) {
    var h = new $34e6ca18c8d3a670$var$HMAC(hash, key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$34e6ca18c8d3a670$exports.hmac = $34e6ca18c8d3a670$var$hmac;
/**
 * Returns true if two HMAC digests are equal.
 * Uses constant-time comparison to avoid leaking timing information.
 *
 * Example:
 *
 *    const receivedDigest = ...
 *    const realDigest = hmac(SHA256, key, data);
 *    if (!equal(receivedDigest, realDigest)) {
 *        throw new Error("Authentication error");
 *    }
 */ $34e6ca18c8d3a670$exports.equal = $0806512cf7f87b87$exports.equal;



/**
 * HMAC-based Extract-and-Expand Key Derivation Function.
 *
 * Implements HKDF from RFC5869.
 *
 * Expands the given master key with salt and info into
 * a limited stream of key material.
 */ var $eea881cb204cba82$var$HKDF = /** @class */ function() {
    /**
     * Create a new HKDF instance for the given hash function
     * with the master key, optional salt, and info.
     *
     * - Master key is a high-entropy secret key (not a password).
     * - Salt is a non-secret random value.
     * - Info is application- and/or context-specific information.
     */ function HKDF(hash, key, salt, info) {
        if (salt === void 0) salt = new Uint8Array(0);
        this._counter = new Uint8Array(1); // starts with zero
        this._hash = hash;
        this._info = info;
        // HKDF-Extract uses salt as HMAC key, and key as data.
        var okm = $34e6ca18c8d3a670$exports.hmac(this._hash, salt, key);
        // Initialize HMAC for expanding with extracted key.
        this._hmac = new $34e6ca18c8d3a670$exports.HMAC(hash, okm);
        // Allocate buffer.
        this._buffer = new Uint8Array(this._hmac.digestLength);
        this._bufpos = this._buffer.length;
    }
    // Fill buffer with new block of HKDF-Extract output.
    HKDF.prototype._fillBuffer = function() {
        // Increment counter.
        this._counter[0]++;
        var ctr = this._counter[0];
        // Check if counter overflowed.
        if (ctr === 0) throw new Error("hkdf: cannot expand more");
        // Prepare HMAC instance for new data with old key.
        this._hmac.reset();
        // Hash in previous output if it was generated
        // (i.e. counter is greater than 1).
        if (ctr > 1) this._hmac.update(this._buffer);
        // Hash in info if it exists.
        if (this._info) this._hmac.update(this._info);
        // Hash in the counter.
        this._hmac.update(this._counter);
        // Output result to buffer and clean HMAC instance.
        this._hmac.finish(this._buffer);
        // Reset buffer position.
        this._bufpos = 0;
    };
    /**
     * Expand returns next key material of the given length.
     *
     * It throws if expansion limit is reached (which is
     * 254 digests of the underlying HMAC function).
     */ HKDF.prototype.expand = function(length) {
        var out = new Uint8Array(length);
        for(var i = 0; i < out.length; i++){
            if (this._bufpos === this._buffer.length) this._fillBuffer();
            out[i] = this._buffer[this._bufpos++];
        }
        return out;
    };
    HKDF.prototype.clean = function() {
        this._hmac.clean();
        $276678191c4bdb56$exports.wipe(this._buffer);
        $276678191c4bdb56$exports.wipe(this._counter);
        this._bufpos = 0;
    };
    return HKDF;
}();
$eea881cb204cba82$exports.HKDF = $eea881cb204cba82$var$HKDF; // TODO(dchest): maybe implement deriveKey?



var $66651f7624f8a7c0$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($66651f7624f8a7c0$exports, "__esModule", {
    value: true
});


$66651f7624f8a7c0$exports.DIGEST_LENGTH = 32;
$66651f7624f8a7c0$exports.BLOCK_SIZE = 64;
/**
 * SHA2-256 cryptographic hash algorithm.
 */ var $66651f7624f8a7c0$var$SHA256 = /** @class */ function() {
    function SHA256() {
        /** Length of hash output */ this.digestLength = $66651f7624f8a7c0$exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = $66651f7624f8a7c0$exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._state = new Int32Array(8); // hash state
        this._temp = new Int32Array(64); // temporary state
        this._buffer = new Uint8Array(128); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA256.prototype._initState = function() {
        this._state[0] = 0x6a09e667;
        this._state[1] = 0xbb67ae85;
        this._state[2] = 0x3c6ef372;
        this._state[3] = 0xa54ff53a;
        this._state[4] = 0x510e527f;
        this._state[5] = 0x9b05688c;
        this._state[6] = 0x1f83d9ab;
        this._state[7] = 0x5be0cd19;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA256.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA256.prototype.clean = function() {
        $276678191c4bdb56$exports.wipe(this._buffer);
        $276678191c4bdb56$exports.wipe(this._temp);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA256.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA256: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < this.blockSize && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $66651f7624f8a7c0$var$hashBlocks(this._temp, this._state, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $66651f7624f8a7c0$var$hashBlocks(this._temp, this._state, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA256.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 64 < 56 ? 64 : 128;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $ddd89ca0ca71c6d3$exports.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $ddd89ca0ca71c6d3$exports.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $66651f7624f8a7c0$var$hashBlocks(this._temp, this._state, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 4; i++)$ddd89ca0ca71c6d3$exports.writeUint32BE(this._state[i], out, i * 4);
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA256.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Returns hash state to be used with restoreState().
     * Only chain value is saved, not buffers or other
     * state variables.
     */ SHA256.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            state: new Int32Array(this._state),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Restores state saved by saveState() and sets bytesHashed
     * to the given value.
     */ SHA256.prototype.restoreState = function(savedState) {
        this._state.set(savedState.state);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA256.prototype.cleanSavedState = function(savedState) {
        $276678191c4bdb56$exports.wipe(savedState.state);
        if (savedState.buffer) $276678191c4bdb56$exports.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA256;
}();
$66651f7624f8a7c0$exports.SHA256 = $66651f7624f8a7c0$var$SHA256;
// Constants
var $66651f7624f8a7c0$var$K = new Int32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
function $66651f7624f8a7c0$var$hashBlocks(w, v, p, pos, len) {
    while(len >= 64){
        var a = v[0];
        var b = v[1];
        var c = v[2];
        var d = v[3];
        var e = v[4];
        var f = v[5];
        var g = v[6];
        var h = v[7];
        for(var i = 0; i < 16; i++){
            var j = pos + i * 4;
            w[i] = $ddd89ca0ca71c6d3$exports.readUint32BE(p, j);
        }
        for(var i = 16; i < 64; i++){
            var u = w[i - 2];
            var t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
            u = w[i - 15];
            var t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
            w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
        }
        for(var i = 0; i < 64; i++){
            var t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + ($66651f7624f8a7c0$var$K[i] + w[i] | 0) | 0) | 0;
            var t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
            h = g;
            g = f;
            f = e;
            e = d + t1 | 0;
            d = c;
            c = b;
            b = a;
            a = t1 + t2 | 0;
        }
        v[0] += a;
        v[1] += b;
        v[2] += c;
        v[3] += d;
        v[4] += e;
        v[5] += f;
        v[6] += g;
        v[7] += h;
        pos += 64;
        len -= 64;
    }
    return pos;
}
function $66651f7624f8a7c0$var$hash(data) {
    var h = new $66651f7624f8a7c0$var$SHA256();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$66651f7624f8a7c0$exports.hash = $66651f7624f8a7c0$var$hash;


var $569072827d3d60aa$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($569072827d3d60aa$exports, "__esModule", {
    value: true
});
$569072827d3d60aa$exports.sharedKey = $569072827d3d60aa$exports.generateKeyPair = $569072827d3d60aa$exports.generateKeyPairFromSeed = $569072827d3d60aa$exports.scalarMultBase = $569072827d3d60aa$exports.scalarMult = $569072827d3d60aa$exports.SHARED_KEY_LENGTH = $569072827d3d60aa$exports.SECRET_KEY_LENGTH = $569072827d3d60aa$exports.PUBLIC_KEY_LENGTH = void 0;


$569072827d3d60aa$exports.PUBLIC_KEY_LENGTH = 32;
$569072827d3d60aa$exports.SECRET_KEY_LENGTH = 32;
$569072827d3d60aa$exports.SHARED_KEY_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $569072827d3d60aa$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $569072827d3d60aa$var$_9 = new Uint8Array(32);
$569072827d3d60aa$var$_9[0] = 9;
const $569072827d3d60aa$var$_121665 = $569072827d3d60aa$var$gf([
    0xdb41,
    1
]);
function $569072827d3d60aa$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $569072827d3d60aa$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $569072827d3d60aa$var$pack25519(o, n) {
    const m = $569072827d3d60aa$var$gf();
    const t = $569072827d3d60aa$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $569072827d3d60aa$var$car25519(t);
    $569072827d3d60aa$var$car25519(t);
    $569072827d3d60aa$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $569072827d3d60aa$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $569072827d3d60aa$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $569072827d3d60aa$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $569072827d3d60aa$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $569072827d3d60aa$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $569072827d3d60aa$var$square(o, a) {
    $569072827d3d60aa$var$mul(o, a, a);
}
function $569072827d3d60aa$var$inv25519(o, inp) {
    const c = $569072827d3d60aa$var$gf();
    for(let i = 0; i < 16; i++)c[i] = inp[i];
    for(let i = 253; i >= 0; i--){
        $569072827d3d60aa$var$square(c, c);
        if (i !== 2 && i !== 4) $569072827d3d60aa$var$mul(c, c, inp);
    }
    for(let i = 0; i < 16; i++)o[i] = c[i];
}
function $569072827d3d60aa$var$scalarMult(n, p) {
    const z = new Uint8Array(32);
    const x = new Float64Array(80);
    const a = $569072827d3d60aa$var$gf(), b = $569072827d3d60aa$var$gf(), c = $569072827d3d60aa$var$gf(), d = $569072827d3d60aa$var$gf(), e = $569072827d3d60aa$var$gf(), f = $569072827d3d60aa$var$gf();
    for(let i = 0; i < 31; i++)z[i] = n[i];
    z[31] = n[31] & 127 | 64;
    z[0] &= 248;
    $569072827d3d60aa$var$unpack25519(x, p);
    for(let i = 0; i < 16; i++)b[i] = x[i];
    a[0] = d[0] = 1;
    for(let i = 254; i >= 0; --i){
        const r = z[i >>> 3] >>> (i & 7) & 1;
        $569072827d3d60aa$var$sel25519(a, b, r);
        $569072827d3d60aa$var$sel25519(c, d, r);
        $569072827d3d60aa$var$add(e, a, c);
        $569072827d3d60aa$var$sub(a, a, c);
        $569072827d3d60aa$var$add(c, b, d);
        $569072827d3d60aa$var$sub(b, b, d);
        $569072827d3d60aa$var$square(d, e);
        $569072827d3d60aa$var$square(f, a);
        $569072827d3d60aa$var$mul(a, c, a);
        $569072827d3d60aa$var$mul(c, b, e);
        $569072827d3d60aa$var$add(e, a, c);
        $569072827d3d60aa$var$sub(a, a, c);
        $569072827d3d60aa$var$square(b, a);
        $569072827d3d60aa$var$sub(c, d, f);
        $569072827d3d60aa$var$mul(a, c, $569072827d3d60aa$var$_121665);
        $569072827d3d60aa$var$add(a, a, d);
        $569072827d3d60aa$var$mul(c, c, a);
        $569072827d3d60aa$var$mul(a, d, f);
        $569072827d3d60aa$var$mul(d, b, x);
        $569072827d3d60aa$var$square(b, e);
        $569072827d3d60aa$var$sel25519(a, b, r);
        $569072827d3d60aa$var$sel25519(c, d, r);
    }
    for(let i = 0; i < 16; i++){
        x[i + 16] = a[i];
        x[i + 32] = c[i];
        x[i + 48] = b[i];
        x[i + 64] = d[i];
    }
    const x32 = x.subarray(32);
    const x16 = x.subarray(16);
    $569072827d3d60aa$var$inv25519(x32, x32);
    $569072827d3d60aa$var$mul(x16, x16, x32);
    const q = new Uint8Array(32);
    $569072827d3d60aa$var$pack25519(q, x16);
    return q;
}
$569072827d3d60aa$exports.scalarMult = $569072827d3d60aa$var$scalarMult;
function $569072827d3d60aa$var$scalarMultBase(n) {
    return $569072827d3d60aa$var$scalarMult(n, $569072827d3d60aa$var$_9);
}
$569072827d3d60aa$exports.scalarMultBase = $569072827d3d60aa$var$scalarMultBase;
function $569072827d3d60aa$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== $569072827d3d60aa$exports.SECRET_KEY_LENGTH) throw new Error(`x25519: seed must be ${$569072827d3d60aa$exports.SECRET_KEY_LENGTH} bytes`);
    const secretKey = new Uint8Array(seed);
    const publicKey = $569072827d3d60aa$var$scalarMultBase(secretKey);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
$569072827d3d60aa$exports.generateKeyPairFromSeed = $569072827d3d60aa$var$generateKeyPairFromSeed;
function $569072827d3d60aa$var$generateKeyPair(prng) {
    const seed = (0, $73945d82524e104e$exports.randomBytes)(32, prng);
    const result = $569072827d3d60aa$var$generateKeyPairFromSeed(seed);
    (0, $276678191c4bdb56$exports.wipe)(seed);
    return result;
}
$569072827d3d60aa$exports.generateKeyPair = $569072827d3d60aa$var$generateKeyPair;
/**
 * Returns a shared key between our secret key and a peer's public key.
 *
 * Throws an error if the given keys are of wrong length.
 *
 * If rejectZero is true throws if the calculated shared key is all-zero.
 * From RFC 7748:
 *
 * > Protocol designers using Diffie-Hellman over the curves defined in
 * > this document must not assume "contributory behavior".  Specially,
 * > contributory behavior means that both parties' private keys
 * > contribute to the resulting shared key.  Since curve25519 and
 * > curve448 have cofactors of 8 and 4 (respectively), an input point of
 * > small order will eliminate any contribution from the other party's
 * > private key.  This situation can be detected by checking for the all-
 * > zero output, which implementations MAY do, as specified in Section 6.
 * > However, a large number of existing implementations do not do this.
 *
 * IMPORTANT: the returned key is a raw result of scalar multiplication.
 * To use it as a key material, hash it with a cryptographic hash function.
 */ function $569072827d3d60aa$var$sharedKey(mySecretKey, theirPublicKey, rejectZero = false) {
    if (mySecretKey.length !== $569072827d3d60aa$exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect secret key length");
    if (theirPublicKey.length !== $569072827d3d60aa$exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect public key length");
    const result = $569072827d3d60aa$var$scalarMult(mySecretKey, theirPublicKey);
    if (rejectZero) {
        let zeros = 0;
        for(let i = 0; i < result.length; i++)zeros |= result[i];
        if (zeros === 0) throw new Error("X25519: invalid shared key");
    }
    return result;
}
$569072827d3d60aa$exports.sharedKey = $569072827d3d60aa$var$sharedKey;


var $74e9859baf4497ef$exports = {};
"use strict";
Object.defineProperty($74e9859baf4497ef$exports, "__esModule", {
    value: true
});
var $3a397656998e9fe7$exports = {};
"use strict";
Object.defineProperty($3a397656998e9fe7$exports, "__esModule", {
    value: true
});
function $3a397656998e9fe7$var$compare(a, b) {
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}
$3a397656998e9fe7$exports.compare = $3a397656998e9fe7$var$compare;



var $41b0be3b2401ec7e$exports = {};
"use strict";
Object.defineProperty($41b0be3b2401ec7e$exports, "__esModule", {
    value: true
});
function $41b0be3b2401ec7e$var$equals(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
$41b0be3b2401ec7e$exports.equals = $41b0be3b2401ec7e$var$equals;




var $61fd98a3451cab50$exports = {};
"use strict";
Object.defineProperty($61fd98a3451cab50$exports, "__esModule", {
    value: true
});


function $61fd98a3451cab50$var$xor(a, b) {
    if (a.length !== b.length) throw new Error("Inputs should have the same length");
    const result = $6082a548169c7b42$exports.allocUnsafe(a.length);
    for(let i = 0; i < a.length; i++)result[i] = a[i] ^ b[i];
    return $784ac8dd0f23c14d$exports.asUint8Array(result);
}
$61fd98a3451cab50$exports.xor = $61fd98a3451cab50$var$xor;


$74e9859baf4497ef$exports.compare = $3a397656998e9fe7$exports.compare;
$74e9859baf4497ef$exports.concat = $475c4a512fd4a246$exports.concat;
$74e9859baf4497ef$exports.equals = $41b0be3b2401ec7e$exports.equals;
$74e9859baf4497ef$exports.fromString = $a4ed053a1131469e$exports.fromString;
$74e9859baf4497ef$exports.toString = $bdf44057d833ab1f$exports.toString;
$74e9859baf4497ef$exports.xor = $61fd98a3451cab50$exports.xor;



var $hPtJY = parcelRequire("hPtJY");
var $48968958eb8b72e8$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $48968958eb8b72e8$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var $48968958eb8b72e8$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = $hPtJY.platform;
    }
    return NodeInfo;
}();
var $48968958eb8b72e8$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var $48968958eb8b72e8$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $48968958eb8b72e8$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $48968958eb8b72e8$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $48968958eb8b72e8$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $48968958eb8b72e8$var$REQUIRED_VERSION_PARTS = 3;
var $48968958eb8b72e8$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $48968958eb8b72e8$var$SEARCHBOX_UA_REGEX
    ]
];
var $48968958eb8b72e8$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Windows CE",
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function $48968958eb8b72e8$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $48968958eb8b72e8$export$1184956100eddc3c(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new $48968958eb8b72e8$export$7c78fe95a9d9b03e();
    if (typeof navigator !== "undefined") return $48968958eb8b72e8$export$1184956100eddc3c(navigator.userAgent);
    return $48968958eb8b72e8$export$bf2c6630ab904918();
}
function $48968958eb8b72e8$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && $48968958eb8b72e8$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $48968958eb8b72e8$export$89ca9f8ca1a50fd5(ua) {
    var data = $48968958eb8b72e8$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $48968958eb8b72e8$export$1184956100eddc3c(ua) {
    var matchedRule = $48968958eb8b72e8$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $48968958eb8b72e8$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split(".").join("_").split("_").slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $48968958eb8b72e8$var$REQUIRED_VERSION_PARTS) versionParts = $48968958eb8b72e8$var$__spreadArray($48968958eb8b72e8$var$__spreadArray([], versionParts, true), $48968958eb8b72e8$var$createVersionParts($48968958eb8b72e8$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = $48968958eb8b72e8$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $48968958eb8b72e8$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $48968958eb8b72e8$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $48968958eb8b72e8$export$8fa985da04a86f0(name, version, os);
}
function $48968958eb8b72e8$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $48968958eb8b72e8$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $48968958eb8b72e8$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $48968958eb8b72e8$export$bf2c6630ab904918() {
    var isNode = typeof $hPtJY !== "undefined" && $hPtJY.version;
    return isNode ? new $48968958eb8b72e8$export$62457c674e0167c0($hPtJY.version.slice(1)) : null;
}
function $48968958eb8b72e8$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}



var $aG48A = parcelRequire("aG48A");
var $9cba2bd26fe13e26$exports = {};
"use strict";
Object.defineProperty($9cba2bd26fe13e26$exports, "__esModule", {
    value: true
});
$9cba2bd26fe13e26$exports.getLocalStorage = $9cba2bd26fe13e26$exports.getLocalStorageOrThrow = $9cba2bd26fe13e26$exports.getCrypto = $9cba2bd26fe13e26$exports.getCryptoOrThrow = $9cba2bd26fe13e26$exports.getLocation = $9cba2bd26fe13e26$exports.getLocationOrThrow = $9cba2bd26fe13e26$exports.getNavigator = $9cba2bd26fe13e26$exports.getNavigatorOrThrow = $9cba2bd26fe13e26$exports.getDocument = $9cba2bd26fe13e26$exports.getDocumentOrThrow = $9cba2bd26fe13e26$exports.getFromWindowOrThrow = $9cba2bd26fe13e26$exports.getFromWindow = void 0;
function $9cba2bd26fe13e26$var$getFromWindow(name) {
    let res = undefined;
    if (typeof window !== "undefined" && typeof window[name] !== "undefined") res = window[name];
    return res;
}
$9cba2bd26fe13e26$exports.getFromWindow = $9cba2bd26fe13e26$var$getFromWindow;
function $9cba2bd26fe13e26$var$getFromWindowOrThrow(name) {
    const res = $9cba2bd26fe13e26$var$getFromWindow(name);
    if (!res) throw new Error(`${name} is not defined in Window`);
    return res;
}
$9cba2bd26fe13e26$exports.getFromWindowOrThrow = $9cba2bd26fe13e26$var$getFromWindowOrThrow;
function $9cba2bd26fe13e26$var$getDocumentOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("document");
}
$9cba2bd26fe13e26$exports.getDocumentOrThrow = $9cba2bd26fe13e26$var$getDocumentOrThrow;
function $9cba2bd26fe13e26$var$getDocument() {
    return $9cba2bd26fe13e26$var$getFromWindow("document");
}
$9cba2bd26fe13e26$exports.getDocument = $9cba2bd26fe13e26$var$getDocument;
function $9cba2bd26fe13e26$var$getNavigatorOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("navigator");
}
$9cba2bd26fe13e26$exports.getNavigatorOrThrow = $9cba2bd26fe13e26$var$getNavigatorOrThrow;
function $9cba2bd26fe13e26$var$getNavigator() {
    return $9cba2bd26fe13e26$var$getFromWindow("navigator");
}
$9cba2bd26fe13e26$exports.getNavigator = $9cba2bd26fe13e26$var$getNavigator;
function $9cba2bd26fe13e26$var$getLocationOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("location");
}
$9cba2bd26fe13e26$exports.getLocationOrThrow = $9cba2bd26fe13e26$var$getLocationOrThrow;
function $9cba2bd26fe13e26$var$getLocation() {
    return $9cba2bd26fe13e26$var$getFromWindow("location");
}
$9cba2bd26fe13e26$exports.getLocation = $9cba2bd26fe13e26$var$getLocation;
function $9cba2bd26fe13e26$var$getCryptoOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("crypto");
}
$9cba2bd26fe13e26$exports.getCryptoOrThrow = $9cba2bd26fe13e26$var$getCryptoOrThrow;
function $9cba2bd26fe13e26$var$getCrypto() {
    return $9cba2bd26fe13e26$var$getFromWindow("crypto");
}
$9cba2bd26fe13e26$exports.getCrypto = $9cba2bd26fe13e26$var$getCrypto;
function $9cba2bd26fe13e26$var$getLocalStorageOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("localStorage");
}
$9cba2bd26fe13e26$exports.getLocalStorageOrThrow = $9cba2bd26fe13e26$var$getLocalStorageOrThrow;
function $9cba2bd26fe13e26$var$getLocalStorage() {
    return $9cba2bd26fe13e26$var$getFromWindow("localStorage");
}
$9cba2bd26fe13e26$exports.getLocalStorage = $9cba2bd26fe13e26$var$getLocalStorage;


var $6824eb17eeee766a$exports = {};
"use strict";
Object.defineProperty($6824eb17eeee766a$exports, "__esModule", {
    value: true
});
$6824eb17eeee766a$exports.getWindowMetadata = void 0;

function $6824eb17eeee766a$var$getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = $9cba2bd26fe13e26$exports.getDocumentOrThrow();
        loc = $9cba2bd26fe13e26$exports.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
$6824eb17eeee766a$exports.getWindowMetadata = $6824eb17eeee766a$var$getWindowMetadata;


var $3ecb7368762fc268$export$f9380c9a627682d3;
var $3ecb7368762fc268$export$98e6a39c04603d36;
var $3ecb7368762fc268$export$fac44ee5b035f737;
var $3ecb7368762fc268$export$7a5253c0f62e0150;
var $3ecb7368762fc268$export$a8c1621ea79325d3;
var $3ecb7368762fc268$export$357523c63a2253b9;
var $3ecb7368762fc268$export$44c361b8ec72ef7f;
"use strict";
var $2854ab6fe5249e91$exports = {};
"use strict";
$2854ab6fe5249e91$exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);


var $40bbc24beab9f9b8$exports = {};
"use strict";
var $40bbc24beab9f9b8$var$token = "%[a-f0-9]{2}";
var $40bbc24beab9f9b8$var$singleMatcher = new RegExp("(" + $40bbc24beab9f9b8$var$token + ")|([^%]+?)", "gi");
var $40bbc24beab9f9b8$var$multiMatcher = new RegExp("(" + $40bbc24beab9f9b8$var$token + ")+", "gi");
function $40bbc24beab9f9b8$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $40bbc24beab9f9b8$var$decodeComponents(left), $40bbc24beab9f9b8$var$decodeComponents(right));
}
function $40bbc24beab9f9b8$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($40bbc24beab9f9b8$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $40bbc24beab9f9b8$var$decodeComponents(tokens, i).join("");
            tokens = input.match($40bbc24beab9f9b8$var$singleMatcher) || [];
        }
        return input;
    }
}
function $40bbc24beab9f9b8$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $40bbc24beab9f9b8$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
$40bbc24beab9f9b8$exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $40bbc24beab9f9b8$var$customDecodeURIComponent(encodedURI);
    }
};


var $08bd16383ca1ef3d$exports = {};
"use strict";
$08bd16383ca1ef3d$exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};


var $36fe9d1ef26e3f64$exports = {};
"use strict";
$36fe9d1ef26e3f64$exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};


const $3ecb7368762fc268$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $3ecb7368762fc268$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $3ecb7368762fc268$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[",
                            $3ecb7368762fc268$var$encode(index, options),
                            "]=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[]=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            ":list=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $3ecb7368762fc268$var$encode(key, options),
                                keyValueSep,
                                $3ecb7368762fc268$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $3ecb7368762fc268$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $3ecb7368762fc268$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $3ecb7368762fc268$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $3ecb7368762fc268$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $3ecb7368762fc268$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$3ecb7368762fc268$var$decode(item, options)) : value === null ? value : $3ecb7368762fc268$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $3ecb7368762fc268$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$3ecb7368762fc268$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $3ecb7368762fc268$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $3ecb7368762fc268$var$encode(value, options) {
    if (options.encode) return options.strict ? $2854ab6fe5249e91$exports(value) : encodeURIComponent(value);
    return value;
}
function $3ecb7368762fc268$var$decode(value, options) {
    if (options.decode) return $40bbc24beab9f9b8$exports(value);
    return value;
}
function $3ecb7368762fc268$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $3ecb7368762fc268$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $3ecb7368762fc268$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $3ecb7368762fc268$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $3ecb7368762fc268$var$extract(input) {
    input = $3ecb7368762fc268$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $3ecb7368762fc268$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $3ecb7368762fc268$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $3ecb7368762fc268$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $3ecb7368762fc268$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $08bd16383ca1ef3d$exports(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $3ecb7368762fc268$var$decode(value, options);
        formatter($3ecb7368762fc268$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $3ecb7368762fc268$var$parseValue(value[k], options);
        else ret[key] = $3ecb7368762fc268$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $3ecb7368762fc268$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$3ecb7368762fc268$export$f9380c9a627682d3 = $3ecb7368762fc268$var$extract;
$3ecb7368762fc268$export$98e6a39c04603d36 = $3ecb7368762fc268$var$parse;
$3ecb7368762fc268$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $3ecb7368762fc268$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $3ecb7368762fc268$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $3ecb7368762fc268$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $3ecb7368762fc268$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $3ecb7368762fc268$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $3ecb7368762fc268$var$encode(key, options) + "=" + $3ecb7368762fc268$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$3ecb7368762fc268$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $08bd16383ca1ef3d$exports(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $3ecb7368762fc268$var$parse($3ecb7368762fc268$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $3ecb7368762fc268$var$decode(hash, options)
    } : {});
};
$3ecb7368762fc268$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$3ecb7368762fc268$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $3ecb7368762fc268$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $3ecb7368762fc268$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $3ecb7368762fc268$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $3ecb7368762fc268$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $3ecb7368762fc268$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$3ecb7368762fc268$var$encodeFragmentIdentifier] ? $3ecb7368762fc268$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$3ecb7368762fc268$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$3ecb7368762fc268$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $3ecb7368762fc268$export$7a5253c0f62e0150(input, options);
    return $3ecb7368762fc268$export$a8c1621ea79325d3({
        url: url,
        query: $36fe9d1ef26e3f64$exports(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$3ecb7368762fc268$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $3ecb7368762fc268$export$357523c63a2253b9(input, exclusionFilter, options);
};


var $6c5e0cebe7c6e693$exports = {};
$parcel$export($6c5e0cebe7c6e693$exports, "RELAY_JSONRPC", () => $a66838b5a814eb12$export$af490b3b9a6de00f);
var $7dcde13c6df73f83$exports = {};


function $770bbe0a33a0b266$export$804de46662e4ac95(obj, key, type = "string") {
    if (!obj[key] || typeof obj[key] !== type) throw new Error(`Missing or invalid "${key}" param`);
}
function $770bbe0a33a0b266$export$c538c02216fcdc03(params, required) {
    let matches = true;
    required.forEach((key)=>{
        const exists = key in params;
        if (!exists) matches = false;
    });
    return matches;
}
function $770bbe0a33a0b266$export$e4b3f942a6d00ef9(params, length) {
    return Array.isArray(params) ? params.length === length : Object.keys(params).length === length;
}
function $770bbe0a33a0b266$export$8fcd263f2845753e(params, minLength) {
    return Array.isArray(params) ? params.length >= minLength : Object.keys(params).length >= minLength;
}
function $770bbe0a33a0b266$export$19e8e281e27dafad(params, required, optional) {
    const exact = !optional.length;
    const matchesLength = exact ? $770bbe0a33a0b266$export$e4b3f942a6d00ef9(params, required.length) : $770bbe0a33a0b266$export$8fcd263f2845753e(params, required.length);
    if (!matchesLength) return false;
    return $770bbe0a33a0b266$export$c538c02216fcdc03(params, required);
}
function $770bbe0a33a0b266$export$18337b4ba58d5c33(method, expected, separator = "_") {
    const split = method.split(separator);
    return split[split.length - 1].trim().toLowerCase() === expected.trim().toLowerCase();
}



function $d7228e581edf756b$export$c75580565fa025bd(request) {
    return $d7228e581edf756b$export$f576347163de0984(request.method) && $d7228e581edf756b$export$dae2311546d43680(request.params);
}
function $d7228e581edf756b$export$f576347163de0984(method) {
    return (0, $770bbe0a33a0b266$export$18337b4ba58d5c33)(method, "subscribe");
}
function $d7228e581edf756b$export$dae2311546d43680(params) {
    const required = [
        "topic"
    ];
    const optional = [];
    return (0, $770bbe0a33a0b266$export$19e8e281e27dafad)(params, required, optional);
}
function $d7228e581edf756b$export$8fa7cf76b41caee0(request) {
    return $d7228e581edf756b$export$71d4d33ac7f7a269(request.method) && $d7228e581edf756b$export$71e8d1aa48c3e86f(request.params);
}
function $d7228e581edf756b$export$71d4d33ac7f7a269(method) {
    return (0, $770bbe0a33a0b266$export$18337b4ba58d5c33)(method, "publish");
}
function $d7228e581edf756b$export$71e8d1aa48c3e86f(params) {
    const required = [
        "message",
        "topic",
        "ttl"
    ];
    const optional = [
        "prompt",
        "tag"
    ];
    return (0, $770bbe0a33a0b266$export$19e8e281e27dafad)(params, required, optional);
}
function $d7228e581edf756b$export$83e292763180b41b(request) {
    return $d7228e581edf756b$export$568d956f39536025(request.method) && $d7228e581edf756b$export$cbc597c53c3b4f80(request.params);
}
function $d7228e581edf756b$export$568d956f39536025(method) {
    return (0, $770bbe0a33a0b266$export$18337b4ba58d5c33)(method, "unsubscribe");
}
function $d7228e581edf756b$export$cbc597c53c3b4f80(params) {
    const required = [
        "id",
        "topic"
    ];
    const optional = [];
    return (0, $770bbe0a33a0b266$export$19e8e281e27dafad)(params, required, optional);
}
function $d7228e581edf756b$export$43cf4100d6287b8e(request) {
    return $d7228e581edf756b$export$3cb4ad320e3a46a4(request.method) && $d7228e581edf756b$export$6366ff9a39f2da4c(request.params);
}
function $d7228e581edf756b$export$3cb4ad320e3a46a4(method) {
    return (0, $770bbe0a33a0b266$export$18337b4ba58d5c33)(method, "subscription");
}
function $d7228e581edf756b$export$6366ff9a39f2da4c(params) {
    const required = [
        "id",
        "data"
    ];
    const optional = [];
    return (0, $770bbe0a33a0b266$export$19e8e281e27dafad)(params, required, optional);
}


function $a40d50f3c8928009$export$abdf96c288cb375(request) {
    if (!(0, $d7228e581edf756b$export$f576347163de0984)(request.method)) throw new Error("JSON-RPC Request has invalid subscribe method");
    if (!(0, $d7228e581edf756b$export$dae2311546d43680)(request.params)) throw new Error("JSON-RPC Request has invalid subscribe params");
    const params = request.params;
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "topic");
    return params;
}
function $a40d50f3c8928009$export$eac3e45ac5c5c9fa(request) {
    if (!(0, $d7228e581edf756b$export$71d4d33ac7f7a269)(request.method)) throw new Error("JSON-RPC Request has invalid publish method");
    if (!(0, $d7228e581edf756b$export$71e8d1aa48c3e86f)(request.params)) throw new Error("JSON-RPC Request has invalid publish params");
    const params = request.params;
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "topic");
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "message");
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "ttl", "number");
    return params;
}
function $a40d50f3c8928009$export$78baa72f78156594(request) {
    if (!(0, $d7228e581edf756b$export$568d956f39536025)(request.method)) throw new Error("JSON-RPC Request has invalid unsubscribe method");
    if (!(0, $d7228e581edf756b$export$cbc597c53c3b4f80)(request.params)) throw new Error("JSON-RPC Request has invalid unsubscribe params");
    const params = request.params;
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "id");
    return params;
}
function $a40d50f3c8928009$export$4d5822edd41f3b48(request) {
    if (!(0, $d7228e581edf756b$export$3cb4ad320e3a46a4)(request.method)) throw new Error("JSON-RPC Request has invalid subscription method");
    if (!(0, $d7228e581edf756b$export$6366ff9a39f2da4c)(request.params)) throw new Error("JSON-RPC Request has invalid subscription params");
    const params = request.params;
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "id");
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "data");
    return params;
}


const $a66838b5a814eb12$export$af490b3b9a6de00f = {
    waku: {
        publish: "waku_publish",
        batchPublish: "waku_batchPublish",
        subscribe: "waku_subscribe",
        batchSubscribe: "waku_batchSubscribe",
        subscription: "waku_subscription",
        unsubscribe: "waku_unsubscribe",
        batchUnsubscribe: "waku_batchUnsubscribe"
    },
    irn: {
        publish: "irn_publish",
        batchPublish: "irn_batchPublish",
        subscribe: "irn_subscribe",
        batchSubscribe: "irn_batchSubscribe",
        subscription: "irn_subscription",
        unsubscribe: "irn_unsubscribe",
        batchUnsubscribe: "irn_batchUnsubscribe"
    },
    iridium: {
        publish: "iridium_publish",
        batchPublish: "iridium_batchPublish",
        subscribe: "iridium_subscribe",
        batchSubscribe: "iridium_batchSubscribe",
        subscription: "iridium_subscription",
        unsubscribe: "iridium_unsubscribe",
        batchUnsubscribe: "iridium_batchUnsubscribe"
    }
};



$parcel$exportWildcard($6c5e0cebe7c6e693$exports, $7dcde13c6df73f83$exports);



var $hPtJY = parcelRequire("hPtJY");
const $a5d33cfc7f8e5437$var$K = ":";
function $a5d33cfc7f8e5437$export$4764229d78de4437(e) {
    const [n, t] = e.split($a5d33cfc7f8e5437$var$K);
    return {
        namespace: n,
        reference: t
    };
}
function $a5d33cfc7f8e5437$export$a5999672e4930644(e) {
    const { namespace: n, reference: t } = e;
    return [
        n,
        t
    ].join($a5d33cfc7f8e5437$var$K);
}
function $a5d33cfc7f8e5437$export$276ab0158c66e3d(e) {
    const [n, t, r] = e.split($a5d33cfc7f8e5437$var$K);
    return {
        namespace: n,
        reference: t,
        address: r
    };
}
function $a5d33cfc7f8e5437$export$566a25328fb93a18(e) {
    const { namespace: n, reference: t, address: r } = e;
    return [
        n,
        t,
        r
    ].join($a5d33cfc7f8e5437$var$K);
}
function $a5d33cfc7f8e5437$export$d579bc26e95946b5(e, n) {
    const t = [];
    return e.forEach((r)=>{
        const o = n(r);
        t.includes(o) || t.push(o);
    }), t;
}
function $a5d33cfc7f8e5437$export$2806d446053abd1d(e) {
    const { address: n } = $a5d33cfc7f8e5437$export$276ab0158c66e3d(e);
    return n;
}
function $a5d33cfc7f8e5437$export$93512919ec2ab555(e) {
    const { namespace: n, reference: t } = $a5d33cfc7f8e5437$export$276ab0158c66e3d(e);
    return $a5d33cfc7f8e5437$export$a5999672e4930644({
        namespace: n,
        reference: t
    });
}
function $a5d33cfc7f8e5437$export$40283ddc77f27f6e(e, n) {
    const { namespace: t, reference: r } = $a5d33cfc7f8e5437$export$4764229d78de4437(n);
    return $a5d33cfc7f8e5437$export$566a25328fb93a18({
        namespace: t,
        reference: r,
        address: e
    });
}
function $a5d33cfc7f8e5437$export$aa4a6b630dfcfa83(e) {
    return $a5d33cfc7f8e5437$export$d579bc26e95946b5(e, $a5d33cfc7f8e5437$export$2806d446053abd1d);
}
function $a5d33cfc7f8e5437$export$d5ee58c6b13696e9(e) {
    return $a5d33cfc7f8e5437$export$d579bc26e95946b5(e, $a5d33cfc7f8e5437$export$93512919ec2ab555);
}
function $a5d33cfc7f8e5437$export$23329703ad972840(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...o.accounts);
    }), t;
}
function $a5d33cfc7f8e5437$export$6281ff29da5f85fe(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$a5d33cfc7f8e5437$export$d5ee58c6b13696e9(o.accounts));
    }), t;
}
function $a5d33cfc7f8e5437$export$d1109eeb751412cf(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$a5d33cfc7f8e5437$export$376384387cd15b27(r, o));
    }), t;
}
function $a5d33cfc7f8e5437$export$376384387cd15b27(e, n) {
    return e.includes(":") ? [
        e
    ] : n.chains || [];
}
const $a5d33cfc7f8e5437$export$a524ae552db7912 = (e)=>e?.split(":"), $a5d33cfc7f8e5437$export$85f23c05c80b194 = (e)=>{
    const n = e && $a5d33cfc7f8e5437$export$a524ae552db7912(e);
    if (n) return n[3];
}, $a5d33cfc7f8e5437$export$a8b149927aef7051 = (e)=>{
    const n = e && $a5d33cfc7f8e5437$export$a524ae552db7912(e);
    if (n) return n[2] + ":" + n[3];
}, $a5d33cfc7f8e5437$export$bf43cfbb4bd95de9 = (e)=>{
    const n = e && $a5d33cfc7f8e5437$export$a524ae552db7912(e);
    if (n) return n.pop();
}, $a5d33cfc7f8e5437$export$25868d1e8e76735f = (e, n)=>{
    const t = `${e.domain} wants you to sign in with your Ethereum account:`, r = $a5d33cfc7f8e5437$export$bf43cfbb4bd95de9(n), o = e.statement, s = `URI: ${e.aud}`, i = `Version: ${e.version}`, d = `Chain ID: ${$a5d33cfc7f8e5437$export$85f23c05c80b194(n)}`, l = `Nonce: ${e.nonce}`, c = `Issued At: ${e.iat}`, u = e.resources && e.resources.length > 0 ? `Resources:
${e.resources.map((a)=>`- ${a}`).join(`
`)}` : void 0;
    return [
        t,
        r,
        "",
        o,
        "",
        s,
        i,
        d,
        l,
        c,
        u
    ].filter((a)=>a != null).join(`
`);
}, $a5d33cfc7f8e5437$export$f7403969428298bd = "base10", $a5d33cfc7f8e5437$export$49eb910ab2518105 = "base16", $a5d33cfc7f8e5437$export$9bff723d552e6bcf = "base64pad", $a5d33cfc7f8e5437$export$9560dad2a83e4f04 = "utf8", $a5d33cfc7f8e5437$export$3425bd336a9673d8 = 0, $a5d33cfc7f8e5437$export$406e97c329f0f3d4 = 1, $a5d33cfc7f8e5437$var$Dn = 0, $a5d33cfc7f8e5437$var$Te = 1, $a5d33cfc7f8e5437$var$Z = 12, $a5d33cfc7f8e5437$var$X = 32;
function $a5d33cfc7f8e5437$export$a949d36eab55b41f() {
    const e = $569072827d3d60aa$exports.generateKeyPair();
    return {
        privateKey: (0, $74e9859baf4497ef$exports.toString)(e.secretKey, $a5d33cfc7f8e5437$export$49eb910ab2518105),
        publicKey: (0, $74e9859baf4497ef$exports.toString)(e.publicKey, $a5d33cfc7f8e5437$export$49eb910ab2518105)
    };
}
function $a5d33cfc7f8e5437$export$d15a28e4f1821243() {
    const e = (0, $73945d82524e104e$exports.randomBytes)($a5d33cfc7f8e5437$var$X);
    return (0, $74e9859baf4497ef$exports.toString)(e, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$f8378f68e053f5c6(e, n) {
    const t = $569072827d3d60aa$exports.sharedKey((0, $74e9859baf4497ef$exports.fromString)(e, $a5d33cfc7f8e5437$export$49eb910ab2518105), (0, $74e9859baf4497ef$exports.fromString)(n, $a5d33cfc7f8e5437$export$49eb910ab2518105), !0), r = new (0, $eea881cb204cba82$exports.HKDF)((0, $66651f7624f8a7c0$exports.SHA256), t).expand($a5d33cfc7f8e5437$var$X);
    return (0, $74e9859baf4497ef$exports.toString)(r, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$1e87d19d4aab5805(e) {
    const n = (0, $66651f7624f8a7c0$exports.hash)((0, $74e9859baf4497ef$exports.fromString)(e, $a5d33cfc7f8e5437$export$49eb910ab2518105));
    return (0, $74e9859baf4497ef$exports.toString)(n, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$d4c241cec96564c1(e) {
    const n = (0, $66651f7624f8a7c0$exports.hash)((0, $74e9859baf4497ef$exports.fromString)(e, $a5d33cfc7f8e5437$export$9560dad2a83e4f04));
    return (0, $74e9859baf4497ef$exports.toString)(n, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$e9d2f9ba70428fb6(e) {
    return (0, $74e9859baf4497ef$exports.fromString)(`${e}`, $a5d33cfc7f8e5437$export$f7403969428298bd);
}
function $a5d33cfc7f8e5437$export$7547a514ee29b9d4(e) {
    return Number((0, $74e9859baf4497ef$exports.toString)(e, $a5d33cfc7f8e5437$export$f7403969428298bd));
}
function $a5d33cfc7f8e5437$export$5b0f6292f11d1d18(e) {
    const n = $a5d33cfc7f8e5437$export$e9d2f9ba70428fb6(typeof e.type < "u" ? e.type : $a5d33cfc7f8e5437$export$3425bd336a9673d8);
    if ($a5d33cfc7f8e5437$export$7547a514ee29b9d4(n) === $a5d33cfc7f8e5437$export$406e97c329f0f3d4 && typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const t = typeof e.senderPublicKey < "u" ? (0, $74e9859baf4497ef$exports.fromString)(e.senderPublicKey, $a5d33cfc7f8e5437$export$49eb910ab2518105) : void 0, r = typeof e.iv < "u" ? (0, $74e9859baf4497ef$exports.fromString)(e.iv, $a5d33cfc7f8e5437$export$49eb910ab2518105) : (0, $73945d82524e104e$exports.randomBytes)($a5d33cfc7f8e5437$var$Z), o = new (0, $1ca962bc0b1868f1$exports.ChaCha20Poly1305)((0, $74e9859baf4497ef$exports.fromString)(e.symKey, $a5d33cfc7f8e5437$export$49eb910ab2518105)).seal(r, (0, $74e9859baf4497ef$exports.fromString)(e.message, $a5d33cfc7f8e5437$export$9560dad2a83e4f04));
    return $a5d33cfc7f8e5437$export$dfdc1655ccc5b9cb({
        type: n,
        sealed: o,
        iv: r,
        senderPublicKey: t
    });
}
function $a5d33cfc7f8e5437$export$e85a0c9a1067c5d3(e) {
    const n = new (0, $1ca962bc0b1868f1$exports.ChaCha20Poly1305)((0, $74e9859baf4497ef$exports.fromString)(e.symKey, $a5d33cfc7f8e5437$export$49eb910ab2518105)), { sealed: t, iv: r } = $a5d33cfc7f8e5437$export$efcd34ab6248d3cd(e.encoded), o = n.open(r, t);
    if (o === null) throw new Error("Failed to decrypt");
    return (0, $74e9859baf4497ef$exports.toString)(o, $a5d33cfc7f8e5437$export$9560dad2a83e4f04);
}
function $a5d33cfc7f8e5437$export$dfdc1655ccc5b9cb(e) {
    if ($a5d33cfc7f8e5437$export$7547a514ee29b9d4(e.type) === $a5d33cfc7f8e5437$export$406e97c329f0f3d4) {
        if (typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $74e9859baf4497ef$exports.toString)((0, $74e9859baf4497ef$exports.concat)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), $a5d33cfc7f8e5437$export$9bff723d552e6bcf);
    }
    return (0, $74e9859baf4497ef$exports.toString)((0, $74e9859baf4497ef$exports.concat)([
        e.type,
        e.iv,
        e.sealed
    ]), $a5d33cfc7f8e5437$export$9bff723d552e6bcf);
}
function $a5d33cfc7f8e5437$export$efcd34ab6248d3cd(e) {
    const n = (0, $74e9859baf4497ef$exports.fromString)(e, $a5d33cfc7f8e5437$export$9bff723d552e6bcf), t = n.slice($a5d33cfc7f8e5437$var$Dn, $a5d33cfc7f8e5437$var$Te), r = $a5d33cfc7f8e5437$var$Te;
    if ($a5d33cfc7f8e5437$export$7547a514ee29b9d4(t) === $a5d33cfc7f8e5437$export$406e97c329f0f3d4) {
        const d = r + $a5d33cfc7f8e5437$var$X, l = d + $a5d33cfc7f8e5437$var$Z, c = n.slice(r, d), u = n.slice(d, l), a = n.slice(l);
        return {
            type: t,
            sealed: a,
            iv: u,
            senderPublicKey: c
        };
    }
    const o = r + $a5d33cfc7f8e5437$var$Z, s = n.slice(r, o), i = n.slice(o);
    return {
        type: t,
        sealed: i,
        iv: s
    };
}
function $a5d33cfc7f8e5437$export$177f3e316562333d(e, n) {
    const t = $a5d33cfc7f8e5437$export$efcd34ab6248d3cd(e);
    return $a5d33cfc7f8e5437$export$7949f60f2444aef2({
        type: $a5d33cfc7f8e5437$export$7547a514ee29b9d4(t.type),
        senderPublicKey: typeof t.senderPublicKey < "u" ? (0, $74e9859baf4497ef$exports.toString)(t.senderPublicKey, $a5d33cfc7f8e5437$export$49eb910ab2518105) : void 0,
        receiverPublicKey: n?.receiverPublicKey
    });
}
function $a5d33cfc7f8e5437$export$7949f60f2444aef2(e) {
    const n = e?.type || $a5d33cfc7f8e5437$export$3425bd336a9673d8;
    if (n === $a5d33cfc7f8e5437$export$406e97c329f0f3d4) {
        if (typeof e?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof e?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: n,
        senderPublicKey: e?.senderPublicKey,
        receiverPublicKey: e?.receiverPublicKey
    };
}
function $a5d33cfc7f8e5437$export$8c165704db2d5c15(e) {
    return e.type === $a5d33cfc7f8e5437$export$406e97c329f0f3d4 && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
var $a5d33cfc7f8e5437$var$Bn = Object.defineProperty, $a5d33cfc7f8e5437$var$Ue = Object.getOwnPropertySymbols, $a5d33cfc7f8e5437$var$Gn = Object.prototype.hasOwnProperty, $a5d33cfc7f8e5437$var$Wn = Object.prototype.propertyIsEnumerable, $a5d33cfc7f8e5437$var$_e = (e, n, t)=>n in e ? $a5d33cfc7f8e5437$var$Bn(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $a5d33cfc7f8e5437$var$$e = (e, n)=>{
    for(var t in n || (n = {}))$a5d33cfc7f8e5437$var$Gn.call(n, t) && $a5d33cfc7f8e5437$var$_e(e, t, n[t]);
    if ($a5d33cfc7f8e5437$var$Ue) for (var t of $a5d33cfc7f8e5437$var$Ue(n))$a5d33cfc7f8e5437$var$Wn.call(n, t) && $a5d33cfc7f8e5437$var$_e(e, t, n[t]);
    return e;
};
const $a5d33cfc7f8e5437$export$f12873d77424d47b = "ReactNative", $a5d33cfc7f8e5437$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $a5d33cfc7f8e5437$export$657dee6d5648750a = " ", $a5d33cfc7f8e5437$export$96c3628b3b9d2079 = ":", $a5d33cfc7f8e5437$export$98238152dfccf046 = "/", $a5d33cfc7f8e5437$export$7f882bb969de14a3 = 2, $a5d33cfc7f8e5437$export$77baccb4c6bd5852 = 1e3, $a5d33cfc7f8e5437$export$e08b61c98317d88c = "js";
function $a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee() {
    return typeof $hPtJY < "u" && typeof $hPtJY.versions < "u" && typeof $hPtJY.versions.node < "u";
}
function $a5d33cfc7f8e5437$export$f7a1e23e542d38e3() {
    return !(0, $9cba2bd26fe13e26$exports.getDocument)() && !!(0, $9cba2bd26fe13e26$exports.getNavigator)() && navigator.product === $a5d33cfc7f8e5437$export$f12873d77424d47b;
}
function $a5d33cfc7f8e5437$export$4e09c449d6c407f7() {
    return !$a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee() && !!(0, $9cba2bd26fe13e26$exports.getNavigator)() && !!(0, $9cba2bd26fe13e26$exports.getDocument)();
}
function $a5d33cfc7f8e5437$export$57570b1603cf6adb() {
    return $a5d33cfc7f8e5437$export$f7a1e23e542d38e3() ? $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative : $a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee() ? $a5d33cfc7f8e5437$export$86b1301a63b15dd9.node : $a5d33cfc7f8e5437$export$4e09c449d6c407f7() ? $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser : $a5d33cfc7f8e5437$export$86b1301a63b15dd9.unknown;
}
function $a5d33cfc7f8e5437$export$40a40f90174d197c() {
    var e;
    try {
        return $a5d33cfc7f8e5437$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Application) < "u" ? (e = $parcel$global.Application) == null ? void 0 : e.applicationId : void 0;
    } catch  {
        return;
    }
}
function $a5d33cfc7f8e5437$export$c4147c69f6845da(e, n) {
    let t = $3ecb7368762fc268$export$98e6a39c04603d36(e);
    return t = $a5d33cfc7f8e5437$var$$e($a5d33cfc7f8e5437$var$$e({}, t), n), e = $3ecb7368762fc268$export$fac44ee5b035f737(t), e;
}
function $a5d33cfc7f8e5437$export$ba31e015127122bb() {
    return (0, $6824eb17eeee766a$exports.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $a5d33cfc7f8e5437$export$6b05aa0115b6fc2d(e, n) {
    var t;
    const r = $a5d33cfc7f8e5437$export$57570b1603cf6adb(), o = {
        protocol: e,
        version: n,
        env: r
    };
    return r === "browser" && (o.host = ((t = (0, $9cba2bd26fe13e26$exports.getLocation)()) == null ? void 0 : t.host) || "unknown"), o;
}
function $a5d33cfc7f8e5437$export$20d4a3cb5829b8b6() {
    if ($a5d33cfc7f8e5437$export$57570b1603cf6adb() === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        const { OS: t, Version: r } = $parcel$global.Platform;
        return [
            t,
            r
        ].join("-");
    }
    const e = (0, $48968958eb8b72e8$export$17b446b869dad473)();
    if (e === null) return "unknown";
    const n = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        n,
        e.name,
        e.version
    ].join("-") : [
        n,
        e.version
    ].join("-");
}
function $a5d33cfc7f8e5437$export$4389b0987726d52d() {
    var e;
    const n = $a5d33cfc7f8e5437$export$57570b1603cf6adb();
    return n === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser ? [
        n,
        ((e = (0, $9cba2bd26fe13e26$exports.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : n;
}
function $a5d33cfc7f8e5437$export$b55a4c6e272b719f(e, n, t) {
    const r = $a5d33cfc7f8e5437$export$20d4a3cb5829b8b6(), o = $a5d33cfc7f8e5437$export$4389b0987726d52d();
    return [
        [
            e,
            n
        ].join("-"),
        [
            $a5d33cfc7f8e5437$export$e08b61c98317d88c,
            t
        ].join("-"),
        r,
        o
    ].join("/");
}
function $a5d33cfc7f8e5437$export$d875b3963ef774f5({ protocol: e, version: n, relayUrl: t, sdkVersion: r, auth: o, projectId: s, useOnCloseEvent: i, bundleId: d }) {
    const l = t.split("?"), c = $a5d33cfc7f8e5437$export$b55a4c6e272b719f(e, n, r), u = {
        auth: o,
        ua: c,
        projectId: s,
        useOnCloseEvent: i || void 0,
        origin: d || void 0
    }, a = $a5d33cfc7f8e5437$export$c4147c69f6845da(l[1] || "", u);
    return l[0] + "?" + a;
}
function $a5d33cfc7f8e5437$export$ed08891a8a54eb(e) {
    let n = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const t = typeof n < "u" ? e.split("://")[1] : e;
    return n = n === "wss" ? "https" : "http", [
        n,
        t
    ].join("://");
}
function $a5d33cfc7f8e5437$export$804de46662e4ac95(e, n, t) {
    if (!e[n] || typeof e[n] !== t) throw new Error(`Missing or invalid "${n}" param`);
}
function $a5d33cfc7f8e5437$export$1e21530e896c0b0b(e, n = $a5d33cfc7f8e5437$export$7f882bb969de14a3) {
    return $a5d33cfc7f8e5437$export$7f00885504704576(e.split($a5d33cfc7f8e5437$export$98238152dfccf046), n);
}
function $a5d33cfc7f8e5437$export$80bffd46c37a96f6(e) {
    return $a5d33cfc7f8e5437$export$1e21530e896c0b0b(e).join($a5d33cfc7f8e5437$export$657dee6d5648750a);
}
function $a5d33cfc7f8e5437$export$1468a49de573f7f9(e, n) {
    return e.filter((t)=>n.includes(t)).length === e.length;
}
function $a5d33cfc7f8e5437$export$7f00885504704576(e, n = $a5d33cfc7f8e5437$export$7f882bb969de14a3) {
    return e.slice(Math.max(e.length - n, 0));
}
function $a5d33cfc7f8e5437$export$c4b8dfeb6e237eb9(e) {
    return Object.fromEntries(e.entries());
}
function $a5d33cfc7f8e5437$export$ac31b37c726bc3ba(e) {
    return new Map(Object.entries(e));
}
function $a5d33cfc7f8e5437$export$592ef47eabb05614(e, n) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        t[r] = n(e[r]);
    }), t;
}
const $a5d33cfc7f8e5437$export$85c927578394b28b = (e)=>e;
function $a5d33cfc7f8e5437$export$e9f8fcacef3bca4b(e) {
    return e.trim().replace(/^\w/, (n)=>n.toUpperCase());
}
function $a5d33cfc7f8e5437$export$9a00dee1beb8f576(e) {
    return e.split($a5d33cfc7f8e5437$export$657dee6d5648750a).map((n)=>$a5d33cfc7f8e5437$export$e9f8fcacef3bca4b(n)).join($a5d33cfc7f8e5437$export$657dee6d5648750a);
}
function $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb(e = (0, $aG48A.FIVE_MINUTES), n) {
    const t = (0, $aG48A.toMiliseconds)(e || (0, $aG48A.FIVE_MINUTES));
    let r, o, s;
    return {
        resolve: (i)=>{
            s && r && (clearTimeout(s), r(i));
        },
        reject: (i)=>{
            s && o && (clearTimeout(s), o(i));
        },
        done: ()=>new Promise((i, d)=>{
                s = setTimeout(()=>{
                    d(new Error(n));
                }, t), r = i, o = d;
            })
    };
}
function $a5d33cfc7f8e5437$export$3da2293b007ed708(e, n, t) {
    return new Promise(async (r, o)=>{
        const s = setTimeout(()=>o(new Error(t)), n);
        try {
            const i = await e;
            r(i);
        } catch (i) {
            o(i);
        }
        clearTimeout(s);
    });
}
function $a5d33cfc7f8e5437$export$187ab6574b2ae23f(e, n) {
    if (typeof n == "string" && n.startsWith(`${e}:`)) return n;
    if (e.toLowerCase() === "topic") {
        if (typeof n != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${n}`;
    } else if (e.toLowerCase() === "id") {
        if (typeof n != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${n}`;
    }
    throw new Error(`Unknown expirer target type: ${e}`);
}
function $a5d33cfc7f8e5437$export$43ab92477f8713b9(e) {
    return $a5d33cfc7f8e5437$export$187ab6574b2ae23f("topic", e);
}
function $a5d33cfc7f8e5437$export$bd13103c2e5cc0c3(e) {
    return $a5d33cfc7f8e5437$export$187ab6574b2ae23f("id", e);
}
function $a5d33cfc7f8e5437$export$93adeb0f16e8e51d(e) {
    const [n, t] = e.split(":"), r = {
        id: void 0,
        topic: void 0
    };
    if (n === "topic" && typeof t == "string") r.topic = t;
    else if (n === "id" && Number.isInteger(Number(t))) r.id = Number(t);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${n}:${t}`);
    return r;
}
function $a5d33cfc7f8e5437$export$b136d03015bfc12(e, n) {
    return (0, $aG48A.fromMiliseconds)((n || Date.now()) + (0, $aG48A.toMiliseconds)(e));
}
function $a5d33cfc7f8e5437$export$57947cfd429801a2(e) {
    return Date.now() >= (0, $aG48A.toMiliseconds)(e);
}
function $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9(e, n) {
    return `${e}${n ? `:${n}` : ""}`;
}
function $a5d33cfc7f8e5437$export$9826fe7ad3921016(e = [], n = []) {
    return [
        ...new Set([
            ...e,
            ...n
        ])
    ];
}
async function $a5d33cfc7f8e5437$export$694a208c8abca99a({ id: e, topic: n, wcDeepLink: t }) {
    try {
        if (!t) return;
        const r = typeof t == "string" ? JSON.parse(t) : t;
        let o = r?.href;
        if (typeof o != "string") return;
        o.endsWith("/") && (o = o.slice(0, -1));
        const s = `${o}/wc?requestId=${e}&sessionTopic=${n}`, i = $a5d33cfc7f8e5437$export$57570b1603cf6adb();
        i === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser ? s.startsWith("https://") ? window.open(s, "_blank", "noreferrer noopener") : window.open(s, "_self", "noreferrer noopener") : i === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u" && await $parcel$global.Linking.openURL(s);
    } catch (r) {
        console.error(r);
    }
}
async function $a5d33cfc7f8e5437$export$e55bfdac47149a32(e, n) {
    try {
        return await e.getItem(n) || ($a5d33cfc7f8e5437$export$4e09c449d6c407f7() ? localStorage.getItem(n) : void 0);
    } catch (t) {
        console.error(t);
    }
}
const $a5d33cfc7f8e5437$export$822d0bd1635d5360 = "irn";
function $a5d33cfc7f8e5437$export$cf77af25151525db(e) {
    return e?.relay || {
        protocol: $a5d33cfc7f8e5437$export$822d0bd1635d5360
    };
}
function $a5d33cfc7f8e5437$export$604e3deb95e1b734(e) {
    const n = (0, $a66838b5a814eb12$export$af490b3b9a6de00f)[e];
    if (typeof n > "u") throw new Error(`Relay Protocol not supported: ${e}`);
    return n;
}
var $a5d33cfc7f8e5437$var$bt = Object.defineProperty, $a5d33cfc7f8e5437$var$Nt = Object.defineProperties, $a5d33cfc7f8e5437$var$Ot = Object.getOwnPropertyDescriptors, $a5d33cfc7f8e5437$var$qe = Object.getOwnPropertySymbols, $a5d33cfc7f8e5437$var$St = Object.prototype.hasOwnProperty, $a5d33cfc7f8e5437$var$wt = Object.prototype.propertyIsEnumerable, $a5d33cfc7f8e5437$var$Be = (e, n, t)=>n in e ? $a5d33cfc7f8e5437$var$bt(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $a5d33cfc7f8e5437$var$It = (e, n)=>{
    for(var t in n || (n = {}))$a5d33cfc7f8e5437$var$St.call(n, t) && $a5d33cfc7f8e5437$var$Be(e, t, n[t]);
    if ($a5d33cfc7f8e5437$var$qe) for (var t of $a5d33cfc7f8e5437$var$qe(n))$a5d33cfc7f8e5437$var$wt.call(n, t) && $a5d33cfc7f8e5437$var$Be(e, t, n[t]);
    return e;
}, $a5d33cfc7f8e5437$var$Tt = (e, n)=>$a5d33cfc7f8e5437$var$Nt(e, $a5d33cfc7f8e5437$var$Ot(n));
function $a5d33cfc7f8e5437$export$3d24f408c2ac468a(e, n = "-") {
    const t = {}, r = "relay" + n;
    return Object.keys(e).forEach((o)=>{
        if (o.startsWith(r)) {
            const s = o.replace(r, ""), i = e[o];
            t[s] = i;
        }
    }), t;
}
function $a5d33cfc7f8e5437$export$59f58847421cfb28(e) {
    e = e.includes("wc://") ? e.replace("wc://", "") : e, e = e.includes("wc:") ? e.replace("wc:", "") : e;
    const n = e.indexOf(":"), t = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, r = e.substring(0, n), o = e.substring(n + 1, t).split("@"), s = typeof t < "u" ? e.substring(t) : "", i = $3ecb7368762fc268$export$98e6a39c04603d36(s);
    return {
        protocol: r,
        topic: $a5d33cfc7f8e5437$export$5ddc9ebef1d00f28(o[0]),
        version: parseInt(o[1], 10),
        symKey: i.symKey,
        relay: $a5d33cfc7f8e5437$export$3d24f408c2ac468a(i),
        expiryTimestamp: i.expiryTimestamp ? parseInt(i.expiryTimestamp, 10) : void 0
    };
}
function $a5d33cfc7f8e5437$export$5ddc9ebef1d00f28(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function $a5d33cfc7f8e5437$export$65c55c7ccd19bb8f(e, n = "-") {
    const t = "relay", r = {};
    return Object.keys(e).forEach((o)=>{
        const s = t + n + o;
        e[o] && (r[s] = e[o]);
    }), r;
}
function $a5d33cfc7f8e5437$export$b2786ede34fb2350(e) {
    return `${e.protocol}:${e.topic}@${e.version}?` + $3ecb7368762fc268$export$fac44ee5b035f737($a5d33cfc7f8e5437$var$Tt($a5d33cfc7f8e5437$var$It({
        symKey: e.symKey
    }, $a5d33cfc7f8e5437$export$65c55c7ccd19bb8f(e.relay)), {
        expiryTimestamp: e.expiryTimestamp
    }));
}
var $a5d33cfc7f8e5437$var$At = Object.defineProperty, $a5d33cfc7f8e5437$var$Ut = Object.defineProperties, $a5d33cfc7f8e5437$var$_t = Object.getOwnPropertyDescriptors, $a5d33cfc7f8e5437$var$Ye = Object.getOwnPropertySymbols, $a5d33cfc7f8e5437$var$$t = Object.prototype.hasOwnProperty, $a5d33cfc7f8e5437$var$Ct = Object.prototype.propertyIsEnumerable, $a5d33cfc7f8e5437$var$Je = (e, n, t)=>n in e ? $a5d33cfc7f8e5437$var$At(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $a5d33cfc7f8e5437$var$jt = (e, n)=>{
    for(var t in n || (n = {}))$a5d33cfc7f8e5437$var$$t.call(n, t) && $a5d33cfc7f8e5437$var$Je(e, t, n[t]);
    if ($a5d33cfc7f8e5437$var$Ye) for (var t of $a5d33cfc7f8e5437$var$Ye(n))$a5d33cfc7f8e5437$var$Ct.call(n, t) && $a5d33cfc7f8e5437$var$Je(e, t, n[t]);
    return e;
}, $a5d33cfc7f8e5437$var$Dt = (e, n)=>$a5d33cfc7f8e5437$var$Ut(e, $a5d33cfc7f8e5437$var$_t(n));
function $a5d33cfc7f8e5437$export$d46695d9c3664fe9(e) {
    const n = [];
    return e.forEach((t)=>{
        const [r, o] = t.split(":");
        n.push(`${r}:${o}`);
    }), n;
}
function $a5d33cfc7f8e5437$export$fb6db6038e742b14(e) {
    const n = [];
    return Object.values(e).forEach((t)=>{
        n.push(...$a5d33cfc7f8e5437$export$d46695d9c3664fe9(t.accounts));
    }), n;
}
function $a5d33cfc7f8e5437$export$7dcf4808e17b15ac(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $a5d33cfc7f8e5437$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.methods);
    }), t;
}
function $a5d33cfc7f8e5437$export$94ee6d00e384a22(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $a5d33cfc7f8e5437$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.events);
    }), t;
}
function $a5d33cfc7f8e5437$export$a8daa26a7c60ef90(e, n) {
    const t = $a5d33cfc7f8e5437$export$93f7b81dc815a714(e, n);
    if (t) throw new Error(t.message);
    const r = {};
    for (const [o, s] of Object.entries(e))r[o] = {
        methods: s.methods,
        events: s.events,
        chains: s.accounts.map((i)=>`${i.split(":")[0]}:${i.split(":")[1]}`)
    };
    return r;
}
function $a5d33cfc7f8e5437$export$c0b86bc9b7d9f338(e) {
    const { proposal: { requiredNamespaces: n, optionalNamespaces: t = {} }, supportedNamespaces: r } = e, o = $a5d33cfc7f8e5437$export$2994550cda701c96(n), s = $a5d33cfc7f8e5437$export$2994550cda701c96(t), i = {};
    Object.keys(r).forEach((c)=>{
        const u = r[c].chains, a = r[c].methods, b = r[c].events, I = r[c].accounts;
        u.forEach((y)=>{
            if (!I.some((f)=>f.includes(y))) throw new Error(`No accounts provided for chain ${y} in namespace ${c}`);
        }), i[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    });
    const d = $a5d33cfc7f8e5437$export$ba5b0a4b585cd1b4(n, i, "approve()");
    if (d) throw new Error(d.message);
    const l = {};
    return !Object.keys(n).length && !Object.keys(t).length ? i : (Object.keys(o).forEach((c)=>{
        const u = r[c].chains.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.chains) == null ? void 0 : h.includes(y);
        }), a = r[c].methods.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.methods) == null ? void 0 : h.includes(y);
        }), b = r[c].events.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.events) == null ? void 0 : h.includes(y);
        }), I = u.map((y)=>r[c].accounts.filter((f)=>f.includes(`${y}:`))).flat();
        l[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    }), Object.keys(s).forEach((c)=>{
        var u, a, b, I, y, f;
        if (!r[c]) return;
        const h = (a = (u = s[c]) == null ? void 0 : u.chains) == null ? void 0 : a.filter((T)=>r[c].chains.includes(T)), En = r[c].methods.filter((T)=>{
            var P, C;
            return (C = (P = s[c]) == null ? void 0 : P.methods) == null ? void 0 : C.includes(T);
        }), bn = r[c].events.filter((T)=>{
            var P, C;
            return (C = (P = s[c]) == null ? void 0 : P.events) == null ? void 0 : C.includes(T);
        }), Nn = h?.map((T)=>r[c].accounts.filter((P)=>P.includes(`${T}:`))).flat();
        l[c] = {
            chains: $a5d33cfc7f8e5437$export$9826fe7ad3921016((b = l[c]) == null ? void 0 : b.chains, h),
            methods: $a5d33cfc7f8e5437$export$9826fe7ad3921016((I = l[c]) == null ? void 0 : I.methods, En),
            events: $a5d33cfc7f8e5437$export$9826fe7ad3921016((y = l[c]) == null ? void 0 : y.events, bn),
            accounts: $a5d33cfc7f8e5437$export$9826fe7ad3921016((f = l[c]) == null ? void 0 : f.accounts, Nn)
        };
    }), l);
}
function $a5d33cfc7f8e5437$export$e03e993df4723bde(e) {
    return e.includes(":");
}
function $a5d33cfc7f8e5437$export$dd404c96fbbb1ff8(e) {
    return $a5d33cfc7f8e5437$export$e03e993df4723bde(e) ? e.split(":")[0] : e;
}
function $a5d33cfc7f8e5437$export$2994550cda701c96(e) {
    var n, t, r;
    const o = {};
    if (!$a5d33cfc7f8e5437$export$16a0268bc22b47b0(e)) return o;
    for (const [s, i] of Object.entries(e)){
        const d = $a5d33cfc7f8e5437$export$e03e993df4723bde(s) ? [
            s
        ] : i.chains, l = i.methods || [], c = i.events || [], u = $a5d33cfc7f8e5437$export$dd404c96fbbb1ff8(s);
        o[u] = $a5d33cfc7f8e5437$var$Dt($a5d33cfc7f8e5437$var$jt({}, o[u]), {
            chains: $a5d33cfc7f8e5437$export$9826fe7ad3921016(d, (n = o[u]) == null ? void 0 : n.chains),
            methods: $a5d33cfc7f8e5437$export$9826fe7ad3921016(l, (t = o[u]) == null ? void 0 : t.methods),
            events: $a5d33cfc7f8e5437$export$9826fe7ad3921016(c, (r = o[u]) == null ? void 0 : r.events)
        });
    }
    return o;
}
const $a5d33cfc7f8e5437$export$990de0b632caca05 = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $a5d33cfc7f8e5437$export$77b3faa414a0ce61 = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $a5d33cfc7f8e5437$export$500d4c4a8fafe35(e, n) {
    const { message: t, code: r } = $a5d33cfc7f8e5437$export$77b3faa414a0ce61[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $a5d33cfc7f8e5437$export$8203ef1531c8b5b5(e, n) {
    const { message: t, code: r } = $a5d33cfc7f8e5437$export$990de0b632caca05[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e, n) {
    return Array.isArray(e) ? typeof n < "u" && e.length ? e.every(n) : !0 : !1;
}
function $a5d33cfc7f8e5437$export$16a0268bc22b47b0(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function $a5d33cfc7f8e5437$export$fce6876652108ab(e) {
    return typeof e > "u";
}
function $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, n) {
    return n && $a5d33cfc7f8e5437$export$fce6876652108ab(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function $a5d33cfc7f8e5437$export$d6781b696a0576d1(e, n) {
    return n && $a5d33cfc7f8e5437$export$fce6876652108ab(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $a5d33cfc7f8e5437$export$6fc4971bf8f326a(e, n) {
    const { requiredNamespaces: t } = n, r = Object.keys(e.namespaces), o = Object.keys(t);
    let s = !0;
    return $a5d33cfc7f8e5437$export$1468a49de573f7f9(o, r) ? (r.forEach((i)=>{
        const { accounts: d, methods: l, events: c } = e.namespaces[i], u = $a5d33cfc7f8e5437$export$d46695d9c3664fe9(d), a = t[i];
        (!$a5d33cfc7f8e5437$export$1468a49de573f7f9($a5d33cfc7f8e5437$export$376384387cd15b27(i, a), u) || !$a5d33cfc7f8e5437$export$1468a49de573f7f9(a.methods, l) || !$a5d33cfc7f8e5437$export$1468a49de573f7f9(a.events, c)) && (s = !1);
    }), s) : !1;
}
function $a5d33cfc7f8e5437$export$e544b39f0a22e47a(e) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function $a5d33cfc7f8e5437$export$49e4a5b6862e3c71(e) {
    if ($a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, !1) && e.includes(":")) {
        const n = e.split(":");
        if (n.length === 3) {
            const t = n[0] + ":" + n[1];
            return !!n[2] && $a5d33cfc7f8e5437$export$e544b39f0a22e47a(t);
        }
    }
    return !1;
}
function $a5d33cfc7f8e5437$export$bef94a5618bf18bf(e) {
    if ($a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, !1)) try {
        return typeof new URL(e) < "u";
    } catch  {
        return !1;
    }
    return !1;
}
function $a5d33cfc7f8e5437$export$f657f7976bb2769d(e) {
    var n;
    return (n = e?.proposer) == null ? void 0 : n.publicKey;
}
function $a5d33cfc7f8e5437$export$c96d5113768aaf5e(e) {
    return e?.topic;
}
function $a5d33cfc7f8e5437$export$5e1c5c89613c213f(e, n) {
    let t = null;
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e?.publicKey, !1) || (t = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n} controller public key should be a string`)), t;
}
function $a5d33cfc7f8e5437$export$c12fced8176774f3(e) {
    let n = !0;
    return $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e) ? e.length && (n = e.every((t)=>$a5d33cfc7f8e5437$export$ee898ca48ab56c74(t, !1))) : n = !1, n;
}
function $a5d33cfc7f8e5437$export$df46c123d7e298ce(e, n, t) {
    let r = null;
    return $a5d33cfc7f8e5437$export$41dd3d480aac4a71(n) && n.length ? n.forEach((o)=>{
        r || $a5d33cfc7f8e5437$export$e544b39f0a22e47a(o) || (r = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chain ${o} should be a string and conform to "namespace:chainId" format`));
    }) : $a5d33cfc7f8e5437$export$e544b39f0a22e47a(e) || (r = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), r;
}
function $a5d33cfc7f8e5437$export$94ae96fb66f29e08(e, n, t) {
    let r = null;
    return Object.entries(e).forEach(([o, s])=>{
        if (r) return;
        const i = $a5d33cfc7f8e5437$export$df46c123d7e298ce(o, $a5d33cfc7f8e5437$export$376384387cd15b27(o, s), `${n} ${t}`);
        i && (r = i);
    }), r;
}
function $a5d33cfc7f8e5437$export$d5644026aaffb9e7(e, n) {
    let t = null;
    return $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e) ? e.forEach((r)=>{
        t || $a5d33cfc7f8e5437$export$49e4a5b6862e3c71(r) || (t = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, account ${r} should be a string and conform to "namespace:chainId:address" format`));
    }) : t = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), t;
}
function $a5d33cfc7f8e5437$export$2a2012e7bfa1cfb4(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $a5d33cfc7f8e5437$export$d5644026aaffb9e7(r?.accounts, `${n} namespace`);
        o && (t = o);
    }), t;
}
function $a5d33cfc7f8e5437$export$b32541d63753af56(e, n) {
    let t = null;
    return $a5d33cfc7f8e5437$export$c12fced8176774f3(e?.methods) ? $a5d33cfc7f8e5437$export$c12fced8176774f3(e?.events) || (t = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", `${n}, events should be an array of strings or empty array for no events`)) : t = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", `${n}, methods should be an array of strings or empty array for no methods`), t;
}
function $a5d33cfc7f8e5437$export$27682c78deeca9d7(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $a5d33cfc7f8e5437$export$b32541d63753af56(r, `${n}, namespace`);
        o && (t = o);
    }), t;
}
function $a5d33cfc7f8e5437$export$9e2b2cae22c6a8b3(e, n, t) {
    let r = null;
    if (e && $a5d33cfc7f8e5437$export$16a0268bc22b47b0(e)) {
        const o = $a5d33cfc7f8e5437$export$27682c78deeca9d7(e, n);
        o && (r = o);
        const s = $a5d33cfc7f8e5437$export$94ae96fb66f29e08(e, n, t);
        s && (r = s);
    } else r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, ${t} should be an object with data`);
    return r;
}
function $a5d33cfc7f8e5437$export$93f7b81dc815a714(e, n) {
    let t = null;
    if (e && $a5d33cfc7f8e5437$export$16a0268bc22b47b0(e)) {
        const r = $a5d33cfc7f8e5437$export$27682c78deeca9d7(e, n);
        r && (t = r);
        const o = $a5d33cfc7f8e5437$export$2a2012e7bfa1cfb4(e, n);
        o && (t = o);
    } else t = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, namespaces should be an object with data`);
    return t;
}
function $a5d33cfc7f8e5437$export$1b3fc298be8c9a7b(e) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.protocol, !0);
}
function $a5d33cfc7f8e5437$export$6294c30b976bd21e(e, n) {
    let t = !1;
    return n && !e ? t = !0 : e && $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e) && e.length && e.forEach((r)=>{
        t = $a5d33cfc7f8e5437$export$1b3fc298be8c9a7b(r);
    }), t;
}
function $a5d33cfc7f8e5437$export$53551be28ad5e34d(e) {
    return typeof e == "number";
}
function $a5d33cfc7f8e5437$export$b3f5fcca1d210454(e) {
    return typeof e < "u" && true;
}
function $a5d33cfc7f8e5437$export$766fe78377d96f2a(e) {
    return !(!e || typeof e != "object" || !e.code || !$a5d33cfc7f8e5437$export$d6781b696a0576d1(e.code, !1) || !e.message || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.message, !1));
}
function $a5d33cfc7f8e5437$export$1a2af3c017fb6d42(e) {
    return !($a5d33cfc7f8e5437$export$fce6876652108ab(e) || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.method, !1));
}
function $a5d33cfc7f8e5437$export$1ae38cf0a848f651(e) {
    return !($a5d33cfc7f8e5437$export$fce6876652108ab(e) || $a5d33cfc7f8e5437$export$fce6876652108ab(e.result) && $a5d33cfc7f8e5437$export$fce6876652108ab(e.error) || !$a5d33cfc7f8e5437$export$d6781b696a0576d1(e.id, !1) || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.jsonrpc, !1));
}
function $a5d33cfc7f8e5437$export$cbe4cdc5960cfa11(e) {
    return !($a5d33cfc7f8e5437$export$fce6876652108ab(e) || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.name, !1));
}
function $a5d33cfc7f8e5437$export$144fc36610eb6522(e, n) {
    return !(!$a5d33cfc7f8e5437$export$e544b39f0a22e47a(n) || !$a5d33cfc7f8e5437$export$fb6db6038e742b14(e).includes(n));
}
function $a5d33cfc7f8e5437$export$8db4804e3a6de711(e, n, t) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(t, !1) ? $a5d33cfc7f8e5437$export$7dcf4808e17b15ac(e, n).includes(t) : !1;
}
function $a5d33cfc7f8e5437$export$df2c67ef8baad16b(e, n, t) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(t, !1) ? $a5d33cfc7f8e5437$export$94ee6d00e384a22(e, n).includes(t) : !1;
}
function $a5d33cfc7f8e5437$export$ba5b0a4b585cd1b4(e, n, t) {
    let r = null;
    const o = $a5d33cfc7f8e5437$var$er(e), s = $a5d33cfc7f8e5437$var$nr(n), i = Object.keys(o), d = Object.keys(s), l = $a5d33cfc7f8e5437$var$pn(Object.keys(e)), c = $a5d33cfc7f8e5437$var$pn(Object.keys(n)), u = l.filter((a)=>!c.includes(a));
    return u.length && (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces keys don't satisfy requiredNamespaces.
      Required: ${u.toString()}
      Received: ${Object.keys(n).toString()}`)), $a5d33cfc7f8e5437$export$1468a49de573f7f9(i, d) || (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces chains don't satisfy required namespaces.
      Required: ${i.toString()}
      Approved: ${d.toString()}`)), Object.keys(n).forEach((a)=>{
        if (!a.includes(":") || r) return;
        const b = $a5d33cfc7f8e5437$export$d46695d9c3664fe9(n[a].accounts);
        b.includes(a) || (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces accounts don't satisfy namespace accounts for ${a}
        Required: ${a}
        Approved: ${b.toString()}`));
    }), i.forEach((a)=>{
        r || ($a5d33cfc7f8e5437$export$1468a49de573f7f9(o[a].methods, s[a].methods) ? $a5d33cfc7f8e5437$export$1468a49de573f7f9(o[a].events, s[a].events) || (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces events don't satisfy namespace events for ${a}`)) : r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces methods don't satisfy namespace methods for ${a}`));
    }), r;
}
function $a5d33cfc7f8e5437$var$er(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        var r;
        t.includes(":") ? n[t] = e[t] : (r = e[t].chains) == null || r.forEach((o)=>{
            n[o] = {
                methods: e[t].methods,
                events: e[t].events
            };
        });
    }), n;
}
function $a5d33cfc7f8e5437$var$pn(e) {
    return [
        ...new Set(e.map((n)=>n.includes(":") ? n.split(":")[0] : n))
    ];
}
function $a5d33cfc7f8e5437$var$nr(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        if (t.includes(":")) n[t] = e[t];
        else {
            const r = $a5d33cfc7f8e5437$export$d46695d9c3664fe9(e[t].accounts);
            r?.forEach((o)=>{
                n[o] = {
                    accounts: e[t].accounts.filter((s)=>s.includes(`${o}:`)),
                    methods: e[t].methods,
                    events: e[t].events
                };
            });
        }
    }), n;
}
function $a5d33cfc7f8e5437$export$59fba2af1ac782b(e, n) {
    return $a5d33cfc7f8e5437$export$d6781b696a0576d1(e, !1) && e <= n.max && e >= n.min;
}
function $a5d33cfc7f8e5437$export$53c2fd0173ad2b80() {
    const e = $a5d33cfc7f8e5437$export$57570b1603cf6adb();
    return new Promise((n)=>{
        switch(e){
            case $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser:
                n($a5d33cfc7f8e5437$export$2f147c609a999e49());
                break;
            case $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative:
                n($a5d33cfc7f8e5437$export$1444c95b1570bd12());
                break;
            case $a5d33cfc7f8e5437$export$86b1301a63b15dd9.node:
                n($a5d33cfc7f8e5437$export$aec5b2d627eec500());
                break;
            default:
                n(!0);
        }
    });
}
function $a5d33cfc7f8e5437$export$2f147c609a999e49() {
    return $a5d33cfc7f8e5437$export$4e09c449d6c407f7() && navigator?.onLine;
}
async function $a5d33cfc7f8e5437$export$1444c95b1570bd12() {
    if ($a5d33cfc7f8e5437$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo) {
        const e = await ($parcel$global == null ? void 0 : $parcel$global.NetInfo.fetch());
        return e?.isConnected;
    }
    return !0;
}
function $a5d33cfc7f8e5437$export$aec5b2d627eec500() {
    return !0;
}
function $a5d33cfc7f8e5437$export$600a1ee4bc680996(e) {
    switch($a5d33cfc7f8e5437$export$57570b1603cf6adb()){
        case $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser:
            $a5d33cfc7f8e5437$export$d32b24f18d96c5f2(e);
            break;
        case $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative:
            $a5d33cfc7f8e5437$export$904edb1c18ec91c7(e);
            break;
        case $a5d33cfc7f8e5437$export$86b1301a63b15dd9.node:
            break;
    }
}
function $a5d33cfc7f8e5437$export$d32b24f18d96c5f2(e) {
    !$a5d33cfc7f8e5437$export$f7a1e23e542d38e3() && $a5d33cfc7f8e5437$export$4e09c449d6c407f7() && (window.addEventListener("online", ()=>e(!0)), window.addEventListener("offline", ()=>e(!1)));
}
function $a5d33cfc7f8e5437$export$904edb1c18ec91c7(e) {
    $a5d33cfc7f8e5437$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo && $parcel$global?.NetInfo.addEventListener((n)=>e(n?.isConnected));
}
const $a5d33cfc7f8e5437$var$ae = {};
class $a5d33cfc7f8e5437$export$b72d712fed4d036d {
    static get(n) {
        return $a5d33cfc7f8e5437$var$ae[n];
    }
    static set(n, t) {
        $a5d33cfc7f8e5437$var$ae[n] = t;
    }
    static delete(n) {
        delete $a5d33cfc7f8e5437$var$ae[n];
    }
}




var $aG48A = parcelRequire("aG48A");

var $7etJZ = parcelRequire("7etJZ");
var $201d0312d0bb8021$exports = {};
$parcel$export($201d0312d0bb8021$exports, "parseConnectionError", () => $ab82c37acb5ed82a$export$f555d7d8f922e407);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcError", () => $21f900087ef2a598$exports.formatJsonRpcError);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcRequest", () => $21f900087ef2a598$exports.formatJsonRpcRequest);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcResult", () => $21f900087ef2a598$exports.formatJsonRpcResult);
$parcel$export($201d0312d0bb8021$exports, "getBigIntRpcId", () => $21f900087ef2a598$exports.getBigIntRpcId);
$parcel$export($201d0312d0bb8021$exports, "IJsonRpcProvider", () => $21f900087ef2a598$exports.IJsonRpcProvider);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcError", () => $21f900087ef2a598$exports.isJsonRpcError);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcRequest", () => $21f900087ef2a598$exports.isJsonRpcRequest);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcResponse", () => $21f900087ef2a598$exports.isJsonRpcResponse);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcResult", () => $21f900087ef2a598$exports.isJsonRpcResult);
$parcel$export($201d0312d0bb8021$exports, "isLocalhostUrl", () => $21f900087ef2a598$exports.isLocalhostUrl);
$parcel$export($201d0312d0bb8021$exports, "isReactNative", () => $21f900087ef2a598$exports.isReactNative);
$parcel$export($201d0312d0bb8021$exports, "isWsUrl", () => $21f900087ef2a598$exports.isWsUrl);
$parcel$export($201d0312d0bb8021$exports, "parseConnectionError", () => $21f900087ef2a598$exports.parseConnectionError);
$parcel$export($201d0312d0bb8021$exports, "payloadId", () => $21f900087ef2a598$exports.payloadId);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcError", () => $3bb3ddc7bbc938cc$export$9f7302ae26c3f77);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcRequest", () => $3bb3ddc7bbc938cc$export$11d081ebb32d4398);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcResult", () => $3bb3ddc7bbc938cc$export$478fdea01c2a3198);
$parcel$export($201d0312d0bb8021$exports, "getBigIntRpcId", () => $3bb3ddc7bbc938cc$export$799a3db5df197877);
$parcel$export($201d0312d0bb8021$exports, "payloadId", () => $3bb3ddc7bbc938cc$export$2f5364a5d4b80251);
$parcel$export($201d0312d0bb8021$exports, "IJsonRpcProvider", () => $4b3041b8db0f8b25$export$46957420a688a16d);
$parcel$export($201d0312d0bb8021$exports, "isLocalhostUrl", () => $ceb127018999f416$export$8eb4a0a481601f29);
$parcel$export($201d0312d0bb8021$exports, "isWsUrl", () => $ceb127018999f416$export$4e4463e75eccf20c);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcError", () => $2e45abd1d679ec32$export$5662a1047b4d1d15);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcRequest", () => $2e45abd1d679ec32$export$f6e4034abe07d2a5);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcResponse", () => $2e45abd1d679ec32$export$308ba927de2bcbe8);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcResult", () => $2e45abd1d679ec32$export$cb3d3b20e3223d77);
const $fb0266a13f89cf1a$export$2ecaad7eb5cc1f25 = "PARSE_ERROR";
const $fb0266a13f89cf1a$export$c77b2f9ece3946ce = "INVALID_REQUEST";
const $fb0266a13f89cf1a$export$e8d537b30db778d6 = "METHOD_NOT_FOUND";
const $fb0266a13f89cf1a$export$13aae195c7978fb1 = "INVALID_PARAMS";
const $fb0266a13f89cf1a$export$f6e3abf3038d348f = "INTERNAL_ERROR";
const $fb0266a13f89cf1a$export$125ebd30471ac25c = "SERVER_ERROR";
const $fb0266a13f89cf1a$export$af84821b5448ca78 = [
    -32700,
    -32600,
    -32601,
    -32602,
    -32603
];
const $fb0266a13f89cf1a$export$fff5b44b15c75f69 = [
    -32000,
    -32099
];
const $fb0266a13f89cf1a$export$cca5387ab287e1ae = {
    [$fb0266a13f89cf1a$export$2ecaad7eb5cc1f25]: {
        code: -32700,
        message: "Parse error"
    },
    [$fb0266a13f89cf1a$export$c77b2f9ece3946ce]: {
        code: -32600,
        message: "Invalid Request"
    },
    [$fb0266a13f89cf1a$export$e8d537b30db778d6]: {
        code: -32601,
        message: "Method not found"
    },
    [$fb0266a13f89cf1a$export$13aae195c7978fb1]: {
        code: -32602,
        message: "Invalid params"
    },
    [$fb0266a13f89cf1a$export$f6e3abf3038d348f]: {
        code: -32603,
        message: "Internal error"
    },
    [$fb0266a13f89cf1a$export$125ebd30471ac25c]: {
        code: -32000,
        message: "Server error"
    }
};
const $fb0266a13f89cf1a$export$d166979eca925bce = $fb0266a13f89cf1a$export$125ebd30471ac25c;



function $ab82c37acb5ed82a$export$e463129eb4bc487f(code) {
    return code <= (0, $fb0266a13f89cf1a$export$fff5b44b15c75f69)[0] && code >= (0, $fb0266a13f89cf1a$export$fff5b44b15c75f69)[1];
}
function $ab82c37acb5ed82a$export$2ae0ec6393ab16c3(code) {
    return (0, $fb0266a13f89cf1a$export$af84821b5448ca78).includes(code);
}
function $ab82c37acb5ed82a$export$7543109e66e1748d(code) {
    return typeof code === "number";
}
function $ab82c37acb5ed82a$export$e1599abf47b5b568(type) {
    if (!Object.keys((0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)).includes(type)) return (0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)[0, $fb0266a13f89cf1a$export$d166979eca925bce];
    return (0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)[type];
}
function $ab82c37acb5ed82a$export$60a3bac005957e12(code) {
    const match = Object.values((0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)).find((e)=>e.code === code);
    if (!match) return (0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)[0, $fb0266a13f89cf1a$export$d166979eca925bce];
    return match;
}
function $ab82c37acb5ed82a$export$6be064b82176dd99(response) {
    if (typeof response.error.code === "undefined") return {
        valid: false,
        error: "Missing code for JSON-RPC error"
    };
    if (typeof response.error.message === "undefined") return {
        valid: false,
        error: "Missing message for JSON-RPC error"
    };
    if (!$ab82c37acb5ed82a$export$7543109e66e1748d(response.error.code)) return {
        valid: false,
        error: `Invalid error code type for JSON-RPC: ${response.error.code}`
    };
    if ($ab82c37acb5ed82a$export$2ae0ec6393ab16c3(response.error.code)) {
        const error = $ab82c37acb5ed82a$export$60a3bac005957e12(response.error.code);
        if (error.message !== (0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)[0, $fb0266a13f89cf1a$export$d166979eca925bce].message && response.error.message === error.message) return {
            valid: false,
            error: `Invalid error code message for JSON-RPC: ${response.error.code}`
        };
    }
    return {
        valid: true
    };
}
function $ab82c37acb5ed82a$export$f555d7d8f922e407(e, url, type) {
    return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${type} RPC url at ${url}`) : e;
}


var $21f900087ef2a598$exports = {};
"use strict";
Object.defineProperty($21f900087ef2a598$exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("ljFVp")), $21f900087ef2a598$exports);

$7WQrb.__exportStar((parcelRequire("5vmD7")), $21f900087ef2a598$exports);


const $c1abc8a6542d5235$export$d1694901a048d7c8 = (0, $21f900087ef2a598$exports.isNode);




function $3bb3ddc7bbc938cc$export$2f5364a5d4b80251(entropy = 3) {
    const date = Date.now() * Math.pow(10, entropy);
    const extra = Math.floor(Math.random() * Math.pow(10, entropy));
    return date + extra;
}
function $3bb3ddc7bbc938cc$export$799a3db5df197877(entropy = 6) {
    return BigInt($3bb3ddc7bbc938cc$export$2f5364a5d4b80251(entropy));
}
function $3bb3ddc7bbc938cc$export$11d081ebb32d4398(method, params, id) {
    return {
        id: id || $3bb3ddc7bbc938cc$export$2f5364a5d4b80251(),
        jsonrpc: "2.0",
        method: method,
        params: params
    };
}
function $3bb3ddc7bbc938cc$export$478fdea01c2a3198(id, result) {
    return {
        id: id,
        jsonrpc: "2.0",
        result: result
    };
}
function $3bb3ddc7bbc938cc$export$9f7302ae26c3f77(id, error, data) {
    return {
        id: id,
        jsonrpc: "2.0",
        error: $3bb3ddc7bbc938cc$export$5201d50a34753d71(error, data)
    };
}
function $3bb3ddc7bbc938cc$export$5201d50a34753d71(error, data) {
    if (typeof error === "undefined") return (0, $ab82c37acb5ed82a$export$e1599abf47b5b568)((0, $fb0266a13f89cf1a$export$f6e3abf3038d348f));
    if (typeof error === "string") error = Object.assign(Object.assign({}, (0, $ab82c37acb5ed82a$export$e1599abf47b5b568)((0, $fb0266a13f89cf1a$export$125ebd30471ac25c))), {
        message: error
    });
    if (typeof data !== "undefined") error.data = data;
    if ((0, $ab82c37acb5ed82a$export$2ae0ec6393ab16c3)(error.code)) error = (0, $ab82c37acb5ed82a$export$60a3bac005957e12)(error.code);
    return error;
}


function $d805e0076f614f48$export$9f3e656a7f6a3adc(route) {
    if (route.includes("*")) return $d805e0076f614f48$export$8e8b9bea55b56df2(route);
    if (/\W/g.test(route)) return false;
    return true;
}
function $d805e0076f614f48$export$c7e2040809cad2c4(route) {
    return route === "*";
}
function $d805e0076f614f48$export$8e8b9bea55b56df2(route) {
    if ($d805e0076f614f48$export$c7e2040809cad2c4(route)) return true;
    if (!route.includes("*")) return false;
    if (route.split("*").length !== 2) return false;
    if (route.split("*").filter((x)=>x.trim() === "").length !== 1) return false;
    return true;
}
function $d805e0076f614f48$export$2d48faaafcc8fbdc(route) {
    return !$d805e0076f614f48$export$c7e2040809cad2c4(route) && $d805e0076f614f48$export$8e8b9bea55b56df2(route) && !route.split("*")[0].trim();
}
function $d805e0076f614f48$export$be298a4710fab756(route) {
    return !$d805e0076f614f48$export$c7e2040809cad2c4(route) && $d805e0076f614f48$export$8e8b9bea55b56df2(route) && !route.split("*")[1].trim();
}




class $223baefd0cc0a951$export$ab429ec7e240e546 {
}



class $4b3041b8db0f8b25$export$77d426dd89724fbe extends (0, $223baefd0cc0a951$export$ab429ec7e240e546) {
    constructor(opts){
        super();
    }
}
class $4b3041b8db0f8b25$export$cb916a2eed49af33 extends (0, $223baefd0cc0a951$export$ab429ec7e240e546) {
    constructor(){
        super();
    }
}
class $4b3041b8db0f8b25$export$46957420a688a16d extends $4b3041b8db0f8b25$export$cb916a2eed49af33 {
    constructor(connection){
        super();
    }
}








const $ceb127018999f416$var$HTTP_REGEX = "^https?:";
const $ceb127018999f416$var$WS_REGEX = "^wss?:";
function $ceb127018999f416$var$getUrlProtocol(url) {
    const matches = url.match(new RegExp(/^\w+:/, "gi"));
    if (!matches || !matches.length) return;
    return matches[0];
}
function $ceb127018999f416$var$matchRegexProtocol(url, regex) {
    const protocol = $ceb127018999f416$var$getUrlProtocol(url);
    if (typeof protocol === "undefined") return false;
    return new RegExp(regex).test(protocol);
}
function $ceb127018999f416$export$206c3129b8bb1b4f(url) {
    return $ceb127018999f416$var$matchRegexProtocol(url, $ceb127018999f416$var$HTTP_REGEX);
}
function $ceb127018999f416$export$4e4463e75eccf20c(url) {
    return $ceb127018999f416$var$matchRegexProtocol(url, $ceb127018999f416$var$WS_REGEX);
}
function $ceb127018999f416$export$8eb4a0a481601f29(url) {
    return new RegExp("wss?://localhost(:d{2,5})?").test(url);
}


function $2e45abd1d679ec32$export$bf3617e9fafa893f(payload) {
    return typeof payload === "object" && "id" in payload && "jsonrpc" in payload && payload.jsonrpc === "2.0";
}
function $2e45abd1d679ec32$export$f6e4034abe07d2a5(payload) {
    return $2e45abd1d679ec32$export$bf3617e9fafa893f(payload) && "method" in payload;
}
function $2e45abd1d679ec32$export$308ba927de2bcbe8(payload) {
    return $2e45abd1d679ec32$export$bf3617e9fafa893f(payload) && ($2e45abd1d679ec32$export$cb3d3b20e3223d77(payload) || $2e45abd1d679ec32$export$5662a1047b4d1d15(payload));
}
function $2e45abd1d679ec32$export$cb3d3b20e3223d77(payload) {
    return "result" in payload;
}
function $2e45abd1d679ec32$export$5662a1047b4d1d15(payload) {
    return "error" in payload;
}
function $2e45abd1d679ec32$export$ae97720cc2d120d4(validation) {
    return "error" in validation && validation.valid === false;
}




class $1582203255a670cd$export$da28308012bf6748 extends (0, $4b3041b8db0f8b25$export$46957420a688a16d) {
    constructor(connection){
        super(connection);
        this.events = new (0, $7etJZ.EventEmitter)();
        this.hasRegisteredEventListeners = false;
        this.connection = this.setConnection(connection);
        if (this.connection.connected) this.registerEventListeners();
    }
    async connect(connection = this.connection) {
        await this.open(connection);
    }
    async disconnect() {
        await this.close();
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    async request(request, context) {
        return this.requestStrict((0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)(request.method, request.params || [], request.id || (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString()), context);
    }
    async requestStrict(request, context) {
        return new Promise(async (resolve, reject)=>{
            if (!this.connection.connected) try {
                await this.open();
            } catch (e) {
                reject(e);
            }
            this.events.on(`${request.id}`, (response)=>{
                if ((0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(response)) reject(response.error);
                else resolve(response.result);
            });
            try {
                await this.connection.send(request, context);
            } catch (e) {
                reject(e);
            }
        });
    }
    setConnection(connection = this.connection) {
        return connection;
    }
    onPayload(payload) {
        this.events.emit("payload", payload);
        if ((0, $2e45abd1d679ec32$export$308ba927de2bcbe8)(payload)) this.events.emit(`${payload.id}`, payload);
        else this.events.emit("message", {
            type: payload.method,
            data: payload.params
        });
    }
    onClose(event) {
        if (event && event.code === 3000) this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${event.code} ${event.reason ? `(${event.reason})` : ""}`));
        this.events.emit("disconnect");
    }
    async open(connection = this.connection) {
        if (this.connection === connection && this.connection.connected) return;
        if (this.connection.connected) this.close();
        if (typeof connection === "string") {
            await this.connection.open(connection);
            connection = this.connection;
        }
        this.connection = this.setConnection(connection);
        await this.connection.open();
        this.registerEventListeners();
        this.events.emit("connect");
    }
    async close() {
        await this.connection.close();
    }
    registerEventListeners() {
        if (this.hasRegisteredEventListeners) return;
        this.connection.on("payload", (payload)=>this.onPayload(payload));
        this.connection.on("close", (event)=>this.onClose(event));
        this.connection.on("error", (error)=>this.events.emit("error", error));
        this.connection.on("register_error", (error)=>this.onClose());
        this.hasRegisteredEventListeners = true;
    }
}
var $1582203255a670cd$export$2e2bcd8739ae039 = $1582203255a670cd$export$da28308012bf6748;


var $566b2fdf5e300ab1$export$2e2bcd8739ae039 = (0, $1582203255a670cd$export$2e2bcd8739ae039);




var $7etJZ = parcelRequire("7etJZ");



const $f6230024aa4de9c4$var$w = ()=>typeof WebSocket < "u" ? WebSocket : typeof $parcel$global < "u" && typeof $parcel$global.WebSocket < "u" ? $parcel$global.WebSocket : typeof window < "u" && typeof window.WebSocket < "u" ? window.WebSocket : typeof self < "u" && typeof self.WebSocket < "u" ? self.WebSocket : (parcelRequire("fvaAM")), $f6230024aa4de9c4$var$b = ()=>typeof WebSocket < "u" || typeof $parcel$global < "u" && typeof $parcel$global.WebSocket < "u" || typeof window < "u" && typeof window.WebSocket < "u" || typeof self < "u" && typeof self.WebSocket < "u", $f6230024aa4de9c4$var$a = (c)=>c.split("?")[0], $f6230024aa4de9c4$var$h = 10, $f6230024aa4de9c4$var$S = $f6230024aa4de9c4$var$w();
class $f6230024aa4de9c4$export$ea0df116fa892998 {
    constructor(e){
        if (this.url = e, this.events = new (0, $7etJZ.EventEmitter), this.registering = !1, !(0, $ceb127018999f416$export$4e4463e75eccf20c)(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
        this.url = e;
    }
    get connected() {
        return typeof this.socket < "u";
    }
    get connecting() {
        return this.registering;
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async open(e = this.url) {
        await this.register(e);
    }
    async close() {
        return new Promise((e, t)=>{
            if (typeof this.socket > "u") {
                t(new Error("Connection already closed"));
                return;
            }
            this.socket.onclose = (n)=>{
                this.onClose(n), e();
            }, this.socket.close();
        });
    }
    async send(e) {
        typeof this.socket > "u" && (this.socket = await this.register());
        try {
            this.socket.send((0, $81c2e06d24b89184$export$abc3f407e87918a4)(e));
        } catch (t) {
            this.onError(e.id, t);
        }
    }
    register(e = this.url) {
        if (!(0, $ceb127018999f416$export$4e4463e75eccf20c)(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
        if (this.registering) {
            const t = this.events.getMaxListeners();
            return (this.events.listenerCount("register_error") >= t || this.events.listenerCount("open") >= t) && this.events.setMaxListeners(t + 1), new Promise((n, o)=>{
                this.events.once("register_error", (s)=>{
                    this.resetMaxListeners(), o(s);
                }), this.events.once("open", ()=>{
                    if (this.resetMaxListeners(), typeof this.socket > "u") return o(new Error("WebSocket connection is missing or invalid"));
                    n(this.socket);
                });
            });
        }
        return this.url = e, this.registering = !0, new Promise((t, n)=>{
            const o = new URLSearchParams(e).get("origin"), s = (0, $21f900087ef2a598$exports.isReactNative)() ? {
                headers: {
                    origin: o
                }
            } : {
                rejectUnauthorized: !(0, $ceb127018999f416$export$8eb4a0a481601f29)(e)
            }, i = new $f6230024aa4de9c4$var$S(e, [], s);
            $f6230024aa4de9c4$var$b() ? i.onerror = (r)=>{
                const l = r;
                n(this.emitError(l.error));
            } : i.on("error", (r)=>{
                n(this.emitError(r));
            }), i.onopen = ()=>{
                this.onOpen(i), t(i);
            };
        });
    }
    onOpen(e) {
        e.onmessage = (t)=>this.onPayload(t), e.onclose = (t)=>this.onClose(t), this.socket = e, this.registering = !1, this.events.emit("open");
    }
    onClose(e) {
        this.socket = void 0, this.registering = !1, this.events.emit("close", e);
    }
    onPayload(e) {
        if (typeof e.data > "u") return;
        const t = typeof e.data == "string" ? (0, $81c2e06d24b89184$export$84137bb44359aed5)(e.data) : e.data;
        this.events.emit("payload", t);
    }
    onError(e, t) {
        const n = this.parseError(t), o = n.message || n.toString(), s = (0, $3bb3ddc7bbc938cc$export$9f7302ae26c3f77)(e, o);
        this.events.emit("payload", s);
    }
    parseError(e, t = this.url) {
        return (0, $ab82c37acb5ed82a$export$f555d7d8f922e407)(e, $f6230024aa4de9c4$var$a(t), "WS");
    }
    resetMaxListeners() {
        this.events.getMaxListeners() > $f6230024aa4de9c4$var$h && this.events.setMaxListeners($f6230024aa4de9c4$var$h);
    }
    emitError(e) {
        const t = this.parseError(new Error(e?.message || `WebSocket connection failed for host: ${$f6230024aa4de9c4$var$a(this.url)}`));
        return this.events.emit("register_error", t), t;
    }
}



var $6cqMT = parcelRequire("6cqMT");
var $436950a2454b4407$exports = {};


$436950a2454b4407$exports = self.fetch || (self.fetch = (parcelRequire("laOt8")).default || (parcelRequire("laOt8")));


function $e9e439c110f17033$var$Hi(n, e) {
    if (n.length >= 255) throw new TypeError("Alphabet too long");
    for(var t = new Uint8Array(256), i = 0; i < t.length; i++)t[i] = 255;
    for(var s = 0; s < n.length; s++){
        var r = n.charAt(s), o = r.charCodeAt(0);
        if (t[o] !== 255) throw new TypeError(r + " is ambiguous");
        t[o] = s;
    }
    var a = n.length, h = n.charAt(0), l = Math.log(a) / Math.log(256), d = Math.log(256) / Math.log(a);
    function g(u) {
        if (u instanceof Uint8Array || (ArrayBuffer.isView(u) ? u = new Uint8Array(u.buffer, u.byteOffset, u.byteLength) : Array.isArray(u) && (u = Uint8Array.from(u))), !(u instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (u.length === 0) return "";
        for(var p = 0, C = 0, D = 0, P = u.length; D !== P && u[D] === 0;)D++, p++;
        for(var x = (P - D) * d + 1 >>> 0, E = new Uint8Array(x); D !== P;){
            for(var O = u[D], N = 0, _ = x - 1; (O !== 0 || N < C) && _ !== -1; _--, N++)O += 256 * E[_] >>> 0, E[_] = O % a >>> 0, O = O / a >>> 0;
            if (O !== 0) throw new Error("Non-zero carry");
            C = N, D++;
        }
        for(var A = x - C; A !== x && E[A] === 0;)A++;
        for(var j = h.repeat(p); A < x; ++A)j += n.charAt(E[A]);
        return j;
    }
    function m(u) {
        if (typeof u != "string") throw new TypeError("Expected String");
        if (u.length === 0) return new Uint8Array;
        var p = 0;
        if (u[p] !== " ") {
            for(var C = 0, D = 0; u[p] === h;)C++, p++;
            for(var P = (u.length - p) * l + 1 >>> 0, x = new Uint8Array(P); u[p];){
                var E = t[u.charCodeAt(p)];
                if (E === 255) return;
                for(var O = 0, N = P - 1; (E !== 0 || O < D) && N !== -1; N--, O++)E += a * x[N] >>> 0, x[N] = E % 256 >>> 0, E = E / 256 >>> 0;
                if (E !== 0) throw new Error("Non-zero carry");
                D = O, p++;
            }
            if (u[p] !== " ") {
                for(var _ = P - D; _ !== P && x[_] === 0;)_++;
                for(var A = new Uint8Array(C + (P - _)), j = C; _ !== P;)A[j++] = x[_++];
                return A;
            }
        }
    }
    function U(u) {
        var p = m(u);
        if (p) return p;
        throw new Error(`Non-${e} character`);
    }
    return {
        encode: g,
        decodeUnsafe: m,
        decode: U
    };
}
var $e9e439c110f17033$var$Ji = $e9e439c110f17033$var$Hi, $e9e439c110f17033$var$Xi = $e9e439c110f17033$var$Ji;
const $e9e439c110f17033$var$$e = (n)=>{
    if (n instanceof Uint8Array && n.constructor.name === "Uint8Array") return n;
    if (n instanceof ArrayBuffer) return new Uint8Array(n);
    if (ArrayBuffer.isView(n)) return new Uint8Array(n.buffer, n.byteOffset, n.byteLength);
    throw new Error("Unknown type, must be binary type");
}, $e9e439c110f17033$var$Wi = (n)=>new TextEncoder().encode(n), $e9e439c110f17033$var$Qi = (n)=>new TextDecoder().decode(n);
class $e9e439c110f17033$var$Zi {
    constructor(e, t, i){
        this.name = e, this.prefix = t, this.baseEncode = i;
    }
    encode(e) {
        if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
        throw Error("Unknown type, must be binary type");
    }
}
class $e9e439c110f17033$var$es {
    constructor(e, t, i){
        if (this.name = e, this.prefix = t, t.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
        this.prefixCodePoint = t.codePointAt(0), this.baseDecode = i;
    }
    decode(e) {
        if (typeof e == "string") {
            if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(e.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(e) {
        return $e9e439c110f17033$var$Fe(this, e);
    }
}
class $e9e439c110f17033$var$ts {
    constructor(e){
        this.decoders = e;
    }
    or(e) {
        return $e9e439c110f17033$var$Fe(this, e);
    }
    decode(e) {
        const t = e[0], i = this.decoders[t];
        if (i) return i.decode(e);
        throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $e9e439c110f17033$var$Fe = (n, e)=>new $e9e439c110f17033$var$ts({
        ...n.decoders || {
            [n.prefix]: n
        },
        ...e.decoders || {
            [e.prefix]: e
        }
    });
class $e9e439c110f17033$var$is {
    constructor(e, t, i, s){
        this.name = e, this.prefix = t, this.baseEncode = i, this.baseDecode = s, this.encoder = new $e9e439c110f17033$var$Zi(e, t, i), this.decoder = new $e9e439c110f17033$var$es(e, t, s);
    }
    encode(e) {
        return this.encoder.encode(e);
    }
    decode(e) {
        return this.decoder.decode(e);
    }
}
const $e9e439c110f17033$var$Q = ({ name: n, prefix: e, encode: t, decode: i })=>new $e9e439c110f17033$var$is(n, e, t, i), $e9e439c110f17033$var$B = ({ prefix: n, name: e, alphabet: t })=>{
    const { encode: i, decode: s } = $e9e439c110f17033$var$Xi(t, e);
    return $e9e439c110f17033$var$Q({
        prefix: n,
        name: e,
        encode: i,
        decode: (r)=>$e9e439c110f17033$var$$e(s(r))
    });
}, $e9e439c110f17033$var$ss = (n, e, t, i)=>{
    const s = {};
    for(let d = 0; d < e.length; ++d)s[e[d]] = d;
    let r = n.length;
    for(; n[r - 1] === "=";)--r;
    const o = new Uint8Array(r * t / 8 | 0);
    let a = 0, h = 0, l = 0;
    for(let d = 0; d < r; ++d){
        const g = s[n[d]];
        if (g === void 0) throw new SyntaxError(`Non-${i} character`);
        h = h << t | g, a += t, a >= 8 && (a -= 8, o[l++] = 255 & h >> a);
    }
    if (a >= t || 255 & h << 8 - a) throw new SyntaxError("Unexpected end of data");
    return o;
}, $e9e439c110f17033$var$rs = (n, e, t)=>{
    const i = e[e.length - 1] === "=", s = (1 << t) - 1;
    let r = "", o = 0, a = 0;
    for(let h = 0; h < n.length; ++h)for(a = a << 8 | n[h], o += 8; o > t;)o -= t, r += e[s & a >> o];
    if (o && (r += e[s & a << t - o]), i) for(; r.length * t & 7;)r += "=";
    return r;
}, $e9e439c110f17033$var$y = ({ name: n, prefix: e, bitsPerChar: t, alphabet: i })=>$e9e439c110f17033$var$Q({
        prefix: e,
        name: n,
        encode (s) {
            return $e9e439c110f17033$var$rs(s, i, t);
        },
        decode (s) {
            return $e9e439c110f17033$var$ss(s, i, t, n);
        }
    }), $e9e439c110f17033$var$ns = $e9e439c110f17033$var$Q({
    prefix: "\x00",
    name: "identity",
    encode: (n)=>$e9e439c110f17033$var$Qi(n),
    decode: (n)=>$e9e439c110f17033$var$Wi(n)
});
var $e9e439c110f17033$var$os = Object.freeze({
    __proto__: null,
    identity: $e9e439c110f17033$var$ns
});
const $e9e439c110f17033$var$as = $e9e439c110f17033$var$y({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
var $e9e439c110f17033$var$hs = Object.freeze({
    __proto__: null,
    base2: $e9e439c110f17033$var$as
});
const $e9e439c110f17033$var$cs = $e9e439c110f17033$var$y({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
var $e9e439c110f17033$var$ls = Object.freeze({
    __proto__: null,
    base8: $e9e439c110f17033$var$cs
});
const $e9e439c110f17033$var$us = $e9e439c110f17033$var$B({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
var $e9e439c110f17033$var$ds = Object.freeze({
    __proto__: null,
    base10: $e9e439c110f17033$var$us
});
const $e9e439c110f17033$var$gs = $e9e439c110f17033$var$y({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), $e9e439c110f17033$var$ps = $e9e439c110f17033$var$y({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
var $e9e439c110f17033$var$Ds = Object.freeze({
    __proto__: null,
    base16: $e9e439c110f17033$var$gs,
    base16upper: $e9e439c110f17033$var$ps
});
const $e9e439c110f17033$var$ys = $e9e439c110f17033$var$y({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), $e9e439c110f17033$var$ms = $e9e439c110f17033$var$y({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), $e9e439c110f17033$var$bs = $e9e439c110f17033$var$y({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$fs = $e9e439c110f17033$var$y({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$Es = $e9e439c110f17033$var$y({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), $e9e439c110f17033$var$ws = $e9e439c110f17033$var$y({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), $e9e439c110f17033$var$vs = $e9e439c110f17033$var$y({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$Is = $e9e439c110f17033$var$y({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$Cs = $e9e439c110f17033$var$y({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
var $e9e439c110f17033$var$_s = Object.freeze({
    __proto__: null,
    base32: $e9e439c110f17033$var$ys,
    base32upper: $e9e439c110f17033$var$ms,
    base32pad: $e9e439c110f17033$var$bs,
    base32padupper: $e9e439c110f17033$var$fs,
    base32hex: $e9e439c110f17033$var$Es,
    base32hexupper: $e9e439c110f17033$var$ws,
    base32hexpad: $e9e439c110f17033$var$vs,
    base32hexpadupper: $e9e439c110f17033$var$Is,
    base32z: $e9e439c110f17033$var$Cs
});
const $e9e439c110f17033$var$Rs = $e9e439c110f17033$var$B({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $e9e439c110f17033$var$Ts = $e9e439c110f17033$var$B({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
var $e9e439c110f17033$var$Ss = Object.freeze({
    __proto__: null,
    base36: $e9e439c110f17033$var$Rs,
    base36upper: $e9e439c110f17033$var$Ts
});
const $e9e439c110f17033$var$Ps = $e9e439c110f17033$var$B({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), $e9e439c110f17033$var$xs = $e9e439c110f17033$var$B({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
var $e9e439c110f17033$var$Os = Object.freeze({
    __proto__: null,
    base58btc: $e9e439c110f17033$var$Ps,
    base58flickr: $e9e439c110f17033$var$xs
});
const $e9e439c110f17033$var$As = $e9e439c110f17033$var$y({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), $e9e439c110f17033$var$zs = $e9e439c110f17033$var$y({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), $e9e439c110f17033$var$Ns = $e9e439c110f17033$var$y({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), $e9e439c110f17033$var$Us = $e9e439c110f17033$var$y({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
var $e9e439c110f17033$var$Ls = Object.freeze({
    __proto__: null,
    base64: $e9e439c110f17033$var$As,
    base64pad: $e9e439c110f17033$var$zs,
    base64url: $e9e439c110f17033$var$Ns,
    base64urlpad: $e9e439c110f17033$var$Us
});
const $e9e439c110f17033$var$ke = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), $e9e439c110f17033$var$$s = $e9e439c110f17033$var$ke.reduce((n, e, t)=>(n[t] = e, n), []), $e9e439c110f17033$var$Fs = $e9e439c110f17033$var$ke.reduce((n, e, t)=>(n[e.codePointAt(0)] = t, n), []);
function $e9e439c110f17033$var$ks(n) {
    return n.reduce((e, t)=>(e += $e9e439c110f17033$var$$s[t], e), "");
}
function $e9e439c110f17033$var$Ms(n) {
    const e = [];
    for (const t of n){
        const i = $e9e439c110f17033$var$Fs[t.codePointAt(0)];
        if (i === void 0) throw new Error(`Non-base256emoji character: ${t}`);
        e.push(i);
    }
    return new Uint8Array(e);
}
const $e9e439c110f17033$var$Ks = $e9e439c110f17033$var$Q({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $e9e439c110f17033$var$ks,
    decode: $e9e439c110f17033$var$Ms
});
var $e9e439c110f17033$var$Bs = Object.freeze({
    __proto__: null,
    base256emoji: $e9e439c110f17033$var$Ks
}), $e9e439c110f17033$var$Vs = $e9e439c110f17033$var$Ke, $e9e439c110f17033$var$Me = 128, $e9e439c110f17033$var$qs = 127, $e9e439c110f17033$var$js = ~$e9e439c110f17033$var$qs, $e9e439c110f17033$var$Gs = Math.pow(2, 31);
function $e9e439c110f17033$var$Ke(n, e, t) {
    e = e || [], t = t || 0;
    for(var i = t; n >= $e9e439c110f17033$var$Gs;)e[t++] = n & 255 | $e9e439c110f17033$var$Me, n /= 128;
    for(; n & $e9e439c110f17033$var$js;)e[t++] = n & 255 | $e9e439c110f17033$var$Me, n >>>= 7;
    return e[t] = n | 0, $e9e439c110f17033$var$Ke.bytes = t - i + 1, e;
}
var $e9e439c110f17033$var$Ys = $e9e439c110f17033$var$de, $e9e439c110f17033$var$Hs = 128, $e9e439c110f17033$var$Be = 127;
function $e9e439c110f17033$var$de(n, i) {
    var t = 0, i = i || 0, s = 0, r = i, o, a = n.length;
    do {
        if (r >= a) throw $e9e439c110f17033$var$de.bytes = 0, new RangeError("Could not decode varint");
        o = n[r++], t += s < 28 ? (o & $e9e439c110f17033$var$Be) << s : (o & $e9e439c110f17033$var$Be) * Math.pow(2, s), s += 7;
    }while (o >= $e9e439c110f17033$var$Hs);
    return $e9e439c110f17033$var$de.bytes = r - i, t;
}
var $e9e439c110f17033$var$Js = Math.pow(2, 7), $e9e439c110f17033$var$Xs = Math.pow(2, 14), $e9e439c110f17033$var$Ws = Math.pow(2, 21), $e9e439c110f17033$var$Qs = Math.pow(2, 28), $e9e439c110f17033$var$Zs = Math.pow(2, 35), $e9e439c110f17033$var$er = Math.pow(2, 42), $e9e439c110f17033$var$tr = Math.pow(2, 49), $e9e439c110f17033$var$ir = Math.pow(2, 56), $e9e439c110f17033$var$sr = Math.pow(2, 63), $e9e439c110f17033$var$rr = function(n) {
    return n < $e9e439c110f17033$var$Js ? 1 : n < $e9e439c110f17033$var$Xs ? 2 : n < $e9e439c110f17033$var$Ws ? 3 : n < $e9e439c110f17033$var$Qs ? 4 : n < $e9e439c110f17033$var$Zs ? 5 : n < $e9e439c110f17033$var$er ? 6 : n < $e9e439c110f17033$var$tr ? 7 : n < $e9e439c110f17033$var$ir ? 8 : n < $e9e439c110f17033$var$sr ? 9 : 10;
}, $e9e439c110f17033$var$nr = {
    encode: $e9e439c110f17033$var$Vs,
    decode: $e9e439c110f17033$var$Ys,
    encodingLength: $e9e439c110f17033$var$rr
}, $e9e439c110f17033$var$Ve = $e9e439c110f17033$var$nr;
const $e9e439c110f17033$var$qe = (n, e, t = 0)=>($e9e439c110f17033$var$Ve.encode(n, e, t), e), $e9e439c110f17033$var$je = (n)=>$e9e439c110f17033$var$Ve.encodingLength(n), $e9e439c110f17033$var$ge = (n, e)=>{
    const t = e.byteLength, i = $e9e439c110f17033$var$je(n), s = i + $e9e439c110f17033$var$je(t), r = new Uint8Array(s + t);
    return $e9e439c110f17033$var$qe(n, r, 0), $e9e439c110f17033$var$qe(t, r, i), r.set(e, s), new $e9e439c110f17033$var$or(n, t, e, r);
};
class $e9e439c110f17033$var$or {
    constructor(e, t, i, s){
        this.code = e, this.size = t, this.digest = i, this.bytes = s;
    }
}
const $e9e439c110f17033$var$Ge = ({ name: n, code: e, encode: t })=>new $e9e439c110f17033$var$ar(n, e, t);
class $e9e439c110f17033$var$ar {
    constructor(e, t, i){
        this.name = e, this.code = t, this.encode = i;
    }
    digest(e) {
        if (e instanceof Uint8Array) {
            const t = this.encode(e);
            return t instanceof Uint8Array ? $e9e439c110f17033$var$ge(this.code, t) : t.then((i)=>$e9e439c110f17033$var$ge(this.code, i));
        } else throw Error("Unknown type, must be binary type");
    }
}
const $e9e439c110f17033$var$Ye = (n)=>async (e)=>new Uint8Array(await crypto.subtle.digest(n, e)), $e9e439c110f17033$var$hr = $e9e439c110f17033$var$Ge({
    name: "sha2-256",
    code: 18,
    encode: $e9e439c110f17033$var$Ye("SHA-256")
}), $e9e439c110f17033$var$cr = $e9e439c110f17033$var$Ge({
    name: "sha2-512",
    code: 19,
    encode: $e9e439c110f17033$var$Ye("SHA-512")
});
var $e9e439c110f17033$var$lr = Object.freeze({
    __proto__: null,
    sha256: $e9e439c110f17033$var$hr,
    sha512: $e9e439c110f17033$var$cr
});
const $e9e439c110f17033$var$He = 0, $e9e439c110f17033$var$ur = "identity", $e9e439c110f17033$var$Je = $e9e439c110f17033$var$$e, $e9e439c110f17033$var$dr = (n)=>$e9e439c110f17033$var$ge($e9e439c110f17033$var$He, $e9e439c110f17033$var$Je(n)), $e9e439c110f17033$var$gr = {
    code: $e9e439c110f17033$var$He,
    name: $e9e439c110f17033$var$ur,
    encode: $e9e439c110f17033$var$Je,
    digest: $e9e439c110f17033$var$dr
};
var $e9e439c110f17033$var$pr = Object.freeze({
    __proto__: null,
    identity: $e9e439c110f17033$var$gr
});
new TextEncoder, new TextDecoder;
const $e9e439c110f17033$var$Xe = {
    ...$e9e439c110f17033$var$os,
    ...$e9e439c110f17033$var$hs,
    ...$e9e439c110f17033$var$ls,
    ...$e9e439c110f17033$var$ds,
    ...$e9e439c110f17033$var$Ds,
    ...$e9e439c110f17033$var$_s,
    ...$e9e439c110f17033$var$Ss,
    ...$e9e439c110f17033$var$Os,
    ...$e9e439c110f17033$var$Ls,
    ...$e9e439c110f17033$var$Bs
};
({
    ...$e9e439c110f17033$var$lr,
    ...$e9e439c110f17033$var$pr
});
function $e9e439c110f17033$var$We(n) {
    return globalThis.Buffer != null ? new Uint8Array(n.buffer, n.byteOffset, n.byteLength) : n;
}
function $e9e439c110f17033$var$Dr(n = 0) {
    return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? $e9e439c110f17033$var$We(globalThis.Buffer.allocUnsafe(n)) : new Uint8Array(n);
}
function $e9e439c110f17033$var$Qe(n, e, t, i) {
    return {
        name: n,
        prefix: e,
        encoder: {
            name: n,
            prefix: e,
            encode: t
        },
        decoder: {
            decode: i
        }
    };
}
const $e9e439c110f17033$var$Ze = $e9e439c110f17033$var$Qe("utf8", "u", (n)=>"u" + new TextDecoder("utf8").decode(n), (n)=>new TextEncoder().encode(n.substring(1))), $e9e439c110f17033$var$pe = $e9e439c110f17033$var$Qe("ascii", "a", (n)=>{
    let e = "a";
    for(let t = 0; t < n.length; t++)e += String.fromCharCode(n[t]);
    return e;
}, (n)=>{
    n = n.substring(1);
    const e = $e9e439c110f17033$var$Dr(n.length);
    for(let t = 0; t < n.length; t++)e[t] = n.charCodeAt(t);
    return e;
}), $e9e439c110f17033$var$yr = {
    utf8: $e9e439c110f17033$var$Ze,
    "utf-8": $e9e439c110f17033$var$Ze,
    hex: $e9e439c110f17033$var$Xe.base16,
    latin1: $e9e439c110f17033$var$pe,
    ascii: $e9e439c110f17033$var$pe,
    binary: $e9e439c110f17033$var$pe,
    ...$e9e439c110f17033$var$Xe
};
function $e9e439c110f17033$var$mr(n, e = "utf8") {
    const t = $e9e439c110f17033$var$yr[e];
    if (!t) throw new Error(`Unsupported encoding "${e}"`);
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? $e9e439c110f17033$var$We(globalThis.Buffer.from(n, "utf-8")) : t.decoder.decode(`${t.prefix}${n}`);
}
const $e9e439c110f17033$export$51b1c900ac262bdf = "wc", $e9e439c110f17033$export$f30bd3c8747cdfbe = 2, $e9e439c110f17033$export$d47601f9de5ee22b = "core", $e9e439c110f17033$export$f258d29ae5e3d545 = `${$e9e439c110f17033$export$51b1c900ac262bdf}@2:${$e9e439c110f17033$export$d47601f9de5ee22b}:`, $e9e439c110f17033$export$db0fdb6d486555c2 = {
    name: $e9e439c110f17033$export$d47601f9de5ee22b,
    logger: "error"
}, $e9e439c110f17033$export$ba920abfe854b85d = {
    database: ":memory:"
}, $e9e439c110f17033$export$92a79f21481c803d = "crypto", $e9e439c110f17033$export$3613aa6e652146e4 = "client_ed25519_seed", $e9e439c110f17033$export$c4bc5e31a4d0ec78 = (0, $aG48A.ONE_DAY), $e9e439c110f17033$export$9d7218f72e8dc49b = "keychain", $e9e439c110f17033$export$34f82f4ba0c3d769 = "0.3", $e9e439c110f17033$export$9662bbc7d10cf481 = "messages", $e9e439c110f17033$export$19dfd1896412c038 = "0.3", $e9e439c110f17033$export$8ddbe6611b67d926 = (0, $aG48A.SIX_HOURS), $e9e439c110f17033$export$9d92662178f2abd1 = "publisher", $e9e439c110f17033$export$822d0bd1635d5360 = "irn", $e9e439c110f17033$export$5176ffa6778d6637 = "error", $e9e439c110f17033$export$a68061e6c48f332a = "wss://relay.walletconnect.com", $e9e439c110f17033$export$27fee22bec112637 = "wss://relay.walletconnect.org", $e9e439c110f17033$export$602d6e27611c3fcb = "relayer", $e9e439c110f17033$export$d56245796e2837d = {
    message: "relayer_message",
    message_ack: "relayer_message_ack",
    connect: "relayer_connect",
    disconnect: "relayer_disconnect",
    error: "relayer_error",
    connection_stalled: "relayer_connection_stalled",
    transport_closed: "relayer_transport_closed",
    publish: "relayer_publish"
}, $e9e439c110f17033$export$119b4645f6b233c8 = "_subscription", $e9e439c110f17033$export$58062acf2f31ddf8 = {
    payload: "payload",
    connect: "connect",
    disconnect: "disconnect",
    error: "error"
}, $e9e439c110f17033$export$11ccd39be2c57d6 = (0, $aG48A.ONE_SECOND), $e9e439c110f17033$export$44b621f74f0f4c93 = {
    database: ":memory:"
}, $e9e439c110f17033$export$5f30917a6f8c9025 = "2.11.3", $e9e439c110f17033$export$fb3eab7adf12329d = 1e4, $e9e439c110f17033$export$629a342182ba24b = "0.3", $e9e439c110f17033$export$9e4ca561755938da = "WALLETCONNECT_CLIENT_ID", $e9e439c110f17033$export$24ff3e54e94ef413 = {
    created: "subscription_created",
    deleted: "subscription_deleted",
    expired: "subscription_expired",
    disabled: "subscription_disabled",
    sync: "subscription_sync",
    resubscribed: "subscription_resubscribed"
}, $e9e439c110f17033$export$9d35d0a6a3599be = (0, $aG48A.THIRTY_DAYS), $e9e439c110f17033$export$9c3a96bb670cddb8 = "subscription", $e9e439c110f17033$export$fb57e03bef4c4cea = "0.3", $e9e439c110f17033$export$9a2ddbfe54f8af77 = (0, $aG48A.FIVE_SECONDS) * 1e3, $e9e439c110f17033$export$390360ea476c6145 = "pairing", $e9e439c110f17033$export$5593ec74b27d1b18 = "0.3", $e9e439c110f17033$export$ee4b1978d0aedfad = (0, $aG48A.THIRTY_DAYS), $e9e439c110f17033$export$d94d6986a8185883 = {
    wc_pairingDelete: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1e3
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1001
        }
    },
    wc_pairingPing: {
        req: {
            ttl: (0, $aG48A.THIRTY_SECONDS),
            prompt: !1,
            tag: 1002
        },
        res: {
            ttl: (0, $aG48A.THIRTY_SECONDS),
            prompt: !1,
            tag: 1003
        }
    },
    unregistered_method: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 0
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 0
        }
    }
}, $e9e439c110f17033$export$ca3c0b962acf7b75 = {
    create: "pairing_create",
    expire: "pairing_expire",
    delete: "pairing_delete",
    ping: "pairing_ping"
}, $e9e439c110f17033$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $e9e439c110f17033$export$160142c73cb99dc3 = "history", $e9e439c110f17033$export$8eba9ce85616c607 = "0.3", $e9e439c110f17033$export$4ddf883392bbc828 = "expirer", $e9e439c110f17033$export$9013719d9206b0c1 = {
    created: "expirer_created",
    deleted: "expirer_deleted",
    expired: "expirer_expired",
    sync: "expirer_sync"
}, $e9e439c110f17033$export$717295846191925d = "0.3", $e9e439c110f17033$export$3cfe73d6765db74 = (0, $aG48A.ONE_DAY), $e9e439c110f17033$export$3b58f2450f2297e3 = "verify-api", $e9e439c110f17033$export$7e3b1a28ddecdbaa = "https://verify.walletconnect.com", $e9e439c110f17033$export$4fe83ee8f9aec7b6 = "https://verify.walletconnect.org", $e9e439c110f17033$export$be24df03c4baa778 = [
    $e9e439c110f17033$export$7e3b1a28ddecdbaa,
    $e9e439c110f17033$export$4fe83ee8f9aec7b6
], $e9e439c110f17033$export$40c022d2cffe0adc = "echo", $e9e439c110f17033$export$3c48c4faab79aab1 = "https://echo.walletconnect.com";
class $e9e439c110f17033$export$dd4508d2540f08d3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.keychain = new Map, this.name = $e9e439c110f17033$export$9d7218f72e8dc49b, this.version = $e9e439c110f17033$export$34f82f4ba0c3d769, this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                const i = await this.getKeyChain();
                typeof i < "u" && (this.keychain = i), this.initialized = !0;
            }
        }, this.has = (i)=>(this.isInitialized(), this.keychain.has(i)), this.set = async (i, s)=>{
            this.isInitialized(), this.keychain.set(i, s), await this.persist();
        }, this.get = (i)=>{
            this.isInitialized();
            const s = this.keychain.get(i);
            if (typeof s > "u") {
                const { message: r } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${i}`);
                throw new Error(r);
            }
            return s;
        }, this.del = async (i)=>{
            this.isInitialized(), this.keychain.delete(i), await this.persist();
        }, this.core = e, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    async setKeyChain(e) {
        await this.core.storage.setItem(this.storageKey, (0, $a5d33cfc7f8e5437$export$c4b8dfeb6e237eb9)(e));
    }
    async getKeyChain() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $a5d33cfc7f8e5437$export$ac31b37c726bc3ba)(e) : void 0;
    }
    async persist() {
        await this.setKeyChain(this.keychain);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$8ac8b6291b7ccf24 {
    constructor(e, t, i){
        this.core = e, this.logger = t, this.name = $e9e439c110f17033$export$92a79f21481c803d, this.initialized = !1, this.init = async ()=>{
            this.initialized || (await this.keychain.init(), this.initialized = !0);
        }, this.hasKeys = (s)=>(this.isInitialized(), this.keychain.has(s)), this.getClientId = async ()=>{
            this.isInitialized();
            const s = await this.getClientSeed(), r = $2281914794d9e636$export$a949d36eab55b41f(s);
            return $f6e90d472e8dfc29$export$1b29ef9371459e10(r.publicKey);
        }, this.generateKeyPair = ()=>{
            this.isInitialized();
            const s = (0, $a5d33cfc7f8e5437$export$a949d36eab55b41f)();
            return this.setPrivateKey(s.publicKey, s.privateKey);
        }, this.signJWT = async (s)=>{
            this.isInitialized();
            const r = await this.getClientSeed(), o = $2281914794d9e636$export$a949d36eab55b41f(r), a = (0, $a5d33cfc7f8e5437$export$d15a28e4f1821243)(), h = $e9e439c110f17033$export$c4bc5e31a4d0ec78;
            return await $2281914794d9e636$export$a8dda30659d36d45(a, s, h, o);
        }, this.generateSharedKey = (s, r, o)=>{
            this.isInitialized();
            const a = this.getPrivateKey(s), h = (0, $a5d33cfc7f8e5437$export$f8378f68e053f5c6)(a, r);
            return this.setSymKey(h, o);
        }, this.setSymKey = async (s, r)=>{
            this.isInitialized();
            const o = r || (0, $a5d33cfc7f8e5437$export$1e87d19d4aab5805)(s);
            return await this.keychain.set(o, s), o;
        }, this.deleteKeyPair = async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }, this.deleteSymKey = async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }, this.encode = async (s, r, o)=>{
            this.isInitialized();
            const a = (0, $a5d33cfc7f8e5437$export$7949f60f2444aef2)(o), h = (0, $81c2e06d24b89184$export$abc3f407e87918a4)(r);
            if ((0, $a5d33cfc7f8e5437$export$8c165704db2d5c15)(a)) {
                const m = a.senderPublicKey, U = a.receiverPublicKey;
                s = await this.generateSharedKey(m, U);
            }
            const l = this.getSymKey(s), { type: d, senderPublicKey: g } = a;
            return (0, $a5d33cfc7f8e5437$export$5b0f6292f11d1d18)({
                type: d,
                symKey: l,
                message: h,
                senderPublicKey: g
            });
        }, this.decode = async (s, r, o)=>{
            this.isInitialized();
            const a = (0, $a5d33cfc7f8e5437$export$177f3e316562333d)(r, o);
            if ((0, $a5d33cfc7f8e5437$export$8c165704db2d5c15)(a)) {
                const h = a.receiverPublicKey, l = a.senderPublicKey;
                s = await this.generateSharedKey(h, l);
            }
            try {
                const h = this.getSymKey(s), l = (0, $a5d33cfc7f8e5437$export$e85a0c9a1067c5d3)({
                    symKey: h,
                    encoded: r
                });
                return (0, $81c2e06d24b89184$export$84137bb44359aed5)(l);
            } catch (h) {
                this.logger.error(`Failed to decode message from topic: '${s}', clientId: '${await this.getClientId()}'`), this.logger.error(h);
            }
        }, this.getPayloadType = (s)=>{
            const r = (0, $a5d33cfc7f8e5437$export$efcd34ab6248d3cd)(s);
            return (0, $a5d33cfc7f8e5437$export$7547a514ee29b9d4)(r.type);
        }, this.getPayloadSenderPublicKey = (s)=>{
            const r = (0, $a5d33cfc7f8e5437$export$efcd34ab6248d3cd)(s);
            return r.senderPublicKey ? (0, $74e9859baf4497ef$exports.toString)(r.senderPublicKey, (0, $a5d33cfc7f8e5437$export$49eb910ab2518105)) : void 0;
        }, this.core = e, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.keychain = i || new $e9e439c110f17033$export$dd4508d2540f08d3(this.core, this.logger);
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    async setPrivateKey(e, t) {
        return await this.keychain.set(e, t), e;
    }
    getPrivateKey(e) {
        return this.keychain.get(e);
    }
    async getClientSeed() {
        let e = "";
        try {
            e = this.keychain.get($e9e439c110f17033$export$3613aa6e652146e4);
        } catch  {
            e = (0, $a5d33cfc7f8e5437$export$d15a28e4f1821243)(), await this.keychain.set($e9e439c110f17033$export$3613aa6e652146e4, e);
        }
        return $e9e439c110f17033$var$mr(e, "base16");
    }
    getSymKey(e) {
        return this.keychain.get(e);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$4a2542d0790ac2fd extends (0, $bace94c1ef08d1bc$export$e67570fe0a885c47) {
    constructor(e, t){
        super(e, t), this.logger = e, this.core = t, this.messages = new Map, this.name = $e9e439c110f17033$export$9662bbc7d10cf481, this.version = $e9e439c110f17033$export$19dfd1896412c038, this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                this.logger.trace("Initialized");
                try {
                    const i = await this.getRelayerMessages();
                    typeof i < "u" && (this.messages = i), this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                        type: "method",
                        method: "restore",
                        size: this.messages.size
                    });
                } catch (i) {
                    this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(i);
                } finally{
                    this.initialized = !0;
                }
            }
        }, this.set = async (i, s)=>{
            this.isInitialized();
            const r = (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(s);
            let o = this.messages.get(i);
            return typeof o > "u" && (o = {}), typeof o[r] < "u" || (o[r] = s, this.messages.set(i, o), await this.persist()), r;
        }, this.get = (i)=>{
            this.isInitialized();
            let s = this.messages.get(i);
            return typeof s > "u" && (s = {}), s;
        }, this.has = (i, s)=>{
            this.isInitialized();
            const r = this.get(i), o = (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(s);
            return typeof r[o] < "u";
        }, this.del = async (i)=>{
            this.isInitialized(), this.messages.delete(i), await this.persist();
        }, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(e, this.name), this.core = t;
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    async setRelayerMessages(e) {
        await this.core.storage.setItem(this.storageKey, (0, $a5d33cfc7f8e5437$export$c4b8dfeb6e237eb9)(e));
    }
    async getRelayerMessages() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $a5d33cfc7f8e5437$export$ac31b37c726bc3ba)(e) : void 0;
    }
    async persist() {
        await this.setRelayerMessages(this.messages);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$var$vr extends (0, $bace94c1ef08d1bc$export$3b0872bbd7e675a2) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$9d92662178f2abd1, this.queue = new Map, this.publishTimeout = (0, $aG48A.toMiliseconds)((0, $aG48A.ONE_MINUTE)), this.failedPublishTimeout = (0, $aG48A.toMiliseconds)((0, $aG48A.ONE_SECOND)), this.needsTransportRestart = !1, this.publish = async (i, s, r)=>{
            var o;
            this.logger.debug("Publishing Payload"), this.logger.trace({
                type: "method",
                method: "publish",
                params: {
                    topic: i,
                    message: s,
                    opts: r
                }
            });
            const a = r?.ttl || $e9e439c110f17033$export$8ddbe6611b67d926, h = (0, $a5d33cfc7f8e5437$export$cf77af25151525db)(r), l = r?.prompt || !1, d = r?.tag || 0, g = r?.id || (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString(), m = {
                topic: i,
                message: s,
                opts: {
                    ttl: a,
                    relay: h,
                    prompt: l,
                    tag: d,
                    id: g
                }
            }, U = `Failed to publish payload, please try again. id:${g} tag:${d}`, u = Date.now();
            let p, C = 1;
            try {
                for(; p === void 0;){
                    if (Date.now() - u > this.publishTimeout) throw new Error(U);
                    this.logger.trace({
                        id: g,
                        attempts: C
                    }, `publisher.publish - attempt ${C}`), p = await await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(this.rpcPublish(i, s, a, h, l, d, g).catch((D)=>this.logger.warn(D)), this.publishTimeout, U), C++, p || await new Promise((D)=>setTimeout(D, this.failedPublishTimeout));
                }
                this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.publish, m), this.logger.debug("Successfully Published Payload"), this.logger.trace({
                    type: "method",
                    method: "publish",
                    params: {
                        id: g,
                        topic: i,
                        message: s,
                        opts: r
                    }
                });
            } catch (D) {
                if (this.logger.debug("Failed to Publish Payload"), this.logger.error(D), (o = r?.internal) != null && o.throwOnFailedPublish) throw D;
                this.queue.set(g, m);
            }
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.relayer = e, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.registerEventListeners();
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    rpcPublish(e, t, i, s, r, o, a) {
        var h, l, d, g;
        const m = {
            method: (0, $a5d33cfc7f8e5437$export$604e3deb95e1b734)(s.protocol).publish,
            params: {
                topic: e,
                message: t,
                ttl: i,
                prompt: r,
                tag: o
            },
            id: a
        };
        return (0, $a5d33cfc7f8e5437$export$fce6876652108ab)((h = m.params) == null ? void 0 : h.prompt) && ((l = m.params) == null || delete l.prompt), (0, $a5d33cfc7f8e5437$export$fce6876652108ab)((d = m.params) == null ? void 0 : d.tag) && ((g = m.params) == null || delete g.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "message",
            direction: "outgoing",
            request: m
        }), this.relayer.request(m);
    }
    removeRequestFromQueue(e) {
        this.queue.delete(e);
    }
    checkQueue() {
        this.queue.forEach(async (e)=>{
            const { topic: t, message: i, opts: s } = e;
            await this.publish(t, i, s);
        });
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $212993b948b3fe4b$exports.HEARTBEAT_EVENTS).pulse, ()=>{
            if (this.needsTransportRestart) {
                this.needsTransportRestart = !1, this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.connection_stalled);
                return;
            }
            this.checkQueue();
        }), this.relayer.on($e9e439c110f17033$export$d56245796e2837d.message_ack, (e)=>{
            this.removeRequestFromQueue(e.id.toString());
        });
    }
}
class $e9e439c110f17033$var$Ir {
    constructor(){
        this.map = new Map, this.set = (e, t)=>{
            const i = this.get(e);
            this.exists(e, t) || this.map.set(e, [
                ...i,
                t
            ]);
        }, this.get = (e)=>this.map.get(e) || [], this.exists = (e, t)=>this.get(e).includes(t), this.delete = (e, t)=>{
            if (typeof t > "u") {
                this.map.delete(e);
                return;
            }
            if (!this.map.has(e)) return;
            const i = this.get(e);
            if (!this.exists(e, t)) return;
            const s = i.filter((r)=>r !== t);
            if (!s.length) {
                this.map.delete(e);
                return;
            }
            this.map.set(e, s);
        }, this.clear = ()=>{
            this.map.clear();
        };
    }
    get topics() {
        return Array.from(this.map.keys());
    }
}
var $e9e439c110f17033$var$Cr = Object.defineProperty, $e9e439c110f17033$var$_r = Object.defineProperties, $e9e439c110f17033$var$Rr = Object.getOwnPropertyDescriptors, $e9e439c110f17033$var$Ut = Object.getOwnPropertySymbols, $e9e439c110f17033$var$Tr = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$Sr = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$Lt = (n, e, t)=>e in n ? $e9e439c110f17033$var$Cr(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : n[e] = t, $e9e439c110f17033$var$q = (n, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$Tr.call(e, t) && $e9e439c110f17033$var$Lt(n, t, e[t]);
    if ($e9e439c110f17033$var$Ut) for (var t of $e9e439c110f17033$var$Ut(e))$e9e439c110f17033$var$Sr.call(e, t) && $e9e439c110f17033$var$Lt(n, t, e[t]);
    return n;
}, $e9e439c110f17033$var$fe = (n, e)=>$e9e439c110f17033$var$_r(n, $e9e439c110f17033$var$Rr(e));
class $e9e439c110f17033$export$60959659b2c22881 extends (0, $bace94c1ef08d1bc$export$300eed987e764b57) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.subscriptions = new Map, this.topicMap = new $e9e439c110f17033$var$Ir, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$9c3a96bb670cddb8, this.version = $e9e439c110f17033$export$fb57e03bef4c4cea, this.pending = new Map, this.cached = [], this.initialized = !1, this.pendingSubscriptionWatchLabel = "pending_sub_watch_label", this.pollingInterval = 20, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.subscribeTimeout = (0, $aG48A.toMiliseconds)((0, $aG48A.ONE_MINUTE)), this.restartInProgress = !1, this.batchSubscribeTopicsLimit = 500, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), this.registerEventListeners(), this.clientId = await this.relayer.core.crypto.getClientId());
        }, this.subscribe = async (i, s)=>{
            await this.restartToComplete(), this.isInitialized(), this.logger.debug("Subscribing Topic"), this.logger.trace({
                type: "method",
                method: "subscribe",
                params: {
                    topic: i,
                    opts: s
                }
            });
            try {
                const r = (0, $a5d33cfc7f8e5437$export$cf77af25151525db)(s), o = {
                    topic: i,
                    relay: r
                };
                this.pending.set(i, o);
                const a = await this.rpcSubscribe(i, r);
                return typeof a == "string" && (this.onSubscribe(a, o), this.logger.debug("Successfully Subscribed Topic"), this.logger.trace({
                    type: "method",
                    method: "subscribe",
                    params: {
                        topic: i,
                        opts: s
                    }
                })), a;
            } catch (r) {
                throw this.logger.debug("Failed to Subscribe Topic"), this.logger.error(r), r;
            }
        }, this.unsubscribe = async (i, s)=>{
            await this.restartToComplete(), this.isInitialized(), typeof s?.id < "u" ? await this.unsubscribeById(i, s.id, s) : await this.unsubscribeByTopic(i, s);
        }, this.isSubscribed = async (i)=>{
            if (this.topics.includes(i)) return !0;
            const s = `${this.pendingSubscriptionWatchLabel}_${i}`;
            return await new Promise((r, o)=>{
                const a = new (0, $aG48A.Watch);
                a.start(s);
                const h = setInterval(()=>{
                    !this.pending.has(i) && this.topics.includes(i) && (clearInterval(h), a.stop(s), r(!0)), a.elapsed(s) >= $e9e439c110f17033$export$9a2ddbfe54f8af77 && (clearInterval(h), a.stop(s), o(new Error("Subscription resolution timeout")));
                }, this.pollingInterval);
            }).catch(()=>!1);
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.start = async ()=>{
            await this.onConnect();
        }, this.stop = async ()=>{
            await this.onDisconnect();
        }, this.restart = async ()=>{
            this.restartInProgress = !0, await this.restore(), await this.reset(), this.restartInProgress = !1;
        }, this.relayer = e, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.clientId = "";
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.relayer.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.subscriptions.size;
    }
    get ids() {
        return Array.from(this.subscriptions.keys());
    }
    get values() {
        return Array.from(this.subscriptions.values());
    }
    get topics() {
        return this.topicMap.topics;
    }
    hasSubscription(e, t) {
        let i = !1;
        try {
            i = this.getSubscription(e).topic === t;
        } catch  {}
        return i;
    }
    onEnable() {
        this.cached = [], this.initialized = !0;
    }
    onDisable() {
        this.cached = this.values, this.subscriptions.clear(), this.topicMap.clear();
    }
    async unsubscribeByTopic(e, t) {
        const i = this.topicMap.get(e);
        await Promise.all(i.map(async (s)=>await this.unsubscribeById(e, s, t)));
    }
    async unsubscribeById(e, t, i) {
        this.logger.debug("Unsubscribing Topic"), this.logger.trace({
            type: "method",
            method: "unsubscribe",
            params: {
                topic: e,
                id: t,
                opts: i
            }
        });
        try {
            const s = (0, $a5d33cfc7f8e5437$export$cf77af25151525db)(i);
            await this.rpcUnsubscribe(e, t, s);
            const r = (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED", `${this.name}, ${e}`);
            await this.onUnsubscribe(e, t, r), this.logger.debug("Successfully Unsubscribed Topic"), this.logger.trace({
                type: "method",
                method: "unsubscribe",
                params: {
                    topic: e,
                    id: t,
                    opts: i
                }
            });
        } catch (s) {
            throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(s), s;
        }
    }
    async rpcSubscribe(e, t) {
        const i = {
            method: (0, $a5d33cfc7f8e5437$export$604e3deb95e1b734)(t.protocol).subscribe,
            params: {
                topic: e
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            return await await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(this.relayer.request(i).catch((s)=>this.logger.warn(s)), this.subscribeTimeout) ? (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(e + this.clientId) : null;
        } catch  {
            this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.connection_stalled);
        }
        return null;
    }
    async rpcBatchSubscribe(e) {
        if (!e.length) return;
        const t = e[0].relay, i = {
            method: (0, $a5d33cfc7f8e5437$export$604e3deb95e1b734)(t.protocol).batchSubscribe,
            params: {
                topics: e.map((s)=>s.topic)
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            return await await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(this.relayer.request(i).catch((s)=>this.logger.warn(s)), this.subscribeTimeout);
        } catch  {
            this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.connection_stalled);
        }
    }
    rpcUnsubscribe(e, t, i) {
        const s = {
            method: (0, $a5d33cfc7f8e5437$export$604e3deb95e1b734)(i.protocol).unsubscribe,
            params: {
                topic: e,
                id: t
            }
        };
        return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: s
        }), this.relayer.request(s);
    }
    onSubscribe(e, t) {
        this.setSubscription(e, $e9e439c110f17033$var$fe($e9e439c110f17033$var$q({}, t), {
            id: e
        })), this.pending.delete(t.topic);
    }
    onBatchSubscribe(e) {
        e.length && e.forEach((t)=>{
            this.setSubscription(t.id, $e9e439c110f17033$var$q({}, t)), this.pending.delete(t.topic);
        });
    }
    async onUnsubscribe(e, t, i) {
        this.events.removeAllListeners(t), this.hasSubscription(t, e) && this.deleteSubscription(t, i), await this.relayer.messages.del(e);
    }
    async setRelayerSubscriptions(e) {
        await this.relayer.core.storage.setItem(this.storageKey, e);
    }
    async getRelayerSubscriptions() {
        return await this.relayer.core.storage.getItem(this.storageKey);
    }
    setSubscription(e, t) {
        this.logger.debug("Setting subscription"), this.logger.trace({
            type: "method",
            method: "setSubscription",
            id: e,
            subscription: t
        }), this.addSubscription(e, t);
    }
    addSubscription(e, t) {
        this.subscriptions.set(e, $e9e439c110f17033$var$q({}, t)), this.topicMap.set(t.topic, e), this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.created, t);
    }
    getSubscription(e) {
        this.logger.debug("Getting subscription"), this.logger.trace({
            type: "method",
            method: "getSubscription",
            id: e
        });
        const t = this.subscriptions.get(e);
        if (!t) {
            const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    deleteSubscription(e, t) {
        this.logger.debug("Deleting subscription"), this.logger.trace({
            type: "method",
            method: "deleteSubscription",
            id: e,
            reason: t
        });
        const i = this.getSubscription(e);
        this.subscriptions.delete(e), this.topicMap.delete(i.topic, e), this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.deleted, $e9e439c110f17033$var$fe($e9e439c110f17033$var$q({}, i), {
            reason: t
        }));
    }
    async persist() {
        await this.setRelayerSubscriptions(this.values), this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.sync);
    }
    async reset() {
        if (this.cached.length) {
            const e = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
            for(let t = 0; t < e; t++){
                const i = this.cached.splice(0, this.batchSubscribeTopicsLimit);
                await this.batchSubscribe(i);
            }
        }
        this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.resubscribed);
    }
    async restore() {
        try {
            const e = await this.getRelayerSubscriptions();
            if (typeof e > "u" || !e.length) return;
            if (this.subscriptions.size) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored subscriptions for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                subscriptions: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore subscriptions for ${this.name}`), this.logger.error(e);
        }
    }
    async batchSubscribe(e) {
        if (!e.length) return;
        const t = await this.rpcBatchSubscribe(e);
        (0, $a5d33cfc7f8e5437$export$41dd3d480aac4a71)(t) && this.onBatchSubscribe(t.map((i, s)=>$e9e439c110f17033$var$fe($e9e439c110f17033$var$q({}, e[s]), {
                id: i
            })));
    }
    async onConnect() {
        await this.restart(), this.onEnable();
    }
    onDisconnect() {
        this.onDisable();
    }
    async checkPending() {
        if (!this.initialized || !this.relayer.connected) return;
        const e = [];
        this.pending.forEach((t)=>{
            e.push(t);
        }), await this.batchSubscribe(e);
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $212993b948b3fe4b$exports.HEARTBEAT_EVENTS).pulse, async ()=>{
            await this.checkPending();
        }), this.events.on($e9e439c110f17033$export$24ff3e54e94ef413.created, async (e)=>{
            const t = $e9e439c110f17033$export$24ff3e54e94ef413.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        }), this.events.on($e9e439c110f17033$export$24ff3e54e94ef413.deleted, async (e)=>{
            const t = $e9e439c110f17033$export$24ff3e54e94ef413.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async restartToComplete() {
        this.restartInProgress && await new Promise((e)=>{
            const t = setInterval(()=>{
                this.restartInProgress || (clearInterval(t), e());
            }, this.pollingInterval);
        });
    }
}
var $e9e439c110f17033$var$Pr = Object.defineProperty, $e9e439c110f17033$var$Ft = Object.getOwnPropertySymbols, $e9e439c110f17033$var$xr = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$Or = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$kt = (n, e, t)=>e in n ? $e9e439c110f17033$var$Pr(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : n[e] = t, $e9e439c110f17033$var$Ar = (n, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$xr.call(e, t) && $e9e439c110f17033$var$kt(n, t, e[t]);
    if ($e9e439c110f17033$var$Ft) for (var t of $e9e439c110f17033$var$Ft(e))$e9e439c110f17033$var$Or.call(e, t) && $e9e439c110f17033$var$kt(n, t, e[t]);
    return n;
};
class $e9e439c110f17033$export$70e73aa29a3d4407 extends (0, $bace94c1ef08d1bc$export$9a0f755fd4f79434) {
    constructor(e){
        super(e), this.protocol = "wc", this.version = 2, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$602d6e27611c3fcb, this.transportExplicitlyClosed = !1, this.initialized = !1, this.connectionAttemptInProgress = !1, this.connectionStatusPollingInterval = 20, this.staleConnectionErrors = [
            "socket hang up",
            "socket stalled",
            "interrupted"
        ], this.hasExperiencedNetworkDisruption = !1, this.requestsInFlight = new Map, this.heartBeatTimeout = (0, $aG48A.toMiliseconds)((0, $aG48A.THIRTY_SECONDS) + (0, $aG48A.ONE_SECOND)), this.request = async (t)=>{
            var i, s;
            this.logger.debug("Publishing Request Payload");
            const r = t.id || (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString();
            await this.toEstablishConnection();
            try {
                const o = this.provider.request(t);
                this.requestsInFlight.set(r, {
                    promise: o,
                    request: t
                }), this.logger.trace({
                    id: r,
                    method: t.method,
                    topic: (i = t.params) == null ? void 0 : i.topic
                }, "relayer.request - attempt to publish...");
                const a = await new Promise(async (h, l)=>{
                    const d = ()=>{
                        l(new Error(`relayer.request - publish interrupted, id: ${r}`));
                    };
                    this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.disconnect, d);
                    const g = await o;
                    this.provider.off($e9e439c110f17033$export$58062acf2f31ddf8.disconnect, d), h(g);
                });
                return this.logger.trace({
                    id: r,
                    method: t.method,
                    topic: (s = t.params) == null ? void 0 : s.topic
                }, "relayer.request - published"), a;
            } catch (o) {
                throw this.logger.debug(`Failed to Publish Request: ${r}`), o;
            } finally{
                this.requestsInFlight.delete(r);
            }
        }, this.resetPingTimeout = ()=>{
            if ((0, $a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee)()) try {
                clearTimeout(this.pingTimeout), this.pingTimeout = setTimeout(()=>{
                    var t, i, s;
                    (s = (i = (t = this.provider) == null ? void 0 : t.connection) == null ? void 0 : i.socket) == null || s.terminate();
                }, this.heartBeatTimeout);
            } catch (t) {
                this.logger.warn(t);
            }
        }, this.onPayloadHandler = (t)=>{
            this.onProviderPayload(t), this.resetPingTimeout();
        }, this.onConnectHandler = ()=>{
            this.startPingTimeout(), this.events.emit($e9e439c110f17033$export$d56245796e2837d.connect);
        }, this.onDisconnectHandler = ()=>{
            this.onProviderDisconnect();
        }, this.onProviderErrorHandler = (t)=>{
            this.logger.error(t), this.events.emit($e9e439c110f17033$export$d56245796e2837d.error, t), this.logger.info("Fatal socket error received, closing transport"), this.transportClose();
        }, this.registerProviderListeners = ()=>{
            this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.error, this.onProviderErrorHandler);
        }, this.core = e.core, this.logger = typeof e.logger < "u" && typeof e.logger != "string" ? (0, $7fc0ce2591a9daef$exports.generateChildLogger)(e.logger, this.name) : (0, $7fc0ce2591a9daef$exports.pino)((0, $7fc0ce2591a9daef$exports.getDefaultLoggerOptions)({
            level: e.logger || $e9e439c110f17033$export$5176ffa6778d6637
        })), this.messages = new $e9e439c110f17033$export$4a2542d0790ac2fd(this.logger, e.core), this.subscriber = new $e9e439c110f17033$export$60959659b2c22881(this, this.logger), this.publisher = new $e9e439c110f17033$var$vr(this, this.logger), this.relayUrl = e?.relayUrl || $e9e439c110f17033$export$a68061e6c48f332a, this.projectId = e.projectId, this.bundleId = (0, $a5d33cfc7f8e5437$export$40a40f90174d197c)(), this.provider = {};
    }
    async init() {
        this.logger.trace("Initialized"), this.registerEventListeners(), await this.createProvider(), await Promise.all([
            this.messages.init(),
            this.subscriber.init()
        ]);
        try {
            await this.transportOpen();
        } catch  {
            this.logger.warn(`Connection via ${this.relayUrl} failed, attempting to connect via failover domain ${$e9e439c110f17033$export$27fee22bec112637}...`), await this.restartTransport($e9e439c110f17033$export$27fee22bec112637);
        }
        this.initialized = !0, setTimeout(async ()=>{
            this.subscriber.topics.length === 0 && this.subscriber.pending.size === 0 && (this.logger.info("No topics subscribed to after init, closing transport"), await this.transportClose(), this.transportExplicitlyClosed = !1);
        }, $e9e439c110f17033$export$fb3eab7adf12329d);
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get connected() {
        var e, t, i;
        return ((i = (t = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : t.socket) == null ? void 0 : i.readyState) === 1;
    }
    get connecting() {
        var e, t, i;
        return ((i = (t = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : t.socket) == null ? void 0 : i.readyState) === 0;
    }
    async publish(e, t, i) {
        this.isInitialized(), await this.publisher.publish(e, t, i), await this.recordMessageEvent({
            topic: e,
            message: t,
            publishedAt: Date.now()
        });
    }
    async subscribe(e, t) {
        var i;
        this.isInitialized();
        let s = ((i = this.subscriber.topicMap.get(e)) == null ? void 0 : i[0]) || "", r;
        const o = (a)=>{
            a.topic === e && (this.subscriber.off($e9e439c110f17033$export$24ff3e54e94ef413.created, o), r());
        };
        return await Promise.all([
            new Promise((a)=>{
                r = a, this.subscriber.on($e9e439c110f17033$export$24ff3e54e94ef413.created, o);
            }),
            new Promise(async (a)=>{
                s = await this.subscriber.subscribe(e, t) || s, a();
            })
        ]), s;
    }
    async unsubscribe(e, t) {
        this.isInitialized(), await this.subscriber.unsubscribe(e, t);
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async transportDisconnect() {
        if (!this.hasExperiencedNetworkDisruption && this.connected && this.requestsInFlight.size > 0) try {
            await Promise.all(Array.from(this.requestsInFlight.values()).map((e)=>e.promise));
        } catch (e) {
            this.logger.warn(e);
        }
        this.hasExperiencedNetworkDisruption || this.connected ? await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(this.provider.disconnect(), 2e3, "provider.disconnect()").catch(()=>this.onProviderDisconnect()) : this.onProviderDisconnect();
    }
    async transportClose() {
        this.transportExplicitlyClosed = !0, await this.transportDisconnect();
    }
    async transportOpen(e) {
        await this.confirmOnlineStateOrThrow(), e && e !== this.relayUrl && (this.relayUrl = e, await this.transportDisconnect(), await this.createProvider()), this.connectionAttemptInProgress = !0, this.transportExplicitlyClosed = !1;
        try {
            await new Promise(async (t, i)=>{
                const s = ()=>{
                    this.provider.off($e9e439c110f17033$export$58062acf2f31ddf8.disconnect, s), i(new Error("Connection interrupted while trying to subscribe"));
                };
                this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.disconnect, s), await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(this.provider.connect(), (0, $aG48A.toMiliseconds)((0, $aG48A.ONE_MINUTE)), `Socket stalled when trying to connect to ${this.relayUrl}`).catch((r)=>{
                    i(r);
                }), await this.subscriber.start(), this.hasExperiencedNetworkDisruption = !1, t();
            });
        } catch (t) {
            this.logger.error(t);
            const i = t;
            if (!this.isConnectionStalled(i.message)) throw t;
        } finally{
            this.connectionAttemptInProgress = !1;
        }
    }
    async restartTransport(e) {
        this.connectionAttemptInProgress || (this.relayUrl = e || this.relayUrl, await this.confirmOnlineStateOrThrow(), await this.transportClose(), await this.createProvider(), await this.transportOpen());
    }
    async confirmOnlineStateOrThrow() {
        if (!await (0, $a5d33cfc7f8e5437$export$53c2fd0173ad2b80)()) throw new Error("No internet connection detected. Please restart your network and try again.");
    }
    startPingTimeout() {
        var e, t, i, s, r;
        if ((0, $a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee)()) try {
            (t = (e = this.provider) == null ? void 0 : e.connection) != null && t.socket && ((r = (s = (i = this.provider) == null ? void 0 : i.connection) == null ? void 0 : s.socket) == null || r.once("ping", ()=>{
                this.resetPingTimeout();
            })), this.resetPingTimeout();
        } catch (o) {
            this.logger.warn(o);
        }
    }
    isConnectionStalled(e) {
        return this.staleConnectionErrors.some((t)=>e.includes(t));
    }
    async createProvider() {
        this.provider.connection && this.unregisterProviderListeners();
        const e = await this.core.crypto.signJWT(this.relayUrl);
        this.provider = new (0, $1582203255a670cd$export$da28308012bf6748)(new (0, $f6230024aa4de9c4$export$ea0df116fa892998)((0, $a5d33cfc7f8e5437$export$d875b3963ef774f5)({
            sdkVersion: $e9e439c110f17033$export$5f30917a6f8c9025,
            protocol: this.protocol,
            version: this.version,
            relayUrl: this.relayUrl,
            projectId: this.projectId,
            auth: e,
            useOnCloseEvent: !0,
            bundleId: this.bundleId
        }))), this.registerProviderListeners();
    }
    async recordMessageEvent(e) {
        const { topic: t, message: i } = e;
        await this.messages.set(t, i);
    }
    async shouldIgnoreMessageEvent(e) {
        const { topic: t, message: i } = e;
        if (!i || i.length === 0) return this.logger.debug(`Ignoring invalid/empty message: ${i}`), !0;
        if (!await this.subscriber.isSubscribed(t)) return this.logger.debug(`Ignoring message for non-subscribed topic ${t}`), !0;
        const s = this.messages.has(t, i);
        return s && this.logger.debug(`Ignoring duplicate message: ${i}`), s;
    }
    async onProviderPayload(e) {
        if (this.logger.debug("Incoming Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "incoming",
            payload: e
        }), (0, $2e45abd1d679ec32$export$f6e4034abe07d2a5)(e)) {
            if (!e.method.endsWith($e9e439c110f17033$export$119b4645f6b233c8)) return;
            const t = e.params, { topic: i, message: s, publishedAt: r } = t.data, o = {
                topic: i,
                message: s,
                publishedAt: r
            };
            this.logger.debug("Emitting Relayer Payload"), this.logger.trace($e9e439c110f17033$var$Ar({
                type: "event",
                event: t.id
            }, o)), this.events.emit(t.id, o), await this.acknowledgePayload(e), await this.onMessageEvent(o);
        } else (0, $2e45abd1d679ec32$export$308ba927de2bcbe8)(e) && this.events.emit($e9e439c110f17033$export$d56245796e2837d.message_ack, e);
    }
    async onMessageEvent(e) {
        await this.shouldIgnoreMessageEvent(e) || (this.events.emit($e9e439c110f17033$export$d56245796e2837d.message, e), await this.recordMessageEvent(e));
    }
    async acknowledgePayload(e) {
        const t = (0, $3bb3ddc7bbc938cc$export$478fdea01c2a3198)(e.id, !0);
        await this.provider.connection.send(t);
    }
    unregisterProviderListeners() {
        this.provider.off($e9e439c110f17033$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.off($e9e439c110f17033$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.off($e9e439c110f17033$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.off($e9e439c110f17033$export$58062acf2f31ddf8.error, this.onProviderErrorHandler);
    }
    async registerEventListeners() {
        let e = await (0, $a5d33cfc7f8e5437$export$53c2fd0173ad2b80)();
        (0, $a5d33cfc7f8e5437$export$600a1ee4bc680996)(async (t)=>{
            e !== t && (e = t, t ? await this.restartTransport().catch((i)=>this.logger.error(i)) : (this.hasExperiencedNetworkDisruption = !0, await this.transportDisconnect(), this.transportExplicitlyClosed = !1));
        });
    }
    async onProviderDisconnect() {
        await this.subscriber.stop(), this.events.emit($e9e439c110f17033$export$d56245796e2837d.disconnect), this.connectionAttemptInProgress = !1, !this.transportExplicitlyClosed && setTimeout(async ()=>{
            await this.transportOpen().catch((e)=>this.logger.error(e));
        }, (0, $aG48A.toMiliseconds)($e9e439c110f17033$export$11ccd39be2c57d6));
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async toEstablishConnection() {
        await this.confirmOnlineStateOrThrow(), !this.connected && (this.connectionAttemptInProgress && await new Promise((e)=>{
            const t = setInterval(()=>{
                this.connected && (clearInterval(t), e());
            }, this.connectionStatusPollingInterval);
        }), await this.transportOpen());
    }
}
var $e9e439c110f17033$var$zr = Object.defineProperty, $e9e439c110f17033$var$Kt = Object.getOwnPropertySymbols, $e9e439c110f17033$var$Nr = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$Ur = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$Bt = (n, e, t)=>e in n ? $e9e439c110f17033$var$zr(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : n[e] = t, $e9e439c110f17033$var$Vt = (n, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$Nr.call(e, t) && $e9e439c110f17033$var$Bt(n, t, e[t]);
    if ($e9e439c110f17033$var$Kt) for (var t of $e9e439c110f17033$var$Kt(e))$e9e439c110f17033$var$Ur.call(e, t) && $e9e439c110f17033$var$Bt(n, t, e[t]);
    return n;
};
class $e9e439c110f17033$export$390f32400eaf98c9 extends (0, $bace94c1ef08d1bc$export$a7f17ba6c54777e7) {
    constructor(e, t, i, s = $e9e439c110f17033$export$f258d29ae5e3d545, r){
        super(e, t, i, s), this.core = e, this.logger = t, this.name = i, this.map = new Map, this.version = $e9e439c110f17033$export$629a342182ba24b, this.cached = [], this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.recentlyDeleted = [], this.recentlyDeletedLimit = 200, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((o)=>{
                this.getKey && o !== null && !(0, $a5d33cfc7f8e5437$export$fce6876652108ab)(o) ? this.map.set(this.getKey(o), o) : (0, $a5d33cfc7f8e5437$export$f657f7976bb2769d)(o) ? this.map.set(o.id, o) : (0, $a5d33cfc7f8e5437$export$c96d5113768aaf5e)(o) && this.map.set(o.topic, o);
            }), this.cached = [], this.initialized = !0);
        }, this.set = async (o, a)=>{
            this.isInitialized(), this.map.has(o) ? await this.update(o, a) : (this.logger.debug("Setting value"), this.logger.trace({
                type: "method",
                method: "set",
                key: o,
                value: a
            }), this.map.set(o, a), await this.persist());
        }, this.get = (o)=>(this.isInitialized(), this.logger.debug("Getting value"), this.logger.trace({
                type: "method",
                method: "get",
                key: o
            }), this.getData(o)), this.getAll = (o)=>(this.isInitialized(), o ? this.values.filter((a)=>Object.keys(o).every((h)=>(0, (/*@__PURE__*/$parcel$interopDefault($6cqMT)))(a[h], o[h]))) : this.values), this.update = async (o, a)=>{
            this.isInitialized(), this.logger.debug("Updating value"), this.logger.trace({
                type: "method",
                method: "update",
                key: o,
                update: a
            });
            const h = $e9e439c110f17033$var$Vt($e9e439c110f17033$var$Vt({}, this.getData(o)), a);
            this.map.set(o, h), await this.persist();
        }, this.delete = async (o, a)=>{
            this.isInitialized(), this.map.has(o) && (this.logger.debug("Deleting value"), this.logger.trace({
                type: "method",
                method: "delete",
                key: o,
                reason: a
            }), this.map.delete(o), this.addToRecentlyDeleted(o), await this.persist());
        }, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.storagePrefix = s, this.getKey = r;
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.map.size;
    }
    get keys() {
        return Array.from(this.map.keys());
    }
    get values() {
        return Array.from(this.map.values());
    }
    addToRecentlyDeleted(e) {
        this.recentlyDeleted.push(e), this.recentlyDeleted.length >= this.recentlyDeletedLimit && this.recentlyDeleted.splice(0, this.recentlyDeletedLimit / 2);
    }
    async setDataStore(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getDataStore() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getData(e) {
        const t = this.map.get(e);
        if (!t) {
            if (this.recentlyDeleted.includes(e)) {
                const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `Record was recently deleted - ${this.name}: ${e}`);
                throw this.logger.error(s), new Error(s);
            }
            const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(i), new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setDataStore(this.values);
    }
    async restore() {
        try {
            const e = await this.getDataStore();
            if (typeof e > "u" || !e.length) return;
            if (this.map.size) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored value for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                value: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore value for ${this.name}`), this.logger.error(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$3370ee24730992a3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.name = $e9e439c110f17033$export$390360ea476c6145, this.version = $e9e439c110f17033$export$5593ec74b27d1b18, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))), this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.ignoredPayloadTypes = [
            (0, $a5d33cfc7f8e5437$export$406e97c329f0f3d4)
        ], this.registeredMethods = [], this.init = async ()=>{
            this.initialized || (await this.pairings.init(), await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.initialized = !0, this.logger.trace("Initialized"));
        }, this.register = ({ methods: i })=>{
            this.isInitialized(), this.registeredMethods = [
                ...new Set([
                    ...this.registeredMethods,
                    ...i
                ])
            ];
        }, this.create = async ()=>{
            this.isInitialized();
            const i = (0, $a5d33cfc7f8e5437$export$d15a28e4f1821243)(), s = await this.core.crypto.setSymKey(i), r = (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $aG48A.FIVE_MINUTES)), o = {
                protocol: $e9e439c110f17033$export$822d0bd1635d5360
            }, a = {
                topic: s,
                expiry: r,
                relay: o,
                active: !1
            }, h = (0, $a5d33cfc7f8e5437$export$b2786ede34fb2350)({
                protocol: this.core.protocol,
                version: this.core.version,
                topic: s,
                symKey: i,
                relay: o,
                expiryTimestamp: r
            });
            return await this.pairings.set(s, a), await this.core.relayer.subscribe(s), this.core.expirer.set(s, r), {
                topic: s,
                uri: h
            };
        }, this.pair = async (i)=>{
            this.isInitialized(), this.isValidPair(i);
            const { topic: s, symKey: r, relay: o, expiryTimestamp: a } = (0, $a5d33cfc7f8e5437$export$59f58847421cfb28)(i.uri);
            let h;
            if (this.pairings.keys.includes(s) && (h = this.pairings.get(s), h.active)) throw new Error(`Pairing already exists: ${s}. Please try again with a new connection URI.`);
            const l = a || (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $aG48A.FIVE_MINUTES)), d = {
                topic: s,
                relay: o,
                expiry: l,
                active: !1
            };
            return await this.pairings.set(s, d), this.core.expirer.set(s, l), i.activatePairing && await this.activate({
                topic: s
            }), this.events.emit($e9e439c110f17033$export$ca3c0b962acf7b75.create, d), this.core.crypto.keychain.has(s) || await this.core.crypto.setSymKey(r, s), await this.core.relayer.subscribe(s, {
                relay: o
            }), d;
        }, this.activate = async ({ topic: i })=>{
            this.isInitialized();
            const s = (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $aG48A.THIRTY_DAYS));
            await this.pairings.update(i, {
                active: !0,
                expiry: s
            }), this.core.expirer.set(i, s);
        }, this.ping = async (i)=>{
            this.isInitialized(), await this.isValidPing(i);
            const { topic: s } = i;
            if (this.pairings.keys.includes(s)) {
                const r = await this.sendRequest(s, "wc_pairingPing", {}), { done: o, resolve: a, reject: h } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)();
                this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("pairing_ping", r), ({ error: l })=>{
                    l ? h(l) : a();
                }), await o();
            }
        }, this.updateExpiry = async ({ topic: i, expiry: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                expiry: s
            });
        }, this.updateMetadata = async ({ topic: i, metadata: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                peerMetadata: s
            });
        }, this.getPairings = ()=>(this.isInitialized(), this.pairings.values), this.disconnect = async (i)=>{
            this.isInitialized(), await this.isValidDisconnect(i);
            const { topic: s } = i;
            this.pairings.keys.includes(s) && (await this.sendRequest(s, "wc_pairingDelete", (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.deletePairing(s));
        }, this.sendRequest = async (i, s, r)=>{
            const o = (0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)(s, r), a = await this.core.crypto.encode(i, o), h = $e9e439c110f17033$export$d94d6986a8185883[s].req;
            return this.core.history.set(i, o), this.core.relayer.publish(i, a, h), o.id;
        }, this.sendResult = async (i, s, r)=>{
            const o = (0, $3bb3ddc7bbc938cc$export$478fdea01c2a3198)(i, r), a = await this.core.crypto.encode(s, o), h = await this.core.history.get(s, i), l = $e9e439c110f17033$export$d94d6986a8185883[h.request.method].res;
            await this.core.relayer.publish(s, a, l), await this.core.history.resolve(o);
        }, this.sendError = async (i, s, r)=>{
            const o = (0, $3bb3ddc7bbc938cc$export$9f7302ae26c3f77)(i, r), a = await this.core.crypto.encode(s, o), h = await this.core.history.get(s, i), l = $e9e439c110f17033$export$d94d6986a8185883[h.request.method] ? $e9e439c110f17033$export$d94d6986a8185883[h.request.method].res : $e9e439c110f17033$export$d94d6986a8185883.unregistered_method.res;
            await this.core.relayer.publish(s, a, l), await this.core.history.resolve(o);
        }, this.deletePairing = async (i, s)=>{
            await this.core.relayer.unsubscribe(i), await Promise.all([
                this.pairings.delete(i, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")),
                this.core.crypto.deleteSymKey(i),
                s ? Promise.resolve() : this.core.expirer.del(i)
            ]);
        }, this.cleanup = async ()=>{
            const i = this.pairings.getAll().filter((s)=>(0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(s.expiry));
            await Promise.all(i.map((s)=>this.deletePairing(s.topic)));
        }, this.onRelayEventRequest = (i)=>{
            const { topic: s, payload: r } = i;
            switch(r.method){
                case "wc_pairingPing":
                    return this.onPairingPingRequest(s, r);
                case "wc_pairingDelete":
                    return this.onPairingDeleteRequest(s, r);
                default:
                    return this.onUnknownRpcMethodRequest(s, r);
            }
        }, this.onRelayEventResponse = async (i)=>{
            const { topic: s, payload: r } = i, o = (await this.core.history.get(s, r.id)).request.method;
            switch(o){
                case "wc_pairingPing":
                    return this.onPairingPingResponse(s, r);
                default:
                    return this.onUnknownRpcMethodResponse(o);
            }
        }, this.onPairingPingRequest = async (i, s)=>{
            const { id: r } = s;
            try {
                this.isValidPing({
                    topic: i
                }), await this.sendResult(r, i, !0), this.events.emit($e9e439c110f17033$export$ca3c0b962acf7b75.ping, {
                    id: r,
                    topic: i
                });
            } catch (o) {
                await this.sendError(r, i, o), this.logger.error(o);
            }
        }, this.onPairingPingResponse = (i, s)=>{
            const { id: r } = s;
            setTimeout(()=>{
                (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("pairing_ping", r), {}) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(s) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("pairing_ping", r), {
                    error: s.error
                });
            }, 500);
        }, this.onPairingDeleteRequest = async (i, s)=>{
            const { id: r } = s;
            try {
                this.isValidDisconnect({
                    topic: i
                }), await this.deletePairing(i), this.events.emit($e9e439c110f17033$export$ca3c0b962acf7b75.delete, {
                    id: r,
                    topic: i
                });
            } catch (o) {
                await this.sendError(r, i, o), this.logger.error(o);
            }
        }, this.onUnknownRpcMethodRequest = async (i, s)=>{
            const { id: r, method: o } = s;
            try {
                if (this.registeredMethods.includes(o)) return;
                const a = (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("WC_METHOD_UNSUPPORTED", o);
                await this.sendError(r, i, a), this.logger.error(a);
            } catch (a) {
                await this.sendError(r, i, a), this.logger.error(a);
            }
        }, this.onUnknownRpcMethodResponse = (i)=>{
            this.registeredMethods.includes(i) || this.logger.error((0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("WC_METHOD_UNSUPPORTED", i));
        }, this.isValidPair = (i)=>{
            var s;
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(i)) {
                const { message: o } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pair() params: ${i}`);
                throw new Error(o);
            }
            if (!(0, $a5d33cfc7f8e5437$export$bef94a5618bf18bf)(i.uri)) {
                const { message: o } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pair() uri: ${i.uri}`);
                throw new Error(o);
            }
            const r = (0, $a5d33cfc7f8e5437$export$59f58847421cfb28)(i.uri);
            if (!((s = r?.relay) != null && s.protocol)) {
                const { message: o } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "pair() uri#relay-protocol");
                throw new Error(o);
            }
            if (!(r != null && r.symKey)) {
                const { message: o } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "pair() uri#symKey");
                throw new Error(o);
            }
            if (r != null && r.expiryTimestamp && (0, $aG48A.toMiliseconds)(r?.expiryTimestamp) < Date.now()) {
                const { message: o } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", "pair() URI has expired. Please try again with a new connection URI.");
                throw new Error(o);
            }
        }, this.isValidPing = async (i)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(i)) {
                const { message: r } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `ping() params: ${i}`);
                throw new Error(r);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }, this.isValidDisconnect = async (i)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(i)) {
                const { message: r } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `disconnect() params: ${i}`);
                throw new Error(r);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }, this.isValidPairingTopic = async (i)=>{
            if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(i, !1)) {
                const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pairing topic should be a string: ${i}`);
                throw new Error(s);
            }
            if (!this.pairings.keys.includes(i)) {
                const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${i}`);
                throw new Error(s);
            }
            if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(this.pairings.get(i).expiry)) {
                await this.deletePairing(i);
                const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", `pairing topic: ${i}`);
                throw new Error(s);
            }
        }, this.core = e, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.pairings = new $e9e439c110f17033$export$390f32400eaf98c9(this.core, this.logger, this.name, this.storagePrefix);
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    registerRelayerEvents() {
        this.core.relayer.on($e9e439c110f17033$export$d56245796e2837d.message, async (e)=>{
            const { topic: t, message: i } = e;
            if (!this.pairings.keys.includes(t) || this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(i))) return;
            const s = await this.core.crypto.decode(t, i);
            try {
                (0, $2e45abd1d679ec32$export$f6e4034abe07d2a5)(s) ? (this.core.history.set(t, s), this.onRelayEventRequest({
                    topic: t,
                    payload: s
                })) : (0, $2e45abd1d679ec32$export$308ba927de2bcbe8)(s) && (await this.core.history.resolve(s), await this.onRelayEventResponse({
                    topic: t,
                    payload: s
                }), this.core.history.delete(t, s.id));
            } catch (r) {
                this.logger.error(r);
            }
        });
    }
    registerExpirerEvents() {
        this.core.expirer.on($e9e439c110f17033$export$9013719d9206b0c1.expired, async (e)=>{
            const { topic: t } = (0, $a5d33cfc7f8e5437$export$93adeb0f16e8e51d)(e.target);
            t && this.pairings.keys.includes(t) && (await this.deletePairing(t, !0), this.events.emit($e9e439c110f17033$export$ca3c0b962acf7b75.expire, {
                topic: t
            }));
        });
    }
}
class $e9e439c110f17033$export$eeb4f10f25d479cb extends (0, $bace94c1ef08d1bc$export$45b2c2643615b67) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.records = new Map, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$160142c73cb99dc3, this.version = $e9e439c110f17033$export$8eba9ce85616c607, this.cached = [], this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.records.set(i.id, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.set = (i, s, r)=>{
            if (this.isInitialized(), this.logger.debug("Setting JSON-RPC request history record"), this.logger.trace({
                type: "method",
                method: "set",
                topic: i,
                request: s,
                chainId: r
            }), this.records.has(s.id)) return;
            const o = {
                id: s.id,
                topic: i,
                request: {
                    method: s.method,
                    params: s.params || null
                },
                chainId: r,
                expiry: (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $aG48A.THIRTY_DAYS))
            };
            this.records.set(o.id, o), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.created, o);
        }, this.resolve = async (i)=>{
            if (this.isInitialized(), this.logger.debug("Updating JSON-RPC response history record"), this.logger.trace({
                type: "method",
                method: "update",
                response: i
            }), !this.records.has(i.id)) return;
            const s = await this.getRecord(i.id);
            typeof s.response > "u" && (s.response = (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(i) ? {
                error: i.error
            } : {
                result: i.result
            }, this.records.set(s.id, s), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.updated, s));
        }, this.get = async (i, s)=>(this.isInitialized(), this.logger.debug("Getting record"), this.logger.trace({
                type: "method",
                method: "get",
                topic: i,
                id: s
            }), await this.getRecord(s)), this.delete = (i, s)=>{
            this.isInitialized(), this.logger.debug("Deleting record"), this.logger.trace({
                type: "method",
                method: "delete",
                id: s
            }), this.values.forEach((r)=>{
                if (r.topic === i) {
                    if (typeof s < "u" && r.id !== s) return;
                    this.records.delete(r.id), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.deleted, r);
                }
            });
        }, this.exists = async (i, s)=>(this.isInitialized(), this.records.has(s) ? (await this.getRecord(s)).topic === i : !1), this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get size() {
        return this.records.size;
    }
    get keys() {
        return Array.from(this.records.keys());
    }
    get values() {
        return Array.from(this.records.values());
    }
    get pending() {
        const e = [];
        return this.values.forEach((t)=>{
            if (typeof t.response < "u") return;
            const i = {
                topic: t.topic,
                request: (0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)(t.request.method, t.request.params, t.id),
                chainId: t.chainId
            };
            return e.push(i);
        }), e;
    }
    async setJsonRpcRecords(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getJsonRpcRecords() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getRecord(e) {
        this.isInitialized();
        const t = this.records.get(e);
        if (!t) {
            const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setJsonRpcRecords(this.values), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.sync);
    }
    async restore() {
        try {
            const e = await this.getJsonRpcRecords();
            if (typeof e > "u" || !e.length) return;
            if (this.records.size) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                records: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(e);
        }
    }
    registerEventListeners() {
        this.events.on($e9e439c110f17033$export$a682338b5ffca937.created, (e)=>{
            const t = $e9e439c110f17033$export$a682338b5ffca937.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.events.on($e9e439c110f17033$export$a682338b5ffca937.updated, (e)=>{
            const t = $e9e439c110f17033$export$a682338b5ffca937.updated;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.events.on($e9e439c110f17033$export$a682338b5ffca937.deleted, (e)=>{
            const t = $e9e439c110f17033$export$a682338b5ffca937.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.core.heartbeat.on((0, $212993b948b3fe4b$exports.HEARTBEAT_EVENTS).pulse, ()=>{
            this.cleanup();
        });
    }
    cleanup() {
        try {
            this.records.forEach((e)=>{
                (0, $aG48A.toMiliseconds)(e.expiry || 0) - Date.now() <= 0 && (this.logger.info(`Deleting expired history log: ${e.id}`), this.delete(e.topic, e.id));
            });
        } catch (e) {
            this.logger.warn(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$e76805ce609031cb extends (0, $bace94c1ef08d1bc$export$41aaa3c39f6f2861) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.expirations = new Map, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$4ddf883392bbc828, this.version = $e9e439c110f17033$export$717295846191925d, this.cached = [], this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.expirations.set(i.target, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.has = (i)=>{
            try {
                const s = this.formatTarget(i);
                return typeof this.getExpiration(s) < "u";
            } catch  {
                return !1;
            }
        }, this.set = (i, s)=>{
            this.isInitialized();
            const r = this.formatTarget(i), o = {
                target: r,
                expiry: s
            };
            this.expirations.set(r, o), this.checkExpiry(r, o), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.created, {
                target: r,
                expiration: o
            });
        }, this.get = (i)=>{
            this.isInitialized();
            const s = this.formatTarget(i);
            return this.getExpiration(s);
        }, this.del = (i)=>{
            if (this.isInitialized(), this.has(i)) {
                const s = this.formatTarget(i), r = this.getExpiration(s);
                this.expirations.delete(s), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.deleted, {
                    target: s,
                    expiration: r
                });
            }
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.expirations.size;
    }
    get keys() {
        return Array.from(this.expirations.keys());
    }
    get values() {
        return Array.from(this.expirations.values());
    }
    formatTarget(e) {
        if (typeof e == "string") return (0, $a5d33cfc7f8e5437$export$43ab92477f8713b9)(e);
        if (typeof e == "number") return (0, $a5d33cfc7f8e5437$export$bd13103c2e5cc0c3)(e);
        const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("UNKNOWN_TYPE", `Target type: ${typeof e}`);
        throw new Error(t);
    }
    async setExpirations(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getExpirations() {
        return await this.core.storage.getItem(this.storageKey);
    }
    async persist() {
        await this.setExpirations(this.values), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.sync);
    }
    async restore() {
        try {
            const e = await this.getExpirations();
            if (typeof e > "u" || !e.length) return;
            if (this.expirations.size) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored expirations for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                expirations: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore expirations for ${this.name}`), this.logger.error(e);
        }
    }
    getExpiration(e) {
        const t = this.expirations.get(e);
        if (!t) {
            const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.warn(i), new Error(i);
        }
        return t;
    }
    checkExpiry(e, t) {
        const { expiry: i } = t;
        (0, $aG48A.toMiliseconds)(i) - Date.now() <= 0 && this.expire(e, t);
    }
    expire(e, t) {
        this.expirations.delete(e), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.expired, {
            target: e,
            expiration: t
        });
    }
    checkExpirations() {
        this.core.relayer.connected && this.expirations.forEach((e, t)=>this.checkExpiry(t, e));
    }
    registerEventListeners() {
        this.core.heartbeat.on((0, $212993b948b3fe4b$exports.HEARTBEAT_EVENTS).pulse, ()=>this.checkExpirations()), this.events.on($e9e439c110f17033$export$9013719d9206b0c1.created, (e)=>{
            const t = $e9e439c110f17033$export$9013719d9206b0c1.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($e9e439c110f17033$export$9013719d9206b0c1.expired, (e)=>{
            const t = $e9e439c110f17033$export$9013719d9206b0c1.expired;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($e9e439c110f17033$export$9013719d9206b0c1.deleted, (e)=>{
            const t = $e9e439c110f17033$export$9013719d9206b0c1.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$91a8e56769aeb334 extends (0, $bace94c1ef08d1bc$export$873b0b865d85ddb6) {
    constructor(e, t){
        super(e, t), this.projectId = e, this.logger = t, this.name = $e9e439c110f17033$export$3b58f2450f2297e3, this.initialized = !1, this.queue = [], this.verifyDisabled = !1, this.init = async (i)=>{
            if (this.verifyDisabled || (0, $a5d33cfc7f8e5437$export$f7a1e23e542d38e3)() || !(0, $a5d33cfc7f8e5437$export$4e09c449d6c407f7)()) return;
            const s = this.getVerifyUrl(i?.verifyUrl);
            this.verifyUrl !== s && this.removeIframe(), this.verifyUrl = s;
            try {
                await this.createIframe();
            } catch (r) {
                this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.info(r);
            }
            if (!this.initialized) {
                this.removeIframe(), this.verifyUrl = $e9e439c110f17033$export$4fe83ee8f9aec7b6;
                try {
                    await this.createIframe();
                } catch (r) {
                    this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.info(r), this.verifyDisabled = !0;
                }
            }
        }, this.register = async (i)=>{
            this.initialized ? this.sendPost(i.attestationId) : (this.addToQueue(i.attestationId), await this.init());
        }, this.resolve = async (i)=>{
            if (this.isDevEnv) return "";
            const s = this.getVerifyUrl(i?.verifyUrl);
            let r;
            try {
                r = await this.fetchAttestation(i.attestationId, s);
            } catch (o) {
                this.logger.info(`failed to resolve attestation: ${i.attestationId} from url: ${s}`), this.logger.info(o), r = await this.fetchAttestation(i.attestationId, $e9e439c110f17033$export$4fe83ee8f9aec7b6);
            }
            return r;
        }, this.fetchAttestation = async (i, s)=>{
            this.logger.info(`resolving attestation: ${i} from url: ${s}`);
            const r = this.startAbortTimer((0, $aG48A.ONE_SECOND) * 2), o = await fetch(`${s}/attestation/${i}`, {
                signal: this.abortController.signal
            });
            return clearTimeout(r), o.status === 200 ? await o.json() : void 0;
        }, this.addToQueue = (i)=>{
            this.queue.push(i);
        }, this.processQueue = ()=>{
            this.queue.length !== 0 && (this.queue.forEach((i)=>this.sendPost(i)), this.queue = []);
        }, this.sendPost = (i)=>{
            var s;
            try {
                if (!this.iframe) return;
                (s = this.iframe.contentWindow) == null || s.postMessage(i, "*"), this.logger.info(`postMessage sent: ${i} ${this.verifyUrl}`);
            } catch  {}
        }, this.createIframe = async ()=>{
            let i;
            const s = (r)=>{
                r.data === "verify_ready" && (this.onInit(), window.removeEventListener("message", s), i());
            };
            await Promise.race([
                new Promise((r)=>{
                    const o = document.getElementById($e9e439c110f17033$export$3b58f2450f2297e3);
                    if (o) return this.iframe = o, this.onInit(), r();
                    window.addEventListener("message", s);
                    const a = document.createElement("iframe");
                    a.id = $e9e439c110f17033$export$3b58f2450f2297e3, a.src = `${this.verifyUrl}/${this.projectId}`, a.style.display = "none", document.body.append(a), this.iframe = a, i = r;
                }),
                new Promise((r, o)=>setTimeout(()=>{
                        window.removeEventListener("message", s), o("verify iframe load timeout");
                    }, (0, $aG48A.toMiliseconds)((0, $aG48A.FIVE_SECONDS))))
            ]);
        }, this.onInit = ()=>{
            this.initialized = !0, this.processQueue();
        }, this.removeIframe = ()=>{
            this.iframe && (this.iframe.remove(), this.iframe = void 0, this.initialized = !1);
        }, this.getVerifyUrl = (i)=>{
            let s = i || $e9e439c110f17033$export$7e3b1a28ddecdbaa;
            return $e9e439c110f17033$export$be24df03c4baa778.includes(s) || (this.logger.info(`verify url: ${s}, not included in trusted list, assigning default: ${$e9e439c110f17033$export$7e3b1a28ddecdbaa}`), s = $e9e439c110f17033$export$7e3b1a28ddecdbaa), s;
        }, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.verifyUrl = $e9e439c110f17033$export$7e3b1a28ddecdbaa, this.abortController = new AbortController, this.isDevEnv = (0, $a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee)() && undefined;
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    startAbortTimer(e) {
        return this.abortController = new AbortController, setTimeout(()=>this.abortController.abort(), (0, $aG48A.toMiliseconds)(e));
    }
}
class $e9e439c110f17033$export$c393c48c5b0cf59a extends (0, $bace94c1ef08d1bc$export$7db533fb638f979d) {
    constructor(e, t){
        super(e, t), this.projectId = e, this.logger = t, this.context = $e9e439c110f17033$export$40c022d2cffe0adc, this.registerDeviceToken = async (i)=>{
            const { clientId: s, token: r, notificationType: o, enableEncrypted: a = !1 } = i, h = `${$e9e439c110f17033$export$3c48c4faab79aab1}/${this.projectId}/clients`;
            await (0, (/*@__PURE__*/$parcel$interopDefault($436950a2454b4407$exports)))(h, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    client_id: s,
                    type: o,
                    token: r,
                    always_raw: a
                })
            });
        }, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.context);
    }
}
var $e9e439c110f17033$var$Lr = Object.defineProperty, $e9e439c110f17033$var$Xt = Object.getOwnPropertySymbols, $e9e439c110f17033$var$$r = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$Fr = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$Wt = (n, e, t)=>e in n ? $e9e439c110f17033$var$Lr(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : n[e] = t, $e9e439c110f17033$var$Qt = (n, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$$r.call(e, t) && $e9e439c110f17033$var$Wt(n, t, e[t]);
    if ($e9e439c110f17033$var$Xt) for (var t of $e9e439c110f17033$var$Xt(e))$e9e439c110f17033$var$Fr.call(e, t) && $e9e439c110f17033$var$Wt(n, t, e[t]);
    return n;
};
class $e9e439c110f17033$export$2e2bcd8739ae039 extends (0, $bace94c1ef08d1bc$export$ed533416df113881) {
    constructor(e){
        super(e), this.protocol = $e9e439c110f17033$export$51b1c900ac262bdf, this.version = $e9e439c110f17033$export$f30bd3c8747cdfbe, this.name = $e9e439c110f17033$export$d47601f9de5ee22b, this.events = new (0, $7etJZ.EventEmitter), this.initialized = !1, this.on = (i, s)=>this.events.on(i, s), this.once = (i, s)=>this.events.once(i, s), this.off = (i, s)=>this.events.off(i, s), this.removeListener = (i, s)=>this.events.removeListener(i, s), this.projectId = e?.projectId, this.relayUrl = e?.relayUrl || $e9e439c110f17033$export$a68061e6c48f332a, this.customStoragePrefix = e != null && e.customStoragePrefix ? `:${e.customStoragePrefix}` : "";
        const t = typeof e?.logger < "u" && typeof e?.logger != "string" ? e.logger : (0, $7fc0ce2591a9daef$exports.pino)((0, $7fc0ce2591a9daef$exports.getDefaultLoggerOptions)({
            level: e?.logger || $e9e439c110f17033$export$db0fdb6d486555c2.logger
        }));
        this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.heartbeat = new (0, $212993b948b3fe4b$exports.HeartBeat), this.crypto = new $e9e439c110f17033$export$8ac8b6291b7ccf24(this, this.logger, e?.keychain), this.history = new $e9e439c110f17033$export$eeb4f10f25d479cb(this, this.logger), this.expirer = new $e9e439c110f17033$export$e76805ce609031cb(this, this.logger), this.storage = e != null && e.storage ? e.storage : new (0, $5e575ac853f40acc$export$8536778e426ddf92)($e9e439c110f17033$var$Qt($e9e439c110f17033$var$Qt({}, $e9e439c110f17033$export$ba920abfe854b85d), e?.storageOptions)), this.relayer = new $e9e439c110f17033$export$70e73aa29a3d4407({
            core: this,
            logger: this.logger,
            relayUrl: this.relayUrl,
            projectId: this.projectId
        }), this.pairing = new $e9e439c110f17033$export$3370ee24730992a3(this, this.logger), this.verify = new $e9e439c110f17033$export$91a8e56769aeb334(this.projectId || "", this.logger), this.echoClient = new $e9e439c110f17033$export$c393c48c5b0cf59a(this.projectId || "", this.logger);
    }
    static async init(e) {
        const t = new $e9e439c110f17033$export$2e2bcd8739ae039(e);
        await t.initialize();
        const i = await t.crypto.getClientId();
        return await t.storage.setItem($e9e439c110f17033$export$9e4ca561755938da, i), t;
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    async start() {
        this.initialized || await this.initialize();
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.crypto.init(), await this.history.init(), await this.expirer.init(), await this.relayer.init(), await this.heartbeat.init(), await this.pairing.init(), this.initialized = !0, this.logger.info("Core Initialization Success");
        } catch (e) {
            throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`, e), this.logger.error(e.message), e;
        }
    }
}
const $e9e439c110f17033$export$4143ab5b91744744 = $e9e439c110f17033$export$2e2bcd8739ae039;






var $7etJZ = parcelRequire("7etJZ");

var $aG48A = parcelRequire("aG48A");

const $4a472e843fedf2e2$export$4fa962fc67384e02 = "wc", $4a472e843fedf2e2$export$61085c48796ff049 = 2, $4a472e843fedf2e2$export$94715592c220319a = "client", $4a472e843fedf2e2$export$7fa6f9ee1e2cab96 = `${$4a472e843fedf2e2$export$4fa962fc67384e02}@${$4a472e843fedf2e2$export$61085c48796ff049}:${$4a472e843fedf2e2$export$94715592c220319a}:`, $4a472e843fedf2e2$export$8dffb3242f2c5f72 = {
    name: $4a472e843fedf2e2$export$94715592c220319a,
    logger: "error",
    controller: !1,
    relayUrl: "wss://relay.walletconnect.com"
}, $4a472e843fedf2e2$export$fb2c3ad2a2bc26e9 = {
    session_proposal: "session_proposal",
    session_update: "session_update",
    session_extend: "session_extend",
    session_ping: "session_ping",
    session_delete: "session_delete",
    session_expire: "session_expire",
    session_request: "session_request",
    session_request_sent: "session_request_sent",
    session_event: "session_event",
    proposal_expire: "proposal_expire",
    session_request_expire: "session_request_expire"
}, $4a472e843fedf2e2$export$2e2bb8505f95527b = {
    database: ":memory:"
}, $4a472e843fedf2e2$export$a26ccd6441b7d638 = "WALLETCONNECT_DEEPLINK_CHOICE", $4a472e843fedf2e2$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $4a472e843fedf2e2$export$160142c73cb99dc3 = "history", $4a472e843fedf2e2$export$8eba9ce85616c607 = "0.3", $4a472e843fedf2e2$export$ae6c7a4f7ed730a1 = "proposal", $4a472e843fedf2e2$export$6db28e89b135a53c = (0, $aG48A.THIRTY_DAYS), $4a472e843fedf2e2$export$1e6a4dc5172f4830 = "Proposal expired", $4a472e843fedf2e2$export$a069e98a8dfeec1e = "session", $4a472e843fedf2e2$export$84b1b9dbcdea0475 = (0, $aG48A.SEVEN_DAYS), $4a472e843fedf2e2$export$2db42d5151ad6eb8 = "engine", $4a472e843fedf2e2$export$4edb1ca37014192d = {
    wc_sessionPropose: {
        req: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !0,
            tag: 1100
        },
        res: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1101
        }
    },
    wc_sessionSettle: {
        req: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1102
        },
        res: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1103
        }
    },
    wc_sessionUpdate: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1104
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1105
        }
    },
    wc_sessionExtend: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1106
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1107
        }
    },
    wc_sessionRequest: {
        req: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !0,
            tag: 1108
        },
        res: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1109
        }
    },
    wc_sessionEvent: {
        req: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !0,
            tag: 1110
        },
        res: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1111
        }
    },
    wc_sessionDelete: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1112
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1113
        }
    },
    wc_sessionPing: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1114
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1115
        }
    }
}, $4a472e843fedf2e2$export$409f0c0a13a1b7c6 = {
    min: (0, $aG48A.FIVE_MINUTES),
    max: (0, $aG48A.SEVEN_DAYS)
}, $4a472e843fedf2e2$export$8602b201748df21a = {
    idle: "IDLE",
    active: "ACTIVE"
}, $4a472e843fedf2e2$export$40b296af21bd38a4 = "request", $4a472e843fedf2e2$export$63c37d8ae5931ad5 = [
    "wc_sessionPropose",
    "wc_sessionRequest",
    "wc_authRequest"
];
var $4a472e843fedf2e2$var$as = Object.defineProperty, $4a472e843fedf2e2$var$cs = Object.defineProperties, $4a472e843fedf2e2$var$ls = Object.getOwnPropertyDescriptors, $4a472e843fedf2e2$var$ge = Object.getOwnPropertySymbols, $4a472e843fedf2e2$var$hs = Object.prototype.hasOwnProperty, $4a472e843fedf2e2$var$ps = Object.prototype.propertyIsEnumerable, $4a472e843fedf2e2$var$we = (y, n, s)=>n in y ? $4a472e843fedf2e2$var$as(y, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : y[n] = s, $4a472e843fedf2e2$var$w = (y, n)=>{
    for(var s in n || (n = {}))$4a472e843fedf2e2$var$hs.call(n, s) && $4a472e843fedf2e2$var$we(y, s, n[s]);
    if ($4a472e843fedf2e2$var$ge) for (var s of $4a472e843fedf2e2$var$ge(n))$4a472e843fedf2e2$var$ps.call(n, s) && $4a472e843fedf2e2$var$we(y, s, n[s]);
    return y;
}, $4a472e843fedf2e2$var$x = (y, n)=>$4a472e843fedf2e2$var$cs(y, $4a472e843fedf2e2$var$ls(n));
class $4a472e843fedf2e2$var$ds extends (0, $bace94c1ef08d1bc$export$87df43c730effa30) {
    constructor(n){
        super(n), this.name = $4a472e843fedf2e2$export$2db42d5151ad6eb8, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))), this.initialized = !1, this.ignoredPayloadTypes = [
            (0, $a5d33cfc7f8e5437$export$406e97c329f0f3d4)
        ], this.requestQueue = {
            state: $4a472e843fedf2e2$export$8602b201748df21a.idle,
            queue: []
        }, this.sessionRequestQueue = {
            state: $4a472e843fedf2e2$export$8602b201748df21a.idle,
            queue: []
        }, this.requestQueueDelay = (0, $aG48A.ONE_SECOND), this.recentlyDeletedMap = new Map, this.recentlyDeletedLimit = 200, this.init = async ()=>{
            this.initialized || (await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.registerPairingEvents(), this.client.core.pairing.register({
                methods: Object.keys($4a472e843fedf2e2$export$4edb1ca37014192d)
            }), this.initialized = !0, setTimeout(()=>{
                this.sessionRequestQueue.queue = this.getPendingSessionRequests(), this.processSessionRequestQueue();
            }, (0, $aG48A.toMiliseconds)(this.requestQueueDelay)));
        }, this.connect = async (s)=>{
            await this.isInitialized();
            const e = $4a472e843fedf2e2$var$x($4a472e843fedf2e2$var$w({}, s), {
                requiredNamespaces: s.requiredNamespaces || {},
                optionalNamespaces: s.optionalNamespaces || {}
            });
            await this.isValidConnect(e);
            const { pairingTopic: t, requiredNamespaces: i, optionalNamespaces: r, sessionProperties: o, relays: a } = e;
            let c = t, d, p = !1;
            try {
                c && (p = this.client.core.pairing.pairings.get(c).active);
            } catch (P) {
                throw this.client.logger.error(`connect() -> pairing.get(${c}) failed`), P;
            }
            if (!c || !p) {
                const { topic: P, uri: f } = await this.client.core.pairing.create();
                c = P, d = f;
            }
            if (!c) {
                const { message: P } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `connect() pairing topic: ${c}`);
                throw new Error(P);
            }
            const h = await this.client.core.crypto.generateKeyPair(), g = $4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionPropose.req.ttl || (0, $aG48A.FIVE_MINUTES), m = (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)(g), v = $4a472e843fedf2e2$var$w({
                requiredNamespaces: i,
                optionalNamespaces: r,
                relays: a ?? [
                    {
                        protocol: (0, $e9e439c110f17033$export$822d0bd1635d5360)
                    }
                ],
                proposer: {
                    publicKey: h,
                    metadata: this.client.metadata
                },
                expiryTimestamp: m
            }, o && {
                sessionProperties: o
            }), { reject: F, resolve: E, done: me } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)(g, $4a472e843fedf2e2$export$1e6a4dc5172f4830);
            this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect"), async ({ error: P, session: f })=>{
                if (P) F(P);
                else if (f) {
                    f.self.publicKey = h;
                    const ee = $4a472e843fedf2e2$var$x($4a472e843fedf2e2$var$w({}, f), {
                        requiredNamespaces: v.requiredNamespaces,
                        optionalNamespaces: v.optionalNamespaces
                    });
                    await this.client.session.set(f.topic, ee), await this.setExpiry(f.topic, f.expiry), c && await this.client.core.pairing.updateMetadata({
                        topic: c,
                        metadata: f.peer.metadata
                    }), E(ee);
                }
            });
            const Z = await this.sendRequest({
                topic: c,
                method: "wc_sessionPropose",
                params: v,
                throwOnFailedPublish: !0
            });
            return await this.setProposal(Z, $4a472e843fedf2e2$var$w({
                id: Z
            }, v)), {
                uri: d,
                approval: me
            };
        }, this.pair = async (s)=>{
            await this.isInitialized();
            try {
                return await this.client.core.pairing.pair(s);
            } catch (e) {
                throw this.client.logger.error("pair() failed"), e;
            }
        }, this.approve = async (s)=>{
            await this.isInitialized();
            try {
                await this.isValidApprove(s);
            } catch (E) {
                throw this.client.logger.error("approve() -> isValidApprove() failed"), E;
            }
            const { id: e, relayProtocol: t, namespaces: i, sessionProperties: r } = s;
            let o;
            try {
                o = this.client.proposal.get(e);
            } catch (E) {
                throw this.client.logger.error(`approve() -> proposal.get(${e}) failed`), E;
            }
            let { pairingTopic: a, proposer: c, requiredNamespaces: d, optionalNamespaces: p } = o;
            a = a || "";
            const h = await this.client.core.crypto.generateKeyPair(), g = c.publicKey, m = await this.client.core.crypto.generateSharedKey(h, g), v = $4a472e843fedf2e2$var$w({
                relay: {
                    protocol: t ?? "irn"
                },
                namespaces: i,
                pairingTopic: a,
                controller: {
                    publicKey: h,
                    metadata: this.client.metadata
                },
                expiry: (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$84b1b9dbcdea0475)
            }, r && {
                sessionProperties: r
            });
            await this.client.core.relayer.subscribe(m);
            const F = $4a472e843fedf2e2$var$x($4a472e843fedf2e2$var$w({}, v), {
                topic: m,
                requiredNamespaces: d,
                optionalNamespaces: p,
                pairingTopic: a,
                acknowledged: !1,
                self: v.controller,
                peer: {
                    publicKey: c.publicKey,
                    metadata: c.metadata
                },
                controller: h
            });
            await this.client.session.set(m, F);
            try {
                await this.sendResult({
                    id: e,
                    topic: a,
                    result: {
                        relay: {
                            protocol: t ?? "irn"
                        },
                        responderPublicKey: h
                    },
                    throwOnFailedPublish: !0
                }), await this.sendRequest({
                    topic: m,
                    method: "wc_sessionSettle",
                    params: v,
                    throwOnFailedPublish: !0
                });
            } catch (E) {
                throw this.client.logger.error(E), this.client.session.delete(m, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.client.core.relayer.unsubscribe(m), E;
            }
            return await this.client.core.pairing.updateMetadata({
                topic: a,
                metadata: c.metadata
            }), await this.client.proposal.delete(e, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.client.core.pairing.activate({
                topic: a
            }), await this.setExpiry(m, (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$84b1b9dbcdea0475)), {
                topic: m,
                acknowledged: ()=>new Promise((E)=>setTimeout(()=>E(this.client.session.get(m)), 500))
            };
        }, this.reject = async (s)=>{
            await this.isInitialized();
            try {
                await this.isValidReject(s);
            } catch (r) {
                throw this.client.logger.error("reject() -> isValidReject() failed"), r;
            }
            const { id: e, reason: t } = s;
            let i;
            try {
                i = this.client.proposal.get(e).pairingTopic;
            } catch (r) {
                throw this.client.logger.error(`reject() -> proposal.get(${e}) failed`), r;
            }
            i && (await this.sendError(e, i, t), await this.client.proposal.delete(e, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")));
        }, this.update = async (s)=>{
            await this.isInitialized();
            try {
                await this.isValidUpdate(s);
            } catch (p) {
                throw this.client.logger.error("update() -> isValidUpdate() failed"), p;
            }
            const { topic: e, namespaces: t } = s, { done: i, resolve: r, reject: o } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)(), a = (0, $3bb3ddc7bbc938cc$export$2f5364a5d4b80251)(), c = (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString(), d = this.client.session.get(e).namespaces;
            return this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_update", a), async ({ error: p })=>{
                p ? o(p) : (await this.client.session.update(e, {
                    namespaces: t
                }), r());
            }), this.sendRequest({
                topic: e,
                method: "wc_sessionUpdate",
                params: {
                    namespaces: t
                },
                throwOnFailedPublish: !0,
                clientRpcId: a,
                relayRpcId: c
            }).catch((p)=>{
                this.client.logger.error(p), this.client.session.update(e, {
                    namespaces: d
                }), o(p);
            }), {
                acknowledged: i
            };
        }, this.extend = async (s)=>{
            await this.isInitialized();
            try {
                await this.isValidExtend(s);
            } catch (a) {
                throw this.client.logger.error("extend() -> isValidExtend() failed"), a;
            }
            const { topic: e } = s, t = (0, $3bb3ddc7bbc938cc$export$2f5364a5d4b80251)(), { done: i, resolve: r, reject: o } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)();
            return this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_extend", t), ({ error: a })=>{
                a ? o(a) : r();
            }), await this.setExpiry(e, (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$84b1b9dbcdea0475)), this.sendRequest({
                topic: e,
                method: "wc_sessionExtend",
                params: {},
                clientRpcId: t,
                throwOnFailedPublish: !0
            }).catch((a)=>{
                o(a);
            }), {
                acknowledged: i
            };
        }, this.request = async (s)=>{
            await this.isInitialized();
            try {
                await this.isValidRequest(s);
            } catch (h) {
                throw this.client.logger.error("request() -> isValidRequest() failed"), h;
            }
            const { chainId: e, request: t, topic: i, expiry: r = $4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionRequest.req.ttl } = s, o = (0, $3bb3ddc7bbc938cc$export$2f5364a5d4b80251)(), a = (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString(), { done: c, resolve: d, reject: p } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)(r, "Request expired. Please try again.");
            return this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", o), ({ error: h, result: g })=>{
                h ? p(h) : d(g);
            }), await Promise.all([
                new Promise(async (h)=>{
                    await this.sendRequest({
                        clientRpcId: o,
                        relayRpcId: a,
                        topic: i,
                        method: "wc_sessionRequest",
                        params: {
                            request: $4a472e843fedf2e2$var$x($4a472e843fedf2e2$var$w({}, t), {
                                expiryTimestamp: (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)(r)
                            }),
                            chainId: e
                        },
                        expiry: r,
                        throwOnFailedPublish: !0
                    }).catch((g)=>p(g)), this.client.events.emit("session_request_sent", {
                        topic: i,
                        request: t,
                        chainId: e,
                        id: o
                    }), h();
                }),
                new Promise(async (h)=>{
                    const g = await (0, $a5d33cfc7f8e5437$export$e55bfdac47149a32)(this.client.core.storage, $4a472e843fedf2e2$export$a26ccd6441b7d638);
                    (0, $a5d33cfc7f8e5437$export$694a208c8abca99a)({
                        id: o,
                        topic: i,
                        wcDeepLink: g
                    }), h();
                }),
                c()
            ]).then((h)=>h[2]);
        }, this.respond = async (s)=>{
            await this.isInitialized(), await this.isValidRespond(s);
            const { topic: e, response: t } = s, { id: i } = t;
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(t) ? await this.sendResult({
                id: i,
                topic: e,
                result: t.result,
                throwOnFailedPublish: !0
            }) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(t) && await this.sendError(i, e, t.error), this.cleanupAfterResponse(s);
        }, this.ping = async (s)=>{
            await this.isInitialized();
            try {
                await this.isValidPing(s);
            } catch (t) {
                throw this.client.logger.error("ping() -> isValidPing() failed"), t;
            }
            const { topic: e } = s;
            if (this.client.session.keys.includes(e)) {
                const t = (0, $3bb3ddc7bbc938cc$export$2f5364a5d4b80251)(), i = (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString(), { done: r, resolve: o, reject: a } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)();
                this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_ping", t), ({ error: c })=>{
                    c ? a(c) : o();
                }), await Promise.all([
                    this.sendRequest({
                        topic: e,
                        method: "wc_sessionPing",
                        params: {},
                        throwOnFailedPublish: !0,
                        clientRpcId: t,
                        relayRpcId: i
                    }),
                    r()
                ]);
            } else this.client.core.pairing.pairings.keys.includes(e) && await this.client.core.pairing.ping({
                topic: e
            });
        }, this.emit = async (s)=>{
            await this.isInitialized(), await this.isValidEmit(s);
            const { topic: e, event: t, chainId: i } = s, r = (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString();
            await this.sendRequest({
                topic: e,
                method: "wc_sessionEvent",
                params: {
                    event: t,
                    chainId: i
                },
                throwOnFailedPublish: !0,
                relayRpcId: r
            });
        }, this.disconnect = async (s)=>{
            await this.isInitialized(), await this.isValidDisconnect(s);
            const { topic: e } = s;
            if (this.client.session.keys.includes(e)) await this.sendRequest({
                topic: e,
                method: "wc_sessionDelete",
                params: (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED"),
                throwOnFailedPublish: !0
            }), await this.deleteSession({
                topic: e,
                emitEvent: !1
            });
            else if (this.client.core.pairing.pairings.keys.includes(e)) await this.client.core.pairing.disconnect({
                topic: e
            });
            else {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISMATCHED_TOPIC", `Session or pairing topic not found: ${e}`);
                throw new Error(t);
            }
        }, this.find = (s)=>(this.isInitialized(), this.client.session.getAll().filter((e)=>(0, $a5d33cfc7f8e5437$export$6fc4971bf8f326a)(e, s))), this.getPendingSessionRequests = ()=>this.client.pendingRequest.getAll(), this.cleanupDuplicatePairings = async (s)=>{
            if (s.pairingTopic) try {
                const e = this.client.core.pairing.pairings.get(s.pairingTopic), t = this.client.core.pairing.pairings.getAll().filter((i)=>{
                    var r, o;
                    return ((r = i.peerMetadata) == null ? void 0 : r.url) && ((o = i.peerMetadata) == null ? void 0 : o.url) === s.peer.metadata.url && i.topic && i.topic !== e.topic;
                });
                if (t.length === 0) return;
                this.client.logger.info(`Cleaning up ${t.length} duplicate pairing(s)`), await Promise.all(t.map((i)=>this.client.core.pairing.disconnect({
                        topic: i.topic
                    }))), this.client.logger.info("Duplicate pairings clean up finished");
            } catch (e) {
                this.client.logger.error(e);
            }
        }, this.deleteSession = async (s)=>{
            const { topic: e, expirerHasDeleted: t = !1, emitEvent: i = !0, id: r = 0 } = s, { self: o } = this.client.session.get(e);
            await this.client.core.relayer.unsubscribe(e), await this.client.session.delete(e, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.addToRecentlyDeleted(e, "session"), this.client.core.crypto.keychain.has(o.publicKey) && await this.client.core.crypto.deleteKeyPair(o.publicKey), this.client.core.crypto.keychain.has(e) && await this.client.core.crypto.deleteSymKey(e), t || this.client.core.expirer.del(e), this.client.core.storage.removeItem($4a472e843fedf2e2$export$a26ccd6441b7d638).catch((a)=>this.client.logger.warn(a)), this.getPendingSessionRequests().forEach((a)=>{
                a.topic === e && this.deletePendingSessionRequest(a.id, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED"));
            }), i && this.client.events.emit("session_delete", {
                id: r,
                topic: e
            });
        }, this.deleteProposal = async (s, e)=>{
            await Promise.all([
                this.client.proposal.delete(s, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")),
                e ? Promise.resolve() : this.client.core.expirer.del(s)
            ]), this.addToRecentlyDeleted(s, "proposal");
        }, this.deletePendingSessionRequest = async (s, e, t = !1)=>{
            await Promise.all([
                this.client.pendingRequest.delete(s, e),
                t ? Promise.resolve() : this.client.core.expirer.del(s)
            ]), this.addToRecentlyDeleted(s, "request"), this.sessionRequestQueue.queue = this.sessionRequestQueue.queue.filter((i)=>i.id !== s), t && (this.sessionRequestQueue.state = $4a472e843fedf2e2$export$8602b201748df21a.idle, this.client.events.emit("session_request_expire", {
                id: s
            }));
        }, this.setExpiry = async (s, e)=>{
            this.client.session.keys.includes(s) && await this.client.session.update(s, {
                expiry: e
            }), this.client.core.expirer.set(s, e);
        }, this.setProposal = async (s, e)=>{
            await this.client.proposal.set(s, e), this.client.core.expirer.set(s, (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionPropose.req.ttl));
        }, this.setPendingSessionRequest = async (s)=>{
            const { id: e, topic: t, params: i, verifyContext: r } = s, o = i.request.expiryTimestamp || (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionRequest.req.ttl);
            await this.client.pendingRequest.set(e, {
                id: e,
                topic: t,
                params: i,
                verifyContext: r
            }), o && this.client.core.expirer.set(e, o);
        }, this.sendRequest = async (s)=>{
            const { topic: e, method: t, params: i, expiry: r, relayRpcId: o, clientRpcId: a, throwOnFailedPublish: c } = s, d = (0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)(t, i, a);
            if ((0, $a5d33cfc7f8e5437$export$4e09c449d6c407f7)() && $4a472e843fedf2e2$export$63c37d8ae5931ad5.includes(t)) {
                const g = (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(JSON.stringify(d));
                this.client.core.verify.register({
                    attestationId: g
                });
            }
            let p;
            try {
                p = await this.client.core.crypto.encode(e, d);
            } catch (g) {
                throw await this.cleanup(), this.client.logger.error(`sendRequest() -> core.crypto.encode() for topic ${e} failed`), g;
            }
            const h = $4a472e843fedf2e2$export$4edb1ca37014192d[t].req;
            return r && (h.ttl = r), o && (h.id = o), this.client.core.history.set(e, d), c ? (h.internal = $4a472e843fedf2e2$var$x($4a472e843fedf2e2$var$w({}, h.internal), {
                throwOnFailedPublish: !0
            }), await this.client.core.relayer.publish(e, p, h)) : this.client.core.relayer.publish(e, p, h).catch((g)=>this.client.logger.error(g)), d.id;
        }, this.sendResult = async (s)=>{
            const { id: e, topic: t, result: i, throwOnFailedPublish: r } = s, o = (0, $3bb3ddc7bbc938cc$export$478fdea01c2a3198)(e, i);
            let a;
            try {
                a = await this.client.core.crypto.encode(t, o);
            } catch (p) {
                throw await this.cleanup(), this.client.logger.error(`sendResult() -> core.crypto.encode() for topic ${t} failed`), p;
            }
            let c;
            try {
                c = await this.client.core.history.get(t, e);
            } catch (p) {
                throw this.client.logger.error(`sendResult() -> history.get(${t}, ${e}) failed`), p;
            }
            const d = $4a472e843fedf2e2$export$4edb1ca37014192d[c.request.method].res;
            r ? (d.internal = $4a472e843fedf2e2$var$x($4a472e843fedf2e2$var$w({}, d.internal), {
                throwOnFailedPublish: !0
            }), await this.client.core.relayer.publish(t, a, d)) : this.client.core.relayer.publish(t, a, d).catch((p)=>this.client.logger.error(p)), await this.client.core.history.resolve(o);
        }, this.sendError = async (s, e, t)=>{
            const i = (0, $3bb3ddc7bbc938cc$export$9f7302ae26c3f77)(s, t);
            let r;
            try {
                r = await this.client.core.crypto.encode(e, i);
            } catch (c) {
                throw await this.cleanup(), this.client.logger.error(`sendError() -> core.crypto.encode() for topic ${e} failed`), c;
            }
            let o;
            try {
                o = await this.client.core.history.get(e, s);
            } catch (c) {
                throw this.client.logger.error(`sendError() -> history.get(${e}, ${s}) failed`), c;
            }
            const a = $4a472e843fedf2e2$export$4edb1ca37014192d[o.request.method].res;
            this.client.core.relayer.publish(e, r, a), await this.client.core.history.resolve(i);
        }, this.cleanup = async ()=>{
            const s = [], e = [];
            this.client.session.getAll().forEach((t)=>{
                let i = !1;
                (0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(t.expiry) && (i = !0), this.client.core.crypto.keychain.has(t.topic) || (i = !0), i && s.push(t.topic);
            }), this.client.proposal.getAll().forEach((t)=>{
                (0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(t.expiryTimestamp) && e.push(t.id);
            }), await Promise.all([
                ...s.map((t)=>this.deleteSession({
                        topic: t
                    })),
                ...e.map((t)=>this.deleteProposal(t))
            ]);
        }, this.onRelayEventRequest = async (s)=>{
            this.requestQueue.queue.push(s), await this.processRequestsQueue();
        }, this.processRequestsQueue = async ()=>{
            if (this.requestQueue.state === $4a472e843fedf2e2$export$8602b201748df21a.active) {
                this.client.logger.info("Request queue already active, skipping...");
                return;
            }
            for(this.client.logger.info(`Request queue starting with ${this.requestQueue.queue.length} requests`); this.requestQueue.queue.length > 0;){
                this.requestQueue.state = $4a472e843fedf2e2$export$8602b201748df21a.active;
                const s = this.requestQueue.queue.shift();
                if (s) try {
                    this.processRequest(s), await new Promise((e)=>setTimeout(e, 300));
                } catch (e) {
                    this.client.logger.warn(e);
                }
            }
            this.requestQueue.state = $4a472e843fedf2e2$export$8602b201748df21a.idle;
        }, this.processRequest = (s)=>{
            const { topic: e, payload: t } = s, i = t.method;
            switch(i){
                case "wc_sessionPropose":
                    return this.onSessionProposeRequest(e, t);
                case "wc_sessionSettle":
                    return this.onSessionSettleRequest(e, t);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateRequest(e, t);
                case "wc_sessionExtend":
                    return this.onSessionExtendRequest(e, t);
                case "wc_sessionPing":
                    return this.onSessionPingRequest(e, t);
                case "wc_sessionDelete":
                    return this.onSessionDeleteRequest(e, t);
                case "wc_sessionRequest":
                    return this.onSessionRequest(e, t);
                case "wc_sessionEvent":
                    return this.onSessionEventRequest(e, t);
                default:
                    return this.client.logger.info(`Unsupported request method ${i}`);
            }
        }, this.onRelayEventResponse = async (s)=>{
            const { topic: e, payload: t } = s, i = (await this.client.core.history.get(e, t.id)).request.method;
            switch(i){
                case "wc_sessionPropose":
                    return this.onSessionProposeResponse(e, t);
                case "wc_sessionSettle":
                    return this.onSessionSettleResponse(e, t);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateResponse(e, t);
                case "wc_sessionExtend":
                    return this.onSessionExtendResponse(e, t);
                case "wc_sessionPing":
                    return this.onSessionPingResponse(e, t);
                case "wc_sessionRequest":
                    return this.onSessionRequestResponse(e, t);
                default:
                    return this.client.logger.info(`Unsupported response method ${i}`);
            }
        }, this.onRelayEventUnknownPayload = (s)=>{
            const { topic: e } = s, { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `Decoded payload on topic ${e} is not identifiable as a JSON-RPC request or a response.`);
            throw new Error(t);
        }, this.onSessionProposeRequest = async (s, e)=>{
            const { params: t, id: i } = e;
            try {
                this.isValidConnect($4a472e843fedf2e2$var$w({}, e.params));
                const r = t.expiryTimestamp || (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionPropose.req.ttl), o = $4a472e843fedf2e2$var$w({
                    id: i,
                    pairingTopic: s,
                    expiryTimestamp: r
                }, t);
                await this.setProposal(i, o);
                const a = (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(JSON.stringify(e)), c = await this.getVerifyContext(a, o.proposer.metadata);
                this.client.events.emit("session_proposal", {
                    id: i,
                    params: o,
                    verifyContext: c
                });
            } catch (r) {
                await this.sendError(i, s, r), this.client.logger.error(r);
            }
        }, this.onSessionProposeResponse = async (s, e)=>{
            const { id: t } = e;
            if ((0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(e)) {
                const { result: i } = e;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    result: i
                });
                const r = this.client.proposal.get(t);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    proposal: r
                });
                const o = r.proposer.publicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    selfPublicKey: o
                });
                const a = i.responderPublicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    peerPublicKey: a
                });
                const c = await this.client.core.crypto.generateSharedKey(o, a);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    sessionTopic: c
                });
                const d = await this.client.core.relayer.subscribe(c);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    subscriptionId: d
                }), await this.client.core.pairing.activate({
                    topic: s
                });
            } else if ((0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(e)) {
                await this.client.proposal.delete(t, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED"));
                const i = (0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect");
                if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners, 954`);
                this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect"), {
                    error: e.error
                });
            }
        }, this.onSessionSettleRequest = async (s, e)=>{
            const { id: t, params: i } = e;
            try {
                this.isValidSessionSettleRequest(i);
                const { relay: r, controller: o, expiry: a, namespaces: c, sessionProperties: d, pairingTopic: p } = e.params, h = $4a472e843fedf2e2$var$w({
                    topic: s,
                    relay: r,
                    expiry: a,
                    namespaces: c,
                    acknowledged: !0,
                    pairingTopic: p,
                    requiredNamespaces: {},
                    optionalNamespaces: {},
                    controller: o.publicKey,
                    self: {
                        publicKey: "",
                        metadata: this.client.metadata
                    },
                    peer: {
                        publicKey: o.publicKey,
                        metadata: o.metadata
                    }
                }, d && {
                    sessionProperties: d
                });
                await this.sendResult({
                    id: e.id,
                    topic: s,
                    result: !0,
                    throwOnFailedPublish: !0
                });
                const g = (0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect");
                if (this.events.listenerCount(g) === 0) throw new Error(`emitting ${g} without any listeners 997`);
                this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect"), {
                    session: h
                }), this.cleanupDuplicatePairings(h);
            } catch (r) {
                await this.sendError(t, s, r), this.client.logger.error(r);
            }
        }, this.onSessionSettleResponse = async (s, e)=>{
            const { id: t } = e;
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(e) ? (await this.client.session.update(s, {
                acknowledged: !0
            }), this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_approve", t), {})) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(e) && (await this.client.session.delete(s, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_approve", t), {
                error: e.error
            }));
        }, this.onSessionUpdateRequest = async (s, e)=>{
            const { params: t, id: i } = e;
            try {
                const r = `${s}_session_update`, o = (0, $a5d33cfc7f8e5437$export$b72d712fed4d036d).get(r);
                if (o && this.isRequestOutOfSync(o, i)) {
                    this.client.logger.info(`Discarding out of sync request - ${i}`), this.sendError(i, s, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("INVALID_UPDATE_REQUEST"));
                    return;
                }
                this.isValidUpdate($4a472e843fedf2e2$var$w({
                    topic: s
                }, t));
                try {
                    (0, $a5d33cfc7f8e5437$export$b72d712fed4d036d).set(r, i), await this.client.session.update(s, {
                        namespaces: t.namespaces
                    }), await this.sendResult({
                        id: i,
                        topic: s,
                        result: !0,
                        throwOnFailedPublish: !0
                    });
                } catch (a) {
                    throw (0, $a5d33cfc7f8e5437$export$b72d712fed4d036d).delete(r), a;
                }
                this.client.events.emit("session_update", {
                    id: i,
                    topic: s,
                    params: t
                });
            } catch (r) {
                await this.sendError(i, s, r), this.client.logger.error(r);
            }
        }, this.isRequestOutOfSync = (s, e)=>parseInt(e.toString().slice(0, -3)) <= parseInt(s.toString().slice(0, -3)), this.onSessionUpdateResponse = (s, e)=>{
            const { id: t } = e, i = (0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_update", t);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(e) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_update", t), {}) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(e) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_update", t), {
                error: e.error
            });
        }, this.onSessionExtendRequest = async (s, e)=>{
            const { id: t } = e;
            try {
                this.isValidExtend({
                    topic: s
                }), await this.setExpiry(s, (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$84b1b9dbcdea0475)), await this.sendResult({
                    id: t,
                    topic: s,
                    result: !0,
                    throwOnFailedPublish: !0
                }), this.client.events.emit("session_extend", {
                    id: t,
                    topic: s
                });
            } catch (i) {
                await this.sendError(t, s, i), this.client.logger.error(i);
            }
        }, this.onSessionExtendResponse = (s, e)=>{
            const { id: t } = e, i = (0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_extend", t);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(e) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_extend", t), {}) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(e) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_extend", t), {
                error: e.error
            });
        }, this.onSessionPingRequest = async (s, e)=>{
            const { id: t } = e;
            try {
                this.isValidPing({
                    topic: s
                }), await this.sendResult({
                    id: t,
                    topic: s,
                    result: !0,
                    throwOnFailedPublish: !0
                }), this.client.events.emit("session_ping", {
                    id: t,
                    topic: s
                });
            } catch (i) {
                await this.sendError(t, s, i), this.client.logger.error(i);
            }
        }, this.onSessionPingResponse = (s, e)=>{
            const { id: t } = e, i = (0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_ping", t);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            setTimeout(()=>{
                (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(e) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_ping", t), {}) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(e) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_ping", t), {
                    error: e.error
                });
            }, 500);
        }, this.onSessionDeleteRequest = async (s, e)=>{
            const { id: t } = e;
            try {
                this.isValidDisconnect({
                    topic: s,
                    reason: e.params
                }), await Promise.all([
                    new Promise((i)=>{
                        this.client.core.relayer.once((0, $e9e439c110f17033$export$d56245796e2837d).publish, async ()=>{
                            i(await this.deleteSession({
                                topic: s,
                                id: t
                            }));
                        });
                    }),
                    this.sendResult({
                        id: t,
                        topic: s,
                        result: !0,
                        throwOnFailedPublish: !0
                    }),
                    this.cleanupPendingSentRequestsForTopic({
                        topic: s,
                        error: (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")
                    })
                ]);
            } catch (i) {
                this.client.logger.error(i);
            }
        }, this.onSessionRequest = async (s, e)=>{
            const { id: t, params: i } = e;
            try {
                this.isValidRequest($4a472e843fedf2e2$var$w({
                    topic: s
                }, i));
                const r = (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(JSON.stringify((0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)("wc_sessionRequest", i, t))), o = this.client.session.get(s), a = await this.getVerifyContext(r, o.peer.metadata), c = {
                    id: t,
                    topic: s,
                    params: i,
                    verifyContext: a
                };
                await this.setPendingSessionRequest(c), this.addSessionRequestToSessionRequestQueue(c), this.processSessionRequestQueue();
            } catch (r) {
                await this.sendError(t, s, r), this.client.logger.error(r);
            }
        }, this.onSessionRequestResponse = (s, e)=>{
            const { id: t } = e, i = (0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", t);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(e) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", t), {
                result: e.result
            }) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(e) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", t), {
                error: e.error
            });
        }, this.onSessionEventRequest = async (s, e)=>{
            const { id: t, params: i } = e;
            try {
                const r = `${s}_session_event_${i.event.name}`, o = (0, $a5d33cfc7f8e5437$export$b72d712fed4d036d).get(r);
                if (o && this.isRequestOutOfSync(o, t)) {
                    this.client.logger.info(`Discarding out of sync request - ${t}`);
                    return;
                }
                this.isValidEmit($4a472e843fedf2e2$var$w({
                    topic: s
                }, i)), this.client.events.emit("session_event", {
                    id: t,
                    topic: s,
                    params: i
                }), (0, $a5d33cfc7f8e5437$export$b72d712fed4d036d).set(r, t);
            } catch (r) {
                await this.sendError(t, s, r), this.client.logger.error(r);
            }
        }, this.addSessionRequestToSessionRequestQueue = (s)=>{
            this.sessionRequestQueue.queue.push(s);
        }, this.cleanupAfterResponse = (s)=>{
            this.deletePendingSessionRequest(s.response.id, {
                message: "fulfilled",
                code: 0
            }), setTimeout(()=>{
                this.sessionRequestQueue.state = $4a472e843fedf2e2$export$8602b201748df21a.idle, this.processSessionRequestQueue();
            }, (0, $aG48A.toMiliseconds)(this.requestQueueDelay));
        }, this.cleanupPendingSentRequestsForTopic = ({ topic: s, error: e })=>{
            const t = this.client.core.history.pending;
            t.length > 0 && t.filter((i)=>i.topic === s && i.request.method === "wc_sessionRequest").forEach((i)=>{
                const r = i.request.id, o = (0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", r);
                if (this.events.listenerCount(o) === 0) throw new Error(`emitting ${o} without any listeners`);
                this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", i.request.id), {
                    error: e
                });
            });
        }, this.processSessionRequestQueue = ()=>{
            if (this.sessionRequestQueue.state === $4a472e843fedf2e2$export$8602b201748df21a.active) {
                this.client.logger.info("session request queue is already active.");
                return;
            }
            const s = this.sessionRequestQueue.queue[0];
            if (!s) {
                this.client.logger.info("session request queue is empty.");
                return;
            }
            try {
                this.sessionRequestQueue.state = $4a472e843fedf2e2$export$8602b201748df21a.active, this.client.events.emit("session_request", s);
            } catch (e) {
                this.client.logger.error(e);
            }
        }, this.onPairingCreated = (s)=>{
            if (s.active) return;
            const e = this.client.proposal.getAll().find((t)=>t.pairingTopic === s.topic);
            e && this.onSessionProposeRequest(s.topic, (0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)("wc_sessionPropose", {
                requiredNamespaces: e.requiredNamespaces,
                optionalNamespaces: e.optionalNamespaces,
                relays: e.relays,
                proposer: e.proposer,
                sessionProperties: e.sessionProperties
            }, e.id));
        }, this.isValidConnect = async (s)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(s)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `connect() params: ${JSON.stringify(s)}`);
                throw new Error(a);
            }
            const { pairingTopic: e, requiredNamespaces: t, optionalNamespaces: i, sessionProperties: r, relays: o } = s;
            if ((0, $a5d33cfc7f8e5437$export$fce6876652108ab)(e) || await this.isValidPairingTopic(e), !(0, $a5d33cfc7f8e5437$export$6294c30b976bd21e)(o, !0)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `connect() relays: ${o}`);
                throw new Error(a);
            }
            !(0, $a5d33cfc7f8e5437$export$fce6876652108ab)(t) && (0, $a5d33cfc7f8e5437$export$16a0268bc22b47b0)(t) !== 0 && this.validateNamespaces(t, "requiredNamespaces"), !(0, $a5d33cfc7f8e5437$export$fce6876652108ab)(i) && (0, $a5d33cfc7f8e5437$export$16a0268bc22b47b0)(i) !== 0 && this.validateNamespaces(i, "optionalNamespaces"), (0, $a5d33cfc7f8e5437$export$fce6876652108ab)(r) || this.validateSessionProps(r, "sessionProperties");
        }, this.validateNamespaces = (s, e)=>{
            const t = (0, $a5d33cfc7f8e5437$export$9e2b2cae22c6a8b3)(s, "connect()", e);
            if (t) throw new Error(t.message);
        }, this.isValidApprove = async (s)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(s)) throw new Error((0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `approve() params: ${s}`).message);
            const { id: e, namespaces: t, relayProtocol: i, sessionProperties: r } = s;
            this.checkRecentlyDeleted(e), await this.isValidProposalId(e);
            const o = this.client.proposal.get(e), a = (0, $a5d33cfc7f8e5437$export$93f7b81dc815a714)(t, "approve()");
            if (a) throw new Error(a.message);
            const c = (0, $a5d33cfc7f8e5437$export$ba5b0a4b585cd1b4)(o.requiredNamespaces, t, "approve()");
            if (c) throw new Error(c.message);
            if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(i, !0)) {
                const { message: d } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `approve() relayProtocol: ${i}`);
                throw new Error(d);
            }
            (0, $a5d33cfc7f8e5437$export$fce6876652108ab)(r) || this.validateSessionProps(r, "sessionProperties");
        }, this.isValidReject = async (s)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(s)) {
                const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `reject() params: ${s}`);
                throw new Error(i);
            }
            const { id: e, reason: t } = s;
            if (this.checkRecentlyDeleted(e), await this.isValidProposalId(e), !(0, $a5d33cfc7f8e5437$export$766fe78377d96f2a)(t)) {
                const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `reject() reason: ${JSON.stringify(t)}`);
                throw new Error(i);
            }
        }, this.isValidSessionSettleRequest = (s)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(s)) {
                const { message: c } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `onSessionSettleRequest() params: ${s}`);
                throw new Error(c);
            }
            const { relay: e, controller: t, namespaces: i, expiry: r } = s;
            if (!(0, $a5d33cfc7f8e5437$export$1b3fc298be8c9a7b)(e)) {
                const { message: c } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string");
                throw new Error(c);
            }
            const o = (0, $a5d33cfc7f8e5437$export$5e1c5c89613c213f)(t, "onSessionSettleRequest()");
            if (o) throw new Error(o.message);
            const a = (0, $a5d33cfc7f8e5437$export$93f7b81dc815a714)(i, "onSessionSettleRequest()");
            if (a) throw new Error(a.message);
            if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(r)) {
                const { message: c } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", "onSessionSettleRequest()");
                throw new Error(c);
            }
        }, this.isValidUpdate = async (s)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(s)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `update() params: ${s}`);
                throw new Error(a);
            }
            const { topic: e, namespaces: t } = s;
            this.checkRecentlyDeleted(e), await this.isValidSessionTopic(e);
            const i = this.client.session.get(e), r = (0, $a5d33cfc7f8e5437$export$93f7b81dc815a714)(t, "update()");
            if (r) throw new Error(r.message);
            const o = (0, $a5d33cfc7f8e5437$export$ba5b0a4b585cd1b4)(i.requiredNamespaces, t, "update()");
            if (o) throw new Error(o.message);
        }, this.isValidExtend = async (s)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(s)) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `extend() params: ${s}`);
                throw new Error(t);
            }
            const { topic: e } = s;
            this.checkRecentlyDeleted(e), await this.isValidSessionTopic(e);
        }, this.isValidRequest = async (s)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(s)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() params: ${s}`);
                throw new Error(a);
            }
            const { topic: e, request: t, chainId: i, expiry: r } = s;
            this.checkRecentlyDeleted(e), await this.isValidSessionTopic(e);
            const { namespaces: o } = this.client.session.get(e);
            if (!(0, $a5d33cfc7f8e5437$export$144fc36610eb6522)(o, i)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() chainId: ${i}`);
                throw new Error(a);
            }
            if (!(0, $a5d33cfc7f8e5437$export$1a2af3c017fb6d42)(t)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() ${JSON.stringify(t)}`);
                throw new Error(a);
            }
            if (!(0, $a5d33cfc7f8e5437$export$8db4804e3a6de711)(o, i, t.method)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() method: ${t.method}`);
                throw new Error(a);
            }
            if (r && !(0, $a5d33cfc7f8e5437$export$59fba2af1ac782b)(r, $4a472e843fedf2e2$export$409f0c0a13a1b7c6)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() expiry: ${r}. Expiry must be a number (in seconds) between ${$4a472e843fedf2e2$export$409f0c0a13a1b7c6.min} and ${$4a472e843fedf2e2$export$409f0c0a13a1b7c6.max}`);
                throw new Error(a);
            }
        }, this.isValidRespond = async (s)=>{
            var e;
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(s)) {
                const { message: r } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `respond() params: ${s}`);
                throw new Error(r);
            }
            const { topic: t, response: i } = s;
            try {
                await this.isValidSessionTopic(t);
            } catch (r) {
                throw (e = s?.response) != null && e.id && this.cleanupAfterResponse(s), r;
            }
            if (!(0, $a5d33cfc7f8e5437$export$1ae38cf0a848f651)(i)) {
                const { message: r } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `respond() response: ${JSON.stringify(i)}`);
                throw new Error(r);
            }
        }, this.isValidPing = async (s)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(s)) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `ping() params: ${s}`);
                throw new Error(t);
            }
            const { topic: e } = s;
            await this.isValidSessionOrPairingTopic(e);
        }, this.isValidEmit = async (s)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(s)) {
                const { message: o } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() params: ${s}`);
                throw new Error(o);
            }
            const { topic: e, event: t, chainId: i } = s;
            await this.isValidSessionTopic(e);
            const { namespaces: r } = this.client.session.get(e);
            if (!(0, $a5d33cfc7f8e5437$export$144fc36610eb6522)(r, i)) {
                const { message: o } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() chainId: ${i}`);
                throw new Error(o);
            }
            if (!(0, $a5d33cfc7f8e5437$export$cbe4cdc5960cfa11)(t)) {
                const { message: o } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(t)}`);
                throw new Error(o);
            }
            if (!(0, $a5d33cfc7f8e5437$export$df2c67ef8baad16b)(r, i, t.name)) {
                const { message: o } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(t)}`);
                throw new Error(o);
            }
        }, this.isValidDisconnect = async (s)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(s)) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `disconnect() params: ${s}`);
                throw new Error(t);
            }
            const { topic: e } = s;
            await this.isValidSessionOrPairingTopic(e);
        }, this.getVerifyContext = async (s, e)=>{
            const t = {
                verified: {
                    verifyUrl: e.verifyUrl || (0, $e9e439c110f17033$export$7e3b1a28ddecdbaa),
                    validation: "UNKNOWN",
                    origin: e.url || ""
                }
            };
            try {
                const i = await this.client.core.verify.resolve({
                    attestationId: s,
                    verifyUrl: e.verifyUrl
                });
                i && (t.verified.origin = i.origin, t.verified.isScam = i.isScam, t.verified.validation = i.origin === new URL(e.url).origin ? "VALID" : "INVALID");
            } catch (i) {
                this.client.logger.info(i);
            }
            return this.client.logger.info(`Verify context: ${JSON.stringify(t)}`), t;
        }, this.validateSessionProps = (s, e)=>{
            Object.values(s).forEach((t)=>{
                if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(t, !1)) {
                    const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `${e} must be in Record<string, string> format. Received: ${JSON.stringify(t)}`);
                    throw new Error(i);
                }
            });
        }, this.addToRecentlyDeleted = (s, e)=>{
            if (this.recentlyDeletedMap.set(s, e), this.recentlyDeletedMap.size >= this.recentlyDeletedLimit) {
                let t = 0;
                const i = this.recentlyDeletedLimit / 2;
                for (const r of this.recentlyDeletedMap.keys()){
                    if (t++ >= i) break;
                    this.recentlyDeletedMap.delete(r);
                }
            }
        }, this.checkRecentlyDeleted = (s)=>{
            const e = this.recentlyDeletedMap.get(s);
            if (e) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `Record was recently deleted - ${e}: ${s}`);
                throw new Error(t);
            }
        };
    }
    async isInitialized() {
        if (!this.initialized) {
            const { message: n } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(n);
        }
        await this.client.core.relayer.confirmOnlineStateOrThrow();
    }
    registerRelayerEvents() {
        this.client.core.relayer.on((0, $e9e439c110f17033$export$d56245796e2837d).message, async (n)=>{
            const { topic: s, message: e } = n;
            if (this.ignoredPayloadTypes.includes(this.client.core.crypto.getPayloadType(e))) return;
            const t = await this.client.core.crypto.decode(s, e);
            try {
                (0, $2e45abd1d679ec32$export$f6e4034abe07d2a5)(t) ? (this.client.core.history.set(s, t), this.onRelayEventRequest({
                    topic: s,
                    payload: t
                })) : (0, $2e45abd1d679ec32$export$308ba927de2bcbe8)(t) ? (await this.client.core.history.resolve(t), await this.onRelayEventResponse({
                    topic: s,
                    payload: t
                }), this.client.core.history.delete(s, t.id)) : this.onRelayEventUnknownPayload({
                    topic: s,
                    payload: t
                });
            } catch (i) {
                this.client.logger.error(i);
            }
        });
    }
    registerExpirerEvents() {
        this.client.core.expirer.on((0, $e9e439c110f17033$export$9013719d9206b0c1).expired, async (n)=>{
            const { topic: s, id: e } = (0, $a5d33cfc7f8e5437$export$93adeb0f16e8e51d)(n.target);
            if (e && this.client.pendingRequest.keys.includes(e)) return await this.deletePendingSessionRequest(e, (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED"), !0);
            s ? this.client.session.keys.includes(s) && (await this.deleteSession({
                topic: s,
                expirerHasDeleted: !0
            }), this.client.events.emit("session_expire", {
                topic: s
            })) : e && (await this.deleteProposal(e, !0), this.client.events.emit("proposal_expire", {
                id: e
            }));
        });
    }
    registerPairingEvents() {
        this.client.core.pairing.events.on((0, $e9e439c110f17033$export$ca3c0b962acf7b75).create, (n)=>this.onPairingCreated(n)), this.client.core.pairing.events.on((0, $e9e439c110f17033$export$ca3c0b962acf7b75).delete, (n)=>{
            this.addToRecentlyDeleted(n.topic, "pairing");
        });
    }
    isValidPairingTopic(n) {
        if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(n, !1)) {
            const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pairing topic should be a string: ${n}`);
            throw new Error(s);
        }
        if (!this.client.core.pairing.pairings.keys.includes(n)) {
            const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${n}`);
            throw new Error(s);
        }
        if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(this.client.core.pairing.pairings.get(n).expiry)) {
            const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", `pairing topic: ${n}`);
            throw new Error(s);
        }
    }
    async isValidSessionTopic(n) {
        if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(n, !1)) {
            const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session topic should be a string: ${n}`);
            throw new Error(s);
        }
        if (this.checkRecentlyDeleted(n), !this.client.session.keys.includes(n)) {
            const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `session topic doesn't exist: ${n}`);
            throw new Error(s);
        }
        if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(this.client.session.get(n).expiry)) {
            await this.deleteSession({
                topic: n
            });
            const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", `session topic: ${n}`);
            throw new Error(s);
        }
        if (!this.client.core.crypto.keychain.has(n)) {
            const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session topic does not exist in keychain: ${n}`);
            throw await this.deleteSession({
                topic: n
            }), new Error(s);
        }
    }
    async isValidSessionOrPairingTopic(n) {
        if (this.checkRecentlyDeleted(n), this.client.session.keys.includes(n)) await this.isValidSessionTopic(n);
        else if (this.client.core.pairing.pairings.keys.includes(n)) this.isValidPairingTopic(n);
        else if ((0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(n, !1)) {
            const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `session or pairing topic doesn't exist: ${n}`);
            throw new Error(s);
        } else {
            const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session or pairing topic should be a string: ${n}`);
            throw new Error(s);
        }
    }
    async isValidProposalId(n) {
        if (!(0, $a5d33cfc7f8e5437$export$53551be28ad5e34d)(n)) {
            const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `proposal id should be a number: ${n}`);
            throw new Error(s);
        }
        if (!this.client.proposal.keys.includes(n)) {
            const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `proposal id doesn't exist: ${n}`);
            throw new Error(s);
        }
        if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(this.client.proposal.get(n).expiryTimestamp)) {
            await this.deleteProposal(n);
            const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", `proposal id: ${n}`);
            throw new Error(s);
        }
    }
}
class $4a472e843fedf2e2$var$us extends (0, $e9e439c110f17033$export$390f32400eaf98c9) {
    constructor(n, s){
        super(n, s, $4a472e843fedf2e2$export$ae6c7a4f7ed730a1, $4a472e843fedf2e2$export$7fa6f9ee1e2cab96), this.core = n, this.logger = s;
    }
}
class $4a472e843fedf2e2$var$ye extends (0, $e9e439c110f17033$export$390f32400eaf98c9) {
    constructor(n, s){
        super(n, s, $4a472e843fedf2e2$export$a069e98a8dfeec1e, $4a472e843fedf2e2$export$7fa6f9ee1e2cab96), this.core = n, this.logger = s;
    }
}
class $4a472e843fedf2e2$var$gs extends (0, $e9e439c110f17033$export$390f32400eaf98c9) {
    constructor(n, s){
        super(n, s, $4a472e843fedf2e2$export$40b296af21bd38a4, $4a472e843fedf2e2$export$7fa6f9ee1e2cab96, (e)=>e.id), this.core = n, this.logger = s;
    }
}
class $4a472e843fedf2e2$export$2e2bcd8739ae039 extends (0, $bace94c1ef08d1bc$export$2ebcf6eeacedad44) {
    constructor(n){
        super(n), this.protocol = $4a472e843fedf2e2$export$4fa962fc67384e02, this.version = $4a472e843fedf2e2$export$61085c48796ff049, this.name = $4a472e843fedf2e2$export$8dffb3242f2c5f72.name, this.events = new (0, $7etJZ.EventEmitter), this.on = (e, t)=>this.events.on(e, t), this.once = (e, t)=>this.events.once(e, t), this.off = (e, t)=>this.events.off(e, t), this.removeListener = (e, t)=>this.events.removeListener(e, t), this.removeAllListeners = (e)=>this.events.removeAllListeners(e), this.connect = async (e)=>{
            try {
                return await this.engine.connect(e);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.pair = async (e)=>{
            try {
                return await this.engine.pair(e);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.approve = async (e)=>{
            try {
                return await this.engine.approve(e);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.reject = async (e)=>{
            try {
                return await this.engine.reject(e);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.update = async (e)=>{
            try {
                return await this.engine.update(e);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.extend = async (e)=>{
            try {
                return await this.engine.extend(e);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.request = async (e)=>{
            try {
                return await this.engine.request(e);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.respond = async (e)=>{
            try {
                return await this.engine.respond(e);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.ping = async (e)=>{
            try {
                return await this.engine.ping(e);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.emit = async (e)=>{
            try {
                return await this.engine.emit(e);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.disconnect = async (e)=>{
            try {
                return await this.engine.disconnect(e);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.find = (e)=>{
            try {
                return this.engine.find(e);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.getPendingSessionRequests = ()=>{
            try {
                return this.engine.getPendingSessionRequests();
            } catch (e) {
                throw this.logger.error(e.message), e;
            }
        }, this.name = n?.name || $4a472e843fedf2e2$export$8dffb3242f2c5f72.name, this.metadata = n?.metadata || (0, $a5d33cfc7f8e5437$export$ba31e015127122bb)();
        const s = typeof n?.logger < "u" && typeof n?.logger != "string" ? n.logger : (0, $7fc0ce2591a9daef$exports.pino)((0, $7fc0ce2591a9daef$exports.getDefaultLoggerOptions)({
            level: n?.logger || $4a472e843fedf2e2$export$8dffb3242f2c5f72.logger
        }));
        this.core = n?.core || new (0, $e9e439c110f17033$export$4143ab5b91744744)(n), this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(s, this.name), this.session = new $4a472e843fedf2e2$var$ye(this.core, this.logger), this.proposal = new $4a472e843fedf2e2$var$us(this.core, this.logger), this.pendingRequest = new $4a472e843fedf2e2$var$gs(this.core, this.logger), this.engine = new $4a472e843fedf2e2$var$ds(this);
    }
    static async init(n) {
        const s = new $4a472e843fedf2e2$export$2e2bcd8739ae039(n);
        return await s.initialize(), s;
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get pairing() {
        return this.core.pairing.pairings;
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.core.start(), await this.session.init(), await this.proposal.init(), await this.pendingRequest.init(), await this.engine.init(), this.core.verify.init({
                verifyUrl: this.metadata.verifyUrl
            }), this.logger.info("SignClient Initialization Success");
        } catch (n) {
            throw this.logger.info("SignClient Initialization Failure"), this.logger.error(n.message), n;
        }
    }
}
const $4a472e843fedf2e2$export$90b8cff65c105172 = $4a472e843fedf2e2$var$ye, $4a472e843fedf2e2$export$bdf4ba258ec679dc = $4a472e843fedf2e2$export$2e2bcd8739ae039;



var $hohVq = parcelRequire("hohVq");

class $ff461f234bab4cda$export$642f71372fab1590 {
    constructor(e){
        this.openModal = (0, $hohVq.ModalCtrl).open, this.closeModal = (0, $hohVq.ModalCtrl).close, this.subscribeModal = (0, $hohVq.ModalCtrl).subscribe, this.setTheme = (0, $hohVq.ThemeCtrl).setThemeConfig, (0, $hohVq.ThemeCtrl).setThemeConfig(e), (0, $hohVq.ConfigCtrl).setConfig(e), this.initUi();
    }
    async initUi() {
        if (typeof window < "u") {
            await (parcelRequire("jiqUU"));
            const e = document.createElement("wcm-modal");
            document.body.insertAdjacentElement("beforeend", e), (0, $hohVq.OptionsCtrl).setIsUiLoaded(!0);
        }
    }
}



var $4b665efddc7cd9c8$export$b5d5a40c24facca4 = {
    purpose: "identification",
    payload: {
        type: "text",
        content: `The following dApp would like to see your public address: ${typeof window < "u" ? window.origin : ""}`
    }
};
var $4b665efddc7cd9c8$export$7448c01626a95a0b = {
    main: {
        number: 0,
        id: "0x00000000851caf3cfdb6e899cf5958bfb1ac3413d346d43539627e6be7ec1b4a",
        size: 170,
        parentID: "0xffffffff53616c757465202620526573706563742c20457468657265756d2100",
        timestamp: 1530316800,
        gasLimit: 1e7,
        beneficiary: "0x0000000000000000000000000000000000000000",
        gasUsed: 0,
        totalScore: 0,
        txsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
        txsFeatures: 0,
        stateRoot: "0x09bfdf9e24dd5cd5b63f3c1b5d58b97ff02ca0490214a021ed7d99b93867839c",
        receiptsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
        signer: "0x0000000000000000000000000000000000000000",
        isTrunk: !0,
        transactions: []
    },
    test: {
        number: 0,
        id: "0x000000000b2bce3c70bc649a02749e8687721b09ed2e15997f466536b20bb127",
        size: 170,
        parentID: "0xffffffff00000000000000000000000000000000000000000000000000000000",
        timestamp: 1530014400,
        gasLimit: 1e7,
        beneficiary: "0x0000000000000000000000000000000000000000",
        gasUsed: 0,
        totalScore: 0,
        txsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
        txsFeatures: 0,
        stateRoot: "0x4ec3af0acbad1ae467ad569337d2fe8576fe303928d35b8cdd91de47e9ac84bb",
        receiptsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
        signer: "0x0000000000000000000000000000000000000000",
        isTrunk: !0,
        transactions: []
    }
};
var $4b665efddc7cd9c8$var$O = {
    requiresCertificate: !0
}, $4b665efddc7cd9c8$export$3b95142b3b92a86a = {
    "wallet-connect": {
        requiresCertificate: !1
    },
    veworld: $4b665efddc7cd9c8$var$O,
    sync2: $4b665efddc7cd9c8$var$O,
    sync: $4b665efddc7cd9c8$var$O
}, $4b665efddc7cd9c8$export$771a7e037f0b0496 = Object.keys($4b665efddc7cd9c8$export$3b95142b3b92a86a);
Object.freeze($4b665efddc7cd9c8$export$3b95142b3b92a86a);
Object.freeze($4b665efddc7cd9c8$export$771a7e037f0b0496);
var $4b665efddc7cd9c8$export$e613c75871d09b0b = ((o)=>(o.RequestTransaction = "thor_sendTransaction", o.SignCertificate = "thor_signCertificate", o.SignTypedData = "thor_signTypedData", o))($4b665efddc7cd9c8$export$e613c75871d09b0b || {});
var $4b665efddc7cd9c8$var$w = {
    NONE: 0,
    ERROR: 1,
    WARN: 2,
    INFO: 3,
    DEBUG: 4
}, $4b665efddc7cd9c8$var$S = $4b665efddc7cd9c8$var$w.NONE, $4b665efddc7cd9c8$export$4269407eefc1557b = {
    configure (n) {
        $4b665efddc7cd9c8$var$S = $4b665efddc7cd9c8$var$w[n];
    },
    debug (n, t, ...e) {
        $4b665efddc7cd9c8$var$S >= $4b665efddc7cd9c8$var$w.DEBUG && console.log(`[${n}] (${t})`, ...e);
    },
    info (n, t, ...e) {
        $4b665efddc7cd9c8$var$S >= $4b665efddc7cd9c8$var$w.INFO && console.info(`[${n}] (${t})`, ...e);
    },
    warn (n, t, ...e) {
        $4b665efddc7cd9c8$var$S >= $4b665efddc7cd9c8$var$w.WARN && console.warn(`[${n}] (${t})`, ...e);
    },
    error (n, t, ...e) {
        $4b665efddc7cd9c8$var$S >= $4b665efddc7cd9c8$var$w.ERROR && console.error(`[${n}] (${t})`, ...e);
    }
};
var $4b665efddc7cd9c8$export$3fbaa9af73216eba = (n)=>({
        signTx: (t, e)=>{
            let o = n.sign("tx", t);
            return e.gas && o.gas(e.gas), e.signer && o.signer(e.signer), e.dependsOn && o.dependsOn(e.dependsOn), e.link && o.link(e.link), e.comment && o.comment(e.comment), e.delegator && o.delegate(e.delegator.url, e.delegator.signer), e.onAccepted && o.accepted(e.onAccepted), $4b665efddc7cd9c8$export$4269407eefc1557b.debug("vendor", "signTx", {
                messages: t.length,
                options: e
            }), o.request();
        },
        signCert: (t, e)=>{
            let o = n.sign("cert", t);
            return e.signer && o.signer(e.signer), e.link && o.link(e.link), e.onAccepted && o.accepted(e.onAccepted), $4b665efddc7cd9c8$export$4269407eefc1557b.debug("vendor", "signCert", {
                message: t,
                options: e
            }), o.request();
        },
        signTypedData (t, e, o, i) {
            throw new Error("Sign typed data it is not available with sync2");
        }
    });
var $4b665efddc7cd9c8$var$W = "dappkit@vechain", $4b665efddc7cd9c8$var$M = `${$4b665efddc7cd9c8$var$W}/source`, $4b665efddc7cd9c8$var$L = `${$4b665efddc7cd9c8$var$W}/account`, $4b665efddc7cd9c8$var$V = `${$4b665efddc7cd9c8$var$W}/connectionCertificate`, $4b665efddc7cd9c8$var$P = `${$4b665efddc7cd9c8$var$W}/accountDomain`, $4b665efddc7cd9c8$var$oe = (n)=>{
    $4b665efddc7cd9c8$export$4269407eefc1557b.debug("LocalStorage", "setSource", n), n ? localStorage.setItem($4b665efddc7cd9c8$var$M, n) : localStorage.removeItem($4b665efddc7cd9c8$var$M);
}, $4b665efddc7cd9c8$var$re = (n)=>{
    $4b665efddc7cd9c8$export$4269407eefc1557b.debug("LocalStorage", "setAccount", n), n ? localStorage.setItem($4b665efddc7cd9c8$var$L, n) : localStorage.removeItem($4b665efddc7cd9c8$var$L);
}, $4b665efddc7cd9c8$var$ie = (n)=>{
    $4b665efddc7cd9c8$export$4269407eefc1557b.debug("LocalStorage", "setAccountDomain", n), n ? localStorage.setItem($4b665efddc7cd9c8$var$P, n) : localStorage.removeItem($4b665efddc7cd9c8$var$P);
}, $4b665efddc7cd9c8$var$se = (n)=>{
    $4b665efddc7cd9c8$export$4269407eefc1557b.debug("LocalStorage", "setConnectionCertificate", n), n ? localStorage.setItem($4b665efddc7cd9c8$var$V, JSON.stringify(n)) : localStorage.removeItem($4b665efddc7cd9c8$var$V);
}, $4b665efddc7cd9c8$var$ce = ()=>{
    let n = localStorage.getItem($4b665efddc7cd9c8$var$M);
    return n || null;
}, $4b665efddc7cd9c8$var$ae = ()=>{
    let n = localStorage.getItem($4b665efddc7cd9c8$var$L);
    return n || null;
}, $4b665efddc7cd9c8$var$le = ()=>{
    let n = localStorage.getItem($4b665efddc7cd9c8$var$P);
    return n || null;
}, $4b665efddc7cd9c8$var$de = ()=>{
    let n = localStorage.getItem($4b665efddc7cd9c8$var$V);
    return n ? JSON.parse(n) : null;
}, $4b665efddc7cd9c8$export$bf2a15d34f3c441c = {
    setAccount: $4b665efddc7cd9c8$var$re,
    setSource: $4b665efddc7cd9c8$var$oe,
    setConnectionCertificate: $4b665efddc7cd9c8$var$se,
    setAccountDomain: $4b665efddc7cd9c8$var$ie,
    getAccountDomain: $4b665efddc7cd9c8$var$le,
    getAccount: $4b665efddc7cd9c8$var$ae,
    getSource: $4b665efddc7cd9c8$var$ce,
    getConnectionCertificate: $4b665efddc7cd9c8$var$de
};
var $4b665efddc7cd9c8$export$3fe296bf74f84675 = (n)=>n ? n === "main" || n === "test" ? $4b665efddc7cd9c8$export$7448c01626a95a0b[n].id : n.id : $4b665efddc7cd9c8$export$7448c01626a95a0b.main.id, $4b665efddc7cd9c8$export$29e00eb624df1375 = (n)=>n ? n === "main" || n === "test" ? $4b665efddc7cd9c8$export$7448c01626a95a0b[n] : n : $4b665efddc7cd9c8$export$7448c01626a95a0b.main;
var $4b665efddc7cd9c8$export$31c5edc1bfe2adbf = class {
    constructor(t, e){
        this.wallet = t;
        this.connect = async (t)=>{
            let e = t?.message || this.certificateData.message, o = t?.options ?? this.certificateData.options, { annex: { domain: i, signer: r, timestamp: a }, signature: g } = await this.signCert(e, o), u = {
                ...e,
                signature: g,
                signer: r,
                domain: i,
                timestamp: a
            };
            try {
                return (0, $564ad8f2c6689928$export$ca20b3ed1788c40a).of(u).verify(), {
                    account: r,
                    verified: !0,
                    connectionCertificate: u
                };
            } catch (m) {
                return console.error("Failed to verify connection certificate", m), {
                    account: r,
                    verified: !1
                };
            }
        };
        this.signCert = (t, e)=>this.wallet.signCert(t, e);
        this.signTx = (t, e)=>this.wallet.signTx(t, e);
        this.signTypedData = (t, e, o, i)=>this.wallet.signTypedData(t, e, o, i);
        this.disconnect = async ()=>this.wallet.disconnect?.();
        this.certificateData = {
            message: e?.message ?? $4b665efddc7cd9c8$export$b5d5a40c24facca4,
            options: e?.options ?? {}
        };
    }
};
var $4b665efddc7cd9c8$export$1c08da98dc60bc89 = class {
    constructor(t){
        this.signer = t;
        this.connect = async ()=>({
                account: await this.signer.connect(),
                verified: !1
            });
        this.signCert = (t, e)=>this.signer.signCert(t, e);
        this.signTx = (t, e)=>this.signer.signTx(t, e);
        this.signTypedData = async (t, e, o, i)=>this.signer.signTypedData(t, e, o, i);
        this.disconnect = ()=>this.signer.disconnect();
    }
};
var $4b665efddc7cd9c8$var$U = {}, $4b665efddc7cd9c8$export$a921ca84c16b5db1 = ({ projectId: n, metadata: t })=>{
    let e = $4b665efddc7cd9c8$var$U[n];
    if (e) return e;
    let o = (0, $4a472e843fedf2e2$export$bdf4ba258ec679dc).init({
        projectId: n,
        metadata: t
    }), i = {
        get: async ()=>{
            try {
                return await o;
            } catch (r) {
                throw console.error("Failed to initialise the wallet connect sign client", r), new Error("Failed to initialise the wallet connect sign client");
            }
        }
    };
    return $4b665efddc7cd9c8$var$U[n] = i, i;
};
var $4b665efddc7cd9c8$var$G = {}, $4b665efddc7cd9c8$var$fe = [
    "0x00000000851caf3cfdb6e899cf5958bfb1ac3413d346d43539627e6be7ec1b4a",
    "0x000000000b2bce3c70bc649a02749e8687721b09ed2e15997f466536b20bb127"
], $4b665efddc7cd9c8$var$me = $4b665efddc7cd9c8$var$fe.map((n)=>`vechain:${n.slice(-32)}`), $4b665efddc7cd9c8$export$113e3ea58c9d93ef = (n)=>{
    let t = $4b665efddc7cd9c8$var$G[n];
    if (t) return t;
    let e = new (0, $ff461f234bab4cda$export$642f71372fab1590)({
        projectId: n,
        explorerRecommendedWalletIds: "NONE",
        mobileWallets: [
            {
                name: "VeWorld",
                id: "veworld-mobile",
                links: {
                    native: "veworld://org.vechain.veworld.app/",
                    universal: "https://veworld.com"
                }
            }
        ],
        chains: $4b665efddc7cd9c8$var$me,
        themeVariables: {
            "--wcm-z-index": "99999999"
        },
        walletImages: {
            "veworld-mobile": "https://www.veworld.net/assets/logo/logo.svg"
        }
    });
    return $4b665efddc7cd9c8$var$G[n] = e, e;
};
var $4b665efddc7cd9c8$export$f1fedd9156ad42c7 = ({ genesisId: n, wcClient: t, web3Modal: e, onDisconnected: o })=>{
    let i = `vechain:${n.slice(-32)}`, r;
    t.get().then((s)=>{
        a(s), g(s);
    }).catch(()=>{
        throw new Error("Failed to get the wallet connect sign client");
    }), window && (window.onfocus = async ()=>{
        r && await (await t.get()).ping({
            topic: r.topic
        });
    });
    let a = (s)=>{
        s.on("session_update", ({ topic: l, params: d })=>{
            $4b665efddc7cd9c8$export$4269407eefc1557b.debug("wallet connect signer", "session_update", {
                topic: l,
                params: d
            });
            let { namespaces: p } = d;
            r = {
                ...s.session.get(l),
                namespaces: p
            };
        }), s.on("session_delete", ()=>{
            o(), _().catch(()=>{
                throw new Error("Failed to disconnect");
            });
        });
    }, g = (s)=>{
        if (typeof r < "u") return;
        $4b665efddc7cd9c8$export$4269407eefc1557b.debug("wallet connect signer", "restore session");
        let l = s.session.keys;
        for (let d of l){
            let p = s.session.get(d), v = p.namespaces.vechain.accounts;
            for (let b of v)if (b.split(":")[1] === n.slice(-32)) {
                r = p;
                return;
            }
        }
    }, u = (s)=>{
        if (!r) return;
        $4b665efddc7cd9c8$export$4269407eefc1557b.debug("wallet connect signer", "validate session");
        let l = r.namespaces.vechain.accounts[0], d = l.split(":")[2], p = l.split(":")[1];
        if (p === n.slice(-32) && !(s && s.toLowerCase() !== d.toLowerCase())) return {
            address: d,
            networkIdentifier: p,
            topic: r.topic
        };
    }, m = async ()=>{
        $4b665efddc7cd9c8$export$4269407eefc1557b.debug("wallet connect signer", "connect");
        let s = await t.get(), l = {
            methods: Object.values($4b665efddc7cd9c8$export$e613c75871d09b0b),
            chains: [
                i
            ],
            events: []
        };
        try {
            let d = {
                vechain: l
            }, p = await s.connect({
                requiredNamespaces: d
            });
            return p.uri && await e.openModal({
                uri: p.uri
            }), await new Promise((v, b)=>{
                let I = e.subscribeModal((h)=>{
                    h.open || (b(new Error("User closed modal while connecting")), I());
                });
                p.approval().then((h)=>{
                    r = h, I(), v(h);
                }).catch((h)=>{
                    e.closeModal(), b(h);
                });
            });
        } catch (d) {
            throw console.error("wc connect failed", d), new Error("wc connect failed");
        }
    }, E = async (s)=>{
        let l = u(s);
        return l ? l.topic : (await m()).topic;
    }, y = async (s, l)=>{
        let d = await E(l);
        return (await t.get()).request({
            topic: d,
            chainId: i,
            request: s
        });
    }, ee = async (s, l)=>y({
            method: "thor_sendTransaction",
            params: [
                {
                    message: s,
                    options: l
                }
            ]
        }), te = async (s, l)=>y({
            method: "thor_signCertificate",
            params: [
                {
                    message: s,
                    options: l
                }
            ]
        }), ne = async (s, l, d, p)=>y({
            method: "thor_signTypedData",
            params: [
                {
                    domain: s,
                    types: l,
                    value: d,
                    options: p
                }
            ]
        }), _ = async ()=>{
        if (!r) return;
        let s = r.topic;
        r = void 0;
        let l = await t.get();
        try {
            await l.disconnect({
                topic: s,
                reason: (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")
            });
        } catch (d) {
            throw console.error("SignClient.disconnect failed", d), new Error("SignClient.disconnect failed");
        }
    };
    return {
        signTx: ee,
        signCert: te,
        signTypedData: ne,
        disconnect: _,
        genesisId: n,
        connect: async ()=>{
            r || (r = await m());
            let s = r.namespaces.vechain;
            if (!s) throw new Error("Failed to create a vechain session with wallet connect");
            let l = s.accounts[0];
            try {
                return l.split(":")[2];
            } catch (d) {
                throw console.error("Failed to get account from session", d), new Error("Failed to get account from session");
            }
        }
    };
};
var $4b665efddc7cd9c8$export$41bdf21621ec4e24 = ({ source: n, genesis: t, walletConnectOptions: e, onDisconnected: o, connectionCertificate: i })=>{
    let r = $4b665efddc7cd9c8$export$3fe296bf74f84675(t);
    switch($4b665efddc7cd9c8$export$4269407eefc1557b.debug("createWallet", n), n){
        case "sync":
            {
                if (!window.connex) throw new Error("User is not in a Sync wallet");
                let a = new $fac7b04398ee9187$exports.Connex.Vendor(r, "sync");
                return new $4b665efddc7cd9c8$export$31c5edc1bfe2adbf($4b665efddc7cd9c8$export$3fbaa9af73216eba(a), i);
            }
        case "sync2":
            {
                let a = new $fac7b04398ee9187$exports.Connex.Vendor(r, "sync2");
                return new $4b665efddc7cd9c8$export$31c5edc1bfe2adbf($4b665efddc7cd9c8$export$3fbaa9af73216eba(a), i);
            }
        case "veworld":
            {
                if (!window.vechain) throw new Error("VeWorld Extension is not installed");
                let a = window.vechain.newConnexSigner(r);
                return new $4b665efddc7cd9c8$export$31c5edc1bfe2adbf(a, i);
            }
        case "wallet-connect":
            {
                if (!e) throw new Error("WalletConnect options are not provided");
                let { projectId: a, metadata: g, modal: u } = e, m = $4b665efddc7cd9c8$export$a921ca84c16b5db1({
                    projectId: a,
                    metadata: g
                }), E = u ?? $4b665efddc7cd9c8$export$113e3ea58c9d93ef(a), y = $4b665efddc7cd9c8$export$f1fedd9156ad42c7({
                    genesisId: r,
                    wcClient: m,
                    web3Modal: E,
                    onDisconnected: o
                });
                return new $4b665efddc7cd9c8$export$1c08da98dc60bc89(y);
            }
    }
};
var $4b665efddc7cd9c8$export$e64256c8aa87bb6 = (n, t = 10, e = 7)=>n.length > t + e + 1 ? `${n.slice(0, t)}\u2026${n.slice(-e)}` : n;
var $4b665efddc7cd9c8$var$J = {
    main: "0xA11413086e163e41901bb81fdc5617c975Fa5a1A",
    test: "0xc403b8EA53F707d7d4de095f0A20bC491Cf2bc94"
}, $4b665efddc7cd9c8$var$we = {
    inputs: [
        {
            internalType: "address[]",
            name: "addresses",
            type: "address[]"
        }
    ],
    name: "getNames",
    outputs: [
        {
            internalType: "string[]",
            name: "names",
            type: "string[]"
        }
    ],
    stateMutability: "view",
    type: "function"
}, $4b665efddc7cd9c8$var$X = async ({ address: n, driver: t })=>{
    if (!n) return null;
    let e = new (0, $77618c5bc79fb5a3$export$638889172ebce0c4)(t), o = t.genesis.id === $4b665efddc7cd9c8$export$7448c01626a95a0b.test.id ? $4b665efddc7cd9c8$var$J.test : $4b665efddc7cd9c8$var$J.main, i = await e.thor.account(o).method($4b665efddc7cd9c8$var$we).call([
        n
    ]), { decoded: { names: r } } = i;
    return r?.[0] || null;
};
var $4b665efddc7cd9c8$export$d9a919bae0329c9a = class {
    constructor(t, e){
        this.options = t;
        this.driver = e;
        this.wallets = {};
        this.setAccountDomain = (t)=>{
            t ? (this.state.isAccountDomainLoading = !0, $4b665efddc7cd9c8$var$X({
                address: t,
                driver: this.driver
            }).then((e)=>{
                this.state.accountDomain = e;
            }).catch((e)=>{
                console.error("Error getting account domain", e), this.state.accountDomain = null;
            }).finally(()=>{
                this.state.isAccountDomainLoading = !1;
            })) : (this.state.accountDomain = null, this.state.isAccountDomainLoading = !1);
        };
        this.setAddress = (t)=>{
            this.state.address = t;
        };
        this.setAddressAndDomain = (t)=>{
            this.setAddress(t), this.setAccountDomain(t);
        };
        this.signConnectionCertificate = async (t)=>{
            let e = t?.message || this.options.connectionCertificate?.message || $4b665efddc7cd9c8$export$b5d5a40c24facca4, o = t?.options || this.options.connectionCertificate?.options || {}, { annex: { domain: i, signer: r, timestamp: a }, signature: g } = await this.wallet.signCert(e, o), u = {
                ...e,
                signature: g,
                signer: r,
                domain: i,
                timestamp: a
            };
            try {
                return (0, $564ad8f2c6689928$export$ca20b3ed1788c40a).of(u).verify(), this.setAddressAndDomain(r), this.state.connectionCertificate = u, {
                    account: r,
                    verified: !0,
                    connectionCertificate: u
                };
            } catch (m) {
                return console.error("Failed to sign connection certificate", m), {
                    account: r,
                    verified: !1
                };
            } finally{
                this.options.walletConnectOptions?.modal?.onConnectionCertificateSigned?.();
            }
        };
        this.connect = (t)=>this.wallet.connect(t).then((e)=>(this.state.source === "wallet-connect" && this.options.requireCertificate && this.options.walletConnectOptions?.modal?.askForConnectionCertificate ? this.options.walletConnectOptions.modal.askForConnectionCertificate() : (this.setAddressAndDomain(e.account), this.state.connectionCertificate = e.connectionCertificate ?? null), e)).catch((e)=>{
                throw $4b665efddc7cd9c8$export$4269407eefc1557b.error("WalletManager", "connect", e), e;
            });
        this.disconnect = (t = !1)=>{
            if (!this.state.source) {
                this.state.source = null, this.setAddressAndDomain(null), this.state.connectionCertificate = null;
                return;
            }
            $4b665efddc7cd9c8$export$4269407eefc1557b.debug("WalletManager", "disconnect", "current source", this.state.source);
            let e = this.wallets[this.state.source];
            if (e && !t && e.disconnect) {
                let o = e.disconnect();
                o instanceof Promise && o.catch((i)=>{
                    $4b665efddc7cd9c8$export$4269407eefc1557b.error("WalletManager", "disconnect", i);
                });
            }
            this.state.source = null, this.setAddressAndDomain(null), this.state.connectionCertificate = null;
        };
        this.signTx = (t, e)=>this.wallet.signTx(t, e).catch((o)=>{
                throw $4b665efddc7cd9c8$export$4269407eefc1557b.error("WalletManager", "signTx", o), o;
            });
        this.signCert = (t, e)=>this.wallet.signCert(t, e).catch((o)=>{
                throw $4b665efddc7cd9c8$export$4269407eefc1557b.error("WalletManager", "signCert", o), o;
            });
        this.signTypedData = (t, e, o, i)=>this.wallet.signTypedData(t, e, o, i).catch((r)=>{
                throw $4b665efddc7cd9c8$export$4269407eefc1557b.error("WalletManager", "signTypedData", r), r;
            });
        this.setSource = (t)=>{
            if (this.state.source !== t) {
                if (this.state.source && this.state.source !== t && this.disconnect(), t === "wallet-connect" && !this.options.walletConnectOptions) throw new Error("WalletConnect options are not provided");
                if (t === "veworld" && !window.vechain) throw new Error("VeWorld Extension is not installed");
                if (t === "sync" && !window.connex) throw new Error("User is not in a Sync wallet");
                $4b665efddc7cd9c8$export$4269407eefc1557b.debug("WalletManager", "setSource", t), this.disconnect(), this.state.source = t;
            }
        };
        this.subscribe = (t)=>(0, $lDt57.subscribe)(this.state, ()=>{
                t(this.state);
            });
        this.subscribeToKey = (t, e)=>(0, $cae0866804f4505b$export$7faad7f6b3708314)(this.state, t, (o)=>{
                e(o);
            });
        this.initState = (t)=>{
            let e = this.getAvailableSources();
            if (!t) return (0, $lDt57.proxy)({
                source: null,
                address: null,
                accountDomain: null,
                isAccountDomainLoading: !1,
                availableSources: e,
                connectionCertificate: null
            });
            let o = $4b665efddc7cd9c8$export$bf2a15d34f3c441c.getAccount(), i = $4b665efddc7cd9c8$export$bf2a15d34f3c441c.getAccountDomain(), r = $4b665efddc7cd9c8$export$bf2a15d34f3c441c.getSource(), a = $4b665efddc7cd9c8$export$bf2a15d34f3c441c.getConnectionCertificate();
            return (0, $lDt57.proxy)({
                source: r,
                address: o,
                accountDomain: i,
                isAccountDomainLoading: !1,
                availableSources: e,
                connectionCertificate: a
            });
        };
        this.initPersistence = (t)=>{
            t && (this.subscribeToKey("address", $4b665efddc7cd9c8$export$bf2a15d34f3c441c.setAccount), this.subscribeToKey("accountDomain", $4b665efddc7cd9c8$export$bf2a15d34f3c441c.setAccountDomain), this.subscribeToKey("source", $4b665efddc7cd9c8$export$bf2a15d34f3c441c.setSource), this.subscribeToKey("connectionCertificate", $4b665efddc7cd9c8$export$bf2a15d34f3c441c.setConnectionCertificate));
        };
        this.getAvailableSources = ()=>{
            let t = $4b665efddc7cd9c8$export$771a7e037f0b0496, e = this.options.allowedWallets ?? t, o = [];
            return e.includes("veworld") && o.push("veworld"), this.options.walletConnectOptions && e.includes("wallet-connect") && o.push("wallet-connect"), e.includes("sync2") && o.push("sync2"), window.connex && e.includes("sync") && o.push("sync"), o;
        };
        this.setFirstDetectedSource = ()=>{
            window.vechain ? this.setSource("veworld") : this.options.walletConnectOptions ? this.setSource("wallet-connect") : window.connex ? this.setSource("sync") : this.setSource("sync2");
        };
        this.state = this.initState(t.usePersistence ?? !1), this.initPersistence(t.usePersistence ?? !1), $4b665efddc7cd9c8$export$4269407eefc1557b.debug("WalletManager", "constructor", this.state), window.vechain?.isInAppBrowser === !0 ? this.setSource("veworld") : t.useFirstDetectedSource && this.setFirstDetectedSource();
    }
    get wallet() {
        let t = this.state.source;
        if ($4b665efddc7cd9c8$export$4269407eefc1557b.debug("WalletManager", "get wallet", "current source", t), !t) throw new Error("No wallet has been selected");
        let e = this.wallets[t];
        if (!e) {
            if (!$4b665efddc7cd9c8$export$771a7e037f0b0496.includes(t)) throw new Error(`No wallet found for: ${t}`);
            $4b665efddc7cd9c8$export$4269407eefc1557b.debug("WalletManager", "get wallet", "creating a new wallet", t);
            let o = {
                ...this.options,
                source: t,
                onDisconnected: ()=>this.disconnect(!0)
            };
            e = $4b665efddc7cd9c8$export$41bdf21621ec4e24(o), this.wallets[t] = e;
        }
        return e;
    }
};
var $4b665efddc7cd9c8$var$Q = {}, $4b665efddc7cd9c8$var$Ae = (n, t, e)=>{
    let o = JSON.stringify({
        node: n,
        genesis: t
    }), i = new TextEncoder().encode(o.normalize()), r = (0, $564ad8f2c6689928$export$9ccf03a0aa23a1ca).of((0, $564ad8f2c6689928$export$a00142b13614340a)(i, "hex")).digits, a = $4b665efddc7cd9c8$var$Q[r];
    return a || (a = new (0, $396d828a707f29ff$exports.DriverNoVendor)(e, t), $4b665efddc7cd9c8$var$Q[r] = a), a;
}, $4b665efddc7cd9c8$export$689c0902427b3cc0 = class {
    constructor(t){
        t.logLevel && ($4b665efddc7cd9c8$export$4269407eefc1557b.configure(t.logLevel), $4b665efddc7cd9c8$export$4269407eefc1557b.debug("DAppKit", "constructor", t));
        let { nodeUrl: e, genesis: o } = t, i = $4b665efddc7cd9c8$export$29e00eb624df1375(o), r = t.customNet || new (0, $396d828a707f29ff$exports.SimpleNet)(e), a = $4b665efddc7cd9c8$var$Ae(e, i, r), g = new $4b665efddc7cd9c8$export$d9a919bae0329c9a(t, a);
        a.signTx = g.signTx.bind(g), a.signCert = g.signCert.bind(g);
        let u = new (0, $77618c5bc79fb5a3$export$638889172ebce0c4)(a);
        this.thor = u.thor, this.vendor = u.vendor, this.wallet = g;
    }
};



/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3da9ee5e4be70f97$var$t = globalThis, $3da9ee5e4be70f97$export$b4d10f6001c083c2 = $3da9ee5e4be70f97$var$t.ShadowRoot && (void 0 === $3da9ee5e4be70f97$var$t.ShadyCSS || $3da9ee5e4be70f97$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $3da9ee5e4be70f97$var$s = Symbol(), $3da9ee5e4be70f97$var$o = new WeakMap;
class $3da9ee5e4be70f97$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $3da9ee5e4be70f97$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($3da9ee5e4be70f97$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $3da9ee5e4be70f97$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $3da9ee5e4be70f97$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $3da9ee5e4be70f97$export$8d80f9cac07cdb3 = (t)=>new $3da9ee5e4be70f97$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $3da9ee5e4be70f97$var$s), $3da9ee5e4be70f97$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $3da9ee5e4be70f97$export$505d1e8739bad805(o, t, $3da9ee5e4be70f97$var$s);
}, $3da9ee5e4be70f97$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($3da9ee5e4be70f97$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $3da9ee5e4be70f97$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $3da9ee5e4be70f97$export$ee69dfd951e24778 = $3da9ee5e4be70f97$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $3da9ee5e4be70f97$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $5c1f81a423d5b637$var$i, defineProperty: $5c1f81a423d5b637$var$e, getOwnPropertyDescriptor: $5c1f81a423d5b637$var$r, getOwnPropertyNames: $5c1f81a423d5b637$var$h, getOwnPropertySymbols: $5c1f81a423d5b637$var$o, getPrototypeOf: $5c1f81a423d5b637$var$n } = Object, $5c1f81a423d5b637$var$a = globalThis, $5c1f81a423d5b637$var$c = $5c1f81a423d5b637$var$a.trustedTypes, $5c1f81a423d5b637$var$l = $5c1f81a423d5b637$var$c ? $5c1f81a423d5b637$var$c.emptyScript : "", $5c1f81a423d5b637$var$p = $5c1f81a423d5b637$var$a.reactiveElementPolyfillSupport, $5c1f81a423d5b637$var$d = (t, s)=>t, $5c1f81a423d5b637$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $5c1f81a423d5b637$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $5c1f81a423d5b637$export$53a6892c50694894 = (t, s)=>!$5c1f81a423d5b637$var$i(t, s), $5c1f81a423d5b637$var$y = {
    attribute: !0,
    type: String,
    converter: $5c1f81a423d5b637$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $5c1f81a423d5b637$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $5c1f81a423d5b637$var$a.litPropertyMetadata ??= new WeakMap;
class $5c1f81a423d5b637$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $5c1f81a423d5b637$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $5c1f81a423d5b637$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $5c1f81a423d5b637$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $5c1f81a423d5b637$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($5c1f81a423d5b637$var$d("elementProperties"))) return;
        const t = $5c1f81a423d5b637$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($5c1f81a423d5b637$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($5c1f81a423d5b637$var$d("properties"))) {
            const t = this.properties, s = [
                ...$5c1f81a423d5b637$var$h(t),
                ...$5c1f81a423d5b637$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $3da9ee5e4be70f97$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $3da9ee5e4be70f97$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$Eg = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$ES(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$E_ ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$E_?.delete(t);
    }
    _$ES() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $3da9ee5e4be70f97$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$E_?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$E_?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EO(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $5c1f81a423d5b637$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $5c1f81a423d5b637$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $5c1f81a423d5b637$export$53a6892c50694894)(this[t], s)) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$Eg = this._$EP());
    }
    C(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$ET ??= new Set).add(t);
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$Eg;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.C(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$E_?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$Ej();
        } catch (s) {
            throw t = !1, this._$Ej(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$E_?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ej() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$Eg;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$ET &&= this._$ET.forEach((t)=>this._$EO(t, this[t])), this._$Ej();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$5c1f81a423d5b637$export$c7c07a37856565d.elementStyles = [], $5c1f81a423d5b637$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $5c1f81a423d5b637$export$c7c07a37856565d[$5c1f81a423d5b637$var$d("elementProperties")] = new Map, $5c1f81a423d5b637$export$c7c07a37856565d[$5c1f81a423d5b637$var$d("finalized")] = new Map, $5c1f81a423d5b637$var$p?.({
    ReactiveElement: $5c1f81a423d5b637$export$c7c07a37856565d
}), ($5c1f81a423d5b637$var$a.reactiveElementVersions ??= []).push("2.0.3");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3c37a6a9a4cce4d8$var$t = globalThis, $3c37a6a9a4cce4d8$var$i = $3c37a6a9a4cce4d8$var$t.trustedTypes, $3c37a6a9a4cce4d8$var$s = $3c37a6a9a4cce4d8$var$i ? $3c37a6a9a4cce4d8$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $3c37a6a9a4cce4d8$var$e = "$lit$", $3c37a6a9a4cce4d8$var$h = `lit$${(Math.random() + "").slice(9)}$`, $3c37a6a9a4cce4d8$var$o = "?" + $3c37a6a9a4cce4d8$var$h, $3c37a6a9a4cce4d8$var$n = `<${$3c37a6a9a4cce4d8$var$o}>`, $3c37a6a9a4cce4d8$var$r = document, $3c37a6a9a4cce4d8$var$l = ()=>$3c37a6a9a4cce4d8$var$r.createComment(""), $3c37a6a9a4cce4d8$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $3c37a6a9a4cce4d8$var$a = Array.isArray, $3c37a6a9a4cce4d8$var$u = (t)=>$3c37a6a9a4cce4d8$var$a(t) || "function" == typeof t?.[Symbol.iterator], $3c37a6a9a4cce4d8$var$d = "[ 	\n\f\r]", $3c37a6a9a4cce4d8$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $3c37a6a9a4cce4d8$var$v = /-->/g, $3c37a6a9a4cce4d8$var$_ = />/g, $3c37a6a9a4cce4d8$var$m = RegExp(`>|${$3c37a6a9a4cce4d8$var$d}(?:([^\\s"'>=/]+)(${$3c37a6a9a4cce4d8$var$d}*=${$3c37a6a9a4cce4d8$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $3c37a6a9a4cce4d8$var$p = /'/g, $3c37a6a9a4cce4d8$var$g = /"/g, $3c37a6a9a4cce4d8$var$$ = /^(?:script|style|textarea|title)$/i, $3c37a6a9a4cce4d8$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5 = $3c37a6a9a4cce4d8$var$y(1), $3c37a6a9a4cce4d8$export$7ed1367e7fa1ad68 = $3c37a6a9a4cce4d8$var$y(2), $3c37a6a9a4cce4d8$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $3c37a6a9a4cce4d8$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $3c37a6a9a4cce4d8$var$A = new WeakMap, $3c37a6a9a4cce4d8$var$E = $3c37a6a9a4cce4d8$var$r.createTreeWalker($3c37a6a9a4cce4d8$var$r, 129);
function $3c37a6a9a4cce4d8$var$C(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $3c37a6a9a4cce4d8$var$s ? $3c37a6a9a4cce4d8$var$s.createHTML(i) : i;
}
const $3c37a6a9a4cce4d8$var$P = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : "", c = $3c37a6a9a4cce4d8$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $3c37a6a9a4cce4d8$var$f ? "!--" === u[1] ? c = $3c37a6a9a4cce4d8$var$v : void 0 !== u[1] ? c = $3c37a6a9a4cce4d8$var$_ : void 0 !== u[2] ? ($3c37a6a9a4cce4d8$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $3c37a6a9a4cce4d8$var$m) : void 0 !== u[3] && (c = $3c37a6a9a4cce4d8$var$m) : c === $3c37a6a9a4cce4d8$var$m ? ">" === u[0] ? (c = r ?? $3c37a6a9a4cce4d8$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $3c37a6a9a4cce4d8$var$m : '"' === u[3] ? $3c37a6a9a4cce4d8$var$g : $3c37a6a9a4cce4d8$var$p) : c === $3c37a6a9a4cce4d8$var$g || c === $3c37a6a9a4cce4d8$var$p ? c = $3c37a6a9a4cce4d8$var$m : c === $3c37a6a9a4cce4d8$var$v || c === $3c37a6a9a4cce4d8$var$_ ? c = $3c37a6a9a4cce4d8$var$f : (c = $3c37a6a9a4cce4d8$var$m, r = void 0);
        const x = c === $3c37a6a9a4cce4d8$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $3c37a6a9a4cce4d8$var$f ? s + $3c37a6a9a4cce4d8$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $3c37a6a9a4cce4d8$var$e + s.slice(d) + $3c37a6a9a4cce4d8$var$h + x) : s + $3c37a6a9a4cce4d8$var$h + (-2 === d ? i : x);
    }
    return [
        $3c37a6a9a4cce4d8$var$C(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        o
    ];
};
class $3c37a6a9a4cce4d8$var$V {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $3c37a6a9a4cce4d8$var$P(t, s);
        if (this.el = $3c37a6a9a4cce4d8$var$V.createElement(f, n), $3c37a6a9a4cce4d8$var$E.currentNode = this.el.content, 2 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $3c37a6a9a4cce4d8$var$E.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($3c37a6a9a4cce4d8$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($3c37a6a9a4cce4d8$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $3c37a6a9a4cce4d8$var$k : "?" === e[1] ? $3c37a6a9a4cce4d8$var$H : "@" === e[1] ? $3c37a6a9a4cce4d8$var$I : $3c37a6a9a4cce4d8$var$R
                    }), r.removeAttribute(t);
                } else t.startsWith($3c37a6a9a4cce4d8$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($3c37a6a9a4cce4d8$var$$.test(r.tagName)) {
                    const t = r.textContent.split($3c37a6a9a4cce4d8$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $3c37a6a9a4cce4d8$var$i ? $3c37a6a9a4cce4d8$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $3c37a6a9a4cce4d8$var$l()), $3c37a6a9a4cce4d8$var$E.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $3c37a6a9a4cce4d8$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $3c37a6a9a4cce4d8$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($3c37a6a9a4cce4d8$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $3c37a6a9a4cce4d8$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $3c37a6a9a4cce4d8$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $3c37a6a9a4cce4d8$var$N(t, i, s = t, e) {
    if (i === $3c37a6a9a4cce4d8$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $3c37a6a9a4cce4d8$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $3c37a6a9a4cce4d8$var$N(t, h._$AS(t, i.values), h, e)), i;
}
class $3c37a6a9a4cce4d8$var$S {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $3c37a6a9a4cce4d8$var$r).importNode(i, !0);
        $3c37a6a9a4cce4d8$var$E.currentNode = e;
        let h = $3c37a6a9a4cce4d8$var$E.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $3c37a6a9a4cce4d8$var$M(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $3c37a6a9a4cce4d8$var$L(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $3c37a6a9a4cce4d8$var$E.nextNode(), o++);
        }
        return $3c37a6a9a4cce4d8$var$E.currentNode = $3c37a6a9a4cce4d8$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $3c37a6a9a4cce4d8$var$M {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $3c37a6a9a4cce4d8$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $3c37a6a9a4cce4d8$var$N(this, t, i), $3c37a6a9a4cce4d8$var$c(t) ? t === $3c37a6a9a4cce4d8$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $3c37a6a9a4cce4d8$export$45b790e32b2810ee && this._$AR(), this._$AH = $3c37a6a9a4cce4d8$export$45b790e32b2810ee) : t !== this._$AH && t !== $3c37a6a9a4cce4d8$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $3c37a6a9a4cce4d8$var$u(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $3c37a6a9a4cce4d8$export$45b790e32b2810ee && $3c37a6a9a4cce4d8$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.$($3c37a6a9a4cce4d8$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $3c37a6a9a4cce4d8$var$V.createElement($3c37a6a9a4cce4d8$var$C(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $3c37a6a9a4cce4d8$var$S(e, this), s = t.u(this.options);
            t.p(i), this.$(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $3c37a6a9a4cce4d8$var$A.get(t.strings);
        return void 0 === i && $3c37a6a9a4cce4d8$var$A.set(t.strings, i = new $3c37a6a9a4cce4d8$var$V(t)), i;
    }
    T(t) {
        $3c37a6a9a4cce4d8$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $3c37a6a9a4cce4d8$var$M(this.k($3c37a6a9a4cce4d8$var$l()), this.k($3c37a6a9a4cce4d8$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $3c37a6a9a4cce4d8$var$R {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $3c37a6a9a4cce4d8$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $3c37a6a9a4cce4d8$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $3c37a6a9a4cce4d8$var$N(this, t, i, 0), o = !$3c37a6a9a4cce4d8$var$c(t) || t !== this._$AH && t !== $3c37a6a9a4cce4d8$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $3c37a6a9a4cce4d8$var$N(this, e[s + n], i, n), r === $3c37a6a9a4cce4d8$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$3c37a6a9a4cce4d8$var$c(r) || r !== this._$AH[n], r === $3c37a6a9a4cce4d8$export$45b790e32b2810ee ? t = $3c37a6a9a4cce4d8$export$45b790e32b2810ee : t !== $3c37a6a9a4cce4d8$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.O(t);
    }
    O(t) {
        t === $3c37a6a9a4cce4d8$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $3c37a6a9a4cce4d8$var$k extends $3c37a6a9a4cce4d8$var$R {
    constructor(){
        super(...arguments), this.type = 3;
    }
    O(t) {
        this.element[this.name] = t === $3c37a6a9a4cce4d8$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $3c37a6a9a4cce4d8$var$H extends $3c37a6a9a4cce4d8$var$R {
    constructor(){
        super(...arguments), this.type = 4;
    }
    O(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $3c37a6a9a4cce4d8$export$45b790e32b2810ee);
    }
}
class $3c37a6a9a4cce4d8$var$I extends $3c37a6a9a4cce4d8$var$R {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $3c37a6a9a4cce4d8$var$N(this, t, i, 0) ?? $3c37a6a9a4cce4d8$export$45b790e32b2810ee) === $3c37a6a9a4cce4d8$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $3c37a6a9a4cce4d8$export$45b790e32b2810ee && s !== $3c37a6a9a4cce4d8$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $3c37a6a9a4cce4d8$export$45b790e32b2810ee && (s === $3c37a6a9a4cce4d8$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $3c37a6a9a4cce4d8$var$L {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $3c37a6a9a4cce4d8$var$N(this, t);
    }
}
const $3c37a6a9a4cce4d8$export$8613d1ca9052b22e = {
    j: $3c37a6a9a4cce4d8$var$e,
    P: $3c37a6a9a4cce4d8$var$h,
    A: $3c37a6a9a4cce4d8$var$o,
    C: 1,
    M: $3c37a6a9a4cce4d8$var$P,
    L: $3c37a6a9a4cce4d8$var$S,
    R: $3c37a6a9a4cce4d8$var$u,
    V: $3c37a6a9a4cce4d8$var$N,
    D: $3c37a6a9a4cce4d8$var$M,
    I: $3c37a6a9a4cce4d8$var$R,
    H: $3c37a6a9a4cce4d8$var$H,
    N: $3c37a6a9a4cce4d8$var$I,
    U: $3c37a6a9a4cce4d8$var$k,
    B: $3c37a6a9a4cce4d8$var$L
}, $3c37a6a9a4cce4d8$var$Z = $3c37a6a9a4cce4d8$var$t.litHtmlPolyfillSupport;
$3c37a6a9a4cce4d8$var$Z?.($3c37a6a9a4cce4d8$var$V, $3c37a6a9a4cce4d8$var$M), ($3c37a6a9a4cce4d8$var$t.litHtmlVersions ??= []).push("3.1.1");
const $3c37a6a9a4cce4d8$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $3c37a6a9a4cce4d8$var$M(i.insertBefore($3c37a6a9a4cce4d8$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $b32aec94b1c85015$export$3f2f9f5909897157 extends (0, $5c1f81a423d5b637$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $3c37a6a9a4cce4d8$export$b3890eb0ae9dca99)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $3c37a6a9a4cce4d8$export$9c068ae9cc5db4e8;
    }
}
$b32aec94b1c85015$export$3f2f9f5909897157._$litElement$ = !0, $b32aec94b1c85015$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $b32aec94b1c85015$export$3f2f9f5909897157
});
const $b32aec94b1c85015$var$r = globalThis.litElementPolyfillSupport;
$b32aec94b1c85015$var$r?.({
    LitElement: $b32aec94b1c85015$export$3f2f9f5909897157
});
const $b32aec94b1c85015$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.0.3");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8df67245738b7c19$export$6acf61af03e62db = !1;





var $MPA2U = parcelRequire("MPA2U");
// see https://github.com/danfinlay/jazzicon
var $848e8f2059b51b3f$exports = {};
/*
  https://github.com/banksean wrapped Makoto Matsumoto and Takuji Nishimura's code in a namespace
  so it's better encapsulated. Now you can have multiple random number generators
  and they won't stomp all over eachother's state.

  If you want to use this as a substitute for Math.random(), use the random()
  method like so:

  var m = new MersenneTwister();
  var randomNumber = m.random();

  You can also call the other genrand_{foo}() methods on the instance.

  If you want to use a specific seed in order to get a repeatable random
  sequence, pass an integer into the constructor:

  var m = new MersenneTwister(123);

  and that will always produce the same random sequence.

  Sean McCullough (banksean@gmail.com)
*/ /*
   A C-program for MT19937, with initialization improved 2002/1/26.
   Coded by Takuji Nishimura and Makoto Matsumoto.

   Before using, initialize the state by using init_seed(seed)
   or init_by_array(init_key, key_length).

   Copyright (C) 1997 - 2002, Makoto Matsumoto and Takuji Nishimura,
   All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions
   are met:

     1. Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer.

     2. Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution.

     3. The names of its contributors may not be used to endorse or promote
        products derived from this software without specific prior written
        permission.

   THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
   "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
   LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
   A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR
   CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
   EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
   PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
   PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
   SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.


   Any feedback is very welcome.
   http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/emt.html
   email: m-mat @ math.sci.hiroshima-u.ac.jp (remove space)
*/ var $848e8f2059b51b3f$var$MersenneTwister = function(seed) {
    if (seed == undefined) seed = new Date().getTime();
    /* Period parameters */ this.N = 624;
    this.M = 397;
    this.MATRIX_A = 0x9908b0df; /* constant vector a */ 
    this.UPPER_MASK = 0x80000000; /* most significant w-r bits */ 
    this.LOWER_MASK = 0x7fffffff; /* least significant r bits */ 
    this.mt = new Array(this.N); /* the array for the state vector */ 
    this.mti = this.N + 1; /* mti==N+1 means mt[N] is not initialized */ 
    if (seed.constructor == Array) this.init_by_array(seed, seed.length);
    else this.init_seed(seed);
};
/* initializes mt[N] with a seed */ /* origin name init_genrand */ $848e8f2059b51b3f$var$MersenneTwister.prototype.init_seed = function(s) {
    this.mt[0] = s >>> 0;
    for(this.mti = 1; this.mti < this.N; this.mti++){
        var s = this.mt[this.mti - 1] ^ this.mt[this.mti - 1] >>> 30;
        this.mt[this.mti] = (((s & 0xffff0000) >>> 16) * 1812433253 << 16) + (s & 0x0000ffff) * 1812433253 + this.mti;
        /* See Knuth TAOCP Vol2. 3rd Ed. P.106 for multiplier. */ /* In the previous versions, MSBs of the seed affect   */ /* only MSBs of the array mt[].                        */ /* 2002/01/09 modified by Makoto Matsumoto             */ this.mt[this.mti] >>>= 0;
    /* for >32 bit machines */ }
};
/* initialize by an array with array-length */ /* init_key is the array for initializing keys */ /* key_length is its length */ /* slight change for C++, 2004/2/26 */ $848e8f2059b51b3f$var$MersenneTwister.prototype.init_by_array = function(init_key, key_length) {
    var i, j, k;
    this.init_seed(19650218);
    i = 1;
    j = 0;
    k = this.N > key_length ? this.N : key_length;
    for(; k; k--){
        var s = this.mt[i - 1] ^ this.mt[i - 1] >>> 30;
        this.mt[i] = (this.mt[i] ^ (((s & 0xffff0000) >>> 16) * 1664525 << 16) + (s & 0x0000ffff) * 1664525) + init_key[j] + j; /* non linear */ 
        this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */ 
        i++;
        j++;
        if (i >= this.N) {
            this.mt[0] = this.mt[this.N - 1];
            i = 1;
        }
        if (j >= key_length) j = 0;
    }
    for(k = this.N - 1; k; k--){
        var s = this.mt[i - 1] ^ this.mt[i - 1] >>> 30;
        this.mt[i] = (this.mt[i] ^ (((s & 0xffff0000) >>> 16) * 1566083941 << 16) + (s & 0x0000ffff) * 1566083941) - i; /* non linear */ 
        this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */ 
        i++;
        if (i >= this.N) {
            this.mt[0] = this.mt[this.N - 1];
            i = 1;
        }
    }
    this.mt[0] = 0x80000000; /* MSB is 1; assuring non-zero initial array */ 
};
/* generates a random number on [0,0xffffffff]-interval */ /* origin name genrand_int32 */ $848e8f2059b51b3f$var$MersenneTwister.prototype.random_int = function() {
    var y;
    var mag01 = new Array(0x0, this.MATRIX_A);
    /* mag01[x] = x * MATRIX_A  for x=0,1 */ if (this.mti >= this.N) {
        var kk;
        if (this.mti == this.N + 1) /* if init_seed() has not been called, */ this.init_seed(5489); /* a default initial seed is used */ 
        for(kk = 0; kk < this.N - this.M; kk++){
            y = this.mt[kk] & this.UPPER_MASK | this.mt[kk + 1] & this.LOWER_MASK;
            this.mt[kk] = this.mt[kk + this.M] ^ y >>> 1 ^ mag01[y & 0x1];
        }
        for(; kk < this.N - 1; kk++){
            y = this.mt[kk] & this.UPPER_MASK | this.mt[kk + 1] & this.LOWER_MASK;
            this.mt[kk] = this.mt[kk + (this.M - this.N)] ^ y >>> 1 ^ mag01[y & 0x1];
        }
        y = this.mt[this.N - 1] & this.UPPER_MASK | this.mt[0] & this.LOWER_MASK;
        this.mt[this.N - 1] = this.mt[this.M - 1] ^ y >>> 1 ^ mag01[y & 0x1];
        this.mti = 0;
    }
    y = this.mt[this.mti++];
    /* Tempering */ y ^= y >>> 11;
    y ^= y << 7 & 0x9d2c5680;
    y ^= y << 15 & 0xefc60000;
    y ^= y >>> 18;
    return y >>> 0;
};
/* generates a random number on [0,0x7fffffff]-interval */ /* origin name genrand_int31 */ $848e8f2059b51b3f$var$MersenneTwister.prototype.random_int31 = function() {
    return this.random_int() >>> 1;
};
/* generates a random number on [0,1]-real-interval */ /* origin name genrand_real1 */ $848e8f2059b51b3f$var$MersenneTwister.prototype.random_incl = function() {
    return this.random_int() * (1.0 / 4294967295.0);
/* divided by 2^32-1 */ };
/* generates a random number on [0,1)-real-interval */ $848e8f2059b51b3f$var$MersenneTwister.prototype.random = function() {
    return this.random_int() * (1.0 / 4294967296.0);
/* divided by 2^32 */ };
/* generates a random number on (0,1)-real-interval */ /* origin name genrand_real3 */ $848e8f2059b51b3f$var$MersenneTwister.prototype.random_excl = function() {
    return (this.random_int() + 0.5) * (1.0 / 4294967296.0);
/* divided by 2^32 */ };
/* generates a random number on [0,1) with 53-bit resolution*/ /* origin name genrand_res53 */ $848e8f2059b51b3f$var$MersenneTwister.prototype.random_long = function() {
    var a = this.random_int() >>> 5, b = this.random_int() >>> 6;
    return (a * 67108864.0 + b) * (1.0 / 9007199254740992.0);
};
/* These real versions are due to Isaku Wada, 2002/01/09 added */ $848e8f2059b51b3f$exports = $848e8f2059b51b3f$var$MersenneTwister;


const $996d4253cce63a49$var$defaultColors = [
    "rgb(244, 67, 54)",
    "rgb(233, 30, 99)",
    "rgb(156, 39, 176)",
    "rgb(103, 58, 183)",
    "rgb(63, 81, 181)",
    "rgb(33, 150, 243)",
    "rgb(3, 169, 244)",
    "rgb(0, 188, 212)",
    "rgb(0, 150, 136)",
    "rgb(76, 175, 80)",
    "rgb(139, 195, 74)",
    "rgb(205, 220, 57)",
    "rgb(255, 193, 7)",
    "rgb(255, 152, 0)",
    "rgb(255, 87, 34)"
];
const $996d4253cce63a49$var$hash = function(str) {
    if (str.length === 0) return 0;
    let h = 0;
    for(let i = 0; i < str.length; i++){
        h = h * 31 + str.charCodeAt(i);
        h = h % Math.pow(2, 32);
    }
    return h;
};
function $996d4253cce63a49$export$b0087c2ddf61a5e6(content, colors) {
    colors = colors || $996d4253cce63a49$var$defaultColors;
    const seed = $996d4253cce63a49$var$hash(content);
    const rand = new $848e8f2059b51b3f$exports(seed);
    colors = colors.slice();
    const genColor = ()=>{
        const idx = Math.floor(colors.length * rand.random());
        return colors.splice(idx, 1)[0];
    };
    const bgStr = `<rect fill="${genColor()}" width="100" height="100"/>`;
    const style = `<style>.picasso circle{mix-blend-mode:soft-light;}</style>`;
    let shapesStr = "";
    const layers = 3;
    const rs = [
        35,
        40,
        45,
        50,
        55,
        60
    ];
    const cxs = [
        0,
        10,
        20,
        30,
        40,
        50,
        60,
        70,
        80,
        90,
        100
    ];
    const cys = [
        30,
        40,
        50,
        60,
        70
    ];
    for(let i = 0; i < layers; i++){
        const r = rs.splice(Math.floor(rs.length * rand.random()), 1)[0];
        const cx = cxs.splice(Math.floor(cxs.length * rand.random()), 1)[0];
        const cy = cys.splice(Math.floor(cys.length * rand.random()), 1)[0];
        const fill = genColor();
        shapesStr += `<circle r="${r}" cx="${cx}" cy="${cy}" fill="${fill}"/>`;
    }
    return `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" class="picasso" width="100" height="100" viewBox="0 0 100 100">${style}${bgStr}${shapesStr}</svg>`;
}
var $996d4253cce63a49$export$2e2bcd8739ae039 = $996d4253cce63a49$export$b0087c2ddf61a5e6;



var $7etJZ = parcelRequire("7etJZ");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3624e2f028ed96c5$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $890353e55d13ed29$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $5c1f81a423d5b637$export$7312b35fbf521afb),
    reflect: !1,
    hasChanged: (0, $5c1f81a423d5b637$export$53a6892c50694894)
}, $890353e55d13ed29$export$8d623b1670eb40f4 = (t = $890353e55d13ed29$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.C(o, void 0, t), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $890353e55d13ed29$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $890353e55d13ed29$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? {
                ...t,
                wrapped: !0
            } : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $25792ed7cdb3810b$export$ca000e230c0caa3e(r) {
    return (0, $890353e55d13ed29$export$d541bacb2bda4494)({
        ...r,
        state: !0,
        attribute: !1
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $5808993fd5d9b3ee$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ede2ebf697141e73$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $1789597cada8212d$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $ede2ebf697141e73$export$51987bb50e1f6752)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $ede2ebf697141e73$export$51987bb50e1f6752)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $489aeb042bbc0611$var$e;
function $489aeb042bbc0611$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $ede2ebf697141e73$export$51987bb50e1f6752)(n, o, {
            get () {
                return (this.renderRoot ?? ($489aeb042bbc0611$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $716a5d6e9e82e99d$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $ede2ebf697141e73$export$51987bb50e1f6752)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $186e1dd026d2d66d$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $ede2ebf697141e73$export$51987bb50e1f6752)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $5cd96ec128ec5d7f$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $ede2ebf697141e73$export$51987bb50e1f6752)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}





var $6ZWSX = parcelRequire("6ZWSX");
var $ade5618b9d1e8b58$require$Buffer = $6ZWSX.Buffer;
var $ade5618b9d1e8b58$var$Ie = Object.defineProperty;
var $ade5618b9d1e8b58$var$Oe = Object.getOwnPropertyDescriptor;
var $ade5618b9d1e8b58$var$e = (t, r, A, g)=>{
    for(var v = g > 1 ? void 0 : g ? $ade5618b9d1e8b58$var$Oe(r, A) : r, s = t.length - 1, i; s >= 0; s--)(i = t[s]) && (v = (g ? i(r, A, v) : i(v)) || v);
    return g && v && $ade5618b9d1e8b58$var$Ie(r, A, v), v;
};
var $ade5618b9d1e8b58$var$Me = .1, $ade5618b9d1e8b58$var$PA = 2.5, $ade5618b9d1e8b58$var$W = 7;
function $ade5618b9d1e8b58$var$LA(t, r, A) {
    return t === r ? !1 : (t - r < 0 ? r - t : t - r) <= A + $ade5618b9d1e8b58$var$Me;
}
function $ade5618b9d1e8b58$var$xe(t, r) {
    let A = Array.prototype.slice.call((0, (/*@__PURE__*/$parcel$interopDefault($MPA2U))).create(t, {
        errorCorrectionLevel: r
    }).modules.data, 0), g = Math.sqrt(A.length);
    return A.reduce((v, s, i)=>(i % g === 0 ? v.push([
            s
        ]) : v[v.length - 1].push(s)) && v, []);
}
var $ade5618b9d1e8b58$export$2faef7998946735 = {
    generate ({ uri: t, size: r, logoSize: A, dotColor: g, edgeColor: v }) {
        let s = [], i = $ade5618b9d1e8b58$var$xe(t, "Q"), d = r / i.length, rA = [
            {
                x: 0,
                y: 0
            },
            {
                x: 1,
                y: 0
            },
            {
                x: 0,
                y: 1
            }
        ];
        rA.forEach(({ x: l, y: f })=>{
            let C = (i.length - $ade5618b9d1e8b58$var$W) * d * l, a = (i.length - $ade5618b9d1e8b58$var$W) * d * f, L = .45;
            for(let P = 0; P < rA.length; P += 1){
                let Y = d * ($ade5618b9d1e8b58$var$W - P * 2);
                s.push((0, $3c37a6a9a4cce4d8$export$7ed1367e7fa1ad68)`
            <rect
              fill=${P % 2 === 0 ? g : v}
              height=${Y}
              rx=${Y * L}
              ry=${Y * L}
              width=${Y}
              x=${C + d * P}
              y=${a + d * P}
            />
          `);
            }
        });
        let yA = Math.floor((A + 25) / d), FA = i.length / 2 - yA / 2, IA = i.length / 2 + yA / 2 - 1, OA = [];
        i.forEach((l, f)=>{
            l.forEach((C, a)=>{
                if (i[f][a] && !(f < $ade5618b9d1e8b58$var$W && a < $ade5618b9d1e8b58$var$W || f > i.length - ($ade5618b9d1e8b58$var$W + 1) && a < $ade5618b9d1e8b58$var$W || f < $ade5618b9d1e8b58$var$W && a > i.length - ($ade5618b9d1e8b58$var$W + 1)) && !(f > FA && f < IA && a > FA && a < IA)) {
                    let L = f * d + d / 2, P = a * d + d / 2;
                    OA.push([
                        L,
                        P
                    ]);
                }
            });
        });
        let J = {};
        return OA.forEach(([l, f])=>{
            J[l] ? J[l].push(f) : J[l] = [
                f
            ];
        }), Object.entries(J).map(([l, f])=>{
            let C = f.filter((a)=>f.every((L)=>!$ade5618b9d1e8b58$var$LA(a, L, d)));
            return [
                Number(l),
                C
            ];
        }).forEach(([l, f])=>{
            f.forEach((C)=>{
                s.push((0, $3c37a6a9a4cce4d8$export$7ed1367e7fa1ad68)`<circle cx=${l} cy=${C} fill=${g} r=${d / $ade5618b9d1e8b58$var$PA} />`);
            });
        }), Object.entries(J).filter(([l, f])=>f.length > 1).map(([l, f])=>{
            let C = f.filter((a)=>f.some((L)=>$ade5618b9d1e8b58$var$LA(a, L, d)));
            return [
                Number(l),
                C
            ];
        }).map(([l, f])=>{
            f.sort((a, L)=>a < L ? -1 : 1);
            let C = [];
            for (let a of f){
                let L = C.find((P)=>P.some((Y)=>$ade5618b9d1e8b58$var$LA(a, Y, d)));
                L ? L.push(a) : C.push([
                    a
                ]);
            }
            return [
                l,
                C.map((a)=>[
                        a[0],
                        a[a.length - 1]
                    ])
            ];
        }).forEach(([l, f])=>{
            f.forEach(([C, a])=>{
                s.push((0, $3c37a6a9a4cce4d8$export$7ed1367e7fa1ad68)`
              <line
                x1=${l}
                x2=${l}
                y1=${C}
                y2=${a}
                stroke=${g}
                stroke-width=${d / ($ade5618b9d1e8b58$var$PA / 2)}
                stroke-linecap="round"
              />
            `);
            });
        }), s;
    }
};
var $ade5618b9d1e8b58$export$58024eed5b2c3194 = (t)=>{
    window.addEventListener("load", t, !1), window.addEventListener("resize", t, !1);
};
var $ade5618b9d1e8b58$export$fb20829f6af70575 = (t, r)=>{
    (0, $4b665efddc7cd9c8$export$4269407eefc1557b).debug("dispatchCustomEvent", t, r);
    let A = new CustomEvent(t, {
        detail: r
    });
    dispatchEvent(A);
}, $ade5618b9d1e8b58$export$2c6be09446e54dfb = (t, r)=>{
    (0, $4b665efddc7cd9c8$export$4269407eefc1557b).debug("subscribeToCustomEvent", t);
    let A = (g)=>{
        r?.(g.detail);
    };
    return addEventListener(t, A), ()=>{
        removeEventListener(t, A);
    };
};
var $ade5618b9d1e8b58$export$d0a8044dce8ff2fc = ()=>{
    let t = navigator.userAgent || navigator.vendor || window.opera;
    return !!(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0, 4)));
}, $ade5618b9d1e8b58$export$a11b0059900ceec8 = ()=>{
    let t = navigator.userAgent || navigator.vendor || window.opera;
    return /android/i.test(t);
};
var $ade5618b9d1e8b58$export$1ebcfac7b0929fc6 = (t, r)=>(A)=>t?.[r]?.[A] || t?.en?.[A] || A;
var $ade5618b9d1e8b58$export$82aa6a7146c28036 = (t, r = !1)=>{
    let A = (0, $996d4253cce63a49$export$b0087c2ddf61a5e6)(t.toLowerCase());
    return r ? `data:image/svg+xml;base64,${$ade5618b9d1e8b58$require$Buffer.from(A, "utf8").toString("base64")}` : `data:image/svg+xml;utf8,${A}`;
}, $ade5618b9d1e8b58$export$6ace02e31606896d = (t, r = 6, A = 4)=>{
    let g = t.substring(0, r), v = t.substring(t.length - A);
    return `${g}\u2022\u2022\u2022\u2022${v}`;
};
var $ade5618b9d1e8b58$export$c537fa0d021d010b = {
    WalletConnectBlue: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`#3496ff`,
    Dark: {
        Primary: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`#404040`,
        PrimaryHover: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`#454545`,
        PrimaryActive: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`#4a4a4a`,
        Secondary: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`#2a2a2a`,
        Tertiary: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`#ffffff`,
        Quaternary: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`#888888`
    },
    Light: {
        Primary: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`#f2f2f2`,
        PrimaryHover: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`#eeeeee`,
        PrimaryActive: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`#eaeaea`,
        Secondary: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`#ffffff`,
        Tertiary: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`#2a2a2a`,
        Quaternary: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`#747474`
    }
};
var $ade5618b9d1e8b58$var$HA = `data:image/png;base64,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
`;
var $ade5618b9d1e8b58$var$zA = "data:image/png;base64,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";
var $ade5618b9d1e8b58$var$EA = `data:image/png;base64,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
`;
var $ade5618b9d1e8b58$var$nA = "data:image/png;base64,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";
var $ade5618b9d1e8b58$export$771a7e037f0b0496 = {
    "wallet-connect": {
        id: "wallet-connect",
        name: "Wallet Connect",
        logo: $ade5618b9d1e8b58$var$EA
    },
    veworld: {
        id: "veworld",
        name: "VeWorld",
        logo: $ade5618b9d1e8b58$var$nA
    },
    sync: {
        id: "sync",
        name: "Sync",
        logo: $ade5618b9d1e8b58$var$HA
    },
    sync2: {
        id: "sync2",
        name: "Sync 2",
        logo: $ade5618b9d1e8b58$var$zA
    }
};
var $ade5618b9d1e8b58$export$114247090b0aae30 = {
    Mobile: 500,
    Tablet: 800
};
var $ade5618b9d1e8b58$export$598805d34b49672 = "https://apps.apple.com/it/app/veworld/id6446854569", $ade5618b9d1e8b58$export$c73908b448db79b5 = "https://play.google.com/store/apps/details?id=org.vechain.veworld.app";
var $ade5618b9d1e8b58$export$a70b275c6c14fce = (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`'Inter', sans-serif`, $ade5618b9d1e8b58$export$89abf52a030e56ee = {
    Family: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`'Inter', sans-serif`,
    Size: {
        Small: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`12px`,
        Medium: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`14px`,
        Large: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`18px`
    },
    Weight: {
        Regular: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`400`,
        Medium: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`500`
    }
};
var $ade5618b9d1e8b58$export$a497cb29076adb1d = {
    en: {
        "connect-wallet": "Connect Wallet",
        "copy-to-clipboard": "Copy to Clipboard",
        connected: "Connected",
        disconnect: "Disconnect",
        "opening-veworld": "Opening VeWorld...",
        "get-veworld": "Get VeWorld",
        "sign-connection-certificate-button": "Sign Certificate",
        "sign-connection-certificate-description": "Proof address is required, please sign a certificate to continue",
        "waiting-signature": "Waiting for signature..."
    },
    it: {
        "connect-wallet": "Connetti il Wallet",
        "copy-to-clipboard": "Copia",
        connected: "Connesso",
        disconnect: "Disconnetti",
        "opening-veworld": "Apertura di VeWorld...",
        "get-veworld": "Ottieni VeWorld",
        "sign-connection-certificate-button": "Firma Certificato",
        "sign-connection-certificate-description": "\xc8 richiesta una firma di certificato per connettersi al wallet.",
        "waiting-signature": "Attendo firma..."
    },
    fr: {
        "connect-wallet": "Connecter le portefeuille",
        "copy-to-clipboard": "Copier dans le presse-papiers",
        connected: "Connect\xe9",
        disconnect: "D\xe9connecter",
        "opening-veworld": "Ouverture de VeWorld...",
        "get-veworld": "Obtenir VeWorld",
        "sign-connection-certificate-description": "Une signature de certificat est requise pour se connecter au portefeuille.",
        "sign-connection-certificate-button": "Signer le certificat",
        "waiting-signature": "En attente de la signature..."
    },
    es: {
        "connect-wallet": "Conectar billetera",
        "copy-to-clipboard": "Copiar al portapapeles",
        connected: "Conectado",
        disconnect: "Desconectar",
        "opening-veworld": "Abriendo VeWorld...",
        "get-veworld": "Obtener VeWorld",
        "sign-connection-certificate-description": "Se requiere una firma de certificado para conectarse a la billetera.",
        "sign-connection-certificate-button": "Firmar certificado",
        "waiting-signature": "Esperando firma..."
    },
    de: {
        "connect-wallet": "Wallet verbinden",
        "copy-to-clipboard": "In Zwischenablage kopieren",
        connected: "Verbunden",
        disconnect: "Trennen",
        "opening-veworld": "VeWorld wird ge\xf6ffnet...",
        "get-veworld": "VeWorld erhalten",
        "sign-connection-certificate-description": "Eine Zertifikatssignatur ist erforderlich, um eine Verbindung zur Brieftasche herzustellen.",
        "sign-connection-certificate-button": "Zertifikat signieren",
        "waiting-signature": "Warte auf Signatur..."
    },
    zh: {
        "connect-wallet": "\u8FDE\u63A5\u94B1\u5305",
        "copy-to-clipboard": "\u590D\u5236\u5230\u526A\u8D34\u677F",
        connected: "\u5DF2\u8FDE\u63A5",
        disconnect: "\u65AD\u5F00\u8FDE\u63A5",
        "opening-veworld": "\u6B63\u5728\u6253\u5F00 VeWorld...",
        "get-veworld": "\u83B7\u53D6 VeWorld",
        "sign-connection-certificate-description": "\u8FDE\u63A5\u94B1\u5305\u9700\u8981\u7B7E\u540D\u8BC1\u4E66\u3002",
        "sign-connection-certificate-button": "\u7B7E\u540D\u8BC1\u4E66",
        "waiting-signature": "\u7B49\u5F85\u7B7E\u540D..."
    },
    ja: {
        "connect-wallet": "\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u63A5\u7D9A",
        "copy-to-clipboard": "\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC",
        connected: "\u63A5\u7D9A\u3055\u308C\u307E\u3057\u305F",
        disconnect: "\u5207\u65AD\u3059\u308B",
        "opening-veworld": "VeWorld \u3092\u958B\u3044\u3066\u3044\u307E\u3059...",
        "get-veworld": "VeWorld \u3092\u53D6\u5F97",
        "sign-connection-certificate-description": "\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u63A5\u7D9A\u3059\u308B\u306B\u306F\u8A3C\u660E\u66F8\u306E\u7F72\u540D\u304C\u5FC5\u8981\u3067\u3059\u3002",
        "sign-connection-certificate-button": "\u8A3C\u660E\u66F8\u306B\u7F72\u540D",
        "waiting-signature": "\u7F72\u540D\u3092\u5F85\u3063\u3066\u3044\u307E\u3059..."
    },
    ru: {
        "connect-wallet": "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        "copy-to-clipboard": "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430",
        connected: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
        disconnect: "\u041E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C",
        "opening-veworld": "\u041E\u0442\u043A\u0440\u044B\u0442\u0438\u0435 VeWorld...",
        "get-veworld": "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C VeWorld",
        "sign-connection-certificate-description": "\u0414\u043B\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u043A \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443 \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u043F\u043E\u0434\u043F\u0438\u0441\u044C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430.",
        "sign-connection-certificate-button": "\u041F\u043E\u0434\u043F\u0438\u0441\u0430\u0442\u044C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442",
        "waiting-signature": "\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u043F\u043E\u0434\u043F\u0438\u0441\u0438..."
    }
};
var $ade5618b9d1e8b58$export$24c540328f957d31 = 100, $ade5618b9d1e8b58$export$e14b98b50e1f2d1e = (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`blur(2px)`, $ade5618b9d1e8b58$export$90043f08d14c91b3 = (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`350px`;
var $ade5618b9d1e8b58$export$9509a5d0b3cb9709 = "https://www.veworld.com/discover/browser/ul/";
var $ade5618b9d1e8b58$export$3ca97b21cbdba72c = {
    Light: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`none`,
    Dark: (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`none`
};
var $ade5618b9d1e8b58$var$We = ()=>document.querySelector("vdk-modal"), $ade5618b9d1e8b58$export$68bce50863fac51 = (t)=>{
    let r = $ade5618b9d1e8b58$var$We();
    if (r) return r;
    let A = document.createElement("vdk-modal");
    return (t?.modalParent ?? document.body).appendChild(A), A;
}, $ade5618b9d1e8b58$var$He = {
    "--vdk-color-dark-primary": $ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.Primary.toString(),
    "--vdk-color-dark-primary-hover": $ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.PrimaryHover.toString(),
    "--vdk-color-dark-primary-active": $ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.PrimaryActive.toString(),
    "--vdk-color-dark-secondary": $ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.Secondary.toString(),
    "--vdk-color-dark-tertiary": $ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.Tertiary.toString(),
    "--vdk-color-dark-quaternary": $ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.Quaternary.toString(),
    "--vdk-color-light-primary": $ade5618b9d1e8b58$export$c537fa0d021d010b.Light.Primary.toString(),
    "--vdk-color-light-primary-hover": $ade5618b9d1e8b58$export$c537fa0d021d010b.Light.PrimaryHover.toString(),
    "--vdk-color-light-primary-active": $ade5618b9d1e8b58$export$c537fa0d021d010b.Light.PrimaryActive.toString(),
    "--vdk-color-light-secondary": $ade5618b9d1e8b58$export$c537fa0d021d010b.Light.Secondary.toString(),
    "--vdk-color-light-tertiary": $ade5618b9d1e8b58$export$c537fa0d021d010b.Light.Tertiary.toString(),
    "--vdk-color-light-quaternary": $ade5618b9d1e8b58$export$c537fa0d021d010b.Light.Quaternary.toString(),
    "--vdk-color-walletconnectblue": $ade5618b9d1e8b58$export$c537fa0d021d010b.WalletConnectBlue.toString(),
    "--vdk-font-family": $ade5618b9d1e8b58$export$89abf52a030e56ee.Family.toString(),
    "--vdk-font-size-medium": $ade5618b9d1e8b58$export$89abf52a030e56ee.Size.Medium.toString(),
    "--vdk-font-size-large": $ade5618b9d1e8b58$export$89abf52a030e56ee.Size.Large.toString(),
    "--vdk-font-weight-medium": $ade5618b9d1e8b58$export$89abf52a030e56ee.Weight.Medium.toString(),
    "--vdk-modal-z-index": $ade5618b9d1e8b58$export$24c540328f957d31.toString(),
    "--vdk-modal-backdrop-filter": $ade5618b9d1e8b58$export$e14b98b50e1f2d1e.toString(),
    "--vdk-modal-width": $ade5618b9d1e8b58$export$90043f08d14c91b3.toString(),
    "--vdk-border-light-source-card": $ade5618b9d1e8b58$export$3ca97b21cbdba72c.Light.toString(),
    "--vdk-border-dark-source-card": $ade5618b9d1e8b58$export$3ca97b21cbdba72c.Dark.toString()
}, $ade5618b9d1e8b58$export$9ac94d66e0989ce7 = (t)=>{
    let r = document.querySelector(":root");
    if (r) for (let [A, g] of Object.entries({
        ...$ade5618b9d1e8b58$var$He,
        ...t
    }))r.style.setProperty(A, g);
}, $ade5618b9d1e8b58$var$kA = (t)=>({
        mode: t.themeMode ?? "LIGHT",
        i18n: t.i18n ? {
            ...$ade5618b9d1e8b58$export$a497cb29076adb1d,
            ...t.i18n
        } : $ade5618b9d1e8b58$export$a497cb29076adb1d,
        language: t.language ?? "en"
    }), $ade5618b9d1e8b58$export$40f8640a65e1db50 = (t)=>{
    let r = document.querySelectorAll("vdk-button"), A = $ade5618b9d1e8b58$var$kA(t);
    r.forEach((g)=>{
        for (let [v, s] of Object.entries(A))s && (g[v] = s);
    });
}, $ade5618b9d1e8b58$export$60523367a7e10402 = (t)=>{
    let r = document.querySelector("vdk-modal"), A = $ade5618b9d1e8b58$var$kA(t);
    if (r) {
        for (let [g, v] of Object.entries(A))v && (r[g] = v);
        t.onSourceClick && (r.onSourceClick = t.onSourceClick);
    }
}, $ade5618b9d1e8b58$export$64f99b1b6d5fba69 = (t)=>{
    t.themeVariables && $ade5618b9d1e8b58$export$9ac94d66e0989ce7(t.themeVariables), $ade5618b9d1e8b58$export$40f8640a65e1db50(t), $ade5618b9d1e8b58$export$60523367a7e10402(t);
};
var $ade5618b9d1e8b58$var$G = class G {
    constructor(r, A){
        this.walletManager = r;
        $ade5618b9d1e8b58$export$68bce50863fac51(A);
    }
    static getInstance(r, A) {
        return G.instance || (G.instance = new G(r, A)), G.instance;
    }
    open() {
        (0, $4b665efddc7cd9c8$export$4269407eefc1557b).debug("ConnectModalManager", "opening the modal"), $ade5618b9d1e8b58$export$fb20829f6af70575("vdk-open-wallet-modal");
    }
    close() {
        (0, $4b665efddc7cd9c8$export$4269407eefc1557b).debug("ConnectModalManager", "closing the modal"), $ade5618b9d1e8b58$export$fb20829f6af70575("vdk-close-wallet-modal");
    }
    closeWalletConnect() {
        (0, $4b665efddc7cd9c8$export$4269407eefc1557b).debug("ConnectModalManager", "closing wallet connect"), $ade5618b9d1e8b58$export$fb20829f6af70575("vdk-close-wc-qrcode");
    }
    closeConnectionCertificateRequest() {
        (0, $4b665efddc7cd9c8$export$4269407eefc1557b).debug("ConnectModalManager", "closing connection certificate request"), $ade5618b9d1e8b58$export$fb20829f6af70575("vdk-close-connection-certificate-request");
    }
    onConnectionStatusChange(r) {
        return (0, $cae0866804f4505b$export$7faad7f6b3708314)(this.walletManager.state, "address", (A)=>{
            r(A);
        });
    }
    onWalletSelected(r) {
        return (0, $cae0866804f4505b$export$7faad7f6b3708314)(this.walletManager.state, "source", (A)=>{
            r(A);
        });
    }
};
$ade5618b9d1e8b58$var$G.instance = null;
var $ade5618b9d1e8b58$export$3af51259be85f379 = $ade5618b9d1e8b58$var$G;
var $ade5618b9d1e8b58$var$QA = "vdk-modal-state-change", $ade5618b9d1e8b58$var$j = class j {
    constructor(){
        this.eventEmitter = new (0, $7etJZ.EventEmitter);
        $ade5618b9d1e8b58$export$2c6be09446e54dfb("vdk-close-wc-qrcode", ()=>{
            this.updateModalState({
                open: !1
            });
        }), $ade5618b9d1e8b58$export$2c6be09446e54dfb("vdk-open-wc-qrcode", ()=>{
            this.updateModalState({
                open: !0
            });
        });
    }
    static getInstance() {
        return j.instance || (j.instance = new j), j.instance;
    }
    openModal(r) {
        return (0, $4b665efddc7cd9c8$export$4269407eefc1557b).debug("CustomWalletConnectModal", "opening the wc modal"), $ade5618b9d1e8b58$export$fb20829f6af70575("vdk-open-wc-qrcode", r), Promise.resolve();
    }
    closeModal() {
        (0, $4b665efddc7cd9c8$export$4269407eefc1557b).debug("CustomWalletConnectModal", "closing the modal"), $ade5618b9d1e8b58$export$fb20829f6af70575("vdk-close-wc-qrcode");
    }
    askForConnectionCertificate() {
        (0, $4b665efddc7cd9c8$export$4269407eefc1557b).debug("CustomWalletConnectModal", "ask for connection certificate"), $ade5618b9d1e8b58$export$fb20829f6af70575("vdk-close-wc-qrcode"), $ade5618b9d1e8b58$export$fb20829f6af70575("vdk-request-connection-certificate");
    }
    onConnectionCertificateSigned() {
        (0, $4b665efddc7cd9c8$export$4269407eefc1557b).debug("CustomWalletConnectModal", "connection certificate signed"), $ade5618b9d1e8b58$export$fb20829f6af70575("vdk-close-wallet-modal"), $ade5618b9d1e8b58$export$fb20829f6af70575("vdk-close-wc-qrcode"), $ade5618b9d1e8b58$export$fb20829f6af70575("vdk-close-connection-certificate-request");
    }
    subscribeModal(r) {
        return (0, $4b665efddc7cd9c8$export$4269407eefc1557b).debug("CustomWalletConnectModal", "subscribing to modal state"), this.eventEmitter.on($ade5618b9d1e8b58$var$QA, r), ()=>{
            this.eventEmitter.off($ade5618b9d1e8b58$var$QA, r);
        };
    }
    updateModalState(r) {
        this.eventEmitter.emit($ade5618b9d1e8b58$var$QA, r);
    }
};
$ade5618b9d1e8b58$var$j.instance = null;
var $ade5618b9d1e8b58$export$9d6fe91dba3f26d5 = $ade5618b9d1e8b58$var$j;
var $ade5618b9d1e8b58$var$aA = null, $ade5618b9d1e8b58$var$pA = null, $ade5618b9d1e8b58$var$KA = !1, $ade5618b9d1e8b58$export$f660724a5e07d7a3 = {
    configure (t) {
        return t.walletConnectOptions && !t.walletConnectOptions.modal && (t.walletConnectOptions.modal = $ade5618b9d1e8b58$export$9d6fe91dba3f26d5.getInstance()), $ade5618b9d1e8b58$var$pA = t, $ade5618b9d1e8b58$var$aA = new (0, $4b665efddc7cd9c8$export$689c0902427b3cc0)(t), $ade5618b9d1e8b58$export$3af51259be85f379.getInstance(this.wallet, {
            modalParent: t.modalParent
        }), $ade5618b9d1e8b58$export$64f99b1b6d5fba69(t), $ade5618b9d1e8b58$export$fb20829f6af70575("vdk-dapp-kit-configured"), $ade5618b9d1e8b58$var$KA = !0, $ade5618b9d1e8b58$var$aA;
    },
    get initialized () {
        return $ade5618b9d1e8b58$var$KA;
    },
    get thor () {
        return this.get().thor;
    },
    get vendor () {
        return this.get().vendor;
    },
    get wallet () {
        return this.get().wallet;
    },
    get configuration () {
        return $ade5618b9d1e8b58$var$pA;
    },
    get modal () {
        return $ade5618b9d1e8b58$export$3af51259be85f379.getInstance(this.wallet, {
            modalParent: $ade5618b9d1e8b58$var$pA?.modalParent
        });
    },
    get () {
        if (!$ade5618b9d1e8b58$var$aA) throw console.error("\uD83D\uDEA8\uD83D\uDEA8\uD83D\uDEA8 DAppKitUI not configured \uD83D\uDEA8\uD83D\uDEA8\uD83D\uDEA8"), new Error("DAppKitUI not configured");
        return $ade5618b9d1e8b58$var$aA;
    }
};
var $ade5618b9d1e8b58$var$JA, $ade5618b9d1e8b58$export$353f5b6fc5456de1 = class extends (0, $b32aec94b1c85015$export$3f2f9f5909897157) {
    constructor(){
        super();
        this.mode = "LIGHT";
        this.i18n = $ade5618b9d1e8b58$export$a497cb29076adb1d;
        this.language = "en";
        this.address = "";
        this.accountDomain = "";
        this.isAccountDomainLoading = !1;
        this.disabled = !1;
        this.mobile = !1;
        $ade5618b9d1e8b58$export$f660724a5e07d7a3.initialized && this.configureButtonUI();
    }
    connectedCallback() {
        super.connectedCallback(), $ade5618b9d1e8b58$export$f660724a5e07d7a3.initialized && this.initAddressListener(), $ade5618b9d1e8b58$var$JA = $ade5618b9d1e8b58$export$2c6be09446e54dfb("vdk-dapp-kit-configured", ()=>{
            this.setAddressFromState(), this.initAddressListener();
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback(), $ade5618b9d1e8b58$var$JA?.();
    }
    setAddressFromState() {
        this.address = $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.state.address ?? "", this.accountDomain = $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.state.accountDomain ?? "", this.isAccountDomainLoading = !!$ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.state.isAccountDomainLoading, this.requestUpdate();
    }
    configureButtonUI() {
        this.mode = $ade5618b9d1e8b58$export$f660724a5e07d7a3.configuration?.themeMode ?? "LIGHT", this.i18n = $ade5618b9d1e8b58$export$f660724a5e07d7a3.configuration?.i18n ?? $ade5618b9d1e8b58$export$a497cb29076adb1d, this.language = $ade5618b9d1e8b58$export$f660724a5e07d7a3.configuration?.language ?? "en", this.address = $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.state.address ?? "", this.accountDomain = $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.state.accountDomain ?? "", this.isAccountDomainLoading = !!$ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.state.isAccountDomainLoading, this.requestUpdate();
    }
    initAddressListener() {
        $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.subscribeToKey("address", (A)=>{
            this.address = A ?? "", this.requestUpdate();
        }), $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.subscribeToKey("accountDomain", (A)=>{
            this.accountDomain = A ?? "", this.requestUpdate();
        }), $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.subscribeToKey("isAccountDomainLoading", (A)=>{
            this.isAccountDomainLoading = A, this.requestUpdate();
        });
    }
    render() {
        return this.address ? (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`<vdk-address-button
                  .mode=${this.mode}
                  .address=${this.address}
                  .accountDomain=${this.accountDomain}
                  .isAccountDomainLoading=${this.isAccountDomainLoading}
                  .disabled=${this.disabled}
                  .mobile=${this.mobile}
              ></vdk-address-button>` : (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`<vdk-connect-button
                  .mode=${this.mode}
                  .i18n=${this.i18n}
                  .language=${this.language}
                  .disabled=${this.disabled}
                  .mobile=${this.mobile}
              ></vdk-connect-button>`;
    }
};
$ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$353f5b6fc5456de1.prototype, "mode", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$353f5b6fc5456de1.prototype, "i18n", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$353f5b6fc5456de1.prototype, "language", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$353f5b6fc5456de1.prototype, "address", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$353f5b6fc5456de1.prototype, "accountDomain", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$353f5b6fc5456de1.prototype, "isAccountDomainLoading", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$353f5b6fc5456de1.prototype, "disabled", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$353f5b6fc5456de1.prototype, "mobile", 2), $ade5618b9d1e8b58$export$353f5b6fc5456de1 = $ade5618b9d1e8b58$var$e([
    (0, $3624e2f028ed96c5$export$da64fc29f17f9d0e)("vdk-button")
], $ade5618b9d1e8b58$export$353f5b6fc5456de1);
var $ade5618b9d1e8b58$var$Q = (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`
    button {
        font-family: var(--vdk-font-family, ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Family});
        font-size: var(--vdk-font-size-medium, ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Size.Medium});
        font-weight: var(--vdk-font-weight-medium, ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Weight.Medium});
        cursor: pointer;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        border: none;
        border-radius: 12px;
        padding: 12px;
        width: 100%;
        gap: 10px;
    }

    button.LIGHT {
        background: var(--vdk-color-light-primary, ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Light.Primary});
        color: var(--vdk-color-light-tertiary, ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Light.Tertiary});
    }
    button.LIGHT:hover:not(:disabled) {
        background: var(
            --vdk-color-light-primary-hover,
            ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Light.PrimaryHover}
        );
    }
    button.LIGHT:active:not(:disabled) {
        background: var(
            --vdk-color-light-primary-active,
            ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Light.PrimaryActive}
        );
    }
    button.LIGHT:disabled {
        opacity: 0.8;
    }

    button.DARK {
        background: var(--vdk-color-dark-primary, ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.Primary});
        color: var(--vdk-color-dark-tertiary, ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.Tertiary});
    }
    button.DARK:hover:not(:disabled) {
        background: var(
            --vdk-color-dark-primary-hover,
            ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.PrimaryHover}
        );
    }
    button.DARK:active:not(:disabled) {
        background: var(
            --vdk-color-dark-primary-active,
            ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.PrimaryActive}
        );
    }

    button.DARK:disabled {
        opacity: 0.8;
    }
`, $ade5618b9d1e8b58$var$sA = (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`
    .icon-button {
        cursor: pointer;
        width: 25px;
        height: 25px;
        padding: 5px;
        border-radius: 50%;
    }

    .icon-button.LIGHT:hover {
        background: var(
            --vdk-color-light-primary,
            ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Light.PrimaryHover}
        );
    }

    .icon-button.DARK:hover {
        background: var(--vdk-color-dark-primary, ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.PrimaryHover});
    }

    .icon-button.LIGHT:active {
        background: var(
            --vdk-color-light-primary,
            ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Light.PrimaryActive}
        );
    }

    .icon-button.DARK:active {
        background: var(--vdk-color-dark-primary, ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.PrimaryActive});
    }

    button:disabled {
        opacity: 0.8;
    }
`;
var $ade5618b9d1e8b58$var$_A = (0, $3c37a6a9a4cce4d8$export$7ed1367e7fa1ad68)`
      <path
        d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
    `, $ade5618b9d1e8b58$var$dA = (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill=${$ade5618b9d1e8b58$export$c537fa0d021d010b.Light.Quaternary}
    >
        ${$ade5618b9d1e8b58$var$_A}
    </svg>
`, $ade5618b9d1e8b58$var$lA = (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill=${$ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.Quaternary}
    >
        ${$ade5618b9d1e8b58$var$_A}
    </svg>
`;
var $ade5618b9d1e8b58$var$ee = (0, $3c37a6a9a4cce4d8$export$7ed1367e7fa1ad68)`
      <path
        d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
    `, $ade5618b9d1e8b58$var$te = (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill=${$ade5618b9d1e8b58$export$c537fa0d021d010b.Light.Quaternary}
    >
        ${$ade5618b9d1e8b58$var$ee}
    </svg>
`, $ade5618b9d1e8b58$var$oe = (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill=${$ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.Quaternary}
    >
        ${$ade5618b9d1e8b58$var$ee}
    </svg>
`;
var $ade5618b9d1e8b58$var$ne = (0, $3c37a6a9a4cce4d8$export$7ed1367e7fa1ad68)`
      <path d="M17.5 14H19C20.1046 14 21 13.1046 21 12V5C21 3.89543 20.1046 3 19 3H12C10.8954 3 10 3.89543 10 5V6.5M5 10H12C13.1046 10 14 10.8954 14 12V19C14 20.1046 13.1046 21 12 21H5C3.89543 21 3 20.1046 3 19V12C3 10.8954 3.89543 10 5 10Z"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    `, $ade5618b9d1e8b58$var$eA = (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        stroke=${$ade5618b9d1e8b58$export$c537fa0d021d010b.Light.Quaternary}
        fill="#00000000"
    >
        ${$ade5618b9d1e8b58$var$ne}
    </svg>
`, $ade5618b9d1e8b58$var$tA = (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        stroke=${$ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.Quaternary}
        fill="#00000000"
    >
        ${$ade5618b9d1e8b58$var$ne}
    </svg>
`;
var $ade5618b9d1e8b58$var$oA = (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill=${$ade5618b9d1e8b58$export$c537fa0d021d010b.WalletConnectBlue}
    >
        <path
            d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
        />
    </svg>
`;
var $ade5618b9d1e8b58$var$ce = (0, $3c37a6a9a4cce4d8$export$7ed1367e7fa1ad68)`
    <path
        d="M3 1C2.44771 1 2 1.44772 2 2V13C2 13.5523 2.44772 14 3 14H10.5C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13H3V2L10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1H3ZM12.6036 4.89645C12.4083 4.70118 12.0917 4.70118 11.8964 4.89645C11.7012 5.09171 11.7012 5.40829 11.8964 5.60355L13.2929 7H6.5C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H13.2929L11.8964 9.39645C11.7012 9.59171 11.7012 9.90829 11.8964 10.1036C12.0917 10.2988 12.4083 10.2988 12.6036 10.1036L14.8536 7.85355C15.0488 7.65829 15.0488 7.34171 14.8536 7.14645L12.6036 4.89645Z"
    />
`, $ade5618b9d1e8b58$var$ve = (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 15"
        fill=${$ade5618b9d1e8b58$export$c537fa0d021d010b.Light.Quaternary}
    >
        ${$ade5618b9d1e8b58$var$ce}
    </svg>
`, $ade5618b9d1e8b58$var$fe = (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 15"
        fill=${$ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.Quaternary}
    >
        ${$ade5618b9d1e8b58$var$ce}
    </svg>
`;
var $ade5618b9d1e8b58$var$ie = (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
    <svg
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style="background: ${$ade5618b9d1e8b58$export$c537fa0d021d010b.WalletConnectBlue};"
    >
        <path
            d="M9.58818 11.8556C13.1293 8.31442 18.8706 8.31442 22.4117 11.8556L22.8379 12.2818C23.015 12.4588 23.015 12.7459 22.8379 12.9229L21.3801 14.3808C21.2915 14.4693 21.148 14.4693 21.0595 14.3808L20.473 13.7943C18.0026 11.3239 13.9973 11.3239 11.5269 13.7943L10.8989 14.4223C10.8104 14.5109 10.6668 14.5109 10.5783 14.4223L9.12041 12.9645C8.94336 12.7875 8.94336 12.5004 9.12041 12.3234L9.58818 11.8556ZM25.4268 14.8706L26.7243 16.1682C26.9013 16.3452 26.9013 16.6323 26.7243 16.8093L20.8737 22.6599C20.6966 22.8371 20.4096 22.8371 20.2325 22.6599L16.0802 18.5076C16.0359 18.4634 15.9641 18.4634 15.9199 18.5076L11.7675 22.6599C11.5905 22.8371 11.3034 22.8371 11.1264 22.66C11.1264 22.66 11.1264 22.6599 11.1264 22.6599L5.27561 16.8092C5.09856 16.6322 5.09856 16.3451 5.27561 16.168L6.57313 14.8706C6.75019 14.6934 7.03726 14.6934 7.21431 14.8706L11.3668 19.023C11.411 19.0672 11.4828 19.0672 11.5271 19.023L15.6793 14.8706C15.8563 14.6934 16.1434 14.6934 16.3205 14.8706L20.473 19.023C20.5172 19.0672 20.589 19.0672 20.6332 19.023L24.7856 14.8706C24.9627 14.6935 25.2498 14.6935 25.4268 14.8706Z"
            fill="white"
        ></path>
    </svg>
`;
var $ade5618b9d1e8b58$var$se = (0, $3c37a6a9a4cce4d8$export$7ed1367e7fa1ad68)`
      <path d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"/>
    `, $ade5618b9d1e8b58$var$de = (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        stroke=${$ade5618b9d1e8b58$export$c537fa0d021d010b.Light.Tertiary}
        fill=${$ade5618b9d1e8b58$export$c537fa0d021d010b.Light.Tertiary}
    >
        ${$ade5618b9d1e8b58$var$se}
    </svg>
`, $ade5618b9d1e8b58$var$le = (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        stroke=${$ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.Tertiary}
        fill=${$ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.Tertiary}
    >
        ${$ade5618b9d1e8b58$var$se}
    </svg>
`;
var $ade5618b9d1e8b58$export$79b5060180039794 = class extends (0, $b32aec94b1c85015$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.mode = "LIGHT";
        this.i18n = $ade5618b9d1e8b58$export$a497cb29076adb1d;
        this.language = "en";
        this.handleOpen = ()=>{
            $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.disconnect(), $ade5618b9d1e8b58$export$f660724a5e07d7a3.modal.open();
        };
        this.disabled = !1;
        this.mobile = !1;
    }
    render() {
        if (this.mobile) {
            let g = this.mode === "LIGHT" ? $ade5618b9d1e8b58$var$de : $ade5618b9d1e8b58$var$le;
            return (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)` <vdk-fonts></vdk-fonts>
                <button
                    class="${this.mode} mobile"
                    @click=${this.handleOpen}
                    ?disabled=${this.disabled}
                >
                    <div class="icon">${g}</div>
                </button>`;
        }
        let A = $ade5618b9d1e8b58$export$1ebcfac7b0929fc6(this.i18n, this.language);
        return (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
            <vdk-fonts></vdk-fonts>
            <button
                class="${this.mode}"
                @click=${this.handleOpen}
                ?disabled=${this.disabled}
            >
                ${A("connect-wallet")}
            </button>
        `;
    }
};
$ade5618b9d1e8b58$export$79b5060180039794.styles = [
    $ade5618b9d1e8b58$var$Q,
    (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`
            button {
                width: auto;
            }
            button.mobile {
                height: 41px;
                width: 41px;
                padding: 0;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .icon {
                padding-top: 4px;
                width: 18px;
                height: 18px;
            }
        `
], $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$79b5060180039794.prototype, "mode", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$79b5060180039794.prototype, "i18n", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$79b5060180039794.prototype, "language", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$79b5060180039794.prototype, "handleOpen", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$79b5060180039794.prototype, "disabled", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$79b5060180039794.prototype, "mobile", 2), $ade5618b9d1e8b58$export$79b5060180039794 = $ade5618b9d1e8b58$var$e([
    (0, $3624e2f028ed96c5$export$da64fc29f17f9d0e)("vdk-connect-button")
], $ade5618b9d1e8b58$export$79b5060180039794);
var $ade5618b9d1e8b58$export$7b5963230809644f = class extends (0, $b32aec94b1c85015$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.accountDomain = "";
        this.isAccountDomainLoading = !1;
        this.mode = "LIGHT";
        this.handleOpen = ()=>{
            $ade5618b9d1e8b58$export$f660724a5e07d7a3.modal.open();
        };
        this.disabled = !1;
        this.mobile = !1;
    }
    render() {
        if (this.mobile) return (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)` <vdk-fonts></vdk-fonts>
                <button
                    class="wallet-button ${this.mode} mobile"
                    @click=${this.handleOpen}
                    ?disabled=${this.disabled}
                >
                    <img
                        class="address-icon mobile"
                        src=${$ade5618b9d1e8b58$export$82aa6a7146c28036(this.address ?? "")}
                    />
                </button>`;
        let A = this.accountDomain && !this.isAccountDomainLoading ? (0, $4b665efddc7cd9c8$export$e64256c8aa87bb6)(this.accountDomain, 7) : $ade5618b9d1e8b58$export$6ace02e31606896d(this.address ?? "");
        return (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)` <vdk-fonts></vdk-fonts>
            <button
                class="wallet-button ${this.mode}"
                @click=${this.handleOpen}
                ?disabled=${this.disabled}
            >
                <img
                    class="address-icon"
                    src=${$ade5618b9d1e8b58$export$82aa6a7146c28036(this.address ?? "")}
                />
                <span class="wallet-address">${A}</span>
            </button>`;
    }
};
$ade5618b9d1e8b58$export$7b5963230809644f.styles = [
    $ade5618b9d1e8b58$var$Q,
    (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`
            button {
                padding: 9px 12px;
                width: auto;
                gap: 4px;
            }

            button.mobile {
                padding: 0px;
            }

            button.mobile:hover {
                opacity: 0.9;
            }

            /* Style for the wallet address */

            .wallet-address {
                font-size: var(--vdk-font-size-medium, ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Size.Medium});
                margin-left: 8px;
                font-family: var(--vdk-font-family, ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Family});
            }

            .address-icon {
                width: 23px;
                height: 23px;
                border-radius: 50%;
            }

            .address-icon.mobile {
                width: 41px;
                height: 41px;
                border-radius: 12px;
            }
        `
], $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$7b5963230809644f.prototype, "address", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$7b5963230809644f.prototype, "accountDomain", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$7b5963230809644f.prototype, "isAccountDomainLoading", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$7b5963230809644f.prototype, "mode", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$7b5963230809644f.prototype, "handleOpen", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$7b5963230809644f.prototype, "disabled", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$7b5963230809644f.prototype, "mobile", 2), $ade5618b9d1e8b58$export$7b5963230809644f = $ade5618b9d1e8b58$var$e([
    (0, $3624e2f028ed96c5$export$da64fc29f17f9d0e)("vdk-address-button")
], $ade5618b9d1e8b58$export$7b5963230809644f);
var $ade5618b9d1e8b58$var$ue, $ade5618b9d1e8b58$export$2b77a92f1a5ad772 = class extends (0, $b32aec94b1c85015$export$3f2f9f5909897157) {
    constructor(){
        super();
        this.address = $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.state.address ?? "";
        this.accountDomain = $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.state.accountDomain ?? "";
        this.isAccountDomainLoading = !!$ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.state.isAccountDomainLoading;
        this.mode = "LIGHT";
        this.i18n = $ade5618b9d1e8b58$export$a497cb29076adb1d;
        this.language = "en";
        this.onDisconnectClick = ()=>{
            $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.disconnect();
        };
        $ade5618b9d1e8b58$export$f660724a5e07d7a3.initialized && this.setAddressFromState();
    }
    connectedCallback() {
        super.connectedCallback(), $ade5618b9d1e8b58$export$f660724a5e07d7a3.initialized && this.initAddressListener(), $ade5618b9d1e8b58$var$ue = $ade5618b9d1e8b58$export$2c6be09446e54dfb("vdk-dapp-kit-configured", ()=>{
            this.setAddressFromState(), this.initAddressListener();
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback(), $ade5618b9d1e8b58$var$ue?.();
    }
    setAddressFromState() {
        this.address = $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.state.address ?? "", this.accountDomain = $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.state.accountDomain ?? "", this.isAccountDomainLoading = !!$ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.state.isAccountDomainLoading, this.requestUpdate();
    }
    initAddressListener() {
        $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.subscribeToKey("address", (A)=>{
            this.address = A ?? "", this.requestUpdate();
        }), $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.subscribeToKey("accountDomain", (A)=>{
            this.accountDomain = A ?? "", this.requestUpdate();
        }), $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.subscribeToKey("isAccountDomainLoading", (A)=>{
            this.isAccountDomainLoading = A, this.requestUpdate();
        });
    }
    render() {
        return $ade5618b9d1e8b58$export$f660724a5e07d7a3.initialized ? (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
            <div>
                ${this.address ? (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)` <vdk-address-modal
                          .mode=${this.mode}
                          .i18n=${this.i18n}
                          .language=${this.language}
                          .address=${this.address}
                          .accountDomain=${this.accountDomain}
                          .isAccountDomainLoading=${this.isAccountDomainLoading}
                          .onDisconnectClick=${this.onDisconnectClick}
                      ></vdk-address-modal>` : (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)` <vdk-connect-modal
                          .mode=${this.mode}
                          .i18n=${this.i18n}
                          .language=${this.language}
                          .onSourceClick=${this.onSourceClick || (0, $3c37a6a9a4cce4d8$export$45b790e32b2810ee)}
                      ></vdk-connect-modal>`}
            </div>
        ` : (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)``;
    }
};
$ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$2b77a92f1a5ad772.prototype, "address", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$2b77a92f1a5ad772.prototype, "accountDomain", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$2b77a92f1a5ad772.prototype, "isAccountDomainLoading", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$2b77a92f1a5ad772.prototype, "mode", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$2b77a92f1a5ad772.prototype, "i18n", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$2b77a92f1a5ad772.prototype, "language", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)({
        type: Function
    })
], $ade5618b9d1e8b58$export$2b77a92f1a5ad772.prototype, "onSourceClick", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)({
        type: Function
    })
], $ade5618b9d1e8b58$export$2b77a92f1a5ad772.prototype, "onDisconnectClick", 2), $ade5618b9d1e8b58$export$2b77a92f1a5ad772 = $ade5618b9d1e8b58$var$e([
    (0, $3624e2f028ed96c5$export$da64fc29f17f9d0e)("vdk-modal")
], $ade5618b9d1e8b58$export$2b77a92f1a5ad772);
var $ade5618b9d1e8b58$export$a703eb468fcf7e69 = class extends (0, $b32aec94b1c85015$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.open = !1;
        this.mode = "LIGHT";
        this.observer = new ResizeObserver(()=>{
            this.modalHeight = this.modalSubContainer?.clientHeight ?? 0;
        });
        this.onClose = ()=>null;
        this.stopPropagation = (A)=>{
            A.stopPropagation();
        };
    }
    willUpdate(A) {
        if (A.has("open")) {
            if (!this.modalSubContainer) return;
            this.open ? (this.modalHeight = this.modalSubContainer.clientHeight, this.observer.observe(this.modalSubContainer)) : (this.modalHeight = 0, this.observer.unobserve(this.modalSubContainer));
        }
    }
    render() {
        return (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
            <div
                class="modal-container ${this.open ? "" : "hidden"}"
                @click=${this.onClose}
            >
                <div
                    class="modal ${this.mode}"
                    @click=${this.stopPropagation}
                    style="height: ${this.modalHeight ? `${this.modalHeight}px` : "auto"}"
                >
                    <div class="modal-sub-container">
                        <slot></slot>
                    </div>
                </div>
            </div>
        `;
    }
};
$ade5618b9d1e8b58$export$a703eb468fcf7e69.styles = (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`
        .modal-container {
            display: flex;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.3);
            opacity: 1;
            transition: opacity 0.1s ease-in-out;
            z-index: var(--vdk-modal-z-index, ${$ade5618b9d1e8b58$export$24c540328f957d31});
            backdrop-filter: var(
                --vdk-modal-backdrop-filter,
                ${$ade5618b9d1e8b58$export$e14b98b50e1f2d1e}
            );
        }

        .modal-container.hidden {
            opacity: 0;
            pointer-events: none;
        }

        .modal {
            position: absolute;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
            transition: height 0.1s ease-in-out, transform 0.2s ease-in-out;
            overflow: hidden;
        }

        .modal-container.hidden .modal {
            transform: scale(0.97);
        }

        .modal.LIGHT {
            background: var(
                --vdk-color-light-secondary,
                ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Light.Secondary}
            );
            color: var(--vdk-color-light-tertiary, ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Light.Tertiary});
        }

        .modal.DARK {
            background: var(
                --vdk-color-dark-secondary,
                ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.Secondary}
            );
            color: var(--vdk-color-dark-tertiary, ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.Tertiary});
        }

        @media (max-width: ${$ade5618b9d1e8b58$export$114247090b0aae30.Mobile}px) {
            .modal {
                width: 100%;
                border-top-left-radius: 16px;
                border-top-right-radius: 16px;
                bottom: 0;
                left: 0;
                right: 0;
            }
        }

        @media (min-width: ${$ade5618b9d1e8b58$export$114247090b0aae30.Mobile}px) {
            .modal-container {
                align-items: center;
                justify-content: center;
            }
            .modal {
                width: var(--vdk-modal-width, ${$ade5618b9d1e8b58$export$90043f08d14c91b3});
                border-radius: 16px;
            }
        }
    `, $ade5618b9d1e8b58$var$e([
    (0, $1789597cada8212d$export$2fa187e846a241c4)(".modal-sub-container")
], $ade5618b9d1e8b58$export$a703eb468fcf7e69.prototype, "modalSubContainer", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$a703eb468fcf7e69.prototype, "modalHeight", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)({
        type: Boolean
    })
], $ade5618b9d1e8b58$export$a703eb468fcf7e69.prototype, "open", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$a703eb468fcf7e69.prototype, "mode", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)({
        type: Function
    })
], $ade5618b9d1e8b58$export$a703eb468fcf7e69.prototype, "onClose", 2), $ade5618b9d1e8b58$export$a703eb468fcf7e69 = $ade5618b9d1e8b58$var$e([
    (0, $3624e2f028ed96c5$export$da64fc29f17f9d0e)("vdk-base-modal")
], $ade5618b9d1e8b58$export$a703eb468fcf7e69);
var $ade5618b9d1e8b58$var$De, $ade5618b9d1e8b58$var$Xe, $ade5618b9d1e8b58$var$Ce, $ade5618b9d1e8b58$var$Le, $ade5618b9d1e8b58$var$be, $ade5618b9d1e8b58$var$qe, $ade5618b9d1e8b58$export$b33e7092bdf63f3f = class extends (0, $b32aec94b1c85015$export$3f2f9f5909897157) {
    constructor(){
        super();
        this.onSourceClick = (A)=>{
            if (A) {
                if (A.id === "veworld" && !window.vechain) {
                    window.open(`${$ade5618b9d1e8b58$export$9509a5d0b3cb9709}${encodeURIComponent(location.href)}`, "_self");
                    return;
                }
                A.id !== "wallet-connect" && (this.setWaitingForTheSignature(!0), this.requestForConnectionCertificate = !0), this.wallet.setSource(A.id), this.wallet.connect().then(()=>{
                    this.requestUpdate();
                }).catch((g)=>{
                    (0, $4b665efddc7cd9c8$export$4269407eefc1557b).error("Connection Attempt", "error trying to connect", g);
                });
            }
        };
        this.onClose = ()=>(0, $3c37a6a9a4cce4d8$export$45b790e32b2810ee);
        this.open = !1;
        this.openingVeWorld = !1;
        this.mode = "LIGHT";
        this.i18n = $ade5618b9d1e8b58$export$a497cb29076adb1d;
        this.language = "en";
        this.walletConnectQRcode = void 0;
        this.requestForConnectionCertificate = !1;
        this.waitingForTheSignature = !1;
        this.setWaitingForTheSignature = (A)=>{
            this.waitingForTheSignature = A;
        };
        this.handleBack = ()=>{
            $ade5618b9d1e8b58$export$f660724a5e07d7a3.modal.closeWalletConnect();
        };
        this.handleClose = ()=>{
            $ade5618b9d1e8b58$export$f660724a5e07d7a3.modal.close(), this.walletConnectQRcode && setTimeout(()=>{
                this.handleBack(), this.wallet.disconnect();
            }, 500), this.requestForConnectionCertificate && setTimeout(()=>{
                $ade5618b9d1e8b58$export$f660724a5e07d7a3.modal.closeConnectionCertificateRequest(), this.wallet.disconnect();
            }, 500), this.onClose();
        };
        $ade5618b9d1e8b58$var$De = $ade5618b9d1e8b58$export$2c6be09446e54dfb("vdk-open-wc-qrcode", (A)=>{
            $ade5618b9d1e8b58$export$d0a8044dce8ff2fc() && (this.openingVeWorld = !0, window.open(`veworld://app.veworld?uri=${encodeURIComponent(A.uri)}`, "_self")), this.open = !0, this.walletConnectQRcode = A.uri;
        }), $ade5618b9d1e8b58$var$Xe = $ade5618b9d1e8b58$export$2c6be09446e54dfb("vdk-close-wc-qrcode", ()=>{
            this.walletConnectQRcode = void 0, this.openingVeWorld = !1;
        }), $ade5618b9d1e8b58$var$Ce = $ade5618b9d1e8b58$export$2c6be09446e54dfb("vdk-open-wallet-modal", ()=>{
            window.vechain?.isInAppBrowser ? this.onSourceClick($ade5618b9d1e8b58$export$771a7e037f0b0496.veworld) : this.open = !0;
        }), $ade5618b9d1e8b58$var$Le = $ade5618b9d1e8b58$export$2c6be09446e54dfb("vdk-close-wallet-modal", ()=>{
            this.open = !1;
        }), $ade5618b9d1e8b58$var$be = $ade5618b9d1e8b58$export$2c6be09446e54dfb("vdk-request-connection-certificate", ()=>{
            this.requestForConnectionCertificate = !0;
        }), $ade5618b9d1e8b58$var$qe = $ade5618b9d1e8b58$export$2c6be09446e54dfb("vdk-close-connection-certificate-request", ()=>{
            this.requestForConnectionCertificate = !1;
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback(), $ade5618b9d1e8b58$var$De?.(), $ade5618b9d1e8b58$var$Xe?.(), $ade5618b9d1e8b58$var$Ce?.(), $ade5618b9d1e8b58$var$Le?.(), $ade5618b9d1e8b58$var$be?.(), $ade5618b9d1e8b58$var$qe?.();
    }
    get availableSources() {
        return $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.state.availableSources.map((A)=>$ade5618b9d1e8b58$export$771a7e037f0b0496[A]);
    }
    get wallet() {
        return $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet;
    }
    renderContent() {
        return this.requestForConnectionCertificate ? (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`<vdk-sign-connection-certificate
                .mode=${this.mode}
                .i18n=${this.i18n}
                .language=${this.language}
                .waitingForTheSignature=${this.waitingForTheSignature}
                .setWaitingForTheSignature=${this.setWaitingForTheSignature}
            ></vdk-sign-connection-certificate>` : this.walletConnectQRcode ? (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)` <vdk-wallet-connect-qrcode
                .openingVeWorld=${this.openingVeWorld}
                .mode=${this.mode}
                .i18n=${this.i18n}
                .language=${this.language}
                .walletConnectQRcode=${this.walletConnectQRcode}
            ></vdk-wallet-connect-qrcode>` : this.availableSources.map((A)=>(0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)` <vdk-source-card
                    .source=${A}
                    .mode=${this.mode}
                    .onClick=${this.onSourceClick}
                ></vdk-source-card>`);
    }
    render() {
        let A = $ade5618b9d1e8b58$export$1ebcfac7b0929fc6(this.i18n, this.language);
        return (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
            <vdk-fonts></vdk-fonts>
            <vdk-base-modal
                .open=${this.open}
                .onClose=${this.handleClose}
                .mode=${this.mode}
            >
                <div class="modal-container">
                    <div class="modal-header">
                        ${this.walletConnectQRcode ? (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)` <div
                                  class="icon-button ${this.mode}"
                                  @click=${this.handleBack}
                              >
                                  ${this.mode === "LIGHT" ? $ade5618b9d1e8b58$var$te : $ade5618b9d1e8b58$var$oe}
                              </div>` : (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)` <div class="icon-button"></div>`}
                        <div>${A("connect-wallet")}</div>
                        <div
                            class="icon-button ${this.mode}"
                            @click=${this.handleClose}
                        >
                            ${this.mode === "LIGHT" ? $ade5618b9d1e8b58$var$dA : $ade5618b9d1e8b58$var$lA}
                        </div>
                    </div>
                    <div class="modal-body">${this.renderContent()}</div>
                </div>
            </vdk-base-modal>
        `;
    }
};
$ade5618b9d1e8b58$export$b33e7092bdf63f3f.styles = [
    $ade5618b9d1e8b58$var$sA,
    (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`
            .modal-container {
                padding: 20px;
            }

            .modal-header {
                font-family: var(--vdk-font-family, ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Family});
                font-weight: var(
                    --vdk-font-weight-medium,
                    ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Weight.Medium}
                );
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 10px;
            }

            .modal-body {
                flex-direction: column;
            }
        `
], $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)({
        type: Function
    })
], $ade5618b9d1e8b58$export$b33e7092bdf63f3f.prototype, "onSourceClick", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)({
        type: Function
    })
], $ade5618b9d1e8b58$export$b33e7092bdf63f3f.prototype, "onClose", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)({
        type: Boolean
    })
], $ade5618b9d1e8b58$export$b33e7092bdf63f3f.prototype, "open", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)({
        type: Boolean
    })
], $ade5618b9d1e8b58$export$b33e7092bdf63f3f.prototype, "openingVeWorld", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$b33e7092bdf63f3f.prototype, "mode", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$b33e7092bdf63f3f.prototype, "i18n", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$b33e7092bdf63f3f.prototype, "language", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$b33e7092bdf63f3f.prototype, "walletConnectQRcode", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$b33e7092bdf63f3f.prototype, "requestForConnectionCertificate", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$b33e7092bdf63f3f.prototype, "waitingForTheSignature", 2), $ade5618b9d1e8b58$export$b33e7092bdf63f3f = $ade5618b9d1e8b58$var$e([
    (0, $3624e2f028ed96c5$export$da64fc29f17f9d0e)("vdk-connect-modal")
], $ade5618b9d1e8b58$export$b33e7092bdf63f3f);
var $ade5618b9d1e8b58$export$c74cbf75d6285884 = class extends (0, $b32aec94b1c85015$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.onClick = void 0;
        this.mode = "LIGHT";
        this.source = void 0;
    }
    get wallet() {
        return $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet;
    }
    handleSourceClick() {
        this.onClick?.(this.source);
    }
    render() {
        return (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
            <button
                class="card ${this.mode}"
                @click=${()=>this.handleSourceClick()}
                data-testid="${this.source?.name}"
            >
                <div>${this.source?.name}</div>
                <img src=${this.source?.logo} />
            </button>
        `;
    }
};
$ade5618b9d1e8b58$export$c74cbf75d6285884.styles = [
    $ade5618b9d1e8b58$var$Q,
    (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`
            button {
                padding: 16px;
                flex: 1;
                margin: 8px 0;
                justify-content: space-between;
                font-size: var(--vdk-font-size-medium, ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Size.Medium});
            }
            button.LIGHT {
                border: var(
                    --vdk-border-light-source-card,
                    ${$ade5618b9d1e8b58$export$3ca97b21cbdba72c.Light}
                );
            }
            button.DARK {
                border: var(
                    --vdk-border-dark-source-card,
                    ${$ade5618b9d1e8b58$export$3ca97b21cbdba72c.Dark}
                );
            }

            img {
                width: 32px;
                height: 32px;
                object-fit: contain;
            }
        `
], $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)({
        type: Function
    })
], $ade5618b9d1e8b58$export$c74cbf75d6285884.prototype, "onClick", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$c74cbf75d6285884.prototype, "mode", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$c74cbf75d6285884.prototype, "source", 2), $ade5618b9d1e8b58$export$c74cbf75d6285884 = $ade5618b9d1e8b58$var$e([
    (0, $3624e2f028ed96c5$export$da64fc29f17f9d0e)("vdk-source-card")
], $ade5618b9d1e8b58$export$c74cbf75d6285884);
var $ade5618b9d1e8b58$var$K = 280, $ade5618b9d1e8b58$export$363b3f72e5d10e9d = class extends (0, $b32aec94b1c85015$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.mode = "LIGHT";
        this.i18n = $ade5618b9d1e8b58$export$a497cb29076adb1d;
        this.language = "en";
        this.walletConnectQRcode = void 0;
        this.showCopiedIcon = !1;
        this.openingVeWorld = !1;
        this.onCopy = async ()=>{
            await navigator.clipboard.writeText(this.walletConnectQRcode || ""), this.showCopiedIcon = !0, setTimeout(()=>{
                this.showCopiedIcon = !1;
            }, 1e3);
        };
        this.getVeWorld = ()=>{
            $ade5618b9d1e8b58$export$a11b0059900ceec8() ? window.open($ade5618b9d1e8b58$export$c73908b448db79b5, "_self") : window.open($ade5618b9d1e8b58$export$598805d34b49672, "_self");
        };
    }
    render() {
        let A = $ade5618b9d1e8b58$export$1ebcfac7b0929fc6(this.i18n, this.language), g = this.mode === "LIGHT" ? $ade5618b9d1e8b58$var$eA : $ade5618b9d1e8b58$var$tA;
        return this.showCopiedIcon && (g = $ade5618b9d1e8b58$var$oA), (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
            <div class="qrcode-body">
                <div class="qrcode-container ${this.mode}">
                    ${this.openingVeWorld ? this.svgLoaderTemplate() : (0, $3c37a6a9a4cce4d8$export$45b790e32b2810ee)}
                    ${this.svgWCQrCode(this.walletConnectQRcode)}
                    <div class="wc-icon">${$ade5618b9d1e8b58$var$ie}</div>
                </div>
                ${this.openingVeWorld ? (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`<div class="openingVeWorldText">
                          ${A("opening-veworld")}
                      </div>` : (0, $3c37a6a9a4cce4d8$export$45b790e32b2810ee)}
                ${this.openingVeWorld ? (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`<button
                          class="${this.mode}"
                          @click=${this.getVeWorld}
                      >
                          <img class="veworld-icon" src=${$ade5618b9d1e8b58$var$nA} />
                          ${A("get-veworld")}
                      </button>` : (0, $3c37a6a9a4cce4d8$export$45b790e32b2810ee)}
                <div class="separator">
                    <div class="line ${this.mode}"></div>
                    <div class="or ${this.mode}">or</div>
                    <div class="line ${this.mode}"></div>
                </div>
                <button class="${this.mode}" @click=${this.onCopy}>
                    <div class="icon">${g}</div>
                    ${A("copy-to-clipboard")}
                </button>
            </div>
        `;
    }
    svgLoaderTemplate() {
        let s = "8", i = 0;
        s.includes("%") ? i = 0.88 * parseInt(s, 10) : i = parseInt(s, 10), i *= 1.17;
        let d = 317 - i * 1.57, rA = 425 - i * 1.8;
        return (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
            <svg
                class="loader"
                viewBox="0 0 110 110"
                width=${$ade5618b9d1e8b58$var$K + 50}
                height=${$ade5618b9d1e8b58$var$K + 50}
            >
                <rect
                    id="wcm-loader"
                    x="2"
                    y="2"
                    width="106"
                    height="106"
                    rx=${i}
                ></rect>
                <use
                    xlink:href="#wcm-loader"
                    stroke-dasharray="106 ${d}"
                    stroke-dashoffset=${rA}
                ></use>
            </svg>
        `;
    }
    svgWCQrCode(A) {
        return A ? (0, $3c37a6a9a4cce4d8$export$7ed1367e7fa1ad68)`
            <svg height=${$ade5618b9d1e8b58$var$K} width=${$ade5618b9d1e8b58$var$K}>
                ${$ade5618b9d1e8b58$export$2faef7998946735.generate({
            uri: A,
            size: $ade5618b9d1e8b58$var$K,
            logoSize: $ade5618b9d1e8b58$var$K / 4,
            dotColor: this.mode === "LIGHT" ? $ade5618b9d1e8b58$export$c537fa0d021d010b.Light.Tertiary.toString() : $ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.Tertiary.toString(),
            edgeColor: this.mode === "LIGHT" ? $ade5618b9d1e8b58$export$c537fa0d021d010b.Light.Secondary.toString() : $ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.Secondary.toString()
        })}
            </svg>
            ` : (0, $3c37a6a9a4cce4d8$export$45b790e32b2810ee);
    }
};
$ade5618b9d1e8b58$export$363b3f72e5d10e9d.styles = [
    $ade5618b9d1e8b58$var$Q,
    (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`
            .qrcode-body {
                flex-direction: column;
                align-items: stretch;
                justify-content: center;
                display: flex;
            }

            .qrcode-container {
                position: relative;
                margin: 20px auto 0 auto;
                width: 280px;
                padding: 10px;
                border-radius: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid;
            }

            .qrcode-container.LIGHT {
                border-color: var(
                    --vdk-color-light-quaternary,
                    ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Light.Quaternary}
                );
            }

            .qrcode-container.DARK {
                border-color: var(
                    --vdk-color-dark-quaternary,
                    ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.Quaternary}
                );
            }

            div.wc-icon {
                border-radius: 12px;
                overflow: hidden;
                position: absolute;
                width: 68px;
                height: 68px;
                object-fit: contain;
            }

            .separator {
                display: flex;
                align-items: center;
                padding: 20px 0px;
            }

            .line {
                display: flex;
                flex-grow: 1;
                height: 1px;
            }

            .line.LIGHT {
                background: var(
                    --vdk-color-light-quaternary,
                    ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Light.Quaternary}
                );
            }

            .line.DARK {
                background: var(
                    --vdk-color-dark-quaternary,
                    ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.Quaternary}
                );
            }

            .or {
                font-family: var(--vdk-font-family, ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Family});
                font-size: var(--vdk-font-size-medium, ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Size.Medium});
                padding: 0 12px;
            }

            .or.LIGHT {
                color: var(
                    --vdk-color-light-quaternary,
                    ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Light.Quaternary}
                );
            }

            .or.DARK {
                color: var(
                    --vdk-color-dark-quaternary,
                    ${$ade5618b9d1e8b58$export$c537fa0d021d010b.Dark.Quaternary}
                );
            }

            .icon {
                width: 20px;
                height: 20px;
            }

            .veworld-icon {
                width: 20px;
                height: 20px;
                border-radius: 5px;
            }

            @keyframes loading {
                to {
                    stroke-dashoffset: 0px;
                }
            }

            use {
                stroke: var(
                    --vdk-color-walletconnectblue,
                    ${$ade5618b9d1e8b58$export$c537fa0d021d010b.WalletConnectBlue}
                );
                animation: loading 1s linear infinite;
            }

            svg.loader {
                position: absolute;
                fill: none;
                stroke: transparent;
                stroke-linecap: round;
                stroke-width: 1px;
                top: 10;
                left: 10;
            }

            .openingVeWorldText {
                text-align: center;
                font-family: var(--vdk-font-family, ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Family});
                font-size: var(--vdk-font-size-medium, ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Size.Medium});
                padding: 20px 0;
                color: var(
                    --vdk-color-walletconnectblue,
                    ${$ade5618b9d1e8b58$export$c537fa0d021d010b.WalletConnectBlue}
                );
            }
        `
], $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$363b3f72e5d10e9d.prototype, "mode", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$363b3f72e5d10e9d.prototype, "i18n", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$363b3f72e5d10e9d.prototype, "language", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$363b3f72e5d10e9d.prototype, "walletConnectQRcode", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$363b3f72e5d10e9d.prototype, "showCopiedIcon", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$363b3f72e5d10e9d.prototype, "openingVeWorld", 2), $ade5618b9d1e8b58$export$363b3f72e5d10e9d = $ade5618b9d1e8b58$var$e([
    (0, $3624e2f028ed96c5$export$da64fc29f17f9d0e)("vdk-wallet-connect-qrcode")
], $ade5618b9d1e8b58$export$363b3f72e5d10e9d);
var $ade5618b9d1e8b58$export$72a60a94ce42415e = class extends (0, $b32aec94b1c85015$export$3f2f9f5909897157) {
    constructor(){
        super();
        this.mode = "LIGHT";
        this.i18n = $ade5618b9d1e8b58$export$a497cb29076adb1d;
        this.language = "en";
        this.waitingForTheSignature = !1;
        this.setWaitingForTheSignature = ()=>{};
        this.submitButtonWidth = 0;
        this.setSubmitButtonWidth = ()=>{
            let A = document.querySelector("vdk-modal")?.shadowRoot?.querySelector("vdk-connect-modal")?.shadowRoot?.querySelector("div")?.clientWidth ?? 0;
            this.submitButtonWidth = A ? A - 40 : 0;
        };
        this.handleSignCertificate = async ()=>{
            this.setWaitingForTheSignature(!0), await $ade5618b9d1e8b58$export$f660724a5e07d7a3.wallet.signConnectionCertificate();
        };
        this.setSubmitButtonWidth(), addEventListener("resize", this.setSubmitButtonWidth);
    }
    svgLoaderTemplate() {
        let g = this.submitButtonWidth - 2, v = 41, s = (g + v) * 2, i = g / 2, d = s - i;
        return (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
            <svg
                class="loader"
                viewBox="0 0 ${this.submitButtonWidth} ${v}"
                width=${this.submitButtonWidth}
                height=${v}
            >
                <rect
                    id="sign-connection-loader"
                    x="1"
                    y="1"
                    width=${g}
                    height=${v - 2}
                    rx="12px"
                ></rect>
                <use
                    xlink:href="#sign-connection-loader"
                    stroke-dasharray="${i} ${d}"
                    stroke-dashoffset=${s}
                ></use>
            </svg>
        `;
    }
    render() {
        let A = $ade5618b9d1e8b58$export$1ebcfac7b0929fc6(this.i18n, this.language);
        return (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
            <div>
                <div class="signCertificateText">
                    ${A("sign-connection-certificate-description")}
                </div>
                ${this.waitingForTheSignature ? this.svgLoaderTemplate() : (0, $3c37a6a9a4cce4d8$export$45b790e32b2810ee)}
                <button
                    class="${this.mode}"
                    @click=${this.handleSignCertificate}
                    .disabled=${this.waitingForTheSignature}
                >
                    ${this.waitingForTheSignature ? A("waiting-signature") : A("sign-connection-certificate-button")}
                </button>
            </div>
        `;
    }
};
$ade5618b9d1e8b58$export$72a60a94ce42415e.styles = [
    $ade5618b9d1e8b58$var$Q,
    (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`
            .signCertificateText {
                margin: 20px;
                text-align: center;
            }

            @keyframes loading {
                to {
                    stroke-dashoffset: 0px;
                }
            }

            use {
                stroke: var(
                    --vdk-color-walletconnectblue,
                    ${$ade5618b9d1e8b58$export$c537fa0d021d010b.WalletConnectBlue}
                );
                animation: loading 1s linear infinite;
            }

            svg.loader {
                position: absolute;
                fill: none;
                stroke: transparent;
                stroke-linecap: round;
                stroke-width: 1px;
                top: 10;
                left: 10;
                z-index: 1;
            }
        `
], $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$72a60a94ce42415e.prototype, "mode", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$72a60a94ce42415e.prototype, "i18n", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$72a60a94ce42415e.prototype, "language", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$72a60a94ce42415e.prototype, "waitingForTheSignature", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$72a60a94ce42415e.prototype, "setWaitingForTheSignature", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$72a60a94ce42415e.prototype, "submitButtonWidth", 2), $ade5618b9d1e8b58$export$72a60a94ce42415e = $ade5618b9d1e8b58$var$e([
    (0, $3624e2f028ed96c5$export$da64fc29f17f9d0e)("vdk-sign-connection-certificate")
], $ade5618b9d1e8b58$export$72a60a94ce42415e);
var $ade5618b9d1e8b58$var$ye, $ade5618b9d1e8b58$var$Fe, $ade5618b9d1e8b58$export$3d5de78e430075f1 = class extends (0, $b32aec94b1c85015$export$3f2f9f5909897157) {
    constructor(){
        super();
        this.open = !1;
        this.address = "";
        this.accountDomain = "";
        this.isAccountDomainLoading = !1;
        this.onDisconnectClick = void 0;
        this.mode = "LIGHT";
        this.i18n = $ade5618b9d1e8b58$export$a497cb29076adb1d;
        this.language = "en";
        this.walletConnectQRcode = void 0;
        this.showCopiedMainIcon = !1;
        this.showCopiedSecondaryIcon = !1;
        this.onClose = ()=>(0, $3c37a6a9a4cce4d8$export$45b790e32b2810ee);
        this.onCopyMainLabel = async ()=>{
            let A = this.accountDomain ? this.accountDomain : this.address;
            await navigator.clipboard.writeText(A), this.showCopiedMainIcon = !0, setTimeout(()=>{
                this.showCopiedMainIcon = !1;
            }, 1e3);
        };
        this.onCopySecondaryLabel = async ()=>{
            await navigator.clipboard.writeText(this.address), this.showCopiedSecondaryIcon = !0, setTimeout(()=>{
                this.showCopiedSecondaryIcon = !1;
            }, 1e3);
        };
        this.handleClose = ()=>{
            $ade5618b9d1e8b58$export$f660724a5e07d7a3.modal.close(), this.onClose();
        };
        $ade5618b9d1e8b58$var$ye = $ade5618b9d1e8b58$export$2c6be09446e54dfb("vdk-open-wallet-modal", ()=>{
            this.open = !0;
        }), $ade5618b9d1e8b58$var$Fe = $ade5618b9d1e8b58$export$2c6be09446e54dfb("vdk-close-wallet-modal", ()=>{
            this.open = !1;
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback(), $ade5618b9d1e8b58$var$ye?.(), $ade5618b9d1e8b58$var$Fe?.();
    }
    render() {
        let A = $ade5618b9d1e8b58$export$1ebcfac7b0929fc6(this.i18n, this.language), g = this.mode === "LIGHT" ? $ade5618b9d1e8b58$var$eA : $ade5618b9d1e8b58$var$tA;
        this.showCopiedMainIcon && (g = $ade5618b9d1e8b58$var$oA);
        let v = this.mode === "LIGHT" ? $ade5618b9d1e8b58$var$eA : $ade5618b9d1e8b58$var$tA;
        this.showCopiedSecondaryIcon && (v = $ade5618b9d1e8b58$var$oA);
        let s = this.accountDomain && !this.isAccountDomainLoading ? (0, $4b665efddc7cd9c8$export$e64256c8aa87bb6)(this.accountDomain, 18) : $ade5618b9d1e8b58$export$6ace02e31606896d(this.address || "");
        return (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
        <vdk-fonts></vdk-fonts>
        <vdk-base-modal
                .open=${this.open}
                .onClose=${this.handleClose}
                .mode=${this.mode}
        >
            <div class="modal-container">
                <div class="modal-header">
                    <div class="icon-button"></div>
                    <div class="title">${A("connected")}</div>
                    <div
                            class="icon-button ${this.mode}"
                            @click=${this.handleClose}
                    >
                        ${this.mode === "LIGHT" ? $ade5618b9d1e8b58$var$dA : $ade5618b9d1e8b58$var$lA}
                    </div>
                </div>
                <div class="modal-body">
                    <img
                            class="address-icon"
                            src=${$ade5618b9d1e8b58$export$82aa6a7146c28036(this.address)}
                    />
                    <div class="address-container">
                    <span class="address-domain">
                            ${s}
                            <div class="copy-icon" @click=${this.onCopyMainLabel}>${g}</div>
                    </span>
                    ${this.accountDomain ? (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)` <span class="secondary-address">
                                  (${$ade5618b9d1e8b58$export$6ace02e31606896d(this.address, 8, 7)})
                                  <div
                                      class="copy-icon-secondary"
                                      @click=${this.onCopySecondaryLabel}
                                  >
                                      ${v}
                                  </div>
                              </span>` : (0, $3c37a6a9a4cce4d8$export$45b790e32b2810ee)}
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                            class="${this.mode}"
                            @click=${this.onDisconnectClick}
                            data-testid="Disconnect"
                    >
                        <div class="disconnect-icon ${this.mode}">
                            ${this.mode === "LIGHT" ? $ade5618b9d1e8b58$var$ve : $ade5618b9d1e8b58$var$fe}
                        </div>
                        ${A("disconnect")}
                    </button>
                </div>
        </vdk-base-modal>
    `;
    }
};
$ade5618b9d1e8b58$export$3d5de78e430075f1.styles = [
    $ade5618b9d1e8b58$var$Q,
    $ade5618b9d1e8b58$var$sA,
    (0, $3da9ee5e4be70f97$export$dbf350e5966cf602)`
            .modal-container {
                display: flex;
                flex-direction: column;
                gap: 15px;
                padding: 20px;
                transition: width 5s, height 4s;
                font-family: var(--vdk-font-family, ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Family});
            }

            .modal-header {
                font-family: var(--vdk-font-family, ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Family});
                font-weight: var(
                    --vdk-font-weight-medium,
                    ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Weight.Medium}
                );
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 20px;
            }

            .modal-body {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                gap: 40px;
                transition: width 2s, height 4s;
            }

            .modal-footer {
                display: flex;
                justify-content: center;
                align-items: center;
                padding-top: 20px;
                font-family: var(--vdk-font-family, ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Family});
            }

            .address-icon {
                width: 30%;
                margin-right: 4px;
                border-radius: 50%;
            }

            .disconnect-icon {
                width: 18px;
                height: 18px;
            }

            .title {
                font-family: var(--vdk-font-family, ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Family});
                font-weight: var(
                    --vdk-font-weight-medium,
                    ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Weight.Medium}
                );
            }

            .address-domain {
                font-size: var(--vdk-font-size-large, ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Size.Large});
                font-family: var(--vdk-font-family, ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Family});
                font-weight: var(
                    --vdk-font-weight-medium,
                    ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Weight.Medium}
                );
                display: flex;
                flex-direction: row;
                justify-content: center;
            }

            .secondary-address {
                font-size: var(--vdk-font-size-small, ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Size.Small});
                font-family: var(--vdk-font-family, ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Family});
                font-weight: var(
                    --vdk-font-weight-regular,
                    ${$ade5618b9d1e8b58$export$89abf52a030e56ee.Weight.Regular}
                );
                display: flex;
                flex-direction: row;
                justify-content: center;
            }

            .address-container {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                gap: 10px;
            }

            .copy-icon {
                cursor: pointer;
                width: 20px;
                height: 20px;
                margin-left: 10px;
            }

            .copy-icon-secondary {
                cursor: pointer;
                width: 15px;
                height: 15px;
                margin-left: 8px;
            }
        `
], $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)({
        type: Boolean
    })
], $ade5618b9d1e8b58$export$3d5de78e430075f1.prototype, "open", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)({
        type: String
    })
], $ade5618b9d1e8b58$export$3d5de78e430075f1.prototype, "address", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$3d5de78e430075f1.prototype, "accountDomain", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$3d5de78e430075f1.prototype, "isAccountDomainLoading", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)({
        type: Function
    })
], $ade5618b9d1e8b58$export$3d5de78e430075f1.prototype, "onDisconnectClick", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$3d5de78e430075f1.prototype, "mode", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$3d5de78e430075f1.prototype, "i18n", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$3d5de78e430075f1.prototype, "language", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$3d5de78e430075f1.prototype, "walletConnectQRcode", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$3d5de78e430075f1.prototype, "showCopiedMainIcon", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)()
], $ade5618b9d1e8b58$export$3d5de78e430075f1.prototype, "showCopiedSecondaryIcon", 2), $ade5618b9d1e8b58$var$e([
    (0, $890353e55d13ed29$export$d541bacb2bda4494)({
        type: Function
    })
], $ade5618b9d1e8b58$export$3d5de78e430075f1.prototype, "onClose", 2), $ade5618b9d1e8b58$export$3d5de78e430075f1 = $ade5618b9d1e8b58$var$e([
    (0, $3624e2f028ed96c5$export$da64fc29f17f9d0e)("vdk-address-modal")
], $ade5618b9d1e8b58$export$3d5de78e430075f1);
var $ade5618b9d1e8b58$export$20f257fc407da7a3 = class extends (0, $b32aec94b1c85015$export$3f2f9f5909897157) {
    render() {
        return (0, $3c37a6a9a4cce4d8$export$c0bb0b647f701bb5)`
            <style>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
                <link href="https://fonts.googleapis.com/css2?family=Inter:wght@100;300;400;500;700&display=swap" rel="stylesheet" />
            </style>
        `;
    }
};
$ade5618b9d1e8b58$export$20f257fc407da7a3 = $ade5618b9d1e8b58$var$e([
    (0, $3624e2f028ed96c5$export$da64fc29f17f9d0e)("vdk-fonts")
], $ade5618b9d1e8b58$export$20f257fc407da7a3);




/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $173afc29708a1a5e$var$e = new Set([
    "children",
    "localName",
    "ref",
    "style",
    "className"
]), $173afc29708a1a5e$var$n = new WeakMap, $173afc29708a1a5e$var$t = (e, t, l, o, a)=>{
    const s = a?.[t];
    void 0 === s || l === o ? (e[t] = l, null == l && t in HTMLElement.prototype && e.removeAttribute(t)) : ((e, t, l)=>{
        let o = $173afc29708a1a5e$var$n.get(e);
        void 0 === o && $173afc29708a1a5e$var$n.set(e, o = new Map);
        let a = o.get(t);
        void 0 !== l ? void 0 === a ? (o.set(t, a = {
            handleEvent: l
        }), e.addEventListener(t, a)) : a.handleEvent = l : void 0 !== a && (o.delete(t), e.removeEventListener(t, a));
    })(e, s, l);
}, $173afc29708a1a5e$export$60e54eaca7e7fb38 = ({ react: n, tagName: l, elementClass: o, events: a, displayName: s })=>{
    const c = new Set(Object.keys(a ?? {})), i = n.forwardRef((s, i)=>{
        const r = n.useRef(null), d = n.useRef(null), f = {}, u = {};
        for (const [n, t] of Object.entries(s))$173afc29708a1a5e$var$e.has(n) ? f["className" === n ? "class" : n] = t : c.has(n) || n in o.prototype ? u[n] = t : f[n] = t;
        return n.useLayoutEffect(()=>{
            if (null !== d.current) {
                for(const e in u)$173afc29708a1a5e$var$t(d.current, e, s[e], r.current ? r.current[e] : void 0, a);
                r.current = s;
            }
        }), n.useLayoutEffect(()=>{
            d.current?.removeAttribute("defer-hydration");
        }, []), f.suppressHydrationWarning = !0, n.createElement(l, {
            ...f,
            ref: n.useCallback((e)=>{
                d.current = e, "function" == typeof i ? i(e) : null !== i && (i.current = e);
            }, [
                i
            ])
        });
    });
    return i.displayName = s ?? o.name, i;
};






var $02bf0a6937931ae2$var$i = (0, $acw62.createContext)(void 0);
var $02bf0a6937931ae2$export$85a7a75309d318c0 = ({ children: e, connex: t })=>{
    let [o, n] = (0, $acw62.useState)(t.wallet.state.address), [r, a] = (0, $acw62.useState)(t.wallet.state.accountDomain), [d, x] = (0, $acw62.useState)(t.wallet.state.isAccountDomainLoading), [m, g] = (0, $acw62.useState)(t.wallet.state.source), [p, y] = (0, $acw62.useState)(t.wallet.state.connectionCertificate);
    (0, $acw62.useEffect)(()=>{
        let D = (0, $cae0866804f4505b$export$7faad7f6b3708314)(t.wallet.state, "address", (s)=>{
            n(s);
        }), L = (0, $cae0866804f4505b$export$7faad7f6b3708314)(t.wallet.state, "accountDomain", (s)=>{
            a(s);
        }), N = (0, $cae0866804f4505b$export$7faad7f6b3708314)(t.wallet.state, "isAccountDomainLoading", (s)=>{
            x(s);
        }), O = (0, $cae0866804f4505b$export$7faad7f6b3708314)(t.wallet.state, "source", (s)=>{
            g(s);
        }), T = (0, $cae0866804f4505b$export$7faad7f6b3708314)(t.wallet.state, "connectionCertificate", (s)=>{
            y(s);
        });
        return ()=>{
            D(), L(), N(), O(), T();
        };
    }, [
        t.wallet.state
    ]);
    let u = (0, $acw62.useCallback)(()=>{
        (0, $ade5618b9d1e8b58$export$f660724a5e07d7a3).modal.open();
    }, []), f = (0, $acw62.useCallback)(()=>{
        (0, $ade5618b9d1e8b58$export$f660724a5e07d7a3).modal.close();
    }, []), A = (0, $acw62.useCallback)((D)=>(0, $ade5618b9d1e8b58$export$f660724a5e07d7a3).modal.onConnectionStatusChange(D), []), h = (0, $acw62.useMemo)(()=>({
            connex: {
                thor: t.thor,
                vendor: t.vendor
            },
            wallet: {
                setSource: t.wallet.setSource,
                disconnect: t.wallet.disconnect,
                connect: t.wallet.connect,
                availableWallets: t.wallet.state.availableSources,
                account: o,
                accountDomain: r,
                isAccountDomainLoading: d,
                source: m,
                connectionCertificate: p,
                signTypedData: t.wallet.signTypedData
            },
            modal: {
                open: u,
                close: f,
                onConnectionStatusChange: A
            }
        }), [
        t,
        o,
        r,
        d,
        m,
        p,
        u,
        f,
        A
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($02bf0a6937931ae2$var$i.Provider, {
        value: h,
        children: e
    });
}, $02bf0a6937931ae2$export$910f2e7837addf5c = ({ children: e, nodeUrl: t, genesis: o, walletConnectOptions: n, usePersistence: r = !1, logLevel: a, requireCertificate: d, themeMode: x, themeVariables: m, i18n: g, language: p, modalParent: y, onSourceClick: u, connectionCertificate: f, allowedWallets: A })=>{
    let [h, D] = (0, $acw62.useState)(null);
    return (0, $acw62.useEffect)(()=>{
        D((0, $ade5618b9d1e8b58$export$f660724a5e07d7a3).configure({
            nodeUrl: t,
            genesis: o,
            walletConnectOptions: n,
            usePersistence: r,
            logLevel: a,
            requireCertificate: d,
            themeVariables: m,
            themeMode: x,
            i18n: g,
            language: p,
            modalParent: y,
            onSourceClick: u,
            connectionCertificate: f,
            allowedWallets: A
        }));
    }, [
        t,
        o,
        n,
        r,
        a,
        d,
        m,
        x,
        g,
        p,
        y,
        u,
        f,
        A
    ]), h ? (0, $7b02d682eb115277$exports.jsx)($02bf0a6937931ae2$export$85a7a75309d318c0, {
        connex: h,
        children: e
    }) : null;
};
var $02bf0a6937931ae2$export$80a3df2e4bfa2936 = ()=>{
    let e = (0, $acw62.useContext)($02bf0a6937931ae2$var$i);
    if (!e) throw new Error('"useConnex" must be used within a ConnexProvider');
    return e.connex;
};
var $02bf0a6937931ae2$export$c34addee860b0acb = ()=>{
    let e = (0, $acw62.useContext)($02bf0a6937931ae2$var$i);
    if (!e) throw new Error('"useWallet" must be used within a ConnexProvider');
    return e.wallet;
};
var $02bf0a6937931ae2$export$6fdf0454adae214b = ()=>{
    let e = (0, $acw62.useContext)($02bf0a6937931ae2$var$i);
    if (!e) throw new Error('"useWalletModal" must be used within a ConnexProvider');
    return e.modal;
};
var $02bf0a6937931ae2$export$eab4424f030fcb21 = (0, $173afc29708a1a5e$export$60e54eaca7e7fb38)({
    tagName: "vdk-button",
    elementClass: (0, $ade5618b9d1e8b58$export$353f5b6fc5456de1),
    react: (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))
});
var $02bf0a6937931ae2$var$l = {
    main: "0xA11413086e163e41901bb81fdc5617c975Fa5a1A",
    test: "0xc403b8EA53F707d7d4de095f0A20bC491Cf2bc94"
};
var $02bf0a6937931ae2$var$H = {
    inputs: [
        {
            internalType: "address[]",
            name: "addresses",
            type: "address[]"
        }
    ],
    name: "getNames",
    outputs: [
        {
            internalType: "string[]",
            name: "names",
            type: "string[]"
        }
    ],
    stateMutability: "view",
    type: "function"
}, $02bf0a6937931ae2$var$R = async ({ address: e, connex: t })=>{
    if (!e) return;
    let o = t.thor.genesis.id === (0, $4b665efddc7cd9c8$export$7448c01626a95a0b).test.id ? $02bf0a6937931ae2$var$l.test : $02bf0a6937931ae2$var$l.main, n = await t.thor.account(o).method($02bf0a6937931ae2$var$H).call([
        e
    ]), { decoded: { names: r } } = n;
    return r?.[0] || void 0;
};
var $02bf0a6937931ae2$var$Q = {
    inputs: [
        {
            internalType: "string[]",
            name: "names",
            type: "string[]"
        }
    ],
    name: "getAddresses",
    outputs: [
        {
            internalType: "address[]",
            name: "addresses",
            type: "address[]"
        }
    ],
    stateMutability: "view",
    type: "function"
}, $02bf0a6937931ae2$var$S = async ({ domain: e, connex: t })=>{
    if (!e) return;
    let o = t.thor.genesis.id === (0, $4b665efddc7cd9c8$export$7448c01626a95a0b).test.id ? $02bf0a6937931ae2$var$l.test : $02bf0a6937931ae2$var$l.main, n = await t.thor.account(o).method($02bf0a6937931ae2$var$Q).call([
        e
    ]), { decoded: { addresses: r } } = n;
    return r?.[0] || void 0;
};
var $02bf0a6937931ae2$var$E = async ({ addressOrDomain: e, connex: t })=>{
    if (!e) return {
        address: void 0,
        domain: void 0,
        isValidAddressOrDomain: !1
    };
    if ((0, $564ad8f2c6689928$export$678e08479eeb6ed8).isAddress(e)) try {
        let n = await $02bf0a6937931ae2$var$R({
            address: e,
            connex: t
        });
        return {
            address: e,
            domain: n,
            isValidAddressOrDomain: !0
        };
    } catch (n) {
        return console.error("Error getting domain: ", n), {
            address: e,
            domain: void 0,
            isValidAddressOrDomain: !0
        };
    }
    try {
        let n = await $02bf0a6937931ae2$var$S({
            domain: e,
            connex: t
        });
        return n === "0x0000000000000000000000000000000000000000" ? {
            address: void 0,
            domain: void 0,
            isValidAddressOrDomain: !1
        } : {
            address: n,
            domain: e,
            isValidAddressOrDomain: !0
        };
    } catch (n) {
        return console.error("Error getting address: ", n), {
            address: void 0,
            domain: void 0,
            isValidAddressOrDomain: !1
        };
    }
};
var $02bf0a6937931ae2$export$5200a49f8a6322ad = ({ addressOrDomain: e })=>{
    let t = $02bf0a6937931ae2$export$80a3df2e4bfa2936(), [o, n] = (0, $acw62.useState)({
        address: void 0,
        domain: void 0,
        isValidAddressOrDomain: !1
    }), [r, a] = (0, $acw62.useState)(!1);
    return (0, $acw62.useEffect)(()=>{
        a(!0), $02bf0a6937931ae2$var$E({
            addressOrDomain: e,
            connex: t
        }).then(n).catch((d)=>{
            console.error("Error fetching vechain domain: ", d), n({
                address: void 0,
                domain: void 0,
                isValidAddressOrDomain: !1
            });
        }).finally(()=>a(!1));
    }, [
        e,
        t
    ]), {
        ...o,
        isLoading: r
    };
};




var $acw62 = parcelRequire("acw62");

const $9ecda7333d28e490$export$e8ee8b3bd696a3a5 = undefined ?? "https://auth.api.vechain.energy";
const $9ecda7333d28e490$export$244d254afac62c47 = undefined ?? "abedfb5522e0bf261f577d874bf347f2";


function $00669f9de23fc3d9$export$2e2bcd8739ae039() {
    const { open: open } = (0, $02bf0a6937931ae2$export$6fdf0454adae214b)();
    const url = new URL(window.location.href);
    const scope = url.searchParams.get("scope") || "";
    const code = url.searchParams.get("code") || "";
    const { account: account, source: source, connectionCertificate: connectionCertificate } = (0, $02bf0a6937931ae2$export$c34addee860b0acb)();
    const cleanScopeList = scope.split(" ").map((scope)=>String(scope).trim()).filter((scope)=>scope !== "");
    if (cleanScopeList.includes("ifttt")) cleanScopeList.push("profile");
    const cleanScope = cleanScopeList.join(" ");
    const applicationName = cleanScopeList.includes("ifttt") ? "<b>IFTTT</b>" : "an application";
    const scopeInformation = cleanScope.includes("profile") ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            "You are authorizing ",
            applicationName,
            " to identify your wallet address",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            "and your personal profile."
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            "You are authorizing ",
            applicationName,
            " to identify your wallet address."
        ]
    });
    const handleCancel = (message = "authorization canceled", _nonce = null)=>{
        if ([
            "sync",
            "sync2",
            null
        ].includes(source)) return;
        const redirect_uri = `${(0, $9ecda7333d28e490$export$e8ee8b3bd696a3a5)}/oauth2/confirm`;
        window.location.href = `${redirect_uri}?code=${code}&error=${encodeURIComponent(message)}`;
    };
    const handleConnect = (0, $acw62.useCallback)(()=>{
        if (!account || !connectionCertificate) open();
        else if (connectionCertificate) {
            const redirect_uri = `${(0, $9ecda7333d28e490$export$e8ee8b3bd696a3a5)}/oauth2/confirm`;
            const signature = {
                annex: {
                    domain: connectionCertificate.domain,
                    timestamp: connectionCertificate.timestamp,
                    signer: connectionCertificate.signer
                },
                signature: connectionCertificate.signature
            };
            window.location.href = `${redirect_uri}?code=${code}&source=${source}&signature=${window.btoa(JSON.stringify(signature))}`;
            document.querySelectorAll("button").forEach((button)=>button.disabled = true);
        }
    }, [
        account,
        open,
        connectionCertificate
    ]);
    (0, $acw62.useEffect)(()=>{
        handleConnect();
    }, [
        handleConnect
    ]);
    if (!code) {
        window.location.href = "https://docs.vechain.energy/vechain.energy/AuthService";
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "box",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "heading",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    width: 64,
                                    height: 64,
                                    fontSize: 18
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    width: "64",
                                    height: "64",
                                    viewBox: "0 0 512 512",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                                id: "helmet",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        id: "lower",
                                                        fill: "#2d2a6d",
                                                        stroke: "none",
                                                        d: "M 331.100006 232.299988 L 314.200012 241.700012 L 314.200012 292.899994 L 275.799988 316 L 275.799988 340.700012 L 256 352.200012 L 236.200012 340.799988 L 236.200012 316.100006 L 197.800003 293 L 197.800003 241.799988 L 180.899994 232.399994 L 142.699997 210.299988 L 142.699997 214.100006 C 142.699997 219.899994 145.800003 225.200012 150.800003 228.100006 L 180.899994 245.399994 L 180.899994 258.5 L 154.800003 243.5 L 154.800003 246.5 C 154.800003 252.799988 158.199997 258.600006 163.600006 261.799988 L 180.899994 271.700012 L 180.899994 283.700012 L 169.600006 277.200012 L 169.600006 326 L 236.200012 365.100006 L 236.200012 353.700012 L 256 365.100006 L 275.799988 353.700012 L 275.799988 365.100006 L 342.399994 326 L 342.399994 277 L 331.100006 283.5 L 331.100006 271.5 L 348.399994 261.600006 C 353.899994 258.5 357.200012 252.600006 357.200012 246.299988 L 357.200012 243.299988 L 331.100006 258.299988 L 331.100006 245.200012 L 361.200012 227.899994 C 366.200012 225 369.299988 219.700012 369.299988 213.899994 L 369.299988 210.100006 L 331.100006 232.299988 Z"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        id: "upper",
                                                        fill: "#2d2a6d",
                                                        stroke: "none",
                                                        d: "M 162.699997 208.700012 L 256 262.5 L 349.299988 208.700012 C 354 206 357 200.899994 357 195.5 L 357 191.200012 L 330.299988 206.700012 C 329.799988 202.299988 329 198 327.700012 193.899994 C 322.100006 176.200012 310.100006 160.799988 293.600006 151.299988 C 282.200012 144.700012 269.100006 141.399994 256 141.399994 C 242.899994 141.399994 229.799988 144.700012 218.399994 151.299988 C 201.899994 160.799988 189.899994 176.200012 184.300003 193.899994 C 183 198.100006 182.199997 202.399994 181.699997 206.700012 L 155 191.200012 L 155 195.5 C 155 200.899994 158 206 162.699997 208.700012 Z M 247.799988 163.700012 L 277.299988 163.700012 L 266.399994 194.299988 L 279 194.299988 L 234.799988 235.600006 L 245.700012 205 L 233.100006 205 L 247.799988 163.700012 Z"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                                                id: "blockGradient",
                                                x1: "256",
                                                y1: "114.9241",
                                                x2: "256",
                                                y2: "403.2589",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                                        offset: "1e-05",
                                                        "stop-color": "#ec1c24",
                                                        "stop-opacity": "1"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                                        offset: "1",
                                                        "stop-color": "#f6921e",
                                                        "stop-opacity": "1"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                fill: "url(#blockGradient)",
                                                stroke: "none",
                                                d: "M 431.899994 328.600006 C 429.700012 327.299988 427.399994 326.5 425.100006 325.899994 L 425.100006 186.100006 C 427.399994 185.600006 429.700012 184.700012 431.899994 183.399994 C 437.700012 180.100006 441.799988 174.600006 443.600006 168.200012 C 445.299988 161.700012 444.399994 155 441.100006 149.200012 C 436.5 141.200012 428 136.700012 419.399994 136.700012 C 415.200012 136.700012 410.799988 137.799988 406.899994 140.100006 C 404.700012 141.399994 402.799988 142.899994 401.100006 144.700012 L 280 74.600006 C 280.700012 72.299988 281.100006 69.899994 281.100006 67.299988 C 281.100006 53.5 269.899994 42.200012 256 42.200012 L 256 42.200012 C 242.200012 42.200012 230.899994 53.399994 230.899994 67.299988 C 230.899994 69.799988 231.299988 72.299988 232 74.600006 L 110.899994 144.5 C 109.300003 142.700012 107.300003 141.200012 105.100006 139.899994 C 101.199997 137.600006 96.899994 136.5 92.600006 136.5 C 83.900002 136.5 75.5 141 70.900002 149 C 67.599998 154.799988 66.699997 161.600006 68.400002 168 C 70.099998 174.5 74.300003 179.899994 80.099998 183.200012 C 82.300003 184.5 84.600006 185.299988 86.899994 185.899994 L 86.899994 325.700012 C 84.600006 326.200012 82.300003 327.100006 80.099998 328.399994 C 74.300003 331.700012 70.199997 337.200012 68.400002 343.600006 C 66.699997 350.100006 67.599998 356.799988 70.900002 362.600006 C 75.5 370.600006 84 375.100006 92.600006 375.100006 C 96.800003 375.100006 101.199997 374 105.100006 371.700012 C 107.300003 370.399994 109.199997 368.899994 110.899994 367.100006 L 232 437.399994 C 231.299988 439.700012 230.899994 442.100006 230.899994 444.700012 C 230.899994 458.5 242.100006 469.799988 256 469.799988 L 256 469.799988 C 269.799988 469.799988 281.100006 458.600006 281.100006 444.700012 C 281.100006 442.200012 280.700012 439.700012 280 437.399994 L 401.100006 367.5 C 402.700012 369.299988 404.700012 370.799988 406.899994 372.100006 C 410.799988 374.399994 415.100006 375.5 419.399994 375.5 C 428.100006 375.5 436.5 371 441.100006 363 C 444.399994 357.200012 445.299988 350.399994 443.600006 344 C 441.799988 337.399994 437.700012 332 431.899994 328.600006 Z M 406.100006 158.200012 C 407 154.700012 409.299988 151.700012 412.5 149.899994 C 415.700012 148.100006 419.299988 147.600006 422.899994 148.5 C 426.399994 149.399994 429.399994 151.700012 431.200012 154.899994 C 433 158.100006 433.5 161.700012 432.600006 165.299988 C 431.700012 168.799988 429.399994 171.799988 426.200012 173.600006 C 424.100006 174.799988 421.799988 175.399994 419.399994 175.399994 C 418.200012 175.399994 417 175.200012 415.799988 174.899994 C 412.299988 174 409.299988 171.700012 407.5 168.5 C 405.700012 165.399994 405.200012 161.700012 406.100006 158.200012 Z M 256 53.700012 L 256 53.700012 C 263.5 53.700012 269.700012 59.799988 269.700012 67.399994 C 269.700012 74.899994 263.600006 81.100006 256 81.100006 L 256 81.100006 C 248.5 81.100006 242.299988 75 242.299988 67.399994 C 242.299988 59.799988 248.5 53.700012 256 53.700012 Z M 85.800003 173.5 C 82.599998 171.700012 80.400002 168.700012 79.400002 165.200012 C 78.5 161.700012 78.900002 158 80.800003 154.799988 C 82.599998 151.600006 85.600006 149.399994 89.100006 148.399994 C 92.600006 147.5 96.300003 147.899994 99.5 149.799988 C 102.699997 151.600006 104.899994 154.600006 105.899994 158.100006 C 106.800003 161.600006 106.399994 165.299988 104.5 168.5 C 102.699997 171.700012 99.699997 173.899994 96.199997 174.899994 C 95 175.200012 93.800003 175.399994 92.600006 175.399994 C 90.300003 175.399994 87.899994 174.700012 85.800003 173.5 Z M 105.899994 353.799988 C 105 357.299988 102.699997 360.299988 99.5 362.100006 C 96.300003 363.899994 92.699997 364.399994 89.100006 363.5 C 85.600006 362.600006 82.599998 360.299988 80.800003 357.100006 C 79 353.899994 78.5 350.299988 79.400002 346.700012 C 80.300003 343.200012 82.599998 340.200012 85.800003 338.399994 C 87.899994 337.200012 90.199997 336.600006 92.600006 336.600006 C 93.800003 336.600006 95 336.799988 96.199997 337.100006 C 99.699997 338 102.699997 340.299988 104.5 343.5 C 106.300003 346.600006 106.800003 350.299988 105.899994 353.799988 Z M 256 458.299988 L 256 458.299988 C 248.5 458.299988 242.299988 452.200012 242.299988 444.600006 C 242.299988 437.100006 248.399994 430.899994 256 430.899994 L 256 430.899994 C 263.5 430.899994 269.700012 437 269.700012 444.600006 C 269.700012 452.200012 263.5 458.299988 256 458.299988 Z M 357 307.700012 L 357 320.899994 L 395.399994 343.100006 C 393.899994 347.899994 394 353 395.399994 357.600006 L 274.299988 427.5 C 271 424 266.600006 421.399994 261.700012 420.200012 L 261.700012 379.200012 L 250.299988 379.200012 L 250.299988 420.200012 C 245.399994 421.299988 241.100006 423.899994 237.700012 427.5 L 116.600006 357.600006 C 118 352.899994 118.100006 347.899994 116.600006 343.100006 L 155 320.899994 L 155 307.700012 L 110.899994 333.200012 C 107.5 329.5 103.100006 327.100006 98.300003 326 L 98.300003 186.100006 C 103 185 107.399994 182.5 110.899994 178.899994 L 142.699997 197.200012 L 142.699997 184 L 116.600006 169 C 118.100006 164.200012 118 159.100006 116.600006 154.5 L 237.700012 84.600006 C 241 88.100006 245.399994 90.700012 250.299988 91.899994 L 250.299988 132.899994 L 261.700012 132.899994 L 261.700012 91.899994 C 266.600006 90.799988 270.899994 88.200012 274.299988 84.600006 L 395.399994 154.5 C 394 159.200012 393.899994 164.200012 395.399994 169 L 369.299988 184 L 369.299988 197.100006 L 401.100006 178.799988 C 404.5 182.5 408.899994 184.899994 413.700012 186 L 413.700012 325.899994 C 409 327 404.600006 329.5 401.100006 333.100006 L 357 307.700012 Z M 431.200012 357.100006 C 429.399994 360.299988 426.399994 362.5 422.899994 363.5 C 419.399994 364.399994 415.700012 364 412.5 362.100006 C 409.299988 360.299988 407.100006 357.299988 406.100006 353.799988 C 405.200012 350.299988 405.600006 346.600006 407.5 343.399994 C 409.299988 340.200012 412.299988 338 415.799988 337 C 417 336.700012 418.200012 336.5 419.399994 336.5 C 421.799988 336.5 424.100006 337.100006 426.200012 338.299988 C 429.399994 340.100006 431.600006 343.100006 432.600006 346.600006 C 433.5 350.299988 433 354 431.200012 357.100006 Z"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "heading-title",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "#",
                                    children: "Identify your Wallet-Address"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "content",
                        children: [
                            scopeInformation,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            "Please sign the authorization code with your Wallet to continue.",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "footing",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "cancel",
                                onClick: ()=>handleCancel(),
                                children: "Cancel"
                            }),
                            !account && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "retry",
                                onClick: handleConnect,
                                children: "Connect Wallet"
                            }),
                            account && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "retry",
                                onClick: handleConnect,
                                children: "Continue with Sign In"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



const $cd93687958c8007e$var$walletConnectOptions = {
    projectId: (0, $9ecda7333d28e490$export$244d254afac62c47),
    metadata: {
        name: "Sign In With Vechain",
        description: "Sign in to your account using your Vechain wallet",
        url: window.location.origin,
        icons: [
            `https://vechain.energy/favicon.png`
        ]
    }
};
function $cd93687958c8007e$export$2e2bcd8739ae039() {
    const url = new URL(window.location.href);
    const network = url.searchParams.get("network") || "main";
    const scope = url.searchParams.get("scope") || "";
    const code = url.searchParams.get("code") || "";
    const cleanScopeList = scope.split(" ").map((scope)=>String(scope).trim()).filter((scope)=>scope !== "");
    if (cleanScopeList.includes("ifttt")) cleanScopeList.push("profile");
    const cleanScope = cleanScopeList.join(" ");
    const signContent = cleanScope === "" ? code : `${code}:${cleanScope}`;
    const cert = {
        message: {
            purpose: "identification",
            payload: {
                type: "text",
                content: signContent
            }
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02bf0a6937931ae2$export$910f2e7837addf5c), {
        nodeUrl: `https://node-${network}net.vechain.energy`,
        genesis: network,
        usePersistence: false,
        walletConnectOptions: $cd93687958c8007e$var$walletConnectOptions,
        requireCertificate: true,
        connectionCertificate: cert,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00669f9de23fc3d9$export$2e2bcd8739ae039), {})
    });
}


const $35da740d59af89ba$var$container = document.getElementById("app");
const $35da740d59af89ba$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($35da740d59af89ba$var$container);
$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.3e30d8d0.js.map
